import * as i0 from '@angular/core';
import { Injectable, ComponentFactoryResolver, Inject, PLATFORM_ID, RendererFactory2, Component, NgZone, Input, Directive, ViewContainerRef, ViewChild, NgModule, CUSTOM_ELEMENTS_SCHEMA, ViewEncapsulation, ElementRef, ChangeDetectorRef, Pipe, EventEmitter, Output, ChangeDetectionStrategy, HostBinding, HostListener } from '@angular/core';
import { Subject, BehaviorSubject, ReplaySubject, of, forkJoin, from } from 'rxjs';
import proj4 from 'proj4';
import { Cluster, Vector, ImageWMS, ImageArcGISRest, WMTS, TileWMS, TileArcGISRest, XYZ, OSM, ImageStatic } from 'ol/source';
import { defaults, ScaleLine, Control } from 'ol/control';
import { DoubleClickZoom, KeyboardPan, KeyboardZoom, MouseWheelZoom, PinchRotate, PinchZoom, DragPan, DragZoom, DragRotate, Select, Modify, Draw, Snap, DragBox } from 'ol/interaction';
import { Group, Vector as Vector$1, Image as Image$1, Tile, Layer } from 'ol/layer';
import { Kinetic, Map, View, Feature as Feature$1 } from 'ol';
import { transform, transformExtent, toLonLat, get, METERS_PER_UNIT } from 'ol/proj';
import { platformModifierKeyOnly, click } from 'ol/events/condition';
import { register } from 'ol/proj/proj4';
import * as i1 from '@ngx-translate/core';
import { TranslateService, TranslateModule, TranslateLoader, TranslateStore } from '@ngx-translate/core';
import { __awaiter } from 'tslib';
import * as i1$1 from '@angular/common/http';
import { HttpClient, HttpHeaders, HttpParams, HttpClientModule } from '@angular/common/http';
import * as i9 from '@angular/common';
import { isPlatformBrowser, Location, PlatformLocation, CommonModule, LocationStrategy, PathLocationStrategy, APP_BASE_HREF } from '@angular/common';
import { getDistance, getArea } from 'ol/sphere';
import { RegularShape, Icon, Circle, Style, Fill, Stroke, Text } from 'ol/style';
import { GeoJSON, TopoJSON, KML, WKT, GPX, WFS, WMSCapabilities, WMTSCapabilities as WMTSCapabilities$1 } from 'ol/format';
import TileLayer from 'ol/layer/Tile';
import * as extent from 'ol/extent';
import { isEmpty } from 'ol/extent';
import { takeUntil, timeout, map, catchError } from 'rxjs/operators';
import * as xml2Json from 'xml-js';
import WMTS$1, { optionsFromCapabilities } from 'ol/source/WMTS';
import WMTSCapabilities from 'ol/format/WMTSCapabilities';
import Feature from 'ol/Feature';
import { Point, Circle as Circle$1, Polygon, LineString } from 'ol/geom';
import dayjs from 'dayjs';
import * as i8 from '@angular/platform-browser';
import { DomSanitizer } from '@angular/platform-browser';
import OpenLayersParser from 'geostyler-openlayers-parser';
import SLDParser from 'geostyler-sld-parser';
import VectorLayer from 'ol/layer/Vector';
import { createDefaultStyle } from 'ol/style/Style';
import { toStringHDMS, createStringXY } from 'ol/coordinate';
import VectorSource from 'ol/source/Vector';
import * as loadingStrategy from 'ol/loadingstrategy';
import { bbox } from 'ol/loadingstrategy';
import Collection from 'ol/Collection';
import { fromExtent, fromCircle } from 'ol/geom/Polygon';
import Resumable from 'resumablejs';
import queue from 'queue';
import { NgbModule, NgbProgressbarModule } from '@ng-bootstrap/ng-bootstrap';
import Geolocation from 'ol/Geolocation';
import Rotate from 'ol/control/Rotate';
import CircleStyle from 'ol/style/Circle';
import Popup from 'ol-popup';
import Overlay from 'ol/Overlay';
import 'share-api-polyfill';
import { moveItemInArray, DragDropModule } from '@angular/cdk/drag-drop';
import { FormsModule } from '@angular/forms';
import * as i1$2 from 'ngx-cookie-service';
import { CookieService } from 'ngx-cookie-service';
import * as merge from 'deepmerge';
import { ColorSketchModule } from 'ngx-color/sketch';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@ngx-translate/core';
import * as ɵngcc2 from '@angular/common/http';
import * as ɵngcc3 from '@angular/common';
import * as ɵngcc4 from '@angular/platform-browser';
import * as ɵngcc5 from '@angular/forms';
import * as ɵngcc6 from '@ng-bootstrap/ng-bootstrap';
import * as ɵngcc7 from '@angular/cdk/drag-drop';
import * as ɵngcc8 from 'ngx-cookie-service';
import * as ɵngcc9 from 'ngx-color/sketch';

function HsAddDataComponent_hs_add_data_url_16_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "hs-add-data-url");
} }
function HsAddDataComponent_hs_add_data_file_17_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "hs-add-data-file");
} }
function HsAddDataComponent_hs_add_data_catalogue_18_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "hs-add-data-catalogue");
} }
const _c0 = function (a0) { return { "btn-primary active": a0 }; };
function HsCompositionsInfoDialogComponent_div_23_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 17);
    ɵngcc0.ɵɵelementStart(1, "div", 10);
    ɵngcc0.ɵɵelementStart(2, "b");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 11);
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const keyword_r11 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(4, 2, "COMMON.keywords"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(keyword_r11);
} }
function HsCompositionsInfoDialogComponent_div_23_div_1_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 17);
    ɵngcc0.ɵɵelementStart(1, "div", 18);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const keyword_r11 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(keyword_r11);
} }
function HsCompositionsInfoDialogComponent_div_23_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, HsCompositionsInfoDialogComponent_div_23_div_1_div_1_Template, 7, 4, "div", 13);
    ɵngcc0.ɵɵtemplate(2, HsCompositionsInfoDialogComponent_div_23_div_1_div_2_Template, 3, 1, "div", 13);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const first_r12 = ctx.first;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", first_r12);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !first_r12);
} }
function HsCompositionsInfoDialogComponent_div_23_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, HsCompositionsInfoDialogComponent_div_23_div_1_Template, 3, 2, "div", 16);
    ɵngcc0.ɵɵelement(2, "br");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.data.info.keywords);
} }
function HsCompositionsInfoDialogComponent_div_24_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 17);
    ɵngcc0.ɵɵelementStart(1, "div", 10);
    ɵngcc0.ɵɵelementStart(2, "b");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 11);
    ɵngcc0.ɵɵelement(6, "img", 19);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(4, 2, "COMMON.thumbnail"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵpropertyInterpolate("src", ctx_r1.data.info.thumbnail.url ? ctx_r1.data.info.thumbnail.url : ctx_r1.data.info.thumbnail, ɵngcc0.ɵɵsanitizeUrl);
} }
function HsCompositionsInfoDialogComponent_div_25_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 17);
    ɵngcc0.ɵɵelementStart(1, "div", 10);
    ɵngcc0.ɵɵelementStart(2, "b");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 11);
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(4, 2, "COMMON.url"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.data.info.url);
} }
function HsCompositionsInfoDialogComponent_div_26_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 17);
    ɵngcc0.ɵɵelementStart(1, "div", 10);
    ɵngcc0.ɵɵelementStart(2, "b");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 11);
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(4, 2, "ADDLAYERS.srs"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r3.data.info.srs);
} }
function HsCompositionsInfoDialogComponent_div_27_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 17);
    ɵngcc0.ɵɵelementStart(1, "div", 10);
    ɵngcc0.ɵɵelementStart(2, "b");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 20);
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(4, 2, "COMMON.extent"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r4.data.info.extent);
} }
function HsCompositionsInfoDialogComponent_div_28_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 17);
    ɵngcc0.ɵɵelementStart(1, "div", 10);
    ɵngcc0.ɵɵelementStart(2, "b");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 11);
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const layer_r18 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(4, 2, "COMMON.layers"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(layer_r18.title);
} }
function HsCompositionsInfoDialogComponent_div_28_div_1_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 17);
    ɵngcc0.ɵɵelementStart(1, "div", 21);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const layer_r18 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(layer_r18.title);
} }
function HsCompositionsInfoDialogComponent_div_28_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, HsCompositionsInfoDialogComponent_div_28_div_1_div_1_Template, 7, 4, "div", 13);
    ɵngcc0.ɵɵtemplate(2, HsCompositionsInfoDialogComponent_div_28_div_1_div_2_Template, 3, 1, "div", 13);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const first_r19 = ctx.first;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", first_r19);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !first_r19);
} }
function HsCompositionsInfoDialogComponent_div_28_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, HsCompositionsInfoDialogComponent_div_28_div_1_Template, 3, 2, "div", 16);
    ɵngcc0.ɵɵelement(2, "br");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r5.data.info.layers);
} }
function HsCompositionsInfoDialogComponent_div_29_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 17);
    ɵngcc0.ɵɵelementStart(1, "div", 22);
    ɵngcc0.ɵɵelementStart(2, "b");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(4, 1, "COMMON.contactInformation"));
} }
function HsCompositionsInfoDialogComponent_div_30_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 17);
    ɵngcc0.ɵɵelementStart(1, "div", 23);
    ɵngcc0.ɵɵelementStart(2, "b");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 24);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const data_r25 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r26 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r26.HsCompositionsService.translateString("SAVECOMPOSITION.form", data_r25.key));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(data_r25.value);
} }
function HsCompositionsInfoDialogComponent_div_30_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, HsCompositionsInfoDialogComponent_div_30_div_1_div_1_Template, 6, 2, "div", 13);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const data_r25 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", data_r25.value);
} }
function HsCompositionsInfoDialogComponent_div_30_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, HsCompositionsInfoDialogComponent_div_30_div_1_Template, 2, 1, "div", 16);
    ɵngcc0.ɵɵpipe(2, "keyvalue");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind1(2, 1, ctx_r7.data.info.contactAddress));
} }
function HsCompositionsInfoDialogComponent_div_31_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 17);
    ɵngcc0.ɵɵelementStart(1, "div", 25);
    ɵngcc0.ɵɵelementStart(2, "b");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 24);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const data_r29 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r30 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r30.HsCompositionsService.translateString("SAVECOMPOSITION.form", data_r29.key));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(data_r29.value);
} }
function HsCompositionsInfoDialogComponent_div_31_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, HsCompositionsInfoDialogComponent_div_31_div_1_div_1_Template, 6, 2, "div", 13);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const data_r29 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", data_r29.value);
} }
function HsCompositionsInfoDialogComponent_div_31_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, HsCompositionsInfoDialogComponent_div_31_div_1_Template, 2, 1, "div", 16);
    ɵngcc0.ɵɵpipe(2, "keyvalue");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind1(2, 1, ctx_r8.data.info.contactPersonPrimary));
} }
function HsCompositionsInfoDialogComponent_ng_container_33_Template(rf, ctx) { if (rf & 1) {
    const _r33 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "a", 26);
    ɵngcc0.ɵɵlistener("click", function HsCompositionsInfoDialogComponent_ng_container_33_Template_a_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r33); const ctx_r32 = ɵngcc0.ɵɵnextContext(); return ctx_r32.close(); });
    ɵngcc0.ɵɵtext(2, "See full metadata record ");
    ɵngcc0.ɵɵelement(3, "i", 27);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("href", ctx_r9.data.info.metadata.record_url, ɵngcc0.ɵɵsanitizeUrl);
} }
function HsCompositionsComponent_div_39_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 49);
    ɵngcc0.ɵɵelementStart(1, "input", 50);
    ɵngcc0.ɵɵlistener("ngModelChange", function HsCompositionsComponent_div_39_Template_input_ngModelChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.hsCompositionsCatalogueService.filterByOnlyMine = $event; })("change", function HsCompositionsComponent_div_39_Template_input_change_1_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.loadFilteredCompositions(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(2, "span", 25);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.hsCompositionsCatalogueService.filterByOnlyMine);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(4, 2, "COMPOSITIONS.onlyMine"));
} }
function HsCompositionsComponent_li_55_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li");
    ɵngcc0.ɵɵelementStart(1, "label", 51);
    ɵngcc0.ɵɵelementStart(2, "input", 52);
    ɵngcc0.ɵɵlistener("ngModelChange", function HsCompositionsComponent_li_55_Template_input_ngModelChange_2_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r13); const keyword_r10 = restoredCtx.$implicit; return keyword_r10.selected = $event; })("change", function HsCompositionsComponent_li_55_Template_input_change_2_listener() { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r14 = ɵngcc0.ɵɵnextContext(); return ctx_r14.loadFilteredCompositions(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const keyword_r10 = ctx.$implicit;
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngModel", keyword_r10.selected);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.hsCompositionsService.translateString("COMPOSITONKEYWORDS", keyword_r10.name));
} }
function HsCompositionsComponent_li_65_Template(rf, ctx) { if (rf & 1) {
    const _r18 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li");
    ɵngcc0.ɵɵelementStart(1, "label", 51);
    ɵngcc0.ɵɵelementStart(2, "input", 53);
    ɵngcc0.ɵɵlistener("ngModelChange", function HsCompositionsComponent_li_65_Template_input_ngModelChange_2_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r18); const theme_r15 = restoredCtx.$implicit; return theme_r15.selected = $event; })("change", function HsCompositionsComponent_li_65_Template_input_change_2_listener() { ɵngcc0.ɵɵrestoreView(_r18); const ctx_r19 = ɵngcc0.ɵɵnextContext(); return ctx_r19.loadFilteredCompositions(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const theme_r15 = ctx.$implicit;
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngModel", theme_r15.selected);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.hsCompositionsService.translateString("COMPOSITONINSPIRETHEMES", theme_r15.name));
} }
function HsCompositionsComponent_li_75_Template(rf, ctx) { if (rf & 1) {
    const _r23 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li");
    ɵngcc0.ɵɵelementStart(1, "label", 51);
    ɵngcc0.ɵɵelementStart(2, "input", 54);
    ɵngcc0.ɵɵlistener("change", function HsCompositionsComponent_li_75_Template_input_change_2_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r23); const item_r20 = restoredCtx.$implicit; const ctx_r22 = ɵngcc0.ɵɵnextContext(); const _r3 = ɵngcc0.ɵɵreference(71); ctx_r22.sortByValueChanged(item_r20); return _r3.close(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r20 = ctx.$implicit;
    const index_r21 = ctx.index;
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("checked", index_r21 === 0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r4.hsCompositionsService.translateString("COMPOSITONSORTVALUES", item_r20.name));
} }
function HsCompositionsComponent_li_85_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 55);
    ɵngcc0.ɵɵelement(1, "img", 56);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("src", ctx_r5.hsUtilsService.getAjaxLoaderIcon(), ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 2, "COMMON.loading"));
} }
const _c1 = function (a0) { return { "hs-endpoint-item-active": a0 }; };
function HsCompositionsComponent_li_89_Template(rf, ctx) { if (rf & 1) {
    const _r26 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 57);
    ɵngcc0.ɵɵlistener("mouseover", function HsCompositionsComponent_li_89_Template_li_mouseover_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r26); const composition_r24 = restoredCtx.$implicit; const ctx_r25 = ɵngcc0.ɵɵnextContext(); return ctx_r25.highlightComposition(composition_r24, true); })("mouseleave", function HsCompositionsComponent_li_89_Template_li_mouseleave_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r26); const composition_r24 = restoredCtx.$implicit; const ctx_r27 = ɵngcc0.ɵɵnextContext(); return ctx_r27.highlightComposition(composition_r24, false); })("click", function HsCompositionsComponent_li_89_Template_li_click_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r26); const composition_r24 = restoredCtx.$implicit; const ctx_r28 = ɵngcc0.ɵɵnextContext(); return ctx_r28.compositionClicked(composition_r24); });
    ɵngcc0.ɵɵelement(1, "hs-compositions-list-item", 58);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const composition_r24 = ctx.$implicit;
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("hidden", ctx_r6.hsCompositionsCatalogueService.dataLoading)("ngClass", ɵngcc0.ɵɵpureFunction1(5, _c1, composition_r24.highlighted));
    ɵngcc0.ɵɵattribute("title", composition_r24.mdAbstract);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("composition", composition_r24)("selectedCompId", ctx_r6.selectedCompId);
} }
const _c2 = function () { return { standalone: true }; };
function HsDialogContainerComponent_ng_template_1_Template(rf, ctx) { }
const _c3 = [[["extra-title"]], [["extra-buttons"]]];
const _c4 = ["extra-title", "extra-buttons"];
function HsPanelContainerComponent_ng_template_0_Template(rf, ctx) { }
function HsToastComponent_ngb_toast_0_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ngb-toast", 1);
    ɵngcc0.ɵɵlistener("hidden", function HsToastComponent_ngb_toast_0_Template_ngb_toast_hidden_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r3); const toast_r1 = restoredCtx.$implicit; const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.PmToastService.remove(toast_r1); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const toast_r1 = ctx.$implicit;
    ɵngcc0.ɵɵclassMap(toast_r1.classname);
    ɵngcc0.ɵɵproperty("header", toast_r1.header)("autohide", toast_r1.autohide)("delay", toast_r1.delay || 5000);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("", toast_r1.textOrTpl, "\n");
} }
const _c5 = ["hslayout"];
function HsLayoutComponent_ng_template_5_Template(rf, ctx) { }
function HsLayoutComponent_div_7_hs_mini_sidebar_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "hs-mini-sidebar", 16);
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("hidden", !ctx_r3.panelVisible("sidebar", ctx_r3));
} }
const _c6 = function (a0, a1) { return { "labels": a0, "buttons": a1 }; };
const _c7 = function (a0) { return { width: a0 }; };
function HsLayoutComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 10);
    ɵngcc0.ɵɵelementStart(1, "div", 11);
    ɵngcc0.ɵɵelement(2, "hs-sidebar", 12);
    ɵngcc0.ɵɵelementStart(3, "div", 13);
    ɵngcc0.ɵɵtemplate(4, HsLayoutComponent_div_7_hs_mini_sidebar_4_Template, 1, 1, "hs-mini-sidebar", 14);
    ɵngcc0.ɵɵelement(5, "hs-panel-container", 15);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(5, _c6, ctx_r2.HsLayoutService.sidebarLabels, ctx_r2.HsLayoutService.sidebarButtons))("ngStyle", ɵngcc0.ɵɵpureFunction1(8, _c7, ctx_r2.panelSpaceWidth() + "px"));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.HsLayoutService.minisidebar);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("service", ctx_r2.HsPanelContainerService)("ngStyle", ɵngcc0.ɵɵpureFunction1(10, _c7, ctx_r2.panelSpaceWidth() - 50 + "px"));
} }
const _c8 = function (a0, a1, a2, a3) { return { "hs-open": a0, "hs-sb-right": a1, "hs-sb-left": a2, "hs-sb-bottom": a3 }; };
const _c9 = ["map"];
function HsMiniSidebarComponent_hs_panel_header_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "hs-panel-header", 6);
    ɵngcc0.ɵɵpipe(1, "translate");
} if (rf & 2) {
    ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(1, 1, "SIDEBAR.additionalPanels"));
} }
function HsMiniSidebarComponent_span_2_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 7);
    ɵngcc0.ɵɵlistener("click", function HsMiniSidebarComponent_span_2_Template_span_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.toggleSidebar(); });
    ɵngcc0.ɵɵelement(1, "i", 8);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r1.HsLayoutService.sidebarExpanded ? ctx_r1.HsConfig.sidebarPosition === "left" ? "icon-chevron-left" : "icon-chevron-right" : ctx_r1.HsConfig.sidebarPosition === "left" ? "icon-chevron-right" : "icon-chevron-left");
} }
function HsMiniSidebarComponent_span_3_i_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 13);
} if (rf & 2) {
    const button_r6 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵclassMapInterpolate1("menu-icon ", button_r6.icon, "");
} }
function HsMiniSidebarComponent_span_3_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 14);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const button_r6 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r8 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵpropertyInterpolate("title", ctx_r8.HsSidebarService.getButtonDescription(button_r6));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(button_r6.content());
} }
const _c10 = function (a0, a1) { return { "active": a0, "hs-panel-hidden": a1 }; };
const _c11 = function (a0) { return { "margin-left": a0 }; };
function HsMiniSidebarComponent_span_3_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 9);
    ɵngcc0.ɵɵlistener("click", function HsMiniSidebarComponent_span_3_Template_span_click_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r12); const button_r6 = restoredCtx.$implicit; const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.HsSidebarService.buttonClicked(button_r6); });
    ɵngcc0.ɵɵtemplate(1, HsMiniSidebarComponent_span_3_i_1_Template, 1, 3, "i", 10);
    ɵngcc0.ɵɵtemplate(2, HsMiniSidebarComponent_span_3_span_2_Template, 2, 2, "span", 11);
    ɵngcc0.ɵɵelementStart(3, "span", 12);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const button_r6 = ctx.$implicit;
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵpropertyInterpolate("title", ctx_r2.HsSidebarService.getButtonDescription(button_r6));
    ɵngcc0.ɵɵproperty("hidden", !button_r6.visible)("ngClass", ɵngcc0.ɵɵpureFunction2(7, _c10, ctx_r2.HsLayoutService.mainpanel === button_r6.panel, !button_r6.fits));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", button_r6.icon);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", button_r6.content);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction1(10, _c11, button_r6.panel === "language" ? "14px" : "20px"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.HsSidebarService.getButtonTitle(button_r6));
} }
const _c12 = function (a0) { return { "active": a0 }; };
function HsMiniSidebarComponent_span_5_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 15);
    ɵngcc0.ɵɵlistener("click", function HsMiniSidebarComponent_span_5_Template_span_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r13 = ɵngcc0.ɵɵnextContext(); return ctx_r13.HsLayoutService.setMainPanel("sidebar", true); });
    ɵngcc0.ɵɵelement(1, "i", 16);
    ɵngcc0.ɵɵelementStart(2, "span", 17);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(2, _c12, ctx_r3.HsLayoutService.mainpanel === "sidebar"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r3.HsSidebarService.getButtonTitle(ctx_r3.HsSidebarService.miniSidebarButton));
} }
function HsSidebarComponent_hs_panel_header_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "hs-panel-header", 6);
    ɵngcc0.ɵɵpipe(1, "translate");
} if (rf & 2) {
    ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(1, 1, "SIDEBAR.additionalPanels"));
} }
function HsSidebarComponent_span_2_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 7);
    ɵngcc0.ɵɵlistener("click", function HsSidebarComponent_span_2_Template_span_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.toggleSidebar(); });
    ɵngcc0.ɵɵelement(1, "i", 8);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r1.HsLayoutService.sidebarExpanded ? ctx_r1.HsConfig.sidebarPosition === "left" ? "icon-chevron-left" : "icon-chevron-right" : ctx_r1.HsConfig.sidebarPosition === "left" ? "icon-chevron-right" : "icon-chevron-left");
} }
function HsSidebarComponent_span_3_i_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 13);
} if (rf & 2) {
    const button_r6 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵclassMapInterpolate1("menu-icon ", button_r6.icon, "");
} }
function HsSidebarComponent_span_3_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 14);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const button_r6 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r8 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵpropertyInterpolate("title", ctx_r8.HsSidebarService.getButtonDescription(button_r6));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(button_r6.content());
} }
function HsSidebarComponent_span_3_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 9);
    ɵngcc0.ɵɵlistener("click", function HsSidebarComponent_span_3_Template_span_click_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r12); const button_r6 = restoredCtx.$implicit; const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.HsSidebarService.buttonClicked(button_r6); });
    ɵngcc0.ɵɵtemplate(1, HsSidebarComponent_span_3_i_1_Template, 1, 3, "i", 10);
    ɵngcc0.ɵɵtemplate(2, HsSidebarComponent_span_3_span_2_Template, 2, 2, "span", 11);
    ɵngcc0.ɵɵelementStart(3, "span", 12);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const button_r6 = ctx.$implicit;
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵpropertyInterpolate("title", ctx_r2.HsSidebarService.getButtonDescription(button_r6));
    ɵngcc0.ɵɵproperty("hidden", !button_r6.visible)("ngClass", ɵngcc0.ɵɵpureFunction2(7, _c10, ctx_r2.HsLayoutService.mainpanel === button_r6.panel, !button_r6.fits));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", button_r6.icon);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", button_r6.content);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction1(10, _c11, button_r6.panel === "language" ? "14px" : "20px"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.HsSidebarService.getButtonTitle(button_r6));
} }
function HsSidebarComponent_span_5_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 15);
    ɵngcc0.ɵɵlistener("click", function HsSidebarComponent_span_5_Template_span_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r13 = ɵngcc0.ɵɵnextContext(); return ctx_r13.HsLayoutService.setMainPanel("sidebar", true); });
    ɵngcc0.ɵɵelement(1, "i", 16);
    ɵngcc0.ɵɵelementStart(2, "span", 17);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(2, _c12, ctx_r3.HsLayoutService.mainpanel === "sidebar"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r3.HsSidebarService.getButtonTitle(ctx_r3.HsSidebarService.miniSidebarButton));
} }
function HsDrawLayerMetadataDialogComponent_div_17_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 17);
    ɵngcc0.ɵɵelementStart(1, "p", 18);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(4, "hs-layman-current-user", 19);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(3, 2, "DRAW.notAuthorized"), " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("endpoint", ctx_r0.endpoint);
} }
function HsDrawLayerMetadataDialogComponent_div_18_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 20);
    ɵngcc0.ɵɵelementStart(1, "button", 21);
    ɵngcc0.ɵɵlistener("click", function HsDrawLayerMetadataDialogComponent_div_18_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.type = "draw"; });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "button", 22);
    ɵngcc0.ɵɵlistener("click", function HsDrawLayerMetadataDialogComponent_div_18_Template_button_click_4_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.type = "layman"; });
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵpipe(6, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r1.type === "draw" ? "btn-primary" : "btn-secondary");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(3, 4, "DRAW.drawToolbar.addDrawLayer"), " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r1.type === "layman" ? "btn-primary" : "btn-secondary");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(6, 6, "DRAW.drawLayerMetadata.loadServerLayers"), " ");
} }
function HsDrawLayerMetadataDialogComponent_form_20_hs_layman_access_rights_7_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "hs-layman-access-rights", 39);
    ɵngcc0.ɵɵlistener("access_rightsChange", function HsDrawLayerMetadataDialogComponent_form_20_hs_layman_access_rights_7_Template_hs_layman_access_rights_access_rightsChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r10 = ɵngcc0.ɵɵnextContext(2); return ctx_r10.access_rights = $event; });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("access_rights", ctx_r8.access_rights);
} }
function HsDrawLayerMetadataDialogComponent_form_20_tr_32_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "tr");
    ɵngcc0.ɵɵelementStart(1, "td");
    ɵngcc0.ɵɵelementStart(2, "input", 40);
    ɵngcc0.ɵɵlistener("ngModelChange", function HsDrawLayerMetadataDialogComponent_form_20_tr_32_Template_input_ngModelChange_2_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r14); const attr_r12 = restoredCtx.$implicit; return attr_r12.name = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "td");
    ɵngcc0.ɵɵelementStart(4, "input", 40);
    ɵngcc0.ɵɵlistener("ngModelChange", function HsDrawLayerMetadataDialogComponent_form_20_tr_32_Template_input_ngModelChange_4_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r14); const attr_r12 = restoredCtx.$implicit; return attr_r12.value = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const attr_r12 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngModel", attr_r12.name)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(4, _c2));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngModel", attr_r12.value)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(5, _c2));
} }
function HsDrawLayerMetadataDialogComponent_form_20_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "form");
    ɵngcc0.ɵɵelementStart(1, "div", 23);
    ɵngcc0.ɵɵelementStart(2, "label", 24);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 25);
    ɵngcc0.ɵɵelementStart(6, "input", 26);
    ɵngcc0.ɵɵlistener("ngModelChange", function HsDrawLayerMetadataDialogComponent_form_20_Template_input_ngModelChange_6_listener($event) { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r16 = ɵngcc0.ɵɵnextContext(); return ctx_r16.title = $event; })("ngModelChange", function HsDrawLayerMetadataDialogComponent_form_20_Template_input_ngModelChange_6_listener() { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r18 = ɵngcc0.ɵɵnextContext(); return ctx_r18.titleChanged(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(7, HsDrawLayerMetadataDialogComponent_form_20_hs_layman_access_rights_7_Template, 1, 1, "hs-layman-access-rights", 27);
    ɵngcc0.ɵɵelementStart(8, "div", 28);
    ɵngcc0.ɵɵelementStart(9, "a", 29);
    ɵngcc0.ɵɵlistener("click", function HsDrawLayerMetadataDialogComponent_form_20_Template_a_click_9_listener() { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r19 = ɵngcc0.ɵɵnextContext(); return ctx_r19.folderVisible = !ctx_r19.folderVisible; });
    ɵngcc0.ɵɵtext(10);
    ɵngcc0.ɵɵpipe(11, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(12, "div", 30);
    ɵngcc0.ɵɵelementStart(13, "div", 23);
    ɵngcc0.ɵɵelementStart(14, "label", 24);
    ɵngcc0.ɵɵtext(15);
    ɵngcc0.ɵɵpipe(16, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(17, "input", 31);
    ɵngcc0.ɵɵlistener("ngModelChange", function HsDrawLayerMetadataDialogComponent_form_20_Template_input_ngModelChange_17_listener($event) { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r20 = ɵngcc0.ɵɵnextContext(); return ctx_r20.path = $event; })("ngModelChange", function HsDrawLayerMetadataDialogComponent_form_20_Template_input_ngModelChange_17_listener() { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r21 = ɵngcc0.ɵɵnextContext(); return ctx_r21.pathChanged(); });
    ɵngcc0.ɵɵpipe(18, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(19, "div", 32);
    ɵngcc0.ɵɵelementStart(20, "h5", 33);
    ɵngcc0.ɵɵtext(21);
    ɵngcc0.ɵɵpipe(22, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(23, "div", 34);
    ɵngcc0.ɵɵelementStart(24, "table", 35);
    ɵngcc0.ɵɵelementStart(25, "tr");
    ɵngcc0.ɵɵelementStart(26, "th");
    ɵngcc0.ɵɵtext(27);
    ɵngcc0.ɵɵpipe(28, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(29, "th");
    ɵngcc0.ɵɵtext(30);
    ɵngcc0.ɵɵpipe(31, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(32, HsDrawLayerMetadataDialogComponent_form_20_tr_32_Template, 5, 6, "tr", 36);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(33, "button", 37);
    ɵngcc0.ɵɵlistener("click", function HsDrawLayerMetadataDialogComponent_form_20_Template_button_click_33_listener() { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r22 = ɵngcc0.ɵɵnextContext(); return ctx_r22.addAttr(); });
    ɵngcc0.ɵɵelement(34, "i", 38);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(4, 12, "DRAW.drawLayerMetadata.layerTitle"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r2.title);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.data.isAuthorized);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(11, 14, "COMMON.advancedOptions"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("hidden", !ctx_r2.folderVisible);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(16, 16, "COMMON.folder"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r2.path)("placeholder", ɵngcc0.ɵɵpipeBind1(18, 18, "DRAW.drawLayerMetadata.nameOfFolder"));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(22, 20, "DRAW.drawLayerMetadata.defaultAttributes"));
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(28, 22, "COMMON.attribute"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(31, 24, "DRAW.drawLayerMetadata.defaultValue"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r2.attributes);
} }
function HsDrawLayerMetadataDialogComponent_form_21_div_1_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r27 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 50);
    ɵngcc0.ɵɵelementStart(1, "label", 51);
    ɵngcc0.ɵɵelementStart(2, "input", 52);
    ɵngcc0.ɵɵlistener("ngModelChange", function HsDrawLayerMetadataDialogComponent_form_21_div_1_div_7_Template_input_ngModelChange_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r27); const ctx_r26 = ɵngcc0.ɵɵnextContext(3); return ctx_r26.data.onlyMine = $event; })("ngModelChange", function HsDrawLayerMetadataDialogComponent_form_21_div_1_div_7_Template_input_ngModelChange_2_listener() { ɵngcc0.ɵɵrestoreView(_r27); const ctx_r28 = ɵngcc0.ɵɵnextContext(3); ctx_r28.data.fillDrawableLayers(); return ctx_r28.onlyMineFilterVisible = !ctx_r28.onlyMineFilterVisible; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r24 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r24.data.onlyMine);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(4, 2, "COMPOSITIONS.onlyMine"), " ");
} }
function HsDrawLayerMetadataDialogComponent_form_21_div_1_li_9_Template(rf, ctx) { if (rf & 1) {
    const _r31 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 53);
    ɵngcc0.ɵɵelementStart(1, "b");
    ɵngcc0.ɵɵelementStart(2, "a", 54);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "span", 55);
    ɵngcc0.ɵɵelementStart(5, "button", 56);
    ɵngcc0.ɵɵlistener("click", function HsDrawLayerMetadataDialogComponent_form_21_div_1_li_9_Template_button_click_5_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r31); const layer_r29 = restoredCtx.$implicit; const ctx_r30 = ɵngcc0.ɵɵnextContext(3); return ctx_r30.selectLayer(layer_r29); });
    ɵngcc0.ɵɵpipe(6, "translate");
    ɵngcc0.ɵɵelement(7, "i", 38);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const layer_r29 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngClass", "list-group-item" + (layer_r29.highlighted ? " active" : ""));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵpropertyInterpolate("title", layer_r29.description);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(layer_r29.title);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(6, 4, "ADDLAYERS.WFS.addToMap"));
} }
function HsDrawLayerMetadataDialogComponent_form_21_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r33 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 42);
    ɵngcc0.ɵɵelementStart(1, "div", 43);
    ɵngcc0.ɵɵelementStart(2, "div", 44);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵelementStart(5, "span", 45);
    ɵngcc0.ɵɵlistener("click", function HsDrawLayerMetadataDialogComponent_form_21_div_1_Template_span_click_5_listener() { ɵngcc0.ɵɵrestoreView(_r33); const ctx_r32 = ɵngcc0.ɵɵnextContext(2); return ctx_r32.onlyMineFilterVisible = !ctx_r32.onlyMineFilterVisible; });
    ɵngcc0.ɵɵelement(6, "i", 46);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(7, HsDrawLayerMetadataDialogComponent_form_21_div_1_div_7_Template, 5, 4, "div", 47);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "ul", 48);
    ɵngcc0.ɵɵtemplate(9, HsDrawLayerMetadataDialogComponent_form_21_div_1_li_9_Template, 8, 6, "li", 49);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r23 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(4, 3, "DRAW.serverLayers"), " ");
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r23.onlyMineFilterVisible);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r23.data.drawableLaymanLayers);
} }
function HsDrawLayerMetadataDialogComponent_form_21_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "form");
    ɵngcc0.ɵɵtemplate(1, HsDrawLayerMetadataDialogComponent_form_21_div_1_Template, 10, 5, "div", 41);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.data.drawableLaymanLayers.length > 0);
} }
function HsDrawLayerMetadataDialogComponent_button_23_Template(rf, ctx) { if (rf & 1) {
    const _r35 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 16);
    ɵngcc0.ɵɵlistener("click", function HsDrawLayerMetadataDialogComponent_button_23_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r35); const ctx_r34 = ɵngcc0.ɵɵnextContext(); return ctx_r34.confirm(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, "DRAW.drawToolbar.addLayer"));
} }
function HsDrawComponent_ng_template_16_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p", 35);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, "DRAW.noSuitableLayer"));
} }
function HsDrawComponent_div_18_div_9_a_4_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 48);
    ɵngcc0.ɵɵlistener("click", function HsDrawComponent_div_18_div_9_a_4_Template_a_click_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r12); const layer_r10 = restoredCtx.$implicit; const ctx_r11 = ɵngcc0.ɵɵnextContext(3); return ctx_r11.selectLayer(layer_r10); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const layer_r10 = ctx.$implicit;
    const ctx_r9 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵpropertyInterpolate("title", ctx_r9.HsLayerUtilsService.translateTitle(ctx_r9.getTitle(layer_r10)));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r9.HsLayerUtilsService.translateTitle(ctx_r9.getTitle(layer_r10)));
} }
function HsDrawComponent_div_18_div_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 45);
    ɵngcc0.ɵɵelementStart(1, "label", 46);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, HsDrawComponent_div_18_div_9_a_4_Template, 2, 2, "a", 47);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 2, "DRAW.activeLayers"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r5.HsDrawService.drawableLayers);
} }
function HsDrawComponent_div_18_div_10_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r16 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 53);
    ɵngcc0.ɵɵelementStart(1, "label", 54);
    ɵngcc0.ɵɵelementStart(2, "input", 55);
    ɵngcc0.ɵɵlistener("ngModelChange", function HsDrawComponent_div_18_div_10_div_7_Template_input_ngModelChange_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r16); const ctx_r15 = ɵngcc0.ɵɵnextContext(3); return ctx_r15.HsDrawService.onlyMine = $event; })("ngModelChange", function HsDrawComponent_div_18_div_10_div_7_Template_input_ngModelChange_2_listener() { ɵngcc0.ɵɵrestoreView(_r16); const ctx_r17 = ɵngcc0.ɵɵnextContext(3); ctx_r17.HsDrawService.fillDrawableLayers(); return ctx_r17.onlyMineFilterVisible = !ctx_r17.onlyMineFilterVisible; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r13.HsDrawService.onlyMine);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(4, 2, "COMPOSITIONS.onlyMine"), " ");
} }
function HsDrawComponent_div_18_div_10_a_8_Template(rf, ctx) { if (rf & 1) {
    const _r20 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 48);
    ɵngcc0.ɵɵlistener("click", function HsDrawComponent_div_18_div_10_a_8_Template_a_click_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r20); const layer_r18 = restoredCtx.$implicit; const ctx_r19 = ɵngcc0.ɵɵnextContext(3); return ctx_r19.selectLayer(layer_r18); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const layer_r18 = ctx.$implicit;
    const ctx_r14 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵpropertyInterpolate("title", ctx_r14.HsLayerUtilsService.translateTitle(layer_r18.title));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r14.HsLayerUtilsService.translateTitle(layer_r18.title));
} }
function HsDrawComponent_div_18_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r22 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 45);
    ɵngcc0.ɵɵelementStart(1, "div", 46);
    ɵngcc0.ɵɵelementStart(2, "div", 49);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵelementStart(5, "span", 50);
    ɵngcc0.ɵɵlistener("click", function HsDrawComponent_div_18_div_10_Template_span_click_5_listener() { ɵngcc0.ɵɵrestoreView(_r22); const ctx_r21 = ɵngcc0.ɵɵnextContext(2); return ctx_r21.onlyMineFilterVisible = !ctx_r21.onlyMineFilterVisible; });
    ɵngcc0.ɵɵelement(6, "i", 51);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(7, HsDrawComponent_div_18_div_10_div_7_Template, 5, 4, "div", 52);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(8, HsDrawComponent_div_18_div_10_a_8_Template, 2, 2, "a", 47);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(4, 3, "DRAW.serverLayers"), " ");
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6.onlyMineFilterVisible);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r6.HsDrawService.drawableLaymanLayers);
} }
function HsDrawComponent_div_18_button_11_Template(rf, ctx) { if (rf & 1) {
    const _r24 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 56);
    ɵngcc0.ɵɵlistener("click", function HsDrawComponent_div_18_button_11_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r24); const ctx_r23 = ɵngcc0.ɵɵnextContext(2); return ctx_r23.HsDrawService.saveDrawingLayer(); });
    ɵngcc0.ɵɵpipe(1, "translate");
    ɵngcc0.ɵɵelement(2, "i", 57);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(1, 1, "DRAW.saveDrawingToLayer"));
} }
function HsDrawComponent_div_18_button_12_Template(rf, ctx) { if (rf & 1) {
    const _r26 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 58);
    ɵngcc0.ɵɵlistener("click", function HsDrawComponent_div_18_button_12_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r26); const ctx_r25 = ɵngcc0.ɵɵnextContext(2); return ctx_r25.HsDrawService.removeLayer(); });
    ɵngcc0.ɵɵpipe(1, "translate");
    ɵngcc0.ɵɵelement(2, "i", 59);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(1, 1, "COMMON.removeLayer"));
} }
const _c13 = function (a0, a1) { return { "btn-light btn-outline-danger border-0": a0, "dropdown-toggle": a1 }; };
const _c14 = function (a0) { return { "show": a0 }; };
function HsDrawComponent_div_18_Template(rf, ctx) { if (rf & 1) {
    const _r28 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 36);
    ɵngcc0.ɵɵelementStart(1, "p", 37);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 38);
    ɵngcc0.ɵɵelementStart(5, "button", 39);
    ɵngcc0.ɵɵlistener("click", function HsDrawComponent_div_18_Template_button_click_5_listener() { ɵngcc0.ɵɵrestoreView(_r28); const ctx_r27 = ɵngcc0.ɵɵnextContext(); ctx_r27.layersExpanded = !ctx_r27.layersExpanded; return ctx_r27.HsDrawService.fillDrawableLayers(); });
    ɵngcc0.ɵɵelementStart(6, "div", 40);
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "div", 41);
    ɵngcc0.ɵɵtemplate(9, HsDrawComponent_div_18_div_9_Template, 5, 4, "div", 42);
    ɵngcc0.ɵɵtemplate(10, HsDrawComponent_div_18_div_10_Template, 9, 5, "div", 42);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(11, HsDrawComponent_div_18_button_11_Template, 3, 3, "button", 43);
    ɵngcc0.ɵɵtemplate(12, HsDrawComponent_div_18_button_12_Template, 3, 3, "button", 44);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 10, "DRAW.drawingTo"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(12, _c13, ctx_r2.HsDrawService.tmpDrawLayer, ctx_r2.HsDrawService.hasSomeDrawables))("disabled", !ctx_r2.HsDrawService.hasSomeDrawables);
    ɵngcc0.ɵɵattribute("aria-expanded", ctx_r2.layersExpanded);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.HsDrawService.selectedLayerString());
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(15, _c14, ctx_r2.layersExpanded));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.HsDrawService.drawableLayers.length > 0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.HsDrawService.drawableLaymanLayers.length > 0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.HsDrawService.tmpDrawLayer);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.HsDrawService.selectedLayer);
} }
function HsDrawComponent_div_53_a_10_Template(rf, ctx) { if (rf & 1) {
    const _r32 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 48);
    ɵngcc0.ɵɵlistener("click", function HsDrawComponent_div_53_a_10_Template_a_click_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r32); const layer_r30 = restoredCtx.$implicit; const ctx_r31 = ɵngcc0.ɵɵnextContext(2); return ctx_r31.changeSnapSource(layer_r30); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const layer_r30 = ctx.$implicit;
    const ctx_r29 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵpropertyInterpolate("title", ctx_r29.HsLayerUtilsService.translateTitle(ctx_r29.getTitle(layer_r30)));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r29.HsLayerUtilsService.translateTitle(ctx_r29.getTitle(layer_r30)));
} }
function HsDrawComponent_div_53_Template(rf, ctx) { if (rf & 1) {
    const _r34 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 60);
    ɵngcc0.ɵɵelementStart(1, "p", 37);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 61);
    ɵngcc0.ɵɵelementStart(5, "button", 62);
    ɵngcc0.ɵɵlistener("click", function HsDrawComponent_div_53_Template_button_click_5_listener() { ɵngcc0.ɵɵrestoreView(_r34); const ctx_r33 = ɵngcc0.ɵɵnextContext(); ctx_r33.snapLayersExpanded = !ctx_r33.snapLayersExpanded; return ctx_r33.HsDrawService.fillDrawableLayers(); });
    ɵngcc0.ɵɵelementStart(6, "div", 63);
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "div", 64);
    ɵngcc0.ɵɵelementStart(9, "div", 45);
    ɵngcc0.ɵɵtemplate(10, HsDrawComponent_div_53_a_10_Template, 2, 2, "a", 47);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(3, 5, "DRAW.snapTo"), ":");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵattribute("aria-expanded", ctx_r3.snapLayersExpanded);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r3.HsDrawService.snapLayerString());
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(7, _c14, ctx_r3.snapLayersExpanded));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r3.HsDrawService.drawableLayers);
} }
function HsDrawComponent_div_54_li_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementStart(3, "strong");
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const layer_r36 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(2, 2, "DRAW.loadingLayer"), " ");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(layer_r36);
} }
function HsDrawComponent_div_54_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 65);
    ɵngcc0.ɵɵelementStart(1, "div", 66);
    ɵngcc0.ɵɵelementStart(2, "ol");
    ɵngcc0.ɵɵtemplate(3, HsDrawComponent_div_54_li_3_Template, 5, 4, "li", 67);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵpipe(5, "translate");
    ɵngcc0.ɵɵelementStart(6, "div", 68);
    ɵngcc0.ɵɵelement(7, "img", 69);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r4.HsDrawService.pendingLayers);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(5, 3, "DRAW.longerLoading"), " ");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("src", ctx_r4.hsUtilsService.getAjaxLoaderIcon(), ɵngcc0.ɵɵsanitizeUrl);
} }
const _c15 = function (a0) { return { "btn-sm": a0 }; };
const _c16 = function (a0) { return { active: a0 }; };
const _c17 = function (a0, a1) { return { "hs-checkmark": a0, "hs-uncheckmark": a1 }; };
function HsDrawToolbarComponent_div_4_div_5_a_4_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 23);
    ɵngcc0.ɵɵlistener("click", function HsDrawToolbarComponent_div_4_div_5_a_4_Template_a_click_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r9); const layer_r7 = restoredCtx.$implicit; const ctx_r8 = ɵngcc0.ɵɵnextContext(3); return ctx_r8.selectLayer(layer_r7); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const layer_r7 = ctx.$implicit;
    const ctx_r6 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r6.HsLayerUtilsService.translateTitle(ctx_r6.getTitle(layer_r7)));
} }
function HsDrawToolbarComponent_div_4_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 20);
    ɵngcc0.ɵɵelementStart(1, "label", 21);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, HsDrawToolbarComponent_div_4_div_5_a_4_Template, 2, 1, "a", 22);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 2, "DRAW.activeLayers"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.HsDrawService.drawableLayers);
} }
function HsDrawToolbarComponent_div_4_div_6_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 28);
    ɵngcc0.ɵɵelementStart(1, "label", 29);
    ɵngcc0.ɵɵelementStart(2, "input", 30);
    ɵngcc0.ɵɵlistener("ngModelChange", function HsDrawToolbarComponent_div_4_div_6_div_7_Template_input_ngModelChange_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r12 = ɵngcc0.ɵɵnextContext(3); return ctx_r12.HsDrawService.onlyMine = $event; })("ngModelChange", function HsDrawToolbarComponent_div_4_div_6_div_7_Template_input_ngModelChange_2_listener() { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r14 = ɵngcc0.ɵɵnextContext(3); ctx_r14.HsDrawService.fillDrawableLayers(); return ctx_r14.onlyMineFilterVisible = !ctx_r14.onlyMineFilterVisible; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r10.HsDrawService.onlyMine);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(4, 2, "COMPOSITIONS.onlyMine"), " ");
} }
function HsDrawToolbarComponent_div_4_div_6_a_8_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 23);
    ɵngcc0.ɵɵlistener("click", function HsDrawToolbarComponent_div_4_div_6_a_8_Template_a_click_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r17); const layer_r15 = restoredCtx.$implicit; const ctx_r16 = ɵngcc0.ɵɵnextContext(3); return ctx_r16.selectLayer(layer_r15); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const layer_r15 = ctx.$implicit;
    const ctx_r11 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r11.HsLayerUtilsService.translateTitle(layer_r15.title));
} }
function HsDrawToolbarComponent_div_4_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r19 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 20);
    ɵngcc0.ɵɵelementStart(1, "div", 21);
    ɵngcc0.ɵɵelementStart(2, "div", 24);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵelementStart(5, "span", 25);
    ɵngcc0.ɵɵlistener("click", function HsDrawToolbarComponent_div_4_div_6_Template_span_click_5_listener() { ɵngcc0.ɵɵrestoreView(_r19); const ctx_r18 = ɵngcc0.ɵɵnextContext(2); return ctx_r18.onlyMineFilterVisible = !ctx_r18.onlyMineFilterVisible; });
    ɵngcc0.ɵɵelement(6, "i", 26);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(7, HsDrawToolbarComponent_div_4_div_6_div_7_Template, 5, 4, "div", 27);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(8, HsDrawToolbarComponent_div_4_div_6_a_8_Template, 2, 1, "a", 22);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(4, 3, "DRAW.serverLayers"), " ");
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.onlyMineFilterVisible);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r2.HsDrawService.drawableLaymanLayers);
} }
function HsDrawToolbarComponent_div_4_button_10_Template(rf, ctx) { if (rf & 1) {
    const _r21 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 31);
    ɵngcc0.ɵɵlistener("click", function HsDrawToolbarComponent_div_4_button_10_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r21); const ctx_r20 = ɵngcc0.ɵɵnextContext(2); return ctx_r20.HsDrawService.saveDrawingLayer(); });
    ɵngcc0.ɵɵpipe(1, "translate");
    ɵngcc0.ɵɵelement(2, "i", 32);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(1, 1, "DRAW.saveDrawingToLayer"));
} }
function HsDrawToolbarComponent_div_4_button_11_Template(rf, ctx) { if (rf & 1) {
    const _r23 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 31);
    ɵngcc0.ɵɵlistener("click", function HsDrawToolbarComponent_div_4_button_11_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r23); const ctx_r22 = ɵngcc0.ɵɵnextContext(2); return ctx_r22.HsDrawService.removeLayer(); });
    ɵngcc0.ɵɵpipe(1, "translate");
    ɵngcc0.ɵɵelement(2, "i", 33);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(1, 1, "COMMON.removeLayer"));
} }
function HsDrawToolbarComponent_div_4_div_26_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r28 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 44);
    ɵngcc0.ɵɵlistener("click", function HsDrawToolbarComponent_div_4_div_26_button_2_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r28); const ctx_r27 = ɵngcc0.ɵɵnextContext(3); return ctx_r27.HsDrawService.removeLastPoint(); });
    ɵngcc0.ɵɵpipe(1, "translate");
    ɵngcc0.ɵɵelement(2, "i", 45);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(1, 1, "DRAW.drawToolbar.removeLastPoint"));
} }
function HsDrawToolbarComponent_div_4_div_26_button_3_Template(rf, ctx) { if (rf & 1) {
    const _r30 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 44);
    ɵngcc0.ɵɵlistener("click", function HsDrawToolbarComponent_div_4_div_26_button_3_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r30); const ctx_r29 = ɵngcc0.ɵɵnextContext(3); return ctx_r29.finishDrawing(); });
    ɵngcc0.ɵɵpipe(1, "translate");
    ɵngcc0.ɵɵelement(2, "i", 46);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(1, 1, "DRAW.drawToolbar.finishFeature"));
} }
function HsDrawToolbarComponent_div_4_div_26_label_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "label", 29);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, "DRAW.drawToolbar.selectType"));
} }
const _c18 = function () { return { "left": 0 }; };
const _c19 = function () { return { "right": 0 }; };
const _c20 = function (a0, a1, a2) { return { "icon-pin": a0, "icon-polygonlasso": a1, "icon-line": a2 }; };
function HsDrawToolbarComponent_div_4_div_26_Template(rf, ctx) { if (rf & 1) {
    const _r32 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 0);
    ɵngcc0.ɵɵelementStart(1, "div", 34);
    ɵngcc0.ɵɵtemplate(2, HsDrawToolbarComponent_div_4_div_26_button_2_Template, 3, 3, "button", 35);
    ɵngcc0.ɵɵtemplate(3, HsDrawToolbarComponent_div_4_div_26_button_3_Template, 3, 3, "button", 35);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "button", 36);
    ɵngcc0.ɵɵlistener("click", function HsDrawToolbarComponent_div_4_div_26_Template_button_click_4_listener() { ɵngcc0.ɵɵrestoreView(_r32); const ctx_r31 = ɵngcc0.ɵɵnextContext(2); return ctx_r31.drawTypeExpanded = !ctx_r31.drawTypeExpanded; });
    ɵngcc0.ɵɵtemplate(5, HsDrawToolbarComponent_div_4_div_26_label_5_Template, 3, 3, "label", 37);
    ɵngcc0.ɵɵelement(6, "i", 38);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 39);
    ɵngcc0.ɵɵelementStart(8, "div", 0);
    ɵngcc0.ɵɵelementStart(9, "button", 40);
    ɵngcc0.ɵɵlistener("click", function HsDrawToolbarComponent_div_4_div_26_Template_button_click_9_listener() { ɵngcc0.ɵɵrestoreView(_r32); const ctx_r33 = ɵngcc0.ɵɵnextContext(2); ctx_r33.setType("Point"); return ctx_r33.drawTypeExpanded = !ctx_r33.drawTypeExpanded; });
    ɵngcc0.ɵɵpipe(10, "translate");
    ɵngcc0.ɵɵelement(11, "i", 41);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(12, "button", 40);
    ɵngcc0.ɵɵlistener("click", function HsDrawToolbarComponent_div_4_div_26_Template_button_click_12_listener() { ɵngcc0.ɵɵrestoreView(_r32); const ctx_r34 = ɵngcc0.ɵɵnextContext(2); ctx_r34.setType("Polygon"); return ctx_r34.drawTypeExpanded = !ctx_r34.drawTypeExpanded; });
    ɵngcc0.ɵɵpipe(13, "translate");
    ɵngcc0.ɵɵelement(14, "i", 42);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(15, "button", 40);
    ɵngcc0.ɵɵlistener("click", function HsDrawToolbarComponent_div_4_div_26_Template_button_click_15_listener() { ɵngcc0.ɵɵrestoreView(_r32); const ctx_r35 = ɵngcc0.ɵɵnextContext(2); ctx_r35.setType("LineString"); return ctx_r35.drawTypeExpanded = !ctx_r35.drawTypeExpanded; });
    ɵngcc0.ɵɵpipe(16, "translate");
    ɵngcc0.ɵɵelement(17, "i", 43);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngStyle", ctx_r5.HsConfig.sidebarPosition !== "left" || ctx_r5.HsLayoutService.sidebarBottom() ? ɵngcc0.ɵɵpureFunction0(19, _c18) : ɵngcc0.ɵɵpureFunction0(20, _c19));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r5.HsDrawService.drawActive);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r5.HsDrawService.drawActive);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(21, _c16, ctx_r5.HsDrawService.type));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r5.HsDrawService.type);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction3(23, _c20, ctx_r5.HsDrawService.type === "Point", ctx_r5.HsDrawService.type === "Polygon", ctx_r5.HsDrawService.type === "LineString"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(27, _c14, ctx_r5.drawTypeExpanded));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(29, _c16, ctx_r5.HsDrawService.type === "Point"))("title", ɵngcc0.ɵɵpipeBind1(10, 13, "COMMON.point"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(31, _c16, ctx_r5.HsDrawService.type === "Polygon"))("title", ɵngcc0.ɵɵpipeBind1(13, 15, "COMMON.polygon"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(33, _c16, ctx_r5.HsDrawService.type === "LineString"))("title", ɵngcc0.ɵɵpipeBind1(16, 17, "COMMON.line"));
} }
const _c21 = function (a0) { return { "d-flex": a0 }; };
function HsDrawToolbarComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r37 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 0);
    ɵngcc0.ɵɵelementStart(1, "button", 4);
    ɵngcc0.ɵɵlistener("click", function HsDrawToolbarComponent_div_4_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r37); const ctx_r36 = ɵngcc0.ɵɵnextContext(); ctx_r36.controlLayerListAction(); return ctx_r36.HsDrawService.fillDrawableLayers(); });
    ɵngcc0.ɵɵelementStart(2, "div", 5);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 6);
    ɵngcc0.ɵɵtemplate(5, HsDrawToolbarComponent_div_4_div_5_Template, 5, 4, "div", 7);
    ɵngcc0.ɵɵtemplate(6, HsDrawToolbarComponent_div_4_div_6_Template, 9, 5, "div", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "button", 8);
    ɵngcc0.ɵɵlistener("click", function HsDrawToolbarComponent_div_4_Template_button_click_7_listener() { ɵngcc0.ɵɵrestoreView(_r37); const ctx_r38 = ɵngcc0.ɵɵnextContext(); return ctx_r38.HsDrawService.saveDrawingLayer(); });
    ɵngcc0.ɵɵpipe(8, "translate");
    ɵngcc0.ɵɵelement(9, "i", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(10, HsDrawToolbarComponent_div_4_button_10_Template, 3, 3, "button", 10);
    ɵngcc0.ɵɵtemplate(11, HsDrawToolbarComponent_div_4_button_11_Template, 3, 3, "button", 11);
    ɵngcc0.ɵɵelementStart(12, "div", 0);
    ɵngcc0.ɵɵelementStart(13, "button", 12);
    ɵngcc0.ɵɵlistener("click", function HsDrawToolbarComponent_div_4_Template_button_click_13_listener($event) { ɵngcc0.ɵɵrestoreView(_r37); const ctx_r39 = ɵngcc0.ɵɵnextContext(); $event.preventDefault(); return ctx_r39.selectionMenuToggled(); });
    ɵngcc0.ɵɵpipe(14, "translate");
    ɵngcc0.ɵɵelement(15, "i", 13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(16, "div", 14);
    ɵngcc0.ɵɵelementStart(17, "div", 15);
    ɵngcc0.ɵɵelementStart(18, "div", 16);
    ɵngcc0.ɵɵelementStart(19, "label", 17);
    ɵngcc0.ɵɵtext(20);
    ɵngcc0.ɵɵpipe(21, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(22, "input", 18);
    ɵngcc0.ɵɵlistener("ngModelChange", function HsDrawToolbarComponent_div_4_Template_input_ngModelChange_22_listener($event) { ɵngcc0.ɵɵrestoreView(_r37); const ctx_r40 = ɵngcc0.ɵɵnextContext(); return ctx_r40.HsDrawService.boxSelectionActive = $event; })("change", function HsDrawToolbarComponent_div_4_Template_input_change_22_listener() { ɵngcc0.ɵɵrestoreView(_r37); const ctx_r41 = ɵngcc0.ɵɵnextContext(); ctx_r41.HsDrawService.toggleBoxSelection(); return ctx_r41.selectionMenuExpanded = !ctx_r41.selectionMenuExpanded; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(23, "button", 19);
    ɵngcc0.ɵɵlistener("click", function HsDrawToolbarComponent_div_4_Template_button_click_23_listener() { ɵngcc0.ɵɵrestoreView(_r37); const ctx_r42 = ɵngcc0.ɵɵnextContext(); ctx_r42.HsDrawService.selectAllFeatures(); return ctx_r42.selectionMenuExpanded = !ctx_r42.selectionMenuExpanded; });
    ɵngcc0.ɵɵpipe(24, "translate");
    ɵngcc0.ɵɵtext(25);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(26, HsDrawToolbarComponent_div_4_div_26_Template, 18, 35, "div", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", !(ctx_r0.HsDrawService.drawableLayers.length > 0 || ctx_r0.HsDrawService.tmpDrawLayer))("ngClass", ctx_r0.HsDrawService.tmpDrawLayer ? "btn-outline-danger" : "btn-outline-primary");
    ɵngcc0.ɵɵattribute("aria-expanded", ctx_r0.layersExpanded);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.HsDrawService.selectedLayerString());
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(29, _c14, ctx_r0.layersExpanded));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.HsDrawService.drawableLayers.length > 0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.HsDrawService.drawableLaymanLayers.length > 0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", ctx_r0.HsDrawService.tmpDrawLayer)("title", ɵngcc0.ɵɵpipeBind1(8, 21, "DRAW.drawToolbar.addDrawLayer"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.HsDrawService.tmpDrawLayer);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.HsDrawService.selectedLayer);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(31, _c16, !ctx_r0.HsDrawService.type))("title", ɵngcc0.ɵɵpipeBind1(14, 23, "STYLER.selection"));
    ɵngcc0.ɵɵattribute("aria-expanded", ctx_r0.selectionMenuExpanded);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(33, _c21, ctx_r0.selectionMenuExpanded));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(21, 25, "DRAW.boxSelection"), "");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.HsDrawService.boxSelectionActive);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("disabled", !ctx_r0.HsDrawService.selectedLayer)("title", ɵngcc0.ɵɵpipeBind1(24, 27, "STYLER.selection"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.translateString("DRAW", ctx_r0.HsDrawService.toggleSelectionString), " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.drawToolbarExpanded);
} }
const _c22 = function (a0, a1) { return { "icon-pencil": a0, "icon-remove": a1 }; };
function HsFeatureTableComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelement(1, "hs-layer-features", 4);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const layer_r1 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("layer", layer_r1);
} }
function HsGeolocationComponent_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 3);
    ɵngcc0.ɵɵlistener("click", function HsGeolocationComponent_button_1_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.HsGeolocationService.startLocalization(); });
    ɵngcc0.ɵɵpipe(1, "translate");
    ɵngcc0.ɵɵelement(2, "i", 4);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(1, 1, "GEOLOCATION.locateMe"));
} }
function HsGeolocationComponent_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 5);
    ɵngcc0.ɵɵlistener("click", function HsGeolocationComponent_button_2_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.HsGeolocationService.toggleTracking(); })("dblclick", function HsGeolocationComponent_button_2_Template_button_dblclick_0_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.HsGeolocationService.stopLocalization(); });
    ɵngcc0.ɵɵpipe(1, "translate");
    ɵngcc0.ɵɵelement(2, "i", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(1, 2, "GEOLOCATION.locateMe"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r1.HsGeolocationService.following && ctx_r1.HsGeolocationService.localization ? "icon-navigation" : "icon-gpson");
} }
const _c23 = function (a0) { return { "ol-collapsed": a0 }; };
function HsInfoComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 10);
    ɵngcc0.ɵɵelementStart(1, "div", 24);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("title", ɵngcc0.ɵɵpipeBind1(2, 2, "INFOCOMPONENT.viewComposeAndAnalyse"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(4, 4, "INFOCOMPONENT.newMap"));
} }
function HsInfoComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 10);
    ɵngcc0.ɵɵelementStart(1, "div", 11);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 25);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵpipe(6, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 3, "INFOCOMPONENT.unsavedMap"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("hidden", !!(!ctx_r1.layer_loading.length && ctx_r1.composition_edited));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(6, 5, "INFOCOMPONENT.youHaveUnsavedChanges"), "");
} }
function HsInfoComponent_span_21_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const layer_r3 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("", layer_r3, " ");
} }
function HsLanguageComponent_button_5_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 5);
    ɵngcc0.ɵɵlistener("click", function HsLanguageComponent_button_5_Template_button_click_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r3); const lang_r1 = restoredCtx.$implicit; const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.HsLanguageService.setLanguage(lang_r1.key); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const lang_r1 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", "btn btn-block" + (ctx_r0.HsLanguageService.language == lang_r1.key.substr(0, 2).toLowerCase() ? " btn-primary" : " btn-secondary"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(lang_r1.name);
} }
function HsLayerManagerRemoveAllDialogComponent_button_19_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 10);
    ɵngcc0.ɵɵlistener("click", function HsLayerManagerRemoveAllDialogComponent_button_19_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r1 = ɵngcc0.ɵɵnextContext(); return ctx_r1.removeAllLayers(true); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, "LAYERMANAGER.dialogRemoveAll.reloadComposition"));
} }
const _c24 = ["layerEditor"];
const _c25 = function (a1) { return { "thumbnail": true, "alert-info": a1 }; };
function HsLayerManagerComponent_div_15_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 23);
    ɵngcc0.ɵɵelementStart(1, "a", 24);
    ɵngcc0.ɵɵlistener("click", function HsLayerManagerComponent_div_15_Template_a_click_1_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r8); const box_r6 = restoredCtx.$implicit; const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.activateTheme(box_r6); });
    ɵngcc0.ɵɵelement(2, "img", 25);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const box_r6 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("title", ctx_r0.getTitle(box_r6));
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(4, _c25, ctx_r0.getActive(box_r6)));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("src", ctx_r0.getThumbnail(box_r6), ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵpropertyInterpolate("alt", ctx_r0.getTitle(box_r6));
} }
function HsLayerManagerComponent_ul_19_li_9_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 37);
} if (rf & 2) {
    const layer_r10 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r12 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("innerHtml", ctx_r12.HsLayerManagerService.makeSafeAndTranslate("LAYERS", layer_r10.abstract), ɵngcc0.ɵɵsanitizeHtml);
} }
function HsLayerManagerComponent_ul_19_li_9_ngb_progressbar_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "ngb-progressbar", 38);
} if (rf & 2) {
    const layer_r10 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("value", layer_r10.loadProgress.percents);
} }
const _c26 = function (a0) { return { "hs-lm-deactivated-layer": a0 }; };
const _c27 = function (a0, a1) { return { "font-weight-bold": a0, "text-muted": a1 }; };
function HsLayerManagerComponent_ul_19_li_9_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 30);
    ɵngcc0.ɵɵelementStart(1, "div", 13);
    ɵngcc0.ɵɵelementStart(2, "div", 27);
    ɵngcc0.ɵɵelementStart(3, "button", 31);
    ɵngcc0.ɵɵlistener("click", function HsLayerManagerComponent_ul_19_li_9_Template_button_click_3_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r17); const layer_r10 = restoredCtx.$implicit; const ctx_r16 = ɵngcc0.ɵɵnextContext(2); return ctx_r16.changeBaseLayerVisibility($event, layer_r10); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, HsLayerManagerComponent_ul_19_li_9_ng_template_4_Template, 1, 1, "ng-template", null, 32, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementStart(6, "div", 33);
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "div", 34);
    ɵngcc0.ɵɵelementStart(9, "span", 35);
    ɵngcc0.ɵɵlistener("click", function HsLayerManagerComponent_ul_19_li_9_Template_span_click_9_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r17); const layer_r10 = restoredCtx.$implicit; const ctx_r18 = ɵngcc0.ɵɵnextContext(2); return ctx_r18.HsLayerManagerService.toggleLayerEditor(layer_r10, "settings", "sublayers"); });
    ɵngcc0.ɵɵpipe(10, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(11, HsLayerManagerComponent_ul_19_li_9_ngb_progressbar_11_Template, 1, 1, "ngb-progressbar", 36);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const layer_r10 = ctx.$implicit;
    const _r11 = ɵngcc0.ɵɵreference(5);
    const ctx_r9 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵpropertyInterpolate("id", layer_r10.idString());
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(11, _c26, !layer_r10.visible || !layer_r10.active));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r9.data.baselayersVisible && layer_r10.visible ? "hs-checkmark" : "hs-uncheckmark");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(13, _c27, layer_r10.active, layer_r10.grayed))("ngbTooltip", layer_r10.abstract ? _r11 : "")("closeDelay", ctx_r9.HsConfig.layerTooltipDelay || 0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r9.HsLayerUtilsService.translateTitle(layer_r10.title), " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(10, 9, "COMMON.info"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", (layer_r10.loadProgress == null ? null : layer_r10.loadProgress.loadTotal) > 0);
} }
function HsLayerManagerComponent_ul_19_Template(rf, ctx) { if (rf & 1) {
    const _r20 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ul", 26);
    ɵngcc0.ɵɵelementStart(1, "li", 12);
    ɵngcc0.ɵɵelementStart(2, "div", 13);
    ɵngcc0.ɵɵelementStart(3, "div", 14);
    ɵngcc0.ɵɵelementStart(4, "span", 15);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵpipe(6, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 27);
    ɵngcc0.ɵɵelementStart(8, "button", 28);
    ɵngcc0.ɵɵlistener("click", function HsLayerManagerComponent_ul_19_Template_button_click_8_listener() { ɵngcc0.ɵɵrestoreView(_r20); const ctx_r19 = ɵngcc0.ɵɵnextContext(); return ctx_r19.changeBaseLayerVisibility(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(9, HsLayerManagerComponent_ul_19_li_9_Template, 12, 16, "li", 29);
    ɵngcc0.ɵɵpipe(10, "filter");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(6, 3, "LAYERMANAGER.baselayers"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r1.data.baselayersVisible ? "hs-checkmark" : "hs-uncheckmark");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind2(10, 5, ctx_r1.data.baselayers, ctx_r1.baselayerFilter));
} }
function HsLayerManagerComponent_li_27_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 37);
} if (rf & 2) {
    const layer_r21 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r23 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("innerHtml", ctx_r23.HsLayerManagerService.makeSafeAndTranslate("LAYERS", layer_r21.abstract), ɵngcc0.ɵɵsanitizeHtml);
} }
const _c28 = function (a0) { return { "hovering": a0 }; };
function HsLayerManagerComponent_li_27_Template(rf, ctx) { if (rf & 1) {
    const _r26 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 39);
    ɵngcc0.ɵɵlistener("click", function HsLayerManagerComponent_li_27_Template_li_click_0_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r26); const layer_r21 = restoredCtx.$implicit; const ctx_r25 = ɵngcc0.ɵɵnextContext(); return ctx_r25.changeTerrainLayerVisibility($event, layer_r21); })("mouseenter", function HsLayerManagerComponent_li_27_Template_li_mouseenter_0_listener() { ɵngcc0.ɵɵrestoreView(_r26); const ctx_r27 = ɵngcc0.ɵɵnextContext(); return ctx_r27.hovering = true; })("mouseleave", function HsLayerManagerComponent_li_27_Template_li_mouseleave_0_listener() { ɵngcc0.ɵɵrestoreView(_r26); const ctx_r28 = ɵngcc0.ɵɵnextContext(); return ctx_r28.hovering = false; });
    ɵngcc0.ɵɵelementStart(1, "div", 13);
    ɵngcc0.ɵɵelementStart(2, "div", 27);
    ɵngcc0.ɵɵelement(3, "button", 40);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, HsLayerManagerComponent_li_27_ng_template_4_Template, 1, 1, "ng-template", null, 32, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementStart(6, "div", 41);
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const layer_r21 = ctx.$implicit;
    const _r22 = ɵngcc0.ɵɵreference(5);
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(6, _c28, ctx_r2.hovering && !layer_r21.active));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r2.data.baselayersVisible && layer_r21.visible ? "hs-checkmark" : "hs-uncheckmark");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(8, _c27, layer_r21.active, layer_r21.grayed))("ngbTooltip", layer_r21.abstract ? _r22 : "")("closeDelay", ctx_r2.HsConfig.layerTooltipDelay || 0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r2.HsLayerUtilsService.translateTitle(layer_r21.title), " ");
} }
function HsLayerManagerComponent_li_30_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 42);
    ɵngcc0.ɵɵelementStart(1, "span", 15);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 1, "LAYERMANAGER.mapContent"));
} }
function HsLayerManagerComponent_ul_31_li_1_Template(rf, ctx) { if (rf & 1) {
    const _r33 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 46);
    ɵngcc0.ɵɵlistener("click", function HsLayerManagerComponent_ul_31_li_1_Template_li_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r33); const value_r29 = ɵngcc0.ɵɵnextContext().$implicit; return value_r29.visible = !value_r29.visible; });
    ɵngcc0.ɵɵelementStart(1, "span");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(3, "span", 47);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const value_r29 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r30 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1("", ctx_r30.HsLanguageService.getTranslationIgnoreNonExisting("LAYERMANAGER", value_r29.name), "\u00A0");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", value_r29.visible ? "icon-chevron-right" : "icon-chevron-down");
} }
function HsLayerManagerComponent_ul_31_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ul", 20);
    ɵngcc0.ɵɵtemplate(1, HsLayerManagerComponent_ul_31_li_1_Template, 4, 2, "li", 43);
    ɵngcc0.ɵɵelementStart(2, "div", 44);
    ɵngcc0.ɵɵelementStart(3, "li", 44);
    ɵngcc0.ɵɵelement(4, "hs-layer-manager-folder", 45);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "li");
    ɵngcc0.ɵɵelement(6, "hs-layermanager-layer-list", 45);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const value_r29 = ctx.$implicit;
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("hidden", ctx_r4.physicalLayerListEnabled);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.data.folders.sub_folders.length > 1);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", !value_r29.visible);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", !(value_r29.sub_folders.length > 0));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("folder", value_r29);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("folder", value_r29);
} }
const _c29 = function () { return { "color": "white" }; };
const _c30 = function () { return { "color": "var(--primary)" }; };
function HsLayerManagerGalleryComponent_div_5_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 17);
    ɵngcc0.ɵɵlistener("click", function HsLayerManagerGalleryComponent_div_5_div_1_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); const layer_r1 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.toggleMiniMenu(layer_r1); });
    ɵngcc0.ɵɵelement(1, "span", 18);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const layer_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("ngStyle", layer_r1.galleryMiniMenu && ɵngcc0.ɵɵpureFunction0(1, _c29) || ɵngcc0.ɵɵpureFunction0(2, _c30));
} }
function HsLayerManagerGalleryComponent_div_5_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 19);
    ɵngcc0.ɵɵlistener("click", function HsLayerManagerGalleryComponent_div_5_div_3_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r11); const layer_r1 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.HsLayerManagerService.setGreyscale(layer_r1); });
    ɵngcc0.ɵɵelement(1, "label", 20);
    ɵngcc0.ɵɵelementStart(2, "p", 21);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const layer_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(4, _c17, layer_r1.grayscale, !layer_r1.grayscale));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(4, 2, "LAYERMANAGER.baseMapGallery.grayscale"), "");
} }
function HsLayerManagerGalleryComponent_div_5_hs_layer_editor_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "hs-layer-editor", 22, 23);
} if (rf & 2) {
    const layer_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("current-layer", layer_r1);
} }
const _c31 = function () { return { "position": "relative" }; };
const _c32 = function () { return { "position": "absolute" }; };
const _c33 = function (a0) { return { "expanded": a0 }; };
const _c34 = function () { return { "background-color": "rgba(192, 189, 189, 0.644)" }; };
const _c35 = function (a0, a1) { return { "active": a0, "hs-ale": a1 }; };
function HsLayerManagerGalleryComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r16 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 9);
    ɵngcc0.ɵɵlistener("click", function HsLayerManagerGalleryComponent_div_5_Template_div_click_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r16); const layer_r1 = restoredCtx.$implicit; const ctx_r15 = ɵngcc0.ɵɵnextContext(); return ctx_r15.toggleBasemap(layer_r1); });
    ɵngcc0.ɵɵtemplate(1, HsLayerManagerGalleryComponent_div_5_div_1_Template, 2, 3, "div", 10);
    ɵngcc0.ɵɵelementStart(2, "div", 11);
    ɵngcc0.ɵɵtemplate(3, HsLayerManagerGalleryComponent_div_5_div_3_Template, 5, 7, "div", 12);
    ɵngcc0.ɵɵelementStart(4, "label", 13);
    ɵngcc0.ɵɵlistener("click", function HsLayerManagerGalleryComponent_div_5_Template_label_click_4_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r16); const layer_r1 = restoredCtx.$implicit; const ctx_r17 = ɵngcc0.ɵɵnextContext(); return ctx_r17.expandMenu(layer_r1); });
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(6, HsLayerManagerGalleryComponent_div_5_hs_layer_editor_6_Template, 2, 1, "hs-layer-editor", 14);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(7, "img", 15);
    ɵngcc0.ɵɵelementStart(8, "a", 16);
    ɵngcc0.ɵɵtext(9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const layer_r1 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction0(13, _c31));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", layer_r1.active);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", !(layer_r1.galleryMiniMenu == true && layer_r1.active))("ngStyle", ɵngcc0.ɵɵpureFunction0(14, _c32))("ngClass", ɵngcc0.ɵɵpureFunction1(15, _c33, ctx_r0.HsLayerManagerService.menuExpanded));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.HsLayerManagerService.menuExpanded);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction0(17, _c34));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.HsLayerManagerService.menuExpanded ? "Less " : "More", "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.HsLayerManagerService.menuExpanded);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("src", layer_r1.thumbnail, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(18, _c35, layer_r1.active, !layer_r1.active));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(21, _c12, layer_r1.active));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.HsLayerUtilsService.translateTitle(layer_r1.title));
} }
function HsLegendComponent_span_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵelementStart(1, "p", 11);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 1, "LEGEND.noLegendExists"));
} }
function HsLegendComponent_li_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 12);
    ɵngcc0.ɵɵelementStart(1, "div");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelement(3, "hs-legend-layer-directive", 13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const layer_r2 = ctx.$implicit;
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("hidden", !ctx_r1.hsLegendService.legendValid(layer_r2));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.hsLayerUtilsService.translateTitle(layer_r2.title), " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("layer", layer_r2);
} }
function HsMeasureComponent_li_22_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵelementStart(1, "sup");
    ɵngcc0.ɵɵtext(2, "2");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function HsMeasureComponent_li_22_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 12);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵtemplate(2, HsMeasureComponent_li_22_span_2_Template, 3, 0, "span", 13);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const measurement_r1 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate2(" ", measurement_r1.size, "\u00A0", measurement_r1.unit, "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", measurement_r1.type === "Area");
} }
function HsQueryFeaturePopupComponent_ng_template_0_a_4_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 8);
    ɵngcc0.ɵɵlistener("click", function HsQueryFeaturePopupComponent_ng_template_0_a_4_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r10); const feature_r5 = ɵngcc0.ɵɵnextContext().feature; const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.removeFeature(feature_r5); });
    ɵngcc0.ɵɵpipe(1, "translate");
    ɵngcc0.ɵɵelement(2, "i", 9);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const type_r6 = ɵngcc0.ɵɵnextContext().type;
    ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(1, 1, "QUERY.featurePopup." + type_r6));
} }
function HsQueryFeaturePopupComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 5);
    ɵngcc0.ɵɵelementStart(1, "div", 6);
    ɵngcc0.ɵɵelementStart(2, "em");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, HsQueryFeaturePopupComponent_ng_template_0_a_4_Template, 3, 3, "a", 7);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const feature_r5 = ctx.feature;
    const type_r6 = ctx.type;
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.serializeFeatureName(feature_r5));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.HsQueryVectorService.isFeatureRemovable(feature_r5) && type_r6);
} }
function HsQueryFeaturePopupComponent_ng_template_2_div_0_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 12);
    ɵngcc0.ɵɵelementStart(1, "div", 6);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(3, "div", 13);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const attribute_r15 = ctx.$implicit;
    const ctx_r14 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r14.HsLanguageService.getTranslationIgnoreNonExisting("FEATURE_TABLE", attribute_r15.key), " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("innerHtml", attribute_r15.displayFunction(attribute_r15.value), ɵngcc0.ɵɵsanitizeHtml);
} }
function HsQueryFeaturePopupComponent_ng_template_2_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, HsQueryFeaturePopupComponent_ng_template_2_div_0_div_1_Template, 4, 2, "div", 11);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const attributes_r12 = ɵngcc0.ɵɵnextContext().attributes;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", attributes_r12);
} }
function HsQueryFeaturePopupComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, HsQueryFeaturePopupComponent_ng_template_2_div_0_Template, 2, 1, "div", 10);
} if (rf & 2) {
    const attributes_r12 = ctx.attributes;
    ɵngcc0.ɵɵproperty("ngIf", attributes_r12.length > 0);
} }
function HsQueryFeaturePopupComponent_div_6_div_7_div_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function HsQueryFeaturePopupComponent_div_6_div_7_div_1_div_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function HsQueryFeaturePopupComponent_div_6_div_7_div_1_div_4_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
const _c36 = function (a0) { return { feature: a0, type: "removeClusterPart" }; };
const _c37 = function (a0) { return { attributes: a0 }; };
function HsQueryFeaturePopupComponent_div_6_div_7_div_1_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 26);
    ɵngcc0.ɵɵtemplate(1, HsQueryFeaturePopupComponent_div_6_div_7_div_1_div_4_ng_container_1_Template, 1, 0, "ng-container", 23);
    ɵngcc0.ɵɵtemplate(2, HsQueryFeaturePopupComponent_div_6_div_7_div_1_div_4_ng_container_2_Template, 1, 0, "ng-container", 23);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const attribute_r26 = ctx.$implicit;
    ɵngcc0.ɵɵnextContext(4);
    const _r0 = ɵngcc0.ɵɵreference(1);
    const _r2 = ɵngcc0.ɵɵreference(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r0)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(4, _c36, attribute_r26.feature));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r2)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(6, _c37, attribute_r26.attributes));
} }
const _c38 = function (a0) { return { feature: a0 }; };
function HsQueryFeaturePopupComponent_div_6_div_7_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 21);
    ɵngcc0.ɵɵelementStart(1, "div", 22);
    ɵngcc0.ɵɵtemplate(2, HsQueryFeaturePopupComponent_div_6_div_7_div_1_ng_container_2_Template, 1, 0, "ng-container", 23);
    ɵngcc0.ɵɵelementStart(3, "div", 24);
    ɵngcc0.ɵɵtemplate(4, HsQueryFeaturePopupComponent_div_6_div_7_div_1_div_4_Template, 3, 8, "div", 25);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const feature_r20 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r21 = ɵngcc0.ɵɵnextContext(2);
    const _r0 = ɵngcc0.ɵɵreference(1);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r0)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(4, _c38, feature_r20));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", !(ctx_r21.attributesForHover.length > 0));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r21.attributesForHover);
} }
function HsQueryFeaturePopupComponent_div_6_div_7_ng_template_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function HsQueryFeaturePopupComponent_div_6_div_7_ng_template_2_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
const _c39 = function (a0) { return { feature: a0, type: "removeFeature" }; };
function HsQueryFeaturePopupComponent_div_6_div_7_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 27);
    ɵngcc0.ɵɵtemplate(1, HsQueryFeaturePopupComponent_div_6_div_7_ng_template_2_ng_container_1_Template, 1, 0, "ng-container", 23);
    ɵngcc0.ɵɵtemplate(2, HsQueryFeaturePopupComponent_div_6_div_7_ng_template_2_ng_container_2_Template, 1, 0, "ng-container", 23);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const feature_r20 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r23 = ɵngcc0.ɵɵnextContext(2);
    const _r0 = ɵngcc0.ɵɵreference(1);
    const _r2 = ɵngcc0.ɵɵreference(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r0)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(4, _c39, feature_r20));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r2)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(6, _c37, ctx_r23.attributesForHover));
} }
function HsQueryFeaturePopupComponent_div_6_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, HsQueryFeaturePopupComponent_div_6_div_7_div_1_Template, 5, 6, "div", 19);
    ɵngcc0.ɵɵtemplate(2, HsQueryFeaturePopupComponent_div_6_div_7_ng_template_2_Template, 3, 8, "ng-template", null, 20, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const feature_r20 = ctx.$implicit;
    const _r22 = ɵngcc0.ɵɵreference(3);
    const ctx_r19 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r19.isClustered(feature_r20))("ngIfElse", _r22);
} }
function HsQueryFeaturePopupComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r34 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 14);
    ɵngcc0.ɵɵelementStart(1, "a", 15);
    ɵngcc0.ɵɵlistener("click", function HsQueryFeaturePopupComponent_div_6_Template_a_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r34); const ctx_r33 = ɵngcc0.ɵɵnextContext(); return ctx_r33.closePopup(); });
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelement(3, "i", 16);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "strong", 17);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(6, "br");
    ɵngcc0.ɵɵtemplate(7, HsQueryFeaturePopupComponent_div_6_div_7_Template, 4, 2, "div", 18);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const layerDesc_r17 = ctx.$implicit;
    const i_r18 = ctx.index;
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", i_r18 !== 0)("title", ɵngcc0.ɵɵpipeBind1(2, 4, "QUERY.featurePopup.closePopup"));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ctx_r4.HsLayerUtilsService.translateTitle(layerDesc_r17.title));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", layerDesc_r17.features);
} }
function HsQueryComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 5);
    ɵngcc0.ɵɵelementStart(1, "div", 6);
    ɵngcc0.ɵɵelement(2, "i", 7);
    ɵngcc0.ɵɵelementStart(3, "p", 8);
    ɵngcc0.ɵɵtext(4, "No features selected");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "p", 9);
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵpipe(7, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("hidden", !ctx_r0.isVisible());
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(7, 2, "QUERY.infoPanel.clickOnMap"));
} }
function HsQueryComponent_hs_query_default_info_panel_body_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "hs-query-default-info-panel-body", 3);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("hidden", !ctx_r1.isVisible());
} }
function HsQueryComponent_div_5_select_8_option_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 19);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const projection_r5 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", projection_r5);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(projection_r5.name);
} }
function HsQueryComponent_div_5_select_8_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "select", 17);
    ɵngcc0.ɵɵlistener("ngModelChange", function HsQueryComponent_div_5_select_8_Template_select_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(2); return ctx_r6.HsQueryBaseService.data.selectedProj = $event; });
    ɵngcc0.ɵɵtemplate(1, HsQueryComponent_div_5_select_8_option_1_Template, 2, 2, "option", 18);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r3.HsQueryBaseService.data.selectedProj)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(3, _c2));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r3.HsQueryBaseService.data.coordinates[0].projections);
} }
function HsQueryComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 10);
    ɵngcc0.ɵɵelementStart(1, "div", 11);
    ɵngcc0.ɵɵelementStart(2, "div", 12);
    ɵngcc0.ɵɵelementStart(3, "strong");
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 11);
    ɵngcc0.ɵɵelementStart(6, "div", 13);
    ɵngcc0.ɵɵelementStart(7, "div", 14);
    ɵngcc0.ɵɵtemplate(8, HsQueryComponent_div_5_select_8_Template, 2, 4, "select", 15);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(9, "input", 16);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("hidden", !ctx_r2.isVisible());
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.HsQueryBaseService.data.coordinates[0].name);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.HsQueryBaseService.data.coordinates.length > 0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("value", ctx_r2.HsQueryBaseService.data.selectedProj.value);
} }
function HsSaveMapDialogComponent_div_19_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "div");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementStart(4, "b");
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "p");
    ɵngcc0.ɵɵelementStart(7, "button", 10);
    ɵngcc0.ɵɵlistener("click", function HsSaveMapDialogComponent_div_19_Template_button_click_7_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); ctx_r3.HsSaveMapManagerService.save(false, ctx_r3.data.endpoint); return ctx_r3.close(); });
    ɵngcc0.ɵɵtext(8);
    ɵngcc0.ɵɵpipe(9, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "p");
    ɵngcc0.ɵɵelementStart(11, "button", 11);
    ɵngcc0.ɵɵlistener("click", function HsSaveMapDialogComponent_div_19_Template_button_click_11_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.HsSaveMapManagerService.selectNewTitle(); });
    ɵngcc0.ɵɵtext(12);
    ɵngcc0.ɵɵpipe(13, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(3, 4, "SAVECOMPOSITION.dialogSave.wantToOverwrite"), " ");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.HsSaveMapManagerService.compoData.title);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(9, 6, "SAVECOMPOSITION.dialogSave.yesSave"));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(13, 8, "SAVECOMPOSITION.dialogSave.noSaveAs"));
} }
function HsSaveMapDialogComponent_div_20_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "div");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "p");
    ɵngcc0.ɵɵelementStart(5, "input", 12);
    ɵngcc0.ɵɵlistener("ngModelChange", function HsSaveMapDialogComponent_div_20_Template_input_ngModelChange_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.HsSaveMapManagerService.compoData.title = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "p");
    ɵngcc0.ɵɵelementStart(7, "button", 10);
    ɵngcc0.ɵɵlistener("click", function HsSaveMapDialogComponent_div_20_Template_button_click_7_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r8 = ɵngcc0.ɵɵnextContext(); ctx_r8.HsSaveMapManagerService.save(true, ctx_r8.data.endpoint); return ctx_r8.close(); });
    ɵngcc0.ɵɵtext(8);
    ɵngcc0.ɵɵpipe(9, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 3, "SAVECOMPOSITION.dialogSave.selectNewNameForMap"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.HsSaveMapManagerService.compoData.title);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(9, 5, "COMMON.save"));
} }
function HsSaveMapDialogComponent_div_21_p_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(2, 1, "SAVECOMPOSITION.dialogSave.youDoNotHave"), " ");
} }
function HsSaveMapDialogComponent_div_21_p_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(2, 1, "SAVECOMPOSITION.dialogSave.useDifferentName"), " ");
} }
function HsSaveMapDialogComponent_div_21_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "div");
    ɵngcc0.ɵɵtemplate(2, HsSaveMapDialogComponent_div_21_p_2_Template, 3, 3, "p", 9);
    ɵngcc0.ɵɵtemplate(3, HsSaveMapDialogComponent_div_21_p_3_Template, 3, 3, "p", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "p");
    ɵngcc0.ɵɵelementStart(5, "button", 10);
    ɵngcc0.ɵɵlistener("click", function HsSaveMapDialogComponent_div_21_Template_button_click_5_listener() { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r11 = ɵngcc0.ɵɵnextContext(); ctx_r11.HsSaveMapManagerService.focusTitle(); return ctx_r11.close(); });
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵpipe(7, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !(ctx_r2.HsSaveMapManagerService.statusData == null ? null : ctx_r2.HsSaveMapManagerService.statusData.hasPermission));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !(ctx_r2.HsSaveMapManagerService.statusData == null ? null : ctx_r2.HsSaveMapManagerService.statusData.titleFree));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(7, 3, "COMMON.ok"));
} }
function HsSaveMapResultDialogComponent_dl_29_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "dl");
    ɵngcc0.ɵɵelementStart(1, "dt");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "dd");
    ɵngcc0.ɵɵelement(4, "hs-widgets-recursive-dd", 15);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r2 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1("", item_r2.key, " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("value", item_r2.value);
} }
function HsSaveMapResultDialogComponent_div_32_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "button", 16);
    ɵngcc0.ɵɵlistener("click", function HsSaveMapResultDialogComponent_div_32_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.initiateSave(false); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "button", 17);
    ɵngcc0.ɵɵlistener("click", function HsSaveMapResultDialogComponent_div_32_Template_button_click_4_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.changeName(); });
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵpipe(6, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 2, "SAVECOMPOSITION.form.overwrite"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(6, 4, "SAVECOMPOSITION.form.changeName"));
} }
const _c40 = function (a0) { return { "justify-content-between": a0 }; };
function HsSaveMapComponent_option_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 14);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const e_r4 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", e_r4);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(e_r4.title);
} }
function HsSaveMapComponent_hs_layman_current_user_16_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "hs-layman-current-user", 15);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("endpoint", ctx_r1.endpoint);
} }
function HsSaveMapComponent_hs_save_map_advanced_form_17_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "hs-save-map-advanced-form", 16);
} }
function HsSaveMapComponent_hs_save_map_simple_form_18_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "hs-save-map-simple-form");
} }
function HsStylerComponent_input_13_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "input", 26);
    ɵngcc0.ɵɵlistener("ngModelChange", function HsStylerComponent_input_13_Template_input_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.hsStylerService.styleObject.name = $event; });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.hsStylerService.styleObject.name);
} }
function HsStylerComponent_ng_container_30_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "hs-rule-list-item", 29);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const rule_r6 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("rule", rule_r6);
} }
function HsStylerComponent_ng_container_30_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "ul", 27);
    ɵngcc0.ɵɵlistener("cdkDropListDropped", function HsStylerComponent_ng_container_30_Template_ul_cdkDropListDropped_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.drop($event); });
    ɵngcc0.ɵɵtemplate(2, HsStylerComponent_ng_container_30_ng_container_2_Template, 2, 1, "ng-container", 28);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("cdkDropListData", ctx_r1.hsStylerService.styleObject.rules);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.hsStylerService.styleObject.rules);
} }
function HsStylerComponent_div_32_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 30);
    ɵngcc0.ɵɵelementStart(1, "hs-file-upload", 31);
    ɵngcc0.ɵɵlistener("uploaded", function HsStylerComponent_div_32_Template_hs_file_upload_uploaded_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.handleFileUpload($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function HsTripPlannerComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 8);
    ɵngcc0.ɵɵelementStart(1, "div", 9);
    ɵngcc0.ɵɵelementStart(2, "a", 11);
    ɵngcc0.ɵɵlistener("click", function HsTripPlannerComponent_div_8_Template_a_click_2_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r4); const waypoint_r2 = restoredCtx.$implicit; const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.toggleEdit(waypoint_r2); });
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "input", 12);
    ɵngcc0.ɵɵlistener("ngModelChange", function HsTripPlannerComponent_div_8_Template_input_ngModelChange_4_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r4); const waypoint_r2 = restoredCtx.$implicit; return waypoint_r2.name = $event; })("blur", function HsTripPlannerComponent_div_8_Template_input_blur_4_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r4); const waypoint_r2 = restoredCtx.$implicit; const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.toggleEdit(waypoint_r2); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 10);
    ɵngcc0.ɵɵelement(6, "img", 13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 14);
    ɵngcc0.ɵɵelementStart(8, "div", 15);
    ɵngcc0.ɵɵtext(9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "div", 10);
    ɵngcc0.ɵɵelementStart(11, "a", 16);
    ɵngcc0.ɵɵlistener("click", function HsTripPlannerComponent_div_8_Template_a_click_11_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r4); const waypoint_r2 = restoredCtx.$implicit; const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.HsTripPlannerService.removeWaypoint(waypoint_r2); });
    ɵngcc0.ɵɵpipe(12, "translate");
    ɵngcc0.ɵɵelement(13, "i", 17);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const waypoint_r2 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("hidden", !!waypoint_r2.editMode);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(waypoint_r2.name);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngModel", waypoint_r2.name)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(11, _c2))("hidden", !waypoint_r2.editMode);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("hidden", !waypoint_r2.loading)("src", ctx_r0.HsUtilsService.getAjaxLoaderIcon(), ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.formatDistance(waypoint_r2));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(12, 9, "TRIP_PLANNER.removeWaypoint"));
} }
function HsTripPlannerComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 18);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(2, 1, "TRIP_PLANNER.waypointDrawingHint"), " ");
} }
function HsAddDataCatalogueComponent_div_16_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 37);
    ɵngcc0.ɵɵelementStart(1, "input", 38);
    ɵngcc0.ɵɵlistener("ngModelChange", function HsAddDataCatalogueComponent_div_16_Template_input_ngModelChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.data.onlyMine = $event; })("ngModelChange", function HsAddDataCatalogueComponent_div_16_Template_input_ngModelChange_1_listener() { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.queryByFilter(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(2, "span", 12);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.data.onlyMine);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(4, 2, "COMPOSITIONS.onlyMine"));
} }
function HsAddDataCatalogueComponent_li_32_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li");
    ɵngcc0.ɵɵelementStart(1, "label", 39);
    ɵngcc0.ɵɵelementStart(2, "input", 40);
    ɵngcc0.ɵɵlistener("change", function HsAddDataCatalogueComponent_li_32_Template_input_change_2_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r14); const searchType_r11 = restoredCtx.$implicit; const ctx_r13 = ɵngcc0.ɵɵnextContext(); const _r1 = ɵngcc0.ɵɵreference(28); ctx_r13.selectType(searchType_r11); return _r1.close(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const searchType_r11 = ctx.$implicit;
    const index_r12 = ctx.index;
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("checked", index_r12 === 0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.translateString("ADDDATA.CATALOGUE.searchFilterTypes", searchType_r11));
} }
function HsAddDataCatalogueComponent_li_42_Template(rf, ctx) { if (rf & 1) {
    const _r18 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li");
    ɵngcc0.ɵɵelementStart(1, "label", 39);
    ɵngcc0.ɵɵelementStart(2, "input", 41);
    ɵngcc0.ɵɵlistener("change", function HsAddDataCatalogueComponent_li_42_Template_input_change_2_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r18); const type_r15 = restoredCtx.$implicit; const ctx_r17 = ɵngcc0.ɵɵnextContext(); const _r3 = ɵngcc0.ɵɵreference(38); ctx_r17.selectQueryType(type_r15, "type"); return _r3.close(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const type_r15 = ctx.$implicit;
    const index_r16 = ctx.index;
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("checked", index_r16 === 1);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r4.translateString("ADDDATA.CATALOGUE.queryDataTypes", type_r15));
} }
function HsAddDataCatalogueComponent_li_52_Template(rf, ctx) { if (rf & 1) {
    const _r22 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li");
    ɵngcc0.ɵɵelementStart(1, "label", 39);
    ɵngcc0.ɵɵelementStart(2, "input", 42);
    ɵngcc0.ɵɵlistener("change", function HsAddDataCatalogueComponent_li_52_Template_input_change_2_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r22); const sortType_r19 = restoredCtx.$implicit; const ctx_r21 = ɵngcc0.ɵɵnextContext(); const _r5 = ɵngcc0.ɵɵreference(48); ctx_r21.selectQueryType(sortType_r19, "sortby"); return _r5.close(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const sortType_r19 = ctx.$implicit;
    const index_r20 = ctx.index;
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("checked", index_r20 === 0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r6.translateString("ADDDATA.CATALOGUE.sortbyTypes", sortType_r19));
} }
function HsAddDataCatalogueComponent_li_64_Template(rf, ctx) { if (rf & 1) {
    const _r25 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 43);
    ɵngcc0.ɵɵlistener("click", function HsAddDataCatalogueComponent_li_64_Template_li_click_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r25); const layer_r23 = restoredCtx.$implicit; const ctx_r24 = ɵngcc0.ɵɵnextContext(); return ctx_r24.layerSelected(layer_r23); })("mouseover", function HsAddDataCatalogueComponent_li_64_Template_li_mouseover_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r25); const layer_r23 = restoredCtx.$implicit; const ctx_r26 = ɵngcc0.ɵɵnextContext(); return ctx_r26.highlightLayer(layer_r23, true); })("mouseleave", function HsAddDataCatalogueComponent_li_64_Template_li_mouseleave_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r25); const layer_r23 = restoredCtx.$implicit; const ctx_r27 = ɵngcc0.ɵɵnextContext(); return ctx_r27.highlightLayer(layer_r23, false); });
    ɵngcc0.ɵɵelement(1, "hs-catalogue-list-item", 44);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const layer_r23 = ctx.$implicit;
    const ctx_r7 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("hidden", ctx_r7.hsAddDataCatalogueService.dataLoading)("ngClass", ɵngcc0.ɵɵpureFunction1(3, _c1, layer_r23.highlighted));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("layer", layer_r23);
} }
function HsCatalogueMetadataComponent_ng_container_14_dl_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "dl");
    ɵngcc0.ɵɵelementStart(1, "dt");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(3, "hs-widgets-recursive-dd", 16);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const key_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(key_r2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("value", ctx_r3.selectedLayer[key_r2]);
} }
function HsCatalogueMetadataComponent_ng_container_14_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, HsCatalogueMetadataComponent_ng_container_14_dl_1_Template, 4, 2, "dl", 14);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const key_r2 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", key_r2 !== "feature");
} }
function HsCatalogueMetadataComponent_div_22_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 18);
    ɵngcc0.ɵɵlistener("click", function HsCatalogueMetadataComponent_div_22_button_1_Template_button_click_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r8); const type_r6 = restoredCtx.$implicit; const ctx_r7 = ɵngcc0.ɵɵnextContext(2); return ctx_r7.addLayerToMap(ctx_r7.selectedDS, ctx_r7.selectedLayer, type_r6); });
    ɵngcc0.ɵɵelement(1, "span", 19);
    ɵngcc0.ɵɵelementStart(2, "span");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const type_r6 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate2("", ɵngcc0.ɵɵpipeBind1(4, 2, "DATASOURCE_SELECTOR.addToMapAs"), " ", type_r6, "");
} }
function HsCatalogueMetadataComponent_div_22_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, HsCatalogueMetadataComponent_div_22_button_1_Template, 5, 4, "button", 17);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.selectedLayer.type);
} }
function HsCatalogueListItemComponent_div_4_span_23_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 25);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, "COMMON.removeLayer"));
} }
const _c41 = function (a0) { return { "cursor": a0 }; };
function HsCatalogueListItemComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 19);
    ɵngcc0.ɵɵelement(1, "hr", 20);
    ɵngcc0.ɵɵelementStart(2, "div", 21);
    ɵngcc0.ɵɵelementStart(3, "a", 22);
    ɵngcc0.ɵɵlistener("click", function HsCatalogueListItemComponent_div_4_Template_a_click_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(); $event.stopPropagation(); return ctx_r4.addLayerToMap(ctx_r4.layer.endpoint, ctx_r4.layer); });
    ɵngcc0.ɵɵelement(4, "i", 23);
    ɵngcc0.ɵɵelement(5, "img", 24);
    ɵngcc0.ɵɵelementStart(6, "span", 25);
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵpipe(8, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "a", 26);
    ɵngcc0.ɵɵlistener("click", function HsCatalogueListItemComponent_div_4_Template_a_click_9_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r6 = ɵngcc0.ɵɵnextContext(); $event.stopPropagation(); return ctx_r6.abortAdd(); });
    ɵngcc0.ɵɵpipe(10, "translate");
    ɵngcc0.ɵɵelement(11, "i", 27);
    ɵngcc0.ɵɵelementStart(12, "span", 25);
    ɵngcc0.ɵɵtext(13);
    ɵngcc0.ɵɵpipe(14, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(15, "a", 28);
    ɵngcc0.ɵɵlistener("click", function HsCatalogueListItemComponent_div_4_Template_a_click_15_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.showMetadata(ctx_r7.layer.endpoint, ctx_r7.layer); });
    ɵngcc0.ɵɵelement(16, "i", 29);
    ɵngcc0.ɵɵelementStart(17, "span", 25);
    ɵngcc0.ɵɵtext(18);
    ɵngcc0.ɵɵpipe(19, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(20, "a", 30);
    ɵngcc0.ɵɵlistener("click", function HsCatalogueListItemComponent_div_4_Template_a_click_20_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r8 = ɵngcc0.ɵɵnextContext(); $event.stopPropagation(); return ctx_r8.removeLayer(ctx_r8.layer); });
    ɵngcc0.ɵɵpipe(21, "translate");
    ɵngcc0.ɵɵelement(22, "i", 31);
    ɵngcc0.ɵɵtemplate(23, HsCatalogueListItemComponent_div_4_span_23_Template, 3, 3, "span", 32);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("hidden", ctx_r0.selectTypeToAddLayerVisible);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", ctx_r0.loadingInfo);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", !ctx_r0.loadingInfo)("src", ctx_r0.hsUtilsService.getAjaxLoaderIcon(), ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(8, 13, "DATASOURCE_SELECTOR.datasourceListItem.addToMap"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(10, 15, "DATASOURCE_SELECTOR.datasourceListItem.abortAdd"))("hidden", !ctx_r0.selectTypeToAddLayerVisible);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(14, 17, "DATASOURCE_SELECTOR.datasourceListItem.abortAdd"));
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(19, 19, "COMMON.metadata"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("title", ctx_r0.layer.editable ? "" : ɵngcc0.ɵɵpipeBind1(21, 21, "DATASOURCE_SELECTOR.datasourceListItem.notAllowedToEditLayer"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r0.layer.editable ? "text-danger" : "text-muted")("ngStyle", ɵngcc0.ɵɵpureFunction1(23, _c41, ctx_r0.layer.editable ? "pointer" : "default"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.layer.editable);
} }
function HsCatalogueListItemComponent_label_18_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "label", 33);
    ɵngcc0.ɵɵlistener("click", function HsCatalogueListItemComponent_label_18_Template_label_click_0_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r11); const type_r9 = restoredCtx.$implicit; const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.selectTypeAndAdd(type_r9, $event); });
    ɵngcc0.ɵɵelement(1, "input", 34);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const type_r9 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", type_r9, " ");
} }
function HsCatalogueListItemComponent_li_25_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 35);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const type_r12 = ctx.$implicit;
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate2(" ", type_r12, " \u2013 ", ctx_r2.translateString("ADDDATA.CATALOGUE.DESC", type_r12), " ");
} }
function HsUiExtensionsRecursiveDdComponent_dd_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "dd");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.value);
} }
function HsUiExtensionsRecursiveDdComponent_dl_1_button_4_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 4);
    ɵngcc0.ɵɵlistener("click", function HsUiExtensionsRecursiveDdComponent_dl_1_button_4_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(2); return ctx_r4.hsDSMapService.zoomTo(ctx_r4.value); });
    ɵngcc0.ɵɵi18n(1, 5);
    ɵngcc0.ɵɵelementEnd();
} }
function HsUiExtensionsRecursiveDdComponent_dl_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "dl");
    ɵngcc0.ɵɵelementStart(1, "dt");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(3, "hs-widgets-recursive-dd", 2);
    ɵngcc0.ɵɵtemplate(4, HsUiExtensionsRecursiveDdComponent_dl_1_button_4_Template, 2, 0, "button", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r2 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(item_r2.key || item_r2[0]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("value", item_r2.value || item_r2[1]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", item_r2.key == "bbox");
} }
function HsLaymanCurrentUserComponent_div_0_a_1_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 4);
    ɵngcc0.ɵɵlistener("click", function HsLaymanCurrentUserComponent_div_0_a_1_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(2); return ctx_r4.login(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(2, 1, "COMPOSITIONS.loginToCatalogue"), "");
} }
function HsLaymanCurrentUserComponent_div_0_a_2_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 5);
    ɵngcc0.ɵɵlistener("click", function HsLaymanCurrentUserComponent_div_0_a_2_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(2); return ctx_r6.login(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵpropertyInterpolate("href", ctx_r2.authUrl(), ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(2, 2, "COMPOSITIONS.loginToCatalogue"), "");
} }
function HsLaymanCurrentUserComponent_div_0_a_3_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 4);
    ɵngcc0.ɵɵlistener("click", function HsLaymanCurrentUserComponent_div_0_a_3_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r8 = ɵngcc0.ɵɵnextContext(2); return ctx_r8.logout(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate2("", ɵngcc0.ɵɵpipeBind1(2, 2, "COMMON.Logout"), " ", ctx_r3.endpoint.user, "");
} }
function HsLaymanCurrentUserComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵtemplate(1, HsLaymanCurrentUserComponent_div_0_a_1_Template, 3, 3, "a", 2);
    ɵngcc0.ɵɵtemplate(2, HsLaymanCurrentUserComponent_div_0_a_2_Template, 3, 4, "a", 3);
    ɵngcc0.ɵɵtemplate(3, HsLaymanCurrentUserComponent_div_0_a_3_Template, 3, 4, "a", 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.isGuest() && ctx_r0.sameDomain());
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.isGuest() && !ctx_r0.sameDomain());
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.isGuest());
} }
function HsPagerComponent_div_0_li_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 7);
    ɵngcc0.ɵɵelementStart(1, "span", 8);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate3(" ", ɵngcc0.ɵɵpipeBind1(3, 3, "COMMON.results"), " ", ctx_r1.pagerService.listStart + 1, " - ", ctx_r1.pagerService.listNext, "");
} }
function HsPagerComponent_div_0_li_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 7);
    ɵngcc0.ɵɵelementStart(1, "span", 8);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate3(" ", ɵngcc0.ɵɵpipeBind1(3, 3, "COMMON.results"), " ", ctx_r2.pagerService.listStart + 1, " - ", ctx_r2.pagerService.matchedRecords, "");
} }
const _c44 = function (a0) { return { "disabled": a0 }; };
const _c45 = function (a0) { return { "color": a0 }; };
function HsPagerComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "ul", 2);
    ɵngcc0.ɵɵelementStart(2, "li", 3);
    ɵngcc0.ɵɵelementStart(3, "a", 4);
    ɵngcc0.ɵɵlistener("click", function HsPagerComponent_div_0_Template_a_click_3_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.getPreviousRecords(); });
    ɵngcc0.ɵɵelementStart(4, "span", 5);
    ɵngcc0.ɵɵtext(5, "\u00AB");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(6, HsPagerComponent_div_0_li_6_Template, 4, 5, "li", 6);
    ɵngcc0.ɵɵtemplate(7, HsPagerComponent_div_0_li_7_Template, 4, 5, "li", 6);
    ɵngcc0.ɵɵelementStart(8, "li", 3);
    ɵngcc0.ɵɵelementStart(9, "a", 4);
    ɵngcc0.ɵɵlistener("click", function HsPagerComponent_div_0_Template_a_click_9_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.getNextRecords(); });
    ɵngcc0.ɵɵelementStart(10, "span", 5);
    ɵngcc0.ɵɵtext(11, "\u00BB");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(6, _c44, ctx_r0.pagerService.listStart === 0))("ngStyle", ɵngcc0.ɵɵpureFunction1(8, _c45, ctx_r0.pagerService.listStart === 0 ? "#555" : "#007bff"));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.resultsVisible() && ctx_r0.pagerService.listNext !== ctx_r0.pagerService.matchedRecords);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.resultsVisible() && ctx_r0.pagerService.listNext === ctx_r0.pagerService.matchedRecords);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(10, _c44, ctx_r0.nextPageAvailable()))("ngStyle", ɵngcc0.ɵɵpureFunction1(12, _c45, ctx_r0.nextPageAvailable() ? "#555" : "#007bff"));
} }
function HsAddDataFileComponent_button_3_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 7);
    ɵngcc0.ɵɵlistener("click", function HsAddDataFileComponent_button_3_Template_button_click_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r6); const type_r4 = restoredCtx.$implicit; const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.selectType(type_r4.id); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const type_r4 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(2, _c12, type_r4.id === ctx_r0.typeSelected));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", type_r4.text, " ");
} }
function HsAddDataFileComponent_hs_add_data_url_vector_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "hs-add-data-url-vector", 8);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("dataType", ctx_r1.typeSelected);
} }
function HsAddDataFileComponent_hs_add_data_url_vector_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "hs-add-data-url-vector", 8);
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("dataType", ctx_r2.typeSelected);
} }
function HsAddDataFileComponent_hs_add_data_file_shp_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "hs-add-data-file-shp");
} }
function HsAddDataTargetPositionComponent_option_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 7);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const layer_r1 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngValue", layer_r1.layer);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.hsLayerUtilsService.translateTitle(layer_r1.title));
} }
function HsCommonUrlComponent_button_6_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 7);
    ɵngcc0.ɵɵlistener("click", function HsCommonUrlComponent_button_6_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.emitConnect(); });
    ɵngcc0.ɵɵelement(1, "i", 8);
    ɵngcc0.ɵɵelementEnd();
} }
function HsCommonUrlDetailsComponent_ng_container_1_option_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const format_r13 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(format_r13);
} }
function HsCommonUrlDetailsComponent_ng_container_1_option_16_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const format_r14 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(format_r14);
} }
function HsCommonUrlDetailsComponent_ng_container_1_option_24_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r15 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(i_r15);
} }
function HsCommonUrlDetailsComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 7);
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵelementStart(3, "div", 4);
    ɵngcc0.ɵɵelementStart(4, "span", 5);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵpipe(6, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "select", 20);
    ɵngcc0.ɵɵlistener("ngModelChange", function HsCommonUrlDetailsComponent_ng_container_1_Template_select_ngModelChange_7_listener($event) { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r16 = ɵngcc0.ɵɵnextContext(); return ctx_r16.data.image_format = $event; });
    ɵngcc0.ɵɵtemplate(8, HsCommonUrlDetailsComponent_ng_container_1_option_8_Template, 2, 1, "option", 21);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "div", 7);
    ɵngcc0.ɵɵelementStart(10, "div", 3);
    ɵngcc0.ɵɵelementStart(11, "div", 4);
    ɵngcc0.ɵɵelementStart(12, "span", 5);
    ɵngcc0.ɵɵtext(13);
    ɵngcc0.ɵɵpipe(14, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(15, "select", 22);
    ɵngcc0.ɵɵlistener("ngModelChange", function HsCommonUrlDetailsComponent_ng_container_1_Template_select_ngModelChange_15_listener($event) { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r18 = ɵngcc0.ɵɵnextContext(); return ctx_r18.data.query_format = $event; });
    ɵngcc0.ɵɵtemplate(16, HsCommonUrlDetailsComponent_ng_container_1_option_16_Template, 2, 1, "option", 21);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(17, "div", 2);
    ɵngcc0.ɵɵelementStart(18, "div", 3);
    ɵngcc0.ɵɵelementStart(19, "div", 4);
    ɵngcc0.ɵɵelementStart(20, "span", 5);
    ɵngcc0.ɵɵtext(21);
    ɵngcc0.ɵɵpipe(22, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(23, "select", 23);
    ɵngcc0.ɵɵlistener("ngModelChange", function HsCommonUrlDetailsComponent_ng_container_1_Template_select_ngModelChange_23_listener($event) { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r19 = ɵngcc0.ɵɵnextContext(); return ctx_r19.data.srs = $event; })("change", function HsCommonUrlDetailsComponent_ng_container_1_Template_select_change_23_listener() { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r20 = ɵngcc0.ɵɵnextContext(); return ctx_r20.srsChanged(); });
    ɵngcc0.ɵɵtemplate(24, HsCommonUrlDetailsComponent_ng_container_1_option_24_Template, 2, 1, "option", 21);
    ɵngcc0.ɵɵpipe(25, "slice");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(6, 10, "ADDLAYERS.imageFormat"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.data.image_format);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.data.image_formats);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(14, 12, "ADDLAYERS.queryFormat"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.data.query_format);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.data.query_formats);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", !ctx_r0.data.srs || ctx_r0.data.srs.toUpperCase() === ctx_r0.data.map_projection);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(22, 14, "ADDLAYERS.srs"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.data.srs);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind3(25, 16, ctx_r0.data.srss, 0, 50));
} }
function HsCommonUrlDetailsComponent_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "p", 24);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", !ctx_r1.data.use_resampling);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(3, 2, "ADDLAYERS.mapAndLayerProjection"), " ");
} }
function HsCommonUrlDetailsComponent_ng_container_12_Template(rf, ctx) { if (rf & 1) {
    const _r22 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "label", 9);
    ɵngcc0.ɵɵelementStart(2, "input", 25);
    ɵngcc0.ɵɵlistener("ngModelChange", function HsCommonUrlDetailsComponent_ng_container_12_Template_input_ngModelChange_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r22); const ctx_r21 = ɵngcc0.ɵɵnextContext(); return ctx_r21.data.use_tiles = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r2.data.use_tiles);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(4, 2, "ADDLAYERS.useTiles"), " ");
} }
function HsCommonUrlDetailsComponent_ng_container_17_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "p", 26);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", ctx_r3.data.use_tiles);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(3, 2, "ADDLAYERS.considerUsingTiles"), " ");
} }
function HsCommonUrlDetailsComponent_ng_container_18_Template(rf, ctx) { if (rf & 1) {
    const _r24 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 7);
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵelementStart(3, "div", 4);
    ɵngcc0.ɵɵelementStart(4, "span", 5);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵpipe(6, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "input", 27);
    ɵngcc0.ɵɵlistener("ngModelChange", function HsCommonUrlDetailsComponent_ng_container_18_Template_input_ngModelChange_7_listener($event) { ɵngcc0.ɵɵrestoreView(_r24); const ctx_r23 = ɵngcc0.ɵɵnextContext(); return ctx_r23.data.tile_size = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(6, 2, "ADDLAYERS.tileSize"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r4.data.tile_size);
} }
function HsCommonUrlDetailsComponent_ng_container_36_Template(rf, ctx) { if (rf & 1) {
    const _r26 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "hs-add-layers-target-position", 28);
    ɵngcc0.ɵɵlistener("addUnderChange", function HsCommonUrlDetailsComponent_ng_container_36_Template_hs_add_layers_target_position_addUnderChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r26); const ctx_r25 = ɵngcc0.ɵɵnextContext(); return ctx_r25.data.add_under = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("addUnder", ctx_r5.data.add_under);
} }
function HsCommonUrlDetailsComponent_ng_container_38_tbody_11_tr_8_option_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 46);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const style_r31 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", style_r31);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("", style_r31.Name, " ");
} }
function HsCommonUrlDetailsComponent_ng_container_38_tbody_11_tr_8_Template(rf, ctx) { if (rf & 1) {
    const _r34 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "tr");
    ɵngcc0.ɵɵelementStart(1, "td", 40);
    ɵngcc0.ɵɵelementStart(2, "div", 41);
    ɵngcc0.ɵɵelementStart(3, "div", 42);
    ɵngcc0.ɵɵelementStart(4, "label", 43);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵpipe(6, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "select", 44);
    ɵngcc0.ɵɵlistener("ngModelChange", function HsCommonUrlDetailsComponent_ng_container_38_tbody_11_tr_8_Template_select_ngModelChange_7_listener($event) { ɵngcc0.ɵɵrestoreView(_r34); const service_r28 = ɵngcc0.ɵɵnextContext().$implicit; return service_r28.styleSelected = $event; });
    ɵngcc0.ɵɵtemplate(8, HsCommonUrlDetailsComponent_ng_container_38_tbody_11_tr_8_option_8_Template, 2, 2, "option", 45);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const service_r28 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(6, 4, "COMMON.style"), ":");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngModel", service_r28.styleSelected)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(6, _c2));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", service_r28.Style);
} }
const _c46 = function (a0) { return { "align-middle": a0 }; };
function HsCommonUrlDetailsComponent_ng_container_38_tbody_11_Template(rf, ctx) { if (rf & 1) {
    const _r37 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "tbody");
    ɵngcc0.ɵɵelementStart(1, "tr", 33);
    ɵngcc0.ɵɵelementStart(2, "td", 34);
    ɵngcc0.ɵɵelementStart(3, "input", 35);
    ɵngcc0.ɵɵlistener("ngModelChange", function HsCommonUrlDetailsComponent_ng_container_38_tbody_11_Template_input_ngModelChange_3_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r37); const service_r28 = restoredCtx.$implicit; return service_r28.checked = $event; })("change", function HsCommonUrlDetailsComponent_ng_container_38_tbody_11_Template_input_change_3_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r37); const service_r28 = restoredCtx.$implicit; const ctx_r38 = ɵngcc0.ɵɵnextContext(2); return ctx_r38.searchForChecked(service_r28); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "td", 36);
    ɵngcc0.ɵɵlistener("click", function HsCommonUrlDetailsComponent_ng_container_38_tbody_11_Template_td_click_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r37); const ctx_r39 = ɵngcc0.ɵɵnextContext(2); return ctx_r39.hsAddDataUrlWmsService.expandTableRow($event); });
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "td", 37);
    ɵngcc0.ɵɵlistener("click", function HsCommonUrlDetailsComponent_ng_container_38_tbody_11_Template_td_click_6_listener($event) { ɵngcc0.ɵɵrestoreView(_r37); const ctx_r40 = ɵngcc0.ɵɵnextContext(2); return ctx_r40.hsAddDataUrlWmsService.expandTableRow($event); });
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(8, HsCommonUrlDetailsComponent_ng_container_38_tbody_11_tr_8_Template, 9, 7, "tr", 1);
    ɵngcc0.ɵɵelementStart(9, "tr", 0);
    ɵngcc0.ɵɵelementStart(10, "td", 38);
    ɵngcc0.ɵɵelementStart(11, "hs-nested-layers-table", 39);
    ɵngcc0.ɵɵlistener("layerChecked", function HsCommonUrlDetailsComponent_ng_container_38_tbody_11_Template_hs_nested_layers_table_layerChecked_11_listener($event) { ɵngcc0.ɵɵrestoreView(_r37); const ctx_r41 = ɵngcc0.ɵɵnextContext(2); return ctx_r41.searchForChecked($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const service_r28 = ctx.$implicit;
    const ctx_r27 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(10, _c46, !ctx_r27.hasNestedLayers(service_r28)));
    ɵngcc0.ɵɵattribute("rowspan", (service_r28.Style == null ? null : service_r28.Style.length) ? 3 : 2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngModel", service_r28.checked);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("title", "Title: " + service_r28.Title + "\nName: " + service_r28.Name);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(service_r28.Title);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("title", service_r28.Abstract);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", service_r28.Abstract, "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", (service_r28.Style == null ? null : service_r28.Style.length) > 1 && service_r28.checked);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", !ctx_r27.hasNestedLayers(service_r28));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("layers", service_r28.Layer);
} }
function HsCommonUrlDetailsComponent_ng_container_38_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "table", 29);
    ɵngcc0.ɵɵelementStart(2, "thead", 30);
    ɵngcc0.ɵɵelementStart(3, "th", 31);
    ɵngcc0.ɵɵtext(4, "\u00A0");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "th");
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵpipe(7, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "th");
    ɵngcc0.ɵɵtext(9);
    ɵngcc0.ɵɵpipe(10, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(11, HsCommonUrlDetailsComponent_ng_container_38_tbody_11_Template, 12, 12, "tbody", 32);
    ɵngcc0.ɵɵpipe(12, "slice");
    ɵngcc0.ɵɵpipe(13, "trackByProperty");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(7, 4, "COMMON.title"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(10, 6, "COMMON.abstract"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind3(12, 8, ctx_r6.data.services, 0, ctx_r6.limitShown))("ngForTrackBy", ɵngcc0.ɵɵpipeBind1(13, 12, "Name"));
} }
function HsCommonUrlDetailsComponent_ng_template_39_tbody_7_Template(rf, ctx) { if (rf & 1) {
    const _r45 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "tbody");
    ɵngcc0.ɵɵelementStart(1, "tr");
    ɵngcc0.ɵɵelementStart(2, "td");
    ɵngcc0.ɵɵelementStart(3, "input", 48);
    ɵngcc0.ɵɵlistener("change", function HsCommonUrlDetailsComponent_ng_template_39_tbody_7_Template_input_change_3_listener() { ɵngcc0.ɵɵrestoreView(_r45); const ctx_r44 = ɵngcc0.ɵɵnextContext(2); return ctx_r44.changed(); })("ngModelChange", function HsCommonUrlDetailsComponent_ng_template_39_tbody_7_Template_input_ngModelChange_3_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r45); const service_r43 = restoredCtx.$implicit; return service_r43.checked = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "td");
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const service_r43 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngModel", service_r43.checked);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(service_r43.name);
} }
function HsCommonUrlDetailsComponent_ng_template_39_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "table", 29);
    ɵngcc0.ɵɵelementStart(1, "thead");
    ɵngcc0.ɵɵelementStart(2, "th", 47);
    ɵngcc0.ɵɵtext(3, "\u00A0");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "th");
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵpipe(6, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(7, HsCommonUrlDetailsComponent_ng_template_39_tbody_7_Template, 6, 2, "tbody", 32);
    ɵngcc0.ɵɵpipe(8, "trackByProperty");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(6, 3, "COMMON.name"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r8.data.services)("ngForTrackBy", ɵngcc0.ɵɵpipeBind1(8, 5, "id"));
} }
const _c47 = function (a0, a1) { return { limitShown: a0, total: a1 }; };
function HsCommonUrlDetailsComponent_ng_container_41_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r49 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 50);
    ɵngcc0.ɵɵelement(1, "span", 51);
    ɵngcc0.ɵɵelementStart(2, "div", 13);
    ɵngcc0.ɵɵelementStart(3, "button", 52);
    ɵngcc0.ɵɵlistener("click", function HsCommonUrlDetailsComponent_ng_container_41_div_1_Template_button_click_3_listener() { ɵngcc0.ɵɵrestoreView(_r49); const ctx_r48 = ɵngcc0.ɵɵnextContext(2); return ctx_r48.limitShown = ctx_r48.limitShown + 100; });
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵpipe(5, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "button", 52);
    ɵngcc0.ɵɵlistener("click", function HsCommonUrlDetailsComponent_ng_container_41_div_1_Template_button_click_6_listener() { ɵngcc0.ɵɵrestoreView(_r49); const ctx_r50 = ɵngcc0.ɵɵnextContext(2); return ctx_r50.limitShown = ctx_r50.data.services.length; });
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵpipe(8, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r47 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("translate", "ADDDATA.CATALOGUE.showingSubset")("translateParams", ɵngcc0.ɵɵpureFunction2(8, _c47, ctx_r47.limitShown, ctx_r47.data.services.length));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(5, 4, "ADDDATA.CATALOGUE.showNext100"), " ");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(8, 6, "ADDDATA.CATALOGUE.showAll"), " ");
} }
function HsCommonUrlDetailsComponent_ng_container_41_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, HsCommonUrlDetailsComponent_ng_container_41_div_1_Template, 9, 11, "div", 49);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r9.reachedLimit());
} }
function HsHistoryListComponent_a_3_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 3);
    ɵngcc0.ɵɵlistener("click", function HsHistoryListComponent_a_3_Template_a_click_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r3); const item_r1 = restoredCtx.$implicit; const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.historyUrlClicked(item_r1.value); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r1 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(item_r1.value);
} }
function HsNestedLayersTableComponent_tbody_1_tr_8_option_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const style_r6 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(style_r6.Name);
} }
function HsNestedLayersTableComponent_tbody_1_tr_8_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "tr");
    ɵngcc0.ɵɵelementStart(1, "td", 7);
    ɵngcc0.ɵɵelementStart(2, "div", 8);
    ɵngcc0.ɵɵelementStart(3, "div", 9);
    ɵngcc0.ɵɵelementStart(4, "label", 10);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵpipe(6, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "select", 11);
    ɵngcc0.ɵɵlistener("ngModelChange", function HsNestedLayersTableComponent_tbody_1_tr_8_Template_select_ngModelChange_7_listener($event) { ɵngcc0.ɵɵrestoreView(_r9); const sub_layer_r1 = ɵngcc0.ɵɵnextContext().$implicit; return sub_layer_r1.styleSelected = $event; });
    ɵngcc0.ɵɵtemplate(8, HsNestedLayersTableComponent_tbody_1_tr_8_option_8_Template, 2, 1, "option", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const sub_layer_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(6, 4, "COMMON.style"), ":");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngModel", sub_layer_r1.styleSelected)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(6, _c2));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", sub_layer_r1.Style);
} }
function HsNestedLayersTableComponent_tbody_1_tr_9_div_3_ng_container_1_option_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 20);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const dimension_value_r17 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("value", dimension_value_r17);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", dimension_value_r17, "");
} }
function HsNestedLayersTableComponent_tbody_1_tr_9_div_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r20 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "label", 10);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div");
    ɵngcc0.ɵɵelementStart(4, "select", 18);
    ɵngcc0.ɵɵlistener("ngModelChange", function HsNestedLayersTableComponent_tbody_1_tr_9_div_3_ng_container_1_Template_select_ngModelChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r20); const dimension_r12 = ɵngcc0.ɵɵnextContext().$implicit; return dimension_r12.value = $event; });
    ɵngcc0.ɵɵtemplate(5, HsNestedLayersTableComponent_tbody_1_tr_9_div_3_ng_container_1_option_5_Template, 2, 2, "option", 19);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const dimension_r12 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1("", dimension_r12.name, ":");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngModel", dimension_r12.value)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(4, _c2));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", dimension_r12.values);
} }
function HsNestedLayersTableComponent_tbody_1_tr_9_div_3_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 21);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const dimension_r12 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate2("", ɵngcc0.ɵɵpipeBind1(2, 2, "ADDLAYERS.unknownDimesion"), ": ", dimension_r12.name, "");
} }
function HsNestedLayersTableComponent_tbody_1_tr_9_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 15);
    ɵngcc0.ɵɵtemplate(1, HsNestedLayersTableComponent_tbody_1_tr_9_div_3_ng_container_1_Template, 6, 5, "ng-container", 16);
    ɵngcc0.ɵɵtemplate(2, HsNestedLayersTableComponent_tbody_1_tr_9_div_3_ng_template_2_Template, 3, 4, "ng-template", null, 17, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const dimension_r12 = ctx.$implicit;
    const _r14 = ɵngcc0.ɵɵreference(3);
    const ctx_r11 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r11.isArray(dimension_r12.values))("ngIfElse", _r14);
} }
function HsNestedLayersTableComponent_tbody_1_tr_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "tr");
    ɵngcc0.ɵɵelementStart(1, "td", 7);
    ɵngcc0.ɵɵelementStart(2, "form", 13);
    ɵngcc0.ɵɵtemplate(3, HsNestedLayersTableComponent_tbody_1_tr_9_div_3_Template, 4, 2, "div", 14);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const sub_layer_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngForOf", sub_layer_r1.Dimension);
} }
function HsNestedLayersTableComponent_tbody_1_tr_10_Template(rf, ctx) { if (rf & 1) {
    const _r25 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "tr");
    ɵngcc0.ɵɵelementStart(1, "td", 22);
    ɵngcc0.ɵɵelementStart(2, "hs-nested-layers-table", 23);
    ɵngcc0.ɵɵlistener("layerChecked", function HsNestedLayersTableComponent_tbody_1_tr_10_Template_hs_nested_layers_table_layerChecked_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r25); const ctx_r24 = ɵngcc0.ɵɵnextContext(2); return ctx_r24.checked($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const sub_layer_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("layers", sub_layer_r1.Layer);
} }
function HsNestedLayersTableComponent_tbody_1_Template(rf, ctx) { if (rf & 1) {
    const _r28 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "tbody");
    ɵngcc0.ɵɵelementStart(1, "tr");
    ɵngcc0.ɵɵelementStart(2, "td", 2);
    ɵngcc0.ɵɵelementStart(3, "input", 3);
    ɵngcc0.ɵɵlistener("ngModelChange", function HsNestedLayersTableComponent_tbody_1_Template_input_ngModelChange_3_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r28); const sub_layer_r1 = restoredCtx.$implicit; return sub_layer_r1.checked = $event; })("change", function HsNestedLayersTableComponent_tbody_1_Template_input_change_3_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r28); const sub_layer_r1 = restoredCtx.$implicit; const ctx_r29 = ɵngcc0.ɵɵnextContext(); return ctx_r29.checked(sub_layer_r1); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "td", 4);
    ɵngcc0.ɵɵlistener("click", function HsNestedLayersTableComponent_tbody_1_Template_td_click_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r28); const ctx_r30 = ɵngcc0.ɵɵnextContext(); return ctx_r30.hsAddDataUrlWmsService.expandTableRow($event); });
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "td", 5);
    ɵngcc0.ɵɵlistener("click", function HsNestedLayersTableComponent_tbody_1_Template_td_click_6_listener($event) { ɵngcc0.ɵɵrestoreView(_r28); const ctx_r31 = ɵngcc0.ɵɵnextContext(); return ctx_r31.hsAddDataUrlWmsService.expandTableRow($event); });
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(8, HsNestedLayersTableComponent_tbody_1_tr_8_Template, 9, 7, "tr", 6);
    ɵngcc0.ɵɵtemplate(9, HsNestedLayersTableComponent_tbody_1_tr_9_Template, 4, 1, "tr", 6);
    ɵngcc0.ɵɵtemplate(10, HsNestedLayersTableComponent_tbody_1_tr_10_Template, 3, 1, "tr", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const sub_layer_r1 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngModel", sub_layer_r1.checked)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(10, _c2));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate1("id", "hs-add-layer-", sub_layer_r1.Name, "");
    ɵngcc0.ɵɵproperty("title", "Title: " + sub_layer_r1.Title + "\nName: " + sub_layer_r1.Name);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("", sub_layer_r1.Title, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("title", sub_layer_r1.Abstract);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(sub_layer_r1.Abstract);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", (sub_layer_r1.Style == null ? null : sub_layer_r1.Style.length) > 1 && sub_layer_r1.checked);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !!sub_layer_r1.Dimension);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !!sub_layer_r1.Layer);
} }
function HsAddDataFileShpComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 28);
    ɵngcc0.ɵɵelementStart(1, "p");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 1, "ADDLAYERS.couldNotUploadSelectedFile"));
} }
function HsAddDataFileShpComponent_p_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const file_r7 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(file_r7.name);
} }
function HsAddDataFileShpComponent_hs_layman_access_rights_33_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "hs-layman-access-rights", 29);
    ɵngcc0.ɵɵlistener("access_rightsChange", function HsAddDataFileShpComponent_hs_layman_access_rights_33_Template_hs_layman_access_rights_access_rightsChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.access_rights = $event; });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("access_rights", ctx_r2.access_rights);
} }
function HsAddDataFileShpComponent_div_46_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 30);
    ɵngcc0.ɵɵelementStart(1, "div", 11);
    ɵngcc0.ɵɵelementStart(2, "label", 12);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "input", 31);
    ɵngcc0.ɵɵlistener("ngModelChange", function HsAddDataFileShpComponent_div_46_Template_input_ngModelChange_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.srs = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 11);
    ɵngcc0.ɵɵelementStart(7, "label", 12);
    ɵngcc0.ɵɵtext(8);
    ɵngcc0.ɵɵpipe(9, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "input", 32);
    ɵngcc0.ɵɵlistener("ngModelChange", function HsAddDataFileShpComponent_div_46_Template_input_ngModelChange_10_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ctx_r12.folder_name = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(4, 4, "ADDLAYERS.srs"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r3.srs);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(9, 6, "ADDLAYERS.folderName"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r3.folder_name);
} }
function HsAddDataFileShpComponent_button_47_ngb_progressbar_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "ngb-progressbar", 37);
} if (rf & 2) {
    const ctx_r13 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("max", 1)("value", ctx_r13.hsLaymanService.totalProgress);
} }
function HsAddDataFileShpComponent_button_47_Template(rf, ctx) { if (rf & 1) {
    const _r15 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 33);
    ɵngcc0.ɵɵlistener("click", function HsAddDataFileShpComponent_button_47_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r15); const ctx_r14 = ɵngcc0.ɵɵnextContext(); return ctx_r14.add(); });
    ɵngcc0.ɵɵelement(1, "i", 34);
    ɵngcc0.ɵɵelement(2, "img", 35);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵtemplate(4, HsAddDataFileShpComponent_button_47_ngb_progressbar_4_Template, 1, 2, "ngb-progressbar", 36);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵpropertyInterpolate("title", ctx_r4.addShpTooltip());
    ɵngcc0.ɵɵproperty("disabled", !ctx_r4.name);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", ctx_r4.loading);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("src", ctx_r4.hsUtilsService.getAjaxLoaderIcon(), ɵngcc0.ɵɵsanitizeUrl)("hidden", !ctx_r4.loading);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r4.loadingText(), " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.loading && ctx_r4.hsAddDataFileShpService.asyncLoading);
} }
function HsAddDataFileShpComponent_div_48_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 38);
    ɵngcc0.ɵɵelementStart(1, "p", 39);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(4, "hs-layman-current-user", 40);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(3, 2, "ADDLAYERS.SHP.loginRequired"), "");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("endpoint", ctx_r5.hsLaymanService.getLaymanEndpoint());
} }
function HsAddDataFileShpComponent_dl_52_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "dl");
    ɵngcc0.ɵɵelementStart(1, "dt");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r16 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(item_r16);
} }
const _c48 = ["vectorFileInput"];
function HsAddDataVectorComponent_hs_common_url_1_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "hs-common-url", 4);
    ɵngcc0.ɵɵlistener("urlChange", function HsAddDataVectorComponent_hs_common_url_1_Template_hs_common_url_urlChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.url = $event; })("connect", function HsAddDataVectorComponent_hs_common_url_1_Template_hs_common_url_connect_0_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.connect(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("url", ctx_r0.url);
} }
function HsAddDataVectorComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 5);
    ɵngcc0.ɵɵelementStart(1, "hs-file-upload", 6);
    ɵngcc0.ɵɵlistener("uploaded", function HsAddDataVectorComponent_div_2_Template_hs_file_upload_uploaded_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.handleFileUpload($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("acceptedFormats", ctx_r1.acceptedFormats);
} }
const _c49 = function (a0) { return { featuresCount: a0 }; };
function HsAddDataVectorComponent_div_3_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 26);
    ɵngcc0.ɵɵelementStart(1, "p", 27);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "ul", 28);
    ɵngcc0.ɵɵelementStart(4, "li", 29);
    ɵngcc0.ɵɵelementStart(5, "a", 30);
    ɵngcc0.ɵɵlistener("click", function HsAddDataVectorComponent_div_3_div_1_Template_a_click_5_listener() { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r13 = ɵngcc0.ɵɵnextContext(2); return ctx_r13.setUploadType("new"); });
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵpipe(7, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "li", 29);
    ɵngcc0.ɵɵelementStart(9, "a", 30);
    ɵngcc0.ɵɵlistener("click", function HsAddDataVectorComponent_div_3_div_1_Template_a_click_9_listener() { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r15 = ɵngcc0.ɵɵnextContext(2); return ctx_r15.setUploadType("existing"); });
    ɵngcc0.ɵɵtext(10);
    ɵngcc0.ɵɵpipe(11, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r8.hsLanguageService.getTranslationIgnoreNonExisting("ADDLAYERS.Vector", "addingFiles", ɵngcc0.ɵɵpureFunction1(9, _c49, ctx_r8.featureCount)), " ");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(11, _c12, ctx_r8.uploadType === "new"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(7, 5, "LAYERS.newLayer"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(13, _c12, ctx_r8.uploadType === "existing"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(11, 7, "LAYERS.existingLayer"));
} }
function HsAddDataVectorComponent_div_3_option_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 31);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const lyr_r16 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", lyr_r16.layer);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("", lyr_r16.title, " ");
} }
function HsAddDataVectorComponent_div_3_div_36_Template(rf, ctx) { if (rf & 1) {
    const _r18 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 32);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementStart(3, "div", 33);
    ɵngcc0.ɵɵelementStart(4, "button", 34);
    ɵngcc0.ɵɵlistener("click", function HsAddDataVectorComponent_div_3_div_36_Template_button_click_4_listener() { ɵngcc0.ɵɵrestoreView(_r18); const ctx_r17 = ɵngcc0.ɵɵnextContext(2); return ctx_r17.saveToLayman = true; });
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵpipe(6, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "button", 34);
    ɵngcc0.ɵɵlistener("click", function HsAddDataVectorComponent_div_3_div_36_Template_button_click_7_listener() { ɵngcc0.ɵɵrestoreView(_r18); const ctx_r19 = ɵngcc0.ɵɵnextContext(2); return ctx_r19.saveToLayman = false; });
    ɵngcc0.ɵɵtext(8);
    ɵngcc0.ɵɵpipe(9, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(2, 5, "ADDDATA.saveToDatabase"), " ");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(11, _c12, ctx_r10.saveToLayman));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(6, 7, "COMMON.yes"), " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(13, _c12, !ctx_r10.saveToLayman));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(9, 9, "COMMON.no"), " ");
} }
function HsAddDataVectorComponent_div_3_hs_layman_access_rights_38_Template(rf, ctx) { if (rf & 1) {
    const _r21 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "hs-layman-access-rights", 35);
    ɵngcc0.ɵɵlistener("access_rightsChange", function HsAddDataVectorComponent_div_3_hs_layman_access_rights_38_Template_hs_layman_access_rights_access_rightsChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r21); const ctx_r20 = ɵngcc0.ɵɵnextContext(2); return ctx_r20.access_rights = $event; });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("access_rights", ctx_r11.access_rights);
} }
function HsAddDataVectorComponent_div_3_div_42_div_11_Template(rf, ctx) { if (rf & 1) {
    const _r24 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 15);
    ɵngcc0.ɵɵelementStart(1, "label", 10);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "input", 41);
    ɵngcc0.ɵɵlistener("ngModelChange", function HsAddDataVectorComponent_div_3_div_42_div_11_Template_input_ngModelChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r24); const ctx_r23 = ɵngcc0.ɵɵnextContext(3); return ctx_r23.extract_styles = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r22 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 2, "ADDLAYERS.VECTOR.extractStyles"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r22.extract_styles);
} }
function HsAddDataVectorComponent_div_3_div_42_Template(rf, ctx) { if (rf & 1) {
    const _r26 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 36);
    ɵngcc0.ɵɵelementStart(1, "div", 15);
    ɵngcc0.ɵɵelementStart(2, "label", 10);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "input", 37);
    ɵngcc0.ɵɵlistener("ngModelChange", function HsAddDataVectorComponent_div_3_div_42_Template_input_ngModelChange_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r26); const ctx_r25 = ɵngcc0.ɵɵnextContext(2); return ctx_r25.srs = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 15);
    ɵngcc0.ɵɵelementStart(7, "label", 10);
    ɵngcc0.ɵɵtext(8);
    ɵngcc0.ɵɵpipe(9, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "input", 38);
    ɵngcc0.ɵɵlistener("ngModelChange", function HsAddDataVectorComponent_div_3_div_42_Template_input_ngModelChange_10_listener($event) { ɵngcc0.ɵɵrestoreView(_r26); const ctx_r27 = ɵngcc0.ɵɵnextContext(2); return ctx_r27.folder_name = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(11, HsAddDataVectorComponent_div_3_div_42_div_11_Template, 5, 4, "div", 39);
    ɵngcc0.ɵɵelementStart(12, "div", 15);
    ɵngcc0.ɵɵelementStart(13, "hs-add-layers-target-position", 40);
    ɵngcc0.ɵɵlistener("addUnderChange", function HsAddDataVectorComponent_div_3_div_42_Template_hs_add_layers_target_position_addUnderChange_13_listener($event) { ɵngcc0.ɵɵrestoreView(_r26); const ctx_r28 = ɵngcc0.ɵɵnextContext(2); return ctx_r28.addUnder = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(4, 6, "ADDLAYERS.srs"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r12.srs);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(9, 8, "ADDLAYERS.folderName"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r12.folder_name);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r12.isKml());
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("addUnder", ctx_r12.addUnder);
} }
function HsAddDataVectorComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r30 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, HsAddDataVectorComponent_div_3_div_1_Template, 12, 15, "div", 7);
    ɵngcc0.ɵɵelementStart(2, "div", 8);
    ɵngcc0.ɵɵelementStart(3, "div", 9);
    ɵngcc0.ɵɵelementStart(4, "label", 10);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵpipe(6, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "select", 11);
    ɵngcc0.ɵɵlistener("ngModelChange", function HsAddDataVectorComponent_div_3_Template_select_ngModelChange_7_listener($event) { ɵngcc0.ɵɵrestoreView(_r30); const ctx_r29 = ɵngcc0.ɵɵnextContext(); return ctx_r29.sourceLayer = $event; });
    ɵngcc0.ɵɵelementStart(8, "option", 12);
    ɵngcc0.ɵɵtext(9);
    ɵngcc0.ɵɵpipe(10, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(11, HsAddDataVectorComponent_div_3_option_11_Template, 2, 2, "option", 13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(12, "div", 8);
    ɵngcc0.ɵɵelementStart(13, "p");
    ɵngcc0.ɵɵelementStart(14, "sub", 14);
    ɵngcc0.ɵɵtext(15);
    ɵngcc0.ɵɵpipe(16, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(17, "div", 15);
    ɵngcc0.ɵɵelementStart(18, "label", 10);
    ɵngcc0.ɵɵtext(19);
    ɵngcc0.ɵɵpipe(20, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(21, "input", 16);
    ɵngcc0.ɵɵlistener("ngModelChange", function HsAddDataVectorComponent_div_3_Template_input_ngModelChange_21_listener($event) { ɵngcc0.ɵɵrestoreView(_r30); const ctx_r31 = ɵngcc0.ɵɵnextContext(); return ctx_r31.title = $event; });
    ɵngcc0.ɵɵpipe(22, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(23, "div", 15);
    ɵngcc0.ɵɵelementStart(24, "label", 10);
    ɵngcc0.ɵɵtext(25);
    ɵngcc0.ɵɵpipe(26, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(27, "input", 17);
    ɵngcc0.ɵɵlistener("ngModelChange", function HsAddDataVectorComponent_div_3_Template_input_ngModelChange_27_listener($event) { ɵngcc0.ɵɵrestoreView(_r30); const ctx_r32 = ɵngcc0.ɵɵnextContext(); return ctx_r32.name = $event; });
    ɵngcc0.ɵɵpipe(28, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(29, "div", 15);
    ɵngcc0.ɵɵelementStart(30, "label", 10);
    ɵngcc0.ɵɵtext(31);
    ɵngcc0.ɵɵpipe(32, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(33, "textarea", 18);
    ɵngcc0.ɵɵlistener("ngModelChange", function HsAddDataVectorComponent_div_3_Template_textarea_ngModelChange_33_listener($event) { ɵngcc0.ɵɵrestoreView(_r30); const ctx_r33 = ɵngcc0.ɵɵnextContext(); return ctx_r33.abstract = $event; });
    ɵngcc0.ɵɵpipe(34, "translate");
    ɵngcc0.ɵɵtext(35, "                    ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(36, HsAddDataVectorComponent_div_3_div_36_Template, 10, 15, "div", 19);
    ɵngcc0.ɵɵelementStart(37, "div", 20);
    ɵngcc0.ɵɵtemplate(38, HsAddDataVectorComponent_div_3_hs_layman_access_rights_38_Template, 1, 1, "hs-layman-access-rights", 21);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(39, "button", 22);
    ɵngcc0.ɵɵlistener("click", function HsAddDataVectorComponent_div_3_Template_button_click_39_listener() { ɵngcc0.ɵɵrestoreView(_r30); const ctx_r34 = ɵngcc0.ɵɵnextContext(); return ctx_r34.advancedPanelVisible = !ctx_r34.advancedPanelVisible; });
    ɵngcc0.ɵɵtext(40);
    ɵngcc0.ɵɵpipe(41, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(42, HsAddDataVectorComponent_div_3_div_42_Template, 14, 10, "div", 23);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(43, "button", 24);
    ɵngcc0.ɵɵlistener("click", function HsAddDataVectorComponent_div_3_Template_button_click_43_listener() { ɵngcc0.ɵɵrestoreView(_r30); const ctx_r35 = ɵngcc0.ɵɵnextContext(); return ctx_r35.add(); });
    ɵngcc0.ɵɵelement(44, "i", 25);
    ɵngcc0.ɵɵtext(45);
    ɵngcc0.ɵɵpipe(46, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.hsAddDataService.typeSelected === "file");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", ctx_r2.uploadType === "new");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(6, 25, "LAYERS.existingLayer"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r2.sourceLayer);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngValue", null)("disabled", true);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(10, 27, "ADDLAYERS.Vector.chooseLayer"), "");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r2.vectorLayers);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", ctx_r2.uploadType === "existing");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(16, 29, "ADDLAYERS.Vector.note"));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(20, 31, "COMMON.title"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("placeholder", ɵngcc0.ɵɵpipeBind1(22, 33, "ADDDATA.URL.submitLayerTitle"))("ngModel", ctx_r2.title);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(26, 35, "COMMON.name"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("placeholder", ɵngcc0.ɵɵpipeBind1(28, 37, "ADDDATA.URL.submitLayerName"))("ngModel", ctx_r2.name);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(32, 39, "COMMON.abstract"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("placeholder", ɵngcc0.ɵɵpipeBind1(34, 41, "COMMON.fillInDescriptive"))("ngModel", ctx_r2.abstract);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.isAuthorized && ctx_r2.saveAvailable);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.saveToLayman);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(41, 43, "COMMON.advancedOptions"), " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.advancedPanelVisible);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("disabled", ctx_r2.uploadType === "new" ? !ctx_r2.title : !ctx_r2.sourceLayer);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(46, 45, "COMMON.add"), " ");
} }
function HsAddDataWfsComponent_hs_common_url_progress_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "hs-common-url-progress");
} }
function HsAddDataWfsComponent_div_3_li_11_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 19);
    ɵngcc0.ɵɵelementStart(1, "div", 20);
    ɵngcc0.ɵɵelementStart(2, "p", 21);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵpipe(5, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const layer_r4 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("hidden", !layer_r4.limitFeatureCount);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate3("", ɵngcc0.ɵɵpipeBind1(4, 4, "ADDLAYERS.WFS.selectedLayerContains"), " ", layer_r4.featureCount, " ", ɵngcc0.ɵɵpipeBind1(5, 6, "ADDLAYERS.WFS.loadingToManyAtOnce"), " ");
} }
function HsAddDataWfsComponent_div_3_li_11_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 16);
    ɵngcc0.ɵɵelementStart(1, "div");
    ɵngcc0.ɵɵelementStart(2, "input", 17);
    ɵngcc0.ɵɵlistener("ngModelChange", function HsAddDataWfsComponent_div_3_li_11_Template_input_ngModelChange_2_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r8); const layer_r4 = restoredCtx.$implicit; return layer_r4.checked = $event; })("change", function HsAddDataWfsComponent_div_3_li_11_Template_input_change_2_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r9 = ɵngcc0.ɵɵnextContext(2); return ctx_r9.changed(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, HsAddDataWfsComponent_div_3_li_11_div_4_Template, 6, 8, "div", 18);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const layer_r4 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngModel", layer_r4.checked);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", layer_r4.Title, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", layer_r4.featureCount > 1000 && layer_r4.checked);
} }
function HsAddDataWfsComponent_div_3_button_16_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "button", 22);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelement(3, "img", 23);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 2, "ADDLAYERS.loadingFeaturePleaseWait"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("src", ctx_r3.hsUtilsService.getAjaxLoaderIcon(), ɵngcc0.ɵɵsanitizeUrl);
} }
function HsAddDataWfsComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵelementStart(1, "div", 5);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 6);
    ɵngcc0.ɵɵelementStart(4, "label", 7);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵpipe(6, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 8);
    ɵngcc0.ɵɵelementStart(8, "input", 9);
    ɵngcc0.ɵɵlistener("ngModelChange", function HsAddDataWfsComponent_div_3_Template_input_ngModelChange_8_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.data.folder_name = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(9, "hr");
    ɵngcc0.ɵɵelementStart(10, "ul", 10);
    ɵngcc0.ɵɵtemplate(11, HsAddDataWfsComponent_div_3_li_11_Template, 5, 3, "li", 11);
    ɵngcc0.ɵɵpipe(12, "trackByProperty");
    ɵngcc0.ɵɵelementStart(13, "li", 12);
    ɵngcc0.ɵɵelementStart(14, "div", 13);
    ɵngcc0.ɵɵelement(15, "hs-common-url-add", 14);
    ɵngcc0.ɵɵtemplate(16, HsAddDataWfsComponent_div_3_button_16_Template, 4, 4, "button", 15);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.title);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(6, 9, "ADDLAYERS.folderName"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.data.folder_name)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(13, _c2));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.data.services)("ngForTrackBy", ɵngcc0.ɵɵpipeBind1(12, 11, "Name"));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("injectedService", ctx_r1.hsAddDataWfsService)("layers", ctx_r1.data.services);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.hsAddDataWfsService.loadingFeatures);
} }
function HsAddDataWmsComponent_hs_common_url_progress_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "hs-common-url-progress");
} }
function HsAddDataWmtsComponent_hs_common_url_progress_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "hs-common-url-progress");
} }
function HsAddDataWmtsComponent_div_3_li_5_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 16);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementStart(3, "div", 17);
    ɵngcc0.ɵɵelementStart(4, "button", 18);
    ɵngcc0.ɵɵlistener("click", function HsAddDataWmtsComponent_div_3_li_5_div_5_Template_button_click_4_listener() { ɵngcc0.ɵɵrestoreView(_r8); const layer_r3 = ɵngcc0.ɵɵnextContext().$implicit; return layer_r3.base = true; });
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵpipe(6, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "button", 18);
    ɵngcc0.ɵɵlistener("click", function HsAddDataWmtsComponent_div_3_li_5_div_5_Template_button_click_7_listener() { ɵngcc0.ɵɵrestoreView(_r8); const layer_r3 = ɵngcc0.ɵɵnextContext().$implicit; return layer_r3.base = false; });
    ɵngcc0.ɵɵtext(8);
    ɵngcc0.ɵɵpipe(9, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const layer_r3 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(2, 5, "ADDDATA.CATALOGUE.addAs"), " ");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(11, _c12, layer_r3.base));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(6, 7, "COMPOSITONKEYWORDS.Basemap"), " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(13, _c12, !layer_r3.base));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(9, 9, "COMMON.layer"), " ");
} }
function HsAddDataWmtsComponent_div_3_li_5_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 11);
    ɵngcc0.ɵɵelementStart(1, "input", 12);
    ɵngcc0.ɵɵlistener("ngModelChange", function HsAddDataWmtsComponent_div_3_li_5_Template_input_ngModelChange_1_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r13); const layer_r3 = restoredCtx.$implicit; return layer_r3.checked = $event; })("change", function HsAddDataWmtsComponent_div_3_li_5_Template_input_change_1_listener() { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r14 = ɵngcc0.ɵɵnextContext(2); return ctx_r14.changed(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(2, "label", 13);
    ɵngcc0.ɵɵelementStart(3, "span", 14);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(5, HsAddDataWmtsComponent_div_3_li_5_div_5_Template, 10, 15, "div", 15);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const layer_r3 = ctx.$implicit;
    const index_r4 = ctx.index;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate1("name", "wmtslayer-", index_r4, "");
    ɵngcc0.ɵɵproperty("ngModel", layer_r3.checked);
    ɵngcc0.ɵɵattribute("id", "wmtslayer-" + index_r4);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(7, _c17, layer_r3.checked, !layer_r3.checked));
    ɵngcc0.ɵɵattribute("for", "wmtslayer-" + index_r4);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(layer_r3.Title);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", layer_r3.checked);
} }
function HsAddDataWmtsComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵelementStart(1, "ul", 5);
    ɵngcc0.ɵɵelementStart(2, "li", 6);
    ɵngcc0.ɵɵelementStart(3, "div");
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(5, HsAddDataWmtsComponent_div_3_li_5_Template, 6, 10, "li", 7);
    ɵngcc0.ɵɵpipe(6, "trackByProperty");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "li", 8);
    ɵngcc0.ɵɵelementStart(8, "div", 9);
    ɵngcc0.ɵɵelement(9, "hs-common-url-add", 10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.data.title);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.data.services)("ngForTrackBy", ɵngcc0.ɵɵpipeBind1(6, 5, "Identifier"));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("injectedService", ctx_r1.hsAddDataUrlWmtsService)("layers", ctx_r1.data.services);
} }
function HsAddDataUrlComponent_button_3_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 7);
    ɵngcc0.ɵɵlistener("click", function HsAddDataUrlComponent_button_3_Template_button_click_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r8); const type_r6 = restoredCtx.$implicit; const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.selectType(type_r6.id); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const type_r6 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(2, _c12, type_r6.id === ctx_r0.typeSelected));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", type_r6.text, " ");
} }
function HsAddDataUrlComponent_hs_add_data_url_arcgis_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "hs-add-data-url-arcgis");
} }
function HsAddDataUrlComponent_hs_add_data_url_wfs_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "hs-add-data-url-wfs");
} }
function HsAddDataUrlComponent_hs_add_data_url_wms_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "hs-add-data-url-wms");
} }
function HsAddDataUrlComponent_hs_add_data_url_wmts_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "hs-add-data-url-wmts");
} }
function HsAddDataUrlComponent_hs_add_data_url_vector_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "hs-add-data-url-vector", 8);
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("dataType", ctx_r5.typeSelected);
} }
function HsAddDataArcGisComponent_hs_common_url_progress_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "hs-common-url-progress");
} }
const _c50 = function (a0) { return { "d-none": a0 }; };
const _c51 = function (a0) { return { "text-muted": a0 }; };
function HsColorPickerComponent_color_sketch_6_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "color-sketch", 6);
    ɵngcc0.ɵɵlistener("onChangeComplete", function HsColorPickerComponent_color_sketch_6_Template_color_sketch_onChangeComplete_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.onPick($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("color", ctx_r0.addAlpha(ctx_r0.symbolizer[ctx_r0.attribute], ctx_r0.symbolizer[ctx_r0.opacityAttribute]));
} }
function HsColorPickerComponent_color_sketch_7_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "color-sketch", 7);
    ɵngcc0.ɵɵlistener("onChangeComplete", function HsColorPickerComponent_color_sketch_7_Template_color_sketch_onChangeComplete_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.onPick($event); });
    ɵngcc0.ɵɵelementEnd();
} }
const _c52 = ["graphicFillMenu"];
function HsFillSymbolizerComponent_hs_symbolizer_28_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "hs-symbolizer", 17);
    ɵngcc0.ɵɵlistener("changes", function HsFillSymbolizerComponent_hs_symbolizer_28_Template_hs_symbolizer_changes_0_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.emitChange(); })("remove", function HsFillSymbolizerComponent_hs_symbolizer_28_Template_hs_symbolizer_remove_0_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.symbolizer.graphicFill = undefined; });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("symbolizer", ctx_r1.symbolizer.graphicFill);
} }
function HsFilterComponent_div_1_div_8_hs_filter_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "hs-filter", 11);
} if (rf & 2) {
    const item_r3 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("filter", item_r3)("parent", ctx_r5.filter);
} }
function HsFilterComponent_div_1_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 9);
    ɵngcc0.ɵɵtemplate(1, HsFilterComponent_div_1_div_8_hs_filter_1_Template, 1, 2, "hs-filter", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r4 = ctx.index;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", i_r4 > 0);
} }
function HsFilterComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 3);
    ɵngcc0.ɵɵelementStart(2, "div", 4);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "hs-add-filter-button", 5);
    ɵngcc0.ɵɵlistener("clicks", function HsFilterComponent_div_1_Template_hs_add_filter_button_clicks_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.hsFiltersService.add($event.kind, true, ctx_r7.filter); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "button", 6);
    ɵngcc0.ɵɵlistener("click", function HsFilterComponent_div_1_Template_button_click_5_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.remove(); });
    ɵngcc0.ɵɵpipe(6, "translate");
    ɵngcc0.ɵɵelement(7, "span", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(8, HsFilterComponent_div_1_div_8_Template, 2, 1, "div", 8);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.hsFiltersService.humanReadableLogOp(ctx_r0.filter[0]));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(6, 3, "STYLER.removeFilter"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.filter);
} }
function HsFilterComponent_hs_comparison_filter_2_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "hs-comparison-filter", 12);
    ɵngcc0.ɵɵlistener("changes", function HsFilterComponent_hs_comparison_filter_2_Template_hs_comparison_filter_changes_0_listener() { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.emitChange(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("filter", ctx_r1.filter)("parent", ctx_r1.parent);
} }
function HsFiltersComponent_div_3_div_7_hs_filter_1_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "hs-filter", 12);
    ɵngcc0.ɵɵlistener("changes", function HsFiltersComponent_div_3_div_7_hs_filter_1_Template_hs_filter_changes_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(3); return ctx_r6.emitChange(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r3 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("filter", item_r3)("parent", ctx_r5.rule.filter);
} }
function HsFiltersComponent_div_3_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 10);
    ɵngcc0.ɵɵtemplate(1, HsFiltersComponent_div_3_div_7_hs_filter_1_Template, 1, 2, "hs-filter", 11);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r4 = ctx.index;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", i_r4 > 0);
} }
function HsFiltersComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵelementStart(1, "div", 5);
    ɵngcc0.ɵɵelementStart(2, "div", 6);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "hs-add-filter-button", 1);
    ɵngcc0.ɵɵlistener("clicks", function HsFiltersComponent_div_3_Template_hs_add_filter_button_clicks_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.add($event.kind, true); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "button", 7);
    ɵngcc0.ɵɵlistener("click", function HsFiltersComponent_div_3_Template_button_click_5_listener() { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.remove(); });
    ɵngcc0.ɵɵelement(6, "span", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(7, HsFiltersComponent_div_3_div_7_Template, 2, 1, "div", 9);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.hsFiltersService.humanReadableLogOp(ctx_r0.rule.filter[0]), " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("title", "STYLER.removeFilter");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.rule.filter);
} }
function HsFiltersComponent_hs_comparison_filter_4_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "hs-comparison-filter", 13);
    ɵngcc0.ɵɵlistener("changes", function HsFiltersComponent_hs_comparison_filter_4_Template_hs_comparison_filter_changes_0_listener() { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ctx_r12.emitChange(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("filter", ctx_r1.rule.filter);
} }
const _c53 = function (a0) { return { "bg-primary": a0 }; };
function HsSelectIconDialogComponent_div_16_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 14);
    ɵngcc0.ɵɵlistener("click", function HsSelectIconDialogComponent_div_16_Template_div_click_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r3); const icon_r1 = restoredCtx.$implicit; const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.iconSelected(icon_r1); });
    ɵngcc0.ɵɵelement(1, "img", 15);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const icon_r1 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(2, _c53, ctx_r0.data.selectedIcon === icon_r1));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("src", icon_r1.url, ɵngcc0.ɵɵsanitizeUrl);
} }
function HsIconSymbolizerComponent_option_20_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const anchor_r3 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(anchor_r3);
} }
function HsIconSymbolizerComponent_div_33_input_8_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "input", 17);
    ɵngcc0.ɵɵlistener("ngModelChange", function HsIconSymbolizerComponent_div_33_input_8_Template_input_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(2); return (ctx_r5.symbolizer.offset[0] = $event); })("change", function HsIconSymbolizerComponent_div_33_input_8_Template_input_change_0_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r7 = ɵngcc0.ɵɵnextContext(2); return ctx_r7.emitChange(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngModelOptions", ɵngcc0.ɵɵpureFunction0(2, _c2))("ngModel", ctx_r4.symbolizer.offset[0]);
} }
function HsIconSymbolizerComponent_div_33_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 8);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "span", 9);
    ɵngcc0.ɵɵpipe(5, "translate");
    ɵngcc0.ɵɵtext(6, "!");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 3);
    ɵngcc0.ɵɵtemplate(8, HsIconSymbolizerComponent_div_33_input_8_Template, 1, 3, "input", 16);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(3, 3, "STYLER.anchorX"), ":");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵpropertyInterpolate("title", ɵngcc0.ɵɵpipeBind1(5, 5, "STYLER.warningAttribNotStoredNotVisualized"));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.symbolizer.offset !== undefined);
} }
function HsIconSymbolizerComponent_div_34_input_8_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "input", 17);
    ɵngcc0.ɵɵlistener("ngModelChange", function HsIconSymbolizerComponent_div_34_input_8_Template_input_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r9 = ɵngcc0.ɵɵnextContext(2); return (ctx_r9.symbolizer.offset[1] = $event); })("change", function HsIconSymbolizerComponent_div_34_input_8_Template_input_change_0_listener() { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r11 = ɵngcc0.ɵɵnextContext(2); return ctx_r11.emitChange(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngModelOptions", ɵngcc0.ɵɵpureFunction0(2, _c2))("ngModel", ctx_r8.symbolizer.offset[1]);
} }
function HsIconSymbolizerComponent_div_34_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 8);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "span", 9);
    ɵngcc0.ɵɵpipe(5, "translate");
    ɵngcc0.ɵɵtext(6, "!");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 3);
    ɵngcc0.ɵɵtemplate(8, HsIconSymbolizerComponent_div_34_input_8_Template, 1, 3, "input", 16);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(3, 3, "STYLER.anchorY"), ":");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵpropertyInterpolate("title", ɵngcc0.ɵɵpipeBind1(5, 5, "STYLER.warningAttribNotStoredNotVisualized"));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.symbolizer.offset !== undefined);
} }
const _c54 = ["graphicLineMenu"];
const _c55 = ["graphicStrokeMenu"];
function HsLineSymbolizerComponent_input_11_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "input", 35);
    ɵngcc0.ɵɵlistener("ngModelChange", function HsLineSymbolizerComponent_input_11_Template_input_ngModelChange_0_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r10); const i_r8 = restoredCtx.index; const ctx_r9 = ɵngcc0.ɵɵnextContext(); return (ctx_r9.symbolizer.dasharray[i_r8] = $event); })("change", function HsLineSymbolizerComponent_input_11_Template_input_change_0_listener() { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.emitChange(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r8 = ctx.index;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngModelOptions", ɵngcc0.ɵɵpureFunction0(2, _c2))("ngModel", ctx_r0.symbolizer.dasharray[i_r8]);
} }
function HsLineSymbolizerComponent_option_27_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const cap_r12 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(cap_r12);
} }
function HsLineSymbolizerComponent_option_37_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const join_r13 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(join_r13);
} }
function HsLineSymbolizerComponent_hs_symbolizer_67_Template(rf, ctx) { if (rf & 1) {
    const _r15 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "hs-symbolizer", 36);
    ɵngcc0.ɵɵlistener("changes", function HsLineSymbolizerComponent_hs_symbolizer_67_Template_hs_symbolizer_changes_0_listener() { ɵngcc0.ɵɵrestoreView(_r15); const ctx_r14 = ɵngcc0.ɵɵnextContext(); return ctx_r14.emitChange(); })("remove", function HsLineSymbolizerComponent_hs_symbolizer_67_Template_hs_symbolizer_remove_0_listener() { ɵngcc0.ɵɵrestoreView(_r15); const ctx_r16 = ɵngcc0.ɵɵnextContext(); return ctx_r16.symbolizer.graphicFill = undefined; });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("symbolizer", ctx_r4.symbolizer.graphicFill);
} }
function HsLineSymbolizerComponent_hs_symbolizer_85_Template(rf, ctx) { if (rf & 1) {
    const _r18 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "hs-symbolizer", 36);
    ɵngcc0.ɵɵlistener("changes", function HsLineSymbolizerComponent_hs_symbolizer_85_Template_hs_symbolizer_changes_0_listener() { ɵngcc0.ɵɵrestoreView(_r18); const ctx_r17 = ɵngcc0.ɵɵnextContext(); return ctx_r17.emitChange(); })("remove", function HsLineSymbolizerComponent_hs_symbolizer_85_Template_hs_symbolizer_remove_0_listener() { ɵngcc0.ɵɵrestoreView(_r18); const ctx_r19 = ɵngcc0.ɵɵnextContext(); return ctx_r19.symbolizer.graphicStroke = undefined; });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("symbolizer", ctx_r6.symbolizer.graphicStroke);
} }
function HsMarkSymbolizerComponent_option_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const wellKnownName_r1 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", wellKnownName_r1, " ");
} }
const _c56 = ["addSymMenu"];
function HsRuleComponent_hs_filters_19_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "hs-filters", 19);
    ɵngcc0.ɵɵlistener("changes", function HsRuleComponent_hs_filters_19_Template_hs_filters_changes_0_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.emitChange(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("rule", ctx_r0.rule);
} }
function HsRuleComponent_hs_scale_denominator_20_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "hs-scale-denominator", 19);
    ɵngcc0.ɵɵlistener("changes", function HsRuleComponent_hs_scale_denominator_20_Template_hs_scale_denominator_changes_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.emitChange(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("rule", ctx_r1.rule);
} }
function HsRuleComponent_ng_container_42_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "hs-symbolizer-list-item", 22);
    ɵngcc0.ɵɵlistener("changes", function HsRuleComponent_ng_container_42_ng_container_2_Template_hs_symbolizer_list_item_changes_1_listener() { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r10 = ɵngcc0.ɵɵnextContext(2); return ctx_r10.emitChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const symbolizer_r9 = ctx.$implicit;
    const ctx_r8 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("rule", ctx_r8.rule)("symbolizer", symbolizer_r9);
} }
function HsRuleComponent_ng_container_42_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "ul", 20);
    ɵngcc0.ɵɵlistener("cdkDropListDropped", function HsRuleComponent_ng_container_42_Template_ul_cdkDropListDropped_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ctx_r12.drop($event); });
    ɵngcc0.ɵɵtemplate(2, HsRuleComponent_ng_container_42_ng_container_2_Template, 2, 2, "ng-container", 21);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("cdkDropListData", ctx_r3.rule.symbolizers);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r3.rule.symbolizers);
} }
const _c57 = ".cdk-drag-preview[_ngcontent-%COMP%]{box-sizing:content-box;border-radius:0;background-color:#b9b9b9bf;border:1px solid #b9b9b9;overflow:hidden;display:flex;align-items:center;color:#000;box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f}.cdk-drag-placeholder[_ngcontent-%COMP%]{opacity:0}.cdk-drag-animating[_ngcontent-%COMP%]{transition:transform 125ms cubic-bezier(0,0,.2,1)}.list-group.hs-styler-content-list.cdk-drop-list-dragging[_ngcontent-%COMP%]   hs-rule-list-item[_ngcontent-%COMP%]:not(.cdk-drag-placeholder){transition:transform .25s cubic-bezier(0,0,.2,1)}.list-group.hs-styler-content-list.cdk-drop-list-dragging[_ngcontent-%COMP%]   hs-symbolizer-list-item[_ngcontent-%COMP%]:not(.cdk-drag-placeholder){transition:transform .25s cubic-bezier(0,0,.2,1)}ul.hs-styler-content-list[_ngcontent-%COMP%]{margin-top:0;margin-bottom:0;border-bottom:1px solid var(--panel-wrapper-bg-color)}li.list-group-item.hs-list-item-header[_ngcontent-%COMP%]{padding:.3em;width:100%;cursor:pointer;display:flex;justify-content:space-between;align-items:center;border-radius:0}li.list-group-item.hs-list-item-header[_ngcontent-%COMP%]   .btn-danger[_ngcontent-%COMP%]{margin-right:1rem}li.list-group-item.hs-list-item-header[_ngcontent-%COMP%]   span.glyphicon[_ngcontent-%COMP%]{font-size:x-small}li.list-group-item.hs-list-item-header[_ngcontent-%COMP%]:hover{background-color:#b9b9b9bf}";
function HsRuleListItemComponent_ng_container_11_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "hs-rule", 7);
    ɵngcc0.ɵɵlistener("changes", function HsRuleListItemComponent_ng_container_11_Template_hs_rule_changes_1_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r1 = ɵngcc0.ɵɵnextContext(); return ctx_r1.hsStylerService.save(); })("mousedown", function HsRuleListItemComponent_ng_container_11_Template_hs_rule_mousedown_1_listener($event) { return $event.stopPropagation(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("rule", ctx_r0.rule);
} }
function HsSliderComponent_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 5);
    ɵngcc0.ɵɵtext(1, "!");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵpropertyInterpolate("title", ctx_r0.warning);
} }
function HsSymbolizerComponent_hs_fill_symbolizer_2_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "hs-fill-symbolizer", 3);
    ɵngcc0.ɵɵlistener("changes", function HsSymbolizerComponent_hs_fill_symbolizer_2_Template_hs_fill_symbolizer_changes_0_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.emitChange(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("symbolizer", ctx_r0.symbolizer);
} }
function HsSymbolizerComponent_hs_line_symbolizer_3_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "hs-line-symbolizer", 3);
    ɵngcc0.ɵɵlistener("changes", function HsSymbolizerComponent_hs_line_symbolizer_3_Template_hs_line_symbolizer_changes_0_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.emitChange(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("symbolizer", ctx_r1.symbolizer);
} }
function HsSymbolizerComponent_hs_mark_symbolizer_4_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "hs-mark-symbolizer", 3);
    ɵngcc0.ɵɵlistener("changes", function HsSymbolizerComponent_hs_mark_symbolizer_4_Template_hs_mark_symbolizer_changes_0_listener() { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.emitChange(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("symbolizer", ctx_r2.symbolizer);
} }
function HsSymbolizerComponent_hs_icon_symbolizer_5_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "hs-icon-symbolizer", 3);
    ɵngcc0.ɵɵlistener("changes", function HsSymbolizerComponent_hs_icon_symbolizer_5_Template_hs_icon_symbolizer_changes_0_listener() { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.emitChange(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("symbolizer", ctx_r3.symbolizer);
} }
function HsSymbolizerComponent_hs_text_symbolizer_6_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "hs-text-symbolizer", 3);
    ɵngcc0.ɵɵlistener("changes", function HsSymbolizerComponent_hs_text_symbolizer_6_Template_hs_text_symbolizer_changes_0_listener() { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r13 = ɵngcc0.ɵɵnextContext(); return ctx_r13.emitChange(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("symbolizer", ctx_r4.symbolizer);
} }
function HsSymbolizerListItemComponent_ng_container_12_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "hs-symbolizer", 7);
    ɵngcc0.ɵɵlistener("changes", function HsSymbolizerListItemComponent_ng_container_12_Template_hs_symbolizer_changes_1_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r1 = ɵngcc0.ɵɵnextContext(); return ctx_r1.emitChange(); })("mousedown", function HsSymbolizerListItemComponent_ng_container_12_Template_hs_symbolizer_mousedown_1_listener($event) { return $event.stopPropagation(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("symbolizer", ctx_r0.symbolizer);
} }
function HsTextSymbolizerComponent_option_15_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 17);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const font_r8 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", font_r8);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(font_r8);
} }
function HsTextSymbolizerComponent_option_31_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const justify_r9 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(justify_r9);
} }
function HsTextSymbolizerComponent_option_41_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const transform_r10 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(transform_r10);
} }
function HsTextSymbolizerComponent_option_51_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const fontStyle_r11 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(fontStyle_r11);
} }
function HsTextSymbolizerComponent_option_61_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const fontWeight_r12 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(fontWeight_r12);
} }
function HsTextSymbolizerComponent_input_74_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "input", 18);
    ɵngcc0.ɵɵlistener("ngModelChange", function HsTextSymbolizerComponent_input_74_Template_input_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r13 = ɵngcc0.ɵɵnextContext(); return (ctx_r13.symbolizer.offset[0] = $event); })("change", function HsTextSymbolizerComponent_input_74_Template_input_change_0_listener() { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r15 = ɵngcc0.ɵɵnextContext(); return ctx_r15.emitChange(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngModelOptions", ɵngcc0.ɵɵpureFunction0(2, _c2))("ngModel", ctx_r5.symbolizer.offset[0]);
} }
function HsTextSymbolizerComponent_input_80_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "input", 18);
    ɵngcc0.ɵɵlistener("ngModelChange", function HsTextSymbolizerComponent_input_80_Template_input_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r16 = ɵngcc0.ɵɵnextContext(); return (ctx_r16.symbolizer.offset[1] = $event); })("change", function HsTextSymbolizerComponent_input_80_Template_input_change_0_listener() { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r18 = ɵngcc0.ɵɵnextContext(); return ctx_r18.emitChange(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngModelOptions", ɵngcc0.ɵɵpureFunction0(2, _c2))("ngModel", ctx_r6.symbolizer.offset[1]);
} }
function HsTextSymbolizerComponent_option_92_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const anchor_r19 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(anchor_r19);
} }
function HsQueryAttributeRowComponent_input_5_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "input", 6);
    ɵngcc0.ɵɵlistener("ngModelChange", function HsQueryAttributeRowComponent_input_5_Template_input_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.attribute.value = $event; })("change", function HsQueryAttributeRowComponent_input_5_Template_input_change_0_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.change(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.attribute.value)("readonly", ctx_r0.readonly)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(3, _c2));
} }
function HsQueryAttributeRowComponent_textarea_6_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "textarea", 7);
    ɵngcc0.ɵɵlistener("ngModelChange", function HsQueryAttributeRowComponent_textarea_6_Template_textarea_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.attribute.value = $event; });
    ɵngcc0.ɵɵtext(1, "            ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.attribute.value)("readonly", ctx_r1.readonly)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(3, _c2));
} }
function HsQueryDefaultInfoPanelBodyComponent_div_0_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 10);
} if (rf & 2) {
    const html_r3 = ctx.$implicit;
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(2, _c14, ctx_r1.featureInfoExpanded))("innerHtml", html_r3, ɵngcc0.ɵɵsanitizeHtml);
} }
function HsQueryDefaultInfoPanelBodyComponent_div_0_tr_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "tr");
    ɵngcc0.ɵɵelementStart(1, "td", 11);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(3, "td", 12);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const attribute_r4 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(attribute_r4.name);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("innerHtml", attribute_r4.value, ɵngcc0.ɵɵsanitizeHtml);
} }
function HsQueryDefaultInfoPanelBodyComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵelementStart(3, "button", 4);
    ɵngcc0.ɵɵlistener("click", function HsQueryDefaultInfoPanelBodyComponent_div_0_Template_button_click_3_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.featureInfoExpanded = !ctx_r5.featureInfoExpanded; });
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵpipe(5, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(6, HsQueryDefaultInfoPanelBodyComponent_div_0_div_6_Template, 1, 4, "div", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(7, "hs-query-feature-list", 6);
    ɵngcc0.ɵɵelementStart(8, "table", 7);
    ɵngcc0.ɵɵelementStart(9, "tbody");
    ɵngcc0.ɵɵtemplate(10, HsQueryDefaultInfoPanelBodyComponent_div_0_tr_10_Template, 4, 2, "tr", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(11, "iframe", 9);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("hidden", !(ctx_r0.HsQueryBaseService.data.featureInfoHtmls.length > 0));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("aria-expanded", ctx_r0.featureInfoExpanded);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(5, 7, "QUERY.featureInfo"), " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.HsQueryBaseService.data.featureInfoHtmls);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("features", ctx_r0.HsQueryBaseService.data.features);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", !(ctx_r0.HsQueryBaseService.data.attributes.length > 0));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.HsQueryBaseService.data.attributes);
} }
function HsQueryFeatureComponent_span_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1, "in layer");
    ɵngcc0.ɵɵelementEnd();
} }
function HsQueryFeatureComponent_hs_query_attribute_row_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "hs-query-attribute-row", 36);
} if (rf & 2) {
    const attribute_r6 = ctx.$implicit;
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("template", ctx_r1.feature.hstemplate)("feature", ctx_r1.feature)("attribute", attribute_r6)("readonly", false);
} }
function HsQueryFeatureComponent_hs_query_attribute_row_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "hs-query-attribute-row", 37);
} if (rf & 2) {
    const stat_r7 = ctx.$implicit;
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("feature", ctx_r2.feature)("attribute", stat_r7)("readonly", true);
} }
function HsQueryFeatureComponent_option_35_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 38);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const layer_r8 = ctx.$implicit;
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngValue", layer_r8);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r3.HsLayerUtilsService.translateTitle(ctx_r3.getTitle(layer_r8)), "");
} }
function HsQueryFeatureComponent_a_59_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 39);
    ɵngcc0.ɵɵlistener("downloadPrepared", function HsQueryFeatureComponent_a_59_Template_a_downloadPrepared_0_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r11); const format_r9 = restoredCtx.$implicit; return format_r9.downloadData = $event; });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const format_r9 = ctx.$implicit;
    ɵngcc0.ɵɵpropertyInterpolate2("download", "", format_r9.name, "_file.", format_r9.ext, "");
    ɵngcc0.ɵɵproperty("hsDownload", format_r9.serializedData)("mimeType", format_r9.mimeType)("href", format_r9.downloadData, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(format_r9.name);
} }
function HsQueryFeatureComponent_button_60_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 40);
    ɵngcc0.ɵɵlistener("click", function HsQueryFeatureComponent_button_60_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ctx_r12.removeFeature(); });
    ɵngcc0.ɵɵelement(1, "i", 41);
    ɵngcc0.ɵɵelementEnd();
} }
function HsQueryFeatureListComponent_div_0_div_8_a_14_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 19);
    ɵngcc0.ɵɵlistener("downloadPrepared", function HsQueryFeatureListComponent_div_0_div_8_a_14_Template_a_downloadPrepared_0_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r7); const format_r5 = restoredCtx.$implicit; return format_r5.downloadData = $event; });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const format_r5 = ctx.$implicit;
    ɵngcc0.ɵɵpropertyInterpolate2("download", "", format_r5.name, "_file.", format_r5.ext, "");
    ɵngcc0.ɵɵproperty("hsDownload", format_r5.serializedData)("mimeType", format_r5.mimeType)("href", format_r5.downloadData, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", format_r5.name, "");
} }
function HsQueryFeatureListComponent_div_0_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 9);
    ɵngcc0.ɵɵelementStart(1, "button", 10);
    ɵngcc0.ɵɵlistener("click", function HsQueryFeatureListComponent_div_0_div_8_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r8 = ɵngcc0.ɵɵnextContext(2); return ctx_r8.toggleEditMenu(); });
    ɵngcc0.ɵɵelement(2, "i", 11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 12);
    ɵngcc0.ɵɵelementStart(4, "a", 13);
    ɵngcc0.ɵɵlistener("click", function HsQueryFeatureListComponent_div_0_div_8_Template_a_click_4_listener() { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r10 = ɵngcc0.ɵɵnextContext(2); return ctx_r10.editTypeSelected("copy"); });
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵpipe(6, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "a", 13);
    ɵngcc0.ɵɵlistener("click", function HsQueryFeatureListComponent_div_0_div_8_Template_a_click_7_listener() { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r11 = ɵngcc0.ɵɵnextContext(2); return ctx_r11.editTypeSelected("move"); });
    ɵngcc0.ɵɵtext(8);
    ɵngcc0.ɵɵpipe(9, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "button", 14);
    ɵngcc0.ɵɵlistener("click", function HsQueryFeatureListComponent_div_0_div_8_Template_button_click_10_listener() { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r12 = ɵngcc0.ɵɵnextContext(2); return ctx_r12.toggleExportMenu(); });
    ɵngcc0.ɵɵpipe(11, "translate");
    ɵngcc0.ɵɵelement(12, "i", 15);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(13, "div", 12);
    ɵngcc0.ɵɵtemplate(14, HsQueryFeatureListComponent_div_0_div_8_a_14_Template, 2, 6, "a", 16);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(15, "button", 17);
    ɵngcc0.ɵɵlistener("click", function HsQueryFeatureListComponent_div_0_div_8_Template_button_click_15_listener() { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r13 = ɵngcc0.ɵɵnextContext(2); return ctx_r13.removeAllSelectedFeatures(); });
    ɵngcc0.ɵɵpipe(16, "translate");
    ɵngcc0.ɵɵelement(17, "i", 18);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(15, _c14, ctx_r2.editMenuVisible));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(6, 7, "QUERY.feature.copyFeatures"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(9, 9, "QUERY.feature.moveFeatures"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(11, 11, "QUERY.downloadAs"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(17, _c14, ctx_r2.exportMenuVisible));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r2.exportFormats);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(16, 13, "QUERY.deleteAllSelected"));
} }
function HsQueryFeatureListComponent_div_0_div_9_option_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 30);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const layer_r15 = ctx.$implicit;
    const ctx_r14 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("ngValue", layer_r15);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r14.HsLayerUtilsService.translateTitle(ctx_r14.getTitle(layer_r15)), "");
} }
function HsQueryFeatureListComponent_div_0_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 20);
    ɵngcc0.ɵɵelementStart(1, "div", 21);
    ɵngcc0.ɵɵelementStart(2, "div", 22);
    ɵngcc0.ɵɵelementStart(3, "label", 23);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵpipe(5, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "select", 24);
    ɵngcc0.ɵɵlistener("ngModelChange", function HsQueryFeatureListComponent_div_0_div_9_Template_select_ngModelChange_6_listener($event) { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r16 = ɵngcc0.ɵɵnextContext(2); return ctx_r16.selectedLayer = $event; });
    ɵngcc0.ɵɵpipe(7, "translate");
    ɵngcc0.ɵɵelementStart(8, "option", 25);
    ɵngcc0.ɵɵtext(9);
    ɵngcc0.ɵɵpipe(10, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(11, HsQueryFeatureListComponent_div_0_div_9_option_11_Template, 2, 2, "option", 26);
    ɵngcc0.ɵɵpipe(12, "async");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(13, "div", 27);
    ɵngcc0.ɵɵelementStart(14, "button", 28);
    ɵngcc0.ɵɵlistener("click", function HsQueryFeatureListComponent_div_0_div_9_Template_button_click_14_listener() { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r18 = ɵngcc0.ɵɵnextContext(2); return ctx_r18.moveOrCopyFeature(); });
    ɵngcc0.ɵɵelement(15, "i", 29);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate2("", ctx_r3.HsFeatureCommonService.translateString("QUERY.feature", ctx_r3.editType + "Features"), " ", ɵngcc0.ɵɵpipeBind1(5, 9, "COMMON.into"), ":");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r3.selectedLayer)("title", ɵngcc0.ɵɵpipeBind1(7, 11, "ADDLAYERS.Vector.chooseLayer"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngValue", null)("disabled", true);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(10, 13, "ADDLAYERS.Vector.chooseLayer"), "");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind1(12, 15, ctx_r3.HsFeatureCommonService.availableLayer$));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("disabled", !ctx_r3.selectedLayer);
} }
const _c58 = function (a0) { return { "flex": a0 }; };
function HsQueryFeatureListComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r20 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 3);
    ɵngcc0.ɵɵelementStart(2, "div", 4);
    ɵngcc0.ɵɵelementStart(3, "p", 5);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵpipe(5, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "button", 6);
    ɵngcc0.ɵɵlistener("click", function HsQueryFeatureListComponent_div_0_Template_button_click_6_listener() { ɵngcc0.ɵɵrestoreView(_r20); const ctx_r19 = ɵngcc0.ɵɵnextContext(); return ctx_r19.selectedFeaturesVisible = !ctx_r19.selectedFeaturesVisible; });
    ɵngcc0.ɵɵpipe(7, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(8, HsQueryFeatureListComponent_div_0_div_8_Template, 18, 19, "div", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(9, HsQueryFeatureListComponent_div_0_div_9_Template, 16, 17, "div", 8);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction1(10, _c58, ctx_r0.features.length > 1 ? "" : "1"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate2(" ", ɵngcc0.ɵɵpipeBind1(5, 6, "QUERY.featuresSelected"), "", ctx_r0.features.length, " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(7, 8, "HISTORY.toggleDropdown"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.features.length > 1);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.editType);
} }
function HsQueryFeatureListComponent_div_1_hs_query_feature_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "hs-query-feature", 32);
} if (rf & 2) {
    const item_r22 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("feature", item_r22);
} }
function HsQueryFeatureListComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, HsQueryFeatureListComponent_div_1_hs_query_feature_1_Template, 1, 1, "hs-query-feature", 31);
    ɵngcc0.ɵɵpipe(2, "slice");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind3(2, 2, ctx_r1.features, 0, 50))("ngForTrackBy", ctx_r1.trackById);
} }
function HsLayerFeaturesComponent_table_6_tr_9_span_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵelementStart(1, "i");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const attr_r4 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(attr_r4.value);
} }
function HsLayerFeaturesComponent_table_6_tr_9_span_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 19);
} if (rf & 2) {
    const attr_r4 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("innerHTML", attr_r4.sanitizedValue, ɵngcc0.ɵɵsanitizeHtml);
} }
function HsLayerFeaturesComponent_table_6_tr_9_div_10_a_1_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 6);
    ɵngcc0.ɵɵlistener("click", function HsLayerFeaturesComponent_table_6_tr_9_div_10_a_1_Template_a_click_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r13); const operation_r11 = restoredCtx.$implicit; const ctx_r12 = ɵngcc0.ɵɵnextContext(4); return ctx_r12.executeOperation(operation_r11); });
    ɵngcc0.ɵɵelementStart(1, "span");
    ɵngcc0.ɵɵelementStart(2, "i");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const operation_r11 = ctx.$implicit;
    const ctx_r10 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r10.HsFeatureTableService.translate(operation_r11.customActionName) || ctx_r10.HsFeatureTableService.translate(operation_r11.action), ";");
} }
function HsLayerFeaturesComponent_table_6_tr_9_div_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, HsLayerFeaturesComponent_table_6_tr_9_div_10_a_1_Template, 4, 1, "a", 20);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const attr_r4 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", attr_r4.value.operations);
} }
function HsLayerFeaturesComponent_table_6_tr_9_Template(rf, ctx) { if (rf & 1) {
    const _r16 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "tr", 13);
    ɵngcc0.ɵɵelementStart(1, "th", 14);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementStart(3, "a", 15);
    ɵngcc0.ɵɵlistener("click", function HsLayerFeaturesComponent_table_6_tr_9_Template_a_click_3_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r16); const attr_r4 = restoredCtx.$implicit; const ctx_r15 = ɵngcc0.ɵɵnextContext(2); return ctx_r15.HsFeatureTableService.sortFeaturesBy(attr_r4.name); });
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵtext(5, "^");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "td", 16);
    ɵngcc0.ɵɵtemplate(7, HsLayerFeaturesComponent_table_6_tr_9_span_7_Template, 3, 1, "span", 17);
    ɵngcc0.ɵɵelementStart(8, "i");
    ɵngcc0.ɵɵtemplate(9, HsLayerFeaturesComponent_table_6_tr_9_span_9_Template, 1, 1, "span", 18);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(10, HsLayerFeaturesComponent_table_6_tr_9_div_10_Template, 2, 1, "div", 17);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const attr_r4 = ctx.$implicit;
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.HsFeatureTableService.translate(attr_r4.name));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(4, 5, "FEATURE_TABLE.sortFeaturesByValue"));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngIf", !attr_r4.sanitizedValue && !(attr_r4.value == null ? null : attr_r4.value.operations));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !!attr_r4.sanitizedValue);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", attr_r4.value == null ? null : attr_r4.value.operations);
} }
function HsLayerFeaturesComponent_table_6_tr_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "tr", 21);
    ɵngcc0.ɵɵelementStart(1, "th", 14);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "td", 16);
    ɵngcc0.ɵɵelementStart(4, "span");
    ɵngcc0.ɵɵelementStart(5, "i");
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const stat_r17 = ctx.$implicit;
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("hidden", !ctx_r3.showFeatureStats);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r3.HsFeatureTableService.translate(stat_r17.name));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(stat_r17.value);
} }
function HsLayerFeaturesComponent_table_6_Template(rf, ctx) { if (rf & 1) {
    const _r19 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "table", 7);
    ɵngcc0.ɵɵelementStart(1, "thead");
    ɵngcc0.ɵɵelementStart(2, "tr", 8);
    ɵngcc0.ɵɵelementStart(3, "th", 9);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementStart(5, "a", 10);
    ɵngcc0.ɵɵlistener("click", function HsLayerFeaturesComponent_table_6_Template_a_click_5_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r19); const feature_r1 = restoredCtx.$implicit; const ctx_r18 = ɵngcc0.ɵɵnextContext(); return ctx_r18.HsFeatureTableService.sortFeaturesBy(feature_r1.name); });
    ɵngcc0.ɵɵpipe(6, "translate");
    ɵngcc0.ɵɵtext(7, "^");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "tbody");
    ɵngcc0.ɵɵtemplate(9, HsLayerFeaturesComponent_table_6_tr_9_Template, 11, 7, "tr", 11);
    ɵngcc0.ɵɵtemplate(10, HsLayerFeaturesComponent_table_6_tr_10_Template, 7, 3, "tr", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const feature_r1 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate1("", ctx_r0.HsFeatureTableService.translate(feature_r1.name), " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(6, 4, "FEATURE_TABLE.sortFeaturesByValue"));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngForOf", feature_r1.attributes);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", feature_r1.stats);
} }
function HsLayerEditorComponent_div_1_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelement(1, "hs-layer-editor-sub-layer-checkbox", 7);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const subLayer_r4 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("subLayer", subLayer_r4);
} }
function HsLayerEditorComponent_div_1_div_3_div_6_a_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 20);
    ɵngcc0.ɵɵpipe(1, "translate");
    ɵngcc0.ɵɵelementStart(2, "span", 21);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "span", 21);
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵpipe(7, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const metadataUrl_r14 = ctx.$implicit;
    ɵngcc0.ɵɵpropertyInterpolate("href", metadataUrl_r14.onlineResource, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(1, 7, "COMMON.metadata"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("hidden", !metadataUrl_r14.type);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate2(" ", ɵngcc0.ɵɵpipeBind1(4, 9, "LAYERMANAGER.layerEditor.metadataOfLayer"), " ", metadataUrl_r14.type, " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("hidden", metadataUrl_r14.type);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(7, 11, "LAYERMANAGER.layerEditor.metadataOfService"), " ");
} }
function HsLayerEditorComponent_div_1_div_3_div_6_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "a", 20);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("href", ctx_r13.getAttribution(ctx_r13.currentLayer.layer).onlineResource, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(2, 3, "LAYERMANAGER.layerEditor.copyright"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(4, 5, "LAYERMANAGER.layerEditor.copyright"), "");
} }
function HsLayerEditorComponent_div_1_div_3_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 8);
    ɵngcc0.ɵɵelementStart(1, "div", 18);
    ɵngcc0.ɵɵtemplate(2, HsLayerEditorComponent_div_1_div_3_div_6_a_2_Template, 8, 13, "a", 19);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, HsLayerEditorComponent_div_1_div_3_div_6_div_3_Template, 5, 7, "div", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r5.HsLayerManagerMetadataService.metadataArray(ctx_r5.currentLayer));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r5.hasCopyright(ctx_r5.currentLayer));
} }
function HsLayerEditorComponent_div_1_div_3_span_16_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵelementStart(1, "span", 22);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 2, "COMMON.from"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" 1:", ctx_r6.minResolution, "");
} }
function HsLayerEditorComponent_div_1_div_3_span_17_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵelementStart(1, "span", 22);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 2, "COMMON.to"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" 1:", ctx_r7.maxResolution, "");
} }
function HsLayerEditorComponent_div_1_div_3_div_19_Template(rf, ctx) { if (rf & 1) {
    const _r16 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 23);
    ɵngcc0.ɵɵelementStart(1, "input", 24);
    ɵngcc0.ɵɵlistener("ngModelChange", function HsLayerEditorComponent_div_1_div_3_div_19_Template_input_ngModelChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r16); const ctx_r15 = ɵngcc0.ɵɵnextContext(3); return ctx_r15.cluster = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(2, "label", 25);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r8.cluster);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(4, 2, "LAYERMANAGER.layerEditor.cluster"));
} }
function HsLayerEditorComponent_div_1_div_3_div_20_Template(rf, ctx) { if (rf & 1) {
    const _r18 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 26);
    ɵngcc0.ɵɵelementStart(1, "label");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "input", 27);
    ɵngcc0.ɵɵlistener("ngModelChange", function HsLayerEditorComponent_div_1_div_3_div_20_Template_input_ngModelChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r18); const ctx_r17 = ɵngcc0.ɵɵnextContext(3); return ctx_r17.distance.value = $event; })("change", function HsLayerEditorComponent_div_1_div_3_div_20_Template_input_change_4_listener() { ɵngcc0.ɵɵrestoreView(_r18); const ctx_r19 = ɵngcc0.ɵɵnextContext(3); return ctx_r19.changeDistance(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 2, "COMMON.distance"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r9.distance.value);
} }
function HsLayerEditorComponent_div_1_div_3_div_21_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "p", 28);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(4, "hs-legend-layer-directive", 15);
    ɵngcc0.ɵɵelement(5, "hr");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r20 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(3, 2, "COMMON.legend"), "");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("layer", ctx_r20.HsLayerEditorService.legendDescriptor);
} }
function HsLayerEditorComponent_div_1_div_3_div_21_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, HsLayerEditorComponent_div_1_div_3_div_21_div_1_Template, 6, 4, "div", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r10.HsLayerEditorService.legendVisible());
} }
function HsLayerEditorComponent_div_1_div_3_div_28_Template(rf, ctx) { if (rf & 1) {
    const _r22 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 29);
    ɵngcc0.ɵɵelementStart(1, "button", 30);
    ɵngcc0.ɵɵlistener("click", function HsLayerEditorComponent_div_1_div_3_div_28_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r22); const ctx_r21 = ɵngcc0.ɵɵnextContext(3); return ctx_r21.HsLayerManagerService.setGreyscale(ctx_r21.currentLayer); });
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "button", 30);
    ɵngcc0.ɵɵlistener("click", function HsLayerEditorComponent_div_1_div_3_div_28_Template_button_click_5_listener() { ɵngcc0.ɵɵrestoreView(_r22); const ctx_r23 = ɵngcc0.ɵɵnextContext(3); return ctx_r23.HsLayerManagerService.setGreyscale(ctx_r23.currentLayer); });
    ɵngcc0.ɵɵpipe(6, "translate");
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵpipe(8, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(14, _c12, !ctx_r11.currentLayer.grayscale))("title", ɵngcc0.ɵɵpipeBind1(2, 6, "LAYERMANAGER.layerEditor.zoomToLayer"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(4, 8, "COMMON.color"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(16, _c12, ctx_r11.currentLayer.grayscale))("title", ɵngcc0.ɵɵpipeBind1(6, 10, "LAYERMANAGER.layerEditor.styleLayer"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(8, 12, "LAYERMANAGER.baseMapGallery.grayscale"));
} }
function HsLayerEditorComponent_div_1_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r25 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "form");
    ɵngcc0.ɵɵelementStart(2, "div", 8);
    ɵngcc0.ɵɵelementStart(3, "small", 9);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵpipe(5, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(6, HsLayerEditorComponent_div_1_div_3_div_6_Template, 4, 2, "div", 10);
    ɵngcc0.ɵɵelementStart(7, "div", 4);
    ɵngcc0.ɵɵelementStart(8, "label");
    ɵngcc0.ɵɵtext(9);
    ɵngcc0.ɵɵpipe(10, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(11, "p", 11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(12, "div", 4);
    ɵngcc0.ɵɵelementStart(13, "label");
    ɵngcc0.ɵɵtext(14);
    ɵngcc0.ɵɵpipe(15, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(16, HsLayerEditorComponent_div_1_div_3_span_16_Template, 5, 4, "span", 6);
    ɵngcc0.ɵɵtemplate(17, HsLayerEditorComponent_div_1_div_3_span_17_Template, 5, 4, "span", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(18, "div", 12);
    ɵngcc0.ɵɵtemplate(19, HsLayerEditorComponent_div_1_div_3_div_19_Template, 5, 4, "div", 13);
    ɵngcc0.ɵɵtemplate(20, HsLayerEditorComponent_div_1_div_3_div_20_Template, 5, 4, "div", 14);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(21, HsLayerEditorComponent_div_1_div_3_div_21_Template, 2, 1, "div", 6);
    ɵngcc0.ɵɵelement(22, "hs-layer-editor-dimensions", 15);
    ɵngcc0.ɵɵelementStart(23, "div", 8);
    ɵngcc0.ɵɵelementStart(24, "label");
    ɵngcc0.ɵɵtext(25);
    ɵngcc0.ɵɵpipe(26, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(27, "input", 16);
    ɵngcc0.ɵɵlistener("ngModelChange", function HsLayerEditorComponent_div_1_div_3_Template_input_ngModelChange_27_listener($event) { ɵngcc0.ɵɵrestoreView(_r25); const ctx_r24 = ɵngcc0.ɵɵnextContext(2); return ctx_r24.opacity = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(28, HsLayerEditorComponent_div_1_div_3_div_28_Template, 9, 18, "div", 17);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate3(" ", ctx_r3.HsLanguageService.getTranslationIgnoreNonExisting("LAYERMANAGER.layerEditor", ctx_r3.currentLayer.type), " ", ɵngcc0.ɵɵpipeBind1(5, 18, "LAYERMANAGER.layerEditor.layerFrom"), " ", ctx_r3.HsLanguageService.getTranslationIgnoreNonExisting("LAYERMANAGER.layerEditor", ctx_r3.currentLayer.source), " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.HsLayerManagerMetadataService.hasMetadata(ctx_r3.currentLayer));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", !ctx_r3.abstract);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(10, 20, "COMMON.abstract"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("innerHtml", ctx_r3.HsLayerManagerService.makeSafeAndTranslate("LAYERS", ctx_r3.abstract), ɵngcc0.ɵɵsanitizeHtml);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", !ctx_r3.isScaleVisible());
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(15, 22, "COMMON.scale"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.minResolutionValid());
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.maxResolutionValid());
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.isVectorLayer());
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.cluster);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.olLayer());
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("layer", ctx_r3.olLayer());
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(26, 24, "LAYERMANAGER.layerEditor.opacity"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r3.opacity);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.currentLayer.visible && ctx_r3.getBase(ctx_r3.currentLayer.layer));
} }
function HsLayerEditorComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵelementStart(1, "div", 4);
    ɵngcc0.ɵɵtemplate(2, HsLayerEditorComponent_div_1_div_2_Template, 2, 1, "div", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, HsLayerEditorComponent_div_1_div_3_Template, 29, 26, "div", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", !ctx_r0.currentLayer.sublayers);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.getSubLayers());
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.currentLayer.settings);
} }
function HsLayerEditorComponent_div_2_div_15_Template(rf, ctx) { if (rf & 1) {
    const _r31 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "div", 32);
    ɵngcc0.ɵɵelementStart(2, "div", 46);
    ɵngcc0.ɵɵelementStart(3, "span", 47);
    ɵngcc0.ɵɵelementStart(4, "span");
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵpipe(6, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(7, "\u00A01");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "input", 48);
    ɵngcc0.ɵɵlistener("ngModelChange", function HsLayerEditorComponent_div_2_div_15_Template_input_ngModelChange_8_listener($event) { ɵngcc0.ɵɵrestoreView(_r31); const ctx_r30 = ɵngcc0.ɵɵnextContext(2); return ctx_r30.minResolution = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r26 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(6, 2, "COMMON.from"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r26.minResolution);
} }
function HsLayerEditorComponent_div_2_div_16_Template(rf, ctx) { if (rf & 1) {
    const _r33 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "div", 32);
    ɵngcc0.ɵɵelementStart(2, "div", 46);
    ɵngcc0.ɵɵelementStart(3, "span", 47);
    ɵngcc0.ɵɵelementStart(4, "span");
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵpipe(6, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(7, "\u00A01");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "input", 49);
    ɵngcc0.ɵɵlistener("ngModelChange", function HsLayerEditorComponent_div_2_div_16_Template_input_ngModelChange_8_listener($event) { ɵngcc0.ɵɵrestoreView(_r33); const ctx_r32 = ɵngcc0.ɵɵnextContext(2); return ctx_r32.maxResolution = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r27 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(6, 2, "COMMON.to"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r27.maxResolution);
} }
function HsLayerEditorComponent_div_2_button_28_Template(rf, ctx) { if (rf & 1) {
    const _r35 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 42);
    ɵngcc0.ɵɵlistener("click", function HsLayerEditorComponent_div_2_button_28_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r35); const ctx_r34 = ɵngcc0.ɵɵnextContext(2); return ctx_r34.createSaveDialog(); });
    ɵngcc0.ɵɵpipe(1, "translate");
    ɵngcc0.ɵɵelement(2, "i", 36);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(1, 1, "LAYERMANAGER.layerEditor.savegeojson"));
} }
function HsLayerEditorComponent_div_2_button_29_Template(rf, ctx) { if (rf & 1) {
    const _r37 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 50);
    ɵngcc0.ɵɵlistener("click", function HsLayerEditorComponent_div_2_button_29_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r37); const ctx_r36 = ɵngcc0.ɵɵnextContext(2); return ctx_r36.removeLayer(); });
    ɵngcc0.ɵɵpipe(1, "translate");
    ɵngcc0.ɵɵelement(2, "i", 51);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(1, 1, "COMMON.removeLayer"));
} }
function HsLayerEditorComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r39 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 31);
    ɵngcc0.ɵɵelementStart(1, "div", 4);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 32);
    ɵngcc0.ɵɵelementStart(6, "input", 33);
    ɵngcc0.ɵɵlistener("ngModelChange", function HsLayerEditorComponent_div_2_Template_input_ngModelChange_6_listener($event) { ɵngcc0.ɵɵrestoreView(_r39); const ctx_r38 = ɵngcc0.ɵɵnextContext(); return ctx_r38.title = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 34);
    ɵngcc0.ɵɵlistener("click", function HsLayerEditorComponent_div_2_Template_div_click_7_listener() { ɵngcc0.ɵɵrestoreView(_r39); const ctx_r40 = ɵngcc0.ɵɵnextContext(); return ctx_r40.saveTitle(); });
    ɵngcc0.ɵɵelementStart(8, "button", 35);
    ɵngcc0.ɵɵelement(9, "i", 36);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "div", 37);
    ɵngcc0.ɵɵelement(11, "br");
    ɵngcc0.ɵɵelementStart(12, "label");
    ɵngcc0.ɵɵtext(13);
    ɵngcc0.ɵɵpipe(14, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(15, HsLayerEditorComponent_div_2_div_15_Template, 9, 4, "div", 6);
    ɵngcc0.ɵɵtemplate(16, HsLayerEditorComponent_div_2_div_16_Template, 9, 4, "div", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(17, "div", 38);
    ɵngcc0.ɵɵpipe(18, "translate");
    ɵngcc0.ɵɵelementStart(19, "button", 39);
    ɵngcc0.ɵɵlistener("click", function HsLayerEditorComponent_div_2_Template_button_click_19_listener() { ɵngcc0.ɵɵrestoreView(_r39); const ctx_r41 = ɵngcc0.ɵɵnextContext(); return ctx_r41.zoomToLayer(); });
    ɵngcc0.ɵɵpipe(20, "translate");
    ɵngcc0.ɵɵelement(21, "i", 40);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(22, "button", 39);
    ɵngcc0.ɵɵlistener("click", function HsLayerEditorComponent_div_2_Template_button_click_22_listener() { ɵngcc0.ɵɵrestoreView(_r39); const ctx_r42 = ɵngcc0.ɵɵnextContext(); return ctx_r42.styleLayer(); });
    ɵngcc0.ɵɵpipe(23, "translate");
    ɵngcc0.ɵɵelement(24, "i", 41);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(25, "button", 42);
    ɵngcc0.ɵɵlistener("click", function HsLayerEditorComponent_div_2_Template_button_click_25_listener() { ɵngcc0.ɵɵrestoreView(_r39); const ctx_r43 = ɵngcc0.ɵɵnextContext(); return ctx_r43.toggleLayerRename(); });
    ɵngcc0.ɵɵpipe(26, "translate");
    ɵngcc0.ɵɵelement(27, "i", 43);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(28, HsLayerEditorComponent_div_2_button_28_Template, 3, 3, "button", 44);
    ɵngcc0.ɵɵtemplate(29, HsLayerEditorComponent_div_2_button_29_Template, 3, 3, "button", 45);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", !ctx_r1.layer_renamer_visible);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(4, 15, "COMMON.title"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.title);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", !ctx_r1.titleUnsaved());
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(14, 17, "COMMON.scale"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.minResolutionValid());
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.maxResolutionValid());
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("aria-label", ɵngcc0.ɵɵpipeBind1(18, 19, "LAYERMANAGER.editorButtons"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("disabled", !ctx_r1.layerIsZoomable())("title", ɵngcc0.ɵɵpipeBind1(20, 21, "LAYERMANAGER.layerEditor.zoomToLayer"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("disabled", !ctx_r1.layerIsStyleable())("title", ɵngcc0.ɵɵpipeBind1(23, 23, "LAYERMANAGER.layerEditor.styleLayer"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(26, 25, "COMMON.renameLayer"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.isLayerVectorLayer(ctx_r1.currentLayer.layer));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.isLayerRemovable());
} }
function HsLayerEditorDimensionsComponent_div_0_div_4_select_3_option_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 11);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const dimension_value_r7 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", dimension_value_r7);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", dimension_value_r7, "");
} }
function HsLayerEditorDimensionsComponent_div_0_div_4_select_3_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "select", 9);
    ɵngcc0.ɵɵlistener("ngModelChange", function HsLayerEditorDimensionsComponent_div_0_div_4_select_3_Template_select_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); const dimension_r2 = ɵngcc0.ɵɵnextContext().$implicit; return dimension_r2.modelValue = $event; })("change", function HsLayerEditorDimensionsComponent_div_0_div_4_select_3_Template_select_change_0_listener() { ɵngcc0.ɵɵrestoreView(_r10); const dimension_r2 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r11 = ɵngcc0.ɵɵnextContext(2); return ctx_r11.hsDimensionService.dimensionChanged(dimension_r2); });
    ɵngcc0.ɵɵtemplate(1, HsLayerEditorDimensionsComponent_div_0_div_4_select_3_option_1_Template, 2, 2, "option", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const dimension_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("ngModel", dimension_r2.modelValue)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(3, _c2));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", dimension_r2.values);
} }
function HsLayerEditorDimensionsComponent_div_0_div_4_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 12);
    ɵngcc0.ɵɵelementStart(1, "input", 13, 14);
    ɵngcc0.ɵɵlistener("ngModelChange", function HsLayerEditorDimensionsComponent_div_0_div_4_div_8_Template_input_ngModelChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r17); const dimension_r2 = ɵngcc0.ɵɵnextContext().$implicit; return dimension_r2.modelValue = $event; })("dateSelect", function HsLayerEditorDimensionsComponent_div_0_div_4_div_8_Template_input_dateSelect_1_listener() { ɵngcc0.ɵɵrestoreView(_r17); const dimension_r2 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r18 = ɵngcc0.ɵɵnextContext(2); return ctx_r18.hsDimensionService.dimensionChanged(dimension_r2); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 15);
    ɵngcc0.ɵɵelementStart(4, "button", 16);
    ɵngcc0.ɵɵlistener("click", function HsLayerEditorDimensionsComponent_div_0_div_4_div_8_Template_button_click_4_listener() { ɵngcc0.ɵɵrestoreView(_r17); const _r14 = ɵngcc0.ɵɵreference(2); return _r14.toggle(); });
    ɵngcc0.ɵɵelement(5, "i", 17);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const dimension_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngModel", dimension_r2.modelValue)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(2, _c2));
} }
function HsLayerEditorDimensionsComponent_div_0_div_4_ngb_timepicker_9_Template(rf, ctx) { if (rf & 1) {
    const _r24 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ngb-timepicker", 18);
    ɵngcc0.ɵɵlistener("ngModelChange", function HsLayerEditorDimensionsComponent_div_0_div_4_ngb_timepicker_9_Template_ngb_timepicker_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r24); const dimension_r2 = ɵngcc0.ɵɵnextContext().$implicit; return dimension_r2.modelTimeValue = $event; })("ngModelChange", function HsLayerEditorDimensionsComponent_div_0_div_4_ngb_timepicker_9_Template_ngb_timepicker_ngModelChange_0_listener() { ɵngcc0.ɵɵrestoreView(_r24); const dimension_r2 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r25 = ɵngcc0.ɵɵnextContext(2); return ctx_r25.hsDimensionService.dimensionChanged(dimension_r2); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const dimension_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("ngModel", dimension_r2.modelTimeValue)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(2, _c2));
} }
function HsLayerEditorDimensionsComponent_div_0_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵelementStart(1, "label", 4);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, HsLayerEditorDimensionsComponent_div_0_div_4_select_3_Template, 2, 4, "select", 5);
    ɵngcc0.ɵɵelementStart(4, "div", 6);
    ɵngcc0.ɵɵelementStart(5, "label");
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵpipe(7, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(8, HsLayerEditorDimensionsComponent_div_0_div_4_div_8_Template, 6, 3, "div", 7);
    ɵngcc0.ɵɵtemplate(9, HsLayerEditorDimensionsComponent_div_0_div_4_ngb_timepicker_9_Template, 1, 3, "ngb-timepicker", 8);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const dimension_r2 = ctx.$implicit;
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1("", dimension_r2.label || dimension_r2.name, ":");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", dimension_r2.type == null);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", !ctx_r1.dimensionIsTime(dimension_r2));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(7, 6, "COMMON.date"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", dimension_r2.type == "datetime" || dimension_r2.type == "date");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", dimension_r2.type == "datetime");
} }
function HsLayerEditorDimensionsComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "p", 1);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, HsLayerEditorDimensionsComponent_div_0_div_4_Template, 10, 8, "div", 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 2, "LAYERMANAGER.dimensions"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.dimensions);
} }
function HsLayerEditorSubLayerCheckboxesComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵelementStart(1, "input", 4);
    ɵngcc0.ɵɵlistener("ngModelChange", function HsLayerEditorSubLayerCheckboxesComponent_div_1_Template_input_ngModelChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return (ctx_r2.checkedSubLayers[ctx_r2.subLayer] = $event); })("change", function HsLayerEditorSubLayerCheckboxesComponent_div_1_Template_input_change_1_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.subLayerSelected(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(2, "label", 5);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.checkedSubLayers[ctx_r0.subLayer]);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.subLayer);
} }
function HsLayerEditorSubLayerCheckboxesComponent_div_2_input_3_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "input", 12);
    ɵngcc0.ɵɵlistener("ngModelChange", function HsLayerEditorSubLayerCheckboxesComponent_div_2_input_3_Template_input_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r10 = ɵngcc0.ɵɵnextContext(2); return (ctx_r10.checkedSubLayers[ctx_r10.subLayer.Name] = $event); })("change", function HsLayerEditorSubLayerCheckboxesComponent_div_2_input_3_Template_input_change_0_listener() { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r12 = ɵngcc0.ɵɵnextContext(2); return ctx_r12.subLayerSelected(ctx_r12.subLayer, ctx_r12.checkedSubLayers[ctx_r12.subLayer.Name]); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r5.checkedSubLayers[ctx_r5.subLayer.Name])("ngModelOptions", ɵngcc0.ɵɵpureFunction0(3, _c2));
    ɵngcc0.ɵɵattribute("id", "hs-sublayers-" + ctx_r5.subLayer.Name);
} }
function HsLayerEditorSubLayerCheckboxesComponent_div_2_input_4_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "input", 12);
    ɵngcc0.ɵɵlistener("ngModelChange", function HsLayerEditorSubLayerCheckboxesComponent_div_2_input_4_Template_input_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r13 = ɵngcc0.ɵɵnextContext(2); return (ctx_r13.withChildren[ctx_r13.subLayer.Name] = $event); })("change", function HsLayerEditorSubLayerCheckboxesComponent_div_2_input_4_Template_input_change_0_listener() { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r15 = ɵngcc0.ɵɵnextContext(2); return ctx_r15.subLayerSelected(ctx_r15.subLayer, ctx_r15.withChildren[ctx_r15.subLayer.Name]); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r6.withChildren[ctx_r6.subLayer.Name])("ngModelOptions", ɵngcc0.ɵɵpureFunction0(3, _c2));
    ɵngcc0.ɵɵattribute("id", "hs-sublayers-" + ctx_r6.subLayer.Name);
} }
const _c59 = function () { return { "cursor": "pointer" }; };
const _c60 = function (a0) { return { "grayed": a0 }; };
const _c61 = function () { return { "font-size": "x-small" }; };
const _c62 = function (a0, a1) { return { "icon-chevron-down": a0, "icon-chevron-right": a1 }; };
function HsLayerEditorSubLayerCheckboxesComponent_div_2_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 13);
    ɵngcc0.ɵɵelement(1, "label", 14);
    ɵngcc0.ɵɵelementStart(2, "div", 15);
    ɵngcc0.ɵɵlistener("click", function HsLayerEditorSubLayerCheckboxesComponent_div_2_div_5_Template_div_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r16 = ɵngcc0.ɵɵnextContext(2); return ctx_r16.toggleExpanded(); });
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementStart(4, "button", 16);
    ɵngcc0.ɵɵelement(5, "i", 17);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(7, _c17, ctx_r7.withChildren[ctx_r7.subLayer.Name], !ctx_r7.withChildren[ctx_r7.subLayer.Name]));
    ɵngcc0.ɵɵattribute("for", "hs-sublayers-" + ctx_r7.subLayer.Name);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction0(10, _c59))("ngClass", ɵngcc0.ɵɵpureFunction1(11, _c60, ctx_r7.HsLayerManagerService.currentResolution >= ctx_r7.subLayer.maxResolution));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r7.subLayer.Title || ctx_r7.subLayer.Name, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction0(13, _c61));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(14, _c62, ctx_r7.expanded, !ctx_r7.expanded));
} }
const _c63 = function (a0, a1, a2) { return { "hs-checkmark": a0, "hs-uncheckmark": a1, "grayed": a2 }; };
function HsLayerEditorSubLayerCheckboxesComponent_div_2_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "label", 14);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction3(3, _c63, ctx_r8.checkedSubLayers[ctx_r8.subLayer.Name], !ctx_r8.checkedSubLayers[ctx_r8.subLayer.Name], ctx_r8.HsLayerManagerService.currentResolution > ctx_r8.subLayer.maxResolution));
    ɵngcc0.ɵɵattribute("for", "hs-sublayers-" + ctx_r8.subLayer.Name);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r8.subLayer.Title || ctx_r8.subLayer.Name);
} }
function HsLayerEditorSubLayerCheckboxesComponent_div_2_div_7_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r23 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "input", 12);
    ɵngcc0.ɵɵlistener("ngModelChange", function HsLayerEditorSubLayerCheckboxesComponent_div_2_div_7_div_1_div_1_Template_input_ngModelChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r23); const subLayer_r19 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r22 = ɵngcc0.ɵɵnextContext(3); return (ctx_r22.checkedSubLayers[subLayer_r19] = $event); })("change", function HsLayerEditorSubLayerCheckboxesComponent_div_2_div_7_div_1_div_1_Template_input_change_1_listener() { ɵngcc0.ɵɵrestoreView(_r23); const subLayer_r19 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r25 = ɵngcc0.ɵɵnextContext(3); return ctx_r25.subLayerSelected(subLayer_r19, ctx_r25.checkedSubLayers[subLayer_r19.Name]); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(2, "label", 5);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const subLayer_r19 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r20 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r20.checkedSubLayers[subLayer_r19])("ngModelOptions", ɵngcc0.ɵɵpureFunction0(5, _c2));
    ɵngcc0.ɵɵattribute("id", "hs-sublayers-" + subLayer_r19);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("for", "hs-sublayers-" + subLayer_r19);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(subLayer_r19);
} }
function HsLayerEditorSubLayerCheckboxesComponent_div_2_div_7_div_1_hs_layer_editor_sub_layer_checkbox_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "hs-layer-editor-sub-layer-checkbox", 21);
} if (rf & 2) {
    const subLayer_r19 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("subLayer", subLayer_r19);
} }
function HsLayerEditorSubLayerCheckboxesComponent_div_2_div_7_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, HsLayerEditorSubLayerCheckboxesComponent_div_2_div_7_div_1_div_1_Template, 4, 6, "div", 10);
    ɵngcc0.ɵɵtemplate(2, HsLayerEditorSubLayerCheckboxesComponent_div_2_div_7_div_1_hs_layer_editor_sub_layer_checkbox_2_Template, 1, 1, "hs-layer-editor-sub-layer-checkbox", 20);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const subLayer_r19 = ctx.$implicit;
    const ctx_r18 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r18.subLayerIsString(subLayer_r19));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r18.subLayerIsString(subLayer_r19));
} }
function HsLayerEditorSubLayerCheckboxesComponent_div_2_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 18);
    ɵngcc0.ɵɵtemplate(1, HsLayerEditorSubLayerCheckboxesComponent_div_2_div_7_div_1_Template, 3, 2, "div", 19);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("hidden", !ctx_r9.expanded);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r9.subLayer.Layer);
} }
function HsLayerEditorSubLayerCheckboxesComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 6);
    ɵngcc0.ɵɵelementStart(1, "div", 7);
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵtemplate(3, HsLayerEditorSubLayerCheckboxesComponent_div_2_input_3_Template, 1, 4, "input", 8);
    ɵngcc0.ɵɵtemplate(4, HsLayerEditorSubLayerCheckboxesComponent_div_2_input_4_Template, 1, 4, "input", 8);
    ɵngcc0.ɵɵtemplate(5, HsLayerEditorSubLayerCheckboxesComponent_div_2_div_5_Template, 6, 17, "div", 9);
    ɵngcc0.ɵɵtemplate(6, HsLayerEditorSubLayerCheckboxesComponent_div_2_div_6_Template, 3, 7, "div", 10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(7, HsLayerEditorSubLayerCheckboxesComponent_div_2_div_7_Template, 2, 2, "div", 11);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r1.subLayer.Layer);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.subLayer.Layer);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.subLayer.Layer);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r1.subLayer.Layer);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.subLayer.Layer);
} }
function HsLayerListComponent_div_0_li_2_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 19);
} if (rf & 2) {
    const layer_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("innerHtml", ctx_r4.HsLayerManagerService.makeSafeAndTranslate("LAYERS", layer_r2.abstract), ɵngcc0.ɵɵsanitizeHtml);
} }
const _c64 = function (a0, a1) { return { "icon-chevron-right": a0, "icon-chevron-down": a1 }; };
function HsLayerListComponent_div_0_li_2_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 20);
    ɵngcc0.ɵɵlistener("click", function HsLayerListComponent_div_0_li_2_div_8_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r10); const layer_r2 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r8 = ɵngcc0.ɵɵnextContext(2); return ctx_r8.HsLayerManagerService.toggleLayerEditor(layer_r2, "sublayers", "settings"); });
    ɵngcc0.ɵɵelement(1, "span", 21);
    ɵngcc0.ɵɵelement(2, "span", 22);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const layer_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", ctx_r5.layerLoaded(layer_r2));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(3, _c64, ctx_r5.HsLayerManagerService.currentLayer === layer_r2, ctx_r5.HsLayerManagerService.currentLayer !== layer_r2))("hidden", !ctx_r5.layerLoaded(layer_r2));
} }
function HsLayerListComponent_div_0_li_2_hs_layermanager_time_editor_24_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "hs-layermanager-time-editor", 23);
} if (rf & 2) {
    const layer_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("layer", layer_r2);
} }
const _c65 = function (a1) { return { "hs-lm-detail-activated": "currentLayer == layer", "grayed": a1 }; };
const _c66 = function (a0) { return { "hover": a0 }; };
function HsLayerListComponent_div_0_li_2_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 4);
    ɵngcc0.ɵɵelementStart(1, "div", 5);
    ɵngcc0.ɵɵelementStart(2, "div", 6);
    ɵngcc0.ɵɵelementStart(3, "button", 7);
    ɵngcc0.ɵɵlistener("click", function HsLayerListComponent_div_0_li_2_Template_button_click_3_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r14); const layer_r2 = restoredCtx.$implicit; const ctx_r13 = ɵngcc0.ɵɵnextContext(2); ctx_r13.HsLayerManagerService.changeLayerVisibility(!layer_r2.visible, layer_r2); ctx_r13.toggleSublayersVisibility(layer_r2); return $event.stopPropagation(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, HsLayerListComponent_div_0_li_2_ng_template_4_Template, 1, 1, "ng-template", null, 8, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementStart(6, "div", 9);
    ɵngcc0.ɵɵlistener("click", function HsLayerListComponent_div_0_li_2_Template_div_click_6_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r14); const layer_r2 = restoredCtx.$implicit; const ctx_r15 = ɵngcc0.ɵɵnextContext(2); return ctx_r15.HsLayerManagerService.toggleLayerEditor(layer_r2, "sublayers", "settings"); });
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(8, HsLayerListComponent_div_0_li_2_div_8_Template, 3, 6, "div", 10);
    ɵngcc0.ɵɵelementStart(9, "div", 11);
    ɵngcc0.ɵɵelementStart(10, "i", 12);
    ɵngcc0.ɵɵlistener("click", function HsLayerListComponent_div_0_li_2_Template_i_click_10_listener($event) { return $event.stopPropagation(); });
    ɵngcc0.ɵɵpipe(11, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(12, "div", 11);
    ɵngcc0.ɵɵelementStart(13, "i", 13);
    ɵngcc0.ɵɵlistener("click", function HsLayerListComponent_div_0_li_2_Template_i_click_13_listener($event) { return $event.stopPropagation(); });
    ɵngcc0.ɵɵpipe(14, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(15, "div", 11);
    ɵngcc0.ɵɵelementStart(16, "i", 14);
    ɵngcc0.ɵɵlistener("click", function HsLayerListComponent_div_0_li_2_Template_i_click_16_listener($event) { return $event.stopPropagation(); });
    ɵngcc0.ɵɵpipe(17, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(18, "div", 11);
    ɵngcc0.ɵɵelementStart(19, "i", 15);
    ɵngcc0.ɵɵlistener("click", function HsLayerListComponent_div_0_li_2_Template_i_click_19_listener($event) { return $event.stopPropagation(); });
    ɵngcc0.ɵɵpipe(20, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(21, "div", 16);
    ɵngcc0.ɵɵelementStart(22, "span", 17);
    ɵngcc0.ɵɵlistener("click", function HsLayerListComponent_div_0_li_2_Template_span_click_22_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r14); const layer_r2 = restoredCtx.$implicit; const ctx_r20 = ɵngcc0.ɵɵnextContext(2); return ctx_r20.HsLayerManagerService.toggleLayerEditor(layer_r2, "settings", "sublayers"); });
    ɵngcc0.ɵɵpipe(23, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(24, HsLayerListComponent_div_0_li_2_hs_layermanager_time_editor_24_Template, 1, 1, "hs-layermanager-time-editor", 18);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const layer_r2 = ctx.$implicit;
    const _r3 = ɵngcc0.ɵɵreference(5);
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵpropertyInterpolate("id", layer_r2.idString());
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(30, _c65, layer_r2.grayed === true));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r1.getExclusive(layer_r2.layer) ? "exclusive" : "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", layer_r2.visible ? "hs-checkmark" : "hs-uncheckmark");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(32, _c66, layer_r2.hasSublayers === true))("ngbTooltip", layer_r2.abstract ? _r3 : "")("closeDelay", ctx_r1.HsConfig.layerTooltipDelay || 0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.HsLayerUtilsService.translateTitle(layer_r2.title), " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", layer_r2.hasSublayers);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", ctx_r1.layerValid(layer_r2));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(11, 20, "LAYERMANAGER.layerList.noAvailableInScale"))("hidden", !layer_r2.grayed);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("hidden", !ctx_r1.layerValid(layer_r2));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(14, 22, "LAYERMANAGER.layerList.layerNotAvailable"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("hidden", !ctx_r1.getHsLaymanSynchronizing(layer_r2.layer));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(17, 24, "LAYERMANAGER.layerList.sendingToLayman"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("hidden", !ctx_r1.isLayerQueryable(layer_r2));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(20, 26, "LAYERMANAGER.layerList.layerIsQueryable"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(23, 28, "COMMON.info"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.showLayerWmsT(layer_r2));
} }
function HsLayerListComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "ul", 2);
    ɵngcc0.ɵɵtemplate(2, HsLayerListComponent_div_0_li_2_Template, 25, 34, "li", 3);
    ɵngcc0.ɵɵpipe(3, "filter");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind2(3, 1, ctx_r0.filtered_layers, ctx_r0.layerFilter));
} }
const _c67 = function (a0) { return { "padding-left": a0 }; };
function HsLayerManagerFolderComponent_ul_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ul", 1);
    ɵngcc0.ɵɵelementStart(1, "a", 2);
    ɵngcc0.ɵɵelementStart(2, "span", 3);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "li", 4);
    ɵngcc0.ɵɵelement(5, "hs-layer-manager-folder", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "li");
    ɵngcc0.ɵɵelement(7, "hs-layermanager-layer-list", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const value_r1 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction1(5, _c67, value_r1.indent * 15));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.HsLanguageService.getTranslationIgnoreNonExisting("LAYERMANAGER", value_r1.name));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", !ctx_r0.folderVisible(value_r1));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("folder", value_r1);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("folder", value_r1);
} }
const _c68 = ["hstimeselector"];
function HsLayerManagerTimeEditorComponent_option_13_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 14);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "date");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const time_r2 = ctx.$implicit;
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngValue", time_r2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind3(2, 2, time_r2, ctx_r1.timeDisplayFormat, ctx_r1.timeDisplayLocale), " ");
} }
const _c69 = function (a0, a1) { return { "btn-info": a0, "text-secondary": a1 }; };
const _c70 = function (a0) { return { "activeLayer": a0 }; };
function HsLayerPhysicalListComponent_div_0_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵelementStart(1, "div", 5);
    ɵngcc0.ɵɵelementStart(2, "p", 6);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(4, "i", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const layer_r2 = ctx.$implicit;
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(2, _c70, layer_r2.active));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.HsLayerUtilsService.translateTitle(layer_r2.title));
} }
function HsLayerPhysicalListComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵlistener("cdkDropListDropped", function HsLayerPhysicalListComponent_div_0_Template_div_cdkDropListDropped_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.drop($event); });
    ɵngcc0.ɵɵtemplate(2, HsLayerPhysicalListComponent_div_0_div_2_Template, 5, 4, "div", 3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("cdkDropListData", ctx_r0.HsLayermanagerPhysicalListService.layersCopy);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.HsLayermanagerPhysicalListService.layersCopy);
} }
function HsLegendLayerComponent_hs_legend_vector_layer_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "hs-legend-vector-layer", 3);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("layer-style", ctx_r0.styles)("geometry-type", ctx_r0.geometryTypes);
} }
function HsLegendLayerComponent_div_2_img_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "img", 5);
} if (rf & 2) {
    const sublayer_r5 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("src", sublayer_r5, ɵngcc0.ɵɵsanitizeUrl);
} }
function HsLegendLayerComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, HsLegendLayerComponent_div_2_img_1_Template, 1, 1, "img", 4);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.layer.subLayerLegends);
} }
const _c71 = function (a0) { return { "background-color": a0 }; };
function HsLegendLayerComponent_div_3_p_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p");
    ɵngcc0.ɵɵelementStart(1, "span", 7);
    ɵngcc0.ɵɵtext(2, "\u00A0\u00A0\u00A0");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const category_r7 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction1(2, _c71, category_r7.color));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1("\u00A0", category_r7.name, " ");
} }
function HsLegendLayerComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, HsLegendLayerComponent_div_3_p_1_Template, 4, 4, "p", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r2.layer.lyr.getSource().legend_categories);
} }
function HsLegendLayerComponent_hs_legend_layer_static_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "hs-legend-layer-static", 8);
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("layer", ctx_r3.layer);
} }
function HsLegendLayerStaticComponent_img_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "img", 2);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("src", ctx_r0.legendImage, ɵngcc0.ɵɵsanitizeUrl);
} }
function HsLegendLayerStaticComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 3);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("innerHtml", ctx_r1.svgContent, ɵngcc0.ɵɵsanitizeHtml);
} }
function HsLegendLayerVectorComponent_div_0_div_2_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelement(1, "img", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const style_r3 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngStyle", style_r3.style)("src", style_r3.icon.src, ɵngcc0.ɵɵsanitizeUrl);
} }
function HsLegendLayerVectorComponent_div_0_div_2_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(1, "svg", 7);
    ɵngcc0.ɵɵelement(2, "circle", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const style_r3 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngStyle", style_r3.style);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngStyle", style_r3.defaultCircle);
} }
function HsLegendLayerVectorComponent_div_0_div_2_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(1, "svg", 7);
    ɵngcc0.ɵɵelement(2, "circle", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const style_r3 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngStyle", style_r3.style);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngStyle", style_r3.customCircle);
} }
function HsLegendLayerVectorComponent_div_0_div_2_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(1, "svg", 7);
    ɵngcc0.ɵɵelement(2, "polygon", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const style_r3 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngStyle", style_r3.style);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngStyle", style_r3.defaultPolygon);
} }
function HsLegendLayerVectorComponent_div_0_div_2_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(1, "svg", 7);
    ɵngcc0.ɵɵelement(2, "polygon", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const style_r3 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngStyle", style_r3.style);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngStyle", style_r3.fullPolygon);
} }
function HsLegendLayerVectorComponent_div_0_div_2_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(1, "svg", 7);
    ɵngcc0.ɵɵelement(2, "polygon", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const style_r3 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngStyle", style_r3.style);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngStyle", style_r3.polygon);
} }
function HsLegendLayerVectorComponent_div_0_div_2_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(1, "svg", 7);
    ɵngcc0.ɵɵelement(2, "line", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const style_r3 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngStyle", style_r3.style);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngStyle", style_r3.defaultLine);
} }
function HsLegendLayerVectorComponent_div_0_div_2_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(1, "svg", 7);
    ɵngcc0.ɵɵelement(2, "line", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const style_r3 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngStyle", style_r3.style);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngStyle", style_r3.line);
} }
function HsLegendLayerVectorComponent_div_0_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, HsLegendLayerVectorComponent_div_0_div_2_div_1_Template, 2, 2, "div", 5);
    ɵngcc0.ɵɵtemplate(2, HsLegendLayerVectorComponent_div_0_div_2_div_2_Template, 3, 2, "div", 5);
    ɵngcc0.ɵɵtemplate(3, HsLegendLayerVectorComponent_div_0_div_2_div_3_Template, 3, 2, "div", 5);
    ɵngcc0.ɵɵtemplate(4, HsLegendLayerVectorComponent_div_0_div_2_div_4_Template, 3, 2, "div", 5);
    ɵngcc0.ɵɵtemplate(5, HsLegendLayerVectorComponent_div_0_div_2_div_5_Template, 3, 2, "div", 5);
    ɵngcc0.ɵɵtemplate(6, HsLegendLayerVectorComponent_div_0_div_2_div_6_Template, 3, 2, "div", 5);
    ɵngcc0.ɵɵtemplate(7, HsLegendLayerVectorComponent_div_0_div_2_div_7_Template, 3, 2, "div", 5);
    ɵngcc0.ɵɵtemplate(8, HsLegendLayerVectorComponent_div_0_div_2_div_8_Template, 3, 2, "div", 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const style_r3 = ctx.$implicit;
    const geometry_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", style_r3.icon && geometry_r1 === "point");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", style_r3.defaultCircle && geometry_r1 === "point");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", style_r3.customCircle && geometry_r1 === "point");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", style_r3.defaultPolygon && geometry_r1 === "polygon");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", style_r3.fullPolygon && geometry_r1 === "polygon");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", style_r3.polygon && geometry_r1 === "polygon");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", style_r3.defaultLine && geometry_r1 === "line");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", style_r3.line && geometry_r1 === "line");
} }
function HsLegendLayerVectorComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵtemplate(2, HsLegendLayerVectorComponent_div_0_div_2_Template, 9, 8, "div", 3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 4);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const geometry_r1 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.layerStyle);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", geometry_r1, " ");
} }
const _c72 = function (a0) { return { "btn-primary": a0 }; };
function HsSaveMapAdvancedFormComponent_li_1_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 31);
    ɵngcc0.ɵɵelementStart(1, "a", 32);
    ɵngcc0.ɵɵlistener("click", function HsSaveMapAdvancedFormComponent_li_1_Template_a_click_1_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r6); const s_r4 = restoredCtx.$implicit; const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.setStep(s_r4); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const s_r4 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattributeInterpolate1("aria-controls", "hs-", s_r4, "");
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(3, _c72, ctx_r0.step === s_r4));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.capitalizeFirstLetter(s_r4));
} }
function HsSaveMapAdvancedFormComponent_div_26_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 33);
    ɵngcc0.ɵɵelementStart(1, "div", 34);
    ɵngcc0.ɵɵelementStart(2, "input", 35);
    ɵngcc0.ɵɵlistener("ngModelChange", function HsSaveMapAdvancedFormComponent_div_26_Template_input_ngModelChange_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.HsSaveMapManagerService.compoData.bbox.east = $event; });
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 34);
    ɵngcc0.ɵɵelementStart(5, "input", 35);
    ɵngcc0.ɵɵlistener("ngModelChange", function HsSaveMapAdvancedFormComponent_div_26_Template_input_ngModelChange_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.HsSaveMapManagerService.compoData.bbox.south = $event; });
    ɵngcc0.ɵɵpipe(6, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 34);
    ɵngcc0.ɵɵelementStart(8, "input", 35);
    ɵngcc0.ɵɵlistener("ngModelChange", function HsSaveMapAdvancedFormComponent_div_26_Template_input_ngModelChange_8_listener($event) { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.HsSaveMapManagerService.compoData.bbox.west = $event; });
    ɵngcc0.ɵɵpipe(9, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "div", 34);
    ɵngcc0.ɵɵelementStart(11, "input", 35);
    ɵngcc0.ɵɵlistener("ngModelChange", function HsSaveMapAdvancedFormComponent_div_26_Template_input_ngModelChange_11_listener($event) { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.HsSaveMapManagerService.compoData.bbox.north = $event; });
    ɵngcc0.ɵɵpipe(12, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngModelOptions", ɵngcc0.ɵɵpureFunction0(20, _c2))("ngModel", ctx_r1.HsSaveMapManagerService.compoData.bbox.east)("title", ɵngcc0.ɵɵpipeBind1(3, 12, "COMMON.east"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngModelOptions", ɵngcc0.ɵɵpureFunction0(21, _c2))("ngModel", ctx_r1.HsSaveMapManagerService.compoData.bbox.south)("title", ɵngcc0.ɵɵpipeBind1(6, 14, "COMMON.south"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngModelOptions", ɵngcc0.ɵɵpureFunction0(22, _c2))("ngModel", ctx_r1.HsSaveMapManagerService.compoData.bbox.west)("title", ɵngcc0.ɵɵpipeBind1(9, 16, "COMMON.west"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngModelOptions", ɵngcc0.ɵɵpureFunction0(23, _c2))("ngModel", ctx_r1.HsSaveMapManagerService.compoData.bbox.north)("title", ɵngcc0.ɵɵpipeBind1(12, 18, "COMMON.north"));
} }
function HsSaveMapAdvancedFormComponent_li_32_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 15);
    ɵngcc0.ɵɵelementStart(1, "div", 36);
    ɵngcc0.ɵɵelementStart(2, "input", 37);
    ɵngcc0.ɵɵlistener("ngModelChange", function HsSaveMapAdvancedFormComponent_li_32_Template_input_ngModelChange_2_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r14); const layer_r12 = restoredCtx.$implicit; return layer_r12.checked = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "label", 38);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const layer_r12 = ctx.$implicit;
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngModelOptions", ɵngcc0.ɵɵpureFunction0(3, _c2))("ngModel", layer_r12.checked);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.HsLayerUtilsService.translateTitle(layer_r12.title));
} }
function HsSaveMapAdvancedFormComponent_tr_49_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "tr");
    ɵngcc0.ɵɵelementStart(1, "td");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "td");
    ɵngcc0.ɵɵelementStart(4, "input", 39);
    ɵngcc0.ɵɵlistener("ngModelChange", function HsSaveMapAdvancedFormComponent_tr_49_Template_input_ngModelChange_4_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r17); const g_r15 = restoredCtx.$implicit; return g_r15.r = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "td");
    ɵngcc0.ɵɵelementStart(6, "input", 39);
    ɵngcc0.ɵɵlistener("ngModelChange", function HsSaveMapAdvancedFormComponent_tr_49_Template_input_ngModelChange_6_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r17); const g_r15 = restoredCtx.$implicit; return g_r15.w = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const g_r15 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1("", g_r15.roleTitle || g_r15.roleName, ":");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngModel", g_r15.r)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(5, _c2));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngModel", g_r15.w)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(6, _c2));
} }
function HsSaveMapSimpleFormComponent_div_0_div_18_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 20);
    ɵngcc0.ɵɵelementStart(1, "label");
    ɵngcc0.ɵɵelementStart(2, "input", 21);
    ɵngcc0.ɵɵlistener("ngModelChange", function HsSaveMapSimpleFormComponent_div_0_div_18_Template_input_ngModelChange_2_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r6); const g_r4 = restoredCtx.$implicit; return g_r4.r = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "span");
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵpipe(5, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const g_r4 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngModel", g_r4.r)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(5, _c2));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(5, 3, "SAVECOMPOSITION.panelMd.makePublic"));
} }
function HsSaveMapSimpleFormComponent_div_0_li_47_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 22);
    ɵngcc0.ɵɵelementStart(1, "span");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "span", 23);
    ɵngcc0.ɵɵelementStart(4, "input", 21);
    ɵngcc0.ɵɵlistener("ngModelChange", function HsSaveMapSimpleFormComponent_div_0_li_47_Template_input_ngModelChange_4_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r10); const layer_r7 = restoredCtx.$implicit; return layer_r7.checked = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const layer_r7 = ctx.$implicit;
    const index_r8 = ctx.index;
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵpropertyInterpolate1("id", "layer-", index_r8, "");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r3.HsLayerUtilsService.translateTitle(layer_r7.title));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngModel", layer_r7.checked)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(4, _c2));
} }
function HsSaveMapSimpleFormComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "form", 1);
    ɵngcc0.ɵɵelementStart(2, "label", 2);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵelementStart(5, "input", 3);
    ɵngcc0.ɵɵlistener("ngModelChange", function HsSaveMapSimpleFormComponent_div_0_Template_input_ngModelChange_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.HsSaveMapManagerService.compoData.title = $event; });
    ɵngcc0.ɵɵpipe(6, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "label", 2);
    ɵngcc0.ɵɵtext(8);
    ɵngcc0.ɵɵpipe(9, "translate");
    ɵngcc0.ɵɵelementStart(10, "textarea", 4);
    ɵngcc0.ɵɵlistener("ngModelChange", function HsSaveMapSimpleFormComponent_div_0_Template_textarea_ngModelChange_10_listener($event) { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r13 = ɵngcc0.ɵɵnextContext(); return ctx_r13.HsSaveMapManagerService.compoData.abstract = $event; });
    ɵngcc0.ɵɵpipe(11, "translate");
    ɵngcc0.ɵɵtext(12, "            ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(13, "label", 2);
    ɵngcc0.ɵɵtext(14);
    ɵngcc0.ɵɵpipe(15, "translate");
    ɵngcc0.ɵɵelement(16, "img", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(17, "div", 2);
    ɵngcc0.ɵɵtemplate(18, HsSaveMapSimpleFormComponent_div_0_div_18_Template, 6, 6, "div", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(19, "button", 7);
    ɵngcc0.ɵɵtext(20);
    ɵngcc0.ɵɵpipe(21, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(22, "div", 8);
    ɵngcc0.ɵɵelementStart(23, "form", 1);
    ɵngcc0.ɵɵelementStart(24, "label", 2);
    ɵngcc0.ɵɵtext(25);
    ɵngcc0.ɵɵpipe(26, "translate");
    ɵngcc0.ɵɵelementStart(27, "input", 9);
    ɵngcc0.ɵɵlistener("ngModelChange", function HsSaveMapSimpleFormComponent_div_0_Template_input_ngModelChange_27_listener($event) { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r14 = ɵngcc0.ɵɵnextContext(); return ctx_r14.HsSaveMapManagerService.compoData.keywords = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(28, "label", 2);
    ɵngcc0.ɵɵtext(29);
    ɵngcc0.ɵɵpipe(30, "translate");
    ɵngcc0.ɵɵelementStart(31, "div", 10);
    ɵngcc0.ɵɵelementStart(32, "div", 11);
    ɵngcc0.ɵɵelementStart(33, "input", 12);
    ɵngcc0.ɵɵlistener("ngModelChange", function HsSaveMapSimpleFormComponent_div_0_Template_input_ngModelChange_33_listener($event) { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r15 = ɵngcc0.ɵɵnextContext(); return (ctx_r15.HsSaveMapManagerService.compoData.bbox[0] = $event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(34, "div", 11);
    ɵngcc0.ɵɵelementStart(35, "input", 13);
    ɵngcc0.ɵɵlistener("ngModelChange", function HsSaveMapSimpleFormComponent_div_0_Template_input_ngModelChange_35_listener($event) { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r16 = ɵngcc0.ɵɵnextContext(); return (ctx_r16.HsSaveMapManagerService.compoData.bbox[1] = $event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(36, "div", 11);
    ɵngcc0.ɵɵelementStart(37, "input", 13);
    ɵngcc0.ɵɵlistener("ngModelChange", function HsSaveMapSimpleFormComponent_div_0_Template_input_ngModelChange_37_listener($event) { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r17 = ɵngcc0.ɵɵnextContext(); return (ctx_r17.HsSaveMapManagerService.compoData.bbox[2] = $event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(38, "div", 11);
    ɵngcc0.ɵɵelementStart(39, "input", 13);
    ɵngcc0.ɵɵlistener("ngModelChange", function HsSaveMapSimpleFormComponent_div_0_Template_input_ngModelChange_39_listener($event) { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r18 = ɵngcc0.ɵɵnextContext(); return (ctx_r18.HsSaveMapManagerService.compoData.bbox[3] = $event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(40, "button", 14);
    ɵngcc0.ɵɵlistener("click", function HsSaveMapSimpleFormComponent_div_0_Template_button_click_40_listener() { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r19 = ɵngcc0.ɵɵnextContext(); return ctx_r19.HsSaveMapManagerService.setCurrentBoundingBox(); });
    ɵngcc0.ɵɵtext(41);
    ɵngcc0.ɵɵpipe(42, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(43, "label", 2);
    ɵngcc0.ɵɵtext(44);
    ɵngcc0.ɵɵpipe(45, "translate");
    ɵngcc0.ɵɵelementStart(46, "ul", 15);
    ɵngcc0.ɵɵtemplate(47, HsSaveMapSimpleFormComponent_div_0_li_47_Template, 5, 5, "li", 16);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(48, "div", 17);
    ɵngcc0.ɵɵelementStart(49, "div", 18);
    ɵngcc0.ɵɵpipe(50, "translate");
    ɵngcc0.ɵɵelementStart(51, "button", 19);
    ɵngcc0.ɵɵlistener("click", function HsSaveMapSimpleFormComponent_div_0_Template_button_click_51_listener() { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r20 = ɵngcc0.ɵɵnextContext(); return ctx_r20.HsSaveMapManagerService.confirmSave(); });
    ɵngcc0.ɵɵtext(52);
    ɵngcc0.ɵɵpipe(53, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(4, 28, "COMMON.name"), " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("placeholder", ɵngcc0.ɵɵpipeBind1(6, 30, "COMMON.fillInName"))("ngModel", ctx_r0.HsSaveMapManagerService.compoData.title);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(9, 32, "COMMON.abstract"), " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("placeholder", ɵngcc0.ɵɵpipeBind1(11, 34, "COMMON.fillInDescriptive"))("ngModel", ctx_r0.HsSaveMapManagerService.compoData.abstract)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(52, _c2));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(15, 36, "COMMON.thumbnail"), " ");
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.HsSaveMapManagerService.statusData.groups);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(21, 38, "COMMON.advancedOptions"));
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(26, 40, "COMMON.keywords"), " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.HsSaveMapManagerService.compoData.keywords)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(53, _c2));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(30, 42, "COMMON.extent"), " ");
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.HsSaveMapManagerService.compoData.bbox[0])("ngModelOptions", ɵngcc0.ɵɵpureFunction0(54, _c2));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.HsSaveMapManagerService.compoData.bbox[1])("ngModelOptions", ɵngcc0.ɵɵpureFunction0(55, _c2));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.HsSaveMapManagerService.compoData.bbox[2])("ngModelOptions", ɵngcc0.ɵɵpureFunction0(56, _c2));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.HsSaveMapManagerService.compoData.bbox[3])("ngModelOptions", ɵngcc0.ɵɵpureFunction0(57, _c2));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(42, 44, "SAVECOMPOSITION.form.userCurrentMapExtent"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(45, 46, "COMMON.layers"), " ");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.HsSaveMapManagerService.compoData.layers);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵattribute("aria-label", ɵngcc0.ɵɵpipeBind1(50, 48, "SAVECOMPOSITION.dialogSave.saveComposition"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("disabled", !ctx_r0.HsSaveMapManagerService.compoData.title);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(53, 50, "COMMON.save"));
} }
function HsSaveMapSimpleFormComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "div", 24);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(3, 1, "SAVECOMPOSITION.panelMd.youAreNotAuthorized"), "");
} }
function HsSearchInputComponent_button_7_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 6);
    ɵngcc0.ɵɵlistener("click", function HsSearchInputComponent_button_7_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r1 = ɵngcc0.ɵɵnextContext(); return ctx_r1.clear(); });
    ɵngcc0.ɵɵelement(1, "i", 7);
    ɵngcc0.ɵɵelementEnd();
} }
function HsSearchResultsComponent_div_1_div_1_a_3_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 4);
    ɵngcc0.ɵɵlistener("click", function HsSearchResultsComponent_div_1_div_1_a_3_Template_a_click_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r7); const result_r5 = restoredCtx.$implicit; const ctx_r6 = ɵngcc0.ɵɵnextContext(3); return ctx_r6.zoomTo(result_r5); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementStart(2, "small", 5);
    ɵngcc0.ɵɵelement(3, "br");
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const result_r5 = ctx.$implicit;
    ɵngcc0.ɵɵattribute("title", result_r5.DisplayDescription);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(result_r5.name || result_r5.DisplayTitle);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(result_r5.fcodeName);
} }
function HsSearchResultsComponent_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "a", 2);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, HsSearchResultsComponent_div_1_div_1_a_3_Template, 5, 3, "a", 3);
    ɵngcc0.ɵɵpipe(4, "limitTo");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r3 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", !(item_r3.value.results.length > 0));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("Provider: ", item_r3.value.name, "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind2(4, 3, item_r3.value.results, 10));
} }
function HsSearchResultsComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, HsSearchResultsComponent_div_1_div_1_Template, 5, 6, "div", 1);
    ɵngcc0.ɵɵpipe(2, "keyvalue");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const provider_r1 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind1(2, 1, provider_r1.value));
} }
function HsTripPlannerLayerSelectorComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 8);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.HsLayerUtilsService.translateTitle(ctx_r0.selectedwrapper.title), " ");
} }
function HsTripPlannerLayerSelectorComponent_a_8_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 9);
    ɵngcc0.ɵɵlistener("click", function HsTripPlannerLayerSelectorComponent_a_8_Template_a_click_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r4); const layer_r2 = restoredCtx.$implicit; const ctx_r3 = ɵngcc0.ɵɵnextContext(); ctx_r3.HsTripPlannerService.selectLayer(layer_r2, ctx_r3.usage); return ctx_r3.layersExpanded = false; });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const layer_r2 = ctx.$implicit;
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵpropertyInterpolate("title", ctx_r1.HsLayerUtilsService.translateTitle(layer_r2.title));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.HsLayerUtilsService.translateTitle(layer_r2.title));
} }
class HslayersService {
    constructor() { }
}
HslayersService.ɵfac = function HslayersService_Factory(t) { return new (t || HslayersService)(); };
HslayersService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HslayersService_Factory() { return new HslayersService(); }, token: HslayersService, providedIn: "root" });
HslayersService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HslayersService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

const servicesSupportedByUrl = [
    'wms',
    'wfs',
    'wmts',
    'kml',
    'geojson',
    'arcgis',
];
//https://stackoverflow.com/questions/40863488/how-can-i-iterate-over-a-custom-literal-type-in-typescript

class HsConfig {
    constructor() {
        this.defaultSymbolizerIcons = [
            { name: 'favourite', url: 'img/icons/favourite28.svg' },
            { name: 'gps', url: 'img/icons/gps43.svg' },
            { name: 'information', url: 'img/icons/information78.svg' },
            { name: 'wifi', url: 'img/icons/wifi8.svg' },
        ];
        this.componentsEnabled = {
            guiOverlay: true,
            sidebar: true,
            toolbar: true,
            drawToolbar: true,
            searchToolbar: true,
            measureToolbar: true,
            geolocationButton: true,
            defaultViewButton: true,
            mapControls: true,
            basemapGallery: false,
            themeToggle: false,
        };
        /**
         * Triggered when config is updated using 'update' function of HsConfig.
         * The full resulting config is provided in the subscriber as a parameter
         */
        this.configChanges = new Subject();
        /**
         *  Determines behavior of exclusive layers (layer.exclusive = true) visibility
         *  If set to true, only layers with same path are affected by exclusivity
         */
        this.pathExclusivity = false;
        this.symbolizerIcons = this.defaultSymbolizerIcons.map((val) => {
            var _a;
            val.url = ((_a = this.assetsPath) !== null && _a !== void 0 ? _a : '') + val.url;
            return val;
        });
    }
    update(newConfig) {
        var _a;
        Object.assign(this.componentsEnabled, newConfig.componentsEnabled);
        delete newConfig.componentsEnabled;
        this.symbolizerIcons = [
            ...this.updateSymbolizers(newConfig),
            ...((_a = newConfig.symbolizerIcons) !== null && _a !== void 0 ? _a : []),
        ];
        delete newConfig.symbolizerIcons;
        Object.assign(this, newConfig);
        this.configChanges.next(this);
    }
    /**
     * This kind of duplicates getAssetsPath() in HsUtilsService, which can't be used here due to circular dependency
     */
    updateSymbolizers(config) {
        var _a;
        /* Removing 'private' since it makes this method non-optional */
        let assetsPath = (_a = config.assetsPath) !== null && _a !== void 0 ? _a : '';
        assetsPath += assetsPath.endsWith('/') ? '' : '/';
        return this.defaultSymbolizerIcons.map((val) => {
            val.url = assetsPath + val.url;
            return val;
        });
    }
}
HsConfig.ɵfac = function HsConfig_Factory(t) { return new (t || HsConfig)(); };
HsConfig.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: HsConfig, factory: HsConfig.ɵfac });
HsConfig.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsConfig, [{
        type: Injectable
    }], function () { return []; }, null); })();

/**
 * HsEventBusService provides observable events which you can subscribe to or fire them
 *
 * @example
 * HsEventBusService.sizeChanges.subscribe((size) =\> \{
 *              doSomethingWith(size);
 * \})
 * @example
 * HsEventBusService.layerLoads.next();
 */
class HsEventBusService {
    constructor() {
        this.sizeChanges = new Subject();
        /**
         * Fires when map completely reset
         * @event mapResets
         */
        this.mapResets = new Subject();
        this.layerManagerUpdates = new Subject();
        this.compositionLoadStarts = new Subject();
        this.compositionDeletes = new Subject();
        /**
         * Fires when composition is loaded or not loaded with Error message
         * @event compositionLoads
         */
        this.compositionLoads = new Subject();
        this.layerRemovals = new Subject();
        this.compositionEdits = new Subject();
        this.layerAdditions = new Subject();
        this.LayerManagerBaseLayerVisibilityChanges = new Subject();
        this.LayerManagerLayerVisibilityChanges = new Subject();
        this.layerLoads = new Subject();
        this.layerLoadings = new Subject();
        /**
         * Fires when user enables layer time synchronization in the UI
         * Used to synchronize time in PARAMS across WM(T)S-t layers
         */
        this.layerTimeSynchronizations = new Subject();
        /**
         * DEPRECATED. Moved into the HsDimensionTimeService for mostly internal usage.
         * @deprecated Replaced by layerDimensionDefinitionChanges
         */
        this.layerTimeChanges = new Subject();
        /**
         * Used to listen for changes either in "time" property in HsLayerDescrtiptor
         * or in "dimensions" property in OL Layer object
         */
        this.layerDimensionDefinitionChanges = new Subject();
        /**
         * Used to listen for changes of dimension settings in layermanager-dimensions component
         */
        this.layermanagerDimensionChanges = new Subject();
        this.vectorQueryFeatureSelection = new Subject();
        this.vectorQueryFeatureDeselection = new Subject();
        /**
         * Fires when current mainpanel change - toggle, change of opened panel.
         * replaces 'core.mainpanel_changed'
         * @event mainPanelChanges
         */
        this.mainPanelChanges = new Subject();
        /**
         * replaces 'measure.drawStart'
         */
        this.measurementStarts = new Subject();
        /**
         * replaces 'measure.drawEnd'
         */
        this.measurementEnds = new Subject();
        this.cesiumLoads = new Subject();
        this.cesiumResizes = new Subject();
        this.zoomTo = new Subject();
        /**
         * Fires when map extent change (move, zoom, resize).
         * Fires with two parameters: map element and new calculated {@link http://openlayers.org/en/latest/apidoc/ol.html#.Extent extent}
         * @event mapExtentChanges
         */
        this.mapExtentChanges = new Subject();
        this.mapCenterSynchronizations = new Subject();
        this.mapLibraryChanges = new Subject();
        /**
         * replaces 'cesium.time_layers_changed'
         */
        this.cesiumTimeLayerChanges = new Subject();
        this.layoutResizes = new Subject();
        this.layoutLoads = new Subject();
        /**
         * replaces 'map.loaded'
         */
        this.olMapLoads = new Subject();
        /**
         * Fires when composition is downloaded from server and parsing begins
         * replaces 'compositions.composition_loading'
         * @event compositionLoading
         */
        this.compositionLoading = new Subject();
        this.currentComposition = new BehaviorSubject(null);
        /**
         * replaces 'search.resultsReceived'
         */
        this.searchResultsReceived = new Subject();
        this.searchZoomTo = new Subject();
        this.clearSearchResults = new Subject();
        /**
         * replaces 'query.dataUpdated'
         */
        this.queryDataUpdated = new Subject();
        /**
         * replaces 'mapClicked'
         */
        this.mapClicked = new Subject();
        /**
         * replaces 'ows.filling'
         */
        this.owsFilling = new Subject();
        /**
         * replaces `ows.${type}_connecting`
         */
        this.owsConnecting = new BehaviorSubject({ type: undefined, uri: '', layer: null });
        /**
         * Fires when layerSelected parameter is found in the URL
         * @event layerSelectedFromUrl
         */
        this.layerSelectedFromUrl = new BehaviorSubject(null);
    }
}
HsEventBusService.ɵfac = function HsEventBusService_Factory(t) { return new (t || HsEventBusService)(); };
HsEventBusService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HsEventBusService_Factory() { return new HsEventBusService(); }, token: HsEventBusService, providedIn: "root" });
HsEventBusService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsEventBusService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class HsLanguageService {
    constructor(TranslateService) {
        this.TranslateService = TranslateService;
        this.getCurrentLanguageCode();
    }
    /**
     * @public
     * @param {string} lang Language code
     * @description Set language
     */
    setLanguage(lang) {
        this.language = lang;
        this.TranslateService.use(lang);
        // this.HsEventBusService.updateLanguageButton.next({
        //   language: lang,
        // });
    }
    /**
     * @public
     * @returns {string} Returns language code
     * @description Get code of current language
     */
    getCurrentLanguageCode() {
        if (typeof this.language == 'undefined' || this.language == '') {
            return 'en';
        }
        return this.language.substr(0, 2).toLowerCase();
    }
    /**
     * @public
     * @returns {Object} Returns available languages
     * @description Get array of available languages based
     */
    listAvailableLanguages() {
        const language_code_name_map = {
            'en': 'English',
            'cs': 'Česky',
            'fr': 'Français',
            'lv': 'Latviski',
            'nl': 'Nederlands',
            'sk': 'Slovensky',
        };
        const langs = [{ key: 'en', name: 'English' }];
        for (const lang of this.TranslateService.getLangs()) {
            if (language_code_name_map.hasOwnProperty(lang) &&
                langs.filter((l) => l.key == lang).length == 0) {
                langs.push({ key: lang, name: language_code_name_map[lang] });
            }
        }
        return langs;
    }
    /**
     * @param {string} str  Identifier of the string to be translated
     * @param params
     * @returns {string} Translation
     */
    getTranslation(str, params) {
        return this.TranslateService.instant(str, params);
    }
    getTranslationIgnoreNonExisting(module, text, params) {
        const tmp = this.getTranslation(module + '.' + text, params || undefined);
        if (tmp.includes(module + '.')) {
            return text;
        }
        return tmp;
    }
}
HsLanguageService.ɵfac = function HsLanguageService_Factory(t) { return new (t || HsLanguageService)(ɵngcc0.ɵɵinject(ɵngcc1.TranslateService)); };
HsLanguageService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HsLanguageService_Factory() { return new HsLanguageService(i0.ɵɵinject(i1.TranslateService)); }, token: HsLanguageService, providedIn: "root" });
HsLanguageService.ctorParameters = () => [
    { type: TranslateService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsLanguageService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.TranslateService }]; }, null); })();

/* eslint-disable no-console */
class HsLogService {
    warn(...attrs) {
        console.warn(attrs);
    }
    log(...attrs) {
        console.log(attrs);
    }
    error(...attrs) {
        console.error(attrs);
    }
    info(...attrs) {
        console.info(attrs);
    }
}
HsLogService.ɵfac = function HsLogService_Factory(t) { return new (t || HsLogService)(); };
HsLogService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HsLogService_Factory() { return new HsLogService(); }, token: HsLogService, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsLogService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], null, null); })();

class HsPanelItem {
    constructor(component, data) {
        this.component = component;
        this.data = data;
    }
}

class HsPanelContainerService {
    constructor() {
        this.panels = [];
        this.panelObserver = new ReplaySubject();
        this.panelDestroyObserver = new Subject();
    }
    create(component, data) {
        this.panelObserver.next(new HsPanelItem(component, data));
    }
    destroy(component) {
        this.panelDestroyObserver.next(component);
    }
}
HsPanelContainerService.ɵfac = function HsPanelContainerService_Factory(t) { return new (t || HsPanelContainerService)(); };
HsPanelContainerService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HsPanelContainerService_Factory() { return new HsPanelContainerService(); }, token: HsPanelContainerService, providedIn: "root" });
HsPanelContainerService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsPanelContainerService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class HsOverlayPanelContainerService extends HsPanelContainerService {
    constructor() {
        super();
    }
}
HsOverlayPanelContainerService.ɵfac = function HsOverlayPanelContainerService_Factory(t) { return new (t || HsOverlayPanelContainerService)(); };
HsOverlayPanelContainerService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HsOverlayPanelContainerService_Factory() { return new HsOverlayPanelContainerService(); }, token: HsOverlayPanelContainerService, providedIn: "root" });
HsOverlayPanelContainerService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsOverlayPanelContainerService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class HsLayoutService {
    constructor(HsConfig, HsEventBusService, $log, componentFactoryResolver, hsPanelContainerService, hsOverlayPanelContainerService) {
        this.HsConfig = HsConfig;
        this.HsEventBusService = HsEventBusService;
        this.$log = $log;
        this.componentFactoryResolver = componentFactoryResolver;
        this.hsPanelContainerService = hsPanelContainerService;
        this.hsOverlayPanelContainerService = hsOverlayPanelContainerService;
        /**
         * Storage of default main panel.
         * This panel is opened during initialization of app and also when other panel than default is closed.
         * @public
         * @default ''
         */
        this.defaultPanel = '';
        /**
         * @public
         */
        this.panel_statuses = {};
        /**
         * @public
         * @description DEPRECATED?
         */
        this.panel_enabled = {};
        /**
         * Storage of current main panel (panel which is opened).
         * When {@link HsLayoutService#defaultPanel defaultPanel} is specified, main panel is set to it during HsCore initialization.
         * @public
         * @default ''
         */
        this.mainpanel = '';
        /**
         * Side on which sidebar will be shown (true = right side of map, false = left side of map)
         * @public
         * @default true
         */
        this.sidebarRight = true;
        /**
         * Whether to display labels of sidebar buttons or not.
         * Used in CSS classes assertion on hs-panelspace.
         * @public
         * @default true
         */
        this.sidebarLabels = true;
        /**
         * Enable sidebar function to open/close sidebar (if false sidebar panel cannot be opened/closed through GUI)
         * @public
         * @default true
         */
        this.sidebarToggleable = true;
        /**
         * DEPRECATED Always true
         * @public
         * @deprecated
         * @default true
         */
        this.sidebarButtons = true;
        /**
         * DEPRECATED Helper property for showing some button on smaller screens
         * @public
         * @deprecated
         * @default false
         */
        this.smallWidth = false;
        /**
         * Show if any sidebar panel is opened (sidebar is completely expanded).
         * When hs.sidebar module is used in app, it change automatically to true during initialization.
         * @public
         * @default false
         */
        this.sidebarExpanded = false;
        /**
         * Show if minisidebar panel is visible in sidebar, allows sidebar to be visible in panelspace
         * @public
         * @default false
         */
        this.initializedOnce = false;
        /**
         * Whether the app has been initialized already once.
         * Need this to not add panels wtice when NgRouter is used
         * @public
         * @default false
         */
        this.minisidebar = false;
        this.panelsEnabledDefaults = {
            legend: true,
            info: true,
            composition_browser: true,
            toolbar: true,
            mobile_settings: false,
            draw: true,
            layermanager: true,
            print: true,
            saveMap: true,
            language: true,
            permalink: true,
            compositionLoadingProgress: false,
            sensors: true,
            tracking: true,
            filter: false,
            search: false,
            tripPlanner: false,
            addData: true,
        };
        this.mapSpaceRef = new BehaviorSubject(null);
        Object.defineProperty(this, 'panelListElement', {
            get: function () {
                return this.contentWrapper.querySelector('.hs-panelplace');
            },
        });
        Object.defineProperty(this, 'dialogAreaElement', {
            get: function () {
                return this.contentWrapper.querySelector('.hs-dialog-area');
            },
        });
        Object.defineProperty(this, 'sidebarListElement', {
            get: function () {
                return this.contentWrapper.querySelector('.hs-sidebar-list');
            },
        });
        /* Timeout is needed because HsConfig can
        be set after this service constructor is executed */
        setTimeout((_) => {
            this.parseConfig();
        }, 0);
    }
    parseConfig() {
        this.panel_enabled = {};
        for (const key of Object.keys(this.panelsEnabledDefaults)) {
            this.panelEnabled(key, this.getPanelEnableState(key));
        }
    }
    getPanelEnableState(panel) {
        var _a, _b;
        if (this.panelsEnabledDefaults[panel] == undefined &&
            (((_a = this.HsConfig) === null || _a === void 0 ? void 0 : _a.panelsEnabled) == undefined ||
                ((_b = this.HsConfig) === null || _b === void 0 ? void 0 : _b.panelsEnabled[panel]) == undefined)) {
            /*
            Function called from sidebar and panel is
            probably custom panel added to buttons array from outside
            */
            return true;
        }
        if (this.HsConfig.panelsEnabled == undefined) {
            return this.panelsEnabledDefaults[panel];
        }
        if (this.HsConfig.panelsEnabled[panel] == undefined) {
            return this.panelsEnabledDefaults[panel];
        }
        else {
            return this.HsConfig.panelsEnabled[panel];
        }
    }
    /**
     * @public
     * @param {string} which Name of panel to test
     * @param {$scope} scope Angular scope of panels controller (optional, needed for test of unpinned panels)
     * @returns {boolean} Panel opened/closed status
     * @description Find if selected panel is currently opened (in sidebar or as unpinned window)
     */
    panelVisible(which, scope) {
        if (scope) {
            if (scope.panelName == undefined) {
                scope.panelName = which;
            }
        }
        if (this.panel_statuses[which] !== undefined) {
            return this.panel_statuses[which] && this.panelEnabled(which);
        }
        return this.mainpanel == which || (scope && scope.unpinned);
    }
    /**
     * Close opened panel programmatically.
     * If sidebar toolbar is used in app, sidebar stay expanded with sidebar labels.
     * Cannot resolve unpinned panels.
     * @public
     */
    hidePanels() {
        this.mainpanel = '';
        this.sidebarLabels = true;
        this.HsEventBusService.mainPanelChanges.next();
    }
    /**
     * @public
     * @param {object} which Panel to close (panel scope)
     * @description Close selected panel (either unpinned panels or actual mainpanel). If default panel is defined, it is opened instead.
     */
    closePanel(which) {
        if (which.unpinned) {
            this.contentWrapper
                .querySelector(which.original_container)
                .appendChild(which.drag_panel);
            which.drag_panel.css({
                top: 'auto',
                left: 'auto',
                position: 'relative',
            });
        }
        which.unpinned = false;
        if (which.panelName == this.mainpanel) {
            if (this.defaultPanel != '') {
                if (which.panelName == this.defaultPanel) {
                    this.sidebarExpanded = false;
                }
                else {
                    this.setMainPanel(this.defaultPanel);
                }
            }
            else {
                this.mainpanel = '';
                this.sidebarLabels = true;
            }
            this.sidebarExpanded = false;
        }
        this.HsEventBusService.mainPanelChanges.next(which);
    }
    /**
     * Get or set panel visibility in sidebar.
     * When panel is disabled it means that it's not displayed in sidebar (it can be opened programmatically) but its functionality is running.
     * Use with status parameter as setter.
     * @public
     * @param which - Selected panel (panel name)
     * @param status - Visibility status of panel to set
     * @returns Panel enabled/disabled status for getter function
     */
    panelEnabled(which, status) {
        if (status === undefined) {
            if (this.panel_enabled[which] != undefined) {
                return this.panel_enabled[which];
            }
            else {
                return true;
            }
        }
        else {
            this.panel_enabled[which] = status;
        }
    }
    /**
     * Wrapper for accessing HsConfig.componentsEnabled settings.
     * @param which - Name of the GUI component to check
     * @returns true if set to true (default), false otherwise
     */
    componentEnabled(which) {
        return (this.HsConfig.componentsEnabled == undefined ||
            this.HsConfig.componentsEnabled[which] == undefined ||
            this.HsConfig.componentsEnabled[which]);
    }
    /**
     * Sets new main panel (Panel displayed in expanded sidebar).
     * Change GUI and queryable status of map (when queryable and with hs.query component in app, map does info query on map click).
     * @public
     * @param which - New panel to activate (panel name)
     * @param by_gui - Whether function call came as result of GUI action
     */
    setMainPanel(which, by_gui) {
        if (!this.panelEnabled(which)) {
            return;
        }
        if (which == this.mainpanel && by_gui) {
            which = '';
            if (this.sidebarExpanded == true) {
                if (this.sidebarBottom()) {
                    this.sidebarExpanded = false;
                }
                else {
                    this.sidebarLabels = true;
                }
            }
        }
        else {
            this.sidebarExpanded = true;
            this.sidebarLabels = false;
        }
        this.mainpanel = which;
        this.HsEventBusService.mainPanelChanges.next(which);
    }
    /**
     * Sets new default panel (Panel which is opened first and which displayed if previous active panel is closed)
     * @public
     * @param which - New panel to be default (specify panel name)
     */
    setDefaultPanel(which) {
        this.defaultPanel = which;
        this.setMainPanel(which);
    }
    panelSpaceWidth() {
        const panelWidths = {
            default: 425,
            ows: 700,
            composition_browser: 550,
            addData: 700,
        };
        const layoutWidth = this.layoutElement.clientWidth;
        Object.assign(panelWidths, this.HsConfig.panelWidths);
        let tmp = panelWidths[this.mainpanel] || panelWidths.default;
        if (typeof tmp === 'string' && tmp.includes('%')) {
            const widthRatio = Number(tmp.replace('%', ''));
            return layoutWidth * (widthRatio / 100);
        }
        if (layoutWidth <= 767 && window.innerWidth <= 767) {
            tmp = layoutWidth;
            this.sidebarToggleable = false;
            return tmp;
        }
        else {
            this.sidebarToggleable =
                this.HsConfig.sidebarToggleable != undefined
                    ? this.HsConfig.sidebarToggleable
                    : true;
            if (!this.sidebarToggleable) {
                return tmp;
            }
        }
        if (this.sidebarExpanded && this.sidebarVisible()) {
            if (panelWidths[this.mainpanel]) {
                tmp = panelWidths[this.mainpanel];
            }
            else {
                tmp = panelWidths.default;
            }
        }
        else {
            if (this.sidebarVisible()) {
                tmp = 48;
            }
            else {
                tmp = 0;
            }
        }
        // if (tmp > layoutWidth * 0.45) {
        //   tmp = layoutWidth * 0.45;
        // }
        return tmp;
    }
    sidebarVisible(state) {
        if (this.HsConfig.sidebarPosition == 'invisible' ||
            this.HsConfig.pureMap ||
            this.HsConfig.componentsEnabled.guiOverlay === false ||
            this.HsConfig.componentsEnabled.sidebar === false) {
            return false;
        }
        if (state != undefined) {
            this._sidebarVisible = state;
        }
        if (this._sidebarVisible == undefined) {
            return true;
        }
        else {
            return this._sidebarVisible;
        }
    }
    sidebarBottom() {
        return window.innerWidth <= 767;
    }
    panelSpaceHeight() {
        if (this.contentWrapper.querySelector('.hs-panelspace-wrapper')) {
            return this.contentWrapper.querySelector('.hs-panelspace-wrapper')
                .clientHeight;
            // return tmp
        }
    }
    mdToolbarHeight() {
        const ELEM = this.contentWrapper.querySelector('.md-app-toolbar');
        return ELEM ? ELEM.clientHeight : 0;
    }
    widthWithoutPanelSpace() {
        return 'calc(100% - ' + this.panelSpaceWidth() + 'px)';
    }
    mapStyle() {
        const fullscreen = this.HsConfig.sizeMode == undefined ||
            this.HsConfig.sizeMode == 'fullscreen';
        let height = this.layoutElement.clientHeight;
        let width = this.layoutElement.clientWidth;
        let marginLeft = 0;
        if (!this.sidebarBottom() || !fullscreen) {
            marginLeft += this.sidebarRight ? 0 : this.panelSpaceWidth();
            width -= this.panelSpaceWidth();
        }
        if (this.sidebarBottom() && (fullscreen || window.innerWidth <= 767)) {
            height -= this.panelSpaceHeight();
            width = this.panelSpaceWidth();
        }
        height -= this.mdToolbarHeight();
        this.HsEventBusService.layoutResizes.next({
            width,
            height,
        });
        return Object.assign({ height: `${height}px`, width: `${width}px` }, (marginLeft > 0 && { marginLeft: `${marginLeft}px` }));
    }
    addMapVisualizer(visualizerComponent) {
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(visualizerComponent);
        this.mapSpaceRef.subscribe((mapSpace) => {
            if (mapSpace) {
                mapSpace.createComponent(componentFactory);
            }
        });
    }
    createPanel(panelComponent, data) {
        this.hsPanelContainerService.create(panelComponent, data || {});
    }
    createOverlay(panelComponent, data) {
        this.hsOverlayPanelContainerService.create(panelComponent, data || {});
    }
}
HsLayoutService.ɵfac = function HsLayoutService_Factory(t) { return new (t || HsLayoutService)(ɵngcc0.ɵɵinject(HsConfig), ɵngcc0.ɵɵinject(HsEventBusService), ɵngcc0.ɵɵinject(HsLogService), ɵngcc0.ɵɵinject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵinject(HsPanelContainerService), ɵngcc0.ɵɵinject(HsOverlayPanelContainerService)); };
HsLayoutService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HsLayoutService_Factory() { return new HsLayoutService(i0.ɵɵinject(HsConfig), i0.ɵɵinject(HsEventBusService), i0.ɵɵinject(HsLogService), i0.ɵɵinject(i0.ComponentFactoryResolver), i0.ɵɵinject(HsPanelContainerService), i0.ɵɵinject(HsOverlayPanelContainerService)); }, token: HsLayoutService, providedIn: "root" });
HsLayoutService.ctorParameters = () => [
    { type: HsConfig },
    { type: HsEventBusService },
    { type: HsLogService },
    { type: ComponentFactoryResolver },
    { type: HsPanelContainerService },
    { type: HsOverlayPanelContainerService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsLayoutService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: HsConfig }, { type: HsEventBusService }, { type: HsLogService }, { type: ɵngcc0.ComponentFactoryResolver }, { type: HsPanelContainerService }, { type: HsOverlayPanelContainerService }]; }, null); })();

class HsUtilsService {
    constructor(HsConfig, http, LogService, platformId) {
        this.HsConfig = HsConfig;
        this.http = http;
        this.LogService = LogService;
        this.platformId = platformId;
    }
    /**
     * Add path to proxy cgi script (hsproxy.cgi) into URL and encode rest of URL if valid HTTP URL is send and proxy use is allowed.
     * @public
     * @param url - URL to proxify
     * @param toEncoding - Optional parameter if UTF-8 encoding shouldn't be used for non-image URLs.
     * @returns Encoded Url with path to hsproxy.cgi script
     */
    proxify(url, toEncoding) {
        var _a;
        const laymanEp = (_a = this.HsConfig.datasources) === null || _a === void 0 ? void 0 : _a.find((ep) => ep.type == 'layman');
        if (url.startsWith(this.HsConfig.proxyPrefix) ||
            (laymanEp && url.startsWith(laymanEp.url))) {
            return url;
        }
        if (url.startsWith('data:application')) {
            return url;
        }
        toEncoding = toEncoding === undefined ? true : toEncoding;
        let outUrl = url;
        //Not using location because don't know if port 80 was specified explicitly or not
        const windowUrlPosition = url.indexOf(window.location.origin);
        if (windowUrlPosition == -1 ||
            windowUrlPosition > 7 ||
            this.getPortFromUrl(url) != this.getPortFromUrl(window.location.origin)) {
            if (this.HsConfig.useProxy === undefined ||
                this.HsConfig.useProxy === true) {
                outUrl = this.HsConfig.proxyPrefix || '/proxy/';
                if (outUrl.indexOf('hsproxy.cgi') > -1) {
                    if (toEncoding &&
                        (url.indexOf('GetMap') == -1 || url.indexOf('GetFeatureInfo') > -1)) {
                        outUrl += 'toEncoding=utf-8&';
                    }
                    outUrl = outUrl + 'url=' + encodeURIComponent(url);
                }
                else {
                    outUrl += url;
                }
            }
        }
        return outUrl;
    }
    /**
     * @public
     * @param url - URL to shorten
     * @returns Shortened URL
     * Promise which shortens URL by using some URL shortener.
     * By default tinyurl is used, but user provided function in config.shortenUrl can be used. Example: function(url) {
              return new Promise(function(resolve, reject){
                  $http.get("http://tinyurl.com/api-create.php?url=" + url, {
                      longUrl: url
                  }).then(function(response) {
                      resolve(response.data);
                  }).catch(function(err) {
                      reject()
                  })
              })
          }
     */
    shortUrl(url) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.HsConfig.shortenUrl != undefined) {
                return this.HsConfig.shortenUrl(url);
            }
            return yield this.http
                .get(this.proxify('http://tinyurl.com/api-create.php?url=' + url), {
                responseType: 'text',
            })
                .toPromise();
            // return new Promise((resolve, reject) => {
            //   this.http
            //     .get(
            //       this.proxify('http://tinyurl.com/api-create.php?url=' + url, true),
            //       {
            //         longUrl: url,
            //       }
            //     )
            //     .then((response) => {
            //       resolve(response.data);
            //     })
            //     .catch((err) => {
            //       reject();
            //     });
            // });
        });
    }
    /**
     * @param url - URL for which to determine port number
     * @returns Port number
     */
    getPortFromUrl(url) {
        if (this.runningInBrowser()) {
            const link = document.createElement('a');
            link.setAttribute('href', url);
            if (link.port == '') {
                if (url.indexOf('https://') === 0) {
                    return '443';
                }
                if (url.indexOf('http://') === 0) {
                    return '80';
                }
            }
            return link.port;
        }
    }
    runningInBrowser() {
        return isPlatformBrowser(this.platformId);
    }
    /**
     * Parse parameters and their values from URL string
     * @public
     * @param str - URL to parse parameters from
     * @returns Object with parsed parameters as properties
     */
    getParamsFromUrl(str) {
        if (typeof str !== 'string') {
            return {};
        }
        if (str.includes('?')) {
            str = str.substring(str.indexOf('?') + 1);
        }
        else {
            return {};
        }
        return str
            .trim()
            .split('&')
            .reduce((ret, param) => {
            if (!param) {
                return ret;
            }
            const parts = param.replace(/\+/g, ' ').split('=');
            let key = parts[0];
            let val = parts[1];
            key = decodeURIComponent(key);
            // missing `=` should be `null`:
            // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
            val = val === undefined ? null : decodeURIComponent(val);
            if (!ret.hasOwnProperty(key)) {
                ret[key] = val;
            }
            else if (Array.isArray(ret[key])) {
                ret[key].push(val);
            }
            else {
                ret[key] = [ret[key], val];
            }
            return ret;
        }, {});
    }
    /**
     * Create encoded Url string from object with parameters
     * @public
     * @param {object} array - Parameter object with parameter key-value pairs
     * @returns Joined encoded URL query string
     */
    paramsToURL(array) {
        const pairs = [];
        for (const key in array) {
            if (array.hasOwnProperty(key) && array[key] !== undefined) {
                pairs.push(encodeURIComponent(key) + '=' + encodeURIComponent(array[key]));
            }
        }
        return pairs.join('&');
    }
    /**
     * Insert every element in the set of matched elements after the target.
     * @public
     * @param {element} newNode - Element to insert
     * @param {element} referenceNode - Element after which to insert
     */
    insertAfter(newNode, referenceNode) {
        if (newNode.length !== undefined && newNode.length > 0) {
            newNode = newNode[0];
        }
        referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
    }
    /**
     * Create URL string from object with parameters without encoding
     * @public
     * @param {object} array - Parameter object with parameter key-value pairs
     * @returns Joined URL query string
     */
    paramsToURLWoEncode(array) {
        const pairs = [];
        for (const key in array) {
            if (array.hasOwnProperty(key)) {
                pairs.push(key + '=' + array[key]);
            }
        }
        return pairs.join('&');
    }
    /**
     * Returns a function, that, as long as it continues to be
     * invoked, will not be triggered.
     * (https://davidwalsh.name/javascript-debounce-function)
     * @public
     * @param {Function} func - Function to execute with throttling
     * @param wait - The function will be called after it stops
     * being called for N milliseconds.
     * @param immediate - If `immediate` is passed, trigger the
     * function on the leading edge, instead of the trailing.
     * @param {object} context - Context element which stores the timeout handle
     * @returns {Function} Returns function which is debounced
     */
    debounce(func, wait, immediate, context) {
        if (context === undefined) {
            context = this;
        }
        return function (...args) {
            const later = function () {
                if (!immediate) {
                    func.apply(context, args);
                }
                context.timeout = null;
            };
            const callNow = immediate && !context.timeout;
            clearTimeout(context.timeout);
            context.timeout = setTimeout(later, wait);
            if (callNow) {
                func.apply(context, args);
            }
        };
    }
    /**
     * Generate randomized UUID
     * @public
     * @returns Random uuid
     */
    generateUuid() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
            const r = (Math.random() * 16) | 0, v = c == 'x' ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        });
    }
    /**
     * Generates CSS color string (rgba(0, 0, 0, 1)) from given range and value for which to have color
     * @public
     * @param numOfSteps - Maximum value which is the last color in rainbow
     * @param step - Current value to get color for
     * @param opacity - Opacity from 0 to 1
     * @returns CSS color
     */
    rainbow(numOfSteps, step, opacity) {
        // based on http://stackoverflow.com/a/7419630
        // This function generates vibrant, "evenly spaced" colours (i.e. no clustering). This is ideal for creating easily distinguishable vibrant markers in Google Maps and other apps.
        // Adam Cole, 2011-Sept-14
        // HSV to RBG adapted from: http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript
        let r, g, b;
        const h = step / (numOfSteps * 1.00000001);
        const i = ~~(h * 4);
        const f = h * 4 - i;
        const q = 1 - f;
        switch (i % 4) {
            case 2:
                (r = f), (g = 1), (b = 0);
                break;
            case 0:
                (r = 0), (g = f), (b = 1);
                break;
            case 3:
                (r = 1), (g = q), (b = 0);
                break;
            case 1:
                (r = 0), (g = 1), (b = q);
                break;
            default:
        }
        const c = 'rgba(' +
            ~~(r * 235) +
            ',' +
            ~~(g * 235) +
            ',' +
            ~~(b * 235) +
            ', ' +
            opacity +
            ')';
        return c;
    }
    /**
     * Creates a deep copy of the input object
     * @param {object} from object to deep copy
     * @param {object?} to optional target for copy
     * @returns a deep copy of input object
     */
    structuredClone(from, to) {
        if (from === null || typeof from !== 'object') {
            return from;
        }
        if (from.constructor != Object && from.constructor != Array) {
            return from;
        }
        if (from.constructor == Date ||
            from.constructor == RegExp ||
            from.constructor == Function ||
            from.constructor == String ||
            from.constructor == Number ||
            from.constructor == Boolean) {
            return new from.constructor(from);
        }
        to = to || new from.constructor();
        for (const key in from) {
            to[key] =
                typeof to[key] == 'undefined'
                    ? this.structuredClone(from[key])
                    : to[key];
        }
        return to;
    }
    /**
     * Check if object is a function
     * @param functionToCheck
     * @returns true when input is a function, false otherwise
     */
    isFunction(functionToCheck) {
        return (functionToCheck &&
            {}.toString.call(functionToCheck) === '[object Function]');
    }
    /**
     * Check if object is plain object (not function, not array, not class)
     * @param objectToCheck
     * @returns true when input is plain old JavaScript object, false otherwise
     */
    isPOJO(objectToCheck) {
        return (objectToCheck && {}.toString.call(objectToCheck) === '[object Object]');
    }
    /**
     * Check if object is an instance of a class
     * @param {object} obj
     * @param {*} type
     * @returns true when obj is an instance of type, false otherwise
     */
    instOf(obj, type) {
        return this._instanceOf(obj, type);
    }
    _instanceOf(obj, klass) {
        if (obj === undefined || obj === null) {
            return false;
        }
        if (this.isFunction(klass)) {
            return obj instanceof klass;
        }
        obj = Object.getPrototypeOf(obj);
        while (obj !== null) {
            if (obj.constructor.name === klass) {
                return true;
            }
            obj = Object.getPrototypeOf(obj);
        }
        return false;
    }
    /**
     * Remove duplicate items from an array
     * @param {Array<object>} dirtyArray Array with possible duplicate objects
     * @param property - Property of objects which must be unique in the new array.
     * Use dot symbol (".") to denote a property chain in nested object.
     * Function will return an empty array if it won't find the property in the object.
     * @returns {Array<object>} Array without duplicate objects
     */
    removeDuplicates(dirtyArray, property) {
        const propertyChain = property.split('.');
        const flatArray = [...dirtyArray];
        for (const prop of propertyChain) {
            for (const idx in flatArray) {
                if (flatArray[idx] === undefined) {
                    this.LogService.error(`Property "${prop}" not found in object.`);
                    return [];
                }
                flatArray[idx] =
                    flatArray[idx].get !== undefined
                        ? flatArray[idx].get(prop) /* get() is only defined for OL objects */
                        : flatArray[idx][prop]; /* POJO access */
            }
        }
        return dirtyArray.filter((item, position) => {
            let propertyValue = item;
            for (const prop of propertyChain) {
                propertyValue =
                    propertyValue.get !== undefined
                        ? propertyValue.get(prop) /* get() is only defined for OL objects */
                        : propertyValue[prop]; /* POJO access */
            }
            return flatArray.indexOf(propertyValue) === position;
        });
    }
    hashCode(s) {
        let hash = 0;
        if (s.length == 0) {
            return hash;
        }
        for (let i = 0; i < s.length; i++) {
            const char = s.charCodeAt(i);
            hash = (hash << 5) - hash + char;
            hash = hash & hash; // Convert to 32bit integer
        }
        return hash;
    }
    /**
     * Replaces input string text with replacement text
     * @public
     * @param target - Target string
     * @param search - String to look for
     * @param replacement - Replacement value
     * @returns Returns modified string
     */
    replaceAll(target, search, replacement) {
        return target.replace(new RegExp(search, 'g'), replacement);
    }
    resolveEsModule(module) {
        if (module.default) {
            return module.default;
        }
        else {
            return module;
        }
    }
    /**
     * Replaces first string letter to UpperCase
     * @public
     * @param target - Target string
     * @returns modified string
     */
    capitalizeFirstLetter(target) {
        return target.charAt(0).toUpperCase() + target.slice(1);
    }
    getAssetsPath() {
        let assetsPath = this.HsConfig.assetsPath || '';
        assetsPath += assetsPath.endsWith('/') ? '' : '/';
        return assetsPath;
    }
    getAjaxLoaderIcon() {
        return this.getAssetsPath() + 'img/ajax-loader.gif';
    }
    undefineEmptyString(str) {
        if (str === undefined) {
            return undefined;
        }
        return str.trim() != '' ? str : undefined;
    }
    isOverflown(element) {
        return (element.scrollHeight > element.clientHeight ||
            element.scrollWidth > element.clientWidth);
    }
    /**
     * @private
     * @param {LineString} line
     * @returns {Measurement} numeric length of line with used units
     * @description Compute and format line length with correct units (m/km)
     */
    formatLength(line, sourceProj) {
        let length = 0;
        const coordinates = line.getCoordinates();
        for (let i = 0; i < coordinates.length - 1; ++i) {
            const c1 = transform(coordinates[i], sourceProj, 'EPSG:4326');
            const c2 = transform(coordinates[i + 1], sourceProj, 'EPSG:4326');
            length += getDistance(c1, c2);
        }
        const output = {
            size: length,
            type: 'Length',
            unit: 'm',
        };
        if (length > 100) {
            output.size = Math.round((length / 1000) * 100) / 100;
            output.unit = 'km';
        }
        else {
            output.size = Math.round(length * 100) / 100;
            output.unit = 'm';
        }
        return output;
    }
    /**
     * @private
     * @param {Polygon} polygon
     * @returns {object} area of polygon with used units
     * @description Compute and format polygon area with correct units (m2/km2)
     */
    formatArea(polygon, sourceProj) {
        const area = Math.abs(getArea(polygon));
        const output = {
            size: area,
            type: 'Area',
            unit: 'm',
        };
        if (area > 10000) {
            output.size = Math.round((area / 1000000) * 100) / 100;
            output.unit = 'km';
        }
        else {
            output.size = Math.round(area * 100) / 100;
            output.unit = 'm';
        }
        return output;
    }
}
HsUtilsService.ɵfac = function HsUtilsService_Factory(t) { return new (t || HsUtilsService)(ɵngcc0.ɵɵinject(HsConfig), ɵngcc0.ɵɵinject(ɵngcc2.HttpClient), ɵngcc0.ɵɵinject(HsLogService), ɵngcc0.ɵɵinject(PLATFORM_ID)); };
HsUtilsService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: HsUtilsService, factory: HsUtilsService.ɵfac });
HsUtilsService.ctorParameters = () => [
    { type: HsConfig },
    { type: HttpClient },
    { type: HsLogService },
    { type: undefined, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsUtilsService, [{
        type: Injectable
    }], function () { return [{ type: HsConfig }, { type: ɵngcc2.HttpClient }, { type: HsLogService }, { type: undefined, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }]; }, null); })();

const TITLE$1 = 'title';
const NAME$1 = 'name';
const ABSTRACT = 'abstract';
const ACCESS_RIGHTS = 'access_rights';
const ACTIVE = 'active';
const ATTRIBUTION = 'attribution';
const AUTO_LEGEND = 'autoLegend';
const CAPABILITIES = 'capabilities';
const BASE = 'base';
const CLUSTER = 'cluster';
const CUSTOM_INFO_TEMPLATE = 'customInfoTemplate';
const DEFINITION = 'definition';
const DIMENSIONS = 'dimensions';
const EDITOR = 'editor';
const ENABLEPROXY = 'enableProxy';
const EVENTS_SUSPENDED = 'eventsSuspended';
const EXCLUSIVE = 'exclusive';
const FEATURE_INFO_LANG = 'featureInfoLang';
const FROM_COMPOSITION = 'fromComposition';
const GET_FEATURE_INFO_TARGET = 'getFeatureInfoTarget';
const HS_ORIGINAL_STYLE = 'hsOriginalStyle';
const HS_LAYMAN_SYNCHRONIZING = 'hsLaymanSynchronizing';
const INFO_FORMAT = 'infoFormat';
const INLINE_LEGEND = 'inlineLegend';
const LAYMAN_LAYER_DESCRIPTOR = 'laymanLayerDescriptor';
const MAX_RESOLUTION_DENOMINATOR = 'maxResolutionDenominator';
const METADATA = 'metadata';
const MINIMUM_TERRAIN_LEVEL = 'minimumTerrainLevel';
const ON_FEATURE_SELECTED = 'onFeatureSelected';
const PATH = 'path';
const POPUP = 'popUp';
const POPUP_CLASS = 'popupClass';
const QUERYABLE = 'queryable';
const QUERY_CAPABILITIES = 'queryCapabilities';
const QUERY_FILTER = 'queryFilter';
const REMOVABLE = 'removable';
const SHOW_IN_LAYER_MANAGER = 'showInLayerManager';
const HS_SLD = 'sld';
const THUMBNAIL = 'thumbnail';
const VIRTUAL_ATTRIBUTES = 'virtualAttributes';
const LEGENDS = 'legends';
const SUB_LAYERS = 'sublayers';
const WORKSPACE = 'workspace';
const WFS_URL = 'wfsUrl';
function getAccessRights(layer) {
    return layer.get(ACCESS_RIGHTS);
}
function setAccessRights(layer, access_rights) {
    layer.set(ACCESS_RIGHTS, access_rights);
}
function setTitle(layer, title) {
    layer.set(TITLE$1, title);
}
function getTitle(layer) {
    return layer.get(TITLE$1);
}
function setName(layer, name) {
    layer.set(NAME$1, name);
}
function getName(layer) {
    return layer.get(NAME$1);
}
function setAbstract(layer, abstract) {
    layer.set(ABSTRACT, abstract);
}
function getAbstract(layer) {
    return layer.get(ABSTRACT);
}
function setActive(group, active) {
    group.set(ACTIVE, active);
}
function getActive(group) {
    return group.get(ACTIVE);
}
function setAttribution(layer, attribution) {
    layer.set(ATTRIBUTION, attribution);
}
function getAttribution(layer) {
    return layer.get(ATTRIBUTION);
}
function setAutoLegend(layer, value) {
    layer.set(AUTO_LEGEND, value);
}
function getAutoLegend(layer) {
    return layer.get(AUTO_LEGEND);
}
function getCachedCapabilities(layer) {
    return layer.get(CAPABILITIES);
}
function setCacheCapabilities(layer, capabilities) {
    layer.set(CAPABILITIES, capabilities);
}
function setBase(layer, base) {
    layer.set(BASE, base);
}
function getBase(layer) {
    return layer.get(BASE);
}
function setCluster(layer, clusterActive) {
    layer.set(CLUSTER, clusterActive);
}
function getCluster(layer) {
    return layer.get(CLUSTER);
}
function setCustomInfoTemplate(layer, customInfoTemplate) {
    layer.set(CUSTOM_INFO_TEMPLATE, customInfoTemplate);
}
function getCustomInfoTemplate(layer) {
    return layer.get(CUSTOM_INFO_TEMPLATE);
}
function setDefinition(layer, definition) {
    layer.set(DEFINITION, definition);
}
function getDefinition(layer) {
    return layer.get(DEFINITION);
}
/**
 * Set the dimensions defintion. TODO: Extend description
 * @param layer
 * @param dimensions
 * @example
 *  dimensions: \{
      time: \{ label: 'Local time', default: '2020-02-25T01:00' \},
      level: \{
        label: 'Level hPa',
        value: 'surface',
        values: ['surface', '950mb - 500m', '900mb - 1km'],
        availability: function(layer) \{
          return layer.get('title') != 'Temperature observations'
        \}
      \}
    \}
 */
function setDimensions(layer, dimensions) {
    layer.set(DIMENSIONS, dimensions);
}
function getDimensions(layer) {
    return layer.get(DIMENSIONS);
}
/**
 * If no dimensions are defined then creates a new dimension object,
 * if dimensions exist but the type is not present yet, it appends that dimension,
 * if dimensions exist and the type is present already, it replaces that dimension
 * @param layer - OL layer object
 * @param dimension - a dimension definition object
 * @param type - dimension type, e.g. 'time', 'height', etc.
 */
function setDimension(layer, dimension, type) {
    if (layer.get(DIMENSIONS)) {
        const dims = layer.get(DIMENSIONS);
        dims[type] = dimension;
        layer.set(DIMENSIONS, dims);
    }
    else {
        layer.set(DIMENSIONS, { [type]: dimension });
    }
}
/**
 * @param layer - OL layer object
 * @param type - dimension type, e.g. 'time', 'height', etc.
 * @returns Single dimension object definition
 */
function getDimension(layer, type) {
    return layer.get(DIMENSIONS) ? layer.get(DIMENSIONS)[type] : undefined;
}
function setEditor(layer, editor) {
    layer.set(EDITOR, editor);
}
function getEditor(layer) {
    return layer.get(EDITOR);
}
function setEnableProxy(layer, enableProxy) {
    layer.set(ENABLEPROXY, enableProxy);
}
function getEnableProxy(layer) {
    return layer.get(ENABLEPROXY);
}
function setEventsSuspended(layer, eventsSuspended) {
    layer.set(EVENTS_SUSPENDED, eventsSuspended);
}
function getEventsSuspended(layer) {
    return layer.get(EVENTS_SUSPENDED);
}
function setExclusive(layer, exclusive) {
    layer.set(EXCLUSIVE, exclusive);
}
function getExclusive(layer) {
    return layer.get(EXCLUSIVE);
}
function setFeatureInfoLang(layer, featureInfoLang) {
    layer.set(FEATURE_INFO_LANG, featureInfoLang);
}
function getFeatureInfoLang(layer) {
    return layer.get(FEATURE_INFO_LANG);
}
function setFromComposition(layer, fromComposition) {
    layer.set(FROM_COMPOSITION, fromComposition);
}
function getFromComposition(layer) {
    return layer.get(FROM_COMPOSITION);
}
function setFeatureInfoTarget(layer, featureInfoTarget) {
    layer.set(GET_FEATURE_INFO_TARGET, featureInfoTarget);
}
function getFeatureInfoTarget(layer) {
    return layer.get(GET_FEATURE_INFO_TARGET);
}
function getSld(layer) {
    return layer.get(HS_SLD);
}
function setSld(layer, sld) {
    layer.set(HS_SLD, sld);
}
function setHsLaymanSynchronizing(layer, hsLaymanSynchronizing) {
    layer.set(HS_LAYMAN_SYNCHRONIZING, hsLaymanSynchronizing);
}
function getHsLaymanSynchronizing(layer) {
    return layer.get(HS_LAYMAN_SYNCHRONIZING);
}
function setInfoFormat(layer, infoFormat) {
    layer.set(INFO_FORMAT, infoFormat);
}
function getInfoFormat(layer) {
    return layer.get(INFO_FORMAT);
}
function setInlineLegend(layer, inlineLegend) {
    layer.set(INLINE_LEGEND, inlineLegend);
}
function getInlineLegend(layer) {
    return layer.get(INLINE_LEGEND);
}
function setLaymanLayerDescriptor(layer, hsLaymanLayerDescriptor) {
    layer.set(LAYMAN_LAYER_DESCRIPTOR, hsLaymanLayerDescriptor);
}
function getLaymanLayerDescriptor(layer) {
    return layer.get(LAYMAN_LAYER_DESCRIPTOR);
}
function setLegends(layer, path) {
    layer.set(LEGENDS, path);
}
function getLegends(layer) {
    if (layer.get(LEGENDS) == undefined &&
        layer.get('legendImage') !== undefined) {
        console.warn('"legendImage" layer property is deprecated in favor of "legends"');
        return layer.get('legendImage');
    }
    return layer.get(LEGENDS);
}
function setMaxResolutionDenominator(layer, maxResolutionDenominator) {
    layer.set(MAX_RESOLUTION_DENOMINATOR, maxResolutionDenominator);
}
function getMaxResolutionDenominator(layer) {
    return layer.get(MAX_RESOLUTION_DENOMINATOR);
}
/**
 * Store metadata which were parsed from layer definition in composition json.
 * @param layer
 * @param metadata
 */
function setMetadata(layer, metadata) {
    layer.set(METADATA, metadata);
}
function getMetadata(layer) {
    return layer.get(METADATA);
}
function setMinimumTerrainLevel(layer, minimumTerrainLevel) {
    layer.set(MINIMUM_TERRAIN_LEVEL, minimumTerrainLevel);
}
function getMinimumTerrainLevel(layer) {
    return layer.get(MINIMUM_TERRAIN_LEVEL);
}
function setOnFeatureSelected(layer, onFeatureSelected) {
    layer.set(ON_FEATURE_SELECTED, onFeatureSelected);
}
function getOnFeatureSelected(layer) {
    return layer.get(ON_FEATURE_SELECTED);
}
function setPath(layer, path) {
    layer.set(PATH, path);
}
function getPath(layer) {
    return layer.get(PATH);
}
function setPopUp(layer, popUp) {
    layer.set(POPUP, popUp);
}
function getPopUp(layer) {
    return layer.get(POPUP);
}
function setPopupClass(layer, popupClass) {
    layer.set(POPUP_CLASS, popupClass);
}
function getPopupClass(layer) {
    return layer.get(POPUP_CLASS);
}
function setQueryable(layer, queryable) {
    layer.set(QUERYABLE, queryable);
}
function getQueryable(layer) {
    return layer.get(QUERYABLE);
}
function setQueryCapabilities(layer, queryCapabilities) {
    layer.set(QUERY_CAPABILITIES, queryCapabilities);
}
function getQueryCapabilities(layer) {
    return layer.get(QUERY_CAPABILITIES);
}
function setQueryFilter(layer, queryFilter) {
    layer.set(QUERY_FILTER, queryFilter);
}
function getQueryFilter(layer) {
    return layer.get(QUERY_FILTER);
}
function setRemovable(layer, removable) {
    layer.set(REMOVABLE, removable);
}
function getRemovable(layer) {
    return layer.get(REMOVABLE);
}
function setShowInLayerManager(layer, showInLayerManager) {
    layer.set(SHOW_IN_LAYER_MANAGER, showInLayerManager);
}
function getShowInLayerManager(layer) {
    return layer.get(SHOW_IN_LAYER_MANAGER);
}
/**
 * Set list of all possible sub-layers for WMS
 * @param layer
 * @param sublayers String of all possible WMS layers sub-layer names separated by comma
 */
function setSubLayers(layer, sublayers) {
    layer.set(SUB_LAYERS, sublayers);
}
/**
 * Get list of all possible sub-layers for WMS
 * @param layer
 */
function getSubLayers(layer) {
    return layer.get(SUB_LAYERS);
}
function setThumbnail(layer, thumbnail) {
    layer.set(THUMBNAIL, thumbnail);
}
function getThumbnail(layer) {
    return layer.get(THUMBNAIL);
}
function setVirtualAttributes(layer, virtualAttributes) {
    layer.set(VIRTUAL_ATTRIBUTES, virtualAttributes);
}
function getVirtualAttributes(layer) {
    return layer.get(VIRTUAL_ATTRIBUTES);
}
function getWorkspace(layer) {
    return layer.get(WORKSPACE);
}
function setWorkspace(layer, workspace) {
    layer.set(WORKSPACE, workspace);
}
function getWfsUrl(layer) {
    return layer.get(WFS_URL);
}
function setWfsUrl(layer, url) {
    layer.set(WFS_URL, url);
}
const HsLayerExt = {
    getAccessRights,
    setAccessRights,
    setTitle,
    getTitle,
    setName,
    getName,
    setAbstract,
    getAbstract,
    setActive,
    getActive,
    setAttribution,
    getAttribution,
    setCacheCapabilities,
    getCachedCapabilities,
    setBase,
    getBase,
    setCluster,
    getCluster,
    setCustomInfoTemplate,
    getCustomInfoTemplate,
    setDefinition,
    getDefinition,
    setDimensions,
    getDimensions,
    setEditor,
    getEditor,
    setEnableProxy,
    getEnableProxy,
    setEventsSuspended,
    getEventsSuspended,
    setExclusive,
    getExclusive,
    setFeatureInfoLang,
    getFeatureInfoLang,
    setFromComposition,
    getFromComposition,
    setFeatureInfoTarget,
    getFeatureInfoTarget,
    setHsLaymanSynchronizing,
    getHsLaymanSynchronizing,
    setInfoFormat,
    getInfoFormat,
    setInlineLegend,
    getInlineLegend,
    setLaymanLayerDescriptor,
    getLaymanLayerDescriptor,
    setMaxResolutionDenominator,
    getMaxResolutionDenominator,
    setMetadata,
    getMetadata,
    setMinimumTerrainLevel,
    getMinimumTerrainLevel,
    setOnFeatureSelected,
    getOnFeatureSelected,
    setPath,
    getPath,
    setPopUp,
    getPopUp,
    setPopupClass,
    getPopupClass,
    setQueryable,
    getQueryable,
    setQueryCapabilities,
    getQueryCapabilities,
    setQueryFilter,
    getQueryFilter,
    setRemovable,
    getRemovable,
    setShowInLayerManager,
    getShowInLayerManager,
    setThumbnail,
    getThumbnail,
    setVirtualAttributes,
    getVirtualAttributes,
    setWorkspace,
    getWorkspace,
    getWfsUrl,
    setWfsUrl,
};

/* eslint-disable no-eq-null */
var DuplicateHandling;
(function (DuplicateHandling) {
    DuplicateHandling[DuplicateHandling["AddDuplicate"] = 0] = "AddDuplicate";
    DuplicateHandling[DuplicateHandling["IgnoreNew"] = 1] = "IgnoreNew";
    DuplicateHandling[DuplicateHandling["RemoveOriginal"] = 2] = "RemoveOriginal";
})(DuplicateHandling || (DuplicateHandling = {}));
class HsMapService {
    constructor(HsConfig, HsLayoutService, HsUtilsService, HsEventBusService, HsLanguageService, rendererFactory) {
        this.HsConfig = HsConfig;
        this.HsLayoutService = HsLayoutService;
        this.HsUtilsService = HsUtilsService;
        this.HsEventBusService = HsEventBusService;
        this.HsLanguageService = HsLanguageService;
        //timer variable for extent change event
        this.timer = null;
        /**
         * @public
         * @type {number} 400
         * @description Duration of added interactions animation. (400 ms used, default in OpenLayers is 250 ms)
         */
        this.duration = 400;
        this.defaultMobileControls = defaults({
            zoom: false,
        });
        this.defaultDesktopControls = defaults({
            attributionOptions: {
                collapsible: true,
                collapsed: true,
            },
        });
        /**
         * @public
         * @type {object}
         * @description Set of default map controls used in HSLayers, may be loaded from config file
         */
        this.controls = this.defaultDesktopControls;
        /**
         * @public
         * @type {object}
         * @description Set of default map interactions used in HSLayers (
         *  {@link http://openlayers.org/en/latest/apidoc/ol.interaction.DoubleClickZoom.html DoubleClickZoom},
         *  {@link http://openlayers.org/en/latest/apidoc/ol.interaction.KeyboardPan.html KeyboardPan},
         *  {@link http://openlayers.org/en/latest/apidoc/ol.interaction.KeyboardZoom.html KeyboardZoom},
         *  {@link http://openlayers.org/en/latest/apidoc/ol.interaction.MouseWheelZoom.html MouseWheelZoom},
         *  {@link http://openlayers.org/en/latest/apidoc/ol.interaction.PinchRotate.html PinchRotate},
         *  {@link http://openlayers.org/en/latest/apidoc/ol.interaction.PinchZoom.html PinchZoom},
         *  {@link http://openlayers.org/en/latest/apidoc/ol.interaction.DragPan.html DragPan},
         *  {@link http://openlayers.org/en/latest/apidoc/ol.interaction.DragZoom.html DragZoom},
         *  {@link http://openlayers.org/en/latest/apidoc/ol.interaction.DragRotate.html DragRotate} )
         */
        this.interactions = {
            'DoubleClickZoom': new DoubleClickZoom({
                duration: this.duration,
            }),
            'KeyboardPan': new KeyboardPan({
                pixelDelta: 256,
            }),
            'KeyboardZoom': new KeyboardZoom({
                duration: this.duration,
            }),
            'MouseWheelZoom': new MouseWheelZoom({
                condition: (browserEvent) => {
                    var _a;
                    if (((_a = this.HsConfig.componentsEnabled) === null || _a === void 0 ? void 0 : _a.mapControls) == false) {
                        return false;
                    }
                    return this.HsConfig.zoomWithModifierKeyOnly
                        ? platformModifierKeyOnly(browserEvent)
                        : true;
                },
                duration: this.duration,
            }),
            'PinchRotate': new PinchRotate(),
            'PinchZoom': new PinchZoom({
                duration: this.duration,
            }),
            'DragPan': new DragPan({
                kinetic: new Kinetic(-0.01, 0.1, 200),
            }),
            'DragZoom': new DragZoom(),
            'DragRotate': new DragRotate(),
        };
        this.featureLayerMapping = {};
        this.setDefaultView = function (e) {
            const center = this.HsConfig.default_view.getCenter();
            this.map.getView().setCenter(center);
            const zoom = this.HsConfig.default_view.getZoom();
            this.map.getView().setZoom(zoom);
        };
        this.renderer = rendererFactory.createRenderer(null, null);
        this.defaultDesktopControls.removeAt(1);
        this.defaultDesktopControls.push(new ScaleLine());
        setTimeout(() => {
            var _a, _b;
            //make sure translations are loaded
            if (((_a = this.HsConfig.componentsEnabled) === null || _a === void 0 ? void 0 : _a.defaultViewButton) &&
                ((_b = this.HsConfig.componentsEnabled) === null || _b === void 0 ? void 0 : _b.guiOverlay) != false) {
                this.createDefaultViewButton();
            }
        }, 500);
    }
    /**
     * Returns the associated layer for feature.
     * This is used in query-vector.service to get the layer of clicked
     * feature when features are listed in info panel.
     *
     * @param feature
     * @returns {Vector} Layer.
     */
    getLayerForFeature(feature) {
        if (typeof feature.getId() == 'undefined') {
            feature.setId(this.HsUtilsService.generateUuid());
        }
        const fid = feature.getId();
        if (this.featureLayerMapping[fid]) {
            return this.featureLayerMapping[fid];
        }
        let layer_;
        const layersToLookFor = [];
        const check = (layer) => {
            const source = layer.getSource();
            if (this.HsUtilsService.instOf(source, Cluster)) {
                layersToLookFor.push({
                    layer,
                    source,
                });
                layersToLookFor.push({
                    layer,
                    source: source.getSource(),
                });
            }
            else if (this.HsUtilsService.instOf(source, Vector)) {
                layersToLookFor.push({
                    layer,
                    source,
                });
            }
        };
        this.map.getLayers().forEach((layer) => {
            if (this.HsUtilsService.instOf(layer, Group)) {
                layer.getLayers().forEach(check);
            }
            else {
                check(layer);
            }
        });
        for (const obj of layersToLookFor) {
            let found = false;
            if (obj.source.getFeatureById) {
                //For ordinary vector layers we can search by Id
                found = obj.source.getFeatureById(fid);
            }
            else {
                //For cluster layers we need to loop through features
                found = obj.source.getFeatures().some((layer_feature) => {
                    return layer_feature === feature;
                });
            }
            if (found) {
                layer_ = obj.layer;
                break;
            }
        }
        if (layer_ && !this.featureLayerMapping[fid]) {
            //TODO: Will have to delete the mapping at some point when layer is cleared or feature removed
            this.featureLayerMapping[fid] = layer_;
        }
        return layer_;
    }
    createDefaultViewButton() {
        const button = this.renderer.createElement('button');
        button.addEventListener('click', (e) => {
            this.setDefaultView(e);
        }, false);
        const icon = this.renderer.createElement('i');
        this.renderer.addClass(icon, 'glyphicon');
        this.renderer.addClass(icon, 'icon-globe');
        this.element = this.renderer.createElement('div');
        this.renderer.addClass(this.element, 'hs-defaultView');
        this.renderer.addClass(this.element, 'ol-unselectable');
        this.renderer.addClass(this.element, 'ol-control');
        this.renderer.setAttribute(this.element, 'title', this.HsLanguageService.getTranslation('MAP.zoomToInitialWindow'));
        this.renderer.appendChild(button, icon);
        this.renderer.appendChild(this.element, button);
        const defaultViewControl = new Control({
            element: this.element,
        });
        this.defaultDesktopControls.push(defaultViewControl);
    }
    /**
     * @param e
     */
    extentChanged(e) {
        if (this.timer !== null) {
            clearTimeout(this.timer);
        }
        this.timer = setTimeout(() => {
            this.HsEventBusService.mapExtentChanges.next({
                element: e.element,
                extent: this.map.getView().calculateExtent(this.map.getSize()),
            });
        }, 500);
    }
    /**
     * @public
     * @description Initialization function for HSLayers map object. Initialize map with basic interaction, scale line and watcher for map view changes. When default controller is used, its called automaticaly, otherwise its must be called before other modules dependent on map object are loaded.
     */
    init() {
        var _a;
        if (this.map) {
            this.map.setTarget(this.mapElement);
        }
        else {
            this.map = new Map({
                controls: this.controls,
                target: this.mapElement,
                interactions: [],
                view: this.cloneView(this.HsConfig.default_view || this.createPlaceholderView()),
            });
            this.map.getView().on('change:center', (e) => {
                this.extentChanged(e);
            });
            this.map.getView().on('change:resolution', (e) => {
                this.extentChanged(e);
            });
            this.map.on('moveend', (e) => {
                this.extentChanged(e);
            });
        }
        if (this.HsConfig.mapInteractionsEnabled != false) {
            for (const value of Object.values(this.interactions).filter((value) => !this.map.getInteractions().getArray().includes(value))) {
                this.map.addInteraction(value);
            }
        }
        //this.map.addControl(new ol.control.ZoomSlider());
        // this.map.addControl(new ol.control.ScaleLine());
        // If the MouseWheelInteraction is set to behave only with CTRL pressed,
        // then also notify the user when he tries to zoom,
        // but the CTRL is not pressed
        if (this.HsConfig.zoomWithModifierKeyOnly &&
            this.HsConfig.mapInteractionsEnabled != false) {
            this.map.on('wheel', (e) => {
                //ctrlKey works for Win and Linux, metaKey for Mac
                if (!(e.originalEvent.ctrlKey || e.originalEvent.metaKey) &&
                    !this.HsLayoutService.contentWrapper.querySelector('.hs-zoom-info-dialog')) {
                    //TODO: change the name of platform modifier key dynamically based on OS
                    const platformModifierKey = 'CTRL/META';
                    //Following styles would be better written as ng-styles...
                    const html = this.renderer.createElement('div');
                    this.renderer.setAttribute(html, 'class', 'alert alert-info mt-1 hs-zoom-info-dialog');
                    this.renderer.setAttribute(html, 'style', `position: absolute; right:15px; top:0.6em;z-index:101`);
                    const text = this.renderer.createText(`${this.HsLanguageService.getTranslation('MAP.zoomKeyModifier', {
                        platformModifierKey: platformModifierKey,
                    })}`);
                    this.renderer.appendChild(html, text);
                    this.renderer.appendChild(this.HsLayoutService.contentWrapper.querySelector('.hs-map-space'), html);
                    setTimeout(() => {
                        this.HsLayoutService.contentWrapper
                            .querySelector('.hs-zoom-info-dialog')
                            .remove();
                    }, 4000);
                }
            });
        }
        this.repopulateLayers(this.visibleLayersInUrl);
        proj4.defs('EPSG:5514', '+proj=krovak +lat_0=49.5 +lon_0=24.83333333333333 +alpha=30.28813972222222 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +towgs84=542.5,89.2,456.9,5.517,2.275,5.516,6.96 +units=m +no_defs');
        proj4.defs('EPSG:4258', '+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs');
        proj4.defs('EPSG:4326', '+proj=longlat +datum=WGS84 +no_defs');
        register(proj4);
        if (((_a = this.HsConfig.componentsEnabled) === null || _a === void 0 ? void 0 : _a.mapControls) == false) {
            this.removeAllControls();
        }
        this.HsEventBusService.olMapLoads.next(this.map);
    }
    loaded() {
        return new Promise((resolve, reject) => {
            if (this.map) {
                resolve(this.map);
                return;
            }
            else {
                this.HsEventBusService.olMapLoads.subscribe((map) => {
                    if (map) {
                        resolve(map);
                    }
                });
            }
        });
    }
    //clone View to not overwrite default
    /**
     * @param template
     */
    cloneView(template) {
        const view = new View(template.options_);
        return view;
    }
    /**
     * @public
     * @param {string} title Title of the layer (from layer creation)
     * @returns {Ol.layer} Ol.layer object
     * @description Find layer object by title of layer
     */
    findLayerByTitle(title) {
        const layers = this.getLayersArray();
        let tmp = null;
        for (const layer of layers) {
            if (getTitle(layer) == title) {
                tmp = layer;
            }
        }
        return tmp;
    }
    /**
     * @param {ol/Layer} existingLayers Layer 1. Usually the one which is already added to map
     * @param {ol/Layer} newLayer Layer 2. Usually the one which will be added to map
     * @returns {boolean} True if layers are equal
     */
    layersEqual(existingLayers, newLayer) {
        if (newLayer === 'undefined') {
            console.warn('Checking duplicity for undefined layer. Why are we doing this?');
            return true;
        }
        if (existingLayers.getSource === 'undefined') {
            return false;
        }
        if (newLayer.getSource === 'undefined') {
            return false;
        }
        const existingSource = existingLayers.getSource();
        const newSource = newLayer.getSource();
        const existingTitle = getTitle(existingLayers);
        const newTitle = getTitle(newLayer);
        const existingSourceType = typeof existingSource;
        const newSourceType = typeof newSource;
        const existingLAYERS = existingSource.getParams == null ? '' : existingSource.getParams().LAYERS;
        const newLAYERS = newSource.getParams == null ? '' : newSource.getParams().LAYERS;
        const existingUrl = existingSource.getUrl == null ? '' : existingSource.getUrl();
        const newUrl = newSource.getUrl == null ? '' : newSource.getUrl();
        const existingUrls = existingSource.getUrls == null ? '' : existingSource.getUrls();
        let newUrls = newSource.getUrls == null ? [''] : newSource.getUrls();
        newUrls = newUrls ? newUrls : [''];
        const urlsEqual = existingUrls == newUrls ||
            (newUrls.length > 0 && existingUrls.indexOf(newUrls[0]) > -1);
        return (existingTitle == newTitle &&
            existingSourceType == newSourceType &&
            existingLAYERS == newLAYERS &&
            existingUrl == newUrl &&
            urlsEqual);
    }
    /**
     * @description Checks if a layer with the same title already exists in the map
     * @param {ol/Layer} lyr A layer to check
     * @returns {boolean} True if layer is already present in the map, false otherwise
     */
    layerAlreadyExists(lyr) {
        const duplicateLayers = this.map
            .getLayers()
            .getArray()
            .filter((existing) => {
            const equal = this.layersEqual(existing, lyr);
            return equal;
        });
        return duplicateLayers.length > 0;
    }
    removeDuplicate(lyr) {
        this.map
            .getLayers()
            .getArray()
            .filter((existing) => {
            const equal = this.layersEqual(existing, lyr);
            return equal;
        })
            .forEach((to_remove) => {
            this.map.getLayers().remove(to_remove);
        });
    }
    getLayersArray() {
        return this.map.getLayers().getArray();
    }
    /**
     * @param lyr {Layer} Layer which to proxify if needed
     * @description Proxify layer based on its source object type and if its tiled or not.
     * Each underlying OL source class has its own way to override imagery loading.
     */
    proxifyLayer(lyr) {
        const source = lyr.getSource();
        if ([ImageWMS, ImageArcGISRest].some((typ) => this.HsUtilsService.instOf(source, typ))) {
            this.proxifyLayerLoader(lyr, false);
        }
        if (this.HsUtilsService.instOf(source, WMTS)) {
            source.setTileLoadFunction((i, s) => this.simpleImageryProxy(i, s));
        }
        if ([TileWMS, TileArcGISRest].some((typ) => this.HsUtilsService.instOf(source, typ))) {
            this.proxifyLayerLoader(lyr, true);
        }
        if (this.HsUtilsService.instOf(source, XYZ) &&
            !this.HsUtilsService.instOf(source, OSM) &&
            source
                .getUrls()
                .filter((url) => url.indexOf('openstreetmap') > -1).length == 0) {
            this.proxifyLayerLoader(lyr, true);
        }
        if (this.HsUtilsService.instOf(source, ImageStatic)) {
            //NOTE: Using url_ is not nice, but don't see other way, because no setUrl or set('url'.. exists yet
            source.url_ = this.HsUtilsService.proxify(source.getUrl());
        }
    }
    /**
     * Function to add layer to map which also checks if
     * the layer is not already present and also proxifies the layer if needed.
     * Generally for non vector layers it would be better to use this function than to add to OL map directly
     * and rely on layer manager service to do the proxification and also it's shorter than to use HsMapService.map.addLayer.
     *
     * @param lyr Layer to add
     * @param duplicateHandling How to handle duplicate layers (same class and title)
     * @param visibleOverride Override the visibility using an array layer titles, which
     */
    addLayer(lyr, duplicateHandling, visibleOverride) {
        if (this.layerAlreadyExists(lyr)) {
            switch (duplicateHandling) {
                case DuplicateHandling.RemoveOriginal:
                    if (getBase(lyr) == true) {
                        return;
                    }
                    this.removeDuplicate(lyr);
                    break;
                case DuplicateHandling.IgnoreNew:
                    return;
                case DuplicateHandling.AddDuplicate:
                default:
            }
        }
        if (visibleOverride) {
            lyr.setVisible(this.layerTitleInArray(lyr, visibleOverride));
        }
        const source = lyr.getSource();
        if (this.HsUtilsService.instOf(source, Vector)) {
            this.getVectorType(lyr);
        }
        this.proxifyLayer(lyr);
        lyr.on('change:source', (e) => {
            this.proxifyLayer(e.target);
        });
        this.map.addLayer(lyr);
    }
    /**
     * @public
     * @param {Array} visibilityOverrides Override the visibility using an array layer titles, which
     * should be visible. Usefull when the layer visibility is stored in a URL parameter
     * @description Add all layers from app config (box_layers and default_layers) to the map.
     * Only layers specified in visibilityOverrides parameter will get instantly visible.
     */
    repopulateLayers(visibilityOverrides) {
        if (this.HsConfig.box_layers) {
            this.HsConfig.box_layers.forEach((box) => {
                for (const lyr of box.getLayers().getArray()) {
                    this.addLayer(lyr, DuplicateHandling.IgnoreNew, visibilityOverrides);
                }
            });
        }
        if (this.HsConfig.default_layers) {
            this.HsConfig.default_layers
                .filter((lyr) => lyr)
                .forEach((lyr) => {
                this.addLayer(lyr, DuplicateHandling.IgnoreNew, visibilityOverrides);
            });
        }
    }
    getCurrentProj() {
        return this.map.getView().getProjection();
    }
    getVectorType(layer) {
        let src;
        if (layer.getSource().getSource) {
            src = layer.getSource().getSource();
        }
        else {
            src = layer.getSource();
        }
        src.hasLine = false;
        src.hasPoly = false;
        src.hasPoint = false;
        if (src.getFeatures().length > 0) {
            this.vectorSourceTypeComputer(src);
        }
        else {
            src.on('change', (evt) => {
                const source = evt.target;
                if (source.getState() === 'ready') {
                    this.vectorSourceTypeComputer(source);
                }
            });
        }
    }
    /**
     * @param src
     */
    vectorSourceTypeComputer(src) {
        src.getFeatures().forEach((f) => {
            if (f.getGeometry()) {
                switch (f.getGeometry().getType()) {
                    case 'LineString':
                    case 'MultiLineString':
                        src.hasLine = true;
                        break;
                    case 'Polygon':
                    case 'MultiPolygon':
                        src.hasPoly = true;
                        break;
                    case 'Point':
                    case 'MultiPoint':
                        src.hasPoint = true;
                        break;
                    default:
                }
            }
        });
        if (src.hasLine || src.hasPoly || src.hasPoint) {
            src.styleAble = true;
        }
    }
    /**
     * @public
     * @description Reset map to state configured in app config (reload all layers and set default view)
     */
    reset() {
        this.removeAllLayers();
        this.repopulateLayers(null);
        this.resetView();
    }
    /**
     * @public
     * @description Reset map view to view configured in app config
     */
    resetView() {
        this.map.setView(this.cloneView(this.HsConfig.default_view || this.createPlaceholderView()));
    }
    /**
     *
     */
    createPlaceholderView() {
        return new View({
            center: transform([17.474129, 52.574], 'EPSG:4326', 'EPSG:3857'),
            zoom: 4,
        });
    }
    /**
     * @public
     * @param {ol.Layer} lyr Layer for which to determine visibility
     * @param {Array} array Layer title to check in.
     * @returns {boolean} Detected visibility of layer
     * @description Checks if layer title is present in an array of layer titles.
     * Used to set visibility by URL parameter which contains visible layer titles
     */
    layerTitleInArray(lyr, array) {
        if (array) {
            return array.filter((title) => title == getTitle(lyr)).length > 0;
        }
        return lyr.getVisible();
    }
    getCanvases() {
        return this.mapElement.querySelectorAll('.ol-layer canvas');
    }
    /**
     * @public
     * @param {Ol.layer} lyr Layer to proxify
     * @param {boolean} tiled Info if layer is tiled
     * @description Proxify layer loader to work with layers from other sources than app
     */
    proxifyLayerLoader(lyr, tiled) {
        const src = lyr.getSource();
        if (getEnableProxy(lyr) && getEnableProxy(lyr) == false) {
            return;
        }
        if (tiled) {
            const tile_url_function = src.getTileUrlFunction() || src.tileUrlFunction();
            src.setTileUrlFunction((b, c, d) => {
                let url = tile_url_function.call(src, b, c, d);
                if (getDimensions(lyr)) {
                    const dimensions = getDimensions(lyr);
                    Object.keys(dimensions).forEach((dimension) => {
                        url = url.replace(`{${dimension}}`, dimensions[dimension].value);
                    });
                }
                if (url.indexOf(this.HsConfig.proxyPrefix) == 0) {
                    return url;
                }
                else {
                    return this.HsUtilsService.proxify(url);
                }
            });
            src.setTileLoadFunction((tile, src) => {
                var _a;
                const laymanEp = (_a = this.HsConfig.datasources) === null || _a === void 0 ? void 0 : _a.find((ep) => ep.type == 'layman');
                if (laymanEp && src.startsWith(laymanEp.url)) {
                    this.laymanWmsLoadingFunction(tile, src);
                }
                else {
                    tile.getImage().src = src;
                }
            });
        }
        else {
            src.setImageLoadFunction((i, s) => this.simpleImageryProxy(i, s));
        }
    }
    simpleImageryProxy(image, src) {
        var _a;
        if (src.indexOf(this.HsConfig.proxyPrefix) == 0) {
            image.getImage().src = src;
        }
        else {
            const laymanEp = (_a = this.HsConfig.datasources) === null || _a === void 0 ? void 0 : _a.find((ep) => ep.type == 'layman');
            if (laymanEp && src.startsWith(laymanEp.url)) {
                this.laymanWmsLoadingFunction(image, src);
            }
            else {
                image.getImage().src = this.HsUtilsService.proxify(src); //Previously urlDecodeComponent was called on src, but it breaks in firefox.
            }
        }
    }
    laymanWmsLoadingFunction(image, src) {
        const xhr = new XMLHttpRequest();
        xhr.withCredentials = true;
        xhr.responseType = 'arraybuffer';
        xhr.open('GET', src);
        xhr.addEventListener('loadend', function (evt) {
            const arrayBufferView = new Uint8Array(this.response);
            const blob = new Blob([arrayBufferView], { type: 'image/png' });
            const urlCreator = window.URL || window.webkitURL;
            const imageUrl = urlCreator.createObjectURL(blob);
            image.getImage().src = imageUrl;
        });
        xhr.send();
    }
    /**
     * @public
     * @param {number} x X coordinate of new center
     * @param {number} y Y coordinate of new center
     * @param {number} zoom New zoom level
     * @description Move map and zoom to specified coordinate/zoom level
     */
    moveToAndZoom(x, y, zoom) {
        const view = this.map.getView();
        view.setCenter([x, y]);
        view.setZoom(zoom);
    }
    getMapExtent() {
        const mapSize = this.map.getSize();
        const mapExtent = mapSize
            ? this.map.getView().calculateExtent(mapSize)
            : [0, 0, 100, 100];
        return mapExtent;
    }
    getMapExtentInEpsg4326() {
        const bbox = transformExtent(this.getMapExtent(), this.getCurrentProj(), 'EPSG:4326');
        return bbox;
    }
    fitExtent(extent) {
        this.map.getView().fit(extent, { size: this.map.getSize() });
    }
    /**
     * @public
     * @description Get ol.Map object from service
     * @returns {ol.Map} ol.Map
     */
    getMap() {
        return this.map;
    }
    removeAllLayers() {
        const to_be_removed = [];
        this.map.getLayers().forEach((lyr) => {
            to_be_removed.push(lyr);
        });
        while (to_be_removed.length > 0) {
            this.map.removeLayer(to_be_removed.shift());
        }
    }
    removeAllControls() {
        [...this.map.getControls().getArray()].forEach((control) => {
            this.map.removeControl(control);
        });
        this.HsConfig.componentsEnabled.mapControls = false;
    }
    removeAllInteractions() {
        this.map.getInteractions().forEach((interaction) => {
            this.map.removeInteraction(interaction);
        });
        this.HsConfig.mapInteractionsEnabled = false;
    }
}
HsMapService.ɵfac = function HsMapService_Factory(t) { return new (t || HsMapService)(ɵngcc0.ɵɵinject(HsConfig), ɵngcc0.ɵɵinject(HsLayoutService), ɵngcc0.ɵɵinject(HsUtilsService), ɵngcc0.ɵɵinject(HsEventBusService), ɵngcc0.ɵɵinject(HsLanguageService), ɵngcc0.ɵɵinject(ɵngcc0.RendererFactory2)); };
HsMapService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HsMapService_Factory() { return new HsMapService(i0.ɵɵinject(HsConfig), i0.ɵɵinject(HsLayoutService), i0.ɵɵinject(HsUtilsService), i0.ɵɵinject(HsEventBusService), i0.ɵɵinject(HsLanguageService), i0.ɵɵinject(i0.RendererFactory2)); }, token: HsMapService, providedIn: "root" });
HsMapService.ctorParameters = () => [
    { type: HsConfig },
    { type: HsLayoutService },
    { type: HsUtilsService },
    { type: HsEventBusService },
    { type: HsLanguageService },
    { type: RendererFactory2 }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsMapService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: HsConfig }, { type: HsLayoutService }, { type: HsUtilsService }, { type: HsEventBusService }, { type: HsLanguageService }, { type: ɵngcc0.RendererFactory2 }]; }, null); })();

class HsAddDataService {
    constructor(hsMapService, hsUtilsService, hsConfig) {
        this.hsMapService = hsMapService;
        this.hsUtilsService = hsUtilsService;
        this.hsConfig = hsConfig;
        this.datasetSelected = new Subject();
        /**
         * Cancels any external url data request from datasources panel
         */
        this.cancelUrlRequest = new Subject();
    }
    addLayer(layer, underLayer) {
        if (underLayer) {
            const layers = this.hsMapService.getLayersArray();
            const underZ = underLayer.getZIndex();
            layer.setZIndex(underZ);
            for (const iLayer of layers.filter((l) => !getBase(l))) {
                if (iLayer.getZIndex() >= underZ) {
                    iLayer.setZIndex(iLayer.getZIndex() + 1);
                }
            }
            const ix = layers.indexOf(underLayer);
            this.hsMapService.map.getLayers().insertAt(ix, layer);
        }
        else {
            this.hsMapService.map.addLayer(layer);
        }
    }
    selectType(type) {
        this.typeSelected = type;
        this.datasetSelected.next({ type: type });
    }
}
HsAddDataService.ɵfac = function HsAddDataService_Factory(t) { return new (t || HsAddDataService)(ɵngcc0.ɵɵinject(HsMapService), ɵngcc0.ɵɵinject(HsUtilsService), ɵngcc0.ɵɵinject(HsConfig)); };
HsAddDataService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HsAddDataService_Factory() { return new HsAddDataService(i0.ɵɵinject(HsMapService), i0.ɵɵinject(HsUtilsService), i0.ɵɵinject(HsConfig)); }, token: HsAddDataService, providedIn: "root" });
HsAddDataService.ctorParameters = () => [
    { type: HsMapService },
    { type: HsUtilsService },
    { type: HsConfig }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsAddDataService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: HsMapService }, { type: HsUtilsService }, { type: HsConfig }]; }, null); })();

class HsPanelBaseComponent {
    constructor(hsLayoutService) {
        this.hsLayoutService = hsLayoutService;
    }
    isVisible() {
        return this.hsLayoutService.panelVisible(this.name);
    }
}
HsPanelBaseComponent.ɵfac = function HsPanelBaseComponent_Factory(t) { return new (t || HsPanelBaseComponent)(ɵngcc0.ɵɵdirectiveInject(HsLayoutService)); };
HsPanelBaseComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsPanelBaseComponent, selectors: [["ng-component"]], decls: 1, vars: 0, template: function HsPanelBaseComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "div");
    } }, encapsulation: 2 });
HsPanelBaseComponent.ctorParameters = () => [
    { type: HsLayoutService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsPanelBaseComponent, [{
        type: Component,
        args: [{
                template: '<div></div>'
            }]
    }], function () { return [{ type: HsLayoutService }]; }, null); })();

/**
 * List of GET parameters set and red by Hslayers
 */
const HS_PRMS = {
    x: 'hs-x',
    y: 'hs-y',
    zoom: 'hs-z',
    visibleLayers: 'hs-visible-layers',
    panel: 'hs-panel',
    lang: 'hs-lang',
    pureMap: 'hs-puremap',
    view: 'hs-view',
    permalink: 'hs-permalink',
    composition: 'hs-composition',
    search: 'hs-search',
    layerSelected: 'hs-layer-selected',
    hsWmsToConnect: 'hs-wms-to-connect',
    hsWfsToConnect: 'hs-wfs-to-connect',
    hsWmtsToConnect: 'hs-wmts-to-connect',
    hsKmlToConnect: 'hs-kml-to-connect',
    hsGeojsonToConnect: 'hs-geojson-to-connect',
    hsArcgisToConnect: 'hs-arcgis-to-connect',
    hsWmsLayers: 'hs-wms-layers',
    hsWfsLayers: 'hs-wfs-layers',
    hsWmtsLayers: 'hs-wmts-layers',
    hsKmlLayers: 'hs-kml-layers',
    hsGeojsonLayers: 'hs-geojson-layers',
    hsArcgisLayers: 'hs-arcgis-layers',
};
/**
 * If we cant find GET param from HS_PRMS, search in old parameters list before renaming.
 * NOTE: It's important that values in HS_PRMS_BACKWARDS don't exist in
 * HS_PRMS values otherwise recursion will occur.
 */
const HS_PRMS_BACKWARDS = {
    permalink: 'permalink',
    view: 'view',
    panel: 'hs_panel',
    lang: 'lang',
    x: 'hs_x',
    y: 'hs_y',
    zoom: 'hs_z',
    pureMap: 'puremap',
    visibleLayers: 'visible_layers',
    composition: 'composition',
    search: 'search',
    layerSelected: 'layerSelected',
    hsWmsToConnect: 'wms_to_connect',
    hsWfsToConnect: 'wfs_to_connect',
    hsWmtsToConnect: 'wmts_to_connect',
    hsWmsLayers: 'wms_layers',
    hsWfsLayers: 'wfs_layers',
    hsWmtsLayers: 'wmts_layers',
};
/**
 * Some params are set on map interaction or UI and we don't
 * want to reset their values with the original ones when generating the browser URL.
 * GET params not in HS_PRMS_REGENERATED will be remembered and set in the URL.
 */
const HS_PRMS_REGENERATED = [
    HS_PRMS.x,
    HS_PRMS.y,
    HS_PRMS.zoom,
    HS_PRMS.lang,
    HS_PRMS.panel,
    HS_PRMS.visibleLayers,
    HS_PRMS_BACKWARDS.x,
    HS_PRMS_BACKWARDS.y,
    HS_PRMS_BACKWARDS.zoom,
    HS_PRMS_BACKWARDS.lang,
    HS_PRMS_BACKWARDS.panel,
    HS_PRMS_BACKWARDS.visibleLayers,
];

class HsCoreService {
    constructor(HsMapService, HsConfig, HsLayoutService, HsUtilsService, log, HsEventBusService, translate) {
        this.HsMapService = HsMapService;
        this.HsConfig = HsConfig;
        this.HsLayoutService = HsLayoutService;
        this.HsUtilsService = HsUtilsService;
        this.log = log;
        this.HsEventBusService = HsEventBusService;
        this.translate = translate;
        /**
         * @public
         */
        this.embeddedEnabled = true;
        this.language = 'en';
        this._puremapApp = false;
        /**
         * Service shortcut to config module defined by app.component.ts for application
         * @public
         * @type {object}
         */
        this.config = HsConfig;
        if (window.innerWidth < 767 || this.HsConfig.sidebarClosed) {
            this.HsLayoutService.sidebarExpanded = false;
            this.HsLayoutService.sidebarLabels = false;
        }
        else {
            this.HsLayoutService.sidebarExpanded = true;
        }
        const languages = this.HsConfig.enabledLanguages
            ? this.HsConfig.enabledLanguages.split(',').map((lang) => lang.trim())
            : ['cs', 'lv'];
        this.translate.addLangs(languages);
        this.translate.setDefaultLang('en');
        if (this.HsConfig.language) {
            this.translate.use(this.HsConfig.language);
        }
        this.HsEventBusService.layoutLoads.subscribe(({ element, innerElement }) => {
            this.init();
        });
    }
    /**
     * Initialization function for HSLayers elements and their sizes.
     * Stores element and container references and sets event listeners for map resizing.
     * @public
     */
    init() {
        if (this.initCalled) {
            return;
        }
        this.HsMapService.loaded().then(() => {
            this.initSizeListeners();
            setTimeout(() => {
                this.updateVH();
                this.updateMapSize();
            }, 750);
            this.initCalled = true;
        });
    }
    /**
     * Define and change size of CSS custom variable --vh used as reference for hs.app-height
     * @private
     */
    updateVH() {
        if (this.HsUtilsService.runningInBrowser()) {
            const vh = window.innerHeight * 0.01;
            document.body.style.setProperty('--vh', `${vh}px`);
            if (window.matchMedia('(orientation: portrait)').matches) {
                document.getElementsByTagName('html')[0].style.height = '100vh';
                setTimeout(() => {
                    document.getElementsByTagName('html')[0].style.height = '100%';
                }, 500);
            }
        }
    }
    /**
     * Add event listeners for updating HS element and map size after browser resizing or complete load of application.
     * @public
     */
    initSizeListeners() {
        window.addEventListener('resize', () => {
            this.HsUtilsService.debounce(function () {
                this.updateVH();
                this.updateMapSize();
                this.HsEventBusService.layoutResizes.next();
            }, 300, false, this)();
        });
    }
    /**
     * Update map size.
     * @public
     */
    updateMapSize() {
        const map = this.HsLayoutService.contentWrapper.querySelector('.hs-ol-map');
        if (map === null) {
            return;
        }
        if (this.HsMapService.map) {
            this.HsMapService.map.updateSize();
            if (window.innerWidth < 767 || this.HsLayoutService.mainpanel != '') {
                this.HsLayoutService.smallWidth = true; //deprecated
                this.HsLayoutService.sidebarLabels = false;
            }
            else {
                this.HsLayoutService.smallWidth = false; //deprecated
                this.HsLayoutService.sidebarLabels = true;
            }
        }
        else {
            console.log('Map not yet initialized!');
        }
        const neededSize = {
            width: map.offsetWidth,
            height: map.offsetHeight,
        };
        this.HsEventBusService.sizeChanges.next(neededSize);
    }
    /**
     * Do authorization check of User, currently authorization is possible only in connection with Liferay app
     * @public
     * @returns Check result - true for authorized user
     */
    isAuthorized() {
        if (window['getLRUser'] === undefined && !this.missingLRFunctionsWarned) {
            this.log.warn('window.getLRUser function needs to be defined, which usually comes from Liferay.');
            this.missingLRFunctionsWarned = true;
        }
        if (window['getLRUser'] && window['getLRUser']() != 'guest') {
            return true;
        }
        return false;
    }
    /**
     * Do complete reset of map (view, layers) according to app config
     * @public
     */
    resetMap() {
        this.HsMapService.reset();
        this.HsEventBusService.mapResets.next();
    }
    /**
     * Tests if screen of used device is mobile type (current breakdown is screen width 800px)
     * @public
     * @returns "mobile" or ""
     */
    isMobile() {
        if (window['cordova']) {
            return 'mobile';
        }
        else {
            return '';
        }
    }
    /**
     * Whether app is running in puremapApp mode
     * @public
     */
    get puremapApp() {
        return this._puremapApp;
    }
    set puremapApp(value) {
        this._puremapApp = value;
        if (value) {
            this.HsConfig.componentsEnabled.guiOverlay = false;
            this.HsMapService.removeAllInteractions();
            this.HsMapService.removeAllControls();
            this.HsLayoutService.sidebarVisible(false);
        }
    }
}
HsCoreService.ɵfac = function HsCoreService_Factory(t) { return new (t || HsCoreService)(ɵngcc0.ɵɵinject(HsMapService), ɵngcc0.ɵɵinject(HsConfig), ɵngcc0.ɵɵinject(HsLayoutService), ɵngcc0.ɵɵinject(HsUtilsService), ɵngcc0.ɵɵinject(HsLogService), ɵngcc0.ɵɵinject(HsEventBusService), ɵngcc0.ɵɵinject(ɵngcc1.TranslateService)); };
HsCoreService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HsCoreService_Factory() { return new HsCoreService(i0.ɵɵinject(HsMapService), i0.ɵɵinject(HsConfig), i0.ɵɵinject(HsLayoutService), i0.ɵɵinject(HsUtilsService), i0.ɵɵinject(HsLogService), i0.ɵɵinject(HsEventBusService), i0.ɵɵinject(i1.TranslateService)); }, token: HsCoreService, providedIn: "root" });
HsCoreService.ctorParameters = () => [
    { type: HsMapService },
    { type: HsConfig },
    { type: HsLayoutService },
    { type: HsUtilsService },
    { type: HsLogService },
    { type: HsEventBusService },
    { type: TranslateService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsCoreService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: HsMapService }, { type: HsConfig }, { type: HsLayoutService }, { type: HsUtilsService }, { type: HsLogService }, { type: HsEventBusService }, { type: ɵngcc1.TranslateService }]; }, null); })();

class HsLayerUtilsService {
    constructor(HsUtilsService, HsLanguageService) {
        this.HsUtilsService = HsUtilsService;
        this.HsLanguageService = HsLanguageService;
    }
    /**
     * Determines if layer has properties needed for 'Zoom to layer' function.
     * @param layer - Selected layer
     * @returns True for layer with BoundingBox property, for
     * WMS layer or for layer, which has source with extent
     */
    layerIsZoomable(layer) {
        if (typeof layer == 'undefined') {
            return false;
        }
        if (layer.getExtent()) {
            return true;
        }
        if (this.isLayerWMS(layer)) {
            return true;
        }
        const src = layer.getSource();
        if (src.getExtent && src.getExtent() && !isEmpty(src.getExtent())) {
            return true;
        }
        return false;
    }
    /**
     * Determines if layer has underlying layers.
     * @param layer - Selected layer
     * @returns True for layer with sub layers, for layer type
     * WMS layer
     */
    hasNestedLayers(layer) {
        if (layer === undefined) {
            return false;
        }
        return layer.Layer !== undefined;
    }
    /**
     * Determines if layer is a Vector layer and therefore styleable
     * @param layer - Selected layer
     * @returns True for ol.layer.Vector
     */
    layerIsStyleable(layer) {
        if (typeof layer == 'undefined') {
            return false;
        }
        if (this.HsUtilsService.instOf(layer, Vector$1) /*&& layer.getSource().styleAble*/) {
            return true;
        }
        return false;
    }
    /**
     * Test if layer is queryable (WMS layer with Info format)
     * @param layer - Selected layer
     * @returns True for ol.layer.Tile and ol.layer.Image with
     * INFO_FORMAT in params
     */
    isLayerQueryable(layer) {
        return this.isLayerWMS(layer) && !!this.getLayerParams(layer).INFO_FORMAT;
    }
    /**
     * Get title of selected layer
     * @param layer - to get layer title
     * @returns Layer title or "Void"
     */
    getLayerTitle(layer) {
        if (getTitle(layer) !== undefined && getTitle(layer) != '') {
            return getTitle(layer).replace(/&#47;/g, '/');
        }
        else {
            return 'Void';
        }
    }
    // todo
    getURL(layer) {
        const src = layer.getSource();
        if (this.HsUtilsService.instOf(src, ImageWMS)) {
            return src.getUrl();
        }
        if (this.HsUtilsService.instOf(src, TileWMS)) {
            return src.getUrls()[0];
        }
        if (this.HsUtilsService.instOf(src, WMTS)) {
            return src.getUrls()[0];
        }
        if (this.HsUtilsService.instOf(src, XYZ)) {
            return src.getUrls()[0];
        }
    }
    /**
     * Test if layer is WMS layer
     * @param layer - Selected layer
     * @returns True for ol.layer.Tile and ol.layer.Image
     */
    isLayerWMS(layer) {
        if (this.HsUtilsService.instOf(layer, TileLayer) &&
            this.HsUtilsService.instOf(layer.getSource(), TileWMS)) {
            return true;
        }
        if (this.HsUtilsService.instOf(layer, Image$1) &&
            this.HsUtilsService.instOf(layer.getSource(), ImageWMS)) {
            return true;
        }
        return false;
    }
    // todo
    isLayerWMTS(layer) {
        if (this.HsUtilsService.instOf(layer, TileLayer) &&
            this.HsUtilsService.instOf(layer.getSource(), WMTS)) {
            return true;
        }
        return false;
    }
    isLayerXYZ(layer) {
        if (this.HsUtilsService.instOf(layer, TileLayer) &&
            this.HsUtilsService.instOf(layer.getSource(), XYZ)) {
            return true;
        }
        return false;
    }
    isLayerArcgis(layer) {
        if (this.HsUtilsService.instOf(layer, TileLayer) &&
            this.HsUtilsService.instOf(layer.getSource(), TileArcGISRest)) {
            return true;
        }
        return false;
    }
    getLayerSourceFormat(layer) {
        var _a;
        if (!this.isLayerVectorLayer(layer)) {
            return;
        }
        return (_a = layer
            .getSource()) === null || _a === void 0 ? void 0 : _a.getFormat();
    }
    /**
     * Test if layer is Vector layer
     * @param layer - Selected layer
     * @returns True for Vector layer
     */
    isLayerVectorLayer(layer) {
        if (this.HsUtilsService.instOf(layer, Vector$1) &&
            (this.HsUtilsService.instOf(layer.getSource(), Cluster) ||
                this.HsUtilsService.instOf(layer.getSource(), Vector))) {
            return true;
        }
        return false;
    }
    /**
     * Test if the features in the vector layer come from a GeoJSON source
     * @param layer - an OL vector layer
     * @returns true only if the GeoJSON format is explicitly specified in the source. False otherwise.
     */
    isLayerGeoJSONSource(layer) {
        if (this.HsUtilsService.instOf(this.getLayerSourceFormat(layer), GeoJSON)) {
            return true;
        }
        return false;
    }
    /**
     * Test if the features in the vector layer come from a TopoJSON source
     * @param layer - an OL vector layer
     * @returns true only if the TopoJSON format is explicitly specified in the source. False otherwise.
     */
    isLayerTopoJSONSource(layer) {
        if (this.HsUtilsService.instOf(this.getLayerSourceFormat(layer), TopoJSON)) {
            return true;
        }
        return false;
    }
    /**
     * Test if the features in the vector layer come from a KML source
     * @param layer - an OL vector layer
     * @returns true only if the KML format is explicitly specified in the source. False otherwise.
     */
    isLayerKMLSource(layer) {
        if (this.HsUtilsService.instOf(this.getLayerSourceFormat(layer), KML)) {
            return true;
        }
        return false;
    }
    /**
     * Test if layer is shown in layer switcher
     * (if not some internal hslayers layer like selected feature layer)
     * @param layer - Layer to check
     * @returns True if showInLayerManager attribute is set to true
     */
    isLayerInManager(layer) {
        return (getShowInLayerManager(layer) === undefined ||
            getShowInLayerManager(layer) == true);
    }
    getSourceParams(source) {
        return source.getParams();
    }
    getLayerParams(layer) {
        const src = layer.getSource();
        if (this.HsUtilsService.instOf(src, ImageWMS)) {
            return this.getSourceParams(src);
        }
        if (this.HsUtilsService.instOf(src, TileWMS)) {
            return this.getSourceParams(src);
        }
        if (this.HsUtilsService.instOf(src, TileArcGISRest)) {
            return this.getSourceParams(src);
        }
    }
    updateLayerParams(layer, params) {
        const src = layer.getSource();
        if (this.HsUtilsService.instOf(src, ImageWMS)) {
            src.updateParams(params);
        }
        if (this.HsUtilsService.instOf(src, TileWMS)) {
            src.updateParams(params);
        }
    }
    /**
     * Test if layer is has a title
     * @param layer - Layer to check
     * @returns True if layer is has a title
     */
    hasLayerTitle(layer) {
        return getTitle(layer) !== undefined && getTitle(layer) !== '';
    }
    /**
     * Test if layers features are editable
     * @param layer - Layer to check
     * @returns True if layer has attribute 'editor' and in it
     * 'editable' property is set to true or missing
     */
    isLayerEditable(layer) {
        if (getEditor(layer) === undefined) {
            return true;
        }
        const editorConfig = getEditor(layer);
        if (editorConfig.editable === undefined) {
            return true;
        }
        return editorConfig.editable;
    }
    /**
     * Get user friendly name of layer based primary on title
     * and secondary on name attributes.
     * Is used in query service and hover popup.
     * @param layer - Layer to get the name for
     */
    getLayerName(layer) {
        if (layer === undefined ||
            (getShowInLayerManager(layer) !== undefined &&
                getShowInLayerManager(layer) === false)) {
            return '';
        }
        else {
            const layerName = getTitle(layer) || getName(layer);
            return layerName;
        }
    }
    /**
     * Checks if layer has a VectorSource object, if layer is
     * not internal for hslayers, if it has title and is shown in layer
     * switcher
     * @param layer - Layer to check
     * @returns True if layer is drawable vector layer
     */
    isLayerDrawable(layer) {
        return (this.HsUtilsService.instOf(layer, Vector$1) &&
            layer.getVisible() &&
            this.isLayerInManager(layer) &&
            this.hasLayerTitle(layer) &&
            this.isLayerEditable(layer));
    }
    /**
     * Checks if layer's source has its own source
     * @param layer - Layer to check
     * @returns True if layer is clustered, false otherwise
     */
    isLayerClustered(layer) {
        return this.isLayerVectorLayer(layer) &&
            getCluster(layer) &&
            this.HsUtilsService.instOf(layer.getSource(), Cluster)
            ? true
            : false;
    }
    translateTitle(title) {
        return this.HsLanguageService.getTranslationIgnoreNonExisting('LAYERS', title);
    }
    /**
     * Test if layers source is loaded
     * @param layer - Selected layer descriptor
     * @returns True loaded / False not (fully) loaded
     */
    layerLoaded(layer) {
        var _a;
        return (_a = layer.loadProgress) === null || _a === void 0 ? void 0 : _a.loaded;
    }
    /**
     * Test if layers source is validly loaded (!true for invalid)
     * @param layer - Selected layer descriptor
     * @returns True invalid, false valid source
     */
    layerInvalid(layer) {
        var _a;
        return (_a = layer.loadProgress) === null || _a === void 0 ? void 0 : _a.error;
    }
}
HsLayerUtilsService.ɵfac = function HsLayerUtilsService_Factory(t) { return new (t || HsLayerUtilsService)(ɵngcc0.ɵɵinject(HsUtilsService), ɵngcc0.ɵɵinject(HsLanguageService)); };
HsLayerUtilsService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: HsLayerUtilsService, factory: HsLayerUtilsService.ɵfac });
HsLayerUtilsService.ctorParameters = () => [
    { type: HsUtilsService },
    { type: HsLanguageService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsLayerUtilsService, [{
        type: Injectable
    }], function () { return [{ type: HsUtilsService }, { type: HsLanguageService }]; }, null); })();

const LCLSTORAGE_EXPIRE = 5000;
class HsSaveMapService {
    constructor(hsConfig, HsMapService, HsUtilsService, HsLayoutService, HsLogService, HsLayerUtilsService) {
        this.hsConfig = hsConfig;
        this.HsMapService = HsMapService;
        this.HsUtilsService = HsUtilsService;
        this.HsLayoutService = HsLayoutService;
        this.HsLogService = HsLogService;
        this.HsLayerUtilsService = HsLayerUtilsService;
        this.internalLayers = [];
        window.addEventListener('beforeunload', (e) => {
            if (hsConfig.saveMapStateOnReload) {
                this.save2storage(e);
            }
        });
    }
    /**
     * Create Json object which stores information about composition, user, map state and map layers (including layer data)
     * @param {Ol.map} map Selected map object
     * @param {object} compoData Composition general metadata
     * @param {object} userData Metadata about user
     * @param {object} statusData Metadata about permissions
     * @returns {object} JSON object with all required map composition metadata
     */
    map2json(map, compoData, userData, statusData) {
        const groups = {};
        for (const g of statusData.groups || []) {
            if (g.r || g.w) {
                groups[g.roleName] = (g.r ? 'r' : '') + (g.w ? 'w' : '');
            }
        }
        if (groups.guest == undefined) {
            groups.guest = 'r';
        }
        let bbox = compoData.bbox;
        if (compoData.bbox && !Array.isArray(compoData.bbox)) {
            bbox = [
                compoData.bbox.east,
                compoData.bbox.south,
                compoData.bbox.west,
                compoData.bbox.north,
            ];
        }
        const json = {
            abstract: compoData.abstract,
            title: compoData.title,
            keywords: compoData.keywords,
            extent: bbox,
            user: {
                address: userData.address,
                city: userData.city,
                country: userData.country,
                email: userData.email || 'none@none',
                name: userData.name,
                organization: userData.organization,
                phone: userData.phone,
                position: userData.position,
                postalcode: userData.postalcode,
                state: userData.state,
            },
            groups: groups,
        };
        // Map properties
        const currentProj = this.HsMapService.getCurrentProj();
        json.scale = currentProj.getMetersPerUnit();
        json.projection = currentProj.getCode().toLowerCase();
        const center = map.getView().getCenter();
        if (center) {
            json.center = [center[0], center[1]];
        }
        json.units = currentProj.getUnits();
        if (map.maxExtent) {
            json.maxExtent = {};
            json.maxExtent.left = map.maxExtent.left;
            json.maxExtent.bottom = map.maxExtent.bottom;
            json.maxExtent.right = map.maxExtent.right;
            json.maxExtent.top = map.maxExtent.top;
        }
        //json.minResolution = map.minResolution;
        //json.maxResolution = map.maxResolution;
        //json.numZoomLevels = map.numZoomLevels;
        //json.resolutions = map.resolutions;
        //json.scales = map.scales;
        //json.sphericalMercator = map.sphericalMercator;
        // Layers properties
        json.layers = this.layers2json(compoData.layers);
        json.current_base_layer = this.getCurrentBaseLayer();
        return json;
    }
    /**
     * Returns object about current selected base layer
     * @param {Map} map Selected map object
     * @returns {object} Returns object with current current selected base layers title as attribute
     */
    getCurrentBaseLayer() {
        let current_base_layer = null;
        for (const lyr of this.HsMapService.getLayersArray()) {
            if ((getShowInLayerManager(lyr) == undefined ||
                getShowInLayerManager(lyr) == true) &&
                getBase(lyr) == true &&
                lyr.getVisible()) {
                current_base_layer = {
                    title: getTitle(lyr),
                };
            }
        }
        return current_base_layer;
    }
    /**
     * Converts map layers into a JSON object. If $scope is defined, stores only layers checked in form
     * Uses layer2json().
     * @param {Array} layers All map layers
     * @returns {Array} JSON object representing the layers
     */
    layers2json(layers) {
        const json = [];
        layers.forEach((layer) => {
            const l = this.layer2json(layer);
            if (l) {
                json.push(l);
            }
        });
        return json;
    }
    /**
     * Converts map layer from Layer object to text in JSON notation.
     *
     * Syntactic sugar for layer2json() UNUSED?
     *
     * @param {object} layer Layer to be converted
     * @param {boolean} pretty Whether to use pretty notation
     * @returns {string} Text in JSON notation representing the layer
     */
    layer2string(layer, pretty) {
        const json = this.layer2json(layer);
        const text = JSON.stringify(json, pretty);
        return text;
    }
    /**
     * Convert layer style object into JSON object, partial function of layer2style
     * (saves Fill color, Stroke color/width, Image fill, stroke, radius, src and type)
     *
     * @param s Style to convert
     * @returns {object} Converted JSON object for style
     */
    serializeStyle(style) {
        const s = Array.isArray(style) ? style[0] : style;
        const o = {};
        const ima = {};
        if (s.getFill() && s.getFill() !== null) {
            o.fill = s.getFill().getColor();
        }
        if (s.getStroke() && s.getStroke() !== null) {
            o.stroke = {
                color: s.getStroke().getColor(),
                width: s.getStroke().getWidth(),
            };
        }
        if (s.getImage() && s.getImage() !== null) {
            const style_img = s.getImage();
            if (this.HsUtilsService.instOf(style_img, RegularShape)) {
                const regShape = style_img;
                if (regShape.getFill()) {
                    ima.fill = regShape.getFill().getColor();
                }
                if (regShape.getStroke()) {
                    ima.stroke = {
                        color: regShape.getStroke().getColor(),
                        width: regShape.getStroke().getWidth(),
                    };
                }
                ima.radius = regShape.getRadius();
            }
            if (this.HsUtilsService.instOf(style_img, Icon) &&
                typeof style_img.getSrc() === 'string' &&
                !style_img.getSrc().startsWith('data:image')) {
                ima.src = this.HsUtilsService.proxify(style_img.getSrc());
            }
            if (this.HsUtilsService.instOf(style_img, Circle)) {
                ima.type = 'circle';
            }
            if (this.HsUtilsService.instOf(style_img, Icon)) {
                ima.type = 'icon';
            }
            o.image = ima;
        }
        return o;
    }
    /**
     * Converts map layer into a JSON object (only for ol.layer.Layer)
     * Layer properties covered:  (CLASS_NAME), name, url, params,
     *                            group, displayInLayerSwitcher, *visibility, *opacity
     *                            attribution, transitionEffect,
     *                             isBaseLayer, minResolution,
     *                            maxResolution, metadata,
     *                            abstract, opacity, singleTile, removable,
     *                            queryable, legend, projections,
     *                            wmsMinScale, wmsMaxScale
     *
     * The layer index is not covered, as we assume
     * that it is corresponding to the layers order.
     *
     * @param layer - Map layer that should be converted
     * @returns JSON object representing the layer
     */
    layer2json(layer) {
        var _a;
        const json = {
            metadata: getMetadata(layer) || {},
        };
        /*
              Commented out because we cant reliably use instanceof.
              utils.instOf is also not possible, because Layer is a base type
    
              if (!layer instanceof Layer) {
                  return;
              }
              */
        // Common stuff
        // type
        //json.className = layer.CLASS_NAME;
        //json.origClassName = layer.CLASS_NAME; // the original type
        // options
        json.visibility = layer.getVisible();
        json.opacity = layer.getOpacity();
        json.base = (_a = getBase(layer)) !== null && _a !== void 0 ? _a : false;
        json.title = getTitle(layer);
        if (getTitle(layer) == undefined) {
            this.HsLogService.warn('Layer title undefined', layer);
        }
        //json.index = layer.map.getLayerIndex(layer);
        json.path = getPath(layer);
        if (layer.getExtent()) {
            const ex = layer.getExtent();
            json.maxExtent = {
                left: ex[0],
                bottom: ex[3],
                right: ex[2],
                top: ex[1],
            };
        }
        // HTTPRequest
        if (this.HsUtilsService.instOf(layer, Tile) ||
            this.HsUtilsService.instOf(layer, Image$1)) {
            const src = layer.getSource();
            if (layer.getMaxResolution() !== null) {
                json.maxResolution = layer.getMaxResolution();
            }
            if (layer.getMinResolution() !== null) {
                json.minResolution = layer.getMinResolution();
            }
            json.displayInLayerSwitcher = getShowInLayerManager(layer);
            if (getDimensions(layer)) {
                json.dimensions = getDimensions(layer);
            }
            if (this.HsUtilsService.instOf(src, XYZ)) {
                json.className = 'XYZ';
            }
            if (this.HsUtilsService.instOf(src, ImageArcGISRest) ||
                this.HsUtilsService.instOf(src, TileArcGISRest)) {
                json.className = 'ArcGISRest';
                json.singleTile = this.HsUtilsService.instOf(src, ImageArcGISRest);
            }
            if (this.HsUtilsService.instOf(src, ImageStatic)) {
                json.className = 'StaticImage';
                json.extent = src.getImageExtent();
            }
            if (this.HsLayerUtilsService.isLayerWMS(layer)) {
                json.className = 'HSLayers.Layer.WMS';
                json.singleTile = this.HsUtilsService.instOf(src, ImageWMS);
                if (getLegends(layer)) {
                    json.legends = [];
                    const legends = getLegends(layer);
                    if (Array.isArray(legends)) {
                        json.legends = legends.map((l) => encodeURIComponent(l));
                    }
                    if (typeof legends == 'string') {
                        json.legends = [legends];
                    }
                }
                if (src.getProjection()) {
                    json.projection = src.getProjection().getCode().toLowerCase();
                }
                json.params = this.HsLayerUtilsService.getLayerParams(layer);
                json.subLayers = getSubLayers(layer);
                json.metadata.styles = src.get('styles');
            }
            json.url = encodeURIComponent(this.HsLayerUtilsService.getURL(layer));
            if (getAttribution(layer)) {
                json.attributions = getAttribution(layer);
            }
            if (this.HsUtilsService.instOf(src, WMTS)) {
                const wmts = src;
                json.className = 'HSLayers.Layer.WMTS';
                json.matrixSet = wmts.getMatrixSet();
                json.layer = wmts.getLayer();
                json.format = wmts.getFormat();
                json.info_format = layer.get('info_format');
                json.url = wmts.getUrls()[0];
            }
        }
        // Vector
        if (this.HsUtilsService.instOf(layer, Vector$1)) {
            let src = layer.getSource();
            if (this.HsLayerUtilsService.isLayerClustered(layer)) {
                src = src.getSource();
            }
            json.name = getName(layer);
            json.className = 'Vector';
            const definition = getDefinition(layer);
            if (definition && definition.url) {
                json.protocol = {
                    url: encodeURIComponent(definition.url),
                    format: definition.format,
                };
                json.workspace = getWorkspace(layer);
                delete json.features;
            }
            else {
                if (getWfsUrl(layer)) {
                    json.protocol = {
                        url: getWfsUrl(layer),
                        format: 'hs.format.externalWFS',
                    };
                }
                else {
                    try {
                        json.features = this.getFeaturesJson(src.getFeatures());
                    }
                    catch (ex) {
                        //Do nothing
                    }
                }
            }
            json.maxResolution = layer.getMaxResolution();
            json.minResolution = layer.getMinResolution();
            json.projection = 'epsg:4326';
            if (getSld(layer) != undefined) {
                json.style = getSld(layer);
            }
            else if (this.HsUtilsService.instOf(layer.getStyle(), Style)) {
                json.style = this.serializeStyle(layer.getStyle());
            }
        }
        return json;
    }
    /**
     * Convert feature array to GeoJSON string
     *
     * @param features - Array of features
     * @returns GeoJSON
     */
    getFeaturesJson(features) {
        const f = new GeoJSON();
        const featureProjection = this.HsMapService.getCurrentProj().getCode();
        return f.writeFeaturesObject(features, {
            dataProjection: 'EPSG:4326',
            featureProjection,
        });
    }
    /**
     * Create thumbnail of map view and save it into selected element
     * @param {$element} $element Selected element
     * @param {object} localThis Context to be passed to postcompose event handler
     * @param {boolean} newRender Force new render?
     */
    generateThumbnail($element, localThis, newRender) {
        /**
         *
         */
        function rendered() {
            const canvas = this.HsMapService.getCanvases()[0];
            const canvas2 = document.createElement('canvas');
            const width = 256, height = 256;
            canvas2.style.width = width + 'px';
            canvas2.style.height = height + 'px';
            canvas2.width = width;
            canvas2.height = height;
            const ctx2 = canvas2.getContext('2d');
            ctx2.drawImage(canvas, canvas.width / 2 - height / 2, canvas.height / 2 - width / 2, width, height, 0, 0, width, height);
            try {
                $element.setAttribute('src', canvas2.toDataURL('image/png'));
                this.thumbnail = canvas2.toDataURL('image/jpeg', 0.8);
            }
            catch (e) {
                this.HsLogService.warn(e);
                $element.setAttribute('src', this.HsUtilsService.getAssetsPath() + 'img/notAvailable.png');
            }
            $element.style.width = width + 'px';
            $element.style.height = height + 'px';
        }
        if (this.HsLayoutService.mainpanel == 'save-map' ||
            this.HsLayoutService.mainpanel == 'permalink' ||
            this.HsLayoutService.mainpanel == 'statusCreator') {
            if ($element === null) {
                return;
            }
            $element.setAttribute('crossOrigin', 'Anonymous');
            rendered.bind(localThis);
            this.HsMapService.map.once('postcompose', rendered);
            if (newRender) {
                this.HsMapService.map.renderSync();
            }
            else {
                rendered();
            }
        }
    }
    save2storage(evt) {
        const data = {
            expires: new Date().getTime() + LCLSTORAGE_EXPIRE,
            layers: this.HsMapService.getLayersArray()
                .filter((lyr) => !this.internalLayers.includes(lyr))
                .map((lyr) => this.layer2json(lyr)),
        };
        //TODO: Set the item sooner, so it can be reloaded after accidental browser crash
        // but remove it if leaving the site for good
        localStorage.setItem('hs_layers', JSON.stringify(data));
    }
}
HsSaveMapService.ɵfac = function HsSaveMapService_Factory(t) { return new (t || HsSaveMapService)(ɵngcc0.ɵɵinject(HsConfig), ɵngcc0.ɵɵinject(HsMapService), ɵngcc0.ɵɵinject(HsUtilsService), ɵngcc0.ɵɵinject(HsLayoutService), ɵngcc0.ɵɵinject(HsLogService), ɵngcc0.ɵɵinject(HsLayerUtilsService)); };
HsSaveMapService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HsSaveMapService_Factory() { return new HsSaveMapService(i0.ɵɵinject(HsConfig), i0.ɵɵinject(HsMapService), i0.ɵɵinject(HsUtilsService), i0.ɵɵinject(HsLayoutService), i0.ɵɵinject(HsLogService), i0.ɵɵinject(HsLayerUtilsService)); }, token: HsSaveMapService, providedIn: "root" });
HsSaveMapService.ctorParameters = () => [
    { type: HsConfig },
    { type: HsMapService },
    { type: HsUtilsService },
    { type: HsLayoutService },
    { type: HsLogService },
    { type: HsLayerUtilsService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsSaveMapService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: HsConfig }, { type: HsMapService }, { type: HsUtilsService }, { type: HsLayoutService }, { type: HsLogService }, { type: HsLayerUtilsService }]; }, null); })();

class HsShareUrlService {
    constructor(HsMapService, HsCore, HsUtilsService, HsSaveMapService, HsConfig, HsLanguageService, HsLayoutService, HsEventBusService, Location, zone, PlatformLocation) {
        this.HsMapService = HsMapService;
        this.HsCore = HsCore;
        this.HsUtilsService = HsUtilsService;
        this.HsSaveMapService = HsSaveMapService;
        this.HsConfig = HsConfig;
        this.HsLanguageService = HsLanguageService;
        this.HsLayoutService = HsLayoutService;
        this.HsEventBusService = HsEventBusService;
        this.Location = Location;
        this.zone = zone;
        this.PlatformLocation = PlatformLocation;
        this.url_generation = true;
        //some of the code is taken from http://stackoverflow.com/questions/22258793/set-url-parameters-without-causing-page-refresh
        this.paramTimer = null;
        this.shareId = null;
        this.current_url = '';
        this.permalinkRequestUrl = '';
        this.params = {};
        this.customParams = {};
        this.updateDebouncer = {};
        this.statusSaving = false;
        this.browserUrlUpdated = new Subject();
        this.keepTrackOfGetParams();
        this.HsMapService.loaded().then((map) => this.init(map));
    }
    keepTrackOfGetParams() {
        const params = this.parse(location.search);
        /* We keep track of most hsl params separately so don't process
        them here. Only third party params are interesting */
        for (const key of Object.keys(HS_PRMS_REGENERATED)) {
            delete params[HS_PRMS_REGENERATED[key]];
        }
        Object.assign(this.customParams, params);
    }
    /**
     * Get actual map state information (visible layers, added layers*, active panel, map center and zoom level), create full Url link and push it in Url bar. (*Added layers are ommited from permalink url).
     */
    update() {
        const view = this.HsMapService.map.getView();
        this.id = this.HsUtilsService.generateUuid();
        const externalLayers = this.HsMapService.getLayersArray().filter((lyr) => !(getShowInLayerManager(lyr) === false));
        const visibleLayers = externalLayers
            .filter((lyr) => lyr.getVisible())
            .map((lyr) => getTitle(lyr));
        const addedLayers = externalLayers.filter((lyr) => { var _a; return !((_a = this.HsConfig.default_layers) === null || _a === void 0 ? void 0 : _a.includes(lyr)); });
        //This might become useful, but url size is limited, so we are not using it
        const addedLayersJson = this.HsSaveMapService.layers2json(addedLayers);
        const pnlMain = this.HsLayoutService.mainpanel;
        this.push(HS_PRMS.panel, pnlMain == 'permalink' ? 'layermanager' : pnlMain);
        this.push(HS_PRMS.x, view.getCenter()[0]);
        this.push(HS_PRMS.y, view.getCenter()[1]);
        this.push(HS_PRMS.zoom, view.getZoom());
        if (this.HsLanguageService.language) {
            this.push(HS_PRMS.lang, this.HsLanguageService.language);
        }
        this.push(HS_PRMS.visibleLayers, visibleLayers.join(';'));
        if (this.HsCore.puremapApp) {
            this.push(HS_PRMS.pureMap, 'true');
        }
        for (const cP in this.customParams) {
            this.push(cP, this.customParams[cP]);
        }
        if (this.statusSaving) {
            return;
        }
        this.HsUtilsService.debounce(() => {
            let locationPath = this.pathName();
            const paramsSerialized = Object.keys(this.params)
                .map((key) => {
                return { key, value: this.params[key] };
            })
                .map((dic) => `${dic.key}=${encodeURIComponent(dic.value)}`)
                .join('&');
            const baseHref = this.PlatformLocation.getBaseHrefFromDOM();
            if (locationPath.indexOf(baseHref) == 0) {
                locationPath = locationPath.replace(baseHref, '');
            }
            this.Location.replaceState(locationPath, paramsSerialized);
            this.browserUrlUpdated.next();
        }, 300, false, this.updateDebouncer)();
    }
    /**
     * @returns Permalink url
     * Create permalink Url to map
     */
    getPermalinkUrl() {
        if (this.HsCore.isMobile() && this.HsConfig.permalinkLocation) {
            return (this.HsConfig.permalinkLocation.origin +
                this.current_url.replace(this.pathName(), this.HsConfig.permalinkLocation.pathname) +
                `&${HS_PRMS.permalink}=${encodeURIComponent(this.permalinkRequestUrl)}`).replace(this.pathName(), this.HsConfig.permalinkLocation.pathname);
        }
        else {
            return `${this.current_url}&${HS_PRMS.permalink}=${encodeURIComponent(this.permalinkRequestUrl)}`;
        }
    }
    pathName() {
        let tmp = window.location.pathname.split('?')[0];
        if (!tmp.endsWith('/') && !tmp.split('/').pop().includes('.')) {
            tmp = tmp + '/';
        }
        return tmp;
    }
    /**
     * @returns Embedded url
     * Create Url for PureMap version of map
     */
    getPureMapUrl() {
        const params = { puremap: 'true' };
        return (this.getPermalinkUrl() +
            '&' +
            this.HsUtilsService.paramsToURLWoEncode(params));
    }
    /**
     * @param str Parameter string to parse
     * @returns Parsed parameter object
     * Parse parameter string from Url into key-value(s) pairs
     */
    parse(str) {
        if (typeof str != 'string') {
            return {};
        }
        str = str.trim().replace(/^\?/, '');
        if (!str) {
            return {};
        }
        return str
            .trim()
            .split('&')
            .reduce((paramDict, param) => {
            const parts = param.replace(/\+/g, ' ').split('=');
            let key = parts[0];
            let val = parts[1];
            key = decodeURIComponent(key);
            // missing `=` should be `null`:
            // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
            val = val == undefined ? null : decodeURIComponent(val);
            if (!paramDict.hasOwnProperty(key)) {
                paramDict[key] = val;
            }
            else if (Array.isArray(paramDict[key])) {
                paramDict[key].push(val);
            }
            else {
                paramDict[key] = [paramDict[key], val];
            }
            return paramDict;
        }, {});
    }
    /**
     * @param obj Parameter object to stringify
     * @returns Encoded parameter string or "" if no parameter object is given
     * Create encoded parameter string from parameter object
     */
    stringify(obj) {
        if (!obj) {
            return '';
        }
        return Object.keys(obj)
            .map((key) => {
            const val = obj[key];
            if (Array.isArray(val)) {
                return val
                    .map((val2) => {
                    return encodeURIComponent(key) + '=' + encodeURIComponent(val2);
                })
                    .join('&');
            }
            return encodeURIComponent(key) + '=' + encodeURIComponent(val);
        })
            .join('&');
    }
    /**
     * @param key Key name for pushed parameter
     * @param new_value Value for pushed parameter
     * Push new key-value pair into paramater object and update Url string with new params
     */
    push(key, new_value) {
        if (new_value === undefined) {
            delete this.params[key];
        }
        else {
            this.params[key] = new_value;
        }
        const new_params_string = this.stringify(this.params);
        this.param_string = new_params_string;
        this.urlUntilParams = location.origin + location.pathname;
        this.current_url = this.urlUntilParams + '?' + new_params_string;
    }
    /**
     * @param param Param to get current value
     * @returns Current value for requested param or null if param doesn't exist
     * Find current param value from Url
     */
    getParamValue(param) {
        const tmp = this.parse(location.search);
        const key = Object.keys(HS_PRMS).find((k) => HS_PRMS[k] == param);
        if (tmp[param]) {
            return tmp[param];
        }
        else {
            if (tmp[param] == undefined && HS_PRMS_BACKWARDS[key] != undefined) {
                return this.getParamValue(HS_PRMS_BACKWARDS[key]);
            }
            else {
                return;
            }
        }
    }
    getParamValues(keys) {
        const tmp = {};
        for (const key of keys) {
            tmp[key] = this.getParamValue(key);
        }
        return tmp;
    }
    /**
     * @param params A dictionary of custom parameters which get added to the generated url
     * Update values for custom parameters which get added to the url and usually are application specific
     */
    updateCustomParams(params) {
        for (const param in params) {
            this.customParams[param] = params[param];
        }
        if (this.paramTimer !== null) {
            clearTimeout(this.paramTimer);
        }
        this.paramTimer = setTimeout(() => {
            this.update();
        }, 1000);
    }
    /**
     * @param map Openlayers map
     */
    init(map) {
        if (this.url_generation) {
            let timer = null;
            this.HsEventBusService.mapExtentChanges.subscribe(this.HsUtilsService.debounce((data) => {
                this.zone.run(() => {
                    this.update();
                });
            }, 200, false, this));
            map.getLayers().on('add', (e) => {
                const layer = e.element;
                const external = getShowInLayerManager(layer);
                if (external !== null && external == false) {
                    return;
                }
                layer.on('change:visible', (e) => {
                    if (timer !== null) {
                        clearTimeout(timer);
                    }
                    timer = setTimeout(() => {
                        this.update();
                    }, 1000);
                });
            });
            const lang = this.getParamValue(HS_PRMS.lang);
            if (lang) {
                this.HsLanguageService.setLanguage(lang);
            }
            const view = this.getParamValue(HS_PRMS.view);
            // this.HsMapService.visible = !(view == '3d');
        }
    }
}
HsShareUrlService.ɵfac = function HsShareUrlService_Factory(t) { return new (t || HsShareUrlService)(ɵngcc0.ɵɵinject(HsMapService), ɵngcc0.ɵɵinject(HsCoreService), ɵngcc0.ɵɵinject(HsUtilsService), ɵngcc0.ɵɵinject(HsSaveMapService), ɵngcc0.ɵɵinject(HsConfig), ɵngcc0.ɵɵinject(HsLanguageService), ɵngcc0.ɵɵinject(HsLayoutService), ɵngcc0.ɵɵinject(HsEventBusService), ɵngcc0.ɵɵinject(ɵngcc3.Location), ɵngcc0.ɵɵinject(ɵngcc0.NgZone), ɵngcc0.ɵɵinject(ɵngcc3.PlatformLocation)); };
HsShareUrlService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HsShareUrlService_Factory() { return new HsShareUrlService(i0.ɵɵinject(HsMapService), i0.ɵɵinject(HsCoreService), i0.ɵɵinject(HsUtilsService), i0.ɵɵinject(HsSaveMapService), i0.ɵɵinject(HsConfig), i0.ɵɵinject(HsLanguageService), i0.ɵɵinject(HsLayoutService), i0.ɵɵinject(HsEventBusService), i0.ɵɵinject(i9.Location), i0.ɵɵinject(i0.NgZone), i0.ɵɵinject(i9.PlatformLocation)); }, token: HsShareUrlService, providedIn: "root" });
HsShareUrlService.ctorParameters = () => [
    { type: HsMapService },
    { type: HsCoreService },
    { type: HsUtilsService },
    { type: HsSaveMapService },
    { type: HsConfig },
    { type: HsLanguageService },
    { type: HsLayoutService },
    { type: HsEventBusService },
    { type: Location },
    { type: NgZone },
    { type: PlatformLocation }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsShareUrlService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: HsMapService }, { type: HsCoreService }, { type: HsUtilsService }, { type: HsSaveMapService }, { type: HsConfig }, { type: HsLanguageService }, { type: HsLayoutService }, { type: HsEventBusService }, { type: ɵngcc3.Location }, { type: ɵngcc0.NgZone }, { type: ɵngcc3.PlatformLocation }]; }, null); })();

class HsSidebarService {
    constructor(HsLayoutService, HsConfig, HsLanguageService, HsCoreService, HsEventBusService, HsUtilsService) {
        this.HsLayoutService = HsLayoutService;
        this.HsConfig = HsConfig;
        this.HsLanguageService = HsLanguageService;
        this.HsCoreService = HsCoreService;
        this.HsEventBusService = HsEventBusService;
        this.HsUtilsService = HsUtilsService;
        this.extraButtons = [];
        this.buttons = [];
        this.sidebarLoad = new Subject();
        /**
         * If buttons with importancy property exist.
         * If not, don't display expansion +/- icon
         */
        this.unimportantExist = false;
        this.visibleButtons = [];
        this.miniSidebarButton = {
            title: () => this.HsLanguageService.getTranslation('SIDEBAR.additionalPanels'),
        };
        this.extraButtons = [];
        /**
         * List of visible buttons taking into account viewport size
         */
        this.visibleButtons = [];
        /**
         * List of sidebar buttons
         */
        this.buttons = [];
        this.HsEventBusService.mainPanelChanges.subscribe(() => {
            /* NOTE: WE used to update map size only 'if (!HsLayoutService.sidebarExpanded) {'
            but that leads to blank margin between map and window border
            (see https://github.com/hslayers/hslayers-ng/issues/1107). Using timer to take
            into account sidebar width changing animation.
            */
            setTimeout(() => {
                this.HsCoreService.updateMapSize();
            }, 550);
        });
        this.HsEventBusService.layoutLoads.subscribe(() => {
            this.setButtonVisibility();
            this.setPanelState(this.buttons);
            //After initial run update sidebar with each layoutResizes event
            this.HsEventBusService.layoutResizes.subscribe(() => {
                this.setButtonVisibility();
            });
        });
    }
    setButtonVisibility() {
        this.importantButtons = this.buttons.filter((button) => {
            return (button.important != false && this.visibleButtons.includes(button.panel));
        });
        this.numberOfUnimportant =
            this.buttons.length - this.importantButtons.length;
        for (const button of this.importantButtons) {
            button.fits = this.fitsSidebar(button);
        }
        if (!this.unimportantExist) {
            this.HsLayoutService.minisidebar = this.importantButtons.some((b) => b.fits == false);
        }
    }
    getButtonTitle(button) {
        return typeof button.title == 'function' ? button.title() : button.title;
    }
    getButtonDescription(button) {
        return typeof button.description == 'function'
            ? button.description()
            : button.description;
    }
    /**
     * Function to set if a button is important and always visible
     * or only when the sidebar buttons are expanded
     *
     * @param panelName
     * @param state
     */
    setButtonImportancy(panelName, state) {
        const backCompat = { datasource_selector: 'addData' };
        panelName = backCompat[panelName] ? backCompat[panelName] : panelName;
        const button = this.buttons.find((b) => b.panel == panelName);
        if (button) {
            //Unimportant buttons are automatically placed inside minisidebar
            button.fits = state;
            button.important = state;
        }
        this.unimportantExist = this.buttons.some((b) => b.important == false);
        this.HsLayoutService.minisidebar = this.unimportantExist;
    }
    buttonClicked(button) {
        if (button.click) {
            button.click();
        }
        else {
            this.HsLayoutService.setMainPanel(button.panel, true);
        }
    }
    setPanelState(buttons) {
        for (const button of buttons) {
            if (this.HsLayoutService.getPanelEnableState(button.panel) &&
                this.checkConfigurableButtons(button)) {
                if (!this.visibleButtons.includes(button.panel)) {
                    this.visibleButtons.push(button.panel);
                    button.visible = true;
                }
            }
            else {
                button.visible = false;
            }
        }
    }
    /**
     * Checks whether the panels, which could be placed both in map or
     * in sidebar, have state defined in config.panelsEnabled. If yes it
     * should be placed in sidebar rather then in map.
     * It´s necessary for buttons like 'measure' because simple
     * 'config.panelsEnabled = false' would prevent their functionality.
     * @param {object} button buttons Buttons object
     */
    checkConfigurableButtons(button) {
        if (typeof button.condition == 'undefined') {
            return true;
        }
        else if (!this.HsConfig.panelsEnabled) {
            return false;
        }
        else {
            return this.HsConfig.panelsEnabled[button.panel];
        }
    }
    /**
     * @public
     * @param {string} which Sidear button to be checked (specify panel name)
     * @description Check if sidebar button should be visible in classic sidebar or hidden inside minisidebar panel
     * @description Toggles minisidebar button
     */
    fitsSidebar(button) {
        const dimensionToCheck = window.innerWidth > 767 ? 'clientHeight' : 'clientWidth';
        let maxNumberOfButtons = Math.floor(this.HsLayoutService.layoutElement[dimensionToCheck] / 60);
        maxNumberOfButtons =
            dimensionToCheck == 'clientHeight'
                ? maxNumberOfButtons - 1
                : maxNumberOfButtons;
        return (this.importantButtons.findIndex((btn) => btn.panel === button.panel) +
            2 <=
            maxNumberOfButtons);
    }
}
HsSidebarService.ɵfac = function HsSidebarService_Factory(t) { return new (t || HsSidebarService)(ɵngcc0.ɵɵinject(HsLayoutService), ɵngcc0.ɵɵinject(HsConfig), ɵngcc0.ɵɵinject(HsLanguageService), ɵngcc0.ɵɵinject(HsCoreService), ɵngcc0.ɵɵinject(HsEventBusService), ɵngcc0.ɵɵinject(HsUtilsService)); };
HsSidebarService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HsSidebarService_Factory() { return new HsSidebarService(i0.ɵɵinject(HsLayoutService), i0.ɵɵinject(HsConfig), i0.ɵɵinject(HsLanguageService), i0.ɵɵinject(HsCoreService), i0.ɵɵinject(HsEventBusService), i0.ɵɵinject(HsUtilsService)); }, token: HsSidebarService, providedIn: "root" });
HsSidebarService.ctorParameters = () => [
    { type: HsLayoutService },
    { type: HsConfig },
    { type: HsLanguageService },
    { type: HsCoreService },
    { type: HsEventBusService },
    { type: HsUtilsService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsSidebarService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: HsLayoutService }, { type: HsConfig }, { type: HsLanguageService }, { type: HsCoreService }, { type: HsEventBusService }, { type: HsUtilsService }]; }, null); })();

class HsAddDataComponent extends HsPanelBaseComponent {
    constructor(hsAddDataService, hsLanguageService, hsShareUrlService, hsLayoutService, hsEventBusService, hsSidebarService) {
        super(hsLayoutService);
        this.hsAddDataService = hsAddDataService;
        this.hsLanguageService = hsLanguageService;
        this.hsShareUrlService = hsShareUrlService;
        this.hsLayoutService = hsLayoutService;
        this.hsEventBusService = hsEventBusService;
        this.name = 'addData';
        hsSidebarService.buttons.push({
            panel: 'addData',
            module: 'hs.addData',
            order: 4,
            fits: true,
            title: () => this.hsLanguageService.getTranslation('PANEL_HEADER.ADDLAYERS'),
            description: () => this.hsLanguageService.getTranslation('SIDEBAR.descriptions.ADDLAYERS'),
            icon: 'icon-database',
        });
        this.hsAddDataService.typeSelected = 'catalogue';
        servicesSupportedByUrl.forEach((type) => this.connectServiceFromUrlParam(type));
    }
    datasetSelect(type) {
        this.hsAddDataService.selectType(type);
    }
    connectServiceFromUrlParam(type) {
        const url = this.hsShareUrlService.getParamValue(`hs-${type}-to-connect`);
        if (url) {
            this.hsLayoutService.setMainPanel('data');
            this.hsAddDataService.typeSelected = 'url';
            this.hsAddDataService.urlType = type;
        }
    }
}
HsAddDataComponent.ɵfac = function HsAddDataComponent_Factory(t) { return new (t || HsAddDataComponent)(ɵngcc0.ɵɵdirectiveInject(HsAddDataService), ɵngcc0.ɵɵdirectiveInject(HsLanguageService), ɵngcc0.ɵɵdirectiveInject(HsShareUrlService), ɵngcc0.ɵɵdirectiveInject(HsLayoutService), ɵngcc0.ɵɵdirectiveInject(HsEventBusService), ɵngcc0.ɵɵdirectiveInject(HsSidebarService)); };
HsAddDataComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsAddDataComponent, selectors: [["hs-add-data"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 19, vars: 22, consts: [[1, "card", "hs-main-panel", 3, "hidden"], ["name", "datasource_selector", 3, "title"], [1, "card-body"], ["role", "tablist", 1, "nav", "flex-column", "flex-sm-row", "dss-tabs"], [1, "nav-item", "hs-tab-single-datasources"], ["role", "tab", "data-toggle", "tab", 1, "nav-link", 3, "ngClass", "click"], [4, "ngIf"]], template: function HsAddDataComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "hs-panel-header", 1);
        ɵngcc0.ɵɵpipe(2, "translate");
        ɵngcc0.ɵɵelementStart(3, "div", 2);
        ɵngcc0.ɵɵelementStart(4, "ul", 3);
        ɵngcc0.ɵɵelementStart(5, "li", 4);
        ɵngcc0.ɵɵelementStart(6, "a", 5);
        ɵngcc0.ɵɵlistener("click", function HsAddDataComponent_Template_a_click_6_listener() { return ctx.datasetSelect("catalogue"); });
        ɵngcc0.ɵɵtext(7);
        ɵngcc0.ɵɵpipe(8, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "li", 4);
        ɵngcc0.ɵɵelementStart(10, "a", 5);
        ɵngcc0.ɵɵlistener("click", function HsAddDataComponent_Template_a_click_10_listener() { return ctx.datasetSelect("url"); });
        ɵngcc0.ɵɵtext(11, " Url ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "li", 4);
        ɵngcc0.ɵɵelementStart(13, "a", 5);
        ɵngcc0.ɵɵlistener("click", function HsAddDataComponent_Template_a_click_13_listener() { return ctx.datasetSelect("file"); });
        ɵngcc0.ɵɵtext(14);
        ɵngcc0.ɵɵpipe(15, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(16, HsAddDataComponent_hs_add_data_url_16_Template, 1, 0, "hs-add-data-url", 6);
        ɵngcc0.ɵɵtemplate(17, HsAddDataComponent_hs_add_data_file_17_Template, 1, 0, "hs-add-data-file", 6);
        ɵngcc0.ɵɵtemplate(18, HsAddDataComponent_hs_add_data_catalogue_18_Template, 1, 0, "hs-add-data-catalogue", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("hidden", !ctx.isVisible());
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(2, 10, "PANEL_HEADER.DATASOURCE_SELECTOR"));
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(16, _c0, ctx.hsAddDataService.typeSelected === "catalogue"));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(8, 12, "ADDDATA.catalogue"), " ");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(18, _c0, ctx.hsAddDataService.typeSelected === "url" || ctx.hsAddDataService.typeSelected === "OWS"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(20, _c0, ctx.hsAddDataService.typeSelected === "file"));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(15, 14, "ADDDATA.file"), " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hsAddDataService.typeSelected === "url" || ctx.hsAddDataService.typeSelected === "OWS");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hsAddDataService.typeSelected === "file");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hsAddDataService.typeSelected === "catalogue");
    } }, directives: function () { return [HsPanelHeaderComponent, ɵngcc3.NgClass, ɵngcc3.NgIf, HsAddDataUrlComponent, HsAddDataFileComponent, HsAddDataCatalogueComponent]; }, pipes: function () { return [ɵngcc1.TranslatePipe]; }, encapsulation: 2 });
HsAddDataComponent.ctorParameters = () => [
    { type: HsAddDataService },
    { type: HsLanguageService },
    { type: HsShareUrlService },
    { type: HsLayoutService },
    { type: HsEventBusService },
    { type: HsSidebarService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsAddDataComponent, [{
        type: Component,
        args: [{
                selector: 'hs-add-data',
                template: "<div class=\"card hs-main-panel\" [hidden]=\"!isVisible()\">\n    <hs-panel-header name=\"datasource_selector\" [title]=\"'PANEL_HEADER.DATASOURCE_SELECTOR' | translate\">\n    </hs-panel-header>\n    <div class=\"card-body\">\n        <ul class=\"nav flex-column flex-sm-row dss-tabs\" role=\"tablist\">\n            <li class=\"nav-item hs-tab-single-datasources\">\n                <a class=\"nav-link\" [ngClass]=\"{'btn-primary active': hsAddDataService.typeSelected === 'catalogue'}\"\n                    role=\"tab\" data-toggle=\"tab\" (click)=\"datasetSelect('catalogue')\">\n                    {{'ADDDATA.catalogue' | translate}}\n                </a>\n            </li>\n            <li class=\"nav-item hs-tab-single-datasources\">\n                <a class=\"nav-link\"\n                    [ngClass]=\"{'btn-primary active': hsAddDataService.typeSelected === 'url' || hsAddDataService.typeSelected === 'OWS'}\"\n                    role=\"tab\" data-toggle=\"tab\" (click)=\"datasetSelect('url')\">\n                    Url\n                </a>\n            </li>\n            <li class=\"nav-item hs-tab-single-datasources\">\n                <a class=\"nav-link\" [ngClass]=\"{'btn-primary active': hsAddDataService.typeSelected === 'file'}\"\n                    role=\"tab\" data-toggle=\"tab\" (click)=\"datasetSelect('file')\">\n                    {{'ADDDATA.file' | translate}}\n                </a>\n            </li>\n        </ul>\n        <hs-add-data-url *ngIf=\"hsAddDataService.typeSelected === 'url' || hsAddDataService.typeSelected === 'OWS'\">\n        </hs-add-data-url>\n        <hs-add-data-file *ngIf=\"hsAddDataService.typeSelected === 'file'\"></hs-add-data-file>\n        <hs-add-data-catalogue *ngIf=\"hsAddDataService.typeSelected === 'catalogue'\"></hs-add-data-catalogue>\n    </div>\n</div>\n"
            }]
    }], function () { return [{ type: HsAddDataService }, { type: HsLanguageService }, { type: HsShareUrlService }, { type: HsLayoutService }, { type: HsEventBusService }, { type: HsSidebarService }]; }, null); })();

var EndpointErrorHandling;
(function (EndpointErrorHandling) {
    EndpointErrorHandling["ignore"] = "ignore";
    EndpointErrorHandling["toast"] = "toast";
})(EndpointErrorHandling || (EndpointErrorHandling = {}));
function isErrorHandlerFunction(object) {
    if (typeof object == 'string' || object === undefined) {
        return false;
    }
    return 'handle' in object;
}

class HsToastService {
    constructor(HsLanguageService) {
        this.HsLanguageService = HsLanguageService;
        this.toasts = [];
    }
    /**
     * @param toast Toast pop up
     * Callback method to remove Toast DOM element from view
     */
    remove(toast) {
        this.toasts = this.toasts.filter((t) => t !== toast);
    }
    /**
     * @param textOrTpl Text or a template message to display
     * @param options Toast window options
     * Pushes new Toasts to array with content and options
     */
    show(textOrTpl, options = {}) {
        if (this.toasts.length >= 5) {
            this.toasts = this.toasts.slice(-4);
        }
        if (!this.toasts.some((toast) => toast.textOrTpl === textOrTpl &&
            (toast === null || toast === void 0 ? void 0 : toast.serviceCalledFrom) === options.serviceCalledFrom)) {
            this.toasts.push(Object.assign({ textOrTpl }, options));
        }
    }
    /**
     * Creates new toast message with custom text and custom styling
     * @param header Header text to display
     * @param text Toast body text to display
     * @param options Custom options for the toast message (disableLocalization: boolean, toastStyleClasses: string, customDelay: number, serviceCalledFrom: string)
     */
    createToastPopupMessage(header, text, options = {}) {
        this.show(options.disableLocalization
            ? text
            : this.HsLanguageService.getTranslation(text), {
            header: options.disableLocalization
                ? header
                : this.HsLanguageService.getTranslation(header),
            delay: options.customDelay || 7000,
            autohide: true,
            classname: options.toastStyleClasses || `bg-danger text-light`,
            serviceCalledFrom: options.serviceCalledFrom,
        });
    }
}
HsToastService.ɵfac = function HsToastService_Factory(t) { return new (t || HsToastService)(ɵngcc0.ɵɵinject(HsLanguageService)); };
HsToastService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HsToastService_Factory() { return new HsToastService(i0.ɵɵinject(HsLanguageService)); }, token: HsToastService, providedIn: "root" });
HsToastService.ctorParameters = () => [
    { type: HsLanguageService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsToastService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: HsLanguageService }]; }, null); })();

class HsCommonLaymanService {
    constructor($http, hsToastService, hsLanguageService) {
        this.$http = $http;
        this.hsToastService = hsToastService;
        this.hsLanguageService = hsLanguageService;
        this.authChange = new Subject();
    }
    /**
     *  Monitor if authorization state has changed and
     * return true and broadcast authChange event if so .
     * @param endpoint Endpoint definition - usually Layman
     * @returns Promise<boolean> true if authorization state changed (user logged in or out)
     */
    detectAuthChange(endpoint) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${endpoint.url}/rest/current-user`;
            try {
                const res = yield this.$http
                    .get(url, { withCredentials: true })
                    .toPromise();
                let somethingChanged = false;
                if (res.username) {
                    if (endpoint.user != res.username) {
                        endpoint.user = res.username;
                        somethingChanged = true;
                        this.authChange.next(endpoint);
                    }
                }
                else {
                    if (endpoint.user != endpoint.originalConfiguredUser) {
                        somethingChanged = true;
                    }
                    endpoint.user = endpoint.originalConfiguredUser;
                }
                return somethingChanged;
            }
            catch (e) {
                console.warn(e);
                return e;
            }
        });
    }
    getCurrentUserIfNeeded(endpoint) {
        return __awaiter(this, void 0, void 0, function* () {
            if (endpoint.user === undefined ||
                ['anonymous', 'browser'].includes(endpoint.user)) {
                yield this.detectAuthChange(endpoint);
            }
        });
    }
    logout(endpoint) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${endpoint.url}/logout`;
            try {
                const response = yield this.$http
                    .get(url, { withCredentials: true })
                    .toPromise();
            }
            catch (ex) {
                console.warn(ex);
            }
            finally {
                endpoint.user = 'anonymous';
                this.authChange.next(endpoint);
            }
        });
    }
    displayLaymanError(endpoint, errorMsg, responseBody) {
        let simplifiedResponse = '';
        if (responseBody.code === undefined) {
            simplifiedResponse = 'COMMON.unknownError';
        }
        switch (responseBody.code) {
            case 48:
                simplifiedResponse = 'mapExtentFilterMissing';
                break;
            case 32:
                simplifiedResponse = 'Authentication failed. Login to the catalogue.';
                this.detectAuthChange(endpoint);
                break;
            default:
                simplifiedResponse = responseBody.message + ' ' + responseBody.detail;
        }
        //If response is object, it is an error response
        this.hsToastService.createToastPopupMessage(this.hsLanguageService.getTranslation(errorMsg), endpoint.title +
            ': ' +
            this.hsLanguageService.getTranslationIgnoreNonExisting('COMMON', simplifiedResponse), { disableLocalization: true, serviceCalledFrom: 'HsCommonLaymanService' });
    }
}
HsCommonLaymanService.ɵfac = function HsCommonLaymanService_Factory(t) { return new (t || HsCommonLaymanService)(ɵngcc0.ɵɵinject(ɵngcc2.HttpClient), ɵngcc0.ɵɵinject(HsToastService), ɵngcc0.ɵɵinject(HsLanguageService)); };
HsCommonLaymanService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HsCommonLaymanService_Factory() { return new HsCommonLaymanService(i0.ɵɵinject(i1$1.HttpClient), i0.ɵɵinject(HsToastService), i0.ɵɵinject(HsLanguageService)); }, token: HsCommonLaymanService, providedIn: "root" });
HsCommonLaymanService.ctorParameters = () => [
    { type: HttpClient },
    { type: HsToastService },
    { type: HsLanguageService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsCommonLaymanService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc2.HttpClient }, { type: HsToastService }, { type: HsLanguageService }]; }, null); })();

class HsCommonEndpointsService {
    constructor(hsConfig, hsCommonLaymanService) {
        this.hsConfig = hsConfig;
        this.hsCommonLaymanService = hsCommonLaymanService;
        this.endpointsFilled = new BehaviorSubject(null);
        this.fillEndpoints();
        this.hsConfig.configChanges.subscribe(() => this.fillEndpoints());
    }
    fillEndpoints() {
        this.endpoints = [
            ...(this.hsConfig.status_manager_url
                ? [
                    {
                        type: 'statusmanager',
                        title: 'Status manager',
                        url: this.hsConfig.status_manager_url,
                        onError: { compositionLoad: EndpointErrorHandling.ignore },
                    },
                ]
                : []),
            ...(this.hsConfig.datasources || []).map((ds) => {
                const tmp = {
                    url: ds.url,
                    type: ds.type,
                    title: ds.title,
                    onError: ds.onError,
                    datasourcePaging: {
                        start: 0,
                        limit: this.getItemsPerPageConfig(ds),
                        loaded: false,
                    },
                    compositionsPaging: {
                        start: 0,
                        limit: this.getItemsPerPageConfig(ds),
                        loaded: false,
                    },
                    paging: {
                        itemsPerPage: this.getItemsPerPageConfig(ds),
                    },
                    user: ds.user,
                    originalConfiguredUser: ds.user,
                    getCurrentUserIfNeeded: () => __awaiter(this, void 0, void 0, function* () { return yield this.hsCommonLaymanService.getCurrentUserIfNeeded(tmp); }),
                };
                return tmp;
            }),
        ]
            /**
             * Sort endpoints in order to give layman's
             * layers priority in duplicate filtering.
             */
            .sort((a, b) => a.type.localeCompare(b.type));
        this.endpointsFilled.next(this.endpoints);
    }
    getItemsPerPageConfig(endpoint) {
        return endpoint.paging !== undefined &&
            endpoint.paging.itemsPerPage !== undefined
            ? endpoint.paging.itemsPerPage
            : this.hsConfig.dsPaging || 10;
    }
}
HsCommonEndpointsService.ɵfac = function HsCommonEndpointsService_Factory(t) { return new (t || HsCommonEndpointsService)(ɵngcc0.ɵɵinject(HsConfig), ɵngcc0.ɵɵinject(HsCommonLaymanService)); };
HsCommonEndpointsService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HsCommonEndpointsService_Factory() { return new HsCommonEndpointsService(i0.ɵɵinject(HsConfig), i0.ɵɵinject(HsCommonLaymanService)); }, token: HsCommonEndpointsService, providedIn: "root" });
HsCommonEndpointsService.ctorParameters = () => [
    { type: HsConfig },
    { type: HsCommonLaymanService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsCommonEndpointsService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: HsConfig }, { type: HsCommonLaymanService }]; }, null); })();

/**
 * This function generates vibrant, "evenly spaced" colours (i.e. no clustering). This is ideal for creating easily distinguishable vibrant markers in Google Maps and other apps.
 * Adam Cole, 2011-Sept-14
 * HSV to RBG adapted from: http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript
 * based on http://stackoverflow.com/a/7419630
 * @param numOfSteps
 * @param step
 * @param opacity
 */
function rainbow(numOfSteps, step, opacity) {
    let r, g, b;
    const h = step / (numOfSteps * 1.00000001);
    const i = ~~(h * 4);
    const f = h * 4 - i;
    const q = 1 - f;
    switch (i % 4) {
        case 2:
            (r = f), (g = 1), (b = 0);
            break;
        case 0:
            (r = 0), (g = f), (b = 1);
            break;
        case 3:
            (r = 1), (g = q), (b = 0);
            break;
        case 1:
            (r = 0), (g = 1), (b = q);
            break;
        default:
            (r = 0), (g = 0), (b = 0);
    }
    const c = 'rgba(' +
        ~~(r * 235) +
        ',' +
        ~~(g * 235) +
        ',' +
        ~~(b * 235) +
        ', ' +
        opacity +
        ')';
    return c;
}
/**
 * @param feature_object
 * @param optionsCategoryField
 * @param feature
 * @param category_map
 * @param category_id
 */
function registerCategoryForStatistics(feature_object, optionsCategoryField, feature, category_map, category_id) {
    if (feature_object[optionsCategoryField]) {
        if (typeof category_map[feature_object[optionsCategoryField]] === 'undefined') {
            category_map[feature_object[optionsCategoryField]] = {
                id: category_id,
                name: feature_object[optionsCategoryField],
            };
            category_id++;
        }
        feature.category_id = category_map[feature_object[optionsCategoryField]].id;
    }
}
/**
 * @param objects
 * @param src
 * @param options
 * @param occupied_xy
 * @param category_map
 * @param category_id
 */
function loadFeatures(objects, src, optionsCategoryField, occupied_xy, category_map, category_id, proj) {
    const features = [];
    const format = new WKT();
    for (const key in objects) {
        if (objects[key]['http://www.w3.org/2003/01/geo/wgs84_pos#lat'] &&
            objects[key]['http://www.w3.org/2003/01/geo/wgs84_pos#long'] &&
            objects[key]['http://www.w3.org/2003/01/geo/wgs84_pos#lat'] != '' &&
            objects[key]['http://www.w3.org/2003/01/geo/wgs84_pos#long'] != '') {
            const x = parseFloat(objects[key]['http://www.w3.org/2003/01/geo/wgs84_pos#long']);
            const y = parseFloat(objects[key]['http://www.w3.org/2003/01/geo/wgs84_pos#lat']);
            if (!isNaN(x) && !isNaN(y)) {
                const coord = transform([x, y], 'EPSG:4326', 'EPSG:3857');
                if (typeof occupied_xy[coord.toString()] !== 'undefined') {
                    continue;
                }
                objects[key].geometry = new Point(coord);
                const feature = new Feature(objects[key]);
                registerCategoryForStatistics(objects[key], optionsCategoryField, feature, category_map, category_id);
                occupied_xy[coord.toString()] = true;
                features.push(feature);
            }
        }
        if (objects[key]['http://www.opengis.net/ont/geosparql#asWKT']) {
            const g_feature = format.readFeature(objects[key]['http://www.opengis.net/ont/geosparql#asWKT'].toUpperCase());
            objects[key].geometry = g_feature.getGeometry();
            objects[key].geometry.transform('EPSG:4326', proj);
            delete objects[key]['http://www.opengis.net/ont/geosparql#asWKT'];
            const coord = objects[key].geometry.getCoordinates();
            if (typeof occupied_xy[coord.toString()] !== 'undefined') {
                continue;
            }
            const feature = new Feature(objects[key]);
            registerCategoryForStatistics(objects[key], optionsCategoryField, feature, category_map, category_id);
            occupied_xy[coord] = true;
            features.push(feature);
        }
    }
    for (const categ in category_map) {
        category_map[categ].color = rainbow(category_id, category_map[categ].id, 0.7);
    }
    src.legend_categories = category_map;
    for (let i = 0; i < features.length; i++) {
        if (features[i].category_id) {
            features[i].color = rainbow(category_id, features[i].category_id, 0.7);
        }
    }
    //console.log(features);
    return features;
}
/**
 * @param extend_with_attribs
 * @param objects
 */
function extendAttributes(extend_with_attribs, objects) {
    if (typeof extend_with_attribs != 'undefined') {
        for (const attr_i in extend_with_attribs) {
            for (const i in objects) {
                if (typeof objects[i][extend_with_attribs[attr_i]] == 'undefined') {
                    objects[i][extend_with_attribs[attr_i]] = '';
                }
            }
        }
    }
}
/**
 * Provides a source of features from SPARQL endpoint
 */
class SparqlJson extends Vector {
    /**
     * Only 'projection' and either 'url' or 'endpointUrl' + 'query' are mandatory
     */
    constructor({ category, category_field, clear_on_move, endpointUrl, endpointOptions, extend_with_attribs, geom_attribute, hsproxy = false, optimizeForVirtuoso = false, projection, query, strategy, url, updates_url, }) {
        super({
            format: new GeoJSON(),
            loader: (extent, resolution, projection) => __awaiter(this, void 0, void 0, function* () {
                this.set('loaded', false);
                if (!url && !endpointUrl) {
                    return;
                }
                if (endpointUrl && query) {
                    const queryParts = query.split('<extent>');
                    url =
                        endpointUrl +
                            '?query=' +
                            encodeURIComponent(queryParts[0]) +
                            '<extent>' +
                            encodeURIComponent(queryParts[1]) +
                            '&format=application%2Fsparql-results%2Bjson';
                    console.log(url);
                }
                if (typeof clear_on_move !== 'undefined' && clear_on_move) {
                    this.clear();
                }
                if (typeof geom_attribute === 'undefined') {
                    geom_attribute = 'bif:st_point(xsd:decimal(?lon), xsd:decimal(?lat))';
                }
                let first_pair = [extent[0], extent[1]];
                let second_pair = [extent[2], extent[3]];
                first_pair = transform(first_pair, 'EPSG:3857', 'EPSG:4326');
                second_pair = transform(second_pair, 'EPSG:3857', 'EPSG:4326');
                extent = [...first_pair, ...second_pair];
                const geof = optimizeForVirtuoso
                    ? 'bif:st_may_intersect'
                    : 'geof:sfIntersects';
                /* Do NOT break lines in the POLYGON() section! */
                const s_extent = encodeURIComponent(`FILTER(${geof}(
            "POLYGON((${extent[0]} ${extent[1]}, ${extent[0]} ${extent[3]}, ${extent[2]} ${extent[3]}, ${extent[2]} ${extent[1]}, ${extent[0]} ${extent[1]}))"^^geo:wktLiteral,
          ${geom_attribute}
          )).`);
                const tmp = url.split('query=');
                url =
                    tmp[0] +
                        'query=' +
                        encodeURIComponent('PREFIX geo: <http://www.opengis.net/ont/geosparql#>\n' +
                            'PREFIX geof: <http://www.opengis.net/def/function/geosparql/>\n') +
                        tmp[1];
                url = url.replace(/<extent>/g, s_extent);
                if (hsproxy) {
                    url =
                        '/cgi-bin/hsproxy.cgi?toEncoding=utf-8&url=' +
                            encodeURIComponent(url);
                }
                if (console && typeof this.get('geoname') !== 'undefined') {
                    console.log('Get ', this.get('geoname'));
                }
                this.loadCounter += 1;
                this.loadTotal += 1;
                console.log(url);
                const response = yield fetch(url, {
                    method: 'GET',
                });
                const data = yield response.json();
                /*if (console) {
                  console.log(
                    'Finish ',
                    this.get('geoname'),
                    data.results.bindings.length
                  );
                }*/
                this.loadCounter -= 1;
                if (updates_url) {
                    let updates_query = updates_url;
                    const tmp = updates_query.split('&query=');
                    updates_query =
                        tmp[0] +
                            '&query=' +
                            encodeURIComponent('PREFIX geo: <http://www.opengis.net/ont/geosparql#>\n' +
                                'PREFIX geof: <http://www.opengis.net/def/function/geosparql/>\n') +
                            tmp[1];
                    updates_query = updates_query.replace(/<extent>/g, s_extent);
                    this.loadCounter += 1;
                    this.loadTotal += 1;
                    const response = yield fetch(updates_query, {
                        method: 'GET',
                    });
                    const updates_data = yield response.json();
                    if (console && typeof this.get('geoname') !== 'undefined') {
                        console.log('Finish updates ', this.get('geoname'), data.results.bindings.length, updates_data.results.bindings.length);
                    }
                    const objects = {};
                    for (const item of data.results.bindings) {
                        if (typeof objects[item.o.value] === 'undefined') {
                            objects[item.o.value] = {
                                'poi_id': item.o.value,
                            };
                        }
                        objects[item.o.value][item.p.value] = item.s.value;
                    }
                    for (const item of updates_data.results.bindings) {
                        let attribute_name = item.attr.value;
                        //Because photos can be more than one
                        if (typeof objects[item.o.value][attribute_name] !== 'undefined' &&
                            attribute_name == 'http://xmlns.com/foaf/0.1/depiction') {
                            for (let try_i = 1; try_i < 20; try_i++) {
                                if (typeof objects[item.o.value][attribute_name + try_i] ==
                                    'undefined') {
                                    attribute_name = attribute_name + try_i;
                                    break;
                                }
                            }
                        }
                        objects[item.o.value][attribute_name] = item.value.value;
                    }
                    if (typeof category != 'undefined') {
                        for (const i in objects) {
                            objects[i]['http://www.sdi4apps.eu/poi/#mainCategory'] = category;
                        }
                    }
                    extendAttributes(extend_with_attribs, objects);
                    if (console) {
                        console.log('Add features', objects);
                    }
                    this.addFeatures(loadFeatures(objects, this, category_field, this.occupied_xy, this.category_map, this.category_id, projection));
                    this.loadCounter -= 1;
                    this.set('last_feature_count', Object.keys(objects).length);
                    if (this.loadCounter == 0) {
                        this.set('loaded', true);
                        this.dispatchEvent('imageloadend');
                    }
                }
                else {
                    const objects = {};
                    for (const b of data.results.bindings) {
                        if (objects[b.o.value] === undefined) {
                            objects[b.o.value] = {
                                'poi_id': b.o.value,
                            };
                        }
                        objects[b.o.value][b.p.value] = b.s.value;
                    }
                    if (typeof category !== 'undefined') {
                        for (const i in objects) {
                            objects[i]['http://www.sdi4apps.eu/poi/#mainCategory'] = category;
                        }
                    }
                    extendAttributes(extend_with_attribs, objects);
                    this.addFeatures(loadFeatures(objects, this, category_field, this.occupied_xy, this.category_map, this.category_id, projection));
                    this.styleAble = true;
                    this.hasPoint = true;
                    this.loadCounter -= 1;
                    this.set('last_feature_count', Object.keys(objects).length);
                    if (this.loadCounter == 0) {
                        this.set('loaded', true);
                        this.dispatchEvent('imageloadend');
                    }
                }
            }),
            strategy: strategy !== null && strategy !== void 0 ? strategy : function (extent, resolution) {
                const tmp = [extent[0], extent[1], extent[2], extent[3]];
                if (extent[2] - extent[0] > 65735) {
                    tmp[0] = (extent[2] + extent[0]) / 2.0 - 65735 / 2.0;
                    tmp[2] = (extent[2] + extent[0]) / 2.0 + 65735 / 2.0;
                    tmp[1] = (extent[3] + extent[1]) / 2.0 - 35000 / 2.0;
                    tmp[3] = (extent[3] + extent[1]) / 2.0 + 35000 / 2.0;
                }
                return [tmp];
            },
        });
        this.category_map = {};
        this.category_id = 0;
        this.occupied_xy = {};
        this.loadCounter = 0;
        this.loadTotal = 0;
        this.legend_categories = this.category_map;
    }
}

class HsDialogItem {
    constructor(component, data) {
        this.component = component;
        this.data = data;
    }
    waitResult() {
        const promise = new Promise((resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;
        });
        return promise;
    }
}
/*
Copyright Google LLC. All Rights Reserved.
Use of this source code is governed by an MIT-style license that
can be found in the LICENSE file at http://angular.io/license
*/

class HsDialogContainerService {
    constructor() {
        this.dialogs = [];
        this.dialogObserver = new Subject();
        this.dialogDestroyObserver = new Subject();
    }
    create(component, data) {
        const item = new HsDialogItem(component, data);
        this.dialogObserver.next(item);
        return item;
    }
    destroy(component) {
        this.dialogDestroyObserver.next(component);
    }
}
HsDialogContainerService.ɵfac = function HsDialogContainerService_Factory(t) { return new (t || HsDialogContainerService)(); };
HsDialogContainerService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HsDialogContainerService_Factory() { return new HsDialogContainerService(); }, token: HsDialogContainerService, providedIn: "root" });
HsDialogContainerService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsDialogContainerService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class HsGetCapabilitiesErrorComponent {
    constructor(hsDialogContainerService) {
        this.hsDialogContainerService = hsDialogContainerService;
    }
    ngOnInit() {
        this.capabilitiesErrorModalVisible = true;
    }
    close() {
        this.hsDialogContainerService.destroy(this);
    }
}
HsGetCapabilitiesErrorComponent.ɵfac = function HsGetCapabilitiesErrorComponent_Factory(t) { return new (t || HsGetCapabilitiesErrorComponent)(ɵngcc0.ɵɵdirectiveInject(HsDialogContainerService)); };
HsGetCapabilitiesErrorComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsGetCapabilitiesErrorComponent, selectors: [["hs-get-capabilities-error"]], inputs: { data: "data" }, decls: 23, vars: 13, consts: [["tabindex", "-1", "role", "dialog", "aria-hidden", "true", 1, "modal", "in", "hs-ows-wms-capabilities-error"], [1, "modal-dialog"], [1, "modal-content"], [1, "modal-header", "bg-danger", "text-white", 2, "opacity", "0.9"], [1, "modal-title", "text-uppercase"], ["type", "button", "data-dismiss", "modal", 1, "close", 3, "click"], ["aria-hidden", "true"], [1, "sr-only"], [1, "modal-body", 2, "max-height", "600px", "overflow-y", "auto"], [1, "modal-footer"], ["type", "button", "data-dismiss", "modal", 1, "btn", "btn-secondary", 3, "click"]], template: function HsGetCapabilitiesErrorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelementStart(4, "h4", 4);
        ɵngcc0.ɵɵtext(5);
        ɵngcc0.ɵɵpipe(6, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "button", 5);
        ɵngcc0.ɵɵlistener("click", function HsGetCapabilitiesErrorComponent_Template_button_click_7_listener() { return ctx.close(); });
        ɵngcc0.ɵɵelementStart(8, "span", 6);
        ɵngcc0.ɵɵtext(9, "\u00D7");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "span", 7);
        ɵngcc0.ɵɵtext(11);
        ɵngcc0.ɵɵpipe(12, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(13, "div", 8);
        ɵngcc0.ɵɵelementStart(14, "p");
        ɵngcc0.ɵɵtext(15);
        ɵngcc0.ɵɵpipe(16, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(17, "p");
        ɵngcc0.ɵɵtext(18);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(19, "div", 9);
        ɵngcc0.ɵɵelementStart(20, "button", 10);
        ɵngcc0.ɵɵlistener("click", function HsGetCapabilitiesErrorComponent_Template_button_click_20_listener() { return ctx.close(); });
        ɵngcc0.ɵɵtext(21);
        ɵngcc0.ɵɵpipe(22, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(6, 5, "ADDLAYERS.capabilitiesParsingProblem"), " ");
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(12, 7, "COMMON.close"));
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(16, 9, "ADDLAYERS.ERROR.thereWasErrorWhile"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.data);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(22, 11, "COMMON.close"));
    } }, pipes: [ɵngcc1.TranslatePipe], encapsulation: 2 });
HsGetCapabilitiesErrorComponent.ctorParameters = () => [
    { type: HsDialogContainerService }
];
HsGetCapabilitiesErrorComponent.propDecorators = {
    data: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsGetCapabilitiesErrorComponent, [{
        type: Component,
        args: [{
                selector: 'hs-get-capabilities-error',
                template: "<div class=\"modal in hs-ows-wms-capabilities-error\" tabindex=\"-1\" role=\"dialog\"  aria-hidden=\"true\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header bg-danger text-white\" style=\"opacity: 0.9;\">\n                <h4 class=\"modal-title text-uppercase\">\n                    {{'ADDLAYERS.capabilitiesParsingProblem' | translate}}\n                </h4>\n                <button type=\"button\" (click)=\"close()\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">{{'COMMON.close' | translate}}</span></button>\n            </div>\n            <div class=\"modal-body\" style=\"max-height:600px; overflow-y:auto\">\n                <p>{{'ADDLAYERS.ERROR.thereWasErrorWhile' | translate}}</p>\n                <p>{{data}}</p>\n            </div>\n            <div class=\"modal-footer\" >\n                <button type=\"button\" class=\"btn btn-secondary\" (click)=\"close()\" data-dismiss=\"modal\">{{'COMMON.close' | translate}}</button>\n            </div>\n        </div>\n    </div>\n</div>\n"
            }]
    }], function () { return [{ type: HsDialogContainerService }]; }, { data: [{
            type: Input
        }] }); })();

class HsAddDataUrlService {
    constructor(hsLog, hsLanguageService, hsDialogContainerService, hsLayoutService) {
        this.hsLog = hsLog;
        this.hsLanguageService = hsLanguageService;
        this.hsDialogContainerService = hsDialogContainerService;
        this.hsLayoutService = hsLayoutService;
        this.addDataCapsParsingError = new Subject();
        this.addDataCapsParsingError.subscribe((e) => {
            this.hsLog.warn(e);
            let error = e.toString();
            if (error.includes('property')) {
                error = this.hsLanguageService.getTranslationIgnoreNonExisting('ADDLAYERS', 'serviceTypeNotMatching');
            }
            this.hsDialogContainerService.create(HsGetCapabilitiesErrorComponent, error);
        });
    }
    /**
     * Selects a service layer to be added (WMS | WMTS | ArcGIS Map Server)
     * @param services - Layer group of a service to select a layer from
     * @param layerToSelect - Layer to be selected (checked = true)
     * @param selector - Layer selector. Can be either 'Name' or 'Title'. Differs in between different services
     */
    selectLayerByName(layerToSelect, services, selector) {
        if (!layerToSelect) {
            return;
        }
        let selectedLayer;
        if (Array.isArray(services)) {
            for (const serviceLayer of services) {
                selectedLayer = this.selectSubLayerByName(layerToSelect, serviceLayer, selector);
            }
        }
        else {
            selectedLayer = this.selectSubLayerByName(layerToSelect, services, selector);
        }
        return selectedLayer;
    }
    /**
     * Helper function for selectLayerByName()
     */
    selectSubLayerByName(layerToSelect, serviceLayer, selector) {
        let selectedLayer;
        if (serviceLayer.Layer && serviceLayer.Name != layerToSelect) {
            selectedLayer = this.selectLayerByName(layerToSelect, serviceLayer.Layer, selector);
        }
        else {
            selectedLayer = this.setLayerCheckedTrue(layerToSelect, serviceLayer, selector);
        }
        return selectedLayer;
    }
    /**
     * Helper function for selectLayerByName()
     * Does the actual selection (checked = true)
     */
    setLayerCheckedTrue(layerToSelect, serviceLayer, selector) {
        if (serviceLayer[selector] == layerToSelect) {
            serviceLayer.checked = true;
            this.scrollToLayer(serviceLayer[selector]);
        }
        return serviceLayer;
    }
    scrollToLayer(name) {
        setTimeout(() => {
            const id = `#hs-add-layer-${name}`;
            const el = this.hsLayoutService.contentWrapper.querySelector(id);
            if (el) {
                el.scrollIntoView();
            }
        }, 1000);
    }
    searchForChecked(services) {
        this.hasAnyChecked = services.some((service) => service.checked);
    }
}
HsAddDataUrlService.ɵfac = function HsAddDataUrlService_Factory(t) { return new (t || HsAddDataUrlService)(ɵngcc0.ɵɵinject(HsLogService), ɵngcc0.ɵɵinject(HsLanguageService), ɵngcc0.ɵɵinject(HsDialogContainerService), ɵngcc0.ɵɵinject(HsLayoutService)); };
HsAddDataUrlService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HsAddDataUrlService_Factory() { return new HsAddDataUrlService(i0.ɵɵinject(HsLogService), i0.ɵɵinject(HsLanguageService), i0.ɵɵinject(HsDialogContainerService), i0.ɵɵinject(HsLayoutService)); }, token: HsAddDataUrlService, providedIn: "root" });
HsAddDataUrlService.ctorParameters = () => [
    { type: HsLogService },
    { type: HsLanguageService },
    { type: HsDialogContainerService },
    { type: HsLayoutService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsAddDataUrlService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: HsLogService }, { type: HsLanguageService }, { type: HsDialogContainerService }, { type: HsLayoutService }]; }, null); })();

//Move to common/dimensions
class HsDimensionDescriptor {
    //Original dimension object can be shared between multiple layers.
    constructor(name, originalDimension) {
        var _a, _b, _c;
        this.name = name;
        this.originalDimension = originalDimension;
        this.type = this.originalDimension.type;
        this.value = (_a = this.originalDimension.value) !== null && _a !== void 0 ? _a : this.originalDimension.default;
        this.modelValue =
            (_b = this.originalDimension.value) !== null && _b !== void 0 ? _b : this.originalDimension.default;
        // Duck-type check if the passed value is an instance of Date.
        if (typeof ((_c = this.value) === null || _c === void 0 ? void 0 : _c.getMonth) == 'function') {
            if (this.type == 'datetime') {
                this.modelValue = {
                    year: this.value.getFullYear(),
                    month: this.value.getMonth() + 1,
                    day: this.value.getDate(),
                };
                this.modelTimeValue = {
                    hour: this.value.getHours(),
                    minute: this.value.getMinutes(),
                };
            }
            if (this.type == 'date') {
                this.modelValue = {
                    year: this.value.getFullYear(),
                    month: this.value.getMonth() + 1,
                    day: this.value.getDate(),
                };
            }
        }
        this.label = this.originalDimension.label;
        this.values = this.originalDimension.values;
        this.format = this.originalDimension.format;
    }
    /* This is needed because ng-bootstrap datepicker sets value to
      object {year:.., month: .., day: ..} but we need vanillaJs Date
      in dimension.value attribute instead. Use the complex value only
      for picker through modelValue */
    postProcessDimensionValue() {
        var _a, _b;
        if (this.modelValue.year && this.modelValue.month) {
            this.originalDimension.value = new Date(this.modelValue.year, this.modelValue.month - 1, this.modelValue.day, (_a = this.modelTimeValue) === null || _a === void 0 ? void 0 : _a.hour, (_b = this.modelTimeValue) === null || _b === void 0 ? void 0 : _b.minute);
        }
        else {
            this.originalDimension.value = this.modelValue;
        }
        if (['datetime', 'date'].includes(this.type) && this.format) {
            this.originalDimension.value = dayjs(this.originalDimension.value).format(this.format);
        }
        this.value = this.originalDimension.value;
    }
}

class HsDimensionTimeService {
    constructor(hsLog, HsUtilsService) {
        this.hsLog = hsLog;
        this.HsUtilsService = HsUtilsService;
        /**
         * To communicate changes between this service and HsDimensionService
         */
        this.layerTimeChanges = new Subject();
    }
    /**
     * Parse interval string to get interval as a number
     * @param interval - Interval time string
     * @returns - Number of milliseconds representing the interval
     */
    parseInterval(interval) {
        let dateComponent;
        let timeComponent;
        let year;
        let month;
        let day;
        let hour;
        let minute;
        let second;
        // eslint-disable-next-line no-multi-assign
        year = month = day = hour = minute = second = 0;
        const indexOfT = interval.search('T');
        if (indexOfT > -1) {
            dateComponent = interval.substring(1, indexOfT);
            timeComponent = interval.substring(indexOfT + 1);
        }
        else {
            dateComponent = interval.substring(1);
        }
        // parse date
        if (dateComponent) {
            const indexOfY = dateComponent.search('Y') > -1 ? dateComponent.search('Y') : undefined;
            const indexOfM = dateComponent.search('M') > -1 ? dateComponent.search('M') : undefined;
            const indexOfD = dateComponent.search('D') > -1 ? dateComponent.search('D') : undefined;
            if (indexOfY !== undefined) {
                year = parseFloat(dateComponent.substring(0, indexOfY));
            }
            if (indexOfM !== undefined) {
                month = parseFloat(dateComponent.substring((indexOfY || -1) + 1, indexOfM));
            }
            if (indexOfD !== undefined) {
                day = parseFloat(dateComponent.substring((indexOfM || indexOfY || -1) + 1, indexOfD));
            }
        }
        // parse time
        if (timeComponent) {
            const indexOfH = timeComponent.search('H') > -1 ? timeComponent.search('H') : undefined;
            const indexOfm = timeComponent.search('M') > -1 ? timeComponent.search('M') : undefined;
            const indexOfS = timeComponent.search('S') > -1 ? timeComponent.search('S') : undefined;
            if (indexOfH !== undefined) {
                hour = parseFloat(timeComponent.substring(0, indexOfH));
            }
            if (indexOfm !== undefined) {
                minute = parseFloat(timeComponent.substring((indexOfH || -1) + 1, indexOfm));
            }
            if (indexOfS !== undefined) {
                second = parseFloat(timeComponent.substring((indexOfm || indexOfH || -1) + 1, indexOfS));
            }
        }
        // year, month, day, hours, minutes, seconds, milliseconds)
        const zero = new Date(0, 0, 0, 0, 0, 0, 0).getTime();
        const step = new Date(year, month, day, hour, minute, second, 0).getTime();
        return step - zero;
    }
    /**
     * Test if WMS layer has time support (WMS-T). WMS layer has to have dimension property
     * @param layer - Container object of layer (layerContainer.layer expected)
     * @returns True for WMS layer with time support
     */
    layerIsWmsT(layer) {
        var _a, _b;
        const olLayer = (_a = layer.layer) !== null && _a !== void 0 ? _a : layer;
        if (!olLayer) {
            return false;
        }
        if (layer.time) {
            return true;
        }
        /*
         * 'dimensions_time' is deprecated
         * backwards compatibility with HSL < 3.0
         */
        if (olLayer.get('dimensions_time') &&
            Array.isArray(olLayer.get('dimensions_time').timeInterval)) {
            this.hsLog.warn('"dimensions_time" is deprecated, use "dimensions" param with "time" object instead');
            const currentDimensions = getDimensions(olLayer);
            const newTimeDimension = {
                label: 'time',
                default: olLayer.get('dimensions_time').value,
            };
            if (!currentDimensions) {
                setDimensions(olLayer, { 'time': newTimeDimension });
            }
            else {
                setDimensions(olLayer, Object.assign(currentDimensions, { 'time': newTimeDimension }));
            }
        }
        if ((_b = getDimensions(olLayer)) === null || _b === void 0 ? void 0 : _b.time) {
            return true;
        }
        return false;
    }
    //TODO: just copy-pasted from "layerIsWmsT()", needs clean-up FIXME: delete
    parseDimensionParam(layer) {
        const dimensions = getDimensions(layer);
        if (dimensions && dimensions['time']) {
            const timedata = {};
            let value = dimensions['time'].values || dimensions['time'].value;
            if (Array.isArray(value)) {
                value = value[0];
            }
            if (typeof value === 'string' ||
                this.HsUtilsService.instOf(value, String)) {
                value = value.replace(/\s*/g, '');
                if (value.search('/') > -1) {
                    const interval = value.split('/').map((d) => {
                        if (d.search('Z') > -1) {
                            d = d.replace('Z', '00:00');
                        }
                        return d;
                    });
                    if (interval.length == 3) {
                        timedata.timeStep = this.parseInterval(interval[2]);
                        interval.pop();
                    }
                    if (interval.length == 2) {
                        timedata.timeInterval = interval;
                    }
                }
            }
        }
    }
    /**
     * Make initial setup for WM(T)S-t layers
     * @param currentLayer - Layer for which the time is being set up
     * @param serviceLayer - Description of that layer's capabilities in a service
     */
    setupTimeLayer(currentLayer, serviceLayer) {
        var _a, _b;
        const olLayer = currentLayer.layer;
        //parse config set at a Layer level
        const hsLayerTimeConfig = (_a = getDimensions(olLayer)) === null || _a === void 0 ? void 0 : _a.time;
        //parse parametres available at the WM(T)S level
        let serviceLayerTimeConfig;
        if (serviceLayer) {
            if (!Array.isArray(serviceLayer.Dimension)) {
                serviceLayerTimeConfig = serviceLayer.Dimension;
            }
            else {
                serviceLayerTimeConfig = (_b = serviceLayer.Dimension) === null || _b === void 0 ? void 0 : _b.find((dim) => dim.name == 'time'); // Let's assume there will be only one time dimension..
            }
        }
        else if (hsLayerTimeConfig) {
            serviceLayerTimeConfig = hsLayerTimeConfig;
        }
        const timePoints = Array.isArray(serviceLayerTimeConfig.values)
            ? serviceLayerTimeConfig.values
            : this.parseTimePoints(serviceLayerTimeConfig.values);
        // Gracefully fallback through time settings to find the best default value
        let today = new Date().toISOString();
        today = today.slice(0, today.indexOf('T'));
        let defaultTime;
        if (timePoints.includes(hsLayerTimeConfig === null || hsLayerTimeConfig === void 0 ? void 0 : hsLayerTimeConfig.default)) {
            defaultTime = hsLayerTimeConfig.default;
        }
        else if (timePoints.includes(serviceLayerTimeConfig === null || serviceLayerTimeConfig === void 0 ? void 0 : serviceLayerTimeConfig.default)) {
            defaultTime = serviceLayerTimeConfig.default;
        }
        else if (timePoints.some((point) => point.startsWith(today))) {
            defaultTime = timePoints.find((point) => point.startsWith(today));
        }
        else {
            defaultTime = timePoints[0];
        }
        currentLayer.time = {
            default: defaultTime,
            timePoints,
            //time_unit: hsLayerTimeConfig.timeUnit, //TODO: cleanup this
        };
        this.polyfillLayerDimensionsValues(currentLayer);
        this.setLayerTime(currentLayer, defaultTime);
    }
    /**
     * Update layer TIME parameter
     * @param currentLayer - Selected layer
     * @param newTime - ISO8601 string of a date and time to set
     */
    setLayerTime(currentLayer, newTime) {
        if (currentLayer === undefined || currentLayer.layer === undefined) {
            return;
        }
        this.layerTimeChanges.next({
            layer: currentLayer,
            time: newTime,
        });
    }
    /**
     * Reads a time dimension definition and transforms it into a canonical form of an array of time points
     * @param values - Stringified time definition. Either defined by a list of values or by an ISO 8601 duration pattern
     * @returns Array of time points in ISO 8601 format
     */
    parseTimePoints(values) {
        values = values.trim();
        if (values.includes('/')) {
            const timeValues = values.split('/');
            if (timeValues.length == 3 && timeValues[2].trim().startsWith('P')) {
                // Duration, pattern: "1999-01-22T19:00:00/2018-01-22T13:00:00/PT8766H"
                return this.timePointsFromInterval(timeValues[0], timeValues[1], this.parseInterval(timeValues[2]));
            }
            else if (timeValues.length == 2) {
                // Duration, pattern: "1999-01-22T19:00:00/2018-01-22T13:00:00"
                // Daily interval is a pure guessing here and might be overkill for common cases
                // TODO: => try better guessing
                return this.timePointsFromInterval(timeValues[0], timeValues[1], 24 * 60 * 60 * 1000);
            }
            else {
                throw new Error(`Invalid ISO8601 time definition provided: ${values}`);
            }
        }
        return values.split(',');
    }
    /**
     * Because of the way the HsDimension interface is set up,
     * we need to fill all parsed and currently undefined values
     * into the "dimensions" property of OL Layer as well.
     * Nevertheless we are duplicating some information.
     */
    polyfillLayerDimensionsValues(layerDescriptor) {
        var _a, _b, _c, _d;
        const dimensionTimeProp = getDimensions(layerDescriptor.layer).time;
        dimensionTimeProp.label = (_a = dimensionTimeProp.label) !== null && _a !== void 0 ? _a : 'time';
        dimensionTimeProp.default =
            (_b = dimensionTimeProp.default) !== null && _b !== void 0 ? _b : layerDescriptor.time.default;
        dimensionTimeProp.value =
            (_c = dimensionTimeProp.value) !== null && _c !== void 0 ? _c : layerDescriptor.time.default;
        dimensionTimeProp.values =
            (_d = dimensionTimeProp.values) !== null && _d !== void 0 ? _d : layerDescriptor.time.timePoints;
    }
    timePointsFromInterval(start, end, step) {
        const timePoints = [];
        const endMillis = new Date(end).getTime();
        let tempMillis = new Date(start).getTime();
        while (tempMillis <= endMillis) {
            timePoints.push(new Date(tempMillis).toISOString());
            tempMillis += step;
        }
        return timePoints;
    }
}
HsDimensionTimeService.ɵfac = function HsDimensionTimeService_Factory(t) { return new (t || HsDimensionTimeService)(ɵngcc0.ɵɵinject(HsLogService), ɵngcc0.ɵɵinject(HsUtilsService)); };
HsDimensionTimeService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HsDimensionTimeService_Factory() { return new HsDimensionTimeService(i0.ɵɵinject(HsLogService), i0.ɵɵinject(HsUtilsService)); }, token: HsDimensionTimeService, providedIn: "root" });
HsDimensionTimeService.ctorParameters = () => [
    { type: HsLogService },
    { type: HsUtilsService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsDimensionTimeService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: HsLogService }, { type: HsUtilsService }]; }, null); })();

class HsDimensionService {
    constructor($log, hsDimensionTimeService, hsEventBusService, hsLayerUtilsService, hsMapService, hsUtilsService) {
        this.$log = $log;
        this.hsDimensionTimeService = hsDimensionTimeService;
        this.hsEventBusService = hsEventBusService;
        this.hsLayerUtilsService = hsLayerUtilsService;
        this.hsMapService = hsMapService;
        this.hsUtilsService = hsUtilsService;
        this.hsDimensionTimeService.layerTimeChanges.subscribe(({ layer: layerDescriptor, time: newTime }) => {
            var _a;
            const dimensions = getDimensions(layerDescriptor.layer);
            if (dimensions && (dimensions['time'] || dimensions['TIME'])) {
                const dimensionDesc = new HsDimensionDescriptor('time', (_a = dimensions['time']) !== null && _a !== void 0 ? _a : dimensions['TIME']);
                dimensionDesc.modelValue = newTime;
                this.dimensionChanged(dimensionDesc);
            }
        });
    }
    getDimensionValues(dimension) {
        try {
            if (typeof dimension.values === 'string') {
                return this.hsDimensionTimeService.parseTimePoints(dimension.values);
            }
            else {
                return dimension.values;
            }
        }
        catch (ex) {
            this.$log.error(ex);
        }
    }
    paramsFromDimensions(layer) {
        if (!layer.Dimension) {
            return;
        }
        const tmp = {};
        for (const dimension of layer.Dimension) {
            if (dimension.value) {
                tmp[dimension.name] = dimension.value;
            }
        }
        return tmp;
    }
    dimensionType(dimension) {
        if (dimension.type == undefined) {
            return null;
        }
        return dimension.type;
    }
    /**
     * A recursive function with goes through layers
     * children and sets the possible dimension values used in dropdown.
     *
     * @param layer - Layer to fill the dimension values
     */
    fillDimensionValues(layer) {
        if (!Array.isArray(layer.Layer)) {
            return;
        }
        if (this.hsLayerUtilsService.hasNestedLayers(layer) &&
            Array.isArray(layer.Layer)) {
            for (const sublayer of layer.Layer) {
                this.fillDimensionValues(sublayer);
            }
        }
        if (layer.Dimension && Array.isArray(layer.Dimension)) {
            for (const dimension of layer.Dimension) {
                /* Since we augment the 'values' property here in the WmsLayer definition
                 * it shall not be needed again in the HsDimensionTimeService.setupTimeLayer()
                 */
                dimension.values = this.getDimensionValues(dimension);
            }
        }
    }
    dimensionChanged(dimension) {
        dimension.postProcessDimensionValue();
        //Dimension can be linked to multiple layers
        for (const layer of this.hsMapService.getLayersArray()) {
            const iteratedDimensions = getDimensions(layer);
            if (iteratedDimensions &&
                Object.keys(iteratedDimensions).filter((dimensionIterator) => iteratedDimensions[dimensionIterator] == dimension.originalDimension).length > 0 //Dimension also linked to this layer?
            ) {
                const src = layer.getSource();
                if (this.hsLayerUtilsService.isLayerWMS(layer)) {
                    const params = this.hsLayerUtilsService.getLayerParams(layer);
                    params[dimension.name == 'time' ? 'TIME' : dimension.name] =
                        dimension.value;
                    this.hsLayerUtilsService.updateLayerParams(layer, params);
                }
                else if (this.hsUtilsService.instOf(src, XYZ)) {
                    src.refresh();
                }
                this.hsEventBusService.layermanagerDimensionChanges.next({
                    layer,
                    dimension: dimension.originalDimension,
                });
            }
        }
    }
    /**
     * Test if layer has dimensions
     * @param layer - OL Layer
     * @returns true if layer has any dimensions
     */
    isLayerWithDimensions(layer) {
        if (!layer) {
            return false;
        }
        const dimensions = getDimensions(layer);
        if (dimensions === undefined) {
            return false;
        }
        return (Object.keys(dimensions).filter((k) => {
            return k == 'time' ? dimensions[k].onlyInEditor : true;
        }).length > 0);
    }
}
HsDimensionService.ɵfac = function HsDimensionService_Factory(t) { return new (t || HsDimensionService)(ɵngcc0.ɵɵinject(HsLogService), ɵngcc0.ɵɵinject(HsDimensionTimeService), ɵngcc0.ɵɵinject(HsEventBusService), ɵngcc0.ɵɵinject(HsLayerUtilsService), ɵngcc0.ɵɵinject(HsMapService), ɵngcc0.ɵɵinject(HsUtilsService)); };
HsDimensionService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HsDimensionService_Factory() { return new HsDimensionService(i0.ɵɵinject(HsLogService), i0.ɵɵinject(HsDimensionTimeService), i0.ɵɵinject(HsEventBusService), i0.ɵɵinject(HsLayerUtilsService), i0.ɵɵinject(HsMapService), i0.ɵɵinject(HsUtilsService)); }, token: HsDimensionService, providedIn: "root" });
HsDimensionService.ctorParameters = () => [
    { type: HsLogService },
    { type: HsDimensionTimeService },
    { type: HsEventBusService },
    { type: HsLayerUtilsService },
    { type: HsMapService },
    { type: HsUtilsService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsDimensionService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: HsLogService }, { type: HsDimensionTimeService }, { type: HsEventBusService }, { type: HsLayerUtilsService }, { type: HsMapService }, { type: HsUtilsService }]; }, null); })();

class HsAddDataCommonUrlService {
    constructor(hsMapService, hsAddDataUrlService, hsToastService, hsAddDataService, hsDimensionService) {
        this.hsMapService = hsMapService;
        this.hsAddDataUrlService = hsAddDataUrlService;
        this.hsToastService = hsToastService;
        this.hsAddDataService = hsAddDataService;
        this.hsDimensionService = hsDimensionService;
        this.loadingInfo = false;
        this.showDetails = false;
        //TODO: all dimension related things need to be refactored into separate module
        this.getDimensionValues = this.hsDimensionService.getDimensionValues;
        this.hsAddDataService.cancelUrlRequest.subscribe(() => {
            this.clear();
        });
    }
    clear() {
        this.layerToSelect = '';
        this.loadingInfo = false;
        this.showDetails = false;
        this.url = '';
    }
    /**
     * For the sake of possible future implementation changes
     * @param url - URL to be set
     */
    updateUrl(url) {
        this.url = url;
    }
    displayParsingError(e) {
        if ((e === null || e === void 0 ? void 0 : e.status) === 401) {
            this.hsToastService.createToastPopupMessage('ADDLAYERS.capabilitiesParsingProblem', 'ADDLAYERS.unauthorizedAccess', { serviceCalledFrom: 'HsAddDataCommonUrlService' });
        }
        else {
            this.hsAddDataUrlService.addDataCapsParsingError.next(e);
        }
    }
    throwParsingError(e) {
        this.clear();
        this.displayParsingError(e);
    }
    //NOTE* - Is this method even needed?
    srsChanged(srs) {
        setTimeout(() => {
            return !this.currentProjectionSupported([srs]);
        }, 0);
    }
    /**
     * Test if current map projection is in supported projection list
     *
     * @param srss - List of supported projections
     * @returns True if map projection is in list, otherwise false
     */
    currentProjectionSupported(srss) {
        if (!srss || srss.length === 0) {
            return false;
        }
        let found = false;
        for (const val of srss) {
            if (!val) {
                found = false;
            }
            else {
                if (this.hsMapService.map
                    .getView()
                    .getProjection()
                    .getCode()
                    .toUpperCase() == val.toUpperCase()) {
                    found = true;
                }
            }
        }
        return found;
    }
    /**
     * Constructs body of LAYER parameter for getMap request
     * @param layerOrLayers - layer object or layers received from capabilities. If no layer is provided
     * merge all checked layer ids into one string
     * @param property - layer property
     * @returns
     */
    createBasemapName(layerOrLayers, property) {
        let baseName = '';
        if (Array.isArray(layerOrLayers)) {
            for (const layer of layerOrLayers) {
                if (layer.checked) {
                    baseName = layer[property];
                    break;
                }
                else {
                    if (layer.Layer) {
                        baseName = baseName.concat(this.createBasemapName(layer.Layer, property));
                    }
                }
            }
        }
        else {
            baseName = layerOrLayers[property];
        }
        return baseName;
    }
    /**
     * @param service -
     */
    getSublayerNames(service) {
        if (service.Layer) {
            return service.Layer.map((l) => {
                const tmp = {};
                if (l.Name) {
                    tmp.name = l.Name;
                }
                if (l.Layer) {
                    tmp.children = this.getSublayerNames(l);
                }
                return tmp;
            });
        }
        else {
            return [];
        }
    }
}
HsAddDataCommonUrlService.ɵfac = function HsAddDataCommonUrlService_Factory(t) { return new (t || HsAddDataCommonUrlService)(ɵngcc0.ɵɵinject(HsMapService), ɵngcc0.ɵɵinject(HsAddDataUrlService), ɵngcc0.ɵɵinject(HsToastService), ɵngcc0.ɵɵinject(HsAddDataService), ɵngcc0.ɵɵinject(HsDimensionService)); };
HsAddDataCommonUrlService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HsAddDataCommonUrlService_Factory() { return new HsAddDataCommonUrlService(i0.ɵɵinject(HsMapService), i0.ɵɵinject(HsAddDataUrlService), i0.ɵɵinject(HsToastService), i0.ɵɵinject(HsAddDataService), i0.ɵɵinject(HsDimensionService)); }, token: HsAddDataCommonUrlService, providedIn: "root" });
HsAddDataCommonUrlService.ctorParameters = () => [
    { type: HsMapService },
    { type: HsAddDataUrlService },
    { type: HsToastService },
    { type: HsAddDataService },
    { type: HsDimensionService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsAddDataCommonUrlService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: HsMapService }, { type: HsAddDataUrlService }, { type: HsToastService }, { type: HsAddDataService }, { type: HsDimensionService }]; }, null); })();

class HsQueryBaseService {
    constructor(HsMapService, HsConfig, HsLayoutService, hsLanguageService, HsUtilsService, HsEventBusService, HsSaveMapService, DomSanitizer, zone) {
        this.HsMapService = HsMapService;
        this.HsConfig = HsConfig;
        this.HsLayoutService = HsLayoutService;
        this.hsLanguageService = hsLanguageService;
        this.HsUtilsService = HsUtilsService;
        this.HsEventBusService = HsEventBusService;
        this.HsSaveMapService = HsSaveMapService;
        this.DomSanitizer = DomSanitizer;
        this.zone = zone;
        this.data = {
            attributes: [],
            features: [],
            featureInfoHtmls: [],
            customFeatures: [],
            coordinates: [],
        };
        this.queryActive = false;
        this.popupClassname = '';
        this.selector = null;
        this.currentQuery = null;
        this.featuresUnderMouse = [];
        this.featureLayersUnderMouse = [];
        this.dataCleared = true;
        this.queryPoint = new Point([0, 0]);
        this.queryLayer = new VectorLayer({
            properties: {
                title: 'Point clicked',
                queryable: false,
                showInLayerManager: false,
                removable: false,
            },
            source: new Vector({
                features: [
                    new Feature$1({
                        geometry: this.queryPoint,
                    }),
                ],
            }),
            style: (feature) => this.pointClickedStyle(feature),
        });
        this.nonQueryablePanels = [
            'measure',
            'composition_browser',
            'analysis',
            'sensors',
            // 'draw',
            'tripPlanner',
        ];
        this.getFeatureInfoStarted = new Subject();
        this.getFeatureInfoCollected = new Subject();
        this.queryStatusChanges = new Subject();
        this.vectorSelectorCreated = new Subject();
        this.vectorSelectorCreated.subscribe((selector) => {
            this.selector = selector;
        });
        this.HsMapService.loaded().then(() => this.init());
    }
    /**
     *
     */
    init() {
        this.map = this.HsMapService.map;
        this.activateQueries();
        this.map.on('singleclick', (evt) => {
            this.zone.run(() => {
                this.HsEventBusService.mapClicked.next(Object.assign(evt, {
                    coordinates: this.getCoordinate(evt.coordinate),
                }));
                if (!this.queryActive) {
                    return;
                }
                this.popupClassname = '';
                if (!this.dataCleared) {
                    this.clearData();
                }
                this.dataCleared = false;
                this.currentQuery = (Math.random() + 1).toString(36).substring(7);
                this.setData(this.getCoordinate(evt.coordinate), 'coordinates', true);
                this.last_coordinate_clicked = evt.coordinate; //It is used in some examples and apps
                this.data.selectedProj = this.data.coordinates[0].projections[0];
                this.getFeatureInfoStarted.next(evt);
            });
        });
        if (this.HsConfig.popUpDisplay && this.HsConfig.popUpDisplay === 'hover') {
            this.map.on('pointermove', this.HsUtilsService.debounce(this.showPopUp, 200, false, this));
        }
        else if (this.HsConfig.popUpDisplay &&
            this.HsConfig.popUpDisplay === 'click') {
            this.map.on('singleclick', this.HsUtilsService.debounce(this.showPopUp, 200, false, this));
        } /* else none */
    }
    /**
     * @param e Event, which triggered this function
     */
    showPopUp(e) {
        var _a, _b;
        // The latter case happens when hovering over the pop-up itself
        if (e.dragging || ((_b = (_a = e.originalEvent) === null || _a === void 0 ? void 0 : _a.target) === null || _b === void 0 ? void 0 : _b.tagName) != 'CANVAS') {
            return;
        }
        if (!this.queryActive) {
            return;
        }
        const map = e.map;
        const tmpFeatures = this.getFeaturesUnderMouse(map, e.pixel);
        if (tmpFeatures.some((f) => !this.featuresUnderMouse.includes(f)) ||
            this.featuresUnderMouse.some((f) => !tmpFeatures.includes(f))) {
            this.zone.run(() => {
                this.featuresUnderMouse = tmpFeatures;
                if (this.featuresUnderMouse.length) {
                    this.featureLayersUnderMouse = this.featuresUnderMouse.map((f) => this.HsMapService.getLayerForFeature(f));
                    this.featureLayersUnderMouse = this.HsUtilsService.removeDuplicates(this.featureLayersUnderMouse, 'title');
                    this.featureLayersUnderMouse = this.featureLayersUnderMouse.map((l) => {
                        const layer = {
                            title: getTitle(l),
                            layer: l,
                            features: this.featuresUnderMouse.filter((f) => this.HsMapService.getLayerForFeature(f) == l),
                        };
                        return layer;
                    });
                }
                else {
                    this.featuresUnderMouse = [];
                }
            });
        }
        const pixel = e.pixel;
        pixel[0] += 2;
        pixel[1] += 4;
        this.hoverPopup.setPosition(map.getCoordinateFromPixel(e.pixel));
    }
    getFeaturesUnderMouse(map, pixel) {
        return map
            .getFeaturesAtPixel(pixel)
            .filter((feature) => {
            const layer = this.HsMapService.getLayerForFeature(feature);
            return layer && layer != this.queryLayer;
        });
    }
    /**
     * @param feature
     */
    serializeFeatureAttributes(feature) {
        var _a;
        const attributesForHover = [];
        const layer = this.HsMapService.getLayerForFeature(feature);
        if (layer === undefined) {
            return;
        }
        let attrsConfig = [];
        if ((_a = getPopUp(layer)) === null || _a === void 0 ? void 0 : _a.attributes) {
            //must be an array
            attrsConfig = getPopUp(layer).attributes;
        }
        else {
            // Layer is not configured to show pop-ups
            return;
        }
        for (const attr of attrsConfig) {
            let attrName, attrLabel;
            let attrFunction = (x) => x;
            if (typeof attr === 'string' || attr instanceof String) {
                //simple case when only attribute name is provided in the layer config
                attrName = attr;
                attrLabel = attr;
            }
            else {
                if (attr.attribute == undefined) {
                    //implies malformed layer config - 'attribute' is obligatory in this case
                    continue;
                }
                attrName = attr.attribute;
                attrLabel = attr.label != undefined ? attr.label : attr.attribute;
                if (attr.displayFunction) {
                    attrFunction = attr.displayFunction;
                }
            }
            if (feature.get(attrName)) {
                attributesForHover.push({
                    key: attrLabel,
                    value: feature.get(attrName),
                    displayFunction: attrFunction,
                });
            }
        }
        return attributesForHover;
    }
    setData(data, type, overwrite) {
        if (type) {
            if (overwrite) {
                this.data[type].length = 0;
            }
            if (Array.isArray(data)) {
                this.data[type] = this.data[type].concat(data);
            }
            else {
                this.data[type].push(data);
            }
            this.HsEventBusService.queryDataUpdated.next(this.data);
        }
        else if (console) {
            console.log('Query.BaseService.setData type not passed');
        }
    }
    clearData(type) {
        if (type) {
            this.data[type].length = 0;
        }
        else {
            this.data.attributes.length = 0;
            this.data.features.length = 0;
            this.data.coordinates.length = 0;
            this.data.featureInfoHtmls = [];
            this.data.customFeatures = [];
        }
        const invisiblePopup = this.getInvisiblePopup();
        if (invisiblePopup) {
            invisiblePopup.contentDocument.body.innerHTML = '';
            invisiblePopup.style.height = '0px';
            invisiblePopup.style.width = '0px';
        }
        this.dataCleared = true;
    }
    getInvisiblePopup() {
        if (this.HsUtilsService.runningInBrowser()) {
            return document.getElementById('invisible_popup');
        }
    }
    pushFeatureInfoHtml(html) {
        this.data.featureInfoHtmls.push(this.DomSanitizer.bypassSecurityTrustHtml(html));
        this.dataCleared = false;
    }
    fillIframeAndResize(response, append) {
        const iframe = this.getInvisiblePopup();
        if (append) {
            iframe.contentDocument.body.innerHTML += response;
        }
        else {
            iframe.contentDocument.body.innerHTML = response;
        }
        let tmp_width = iframe.contentWindow.innerWidth;
        if (tmp_width >
            this.HsLayoutService.contentWrapper.querySelector('.hs-ol-map')
                .clientWidth -
                60) {
            tmp_width =
                this.HsLayoutService.contentWrapper.querySelector('.hs-ol-map')
                    .clientWidth - 60;
        }
        iframe.style.width = tmp_width + 'px';
        let tmp_height = iframe.contentWindow.innerHeight;
        if (tmp_height > 700) {
            tmp_height = 700;
        }
        iframe.style.height = tmp_height + 'px';
    }
    /**
     * @param coordinate
     */
    getCoordinate(coordinate) {
        this.queryPoint.setCoordinates(coordinate, 'XY');
        const epsg4326Coordinate = transform(coordinate, this.HsMapService.getCurrentProj(), 'EPSG:4326');
        const coords = {
            name: this.hsLanguageService.getTranslation('QUERY.coordinates'),
            mapProjCoordinate: coordinate,
            epsg4326Coordinate,
            projections: [
                {
                    name: 'EPSG:4326',
                    value: toStringHDMS(epsg4326Coordinate),
                },
                {
                    name: 'EPSG:4326',
                    value: createStringXY(7)(epsg4326Coordinate),
                },
                {
                    name: this.HsMapService.getCurrentProj().getCode(),
                    value: createStringXY(7)(coordinate),
                },
            ],
        };
        return coords;
    }
    activateQueries() {
        if (this.queryActive) {
            return;
        }
        this.queryActive = true;
        this.HsMapService.loaded().then((map) => {
            map.addLayer(this.queryLayer);
            this.HsSaveMapService.internalLayers.push(this.queryLayer);
            this.queryStatusChanges.next(true);
        });
    }
    deactivateQueries() {
        if (!this.queryActive) {
            return;
        }
        this.queryActive = false;
        this.HsMapService.loaded().then((map) => {
            map.removeLayer(this.queryLayer);
            this.queryStatusChanges.next(false);
        });
    }
    currentPanelQueryable() {
        return (!this.nonQueryablePanels.includes(this.HsLayoutService.mainpanel) &&
            !this.nonQueryablePanels.includes('*'));
    }
    /**
     * @param feature
     */
    pointClickedStyle(feature) {
        const defaultStyle = new Style({
            image: new Circle({
                fill: new Fill({
                    color: 'rgba(255, 156, 156, 0.4)',
                }),
                stroke: new Stroke({
                    color: '#cc3333',
                    width: 1,
                }),
                radius: 5,
            }),
        });
        if (this.HsConfig.queryPoint) {
            const circle = defaultStyle.getImage();
            if (this.HsConfig.queryPoint == 'hidden') {
                circle.setRadius(0);
            }
            else if (this.HsConfig.queryPoint == 'notWithin') {
                if (this.selector.getFeatures().getLength() > 0) {
                    circle.setRadius(0);
                }
            }
        }
        return defaultStyle;
    }
}
HsQueryBaseService.ɵfac = function HsQueryBaseService_Factory(t) { return new (t || HsQueryBaseService)(ɵngcc0.ɵɵinject(HsMapService), ɵngcc0.ɵɵinject(HsConfig), ɵngcc0.ɵɵinject(HsLayoutService), ɵngcc0.ɵɵinject(HsLanguageService), ɵngcc0.ɵɵinject(HsUtilsService), ɵngcc0.ɵɵinject(HsEventBusService), ɵngcc0.ɵɵinject(HsSaveMapService), ɵngcc0.ɵɵinject(ɵngcc4.DomSanitizer), ɵngcc0.ɵɵinject(ɵngcc0.NgZone)); };
HsQueryBaseService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HsQueryBaseService_Factory() { return new HsQueryBaseService(i0.ɵɵinject(HsMapService), i0.ɵɵinject(HsConfig), i0.ɵɵinject(HsLayoutService), i0.ɵɵinject(HsLanguageService), i0.ɵɵinject(HsUtilsService), i0.ɵɵinject(HsEventBusService), i0.ɵɵinject(HsSaveMapService), i0.ɵɵinject(i8.DomSanitizer), i0.ɵɵinject(i0.NgZone)); }, token: HsQueryBaseService, providedIn: "root" });
HsQueryBaseService.ctorParameters = () => [
    { type: HsMapService },
    { type: HsConfig },
    { type: HsLayoutService },
    { type: HsLanguageService },
    { type: HsUtilsService },
    { type: HsEventBusService },
    { type: HsSaveMapService },
    { type: DomSanitizer },
    { type: NgZone }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsQueryBaseService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: HsMapService }, { type: HsConfig }, { type: HsLayoutService }, { type: HsLanguageService }, { type: HsUtilsService }, { type: HsEventBusService }, { type: HsSaveMapService }, { type: ɵngcc4.DomSanitizer }, { type: ɵngcc0.NgZone }]; }, null); })();

const TITLE = 'title';
const HIGHLIGHTED = 'highlighted';
const LABEL = 'label';
const NAME = 'name';
const RECORD = 'record';
const FEATURES = 'features';
const UNITID = 'unitId';
function setFeatureTitle(feature, title) {
    feature.set(TITLE, title);
}
function getFeatureTitle(feature) {
    return feature.get(TITLE);
}
function setHighlighted(feature, highlighted) {
    feature.set(HIGHLIGHTED, highlighted);
}
function getHighlighted(feature) {
    return feature.get(HIGHLIGHTED);
}
function setFeatureLabel(feature, label) {
    feature.set(LABEL, label);
}
function getFeatureLabel(feature) {
    return feature.get(LABEL);
}
function setFeatureName(feature, name) {
    feature.set(NAME, name);
}
function getFeatureName(feature) {
    return feature.get(NAME);
}
function setRecord(feature, record) {
    feature.set(RECORD, record);
}
function getRecord(feature) {
    return feature.get(RECORD);
}
function setFeatures(feature, features) {
    feature.set(FEATURES, features);
}
function getFeatures(feature) {
    return feature.get(FEATURES);
}
function setUnitId(feature, unitId) {
    feature.set(UNITID, unitId);
}
function getUnitId(feature) {
    return feature.get(UNITID);
}
const HsFeatureExt = {
    setFeatureTitle,
    getFeatureTitle,
    setHighlighted,
    getHighlighted,
    setFeatureLabel,
    getFeatureLabel,
    setFeatureName,
    getFeatureName,
    setRecord,
    getRecord,
    setFeatures,
    getFeatures,
    setUnitId,
    getUnitId,
};

class HsQueryVectorService {
    constructor(HsQueryBaseService, HsMapService, HsConfig, HsLayerUtilsService, HsUtilsService, HsEventBusService, DomSanitizer) {
        var _a;
        this.HsQueryBaseService = HsQueryBaseService;
        this.HsMapService = HsMapService;
        this.HsConfig = HsConfig;
        this.HsLayerUtilsService = HsLayerUtilsService;
        this.HsUtilsService = HsUtilsService;
        this.HsEventBusService = HsEventBusService;
        this.DomSanitizer = DomSanitizer;
        this.featureRemovals = new Subject();
        this.selector = new Select({
            condition: click,
            multi: ((_a = this.HsConfig.query) === null || _a === void 0 ? void 0 : _a.multi) ? this.HsConfig.query.multi : false,
            filter: function (feature, layer) {
                if (layer === null) {
                    return;
                }
                if (getQueryable(layer) === false) {
                    return false;
                }
                else {
                    return true;
                }
            },
        });
        this.HsQueryBaseService.vectorSelectorCreated.next(this.selector);
        this.HsEventBusService.olMapLoads.subscribe((map) => {
            map.addInteraction(this.selector);
        });
        this.HsQueryBaseService.queryStatusChanges.subscribe(() => {
            /*if (Base.queryActive) OlMap.map.addInteraction(this.selector);
                  else OlMap.map.removeInteraction(this.selector);*/
        });
        this.selector.getFeatures().on('add', (e) => {
            this.HsEventBusService.vectorQueryFeatureSelection.next({
                feature: e.element,
                selector: this.selector,
            });
        });
        this.selector.getFeatures().on('remove', (e) => {
            this.HsEventBusService.vectorQueryFeatureDeselection.next({
                feature: e.element,
                selector: this.selector,
            });
        });
        this.HsEventBusService.vectorQueryFeatureSelection.subscribe((e) => {
            if (e === null || e === void 0 ? void 0 : e.feature) {
                const layer = this.HsMapService.getLayerForFeature(e.feature);
                if (layer && getOnFeatureSelected(layer)) {
                    const originalFeature = this.getSelectedFeature(e.feature);
                    if (originalFeature) {
                        getOnFeatureSelected(layer)(originalFeature);
                    }
                }
            }
        });
        this.HsQueryBaseService.getFeatureInfoStarted.subscribe((e) => {
            this.HsQueryBaseService.clearData('features');
            if (!this.HsQueryBaseService.queryActive) {
                return;
            }
            this.createFeatureAttributeList();
        });
    }
    getSelectedFeature(feature) {
        let original = feature;
        if (getFeatures(original) && getFeatures(original).length == 1) {
            original = getFeatures(original)[0];
        }
        return original;
    }
    createFeatureAttributeList() {
        this.HsQueryBaseService.data.attributes.length = 0;
        const features = this.selector.getFeatures().getArray();
        let featureDescriptions = [];
        for (const feature of features) {
            featureDescriptions = featureDescriptions.concat(this.getFeatureAttributes(feature));
        }
        this.HsQueryBaseService.setData(featureDescriptions, 'features');
        this.HsQueryBaseService.getFeatureInfoCollected.next();
    }
    exportData(clickedFormat, feature) {
        let fmt;
        const featureArray = Array.isArray(feature) ? feature : [feature];
        switch (clickedFormat) {
            case 'WKT':
                fmt = new WKT();
                return fmt.writeFeatures(featureArray);
                break;
            case 'GeoJSON':
            default:
                fmt = new GeoJSON();
                return fmt.writeFeatures(featureArray, {
                    dataProjection: 'EPSG:4326',
                    featureProjection: this.HsMapService.getCurrentProj(),
                });
                break;
        }
    }
    /**
     * @param feature
     */
    getFeatureLayerName(feature) {
        const layer = this.HsMapService.getLayerForFeature(feature);
        return this.HsLayerUtilsService.getLayerName(layer);
    }
    /**
     * @param feature
     */
    getCentroid(feature) {
        if (feature == undefined) {
            return;
        }
        const center = extent.getCenter(feature.getGeometry().getExtent());
        return center;
    }
    /**
     * (PRIVATE) Adding a default stats to query based on feature geom type
     * @param f Selected feature from map
     */
    addDefaultStats(f) {
        const geom = f.getGeometry();
        const type = geom.getType();
        if (type == 'Polygon') {
            const area = this.HsUtilsService.formatArea(geom, this.HsMapService.getCurrentProj());
            return [
                { name: `${area.type} in ${area.unit}`, value: area.size },
                { name: 'center', value: toLonLat(this.getCentroid(f)) },
            ];
        }
        if (type == 'LineString') {
            const length = this.HsUtilsService.formatLength(geom, this.HsMapService.getCurrentProj());
            return [
                { name: `${length.type} in ${length.unit}`, value: length.size },
                { name: 'center', value: toLonLat(this.getCentroid(f)) },
            ];
        }
        if (type == 'Point') {
            return [{ name: 'center', value: toLonLat(this.getCentroid(f)) }];
        }
    }
    /**
     * @param {ol/Feature} feature
     * @returns {ol/source/Source}
     */
    olSource(feature) {
        const layer = this.HsMapService.getLayerForFeature(feature);
        if (layer == undefined) {
            return;
        }
        else if (layer.getSource().getSource) {
            return layer.getSource().getSource();
        }
        else {
            return layer.getSource();
        }
    }
    /**
     * @param {ol/Feature} feature
     * @returns {boolean}
     */
    isFeatureRemovable(feature) {
        const source = this.olSource(feature);
        if (source == undefined) {
            return false;
        }
        const layer = this.HsMapService.getLayerForFeature(feature);
        return (this.HsUtilsService.instOf(source, Vector) &&
            this.HsLayerUtilsService.isLayerEditable(layer));
    }
    /**
     * @param {ol/Feature} feature
     */
    removeFeature(feature) {
        const source = this.olSource(feature);
        if (this.HsUtilsService.instOf(source, Vector)) {
            source.removeFeature(feature);
        }
        this.selector.getFeatures().remove(feature);
        this.featureRemovals.next(feature);
    }
    /**
     * (PRIVATE) Handler for querying vector layers of map. Get information about selected feature.
     * @param feature Selected feature from map
     */
    getFeatureAttributes(feature) {
        const attributes = [];
        let tmp = [];
        const hstemplate = feature.get('hstemplate')
            ? feature.get('hstemplate')
            : null;
        let customInfoTemplate = null;
        feature.getKeys().forEach((key) => {
            if (['gid', 'geometry', 'wkb_geometry'].indexOf(key) > -1) {
                return;
            }
            if (key == 'features') {
                for (const subFeature of getFeatures(feature)) {
                    tmp = tmp.concat(this.getFeatureAttributes(subFeature));
                }
            }
            else {
                const obj = {
                    name: key,
                    value: feature.get(key),
                };
                obj.sanitizedValue = this.sanitizeAttributeValue(feature.get(key));
                attributes.push(obj);
            }
        });
        const layer = this.HsMapService.getLayerForFeature(feature);
        if (layer && getCustomInfoTemplate(layer)) {
            customInfoTemplate = getCustomInfoTemplate(layer);
        }
        if (layer && getVirtualAttributes(layer)) {
            const virtualAttributes = getVirtualAttributes(layer);
            for (const key of Object.keys(virtualAttributes)) {
                const value = virtualAttributes[key](feature);
                const obj = {
                    name: key,
                    value,
                };
                obj.sanitizedValue = this.sanitizeAttributeValue(value);
                attributes.push(obj);
            }
        }
        if (!getFeatures(feature)) {
            const featureDescription = {
                layer: this.getFeatureLayerName(feature),
                name: 'Feature',
                attributes: attributes,
                stats: this.addDefaultStats(feature),
                hstemplate,
                feature,
                customInfoTemplate: this.DomSanitizer.bypassSecurityTrustHtml(customInfoTemplate),
            };
            tmp.push(featureDescription);
        }
        return tmp;
    }
    sanitizeAttributeValue(value) {
        if ((typeof value).toLowerCase() == 'string') {
            return this.DomSanitizer.bypassSecurityTrustHtml(value);
        }
        else {
            return;
        }
    }
}
HsQueryVectorService.ɵfac = function HsQueryVectorService_Factory(t) { return new (t || HsQueryVectorService)(ɵngcc0.ɵɵinject(HsQueryBaseService), ɵngcc0.ɵɵinject(HsMapService), ɵngcc0.ɵɵinject(HsConfig), ɵngcc0.ɵɵinject(HsLayerUtilsService), ɵngcc0.ɵɵinject(HsUtilsService), ɵngcc0.ɵɵinject(HsEventBusService), ɵngcc0.ɵɵinject(ɵngcc4.DomSanitizer)); };
HsQueryVectorService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HsQueryVectorService_Factory() { return new HsQueryVectorService(i0.ɵɵinject(HsQueryBaseService), i0.ɵɵinject(HsMapService), i0.ɵɵinject(HsConfig), i0.ɵɵinject(HsLayerUtilsService), i0.ɵɵinject(HsUtilsService), i0.ɵɵinject(HsEventBusService), i0.ɵɵinject(i8.DomSanitizer)); }, token: HsQueryVectorService, providedIn: "root" });
HsQueryVectorService.ctorParameters = () => [
    { type: HsQueryBaseService },
    { type: HsMapService },
    { type: HsConfig },
    { type: HsLayerUtilsService },
    { type: HsUtilsService },
    { type: HsEventBusService },
    { type: DomSanitizer }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsQueryVectorService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: HsQueryBaseService }, { type: HsMapService }, { type: HsConfig }, { type: HsLayerUtilsService }, { type: HsUtilsService }, { type: HsEventBusService }, { type: ɵngcc4.DomSanitizer }]; }, null); })();

const defaultStyle = `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
<StyledLayerDescriptor version="1.0.0" xsi:schemaLocation="http://www.opengis.net/sld StyledLayerDescriptor.xsd" xmlns="http://www.opengis.net/sld" xmlns:ogc="http://www.opengis.net/ogc" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance">
  <NamedLayer>
    <Name/>
    <UserStyle>
      <Name/>
      <Title/>
      <FeatureTypeStyle>
        <Rule>
          <Name/>
          <PointSymbolizer>
            <Graphic>
              <Mark>
                <WellKnownName>circle</WellKnownName>
                <Fill>
                  <CssParameter name="fill">#FFFFFF</CssParameter>
                  <CssParameter name="fill-opacity">0.41</CssParameter>
                </Fill>
                <Stroke>
                  <CssParameter name="stroke">#0099ff</CssParameter>
                  <CssParameter name="stroke-width">1.25</CssParameter>
                </Stroke>
              </Mark>
              <Size>10</Size>
            </Graphic>
          </PointSymbolizer>
          <PolygonSymbolizer>
            <Fill>
              <CssParameter name="fill-opacity">0.45</CssParameter>
            </Fill>
            <Stroke>
              <CssParameter name="stroke">#0099ff</CssParameter>
              <CssParameter name="stroke-width">1.25</CssParameter>
              <CssParameter name="stroke-opacity">0.3</CssParameter>
            </Stroke>
          </PolygonSymbolizer>
          <LineSymbolizer>
            <Stroke>
              <CssParameter name="stroke">#0099ff</CssParameter>
              <CssParameter name="stroke-width">1.25</CssParameter>
            </Stroke>
          </LineSymbolizer>
        </Rule>
      </FeatureTypeStyle>
    </UserStyle>
  </NamedLayer>
</StyledLayerDescriptor>`;
const simple_style = new Style({
    fill: new Fill({
        color: 'rgba(255, 255, 255, 1)',
    }),
    stroke: new Stroke({
        color: '#ffcc33',
        width: 1,
    }),
    image: new Circle({
        radius: 7,
        fill: new Fill({
            color: '#ffcc33',
        }),
    }),
});

function parseStyle(j) {
    return __awaiter(this, void 0, void 0, function* () {
        const style_json = {};
        if (j.fill) {
            style_json.fill = new Fill({
                color: j.fill,
            });
        }
        if (j.stroke) {
            style_json.stroke = new Stroke({
                color: j.stroke.color,
                width: j.stroke.width,
            });
        }
        if (j.image) {
            if (j.image.type == 'circle') {
                const circle_json = {};
                if (j.image.radius) {
                    circle_json.radius = j.image.radius;
                }
                if (j.image.fill) {
                    circle_json.fill = new Fill({
                        color: j.image.fill,
                    });
                }
                if (j.image.stroke) {
                    circle_json.stroke = new Stroke({
                        color: j.image.stroke.color,
                        width: j.image.stroke.width,
                    });
                }
                style_json.image = new Circle(circle_json);
            }
            if (j.image.type == 'icon') {
                const img = new Image();
                img.src = j.image.src;
                if (img.width == 0) {
                    img.width = 43;
                }
                if (img.height == 0) {
                    img.height = 41;
                }
                const icon_json = {
                    img: img,
                    imgSize: [img.width, img.height],
                    crossOrigin: 'anonymous',
                };
                style_json.image = new Icon(icon_json);
            }
        }
        const sld = yield convertHsStyleToSld(j);
        return { style: new Style(style_json), sld };
    });
}
/**
 * We get serialized layer definition including style definition in custom JSON format.
 * This we need to convert to SLD xml text
 * @param json - Serialized layer which we get from hslayers-ng
 * @param layer - Vector layer to get title from
 */
function convertHsStyleToSld(json) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function* () {
        const symbolizers = [];
        if (((_a = json.image) === null || _a === void 0 ? void 0 : _a.type) == 'circle') {
            symbolizers.push(createCircleSymbol(json));
        }
        if (((_b = json.image) === null || _b === void 0 ? void 0 : _b.type) == 'icon') {
            symbolizers.push(createIconSymbol(json));
        }
        if (json.fill) {
            symbolizers.push(createPolygonSymbol(json));
        }
        else if (json.stroke) {
            symbolizers.push(createLineSymbol(json));
        }
        if (symbolizers.length > 0) {
            const name = '';
            const sldModel = {
                name,
                rules: [{ name, symbolizers }],
            };
            const parser = new SLDParser();
            return yield parser.writeStyle(sldModel);
        }
    });
}
/**
 * Create polygon symbolizer configuration from which the
 * geostyler-sld-parser library will generate SLD xml
 * @param json -
 * @returns
 */
function createPolygonSymbol(json) {
    const tmp = {
        kind: 'Fill',
        color: json.fill.color,
    };
    if (json.stroke) {
        Object.assign(tmp, {
            outlineColor: json.stroke.color,
            outlineWidth: json.stroke.width,
        });
    }
    return tmp;
}
/**
 * Create line symbolizer configuration from which the
 * geostyler-sld-parser library will generate SLD xml
 * @param json -
 * @returns
 */
function createLineSymbol(json) {
    const tmp = {
        kind: 'Line',
        color: json.stroke.color,
        width: json.stroke.width,
    };
    return tmp;
}
/**
 * Create circle symbolizer configuration from which the
 * geostyler-sld-parser library will generate SLD xml
 * @param json -
 * @returns
 */
function createCircleSymbol(json) {
    const tmp = {
        kind: 'Mark',
        wellKnownName: 'circle',
        color: json.image.fill.color || json.fill,
        radius: json.image.radius,
    };
    if (json.image.stroke) {
        tmp.strokeColor = json.image.stroke.color;
    }
    else {
        tmp.strokeColor = json.stroke.color;
    }
    if (json.stroke) {
        tmp.strokeWidth = json.stroke.width;
    }
    return tmp;
}
/**
 * Create icon symbolizer configuration from which the
 * geostyler-sld-parser library will generate SLD xml.
 * It must include embedded base64 encoded svg image
 * @param json -
 * @returns
 */
function createIconSymbol(json) {
    return {
        kind: 'Icon',
        offset: [0, 0],
        image: json.image.src.replace('data:image/svg+xml;base64,', 'base64:') +
            `?fill=${encodeURIComponent(json.fill)}&fill-opacity=1&outline=${encodeURIComponent(json.stroke.color)}&outline-opacity=1&outline-width=${json.stroke.width}`,
    };
}

class HsStylerService {
    constructor(hsQueryVectorService, hsUtilsService, hsLayerUtilsService, hsEventBusService, hsLogService, sanitizer, hsMapService, hsSaveMapService) {
        this.hsQueryVectorService = hsQueryVectorService;
        this.hsUtilsService = hsUtilsService;
        this.hsLayerUtilsService = hsLayerUtilsService;
        this.hsEventBusService = hsEventBusService;
        this.hsLogService = hsLogService;
        this.sanitizer = sanitizer;
        this.hsMapService = hsMapService;
        this.hsSaveMapService = hsSaveMapService;
        this.layer = null;
        this.onSet = new Subject();
        this.parser = new SLDParser();
        this.pin_white_blue = new Style({
            image: new Icon({
                src: this.hsUtilsService.getAssetsPath() + 'img/pin_white_blue32.png',
                crossOrigin: 'anonymous',
                anchor: [0.5, 1],
            }),
        });
        this.pin_white_blue_highlight = (feature, resolution) => {
            return [
                new Style({
                    image: new Icon({
                        src: getHighlighted(feature)
                            ? this.hsUtilsService.getAssetsPath() + 'img/pin_white_red32.png'
                            : this.hsUtilsService.getAssetsPath() + 'img/pin_white_blue32.png',
                        crossOrigin: 'anonymous',
                        anchor: [0.5, 1],
                    }),
                }),
            ];
        };
        this.hsMapService.loaded().then(() => this.init());
    }
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            for (const layer of this.hsMapService
                .getLayersArray()
                .filter((layer) => this.hsLayerUtilsService.isLayerVectorLayer(layer))) {
                this.initLayerStyle(layer);
            }
            this.hsEventBusService.layerAdditions.subscribe((layerDescriptor) => {
                if (this.hsLayerUtilsService.isLayerVectorLayer(layerDescriptor.layer)) {
                    this.initLayerStyle(layerDescriptor.layer);
                }
            });
        });
    }
    isVectorLayer(layer) {
        if (this.hsUtilsService.instOf(layer, VectorLayer)) {
            return true;
        }
        else {
            return false;
        }
    }
    /**
     * Get a Source for any vector layer. Both clustered and un-clustered.
     * @param layer - Any vector layer
     * @param isClustered -
     * @returns Source of the input layer or source of its cluster's source
     */
    getLayerSource(layer, isClustered) {
        if (!layer) {
            return;
        }
        let src;
        if (isClustered) {
            src = layer.getSource().getSource();
        }
        else {
            src = layer.getSource();
        }
        return src;
    }
    /**
     * Style clustered layer features using cluster style or individual feature style.
     * @param layer - Any vector layer
     */
    styleClusteredLayer(layer) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            yield this.fill(layer);
            //Check if layer already has SLD style for clusters
            if (!this.styleObject.rules.find((r) => {
                try {
                    /*
                    For clusters SLD styles created by Hslayers have 'AND' rule where the
                    first condition checks if 'features' attribute of a feature is set.
                    See addRule function
                    */
                    return r.filter[1][1] == 'features';
                }
                catch (ex) {
                    return false;
                }
            })) {
                // Remember to clone singleFeatureFilter on usage so the filters
                // don't share the same reference
                const singleFeatureFilter = [
                    '||',
                    ['==', 'features', 'undefined'],
                    ['==', 'features', '[object Object]'],
                ];
                for (const rule of this.styleObject.rules) {
                    // Set filter so the original style is applied to features which are not clusters
                    rule.filter =
                        ((_a = rule.filter) === null || _a === void 0 ? void 0 : _a.length) > 0
                            ? ['&&', [...singleFeatureFilter], rule.filter]
                            : [...singleFeatureFilter];
                }
                yield this.addRule('Cluster');
            }
            let style = layer.getStyle();
            if (this.hsUtilsService.instOf(this.layer.getSource(), Cluster) &&
                this.hsUtilsService.isFunction(style)) {
                style = this.wrapStyleForClusters(style);
                layer.setStyle(style);
            }
        });
    }
    /**
     * Parse style from 'sld' attribute defined in SLD format and convert to OL
     * style which is set on the layer. Also do the opposite if no SLD is defined,
     * because SLD is used in the styler panel.
     *
     * @param layer - OL layer to fill the missing style info
     */
    initLayerStyle(layer) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.isVectorLayer(layer)) {
                return;
            }
            let sld = getSld(layer);
            let style = layer.getStyle();
            if ((!style || style == createDefaultStyle) && !sld) {
                sld = defaultStyle;
                setSld(layer, defaultStyle);
            }
            if (sld && (!style || style == createDefaultStyle)) {
                style = (yield this.parseStyle(sld)).style;
                if (style) {
                    layer.setStyle(style);
                }
                if (getCluster(layer)) {
                    yield this.styleClusteredLayer(layer);
                }
            }
            else if (style &&
                !sld &&
                !this.hsUtilsService.isFunction(style) &&
                !Array.isArray(style)) {
                const customJson = this.hsSaveMapService.serializeStyle(style);
                const sld = (yield this.parseStyle(customJson)).sld;
                if (sld) {
                    setSld(layer, sld);
                }
            }
            this.sld = sld;
        });
    }
    /**
     * Parse style encoded as custom JSON or SLD and return OL style object.
     * This function is used to support backwards compatibility with custom format.
     * @param style -
     * @returns OL style object
     */
    parseStyle(style) {
        return __awaiter(this, void 0, void 0, function* () {
            if (typeof style == 'string') {
                return { sld: style, style: yield this.sldToOlStyle(style) };
            }
            else if (typeof style == 'object') {
                //Backwards compatibility with style encoded in custom JSON object
                return parseStyle(style);
            }
        });
    }
    /**
     * Prepare current layers style for editing by converting
     * SLD attribute string to JSON and reading layers title
     *
     * @param layer - OL layer
     */
    fill(layer) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (!layer) {
                    return;
                }
                this.layer = layer;
                this.layerTitle = getTitle(layer);
                const sld = getSld(layer);
                if (sld != undefined) {
                    this.styleObject = yield this.sldToJson(sld);
                }
                else {
                    this.styleObject = { name: 'untitled style', rules: [] };
                }
                this.geostylerWorkaround();
            }
            catch (ex) {
                this.hsLogService.error(ex.message);
            }
        });
    }
    /**
     * Tweak geostyler object attributes to mitigate
     * some discrepancies between opacity and fillOpacity usage
     */
    geostylerWorkaround() {
        if (this.styleObject.rules) {
            for (const rule of this.styleObject.rules) {
                if (rule.symbolizers) {
                    for (const symbol of rule.symbolizers.filter((symb) => symb.kind == 'Fill')) {
                        symbol.opacity = symbol.fillOpacity;
                    }
                }
            }
        }
    }
    /**
     * Convert SLD to OL style object
     */
    sldToOlStyle(sld) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const sldObject = yield this.sldToJson(sld);
                return yield this.geoStylerStyleToOlStyle(sldObject);
            }
            catch (ex) {
                this.hsLogService.error(ex);
            }
        });
    }
    geoStylerStyleToOlStyle(sldObject) {
        return __awaiter(this, void 0, void 0, function* () {
            const olConverter = new OpenLayersParser();
            const style = yield olConverter.writeStyle(sldObject);
            return style;
        });
    }
    /**
     * Convert SLD text to JSON which is easier to edit in Angular.
     * @param sld -
     * @returns
     */
    sldToJson(sld) {
        return __awaiter(this, void 0, void 0, function* () {
            const sldObject = yield this.parser.readStyle(sld);
            return sldObject;
        });
    }
    jsonToSld(styleObject) {
        return __awaiter(this, void 0, void 0, function* () {
            const sld = yield this.parser.writeStyle(styleObject);
            return sld;
        });
    }
    addRule(kind) {
        return __awaiter(this, void 0, void 0, function* () {
            switch (kind) {
                case 'Cluster':
                    this.styleObject.rules.push({
                        name: 'Cluster rule',
                        filter: [
                            '&&',
                            ['!=', 'features', 'undefined'],
                            ['!=', 'features', '[object Object]'],
                        ],
                        symbolizers: [
                            {
                                kind: 'Mark',
                                color: '#FFFFFF',
                                strokeOpacity: 0.41,
                                strokeColor: '#0099ff',
                                strokeWidth: 2,
                                wellKnownName: 'circle',
                                radius: 10,
                            },
                            {
                                kind: 'Text',
                                label: '{{features}}',
                                haloColor: '#fff',
                                color: '#000',
                                offset: [0, 0],
                            },
                        ],
                    });
                    break;
                case 'Simple':
                default:
                    this.styleObject.rules.push({
                        name: 'Untitled rule',
                        symbolizers: [],
                    });
            }
            yield this.save();
        });
    }
    removeRule(rule) {
        return __awaiter(this, void 0, void 0, function* () {
            this.styleObject.rules.splice(this.styleObject.rules.indexOf(rule), 1);
            yield this.save();
        });
    }
    encodeTob64(str) {
        return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, (match, p1) => {
            return String.fromCharCode(parseInt(p1, 16));
        }));
    }
    decodeToUnicode(str) {
        return decodeURIComponent(Array.prototype.map
            .call(atob(str), (c) => {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
            .join(''));
    }
    save() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let style = yield this.geoStylerStyleToOlStyle(this.styleObject);
                if (this.styleObject.rules.length == 0) {
                    this.hsLogService.warn('Missing style rules for layer', this.layer);
                    style = createDefaultStyle;
                }
                /* style is a function when text symbolizer is used. We need some hacking
                for cluster layer in that case to have the correct number of features in
                cluster display over the label */
                if (this.hsUtilsService.instOf(this.layer.getSource(), Cluster) &&
                    this.hsUtilsService.isFunction(style)) {
                    style = this.wrapStyleForClusters(style);
                }
                this.layer.setStyle(style);
                const sld = yield this.jsonToSld(this.styleObject);
                setSld(this.layer, sld);
                this.sld = sld;
                this.onSet.next(this.layer);
            }
            catch (ex) {
                this.hsLogService.error(ex);
            }
        });
    }
    /**
     * HACK is needed to style cluster layers. It wraps existing OL style function
     * in a function which searches for for Text styles and in them for serialized
     * feature arrays and instead sets the length of this array as the label.
     * If the geostyler text symbolizer had {{features}} as the text label template
     * (which returns the "features" attribute of the parent/cluster feature) and returned
     * '[object Object], [object Object]' the result would become "2".
     * See https://github.com/geostyler/geostyler-openlayers-parser/issues/227
     * @param style -
     * @returns
     */
    wrapStyleForClusters(style) {
        return (feature, resolution) => {
            var _a, _b;
            const tmp = style(feature, resolution);
            if (!tmp) {
                return;
            }
            if (Array.isArray(tmp)) {
                for (const evaluatedStyle of tmp) {
                    if (evaluatedStyle.getText &&
                        ((_b = (_a = evaluatedStyle.getText()) === null || _a === void 0 ? void 0 : _a.getText()) === null || _b === void 0 ? void 0 : _b.includes('[object Object]'))) {
                        const featureListSerialized = evaluatedStyle.getText().getText();
                        const fCount = featureListSerialized.split(',').length.toString();
                        evaluatedStyle.getText().setText(fCount);
                    }
                }
            }
            return tmp;
        };
    }
    reset() {
        return __awaiter(this, void 0, void 0, function* () {
            setSld(this.layer, undefined);
            this.layer.setStyle(createDefaultStyle);
            yield this.initLayerStyle(this.layer);
            yield this.fill(this.layer);
            yield this.save();
        });
    }
    loadSld(sld) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield this.parser.readStyle(sld);
                setSld(this.layer, sld);
                yield this.fill(this.layer);
                yield this.save();
            }
            catch (err) {
                console.warn('SLD could not be parsed');
            }
        });
    }
}
HsStylerService.ɵfac = function HsStylerService_Factory(t) { return new (t || HsStylerService)(ɵngcc0.ɵɵinject(HsQueryVectorService), ɵngcc0.ɵɵinject(HsUtilsService), ɵngcc0.ɵɵinject(HsLayerUtilsService), ɵngcc0.ɵɵinject(HsEventBusService), ɵngcc0.ɵɵinject(HsLogService), ɵngcc0.ɵɵinject(ɵngcc4.DomSanitizer), ɵngcc0.ɵɵinject(HsMapService), ɵngcc0.ɵɵinject(HsSaveMapService)); };
HsStylerService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HsStylerService_Factory() { return new HsStylerService(i0.ɵɵinject(HsQueryVectorService), i0.ɵɵinject(HsUtilsService), i0.ɵɵinject(HsLayerUtilsService), i0.ɵɵinject(HsEventBusService), i0.ɵɵinject(HsLogService), i0.ɵɵinject(i8.DomSanitizer), i0.ɵɵinject(HsMapService), i0.ɵɵinject(HsSaveMapService)); }, token: HsStylerService, providedIn: "root" });
HsStylerService.ctorParameters = () => [
    { type: HsQueryVectorService },
    { type: HsUtilsService },
    { type: HsLayerUtilsService },
    { type: HsEventBusService },
    { type: HsLogService },
    { type: DomSanitizer },
    { type: HsMapService },
    { type: HsSaveMapService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsStylerService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: HsQueryVectorService }, { type: HsUtilsService }, { type: HsLayerUtilsService }, { type: HsEventBusService }, { type: HsLogService }, { type: ɵngcc4.DomSanitizer }, { type: HsMapService }, { type: HsSaveMapService }]; }, null); })();

class VectorLayerDescriptor {
    constructor(type, name, title, abstract, url, options, mapProjection) {
        /**
         * Artificial object which is used when layer is saved to composition.
         * It describes format (ol.format.KML, )
         */
        const definition = {};
        this.mapProjection = mapProjection;
        this.layerParams = {
            abstract,
            definition,
            name,
            title,
            opacity: options.opacity || 1,
            fromComposition: options.fromComposition || false,
            style: options.style,
            removable: true,
            path: options.path,
            sld: options.sld,
            visible: options.visible,
            workspace: options.workspace,
            access_rights: options.access_rights,
            queryCapabilities: options.queryCapabilities,
        };
        switch (type ? type.toLowerCase() : '') {
            case 'kml':
                definition.format = 'ol.format.KML';
                definition.url = url;
                break;
            case 'geojson':
                definition.format = 'ol.format.GeoJSON';
                definition.url = url;
                break;
            case 'gpx':
                definition.format = 'ol.format.GPX';
                definition.url = url;
                break;
            case 'sparql':
                definition.format = 'hs.format.Sparql';
                break;
            case 'wfs':
                Object.assign(this.layerParams, {
                    editor: {
                        editable: true,
                        defaultAttributes: {
                            name: title,
                        },
                    },
                });
                break;
            default:
        }
    }
}

class VectorSourceFromUrl extends VectorSource {
    constructor(descriptor) {
        super({
            format: descriptor.sourceParams.format,
            url: descriptor.sourceParams.url,
            strategy: loadingStrategy.all,
        });
        this.featureProjection = get(descriptor.sourceParams.srs);
        this.mapProjection = descriptor.mapProjection;
        super.set('extractStyles', descriptor.sourceParams.extractStyles);
        super.setLoader(this.loaderFunction);
    }
    loaderFunction(extent, resolution, projection) {
        const _super = Object.create(null, {
            set: { get: () => super.set },
            getUrl: { get: () => super.getUrl },
            addFeatures: { get: () => super.addFeatures },
            getFormat: { get: () => super.getFormat }
        });
        return __awaiter(this, void 0, void 0, function* () {
            try {
                _super.set.call(this, 'loaded', false);
                const response = yield fetch(_super.getUrl.call(this));
                let data = yield response.text();
                if (data.type == 'GeometryCollection') {
                    const temp = {
                        type: 'Feature',
                        geometry: data,
                    };
                    data = temp;
                }
                _super.addFeatures.call(this, _super.getFormat.call(this).readFeatures(data, {
                    dataProjection: this.featureProjection,
                    featureProjection: this.mapProjection,
                }));
                _super.set.call(this, 'loaded', true);
            }
            catch (err) {
                this.error = true;
                this.errorMessage = err.status;
                _super.set.call(this, 'loaded', true);
            }
        });
    }
}

class VectorSourceDescriptor {
    constructor(type, url, srs, options, mapProjection) {
        this.mapProjection = mapProjection;
        this.sourceParams = {
            fromComposition: options.fromComposition || false,
            srs,
        };
        switch (type ? type.toLowerCase() : '') {
            case 'kml':
                this.sourceParams.url = url;
                this.sourceParams.format = new KML({
                    extractStyles: options.extractStyles,
                });
                this.sourceClass = VectorSourceFromUrl;
                break;
            case 'geojson':
                this.sourceParams.url = url;
                this.sourceParams.format = new GeoJSON();
                this.sourceClass = VectorSourceFromUrl;
                break;
            case 'gpx':
                this.sourceParams.url = url;
                this.sourceParams.format = new GPX();
                this.sourceClass = VectorSourceFromUrl;
                break;
            case 'sparql':
                this.sourceParams = {
                    geom_attribute: '?geom',
                    url: url,
                    category_field: 'http://www.openvoc.eu/poi#categoryWaze',
                    projection: 'EPSG:3857',
                    minResolution: 1,
                    maxResolution: 38,
                    //#####feature_loaded: function(feature){feature.set('hstemplate', 'hs.geosparql_directive')}
                };
                this.sourceClass = SparqlJson;
                break;
            case 'wfs':
                this.sourceClass = VectorSource;
                break;
            default:
                this.sourceClass = VectorSource;
                const format = new GeoJSON();
                let features = options.features || [];
                if (typeof features === 'string') {
                    features = format.readFeatures(options.features, {
                        dataProjection: srs,
                        featureProjection: this.mapProjection,
                    });
                }
                this.sourceParams = {
                    srs,
                    options,
                    features,
                };
        }
    }
}

class HsAddDataVectorService {
    constructor(hsMapService, hsUtilsService, hsStylerService, hsAddDataService) {
        this.hsMapService = hsMapService;
        this.hsUtilsService = hsUtilsService;
        this.hsStylerService = hsStylerService;
        this.hsAddDataService = hsAddDataService;
        this.readUploadedFileAsText = (inputFile) => {
            const temporaryFileReader = new FileReader();
            return new Promise((resolve, reject) => {
                temporaryFileReader.onerror = () => {
                    temporaryFileReader.abort();
                    reject(new DOMException('Problem parsing input file.'));
                };
                temporaryFileReader.onload = () => {
                    resolve(temporaryFileReader.result);
                };
                temporaryFileReader.readAsText(inputFile);
            });
        };
        this.readUploadedFileAsURL = (inputFile) => {
            const temporaryFileReader = new FileReader();
            return new Promise((resolve, reject) => {
                temporaryFileReader.onerror = () => {
                    temporaryFileReader.abort();
                    reject(new DOMException('Problem parsing input file.'));
                };
                temporaryFileReader.onload = () => {
                    resolve(temporaryFileReader.result);
                };
                temporaryFileReader.readAsDataURL(inputFile);
            });
        };
    }
    /**
     * Load non-wms OWS data and create layer
     * @param type - Type of data to load (supports Kml, Geojson, Wfs and Sparql)
     * @param url - Url of data/service localization
     * @param name -
     * @param title - Title of new layer
     * @param abstract - Abstract of new layer
     * @param addUnder -
     * @param srs - EPSG code of selected projection (eg. "EPSG:4326")
     * @param options - Other options
     * @returns Return Promise which return OpenLayers vector layer
     */
    addVectorLayer(type, url, name, title, abstract, srs, options, addUnder) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const lyr = yield this.createVectorLayer(type, url, name, title, abstract, srs, options);
                /*
                TODO: Should have set definition property with protocol inside
                so layer synchronizer would know if to sync
                */
                if (url !== undefined) {
                    setDefinition(lyr, {
                        format: 'hs.format.WFS',
                        url: url,
                    });
                }
                else {
                    setDefinition(lyr, {
                        format: 'hs.format.WFS',
                    });
                }
                if (this.hsMapService.map) {
                    this.hsAddDataService.addLayer(lyr, addUnder);
                }
                resolve(lyr);
            }
            catch (ex) {
                reject(ex);
            }
        }));
    }
    /**
     * Load non-wms OWS data and create layer
     * @param type - Type of data to load (supports Kml, Geojson, Wfs and Sparql)
     * @param url - Url of data/service localization
     * @param name -
     * @param title - Title of new layer
     * @param abstract - Abstract of new layer
     * @param srs - EPSG code of selected projection (eg. "EPSG:4326")
     * @param options - Other options
     * @returns Return Promise which return OpenLayers vector layer
     */
    createVectorLayer(type, url, name, title, abstract, srs, options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            if (type.toLowerCase() != 'sparql' &&
                type.toLowerCase() != 'wfs' &&
                url !== undefined) {
                url = this.hsUtilsService.proxify(url);
            }
            if (this.hsUtilsService.undefineEmptyString(type) === undefined) {
                type = this.tryGuessTypeFromNameOrUrl(url);
            }
            let mapProjection;
            if (this.hsMapService.map) {
                mapProjection = this.hsMapService.map.getView().getProjection().getCode();
            }
            const descriptor = new VectorLayerDescriptor(type, name, title, abstract, url, options, mapProjection);
            const sourceDescriptor = new VectorSourceDescriptor(type, url, srs, options, mapProjection);
            const src = sourceDescriptor.sourceClass == Vector
                ? new sourceDescriptor.sourceClass(sourceDescriptor.sourceParams)
                : new sourceDescriptor.sourceClass(sourceDescriptor);
            descriptor.layerParams.source = src;
            if (descriptor.layerParams.style) {
                Object.assign(descriptor.layerParams, yield this.hsStylerService.parseStyle(descriptor.layerParams.style));
            }
            const lyr = new Vector$1(descriptor.layerParams);
            return lyr;
        });
    }
    fitExtent(lyr) {
        const src = lyr.getSource();
        if (src.getFeatures().length > 0) {
            this.tryFit(src.getExtent(), src);
        }
        else {
            src.on('change', this.changeListener(src));
        }
    }
    changeListener(src) {
        if (src.getState() == 'ready') {
            setTimeout(() => {
                if (src.getFeatures().length == 0) {
                    return;
                }
                const extent = src.getExtent();
                this.tryFit(extent, src);
            }, 1000);
        }
    }
    /**
     * @param extent -
     * @param src -
     */
    tryFit(extent, src) {
        if (!isNaN(extent[0]) &&
            !isNaN(extent[1]) &&
            !isNaN(extent[2]) &&
            !isNaN(extent[3]) &&
            this.hsMapService.map) {
            this.hsMapService.fitExtent(extent);
            src.un('change', this.changeListener);
        }
    }
    /**
     * Tries to guess file type based on the file extension
     * @param name - Parsed file name from uploaded file
     */
    tryGuessTypeFromNameOrUrl(url) {
        if (url !== undefined) {
            if (url.toLowerCase().endsWith('kml')) {
                return 'kml';
            }
            if (url.toLowerCase().endsWith('gpx')) {
                return 'gpx';
            }
            if (url.toLowerCase().endsWith('geojson') ||
                url.toLowerCase().endsWith('json')) {
                return 'geojson';
            }
        }
    }
    createVectorObjectFromXml(file, type) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const uploadedContent = yield this.readUploadedFileAsURL(file);
                const dataUrl = uploadedContent.toString();
                const object = {
                    url: dataUrl,
                    name: file.name,
                    title: file.name,
                    type: type,
                };
                return object;
            }
            catch (e) {
                console.log('Uploaded file is not supported!');
            }
        });
    }
    readUploadedFile(file) {
        return __awaiter(this, void 0, void 0, function* () {
            let uploadedData = {};
            const fileType = this.tryGuessTypeFromNameOrUrl(file.name.toLowerCase());
            switch (fileType) {
                case 'kml':
                    uploadedData = yield this.createVectorObjectFromXml(file, fileType);
                    break;
                case 'gpx':
                    uploadedData = yield this.convertUploadedData(file);
                    break;
                default:
                    try {
                        const fileContents = yield this.readUploadedFileAsText(file);
                        const fileToJSON = JSON.parse(fileContents);
                        if (fileToJSON !== undefined) {
                            fileToJSON.name = file.name.split('.')[0];
                            uploadedData = this.createVectorObjectFromJson(fileToJSON);
                            return uploadedData;
                        }
                    }
                    catch (e) {
                        console.log('Uploaded file is not supported!', e);
                    }
            }
            return uploadedData;
        });
    }
    /**
     * Reads and returns features from uploaded file as objects
     * @param json - Uploaded file parsed as json object
     */
    createVectorObjectFromJson(json) {
        var _a;
        let features = [];
        const format = new GeoJSON();
        const projection = format.readProjection(json);
        if (((_a = json.features) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            features = format.readFeatures(json);
            this.transformFeaturesIfNeeded(features, projection);
        }
        const object = {
            name: json.name,
            title: json.name,
            srs: projection,
            features,
        };
        return object;
    }
    transformFeaturesIfNeeded(features, projection) {
        const mapProjection = this.hsMapService.map.getView().getProjection();
        if (projection != mapProjection) {
            features.forEach((f) => 
            //TODO: Make it parallel using workers or some library
            f.getGeometry().transform(projection, mapProjection));
        }
    }
    /**
     * Converts uploaded kml or gpx files into GeoJSON format / parse loaded GeoJSON
     * @param file - Uploaded  kml, gpx or GeoJSON files
     */
    convertUploadedData(file) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            let parser;
            const uploadedData = {};
            try {
                const uploadedContent = yield this.readUploadedFileAsText(file);
                let fileType = this.tryGuessTypeFromNameOrUrl(file.name.toLowerCase());
                switch (fileType) {
                    case 'kml':
                        parser = new KML();
                        uploadedData.features = parser.readFeatures(uploadedContent);
                        break;
                    case 'gpx':
                        parser = new GPX();
                        uploadedData.features = parser.readFeatures(uploadedContent);
                        fileType = 'json';
                        break;
                    default:
                }
                if (((_a = uploadedData === null || uploadedData === void 0 ? void 0 : uploadedData.features) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                    this.transformFeaturesIfNeeded(uploadedData.features, parser.readProjection(uploadedContent));
                }
                uploadedData.title = file.name.split('.')[0].trim();
                uploadedData.name = uploadedData.title;
                uploadedData.type = fileType;
                return uploadedData;
            }
            catch (e) {
                console.error('Uploaded file is not supported' + e);
            }
        });
    }
}
HsAddDataVectorService.ɵfac = function HsAddDataVectorService_Factory(t) { return new (t || HsAddDataVectorService)(ɵngcc0.ɵɵinject(HsMapService), ɵngcc0.ɵɵinject(HsUtilsService), ɵngcc0.ɵɵinject(HsStylerService), ɵngcc0.ɵɵinject(HsAddDataService)); };
HsAddDataVectorService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HsAddDataVectorService_Factory() { return new HsAddDataVectorService(i0.ɵɵinject(HsMapService), i0.ɵɵinject(HsUtilsService), i0.ɵɵinject(HsStylerService), i0.ɵɵinject(HsAddDataService)); }, token: HsAddDataVectorService, providedIn: "root" });
HsAddDataVectorService.ctorParameters = () => [
    { type: HsMapService },
    { type: HsUtilsService },
    { type: HsStylerService },
    { type: HsAddDataService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsAddDataVectorService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: HsMapService }, { type: HsUtilsService }, { type: HsStylerService }, { type: HsAddDataService }]; }, null); })();

/**
 * Provides a source of features from WFS endpoint
 */
class WfsSource extends Vector {
    constructor(hsUtilsService, http, { data_version, output_format, crs, provided_url, layer, layer_name, map_projection, }) {
        super({
            loader: function (extent, resolution, projection) {
                return __awaiter(this, void 0, void 0, function* () {
                    if (typeof data_version == 'undefined') {
                        data_version = '1.0.0';
                    }
                    if (typeof output_format == 'undefined') {
                        output_format = data_version == '1.0.0' ? 'GML2' : 'GML3';
                    }
                    const srs = crs.toUpperCase();
                    extent = transformExtent(extent, projection.getCode(), srs);
                    if (srs.includes('4326') || srs.includes('4258')) {
                        extent = [extent[1], extent[0], extent[3], extent[2]];
                    }
                    let url = [
                        provided_url,
                        hsUtilsService.paramsToURLWoEncode({
                            service: 'wfs',
                            version: data_version,
                            request: 'GetFeature',
                            typeName: layer_name,
                            srsName: srs,
                            output_format: output_format,
                            // count: layer.limitFeatureCount ? 1000 : '',
                            BBOX: extent.join(',') + ',' + srs,
                        }),
                    ].join('?');
                    url = hsUtilsService.proxify(url);
                    const response = yield http
                        .get(url, { responseType: 'text' })
                        .toPromise();
                    if (response) {
                        const features = readFeatures(response, map_projection, data_version, srs);
                        this.addFeatures(features);
                    }
                });
            },
            strategy: bbox,
        });
    }
}
function readFeatures(doc, map_projection, data_version, srs) {
    const wfs = new WFS({ version: data_version });
    const features = wfs.readFeatures(doc, {
        dataProjection: srs,
        featureProjection: map_projection.getCode() == srs ? '' : map_projection,
    });
    return features;
}

class HsCapabilityCacheService {
    constructor() {
        this.cache = {};
    }
    set(url, wrap) {
        this.cache[url] = wrap;
    }
    get(url) {
        return this.cache[url];
    }
}
HsCapabilityCacheService.ɵfac = function HsCapabilityCacheService_Factory(t) { return new (t || HsCapabilityCacheService)(); };
HsCapabilityCacheService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HsCapabilityCacheService_Factory() { return new HsCapabilityCacheService(); }, token: HsCapabilityCacheService, providedIn: "root" });
HsCapabilityCacheService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsCapabilityCacheService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return []; }, null); })();

class HsWfsGetCapabilitiesService {
    constructor(httpClient, hsEventBusService, hsMapService, hsUtilsService, hsAddDataService, hsCapabilityCacheService) {
        this.httpClient = httpClient;
        this.hsEventBusService = hsEventBusService;
        this.hsMapService = hsMapService;
        this.hsUtilsService = hsUtilsService;
        this.hsAddDataService = hsAddDataService;
        this.hsCapabilityCacheService = hsCapabilityCacheService;
    }
    /**
     * Get WFS service location without parameters from url string
     *
     * @param str - Url string to parse
     * @returns WFS service Url without params
     */
    getPathFromUrl(str) {
        if (str.indexOf('?') > -1) {
            return str.substring(0, str.indexOf('?'));
        }
        else {
            return str;
        }
    }
    /**
     * Create WFS parameter string from parameter object
     * TODO: Probably the same as utils.paramsToURL
     *
     * @param obj - Object with stored WFS service parameters
     * @returns Parameter string or empty string if no object given
     */
    params2String(obj) {
        return obj
            ? Object.keys(obj)
                .map((key) => {
                const val = obj[key];
                if (Array.isArray(val)) {
                    return val
                        .map((val2) => {
                        return (encodeURIComponent(key) + '=' + encodeURIComponent(val2));
                    })
                        .join('&');
                }
                return encodeURIComponent(key) + '=' + encodeURIComponent(val);
            })
                .join('&')
            : '';
    }
    /**
     * Parse added service url and sends request GetCapabilities to WFS service
     *
     * @param service_url - Raw Url localization of service
     * @returns Promise object - Response to GetCapabilities request
     */
    request(service_url) {
        return __awaiter(this, void 0, void 0, function* () {
            service_url = service_url.replace(/&amp;/g, '&');
            this.service_url = service_url;
            const params = this.hsUtilsService.getParamsFromUrl(service_url);
            const path = this.getPathFromUrl(service_url);
            if (params.request == undefined && params.REQUEST == undefined) {
                params.request = 'GetCapabilities';
            }
            else if (params.request !== undefined) {
                params.request = 'GetCapabilities';
            }
            else if (params.REQUEST !== undefined) {
                params.REQUEST = 'GetCapabilities';
            }
            if (params.service == undefined && params.SERVICE == undefined) {
                params.service = 'WFS';
            }
            if (params.version == undefined && params.VERSION == undefined) {
                params.version = '1.1.0';
            }
            let url = [path, this.params2String(params)].join('?');
            url = this.hsUtilsService.proxify(url);
            if (this.hsCapabilityCacheService.get(url)) {
                return this.hsCapabilityCacheService.get(url);
            }
            try {
                const r = yield this.httpClient
                    .get(url, {
                    responseType: 'text',
                })
                    .pipe(takeUntil(this.hsAddDataService.cancelUrlRequest))
                    .toPromise();
                const wrap = { response: r };
                this.hsCapabilityCacheService.set(url, wrap);
                return wrap;
            }
            catch (e) {
                return { response: e, error: true };
            }
        });
    }
}
HsWfsGetCapabilitiesService.ɵfac = function HsWfsGetCapabilitiesService_Factory(t) { return new (t || HsWfsGetCapabilitiesService)(ɵngcc0.ɵɵinject(ɵngcc2.HttpClient), ɵngcc0.ɵɵinject(HsEventBusService), ɵngcc0.ɵɵinject(HsMapService), ɵngcc0.ɵɵinject(HsUtilsService), ɵngcc0.ɵɵinject(HsAddDataService), ɵngcc0.ɵɵinject(HsCapabilityCacheService)); };
HsWfsGetCapabilitiesService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HsWfsGetCapabilitiesService_Factory() { return new HsWfsGetCapabilitiesService(i0.ɵɵinject(i1$1.HttpClient), i0.ɵɵinject(HsEventBusService), i0.ɵɵinject(HsMapService), i0.ɵɵinject(HsUtilsService), i0.ɵɵinject(HsAddDataService), i0.ɵɵinject(HsCapabilityCacheService)); }, token: HsWfsGetCapabilitiesService, providedIn: "root" });
HsWfsGetCapabilitiesService.ctorParameters = () => [
    { type: HttpClient },
    { type: HsEventBusService },
    { type: HsMapService },
    { type: HsUtilsService },
    { type: HsAddDataService },
    { type: HsCapabilityCacheService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsWfsGetCapabilitiesService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc2.HttpClient }, { type: HsEventBusService }, { type: HsMapService }, { type: HsUtilsService }, { type: HsAddDataService }, { type: HsCapabilityCacheService }]; }, null); })();

class HsAddDataWfsService {
    constructor(http, hsUtilsService, hsWfsGetCapabilitiesService, hsMapService, hsEventBusService, hsLayoutService, hsAddDataCommonUrlService) {
        this.http = http;
        this.hsUtilsService = hsUtilsService;
        this.hsWfsGetCapabilitiesService = hsWfsGetCapabilitiesService;
        this.hsMapService = hsMapService;
        this.hsEventBusService = hsEventBusService;
        this.hsLayoutService = hsLayoutService;
        this.hsAddDataCommonUrlService = hsAddDataCommonUrlService;
        this.data = {
            add_all: null,
            bbox: null,
            folder_name: 'WFS',
            layers: [],
            map_projection: undefined,
            output_format: '',
            output_formats: null,
            services: [],
            srs: null,
            srss: [],
            title: '',
            version: '',
        };
        this.definedProjections = [
            'EPSG:3857',
            'EPSG:5514',
            'EPSG:4258',
            'EPSG:4326',
        ];
        this.hsEventBusService.olMapLoads.subscribe(() => {
            this.data.map_projection = this.hsMapService.map
                .getView()
                .getProjection()
                .getCode()
                .toUpperCase();
        });
    }
    addLayerFromCapabilities(wrapper, sld) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!wrapper.response && !wrapper.error) {
                return;
            }
            if (wrapper.error) {
                this.hsAddDataCommonUrlService.throwParsingError(wrapper.response.message);
                return;
            }
            try {
                const bbox = yield this.parseCapabilities(wrapper.response);
                if (this.hsAddDataCommonUrlService.layerToSelect) {
                    for (const layer of this.data.services) {
                        //TODO: If Layman allows layers with different casing,
                        // then remove the case lowering
                        if (layer.Title.toLowerCase() ===
                            this.hsAddDataCommonUrlService.layerToSelect.toLowerCase() ||
                            layer.Name.toLowerCase() ===
                                this.hsAddDataCommonUrlService.layerToSelect.toLowerCase()) {
                            layer.checked = true;
                        }
                    }
                    this.addLayers(true, sld);
                    this.hsAddDataCommonUrlService.layerToSelect = null;
                    this.zoomToBBox(bbox);
                }
            }
            catch (e) {
                this.hsAddDataCommonUrlService.throwParsingError(e);
            }
        });
    }
    /**
     * @param response - A stringified XML response to getCapabilities request
     * @returns
     */
    parseCapabilities(response) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this.loadingFeatures = false;
                let caps = xml2Json.xml2js(response, { compact: true });
                if (caps['wfs:WFS_Capabilities']) {
                    caps = caps['wfs:WFS_Capabilities'];
                }
                else {
                    caps = caps['WFS_Capabilities'];
                }
                this.parseWFSJson(caps);
                this.data.title = caps.ServiceIdentification.Title || 'Wfs layer';
                // this.description = addAnchors(caps.ServiceIdentification.Abstract);
                this.data.version = caps.ServiceIdentification.ServiceTypeVersion;
                const layer = Array.isArray(caps.FeatureTypeList.FeatureType)
                    ? caps.FeatureTypeList.FeatureType[0]
                    : caps.FeatureTypeList.FeatureType;
                this.data.layers = Array.isArray(caps.FeatureTypeList.FeatureType)
                    ? caps.FeatureTypeList.FeatureType
                    : [caps.FeatureTypeList.FeatureType];
                this.data.bbox =
                    layer.WGS84BoundingBox || layer.OutputFormats.WGS84BoundingBox;
                this.data.output_format = this.getPreferredFormat(this.data.version);
                this.data.services = caps.FeatureTypeList.FeatureType[0]
                    ? caps.FeatureTypeList.FeatureType
                    : [caps.FeatureTypeList.FeatureType];
                const srsType = layer.DefaultSRS ? 'SRS' : 'CRS';
                if (layer['Default' + srsType] !== undefined) {
                    this.data.srss = [layer['Default' + srsType]];
                }
                else {
                    this.data.srss = [];
                    this.data.srss.push('EPSG:4326');
                }
                const otherSRS = layer['Other' + srsType];
                if (otherSRS) {
                    if (typeof otherSRS == 'string') {
                        this.data.srss.push(otherSRS);
                    }
                    else {
                        for (const srs of layer['Other' + srsType]) {
                            this.data.srss.push(srs);
                        }
                    }
                }
                if (this.data.srss[0] === undefined) {
                    this.data.srss = [
                        caps.FeatureTypeList.FeatureType[0]['Default' + srsType],
                    ];
                    for (const srs of caps.FeatureTypeList.FeatureType[0]['Other' + srsType]) {
                        this.data.srss.push(srs);
                    }
                }
                this.data.srss = this.parseEPSG(this.data.srss);
                if (this.data.srss.length == 0) {
                    this.data.srss = ['EPSG:3857'];
                }
                this.data.srs = (() => {
                    for (const srs of this.data.srss) {
                        if (srs.includes('3857')) {
                            return srs;
                        }
                    }
                    return this.data.srss[0];
                })();
                if (!this.hsAddDataCommonUrlService.layerToSelect) {
                    setTimeout(() => {
                        try {
                            this.parseFeatureCount();
                        }
                        catch (e) {
                            throw new Error(e);
                        }
                    });
                }
                this.hsAddDataCommonUrlService.loadingInfo = false;
                return this.data.bbox;
            }
            catch (e) {
                throw new Error(e);
            }
        });
    }
    getPreferredFormat(version) {
        switch (version) {
            case '1.0.0':
                return 'GML2';
            case '1.1.0':
                return 'GML3';
            case '2.0.0':
                return 'GML32';
            default:
                return 'GML3';
        }
    }
    parseFeatureCount() {
        for (const service of this.data.services) {
            const url = [
                this.hsWfsGetCapabilitiesService.service_url.split('?')[0],
                this.hsUtilsService.paramsToURLWoEncode({
                    service: 'wfs',
                    version: this.data.version,
                    request: 'GetFeature',
                    typeName: service.Name,
                    resultType: 'hits',
                }),
            ].join('?');
            this.http
                .get(this.hsUtilsService.proxify(url), { responseType: 'text' })
                .subscribe((response) => {
                const oParser = new DOMParser();
                const oDOM = oParser.parseFromString(response, 'application/xml');
                const doc = oDOM.documentElement;
                service.featureCount = doc.getAttribute('numberOfFeatures');
                //WFS 2.0.0
                if (service.featureCount == 0 || !service.featureCount) {
                    service.featureCount = doc.getAttribute('numberMatched');
                }
                service.featureCount > 1000
                    ? (service.limitFeatureCount = true)
                    : (service.limitFeatureCount = false);
            }, (e) => {
                this.hsAddDataCommonUrlService.throwParsingError(e);
            });
        }
    }
    parseWFSJson(json) {
        try {
            for (const key of Object.keys(json)) {
                if (key.includes(':')) {
                    json[key.substring(4)] = json[key];
                    if (typeof json[key.substring(4)] == 'object') {
                        this.parseWFSJson(json[key]);
                    }
                    if (json[key.substring(4)] && json[key.substring(4)]['_text']) {
                        json[key.substring(4)] = json[key.substring(4)]['_text'];
                    }
                    delete json[key];
                }
                if (typeof json[key] == 'object') {
                    this.parseWFSJson(json[key]);
                    if (json[key] && json[key]['_text']) {
                        json[key] = json[key]['_text'];
                    }
                }
            }
        }
        catch (e) {
            throw new Error(e);
        }
    }
    parseEPSG(srss) {
        srss.forEach((srs, index) => {
            const epsgCode = srs.slice(-4);
            srss[index] = 'EPSG:' + epsgCode;
            if (!get(srss[index])) {
                srss.splice(srss.indexOf(index), 1);
            }
        });
        return [...Array.from(new Set(srss))].filter((srs) => this.definedProjections.includes(srs));
    }
    /**
     * First step in adding layers to the map. Lops through the list of layers and calls addLayer.
     * @param checkedOnly - Add all available layers or only checked ones. Checked=false=all
     */
    addLayers(checkedOnly, sld) {
        this.data.add_all = checkedOnly;
        for (const layer of this.data.services) {
            this.addLayersRecursively(layer, { sld });
        }
    }
    addLayersRecursively(layer, options) {
        if (!this.data.add_all || layer.checked) {
            this.addLayer(layer, {
                layerName: layer.Name,
                folder: this.hsUtilsService.undefineEmptyString(this.data.folder_name),
                crs: this.data.srs,
                sld: options.sld,
            });
        }
        if (layer.Layer) {
            for (const sublayer of layer.Layer) {
                this.addLayersRecursively(sublayer, { sld: options.sld });
            }
        }
    }
    /**
     * (PRIVATE) Add selected layer to map???
     * @param layer - capabilities layer object
     * @param layerName - layer name in the map
     * @param folder - name
     * @param srs - of the layer
     */
    addLayer(layer, options) {
        const new_layer = new VectorLayer({
            properties: {
                name: options.layerName,
                title: layer.Title.replace(/\//g, '&#47;'),
                path: options.folder,
                removable: true,
                sld: options.sld,
                wfsUrl: this.hsWfsGetCapabilitiesService.service_url.split('?')[0],
            },
            source: new WfsSource(this.hsUtilsService, this.http, {
                data_version: this.data.version,
                output_format: this.data.output_format,
                crs: options.crs,
                provided_url: this.hsWfsGetCapabilitiesService.service_url.split('?')[0],
                layer: layer,
                layer_name: options.layerName,
                map_projection: this.hsMapService.map.getView().getProjection(),
            }),
            renderOrder: null,
            //Used to determine whether its URL WFS service when saving to compositions
        });
        this.hsMapService.map.addLayer(new_layer);
        this.hsLayoutService.setMainPanel('layermanager');
    }
    zoomToBBox(bbox) {
        if (!bbox) {
            return;
        }
        if (bbox.LowerCorner) {
            bbox = [
                bbox.LowerCorner.split(' ')[0],
                bbox.LowerCorner.split(' ')[1],
                bbox.UpperCorner.split(' ')[0],
                bbox.UpperCorner.split(' ')[1],
            ];
        }
        if (!this.data.map_projection) {
            this.data.map_projection = this.hsMapService.map
                .getView()
                .getProjection()
                .getCode()
                .toUpperCase();
        }
        const extent = transformExtent(bbox, 'EPSG:4326', this.data.map_projection);
        if (extent) {
            this.hsMapService.fitExtent(extent);
        }
    }
}
HsAddDataWfsService.ɵfac = function HsAddDataWfsService_Factory(t) { return new (t || HsAddDataWfsService)(ɵngcc0.ɵɵinject(ɵngcc2.HttpClient), ɵngcc0.ɵɵinject(HsUtilsService), ɵngcc0.ɵɵinject(HsWfsGetCapabilitiesService), ɵngcc0.ɵɵinject(HsMapService), ɵngcc0.ɵɵinject(HsEventBusService), ɵngcc0.ɵɵinject(HsLayoutService), ɵngcc0.ɵɵinject(HsAddDataCommonUrlService)); };
HsAddDataWfsService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HsAddDataWfsService_Factory() { return new HsAddDataWfsService(i0.ɵɵinject(i1$1.HttpClient), i0.ɵɵinject(HsUtilsService), i0.ɵɵinject(HsWfsGetCapabilitiesService), i0.ɵɵinject(HsMapService), i0.ɵɵinject(HsEventBusService), i0.ɵɵinject(HsLayoutService), i0.ɵɵinject(HsAddDataCommonUrlService)); }, token: HsAddDataWfsService, providedIn: "root" });
HsAddDataWfsService.ctorParameters = () => [
    { type: HttpClient },
    { type: HsUtilsService },
    { type: HsWfsGetCapabilitiesService },
    { type: HsMapService },
    { type: HsEventBusService },
    { type: HsLayoutService },
    { type: HsAddDataCommonUrlService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsAddDataWfsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc2.HttpClient }, { type: HsUtilsService }, { type: HsWfsGetCapabilitiesService }, { type: HsMapService }, { type: HsEventBusService }, { type: HsLayoutService }, { type: HsAddDataCommonUrlService }]; }, null); })();

/**
 * Loop through list of formats returned by getcapabilities and select first available from the list of available formats
 *
 * @param formats - List of formats available for service
 * @param preferredFormats - List of preferred formats for output
 * @returns Either one of preferred formats or first available format
 */
function getPreferredFormat(formats, preferredFormats) {
    for (let i = 0; i < preferredFormats.length; i++) {
        if (formats.indexOf(preferredFormats[i]) > -1) {
            return preferredFormats[i];
        }
    }
    return formats[0];
}

class HsWmsGetCapabilitiesService {
    constructor(httpClient, hsEventBusService, hsMapService, hsUtilsService, hsCommonEndpointsService, hsAddDataService, hsCapabilityCacheService) {
        this.httpClient = httpClient;
        this.hsEventBusService = hsEventBusService;
        this.hsMapService = hsMapService;
        this.hsUtilsService = hsUtilsService;
        this.hsCommonEndpointsService = hsCommonEndpointsService;
        this.hsAddDataService = hsAddDataService;
        this.hsCapabilityCacheService = hsCapabilityCacheService;
    }
    /**
     * Get WMS service location without parameters from url string
     *
     * @param str Url string to parse
     * @returns WMS service Url
     */
    getPathFromUrl(str) {
        if (str.indexOf('?') > -1) {
            return str.substring(0, str.indexOf('?'));
        }
        else {
            return str;
        }
    }
    /**
     * Create WMS parameter string from parameter object
     * TODO: Probably the same as utils.paramsToURL
     *
     * @param obj Object with stored WMS service parameters
     * @returns Parameter string or empty string if no object given
     */
    params2String(obj) {
        return obj
            ? Object.keys(obj)
                .map((key) => {
                const val = obj[key];
                if (Array.isArray(val)) {
                    return val
                        .map((val2) => {
                        return (encodeURIComponent(key) + '=' + encodeURIComponent(val2));
                    })
                        .join('&');
                }
                return encodeURIComponent(key) + '=' + encodeURIComponent(val);
            })
                .join('&')
            : '';
    }
    /**
     * Parse added service url and sends GetCapabilities request to WMS service
     *
     * @param service_url Raw Url localization of service
     * @param [options]
     * @returns Promise object - Response to GetCapabilities request
     */
    request(service_url) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            service_url = service_url.replace(/&amp;/g, '&');
            const params = this.hsUtilsService.getParamsFromUrl(service_url);
            const path = this.getPathFromUrl(service_url);
            if (params.request === undefined && params.REQUEST === undefined) {
                params.request = 'GetCapabilities';
            }
            else if (params.request !== undefined) {
                params.request = 'GetCapabilities';
            }
            else if (params.REQUEST !== undefined) {
                params.REQUEST = 'GetCapabilities';
            }
            if (params.service === undefined && params.SERVICE === undefined) {
                params.service = 'WMS';
            }
            if (params.version === undefined && params.VERSION === undefined) {
                params.version = '1.3.0';
            }
            let url = [path, this.params2String(params)].join('?');
            url = this.hsUtilsService.proxify(url);
            if (this.hsCapabilityCacheService.get(url)) {
                return this.hsCapabilityCacheService.get(url);
            }
            try {
                const r = yield this.httpClient
                    .get(url, {
                    responseType: 'text',
                    withCredentials: url.includes((_b = (_a = this.hsCommonEndpointsService) === null || _a === void 0 ? void 0 : _a.endpoints.filter((ep) => ep.type == 'layman')[0]) === null || _b === void 0 ? void 0 : _b.url),
                })
                    .pipe(takeUntil(this.hsAddDataService.cancelUrlRequest))
                    .toPromise();
                const wrap = { response: r };
                this.hsCapabilityCacheService.set(url, wrap);
                return wrap;
            }
            catch (e) {
                return {
                    response: e,
                    error: true,
                };
            }
        });
    }
    /**
     * Load all layers of selected service to the map
     *
     * @param capabilities_xml XML response of GetCapabilities of selected service
     * @param path
     * @returns List of layers from service
     */
    service2layers(capabilities_xml, path) {
        const parser = new WMSCapabilities();
        const caps = parser.read(capabilities_xml);
        let service = caps.Capability.Layer;
        if (service.length == undefined && service.Layer != undefined) {
            service = [service];
        }
        //const srss = caps.Capability.Layer.CRS;
        const image_formats = caps.Capability.Request.GetMap.Format;
        const query_formats = caps.Capability.Request.GetFeatureInfo
            ? caps.Capability.Request.GetFeatureInfo.Format
            : [];
        const image_format = getPreferredFormat(image_formats, [
            'image/png; mode=8bit',
            'image/png',
            'image/gif',
            'image/jpeg',
        ]);
        const query_format = getPreferredFormat(query_formats, [
            'application/vnd.esri.wms_featureinfo_xml',
            'application/vnd.ogc.gml',
            'application/vnd.ogc.wms_xml',
            'text/plain',
            'text/html',
        ]);
        const tmp = [];
        service.forEach((service) => {
            service.Layer.forEach((layer) => {
                let attributions = [];
                if (layer.Attribution) {
                    attributions = [
                        `<a href="${layer.Attribution.OnlineResource}">${layer.Attribution.Title}</a>`,
                    ];
                }
                const metadata = this.getMetadataObjectWithUrls(layer);
                const new_layer = new Tile({
                    properties: {
                        title: layer.Title.replace(/\//g, '&#47;'),
                        name: layer.Name.replace(/\//g, '&#47;'),
                        path,
                        abstract: layer.Abstract,
                        metadata,
                    },
                    source: new TileWMS({
                        url: caps.Capability.Request.GetMap.DCPType[0].HTTP.Get
                            .OnlineResource,
                        attributions: attributions,
                        params: {
                            LAYERS: layer.Name,
                            INFO_FORMAT: layer.queryable ? query_format : undefined,
                            FORMAT: image_format,
                            styles: layer.Style && layer.Style.length > 0
                                ? layer.Style[0].Name
                                : undefined,
                        },
                        crossOrigin: 'anonymous',
                    }),
                    useInterimTilesOnError: false,
                    extent: layer.BoundingBox,
                });
                this.hsMapService.proxifyLayerLoader(new_layer, true);
                tmp.push(new_layer);
            });
        });
        return tmp;
    }
    getMetadataObjectWithUrls(layer) {
        if (layer.MetadataURL) {
            const metadata = {
                urls: layer.MetadataURL.map((url) => {
                    return {
                        type: url.type,
                        format: url.Format,
                        onlineResource: url.OnlineResource,
                    };
                }),
            };
            return metadata;
        }
    }
}
HsWmsGetCapabilitiesService.ɵfac = function HsWmsGetCapabilitiesService_Factory(t) { return new (t || HsWmsGetCapabilitiesService)(ɵngcc0.ɵɵinject(ɵngcc2.HttpClient), ɵngcc0.ɵɵinject(HsEventBusService), ɵngcc0.ɵɵinject(HsMapService), ɵngcc0.ɵɵinject(HsUtilsService), ɵngcc0.ɵɵinject(HsCommonEndpointsService), ɵngcc0.ɵɵinject(HsAddDataService), ɵngcc0.ɵɵinject(HsCapabilityCacheService)); };
HsWmsGetCapabilitiesService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HsWmsGetCapabilitiesService_Factory() { return new HsWmsGetCapabilitiesService(i0.ɵɵinject(i1$1.HttpClient), i0.ɵɵinject(HsEventBusService), i0.ɵɵinject(HsMapService), i0.ɵɵinject(HsUtilsService), i0.ɵɵinject(HsCommonEndpointsService), i0.ɵɵinject(HsAddDataService), i0.ɵɵinject(HsCapabilityCacheService)); }, token: HsWmsGetCapabilitiesService, providedIn: "root" });
HsWmsGetCapabilitiesService.ctorParameters = () => [
    { type: HttpClient },
    { type: HsEventBusService },
    { type: HsMapService },
    { type: HsUtilsService },
    { type: HsCommonEndpointsService },
    { type: HsAddDataService },
    { type: HsCapabilityCacheService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsWmsGetCapabilitiesService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc2.HttpClient }, { type: HsEventBusService }, { type: HsMapService }, { type: HsUtilsService }, { type: HsCommonEndpointsService }, { type: HsAddDataService }, { type: HsCapabilityCacheService }]; }, null); })();

class HsWmtsGetCapabilitiesService {
    constructor(httpClient, hsEventBusService, hsMapService, hsUtilsService, hsWmsGetCapabilitiesService, hsAddDataService, hsCapabilityCacheService) {
        this.httpClient = httpClient;
        this.hsEventBusService = hsEventBusService;
        this.hsMapService = hsMapService;
        this.hsUtilsService = hsUtilsService;
        this.hsWmsGetCapabilitiesService = hsWmsGetCapabilitiesService;
        this.hsAddDataService = hsAddDataService;
        this.hsCapabilityCacheService = hsCapabilityCacheService;
    }
    /**
     * Get WMTS service location without parameters from url string
     *
     * @param str - Url string to parse
     * @returns WMTS service Url
     */
    getPathFromUrl(str) {
        if (str.indexOf('?') > -1) {
            return str.substring(0, str.indexOf('?'));
        }
        else {
            return str;
        }
    }
    /**
     * Create WMTS parameter string from parameter object
     * TODO: Probably the same as utils.paramsToURL
     *
     * @param obj - Object with stored WMS service parameters
     * @returns Parameter string or empty string if no object given
     */
    params2String(obj) {
        return obj
            ? Object.keys(obj)
                .map((key) => {
                const val = obj[key];
                if (Array.isArray(val)) {
                    return val
                        .map((val2) => {
                        return (encodeURIComponent(key) + '=' + encodeURIComponent(val2));
                    })
                        .join('&');
                }
                return encodeURIComponent(key) + '=' + encodeURIComponent(val);
            })
                .join('&')
            : '';
    }
    /**
     * Parse added service url and sends GetCapabilities request to WMTS service
     *
     * @param service_url - Raw Url localization of service
     * @returns Promise object -  Response to GetCapabilities request
     */
    request(service_url) {
        return __awaiter(this, void 0, void 0, function* () {
            service_url = service_url.replace(/&amp;/g, '&');
            const params = this.hsUtilsService.getParamsFromUrl(service_url);
            const path = this.getPathFromUrl(service_url);
            if (params.request == undefined && params.REQUEST == undefined) {
                params.request = 'GetCapabilities';
            }
            else if (params.request != undefined) {
                params.request = 'GetCapabilities';
            }
            else if (params.REQUEST != undefined) {
                params.REQUEST = 'GetCapabilities';
            }
            if (params.service == undefined && params.SERVICE == undefined) {
                params.service = 'wmts';
            }
            if (params.version == undefined && params.VERSION == undefined) {
                params.version = '1.3.0';
            }
            let url = [path, this.params2String(params)].join('?');
            if (this.hsCapabilityCacheService.get(url)) {
                return this.hsCapabilityCacheService.get(url);
            }
            try {
                url = this.hsUtilsService.proxify(url);
                const r = yield this.httpClient
                    .get(url, {
                    responseType: 'text',
                })
                    .pipe(takeUntil(this.hsAddDataService.cancelUrlRequest))
                    .toPromise();
                const wrap = { response: r };
                this.hsCapabilityCacheService.set(url, wrap);
                return wrap;
            }
            catch (error) {
                return {
                    response: error,
                    error: true,
                };
            }
        });
    }
    /**
     * Load all layers of selected service to the map
     *
     * @param capabilities_xml - XML response of GetCapabilities of selected service
     * @returns List of layers from service
     */
    service2layers(capabilities_xml) {
        const parser = new WMTSCapabilities();
        const caps = parser.read(capabilities_xml);
        const service = caps.Capability.Layer;
        //const srss = caps.Capability.Layer.CRS;
        const image_formats = caps.Capability.Request.GetMap.Format;
        const query_formats = caps.Capability.Request.GetFeatureInfo
            ? caps.Capability.Request.GetFeatureInfo.Format
            : [];
        const image_format = getPreferredFormat(image_formats, [
            'image/png; mode=8bit',
            'image/png',
            'image/gif',
            'image/jpeg',
        ]);
        const query_format = getPreferredFormat(query_formats, [
            'application/vnd.esri.wmts_featureinfo_xml',
            'application/vnd.ogc.gml',
            'application/vnd.ogc.wmts_xml',
            'text/plain',
            'text/html',
        ]);
        const tmp = [];
        for (const subservice of service) {
            for (const layer of subservice.Layer) {
                let attributions = [];
                if (layer.Attribution) {
                    attributions = [
                        `<a href="${layer.Attribution.OnlineResource}">${layer.Attribution.Title}</a>`,
                    ];
                }
                const metadata = this.hsWmsGetCapabilitiesService.getMetadataObjectWithUrls(layer);
                const new_layer = new Tile({
                    properties: {
                        title: layer.Title.replace(/\//g, '&#47;'),
                        abstract: layer.Abstract,
                        metadata,
                    },
                    source: new WMTS({
                        url: caps.Capability.Request.GetMap.DCPType[0].HTTP.Get
                            .OnlineResource,
                        attributions: attributions,
                        style: layer.Style && layer.Style.length > 0
                            ? layer.Style[0].Name
                            : undefined,
                        crossOrigin: 'anonymous',
                    }),
                    useInterimTilesOnError: false,
                    extent: layer.BoundingBox,
                });
                tmp.push(new_layer);
            }
        }
        return tmp;
    }
}
HsWmtsGetCapabilitiesService.ɵfac = function HsWmtsGetCapabilitiesService_Factory(t) { return new (t || HsWmtsGetCapabilitiesService)(ɵngcc0.ɵɵinject(ɵngcc2.HttpClient), ɵngcc0.ɵɵinject(HsEventBusService), ɵngcc0.ɵɵinject(HsMapService), ɵngcc0.ɵɵinject(HsUtilsService), ɵngcc0.ɵɵinject(HsWmsGetCapabilitiesService), ɵngcc0.ɵɵinject(HsAddDataService), ɵngcc0.ɵɵinject(HsCapabilityCacheService)); };
HsWmtsGetCapabilitiesService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HsWmtsGetCapabilitiesService_Factory() { return new HsWmtsGetCapabilitiesService(i0.ɵɵinject(i1$1.HttpClient), i0.ɵɵinject(HsEventBusService), i0.ɵɵinject(HsMapService), i0.ɵɵinject(HsUtilsService), i0.ɵɵinject(HsWmsGetCapabilitiesService), i0.ɵɵinject(HsAddDataService), i0.ɵɵinject(HsCapabilityCacheService)); }, token: HsWmtsGetCapabilitiesService, providedIn: "root" });
HsWmtsGetCapabilitiesService.ctorParameters = () => [
    { type: HttpClient },
    { type: HsEventBusService },
    { type: HsMapService },
    { type: HsUtilsService },
    { type: HsWmsGetCapabilitiesService },
    { type: HsAddDataService },
    { type: HsCapabilityCacheService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsWmtsGetCapabilitiesService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc2.HttpClient }, { type: HsEventBusService }, { type: HsMapService }, { type: HsUtilsService }, { type: HsWmsGetCapabilitiesService }, { type: HsAddDataService }, { type: HsCapabilityCacheService }]; }, null); })();

class HsCompositionsLayerParserService {
    constructor(HsMapService, HsAddDataVectorService, HsStylerService, HsWmtsGetCapabilitiesService, HsLanguageService, HsToastService, HsEventBusService, HsAddDataWfsService, hsWfsGetCapabilitiesService, hsAddDataCommonUrlService) {
        this.HsMapService = HsMapService;
        this.HsAddDataVectorService = HsAddDataVectorService;
        this.HsStylerService = HsStylerService;
        this.HsWmtsGetCapabilitiesService = HsWmtsGetCapabilitiesService;
        this.HsLanguageService = HsLanguageService;
        this.HsToastService = HsToastService;
        this.HsEventBusService = HsEventBusService;
        this.HsAddDataWfsService = HsAddDataWfsService;
        this.hsWfsGetCapabilitiesService = hsWfsGetCapabilitiesService;
        this.hsAddDataCommonUrlService = hsAddDataCommonUrlService;
    }
    /**
     * @public
     * @param {object} lyr_def Layer definition object
     * @description Initiate creation of WFS layer thorough HsAddDataWfsService
     */
    createWFSLayer(lyr_def) {
        return __awaiter(this, void 0, void 0, function* () {
            this.hsAddDataCommonUrlService.layerToSelect = lyr_def.name;
            const wrapper = yield this.hsWfsGetCapabilitiesService.request(lyr_def.protocol.url);
            this.HsAddDataWfsService.addLayerFromCapabilities(wrapper);
        });
    }
    /**
     * @public
     * @param {object} lyr_def Layer definition object
     * @returns {object} Ol Tile layer
     * @description Parse definition object to create WMTS Ol.layer  (source = ol.source.WMTS)
     */
    createWMTSLayer(lyr_def) {
        return __awaiter(this, void 0, void 0, function* () {
            const wmts = new Tile({
                source: new WMTS$1({}),
                properties: {
                    title: lyr_def.title,
                    info_format: lyr_def.info_format,
                },
            });
            // Get WMTS Capabilities and create WMTS source base on it
            const wrapper = yield this.HsWmtsGetCapabilitiesService.request(lyr_def.url);
            try {
                //parse the XML response and create options object...
                const parser = new WMTSCapabilities();
                const result = parser.read(wrapper.response);
                // ...create WMTS Capabilities based on the parsed options
                const options = optionsFromCapabilities(result, {
                    layer: lyr_def.layer,
                    matrixSet: lyr_def.matrixSet,
                    format: lyr_def.format,
                });
                // WMTS source for raster tiles layer
                wmts.setSource(new WMTS$1(options));
                this.HsMapService.proxifyLayerLoader(wmts, true);
            }
            catch (error) {
                this.HsToastService.createToastPopupMessage(this.HsLanguageService.getTranslation('ADDLAYERS.capabilitiesParsingProblem'), this.HsLanguageService.getTranslationIgnoreNonExisting('ERRORMESSAGES', error), {
                    disableLocalization: true,
                    serviceCalledFrom: 'HsCompositionsLayerParserService',
                });
                this.HsMapService.map.getLayers().remove(wmts);
            }
            wmts.setVisible(lyr_def.visibility);
            return wmts;
        });
    }
    /**
     * @public
     * @param {object} lyr_def Layer definition object
     * @returns {object} Ol Image or Tile layer
     * @description Parse definition object to create WMS Ol.layer  (source = ol.source.ImageWMS / ol.source.TileWMS)
     */
    createWmsLayer(lyr_def) {
        var _a;
        const params = lyr_def.params;
        const legends = this.getLegends(lyr_def);
        delete params.REQUEST;
        //delete params.FORMAT; Commented, because otherwise when loading from cookie or store, it displays jpeg
        const url = decodeURIComponent(lyr_def.url);
        const sourceOptions = {
            url: url,
            attributions: lyr_def.attribution
                ? `<a href="${lyr_def.attribution.OnlineResource}">${lyr_def.attribution.Title}</a>`
                : undefined,
            params,
            crossOrigin: 'anonymous',
            projection: (_a = lyr_def.projection) === null || _a === void 0 ? void 0 : _a.toUpperCase(),
            ratio: lyr_def.ratio,
        };
        const source = lyr_def.singleTile
            ? new ImageWMS(sourceOptions)
            : new TileWMS(sourceOptions);
        const layerOptions = {
            title: lyr_def.title,
            fromComposition: true,
            maxResolution: lyr_def.maxResolution || Infinity,
            minResolution: lyr_def.minResolution || 0,
            showInLayerManager: lyr_def.displayInLayerSwitcher,
            abstract: lyr_def.name || lyr_def.abstract,
            base: lyr_def.base,
            metadata: lyr_def.metadata,
            dimensions: lyr_def.dimensions,
            legends: legends,
            path: lyr_def.path,
            opacity: lyr_def.opacity || 1,
            source,
            subLayers: lyr_def.subLayers,
        };
        const new_layer = lyr_def.singleTile
            ? new Image$1(layerOptions)
            : new Tile(layerOptions);
        new_layer.setVisible(lyr_def.visibility);
        this.HsMapService.proxifyLayerLoader(new_layer, !lyr_def.singleTile);
        return new_layer;
    }
    /**
     * @public
     * @param {object} lyr_def Layer definition object
     * @returns {object} Ol Image or Tile layer
     * @description Parse definition object to create ArcGIS Ol.layer  (source = ol.source.ImageArcGISRest / ol.source.TileArcGISRest)
     */
    createArcGISLayer(lyr_def) {
        var _a;
        const params = lyr_def.params;
        const legends = this.getLegends(lyr_def);
        if (params) {
            delete params.REQUEST;
        }
        //delete params.FORMAT; Commented, because otherwise when loading from cookie or store, it displays jpeg
        const sourceOptions = {
            url: decodeURIComponent(lyr_def.url),
            attributions: lyr_def.attribution
                ? `<a href="${lyr_def.attribution.OnlineResource}">${lyr_def.attribution.Title}</a>`
                : undefined,
            params,
            crossOrigin: 'anonymous',
            projection: (_a = lyr_def.projection) === null || _a === void 0 ? void 0 : _a.toUpperCase(),
            ratio: lyr_def.ratio,
        };
        const source = lyr_def.singleTile
            ? new ImageArcGISRest(sourceOptions)
            : new TileArcGISRest(sourceOptions);
        const layerOptions = {
            title: lyr_def.title,
            fromComposition: true,
            maxResolution: lyr_def.maxResolution || Infinity,
            minResolution: lyr_def.minResolution || 0,
            showInLayerManager: lyr_def.displayInLayerSwitcher,
            abstract: lyr_def.name || lyr_def.abstract,
            base: lyr_def.base,
            metadata: lyr_def.metadata,
            dimensions: lyr_def.dimensions,
            legends: legends,
            path: lyr_def.path,
            opacity: lyr_def.opacity || 1,
            source,
        };
        const new_layer = new lyr_def.singleTile()
            ? new Image$1(layerOptions)
            : new Tile(layerOptions);
        new_layer.setVisible(lyr_def.visibility);
        //TODO Proxify
        //OlMap.proxifyLayerLoader(new_layer, !lyr_def.singleTile);
        return new_layer;
    }
    /**
     * @public
     * @param {object} lyr_def Layer definition object
     * @returns {object} Ol Image or Tile layer
     * @description Parse definition object to create XYZ Ol.layer
     */
    createXYZLayer(lyr_def) {
        var _a;
        const legends = this.getLegends(lyr_def);
        const source = new XYZ({
            url: decodeURIComponent(lyr_def.url),
            attributions: lyr_def.attribution
                ? `<a href="${lyr_def.attribution.OnlineResource}">${lyr_def.attribution.Title}</a>`
                : undefined,
            crossOrigin: 'anonymous',
            projection: (_a = lyr_def.projection) === null || _a === void 0 ? void 0 : _a.toUpperCase(),
            wrapX: lyr_def.wrapX,
            //TODO Add the rest of parameters and describe in the composition schema
        });
        const new_layer = new Tile({
            maxResolution: lyr_def.maxResolution || Infinity,
            minResolution: lyr_def.minResolution || 0,
            opacity: lyr_def.opacity || 1,
            source,
            properties: {
                title: lyr_def.title,
                fromComposition: true,
                showInLayerManager: lyr_def.displayInLayerSwitcher,
                abstract: lyr_def.name || lyr_def.abstract,
                base: lyr_def.base || lyr_def.url.indexOf('openstreetmap') > -1,
                metadata: lyr_def.metadata,
                dimensions: lyr_def.dimensions,
                legends: legends,
                path: lyr_def.path,
            },
        });
        new_layer.setVisible(lyr_def.visibility);
        //TODO Proxify
        //OlMap.proxifyLayerLoader(new_layer, !lyr_def.singleTile);
        return new_layer;
    }
    /**
     * @public
     * @param {object} lyr_def Layer definition object
     * @returns {object} Ol Image or Tile layer
     * @description Parse definition object to create ImageStatic Ol.layer
     */
    createStaticImageLayer(lyr_def) {
        var _a;
        const legends = this.getLegends(lyr_def);
        const source = new ImageStatic({
            url: decodeURIComponent(lyr_def.url),
            attributions: lyr_def.attribution
                ? `<a href="${lyr_def.attribution.OnlineResource}">${lyr_def.attribution.Title}</a>`
                : undefined,
            imageExtent: lyr_def.extent,
            crossOrigin: 'anonymous',
            projection: (_a = lyr_def.projection) === null || _a === void 0 ? void 0 : _a.toUpperCase(),
            //TODO Add the rest of parameters and describe in the composition schema
        });
        const new_layer = new Image$1({
            maxResolution: lyr_def.maxResolution || Infinity,
            minResolution: lyr_def.minResolution || 0,
            opacity: lyr_def.opacity || 1,
            source,
            properties: {
                title: lyr_def.title,
                fromComposition: true,
                showInLayerManager: lyr_def.displayInLayerSwitcher,
                abstract: lyr_def.name || lyr_def.abstract,
                base: lyr_def.base,
                metadata: lyr_def.metadata,
                dimensions: lyr_def.dimensions,
                legends: legends,
                path: lyr_def.path,
            },
        });
        new_layer.setVisible(lyr_def.visibility);
        return new_layer;
    }
    /**
     * @public
     * @param {object} lyr_def Layer definition object
     * @description  Parse definition object to create Sparql layer
     */
    createSparqlLayer(lyr_def) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = decodeURIComponent(lyr_def.protocol.url);
            const definition = {};
            definition.url = url;
            definition.format = 'hs.format.Sparql';
            let style = null;
            if (lyr_def.style) {
                style = (yield this.HsStylerService.parseStyle(lyr_def.style)).style;
            }
            const src = new SparqlJson({
                geom_attribute: '?geom',
                url: url,
                category: 'http://www.openvoc.eu/poi#categoryWaze',
                projection: 'EPSG:3857',
            });
            const lyr = new Vector$1({
                properties: {
                    title: lyr_def.title,
                    fromComposition: true,
                    definition,
                },
                source: src,
                opacity: lyr_def.opacity || 1,
                style: style,
            });
            lyr.setVisible(lyr_def.visibility);
            return lyr;
        });
    }
    getLegends(lyr_def) {
        if (lyr_def.legends) {
            return lyr_def.legends.map((legend) => decodeURIComponent(legend));
        }
        return [];
    }
    /**
     * @public
     * @param {object} lyr_def Layer definition object
     * @returns {ol.layer.Vector|Function} Either valid vector layer or function for creation of other supported vector file types)
     * @description Parse definition object to create Vector layer (classic Ol.vector, KML, GeoJSON, WFS, Sparql)
     */
    createVectorLayer(lyr_def) {
        var _a, _b, _c, _d, _e;
        return __awaiter(this, void 0, void 0, function* () {
            let format = '';
            if (lyr_def.protocol) {
                format = lyr_def.protocol.format;
                if (lyr_def.protocol.url !== undefined) {
                    lyr_def.protocol.url = decodeURIComponent(lyr_def.protocol.url);
                }
            }
            const options = {
                opacity: lyr_def.opacity || 1,
                fromComposition: true,
                path: lyr_def.path,
                visible: lyr_def.visibility,
                // Extract workspace name for partial backwards compatibility.
                workspace: lyr_def.workspace ||
                    ((_a = lyr_def.protocol) === null || _a === void 0 ? void 0 : _a.url.split('geoserver/')[1].split('/')[0]),
            };
            let extractStyles = true;
            if (lyr_def.style) {
                Object.assign(options, yield this.HsStylerService.parseStyle(lyr_def.style));
                extractStyles = false;
            }
            const title = lyr_def.title || 'Layer';
            let layer;
            switch (format) {
                case 'ol.format.KML':
                    layer = yield this.HsAddDataVectorService.createVectorLayer('kml', lyr_def.protocol.url, lyr_def.name || title, title, lyr_def.abstract, (_b = lyr_def.projection) === null || _b === void 0 ? void 0 : _b.toUpperCase(), Object.assign(options, { extractStyles }));
                    break;
                case 'ol.format.GeoJSON':
                    layer = yield this.HsAddDataVectorService.createVectorLayer('geojson', lyr_def.protocol.url, lyr_def.name || title, title, lyr_def.abstract, (_c = lyr_def.projection) === null || _c === void 0 ? void 0 : _c.toUpperCase(), options);
                    break;
                case 'hs.format.WFS':
                case 'WFS':
                    layer = yield this.HsAddDataVectorService.createVectorLayer('wfs', lyr_def.protocol.url, 
                    //lyr_def.protocol.LAYERS
                    lyr_def.name || title, title, lyr_def.abstract, (_d = lyr_def.projection) === null || _d === void 0 ? void 0 : _d.toUpperCase(), options);
                    break;
                case 'hs.format.Sparql':
                    layer = yield this.createSparqlLayer(lyr_def);
                    break;
                default:
                    const features = lyr_def.features
                        ? new GeoJSON().readFeatures(lyr_def.features, {
                            dataProjection: 'EPSG:4326',
                            featureProjection: this.HsMapService.getCurrentProj(),
                        })
                        : undefined;
                    layer = yield this.HsAddDataVectorService.createVectorLayer('', undefined, lyr_def.name || title, title, lyr_def.abstract, (_e = lyr_def.projection) === null || _e === void 0 ? void 0 : _e.toUpperCase(), {
                        opacity: lyr_def.opacity,
                        visible: lyr_def.visibility,
                        path: lyr_def.path,
                        fromComposition: lyr_def.fromComposition,
                        style: lyr_def.style,
                        features,
                    });
            }
            setDefinition(layer, lyr_def.protocol);
            return layer;
        });
    }
}
HsCompositionsLayerParserService.ɵfac = function HsCompositionsLayerParserService_Factory(t) { return new (t || HsCompositionsLayerParserService)(ɵngcc0.ɵɵinject(HsMapService), ɵngcc0.ɵɵinject(HsAddDataVectorService), ɵngcc0.ɵɵinject(HsStylerService), ɵngcc0.ɵɵinject(HsWmtsGetCapabilitiesService), ɵngcc0.ɵɵinject(HsLanguageService), ɵngcc0.ɵɵinject(HsToastService), ɵngcc0.ɵɵinject(HsEventBusService), ɵngcc0.ɵɵinject(HsAddDataWfsService), ɵngcc0.ɵɵinject(HsWfsGetCapabilitiesService), ɵngcc0.ɵɵinject(HsAddDataCommonUrlService)); };
HsCompositionsLayerParserService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HsCompositionsLayerParserService_Factory() { return new HsCompositionsLayerParserService(i0.ɵɵinject(HsMapService), i0.ɵɵinject(HsAddDataVectorService), i0.ɵɵinject(HsStylerService), i0.ɵɵinject(HsWmtsGetCapabilitiesService), i0.ɵɵinject(HsLanguageService), i0.ɵɵinject(HsToastService), i0.ɵɵinject(HsEventBusService), i0.ɵɵinject(HsAddDataWfsService), i0.ɵɵinject(HsWfsGetCapabilitiesService), i0.ɵɵinject(HsAddDataCommonUrlService)); }, token: HsCompositionsLayerParserService, providedIn: "root" });
HsCompositionsLayerParserService.ctorParameters = () => [
    { type: HsMapService },
    { type: HsAddDataVectorService },
    { type: HsStylerService },
    { type: HsWmtsGetCapabilitiesService },
    { type: HsLanguageService },
    { type: HsToastService },
    { type: HsEventBusService },
    { type: HsAddDataWfsService },
    { type: HsWfsGetCapabilitiesService },
    { type: HsAddDataCommonUrlService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsCompositionsLayerParserService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: HsMapService }, { type: HsAddDataVectorService }, { type: HsStylerService }, { type: HsWmtsGetCapabilitiesService }, { type: HsLanguageService }, { type: HsToastService }, { type: HsEventBusService }, { type: HsAddDataWfsService }, { type: HsWfsGetCapabilitiesService }, { type: HsAddDataCommonUrlService }]; }, null); })();

class HsCompositionsWarningDialogComponent {
    constructor(HsDialogContainerService) {
        this.HsDialogContainerService = HsDialogContainerService;
    }
    close() {
        this.HsDialogContainerService.destroy(this);
    }
}
HsCompositionsWarningDialogComponent.ɵfac = function HsCompositionsWarningDialogComponent_Factory(t) { return new (t || HsCompositionsWarningDialogComponent)(ɵngcc0.ɵɵdirectiveInject(HsDialogContainerService)); };
HsCompositionsWarningDialogComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsCompositionsWarningDialogComponent, selectors: [["hs-compositions-warning-dialog"]], decls: 29, vars: 17, consts: [["tabindex", "-1", "role", "dialog", "aria-hidden", "true", 1, "modal", "in", "hs-composition-warning-dialog"], [1, "modal-dialog"], [1, "modal-content"], [1, "modal-header"], [1, "modal-title"], ["type", "button", "data-dismiss", "modal", 1, "close", 3, "click"], ["aria-hidden", "true"], [1, "sr-only"], [1, "modal-body", 2, "max-height", "600px", "overflow-y", "auto"], [1, "modal-footer"], ["type", "button", "data-dismiss", "modal", 1, "btn", "btn-primary", "compositions-btn-warning", 3, "click"]], template: function HsCompositionsWarningDialogComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelementStart(4, "h4", 4);
        ɵngcc0.ɵɵtext(5);
        ɵngcc0.ɵɵpipe(6, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "button", 5);
        ɵngcc0.ɵɵlistener("click", function HsCompositionsWarningDialogComponent_Template_button_click_7_listener() { return ctx.close(); });
        ɵngcc0.ɵɵelementStart(8, "span", 6);
        ɵngcc0.ɵɵtext(9, "\u00D7");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "span", 7);
        ɵngcc0.ɵɵtext(11);
        ɵngcc0.ɵɵpipe(12, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(13, "div", 8);
        ɵngcc0.ɵɵelement(14, "br");
        ɵngcc0.ɵɵtext(15);
        ɵngcc0.ɵɵpipe(16, "translate");
        ɵngcc0.ɵɵelementStart(17, "b");
        ɵngcc0.ɵɵtext(18);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(19, "hr");
        ɵngcc0.ɵɵelement(20, "br");
        ɵngcc0.ɵɵtext(21);
        ɵngcc0.ɵɵelement(22, "br");
        ɵngcc0.ɵɵtext(23);
        ɵngcc0.ɵɵpipe(24, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(25, "div", 9);
        ɵngcc0.ɵɵelementStart(26, "button", 10);
        ɵngcc0.ɵɵlistener("click", function HsCompositionsWarningDialogComponent_Template_button_click_26_listener() { return ctx.close(); });
        ɵngcc0.ɵɵtext(27);
        ɵngcc0.ɵɵpipe(28, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(6, 7, "COMMON.warning"));
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(12, 9, "COMMON.close"));
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(16, 11, "COMMON.name"), ": ");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.data.composition_title);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1("", ctx.data.message, " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(24, 13, "COMPOSITIONS.dialogWarning.toContinue"), " ");
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(28, 15, "COMMON.ignoreAndContinue"));
    } }, pipes: [ɵngcc1.TranslatePipe], encapsulation: 2 });
HsCompositionsWarningDialogComponent.ctorParameters = () => [
    { type: HsDialogContainerService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsCompositionsWarningDialogComponent, [{
        type: Component,
        args: [{
                selector: 'hs-compositions-warning-dialog',
                template: "<div class=\"modal in hs-composition-warning-dialog\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <h4 class=\"modal-title\">{{'COMMON.warning' | translate}}</h4>\n                <button type=\"button\" (click)=\"close()\" class=\"close\" data-dismiss=\"modal\"><span\n                        aria-hidden=\"true\">&times;</span><span class=\"sr-only\">{{'COMMON.close' | translate}}</span></button>\n            </div>\n            <div class=\"modal-body\" style=\"max-height: 600px; overflow-y: auto\">\n                <br>{{'COMMON.name' | translate}}: <b>{{data.composition_title}}</b>\n                <hr>\n                <br>{{data.message}}\n                <br>{{'COMPOSITIONS.dialogWarning.toContinue' | translate}}\n            </div>\n            <div class=\"modal-footer\">\n                <button type=\"button\" class=\"btn btn-primary compositions-btn-warning\" (click)=\"close()\"\n                    data-dismiss=\"modal\">{{'COMMON.ignoreAndContinue' | translate}}</button>\n            </div>\n        </div>\n    </div>\n</div>"
            }]
    }], function () { return [{ type: HsDialogContainerService }]; }, null); })();

class HsConfirmDialogComponent {
    constructor(HsDialogContainerService) {
        this.HsDialogContainerService = HsDialogContainerService;
    }
    yes() {
        this.HsDialogContainerService.destroy(this);
        this.dialogItem.resolve('yes');
    }
    no() {
        this.HsDialogContainerService.destroy(this);
        this.dialogItem.resolve('no');
    }
}
HsConfirmDialogComponent.ɵfac = function HsConfirmDialogComponent_Factory(t) { return new (t || HsConfirmDialogComponent)(ɵngcc0.ɵɵdirectiveInject(HsDialogContainerService)); };
HsConfirmDialogComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsConfirmDialogComponent, selectors: [["hs-confirm-dialog"]], decls: 26, vars: 18, consts: [["tabindex", "-1", "role", "dialog", "aria-hidden", "true", 1, "modal", "in"], [1, "modal-dialog"], [1, "modal-content"], [1, "modal-header"], [1, "modal-title"], ["type", "button", "data-dismiss", "modal", 1, "close", 3, "click"], ["aria-hidden", "true"], [1, "sr-only"], [1, "modal-body", 2, "overflow-y", "auto"], [1, "font-weight-bold", "h6"], [1, "h6", "small"], [1, "modal-footer"], ["type", "button", "data-dismiss", "modal", 1, "btn", "btn-primary", 3, "title", "click"], ["type", "button", "data-dismiss", "modal", 1, "btn", "btn-secondary", "compositions-btn-cancel", 3, "title", "click"]], template: function HsConfirmDialogComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelementStart(4, "h4", 4);
        ɵngcc0.ɵɵtext(5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "button", 5);
        ɵngcc0.ɵɵlistener("click", function HsConfirmDialogComponent_Template_button_click_6_listener() { return ctx.no(); });
        ɵngcc0.ɵɵelementStart(7, "span", 6);
        ɵngcc0.ɵɵtext(8, "\u00D7");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "span", 7);
        ɵngcc0.ɵɵtext(10);
        ɵngcc0.ɵɵpipe(11, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "div", 8);
        ɵngcc0.ɵɵelementStart(13, "p", 9);
        ɵngcc0.ɵɵtext(14);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(15, "p", 10);
        ɵngcc0.ɵɵtext(16);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(17, "div", 11);
        ɵngcc0.ɵɵelementStart(18, "button", 12);
        ɵngcc0.ɵɵlistener("click", function HsConfirmDialogComponent_Template_button_click_18_listener() { return ctx.yes(); });
        ɵngcc0.ɵɵpipe(19, "translate");
        ɵngcc0.ɵɵtext(20);
        ɵngcc0.ɵɵpipe(21, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(22, "button", 13);
        ɵngcc0.ɵɵlistener("click", function HsConfirmDialogComponent_Template_button_click_22_listener() { return ctx.no(); });
        ɵngcc0.ɵɵpipe(23, "translate");
        ɵngcc0.ɵɵtext(24);
        ɵngcc0.ɵɵpipe(25, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.data.title, " ");
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(11, 8, "COMMON.close"));
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate(ctx.data.message);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.data.note);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(19, 10, "COMMON.yes"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(21, 12, "COMMON.yes"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(23, 14, "COMMON.no"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(25, 16, "COMMON.no"));
    } }, pipes: [ɵngcc1.TranslatePipe], encapsulation: 2 });
HsConfirmDialogComponent.ctorParameters = () => [
    { type: HsDialogContainerService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsConfirmDialogComponent, [{
        type: Component,
        args: [{
                selector: 'hs-confirm-dialog',
                template: "<div class=\"modal in\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <h4 class=\"modal-title\">\n                    {{data.title}}\n                </h4>\n                <button type=\"button\" (click)=\"no()\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">{{'COMMON.close' | translate}}</span></button>\n            </div>\n            <div class=\"modal-body\" style=\"overflow-y:auto\">\n                <p class=\"font-weight-bold h6\">{{data.message}}</p>\n                <p class=\"h6 small\">{{data.note}}</p>\n            </div>\n            <div class=\"modal-footer\">\n                <button type=\"button\" class=\"btn btn-primary\" (click)=\"yes()\" [title]=\"'COMMON.yes' | translate\" data-dismiss=\"modal\">{{'COMMON.yes' | translate}}</button>\n                <button type=\"button\" class=\"btn btn-secondary compositions-btn-cancel\" [title]=\"'COMMON.no' | translate\" (click)=\"no()\" data-dismiss=\"modal\">{{'COMMON.no' | translate}}</button>      \n            </div>\n        </div>\n    </div>\n</div>\n"
            }]
    }], function () { return [{ type: HsDialogContainerService }]; }, null); })();

/**
 * @param record - Record of one dataset from Get Records response
 * @returns
 * Create extent features for displaying extent of loaded dataset records in map
 */
function addExtentFeature(record, mapProjection) {
    const attributes = {
        hs_notqueryable: true,
        highlighted: false,
        title: record.title || record.name,
        geometry: null,
    };
    const mapExtent = mapProjection.getExtent();
    const recordBBox = record.bbox || record.bounding_box;
    const b = parseExtent(recordBBox || ['180', '180', '180', '180']);
    //Check if height or Width covers the whole screen
    const extent = record.bounding_box //if from layman
        ? transformExtentValue(b, mapProjection, true)
        : transformExtentValue(b, mapProjection);
    if (b &&
        ((extent[0] < mapExtent[0] && extent[2] > mapExtent[2]) ||
            (extent[1] < mapExtent[1] && extent[3] > mapExtent[3]))) {
        return;
    }
    attributes.geometry = fromExtent(extent);
    return new Feature(attributes);
}
function transformExtentValue(pairs, mapProjection, disableTransform) {
    if (!pairs) {
        return;
    }
    let first_pair;
    let second_pair;
    if (disableTransform) {
        (first_pair = pairs[0]), (second_pair = pairs[1]);
    }
    else {
        first_pair = transform(pairs[0], 'EPSG:4326', mapProjection);
        second_pair = transform(pairs[1], 'EPSG:4326', mapProjection);
    }
    const mapProjectionExtent = mapProjection.getExtent();
    if (!isFinite(first_pair[0])) {
        first_pair[0] = mapProjectionExtent[0];
    }
    if (!isFinite(first_pair[1])) {
        first_pair[1] = mapProjectionExtent[1];
    }
    if (!isFinite(second_pair[0])) {
        second_pair[0] = mapProjectionExtent[2];
    }
    if (!isFinite(second_pair[1])) {
        second_pair[1] = mapProjectionExtent[3];
    }
    if (isNaN(first_pair[0]) ||
        isNaN(first_pair[1]) ||
        isNaN(second_pair[0]) ||
        isNaN(second_pair[1])) {
        return;
    }
    return [first_pair[0], first_pair[1], second_pair[0], second_pair[1]];
}
function parseExtent(bbox) {
    if (!bbox) {
        return;
    }
    let b;
    const pairs = [];
    if (typeof bbox === 'string') {
        b = bbox.split(' ');
    }
    else if (Array.isArray(bbox)) {
        b = bbox;
    }
    pairs.push([parseFloat(b[0]), parseFloat(b[1])]);
    pairs.push([parseFloat(b[2]), parseFloat(b[3])]);
    return pairs;
}

class HsLaymanBrowserService {
    constructor(http, log, hsCommonLaymanService, hsUtilsService, hsToastService, hsLanguageService, hsMapService) {
        this.http = http;
        this.log = log;
        this.hsCommonLaymanService = hsCommonLaymanService;
        this.hsUtilsService = hsUtilsService;
        this.hsToastService = hsToastService;
        this.hsLanguageService = hsLanguageService;
        this.hsMapService = hsMapService;
    }
    /**
     * Loads datasets metadata from Layman
     * @param endpoint - Configuration of selected datasource (from app config)
     * extent feature is created. Has one parameter: feature
     * @param data -
     */
    queryCatalog(endpoint, data, extentFeatureCreated) {
        var _a, _b;
        endpoint.getCurrentUserIfNeeded(endpoint);
        const withPermissionOrMine = (data === null || data === void 0 ? void 0 : data.onlyMine)
            ? endpoint.user !== 'anonymous' && endpoint.user !== 'browser'
                ? `workspaces/${endpoint.user}/`
                : ''
            : '';
        const url = `${endpoint.url}/rest/${withPermissionOrMine}layers`;
        endpoint.datasourcePaging.loaded = false;
        let query, bbox, sortBy, params;
        if (data) {
            query = data.query;
            sortBy = query.sortby == 'date' ? 'last_change' : query.sortby;
            const b = transformExtent(this.hsMapService.map
                .getView()
                .calculateExtent(this.hsMapService.map.getSize()), this.hsMapService.map.getView().getProjection(), 'EPSG:3857');
            bbox = data.filterByExtent ? b.join(',') : '';
            params = {
                //Draw layer limit independent on datasourcePaging
                'limit': `${(_a = data.limit) !== null && _a !== void 0 ? _a : endpoint.datasourcePaging.limit}`,
                'offset': `${endpoint.datasourcePaging.start}`,
                'full_text_filter': `${(_b = query === null || query === void 0 ? void 0 : query.textFilter) !== null && _b !== void 0 ? _b : ''}`,
                'order_by': `${sortBy !== null && sortBy !== void 0 ? sortBy : 'last_change'}`,
            };
            //Use bbox_filter only if its defined to prevent
            //Wrong parameter value error
            if (bbox) {
                params['bbox_filter'] = bbox;
            }
        }
        endpoint.httpCall = this.http
            .get(url, {
            observe: 'response',
            withCredentials: true,
            responseType: 'json',
            params,
        })
            .pipe(timeout(5000), map((x) => {
            if (Array.isArray(x.body)) {
                x.body.dataset = endpoint;
                x.body.extentFeatureCreated = extentFeatureCreated;
                x.body.matched = x.headers.get('x-total-count')
                    ? x.headers.get('x-total-count')
                    : x.body.length;
                this.datasetsReceived(x.body);
            }
            else {
                this.hsCommonLaymanService.displayLaymanError(endpoint, 'ADDLAYERS.ERROR.errorWhileRequestingLayers', x.body);
            }
            return x.body;
        }), catchError((e) => {
            var _a, _b, _c;
            if (isErrorHandlerFunction((_a = endpoint.onError) === null || _a === void 0 ? void 0 : _a.compositionLoad)) {
                ((_b = endpoint.onError) === null || _b === void 0 ? void 0 : _b.compositionLoad).handle(endpoint, e);
                return of(e);
            }
            switch ((_c = endpoint.onError) === null || _c === void 0 ? void 0 : _c.compositionLoad) {
                case EndpointErrorHandling.ignore:
                    break;
                case EndpointErrorHandling.toast:
                default:
                    this.hsToastService.createToastPopupMessage(this.hsLanguageService.getTranslation('ADDLAYERS.ERROR.errorWhileRequestingLayers'), endpoint.title +
                        ': ' +
                        this.hsLanguageService.getTranslationIgnoreNonExisting('ERRORMESSAGES', e.status ? e.status.toString() : e.message, { url: url }), {
                        disableLocalization: true,
                        serviceCalledFrom: 'HsLaymanBrowserService',
                    });
            }
            endpoint.datasourcePaging.loaded = true;
            return of(e);
        }));
        return endpoint.httpCall;
    }
    displayLaymanError(endpointTitle, responseBody) {
        let simplifiedResponse = '';
        if (responseBody.code === undefined) {
            simplifiedResponse = 'COMMON.unknownError';
        }
        switch (responseBody.code) {
            case 48:
                simplifiedResponse = 'mapExtentFilterMissing';
                break;
            case 32:
                simplifiedResponse =
                    'Unsuccessful OAuth2 authentication. Access token is not valid';
                break;
            default:
                simplifiedResponse = responseBody.message + ' ' + responseBody.detail;
        }
        //If response is object, it is an error response
        this.hsToastService.createToastPopupMessage(this.hsLanguageService.getTranslation('ADDLAYERS.ERROR.errorWhileRequestingLayers'), endpointTitle +
            ': ' +
            this.hsLanguageService.getTranslationIgnoreNonExisting('COMMON', simplifiedResponse), { disableLocalization: true, serviceCalledFrom: 'HsLaymanBrowserService' });
    }
    /**
     * (PRIVATE) Callback for catalogue http query
     * @param data - HTTP response containing all the layers
     */
    datasetsReceived(data) {
        if (!data.dataset) {
            this.hsToastService.createToastPopupMessage(this.hsLanguageService.getTranslation('COMMON.warning'), data.dataset.title +
                ': ' +
                this.hsLanguageService.getTranslation('COMMON.noDataReceived'), {
                disableLocalization: true,
                toastStyleClasses: 'bg-warning text-light',
                serviceCalledFrom: 'HsLaymanBrowserService',
            });
            return;
        }
        const dataset = data.dataset;
        dataset.loading = false;
        dataset.layers = [];
        dataset.datasourcePaging.loaded = true;
        if (!data.length) {
            dataset.datasourcePaging.matched = 0;
        }
        else {
            dataset.datasourcePaging.matched = parseInt(data.matched);
            dataset.layers = data.map((layer) => {
                const tmp = {
                    title: layer.title,
                    type: ['WMS', 'WFS'],
                    name: layer.name,
                    id: layer.uuid,
                    feature: layer.feature,
                    highlighted: false,
                    workspace: layer.workspace,
                    editable: layer.access_rights.write.some((user) => {
                        return [dataset.user, 'EVERYONE'].includes(user);
                    }),
                };
                if (data.extentFeatureCreated) {
                    const extentFeature = addExtentFeature(layer, this.hsMapService.getCurrentProj());
                    if (extentFeature) {
                        tmp.feature = extentFeature;
                        extentFeature.set('record', tmp);
                        data.extentFeatureCreated(extentFeature);
                    }
                }
                return tmp;
            });
        }
    }
    /**
     * Fills metadata about layer, because Layman layer list API provides just name and UUID
     * @param endpoint - Configuration of selected datasource (from app config)
     * @param layer - Layman layer for which to get metadata
     * @returns Promise which is resolved when layer metadata is filled
     */
    fillLayerMetadata(endpoint, layer) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${endpoint.url}/rest/workspaces/${layer.workspace}/layers/${layer.name}`;
            try {
                return yield this.http
                    .get(url, {
                    //timeout: endpoint.canceler.promise,
                    //endpoint,
                    responseType: 'json',
                    withCredentials: true,
                })
                    .toPromise()
                    .then((data) => {
                    delete data.type;
                    layer = Object.assign(Object.assign({}, layer), data);
                    if (layer.thumbnail) {
                        layer.thumbnail = endpoint.url + layer.thumbnail.url;
                    }
                    return layer;
                });
            }
            catch (e) {
                this.log.error(e);
                return e;
            }
        });
    }
    /**
     * Gets layer metadata and returns promise which describes layer
     * @param ds - Configuration of selected datasource (from app config)
     * @param layer - Layman layer for which to get metadata
     * @returns Promise which describes layer in a common format for use in add-layers component
     */
    describeWhatToAdd(ds, layer) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const lyr = yield this.fillLayerMetadata(ds, layer);
            let sld = undefined;
            if ((_a = lyr.sld) === null || _a === void 0 ? void 0 : _a.url) {
                sld = yield this.http
                    .get((_b = lyr.sld) === null || _b === void 0 ? void 0 : _b.url, {
                    headers: new HttpHeaders().set('Content-Type', 'text'),
                    responseType: 'text',
                })
                    .toPromise();
                if (!(sld === null || sld === void 0 ? void 0 : sld.includes('StyledLayerDescriptor'))) {
                    sld = undefined;
                }
            }
            if (lyr.wms.url) {
                return {
                    type: lyr.type,
                    link: lyr.wms.url,
                    sld,
                    layer: lyr.name,
                    name: lyr.name,
                    title: lyr.title,
                    dsType: ds.type,
                    editable: lyr.editable,
                    workspace: lyr.workspace,
                };
            }
            else {
                this.hsToastService.createToastPopupMessage(this.hsLanguageService.getTranslation('ADDLAYERS.ERROR.errorWhileRequestingLayers'), this.hsLanguageService.getTranslation('ADDLAYERS.ERROR.urlInvalid'), { disableLocalization: true, serviceCalledFrom: 'HsLaymanBrowserService' });
                return false;
            }
        });
    }
}
HsLaymanBrowserService.ɵfac = function HsLaymanBrowserService_Factory(t) { return new (t || HsLaymanBrowserService)(ɵngcc0.ɵɵinject(ɵngcc2.HttpClient), ɵngcc0.ɵɵinject(HsLogService), ɵngcc0.ɵɵinject(HsCommonLaymanService), ɵngcc0.ɵɵinject(HsUtilsService), ɵngcc0.ɵɵinject(HsToastService), ɵngcc0.ɵɵinject(HsLanguageService), ɵngcc0.ɵɵinject(HsMapService)); };
HsLaymanBrowserService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HsLaymanBrowserService_Factory() { return new HsLaymanBrowserService(i0.ɵɵinject(i1$1.HttpClient), i0.ɵɵinject(HsLogService), i0.ɵɵinject(HsCommonLaymanService), i0.ɵɵinject(HsUtilsService), i0.ɵɵinject(HsToastService), i0.ɵɵinject(HsLanguageService), i0.ɵɵinject(HsMapService)); }, token: HsLaymanBrowserService, providedIn: "root" });
HsLaymanBrowserService.ctorParameters = () => [
    { type: HttpClient },
    { type: HsLogService },
    { type: HsCommonLaymanService },
    { type: HsUtilsService },
    { type: HsToastService },
    { type: HsLanguageService },
    { type: HsMapService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsLaymanBrowserService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc2.HttpClient }, { type: HsLogService }, { type: HsCommonLaymanService }, { type: HsUtilsService }, { type: HsToastService }, { type: HsLanguageService }, { type: HsMapService }]; }, null); })();

const PREFER_RESUMABLE_SIZE_LIMIT = 2 * 1024 * 1024; // 2 MB
/**
 * Get Layman friendly name for layer based on its title by
 * replacing spaces with underscores, converting to lowercase, etc.
 * see https://github.com/jirik/layman/blob/c79edab5d9be51dee0e2bfc5b2f6a380d2657cbd/src/layman/util.py#L30
 * @param title - Title to get Layman-friendly name for
 * @returns New layer name
 */
function getLaymanFriendlyLayerName(title) {
    //TODO: Unidecode on server side or just drop the unsupported letters.
    title = title
        .toLowerCase()
        .replace(/[^\w\s\-\.]/gm, '') //Remove spaces
        .trim()
        .replace(/[\s\-\._]+/gm, '_') //Remove dashes
        .replace(/[^\x00-\x7F]/g, ''); //Remove non-ascii letters https://stackoverflow.com/questions/20856197/remove-non-ascii-character-in-string
    return title;
}
/**
 * Get layman friendly name of layer based primary on name
 * and secondary on title attributes.
 *
 * @param layer Layr to get the name for
 */
function getLayerName(layer) {
    const layerName = getName(layer) || getTitle(layer);
    if (layerName == undefined) {
        this.$log.warn('Layer title/name not set for', layer);
    }
    return getLaymanFriendlyLayerName(layerName);
}
function wfsNotAvailable(descr) {
    return descr.wfs.status == 'NOT_AVAILABLE';
}
function wfsPendingOrStarting(descr) {
    return descr.wfs.status == 'PENDING' || descr.wfs.status == 'STARTED';
}
function wfsFailed(descr) {
    return descr.wfs.status == 'FAILURE';
}

class HsLaymanService {
    constructor(HsUtilsService, http, HsMapService, HsLogService, HsCommonEndpointsService, $log, HsToastService, HsLanguageService) {
        this.HsUtilsService = HsUtilsService;
        this.http = http;
        this.HsMapService = HsMapService;
        this.HsLogService = HsLogService;
        this.HsCommonEndpointsService = HsCommonEndpointsService;
        this.$log = $log;
        this.HsToastService = HsToastService;
        this.HsLanguageService = HsLanguageService;
        this.pendingLayers = [];
        this.laymanLayerPending = new Subject();
        this.totalProgress = 0;
    }
    /**
     * Save composition to Layman
     * @param compositionJson Json with composition definition
     * @param endpoint Endpoint description
     * @param compoData Additional fields for composition such
     * @param saveAsNew Save as new composition as title, name
     * @returns Promise result of POST
     */
    save(compositionJson, endpoint, compoData, saveAsNew) {
        return __awaiter(this, void 0, void 0, function* () {
            const write = compoData.access_rights['access_rights.write'] == 'private'
                ? endpoint.user
                : compoData.access_rights['access_rights.write'];
            const read = compoData.access_rights['access_rights.read'] == 'private'
                ? endpoint.user
                : compoData.access_rights['access_rights.read'];
            try {
                let response;
                let success = false;
                //Need safety against infinite loop when fixing errors and retrying
                let amendmentsApplied = false;
                //If at First You Don't Succeed, Try, Try Again
                while (!success) {
                    const formdata = new FormData();
                    formdata.append('file', new Blob([JSON.stringify(compositionJson)], {
                        type: 'application/json',
                    }), 'blob.json');
                    formdata.append('name', compoData.name);
                    formdata.append('title', compoData.title);
                    formdata.append('abstract', compoData.abstract);
                    const headers = new HttpHeaders();
                    headers.append('Content-Type', null);
                    headers.append('Accept', 'application/json');
                    formdata.append('access_rights.read', read);
                    formdata.append('access_rights.write', write);
                    const workspace = compoData.workspace
                        ? saveAsNew
                            ? endpoint.user
                            : compoData.workspace
                        : endpoint.user;
                    const options = {
                        headers: headers,
                        withCredentials: true,
                    };
                    response = yield this.http[saveAsNew ? 'post' : 'patch'](`${endpoint.url}/rest/workspaces/${workspace}/maps${saveAsNew ? `?${Math.random()}` : `/${compoData.name}`}`, formdata, options).toPromise();
                    //Unsuccessfull request response contains code,detail and message properties
                    if (!response.code) {
                        success = true;
                    }
                    else {
                        if (amendmentsApplied) {
                            break;
                        }
                        featuresTypeFallback(response, compositionJson);
                        amendmentsApplied = true;
                    }
                }
                return response;
            }
            catch (err) {
                throw err;
            }
        });
    }
    /**
     * Send layer definition and features to Layman
     * @param endpoint Endpoint description
     * @param geojson Geojson object with features to send to server
     * @param description Object containing {name, title, crs, workspace, access_rights} of
     * layer to retrieve
     * @param layerDesc Previously fetched layer descriptor
     * @returns Promise result of POST/PATCH
     */
    makeUpsertLayerRequest(endpoint, geojson, description, layerDesc) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const formdata = new FormData();
            if (geojson) {
                formdata.append('file', new Blob([JSON.stringify(geojson)], { type: 'application/geo+json' }), 'blob.geojson');
            }
            const files_to_async_upload = [];
            const sumFileSize = formdata
                .getAll('file')
                .filter((f) => f.name)
                .reduce((prev, f) => prev + f.size, 0);
            const async_upload = sumFileSize >= PREFER_RESUMABLE_SIZE_LIMIT;
            if (async_upload) {
                this.switchFormDataToFileNames(formdata, files_to_async_upload);
            }
            formdata.append('sld', new Blob([description.sld], { type: 'application/octet-stream' }), 'file.sld');
            formdata.append('name', description.name);
            formdata.append('title', description.title);
            formdata.append('crs', description.crs);
            if (description.access_rights) {
                const write = description.access_rights['access_rights.write'] == 'private'
                    ? endpoint.user
                    : (_a = description.access_rights['access_rights.write']) !== null && _a !== void 0 ? _a : 'EVERYONE';
                const read = description.access_rights['access_rights.read'] == 'private'
                    ? endpoint.user
                    : (_b = description.access_rights['access_rights.read']) !== null && _b !== void 0 ? _b : 'EVERYONE';
                formdata.append('access_rights.write', write);
                formdata.append('access_rights.read', read);
            }
            const headers = new HttpHeaders();
            headers.append('Content-Type', null);
            headers.append('Accept', 'application/json');
            const options = {
                headers: headers,
                withCredentials: true,
            };
            try {
                let layerDesc2 = layerDesc;
                try {
                    if (layerDesc2 == undefined) {
                        layerDesc2 = yield this.describeLayer(endpoint, description.name, description.workspace);
                    }
                }
                catch (ex) {
                    this.HsLogService.log(`Creating layer ${description.name}`);
                }
                return yield this.http[(layerDesc2 === null || layerDesc2 === void 0 ? void 0 : layerDesc2.name) ? 'patch' : 'post'](`${endpoint.url}/rest/workspaces/${description.workspace}/layers${(layerDesc2 === null || layerDesc2 === void 0 ? void 0 : layerDesc2.name) ? '/' + description.name : ''}?${Math.random()}`, formdata, options)
                    .toPromise()
                    .then((data) => __awaiter(this, void 0, void 0, function* () {
                    if (data && data.length > 0) {
                        if (async_upload) {
                            const promise = yield this.asyncUpload(files_to_async_upload, data, {
                                url: endpoint.url,
                                user: description.workspace,
                            });
                            return promise;
                        }
                        else {
                            return data;
                        }
                    }
                    else {
                        return data;
                    }
                }));
            }
            catch (err) {
                throw err;
            }
        });
    }
    /**
     * Saves files for later upload and switches from files to file names in form data
     */
    switchFormDataToFileNames(formdata, files_to_async_upload) {
        const files = formdata.getAll('file').filter((f) => f.name);
        files_to_async_upload.push(...files);
        const file_names = files.map((f) => f.name);
        formdata.delete('file');
        file_names.forEach((fn) => formdata.append('file', fn));
    }
    /**
     * Use resumable to chunk upload data larger than PREFER_RESUMABLE_SIZE_LIMIT(2MB)
     */
    asyncUpload(files_to_async_upload, data, endpoint) {
        return new Promise((resolve, reject) => {
            files_to_async_upload = files_to_async_upload.filter((file_to_upload) => !!data[0]['files_to_upload'].find((expected_file) => file_to_upload.name === expected_file.file));
            const layername = data[0]['name'];
            const resumable = new Resumable({
                target: `${endpoint.url}/rest/workspaces/${endpoint.user}/layers/${layername}/chunk`,
                query: {
                    'layman_original_parameter': 'file',
                },
                testChunks: false,
                maxFiles: 3,
                withCredentials: true,
            });
            const chunksProgress = [];
            resumable.on('complete', () => {
                this.HsLogService.log(`Async upload finished successfully!`);
                resolve(data);
            });
            resumable.on('fileError', (file, message) => {
                console.log('fileError', message);
                reject(message);
            });
            resumable.on('fileSuccess', (file, message) => {
                this.HsLogService.log(message);
            });
            resumable.on('fileProgress', (file) => {
                chunksProgress[file.uniqueIdentifier] = file.progress(false);
                const sum = Object.values(chunksProgress).reduce((a, b) => a + b);
                this.totalProgress = sum / files_to_async_upload.length;
            });
            resumable.on('filesAdded', (files) => {
                this.HsLogService.log(`${files.length} files added to Resumable.js, starting async upload.`);
                resumable.upload();
            });
            // add files to Resumable.js, it will fire 'filesAdded' event
            resumable.addFiles(files_to_async_upload);
        });
    }
    /**
     * Create Layman layer if needed and send all features
     * @param endpoint Endpoint description
     * @param ep
     * @param layer Layer to get Layman friendly name for
     * get features
     */
    upsertLayer(ep, layer, withFeatures) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (layer.getSource().loading) {
                return;
            }
            const layerName = getLayerName(layer);
            let layerTitle = getTitle(layer);
            const f = new GeoJSON();
            const crsSupported = ['EPSG:4326', 'EPSG:3857'].includes(this.crs);
            let geojson;
            if (withFeatures) {
                if (!crsSupported) {
                    geojson = f.writeFeaturesObject(layer
                        .getSource()
                        .getFeatures()
                        .map((f) => {
                        const f2 = f.clone();
                        f2.getGeometry().transform(this.crs, 'EPSG:3857');
                        return f2;
                    }));
                }
                else {
                    geojson = f.writeFeaturesObject(layer.getSource().getFeatures());
                }
            }
            if (((_a = ep === null || ep === void 0 ? void 0 : ep.version) === null || _a === void 0 ? void 0 : _a.split('.').join()) < 171) {
                layerTitle = getLaymanFriendlyLayerName(layerTitle);
            }
            setHsLaymanSynchronizing(layer, true);
            yield this.makeUpsertLayerRequest(ep, geojson, {
                title: layerTitle,
                name: layerName,
                crs: crsSupported ? this.crs : 'EPSG:3857',
                workspace: getWorkspace(layer),
                access_rights: getAccessRights(layer),
                sld: getSld(layer),
            });
            setTimeout(() => __awaiter(this, void 0, void 0, function* () {
                yield this.makeGetLayerRequest(ep, layer);
                setHsLaymanSynchronizing(layer, false);
            }), 2000);
        });
    }
    /**
     * Sync wfs features using transaction. Publish layer first if needed
     * @param param0
     * @param param0.ep
     * @param param0.add
     * @param param0.upd
     * @param param0.del
     * @param param0.layer
     * @returns Promise result of POST
     */
    sync({ ep, add, upd, del, layer }) {
        return __awaiter(this, void 0, void 0, function* () {
            /* Clone because endpoint.user can change while the request is processed
            and then description might get cached even if anonymous user was set before.
            Should not cache anonymous layers, because layer can be authorized anytime */
            const endpoint = Object.assign({}, ep);
            try {
                let desc = getLaymanLayerDescriptor(layer);
                const name = getLayerName(layer);
                try {
                    if (!desc) {
                        desc = yield this.describeLayer(endpoint, name, getWorkspace(layer));
                        this.cacheLaymanDescriptor(layer, desc, endpoint);
                    }
                    if (desc.name == undefined || desc.wfs.url == undefined) {
                        throw `Layer or its name/url didn't exist`;
                    }
                }
                catch (ex) {
                    this.HsLogService.warn(`Layer ${name} didn't exist. Creating..`);
                    this.upsertLayer(ep, layer, true);
                    return;
                }
                desc.wfs.url = desc.wfs.url;
                return this.makeWfsRequest({ ep: endpoint, add, upd, del, layer }, desc.wfs.url);
            }
            catch (ex) {
                throw ex;
            }
        });
    }
    /**
     * Make WFS transaction request
     * @param param0 Object describing endpoint, layer and arrays
     * for each of the methods: update, del, insert containing the features to be processed
     * @param param0.add
     * @param param0.ep
     * @param url Layman client / geoserver
     * @param param0.upd
     * @param param0.del
     * @param param0.layer
     */
    makeWfsRequest({ ep, add, upd, del, layer }, url) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const srsName = this.HsMapService.getCurrentProj().getCode();
                const featureType = getLayerName(layer);
                const wfsFormat = new WFS();
                const options = {
                    featureNS: 'http://' + ep.user,
                    featurePrefix: ep.user,
                    featureType,
                    srsName,
                    nativeElements: null,
                };
                const featureNode = wfsFormat.writeTransaction(add, upd, del, options);
                const headers = new HttpHeaders();
                headers.append('Content-Type', 'application/xml');
                headers.append('Accept', 'application/xml');
                const httpOptions = {
                    headers,
                    responseType: 'text',
                    withCredentials: true,
                };
                const body = featureNode.outerHTML
                    .replace(/<geometry>/gm, '<wkb_geometry>')
                    .replace(/<\/geometry>/gm, '</wkb_geometry>');
                const r = yield this.http.post(url, body, httpOptions).toPromise();
                return r;
            }
            catch (ex) {
                this.HsLogService.error(ex);
            }
        });
    }
    cacheLaymanDescriptor(layer, desc, endpoint) {
        if (endpoint.user != 'browser') {
            setLaymanLayerDescriptor(layer, desc);
        }
    }
    /**
     * @param ep
     * @param layer
     * @param endpoint Endpoint description
     * @param layerName Escaped name of layer
     * @returns Promise with WFS xml (GML3.1) response
     * with features for a specified layer
     * Retrieve layers features from server
     */
    makeGetLayerRequest(ep, layer) {
        return __awaiter(this, void 0, void 0, function* () {
            /* Clone because endpoint.user can change while the request is processed
            and then description might get cached even if anonymous user was set before.
            Should not cache anonymous layers, because layer can be authorized anytime */
            const endpoint = Object.assign({}, ep);
            let descr;
            const layerName = getLayerName(layer);
            try {
                descr = yield this.describeLayer(endpoint, layerName, getWorkspace(layer));
                if (descr === null || //In case of response?.code == 15 || 32
                    (descr.wfs.status == descr.wms.status && wfsNotAvailable(descr))) {
                    return null;
                }
                else if ((descr === null || descr === void 0 ? void 0 : descr.name) && !wfsNotAvailable(descr)) {
                    this.cacheLaymanDescriptor(layer, descr, endpoint);
                }
            }
            catch (ex) {
                //If layman returned 404
                return null;
            }
            try {
                /* When OL will support GML3.2, then we can use WFS
                  version 2.0.0. Currently only 3.1.1 is possible */
                const response = yield this.http
                    .get(descr.wfs.url +
                    '?' +
                    this.HsUtilsService.paramsToURL({
                        service: 'wfs',
                        version: '1.1.0',
                        request: 'GetFeature',
                        typeNames: `${getWorkspace(layer)}:${descr.name}`,
                        r: Math.random(),
                        srsName: this.HsMapService.getCurrentProj().getCode(),
                    }), { responseType: 'text', withCredentials: true })
                    .toPromise();
                return response;
            }
            catch (ex) {
                return null;
            }
        });
    }
    /**
     * Try getting layer description from layman.
     * @param endpoint Endpoint description
     * @param layerName Layer name
     * @returns Promise which returns layers
     * description containing name, file, wms, wfs urls etc.
     */
    describeLayer(endpoint, layerName, workspace) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                layerName = getLaymanFriendlyLayerName(layerName); //Better safe than sorry
                const response = yield this.http
                    .get(`${endpoint.url}/rest/workspaces/${workspace}/layers/${layerName}?${Math.random()}`, {
                    withCredentials: true,
                })
                    .toPromise();
                if ((response === null || response === void 0 ? void 0 : response.code) == 15 || (response === null || response === void 0 ? void 0 : response.code) == 15 || wfsFailed(response)) {
                    return null;
                }
                if (wfsPendingOrStarting(response) ||
                    (response.wfs.status == 'SUCCESS' && response.wfs.url == undefined)) {
                    if (!this.pendingLayers.includes(layerName)) {
                        this.pendingLayers.push(layerName);
                        this.laymanLayerPending.next(this.pendingLayers);
                    }
                    yield new Promise((resolve) => setTimeout(resolve, 3500));
                    return this.describeLayer(endpoint, layerName, workspace);
                }
                if (response.name) {
                    this.managePendingLayers(layerName);
                    return response;
                }
            }
            catch (ex) {
                this.managePendingLayers(layerName);
                this.HsLogService.error(ex);
                throw ex;
            }
        });
    }
    managePendingLayers(layerName) {
        if (this.pendingLayers.includes(layerName)) {
            this.pendingLayers = this.pendingLayers.filter((layer) => layer != layerName);
            this.laymanLayerPending.next(this.pendingLayers);
        }
    }
    /**
     * Removes selected layer from layman.
     * @param layer
     */
    removeLayer(layer) {
        (this.HsCommonEndpointsService.endpoints || [])
            .filter((ds) => ds.type == 'layman')
            .forEach((ds) => {
            const layerName = typeof layer == 'string' ? layer : getLayerName(layer);
            this.http
                .delete(`${ds.url}/rest/workspaces/${ds.user}/layers/${layerName}`, {
                withCredentials: true,
            })
                .toPromise()
                .catch((error) => {
                this.HsToastService.createToastPopupMessage(this.HsLanguageService.getTranslation('COMMON.warning'), this.HsLanguageService.getTranslationIgnoreNonExisting('SAVECOMPOSITION', 'removeLayerError', {
                    error: error.error.message,
                    layer: layer instanceof Layer
                        ? layer.get('title')
                        : layer,
                }), { serviceCalledFrom: 'HsLaymanService' });
            });
        });
    }
    getLaymanEndpoint() {
        return this.HsCommonEndpointsService.endpoints.find((e) => e.type == 'layman');
    }
    isLaymanGuest() {
        const endpoint = this.getLaymanEndpoint();
        return endpoint.user == 'anonymous' || endpoint.user == 'browser';
    }
}
HsLaymanService.ɵfac = function HsLaymanService_Factory(t) { return new (t || HsLaymanService)(ɵngcc0.ɵɵinject(HsUtilsService), ɵngcc0.ɵɵinject(ɵngcc2.HttpClient), ɵngcc0.ɵɵinject(HsMapService), ɵngcc0.ɵɵinject(HsLogService), ɵngcc0.ɵɵinject(HsCommonEndpointsService), ɵngcc0.ɵɵinject(HsLogService), ɵngcc0.ɵɵinject(HsToastService), ɵngcc0.ɵɵinject(HsLanguageService)); };
HsLaymanService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HsLaymanService_Factory() { return new HsLaymanService(i0.ɵɵinject(HsUtilsService), i0.ɵɵinject(i1$1.HttpClient), i0.ɵɵinject(HsMapService), i0.ɵɵinject(HsLogService), i0.ɵɵinject(HsCommonEndpointsService), i0.ɵɵinject(HsLogService), i0.ɵɵinject(HsToastService), i0.ɵɵinject(HsLanguageService)); }, token: HsLaymanService, providedIn: "root" });
HsLaymanService.ctorParameters = () => [
    { type: HsUtilsService },
    { type: HttpClient },
    { type: HsMapService },
    { type: HsLogService },
    { type: HsCommonEndpointsService },
    { type: HsLogService },
    { type: HsToastService },
    { type: HsLanguageService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsLaymanService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: HsUtilsService }, { type: ɵngcc2.HttpClient }, { type: HsMapService }, { type: HsLogService }, { type: HsCommonEndpointsService }, { type: HsLogService }, { type: HsToastService }, { type: HsLanguageService }]; }, null); })();
/**
 * Mend error when features are not encoded as string.
 * They would not need to be encoded in future, but for now Layman
 * and composition schema requires them to be.
 * @param response - Check if server response contained error about features
 * @param compositionJson  - Composition json being sent on first try
 */
function featuresTypeFallback(response, compositionJson) {
    if (response.code == 2 &&
        response.detail &&
        response.detail['validation-errors'] &&
        response.detail['validation-errors'].some((er) => er.message.startsWith("{'type': 'FeatureCollection'"))) {
        for (const layer of compositionJson.layers.filter((l) => l.features && typeof l.features !== 'string')) {
            layer.features = JSON.stringify(layer.features);
        }
    }
}

const TMP_LAYER_TITLE = 'tmpDrawLayer';
class HsDrawService {
    constructor(HsMapService, HsLayerUtilsService, HsEventBusService, HsLayoutService, HsDialogContainerService, HsLogService, HsConfig, HsQueryBaseService, HsQueryVectorService, HsLaymanService, HsLanguageService, HsLaymanBrowserService, HsAddDataVectorService, HsUtilsService, HsCommonLaymanService, hsToastService) {
        this.HsMapService = HsMapService;
        this.HsLayerUtilsService = HsLayerUtilsService;
        this.HsEventBusService = HsEventBusService;
        this.HsLayoutService = HsLayoutService;
        this.HsDialogContainerService = HsDialogContainerService;
        this.HsLogService = HsLogService;
        this.HsConfig = HsConfig;
        this.HsQueryBaseService = HsQueryBaseService;
        this.HsQueryVectorService = HsQueryVectorService;
        this.HsLaymanService = HsLaymanService;
        this.HsLanguageService = HsLanguageService;
        this.HsLaymanBrowserService = HsLaymanBrowserService;
        this.HsAddDataVectorService = HsAddDataVectorService;
        this.HsUtilsService = HsUtilsService;
        this.HsCommonLaymanService = HsCommonLaymanService;
        this.hsToastService = hsToastService;
        this.drawableLayers = [];
        this.drawableLaymanLayers = [];
        this.boxSelectionActive = false;
        this.snapActive = false;
        this.drawActive = false;
        this.selectedFeatures = new Collection();
        this.toggleSelectionString = 'selectAllFeatures';
        this.highlightDrawButton = false; // Toggles toolbar button 'Draw' class
        this.drawingLayerChanges = new Subject();
        this.onlyMine = true;
        this.addedLayersRemoved = false;
        this.layerMetadataDialog = new Subject();
        //Layer being loaded from layman (endpoint url pending)
        this.pendingLayers = [];
        this.requiredSymbolizer = {
            Point: ['Point'],
            Polygon: ['Fill', 'Line'],
            LineString: ['Line'],
            Circle: ['Fill', 'Line'],
        };
        this.keyUp = this.keyUp.bind(this);
        this.HsMapService.loaded().then((map) => {
            this.modify = new Modify({
                features: this.selectedFeatures,
            });
            map.addInteraction(this.modify);
        });
        this.selectedFeatures.on('add', (e) => {
            if (this.onSelected) {
                this.onSelected(e);
            }
            this.modify.setActive(true);
        });
        this.selectedFeatures.on('remove', (e) => {
            if (this.selectedFeatures.length == 0) {
                this.modify.setActive(false);
            }
        });
        this.HsEventBusService.vectorQueryFeatureSelection.subscribe((event) => {
            this.selectedFeatures.push(event.feature);
        });
        this.HsEventBusService.vectorQueryFeatureDeselection.subscribe(({ feature, selector }) => {
            this.selectedFeatures.remove(feature);
        });
        this.HsEventBusService.mapResets.subscribe(() => {
            this.addedLayersRemoved = true;
            this.fillDrawableLayers();
        });
        this.HsEventBusService.mainPanelChanges.subscribe((event) => {
            if (event === 'draw' && this.HsMapService.map) {
                this.fillDrawableLayers();
            }
        });
        this.HsCommonLaymanService.authChange.subscribe((endpoint) => {
            this.fillDrawableLayers();
            this.isAuthorized =
                endpoint.user !== 'anonymous' && endpoint.user !== 'browser';
            //When metadata dialog window opened. Layer is being added
            if (this.selectedLayer && this.tmpDrawLayer) {
                setWorkspace(this.selectedLayer, endpoint.user);
                const definition = {
                    format: this.isAuthorized ? 'hs.format.WFS' : null,
                    url: this.isAuthorized
                        ? this.HsLaymanService.getLaymanEndpoint().url + '/wfs'
                        : null,
                };
                setDefinition(this.selectedLayer, definition);
            }
        });
        this.HsEventBusService.LayerManagerLayerVisibilityChanges.subscribe((event) => {
            if (this.draw && event.layer == this.selectedLayer) {
                this.setType(this.type);
            }
        });
        this.HsLaymanService.laymanLayerPending.subscribe((pendingLayers) => {
            this.pendingLayers = pendingLayers;
        });
    }
    /**
     * initial function if the draw panel is loaded as first panel
     */
    init() {
        this.HsMapService.loaded().then((_) => {
            this.fillDrawableLayers();
        });
    }
    /**
     * selectedLayerString
     * @returns Possibly translated name of layer selected for drawing
     */
    selectedLayerString() {
        if (this.selectedLayer) {
            const title = getTitle(this.selectedLayer);
            return title == TMP_LAYER_TITLE
                ? this.HsLanguageService.getTranslation('DRAW.unsavedDrawing')
                : this.HsLayerUtilsService.translateTitle(title) ||
                    getName(this.selectedLayer);
        }
        else {
            return this.HsLanguageService.getTranslation('DRAW.Select layer');
        }
    }
    /**
     * snapLayerString
     * @returns Possibly translated name of layer selected for snapping
     */
    snapLayerString() {
        if (this.snapLayer) {
            const title = getTitle(this.snapLayer);
            return (this.HsLayerUtilsService.translateTitle(title) ||
                getName(this.snapLayer));
        }
    }
    saveDrawingLayer() {
        if (this.selectedLayer) {
            this.previouslySelected = this.selectedLayer;
        }
        let tmpTitle = this.HsLanguageService.getTranslation('DRAW.drawLayer');
        const tmpLayer = this.HsMapService.findLayerByTitle(TMP_LAYER_TITLE);
        const tmpSource = tmpLayer ? tmpLayer.getSource() : new VectorSource();
        let i = 1;
        while (this.HsMapService.findLayerByTitle(tmpTitle)) {
            tmpTitle = `${this.HsLanguageService.getTranslation('DRAW.drawLayer')} ${i++}`;
        }
        const layman = this.HsLaymanService.getLaymanEndpoint();
        const drawLayer = new VectorLayer({
            //TODO: Also name should be set, but take care in case a layer with that name already exists in layman
            source: tmpSource,
            visible: true,
        });
        setTitle(drawLayer, tmpTitle);
        setShowInLayerManager(drawLayer, true);
        setRemovable(drawLayer, true);
        setSld(drawLayer, defaultStyle);
        setEditor(drawLayer, { editable: true });
        setPath(drawLayer, this.HsConfig.defaultDrawLayerPath || 'User generated'); //TODO: Translate this
        setDefinition(drawLayer, {
            format: this.isAuthorized ? 'hs.format.WFS' : null,
            url: this.isAuthorized ? layman.url + '/wfs' : null,
        });
        setWorkspace(drawLayer, layman === null || layman === void 0 ? void 0 : layman.user);
        this.tmpDrawLayer = true;
        this.selectedLayer = drawLayer;
        this.layerMetadataDialog.next();
    }
    setType(what) {
        if (this.type == what) {
            this.type = null;
            this.deactivateDrawing();
            const tmpLayer = this.HsMapService.findLayerByTitle(TMP_LAYER_TITLE) || null;
            if (tmpLayer) {
                this.HsMapService.map.removeLayer(tmpLayer);
                this.tmpDrawLayer = false;
            }
            this.HsQueryBaseService.activateQueries();
            return false;
        }
        //console.log(this.drawableLayers);
        //console.log(this.selectedLayer);
        if (this.drawableLayers.length == 0 && !this.tmpDrawLayer) {
            const drawLayer = new VectorLayer({
                source: new VectorSource(),
                visible: true,
            });
            setTitle(drawLayer, TMP_LAYER_TITLE);
            setShowInLayerManager(drawLayer, false);
            setRemovable(drawLayer, true);
            setEditor(drawLayer, { editable: true });
            setPath(drawLayer, this.HsConfig.defaultDrawLayerPath || 'User generated');
            this.tmpDrawLayer = true;
            this.selectedLayer = drawLayer;
            this.addDrawLayer(drawLayer);
        }
        this.type = what;
        if (this.selectedLayer) {
            this.source = this.HsLayerUtilsService.isLayerClustered(this.selectedLayer)
                ? this.selectedLayer.getSource().getSource() //Is it clustered vector layer?
                : this.selectedLayer.getSource();
        }
        return true;
    }
    /**
     * Handles drawing layer selection/change by activating drawing for selected layer.
     * In case of Layman layer not yet existing in app it pulls the layer first.
     * @param layer
     */
    selectLayer(layer) {
        return __awaiter(this, void 0, void 0, function* () {
            let lyr = layer;
            if (layer.type) {
                lyr = yield this.HsAddDataVectorService.addVectorLayer('wfs', this.laymanEndpoint.url, layer.name, layer.title, undefined, 'EPSG:4326', { workspace: layer.workspace });
                lyr = this.HsMapService.findLayerByTitle(layer.title);
            }
            if (lyr != this.selectedLayer) {
                if (this.selectedLayer &&
                    getTitle(this.selectedLayer) == TMP_LAYER_TITLE) {
                    this.tmpDrawLayer = false;
                    this.HsMapService.map.removeLayer(this.selectedLayer);
                }
                this.selectedLayer = lyr;
                this.changeDrawSource();
            }
            this.fillDrawableLayers();
        });
    }
    /**
     * Add draw layer to the map and repopulate list of drawables.
     * @param layer
     */
    addDrawLayer(layer) {
        this.HsMapService.map.addLayer(layer);
        this.fillDrawableLayers();
    }
    /**
     * @param {Function} changeStyle controller callback function
     * @description Update draw style without neccessity to reactivate drawing interaction
     */
    updateStyle(changeStyle) {
        if (this.draw) {
            this.currentStyle = changeStyle();
            this.draw.getOverlay().setStyle(this.currentStyle);
        }
    }
    onDrawEnd(e) {
        if (!getEditor(this.selectedLayer)) {
            return;
        }
        const editorConfig = getEditor(this.selectedLayer);
        if (editorConfig.defaultAttributes) {
            for (const key in editorConfig.defaultAttributes) {
                const value = editorConfig.defaultAttributes[key];
                e.feature.set(key, value);
            }
        }
        /*Timeout is necessary because features are not immediately
         * added to the layer and layer can't be retrieved from the
         * feature, so they don't appear in Info panel */
        if (this.HsLayoutService.mainpanel != 'draw' &&
            this.HsConfig.openQueryPanelOnDrawEnd) {
            this.HsLayoutService.setMainPanel('info');
        }
        setTimeout(() => {
            this.HsQueryBaseService.clearData('features');
            this.HsQueryVectorService.selector.getFeatures().push(e.feature);
            this.HsQueryVectorService.createFeatureAttributeList();
        });
    }
    /**
     * Re-enables getFeatureInfo info and cleans up after drawing
     */
    afterDrawEnd() {
        if (this.draw) {
            this.draw.setActive(false);
        }
        this.drawActive = false;
    }
    removeLastPoint() {
        this.draw.removeLastPoint();
    }
    /**
     * Sets layer source where new drawing should be pushed to... after 'selectedLayer' change
     */
    changeDrawSource() {
        if (this.selectedLayer.getSource === undefined) {
            return;
        }
        this.source = this.HsLayerUtilsService.isLayerClustered(this.selectedLayer)
            ? this.selectedLayer.getSource().getSource()
            : this.selectedLayer.getSource();
        this.drawingLayerChanges.next({
            layer: this.selectedLayer,
            source: this.source,
        });
        if (this.draw) {
            //Reactivate drawing with updated source
            this.activateDrawing({
                drawState: true,
                onDrawEnd: (e) => this.onDrawEnd(e),
            });
            //Set snapLayer and snap interaction source
            this.snapLayer = this.selectedLayer;
            this.toggleSnapping(this.source);
        }
    }
    /**
     * Deactivate all hs.draw interaction in map (Draw, Modify, Select)
     * @returns {Promise}
     */
    deactivateDrawing() {
        return new Promise((resolve, reject) => {
            this.HsMapService.loaded().then((map) => {
                this.afterDrawEnd();
                if (this.draw) {
                    map.removeInteraction(this.draw);
                    this.draw = null;
                }
                resolve(null);
            });
        });
    }
    stopDrawing() {
        if (!this.draw || this.draw === null) {
            return;
        }
        try {
            if (this.draw.getActive()) {
                this.draw.finishDrawing();
            }
        }
        catch (ex) {
            this.HsLogService.warn(ex);
        }
        this.draw.setActive(false);
        this.modify.setActive(false);
        this.HsQueryBaseService.activateQueries();
        this.type = null;
        this.drawActive = false;
    }
    startDrawing() {
        try {
            if (this.draw.getActive()) {
                this.draw.finishDrawing();
            }
        }
        catch (ex) {
            this.HsLogService.warn(ex);
        }
        this.draw.setActive(true);
    }
    /**
     * Repopulates drawable layers. In case layman connection exists it also creates
     * a list of available server possibilities.
     */
    fillDrawableLayers() {
        return __awaiter(this, void 0, void 0, function* () {
            let drawables = [];
            yield this.HsMapService.loaded();
            drawables = this.HsMapService.map
                .getLayers()
                .getArray()
                .filter((layer) => this.HsLayerUtilsService.isLayerDrawable(layer));
            if (drawables.length == 0 && !this.tmpDrawLayer) {
                this.type = null;
                this.deactivateDrawing();
                this.selectedLayer = null;
                this.snapSource = null;
            }
            else if (drawables.length > 0) {
                if (this.selectedLayerNotAvailable(drawables)) {
                    this.selectedLayer = drawables[0];
                    this.changeDrawSource();
                }
            }
            this.addedLayersRemoved = false;
            this.drawableLayers = drawables;
            this.laymanEndpoint = this.HsLaymanService.getLaymanEndpoint();
            if (this.laymanEndpoint) {
                yield this.HsLaymanBrowserService.queryCatalog(this.laymanEndpoint, {
                    onlyMine: this.onlyMine,
                    limit: '',
                    query: {},
                }).toPromise();
                if (this.laymanEndpoint.layers) {
                    this.drawableLaymanLayers = this.laymanEndpoint.layers.filter((layer) => {
                        return (!this.HsMapService.findLayerByTitle(layer.title) && layer.editable);
                    });
                }
            }
            this.hasSomeDrawables =
                this.drawableLayers.length > 0 || this.drawableLaymanLayers.length > 0;
        });
    }
    selectedLayerNotAvailable(drawables) {
        if (this.addedLayersRemoved) {
            return true;
        }
        else {
            return (
            //Don't want to change after authChange when layer is being added
            (!this.tmpDrawLayer &&
                !drawables.some((layer) => this.selectedLayer &&
                    getTitle(layer) == getTitle(this.selectedLayer))) ||
                !this.selectedLayer);
        }
    }
    /**
     * Removes selected drawing layer from both Layermanager and Layman
     */
    removeLayer() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const note = this.isAuthorized
                ? this.HsLanguageService.getTranslation('DRAW.deleteNote')
                : '';
            const dialog = this.HsDialogContainerService.create(HsConfirmDialogComponent, {
                message: this.HsLanguageService.getTranslation('DRAW.reallyDeleteThisLayer'),
                note: note,
                title: this.HsLanguageService.getTranslation('COMMON.confirmDelete'),
            });
            const confirmed = yield dialog.waitResult();
            if (confirmed == 'yes') {
                this.HsMapService.map.removeLayer(this.selectedLayer);
                const definition = getDefinition(this.selectedLayer);
                if (((_a = definition === null || definition === void 0 ? void 0 : definition.format) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes('wfs')) &&
                    (definition === null || definition === void 0 ? void 0 : definition.url)) {
                    this.HsLaymanService.removeLayer(this.selectedLayer);
                }
                if (getTitle(this.selectedLayer) == TMP_LAYER_TITLE) {
                    this.tmpDrawLayer = false;
                }
                this.selectedLayer = null;
                this.fillDrawableLayers();
            }
        });
    }
    /**
     * @param event
     */
    keyUp(event) {
        if (event.key == 'Backspace') {
            this.removeLastPoint();
        }
    }
    /**
     * Determines whether rightclick should finish the drawing or not
     * @param typeNum - Number used in calculation of minimal number of vertexes. Depends on geom type (polygon/line)
     * @param vertexCount - Number of vertexes the sketch has
     * @returns return boolean value if right mouse button was clicked
     */
    rightClickCondition(typeNum, vertexCount) {
        const minPoints = this.HsConfig.preserveLastSketchPoint ? 1 : 0;
        const minVertexCount = typeNum - minPoints;
        if (vertexCount >= minVertexCount) {
            setTimeout(() => {
                if (minPoints == 0) {
                    this.removeLastPoint();
                }
                this.draw.finishDrawing();
            }, 250);
            return true;
        }
        return false;
    }
    /**
     * @param {object} options Options object
     * @param {Function} [options.onDrawStart] Callback function called when drawing is started
     * @param {Function} [options.onDrawEnd] Callback function called when drawing is finished
     * @param {Function} [options.onSelected] Callback function called when feature is selected for modification
     * @param {Function} [options.onDeselected] Callback function called when feature is deselected
     * @param {Function} [options.changeStyle] controller callback function which set style
     * dynamically according to selected parameters
     * @param {boolean} options.drawState Should drawing be set active when
     * creating the interactions
     * @description Add drawing interaction to map. Partial interactions are Draw, Modify and Select. Add Event listeners for drawstart, drawend and (de)selection of feature.
     */
    activateDrawing({ onDrawStart, onDrawEnd = (e) => this.onDrawEnd(e), onSelected, onDeselected, drawState = true, }) {
        this.onDeselected = onDeselected;
        this.onSelected = onSelected;
        this.deactivateDrawing().then(() => {
            this.HsQueryBaseService.deactivateQueries();
            this.draw = new Draw({
                source: this.source,
                type: /** @type {GeometryType} */ this.type,
                condition: (e) => {
                    var _a, _b;
                    if (e.originalEvent.buttons === 1) {
                        //left click
                        return true;
                    }
                    else if (e.originalEvent.buttons === 2) {
                        //right click
                        if (this.type == 'Polygon') {
                            const vertexCount = (_a = this.draw.sketchLineCoords_) === null || _a === void 0 ? void 0 : _a.length;
                            return this.rightClickCondition(4, vertexCount);
                        }
                        else if (this.type == 'LineString') {
                            const vertexCount = (_b = this.draw.sketchCoords_) === null || _b === void 0 ? void 0 : _b.length;
                            return this.rightClickCondition(2, vertexCount - 1);
                        }
                    }
                },
            });
            this.draw.setActive(drawState);
            this.HsMapService.loaded().then((map) => {
                map.addInteraction(this.draw);
            });
            this.draw.on('drawstart', (e) => {
                if (!this.hasRequiredSymbolizer()) {
                    this.hsToastService.createToastPopupMessage(this.HsLanguageService.getTranslation('DRAW.stylingMissing'), `${this.HsLanguageService.getTranslation('DRAW.stylingMissingWarning', {
                        type: this.type,
                        symbolizer: this.requiredSymbolizer[this.type].join(' or '),
                        panel: this.HsLanguageService.getTranslation('PANEL_HEADER.LM'),
                    })}`, {
                        serviceCalledFrom: 'HsDrawService',
                    });
                }
                this.drawActive = true;
                this.modify.setActive(false);
                if (onDrawStart) {
                    onDrawStart(e);
                }
                if (this.HsUtilsService.runningInBrowser()) {
                    document.addEventListener('keyup', this.keyUp);
                }
            });
            this.draw.on('drawend', (e) => {
                if (this.type == 'Circle') {
                    e.feature.setGeometry(fromCircle(e.feature.getGeometry()));
                }
                if (onDrawEnd) {
                    onDrawEnd(e);
                }
                if (this.HsUtilsService.runningInBrowser()) {
                    document.removeEventListener('keyup', this.keyUp);
                }
            });
            //Add snap interaction -  must be added after the Modify and Draw interactions
            const snapSourceToBeUsed = this.snapSource
                ? this.snapSource
                : this.source;
            this.toggleSnapping(snapSourceToBeUsed);
        });
    }
    /**
     * Checks whether selected geometry can be properly visualized on selected layer
     */
    hasRequiredSymbolizer() {
        const sld = getSld(this.selectedLayer);
        return this.requiredSymbolizer[this.type].some((symbolizer) => {
            return sld.includes(`${symbolizer}Symbolizer`);
        });
    }
    /**
     * Handle snap interaction changes
     * Remove snap interaction if it already exists, recreate it if source is provided.
     */
    toggleSnapping(source) {
        this.HsMapService.loaded().then((map) => {
            this.snapSource = source ? source : this.snapSource;
            if (this.snap) {
                map.removeInteraction(this.snap);
                // this.snapLayer = null;
            }
            if (this.snapActive && this.snapSource) {
                this.snap = new Snap({
                    source: this.snapSource,
                });
                map.addInteraction(this.snap);
            }
        });
    }
    /**
     * Changes layer source of snap interaction
     */
    changeSnapSource(layer) {
        //isLayerClustered
        const snapSourceToBeUsed = this.HsLayerUtilsService.isLayerClustered(layer)
            ? layer.getSource().getSource()
            : layer.getSource();
        this.snapLayer = layer;
        this.toggleSnapping(snapSourceToBeUsed);
    }
    /**
     * Selects or deselects all features in this.selectedLayer
     */
    selectAllFeatures() {
        const selectFeatures = this.selectedFeatures.getLength() !=
            this.selectedLayer.getSource().getFeatures().length;
        this.toggleSelectionString = selectFeatures
            ? 'deselectAllFeatures'
            : 'selectAllFeatures';
        this.HsQueryBaseService.clearData('features');
        this.HsQueryBaseService.selector.getFeatures().clear();
        if (selectFeatures) {
            this.HsQueryBaseService.selector
                .getFeatures()
                .extend(this.selectedLayer.getSource().getFeatures());
        }
        this.HsQueryVectorService.createFeatureAttributeList();
    }
    toggleBoxSelection() {
        this.HsMapService.loaded().then((map) => {
            if (this.boxSelection) {
                map.removeInteraction(this.boxSelection);
            }
            if (this.boxSelectionActive) {
                this.boxSelection = new DragBox({
                    condition: platformModifierKeyOnly,
                });
                map.addInteraction(this.boxSelection);
                this.boxSelection.on('boxend', () => {
                    if (!this.selectedLayer) {
                        return;
                    }
                    this.HsQueryBaseService.clearData('features');
                    const extent = this.boxSelection.getGeometry().getExtent();
                    this.selectedLayer
                        .getSource()
                        .forEachFeatureIntersectingExtent(extent, (feature) => {
                        this.HsQueryBaseService.selector.getFeatures().push(feature);
                    });
                    this.HsQueryVectorService.createFeatureAttributeList();
                });
                this.boxSelection.on('boxstart', () => {
                    this.HsQueryBaseService.selector.getFeatures().clear();
                });
                this.hsToastService.createToastPopupMessage(this.HsLanguageService.getTranslation('DRAW.boxSelectionActivated'), `${this.HsLanguageService.getTranslation('DRAW.useModifierToSelectWithBox', {
                    platformModifierKey: 'CTRL/META',
                })}`, {
                    toastStyleClasses: 'bg-info text-white',
                    serviceCalledFrom: 'HsDrawService',
                });
            }
        });
    }
}
HsDrawService.ɵfac = function HsDrawService_Factory(t) { return new (t || HsDrawService)(ɵngcc0.ɵɵinject(HsMapService), ɵngcc0.ɵɵinject(HsLayerUtilsService), ɵngcc0.ɵɵinject(HsEventBusService), ɵngcc0.ɵɵinject(HsLayoutService), ɵngcc0.ɵɵinject(HsDialogContainerService), ɵngcc0.ɵɵinject(HsLogService), ɵngcc0.ɵɵinject(HsConfig), ɵngcc0.ɵɵinject(HsQueryBaseService), ɵngcc0.ɵɵinject(HsQueryVectorService), ɵngcc0.ɵɵinject(HsLaymanService), ɵngcc0.ɵɵinject(HsLanguageService), ɵngcc0.ɵɵinject(HsLaymanBrowserService), ɵngcc0.ɵɵinject(HsAddDataVectorService), ɵngcc0.ɵɵinject(HsUtilsService), ɵngcc0.ɵɵinject(HsCommonLaymanService), ɵngcc0.ɵɵinject(HsToastService)); };
HsDrawService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HsDrawService_Factory() { return new HsDrawService(i0.ɵɵinject(HsMapService), i0.ɵɵinject(HsLayerUtilsService), i0.ɵɵinject(HsEventBusService), i0.ɵɵinject(HsLayoutService), i0.ɵɵinject(HsDialogContainerService), i0.ɵɵinject(HsLogService), i0.ɵɵinject(HsConfig), i0.ɵɵinject(HsQueryBaseService), i0.ɵɵinject(HsQueryVectorService), i0.ɵɵinject(HsLaymanService), i0.ɵɵinject(HsLanguageService), i0.ɵɵinject(HsLaymanBrowserService), i0.ɵɵinject(HsAddDataVectorService), i0.ɵɵinject(HsUtilsService), i0.ɵɵinject(HsCommonLaymanService), i0.ɵɵinject(HsToastService)); }, token: HsDrawService, providedIn: "root" });
HsDrawService.ctorParameters = () => [
    { type: HsMapService },
    { type: HsLayerUtilsService },
    { type: HsEventBusService },
    { type: HsLayoutService },
    { type: HsDialogContainerService },
    { type: HsLogService },
    { type: HsConfig },
    { type: HsQueryBaseService },
    { type: HsQueryVectorService },
    { type: HsLaymanService },
    { type: HsLanguageService },
    { type: HsLaymanBrowserService },
    { type: HsAddDataVectorService },
    { type: HsUtilsService },
    { type: HsCommonLaymanService },
    { type: HsToastService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsDrawService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: HsMapService }, { type: HsLayerUtilsService }, { type: HsEventBusService }, { type: HsLayoutService }, { type: HsDialogContainerService }, { type: HsLogService }, { type: HsConfig }, { type: HsQueryBaseService }, { type: HsQueryVectorService }, { type: HsLaymanService }, { type: HsLanguageService }, { type: HsLaymanBrowserService }, { type: HsAddDataVectorService }, { type: HsUtilsService }, { type: HsCommonLaymanService }, { type: HsToastService }]; }, null); })();

class HsLayerEditorVectorLayerService {
    constructor(HsMapService, HsUtilsService, HsStylerService, HsConfig) {
        this.HsMapService = HsMapService;
        this.HsUtilsService = HsUtilsService;
        this.HsStylerService = HsStylerService;
        this.HsConfig = HsConfig;
        this.layersClusteredFromStart = [];
    }
    /**
     * Convert layer to clustered state where it's source gets nested in another
     * VectorSource and first level sources features contain 'features' attribute
     * with the original features in it as an array
     * @param newValue - Cluster or not to cluster
     * @param distance - Minimum distance in pixels between clusters
     */
    cluster(newValue, layer, distance, generateStyle) {
        return __awaiter(this, void 0, void 0, function* () {
            if (newValue == true) {
                if (!this.HsUtilsService.instOf(layer.getSource(), Cluster)) {
                    layer.setSource(this.createClusteredSource(layer, distance));
                    if (generateStyle) {
                        yield this.HsStylerService.styleClusteredLayer(layer);
                    }
                    this.updateFeatureTableLayers(layer);
                }
            }
            else if (this.HsUtilsService.instOf(layer.getSource(), Cluster)) {
                layer.setSource(layer.getSource().getSource());
            }
        });
    }
    createClusteredSource(layer, distance) {
        return new Cluster({
            distance,
            source: layer.getSource(),
            geometryFunction: function (feature) {
                if (!feature) {
                    return null;
                }
                switch (feature.getGeometry().getType()) {
                    case 'Point':
                        return feature.getGeometry();
                    case 'Circle':
                        return new Point(feature.getGeometry().getCenter());
                    case 'Polygon':
                        return feature.getGeometry().getInteriorPoint();
                    case 'LineString':
                        return new Point(feature.getGeometry().getFirstCoordinate());
                    default:
                        return null;
                }
            },
        });
    }
    updateFeatureTableLayers(layer) {
        var _a;
        const currentLayerIndex = (_a = this.HsConfig.layersInFeatureTable) === null || _a === void 0 ? void 0 : _a.findIndex((l) => l == layer);
        if (layer && currentLayerIndex > -1) {
            this.HsConfig.layersInFeatureTable[currentLayerIndex] = layer;
        }
    }
}
HsLayerEditorVectorLayerService.ɵfac = function HsLayerEditorVectorLayerService_Factory(t) { return new (t || HsLayerEditorVectorLayerService)(ɵngcc0.ɵɵinject(HsMapService), ɵngcc0.ɵɵinject(HsUtilsService), ɵngcc0.ɵɵinject(HsStylerService), ɵngcc0.ɵɵinject(HsConfig)); };
HsLayerEditorVectorLayerService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HsLayerEditorVectorLayerService_Factory() { return new HsLayerEditorVectorLayerService(i0.ɵɵinject(HsMapService), i0.ɵɵinject(HsUtilsService), i0.ɵɵinject(HsStylerService), i0.ɵɵinject(HsConfig)); }, token: HsLayerEditorVectorLayerService, providedIn: "root" });
HsLayerEditorVectorLayerService.ctorParameters = () => [
    { type: HsMapService },
    { type: HsUtilsService },
    { type: HsStylerService },
    { type: HsConfig }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsLayerEditorVectorLayerService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: HsMapService }, { type: HsUtilsService }, { type: HsStylerService }, { type: HsConfig }]; }, null); })();

class HsLayerManagerMetadataService {
    constructor(HsWmtsGetCapabilitiesService, HsWfsGetCapabilitiesService, HsWmsGetCapabilitiesService, HsDimensionTimeService, HsLayerUtilsService, hsLog) {
        this.HsWmtsGetCapabilitiesService = HsWmtsGetCapabilitiesService;
        this.HsWfsGetCapabilitiesService = HsWfsGetCapabilitiesService;
        this.HsWmsGetCapabilitiesService = HsWmsGetCapabilitiesService;
        this.HsDimensionTimeService = HsDimensionTimeService;
        this.HsLayerUtilsService = HsLayerUtilsService;
        this.hsLog = hsLog;
    }
    /**
     * Recursive callback which identifies object representing added layer in WMS getCapabilities structure.
     * It is used as reference for sublayer structure, metadata
     * @param layerName
     * @param currentLayer
     * @returns Wms layer definition
     */
    identifyLayerObject(layerName, currentLayer) {
        // FIXME: Temporary bypass for layer names like 'UTM:evi'
        /*if (layerName.includes(':')) { //This is wrong because then we are not able to find layer by name
          layerName = layerName.slice(layerName.indexOf(':'));
        }*/
        // NOTE: We are parsing also a top-most layer of the WMS Service, as it is implementationally simpler
        if (layerName == currentLayer.Name) {
            return currentLayer;
        }
        else if (Array.isArray(currentLayer.Layer)) {
            for (const subLayer of currentLayer.Layer) {
                const found = this.identifyLayerObject(layerName, subLayer);
                if (found) {
                    return found;
                }
            }
        }
        else if (currentLayer.Layer) {
            return this.identifyLayerObject(layerName, currentLayer.Layer);
        }
        return null;
    }
    /**
     * Adds hasSublayers parameter if layer has sub-layers
     * @param layerDescriptor - Selected layer
     */
    fillMetadata(layerDescriptor) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const layer = layerDescriptor.layer;
            yield this.queryMetadata(layerDescriptor);
            const subLayers = (_a = getCachedCapabilities(layer)) === null || _a === void 0 ? void 0 : _a.Layer;
            if (subLayers != undefined && subLayers.length > 0) {
                if (!layerDescriptor.hasSublayers) {
                    layerDescriptor.hasSublayers = true;
                    //ADD config values
                }
            }
        });
    }
    metadataArray(layer) {
        var _a;
        return (_a = getMetadata(layer.layer)) === null || _a === void 0 ? void 0 : _a.urls;
    }
    /**
     * Determines if layer has metadata information available *
     * @param layer Current layer
     */
    hasMetadata(layer) {
        var _a;
        if (!layer) {
            return false;
        }
        else {
            return layer && ((_a = getMetadata(layer.layer)) === null || _a === void 0 ? void 0 : _a.urls) ? true : false;
        }
    }
    roundToHundreds(num) {
        return Math.ceil(num / 100) * 100;
    }
    /**
     * @param properties
     * @returns {any}
     * @description Looks for maxScaleDenominator in property object
     */
    searchForScaleDenominator(properties) {
        let maxScale = properties.MaxScaleDenominator
            ? properties.MaxScaleDenominator
            : null;
        const layers = properties.Layer;
        if (layers) {
            for (const sublayer of layers) {
                if (sublayer.Layer) {
                    const subScale = this.searchForScaleDenominator(sublayer);
                    maxScale = subScale > maxScale ? subScale : maxScale;
                }
                else {
                    if (sublayer.MaxScaleDenominator) {
                        sublayer.maxResolution = sublayer.MaxScaleDenominator;
                        if (maxScale < sublayer.MaxScaleDenominator) {
                            maxScale = sublayer.MaxScaleDenominator;
                        }
                    }
                    else if (!sublayer.maxResolution) {
                        sublayer.maxResolution = maxScale;
                    }
                }
            }
        }
        if (maxScale) {
            properties.maxResolution = maxScale;
        }
        return maxScale;
    }
    /**
     * Sets or updates values in layer object
     * @param layer
     * @param key
     * @param values
     */
    //TODO: TYPES
    setOrUpdate(layer, key, values) {
        const previousValue = layer.get(key);
        if (previousValue) {
            for (const value of values) {
                layer.set(key, previousValue.push(value));
            }
        }
        else {
            layer.set(key, values);
        }
    }
    parseLayerInfo(layerDescriptor, layerName, caps) {
        var _a, _b;
        const olLayer = layerDescriptor.layer;
        const legends = [];
        const layerCaps = caps.Capability.Layer;
        let layerObj; //Main object representing layer created from capabilities which will be cached
        if (layerName.includes(',')) {
            const layerObjs = []; //array of layer objects representing added layer
            for (const subLayer of layerName.split(',')) {
                const layerSubObject = this.identifyLayerObject(subLayer, layerCaps);
                layerObjs.push(layerSubObject);
                this.collectLegend(layerSubObject, legends);
                if (layerSubObject &&
                    layerSubObject.Layer !== undefined &&
                    getSubLayers(olLayer)) {
                    delete layerSubObject.Layer;
                }
            }
            if (getCachedCapabilities(olLayer) === undefined) {
                layerObj = Object.assign(JSON.parse(JSON.stringify(layerObjs[0])), {
                    maxResolution: Math.max(...layerObjs.map((layer) => this.searchForScaleDenominator(layer))),
                    Layer: layerObjs,
                });
            }
            this.fillMetadataUrlsIfNotExist(olLayer, caps);
        }
        else {
            layerObj = this.identifyLayerObject(layerName, layerCaps);
            if (layerObj == undefined) {
                return;
            }
            if (((_a = layerObj.Dimension) === null || _a === void 0 ? void 0 : _a.name) === 'time' ||
                ((_b = layerObj.Dimension) === null || _b === void 0 ? void 0 : _b.filter((dim) => dim.name === 'time').length) > 0) {
                this.HsDimensionTimeService.setupTimeLayer(layerDescriptor, layerObj);
            }
            if (layerObj.Layer && getSubLayers(olLayer)) {
                layerObj.maxResolution = this.searchForScaleDenominator(layerObj);
                delete layerObj.Layer;
            }
            this.collectLegend(layerObj, legends);
        }
        if (getCachedCapabilities(olLayer) == undefined) {
            setCacheCapabilities(olLayer, layerObj);
        }
        this.parseAttribution(olLayer, getCachedCapabilities(olLayer));
        const existingLegends = getLegends(olLayer);
        if (legends.length > 0 && existingLegends == undefined) {
            setLegends(olLayer, legends);
        }
    }
    collectLegend(layerObject, legends) {
        var _a;
        const styleWithLegend = (_a = layerObject.Style) === null || _a === void 0 ? void 0 : _a.find((style) => style.LegendURL !== undefined);
        if (styleWithLegend) {
            legends.push(styleWithLegend.LegendURL[0].OnlineResource);
        }
    }
    parseAttribution(layer, caps) {
        var _a;
        const attr = caps.Attribution;
        if (((_a = getAttribution(layer)) === null || _a === void 0 ? void 0 : _a.locked) || attr == undefined) {
            return;
        }
        const parsedAttribution = {
            title: attr.Title,
            onlineResource: attr.OnlineResource,
            logoUrl: attr.LogoURL
                ? {
                    format: attr.LogoURL.Format,
                    onlineResource: attr.LogoURL.OnlineResource,
                }
                : undefined,
        };
        setAttribution(layer, parsedAttribution);
    }
    /**
     * Callback function, adds getCapabilities response metadata to layer object
     * @param layerDescriptor - Selected layer
     * @returns Promise
     */
    queryMetadata(layerDescriptor) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const layer = layerDescriptor.layer;
            const capabilities = '';
            const url = this.HsLayerUtilsService.getURL(layer);
            if (!url) {
                return;
            }
            //WMS
            if (this.HsLayerUtilsService.isLayerWMS(layer)) {
                const wrapper = yield this.HsWmsGetCapabilitiesService.request(url);
                if (wrapper.error) {
                    this.hsLog.warn('GetCapabilities call invalid', wrapper.response);
                }
                const parser = new WMSCapabilities();
                const caps = parser.read(wrapper.response);
                const params = this.HsLayerUtilsService.getLayerParams(layer);
                const layerNameInParams = params.LAYERS;
                this.parseLayerInfo(layerDescriptor, layerNameInParams, caps);
                if (getSubLayers(layer)) {
                    params.LAYERS = params.LAYERS.concat(',', getSubLayers(layer));
                    this.HsLayerUtilsService.updateLayerParams(layer, params);
                }
                this.fillMetadataUrlsIfNotExist(layer, caps);
                //Identify max resolution of layer. If layer has sublayers the highest value is selected
                setTimeout(() => {
                    if (getMaxResolutionDenominator(layer)) {
                        layer.set('maxResolution', this.roundToHundreds(getMaxResolutionDenominator(layer)));
                        return;
                    }
                    const maxScale = this.searchForScaleDenominator(layer.getProperties());
                    if (maxScale) {
                        layer.set('maxResolution', this.roundToHundreds(maxScale));
                    }
                });
                return true;
            }
            //WMTS
            else if (this.HsLayerUtilsService.isLayerWMTS(layer)) {
                const wrapper = yield this.HsWmtsGetCapabilitiesService.request(url);
                if (wrapper.error) {
                    return wrapper.response;
                }
                else {
                    const parser = new WMTSCapabilities$1();
                    const caps = parser.read(wrapper.response);
                    layer.setProperties(caps);
                    if (!((_a = getAttribution(layer)) === null || _a === void 0 ? void 0 : _a.locked)) {
                        setAttribution(layer, {
                            onlineResource: caps.ServiceProvider.ProviderSite,
                        });
                    }
                    return true;
                }
            }
            //WFS and vector
            else if (this.HsLayerUtilsService.isLayerVectorLayer(layer)) {
                if (url) {
                    const wrapper = yield this.HsWfsGetCapabilitiesService.request(url);
                    if (wrapper.error) {
                        return wrapper.response;
                    }
                    else {
                        const parser = new DOMParser();
                        const caps = parser.parseFromString(wrapper.response.data, 'application/xml');
                        const el = caps.getElementsByTagNameNS('*', 'ProviderSite');
                        if (!((_b = getAttribution(layer)) === null || _b === void 0 ? void 0 : _b.locked)) {
                            setAttribution(layer, {
                                onlineResource: el[0].getAttribute('xlink:href'),
                            });
                        }
                        return true;
                    }
                }
            }
        });
    }
    fillMetadataUrlsIfNotExist(layer, caps) {
        if (getMetadata(layer) == undefined) {
            setMetadata(layer, {
                urls: [{ onlineResource: caps.Service.OnlineResource }],
            });
        }
    }
}
HsLayerManagerMetadataService.ɵfac = function HsLayerManagerMetadataService_Factory(t) { return new (t || HsLayerManagerMetadataService)(ɵngcc0.ɵɵinject(HsWmtsGetCapabilitiesService), ɵngcc0.ɵɵinject(HsWfsGetCapabilitiesService), ɵngcc0.ɵɵinject(HsWmsGetCapabilitiesService), ɵngcc0.ɵɵinject(HsDimensionTimeService), ɵngcc0.ɵɵinject(HsLayerUtilsService), ɵngcc0.ɵɵinject(HsLogService)); };
HsLayerManagerMetadataService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HsLayerManagerMetadataService_Factory() { return new HsLayerManagerMetadataService(i0.ɵɵinject(HsWmtsGetCapabilitiesService), i0.ɵɵinject(HsWfsGetCapabilitiesService), i0.ɵɵinject(HsWmsGetCapabilitiesService), i0.ɵɵinject(HsDimensionTimeService), i0.ɵɵinject(HsLayerUtilsService), i0.ɵɵinject(HsLogService)); }, token: HsLayerManagerMetadataService, providedIn: "root" });
HsLayerManagerMetadataService.ctorParameters = () => [
    { type: HsWmtsGetCapabilitiesService },
    { type: HsWfsGetCapabilitiesService },
    { type: HsWmsGetCapabilitiesService },
    { type: HsDimensionTimeService },
    { type: HsLayerUtilsService },
    { type: HsLogService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsLayerManagerMetadataService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: HsWmtsGetCapabilitiesService }, { type: HsWfsGetCapabilitiesService }, { type: HsWmsGetCapabilitiesService }, { type: HsDimensionTimeService }, { type: HsLayerUtilsService }, { type: HsLogService }]; }, null); })();

class HsLayerSelectorService {
    constructor() {
        this.layerSelected = new Subject();
    }
    /**
     * Multicasts new HsLayerManagerService.currentLayer to observers listening to the layerSelected subject.
     * @param hsLayer - Selected layer (HsLayerManagerService.currentLayer)
     */
    select(hsLayer) {
        this.layerSelected.next(hsLayer);
    }
}
HsLayerSelectorService.ɵfac = function HsLayerSelectorService_Factory(t) { return new (t || HsLayerSelectorService)(); };
HsLayerSelectorService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HsLayerSelectorService_Factory() { return new HsLayerSelectorService(); }, token: HsLayerSelectorService, providedIn: "root" });
HsLayerSelectorService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsLayerSelectorService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class HsQueuesService {
    constructor() {
        this.queues = {};
    }
    ensureQueue(useCase, customConcurrency) {
        if (this.queues[useCase]) {
            return this.queues[useCase].q;
        }
        const newQueue = {
            q: queue({ results: [], concurrency: customConcurrency || 5 }),
        };
        this.queues[useCase] = newQueue;
        newQueue.q.autostart = true;
        newQueue.q.on('end', () => {
            delete this.queues[useCase];
        });
        return newQueue.q;
    }
}
HsQueuesService.ɵfac = function HsQueuesService_Factory(t) { return new (t || HsQueuesService)(); };
HsQueuesService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HsQueuesService_Factory() { return new HsQueuesService(); }, token: HsQueuesService, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsQueuesService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class HsLayerManagerService {
    constructor(HsConfig, HsDimensionTimeService, HsDrawService, HsEventBusService, HsLanguageService, HsLayerEditorVectorLayerService, HsLayerManagerMetadata, HsLayerSelectorService, HsLayerUtilsService, HsLayoutService, HsLog, HsMapService, HsQueuesService, HsShareUrlService, HsUtilsService, sanitizer, zone) {
        this.HsConfig = HsConfig;
        this.HsDimensionTimeService = HsDimensionTimeService;
        this.HsDrawService = HsDrawService;
        this.HsEventBusService = HsEventBusService;
        this.HsLanguageService = HsLanguageService;
        this.HsLayerEditorVectorLayerService = HsLayerEditorVectorLayerService;
        this.HsLayerManagerMetadata = HsLayerManagerMetadata;
        this.HsLayerSelectorService = HsLayerSelectorService;
        this.HsLayerUtilsService = HsLayerUtilsService;
        this.HsLayoutService = HsLayoutService;
        this.HsLog = HsLog;
        this.HsMapService = HsMapService;
        this.HsQueuesService = HsQueuesService;
        this.HsShareUrlService = HsShareUrlService;
        this.HsUtilsService = HsUtilsService;
        this.sanitizer = sanitizer;
        this.zone = zone;
        /**
         * Containing object for all properties which are shared with controllers.
         */
        this.data = {
            /**
             * Folders object for structure of layers. Each level contain 5 properties:
             * hsl_path \{String\}: Worded path to folder position in folders hierarchy.
             * coded_path \{String\}: Path encoded in numbers
             * layers \{Array\}: List of layers for current folder
             * sub_folders \{Array\}: List of subfolders for current folder
             * indent \{Number\}: Hierarchy level for current folder
             * name \{String\}: Optional - only from indent 1, base folder is not named
             * @public
             */
            folders: {
                //TODO: need to describe how hsl_path works here
                hsl_path: '',
                coded_path: '0-',
                layers: [],
                sub_folders: [],
                indent: 0,
            },
            /**
             * List of all layers (baselayers are excluded) loaded in LayerManager.
             * @public
             */
            layers: [],
            /**
             * List of all baselayers loaded in layer manager.
             * @public
             */
            baselayers: [],
            /**
             * List of all cesium terrain layers loaded in layer manager.
             * @public
             */
            terrainlayers: [],
            /**
             * Store if baselayers are visible (more precisely one of baselayers)
             * @public
             */
            baselayersVisible: true,
            filter: '',
        };
        this.menuExpanded = false;
        this.zIndexValue = 0;
        this.HsMapService.loaded().then(() => this.init());
        this.HsEventBusService.layerManagerUpdates.subscribe((val) => {
            this.refreshLists();
        });
        this.HsEventBusService.layerDimensionDefinitionChanges.subscribe(({ layer: olLayer }) => {
            if (this.HsDimensionTimeService.layerIsWmsT(olLayer)) {
                const layerDescriptor = this.data.layers.find((ld) => ld.layer == olLayer);
                this.HsDimensionTimeService.setupTimeLayer(layerDescriptor);
            }
        });
    }
    /**
     * Function for adding layer added to map into layer manager structure.
     * In service automatically used after layer is added to map.
     * Layers which shouldn't be in layer manager (showInLayerManager property) aren't added.
     * Loading events and legends URLs are created for each layer.
     * Layers also get automatic watcher for changing visibility (to synchronize visibility in map and layer manager).
     * Position is calculated for each layer and for time layers time properties are created.
     * Each layer is also inserted in correct layer list and inserted into folder structure.
     * @private
     * @param e - Event object emitted by OL add layer event
     * @param suspendEvents - If set to true, no new values for layerAdditions, layerManagerUpdates or compositionEdits observables will be emitted. Otherwise will.
     */
    layerAdded(e, suspendEvents) {
        return __awaiter(this, void 0, void 0, function* () {
            const layer = e.element;
            this.checkLayerHealth(layer);
            if (getShowInLayerManager(layer) !== null &&
                getShowInLayerManager(layer) == false) {
                return;
            }
            layer.on('change:visible', (e) => this.layerVisibilityChanged(e));
            if (this.HsLayerUtilsService.isLayerVectorLayer(layer) &&
                getCluster(layer)) {
                this.HsLayerEditorVectorLayerService.layersClusteredFromStart.push(layer);
                yield this.HsLayerEditorVectorLayerService.cluster(true, layer, this.HsConfig.clusteringDistance || 40, false);
            }
            /**
             * Wrapper for layers in layer manager structure.
             * Each layer object stores layer's title, grayed (if layer is currently visible - for layers which have max/min resolution), visible (layer is visible), and actual layer.
             * Each layer wrapper is accessible from layer list or folder structure.
             * @private
             */
            const layerDescriptor = {
                title: this.HsLayerUtilsService.getLayerTitle(layer),
                abstract: getAbstract(layer),
                layer,
                grayed: !this.isLayerInResolutionInterval(layer),
                visible: layer.getVisible(),
                uid: this.HsUtilsService.generateUuid(),
                idString() {
                    return 'layer' + (this.coded_path || '') + (this.uid || '');
                },
                type: this.getLayerSourceType(layer),
                source: this.getLayerSourceUrl(layer),
            };
            this.loadingEvents(layerDescriptor);
            layerDescriptor.trackBy = `${layerDescriptor.uid} ${layerDescriptor.position}`;
            layer.on('propertychange', (event) => {
                if (event.key == 'title') {
                    layerDescriptor.title = this.HsLayerUtilsService.getLayerTitle(layer);
                }
            });
            if (getBase(layer) !== true) {
                this.populateFolders(layer);
                layerDescriptor.legends = getLegends(layer);
                this.data.layers.push(layerDescriptor);
                if (getQueryCapabilities(layer) !== false) {
                    const que = this.HsQueuesService.ensureQueue('wmsGetCapabilities', 1);
                    que.push((cb) => __awaiter(this, void 0, void 0, function* () {
                        try {
                            yield this.HsLayerManagerMetadata.fillMetadata(layerDescriptor);
                            layerDescriptor.grayed = !this.isLayerInResolutionInterval(layer);
                            cb();
                        }
                        catch (err) {
                            cb(err);
                        }
                    }));
                }
            }
            else {
                layerDescriptor.active = layer.getVisible();
                if (layerDescriptor.active) {
                    this.changeBaseLayerVisibility(true, layerDescriptor);
                }
                layerDescriptor.thumbnail = this.getImage(layer);
                this.data.baselayers.push(layerDescriptor);
            }
            //*NOTE Commented out, because the  following references to this.data.baselayer are causing issues.
            // if (layer.getVisible() && getBase(layer)) {
            //   this.data.baselayer = this.HsLayerUtilsService.getLayerTitle(layer);
            // }
            this.sortFoldersByZ();
            if (!suspendEvents) {
                this.HsEventBusService.layerAdditions.next(layerDescriptor);
                this.HsEventBusService.layerManagerUpdates.next(layer);
                this.HsEventBusService.compositionEdits.next();
            }
        });
    }
    /**
     * Triage of layer source type and format.
     * Only the commonly used values are listed here, it shall be probably extended in the future.
     * @returns Short description of source type: 'WMS', 'XYZ', 'vector (GeoJSON)' etc.
     */
    getLayerSourceType(layer) {
        if (this.HsLayerUtilsService.isLayerKMLSource(layer)) {
            return `vector (KML)`;
        }
        if (this.HsLayerUtilsService.isLayerGeoJSONSource(layer)) {
            return `vector (GeoJSON)`;
        }
        if (this.HsLayerUtilsService.isLayerTopoJSONSource(layer)) {
            return `vector (TopoJSON)`;
        }
        if (this.HsLayerUtilsService.isLayerVectorLayer(layer)) {
            return 'vector';
        }
        if (this.HsLayerUtilsService.isLayerWMTS(layer)) {
            return 'WMTS';
        }
        if (this.HsLayerUtilsService.isLayerWMS(layer)) {
            return 'WMS';
        }
        if (this.HsLayerUtilsService.isLayerXYZ(layer)) {
            return 'XYZ';
        }
        if (this.HsLayerUtilsService.isLayerArcgis(layer)) {
            return 'ARCGIS';
        }
        this.HsLog.warn(`Cannot decide a type of source of layer ${getTitle(layer)}`);
        return 'unknown type';
    }
    /**
     * Gets the URL provided in the layer's source, if it is not a data blob or undefined
     * @returns URL provided in the layer's source or 'memory'
     */
    getLayerSourceUrl(layer) {
        var _a;
        const url = (_a = this.HsLayerUtilsService.getURL(layer)) === null || _a === void 0 ? void 0 : _a.split('?')[0]; //better stripe out any URL params
        if (!url || url.startsWith('data:')) {
            return 'memory';
        }
        return url;
    }
    /**
     * Function for adding baselayer thumbnail visible in basemap gallery.
     * @param layer - Base layer added to map
     */
    getImage(layer) {
        const thumbnail = getThumbnail(layer);
        if (thumbnail) {
            if (thumbnail.length > 10) {
                return thumbnail;
            }
            else {
                return this.HsUtilsService.getAssetsPath() + 'img/' + thumbnail;
            }
        }
        else {
            return this.HsUtilsService.getAssetsPath() + 'img/default.png';
        }
    }
    /**
     * @param layer
     */
    checkLayerHealth(layer) {
        if (this.isWms(layer)) {
            if (this.HsLayerUtilsService.getLayerParams(layer).LAYERS == undefined) {
                this.HsLog.warn('Layer', layer, 'is missing LAYERS parameter');
            }
        }
    }
    /**
     * @param e
     */
    layerVisibilityChanged(e) {
        if (getBase(e.target) != true) {
            for (const layer of this.data.layers) {
                if (layer.layer == e.target) {
                    layer.visible = e.target.getVisible();
                    break;
                }
            }
        }
        else {
            for (const baseLayer of this.data.baselayers) {
                if (baseLayer.layer == e.target) {
                    baseLayer.active = e.target.getVisible();
                }
                else {
                    baseLayer.active = false;
                }
            }
        }
    }
    /**
     * Sort layers which are added to map and registered
     * in layermanager by Z and notify components that layer positions have changed.
     */
    updateLayerListPositions() {
        //TODO: We could also sort by title or other property. Not supported right now though, just zIndex
        this.data.layers = this.sortLayersByZ(this.data.layers);
    }
    sortLayersByZ(arr) {
        const minus = this.HsConfig.reverseLayerList || false;
        return arr.sort((a, b) => {
            a = a.layer.getZIndex();
            b = b.layer.getZIndex();
            const tmp = (a < b ? -1 : a > b ? 1 : 0) * (minus ? -1 : 1);
            return tmp;
        });
    }
    /**
     * Executed when a content of data.baselayers or data.terrainlayers changes.
     * Angular does not detect changes inside arrays unless triggered from the view.
     * But it does detect changes of class properties.
     * Hence the whole array is copied so an "immutable" change happens and Angular detects that.
     */
    refreshLists() {
        this.data.baselayers = Array.from(this.data.baselayers);
        this.data.terrainlayers = Array.from(this.data.terrainlayers);
    }
    /**
     * (PRIVATE) Get layer by its title
     * @private
     * @param title
     */
    getLayerByTitle(title) {
        let tmp;
        for (const layer of this.data.layers) {
            if (layer.title == title) {
                tmp = layer;
            }
        }
        return tmp;
    }
    /**
     * Get layer container object for OL layer
     * @private
     * @param layer - to get layer title
     * @returns Layer container which is used in layer-list directive
     */
    getLayerDescriptorForOlLayer(layer) {
        const tmp = this.data.layers.filter((l) => l.layer == layer);
        if (tmp.length > 0) {
            return tmp[0];
        }
        return;
    }
    /**
     * Place layer into layer manager folder structure based on path property hsl-path of layer
     * @private
     * @param lyr - Layer to add into folder structure
     */
    populateFolders(lyr) {
        var _a;
        let path = getPath(lyr);
        if (!path) {
            /* Check whether 'other' folder exists.
              Can not just add getTranslationIgnoreNonExisting string in case no path exists
              because on init the translation is ignored.
            */
            if ((_a = this.data.folders.sub_folders) === null || _a === void 0 ? void 0 : _a.filter((f) => f.name == 'other')[0]) {
                path = 'other';
            }
            else {
                path = this.HsLanguageService.getTranslationIgnoreNonExisting('LAYERMANAGER', 'other');
            }
            setPath(lyr, path);
        }
        const parts = path.split('/');
        let curfolder = this.data.folders;
        const zIndex = lyr.getZIndex();
        for (let i = 0; i < parts.length; i++) {
            let found = null;
            for (const folder of curfolder.sub_folders) {
                if (folder.name == parts[i]) {
                    found = folder;
                }
            }
            if (found === null) {
                //TODO: Need to describe how hsl_path works here
                const new_folder = {
                    sub_folders: [],
                    indent: i,
                    layers: [],
                    name: parts[i],
                    hsl_path: curfolder.hsl_path +
                        (curfolder.hsl_path != '' ? '/' : '') +
                        parts[i],
                    coded_path: curfolder.coded_path + curfolder.sub_folders.length + '-',
                    visible: true,
                    zIndex: zIndex,
                };
                curfolder.sub_folders.push(new_folder);
                curfolder = new_folder;
            }
            else {
                curfolder = found;
            }
        }
        curfolder.zIndex = curfolder.zIndex < zIndex ? zIndex : curfolder.zIndex;
        curfolder.layers.push(lyr);
        // if (this.data.folders.layers.indexOf(lyr) > -1) {
        //   this.data.folders.layers.splice(this.data.folders.layers.indexOf(lyr), 1);
        // }
    }
    /**
     * Remove layer from layer folder structure a clean empty folder
     * @private
     * @param lyr - Layer to remove from layer folder
     */
    cleanFolders(lyr) {
        if (getShowInLayerManager(lyr) == false) {
            return;
        }
        if (getPath(lyr) != undefined && getPath(lyr) !== 'undefined') {
            const path = getPath(lyr);
            const parts = path.split('/');
            let curfolder = this.data.folders;
            for (let i = 0; i < parts.length; i++) {
                for (const folder of curfolder.sub_folders) {
                    if (folder.name == parts[i]) {
                        curfolder = folder;
                    }
                }
            }
            curfolder.layers.splice(curfolder.layers.indexOf(lyr), 1);
            for (let i = parts.length; i > 0; i--) {
                if (curfolder.layers.length == 0 && curfolder.sub_folders.length == 0) {
                    let newfolder = this.data.folders;
                    if (i > 1) {
                        for (let j = 0; j < i - 1; j++) {
                            for (const folder of newfolder.sub_folders) {
                                if (folder.name == parts[j]) {
                                    newfolder = folder;
                                }
                            }
                        }
                    }
                    const ixToRemove = newfolder.sub_folders.indexOf(curfolder);
                    if (ixToRemove > -1) {
                        newfolder.sub_folders.splice(ixToRemove, 1);
                    }
                    curfolder = newfolder;
                }
                else {
                    break;
                }
            }
        }
        else {
            const ixToRemove = this.data.folders.layers.indexOf(lyr);
            if (ixToRemove > -1) {
                this.data.folders.layers.splice(ixToRemove, 1);
            }
        }
    }
    /**
     * Callback function for removing layer. Clean layers variables
     * (PRIVATE)
     * @private
     * @param e - Events emitted by ol.Collection instances are instances of this type.
     */
    layerRemoved(e) {
        this.cleanFolders(e.element);
        for (let i = 0; i < this.data.layers.length; i++) {
            if (this.data.layers[i].layer == e.element) {
                this.data.layers.splice(i, 1);
            }
        }
        for (let i = 0; i < this.data.baselayers.length; i++) {
            if (this.data.baselayers[i].layer == e.element) {
                this.data.baselayers.splice(i, 1);
            }
        }
        this.removeFromArray(this.HsLayerEditorVectorLayerService.layersClusteredFromStart, e.element);
        this.HsEventBusService.layerManagerUpdates.next(e.element);
        this.HsEventBusService.layerRemovals.next(e.element);
        this.HsEventBusService.compositionEdits.next();
        const layers = this.HsMapService.map.getLayers().getArray();
        if (this.zIndexValue > layers.length) {
            this.zIndexValue--;
        }
    }
    removeFromArray(arrayToSearch, layer) {
        for (let i = 0; i < arrayToSearch.length; i++) {
            if (arrayToSearch[i] == layer) {
                arrayToSearch.splice(i, 1);
            }
        }
    }
    /**
     * Initialize box layers and their starting active state
     * (PRIVATE)
     * @private
     */
    boxLayersInit() {
        if (this.HsConfig.box_layers != undefined) {
            this.data.box_layers = this.HsConfig.box_layers;
            for (const box of this.data.box_layers) {
                let visible = false;
                let baseVisible = false;
                for (const layer of box.get('layers').getArray()) {
                    if (layer.get('visible') == true && getBase(layer) == true) {
                        baseVisible = true;
                    }
                    else if (layer.get('visible') == true) {
                        visible = true;
                    }
                }
                setActive(box, baseVisible ? baseVisible : visible);
            }
        }
    }
    /**
     * Change visibility of selected layer. If layer has exclusive setting, other layers from same group may be turned invisible
     * @param visibility - Visibility layer should have
     * @param layer - Selected layer - wrapped layer object (layer.layer expected)
     */
    changeLayerVisibility(visibility, layer) {
        layer.layer.setVisible(visibility);
        layer.visible = visibility;
        layer.grayed = !this.isLayerInResolutionInterval(layer.layer);
        //Set the other exclusive layers invisible - all or the ones with same path based on config
        if (visibility && getExclusive(layer.layer) == true) {
            for (const other_layer of this.data.layers) {
                const pathExclusivity = this.HsConfig.pathExclusivity
                    ? getPath(other_layer.layer) == getPath(layer.layer)
                    : true;
                if (getExclusive(other_layer.layer) == true &&
                    other_layer != layer &&
                    pathExclusivity) {
                    other_layer.layer.setVisible(false);
                    other_layer.visible = false;
                }
            }
        }
        if (!visibility && this.HsUtilsService.instOf(layer.layer, Vector$1)) {
            this.HsEventBusService.LayerManagerLayerVisibilityChanges.next(layer);
        }
    }
    /**
     * Change visibility (on/off) of baselayers, only one baselayer may be visible
     * @param $event - Info about the event change visibility event, used if visibility of only one layer is changed
     * @param layer - Selected layer - wrapped layer object (layer.layer expected)
     */
    changeBaseLayerVisibility($event = null, layer = null) {
        if (layer === null || layer.layer != undefined) {
            if (this.data.baselayersVisible == true) {
                //*NOTE Currently breaking base layer visibility when loading from composition with custom base layer to
                //other compositions without any base layer
                //*TODO Rewrite this loop hell to more readable code
                if ($event) {
                    //&& this.data.baselayer != layer.title
                    for (const baseLayer of this.data.baselayers) {
                        if (baseLayer.layer) {
                            baseLayer.layer.setVisible(false);
                            baseLayer.visible = false;
                            baseLayer.active = false;
                            if (baseLayer != layer) {
                                baseLayer.galleryMiniMenu = false;
                            }
                        }
                    }
                    for (const baseLayer of this.data.baselayers) {
                        if (baseLayer.layer && baseLayer == layer) {
                            baseLayer.layer.setVisible(true);
                            baseLayer.visible = true;
                            baseLayer.active = true;
                            //this.data.baselayer = layer.title;
                            break;
                        }
                    }
                }
                else {
                    this.data.baselayersVisible = false;
                    for (const baseLayer of this.data.baselayers) {
                        baseLayer.layer.setVisible(false);
                        baseLayer.galleryMiniMenu = false;
                    }
                }
            }
            else {
                if ($event) {
                    layer.active = true;
                    for (const baseLayer of this.data.baselayers) {
                        if (baseLayer != layer) {
                            baseLayer.active = false;
                            baseLayer.visible = false;
                        }
                        else {
                            baseLayer.layer.setVisible(true);
                            baseLayer.visible = true;
                            //this.data.baselayer = layer.title;
                        }
                    }
                }
                else {
                    for (const baseLayer of this.data.baselayers) {
                        if (baseLayer.visible == true) {
                            baseLayer.layer.setVisible(true);
                        }
                    }
                }
                this.data.baselayersVisible = true;
            }
        }
        else {
            for (const baseLayer of this.data.baselayers) {
                if (baseLayer.type != undefined && baseLayer.type == 'terrain') {
                    baseLayer.visible = baseLayer == layer;
                    baseLayer.active = baseLayer.visible;
                }
            }
        }
        this.HsEventBusService.LayerManagerBaseLayerVisibilityChanges.next(layer);
    }
    /**
     * Change visibility (on/off) of baselayers, only one baselayer may be visible
     * @param $event - Info about the event change visibility event, used if visibility of only one layer is changed
     * @param layer - Selected layer - wrapped layer object (layer.layer expected)
     */
    changeTerrainLayerVisibility($event, layer) {
        for (let i = 0; i < this.data.terrainlayers.length; i++) {
            if (this.data.terrainlayers[i].type != undefined &&
                this.data.terrainlayers[i].type == 'terrain') {
                this.data.terrainlayers[i].visible =
                    this.data.terrainlayers[i] == layer;
                this.data.terrainlayers[i].active = this.data.terrainlayers[i].visible;
            }
        }
        this.HsEventBusService.LayerManagerBaseLayerVisibilityChanges.next(layer);
    }
    /**
     * Remove all non-base layers that were added to the map by user.
     * Doesn't remove layers added through app config (In case we want it to be 'removable', it can be set to true in the config.)
     * (PRIVATE)
     * @private
     */
    removeAllLayers() {
        const to_be_removed = [];
        this.HsMapService.map.getLayers().forEach((lyr) => {
            if (getRemovable(lyr) == true) {
                if (getBase(lyr) == undefined || getBase(lyr) == false) {
                    if (getShowInLayerManager(lyr) == undefined ||
                        getShowInLayerManager(lyr) == true) {
                        to_be_removed.push(lyr);
                    }
                }
            }
        });
        while (to_be_removed.length > 0) {
            this.HsMapService.map.removeLayer(to_be_removed.shift());
        }
        this.HsDrawService.addedLayersRemoved = true;
        this.HsDrawService.fillDrawableLayers();
    }
    /**
     * Show all layers of particular layer group (when groups are defined)
     * @param theme - Group layer to activate
     */
    activateTheme(theme) {
        let switchOn = true;
        if (getActive(theme) == true) {
            switchOn = false;
        }
        setActive(theme, switchOn);
        let baseSwitched = false;
        theme.setVisible(switchOn);
        for (const layer of theme.get('layers')) {
            if (getBase(layer) == true && !baseSwitched) {
                this.changeBaseLayerVisibility();
                baseSwitched = true;
            }
            else if (getBase(layer) == true) {
                return;
            }
            else {
                layer.setVisible(switchOn);
            }
        }
    }
    /**
     * Create events for checking if layer is being loaded or is loaded for ol.layer.Image or ol.layer.Tile
     * @param layer - Layer which is being added
     */
    loadingEvents(layer) {
        const olLayer = layer.layer;
        const source = olLayer.getSource();
        const loadProgress = {
            loadCounter: 0,
            loadTotal: 0,
            loadError: 0,
            loaded: true,
            error: undefined,
            percents: 0,
        };
        layer.loadProgress = loadProgress;
        if (this.HsUtilsService.instOf(olLayer, Vector$1)) {
            source.on('propertychange', (event) => {
                if (event.key == 'loaded') {
                    if (event.oldValue == false) {
                        this.HsEventBusService.layerLoads.next(olLayer);
                    }
                    else {
                        this.HsEventBusService.layerLoadings.next({
                            layer: olLayer,
                            progress: loadProgress,
                        });
                    }
                }
            });
        }
        else if (this.HsUtilsService.instOf(olLayer, Image$1)) {
            source.on('imageloadstart', (event) => {
                loadProgress.loadTotal += 1;
                this.changeLoadCounter(olLayer, loadProgress, 1);
            });
            source.on('imageloadend', (event) => {
                this.changeLoadCounter(olLayer, loadProgress, -1);
            });
            source.on('imageloaderror', (event) => {
                loadProgress.loaded = true;
                loadProgress.error = true;
                this.HsEventBusService.layerLoads.next(olLayer);
            });
        }
        else if (this.HsUtilsService.instOf(olLayer, Tile)) {
            source.on('tileloadstart', (event) => {
                loadProgress.loadTotal += 1;
                this.changeLoadCounter(olLayer, loadProgress, 1);
            });
            source.on('tileloadend', (event) => {
                this.changeLoadCounter(olLayer, loadProgress, -1);
            });
            source.on('tileloaderror', (event) => {
                this.changeLoadCounter(olLayer, loadProgress, -1);
                loadProgress.loadError += 1;
                if (loadProgress.loadError == loadProgress.loadTotal) {
                    loadProgress.error = true;
                }
            });
        }
    }
    changeLoadCounter(layer, progress, change) {
        progress.loadCounter += change;
        //No more tiles to load?
        if (progress.loadCounter == 0) {
            progress.loaded = true;
            // If in 2 seconds no new tiles are starting to to load
            // we can assume that layer has finished loading
            if (progress.timer) {
                clearTimeout(progress.timer);
            }
            progress.timer = setTimeout(() => {
                if (progress.loadCounter == 0) {
                    this.zone.run(() => {
                        progress.loadTotal = 0;
                        this.HsEventBusService.layerLoads.next(layer);
                        progress.percents = 100;
                    });
                }
            }, 2000);
        }
        progress.loaded = !(progress.loadTotal > 0 && progress.loaded);
        let percents = 100.0;
        if (progress.loadTotal > 0) {
            percents = Math.round(((progress.loadTotal - progress.loadCounter) / progress.loadTotal) * 100);
        }
        progress.percents = percents;
        this.HsEventBusService.layerLoadings.next({ layer, progress });
        //Throttle updating UI a bit for many layers * many tiles
        const delta = new Date().getTime() - this.lastProgressUpdate;
        if (percents == 100 || delta > 1000) {
            this.zone.run(() => {
                this.lastProgressUpdate = new Date().getTime();
            });
        }
    }
    /**
     * Checks if given layer is a WMS layer
     */
    isWms(layer) {
        return (this.HsUtilsService.instOf(layer.getSource(), TileWMS) ||
            this.HsUtilsService.instOf(layer.getSource(), ImageWMS) ||
            this.HsUtilsService.instOf(layer.getSource(), TileArcGISRest));
    }
    /**
     * Test if layer (WMS) resolution is within map resolution interval
     * @param lyr - Selected layer
     */
    isLayerInResolutionInterval(lyr) {
        let cur_res;
        if (this.isWms(lyr)) {
            const view = this.HsMapService.map.getView();
            const resolution = view.getResolution();
            const units = view.getProjection().getUnits();
            const dpi = 25.4 / 0.28;
            const mpu = METERS_PER_UNIT[units];
            cur_res = resolution * mpu * 39.37 * dpi;
        }
        else {
            cur_res = this.HsMapService.map.getView().getResolution();
        }
        this.currentResolution = cur_res;
        return (lyr.getMinResolution() <= cur_res && cur_res <= lyr.getMaxResolution());
    }
    /**
     * Toggles Additional information panel for current layer.
     * @param layer - Selected layer (HsLayerManagerService.currentLayer)
     * @param toToggle - Part of layer editor to be toggled
     * @param control - Part of layer editor to be controlled for state.
     * Determines whether only toggled part or whole layereditor would be closed
     */
    toggleLayerEditor(layer, toToggle, control) {
        if (toToggle == 'sublayers' && layer.hasSublayers != true) {
            return;
        }
        if (this.currentLayer != layer) {
            this.toggleCurrentLayer(layer);
            if (this.menuExpanded) {
                this.menuExpanded = false;
            }
            layer[toToggle] = true;
        }
        else {
            layer[toToggle] = !layer[toToggle];
            if (!layer[control]) {
                this.toggleCurrentLayer(layer);
            }
        }
    }
    /**
     * Opens detailed panel for manipulating selected layer and viewing metadata
     * @param layer - Selected layer to edit or view - Wrapped layer object
     */
    toggleCurrentLayer(layer) {
        if (this.currentLayer == layer) {
            layer.sublayers = false;
            layer.settings = false;
            this.currentLayer = null;
            this.updateGetParam(undefined);
        }
        else {
            this.setCurrentLayer(layer);
            return false;
        }
    }
    setCurrentLayer(layer) {
        try {
            this.currentLayer = layer;
            this.updateGetParam(layer.title);
            if (!layer.checkedSubLayers) {
                layer.checkedSubLayers = {};
                layer.withChildren = {};
            }
            this.HsLayerSelectorService.select(layer);
            if (this.HsUtilsService.runningInBrowser()) {
                const layerNode = document.getElementById(layer.idString());
                if (layerNode && this.layerEditorElement) {
                    this.HsUtilsService.insertAfter(this.layerEditorElement, layerNode);
                }
            }
            return false;
        }
        catch (ex) {
            console.error(ex);
        }
    }
    updateGetParam(title) {
        const t = {};
        t[HS_PRMS.layerSelected] = title;
        this.HsShareUrlService.updateCustomParams(t);
    }
    /**
     * Makes layer grayscale
     * @param layer - Selected layer (currentLayer)
     */
    setGreyscale(layer) {
        const layerContainer = this.HsLayoutService.contentWrapper.querySelector('.ol-layers > div:first-child');
        if (layerContainer.classList.contains('hs-grayscale')) {
            layerContainer.classList.remove('hs-grayscale');
            layer.grayscale = false;
        }
        else {
            layerContainer.classList.add('hs-grayscale');
            layer.grayscale = true;
        }
        setTimeout(() => {
            layer.galleryMiniMenu = false;
        }, 100);
    }
    sortFoldersByZ() {
        this.data.folders.sub_folders.sort((a, b) => (a.zIndex < b.zIndex ? -1 : a.zIndex > b.zIndex ? 1 : 0) *
            (this.HsConfig.reverseLayerList ? -1 : 1));
    }
    /**
     * Initialization of needed controllers, run when map object is available
     * (PRIVATE)
     * @private
     */
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            this.map = this.HsMapService.map;
            this.HsMapService.map.getLayers().forEach((lyr) => {
                this.applyZIndex(lyr);
                this.layerAdded({
                    element: lyr,
                }, true);
            });
            this.sortFoldersByZ();
            this.sortLayersByZ(this.data.layers);
            this.HsEventBusService.layerManagerUpdates.next();
            this.toggleEditLayerByUrlParam();
            this.boxLayersInit();
            this.map
                .getView()
                .on('change:resolution', this.HsUtilsService.debounce(this.resolutionChangeDebounceCallback, 200, false, this));
            this.map.getLayers().on('add', (e) => {
                this.applyZIndex(e.element, true);
                if (getShowInLayerManager(e.element) == false) {
                    return;
                }
                this.layerAdded(e);
            });
            this.map.getLayers().on('remove', (e) => this.layerRemoved(e));
        });
    }
    resolutionChangeDebounceCallback() {
        setTimeout(() => {
            for (let i = 0; i < this.data.layers.length; i++) {
                const tmp = !this.isLayerInResolutionInterval(this.data.layers[i].layer);
                if (this.data.layers[i].grayed != tmp) {
                    this.data.layers[i].grayed = tmp;
                }
            }
            this.timer = null;
        }, 250);
    }
    /**
     * Opens editor for layer specified in 'hs-layer-selected' url parameter
     */
    toggleEditLayerByUrlParam() {
        const layerTitle = this.HsShareUrlService.getParamValue(HS_PRMS.layerSelected);
        if (layerTitle != undefined) {
            setTimeout(() => {
                const layerFound = this.data.layers.find((layer) => layer.title == layerTitle);
                if (layerFound !== undefined) {
                    this.toggleLayerEditor(layerFound, 'settings', 'sublayers');
                    this.HsEventBusService.layerSelectedFromUrl.next(layerFound.layer);
                }
            }, 500);
        }
    }
    /**
     * Sets zIndex of layer being added to be the highest among layers in same path
     * @param layer - layer being added
     */
    setPathMaxZIndex(layer) {
        let pathLayers;
        if (getBase(layer)) {
            pathLayers = this.data.baselayers;
        }
        else {
            let path = getPath(layer);
            //If not set it'll be assigned inside populateFolders function as 'other'
            path = path ? path : 'other';
            pathLayers = this.data.layers.filter((layer) => getPath(layer.layer) == path);
        }
        if (pathLayers.length > 0) {
            //Get max available index value
            const maxPathZIndex = Math.max(...pathLayers.map((lyr) => lyr.layer.getZIndex() || 0));
            layer.setZIndex(maxPathZIndex + 1);
            //Increase zIndex of the layer that are supposed to be rendered above inserted
            for (const lyr of this.data.layers.filter((lyr) => lyr.layer.getZIndex() >= layer.getZIndex())) {
                lyr.layer.setZIndex(lyr.layer.getZIndex() + 1);
            }
        }
    }
    /**
     * Sets zIndex of layer being added.
     * @param layer - layer being added
     * @param asCallback - Whether the function is called directly or as a callback of add layer event.
     * No need to run each layer through setPathMaxZIndex on init
     */
    applyZIndex(layer, asCallback) {
        if (asCallback && getShowInLayerManager(layer) !== false) {
            this.setPathMaxZIndex(layer);
        }
        if (layer.getZIndex() == undefined) {
            layer.setZIndex(this.zIndexValue++);
        }
        else {
            this.zIndexValue++;
        }
    }
    makeSafeAndTranslate(group, input) {
        const translation = this.HsLanguageService.getTranslationIgnoreNonExisting(group, input);
        if (translation) {
            return this.sanitizer.bypassSecurityTrustHtml(translation);
        }
        else {
            return '';
        }
    }
    expandFilter(layer, value) {
        layer.expandFilter = value;
        this.currentLayer = layer;
        this.HsLayerSelectorService.select(layer);
    }
    expandInfo(layer, value) {
        layer.expandInfo = value;
    }
    /*
      Generates downloadable geoJSON for vector layer.
      Features are also transformed into the EPSG:4326 projection
    */
    saveGeoJson() {
        const geojsonParser = new GeoJSON();
        const olLayer = this.currentLayer.layer;
        const geojson = geojsonParser.writeFeatures((this.HsLayerUtilsService.isLayerClustered(olLayer)
            ? olLayer.getSource().getSource()
            : olLayer.getSource()).getFeatures(), {
            dataProjection: 'EPSG:4326',
            featureProjection: this.HsMapService.getCurrentProj(),
        });
        const file = new Blob([geojson], { type: 'application/json' });
        const a = document.createElement('a'), url = URL.createObjectURL(file);
        a.href = url;
        a.download = getTitle(this.currentLayer.layer).replace(/\s/g, '');
        document.body.appendChild(a);
        a.click();
        setTimeout(() => {
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
        }, 0);
    }
}
HsLayerManagerService.ɵfac = function HsLayerManagerService_Factory(t) { return new (t || HsLayerManagerService)(ɵngcc0.ɵɵinject(HsConfig), ɵngcc0.ɵɵinject(HsDimensionTimeService), ɵngcc0.ɵɵinject(HsDrawService), ɵngcc0.ɵɵinject(HsEventBusService), ɵngcc0.ɵɵinject(HsLanguageService), ɵngcc0.ɵɵinject(HsLayerEditorVectorLayerService), ɵngcc0.ɵɵinject(HsLayerManagerMetadataService), ɵngcc0.ɵɵinject(HsLayerSelectorService), ɵngcc0.ɵɵinject(HsLayerUtilsService), ɵngcc0.ɵɵinject(HsLayoutService), ɵngcc0.ɵɵinject(HsLogService), ɵngcc0.ɵɵinject(HsMapService), ɵngcc0.ɵɵinject(HsQueuesService), ɵngcc0.ɵɵinject(HsShareUrlService), ɵngcc0.ɵɵinject(HsUtilsService), ɵngcc0.ɵɵinject(ɵngcc4.DomSanitizer), ɵngcc0.ɵɵinject(ɵngcc0.NgZone)); };
HsLayerManagerService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HsLayerManagerService_Factory() { return new HsLayerManagerService(i0.ɵɵinject(HsConfig), i0.ɵɵinject(HsDimensionTimeService), i0.ɵɵinject(HsDrawService), i0.ɵɵinject(HsEventBusService), i0.ɵɵinject(HsLanguageService), i0.ɵɵinject(HsLayerEditorVectorLayerService), i0.ɵɵinject(HsLayerManagerMetadataService), i0.ɵɵinject(HsLayerSelectorService), i0.ɵɵinject(HsLayerUtilsService), i0.ɵɵinject(HsLayoutService), i0.ɵɵinject(HsLogService), i0.ɵɵinject(HsMapService), i0.ɵɵinject(HsQueuesService), i0.ɵɵinject(HsShareUrlService), i0.ɵɵinject(HsUtilsService), i0.ɵɵinject(i8.DomSanitizer), i0.ɵɵinject(i0.NgZone)); }, token: HsLayerManagerService, providedIn: "root" });
HsLayerManagerService.ctorParameters = () => [
    { type: HsConfig },
    { type: HsDimensionTimeService },
    { type: HsDrawService },
    { type: HsEventBusService },
    { type: HsLanguageService },
    { type: HsLayerEditorVectorLayerService },
    { type: HsLayerManagerMetadataService },
    { type: HsLayerSelectorService },
    { type: HsLayerUtilsService },
    { type: HsLayoutService },
    { type: HsLogService },
    { type: HsMapService },
    { type: HsQueuesService },
    { type: HsShareUrlService },
    { type: HsUtilsService },
    { type: DomSanitizer },
    { type: NgZone }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsLayerManagerService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: HsConfig }, { type: HsDimensionTimeService }, { type: HsDrawService }, { type: HsEventBusService }, { type: HsLanguageService }, { type: HsLayerEditorVectorLayerService }, { type: HsLayerManagerMetadataService }, { type: HsLayerSelectorService }, { type: HsLayerUtilsService }, { type: HsLayoutService }, { type: HsLogService }, { type: HsMapService }, { type: HsQueuesService }, { type: HsShareUrlService }, { type: HsUtilsService }, { type: ɵngcc4.DomSanitizer }, { type: ɵngcc0.NgZone }]; }, null); })();

class HsCompositionsParserService {
    constructor(HsMapService, HsConfig, $http, HsUtilsService, HsCompositionsLayerParserService, HsDialogContainerService, HsLayoutService, $log, HsEventBusService, HsLanguageService, HsCommonEndpointsService, HsLayerManagerService) {
        this.HsMapService = HsMapService;
        this.HsConfig = HsConfig;
        this.$http = $http;
        this.HsUtilsService = HsUtilsService;
        this.HsCompositionsLayerParserService = HsCompositionsLayerParserService;
        this.HsDialogContainerService = HsDialogContainerService;
        this.HsLayoutService = HsLayoutService;
        this.$log = $log;
        this.HsEventBusService = HsEventBusService;
        this.HsLanguageService = HsLanguageService;
        this.HsCommonEndpointsService = HsCommonEndpointsService;
        this.HsLayerManagerService = HsLayerManagerService;
        /**
         * @public
         * @type {string} null
         * @description Stores current composition URL if there is one or NULL
         */
        this.composition_loaded = null;
        /**
         * @public
         * @type {boolean} null
         * @description Stores whether current composition was edited (for composition changes, saving etc.)
         */
        this.composition_edited = false;
        /**
         * @public
         * @type {string} ""
         * @description Stores title of current composition
         */
        this.current_composition_title = '';
    }
    /**
     * @public
     * @param {string} url Url of selected composition
     * @param {boolean} overwrite Whether overwrite current composition in map -
     * remove all layers from maps which originate from composition (if not pasted, it counts as "true")
     * @param {Function} callback Optional function which should be called when composition is successfully loaded
     * @param {Function} pre_parse Optional function for pre-parsing loaded data about composition to accepted format
     * @returns {Promise}
     * @description Load selected composition from server, parse it and add layers to map.
     * Optionally (based on app config) may open layer manager panel
     */
    loadUrl(url, overwrite, callback, pre_parse) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            this.current_composition_url = url;
            url = url.replace(/&amp;/g, '&');
            url = this.HsUtilsService.proxify(url);
            const options = {};
            if (url.includes('.wmc')) {
                pre_parse = (res) => this.parseWMC(res);
                options['responseType'] = 'text';
            }
            options['withCredentials'] = url.includes((_b = (_a = this.HsCommonEndpointsService) === null || _a === void 0 ? void 0 : _a.endpoints.filter((ep) => ep.type == 'layman')[0]) === null || _b === void 0 ? void 0 : _b.url);
            const data = yield this.$http.get(url, options).toPromise();
            if (data === null || data === void 0 ? void 0 : data.file) {
                // Layman composition wrapper
                return this.loadUrl(data.file.url, overwrite, callback, pre_parse);
            }
            this.loaded(data, pre_parse, url, overwrite, callback);
        });
    }
    loaded(response, pre_parse, url, overwrite, callback) {
        return __awaiter(this, void 0, void 0, function* () {
            this.HsEventBusService.compositionLoading.next(response);
            if (this.checkLoadSuccess(response)) {
                this.composition_loaded = url;
                if (this.HsUtilsService.isFunction(pre_parse)) {
                    response = pre_parse(response);
                }
                response.workspace = this.current_composition_workspace;
                /*
                Response might contain {data:{abstract:...}} or {abstract:}
                directly. If there is data object,
                that means composition is enclosed in
                container which itself might contain title or extent
                properties */
                yield this.loadCompositionObject(response.data || response, overwrite, response.title, response.extent);
                this.finalizeCompositionLoading(response);
                if (this.HsUtilsService.isFunction(callback)) {
                    callback();
                }
            }
            else {
                this.raiseCompositionLoadError(response);
            }
        });
    }
    parseWMC(response) {
        let res = xml2Json.xml2js(response, { compact: true });
        res = res.ViewContext;
        const compositionJSON = {
            current_base_layer: {
                title: 'Composite_base_layer',
            },
            extent: [
                parseFloat(res.General.BoundingBox._attributes['maxx']),
                parseFloat(res.General.BoundingBox._attributes['maxy']),
                parseFloat(res.General.BoundingBox._attributes['minx']),
                parseFloat(res.General.BoundingBox._attributes['miny']),
            ],
            layers: [],
            units: res.LayerList.Layer[0].Extension['ol:units']._text,
            scale: 1,
            id: res._attributes.id,
        };
        compositionJSON.name = res.General.Title._text;
        compositionJSON.projection = res.General.BoundingBox._attributes.SRS;
        compositionJSON.projection =
            compositionJSON.projection == 'EPSG:102067'
                ? 'EPSG:5514'
                : compositionJSON.projection;
        compositionJSON.extent = transformExtent(compositionJSON.extent, compositionJSON.projection, 'EPSG:4326');
        for (const layer of res.LayerList.Layer) {
            const layerToAdd = {
                className: 'HSLayers.Layer.WMS',
                dimensions: {},
                legends: [''],
                maxResolution: null,
                metadata: {},
                minResolution: 0,
                opacity: layer.Extension['ol:opacity']
                    ? parseFloat(layer.Extension['ol:opacity']._text)
                    : 1,
                showInLayerManager: layer.Extension['ol:displayInLayerSwitcher']._text,
                params: {
                    FORMAT: 'image/png',
                    INFO_FORMAT: 'text/html',
                    LAYERS: layer.Name._text,
                    VERSION: layer.Server._attributes.version,
                },
                ratio: 1.5,
                singleTile: true,
                title: layer.Extension['hsl:layer_title']._text,
                url: layer.Server.OnlineResource._attributes['xlink:href'],
                visibility: true,
            };
            compositionJSON.layers.push(layerToAdd);
        }
        const composition = { data: {} };
        composition.data = compositionJSON;
        return composition;
    }
    checkLoadSuccess(response) {
        return (response.success == true /*micka*/ ||
            (response.success == undefined /*layman*/ &&
                response.name !== undefined) ||
            response.includes('LayerList') /*.wmc micka*/);
    }
    loadCompositionObject(obj, overwrite, titleFromContainer, extentFromContainer) {
        return __awaiter(this, void 0, void 0, function* () {
            if (overwrite == undefined || overwrite == true) {
                this.removeCompositionLayers();
            }
            this.HsEventBusService.currentComposition.next(obj);
            this.current_composition_title = titleFromContainer || obj.title;
            const possibleExtent = extentFromContainer || obj.extent;
            if (possibleExtent !== undefined) {
                const extent = parseExtent(possibleExtent);
                if ((extent[0][0] < -90 && extent[0][1] < -180) ||
                    (extent[1][0] > 90 && extent[1][1] > 180)) {
                    this.loadWarningBootstrap(extent);
                }
                else {
                    this.HsMapService.fitExtent(transformExtentValue(extent, this.HsMapService.getCurrentProj()));
                }
            }
            const layers = yield this.jsonToLayers(obj);
            if ((layers === null || layers === void 0 ? void 0 : layers.length) > 0) {
                layers.forEach((lyr) => {
                    this.HsMapService.addLayer(lyr, DuplicateHandling.RemoveOriginal);
                });
                this.HsLayerManagerService.updateLayerListPositions();
            }
            if (obj.current_base_layer) {
                this.HsMapService.map.getLayers().forEach((lyr) => {
                    if (getTitle(lyr) == obj.current_base_layer.title ||
                        getTitle(lyr) == obj.current_base_layer) {
                        lyr.setVisible(true);
                    }
                });
            }
        });
    }
    finalizeCompositionLoading(responseData) {
        if (this.HsConfig.open_lm_after_comp_loaded) {
            this.HsLayoutService.setMainPanel('layermanager');
        }
        this.composition_edited = false;
        this.HsEventBusService.compositionLoads.next(responseData);
    }
    raiseCompositionLoadError(response) {
        const respError = {};
        respError.error = response.error;
        switch (response.error) {
            case 'no data':
                respError.title = 'Composition not found';
                respError.abstract =
                    'Sorry but composition was deleted or incorrectly saved';
                break;
            default:
                respError.title = 'Composition not loaded';
                respError.abstract =
                    'We are sorry, but composition was not loaded due to some error';
                break;
        }
        this.HsEventBusService.compositionLoads.next(respError);
    }
    /**
     * @public
     * @description Remove all layers gained from composition from map
     */
    removeCompositionLayers() {
        const to_be_removed = [];
        this.HsMapService.getLayersArray().forEach((lyr) => {
            if (getFromComposition(lyr)) {
                to_be_removed.push(lyr);
            }
        });
        while (to_be_removed.length > 0) {
            this.HsMapService.map.removeLayer(to_be_removed.shift());
        }
    }
    /**
     * @public
     * @param {string} url Url to composition info
     * @returns {object} Object containing composition info
     * @description Send Ajax request to selected server to gain information about composition
     */
    loadInfo(url) {
        return __awaiter(this, void 0, void 0, function* () {
            url = url.replace(/&amp;/g, '&');
            url = this.HsUtilsService.proxify(url);
            let options;
            options = { responseType: 'json' };
            let response;
            if (url.endsWith('.wmc')) {
                options = { responseType: 'text' };
                response = yield this.$http.get(url, options).toPromise();
                response = this.parseMickaWmcInfo(response);
            }
            else {
                response = yield this.$http.get(url, options).toPromise();
            }
            return response.data || response;
        });
    }
    parseMickaWmcInfo(response) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10;
        let res = xml2Json.xml2js(response, { compact: true });
        const layersInfo = (_a = res.ViewContext.LayerList) === null || _a === void 0 ? void 0 : _a.Layer;
        const keywordsInfo = (_b = res.ViewContext.General.KeywordList) === null || _b === void 0 ? void 0 : _b.Keyword;
        res = res.ViewContext.General;
        const infoDetails = {
            title: (_c = res.Title) === null || _c === void 0 ? void 0 : _c._text,
            abstract: (_d = res.Abstract) === null || _d === void 0 ? void 0 : _d._text,
            srs: (_f = (_e = res.BoundingBox) === null || _e === void 0 ? void 0 : _e._attributes) === null || _f === void 0 ? void 0 : _f.SRS,
            extent: [
                parseFloat((_g = res.BoundingBox) === null || _g === void 0 ? void 0 : _g._attributes['maxx']),
                parseFloat((_h = res.BoundingBox) === null || _h === void 0 ? void 0 : _h._attributes['maxy']),
                parseFloat((_j = res.BoundingBox) === null || _j === void 0 ? void 0 : _j._attributes['minx']),
                parseFloat((_k = res.BoundingBox) === null || _k === void 0 ? void 0 : _k._attributes['miny']),
            ],
            contactAddress: {
                address: (_o = (_m = (_l = res.ContactInformation) === null || _l === void 0 ? void 0 : _l.ContactAddress) === null || _m === void 0 ? void 0 : _m.Address) === null || _o === void 0 ? void 0 : _o._text,
                city: (_r = (_q = (_p = res.ContactInformation) === null || _p === void 0 ? void 0 : _p.ContactAddress) === null || _q === void 0 ? void 0 : _q.City) === null || _r === void 0 ? void 0 : _r._text,
                country: (_u = (_t = (_s = res.ContactInformation) === null || _s === void 0 ? void 0 : _s.ContactAddress) === null || _t === void 0 ? void 0 : _t.Country) === null || _u === void 0 ? void 0 : _u._text,
                postalCode: (_x = (_w = (_v = res.ContactInformation) === null || _v === void 0 ? void 0 : _v.ContactAddress) === null || _w === void 0 ? void 0 : _w.PostCode) === null || _x === void 0 ? void 0 : _x._text,
                stateOrProvince: (_0 = (_z = (_y = res.ContactInformation) === null || _y === void 0 ? void 0 : _y.ContactAddress) === null || _z === void 0 ? void 0 : _z.StateOrProvince) === null || _0 === void 0 ? void 0 : _0._text,
            },
            contactPersonPrimary: {
                organization: (_3 = (_2 = (_1 = res.ContactInformation) === null || _1 === void 0 ? void 0 : _1.ContactPersonPrimary) === null || _2 === void 0 ? void 0 : _2.ContactOrganization) === null || _3 === void 0 ? void 0 : _3._text,
                person: (_6 = (_5 = (_4 = res.ContactInformation) === null || _4 === void 0 ? void 0 : _4.ContactPersonPrimary) === null || _5 === void 0 ? void 0 : _5.ContactPerson) === null || _6 === void 0 ? void 0 : _6._text,
                phone: (_8 = (_7 = res.ContactInformation) === null || _7 === void 0 ? void 0 : _7.ContactVoiceTelephone) === null || _8 === void 0 ? void 0 : _8._text,
                email: (_10 = (_9 = res.ContactInformation) === null || _9 === void 0 ? void 0 : _9.ContactElectronicMailAddress) === null || _10 === void 0 ? void 0 : _10._text,
            },
        };
        if (layersInfo !== undefined) {
            infoDetails.layers = layersInfo.map((lyr) => {
                var _a;
                return {
                    title: (_a = lyr.Title) === null || _a === void 0 ? void 0 : _a._text,
                };
            });
        }
        if (keywordsInfo !== undefined) {
            Array.isArray(keywordsInfo)
                ? (infoDetails.keywords = keywordsInfo.map((kw) => kw._text))
                : (infoDetails.keywords = keywordsInfo._text);
        }
        return infoDetails;
    }
    loadWarningBootstrap(extent) {
        this.HsDialogContainerService.create(HsCompositionsWarningDialogComponent, {
            extent: extent,
            composition_title: this.current_composition_title,
            message: this.HsLanguageService.getTranslationIgnoreNonExisting('COMPOSITIONS.dialogWarning', 'outOfBounds'),
        });
    }
    /**
     * @public
     * @param {object} j Composition object with Layers
     * @returns {Array} Array of created layers
     * @description Parse composition object to extract individual layers and add them to map
     */
    jsonToLayers(j) {
        return __awaiter(this, void 0, void 0, function* () {
            const layers = [];
            if (j.data) {
                j = j.data;
            }
            for (const lyr_def of j.layers) {
                const layer = yield this.jsonToLayer(lyr_def);
                if (layer == undefined) {
                    if (lyr_def.protocol.format != 'hs.format.externalWFS') {
                        this.$log.warn('Was not able to parse layer from composition', lyr_def);
                    }
                }
                else {
                    layers.push(layer);
                }
            }
            return layers;
        });
    }
    /**
     * @public
     * @param {object} lyr_def Layer to be created (encapsulated in layer definition object)
     * @returns {Function} Parser function to create layer (using config_parsers service)
     * @description Select correct layer parser for input data based on layer "className" property (HSLayers.Layer.WMS/OpenLayers.Layer.Vector)
     */
    jsonToLayer(lyr_def) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            let resultLayer;
            switch (lyr_def.className) {
                case 'HSLayers.Layer.WMS':
                case 'WMS':
                    resultLayer =
                        this.HsCompositionsLayerParserService.createWmsLayer(lyr_def);
                    break;
                case 'HSLayers.Layer.WMTS':
                    resultLayer =
                        this.HsCompositionsLayerParserService.createWMTSLayer(lyr_def);
                    break;
                case 'ArcGISRest':
                    resultLayer =
                        this.HsCompositionsLayerParserService.createArcGISLayer(lyr_def);
                    break;
                case 'XYZ':
                    resultLayer =
                        this.HsCompositionsLayerParserService.createXYZLayer(lyr_def);
                    break;
                case 'StaticImage':
                    resultLayer =
                        this.HsCompositionsLayerParserService.createStaticImageLayer(lyr_def);
                    break;
                case 'OpenLayers.Layer.Vector':
                case 'Vector':
                case 'hs.format.LaymanWfs':
                    if (((_a = lyr_def.protocol) === null || _a === void 0 ? void 0 : _a.format) == 'hs.format.externalWFS') {
                        this.HsCompositionsLayerParserService.createWFSLayer(lyr_def);
                    }
                    else {
                        resultLayer =
                            yield this.HsCompositionsLayerParserService.createVectorLayer(lyr_def);
                    }
                    break;
                default:
                    const existing = this.HsMapService.getLayersArray().find((l) => getTitle(l) == lyr_def.title);
                    if (existing != undefined) {
                        existing.setZIndex(undefined);
                        return existing;
                    }
                    return;
            }
            if (resultLayer) {
                setMetadata(resultLayer, lyr_def.metadata);
            }
            return resultLayer;
        });
    }
}
HsCompositionsParserService.ɵfac = function HsCompositionsParserService_Factory(t) { return new (t || HsCompositionsParserService)(ɵngcc0.ɵɵinject(HsMapService), ɵngcc0.ɵɵinject(HsConfig), ɵngcc0.ɵɵinject(ɵngcc2.HttpClient), ɵngcc0.ɵɵinject(HsUtilsService), ɵngcc0.ɵɵinject(HsCompositionsLayerParserService), ɵngcc0.ɵɵinject(HsDialogContainerService), ɵngcc0.ɵɵinject(HsLayoutService), ɵngcc0.ɵɵinject(HsLogService), ɵngcc0.ɵɵinject(HsEventBusService), ɵngcc0.ɵɵinject(HsLanguageService), ɵngcc0.ɵɵinject(HsCommonEndpointsService), ɵngcc0.ɵɵinject(HsLayerManagerService)); };
HsCompositionsParserService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HsCompositionsParserService_Factory() { return new HsCompositionsParserService(i0.ɵɵinject(HsMapService), i0.ɵɵinject(HsConfig), i0.ɵɵinject(i1$1.HttpClient), i0.ɵɵinject(HsUtilsService), i0.ɵɵinject(HsCompositionsLayerParserService), i0.ɵɵinject(HsDialogContainerService), i0.ɵɵinject(HsLayoutService), i0.ɵɵinject(HsLogService), i0.ɵɵinject(HsEventBusService), i0.ɵɵinject(HsLanguageService), i0.ɵɵinject(HsCommonEndpointsService), i0.ɵɵinject(HsLayerManagerService)); }, token: HsCompositionsParserService, providedIn: "root" });
HsCompositionsParserService.ctorParameters = () => [
    { type: HsMapService },
    { type: HsConfig },
    { type: HttpClient },
    { type: HsUtilsService },
    { type: HsCompositionsLayerParserService },
    { type: HsDialogContainerService },
    { type: HsLayoutService },
    { type: HsLogService },
    { type: HsEventBusService },
    { type: HsLanguageService },
    { type: HsCommonEndpointsService },
    { type: HsLayerManagerService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsCompositionsParserService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: HsMapService }, { type: HsConfig }, { type: ɵngcc2.HttpClient }, { type: HsUtilsService }, { type: HsCompositionsLayerParserService }, { type: HsDialogContainerService }, { type: HsLayoutService }, { type: HsLogService }, { type: HsEventBusService }, { type: HsLanguageService }, { type: HsCommonEndpointsService }, { type: HsLayerManagerService }]; }, null); })();

class HsCompositionsLaymanService {
    constructor($http, hsUtilsService, hsCommonLaymanService, hsCompositionsParserService, hsEventBusService, hsToastService, hsLanguageService, hsMapService) {
        this.$http = $http;
        this.hsUtilsService = hsUtilsService;
        this.hsCommonLaymanService = hsCommonLaymanService;
        this.hsCompositionsParserService = hsCompositionsParserService;
        this.hsEventBusService = hsEventBusService;
        this.hsToastService = hsToastService;
        this.hsLanguageService = hsLanguageService;
        this.hsMapService = hsMapService;
        this.data = {};
    }
    loadList(endpoint, params, extentFeatureCreated) {
        endpoint.getCurrentUserIfNeeded(endpoint);
        endpoint.compositionsPaging.loaded = false;
        const query = params.query.title ? params.query.title : '';
        const sortBy = params.sortBy == 'date:D'
            ? 'last_change'
            : params.sortBy !== undefined && params.sortBy != 'None' //Set by date by default, was requested long time ago
                ? params.sortBy
                : 'last_change';
        const b = transformExtent(this.hsMapService.map
            .getView()
            .calculateExtent(this.hsMapService.map.getSize()), this.hsMapService.getCurrentProj(), 'EPSG:3857');
        const bbox = params.filterByExtent ? b.join(',') : '';
        const withPermissionOrMine = params.filterByOnlyMine
            ? endpoint.user !== 'anonymous' && endpoint.user !== 'browser'
                ? `workspaces/${endpoint.user}/`
                : ''
            : '';
        const url = `${endpoint.url}/rest/${withPermissionOrMine}maps`;
        endpoint.listLoading = this.$http
            .get(url, {
            observe: 'response',
            withCredentials: true,
            params: {
                'limit': `${endpoint.compositionsPaging.limit}`,
                'offset': `${endpoint.compositionsPaging.start}`,
                'full_text_filter': `${query}`,
                'order_by': `${sortBy}`,
                'bbox_filter': `${bbox}`,
            },
        })
            .pipe(timeout(5000), map((response) => {
            if (Array.isArray(response.body)) {
                response.body.extentFeatureCreated = extentFeatureCreated;
                this.compositionsReceived(endpoint, response);
            }
            else {
                this.hsCommonLaymanService.displayLaymanError(endpoint, 'COMPOSITIONS.errorWhileRequestingCompositions', response.body);
            }
        }), catchError((e) => {
            var _a, _b, _c;
            if (isErrorHandlerFunction((_a = endpoint.onError) === null || _a === void 0 ? void 0 : _a.compositionLoad)) {
                ((_b = endpoint.onError) === null || _b === void 0 ? void 0 : _b.compositionLoad).handle(endpoint, e);
                return of(e);
            }
            switch ((_c = endpoint.onError) === null || _c === void 0 ? void 0 : _c.compositionLoad) {
                case EndpointErrorHandling.ignore:
                    break;
                case EndpointErrorHandling.toast:
                default:
                    this.hsToastService.createToastPopupMessage(this.hsLanguageService.getTranslation('COMPOSITIONS.errorWhileRequestingCompositions'), endpoint.title +
                        ': ' +
                        this.hsLanguageService.getTranslationIgnoreNonExisting('ERRORMESSAGES', e.status ? e.status.toString() : e.message, { url: endpoint.url }), {
                        disableLocalization: true,
                        serviceCalledFrom: 'HsCompositionsLaymanService',
                    });
                    break;
            }
            return of(e);
        }));
        return endpoint.listLoading;
    }
    compositionsReceived(endpoint, response) {
        if (response.body.length == 0) {
            endpoint.compositionsPaging.matched = 0;
            this.displayWarningToast(endpoint, 'COMMON.noDataReceived');
            return;
        }
        endpoint.compositionsPaging.loaded = true;
        endpoint.compositionsPaging.matched = response.headers.get('x-total-count') // in case response is an error, x-total-count will return null, it must be checked
            ? parseInt(response.headers.get('x-total-count'))
            : response.body.length;
        endpoint.compositions = response.body.map((record) => {
            const tmp = {
                name: record.name,
                title: record.title,
                access_rights: record.access_rights,
                feature: undefined,
                highlighted: false,
                editable: record.access_rights.write.some((user) => {
                    return [endpoint.user, 'EVERYONE'].includes(user);
                }),
                url: `${endpoint.url}/rest/workspaces/${record.workspace}/maps/${record.name}`,
                endpoint: endpoint,
                workspace: record.workspace,
                id: `m-${record.uuid}`, //m-* to match micka's id structure.
            };
            if (response.body.extentFeatureCreated) {
                const mapProjection = this.hsMapService.getCurrentProj();
                const extentFeature = addExtentFeature(record, mapProjection);
                if (extentFeature) {
                    tmp.feature = extentFeature;
                    extentFeature.set('record', tmp);
                    response.body.extentFeatureCreated(extentFeature);
                }
            }
            return tmp;
        });
    }
    delete(endpoint, composition) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${endpoint.url}/rest/workspaces/${composition.workspace}/maps/${composition.name}`;
            yield this.$http.delete(url, { withCredentials: true }).toPromise();
            this.hsEventBusService.compositionDeletes.next(composition);
        });
    }
    getInfo(composition) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = composition.endpoint;
            if (composition.name == undefined) {
                this.displayWarningToast(endpoint, 'COMPOSITIONS.compostionsNameAttributeIsNotDefined');
                return;
            }
            if (endpoint.user == undefined) {
                this.displayWarningToast(endpoint, 'COMPOSITIONS.endpointUserIsNotDefined');
                return;
            }
            if (endpoint.url == undefined) {
                this.displayWarningToast(endpoint, 'COMPOSITIONS.endpointUrlIsNotDefined');
                return;
            }
            const url = `${endpoint.url}/rest/workspaces/${composition.workspace}/maps/${composition.name}`;
            const info = yield this.hsCompositionsParserService.loadInfo(url);
            if (((_a = info.thumbnail) === null || _a === void 0 ? void 0 : _a.status) !== undefined &&
                ((_b = info.thumbnail) === null || _b === void 0 ? void 0 : _b.status) == 'NOT_AVAILABLE') {
                delete info.thumbnail;
            }
            info.abstract = info.description;
            return info;
        });
    }
    resetCompositionCounter(endpoint) {
        endpoint.compositionsPaging.start = 0;
        endpoint.compositionsPaging.next = this.data.limit;
        endpoint.compositionsPaging.matched = 0;
    }
    displayWarningToast(endpoint, message) {
        this.hsToastService.createToastPopupMessage(this.hsLanguageService.getTranslation('COMMON.warning'), endpoint.title + ': ' + this.hsLanguageService.getTranslation(message), {
            disableLocalization: true,
            toastStyleClasses: 'bg-warning text-light',
            serviceCalledFrom: 'HsCompositionsLaymanService',
        });
    }
}
HsCompositionsLaymanService.ɵfac = function HsCompositionsLaymanService_Factory(t) { return new (t || HsCompositionsLaymanService)(ɵngcc0.ɵɵinject(ɵngcc2.HttpClient), ɵngcc0.ɵɵinject(HsUtilsService), ɵngcc0.ɵɵinject(HsCommonLaymanService), ɵngcc0.ɵɵinject(HsCompositionsParserService), ɵngcc0.ɵɵinject(HsEventBusService), ɵngcc0.ɵɵinject(HsToastService), ɵngcc0.ɵɵinject(HsLanguageService), ɵngcc0.ɵɵinject(HsMapService)); };
HsCompositionsLaymanService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HsCompositionsLaymanService_Factory() { return new HsCompositionsLaymanService(i0.ɵɵinject(i1$1.HttpClient), i0.ɵɵinject(HsUtilsService), i0.ɵɵinject(HsCommonLaymanService), i0.ɵɵinject(HsCompositionsParserService), i0.ɵɵinject(HsEventBusService), i0.ɵɵinject(HsToastService), i0.ɵɵinject(HsLanguageService), i0.ɵɵinject(HsMapService)); }, token: HsCompositionsLaymanService, providedIn: "root" });
HsCompositionsLaymanService.ctorParameters = () => [
    { type: HttpClient },
    { type: HsUtilsService },
    { type: HsCommonLaymanService },
    { type: HsCompositionsParserService },
    { type: HsEventBusService },
    { type: HsToastService },
    { type: HsLanguageService },
    { type: HsMapService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsCompositionsLaymanService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc2.HttpClient }, { type: HsUtilsService }, { type: HsCommonLaymanService }, { type: HsCompositionsParserService }, { type: HsEventBusService }, { type: HsToastService }, { type: HsLanguageService }, { type: HsMapService }]; }, null); })();

class HsCompositionsMapService {
    constructor(HsEventBusService, HsMapService, HsLayoutService, HsSaveMapService, zone) {
        this.HsEventBusService = HsEventBusService;
        this.HsMapService = HsMapService;
        this.HsLayoutService = HsLayoutService;
        this.HsSaveMapService = HsSaveMapService;
        this.zone = zone;
        this.extentLayer = new VectorLayer({
            properties: {
                title: 'Composition extents',
                showInLayerManager: false,
                removable: false,
            },
            source: new Vector(),
            style: function (feature, resolution) {
                return [
                    new Style({
                        stroke: new Stroke({
                            color: '#005CB6',
                            width: getHighlighted(feature) ? 4 : 1,
                        }),
                        fill: new Fill({
                            color: 'rgba(0, 0, 255, 0.01)',
                        }),
                    }),
                ];
            },
        });
        this.HsMapService.loaded().then((map) => {
            map.on('pointermove', (e) => this.mapPointerMoved(e));
            map.addLayer(this.extentLayer);
            this.HsSaveMapService.internalLayers.push(this.extentLayer);
        });
        this.HsEventBusService.mainPanelChanges.subscribe(() => {
            if (this.extentLayer) {
                if (this.HsLayoutService.mainpanel === 'composition_browser' ||
                    this.HsLayoutService.mainpanel === 'composition') {
                    this.extentLayer.setVisible(true);
                }
                else {
                    this.extentLayer.setVisible(false);
                }
            }
        });
    }
    /**
     * @param evt
     */
    mapPointerMoved(evt) {
        const featuresUnderMouse = this.extentLayer
            .getSource()
            .getFeaturesAtCoordinate(evt.coordinate);
        const highlightedFeatures = this.extentLayer
            .getSource()
            .getFeatures()
            .filter((feature) => getRecord(feature).highlighted);
        const dontHighlight = highlightedFeatures.filter((feature) => !featuresUnderMouse.includes(feature));
        const highlight = featuresUnderMouse.filter((feature) => !highlightedFeatures.includes(feature));
        if (dontHighlight.length > 0 || highlight.length > 0) {
            this.zone.run(() => {
                for (const feature of highlight) {
                    getRecord(feature).highlighted = true;
                }
                for (const feature of dontHighlight) {
                    getRecord(feature).highlighted = false;
                }
            });
        }
    }
    highlightComposition(composition, state) {
        if (composition.feature) {
            setHighlighted(composition.feature, state);
        }
    }
    clearExtentLayer() {
        this.extentLayer.getSource().clear();
    }
    /**
     * Callback function which gets executed when extent feature
     * is created. It should add the feature to vector layer source
     * @param extentFeature - OpenLayers Feature
     */
    addExtentFeature(extentFeature) {
        this.extentLayer.getSource().addFeatures([extentFeature]);
    }
    getFeatureRecordAndUnhighlight(feature, selector) {
        if (this.HsMapService.getLayerForFeature(feature) == this.extentLayer &&
            getRecord(feature)) {
            const record = getRecord(feature);
            setHighlighted(feature, false);
            selector.getFeatures().clear();
            return record;
        }
    }
}
HsCompositionsMapService.ɵfac = function HsCompositionsMapService_Factory(t) { return new (t || HsCompositionsMapService)(ɵngcc0.ɵɵinject(HsEventBusService), ɵngcc0.ɵɵinject(HsMapService), ɵngcc0.ɵɵinject(HsLayoutService), ɵngcc0.ɵɵinject(HsSaveMapService), ɵngcc0.ɵɵinject(ɵngcc0.NgZone)); };
HsCompositionsMapService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HsCompositionsMapService_Factory() { return new HsCompositionsMapService(i0.ɵɵinject(HsEventBusService), i0.ɵɵinject(HsMapService), i0.ɵɵinject(HsLayoutService), i0.ɵɵinject(HsSaveMapService), i0.ɵɵinject(i0.NgZone)); }, token: HsCompositionsMapService, providedIn: "root" });
HsCompositionsMapService.ctorParameters = () => [
    { type: HsEventBusService },
    { type: HsMapService },
    { type: HsLayoutService },
    { type: HsSaveMapService },
    { type: NgZone }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsCompositionsMapService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: HsEventBusService }, { type: HsMapService }, { type: HsLayoutService }, { type: HsSaveMapService }, { type: ɵngcc0.NgZone }]; }, null); })();

class HsCompositionsMickaService {
    constructor(HsCompositionsParserService, $http, HsMapService, HsUtilsService, HsToastService, HsLanguageService) {
        this.HsCompositionsParserService = HsCompositionsParserService;
        this.$http = $http;
        this.HsMapService = HsMapService;
        this.HsUtilsService = HsUtilsService;
        this.HsToastService = HsToastService;
        this.HsLanguageService = HsLanguageService;
    }
    getCompositionsQueryUrl(endpoint, params, bbox) {
        const query = params.query;
        const bboxDelimiter = endpoint.url.indexOf('cswClientRun.php') > 0 ? ',' : ' ';
        const serviceName = endpoint.serviceName !== undefined
            ? 'serviceName=&' + endpoint.serviceName
            : '';
        bbox = params.filterByExtent
            ? encodeURIComponent(" and BBOX='" + bbox.join(bboxDelimiter) + "'")
            : '';
        const textFilter = query && query.title !== undefined && query.title != ''
            ? encodeURIComponent(" AND title like '*" +
                query.title +
                "*' OR abstract like '*" +
                query.title +
                "*'")
            : '';
        const selected = [];
        let keywordFilter = '';
        let tmp = endpoint.url;
        for (const key of params.keywords) {
            if (key.selected) {
                selected.push("Subject='" + key.value + "'");
            }
        }
        for (const theme of params.themes) {
            if (theme.selected) {
                selected.push("Subject='" + theme.value + "'");
            }
        }
        if (selected.length > 0) {
            keywordFilter = encodeURIComponent(' AND ' + selected.join(' OR '));
        }
        tmp +=
            '?format=json&' +
                serviceName +
                'query=type%3D' +
                params.type +
                bbox +
                textFilter +
                keywordFilter +
                '&lang=eng&sortBy=' +
                params.sortBy +
                '&detail=summary&start=' +
                params.start +
                '&limit=' +
                params.limit;
        tmp = this.HsUtilsService.proxify(tmp);
        return tmp;
    }
    compositionsReceived(endpoint, response) {
        if (!response.records) {
            this.HsToastService.createToastPopupMessage(this.HsLanguageService.getTranslation('COMMON.warning'), endpoint.title +
                ': ' +
                this.HsLanguageService.getTranslation('COMMON.noDataReceived'), {
                disableLocalization: true,
                toastStyleClasses: 'bg-warning text-light',
                serviceCalledFrom: 'HsCompositionsMickaService',
            });
            return;
        }
        endpoint.compositionsPaging.loaded = true;
        endpoint.compositions = response.records;
        if (response.records && response.records.length > 0) {
            endpoint.compositionsPaging.matched = response.matched;
        }
        else {
            endpoint.compositionsPaging.matched = 0;
        }
        endpoint.compositionsPaging.next = response.next;
        for (const record of endpoint.compositions) {
            record.editable = false;
            record.endpoint = endpoint;
            if (record.thumbnail == undefined) {
                record.thumbnail = endpoint.url + '?request=loadthumb&id=' + record.id;
            }
            if (response.extentFeatureCreated) {
                const mapProjection = this.HsMapService.getCurrentProj();
                const extentFeature = addExtentFeature(record, mapProjection);
                if (extentFeature) {
                    record.feature = extentFeature;
                    response.extentFeatureCreated(extentFeature);
                }
            }
        }
    }
    loadList(endpoint, params, extentFeatureCreated, bbox) {
        params = this.checkForParams(endpoint, params);
        const url = this.getCompositionsQueryUrl(endpoint, params, bbox);
        endpoint.compositionsPaging.loaded = false;
        endpoint.httpCall = this.$http
            .get(url, {
            responseType: 'json',
        })
            .pipe(timeout(5000), map((response) => {
            response.extentFeatureCreated = extentFeatureCreated;
            this.compositionsReceived(endpoint, response);
        }), catchError((e) => {
            this.HsToastService.createToastPopupMessage(this.HsLanguageService.getTranslation('COMPOSITIONS.errorWhileRequestingCompositions'), endpoint.title +
                ': ' +
                this.HsLanguageService.getTranslationIgnoreNonExisting('ERRORMESSAGES', e.status ? e.status.toString() : e.message, { url: url }), {
                disableLocalization: true,
                serviceCalledFrom: 'HsCompositionsMickaService',
            });
            return of(e);
        }));
        return endpoint.httpCall;
    }
    resetCompositionCounter(endpoint) {
        endpoint.compositionsPaging.start = 0;
        endpoint.compositionsPaging.next = endpoint.compositionsPaging.limit;
        endpoint.compositionsPaging.matched = 0;
    }
    checkForParams(endpoint, params) {
        if (params.sortBy == undefined || params.sortBy === 'None') {
            params.sortBy = 'date:D';
        }
        if (params.type == undefined || params.type === 'None') {
            params.type = 'application';
        }
        if (params.start == undefined) {
            params.start = endpoint.compositionsPaging.start;
        }
        if (params.limit == undefined || isNaN(params.limit)) {
            params.limit = endpoint.compositionsPaging.limit;
        }
        return params;
    }
}
HsCompositionsMickaService.ɵfac = function HsCompositionsMickaService_Factory(t) { return new (t || HsCompositionsMickaService)(ɵngcc0.ɵɵinject(HsCompositionsParserService), ɵngcc0.ɵɵinject(ɵngcc2.HttpClient), ɵngcc0.ɵɵinject(HsMapService), ɵngcc0.ɵɵinject(HsUtilsService), ɵngcc0.ɵɵinject(HsToastService), ɵngcc0.ɵɵinject(HsLanguageService)); };
HsCompositionsMickaService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HsCompositionsMickaService_Factory() { return new HsCompositionsMickaService(i0.ɵɵinject(HsCompositionsParserService), i0.ɵɵinject(i1$1.HttpClient), i0.ɵɵinject(HsMapService), i0.ɵɵinject(HsUtilsService), i0.ɵɵinject(HsToastService), i0.ɵɵinject(HsLanguageService)); }, token: HsCompositionsMickaService, providedIn: "root" });
HsCompositionsMickaService.ctorParameters = () => [
    { type: HsCompositionsParserService },
    { type: HttpClient },
    { type: HsMapService },
    { type: HsUtilsService },
    { type: HsToastService },
    { type: HsLanguageService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsCompositionsMickaService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: HsCompositionsParserService }, { type: ɵngcc2.HttpClient }, { type: HsMapService }, { type: HsUtilsService }, { type: HsToastService }, { type: HsLanguageService }]; }, null); })();

class HsStatusManagerService {
    constructor(http, HsConfig, HsUtilsService, HsCommonEndpointsService) {
        this.http = http;
        this.HsConfig = HsConfig;
        this.HsUtilsService = HsUtilsService;
        this.HsCommonEndpointsService = HsCommonEndpointsService;
    }
    endpointUrl() {
        var _a;
        let hostName = location.protocol + '//' + location.host;
        if (this.HsConfig.hostname) {
            if (this.HsConfig.hostname.status_manager &&
                this.HsConfig.hostname.status_manager.url) {
                return this.HsConfig.hostname.status_manager.url;
            }
            if (this.HsConfig.hostname.user && this.HsConfig.hostname.user.url) {
                hostName = this.HsConfig.hostname.user.url;
            }
            else if (this.HsConfig.hostname.default &&
                this.HsConfig.hostname.default.url) {
                hostName = this.HsConfig.hostname.default.url;
            }
        }
        if ((_a = this.HsConfig.status_manager_url) === null || _a === void 0 ? void 0 : _a.includes('://')) {
            //Full url specified
            return this.HsConfig.status_manager_url;
        }
        else {
            return hostName + (this.HsConfig.status_manager_url || '/statusmanager/');
        }
    }
    findStatusmanagerEndpoint() {
        const found = this.HsCommonEndpointsService.endpoints.filter((e) => e.type == 'status_manager');
        if (found.length > 0) {
            return found[0];
        }
    }
    save(compositionJson, endpoint, compoData, saveAsNew) {
        if (saveAsNew || compoData.id == '') {
            compoData.id = this.HsUtilsService.generateUuid();
        }
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.http
                    .post(this.endpointUrl(), {
                    data: compositionJson,
                    permanent: true,
                    id: compoData.id,
                    project: this.HsConfig.project_name,
                    thumbnail: compoData.thumbnail,
                    request: 'save',
                })
                    .toPromise();
                resolve(response);
            }
            catch (err) {
                reject();
            }
        }));
    }
}
HsStatusManagerService.ɵfac = function HsStatusManagerService_Factory(t) { return new (t || HsStatusManagerService)(ɵngcc0.ɵɵinject(ɵngcc2.HttpClient), ɵngcc0.ɵɵinject(HsConfig), ɵngcc0.ɵɵinject(HsUtilsService), ɵngcc0.ɵɵinject(HsCommonEndpointsService)); };
HsStatusManagerService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HsStatusManagerService_Factory() { return new HsStatusManagerService(i0.ɵɵinject(i1$1.HttpClient), i0.ɵɵinject(HsConfig), i0.ɵɵinject(HsUtilsService), i0.ɵɵinject(HsCommonEndpointsService)); }, token: HsStatusManagerService, providedIn: "root" });
HsStatusManagerService.ctorParameters = () => [
    { type: HttpClient },
    { type: HsConfig },
    { type: HsUtilsService },
    { type: HsCommonEndpointsService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsStatusManagerService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc2.HttpClient }, { type: HsConfig }, { type: HsUtilsService }, { type: HsCommonEndpointsService }]; }, null); })();

class HsCompositionsStatusManagerService {
    constructor(HsStatusManagerService, HsConfig, HsUtilsService, $http, HsEventBusService, HsToastService, HsLanguageService) {
        this.HsStatusManagerService = HsStatusManagerService;
        this.HsConfig = HsConfig;
        this.HsUtilsService = HsUtilsService;
        this.$http = $http;
        this.HsEventBusService = HsEventBusService;
        this.HsToastService = HsToastService;
        this.HsLanguageService = HsLanguageService;
    }
    /**
     * @public
     * @description Load list of compositions according to current
     * filter values and pager position (filter, keywords, current
     * extent, start composition, compositions number per page).
     * Display compositions extent in map. Loops through the existing
     * list of compositions, and when a composition is
     * found in statusmanagers list, then it becomes editable.
     * @param ds
     * @param params
     * @param bbox
     */
    loadList(ds, params, bbox) {
        let url = this.HsStatusManagerService.endpointUrl();
        const query = params.query;
        const textFilter = query && query.title !== undefined && query.title != ''
            ? '&q=' + encodeURIComponent('*' + query.title + '*')
            : '';
        url +=
            '?request=list&project=' +
                encodeURIComponent(this.HsConfig.project_name) +
                '&extent=' +
                bbox.join(',') +
                textFilter +
                '&start=0&limit=1000&sort=' +
                getStatusSortAttr(params.sortBy);
        url = this.HsUtilsService.proxify(url);
        if (ds.listLoading) {
            ds.listLoading.unsubscribe();
            delete ds.listLoading;
        }
        const listLoading = this.$http.get(url).pipe(timeout(2000), map((response) => response), catchError((e) => {
            var _a, _b, _c;
            if (isErrorHandlerFunction((_a = ds.onError) === null || _a === void 0 ? void 0 : _a.compositionLoad)) {
                ((_b = ds.onError) === null || _b === void 0 ? void 0 : _b.compositionLoad).handle(ds, e);
                return of(e);
            }
            switch ((_c = ds.onError) === null || _c === void 0 ? void 0 : _c.compositionLoad) {
                case EndpointErrorHandling.ignore:
                    break;
                case EndpointErrorHandling.toast:
                default:
                    this.HsToastService.createToastPopupMessage(this.HsLanguageService.getTranslation('COMPOSITIONS.errorWhileRequestingCompositions'), ds.title +
                        ': ' +
                        this.HsLanguageService.getTranslationIgnoreNonExisting('ERRORMESSAGES', e.status ? e.status.toString() : e.message, { url: url }), {
                        disableLocalization: true,
                        serviceCalledFrom: 'HsCompositionsStatusManagerService',
                    });
            }
            return of(e);
        }));
        ds.listLoading = listLoading.subscribe((response) => {
            if (response.results === undefined) {
                return;
            }
            if (ds.compositions === undefined) {
                ds.compositions = [];
                ds.matched = 0;
            }
            for (const record of response.results) {
                let found = false;
                for (const composition of ds.compositions) {
                    if (composition.id == record.id) {
                        if (record.edit !== undefined) {
                            composition.editable = record.edit;
                        }
                        found = true;
                    }
                }
                if (!found) {
                    record.editable = false;
                    if (record.edit !== undefined) {
                        record.editable = record.edit;
                    }
                    if (record.link == undefined) {
                        record.link =
                            this.HsStatusManagerService.endpointUrl() +
                                '?request=load&id=' +
                                record.id;
                    }
                    if (record.thumbnail == undefined) {
                        record.thumbnail =
                            this.HsStatusManagerService.endpointUrl() +
                                '?request=loadthumb&id=' +
                                record.id;
                    }
                    const attributes = {
                        record: record,
                        hs_notqueryable: true,
                        highlighted: false,
                    };
                    if (record) {
                        ds.compositions.push(record);
                        ds.matched = ds.matched + 1;
                    }
                }
            }
        }, (err) => {
            //Do nothing
        });
    }
    delete(endpoint, composition) {
        let url = this.HsStatusManagerService.endpointUrl() +
            '?request=delete&id=' +
            composition.id +
            '&project=' +
            encodeURIComponent(this.HsConfig.project_name);
        url = this.HsUtilsService.proxify(url);
        this.$http.get(url).toPromise();
        this.HsEventBusService.compositionDeletes.next(composition);
    }
}
HsCompositionsStatusManagerService.ɵfac = function HsCompositionsStatusManagerService_Factory(t) { return new (t || HsCompositionsStatusManagerService)(ɵngcc0.ɵɵinject(HsStatusManagerService), ɵngcc0.ɵɵinject(HsConfig), ɵngcc0.ɵɵinject(HsUtilsService), ɵngcc0.ɵɵinject(ɵngcc2.HttpClient), ɵngcc0.ɵɵinject(HsEventBusService), ɵngcc0.ɵɵinject(HsToastService), ɵngcc0.ɵɵinject(HsLanguageService)); };
HsCompositionsStatusManagerService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HsCompositionsStatusManagerService_Factory() { return new HsCompositionsStatusManagerService(i0.ɵɵinject(HsStatusManagerService), i0.ɵɵinject(HsConfig), i0.ɵɵinject(HsUtilsService), i0.ɵɵinject(i1$1.HttpClient), i0.ɵɵinject(HsEventBusService), i0.ɵɵinject(HsToastService), i0.ɵɵinject(HsLanguageService)); }, token: HsCompositionsStatusManagerService, providedIn: "root" });
HsCompositionsStatusManagerService.ctorParameters = () => [
    { type: HsStatusManagerService },
    { type: HsConfig },
    { type: HsUtilsService },
    { type: HttpClient },
    { type: HsEventBusService },
    { type: HsToastService },
    { type: HsLanguageService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsCompositionsStatusManagerService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: HsStatusManagerService }, { type: HsConfig }, { type: HsUtilsService }, { type: ɵngcc2.HttpClient }, { type: HsEventBusService }, { type: HsToastService }, { type: HsLanguageService }]; }, null); })();
/**
 * @param sortBy
 */
function getStatusSortAttr(sortBy) {
    const sortMap = {
        bbox: '[{"property":"bbox","direction":"ASC"}]',
        title: '[{"property":"title","direction":"ASC"}]',
        date: '[{"property":"date","direction":"ASC"}]',
    };
    return encodeURIComponent(sortMap[sortBy]);
}

class HsCompositionsStatusManagerMickaJointService {
    constructor(HsCompositionsStatusManagerService, HsCompositionsMickaService, HsCompositionsMapService, HsCompositionsParserService, HsUtilsService, HsToastService, HsLanguageService) {
        this.HsCompositionsStatusManagerService = HsCompositionsStatusManagerService;
        this.HsCompositionsMickaService = HsCompositionsMickaService;
        this.HsCompositionsMapService = HsCompositionsMapService;
        this.HsCompositionsParserService = HsCompositionsParserService;
        this.HsUtilsService = HsUtilsService;
        this.HsToastService = HsToastService;
        this.HsLanguageService = HsLanguageService;
    }
    /**
     * @public
     * @description Load list of compositions according to current
     * filter values and pager position (filter, keywords, current
     * extent, start composition, compositions number per page).
     * Display compositions extent in map. Loops through the existing
     * list of compositions, and when a composition is
     * found in statusmanagers list, then it becomes editable.
     * @param ds
     * @param params
     * @param bbox
     */
    loadList(ds, params, extentFeatureCreated, bbox) {
        const Observable = this.HsCompositionsMickaService.loadList(ds, params, extentFeatureCreated, bbox).pipe(map((response) => {
            this.HsCompositionsStatusManagerService.loadList(ds, params, bbox);
        }), catchError((e) => {
            var _a, _b, _c;
            if (isErrorHandlerFunction((_a = ds.onError) === null || _a === void 0 ? void 0 : _a.compositionLoad)) {
                ((_b = ds.onError) === null || _b === void 0 ? void 0 : _b.compositionLoad).handle(ds, e);
                return of(e);
            }
            switch ((_c = ds.onError) === null || _c === void 0 ? void 0 : _c.compositionLoad) {
                case EndpointErrorHandling.ignore:
                    break;
                case EndpointErrorHandling.toast:
                default:
                    this.HsToastService.createToastPopupMessage(this.HsLanguageService.getTranslation('COMPOSITIONS.errorWhileRequestingCompositions'), ds.title +
                        ': ' +
                        this.HsLanguageService.getTranslationIgnoreNonExisting('ERRORMESSAGES', e.status ? e.status.toString() : e.message, { url: ds.url }), {
                        disableLocalization: true,
                        serviceCalledFrom: 'HsCompositionsStatusManagerMickaJointService',
                    });
            }
            return of(e);
        }));
        return Observable;
    }
    getInfo(composition) {
        return __awaiter(this, void 0, void 0, function* () {
            const compLinks = composition.link || composition.links;
            if (compLinks === undefined) {
                return;
            }
            const compUrls = this.getCompositionUrls(compLinks);
            let info = {};
            let url = '';
            Array.isArray(compUrls) ? (url = compUrls[0]) : (url = compUrls);
            try {
                info = yield this.HsCompositionsParserService.loadInfo(url);
                //TODO: find out if this is even available
                // info.thumbnail = this.HsUtilsService.proxify(composition.thumbnail);
                info.metadata = {
                    record_url: composition.endpoint.url.replace('csw', 'record/basic/') +
                        composition.id,
                };
                return info;
            }
            catch (e) {
                this.HsToastService.createToastPopupMessage(this.HsLanguageService.getTranslation('COMPOSITIONS.errorWhileLoadingCompositionMetadata'), this.HsLanguageService.getTranslationIgnoreNonExisting('ERRORMESSAGES', e.status ? e.status.toString() : e.message, { url: url }), {
                    disableLocalization: true,
                    serviceCalledFrom: 'HsCompositionsStatusManagerMickaJointService',
                });
            }
        });
    }
    delete(endpoint, composition) {
        this.HsCompositionsStatusManagerService.delete(endpoint, composition);
    }
    getCompositionUrls(compData) {
        if (typeof compData == 'string') {
            return compData;
        }
        if (typeof compData == 'object' && compData.url !== undefined) {
            return compData.url;
        }
        return compData.map((link) => typeof link == 'object' && link.url !== undefined ? link.url : link);
    }
}
HsCompositionsStatusManagerMickaJointService.ɵfac = function HsCompositionsStatusManagerMickaJointService_Factory(t) { return new (t || HsCompositionsStatusManagerMickaJointService)(ɵngcc0.ɵɵinject(HsCompositionsStatusManagerService), ɵngcc0.ɵɵinject(HsCompositionsMickaService), ɵngcc0.ɵɵinject(HsCompositionsMapService), ɵngcc0.ɵɵinject(HsCompositionsParserService), ɵngcc0.ɵɵinject(HsUtilsService), ɵngcc0.ɵɵinject(HsToastService), ɵngcc0.ɵɵinject(HsLanguageService)); };
HsCompositionsStatusManagerMickaJointService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HsCompositionsStatusManagerMickaJointService_Factory() { return new HsCompositionsStatusManagerMickaJointService(i0.ɵɵinject(HsCompositionsStatusManagerService), i0.ɵɵinject(HsCompositionsMickaService), i0.ɵɵinject(HsCompositionsMapService), i0.ɵɵinject(HsCompositionsParserService), i0.ɵɵinject(HsUtilsService), i0.ɵɵinject(HsToastService), i0.ɵɵinject(HsLanguageService)); }, token: HsCompositionsStatusManagerMickaJointService, providedIn: "root" });
HsCompositionsStatusManagerMickaJointService.ctorParameters = () => [
    { type: HsCompositionsStatusManagerService },
    { type: HsCompositionsMickaService },
    { type: HsCompositionsMapService },
    { type: HsCompositionsParserService },
    { type: HsUtilsService },
    { type: HsToastService },
    { type: HsLanguageService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsCompositionsStatusManagerMickaJointService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: HsCompositionsStatusManagerService }, { type: HsCompositionsMickaService }, { type: HsCompositionsMapService }, { type: HsCompositionsParserService }, { type: HsUtilsService }, { type: HsToastService }, { type: HsLanguageService }]; }, null); })();

class HsCompositionsService {
    constructor(http, HsMapService, HsCore, HsCompositionsParserService, HsConfig, HsPermalinkUrlService, HsUtilsService, HsStatusManagerService, HsCompositionsMickaService, HsCompositionsStatusManagerMickaJointService, HsCompositionsLaymanService, HsLanguageService, $log, HsCommonEndpointsService, HsCompositionsMapService, HsEventBusService) {
        this.http = http;
        this.HsMapService = HsMapService;
        this.HsCore = HsCore;
        this.HsCompositionsParserService = HsCompositionsParserService;
        this.HsConfig = HsConfig;
        this.HsPermalinkUrlService = HsPermalinkUrlService;
        this.HsUtilsService = HsUtilsService;
        this.HsStatusManagerService = HsStatusManagerService;
        this.HsCompositionsMickaService = HsCompositionsMickaService;
        this.HsCompositionsStatusManagerMickaJointService = HsCompositionsStatusManagerMickaJointService;
        this.HsCompositionsLaymanService = HsCompositionsLaymanService;
        this.HsLanguageService = HsLanguageService;
        this.$log = $log;
        this.HsCommonEndpointsService = HsCommonEndpointsService;
        this.HsCompositionsMapService = HsCompositionsMapService;
        this.HsEventBusService = HsEventBusService;
        this.data = {};
        this.notSavedCompositionLoading = new Subject();
        this.compositionNotFoundAtUrl = new Subject();
        if (HsConfig.saveMapStateOnReload) {
            //Load composition data from cookies only if it is anticipated
            setTimeout(() => {
                this.tryParseCompositionFromCookie();
            }, 500);
        }
        this.tryParseCompositionFromUrlParam();
        this.parsePermalinkLayers();
        this.HsEventBusService.mapResets.subscribe(() => {
            this.HsCompositionsParserService.composition_loaded = null;
            this.HsCompositionsParserService.composition_edited = false;
        });
        this.HsEventBusService.compositionEdits.subscribe(() => {
            this.HsCompositionsParserService.composition_edited = true;
        });
        this.HsEventBusService.compositionLoadStarts.subscribe((id) => {
            id = `${this.HsStatusManagerService.endpointUrl()}?request=load&id=${id}`;
            this.HsCompositionsParserService.loadUrl(id);
        });
        this.HsEventBusService.vectorQueryFeatureSelection.subscribe((e) => {
            const record = this.HsCompositionsMapService.getFeatureRecordAndUnhighlight(e.feature, e.selector);
            if (record) {
                this.loadComposition(this.getRecordLink(record));
            }
        });
    }
    loadCompositions(ds, params) {
        this.HsCompositionsMapService.clearExtentLayer();
        const bbox = this.HsMapService.getMapExtentInEpsg4326();
        const Observable = this.managerByType(ds).loadList(ds, params, (feature) => this.HsCompositionsMapService.addExtentFeature(feature), bbox);
        return Observable;
    }
    resetCompositionCounter() {
        this.HsCommonEndpointsService.endpoints.forEach((ep) => {
            switch (ep.type) {
                case 'micka':
                    return this.HsCompositionsMickaService.resetCompositionCounter(ep);
                case 'layman':
                    return this.HsCompositionsLaymanService.resetCompositionCounter(ep);
                default:
                    this.$log.warn(`Endpoint type '${ep.type} not supported`);
            }
        });
    }
    managerByType(endpoint) {
        switch (endpoint.type) {
            case 'micka':
                return this.HsCompositionsStatusManagerMickaJointService;
            case 'layman':
                return this.HsCompositionsLaymanService;
            default:
                this.$log.warn(`Endpoint type '${endpoint.type} not supported`);
        }
    }
    deleteComposition(composition) {
        var _a;
        const endpoint = composition.endpoint;
        (_a = this.managerByType(endpoint)) === null || _a === void 0 ? void 0 : _a.delete(endpoint, composition);
    }
    shareComposition(record) {
        return __awaiter(this, void 0, void 0, function* () {
            const recordLink = encodeURIComponent(this.getRecordLink(record));
            const permalinkOverride = this.HsConfig.permalinkLocation;
            const compositionUrl = this.HsCore.isMobile() && permalinkOverride
                ? permalinkOverride.origin + permalinkOverride.pathname
                : `${location.origin}${location.pathname}?composition=${recordLink}`;
            this.shareId = this.HsUtilsService.generateUuid();
            const headers = new HttpHeaders().set('Content-Type', 'text/plain; charset=utf-8');
            return yield this.http
                .post(this.HsStatusManagerService.endpointUrl(), JSON.stringify({
                request: 'socialShare',
                id: this.shareId,
                url: encodeURIComponent(compositionUrl),
                title: record.title,
                description: record.abstract,
                image: record.thumbnail || 'https://ng.hslayers.org/img/logo.png',
            }), { headers, responseType: 'text' })
                .toPromise();
        });
    }
    getShareUrl() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return yield this.HsUtilsService.shortUrl(this.HsStatusManagerService.endpointUrl() +
                    '?request=socialshare&id=' +
                    this.shareId);
            }
            catch (ex) {
                this.$log.log('Error creating short Url');
            }
        });
    }
    getCompositionInfo(composition) {
        return __awaiter(this, void 0, void 0, function* () {
            const info = yield this.managerByType(composition.endpoint).getInfo(composition);
            this.data.info = info;
            return info;
        });
    }
    getRecordLink(record) {
        var _a;
        try {
            let url;
            if (record.link !== undefined) {
                url = record.link;
            }
            else if (record.links !== undefined) {
                url = record.links.filter((l) => l.url.includes('/file') || l.url.endsWith('.wmc'))[0].url;
            }
            if (((_a = record === null || record === void 0 ? void 0 : record.endpoint) === null || _a === void 0 ? void 0 : _a.type) == 'layman') {
                url = record.url + '/file' + '?timestamp=' + Date.now();
            }
            return url;
        }
        catch (e) {
            this.$log.warn(e);
        }
    }
    loadCompositionParser(record) {
        return new Promise((resolve, reject) => {
            let url;
            switch (record.endpoint.type) {
                case 'micka':
                    url = this.getRecordLink(record);
                    break;
                case 'layman':
                    url = record.url + '/file';
                    break;
                default:
                    this.$log.warn(`Endpoint type '${record.endpoint.type} not supported`);
                    reject();
                    return;
            }
            if (url) {
                //Provide save-map comoData workspace property and distinguish between editable and non-editable compositions
                this.HsCompositionsParserService.current_composition_workspace =
                    record.editable ? record.workspace : null;
                if (this.HsCompositionsParserService.composition_edited == true) {
                    this.notSavedCompositionLoading.next(url);
                    reject();
                }
                else {
                    this.loadComposition(url, true).then(() => {
                        resolve();
                    });
                }
            }
        });
    }
    /**
     * Load layers received through permalink to map
     */
    parsePermalinkLayers() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.HsMapService.loaded();
            const permalink = this.HsPermalinkUrlService.getParamValue(HS_PRMS.permalink);
            if (!permalink) {
                return;
            }
            const layersUrl = this.HsUtilsService.proxify(permalink);
            const response = yield this.http.get(layersUrl).toPromise();
            if (response.success == true) {
                const data = {};
                data.data = {};
                if (response.data.layers) {
                    data.data.layers = response.data.layers;
                }
                else {
                    //Some old structure, where layers are stored in data
                    data.data.layers = response.data;
                }
                this.HsCompositionsParserService.removeCompositionLayers();
                const layers = yield this.HsCompositionsParserService.jsonToLayers(data);
                for (let i = 0; i < layers.length; i++) {
                    this.HsMapService.addLayer(layers[i], DuplicateHandling.RemoveOriginal);
                }
            }
            else {
                this.$log.log('Error loading permalink layers');
            }
        });
    }
    loadComposition(url, overwrite) {
        return this.HsCompositionsParserService.loadUrl(url, overwrite);
    }
    tryParseCompositionFromCookie() {
        return __awaiter(this, void 0, void 0, function* () {
            if (localStorage.getItem('hs_layers') &&
                window.permalinkApp != true) {
                yield this.HsMapService.loaded();
                const data = localStorage.getItem('hs_layers');
                if (!data) {
                    return;
                }
                const parsed = JSON.parse(data);
                if (parsed.expires && parsed.expires < new Date().getTime()) {
                    return;
                }
                const layers = yield this.HsCompositionsParserService.jsonToLayers(parsed);
                for (let i = 0; i < layers.length; i++) {
                    this.HsMapService.addLayer(layers[i], DuplicateHandling.IgnoreNew);
                }
                localStorage.removeItem('hs_layers');
            }
        });
    }
    tryParseCompositionFromUrlParam() {
        return __awaiter(this, void 0, void 0, function* () {
            let id = this.HsPermalinkUrlService.getParamValue(HS_PRMS.composition);
            if (id) {
                if (!id.includes('http') &&
                    !id.includes(this.HsConfig.status_manager_url)) {
                    id =
                        this.HsStatusManagerService.endpointUrl() + '?request=load&id=' + id;
                }
                try {
                    yield this.HsCompositionsParserService.loadUrl(id);
                }
                catch (e) {
                    this.compositionNotFoundAtUrl.next(e);
                    this.$log.warn(e);
                }
            }
        });
    }
    commonId(composition) {
        if (composition === undefined) {
            return '';
        }
        return composition.uuid || composition.id;
    }
    translateString(module, text) {
        return this.HsLanguageService.getTranslationIgnoreNonExisting(module, text);
    }
}
HsCompositionsService.ɵfac = function HsCompositionsService_Factory(t) { return new (t || HsCompositionsService)(ɵngcc0.ɵɵinject(ɵngcc2.HttpClient), ɵngcc0.ɵɵinject(HsMapService), ɵngcc0.ɵɵinject(HsCoreService), ɵngcc0.ɵɵinject(HsCompositionsParserService), ɵngcc0.ɵɵinject(HsConfig), ɵngcc0.ɵɵinject(HsShareUrlService), ɵngcc0.ɵɵinject(HsUtilsService), ɵngcc0.ɵɵinject(HsStatusManagerService), ɵngcc0.ɵɵinject(HsCompositionsMickaService), ɵngcc0.ɵɵinject(HsCompositionsStatusManagerMickaJointService), ɵngcc0.ɵɵinject(HsCompositionsLaymanService), ɵngcc0.ɵɵinject(HsLanguageService), ɵngcc0.ɵɵinject(HsLogService), ɵngcc0.ɵɵinject(HsCommonEndpointsService), ɵngcc0.ɵɵinject(HsCompositionsMapService), ɵngcc0.ɵɵinject(HsEventBusService)); };
HsCompositionsService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HsCompositionsService_Factory() { return new HsCompositionsService(i0.ɵɵinject(i1$1.HttpClient), i0.ɵɵinject(HsMapService), i0.ɵɵinject(HsCoreService), i0.ɵɵinject(HsCompositionsParserService), i0.ɵɵinject(HsConfig), i0.ɵɵinject(HsShareUrlService), i0.ɵɵinject(HsUtilsService), i0.ɵɵinject(HsStatusManagerService), i0.ɵɵinject(HsCompositionsMickaService), i0.ɵɵinject(HsCompositionsStatusManagerMickaJointService), i0.ɵɵinject(HsCompositionsLaymanService), i0.ɵɵinject(HsLanguageService), i0.ɵɵinject(HsLogService), i0.ɵɵinject(HsCommonEndpointsService), i0.ɵɵinject(HsCompositionsMapService), i0.ɵɵinject(HsEventBusService)); }, token: HsCompositionsService, providedIn: "root" });
HsCompositionsService.ctorParameters = () => [
    { type: HttpClient },
    { type: HsMapService },
    { type: HsCoreService },
    { type: HsCompositionsParserService },
    { type: HsConfig },
    { type: HsShareUrlService },
    { type: HsUtilsService },
    { type: HsStatusManagerService },
    { type: HsCompositionsMickaService },
    { type: HsCompositionsStatusManagerMickaJointService },
    { type: HsCompositionsLaymanService },
    { type: HsLanguageService },
    { type: HsLogService },
    { type: HsCommonEndpointsService },
    { type: HsCompositionsMapService },
    { type: HsEventBusService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsCompositionsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc2.HttpClient }, { type: HsMapService }, { type: HsCoreService }, { type: HsCompositionsParserService }, { type: HsConfig }, { type: HsShareUrlService }, { type: HsUtilsService }, { type: HsStatusManagerService }, { type: HsCompositionsMickaService }, { type: HsCompositionsStatusManagerMickaJointService }, { type: HsCompositionsLaymanService }, { type: HsLanguageService }, { type: HsLogService }, { type: HsCommonEndpointsService }, { type: HsCompositionsMapService }, { type: HsEventBusService }]; }, null); })();

class HsCompositionsInfoDialogComponent {
    constructor(HsDialogContainerService, HsCompositionsService) {
        this.HsDialogContainerService = HsDialogContainerService;
        this.HsCompositionsService = HsCompositionsService;
    }
    close() {
        console.log(this.data);
        this.HsDialogContainerService.destroy(this);
    }
}
HsCompositionsInfoDialogComponent.ɵfac = function HsCompositionsInfoDialogComponent_Factory(t) { return new (t || HsCompositionsInfoDialogComponent)(ɵngcc0.ɵɵdirectiveInject(HsDialogContainerService), ɵngcc0.ɵɵdirectiveInject(HsCompositionsService)); };
HsCompositionsInfoDialogComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsCompositionsInfoDialogComponent, selectors: [["hs-compositions-info-dialog"]], decls: 37, vars: 24, consts: [["tabindex", "-1", "role", "dialog", "aria-hidden", "true", 1, "modal", "in", "hs-composition-info-dialog"], [1, "modal-dialog"], [1, "modal-content"], [1, "modal-header"], [1, "modal-title"], ["type", "button", "data-dismiss", "modal", 1, "close", 3, "click"], ["aria-hidden", "true"], [1, "sr-only"], [1, "modal-body", 2, "max-height", "600px", "overflow-y", "auto"], [1, "row", 2, "text-align", "justify", "text-justify", "inter-word"], [1, "col-md-3"], [1, "col-md-9"], [4, "ngIf"], ["class", "row", 4, "ngIf"], [1, "modal-footer"], ["data-dismiss", "modal", 1, "btn", "btn-secondary", 3, "click"], [4, "ngFor", "ngForOf"], [1, "row"], [1, "col-md-offset-3", "col-md-9"], [3, "src"], [1, "col-md-9", 2, "word-break", "break-all"], [1, "offset-md-3", "col-md-9"], [1, "col"], [1, "col-md-4"], [1, "col-md-8"], [1, "col-md-4", 2, "word-break", "break-all"], ["target", "_blank", 1, "btn", "btn-primary", 3, "href", "click"], [1, "icon", "icon-opennewwindow"]], template: function HsCompositionsInfoDialogComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelementStart(4, "h4", 4);
        ɵngcc0.ɵɵtext(5);
        ɵngcc0.ɵɵelementStart(6, "span");
        ɵngcc0.ɵɵtext(7);
        ɵngcc0.ɵɵpipe(8, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "button", 5);
        ɵngcc0.ɵɵlistener("click", function HsCompositionsInfoDialogComponent_Template_button_click_9_listener() { return ctx.close(); });
        ɵngcc0.ɵɵelementStart(10, "span", 6);
        ɵngcc0.ɵɵtext(11, "\u00D7");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "span", 7);
        ɵngcc0.ɵɵtext(13);
        ɵngcc0.ɵɵpipe(14, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(15, "div", 8);
        ɵngcc0.ɵɵelementStart(16, "div", 9);
        ɵngcc0.ɵɵelementStart(17, "div", 10);
        ɵngcc0.ɵɵelementStart(18, "b");
        ɵngcc0.ɵɵtext(19);
        ɵngcc0.ɵɵpipe(20, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(21, "div", 11);
        ɵngcc0.ɵɵtext(22);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(23, HsCompositionsInfoDialogComponent_div_23_Template, 3, 1, "div", 12);
        ɵngcc0.ɵɵtemplate(24, HsCompositionsInfoDialogComponent_div_24_Template, 7, 4, "div", 13);
        ɵngcc0.ɵɵtemplate(25, HsCompositionsInfoDialogComponent_div_25_Template, 7, 4, "div", 13);
        ɵngcc0.ɵɵtemplate(26, HsCompositionsInfoDialogComponent_div_26_Template, 7, 4, "div", 13);
        ɵngcc0.ɵɵtemplate(27, HsCompositionsInfoDialogComponent_div_27_Template, 7, 4, "div", 13);
        ɵngcc0.ɵɵtemplate(28, HsCompositionsInfoDialogComponent_div_28_Template, 3, 1, "div", 12);
        ɵngcc0.ɵɵtemplate(29, HsCompositionsInfoDialogComponent_div_29_Template, 5, 3, "div", 13);
        ɵngcc0.ɵɵtemplate(30, HsCompositionsInfoDialogComponent_div_30_Template, 3, 3, "div", 12);
        ɵngcc0.ɵɵtemplate(31, HsCompositionsInfoDialogComponent_div_31_Template, 3, 3, "div", 12);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(32, "div", 14);
        ɵngcc0.ɵɵtemplate(33, HsCompositionsInfoDialogComponent_ng_container_33_Template, 4, 1, "ng-container", 12);
        ɵngcc0.ɵɵelementStart(34, "button", 15);
        ɵngcc0.ɵɵlistener("click", function HsCompositionsInfoDialogComponent_Template_button_click_34_listener() { return ctx.close(); });
        ɵngcc0.ɵɵtext(35);
        ɵngcc0.ɵɵpipe(36, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.data.info.title, " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(8, 16, "COMPOSITIONS.dialogInfo.details"));
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(14, 18, "COMMON.close"));
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(20, 20, "COMMON.abstract"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.data.info.abstract);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.data.info.keywords);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.data.info.thumbnail);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.data.info.url && ctx.data.info);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.data.info.srs);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.data.info.extent);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.data.info.layers);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.data.info.contactAddress || ctx.data.info.contactPersonPrimary);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.data.info.contactAddress);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.data.info.contactPersonPrimary);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.data.info == null ? null : ctx.data.info.metadata == null ? null : ctx.data.info.metadata.record_url);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(36, 22, "COMMON.close"));
    } }, directives: [ɵngcc3.NgIf, ɵngcc3.NgForOf], pipes: [ɵngcc1.TranslatePipe, ɵngcc3.KeyValuePipe], encapsulation: 2 });
HsCompositionsInfoDialogComponent.ctorParameters = () => [
    { type: HsDialogContainerService },
    { type: HsCompositionsService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsCompositionsInfoDialogComponent, [{
        type: Component,
        args: [{
                selector: 'hs-compositions-info-dialog',
                template: "<div class=\"modal in hs-composition-info-dialog\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <h4 class=\"modal-title\">\n                    {{data.info.title}} <span>{{'COMPOSITIONS.dialogInfo.details' | translate}}</span>\n                </h4>\n                <button type=\"button\" (click)=\"close()\" class=\"close\" data-dismiss=\"modal\"><span\n                        aria-hidden=\"true\">&times;</span><span class=\"sr-only\">{{'COMMON.close' |\n                        translate}}</span></button>\n            </div>\n            <div class=\"modal-body\" style=\"max-height: 600px; overflow-y: auto\">\n                <div class=\"row\" style=\"text-align: justify; text-justify: inter-word;\">\n                    <div class=\"col-md-3\"><b>{{'COMMON.abstract' | translate}}</b></div>\n                    <div class=\"col-md-9\">{{data.info.abstract}}</div>\n                </div>\n                <div *ngIf=\"data.info.keywords\">\n                    <div *ngFor=\"let keyword of data.info.keywords;let first = first;\">\n                        <div class=\"row\" *ngIf=\"first\">\n                            <div class=\"col-md-3\"><b>{{'COMMON.keywords' | translate}}</b></div>\n                            <div class=\"col-md-9\">{{keyword}}</div>\n                        </div>\n                        <div class=\"row\" *ngIf=\"!first\">\n                            <div class=\"col-md-offset-3 col-md-9\">{{keyword}}</div>\n                        </div>\n                    </div>\n                    <br>\n                </div>\n                <div class=\"row\" *ngIf=\"data.info.thumbnail\">\n                    <div class=\"col-md-3\"><b>{{'COMMON.thumbnail' | translate}}</b></div>\n                    <div class=\"col-md-9\"><img\n                            src=\"{{data.info.thumbnail.url ? data.info.thumbnail.url : data.info.thumbnail}}\"></div>\n                </div>\n                <div class=\"row\" *ngIf=\"data.info.url && data.info\">\n                    <div class=\"col-md-3\"><b>{{'COMMON.url' | translate}}</b></div>\n                    <div class=\"col-md-9\">{{data.info.url}}</div>\n                </div>\n                <div class=\"row\" *ngIf=\"data.info.srs\">\n                    <div class=\"col-md-3\"><b>{{'ADDLAYERS.srs' | translate}}</b></div>\n                    <div class=\"col-md-9\">{{data.info.srs}}</div>\n                </div>\n                <div class=\"row\" *ngIf=\"data.info.extent\">\n                    <div class=\"col-md-3\"><b>{{'COMMON.extent' | translate}}</b></div>\n                    <div class=\"col-md-9\" style=\"word-break:break-all\">{{data.info.extent}}</div>\n                </div>\n                <div *ngIf=\"data.info.layers\">\n                    <div *ngFor=\"let layer of data.info.layers;let first = first;\">\n                        <div class=\"row\" *ngIf=\"first\">\n                            <div class=\"col-md-3\"><b>{{'COMMON.layers' | translate}}</b></div>\n                            <div class=\"col-md-9\">{{layer.title}}</div>\n                        </div>\n                        <div class=\"row\" *ngIf=\"!first\">\n                            <div class=\"offset-md-3 col-md-9\">{{layer.title}}</div>\n                        </div>\n                    </div>\n                    <br>\n                </div>\n                <!-- <div *ngIf=\"data.info.metadata\">\n                    <div class=\"row\">\n                         <div class=\"col\"><b>{{'COMPOSITIONS.dialogInfo.metadataAboutMetadata' | translate}}</b></div>\n                    </div>\n                     <div *ngFor=\"let metadata of data.info.metadata | keyvalue\">\n                         <div class=\"row\" *ngIf=\"metadata.value\">\n                            <div class=\"col-md-3\"><b>{{HsCompositionsService.translateString('COMPOSITIONS.dialogInfo.metadata', metadata.key)}}</b></div>\n                            <div class=\"col-md-9\" style=\"overflow-wrap: break-word\">{{metadata.value}}</div>\n                         </div>\n                     </div>\n                </div> -->\n                <div class=\"row\" *ngIf=\"data.info.contactAddress || data.info.contactPersonPrimary\">\n                    <div class=\"col\"><b>{{'COMMON.contactInformation' | translate}}</b></div>\n                </div>\n                <div *ngIf=\"data.info.contactAddress\">\n                    <div *ngFor=\"let data of data.info.contactAddress | keyvalue\">\n                        <div class=\"row\" *ngIf=\"data.value\">\n                            <div class=\"col-md-4\"><b>{{HsCompositionsService.translateString('SAVECOMPOSITION.form',\n                                    data.key)}}</b></div>\n                            <div class=\"col-md-8\">{{data.value}}</div>\n                        </div>\n                    </div>\n                </div>\n                <div *ngIf=\"data.info.contactPersonPrimary\">\n                    <div *ngFor=\"let data of data.info.contactPersonPrimary | keyvalue\">\n                        <div class=\"row\" *ngIf=\"data.value\">\n                            <div class=\"col-md-4\" style=\"word-break:break-all\">\n                                <b>{{HsCompositionsService.translateString('SAVECOMPOSITION.form', data.key)}}</b>\n                            </div>\n                            <div class=\"col-md-8\">{{data.value}}</div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class=\"modal-footer\">\n                <ng-container *ngIf=\"data.info?.metadata?.record_url\">\n                    <a target=\"_blank\" [href]=\"data.info.metadata.record_url\" class=\"btn btn-primary\"\n                        (click)=\"close()\">See\n                        full metadata record <i class=\"icon icon-opennewwindow\"></i></a>\n                </ng-container>\n                <button class=\"btn btn-secondary\" (click)=\"close()\" data-dismiss=\"modal\">{{'COMMON.close' |\n                    translate}}</button>\n            </div>\n        </div>\n    </div>\n</div>"
            }]
    }], function () { return [{ type: HsDialogContainerService }, { type: HsCompositionsService }]; }, null); })();

const KEYWORDS = [
    { name: 'Basemap', value: 'Basemap', selected: false },
    { name: 'Borders', value: 'Borders', selected: false },
    { name: 'Physical geography', value: 'Physical geography', selected: false },
    { name: 'Demographics', value: 'Demographics', selected: false },
    { name: 'Economics', value: 'Economics', selected: false },
    {
        name: 'Socio political conditions',
        value: 'Socio political conditions',
        selected: false,
    },
    { name: 'Culture', value: 'Culture', selected: false },
    { name: 'Transport', value: 'Transport', selected: false },
    { name: 'Land use', value: 'Land use', selected: false },
    { name: 'Environment', value: 'Environment', selected: false },
    { name: 'Water', value: 'Water', selected: false },
    { name: 'Hazards', value: 'Hazards', selected: false },
    { name: 'Cadastre', value: 'Cadastre', selected: false },
    { name: 'Infrastructure', value: 'Infrastructure', selected: false },
    { name: 'Real estate', value: 'Real estate', selected: false },
    { name: 'Planning', value: 'Planning', selected: false },
    { name: 'Complex information', value: 'Complex information', selected: false },
];
const INSPIRETHEMES = [
    {
        name: 'Addresses',
        value: 'http://inspire.ec.europa.eu/theme/ad',
        selected: false,
    },
    {
        name: 'Administrative units',
        value: 'http://inspire.ec.europa.eu/theme/au',
        selected: false,
    },
    {
        name: 'Coordinate reference systems',
        value: 'http://inspire.ec.europa.eu/theme/rs',
        selected: false,
    },
    {
        name: 'Geographical grid systems',
        value: 'http://inspire.ec.europa.eu/theme/gg',
        selected: false,
    },
    {
        name: 'Cadastral parcels',
        value: 'http://inspire.ec.europa.eu/theme/cp',
        selected: false,
    },
    {
        name: 'Geographical names',
        value: 'http://inspire.ec.europa.eu/theme/gn',
        selected: false,
    },
    {
        name: 'Hydrography',
        value: 'http://inspire.ec.europa.eu/theme/hy',
        selected: false,
    },
    {
        name: 'Protected sites',
        value: 'http://inspire.ec.europa.eu/theme/ps',
        selected: false,
    },
    {
        name: 'Transport networks',
        value: 'http://inspire.ec.europa.eu/theme/tn',
        selected: false,
    },
    {
        name: 'Elevation',
        value: 'http://inspire.ec.europa.eu/theme/el',
        selected: false,
    },
    {
        name: 'Geology',
        value: 'http://inspire.ec.europa.eu/theme/ge',
        selected: false,
    },
    {
        name: 'Land cover',
        value: 'http://inspire.ec.europa.eu/theme/lc',
        selected: false,
    },
    {
        name: 'Orthoimagery',
        value: 'http://inspire.ec.europa.eu/theme/oi',
        selected: false,
    },
    {
        name: 'Agricultural and aquaculture facilities',
        value: 'http://inspire.ec.europa.eu/theme/af',
        selected: false,
    },
    {
        name: 'Area management/restriction/regulation zones and reporting units',
        value: 'http://inspire.ec.europa.eu/theme/am',
        selected: false,
    },
    {
        name: 'Atmospheric conditions',
        value: 'http://inspire.ec.europa.eu/theme/ac',
        selected: false,
    },
    {
        name: 'Bio-geographical regions',
        value: 'http://inspire.ec.europa.eu/theme/br',
        selected: false,
    },
    {
        name: 'Buildings',
        value: 'http://inspire.ec.europa.eu/theme/bu',
        selected: false,
    },
    {
        name: 'Energy resources',
        value: 'http://inspire.ec.europa.eu/theme/er',
        selected: false,
    },
    {
        name: 'Environmental monitoring facilities',
        value: 'http://inspire.ec.europa.eu/theme/ef',
        selected: false,
    },
    {
        name: 'Habitants and biotopes',
        value: 'http://inspire.ec.europa.eu/theme/hb',
        selected: false,
    },
    {
        name: 'Human health and safety',
        value: 'http://inspire.ec.europa.eu/theme/hh',
        selected: false,
    },
    {
        name: 'Land use',
        value: 'http://inspire.ec.europa.eu/theme/lu',
        selected: false,
    },
    {
        name: 'Mineral resources',
        value: 'http://inspire.ec.europa.eu/theme/mr',
        selected: false,
    },
    {
        name: 'Natural risk zones',
        value: 'http://inspire.ec.europa.eu/theme/nz',
        selected: false,
    },
    {
        name: 'Oceanographic geographical features',
        value: 'http://inspire.ec.europa.eu/theme/of',
        selected: false,
    },
    {
        name: 'Population distribution - demography',
        value: 'http://inspire.ec.europa.eu/theme/pd',
        selected: false,
    },
    {
        name: 'Production and industrial facilities',
        value: 'http://inspire.ec.europa.eu/theme/pf',
        selected: false,
    },
    {
        name: 'Sea regions',
        value: 'http://inspire.ec.europa.eu/theme/sr',
        selected: false,
    },
    {
        name: 'Soil',
        value: 'http://inspire.ec.europa.eu/theme/so',
        selected: false,
    },
    {
        name: 'Species distribution',
        value: 'http://inspire.ec.europa.eu/theme/sd',
        selected: false,
    },
    {
        name: 'Statistical units',
        value: 'http://inspire.ec.europa.eu/theme/su',
        selected: false,
    },
    {
        name: 'Utility and governmental services',
        value: 'http://inspire.ec.europa.eu/theme/us',
        selected: false,
    },
    {
        name: 'Meteorological geographical features',
        value: 'http://inspire.ec.europa.eu/theme/mf',
        selected: false,
    },
    {
        name: 'Atmospheric Conditions and meteorological geographical features',
        value: 'http://inspire.ec.europa.eu/theme/ac-mf',
        selected: false,
    },
];
const SORTBYVALUES = [
    { name: 'None', value: 'None' },
    { name: 'Title', value: 'title' },
    { name: 'Date', value: 'date:D' },
    { name: 'Bbox', value: 'bbox' },
];
const TYPES = [
    { name: 'None', value: 'None' },
    { name: 'Datasource', value: 'datasource' },
    { name: 'Service', value: 'service' },
    { name: 'Application', value: 'application' },
    { name: 'Feature catalogue', value: 'feature catalogue' },
];

class HsCompositionsCatalogueService {
    constructor(hsMapService, hsCompositionsService, hsLayoutService, hsCommonEndpointsService, hsUtilsService, hsEventBusService, hsDialogContainerService, hsLaymanService, hsCommonLaymanService, _zone) {
        this.hsMapService = hsMapService;
        this.hsCompositionsService = hsCompositionsService;
        this.hsLayoutService = hsLayoutService;
        this.hsCommonEndpointsService = hsCommonEndpointsService;
        this.hsUtilsService = hsUtilsService;
        this.hsEventBusService = hsEventBusService;
        this.hsDialogContainerService = hsDialogContainerService;
        this.hsLaymanService = hsLaymanService;
        this.hsCommonLaymanService = hsCommonLaymanService;
        this._zone = _zone;
        this.compositionEntries = [];
        /**
         *List of sort by values (currently hard-coded selection),that will be applied in compositions lookup
         */
        this.sortByValues = SORTBYVALUES;
        /**
         * List of composition type values (currently hard-coded selection),that will be applied in compositions lookup
         */
        this.types = TYPES;
        /**
         * List of composition theme values (currently hard-coded selection),that will be applied in compositions lookup
         */
        this.inspireThemes = INSPIRETHEMES;
        this.data = {
            query: { editable: false, title: '' },
            keywords: KEYWORDS,
            sortBy: SORTBYVALUES[0],
            type: TYPES[0].name,
            themes: INSPIRETHEMES,
        };
        this.recordsPerPage = 20;
        this.matchedRecords = 0;
        this.listStart = 0;
        this.listNext = this.recordsPerPage;
        /**
         * Store whether filter compositions by current window extent during composition search
         */
        this.filterByExtent = true;
        this.filterByOnlyMine = false;
        this.extentChangeSuppressed = false;
        this.filteredEndpoints = this.getFilteredEndpointsForCompositions();
        this.hsCommonEndpointsService.endpointsFilled.subscribe(() => (this.filteredEndpoints = this.getFilteredEndpointsForCompositions()));
        hsEventBusService.mainPanelChanges.subscribe(() => {
            if (this.hsLayoutService.mainpanel === 'composition_browser' ||
                this.hsLayoutService.mainpanel === 'composition') {
                this.loadFilteredCompositions();
                this.extentChangeSuppressed = true;
            }
        });
        const extentChangeDebouncer = {};
        this.hsEventBusService.mapExtentChanges.subscribe(hsUtilsService.debounce(() => {
            if ((this.hsLayoutService.mainpanel != 'composition_browser' &&
                this.hsLayoutService.mainpanel != 'composition') ||
                this.extentChangeSuppressed) {
                this.extentChangeSuppressed = false;
                return;
            }
            if (this.filterByExtent) {
                this._zone.run(() => {
                    this.loadFilteredCompositions();
                });
            }
        }, 400, false, extentChangeDebouncer));
        this.hsEventBusService.compositionDeletes.subscribe((composition) => {
            //TODO: rewrite
            const deleteDialog = this.hsLayoutService.contentWrapper.querySelector('.hs-composition-delete-dialog');
            if (deleteDialog) {
                deleteDialog.parentNode.remove(deleteDialog);
            }
            this._zone.run(() => {
                this.loadFilteredCompositions();
            });
        });
        this.hsCompositionsService.compositionNotFoundAtUrl.subscribe((error) => {
            this.hsDialogContainerService.create(HsCompositionsInfoDialogComponent, {
                info: {
                    title: 'Composition not found',
                    abstract: error.message,
                },
            });
        });
        this.hsCommonLaymanService.authChange.subscribe(() => {
            if (this.hsLayoutService.mainpanel != 'composition_browser' &&
                this.hsLayoutService.mainpanel != 'composition') {
                return;
            }
            this.loadFilteredCompositions();
        });
    }
    /**
     * Load list of compositions for all endpoints
     * @param createRequestLimits If true, create request limits for endpoints
     * @param suspendLimitCalculation
     */
    loadCompositions(suspendLimitCalculation) {
        if (this.loadCompositionsQuery) {
            this.loadCompositionsQuery.unsubscribe();
            delete this.loadCompositionsQuery;
        }
        this.clearLoadedData();
        this.dataLoading = true;
        this.hsMapService.loaded().then(() => {
            const observables = [];
            for (const endpoint of this.filteredEndpoints) {
                observables.push(this.loadCompositionFromEndpoint(endpoint));
            }
            this.loadCompositionsQuery = forkJoin(observables).subscribe(() => {
                suspendLimitCalculation
                    ? this.createCompositionList()
                    : this.calculateEndpointLimits();
            });
        });
    }
    /**
     * Calculates each endpoint composition request limit, based on the matched compositions ratio
     * from all endpoint matched compositions
     */
    calculateEndpointLimits() {
        this.matchedRecords = 0;
        this.recordsPerPage = 20;
        this.filteredEndpoints = this.getFilteredEndpointsForCompositions().filter((ep) => ep.compositionsPaging.matched != 0);
        if (this.filteredEndpoints.length == 0) {
            this.dataLoading = false;
            return;
        }
        this.filteredEndpoints.forEach((ep) => (this.matchedRecords += ep.compositionsPaging.matched));
        let sumLimits = 0;
        this.filteredEndpoints.forEach((ep) => {
            ep.compositionsPaging.limit = Math.floor((ep.compositionsPaging.matched / this.matchedRecords) *
                this.recordsPerPage);
            if (ep.compositionsPaging.limit == 0) {
                ep.compositionsPaging.limit = 1;
            }
            sumLimits += ep.compositionsPaging.limit;
        });
        this.recordsPerPage = sumLimits;
        this.loadCompositions(true);
    }
    /**
     * Load list of compositions according to current filter values and pager position
     * (filter, keywords, current extent, start composition, compositions number per page). Display compositions extent in map
     * @param ep
     */
    loadCompositionFromEndpoint(ep) {
        return this.hsCompositionsService.loadCompositions(ep, {
            query: this.data.query,
            sortBy: this.data.sortBy.value,
            filterByExtent: this.filterByExtent,
            keywords: this.data.keywords,
            themes: this.data.themes,
            type: this.data.type,
            start: ep.compositionsPaging.start,
            limit: ep.compositionsPaging.limit,
            filterByOnlyMine: this.filterByOnlyMine,
        });
    }
    /**
     * Clear all loaded data and filter endpoint array (if required) before loading compositions
     */
    loadFilteredCompositions() {
        this.clearListCounters();
        this.filteredEndpoints = this.getFilteredEndpointsForCompositions().filter((ep) => {
            if (this.filterByOnlyMine) {
                return !this.filterByOnlyMine || ep.type == 'layman';
            }
            else {
                return true;
            }
        });
        this.loadCompositions();
    }
    /**
     * Creates list of compositions from all endpoints currently available
     */
    createCompositionList() {
        for (const endpoint of this.filteredEndpoints) {
            this.arrayContainsData(this.compositionEntries)
                ? this.filterDuplicates(endpoint)
                : (this.compositionEntries = this.compositionEntries.concat(endpoint.compositions));
        }
        this.dataLoading = false;
        if (this.matchedRecords < this.recordsPerPage) {
            this.listNext = this.matchedRecords;
        }
    }
    /**
     * @param responseArray Array of compositions data
     *  Filters compositions from responseArray with the same id in already loaded compositionEntries array
     * @param endpoint
     */
    filterDuplicates(endpoint) {
        if (!this.arrayContainsData(endpoint.compositions)) {
            return;
        }
        const filteredCompositions = endpoint.compositions.filter((data) => this.compositionEntries.filter((u) => u.id == data.id).length == 0);
        this.matchedRecords -=
            endpoint.compositions.length - filteredCompositions.length;
        this.compositionEntries =
            this.compositionEntries.concat(filteredCompositions);
    }
    /**
     * Clears all list counters regarding paging
     */
    clearListCounters() {
        this.listStart = 0;
        this.listNext = this.recordsPerPage;
        this.hsCompositionsService.resetCompositionCounter();
    }
    /**
     * Clears all data saved regarding loaded compositions
     */
    clearLoadedData() {
        this.compositionEntries = [];
        this.filteredEndpoints.forEach((ep) => (ep.compositions = []));
    }
    /**
     
     * Evaluates if array is defined and contains any data
     * @param arr
     */
    arrayContainsData(arr) {
        if (arr !== undefined && arr.length > 0) {
            return true;
        }
        else {
            return false;
        }
    }
    /**
     * Load previous list of compositions to display on pager
     */
    getPreviousRecords() {
        if (this.listStart - this.recordsPerPage <= 0) {
            this.listStart = 0;
            this.listNext = this.recordsPerPage;
            this.filteredEndpoints.forEach((ep) => (ep.compositionsPaging.start = 0));
        }
        else {
            this.listStart -= this.recordsPerPage;
            this.listNext = this.listStart + this.recordsPerPage;
            this.filteredEndpoints.forEach((ep) => (ep.compositionsPaging.start -= ep.compositionsPaging.limit));
        }
        this.loadCompositions(true);
    }
    /**
     * Load next list of compositions to display on pager
     */
    getNextRecords() {
        this.listStart += this.recordsPerPage;
        this.listNext += this.recordsPerPage;
        if (this.listNext > this.matchedRecords) {
            this.listNext = this.matchedRecords;
        }
        this.filteredEndpoints.forEach((ep) => (ep.compositionsPaging.start += ep.compositionsPaging.limit));
        this.loadCompositions(true);
    }
    /**
     * Filters statusmanager endpoint out from rest of the endpoints
     */
    getFilteredEndpointsForCompositions() {
        return this.hsCommonEndpointsService.endpoints.filter((ep) => ep.type != 'statusmanager');
    }
    /**
     * Clears all filters set for composition list filtering
     */
    clearFilters() {
        this.data.query.title = '';
        this.data.sortBy = SORTBYVALUES[0];
        this.data.type = TYPES[0].name;
        this.data.keywords.forEach((kw) => (kw.selected = false));
        this.data.themes.forEach((th) => (th.selected = false));
        this.filteredEndpoints.push(this.hsLaymanService.getLaymanEndpoint());
        this.loadFilteredCompositions();
    }
}
HsCompositionsCatalogueService.ɵfac = function HsCompositionsCatalogueService_Factory(t) { return new (t || HsCompositionsCatalogueService)(ɵngcc0.ɵɵinject(HsMapService), ɵngcc0.ɵɵinject(HsCompositionsService), ɵngcc0.ɵɵinject(HsLayoutService), ɵngcc0.ɵɵinject(HsCommonEndpointsService), ɵngcc0.ɵɵinject(HsUtilsService), ɵngcc0.ɵɵinject(HsEventBusService), ɵngcc0.ɵɵinject(HsDialogContainerService), ɵngcc0.ɵɵinject(HsLaymanService), ɵngcc0.ɵɵinject(HsCommonLaymanService), ɵngcc0.ɵɵinject(ɵngcc0.NgZone)); };
HsCompositionsCatalogueService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HsCompositionsCatalogueService_Factory() { return new HsCompositionsCatalogueService(i0.ɵɵinject(HsMapService), i0.ɵɵinject(HsCompositionsService), i0.ɵɵinject(HsLayoutService), i0.ɵɵinject(HsCommonEndpointsService), i0.ɵɵinject(HsUtilsService), i0.ɵɵinject(HsEventBusService), i0.ɵɵinject(HsDialogContainerService), i0.ɵɵinject(HsLaymanService), i0.ɵɵinject(HsCommonLaymanService), i0.ɵɵinject(i0.NgZone)); }, token: HsCompositionsCatalogueService, providedIn: "root" });
HsCompositionsCatalogueService.ctorParameters = () => [
    { type: HsMapService },
    { type: HsCompositionsService },
    { type: HsLayoutService },
    { type: HsCommonEndpointsService },
    { type: HsUtilsService },
    { type: HsEventBusService },
    { type: HsDialogContainerService },
    { type: HsLaymanService },
    { type: HsCommonLaymanService },
    { type: NgZone }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsCompositionsCatalogueService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: HsMapService }, { type: HsCompositionsService }, { type: HsLayoutService }, { type: HsCommonEndpointsService }, { type: HsUtilsService }, { type: HsEventBusService }, { type: HsDialogContainerService }, { type: HsLaymanService }, { type: HsCommonLaymanService }, { type: ɵngcc0.NgZone }]; }, null); })();

class HsSaveMapManagerService {
    constructor(HsMapService, HsSaveMapService, HsConfig, http, HsStatusManagerService, HsLaymanService, HsLayoutService, HsUtilsService, HsEventBusService) {
        this.HsMapService = HsMapService;
        this.HsSaveMapService = HsSaveMapService;
        this.HsConfig = HsConfig;
        this.http = http;
        this.HsStatusManagerService = HsStatusManagerService;
        this.HsLaymanService = HsLaymanService;
        this.HsLayoutService = HsLayoutService;
        this.HsUtilsService = HsUtilsService;
        this.HsEventBusService = HsEventBusService;
        this.statusData = {
            titleFree: undefined,
            hasPermission: undefined,
            success: undefined,
            changeTitle: undefined,
            groups: [],
        };
        this.compoData = {
            title: '',
            name: '',
            abstract: '',
            keywords: [],
            layers: [],
            id: '',
            thumbnail: undefined,
            bbox: { east: 0, south: 0, west: 0, north: 0 },
            currentCompositionTitle: '',
            currentComposition: undefined,
            access_rights: {
                'access_rights.write': 'private',
                'access_rights.read': 'EVERYONE',
            },
        };
        this.userData = {
            email: '',
            phone: '',
            name: '',
            address: '',
            country: '',
            postalCode: '',
            city: '',
            organization: '',
        };
        this.panelOpened = new Subject();
        this.saveMapResulted = new Subject();
        this.endpointSelected = new BehaviorSubject(null);
        this.preSaveCheckCompleted = new Subject();
        HsEventBusService.compositionLoads.subscribe((data) => {
            var _a;
            if (data.error == undefined) {
                const responseData = (_a = data.data) !== null && _a !== void 0 ? _a : data;
                this.compoData.id = responseData.id;
                this.compoData.abstract = responseData.abstract;
                this.compoData.title = responseData.title;
                this.compoData.name = responseData.name;
                this.compoData.keywords = responseData.keywords;
                this.compoData.currentComposition = responseData;
                this.compoData.workspace = responseData.workspace;
                this.compoData.currentCompositionTitle = this.compoData.title;
            }
        });
        HsEventBusService.mapResets.subscribe(() => {
            this.resetCompoData();
        });
        HsEventBusService.mainPanelChanges.subscribe(() => {
            if (HsLayoutService.mainpanel == 'saveMap' ||
                HsLayoutService.mainpanel == 'statusCreator') {
                HsMapService.loaded().then(() => {
                    this.fillCompositionData();
                    this.HsSaveMapService.generateThumbnail(this.HsLayoutService.contentWrapper.querySelector('.hs-stc-thumbnail'), this.compoData);
                });
            }
        });
        this.HsEventBusService.olMapLoads.subscribe((map) => {
            this.setCurrentBoundingBox();
            map.on('postcompose', this.HsUtilsService.debounce(() => {
                this.setCurrentBoundingBox();
                this.HsSaveMapService.generateThumbnail(this.HsLayoutService.contentWrapper.querySelector('.hs-stc-thumbnail'), this.compoData);
            }, 1000, false, this));
        });
    }
    //TODO: Add interface to describe Endpoint instead of any
    selectEndpoint(endpoint) {
        this.endpointSelected.next(endpoint);
    }
    setCurrentBoundingBox() {
        this.compoData.bbox = this.getCurrentExtent();
    }
    confirmSave() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.http
                    .post(this.HsStatusManagerService.endpointUrl(), {
                    project: this.HsConfig.project_name,
                    title: this.compoData.title,
                    request: 'rightToSave',
                })
                    .toPromise();
                const j = response.data;
                this.statusData.hasPermission = j.results.hasPermission;
                this.statusData.titleFree = j.results.titleFree;
                if (j.results.guessedTitle) {
                    this.statusData.guessedTitle = j.results.guessedTitle;
                }
                if (!this.statusData.titleFree) {
                    this.statusData.changeTitle = false;
                }
                if (this.statusData.titleFree && this.statusData.hasPermission) {
                    this.save(true, this.HsStatusManagerService.findStatusmanagerEndpoint());
                }
                this.preSaveCheckCompleted.next({
                    endpoint: this.HsStatusManagerService.findStatusmanagerEndpoint(),
                });
            }
            catch (ex) {
                this.statusData.success = false;
            }
        });
    }
    save(saveAsNew, endpoint) {
        return new Promise((resolve, reject) => {
            const tempCompoData = {};
            Object.assign(tempCompoData, this.compoData);
            // Check whether layers were already formatted
            if (tempCompoData.layers[0].layer) {
                tempCompoData.layers = tempCompoData.layers
                    .filter((l) => l.checked)
                    .map((l) => l.layer);
            }
            const compositionJson = this.generateCompositionJson(tempCompoData);
            let saver = this.HsStatusManagerService;
            if (endpoint.type == 'layman') {
                saver = this.HsLaymanService;
            }
            saver
                .save(compositionJson, endpoint, tempCompoData, saveAsNew)
                .then((response) => {
                const compInfo = {};
                const j = response;
                let status = false;
                if (endpoint.type == 'statusmanager') {
                    status = j.saved;
                }
                if (endpoint.type == 'layman') {
                    if (saveAsNew) {
                        status = j.length == 1 && j[0].uuid !== undefined;
                    }
                    else {
                        status = j.uuid !== undefined;
                    }
                }
                if (!status) {
                    if (endpoint.type == 'layman' && j.status == 'CONFLICT') {
                        compInfo.id = j[0].uuid;
                        compInfo.name = j[0].name;
                    }
                    if (endpoint.type == 'statusmanager') {
                        compInfo.id = j.id;
                        compInfo.title = j.title;
                        compInfo.abstract = j.abstract || '';
                    }
                }
                else {
                    this.HsEventBusService.compositionLoading.next(compInfo);
                    this.HsEventBusService.compositionLoads.next(compInfo);
                }
                //const saveStatus = this.status ? 'ok' : 'not-saved';
                //this.statusData.success = this.status;
                response.status = status;
                resolve(response);
            })
                .catch((e) => {
                //e contains the json responses data object from api
                //this.statusData.success = false;
                reject({
                    status: false,
                    error: e,
                });
            });
        });
    }
    /**
     * @param download Used when generating json for catalogue save
     * @returns composition JSON
     */
    generateCompositionJson(compoData) {
        /*TODO: REFACTOR
          Workaround for composition JSON generated for download.
          Should be handled differently and generated only once. Task for upcoming component rework
        */
        const tempCompoData = Object.assign({}, (compoData !== null && compoData !== void 0 ? compoData : this.compoData));
        if (!compoData) {
            tempCompoData.layers = tempCompoData.layers
                .filter((l) => l.checked)
                .map((l) => l.layer);
        }
        return this.HsSaveMapService.map2json(this.HsMapService.map, tempCompoData, this.userData, this.statusData);
    }
    /**
     * Initialization of Save map wizard from outside of component
     * @param composition
     */
    openPanel(composition) {
        this.HsLayoutService.setMainPanel('saveMap', true);
        this.fillCompositionData();
        this.panelOpened.next({ composition });
    }
    fillCompositionData() {
        return __awaiter(this, void 0, void 0, function* () {
            this.fillLayers();
            yield this.fillGroups();
            this.statusData.groups.unshift({
                roleTitle: 'Public',
                roleName: 'guest',
                w: false,
                r: false,
            });
            const cc = this.compoData.currentComposition;
            if (this.compoData.currentComposition && cc != '') {
                for (const g of this.statusData.groups) {
                    if (cc.groups && cc.groups[g.roleName]) {
                        g.w = cc.groups[g.roleName].indexOf('w') > -1;
                        g.r = cc.groups[g.roleName].indexOf('r') > -1;
                    }
                }
            }
            this.loadUserDetails();
        });
    }
    fillLayers() {
        this.compoData.layers = [];
        this.compoData.bbox = this.getCurrentExtent();
        this.compoData.layers = this.HsMapService.map
            .getLayers()
            .getArray()
            .filter((lyr) => getShowInLayerManager(lyr) == undefined ||
            getShowInLayerManager(lyr) == true)
            .map((lyr) => {
            return {
                title: getTitle(lyr),
                checked: true,
                layer: lyr,
            };
        })
            .sort((a, b) => {
            return a.layer.getZIndex() - b.layer.getZIndex();
        });
    }
    /**
     * Send getGroups request to status manager server and process response
     * @param {Function} cb Callback function
     */
    fillGroups() {
        return __awaiter(this, void 0, void 0, function* () {
            this.statusData.groups = [];
            if (this.HsConfig.advancedForm) {
                const response = yield this.http
                    .get(this.HsStatusManagerService.endpointUrl(), {
                    params: new HttpParams({
                        fromObject: {
                            request: 'getGroups',
                        },
                    }),
                })
                    .toPromise();
                const j = response.data;
                if (j.success) {
                    this.statusData.groups = j.result;
                    for (const g of this.statusData.groups) {
                        g.w = false;
                        g.r = false;
                    }
                }
            }
        });
    }
    /**
     * Get User info from server and call callback (setUserDetail)
     */
    loadUserDetails() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.http
                .get(this.HsStatusManagerService.endpointUrl() + '?request=getuserinfo')
                .toPromise();
            this.setUserDetails(response);
        });
    }
    /**
     * Process user info into controller model, so they can be used in Save composition forms
     * @param {object} response Http response containing user data
     */
    setUserDetails(response) {
        const user = response.data;
        if (user && user.success == true) {
            // set the values
            if (user.userInfo) {
                this.userData.email = user.userInfo.email;
                this.userData.phone = user.userInfo.phone;
                this.userData.name =
                    user.userInfo.firstName + ' ' + user.userInfo.lastName;
            }
            if (user.userInfo && user.userInfo.org) {
                this.userData.address = user.userInfo.org.street;
                this.userData.country = user.userInfo.org.state;
                this.userData.postalcode = user.userInfo.org.zip;
                this.userData.city = user.userInfo.org.city;
                this.userData.organization = user.userInfo.org.name;
            }
        }
    }
    /**
     * Get current extent of map, transform it into EPSG:4326 and save it into controller model
     * @returns {Array} Extent coordinates
     */
    getCurrentExtent() {
        const b = this.HsMapService.map
            .getView()
            .calculateExtent(this.HsMapService.map.getSize());
        let pair1 = [b[0], b[1]];
        let pair2 = [b[2], b[3]];
        const cur_proj = this.HsMapService.getCurrentProj().getCode();
        pair1 = transform(pair1, cur_proj, 'EPSG:4326');
        pair2 = transform(pair2, cur_proj, 'EPSG:4326');
        return {
            east: pair1[0].toFixed(2),
            south: pair1[1].toFixed(2),
            west: pair2[0].toFixed(2),
            north: pair2[1].toFixed(2),
        };
    }
    /**
     * Callback for saving with new title
     */
    selectNewTitle() {
        this.compoData.title = this.statusData.guessedTitle;
        this.changeTitle = true;
    }
    resetCompoData() {
        this.compoData.id = '';
        this.compoData.abstract = '';
        this.compoData.title = '';
        this.compoData.name = '';
        this.compoData.currentCompositionTitle = '';
        this.compoData.keywords = '';
        this.compoData.currentComposition = '';
    }
    initiateSave(saveAsNew) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const augmentedResponse = yield this.save(saveAsNew, this.endpointSelected.getValue());
                this.processSaveCallback(augmentedResponse);
            }
            catch (ex) {
                this.processSaveCallback(ex);
            }
        });
    }
    processSaveCallback(response) {
        this.statusData.status = response.status;
        if (!response.status) {
            if (response.code == 24) {
                this.statusData.overWriteNeeded = true;
                this.compoData.name = response.detail.mapname;
                this.statusData.resultCode = 'exists';
            }
            else if (response.code == 32) {
                this.statusData.resultCode = 'not-saved';
            }
            else {
                this.statusData.resultCode = 'error';
            }
            this.statusData.error = response;
        }
        else {
            this.HsLayoutService.setMainPanel('layermanager', true);
        }
        this.saveMapResulted.next(this.statusData);
    }
    focusTitle() {
        if (this.statusData.guessedTitle) {
            this.compoData.title = this.statusData.guessedTitle;
        }
        //TODO Check if this works and input is focused
        this.HsLayoutService.contentWrapper.querySelector('.hs-stc-title').focus();
    }
}
HsSaveMapManagerService.ɵfac = function HsSaveMapManagerService_Factory(t) { return new (t || HsSaveMapManagerService)(ɵngcc0.ɵɵinject(HsMapService), ɵngcc0.ɵɵinject(HsSaveMapService), ɵngcc0.ɵɵinject(HsConfig), ɵngcc0.ɵɵinject(ɵngcc2.HttpClient), ɵngcc0.ɵɵinject(HsStatusManagerService), ɵngcc0.ɵɵinject(HsLaymanService), ɵngcc0.ɵɵinject(HsLayoutService), ɵngcc0.ɵɵinject(HsUtilsService), ɵngcc0.ɵɵinject(HsEventBusService)); };
HsSaveMapManagerService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HsSaveMapManagerService_Factory() { return new HsSaveMapManagerService(i0.ɵɵinject(HsMapService), i0.ɵɵinject(HsSaveMapService), i0.ɵɵinject(HsConfig), i0.ɵɵinject(i1$1.HttpClient), i0.ɵɵinject(HsStatusManagerService), i0.ɵɵinject(HsLaymanService), i0.ɵɵinject(HsLayoutService), i0.ɵɵinject(HsUtilsService), i0.ɵɵinject(HsEventBusService)); }, token: HsSaveMapManagerService, providedIn: "root" });
HsSaveMapManagerService.ctorParameters = () => [
    { type: HsMapService },
    { type: HsSaveMapService },
    { type: HsConfig },
    { type: HttpClient },
    { type: HsStatusManagerService },
    { type: HsLaymanService },
    { type: HsLayoutService },
    { type: HsUtilsService },
    { type: HsEventBusService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsSaveMapManagerService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: HsMapService }, { type: HsSaveMapService }, { type: HsConfig }, { type: ɵngcc2.HttpClient }, { type: HsStatusManagerService }, { type: HsLaymanService }, { type: HsLayoutService }, { type: HsUtilsService }, { type: HsEventBusService }]; }, null); })();

class HsCompositionsOverwriteDialogComponent {
    constructor(HsDialogContainerService, HsCompositionsService, HsSaveMapManagerService) {
        this.HsDialogContainerService = HsDialogContainerService;
        this.HsCompositionsService = HsCompositionsService;
        this.HsSaveMapManagerService = HsSaveMapManagerService;
    }
    close() {
        this.HsDialogContainerService.destroy(this);
    }
    /**
     * @public
     * @description Load new composition without saving old composition
     */
    overwrite() {
        this.HsCompositionsService.loadComposition(this.HsCompositionsService.compositionToLoad.url, true);
        this.close();
    }
    /**
     * @public
     * @description Save currently loaded composition first
     */
    save() {
        this.HsSaveMapManagerService.openPanel(null);
        this.close();
    }
    /**
     * @public
     * @description Load new composition (with service_parser Load function) and merge it with old composition
     */
    add() {
        this.HsCompositionsService.loadComposition(this.HsCompositionsService.compositionToLoad.url, false);
        this.close();
    }
}
HsCompositionsOverwriteDialogComponent.ɵfac = function HsCompositionsOverwriteDialogComponent_Factory(t) { return new (t || HsCompositionsOverwriteDialogComponent)(ɵngcc0.ɵɵdirectiveInject(HsDialogContainerService), ɵngcc0.ɵɵdirectiveInject(HsCompositionsService), ɵngcc0.ɵɵdirectiveInject(HsSaveMapManagerService)); };
HsCompositionsOverwriteDialogComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsCompositionsOverwriteDialogComponent, selectors: [["hs-compositions-overwrite-dialog"]], decls: 37, vars: 28, consts: [["tabindex", "-1", "role", "dialog", "aria-hidden", "true", 1, "modal", "in", "hs-composition-overwrite-dialog"], [1, "modal-dialog"], [1, "modal-content"], [1, "modal-header"], [1, "modal-title"], ["type", "button", "data-dismiss", "modal", 1, "close", 3, "click"], ["aria-hidden", "true"], [1, "sr-only"], [1, "modal-body", 2, "max-height", "600px", "overflow-y", "auto"], [1, "modal-footer"], ["type", "button", "data-dismiss", "modal", 1, "btn", "btn-primary", "compositions-btn-overwrite", 3, "click"], ["type", "button", "data-dismiss", "modal", 1, "btn", "btn-primary", "compositions-btn-add", 3, "click"], ["type", "button", "data-dismiss", "modal", 1, "btn", "btn-primary", "compositions-btn-save", 3, "click"], ["type", "button", "data-dismiss", "modal", 1, "btn", "btn-secondary", "compositions-btn-cancel", 3, "click"]], template: function HsCompositionsOverwriteDialogComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelementStart(4, "h4", 4);
        ɵngcc0.ɵɵtext(5);
        ɵngcc0.ɵɵpipe(6, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "button", 5);
        ɵngcc0.ɵɵlistener("click", function HsCompositionsOverwriteDialogComponent_Template_button_click_7_listener() { return ctx.close(); });
        ɵngcc0.ɵɵelementStart(8, "span", 6);
        ɵngcc0.ɵɵtext(9, "\u00D7");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "span", 7);
        ɵngcc0.ɵɵtext(11);
        ɵngcc0.ɵɵpipe(12, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(13, "div", 8);
        ɵngcc0.ɵɵtext(14);
        ɵngcc0.ɵɵpipe(15, "translate");
        ɵngcc0.ɵɵelementStart(16, "b");
        ɵngcc0.ɵɵtext(17);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(18, "br");
        ɵngcc0.ɵɵtext(19);
        ɵngcc0.ɵɵpipe(20, "translate");
        ɵngcc0.ɵɵelement(21, "br");
        ɵngcc0.ɵɵtext(22);
        ɵngcc0.ɵɵpipe(23, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(24, "div", 9);
        ɵngcc0.ɵɵelementStart(25, "button", 10);
        ɵngcc0.ɵɵlistener("click", function HsCompositionsOverwriteDialogComponent_Template_button_click_25_listener() { return ctx.overwrite(); });
        ɵngcc0.ɵɵtext(26);
        ɵngcc0.ɵɵpipe(27, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(28, "button", 11);
        ɵngcc0.ɵɵlistener("click", function HsCompositionsOverwriteDialogComponent_Template_button_click_28_listener() { return ctx.add(); });
        ɵngcc0.ɵɵtext(29);
        ɵngcc0.ɵɵpipe(30, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(31, "button", 12);
        ɵngcc0.ɵɵlistener("click", function HsCompositionsOverwriteDialogComponent_Template_button_click_31_listener() { return ctx.save(); });
        ɵngcc0.ɵɵtext(32);
        ɵngcc0.ɵɵpipe(33, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(34, "button", 13);
        ɵngcc0.ɵɵlistener("click", function HsCompositionsOverwriteDialogComponent_Template_button_click_34_listener() { return ctx.close(); });
        ɵngcc0.ɵɵtext(35);
        ɵngcc0.ɵɵpipe(36, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(6, 10, "COMPOSITIONS.dialogoverwriteConfirm.overwriteExistingMap"));
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(12, 12, "COMMON.close"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(15, 14, "COMPOSITIONS.dialogoverwriteConfirm.youAreOpeningMap"), " ");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.data.composition_name_to_be_loaded);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(20, 16, "COMPOSITIONS.dialogoverwriteConfirm.thereAreCurrentlyUnsavedChanges"), " ");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(23, 18, "COMPOSITIONS.dialogoverwriteConfirm.whatDoYouWant"));
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(27, 20, "COMMON.continue"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(30, 22, "COMPOSITIONS.dialogoverwriteConfirm.mergeCompositions"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(33, 24, "COMPOSITIONS.dialogoverwriteConfirm.saveChangesFirst"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(36, 26, "COMMON.cancel"));
    } }, pipes: [ɵngcc1.TranslatePipe], encapsulation: 2 });
HsCompositionsOverwriteDialogComponent.ctorParameters = () => [
    { type: HsDialogContainerService },
    { type: HsCompositionsService },
    { type: HsSaveMapManagerService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsCompositionsOverwriteDialogComponent, [{
        type: Component,
        args: [{
                selector: 'hs-compositions-overwrite-dialog',
                template: "<div class=\"modal in hs-composition-overwrite-dialog\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <h4 class=\"modal-title\">{{'COMPOSITIONS.dialogoverwriteConfirm.overwriteExistingMap' | translate}}</h4>\n                <button type=\"button\" (click)=\"close()\" class=\"close\" data-dismiss=\"modal\"><span\n                        aria-hidden=\"true\">&times;</span><span class=\"sr-only\">{{'COMMON.close' | translate}}</span></button>\n            </div>\n            <div class=\"modal-body\" style=\"max-height: 600px; overflow-y: auto\">\n                {{'COMPOSITIONS.dialogoverwriteConfirm.youAreOpeningMap' | translate}}\n                <b>{{data.composition_name_to_be_loaded}}</b>\n                <br>{{'COMPOSITIONS.dialogoverwriteConfirm.thereAreCurrentlyUnsavedChanges' | translate}}\n                <br>{{'COMPOSITIONS.dialogoverwriteConfirm.whatDoYouWant' | translate}}</div>\n            <div class=\"modal-footer\">\n                <button type=\"button\" class=\"btn btn-primary compositions-btn-overwrite\" (click)=\"overwrite()\"\n                    data-dismiss=\"modal\">{{'COMMON.continue' | translate}}</button>\n                <button type=\"button\" class=\"btn btn-primary compositions-btn-add\" (click)=\"add();\"\n                    data-dismiss=\"modal\">{{'COMPOSITIONS.dialogoverwriteConfirm.mergeCompositions' | translate}}</button>\n                <button type=\"button\" class=\"btn btn-primary compositions-btn-save\" (click)=\"save()\"\n                    data-dismiss=\"modal\">{{'COMPOSITIONS.dialogoverwriteConfirm.saveChangesFirst' | translate}}</button>\n                <button type=\"button\" class=\"btn btn-secondary compositions-btn-cancel\" (click)=\"close()\"\n                    data-dismiss=\"modal\">{{'COMMON.cancel' | translate}}</button>\n            </div>\n        </div>\n    </div>\n</div>"
            }]
    }], function () { return [{ type: HsDialogContainerService }, { type: HsCompositionsService }, { type: HsSaveMapManagerService }]; }, null); })();

class HsCompositionsComponent extends HsPanelBaseComponent {
    constructor(hsCompositionsService, hsCompositionsParserService, hsLayoutService, hsUtilsService, hsCompositionsMapService, hsSaveMapManagerService, hsDialogContainerService, hsCompositionsCatalogueService, hsLaymanService, hsSidebarService, hsLanguageService) {
        super(hsLayoutService);
        this.hsCompositionsService = hsCompositionsService;
        this.hsCompositionsParserService = hsCompositionsParserService;
        this.hsLayoutService = hsLayoutService;
        this.hsUtilsService = hsUtilsService;
        this.hsCompositionsMapService = hsCompositionsMapService;
        this.hsSaveMapManagerService = hsSaveMapManagerService;
        this.hsDialogContainerService = hsDialogContainerService;
        this.hsCompositionsCatalogueService = hsCompositionsCatalogueService;
        this.hsLaymanService = hsLaymanService;
        this.keywordsVisible = false;
        this.themesVisible = false;
        this.urlToAdd = '';
        this.addCompositionUrlVisible = false;
        this.optionsButtonLabel = 'more';
        this.optionsMenuOpen = false;
        this.name = 'composition_browser';
        hsSidebarService.buttons.push({
            panel: 'composition_browser',
            module: 'hs.compositions',
            order: 3,
            fits: true,
            title: () => hsLanguageService.getTranslation('PANEL_HEADER.MAPCOMPOSITIONS'),
            description: () => hsLanguageService.getTranslation('SIDEBAR.descriptions.MAPCOMPOSITIONS'),
            icon: 'icon-map',
        });
        this.loadFilteredCompositions = () => hsCompositionsCatalogueService.loadFilteredCompositions();
        this.notSavedCompositionLoadingSubscription =
            this.hsCompositionsService.notSavedCompositionLoading.subscribe((url) => {
                this.hsCompositionsService.compositionToLoad = { url, title: '' };
                this.loadUnsavedDialogBootstrap(url, '');
            });
    }
    ngOnDestroy() {
        this.notSavedCompositionLoadingSubscription.unsubscribe();
    }
    /**
     * @param composition Composition to highlight
     * @param state Target state of composition ( True - highlighted, False - normal)
     * Highlight (or dim) composition, toggle visual state of composition extent on map
     */
    highlightComposition(composition, state) {
        composition.highlighted = state;
        this.hsCompositionsMapService.highlightComposition(composition, state);
    }
    /**
     * @param url
     * @param record Composition to be loaded
     * Load selected composition in map, if current composition was edited display Overwrite dialog
     */
    addCompositionUrl(url) {
        if (this.hsCompositionsParserService.composition_edited == true) {
            this.hsCompositionsService.notSavedCompositionLoading.next(url);
        }
        else {
            this.hsCompositionsService.loadComposition(url, true).then((_) => {
                this.addCompositionUrlVisible = false;
            });
        }
    }
    handleFileSelect(evt) {
        const files = evt.target.files; // FileList object
        for (const f of files) {
            if (!f.type.match('application/json')) {
                continue;
            }
            const reader = new FileReader();
            reader.onload = (theFile) => __awaiter(this, void 0, void 0, function* () {
                const json = JSON.parse(reader.result);
                yield this.hsCompositionsParserService.loadCompositionObject(json, true);
            });
            reader.readAsText(f);
        }
    }
    /**
     * @param url
     * @param title
     */
    loadUnsavedDialogBootstrap(url, title) {
        this.hsDialogContainerService.create(HsCompositionsOverwriteDialogComponent, {
            composition_name_to_be_loaded: title,
        });
    }
    openOptionsMenu() {
        this.optionsMenuOpen = !this.optionsMenuOpen;
        if (this.optionsMenuOpen) {
            this.optionsButtonLabel = 'less';
            this.keywordsVisible = false;
            this.themesVisible = false;
        }
        else {
            this.optionsButtonLabel = 'more';
        }
    }
    clearFilters() {
        this.optionsMenuOpen = false;
        this.themesVisible = false;
        this.keywordsVisible = false;
        this.selectedCompId = '';
        this.hsCompositionsCatalogueService.clearFilters();
    }
    changeUrlButtonVisible() {
        this.addCompositionUrlVisible = !this.addCompositionUrlVisible;
    }
    openSaveMapPanel() {
        this.hsLayoutService.setMainPanel('saveMap');
    }
    compositionClicked(composition) {
        if (this.selectedCompId != this.hsCompositionsService.commonId(composition)) {
            this.selectedCompId = this.hsCompositionsService.commonId(composition);
        }
        else {
            this.selectedCompId = '';
        }
    }
    reload() {
        this.clearFilters();
        this.loadFilteredCompositions();
    }
    sortByValueChanged(sortBy) {
        this.hsCompositionsCatalogueService.data.sortBy = sortBy;
        this.loadFilteredCompositions();
    }
}
HsCompositionsComponent.ɵfac = function HsCompositionsComponent_Factory(t) { return new (t || HsCompositionsComponent)(ɵngcc0.ɵɵdirectiveInject(HsCompositionsService), ɵngcc0.ɵɵdirectiveInject(HsCompositionsParserService), ɵngcc0.ɵɵdirectiveInject(HsLayoutService), ɵngcc0.ɵɵdirectiveInject(HsUtilsService), ɵngcc0.ɵɵdirectiveInject(HsCompositionsMapService), ɵngcc0.ɵɵdirectiveInject(HsSaveMapManagerService), ɵngcc0.ɵɵdirectiveInject(HsDialogContainerService), ɵngcc0.ɵɵdirectiveInject(HsCompositionsCatalogueService), ɵngcc0.ɵɵdirectiveInject(HsLaymanService), ɵngcc0.ɵɵdirectiveInject(HsSidebarService), ɵngcc0.ɵɵdirectiveInject(HsLanguageService)); };
HsCompositionsComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsCompositionsComponent, selectors: [["hs-compositions"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 91, vars: 63, consts: [[1, "card", "hs-main-panel", 3, "hidden"], ["name", "composition_browser", 3, "title"], [1, "but-title-sm", "hs-extra-buttons", 3, "title", "click"], [1, "glyphicon", "icon-fatredo"], [1, "icon-save-floppy"], [1, "but-title-sm", "hs-extra-buttons", "btn-file", "mb-0", 2, "font-size", "14px", "padding", "1px 6px", 3, "title"], [1, "icon-upload"], ["type", "file", "accept", ".json", 2, "display", "none", 3, "change"], [1, "icon-plus"], [1, "mt-3", "mx-3", "pl-1", "d-flex", "justify-content-between"], [1, "input-group", "mb-2", 3, "hidden"], ["type", "text", 1, "form-control", 3, "placeholder", "ngModel", "ngModelOptions", "ngModelChange"], [1, "input-group-append"], ["type", "button", 1, "btn", "btn-secondary", 3, "click"], [1, "icon-link"], [1, "mx-3", "pl-1", "d-flex", "justify-content-between"], [1, "input-group", 2, "width", "55% !important"], ["type", "search", "name", "search", 1, "form-control", "border-right-0", 3, "placeholder", "ngModel", "ngModelChange"], [1, "btn", "input-group-text", "text-secondary", "hs-light-background", "border-left-0", 3, "click"], [1, "icon-search", "icon-primary"], [3, "endpoint"], [1, "d-flex", "ml-4", "mr-3", "justify-content-between", "py-1"], [1, "d-flex"], [1, "input-group-text", "border-0", "pl-0"], ["type", "checkbox", "name", "hsCompositionsCatalogueService.filterByExtent", 3, "ngModel", "ngModelChange", "change"], [1, "ml-1"], ["class", "input-group-text border-0", 4, "ngIf"], ["ngbDropdown", "", "display", "dynamic", "placement", "bottom-right", 1, "d-inline-block"], ["ngbDropdownToggle", "", 1, "btn", "btn-light", "hs-white-background", "hs-custom-toggle", 3, "click"], ["ngbDropdownMenu", "", "aria-labelledby", "filtersDropdown", 1, "dropdown-menu-right", "p-2", "m-1", 2, "min-width", "23rem", "max-width", "23rem", "overflow", "visible"], [1, "p-1", "pl-3", 2, "border-collapse", "separate", "border-spacing", "0.5rem 0.5rem"], [1, "tdbreak"], ["ngbDropdown", "", "display", "dynamic", "placement", "bottom-right"], ["type", "button", "ngbDropdownToggle", "", 1, "btn", "btn-light", "btn-sm", "hs-custom-toggle", "hs-background-alfa", "p-2", "pl-1", "border-0", 2, "text-align", "start", "min-width", "11rem", "max-width", "11rem", "border-radius", "0px", "justify-content", "space-between", "display", "flex", "align-items", "center"], ["ngbDropdownMenu", "", "aria-labelledby", "keywords", 1, "pl-2", 2, "overflow-y", "auto", "max-height", "10rem", "min-width", "15rem"], [4, "ngFor", "ngForOf"], ["ngbDropdownMenu", "", "aria-labelledby", "inspireThemes", 1, "pl-2", 2, "overflow-y", "auto", "max-height", "10rem", "min-width", "20rem"], ["sortByDrop", "ngbDropdown"], ["ngbDropdownMenu", "", "aria-labelledby", "sortBy", 1, "pl-2", 2, "overflow-y", "auto", "max-height", "10rem", "min-width", "10rem"], ["colspan", "2", 2, "text-align", "center", "vertical-align", "middle"], [1, "btn", "btn-block", "btn-light", "hs-background-alfa", 2, "border-radius", "0.25rem", 3, "click"], [1, "tab-content"], [1, "card", "d-flex", 2, "font-size", "1rem !important"], [1, "card-body"], [1, "list-group"], ["class", "list-group-item text-primary text-center py-2", 4, "ngIf"], [1, "list-group-item", 3, "hidden"], ["class", "list-group-item clearfix", "style", "cursor: pointer;", "data-container", "body", "data-placement", "bottom", 3, "hidden", "ngClass", "mouseover", "mouseleave", "click", 4, "ngFor", "ngForOf"], [3, "pagerService"], [1, "input-group-text", "border-0"], ["type", "checkbox", "name", "hsCompositionsCatalogueService.filterByOnlyMine", 3, "ngModel", "ngModelChange", "change"], [2, "cursor", "pointer"], ["type", "checkbox", "name", "keyword[index]", 1, "mr-2", 3, "ngModel", "ngModelChange", "change"], ["type", "checkbox", "name", "theme[index]", 1, "mr-2", 3, "ngModel", "ngModelChange", "change"], ["type", "radio", "name", "sort-index", 1, "mr-2", 3, "checked", "change"], [1, "list-group-item", "text-primary", "text-center", "py-2"], [1, "pr-2", 3, "src"], ["data-container", "body", "data-placement", "bottom", 1, "list-group-item", "clearfix", 2, "cursor", "pointer", 3, "hidden", "ngClass", "mouseover", "mouseleave", "click"], [3, "composition", "selectedCompId"]], template: function HsCompositionsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "hs-panel-header", 1);
        ɵngcc0.ɵɵpipe(2, "translate");
        ɵngcc0.ɵɵelementStart(3, "extra-buttons");
        ɵngcc0.ɵɵelementStart(4, "button", 2);
        ɵngcc0.ɵɵlistener("click", function HsCompositionsComponent_Template_button_click_4_listener() { return ctx.reload(); });
        ɵngcc0.ɵɵpipe(5, "translate");
        ɵngcc0.ɵɵelement(6, "i", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "button", 2);
        ɵngcc0.ɵɵlistener("click", function HsCompositionsComponent_Template_button_click_7_listener() { return ctx.openSaveMapPanel(); });
        ɵngcc0.ɵɵpipe(8, "translate");
        ɵngcc0.ɵɵelement(9, "span", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "label", 5);
        ɵngcc0.ɵɵpipe(11, "translate");
        ɵngcc0.ɵɵelement(12, "span", 6);
        ɵngcc0.ɵɵelementStart(13, "input", 7);
        ɵngcc0.ɵɵlistener("change", function HsCompositionsComponent_Template_input_change_13_listener($event) { return ctx.handleFileSelect($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(14, "button", 2);
        ɵngcc0.ɵɵlistener("click", function HsCompositionsComponent_Template_button_click_14_listener() { return ctx.changeUrlButtonVisible(); });
        ɵngcc0.ɵɵpipe(15, "translate");
        ɵngcc0.ɵɵelement(16, "span", 8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(17, "div", 9);
        ɵngcc0.ɵɵelementStart(18, "div", 10);
        ɵngcc0.ɵɵelementStart(19, "input", 11);
        ɵngcc0.ɵɵlistener("ngModelChange", function HsCompositionsComponent_Template_input_ngModelChange_19_listener($event) { return ctx.urlToAdd = $event; });
        ɵngcc0.ɵɵpipe(20, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(21, "div", 12);
        ɵngcc0.ɵɵelementStart(22, "button", 13);
        ɵngcc0.ɵɵlistener("click", function HsCompositionsComponent_Template_button_click_22_listener() { return ctx.addCompositionUrl(ctx.urlToAdd); });
        ɵngcc0.ɵɵelement(23, "i", 14);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(24, "div", 15);
        ɵngcc0.ɵɵelementStart(25, "div", 16);
        ɵngcc0.ɵɵelementStart(26, "input", 17);
        ɵngcc0.ɵɵlistener("ngModelChange", function HsCompositionsComponent_Template_input_ngModelChange_26_listener($event) { return ctx.hsCompositionsCatalogueService.data.query.title = $event; })("ngModelChange", function HsCompositionsComponent_Template_input_ngModelChange_26_listener() { return ctx.loadFilteredCompositions(); });
        ɵngcc0.ɵɵpipe(27, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(28, "div", 12);
        ɵngcc0.ɵɵelementStart(29, "button", 18);
        ɵngcc0.ɵɵlistener("click", function HsCompositionsComponent_Template_button_click_29_listener() { return ctx.loadFilteredCompositions(); });
        ɵngcc0.ɵɵelement(30, "i", 19);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(31, "hs-layman-current-user", 20);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(32, "div", 21);
        ɵngcc0.ɵɵelementStart(33, "div", 22);
        ɵngcc0.ɵɵelementStart(34, "div", 23);
        ɵngcc0.ɵɵelementStart(35, "input", 24);
        ɵngcc0.ɵɵlistener("ngModelChange", function HsCompositionsComponent_Template_input_ngModelChange_35_listener($event) { return ctx.hsCompositionsCatalogueService.filterByExtent = $event; })("change", function HsCompositionsComponent_Template_input_change_35_listener() { return ctx.loadFilteredCompositions(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(36, "span", 25);
        ɵngcc0.ɵɵtext(37);
        ɵngcc0.ɵɵpipe(38, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(39, HsCompositionsComponent_div_39_Template, 5, 4, "div", 26);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(40, "div", 27);
        ɵngcc0.ɵɵelementStart(41, "button", 28);
        ɵngcc0.ɵɵlistener("click", function HsCompositionsComponent_Template_button_click_41_listener() { return ctx.openOptionsMenu(); });
        ɵngcc0.ɵɵtext(42);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(43, "div", 29);
        ɵngcc0.ɵɵelementStart(44, "table", 30);
        ɵngcc0.ɵɵelementStart(45, "tbody");
        ɵngcc0.ɵɵelementStart(46, "tr");
        ɵngcc0.ɵɵelementStart(47, "td", 31);
        ɵngcc0.ɵɵtext(48);
        ɵngcc0.ɵɵpipe(49, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(50, "td", 32);
        ɵngcc0.ɵɵelementStart(51, "button", 33);
        ɵngcc0.ɵɵtext(52);
        ɵngcc0.ɵɵpipe(53, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(54, "ul", 34);
        ɵngcc0.ɵɵtemplate(55, HsCompositionsComponent_li_55_Template, 4, 2, "li", 35);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(56, "tr");
        ɵngcc0.ɵɵelementStart(57, "td", 31);
        ɵngcc0.ɵɵtext(58);
        ɵngcc0.ɵɵpipe(59, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(60, "td", 32);
        ɵngcc0.ɵɵelementStart(61, "button", 33);
        ɵngcc0.ɵɵtext(62);
        ɵngcc0.ɵɵpipe(63, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(64, "ul", 36);
        ɵngcc0.ɵɵtemplate(65, HsCompositionsComponent_li_65_Template, 4, 2, "li", 35);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(66, "tr");
        ɵngcc0.ɵɵelementStart(67, "td", 31);
        ɵngcc0.ɵɵtext(68);
        ɵngcc0.ɵɵpipe(69, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(70, "td", 32, 37);
        ɵngcc0.ɵɵelementStart(72, "button", 33);
        ɵngcc0.ɵɵtext(73);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(74, "ul", 38);
        ɵngcc0.ɵɵtemplate(75, HsCompositionsComponent_li_75_Template, 4, 2, "li", 35);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(76, "tr");
        ɵngcc0.ɵɵelementStart(77, "td", 39);
        ɵngcc0.ɵɵelementStart(78, "button", 40);
        ɵngcc0.ɵɵlistener("click", function HsCompositionsComponent_Template_button_click_78_listener() { return ctx.clearFilters(); });
        ɵngcc0.ɵɵtext(79);
        ɵngcc0.ɵɵpipe(80, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(81, "div", 41);
        ɵngcc0.ɵɵelementStart(82, "div", 42);
        ɵngcc0.ɵɵelementStart(83, "div", 43);
        ɵngcc0.ɵɵelementStart(84, "ul", 44);
        ɵngcc0.ɵɵtemplate(85, HsCompositionsComponent_li_85_Template, 4, 4, "li", 45);
        ɵngcc0.ɵɵelementStart(86, "li", 46);
        ɵngcc0.ɵɵtext(87);
        ɵngcc0.ɵɵpipe(88, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(89, HsCompositionsComponent_li_89_Template, 2, 7, "li", 47);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(90, "hs-pager", 48);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("hidden", !ctx.isVisible());
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(2, 32, "PANEL_HEADER.COMPOSITIONS"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(5, 34, "COMMON.reload"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(8, 36, "PANEL_HEADER.SAVECOMPOSITION"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(11, 38, "COMPOSITIONS.import"));
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(15, 40, "COMPOSITIONS.addByAddress"));
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("hidden", !ctx.addCompositionUrlVisible);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("placeholder", ɵngcc0.ɵɵpipeBind1(20, 42, "COMPOSITIONS.Address"))("ngModel", ctx.urlToAdd)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(62, _c2));
        ɵngcc0.ɵɵadvance(7);
        ɵngcc0.ɵɵproperty("placeholder", ɵngcc0.ɵɵpipeBind1(27, 44, "COMMON.search"))("ngModel", ctx.hsCompositionsCatalogueService.data.query.title);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("endpoint", ctx.hsLaymanService.getLaymanEndpoint());
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngModel", ctx.hsCompositionsCatalogueService.filterByExtent);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(38, 46, "COMPOSITIONS.filterByMap"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hsLaymanService.getLaymanEndpoint() && !ctx.hsLaymanService.isLaymanGuest());
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.hsCompositionsService.translateString("COMMON", ctx.optionsButtonLabel));
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(49, 48, "COMMON.keywords"), " ");
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(53, 50, "COMPOSITIONS.selectKeywords"), " ");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.hsCompositionsCatalogueService.data.keywords);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(59, 52, "COMPOSITIONS.inspireTheme"), " ");
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(63, 54, "COMPOSITIONS.selectThemes"), " ");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.hsCompositionsCatalogueService.data.themes);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(69, 56, "COMMON.sortBy"), " ");
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.hsCompositionsService.translateString("COMPOSITONSORTVALUES", ctx.hsCompositionsCatalogueService.data.sortBy.name), " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.hsCompositionsCatalogueService.sortByValues);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(80, 58, "COMPOSITIONS.clearFilters"), "");
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hsCompositionsCatalogueService.dataLoading);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", ctx.hsCompositionsCatalogueService.compositionEntries.length > 0 || ctx.hsCompositionsCatalogueService.dataLoading);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(88, 60, "DATASOURCE_SELECTOR.noResults"), "");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.hsCompositionsCatalogueService.compositionEntries);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("pagerService", ctx.hsCompositionsCatalogueService);
    } }, directives: function () { return [HsPanelHeaderComponent, ɵngcc5.DefaultValueAccessor, ɵngcc5.NgControlStatus, ɵngcc5.NgModel, HsLaymanCurrentUserComponent, ɵngcc5.CheckboxControlValueAccessor, ɵngcc3.NgIf, ɵngcc6.NgbDropdown, ɵngcc6.NgbDropdownToggle, ɵngcc6.NgbDropdownMenu, ɵngcc3.NgForOf, HsPagerComponent, ɵngcc3.NgClass, HsCompositionsListItemComponent]; }, pipes: function () { return [ɵngcc1.TranslatePipe]; }, encapsulation: 2 });
HsCompositionsComponent.ctorParameters = () => [
    { type: HsCompositionsService },
    { type: HsCompositionsParserService },
    { type: HsLayoutService },
    { type: HsUtilsService },
    { type: HsCompositionsMapService },
    { type: HsSaveMapManagerService },
    { type: HsDialogContainerService },
    { type: HsCompositionsCatalogueService },
    { type: HsLaymanService },
    { type: HsSidebarService },
    { type: HsLanguageService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsCompositionsComponent, [{
        type: Component,
        args: [{
                selector: 'hs-compositions',
                template: "<div class=\"card hs-main-panel\" [hidden]=\"!isVisible()\">\n    <hs-panel-header name=\"composition_browser\" [title]=\"'PANEL_HEADER.COMPOSITIONS' | translate\">\n        <extra-buttons>\n            <button class=\"but-title-sm hs-extra-buttons\" (click)=\"reload()\" [title]=\"'COMMON.reload' | translate\">\n                <i class=\"glyphicon icon-fatredo\"></i>\n            </button>\n            <button class=\"but-title-sm hs-extra-buttons\" [title]=\"'PANEL_HEADER.SAVECOMPOSITION'|translate\"\n                (click)=\"openSaveMapPanel()\">\n                <span class=\"icon-save-floppy\"></span>\n            </button>\n            <label class=\"but-title-sm hs-extra-buttons btn-file mb-0\" style=\"font-size: 14px; padding: 1px 6px;\"\n                [title]=\"'COMPOSITIONS.import'|translate\">\n                <span class=\"icon-upload\"></span><input type=\"file\" (change)=\"handleFileSelect($event)\" accept=\".json\"\n                    style=\"display: none;\">\n            </label>\n            <button class=\"but-title-sm hs-extra-buttons\" [title]=\"'COMPOSITIONS.addByAddress'|translate\"\n                (click)=\"changeUrlButtonVisible()\">\n                <span class=\"icon-plus\"></span>\n            </button>\n        </extra-buttons>\n    </hs-panel-header>\n    <div class=\"mt-3 mx-3 pl-1 d-flex justify-content-between\">\n        <div class=\"input-group mb-2\" [hidden]=\"!addCompositionUrlVisible\">\n            <input type=\"text\" class=\"form-control\" [placeholder]=\"'COMPOSITIONS.Address'|translate\"\n                [(ngModel)]=\"urlToAdd\" [ngModelOptions]=\"{standalone: true}\">\n            <div class=\"input-group-append\">\n                <button type=\"button\" class=\"btn btn-secondary\" (click)=\"addCompositionUrl(urlToAdd)\"><i\n                        class=\"icon-link\"></i></button>\n            </div>\n        </div>\n    </div>\n    <div class=\"mx-3 pl-1 d-flex justify-content-between\">\n        <div class=\"input-group\" style=\"width: 55% !important;\">\n            <input type=\"search\" class=\"form-control border-right-0\" [placeholder]=\"'COMMON.search'|translate\"\n                name=\"search\" [(ngModel)]=\"hsCompositionsCatalogueService.data.query.title\"\n                (ngModelChange)=\"loadFilteredCompositions()\">\n            <div class=\"input-group-append\">\n                <button class=\"btn input-group-text text-secondary hs-light-background border-left-0\"\n                    (click)=\"loadFilteredCompositions()\">\n                    <i class=\"icon-search icon-primary\"></i>\n                </button>\n            </div>\n        </div>\n        <hs-layman-current-user [endpoint]=\"hsLaymanService.getLaymanEndpoint()\"></hs-layman-current-user>\n    </div>\n    <div class=\"d-flex ml-4 mr-3 justify-content-between py-1 \">\n        <div class=\"d-flex\">\n            <div class=\"input-group-text border-0 pl-0\">\n                <input type=\"checkbox\" [(ngModel)]=\"hsCompositionsCatalogueService.filterByExtent\"\n                    (change)='loadFilteredCompositions()' name=\"hsCompositionsCatalogueService.filterByExtent\">\n                <span class=\"ml-1\">{{'COMPOSITIONS.filterByMap' | translate}}</span>\n            </div>\n            <div class=\"input-group-text border-0\"\n                *ngIf=\"hsLaymanService.getLaymanEndpoint() && !hsLaymanService.isLaymanGuest()\">\n                <input type=\"checkbox\" [(ngModel)]=\"hsCompositionsCatalogueService.filterByOnlyMine\"\n                    (change)='loadFilteredCompositions()' name=\"hsCompositionsCatalogueService.filterByOnlyMine\">\n                <span class=\"ml-1\">{{'COMPOSITIONS.onlyMine' | translate}}</span>\n            </div>\n        </div>\n        <div ngbDropdown display=\"dynamic\" placement=\"bottom-right\" class=\"d-inline-block\">\n            <button class=\"btn btn-light hs-white-background hs-custom-toggle\" (click)=\"openOptionsMenu()\"\n                ngbDropdownToggle>{{hsCompositionsService.translateString('COMMON',\n                optionsButtonLabel)}}</button>\n            <div ngbDropdownMenu class=\"dropdown-menu-right p-2 m-1\"\n                style=\"min-width: 23rem; max-width: 23rem;  overflow: visible\" aria-labelledby=\"filtersDropdown\">\n                <table class=\"p-1 pl-3\" style=\"border-collapse:separate; border-spacing:0.5rem 0.5rem;\">\n                    <tbody>\n                        <!-- <tr>\n                                    <td class=\"tdbreak\">\n                                        {{'COMMON.type' | translate}}\n                                    </td>\n                                    <td>\n                                        <select class=\"form-control hs-background-alfa pl-1\" name=\"type\"\n                                            [(ngModel)]=\"hsCompositionsCatalogueService.data.type\"\n                                            (change)=\"loadFilteredCompositions()\"\n                                            style=\"min-width: 11rem; max-width: 11rem;border:0px\">\n                                            <option *ngFor=\"let type of hsCompositionsCatalogueService.types\"\n                                                [ngValue]=\"type.value\">\n                                                {{hsCompositionsService.translateString('COMPOSITONTYPES', type.name)}}</option>\n                                        </select>\n                                    </td>\n                                </tr> -->\n                        <tr>\n                            <td class=\"tdbreak\">\n                                {{'COMMON.keywords' | translate}}\n                            </td>\n                            <td ngbDropdown display=\"dynamic\" placement=\"bottom-right\">\n                                <button type=\"button\" ngbDropdownToggle\n                                    class=\"btn btn-light btn-sm hs-custom-toggle hs-background-alfa p-2 pl-1 border-0\"\n                                    style=\"text-align:start; min-width: 11rem; max-width: 11rem; border-radius: 0px; justify-content: space-between; display:flex; align-items: center;\">\n                                    {{'COMPOSITIONS.selectKeywords' | translate}}\n                                </button>\n                                <ul ngbDropdownMenu aria-labelledby=\"keywords\" class=\"pl-2\"\n                                    style=\"overflow-y: auto; max-height: 10rem; min-width: 15rem\">\n                                    <li\n                                        *ngFor=\"let keyword of hsCompositionsCatalogueService.data.keywords, let index = index;\">\n                                        <label style=\"cursor: pointer;\"><input class=\"mr-2\" type=\"checkbox\"\n                                                [(ngModel)]=\"keyword.selected\" name=\"keyword[index]\"\n                                                (change)=\"loadFilteredCompositions()\">{{hsCompositionsService.translateString('COMPOSITONKEYWORDS',\n                                            keyword.name)}}</label>\n                                    </li>\n                                </ul>\n                            </td>\n                        </tr>\n                        <tr>\n                            <td class=\"tdbreak\">\n                                {{'COMPOSITIONS.inspireTheme' | translate}}\n                            </td>\n                            <td ngbDropdown display=\"dynamic\" placement=\"bottom-right\">\n                                <button type=\"button\" ngbDropdownToggle\n                                    class=\"btn btn-light btn-sm hs-custom-toggle hs-background-alfa p-2 pl-1 border-0\"\n                                    style=\"text-align:start; min-width: 11rem; max-width: 11rem; border-radius: 0px; justify-content: space-between; display:flex; align-items: center;\">\n                                    {{'COMPOSITIONS.selectThemes' | translate}}\n                                </button>\n                                <ul ngbDropdownMenu aria-labelledby=\"inspireThemes\" class=\"pl-2\"\n                                    style=\"overflow-y: auto; max-height: 10rem; min-width: 20rem\">\n                                    <li\n                                        *ngFor=\"let theme of hsCompositionsCatalogueService.data.themes, let index = index;\">\n                                        <label style=\"cursor: pointer;\"><input class=\"mr-2\" type=\"checkbox\"\n                                                [(ngModel)]=\"theme.selected\" name=\"theme[index]\"\n                                                (change)=\"loadFilteredCompositions()\">{{hsCompositionsService.translateString('COMPOSITONINSPIRETHEMES',\n                                            theme.name)}}</label>\n                                    </li>\n                                </ul>\n                            </td>\n                        </tr>\n\n                        <tr>\n                            <td class=\"tdbreak\">\n                                {{'COMMON.sortBy' | translate}}\n                            </td>\n                            <td ngbDropdown display=\"dynamic\" placement=\"bottom-right\" #sortByDrop=\"ngbDropdown\">\n                                <button type=\"button\" ngbDropdownToggle\n                                    class=\"btn btn-light btn-sm hs-custom-toggle hs-background-alfa p-2 pl-1 border-0\"\n                                    style=\"text-align:start; min-width: 11rem; max-width: 11rem; border-radius: 0px; justify-content: space-between; display:flex; align-items: center;\">\n                                    {{hsCompositionsService.translateString('COMPOSITONSORTVALUES',\n                                    hsCompositionsCatalogueService.data.sortBy.name)}}\n                                </button>\n                                <ul ngbDropdownMenu aria-labelledby=\"sortBy\" class=\"pl-2\"\n                                    style=\"overflow-y: auto; max-height: 10rem; min-width:10rem\">\n                                    <li\n                                        *ngFor=\"let item of hsCompositionsCatalogueService.sortByValues, let index = index;\">\n                                        <label style=\"cursor: pointer;\"><input class=\"mr-2\" type=\"radio\"\n                                                name=\"sort-index\" [checked]=\"(index === 0)\"\n                                                (change)=\"sortByValueChanged(item);sortByDrop.close()\">{{hsCompositionsService.translateString('COMPOSITONSORTVALUES',\n                                            item.name)}}</label>\n                                    </li>\n                                </ul>\n                            </td>\n                        </tr>\n                        <tr>\n                            <td colspan=\"2\" style=\"text-align: center; vertical-align: middle;\">\n                                <button class=\"btn btn-block btn-light hs-background-alfa\"\n                                    style=\"border-radius: 0.25rem;\" (click)=\"clearFilters()\">\n                                    {{'COMPOSITIONS.clearFilters' | translate}}</button>\n                            </td>\n                        </tr>\n                    </tbody>\n                </table>\n            </div>\n        </div>\n    </div>\n    <div class=\"tab-content\">\n        <div class=\"card d-flex\" style=\"font-size: 1rem !important;\">\n            <div class=\"card-body\">\n                <ul class=\"list-group\">\n                    <li class=\"list-group-item text-primary text-center py-2\"\n                        *ngIf=\"hsCompositionsCatalogueService.dataLoading\"><img class=\"pr-2\"\n                            [src]=\"hsUtilsService.getAjaxLoaderIcon()\" />{{'COMMON.loading' | translate}}</li>\n                    <li [hidden]=\"hsCompositionsCatalogueService.compositionEntries.length > 0 || hsCompositionsCatalogueService.dataLoading\"\n                        class=\"list-group-item\">\n                        {{'DATASOURCE_SELECTOR.noResults' | translate}}</li>\n                    <li *ngFor=\"let composition of hsCompositionsCatalogueService.compositionEntries\"\n                        [hidden]=\"hsCompositionsCatalogueService.dataLoading\" class=\"list-group-item clearfix\"\n                        style=\"cursor: pointer;\" [ngClass]=\"{'hs-endpoint-item-active' : composition.highlighted}\"\n                        (mouseover)=\"highlightComposition(composition, true)\"\n                        (mouseleave)=\"highlightComposition(composition, false)\"\n                        (click)=\"compositionClicked(composition)\" data-container=\"body\" data-placement=\"bottom\"\n                        [attr.title]=\"composition.mdAbstract\">\n                        <hs-compositions-list-item [composition]=\"composition\" [selectedCompId]=\"selectedCompId\">\n                        </hs-compositions-list-item>\n                    </li>\n                </ul>\n            </div>\n            <hs-pager [pagerService]=\"hsCompositionsCatalogueService\"></hs-pager>\n        </div>\n    </div>\n</div>"
            }]
    }], function () { return [{ type: HsCompositionsService }, { type: HsCompositionsParserService }, { type: HsLayoutService }, { type: HsUtilsService }, { type: HsCompositionsMapService }, { type: HsSaveMapManagerService }, { type: HsDialogContainerService }, { type: HsCompositionsCatalogueService }, { type: HsLaymanService }, { type: HsSidebarService }, { type: HsLanguageService }]; }, null); })();

class HsDialogHostDirective {
    constructor(viewContainerRef) {
        this.viewContainerRef = viewContainerRef;
    }
}
HsDialogHostDirective.ɵfac = function HsDialogHostDirective_Factory(t) { return new (t || HsDialogHostDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef)); };
HsDialogHostDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: HsDialogHostDirective, selectors: [["", "dialog-host", ""]] });
HsDialogHostDirective.ctorParameters = () => [
    { type: ViewContainerRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsDialogHostDirective, [{
        type: Directive,
        args: [{
                selector: '[dialog-host]'
            }]
    }], function () { return [{ type: ɵngcc0.ViewContainerRef }]; }, null); })();

class HsDialogContainerComponent {
    constructor(HsDialogContainerService, componentFactoryResolver) {
        this.HsDialogContainerService = HsDialogContainerService;
        this.componentFactoryResolver = componentFactoryResolver;
        this.ngUnsubscribe = new Subject();
    }
    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
    ngOnInit() {
        this.HsDialogContainerService.dialogObserver
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((item) => {
            this.loadDialog(item);
        });
        this.HsDialogContainerService.dialogDestroyObserver
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((item) => {
            this.destroyDialog(item);
        });
    }
    destroyDialog(dialog) {
        const viewContainerRef = this.dialogHost.viewContainerRef;
        viewContainerRef.remove(viewContainerRef.indexOf(dialog.viewRef));
    }
    loadDialog(dialogItem) {
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(dialogItem.component);
        const viewContainerRef = this.dialogHost.viewContainerRef;
        //    viewContainerRef.clear();
        const componentRef = viewContainerRef.createComponent(componentFactory);
        componentRef.instance.viewRef = componentRef.hostView;
        componentRef.instance.data = dialogItem.data;
        componentRef.instance.dialogItem = dialogItem;
    }
}
HsDialogContainerComponent.ɵfac = function HsDialogContainerComponent_Factory(t) { return new (t || HsDialogContainerComponent)(ɵngcc0.ɵɵdirectiveInject(HsDialogContainerService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver)); };
HsDialogContainerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsDialogContainerComponent, selectors: [["hs-dialog-container"]], viewQuery: function HsDialogContainerComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(HsDialogHostDirective, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dialogHost = _t.first);
    } }, decls: 2, vars: 0, consts: [["dialog-host", ""]], template: function HsDialogContainerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵtemplate(1, HsDialogContainerComponent_ng_template_1_Template, 0, 0, "ng-template", 0);
        ɵngcc0.ɵɵelementEnd();
    } }, directives: [HsDialogHostDirective], encapsulation: 2 });
HsDialogContainerComponent.ctorParameters = () => [
    { type: HsDialogContainerService },
    { type: ComponentFactoryResolver }
];
HsDialogContainerComponent.propDecorators = {
    dialogHost: [{ type: ViewChild, args: [HsDialogHostDirective, { static: true },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsDialogContainerComponent, [{
        type: Component,
        args: [{
                selector: 'hs-dialog-container',
                template: "<div>\n    <ng-template dialog-host></ng-template>\n</div>"
            }]
    }], function () { return [{ type: HsDialogContainerService }, { type: ɵngcc0.ComponentFactoryResolver }]; }, { dialogHost: [{
            type: ViewChild,
            args: [HsDialogHostDirective, { static: true }]
        }] }); })();

class HsPanelHeaderComponent {
    /*transclude: {
      'extraButtons': '?extraButtons',
      'extraTitle': '?extraTitle',
    },*/
    constructor(HsLayoutService) {
        this.HsLayoutService = HsLayoutService;
    }
    closePanel() {
        this.HsLayoutService.closePanel(this.name);
    }
}
HsPanelHeaderComponent.ɵfac = function HsPanelHeaderComponent_Factory(t) { return new (t || HsPanelHeaderComponent)(ɵngcc0.ɵɵdirectiveInject(HsLayoutService)); };
HsPanelHeaderComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsPanelHeaderComponent, selectors: [["hs-panel-header"]], inputs: { name: "name", title: "title" }, ngContentSelectors: _c4, decls: 4, vars: 1, consts: [[1, "card-header"]], template: function HsPanelHeaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c3);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵprojection(3, 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.title);
    } }, encapsulation: 2 });
HsPanelHeaderComponent.ctorParameters = () => [
    { type: HsLayoutService }
];
HsPanelHeaderComponent.propDecorators = {
    name: [{ type: Input }],
    title: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsPanelHeaderComponent, [{
        type: Component,
        args: [{
                selector: 'hs-panel-header',
                template: "<div class=\"card-header\">{{title}}<ng-content select=\"extra-title\"></ng-content>\n    <ng-content select=\"extra-buttons\"></ng-content>\n</div>"
            }]
    }], function () { return [{ type: HsLayoutService }]; }, { name: [{
            type: Input
        }], title: [{
            type: Input
        }] }); })();

class HsPanelHostDirective {
    constructor(viewContainerRef) {
        this.viewContainerRef = viewContainerRef;
    }
}
HsPanelHostDirective.ɵfac = function HsPanelHostDirective_Factory(t) { return new (t || HsPanelHostDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef)); };
HsPanelHostDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: HsPanelHostDirective, selectors: [["", "panel-host", ""]] });
HsPanelHostDirective.ctorParameters = () => [
    { type: ViewContainerRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsPanelHostDirective, [{
        type: Directive,
        args: [{
                selector: '[panel-host]'
            }]
    }], function () { return [{ type: ɵngcc0.ViewContainerRef }]; }, null); })();

class HsPanelContainerComponent {
    constructor(componentFactoryResolver) {
        this.componentFactoryResolver = componentFactoryResolver;
        this.ngUnsubscribe = new Subject();
    }
    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
    ngOnInit() {
        this.service.panelObserver
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((item) => {
            this.loadPanel(item);
        });
        this.service.panelDestroyObserver
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((item) => {
            this.destroyPanel(item);
        });
    }
    destroyPanel(panel) {
        const viewContainerRef = this.panelHost.viewContainerRef;
        viewContainerRef.remove(viewContainerRef.indexOf(panel.viewRef));
    }
    loadPanel(panelItem) {
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(panelItem.component);
        const viewContainerRef = this.panelHost.viewContainerRef;
        //    viewContainerRef.clear();
        const componentRef = viewContainerRef.createComponent(componentFactory);
        componentRef.instance.viewRef = componentRef.hostView;
        componentRef.instance.data = panelItem.data;
    }
}
HsPanelContainerComponent.ɵfac = function HsPanelContainerComponent_Factory(t) { return new (t || HsPanelContainerComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver)); };
HsPanelContainerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsPanelContainerComponent, selectors: [["hs-panel-container"]], viewQuery: function HsPanelContainerComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(HsPanelHostDirective, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.panelHost = _t.first);
    } }, inputs: { service: "service" }, decls: 1, vars: 0, consts: [["panel-host", ""]], template: function HsPanelContainerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, HsPanelContainerComponent_ng_template_0_Template, 0, 0, "ng-template", 0);
    } }, directives: [HsPanelHostDirective], encapsulation: 2 });
HsPanelContainerComponent.ctorParameters = () => [
    { type: ComponentFactoryResolver }
];
HsPanelContainerComponent.propDecorators = {
    panelHost: [{ type: ViewChild, args: [HsPanelHostDirective, { static: true },] }],
    service: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsPanelContainerComponent, [{
        type: Component,
        args: [{
                selector: 'hs-panel-container',
                template: "<ng-template panel-host></ng-template>\n"
            }]
    }], function () { return [{ type: ɵngcc0.ComponentFactoryResolver }]; }, { panelHost: [{
            type: ViewChild,
            args: [HsPanelHostDirective, { static: true }]
        }], service: [{
            type: Input
        }] }); })();

class HsPanelHelpersModule {
}
HsPanelHelpersModule.ɵfac = function HsPanelHelpersModule_Factory(t) { return new (t || HsPanelHelpersModule)(); };
HsPanelHelpersModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: HsPanelHelpersModule });
HsPanelHelpersModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsPanelHelpersModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    HsPanelHeaderComponent,
                    HsPanelHostDirective,
                    HsPanelContainerComponent,
                    HsPanelBaseComponent,
                ],
                imports: [],
                entryComponents: [
                    HsPanelHeaderComponent,
                    HsPanelContainerComponent,
                    HsPanelBaseComponent,
                ],
                exports: [
                    HsPanelHeaderComponent,
                    HsPanelContainerComponent,
                    HsPanelBaseComponent,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(HsPanelHelpersModule, { declarations: [HsPanelHeaderComponent, HsPanelHostDirective, HsPanelContainerComponent, HsPanelBaseComponent], exports: [HsPanelHeaderComponent, HsPanelContainerComponent, HsPanelBaseComponent] }); })();

var Themes;
(function (Themes) {
    Themes["dark"] = "dark";
    Themes["light"] = "light";
})(Themes || (Themes = {}));
const light = {
    name: Themes.light,
    properties: {
        '--text-color': 'hsl(0, 0%, 0%)',
        '--panel-wrapper-bg-color': 'hsl(0, 0%, 100%)',
        //*****Sidebar*****//
        //Background color of sidebar
        '--sidebar-bg-color': 'hsl(0, 0%, 100%)',
        //Color of sidebar icon
        '--sidebar-item-color': 'hsl(211, 100%, 50%)',
        '--sidebar-item-color-active': 'hsl(0, 0%, 100%)',
        //Background color of active sidebar item
        '--sidebar-bg-color-active': 'hsl(211, 100%, 50%)',
        //*PRIMARY */
        '--primary': 'hsl(211deg, 100%, 50%)',
        '--primary-h': '211',
        '--primary-s': '100%',
        '--primary-l': '50%',
        // '--primary-a': 1,
        //*SECONDARY */
        '--secondary': 'hsl(208, 7%, 46%)',
        '--secondary-h': 208,
        '--secondary-s': '7%',
        '--secondary-l': '46%',
        '--secondary-a': 1,
        //*LIGHT */
        '--light': 'hsl(210, 17%, 94%)',
        '--light-h': 210,
        '--light-s': '17%',
        '--light-l': '98%',
        '--light-a': 1,
        //*GREY-200 */
        '--gray-200': 'hsl(210, 16%, 93%)',
        '--gray-200-h': 210,
        '--gray-200-s': '16%',
        '--gray-200-l': '93%',
        '--gray-200-a': 1,
        //*GREY-800 */
        '--gray-800': 'hsl(210, 10%, 23%)',
        //*GREY-900 */
        '--gray-900': 'hsl(210, 11%, 15%)',
        /* WHITE */
        '--white': 'hsl(0, 0%, 100%)',
        '--white-h': '0',
        '--white-s': '0%',
        '--white-l': '100%',
        '--white-a': 1,
        '--map-controls-bg': 'hsla(214, 100%, 27%, 0.5)',
    },
};
const dark = {
    name: Themes.dark,
    properties: {
        '--text-color': 'hsla(0, 0%, 100%, 87%)',
        '--panel-wrapper-bg-color': 'hsl(220, 29%, 12%)',
        //*****Sidebar*****//
        //Background color of sidebar
        '--sidebar-bg-color': 'hsl(218, 27%, 18%)',
        //Background color of active sidebar item
        '--sidebar-bg-color-active': 'hsl(45, 95%, 43%)',
        //Color of sidebar icon
        '--sidebar-item-color': 'hsl(0, 0%, 100%)',
        '--sidebar-item-color-active': 'hsl(0, 0%, 100%)',
        //*PRIMARY */
        '--primary': 'hsl(199deg 76% 40%)',
        '--primary-h': 199,
        '--primary-s': '76%',
        '--primary-l': '40%',
        // '--primary-a': 1,
        //*SECONDARY */
        '--secondary': 'hsl(45, 95%, 43%)',
        '--secondary-h': 45,
        '--secondary-s': '95%',
        '--secondary-l': '45%',
        '--secondary-a': 1,
        //*LIGHT */
        '--light': 'hsl(220, 29%, 22%)',
        '--light-h': 220,
        '--light-s': '29%',
        '--light-l': '22%',
        '--light-a': 1,
        //*GREY-200 */
        '--gray-200': 'hsl(220, 31%, 15%)',
        '--gray-200-h': 220,
        '--gray-200-s': '29%',
        '--gray-200-l': '22%',
        '--gray-200-a': 1,
        //*GREY-800 */
        '--gray-800': 'hsla(0, 0%, 100%, 60%)',
        //*GREY-900 */
        '--gray-900': 'hsla(0, 0%, 100%, 69%)',
        /* WHITE */
        '--white': 'hsl(217deg 16% 21%)',
        '--white-h': '217',
        '--white-s': '16%',
        '--white-l': '21%',
        // '--white-a': 1,
        '--font-weight-bold': 600,
        '--font-weight-normal': 350,
        '--map-controls-bg': 'hsl(218, 27%, 18%)',
    },
};

class HsThemeService {
    constructor(HsLayoutService) {
        this.HsLayoutService = HsLayoutService;
        this.active = light;
        this.availableThemes = [light, dark];
    }
    getAvailableThemes() {
        return this.availableThemes;
    }
    getActiveTheme() {
        return this.active;
    }
    isDarkTheme() {
        return this.active.name === dark.name;
    }
    setDarkTheme() {
        this.setActiveTheme(dark);
    }
    setLightTheme() {
        this.setActiveTheme(light);
    }
    setActiveTheme(theme) {
        this.active = theme;
        Object.keys(this.active.properties).forEach((property) => {
            this.HsLayoutService.layoutElement.style.setProperty(property, this.active.properties[property]);
        });
    }
}
HsThemeService.ɵfac = function HsThemeService_Factory(t) { return new (t || HsThemeService)(ɵngcc0.ɵɵinject(HsLayoutService)); };
HsThemeService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HsThemeService_Factory() { return new HsThemeService(i0.ɵɵinject(HsLayoutService)); }, token: HsThemeService, providedIn: "root" });
HsThemeService.ctorParameters = () => [
    { type: HsLayoutService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsThemeService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: HsLayoutService }]; }, null); })();

class HsToastComponent {
    constructor(PmToastService) {
        this.PmToastService = PmToastService;
    }
}
HsToastComponent.ɵfac = function HsToastComponent_Factory(t) { return new (t || HsToastComponent)(ɵngcc0.ɵɵdirectiveInject(HsToastService)); };
HsToastComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsToastComponent, selectors: [["hs-toast"]], decls: 1, vars: 1, consts: [["style", "overflow: hidden; max-height: 8rem;", 3, "header", "class", "autohide", "delay", "hidden", 4, "ngFor", "ngForOf"], [2, "overflow", "hidden", "max-height", "8rem", 3, "header", "autohide", "delay", "hidden"]], template: function HsToastComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, HsToastComponent_ngb_toast_0_Template, 2, 6, "ngb-toast", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngForOf", ctx.PmToastService.toasts);
    } }, directives: [ɵngcc3.NgForOf, ɵngcc6.NgbToast], styles: ["[_nghost-%COMP%] {\n        position: absolute;\n        bottom: 0.1rem;\n        z-index: 150;\n        border-style: none;\n        display: flex;\n        max-height: 90%;\n        flex-direction: column;\n        max-width: 400px;\n      }"] });
HsToastComponent.ctorParameters = () => [
    { type: HsToastService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsToastComponent, [{
        type: Component,
        args: [{
                selector: 'hs-toast',
                template: "<ngb-toast *ngFor=\"let toast of PmToastService.toasts\" [header]=\"toast.header\" [class]=\"toast.classname\"\n  style=\"overflow: hidden; max-height: 8rem;\" [autohide]=\"toast.autohide\" [delay]=\"toast.delay || 5000\"\n  (hidden)=\"PmToastService.remove(toast)\">{{toast.textOrTpl}}\n</ngb-toast>\n",
                styles: [`
      :host {
        position: absolute;
        bottom: 0.1rem;
        z-index: 150;
        border-style: none;
        display: flex;
        max-height: 90%;
        flex-direction: column;
        max-width: 400px;
      }
    `]
            }]
    }], function () { return [{ type: HsToastService }]; }, null); })();

class HsToastModule {
}
HsToastModule.ɵfac = function HsToastModule_Factory(t) { return new (t || HsToastModule)(); };
HsToastModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: HsToastModule });
HsToastModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, NgbModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsToastModule, [{
        type: NgModule,
        args: [{
                schemas: [CUSTOM_ELEMENTS_SCHEMA],
                declarations: [HsToastComponent],
                imports: [CommonModule, NgbModule],
                exports: [HsToastComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(HsToastModule, { declarations: function () { return [HsToastComponent]; }, imports: function () { return [CommonModule, NgbModule]; }, exports: function () { return [HsToastComponent]; } }); })();

class HsMapHostDirective {
    constructor(viewContainerRef) {
        this.viewContainerRef = viewContainerRef;
    }
}
HsMapHostDirective.ɵfac = function HsMapHostDirective_Factory(t) { return new (t || HsMapHostDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef)); };
HsMapHostDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: HsMapHostDirective, selectors: [["", "map-host", ""]] });
HsMapHostDirective.ctorParameters = () => [
    { type: ViewContainerRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsMapHostDirective, [{
        type: Directive,
        args: [{
                selector: '[map-host]'
            }]
    }], function () { return [{ type: ɵngcc0.ViewContainerRef }]; }, null); })();

class HsLayoutComponent {
    constructor(HsConfig, HsLayoutService, HsEventBusService, HsThemeService, elementRef, cdr, HsUtilsService, HsPanelContainerService, HsOverlayPanelContainerService) {
        this.HsConfig = HsConfig;
        this.HsLayoutService = HsLayoutService;
        this.HsEventBusService = HsEventBusService;
        this.HsThemeService = HsThemeService;
        this.elementRef = elementRef;
        this.cdr = cdr;
        this.HsUtilsService = HsUtilsService;
        this.HsPanelContainerService = HsPanelContainerService;
        this.HsOverlayPanelContainerService = HsOverlayPanelContainerService;
        this.HsLayoutService.layoutElement = elementRef.nativeElement;
    }
    panelVisible(which, scope) {
        return this.HsLayoutService.panelVisible(which, scope);
    }
    panelEnabled(which, status) {
        return this.HsLayoutService.panelEnabled(which, status);
    }
    panelSpaceWidth() {
        return this.HsLayoutService.panelSpaceWidth();
    }
    ngOnInit() {
        this.HsLayoutService.contentWrapper =
            this.elementRef.nativeElement.querySelector('.hs-content-wrapper');
        if (this.HsConfig.sidebarPosition === 'left') {
            this.HsLayoutService.contentWrapper.classList.add('flex-reverse');
            this.HsLayoutService.sidebarRight = false;
        }
        else if (this.HsConfig.sidebarPosition != 'invisible') {
            this.HsConfig.sidebarPosition = 'right';
        }
        if (window.innerWidth < 600 && this.HsUtilsService.runningInBrowser()) {
            const viewport = document.querySelector('meta[name="viewport"]');
            viewport.setAttribute('content', 'width=device-width, initial-scale=0.6, maximum-scale=2, user-scalable=no');
        }
        //this.$emit('scope_loaded', 'Layout');
        switch (this.HsConfig.theme) {
            case 'dark':
                this.HsThemeService.setDarkTheme();
                break;
            default:
                this.HsThemeService.setLightTheme();
                break;
        }
    }
    ngAfterViewInit() {
        this.HsLayoutService.layoutElement = this.hslayout.nativeElement;
        const hsapp = this.elementRef.nativeElement.parentElement;
        if (window.innerWidth < 767) {
            document.body.style.margin = '0px';
        }
        if (getComputedStyle(hsapp).display == 'inline') {
            hsapp.style.display = 'block';
            console.warn('Main element (#hs-app) needs display property to be defined...fallback value added');
        }
        //Minimal value expected for clientHeight of hsapp element at the initiation in case of WINDOWED mode
        //In comparison with clientHeight used to distinguish between full and windowed mode.
        const minHeight = window.devicePixelRatio <= 1 ? 350 : 300 * window.devicePixelRatio;
        //In case the app height is not set on hslayers element, height is determined by
        //the main panel height which vary from 0 if no mainpanel is set to 90 or even 208 in some cases .
        //Value of 300 or less /would mean that height is not set we need do something
        if (hsapp.clientHeight < minHeight) {
            hsapp.style.height = '100%';
            //If its still the same, height is not even set on parents of hslayers element - we want fullscreen app
            if (hsapp.clientHeight < minHeight) {
                hsapp.style.height = 'calc(var(--vh, 1vh) * 100)';
            }
            console.warn('Main element (#hs-app) needs height property to be defined...fallback value added');
        }
        this.HsEventBusService.layoutLoads.next({
            element: this.elementRef.nativeElement,
            innerElement: '.hs-map-space',
        });
        this.HsLayoutService.mapSpaceRef.next(this.mapHost.viewContainerRef);
        this.cdr.detectChanges();
    }
}
HsLayoutComponent.ɵfac = function HsLayoutComponent_Factory(t) { return new (t || HsLayoutComponent)(ɵngcc0.ɵɵdirectiveInject(HsConfig), ɵngcc0.ɵɵdirectiveInject(HsLayoutService), ɵngcc0.ɵɵdirectiveInject(HsEventBusService), ɵngcc0.ɵɵdirectiveInject(HsThemeService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(HsUtilsService), ɵngcc0.ɵɵdirectiveInject(HsPanelContainerService), ɵngcc0.ɵɵdirectiveInject(HsOverlayPanelContainerService)); };
HsLayoutComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsLayoutComponent, selectors: [["hs-layout"]], viewQuery: function HsLayoutComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c5, 5);
        ɵngcc0.ɵɵviewQuery(HsMapHostDirective, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.hslayout = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.mapHost = _t.first);
    } }, decls: 11, vars: 9, consts: [[1, "hs-page-wrapper", "hsl", 2, "width", "100%", "height", "100%"], ["hslayout", ""], [1, "hs-content-wrapper", "d-flex", "w-100", "h-100", 3, "ngClass"], [1, "hs-map-space", "d-flex"], [1, "hs-flex-fill", "d-flex"], ["map-host", ""], [3, "service"], ["class", "hs-panelspace", 3, "ngClass", "ngStyle", 4, "ngIf"], ["aria-live", "polite", "aria-atomic", "true", 3, "ngClass"], [1, "hs-dialog-area"], [1, "hs-panelspace", 3, "ngClass", "ngStyle"], [1, "hs-panelspace-wrapper", "mr-1"], [1, "border-0"], [1, "hs-panelplace"], [3, "hidden", 4, "ngIf"], [1, "hs-panelplace", 3, "service", "ngStyle"], [3, "hidden"]], template: function HsLayoutComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0, 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelement(4, "hs-map", 4);
        ɵngcc0.ɵɵtemplate(5, HsLayoutComponent_ng_template_5_Template, 0, 0, "ng-template", 5);
        ɵngcc0.ɵɵelement(6, "hs-panel-container", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(7, HsLayoutComponent_div_7_Template, 6, 12, "div", 7);
        ɵngcc0.ɵɵelement(8, "hs-toast", 8);
        ɵngcc0.ɵɵelement(9, "div", 9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(10, "hs-dialog-container");
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction4(4, _c8, ctx.HsLayoutService.sidebarExpanded && ctx.HsLayoutService.sidebarVisible(), ctx.HsConfig.sidebarPosition == "right" && ctx.HsLayoutService.sidebarVisible(), ctx.HsConfig.sidebarPosition == "left" && ctx.HsLayoutService.sidebarVisible(), ctx.HsLayoutService.sidebarBottom()));
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("service", ctx.HsOverlayPanelContainerService);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.HsLayoutService.sidebarVisible());
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ctx.HsConfig.sidebarPosition == "left" ? "hs-sb-right" : "hs-sb-left");
    } }, directives: function () { return [ɵngcc3.NgClass, HsMapComponent, HsMapHostDirective, HsPanelContainerComponent, ɵngcc3.NgIf, HsToastComponent, HsDialogContainerComponent, ɵngcc3.NgStyle, HsSidebarComponent, HsMiniSidebarComponent]; }, styles: ["@charset \"UTF-8\";.ol-box{box-sizing:border-box;border-radius:2px;border:1.5px solid rgb(179,197,219);background-color:#fff6}.ol-mouse-position{top:8px;right:8px;position:absolute}.ol-scale-line{background:rgba(0,60,136,.3);border-radius:4px;bottom:8px;left:8px;padding:2px;position:absolute}.ol-scale-line-inner{border:1px solid #eee;border-top:none;color:#eee;font-size:10px;text-align:center;margin:1px;will-change:contents,width;transition:all .25s}.ol-scale-bar{position:absolute;bottom:8px;left:8px}.ol-scale-step-marker{width:1px;height:15px;background-color:#000;float:right;z-Index:10}.ol-scale-step-text{position:absolute;bottom:-5px;font-size:12px;z-Index:11;color:#000;text-shadow:-2px 0 #FFFFFF,0 2px #FFFFFF,2px 0 #FFFFFF,0 -2px #FFFFFF}.ol-scale-text{position:absolute;font-size:14px;text-align:center;bottom:25px;color:#000;text-shadow:-2px 0 #FFFFFF,0 2px #FFFFFF,2px 0 #FFFFFF,0 -2px #FFFFFF}.ol-scale-singlebar{position:relative;height:10px;z-Index:9;box-sizing:border-box;border:1px solid black}.ol-unsupported{display:none}.ol-viewport,.ol-unselectable{-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;user-select:none;-webkit-tap-highlight-color:rgba(0,0,0,0)}.ol-selectable{-webkit-touch-callout:default;-webkit-user-select:text;-moz-user-select:text;user-select:text}.ol-grabbing{cursor:-webkit-grabbing;cursor:grabbing}.ol-grab{cursor:move;cursor:-webkit-grab;cursor:grab}.ol-control{position:absolute;background-color:#fff6;border-radius:4px;padding:2px}.ol-control:hover{background-color:#fff9}.ol-zoom{top:.5em;left:.5em}.ol-rotate{top:.5em;right:.5em;transition:opacity .25s linear,visibility 0s linear}.ol-rotate.ol-hidden{opacity:0;visibility:hidden;transition:opacity .25s linear,visibility 0s linear .25s}.ol-zoom-extent{top:4.643em;left:.5em}.ol-full-screen{right:.5em;top:.5em}.ol-control button{display:block;margin:1px;padding:0;color:#fff;font-weight:bold;text-decoration:none;font-size:inherit;text-align:center;height:1.375em;width:1.375em;line-height:.4em;background-color:#003c8880;border:none;border-radius:2px}.ol-control button::-moz-focus-inner{border:none;padding:0}.ol-zoom-extent button{line-height:1.4em}.ol-compass{display:block;font-weight:normal;font-size:1.2em;will-change:transform}.ol-touch .ol-control button{font-size:1.5em}.ol-touch .ol-zoom-extent{top:5.5em}.ol-control button:hover,.ol-control button:focus{text-decoration:none;background-color:#003c88b3}.ol-zoom .ol-zoom-in{border-radius:2px 2px 0 0}.ol-zoom .ol-zoom-out{border-radius:0 0 2px 2px}.ol-attribution{text-align:right;bottom:.5em;right:.5em;max-width:calc(100% - 1.3em);display:flex;flex-flow:row-reverse;align-items:center}.ol-attribution a{color:#003c88b3;text-decoration:none}.ol-attribution ul{margin:0;padding:1px .5em;color:#000;text-shadow:0 0 2px #fff;font-size:12px}.ol-attribution li{display:inline;list-style:none}.ol-attribution li:not(:last-child):after{content:\" \"}.ol-attribution img{max-height:2em;max-width:inherit;vertical-align:middle}.ol-attribution button{flex-shrink:0}.ol-attribution.ol-collapsed ul{display:none}.ol-attribution:not(.ol-collapsed){background:rgba(255,255,255,.8)}.ol-attribution.ol-uncollapsible{bottom:0;right:0;border-radius:4px 0 0}.ol-attribution.ol-uncollapsible img{margin-top:-.2em;max-height:1.6em}.ol-attribution.ol-uncollapsible button{display:none}.ol-zoomslider{top:4.5em;left:.5em;height:200px}.ol-zoomslider button{position:relative;height:10px}.ol-touch .ol-zoomslider{top:5.5em}.ol-overviewmap{left:.5em;bottom:.5em}.ol-overviewmap.ol-uncollapsible{bottom:0;left:0;border-radius:0 4px 0 0}.ol-overviewmap .ol-overviewmap-map,.ol-overviewmap button{display:block}.ol-overviewmap .ol-overviewmap-map{border:1px solid #7b98bc;height:150px;margin:2px;width:150px}.ol-overviewmap:not(.ol-collapsed) button{bottom:2px;left:2px;position:absolute}.ol-overviewmap.ol-collapsed .ol-overviewmap-map,.ol-overviewmap.ol-uncollapsible button{display:none}.ol-overviewmap:not(.ol-collapsed){background:rgba(255,255,255,.8)}.ol-overviewmap-box{border:2px dotted rgba(0,60,136,.7)}.ol-overviewmap .ol-overviewmap-box:hover{cursor:move}.hsl,.hsl:before,.hsl:after,.hsl * .hsl *:before,.hsl *:after{all:revert}.hsl{color:var(--text-color)}.hsl :root{--blue: #007bff;--indigo: #6610f2;--purple: #6f42c1;--pink: #e83e8c;--red: #dc3545;--orange: #fd7e14;--yellow: #ffc107;--green: #28a745;--teal: #20c997;--cyan: #17a2b8;--white: var(--white);--gray: #6c757d;--gray-dark: var(--gray-800);--primary: var(--primary);--secondary: var(--secondary);--success: #28a745;--info: #17a2b8;--warning: #ffc107;--danger: #dc3545;--light: var(--light);--dark: var(--gray-800);--gray: var(--gray-900);--breakpoint-xs: 0;--breakpoint-sm: 576px;--breakpoint-md: 768px;--breakpoint-lg: 992px;--breakpoint-xl: 1200px;--font-family-sans-serif: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";--font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace}.hsl *,.hsl *:before,.hsl *:after{box-sizing:border-box}.hsl html{font-family:sans-serif;line-height:1.15;-webkit-text-size-adjust:100%;-webkit-tap-highlight-color:rgba(0,0,0,0)}.hsl article,.hsl aside,.hsl figcaption,.hsl figure,.hsl footer,.hsl header,.hsl hgroup,.hsl main,.hsl nav,.hsl section{display:block}.hsl body{margin:0;font-family:-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,\"Noto Sans\",\"Liberation Sans\",sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Noto Color Emoji\";font-size:1rem;font-weight:400;line-height:1.5;color:var(--gray-900);text-align:left;background-color:var(--white)}.hsl [tabindex=\"-1\"]:focus:not(:focus-visible){outline:0!important}.hsl hr{box-sizing:content-box;height:0;overflow:visible}.hsl h1,.hsl h2,.hsl h3,.hsl h4,.hsl h5,.hsl h6{margin-top:0;margin-bottom:.5rem}.hsl p{margin-top:0;margin-bottom:1rem}.hsl abbr[title],.hsl abbr[data-original-title]{text-decoration:underline;-webkit-text-decoration:underline dotted;text-decoration:underline dotted;cursor:help;border-bottom:0;-webkit-text-decoration-skip-ink:none;text-decoration-skip-ink:none}.hsl address{margin-bottom:1rem;font-style:normal;line-height:inherit}.hsl ol,.hsl ul,.hsl dl{margin-top:0;margin-bottom:1rem}.hsl ol ol,.hsl ul ul,.hsl ol ul,.hsl ul ol{margin-bottom:0}.hsl dt{font-weight:700}.hsl dd{margin-bottom:.5rem;margin-left:0}.hsl blockquote{margin:0 0 1rem}.hsl b,.hsl strong{font-weight:bolder}.hsl small{font-size:80%}.hsl sub,.hsl sup{position:relative;font-size:75%;line-height:0;vertical-align:baseline}.hsl sub{bottom:-.25em}.hsl sup{top:-.5em}.hsl a{color:var(--primary);text-decoration:none;background-color:transparent}.hsl a:hover{color:hsla(var(--primary-h),var(--primary-s),calc(var(--primary-l) + -15%),1);color:hsla(var(--primary-h),var(--primary-s),calc(var(--primary-l) + -15%),var(--primary-a, 1));text-decoration:underline}.hsl a:not([href]):not([class]){color:inherit;text-decoration:none}.hsl a:not([href]):not([class]):hover{color:inherit;text-decoration:none}.hsl pre,.hsl code,.hsl kbd,.hsl samp{font-family:SFMono-Regular,Menlo,Monaco,Consolas,\"Liberation Mono\",\"Courier New\",monospace;font-size:1em}.hsl pre{margin-top:0;margin-bottom:1rem;overflow:auto;-ms-overflow-style:scrollbar}.hsl figure{margin:0 0 1rem}.hsl img{vertical-align:middle;border-style:none}.hsl svg{overflow:hidden;vertical-align:middle}.hsl table{border-collapse:collapse}.hsl caption{padding-top:.75rem;padding-bottom:.75rem;color:#6c757d;text-align:left;caption-side:bottom}.hsl th{text-align:inherit;text-align:-webkit-match-parent}.hsl label{display:inline-block;margin-bottom:.5rem}.hsl button{border-radius:0}.hsl button:focus:not(:focus-visible){outline:0}.hsl input,.hsl button,.hsl select,.hsl optgroup,.hsl textarea{margin:0;font-family:inherit;font-size:inherit;line-height:inherit}.hsl button,.hsl input{overflow:visible}.hsl button,.hsl select{text-transform:none}.hsl [role=button]{cursor:pointer}.hsl select{word-wrap:normal}.hsl button,.hsl [type=button],.hsl [type=reset],.hsl [type=submit]{-webkit-appearance:button}.hsl button:not(:disabled),.hsl [type=button]:not(:disabled),.hsl [type=reset]:not(:disabled),.hsl [type=submit]:not(:disabled){cursor:pointer}.hsl button::-moz-focus-inner,.hsl [type=button]::-moz-focus-inner,.hsl [type=reset]::-moz-focus-inner,.hsl [type=submit]::-moz-focus-inner{padding:0;border-style:none}.hsl input[type=radio],.hsl input[type=checkbox]{box-sizing:border-box;padding:0}.hsl textarea{overflow:auto;resize:vertical}.hsl fieldset{min-width:0;padding:0;margin:0;border:0}.hsl legend{display:block;width:100%;max-width:100%;padding:0;margin-bottom:.5rem;font-size:1.5rem;line-height:inherit;color:inherit;white-space:normal}@media (max-width: 1200px){.hsl legend{font-size:calc(1.275rem + .3vw)}}.hsl progress{vertical-align:baseline}.hsl [type=number]::-webkit-inner-spin-button,.hsl [type=number]::-webkit-outer-spin-button{height:auto}.hsl [type=search]{outline-offset:-2px;-webkit-appearance:none}.hsl [type=search]::-webkit-search-decoration{-webkit-appearance:none}.hsl ::-webkit-file-upload-button{font:inherit;-webkit-appearance:button}.hsl output{display:inline-block}.hsl summary{display:list-item;cursor:pointer}.hsl template{display:none}.hsl [hidden]{display:none!important}.hsl h1,.hsl h2,.hsl h3,.hsl h4,.hsl h5,.hsl h6,.hsl .h1,.hsl .h2,.hsl .h3,.hsl .h4,.hsl .h5,.hsl .h6{margin-bottom:.5rem;font-weight:500;line-height:1.2}.hsl h1,.hsl .h1{font-size:2.5rem}@media (max-width: 1200px){.hsl h1,.hsl .h1{font-size:calc(1.375rem + 1.5vw)}}.hsl h2,.hsl .h2{font-size:2rem}@media (max-width: 1200px){.hsl h2,.hsl .h2{font-size:calc(1.325rem + .9vw)}}.hsl h3,.hsl .h3{font-size:1.75rem}@media (max-width: 1200px){.hsl h3,.hsl .h3{font-size:calc(1.3rem + .6vw)}}.hsl h4,.hsl .h4{font-size:1.5rem}@media (max-width: 1200px){.hsl h4,.hsl .h4{font-size:calc(1.275rem + .3vw)}}.hsl h5,.hsl .h5{font-size:1.25rem}.hsl h6,.hsl .h6{font-size:1rem}.hsl .lead{font-size:1.25rem;font-weight:300}.hsl .display-1{font-size:6rem;font-weight:300;line-height:1.2}@media (max-width: 1200px){.hsl .display-1{font-size:calc(1.725rem + 5.7vw)}}.hsl .display-2{font-size:5.5rem;font-weight:300;line-height:1.2}@media (max-width: 1200px){.hsl .display-2{font-size:calc(1.675rem + 5.1vw)}}.hsl .display-3{font-size:4.5rem;font-weight:300;line-height:1.2}@media (max-width: 1200px){.hsl .display-3{font-size:calc(1.575rem + 3.9vw)}}.hsl .display-4{font-size:3.5rem;font-weight:300;line-height:1.2}@media (max-width: 1200px){.hsl .display-4{font-size:calc(1.475rem + 2.7vw)}}.hsl hr{margin-top:1rem;margin-bottom:1rem;border:0;border-top:1px solid rgba(0,0,0,.1)}.hsl small,.hsl .small{font-size:80%;font-weight:400}.hsl mark,.hsl .mark{padding:.2em;background-color:#fcf8e3}.hsl .list-unstyled{padding-left:0;list-style:none}.hsl .list-inline{padding-left:0;list-style:none}.hsl .list-inline-item{display:inline-block}.hsl .list-inline-item:not(:last-child){margin-right:.5rem}.hsl .initialism{font-size:90%;text-transform:uppercase}.hsl .blockquote{margin-bottom:1rem;font-size:1.25rem}.hsl .blockquote-footer{display:block;font-size:80%;color:#6c757d}.hsl .blockquote-footer:before{content:\"\\2014\\a0\"}.hsl .img-fluid{max-width:100%;height:auto}.hsl .img-thumbnail{padding:.25rem;background-color:var(--white);border:1px solid #dee2e6;border-radius:.25rem;max-width:100%;height:auto}.hsl .figure{display:inline-block}.hsl .figure-img{margin-bottom:.5rem;line-height:1}.hsl .figure-caption{font-size:90%;color:#6c757d}.hsl code{font-size:87.5%;color:#e83e8c;word-wrap:break-word}a>.hsl code{color:inherit}.hsl kbd{padding:.2rem .4rem;font-size:87.5%;color:var(--white);background-color:var(--gray-900);border-radius:.2rem}.hsl kbd kbd{padding:0;font-size:100%;font-weight:700}.hsl pre{display:block;font-size:87.5%;color:var(--gray-900)}.hsl pre code{font-size:inherit;color:inherit;word-break:normal}.hsl .pre-scrollable{max-height:340px;overflow-y:scroll}.hsl .container,.hsl .container-fluid,.hsl .container-xl,.hsl .container-lg,.hsl .container-md,.hsl .container-sm{width:100%;padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto}@media (min-width: 576px){.hsl .container-sm,.hsl .container{max-width:540px}}@media (min-width: 768px){.hsl .container-md,.hsl .container-sm,.hsl .container{max-width:720px}}@media (min-width: 992px){.hsl .container-lg,.hsl .container-md,.hsl .container-sm,.hsl .container{max-width:960px}}@media (min-width: 1200px){.hsl .container-xl,.hsl .container-lg,.hsl .container-md,.hsl .container-sm,.hsl .container{max-width:1140px}}.hsl .row{display:flex;flex-wrap:wrap;margin-right:-15px;margin-left:-15px}.hsl .no-gutters{margin-right:0;margin-left:0}.hsl .no-gutters>.col,.hsl .no-gutters>[class*=col-]{padding-right:0;padding-left:0}.hsl .col-xl,.hsl .col-xl-auto,.hsl .col-xl-12,.hsl .col-xl-11,.hsl .col-xl-10,.hsl .col-xl-9,.hsl .col-xl-8,.hsl .col-xl-7,.hsl .col-xl-6,.hsl .col-xl-5,.hsl .col-xl-4,.hsl .col-xl-3,.hsl .col-xl-2,.hsl .col-xl-1,.hsl .col-lg,.hsl .col-lg-auto,.hsl .col-lg-12,.hsl .col-lg-11,.hsl .col-lg-10,.hsl .col-lg-9,.hsl .col-lg-8,.hsl .col-lg-7,.hsl .col-lg-6,.hsl .col-lg-5,.hsl .col-lg-4,.hsl .col-lg-3,.hsl .col-lg-2,.hsl .col-lg-1,.hsl .col-md,.hsl .col-md-auto,.hsl .col-md-12,.hsl .col-md-11,.hsl .col-md-10,.hsl .col-md-9,.hsl .col-md-8,.hsl .col-md-7,.hsl .col-md-6,.hsl .col-md-5,.hsl .col-md-4,.hsl .col-md-3,.hsl .col-md-2,.hsl .col-md-1,.hsl .col-sm,.hsl .col-sm-auto,.hsl .col-sm-12,.hsl .col-sm-11,.hsl .col-sm-10,.hsl .col-sm-9,.hsl .col-sm-8,.hsl .col-sm-7,.hsl .col-sm-6,.hsl .col-sm-5,.hsl .col-sm-4,.hsl .col-sm-3,.hsl .col-sm-2,.hsl .col-sm-1,.hsl .col,.hsl .col-auto,.hsl .col-12,.hsl .col-11,.hsl .col-10,.hsl .col-9,.hsl .col-8,.hsl .col-7,.hsl .col-6,.hsl .col-5,.hsl .col-4,.hsl .col-3,.hsl .col-2,.hsl .col-1{position:relative;width:100%;padding-right:15px;padding-left:15px}.hsl .col{flex-basis:0;flex-grow:1;max-width:100%}.hsl .row-cols-1>*{flex:0 0 100%;max-width:100%}.hsl .row-cols-2>*{flex:0 0 50%;max-width:50%}.hsl .row-cols-3>*{flex:0 0 33.3333333333%;max-width:33.3333333333%}.hsl .row-cols-4>*{flex:0 0 25%;max-width:25%}.hsl .row-cols-5>*{flex:0 0 20%;max-width:20%}.hsl .row-cols-6>*{flex:0 0 16.6666666667%;max-width:16.6666666667%}.hsl .col-auto{flex:0 0 auto;width:auto;max-width:100%}.hsl .col-1{flex:0 0 8.3333333333%;max-width:8.3333333333%}.hsl .col-2{flex:0 0 16.6666666667%;max-width:16.6666666667%}.hsl .col-3{flex:0 0 25%;max-width:25%}.hsl .col-4{flex:0 0 33.3333333333%;max-width:33.3333333333%}.hsl .col-5{flex:0 0 41.6666666667%;max-width:41.6666666667%}.hsl .col-6{flex:0 0 50%;max-width:50%}.hsl .col-7{flex:0 0 58.3333333333%;max-width:58.3333333333%}.hsl .col-8{flex:0 0 66.6666666667%;max-width:66.6666666667%}.hsl .col-9{flex:0 0 75%;max-width:75%}.hsl .col-10{flex:0 0 83.3333333333%;max-width:83.3333333333%}.hsl .col-11{flex:0 0 91.6666666667%;max-width:91.6666666667%}.hsl .col-12{flex:0 0 100%;max-width:100%}.hsl .order-first{order:-1}.hsl .order-last{order:13}.hsl .order-0{order:0}.hsl .order-1{order:1}.hsl .order-2{order:2}.hsl .order-3{order:3}.hsl .order-4{order:4}.hsl .order-5{order:5}.hsl .order-6{order:6}.hsl .order-7{order:7}.hsl .order-8{order:8}.hsl .order-9{order:9}.hsl .order-10{order:10}.hsl .order-11{order:11}.hsl .order-12{order:12}.hsl .offset-1{margin-left:8.3333333333%}.hsl .offset-2{margin-left:16.6666666667%}.hsl .offset-3{margin-left:25%}.hsl .offset-4{margin-left:33.3333333333%}.hsl .offset-5{margin-left:41.6666666667%}.hsl .offset-6{margin-left:50%}.hsl .offset-7{margin-left:58.3333333333%}.hsl .offset-8{margin-left:66.6666666667%}.hsl .offset-9{margin-left:75%}.hsl .offset-10{margin-left:83.3333333333%}.hsl .offset-11{margin-left:91.6666666667%}@media (min-width: 576px){.hsl .col-sm{flex-basis:0;flex-grow:1;max-width:100%}.hsl .row-cols-sm-1>*{flex:0 0 100%;max-width:100%}.hsl .row-cols-sm-2>*{flex:0 0 50%;max-width:50%}.hsl .row-cols-sm-3>*{flex:0 0 33.3333333333%;max-width:33.3333333333%}.hsl .row-cols-sm-4>*{flex:0 0 25%;max-width:25%}.hsl .row-cols-sm-5>*{flex:0 0 20%;max-width:20%}.hsl .row-cols-sm-6>*{flex:0 0 16.6666666667%;max-width:16.6666666667%}.hsl .col-sm-auto{flex:0 0 auto;width:auto;max-width:100%}.hsl .col-sm-1{flex:0 0 8.3333333333%;max-width:8.3333333333%}.hsl .col-sm-2{flex:0 0 16.6666666667%;max-width:16.6666666667%}.hsl .col-sm-3{flex:0 0 25%;max-width:25%}.hsl .col-sm-4{flex:0 0 33.3333333333%;max-width:33.3333333333%}.hsl .col-sm-5{flex:0 0 41.6666666667%;max-width:41.6666666667%}.hsl .col-sm-6{flex:0 0 50%;max-width:50%}.hsl .col-sm-7{flex:0 0 58.3333333333%;max-width:58.3333333333%}.hsl .col-sm-8{flex:0 0 66.6666666667%;max-width:66.6666666667%}.hsl .col-sm-9{flex:0 0 75%;max-width:75%}.hsl .col-sm-10{flex:0 0 83.3333333333%;max-width:83.3333333333%}.hsl .col-sm-11{flex:0 0 91.6666666667%;max-width:91.6666666667%}.hsl .col-sm-12{flex:0 0 100%;max-width:100%}.hsl .order-sm-first{order:-1}.hsl .order-sm-last{order:13}.hsl .order-sm-0{order:0}.hsl .order-sm-1{order:1}.hsl .order-sm-2{order:2}.hsl .order-sm-3{order:3}.hsl .order-sm-4{order:4}.hsl .order-sm-5{order:5}.hsl .order-sm-6{order:6}.hsl .order-sm-7{order:7}.hsl .order-sm-8{order:8}.hsl .order-sm-9{order:9}.hsl .order-sm-10{order:10}.hsl .order-sm-11{order:11}.hsl .order-sm-12{order:12}.hsl .offset-sm-0{margin-left:0}.hsl .offset-sm-1{margin-left:8.3333333333%}.hsl .offset-sm-2{margin-left:16.6666666667%}.hsl .offset-sm-3{margin-left:25%}.hsl .offset-sm-4{margin-left:33.3333333333%}.hsl .offset-sm-5{margin-left:41.6666666667%}.hsl .offset-sm-6{margin-left:50%}.hsl .offset-sm-7{margin-left:58.3333333333%}.hsl .offset-sm-8{margin-left:66.6666666667%}.hsl .offset-sm-9{margin-left:75%}.hsl .offset-sm-10{margin-left:83.3333333333%}.hsl .offset-sm-11{margin-left:91.6666666667%}}@media (min-width: 768px){.hsl .col-md{flex-basis:0;flex-grow:1;max-width:100%}.hsl .row-cols-md-1>*{flex:0 0 100%;max-width:100%}.hsl .row-cols-md-2>*{flex:0 0 50%;max-width:50%}.hsl .row-cols-md-3>*{flex:0 0 33.3333333333%;max-width:33.3333333333%}.hsl .row-cols-md-4>*{flex:0 0 25%;max-width:25%}.hsl .row-cols-md-5>*{flex:0 0 20%;max-width:20%}.hsl .row-cols-md-6>*{flex:0 0 16.6666666667%;max-width:16.6666666667%}.hsl .col-md-auto{flex:0 0 auto;width:auto;max-width:100%}.hsl .col-md-1{flex:0 0 8.3333333333%;max-width:8.3333333333%}.hsl .col-md-2{flex:0 0 16.6666666667%;max-width:16.6666666667%}.hsl .col-md-3{flex:0 0 25%;max-width:25%}.hsl .col-md-4{flex:0 0 33.3333333333%;max-width:33.3333333333%}.hsl .col-md-5{flex:0 0 41.6666666667%;max-width:41.6666666667%}.hsl .col-md-6{flex:0 0 50%;max-width:50%}.hsl .col-md-7{flex:0 0 58.3333333333%;max-width:58.3333333333%}.hsl .col-md-8{flex:0 0 66.6666666667%;max-width:66.6666666667%}.hsl .col-md-9{flex:0 0 75%;max-width:75%}.hsl .col-md-10{flex:0 0 83.3333333333%;max-width:83.3333333333%}.hsl .col-md-11{flex:0 0 91.6666666667%;max-width:91.6666666667%}.hsl .col-md-12{flex:0 0 100%;max-width:100%}.hsl .order-md-first{order:-1}.hsl .order-md-last{order:13}.hsl .order-md-0{order:0}.hsl .order-md-1{order:1}.hsl .order-md-2{order:2}.hsl .order-md-3{order:3}.hsl .order-md-4{order:4}.hsl .order-md-5{order:5}.hsl .order-md-6{order:6}.hsl .order-md-7{order:7}.hsl .order-md-8{order:8}.hsl .order-md-9{order:9}.hsl .order-md-10{order:10}.hsl .order-md-11{order:11}.hsl .order-md-12{order:12}.hsl .offset-md-0{margin-left:0}.hsl .offset-md-1{margin-left:8.3333333333%}.hsl .offset-md-2{margin-left:16.6666666667%}.hsl .offset-md-3{margin-left:25%}.hsl .offset-md-4{margin-left:33.3333333333%}.hsl .offset-md-5{margin-left:41.6666666667%}.hsl .offset-md-6{margin-left:50%}.hsl .offset-md-7{margin-left:58.3333333333%}.hsl .offset-md-8{margin-left:66.6666666667%}.hsl .offset-md-9{margin-left:75%}.hsl .offset-md-10{margin-left:83.3333333333%}.hsl .offset-md-11{margin-left:91.6666666667%}}@media (min-width: 992px){.hsl .col-lg{flex-basis:0;flex-grow:1;max-width:100%}.hsl .row-cols-lg-1>*{flex:0 0 100%;max-width:100%}.hsl .row-cols-lg-2>*{flex:0 0 50%;max-width:50%}.hsl .row-cols-lg-3>*{flex:0 0 33.3333333333%;max-width:33.3333333333%}.hsl .row-cols-lg-4>*{flex:0 0 25%;max-width:25%}.hsl .row-cols-lg-5>*{flex:0 0 20%;max-width:20%}.hsl .row-cols-lg-6>*{flex:0 0 16.6666666667%;max-width:16.6666666667%}.hsl .col-lg-auto{flex:0 0 auto;width:auto;max-width:100%}.hsl .col-lg-1{flex:0 0 8.3333333333%;max-width:8.3333333333%}.hsl .col-lg-2{flex:0 0 16.6666666667%;max-width:16.6666666667%}.hsl .col-lg-3{flex:0 0 25%;max-width:25%}.hsl .col-lg-4{flex:0 0 33.3333333333%;max-width:33.3333333333%}.hsl .col-lg-5{flex:0 0 41.6666666667%;max-width:41.6666666667%}.hsl .col-lg-6{flex:0 0 50%;max-width:50%}.hsl .col-lg-7{flex:0 0 58.3333333333%;max-width:58.3333333333%}.hsl .col-lg-8{flex:0 0 66.6666666667%;max-width:66.6666666667%}.hsl .col-lg-9{flex:0 0 75%;max-width:75%}.hsl .col-lg-10{flex:0 0 83.3333333333%;max-width:83.3333333333%}.hsl .col-lg-11{flex:0 0 91.6666666667%;max-width:91.6666666667%}.hsl .col-lg-12{flex:0 0 100%;max-width:100%}.hsl .order-lg-first{order:-1}.hsl .order-lg-last{order:13}.hsl .order-lg-0{order:0}.hsl .order-lg-1{order:1}.hsl .order-lg-2{order:2}.hsl .order-lg-3{order:3}.hsl .order-lg-4{order:4}.hsl .order-lg-5{order:5}.hsl .order-lg-6{order:6}.hsl .order-lg-7{order:7}.hsl .order-lg-8{order:8}.hsl .order-lg-9{order:9}.hsl .order-lg-10{order:10}.hsl .order-lg-11{order:11}.hsl .order-lg-12{order:12}.hsl .offset-lg-0{margin-left:0}.hsl .offset-lg-1{margin-left:8.3333333333%}.hsl .offset-lg-2{margin-left:16.6666666667%}.hsl .offset-lg-3{margin-left:25%}.hsl .offset-lg-4{margin-left:33.3333333333%}.hsl .offset-lg-5{margin-left:41.6666666667%}.hsl .offset-lg-6{margin-left:50%}.hsl .offset-lg-7{margin-left:58.3333333333%}.hsl .offset-lg-8{margin-left:66.6666666667%}.hsl .offset-lg-9{margin-left:75%}.hsl .offset-lg-10{margin-left:83.3333333333%}.hsl .offset-lg-11{margin-left:91.6666666667%}}@media (min-width: 1200px){.hsl .col-xl{flex-basis:0;flex-grow:1;max-width:100%}.hsl .row-cols-xl-1>*{flex:0 0 100%;max-width:100%}.hsl .row-cols-xl-2>*{flex:0 0 50%;max-width:50%}.hsl .row-cols-xl-3>*{flex:0 0 33.3333333333%;max-width:33.3333333333%}.hsl .row-cols-xl-4>*{flex:0 0 25%;max-width:25%}.hsl .row-cols-xl-5>*{flex:0 0 20%;max-width:20%}.hsl .row-cols-xl-6>*{flex:0 0 16.6666666667%;max-width:16.6666666667%}.hsl .col-xl-auto{flex:0 0 auto;width:auto;max-width:100%}.hsl .col-xl-1{flex:0 0 8.3333333333%;max-width:8.3333333333%}.hsl .col-xl-2{flex:0 0 16.6666666667%;max-width:16.6666666667%}.hsl .col-xl-3{flex:0 0 25%;max-width:25%}.hsl .col-xl-4{flex:0 0 33.3333333333%;max-width:33.3333333333%}.hsl .col-xl-5{flex:0 0 41.6666666667%;max-width:41.6666666667%}.hsl .col-xl-6{flex:0 0 50%;max-width:50%}.hsl .col-xl-7{flex:0 0 58.3333333333%;max-width:58.3333333333%}.hsl .col-xl-8{flex:0 0 66.6666666667%;max-width:66.6666666667%}.hsl .col-xl-9{flex:0 0 75%;max-width:75%}.hsl .col-xl-10{flex:0 0 83.3333333333%;max-width:83.3333333333%}.hsl .col-xl-11{flex:0 0 91.6666666667%;max-width:91.6666666667%}.hsl .col-xl-12{flex:0 0 100%;max-width:100%}.hsl .order-xl-first{order:-1}.hsl .order-xl-last{order:13}.hsl .order-xl-0{order:0}.hsl .order-xl-1{order:1}.hsl .order-xl-2{order:2}.hsl .order-xl-3{order:3}.hsl .order-xl-4{order:4}.hsl .order-xl-5{order:5}.hsl .order-xl-6{order:6}.hsl .order-xl-7{order:7}.hsl .order-xl-8{order:8}.hsl .order-xl-9{order:9}.hsl .order-xl-10{order:10}.hsl .order-xl-11{order:11}.hsl .order-xl-12{order:12}.hsl .offset-xl-0{margin-left:0}.hsl .offset-xl-1{margin-left:8.3333333333%}.hsl .offset-xl-2{margin-left:16.6666666667%}.hsl .offset-xl-3{margin-left:25%}.hsl .offset-xl-4{margin-left:33.3333333333%}.hsl .offset-xl-5{margin-left:41.6666666667%}.hsl .offset-xl-6{margin-left:50%}.hsl .offset-xl-7{margin-left:58.3333333333%}.hsl .offset-xl-8{margin-left:66.6666666667%}.hsl .offset-xl-9{margin-left:75%}.hsl .offset-xl-10{margin-left:83.3333333333%}.hsl .offset-xl-11{margin-left:91.6666666667%}}.hsl .table{width:100%;margin-bottom:1rem;color:var(--gray-900)}.hsl .table th,.hsl .table td{padding:.75rem;vertical-align:top;border-top:1px solid #dee2e6}.hsl .table thead th{vertical-align:bottom;border-bottom:2px solid #dee2e6}.hsl .table tbody+tbody{border-top:2px solid #dee2e6}.hsl .table-sm th,.hsl .table-sm td{padding:.3rem}.hsl .table-bordered{border:1px solid #dee2e6}.hsl .table-bordered th,.hsl .table-bordered td{border:1px solid #dee2e6}.hsl .table-bordered thead th,.hsl .table-bordered thead td{border-bottom-width:2px}.hsl .table-borderless th,.hsl .table-borderless td,.hsl .table-borderless thead th,.hsl .table-borderless tbody+tbody{border:0}.hsl .table-striped tbody tr:nth-of-type(odd){background-color:#0000000d}.hsl .table-hover tbody tr:hover{color:var(--gray-900);background-color:#00000013}.hsl .table-primary,.hsl .table-primary>th,.hsl .table-primary>td{background-color:hsla(calc(var(--primary-h)),calc(var(--primary-s)),calc((var(--white-l) + var(--primary-l)) / 2),calc((1 + 1) / 2));background-color:hsla(calc(var(--primary-h)),calc(var(--primary-s)),calc((var(--white-l) + var(--primary-l)) / 2),calc((var(--white-a, 1) + var(--primary-a, 1)) / 2))}.hsl .table-primary th,.hsl .table-primary td,.hsl .table-primary thead th,.hsl .table-primary tbody+tbody{border-color:hsla(calc(var(--primary-h)),calc(var(--primary-s)),calc((var(--white-l) + var(--primary-l)) / 2),calc((1 + 1) / 2));border-color:hsla(calc(var(--primary-h)),calc(var(--primary-s)),calc((var(--white-l) + var(--primary-l)) / 2),calc((var(--white-a, 1) + var(--primary-a, 1)) / 2))}.hsl .table-hover .table-primary:hover{background-color:hsla(calc(var(--primary-h)),calc(var(--primary-s)),calc(calc((var(--white-l) + var(--primary-l)) / 2) + -5%),calc((1 + 1) / 2));background-color:hsla(calc(var(--primary-h)),calc(var(--primary-s)),calc(calc((var(--white-l) + var(--primary-l)) / 2) + -5%),calc((var(--white-a, 1) + var(--primary-a, 1)) / 2))}.hsl .table-hover .table-primary:hover>td,.hsl .table-hover .table-primary:hover>th{background-color:hsla(calc(var(--primary-h)),calc(var(--primary-s)),calc(calc((var(--white-l) + var(--primary-l)) / 2) + -5%),calc((1 + 1) / 2));background-color:hsla(calc(var(--primary-h)),calc(var(--primary-s)),calc(calc((var(--white-l) + var(--primary-l)) / 2) + -5%),calc((var(--white-a, 1) + var(--primary-a, 1)) / 2))}.hsl .table-secondary,.hsl .table-secondary>th,.hsl .table-secondary>td{background-color:hsla(calc(var(--secondary-h)),calc(var(--secondary-s)),calc((var(--white-l) + var(--secondary-l)) / 2),calc((1 + 1) / 2));background-color:hsla(calc(var(--secondary-h)),calc(var(--secondary-s)),calc((var(--white-l) + var(--secondary-l)) / 2),calc((var(--white-a, 1) + var(--secondary-a, 1)) / 2))}.hsl .table-secondary th,.hsl .table-secondary td,.hsl .table-secondary thead th,.hsl .table-secondary tbody+tbody{border-color:hsla(calc(var(--secondary-h)),calc(var(--secondary-s)),calc((var(--white-l) + var(--secondary-l)) / 2),calc((1 + 1) / 2));border-color:hsla(calc(var(--secondary-h)),calc(var(--secondary-s)),calc((var(--white-l) + var(--secondary-l)) / 2),calc((var(--white-a, 1) + var(--secondary-a, 1)) / 2))}.hsl .table-hover .table-secondary:hover{background-color:hsla(calc(var(--secondary-h)),calc(var(--secondary-s)),calc(calc((var(--white-l) + var(--secondary-l)) / 2) + -5%),calc((1 + 1) / 2));background-color:hsla(calc(var(--secondary-h)),calc(var(--secondary-s)),calc(calc((var(--white-l) + var(--secondary-l)) / 2) + -5%),calc((var(--white-a, 1) + var(--secondary-a, 1)) / 2))}.hsl .table-hover .table-secondary:hover>td,.hsl .table-hover .table-secondary:hover>th{background-color:hsla(calc(var(--secondary-h)),calc(var(--secondary-s)),calc(calc((var(--white-l) + var(--secondary-l)) / 2) + -5%),calc((1 + 1) / 2));background-color:hsla(calc(var(--secondary-h)),calc(var(--secondary-s)),calc(calc((var(--white-l) + var(--secondary-l)) / 2) + -5%),calc((var(--white-a, 1) + var(--secondary-a, 1)) / 2))}.hsl .table-success,.hsl .table-success>th,.hsl .table-success>td{background-color:hsla(calc(133.7007874016deg),calc(61.3526570048%),calc((var(--white-l) + 40.5882352941%) / 2),calc((1 + 1) / 2));background-color:hsla(calc(133.7007874016deg),calc(61.3526570048%),calc((var(--white-l) + 40.5882352941%) / 2),calc((var(--white-a, 1) + 1) / 2))}.hsl .table-success th,.hsl .table-success td,.hsl .table-success thead th,.hsl .table-success tbody+tbody{border-color:hsla(calc(133.7007874016deg),calc(61.3526570048%),calc((var(--white-l) + 40.5882352941%) / 2),calc((1 + 1) / 2));border-color:hsla(calc(133.7007874016deg),calc(61.3526570048%),calc((var(--white-l) + 40.5882352941%) / 2),calc((var(--white-a, 1) + 1) / 2))}.hsl .table-hover .table-success:hover{background-color:hsla(calc(133.7007874016deg),calc(61.3526570048%),calc(calc((var(--white-l) + 40.5882352941%) / 2) + -5%),calc((1 + 1) / 2));background-color:hsla(calc(133.7007874016deg),calc(61.3526570048%),calc(calc((var(--white-l) + 40.5882352941%) / 2) + -5%),calc((var(--white-a, 1) + 1) / 2))}.hsl .table-hover .table-success:hover>td,.hsl .table-hover .table-success:hover>th{background-color:hsla(calc(133.7007874016deg),calc(61.3526570048%),calc(calc((var(--white-l) + 40.5882352941%) / 2) + -5%),calc((1 + 1) / 2));background-color:hsla(calc(133.7007874016deg),calc(61.3526570048%),calc(calc((var(--white-l) + 40.5882352941%) / 2) + -5%),calc((var(--white-a, 1) + 1) / 2))}.hsl .table-info,.hsl .table-info>th,.hsl .table-info>td{background-color:hsla(calc(188.198757764deg),calc(77.7777777778%),calc((var(--white-l) + 40.5882352941%) / 2),calc((1 + 1) / 2));background-color:hsla(calc(188.198757764deg),calc(77.7777777778%),calc((var(--white-l) + 40.5882352941%) / 2),calc((var(--white-a, 1) + 1) / 2))}.hsl .table-info th,.hsl .table-info td,.hsl .table-info thead th,.hsl .table-info tbody+tbody{border-color:hsla(calc(188.198757764deg),calc(77.7777777778%),calc((var(--white-l) + 40.5882352941%) / 2),calc((1 + 1) / 2));border-color:hsla(calc(188.198757764deg),calc(77.7777777778%),calc((var(--white-l) + 40.5882352941%) / 2),calc((var(--white-a, 1) + 1) / 2))}.hsl .table-hover .table-info:hover{background-color:hsla(calc(188.198757764deg),calc(77.7777777778%),calc(calc((var(--white-l) + 40.5882352941%) / 2) + -5%),calc((1 + 1) / 2));background-color:hsla(calc(188.198757764deg),calc(77.7777777778%),calc(calc((var(--white-l) + 40.5882352941%) / 2) + -5%),calc((var(--white-a, 1) + 1) / 2))}.hsl .table-hover .table-info:hover>td,.hsl .table-hover .table-info:hover>th{background-color:hsla(calc(188.198757764deg),calc(77.7777777778%),calc(calc((var(--white-l) + 40.5882352941%) / 2) + -5%),calc((1 + 1) / 2));background-color:hsla(calc(188.198757764deg),calc(77.7777777778%),calc(calc((var(--white-l) + 40.5882352941%) / 2) + -5%),calc((var(--white-a, 1) + 1) / 2))}.hsl .table-warning,.hsl .table-warning>th,.hsl .table-warning>td{background-color:hsla(calc(45deg),calc(100%),calc((var(--white-l) + 51.3725490196%) / 2),calc((1 + 1) / 2));background-color:hsla(calc(45deg),calc(100%),calc((var(--white-l) + 51.3725490196%) / 2),calc((var(--white-a, 1) + 1) / 2))}.hsl .table-warning th,.hsl .table-warning td,.hsl .table-warning thead th,.hsl .table-warning tbody+tbody{border-color:hsla(calc(45deg),calc(100%),calc((var(--white-l) + 51.3725490196%) / 2),calc((1 + 1) / 2));border-color:hsla(calc(45deg),calc(100%),calc((var(--white-l) + 51.3725490196%) / 2),calc((var(--white-a, 1) + 1) / 2))}.hsl .table-hover .table-warning:hover{background-color:hsla(calc(45deg),calc(100%),calc(calc((var(--white-l) + 51.3725490196%) / 2) + -5%),calc((1 + 1) / 2));background-color:hsla(calc(45deg),calc(100%),calc(calc((var(--white-l) + 51.3725490196%) / 2) + -5%),calc((var(--white-a, 1) + 1) / 2))}.hsl .table-hover .table-warning:hover>td,.hsl .table-hover .table-warning:hover>th{background-color:hsla(calc(45deg),calc(100%),calc(calc((var(--white-l) + 51.3725490196%) / 2) + -5%),calc((1 + 1) / 2));background-color:hsla(calc(45deg),calc(100%),calc(calc((var(--white-l) + 51.3725490196%) / 2) + -5%),calc((var(--white-a, 1) + 1) / 2))}.hsl .table-danger,.hsl .table-danger>th,.hsl .table-danger>td{background-color:hsla(calc(354.251497006deg),calc(70.4641350211%),calc((var(--white-l) + 53.5294117647%) / 2),calc((1 + 1) / 2));background-color:hsla(calc(354.251497006deg),calc(70.4641350211%),calc((var(--white-l) + 53.5294117647%) / 2),calc((var(--white-a, 1) + 1) / 2))}.hsl .table-danger th,.hsl .table-danger td,.hsl .table-danger thead th,.hsl .table-danger tbody+tbody{border-color:hsla(calc(354.251497006deg),calc(70.4641350211%),calc((var(--white-l) + 53.5294117647%) / 2),calc((1 + 1) / 2));border-color:hsla(calc(354.251497006deg),calc(70.4641350211%),calc((var(--white-l) + 53.5294117647%) / 2),calc((var(--white-a, 1) + 1) / 2))}.hsl .table-hover .table-danger:hover{background-color:hsla(calc(354.251497006deg),calc(70.4641350211%),calc(calc((var(--white-l) + 53.5294117647%) / 2) + -5%),calc((1 + 1) / 2));background-color:hsla(calc(354.251497006deg),calc(70.4641350211%),calc(calc((var(--white-l) + 53.5294117647%) / 2) + -5%),calc((var(--white-a, 1) + 1) / 2))}.hsl .table-hover .table-danger:hover>td,.hsl .table-hover .table-danger:hover>th{background-color:hsla(calc(354.251497006deg),calc(70.4641350211%),calc(calc((var(--white-l) + 53.5294117647%) / 2) + -5%),calc((1 + 1) / 2));background-color:hsla(calc(354.251497006deg),calc(70.4641350211%),calc(calc((var(--white-l) + 53.5294117647%) / 2) + -5%),calc((var(--white-a, 1) + 1) / 2))}.hsl .table-light,.hsl .table-light>th,.hsl .table-light>td{background-color:hsla(calc(var(--light-h)),calc(var(--light-s)),calc((var(--white-l) + var(--light-l)) / 2),calc((1 + 1) / 2));background-color:hsla(calc(var(--light-h)),calc(var(--light-s)),calc((var(--white-l) + var(--light-l)) / 2),calc((var(--white-a, 1) + var(--light-a, 1)) / 2))}.hsl .table-light th,.hsl .table-light td,.hsl .table-light thead th,.hsl .table-light tbody+tbody{border-color:hsla(calc(var(--light-h)),calc(var(--light-s)),calc((var(--white-l) + var(--light-l)) / 2),calc((1 + 1) / 2));border-color:hsla(calc(var(--light-h)),calc(var(--light-s)),calc((var(--white-l) + var(--light-l)) / 2),calc((var(--white-a, 1) + var(--light-a, 1)) / 2))}.hsl .table-hover .table-light:hover{background-color:hsla(calc(var(--light-h)),calc(var(--light-s)),calc(calc((var(--white-l) + var(--light-l)) / 2) + -5%),calc((1 + 1) / 2));background-color:hsla(calc(var(--light-h)),calc(var(--light-s)),calc(calc((var(--white-l) + var(--light-l)) / 2) + -5%),calc((var(--white-a, 1) + var(--light-a, 1)) / 2))}.hsl .table-hover .table-light:hover>td,.hsl .table-hover .table-light:hover>th{background-color:hsla(calc(var(--light-h)),calc(var(--light-s)),calc(calc((var(--white-l) + var(--light-l)) / 2) + -5%),calc((1 + 1) / 2));background-color:hsla(calc(var(--light-h)),calc(var(--light-s)),calc(calc((var(--white-l) + var(--light-l)) / 2) + -5%),calc((var(--white-a, 1) + var(--light-a, 1)) / 2))}.hsl .table-dark,.hsl .table-dark>th,.hsl .table-dark>td{background-color:hsla(calc(var(--gray-800-h)),calc(var(--gray-800-s)),calc((var(--white-l) + var(--gray-800-l)) / 2),calc((1 + 1) / 2));background-color:hsla(calc(var(--gray-800-h)),calc(var(--gray-800-s)),calc((var(--white-l) + var(--gray-800-l)) / 2),calc((var(--white-a, 1) + var(--gray-800-a, 1)) / 2))}.hsl .table-dark th,.hsl .table-dark td,.hsl .table-dark thead th,.hsl .table-dark tbody+tbody{border-color:hsla(calc(var(--gray-800-h)),calc(var(--gray-800-s)),calc((var(--white-l) + var(--gray-800-l)) / 2),calc((1 + 1) / 2));border-color:hsla(calc(var(--gray-800-h)),calc(var(--gray-800-s)),calc((var(--white-l) + var(--gray-800-l)) / 2),calc((var(--white-a, 1) + var(--gray-800-a, 1)) / 2))}.hsl .table-hover .table-dark:hover{background-color:hsla(calc(var(--gray-800-h)),calc(var(--gray-800-s)),calc(calc((var(--white-l) + var(--gray-800-l)) / 2) + -5%),calc((1 + 1) / 2));background-color:hsla(calc(var(--gray-800-h)),calc(var(--gray-800-s)),calc(calc((var(--white-l) + var(--gray-800-l)) / 2) + -5%),calc((var(--white-a, 1) + var(--gray-800-a, 1)) / 2))}.hsl .table-hover .table-dark:hover>td,.hsl .table-hover .table-dark:hover>th{background-color:hsla(calc(var(--gray-800-h)),calc(var(--gray-800-s)),calc(calc((var(--white-l) + var(--gray-800-l)) / 2) + -5%),calc((1 + 1) / 2));background-color:hsla(calc(var(--gray-800-h)),calc(var(--gray-800-s)),calc(calc((var(--white-l) + var(--gray-800-l)) / 2) + -5%),calc((var(--white-a, 1) + var(--gray-800-a, 1)) / 2))}.hsl .table-gray,.hsl .table-gray>th,.hsl .table-gray>td{background-color:hsla(calc(var(--gray-900-h)),calc(var(--gray-900-s)),calc((var(--white-l) + var(--gray-900-l)) / 2),calc((1 + 1) / 2));background-color:hsla(calc(var(--gray-900-h)),calc(var(--gray-900-s)),calc((var(--white-l) + var(--gray-900-l)) / 2),calc((var(--white-a, 1) + var(--gray-900-a, 1)) / 2))}.hsl .table-gray th,.hsl .table-gray td,.hsl .table-gray thead th,.hsl .table-gray tbody+tbody{border-color:hsla(calc(var(--gray-900-h)),calc(var(--gray-900-s)),calc((var(--white-l) + var(--gray-900-l)) / 2),calc((1 + 1) / 2));border-color:hsla(calc(var(--gray-900-h)),calc(var(--gray-900-s)),calc((var(--white-l) + var(--gray-900-l)) / 2),calc((var(--white-a, 1) + var(--gray-900-a, 1)) / 2))}.hsl .table-hover .table-gray:hover{background-color:hsla(calc(var(--gray-900-h)),calc(var(--gray-900-s)),calc(calc((var(--white-l) + var(--gray-900-l)) / 2) + -5%),calc((1 + 1) / 2));background-color:hsla(calc(var(--gray-900-h)),calc(var(--gray-900-s)),calc(calc((var(--white-l) + var(--gray-900-l)) / 2) + -5%),calc((var(--white-a, 1) + var(--gray-900-a, 1)) / 2))}.hsl .table-hover .table-gray:hover>td,.hsl .table-hover .table-gray:hover>th{background-color:hsla(calc(var(--gray-900-h)),calc(var(--gray-900-s)),calc(calc((var(--white-l) + var(--gray-900-l)) / 2) + -5%),calc((1 + 1) / 2));background-color:hsla(calc(var(--gray-900-h)),calc(var(--gray-900-s)),calc(calc((var(--white-l) + var(--gray-900-l)) / 2) + -5%),calc((var(--white-a, 1) + var(--gray-900-a, 1)) / 2))}.hsl .table-active,.hsl .table-active>th,.hsl .table-active>td{background-color:#00000013}.hsl .table-hover .table-active:hover{background-color:#00000013}.hsl .table-hover .table-active:hover>td,.hsl .table-hover .table-active:hover>th{background-color:#00000013}.hsl .table .thead-dark th{color:var(--white);background-color:var(--gray-800);border-color:hsla(var(--gray-800-h),var(--gray-800-s),calc(var(--gray-800-l) + 7.5%),1);border-color:hsla(var(--gray-800-h),var(--gray-800-s),calc(var(--gray-800-l) + 7.5%),var(--gray-800-a, 1))}.hsl .table .thead-light th{color:var(--text-color);background-color:var(--gray-200);border-color:#dee2e6}.hsl .table-dark{color:var(--white);background-color:var(--gray-800)}.hsl .table-dark th,.hsl .table-dark td,.hsl .table-dark thead th{border-color:hsla(var(--gray-800-h),var(--gray-800-s),calc(var(--gray-800-l) + 7.5%),1);border-color:hsla(var(--gray-800-h),var(--gray-800-s),calc(var(--gray-800-l) + 7.5%),var(--gray-800-a, 1))}.hsl .table-dark.table-bordered{border:0}.hsl .table-dark.table-striped tbody tr:nth-of-type(odd){background-color:hsla(var(--white-h),var(--white-s),var(--white-l),.05)}.hsl .table-dark.table-hover tbody tr:hover{color:var(--white);background-color:hsla(var(--white-h),var(--white-s),var(--white-l),.075)}@media (max-width: 575.98px){.hsl .table-responsive-sm{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch}.hsl .table-responsive-sm>.table-bordered{border:0}}@media (max-width: 767.98px){.hsl .table-responsive-md{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch}.hsl .table-responsive-md>.table-bordered{border:0}}@media (max-width: 991.98px){.hsl .table-responsive-lg{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch}.hsl .table-responsive-lg>.table-bordered{border:0}}@media (max-width: 1199.98px){.hsl .table-responsive-xl{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch}.hsl .table-responsive-xl>.table-bordered{border:0}}.hsl .table-responsive{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch}.hsl .table-responsive>.table-bordered{border:0}.hsl .form-control{display:block;width:100%;height:calc(1.5em + .75rem + 2px);padding:.375rem .75rem;font-size:1rem;font-weight:400;line-height:1.5;color:var(--text-color);background-color:var(--white);background-clip:padding-box;border:1px solid #ced4da;border-radius:.25rem;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion: reduce){.hsl .form-control{transition:none}}.hsl .form-control::-ms-expand{background-color:transparent;border:0}.hsl .form-control:-moz-focusring{color:transparent;text-shadow:0 0 0 var(--text-color)}.hsl .form-control:focus{color:var(--text-color);background-color:var(--white);border-color:hsla(var(--primary-h),var(--primary-s),calc(var(--primary-l) + 25%),1);border-color:hsla(var(--primary-h),var(--primary-s),calc(var(--primary-l) + 25%),var(--primary-a, 1));outline:0;box-shadow:0 0 0 .2rem hsla(var(--primary-h),var(--primary-s),var(--primary-l),.25)}.hsl .form-control::-moz-placeholder{color:#6c757d;opacity:1}.hsl .form-control::placeholder{color:#6c757d;opacity:1}.hsl .form-control:disabled,.hsl .form-control[readonly]{background-color:var(--gray-200);opacity:1}.hsl input[type=date].form-control,.hsl input[type=time].form-control,.hsl input[type=datetime-local].form-control,.hsl input[type=month].form-control{-webkit-appearance:none;-moz-appearance:none;appearance:none}.hsl select.form-control:focus::-ms-value{color:var(--text-color);background-color:var(--white)}.hsl .form-control-file,.hsl .form-control-range{display:block;width:100%}.hsl .col-form-label{padding-top:calc(.375rem + 1px);padding-bottom:calc(.375rem + 1px);margin-bottom:0;font-size:inherit;line-height:1.5}.hsl .col-form-label-lg{padding-top:calc(.5rem + 1px);padding-bottom:calc(.5rem + 1px);font-size:1.25rem;line-height:1.5}.hsl .col-form-label-sm{padding-top:calc(.25rem + 1px);padding-bottom:calc(.25rem + 1px);font-size:.875rem;line-height:1.5}.hsl .form-control-plaintext{display:block;width:100%;padding:.375rem 0;margin-bottom:0;font-size:1rem;line-height:1.5;color:var(--gray-900);background-color:transparent;border:solid transparent;border-width:1px 0}.hsl .form-control-plaintext.form-control-sm,.hsl .form-control-plaintext.form-control-lg{padding-right:0;padding-left:0}.hsl .form-control-sm{height:calc(1.5em + .5rem + 2px);padding:.25rem .5rem;font-size:.875rem;line-height:1.5;border-radius:.2rem}.hsl .form-control-lg{height:calc(1.5em + 1rem + 2px);padding:.5rem 1rem;font-size:1.25rem;line-height:1.5;border-radius:.3rem}.hsl select.form-control[size],.hsl select.form-control[multiple]{height:auto}.hsl textarea.form-control{height:auto}.hsl .form-group{margin-bottom:1rem}.hsl .form-text{display:block;margin-top:.25rem}.hsl .form-row{display:flex;flex-wrap:wrap;margin-right:-5px;margin-left:-5px}.hsl .form-row>.col,.hsl .form-row>[class*=col-]{padding-right:5px;padding-left:5px}.hsl .form-check{position:relative;display:block;padding-left:1.25rem}.hsl .form-check-input{position:absolute;margin-top:.3rem;margin-left:-1.25rem}.hsl .form-check-input[disabled]~.form-check-label,.hsl .form-check-input:disabled~.form-check-label{color:#6c757d}.hsl .form-check-label{margin-bottom:0}.hsl .form-check-inline{display:inline-flex;align-items:center;padding-left:0;margin-right:.75rem}.hsl .form-check-inline .form-check-input{position:static;margin-top:0;margin-right:.3125rem;margin-left:0}.hsl .valid-feedback{display:none;width:100%;margin-top:.25rem;font-size:80%;color:#28a745}.hsl .valid-tooltip{position:absolute;top:100%;left:0;z-index:5;display:none;max-width:100%;padding:.25rem .5rem;margin-top:.1rem;font-size:.875rem;line-height:1.5;color:var(--white);background-color:#28a745e6;border-radius:.25rem}.form-row>.col>.hsl .valid-tooltip,.form-row>[class*=col-]>.hsl .valid-tooltip{left:5px}.was-validated .hsl:valid~.valid-feedback,.was-validated .hsl:valid~.valid-tooltip,.hsl.is-valid~.valid-feedback,.hsl.is-valid~.valid-tooltip{display:block}.was-validated .hsl .form-control:valid,.hsl .form-control.is-valid{border-color:#28a745;padding-right:calc(1.5em + .75rem);background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%2328a745' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\");background-repeat:no-repeat;background-position:right calc(.375em + .1875rem) center;background-size:calc(.75em + .375rem) calc(.75em + .375rem)}.was-validated .hsl .form-control:valid:focus,.hsl .form-control.is-valid:focus{border-color:#28a745;box-shadow:0 0 0 .2rem #28a74540}.was-validated .hsl textarea.form-control:valid,.hsl textarea.form-control.is-valid{padding-right:calc(1.5em + .75rem);background-position:top calc(.375em + .1875rem) right calc(.375em + .1875rem)}.was-validated .hsl .custom-select:valid,.hsl .custom-select.is-valid{border-color:#28a745;padding-right:calc(.75em + 2.3125rem);background:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='var%28--gray-800%29' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e\") right .75rem center/8px 10px no-repeat,var(--white) url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%2328a745' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\") center right 1.75rem/calc(.75em + .375rem) calc(.75em + .375rem) no-repeat}.was-validated .hsl .custom-select:valid:focus,.hsl .custom-select.is-valid:focus{border-color:#28a745;box-shadow:0 0 0 .2rem #28a74540}.was-validated .hsl .form-check-input:valid~.form-check-label,.hsl .form-check-input.is-valid~.form-check-label{color:#28a745}.was-validated .hsl .form-check-input:valid~.valid-feedback,.was-validated .hsl .form-check-input:valid~.valid-tooltip,.hsl .form-check-input.is-valid~.valid-feedback,.hsl .form-check-input.is-valid~.valid-tooltip{display:block}.was-validated .hsl .custom-control-input:valid~.custom-control-label,.hsl .custom-control-input.is-valid~.custom-control-label{color:#28a745}.was-validated .hsl .custom-control-input:valid~.custom-control-label:before,.hsl .custom-control-input.is-valid~.custom-control-label:before{border-color:#28a745}.was-validated .hsl .custom-control-input:valid:checked~.custom-control-label:before,.hsl .custom-control-input.is-valid:checked~.custom-control-label:before{border-color:#2ebf4f;background-color:#2ebf4f}.was-validated .hsl .custom-control-input:valid:focus~.custom-control-label:before,.hsl .custom-control-input.is-valid:focus~.custom-control-label:before{box-shadow:0 0 0 .2rem #28a74540}.was-validated .hsl .custom-control-input:valid:focus:not(:checked)~.custom-control-label:before,.hsl .custom-control-input.is-valid:focus:not(:checked)~.custom-control-label:before{border-color:#28a745}.was-validated .hsl .custom-file-input:valid~.custom-file-label,.hsl .custom-file-input.is-valid~.custom-file-label{border-color:#28a745}.was-validated .hsl .custom-file-input:valid:focus~.custom-file-label,.hsl .custom-file-input.is-valid:focus~.custom-file-label{border-color:#28a745;box-shadow:0 0 0 .2rem #28a74540}.hsl .invalid-feedback{display:none;width:100%;margin-top:.25rem;font-size:80%;color:#dc3545}.hsl .invalid-tooltip{position:absolute;top:100%;left:0;z-index:5;display:none;max-width:100%;padding:.25rem .5rem;margin-top:.1rem;font-size:.875rem;line-height:1.5;color:var(--white);background-color:#dc3545e6;border-radius:.25rem}.form-row>.col>.hsl .invalid-tooltip,.form-row>[class*=col-]>.hsl .invalid-tooltip{left:5px}.was-validated .hsl:invalid~.invalid-feedback,.was-validated .hsl:invalid~.invalid-tooltip,.hsl.is-invalid~.invalid-feedback,.hsl.is-invalid~.invalid-tooltip{display:block}.was-validated .hsl .form-control:invalid,.hsl .form-control.is-invalid{border-color:#dc3545;padding-right:calc(1.5em + .75rem);background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23dc3545' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e\");background-repeat:no-repeat;background-position:right calc(.375em + .1875rem) center;background-size:calc(.75em + .375rem) calc(.75em + .375rem)}.was-validated .hsl .form-control:invalid:focus,.hsl .form-control.is-invalid:focus{border-color:#dc3545;box-shadow:0 0 0 .2rem #dc354540}.was-validated .hsl textarea.form-control:invalid,.hsl textarea.form-control.is-invalid{padding-right:calc(1.5em + .75rem);background-position:top calc(.375em + .1875rem) right calc(.375em + .1875rem)}.was-validated .hsl .custom-select:invalid,.hsl .custom-select.is-invalid{border-color:#dc3545;padding-right:calc(.75em + 2.3125rem);background:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='var%28--gray-800%29' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e\") right .75rem center/8px 10px no-repeat,var(--white) url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23dc3545' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e\") center right 1.75rem/calc(.75em + .375rem) calc(.75em + .375rem) no-repeat}.was-validated .hsl .custom-select:invalid:focus,.hsl .custom-select.is-invalid:focus{border-color:#dc3545;box-shadow:0 0 0 .2rem #dc354540}.was-validated .hsl .form-check-input:invalid~.form-check-label,.hsl .form-check-input.is-invalid~.form-check-label{color:#dc3545}.was-validated .hsl .form-check-input:invalid~.invalid-feedback,.was-validated .hsl .form-check-input:invalid~.invalid-tooltip,.hsl .form-check-input.is-invalid~.invalid-feedback,.hsl .form-check-input.is-invalid~.invalid-tooltip{display:block}.was-validated .hsl .custom-control-input:invalid~.custom-control-label,.hsl .custom-control-input.is-invalid~.custom-control-label{color:#dc3545}.was-validated .hsl .custom-control-input:invalid~.custom-control-label:before,.hsl .custom-control-input.is-invalid~.custom-control-label:before{border-color:#dc3545}.was-validated .hsl .custom-control-input:invalid:checked~.custom-control-label:before,.hsl .custom-control-input.is-invalid:checked~.custom-control-label:before{border-color:#e04958;background-color:#e04958}.was-validated .hsl .custom-control-input:invalid:focus~.custom-control-label:before,.hsl .custom-control-input.is-invalid:focus~.custom-control-label:before{box-shadow:0 0 0 .2rem #dc354540}.was-validated .hsl .custom-control-input:invalid:focus:not(:checked)~.custom-control-label:before,.hsl .custom-control-input.is-invalid:focus:not(:checked)~.custom-control-label:before{border-color:#dc3545}.was-validated .hsl .custom-file-input:invalid~.custom-file-label,.hsl .custom-file-input.is-invalid~.custom-file-label{border-color:#dc3545}.was-validated .hsl .custom-file-input:invalid:focus~.custom-file-label,.hsl .custom-file-input.is-invalid:focus~.custom-file-label{border-color:#dc3545;box-shadow:0 0 0 .2rem #dc354540}.hsl .form-inline{display:flex;flex-flow:row wrap;align-items:center}.hsl .form-inline .form-check{width:100%}@media (min-width: 576px){.hsl .form-inline label{display:flex;align-items:center;justify-content:center;margin-bottom:0}.hsl .form-inline .form-group{display:flex;flex:0 0 auto;flex-flow:row wrap;align-items:center;margin-bottom:0}.hsl .form-inline .form-control{display:inline-block;width:auto;vertical-align:middle}.hsl .form-inline .form-control-plaintext{display:inline-block}.hsl .form-inline .input-group,.hsl .form-inline .custom-select{width:auto}.hsl .form-inline .form-check{display:flex;align-items:center;justify-content:center;width:auto;padding-left:0}.hsl .form-inline .form-check-input{position:relative;flex-shrink:0;margin-top:0;margin-right:.25rem;margin-left:0}.hsl .form-inline .custom-control{align-items:center;justify-content:center}.hsl .form-inline .custom-control-label{margin-bottom:0}}.hsl .btn{display:inline-block;font-weight:400;color:var(--gray-900);text-align:center;vertical-align:middle;-webkit-user-select:none;-moz-user-select:none;user-select:none;background-color:transparent;border:1px solid transparent;padding:.375rem .75rem;font-size:1rem;line-height:1.5;border-radius:.25rem;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion: reduce){.hsl .btn{transition:none}}.hsl .btn:hover{color:var(--gray-900);text-decoration:none}.hsl .btn:focus,.hsl .btn.focus{outline:0;box-shadow:0 0 0 .2rem hsla(var(--primary-h),var(--primary-s),var(--primary-l),.25)}.hsl .btn.disabled,.hsl .btn:disabled{opacity:.65}.hsl .btn:not(:disabled):not(.disabled){cursor:pointer}.hsl a.btn.disabled,.hsl fieldset:disabled a.btn{pointer-events:none}.hsl .btn-primary{color:hsla(0,0%,calc(-100 * calc(var(--primary-l) - 58.59375%)),1);background-color:var(--primary);border-color:var(--primary)}.hsl .btn-primary:hover{color:hsla(0,0%,calc(-100 * calc(calc(var(--primary-l) + -7.5%) - 58.59375%)),1);background-color:hsla(var(--primary-h),var(--primary-s),calc(var(--primary-l) + -7.5%),1);background-color:hsla(var(--primary-h),var(--primary-s),calc(var(--primary-l) + -7.5%),var(--primary-a, 1));border-color:hsla(var(--primary-h),var(--primary-s),calc(var(--primary-l) + -10%),1);border-color:hsla(var(--primary-h),var(--primary-s),calc(var(--primary-l) + -10%),var(--primary-a, 1))}.hsl .btn-primary:focus,.hsl .btn-primary.focus{color:hsla(0,0%,calc(-100 * calc(calc(var(--primary-l) + -7.5%) - 58.59375%)),1);background-color:hsla(var(--primary-h),var(--primary-s),calc(var(--primary-l) + -7.5%),1);background-color:hsla(var(--primary-h),var(--primary-s),calc(var(--primary-l) + -7.5%),var(--primary-a, 1));border-color:hsla(var(--primary-h),var(--primary-s),calc(var(--primary-l) + -10%),1);border-color:hsla(var(--primary-h),var(--primary-s),calc(var(--primary-l) + -10%),var(--primary-a, 1));box-shadow:0 0 0 .2rem hsla(calc(var(--primary-h)),calc(var(--primary-s)),calc((calc(-100 * calc(var(--primary-l) - 58.59375%)) + var(--primary-l)) / 2),.5)}.hsl .btn-primary.disabled,.hsl .btn-primary:disabled{color:hsla(0,0%,calc(-100 * calc(var(--primary-l) - 58.59375%)),1);background-color:var(--primary);border-color:var(--primary)}.hsl .btn-primary:not(:disabled):not(.disabled):active,.hsl .btn-primary:not(:disabled):not(.disabled).active,.show>.hsl .btn-primary.dropdown-toggle{color:hsla(0,0%,calc(-100 * calc(calc(var(--primary-l) + -10%) - 58.59375%)),1);background-color:hsla(var(--primary-h),var(--primary-s),calc(var(--primary-l) + -10%),1);background-color:hsla(var(--primary-h),var(--primary-s),calc(var(--primary-l) + -10%),var(--primary-a, 1));border-color:hsla(var(--primary-h),var(--primary-s),calc(var(--primary-l) + -12.5%),1);border-color:hsla(var(--primary-h),var(--primary-s),calc(var(--primary-l) + -12.5%),var(--primary-a, 1))}.hsl .btn-primary:not(:disabled):not(.disabled):active:focus,.hsl .btn-primary:not(:disabled):not(.disabled).active:focus,.show>.hsl .btn-primary.dropdown-toggle:focus{box-shadow:0 0 0 .2rem hsla(calc(var(--primary-h)),calc(var(--primary-s)),calc((calc(-100 * calc(var(--primary-l) - 58.59375%)) + var(--primary-l)) / 2),.5)}.hsl .btn-secondary{color:hsla(0,0%,calc(-100 * calc(var(--secondary-l) - 58.59375%)),1);background-color:var(--secondary);border-color:var(--secondary)}.hsl .btn-secondary:hover{color:hsla(0,0%,calc(-100 * calc(calc(var(--secondary-l) + -7.5%) - 58.59375%)),1);background-color:hsla(var(--secondary-h),var(--secondary-s),calc(var(--secondary-l) + -7.5%),1);background-color:hsla(var(--secondary-h),var(--secondary-s),calc(var(--secondary-l) + -7.5%),var(--secondary-a, 1));border-color:hsla(var(--secondary-h),var(--secondary-s),calc(var(--secondary-l) + -10%),1);border-color:hsla(var(--secondary-h),var(--secondary-s),calc(var(--secondary-l) + -10%),var(--secondary-a, 1))}.hsl .btn-secondary:focus,.hsl .btn-secondary.focus{color:hsla(0,0%,calc(-100 * calc(calc(var(--secondary-l) + -7.5%) - 58.59375%)),1);background-color:hsla(var(--secondary-h),var(--secondary-s),calc(var(--secondary-l) + -7.5%),1);background-color:hsla(var(--secondary-h),var(--secondary-s),calc(var(--secondary-l) + -7.5%),var(--secondary-a, 1));border-color:hsla(var(--secondary-h),var(--secondary-s),calc(var(--secondary-l) + -10%),1);border-color:hsla(var(--secondary-h),var(--secondary-s),calc(var(--secondary-l) + -10%),var(--secondary-a, 1));box-shadow:0 0 0 .2rem hsla(calc(var(--secondary-h)),calc(var(--secondary-s)),calc((calc(-100 * calc(var(--secondary-l) - 58.59375%)) + var(--secondary-l)) / 2),.5)}.hsl .btn-secondary.disabled,.hsl .btn-secondary:disabled{color:hsla(0,0%,calc(-100 * calc(var(--secondary-l) - 58.59375%)),1);background-color:var(--secondary);border-color:var(--secondary)}.hsl .btn-secondary:not(:disabled):not(.disabled):active,.hsl .btn-secondary:not(:disabled):not(.disabled).active,.show>.hsl .btn-secondary.dropdown-toggle{color:hsla(0,0%,calc(-100 * calc(calc(var(--secondary-l) + -10%) - 58.59375%)),1);background-color:hsla(var(--secondary-h),var(--secondary-s),calc(var(--secondary-l) + -10%),1);background-color:hsla(var(--secondary-h),var(--secondary-s),calc(var(--secondary-l) + -10%),var(--secondary-a, 1));border-color:hsla(var(--secondary-h),var(--secondary-s),calc(var(--secondary-l) + -12.5%),1);border-color:hsla(var(--secondary-h),var(--secondary-s),calc(var(--secondary-l) + -12.5%),var(--secondary-a, 1))}.hsl .btn-secondary:not(:disabled):not(.disabled):active:focus,.hsl .btn-secondary:not(:disabled):not(.disabled).active:focus,.show>.hsl .btn-secondary.dropdown-toggle:focus{box-shadow:0 0 0 .2rem hsla(calc(var(--secondary-h)),calc(var(--secondary-s)),calc((calc(-100 * calc(var(--secondary-l) - 58.59375%)) + var(--secondary-l)) / 2),.5)}.hsl .btn-success{color:var(--white);background-color:#28a745;border-color:#28a745}.hsl .btn-success:hover{color:var(--white);background-color:#259a40;border-color:#24963e}.hsl .btn-success:focus,.hsl .btn-success.focus{color:var(--white);background-color:#259a40;border-color:#24963e;box-shadow:0 0 0 .2rem hsla(calc(133.7007874016deg),calc(61.3526570048%),calc((var(--white-l) + 40.5882352941%) / 2),.5)}.hsl .btn-success.disabled,.hsl .btn-success:disabled{color:var(--white);background-color:#28a745;border-color:#28a745}.hsl .btn-success:not(:disabled):not(.disabled):active,.hsl .btn-success:not(:disabled):not(.disabled).active,.show>.hsl .btn-success.dropdown-toggle{color:var(--white);background-color:#24963e;border-color:#23923c}.hsl .btn-success:not(:disabled):not(.disabled):active:focus,.hsl .btn-success:not(:disabled):not(.disabled).active:focus,.show>.hsl .btn-success.dropdown-toggle:focus{box-shadow:0 0 0 .2rem hsla(calc(133.7007874016deg),calc(61.3526570048%),calc((var(--white-l) + 40.5882352941%) / 2),.5)}.hsl .btn-info{color:var(--white);background-color:#17a2b8;border-color:#17a2b8}.hsl .btn-info:hover{color:var(--white);background-color:#1596aa;border-color:#1592a6}.hsl .btn-info:focus,.hsl .btn-info.focus{color:var(--white);background-color:#1596aa;border-color:#1592a6;box-shadow:0 0 0 .2rem hsla(calc(188.198757764deg),calc(77.7777777778%),calc((var(--white-l) + 40.5882352941%) / 2),.5)}.hsl .btn-info.disabled,.hsl .btn-info:disabled{color:var(--white);background-color:#17a2b8;border-color:#17a2b8}.hsl .btn-info:not(:disabled):not(.disabled):active,.hsl .btn-info:not(:disabled):not(.disabled).active,.show>.hsl .btn-info.dropdown-toggle{color:var(--white);background-color:#1592a6;border-color:#148ea1}.hsl .btn-info:not(:disabled):not(.disabled):active:focus,.hsl .btn-info:not(:disabled):not(.disabled).active:focus,.show>.hsl .btn-info.dropdown-toggle:focus{box-shadow:0 0 0 .2rem hsla(calc(188.198757764deg),calc(77.7777777778%),calc((var(--white-l) + 40.5882352941%) / 2),.5)}.hsl .btn-warning{color:var(--gray-900);background-color:#ffc107;border-color:#ffc107}.hsl .btn-warning:hover{color:var(--gray-900);background-color:#f2b600;border-color:#ecb100}.hsl .btn-warning:focus,.hsl .btn-warning.focus{color:var(--gray-900);background-color:#f2b600;border-color:#ecb100;box-shadow:0 0 0 .2rem hsla(calc(45deg),calc(100%),calc((var(--gray-900-l) + 51.3725490196%) / 2),.5)}.hsl .btn-warning.disabled,.hsl .btn-warning:disabled{color:var(--gray-900);background-color:#ffc107;border-color:#ffc107}.hsl .btn-warning:not(:disabled):not(.disabled):active,.hsl .btn-warning:not(:disabled):not(.disabled).active,.show>.hsl .btn-warning.dropdown-toggle{color:var(--gray-900);background-color:#ecb100;border-color:#e5ac00}.hsl .btn-warning:not(:disabled):not(.disabled):active:focus,.hsl .btn-warning:not(:disabled):not(.disabled).active:focus,.show>.hsl .btn-warning.dropdown-toggle:focus{box-shadow:0 0 0 .2rem hsla(calc(45deg),calc(100%),calc((var(--gray-900-l) + 51.3725490196%) / 2),.5)}.hsl .btn-danger{color:var(--white);background-color:#dc3545;border-color:#dc3545}.hsl .btn-danger:hover{color:var(--white);background-color:#d72536;border-color:#d12435}.hsl .btn-danger:focus,.hsl .btn-danger.focus{color:var(--white);background-color:#d72536;border-color:#d12435;box-shadow:0 0 0 .2rem hsla(calc(354.251497006deg),calc(70.4641350211%),calc((var(--white-l) + 53.5294117647%) / 2),.5)}.hsl .btn-danger.disabled,.hsl .btn-danger:disabled{color:var(--white);background-color:#dc3545;border-color:#dc3545}.hsl .btn-danger:not(:disabled):not(.disabled):active,.hsl .btn-danger:not(:disabled):not(.disabled).active,.show>.hsl .btn-danger.dropdown-toggle{color:var(--white);background-color:#d12435;border-color:#cc2333}.hsl .btn-danger:not(:disabled):not(.disabled):active:focus,.hsl .btn-danger:not(:disabled):not(.disabled).active:focus,.show>.hsl .btn-danger.dropdown-toggle:focus{box-shadow:0 0 0 .2rem hsla(calc(354.251497006deg),calc(70.4641350211%),calc((var(--white-l) + 53.5294117647%) / 2),.5)}.hsl .btn-light{color:hsla(0,0%,calc(-100 * calc(var(--light-l) - 58.59375%)),1);background-color:var(--light);border-color:var(--light)}.hsl .btn-light:hover{color:hsla(0,0%,calc(-100 * calc(calc(var(--light-l) + -7.5%) - 58.59375%)),1);background-color:hsla(var(--light-h),var(--light-s),calc(var(--light-l) + -7.5%),1);background-color:hsla(var(--light-h),var(--light-s),calc(var(--light-l) + -7.5%),var(--light-a, 1));border-color:hsla(var(--light-h),var(--light-s),calc(var(--light-l) + -10%),1);border-color:hsla(var(--light-h),var(--light-s),calc(var(--light-l) + -10%),var(--light-a, 1))}.hsl .btn-light:focus,.hsl .btn-light.focus{color:hsla(0,0%,calc(-100 * calc(calc(var(--light-l) + -7.5%) - 58.59375%)),1);background-color:hsla(var(--light-h),var(--light-s),calc(var(--light-l) + -7.5%),1);background-color:hsla(var(--light-h),var(--light-s),calc(var(--light-l) + -7.5%),var(--light-a, 1));border-color:hsla(var(--light-h),var(--light-s),calc(var(--light-l) + -10%),1);border-color:hsla(var(--light-h),var(--light-s),calc(var(--light-l) + -10%),var(--light-a, 1));box-shadow:0 0 0 .2rem hsla(calc(var(--light-h)),calc(var(--light-s)),calc((calc(-100 * calc(var(--light-l) - 58.59375%)) + var(--light-l)) / 2),.5)}.hsl .btn-light.disabled,.hsl .btn-light:disabled{color:hsla(0,0%,calc(-100 * calc(var(--light-l) - 58.59375%)),1);background-color:var(--light);border-color:var(--light)}.hsl .btn-light:not(:disabled):not(.disabled):active,.hsl .btn-light:not(:disabled):not(.disabled).active,.show>.hsl .btn-light.dropdown-toggle{color:hsla(0,0%,calc(-100 * calc(calc(var(--light-l) + -10%) - 58.59375%)),1);background-color:hsla(var(--light-h),var(--light-s),calc(var(--light-l) + -10%),1);background-color:hsla(var(--light-h),var(--light-s),calc(var(--light-l) + -10%),var(--light-a, 1));border-color:hsla(var(--light-h),var(--light-s),calc(var(--light-l) + -12.5%),1);border-color:hsla(var(--light-h),var(--light-s),calc(var(--light-l) + -12.5%),var(--light-a, 1))}.hsl .btn-light:not(:disabled):not(.disabled):active:focus,.hsl .btn-light:not(:disabled):not(.disabled).active:focus,.show>.hsl .btn-light.dropdown-toggle:focus{box-shadow:0 0 0 .2rem hsla(calc(var(--light-h)),calc(var(--light-s)),calc((calc(-100 * calc(var(--light-l) - 58.59375%)) + var(--light-l)) / 2),.5)}.hsl .btn-dark{color:hsla(0,0%,calc(-100 * calc(var(--gray-800-l) - 58.59375%)),1);background-color:var(--gray-800);border-color:var(--gray-800)}.hsl .btn-dark:hover{color:hsla(0,0%,calc(-100 * calc(calc(var(--gray-800-l) + -7.5%) - 58.59375%)),1);background-color:hsla(var(--gray-800-h),var(--gray-800-s),calc(var(--gray-800-l) + -7.5%),1);background-color:hsla(var(--gray-800-h),var(--gray-800-s),calc(var(--gray-800-l) + -7.5%),var(--gray-800-a, 1));border-color:hsla(var(--gray-800-h),var(--gray-800-s),calc(var(--gray-800-l) + -10%),1);border-color:hsla(var(--gray-800-h),var(--gray-800-s),calc(var(--gray-800-l) + -10%),var(--gray-800-a, 1))}.hsl .btn-dark:focus,.hsl .btn-dark.focus{color:hsla(0,0%,calc(-100 * calc(calc(var(--gray-800-l) + -7.5%) - 58.59375%)),1);background-color:hsla(var(--gray-800-h),var(--gray-800-s),calc(var(--gray-800-l) + -7.5%),1);background-color:hsla(var(--gray-800-h),var(--gray-800-s),calc(var(--gray-800-l) + -7.5%),var(--gray-800-a, 1));border-color:hsla(var(--gray-800-h),var(--gray-800-s),calc(var(--gray-800-l) + -10%),1);border-color:hsla(var(--gray-800-h),var(--gray-800-s),calc(var(--gray-800-l) + -10%),var(--gray-800-a, 1));box-shadow:0 0 0 .2rem hsla(calc(var(--gray-800-h)),calc(var(--gray-800-s)),calc((calc(-100 * calc(var(--gray-800-l) - 58.59375%)) + var(--gray-800-l)) / 2),.5)}.hsl .btn-dark.disabled,.hsl .btn-dark:disabled{color:hsla(0,0%,calc(-100 * calc(var(--gray-800-l) - 58.59375%)),1);background-color:var(--gray-800);border-color:var(--gray-800)}.hsl .btn-dark:not(:disabled):not(.disabled):active,.hsl .btn-dark:not(:disabled):not(.disabled).active,.show>.hsl .btn-dark.dropdown-toggle{color:hsla(0,0%,calc(-100 * calc(calc(var(--gray-800-l) + -10%) - 58.59375%)),1);background-color:hsla(var(--gray-800-h),var(--gray-800-s),calc(var(--gray-800-l) + -10%),1);background-color:hsla(var(--gray-800-h),var(--gray-800-s),calc(var(--gray-800-l) + -10%),var(--gray-800-a, 1));border-color:hsla(var(--gray-800-h),var(--gray-800-s),calc(var(--gray-800-l) + -12.5%),1);border-color:hsla(var(--gray-800-h),var(--gray-800-s),calc(var(--gray-800-l) + -12.5%),var(--gray-800-a, 1))}.hsl .btn-dark:not(:disabled):not(.disabled):active:focus,.hsl .btn-dark:not(:disabled):not(.disabled).active:focus,.show>.hsl .btn-dark.dropdown-toggle:focus{box-shadow:0 0 0 .2rem hsla(calc(var(--gray-800-h)),calc(var(--gray-800-s)),calc((calc(-100 * calc(var(--gray-800-l) - 58.59375%)) + var(--gray-800-l)) / 2),.5)}.hsl .btn-gray{color:hsla(0,0%,calc(-100 * calc(var(--gray-900-l) - 58.59375%)),1);background-color:var(--gray-900);border-color:var(--gray-900)}.hsl .btn-gray:hover{color:hsla(0,0%,calc(-100 * calc(calc(var(--gray-900-l) + -7.5%) - 58.59375%)),1);background-color:hsla(var(--gray-900-h),var(--gray-900-s),calc(var(--gray-900-l) + -7.5%),1);background-color:hsla(var(--gray-900-h),var(--gray-900-s),calc(var(--gray-900-l) + -7.5%),var(--gray-900-a, 1));border-color:hsla(var(--gray-900-h),var(--gray-900-s),calc(var(--gray-900-l) + -10%),1);border-color:hsla(var(--gray-900-h),var(--gray-900-s),calc(var(--gray-900-l) + -10%),var(--gray-900-a, 1))}.hsl .btn-gray:focus,.hsl .btn-gray.focus{color:hsla(0,0%,calc(-100 * calc(calc(var(--gray-900-l) + -7.5%) - 58.59375%)),1);background-color:hsla(var(--gray-900-h),var(--gray-900-s),calc(var(--gray-900-l) + -7.5%),1);background-color:hsla(var(--gray-900-h),var(--gray-900-s),calc(var(--gray-900-l) + -7.5%),var(--gray-900-a, 1));border-color:hsla(var(--gray-900-h),var(--gray-900-s),calc(var(--gray-900-l) + -10%),1);border-color:hsla(var(--gray-900-h),var(--gray-900-s),calc(var(--gray-900-l) + -10%),var(--gray-900-a, 1));box-shadow:0 0 0 .2rem hsla(calc(var(--gray-900-h)),calc(var(--gray-900-s)),calc((calc(-100 * calc(var(--gray-900-l) - 58.59375%)) + var(--gray-900-l)) / 2),.5)}.hsl .btn-gray.disabled,.hsl .btn-gray:disabled{color:hsla(0,0%,calc(-100 * calc(var(--gray-900-l) - 58.59375%)),1);background-color:var(--gray-900);border-color:var(--gray-900)}.hsl .btn-gray:not(:disabled):not(.disabled):active,.hsl .btn-gray:not(:disabled):not(.disabled).active,.show>.hsl .btn-gray.dropdown-toggle{color:hsla(0,0%,calc(-100 * calc(calc(var(--gray-900-l) + -10%) - 58.59375%)),1);background-color:hsla(var(--gray-900-h),var(--gray-900-s),calc(var(--gray-900-l) + -10%),1);background-color:hsla(var(--gray-900-h),var(--gray-900-s),calc(var(--gray-900-l) + -10%),var(--gray-900-a, 1));border-color:hsla(var(--gray-900-h),var(--gray-900-s),calc(var(--gray-900-l) + -12.5%),1);border-color:hsla(var(--gray-900-h),var(--gray-900-s),calc(var(--gray-900-l) + -12.5%),var(--gray-900-a, 1))}.hsl .btn-gray:not(:disabled):not(.disabled):active:focus,.hsl .btn-gray:not(:disabled):not(.disabled).active:focus,.show>.hsl .btn-gray.dropdown-toggle:focus{box-shadow:0 0 0 .2rem hsla(calc(var(--gray-900-h)),calc(var(--gray-900-s)),calc((calc(-100 * calc(var(--gray-900-l) - 58.59375%)) + var(--gray-900-l)) / 2),.5)}.hsl .btn-outline-primary{color:var(--primary);border-color:var(--primary)}.hsl .btn-outline-primary:hover{color:hsla(0,0%,calc(-100 * calc(var(--primary-l) - 58.59375%)),1);background-color:var(--primary);border-color:var(--primary)}.hsl .btn-outline-primary:focus,.hsl .btn-outline-primary.focus{box-shadow:0 0 0 .2rem hsla(var(--primary-h),var(--primary-s),var(--primary-l),.5)}.hsl .btn-outline-primary.disabled,.hsl .btn-outline-primary:disabled{color:var(--primary);background-color:transparent}.hsl .btn-outline-primary:not(:disabled):not(.disabled):active,.hsl .btn-outline-primary:not(:disabled):not(.disabled).active,.show>.hsl .btn-outline-primary.dropdown-toggle{color:hsla(0,0%,calc(-100 * calc(var(--primary-l) - 58.59375%)),1);background-color:var(--primary);border-color:var(--primary)}.hsl .btn-outline-primary:not(:disabled):not(.disabled):active:focus,.hsl .btn-outline-primary:not(:disabled):not(.disabled).active:focus,.show>.hsl .btn-outline-primary.dropdown-toggle:focus{box-shadow:0 0 0 .2rem hsla(var(--primary-h),var(--primary-s),var(--primary-l),.5)}.hsl .btn-outline-secondary{color:var(--secondary);border-color:var(--secondary)}.hsl .btn-outline-secondary:hover{color:hsla(0,0%,calc(-100 * calc(var(--secondary-l) - 58.59375%)),1);background-color:var(--secondary);border-color:var(--secondary)}.hsl .btn-outline-secondary:focus,.hsl .btn-outline-secondary.focus{box-shadow:0 0 0 .2rem hsla(var(--secondary-h),var(--secondary-s),var(--secondary-l),.5)}.hsl .btn-outline-secondary.disabled,.hsl .btn-outline-secondary:disabled{color:var(--secondary);background-color:transparent}.hsl .btn-outline-secondary:not(:disabled):not(.disabled):active,.hsl .btn-outline-secondary:not(:disabled):not(.disabled).active,.show>.hsl .btn-outline-secondary.dropdown-toggle{color:hsla(0,0%,calc(-100 * calc(var(--secondary-l) - 58.59375%)),1);background-color:var(--secondary);border-color:var(--secondary)}.hsl .btn-outline-secondary:not(:disabled):not(.disabled):active:focus,.hsl .btn-outline-secondary:not(:disabled):not(.disabled).active:focus,.show>.hsl .btn-outline-secondary.dropdown-toggle:focus{box-shadow:0 0 0 .2rem hsla(var(--secondary-h),var(--secondary-s),var(--secondary-l),.5)}.hsl .btn-outline-success{color:#28a745;border-color:#28a745}.hsl .btn-outline-success:hover{color:var(--white);background-color:#28a745;border-color:#28a745}.hsl .btn-outline-success:focus,.hsl .btn-outline-success.focus{box-shadow:0 0 0 .2rem #28a74580}.hsl .btn-outline-success.disabled,.hsl .btn-outline-success:disabled{color:#28a745;background-color:transparent}.hsl .btn-outline-success:not(:disabled):not(.disabled):active,.hsl .btn-outline-success:not(:disabled):not(.disabled).active,.show>.hsl .btn-outline-success.dropdown-toggle{color:var(--white);background-color:#28a745;border-color:#28a745}.hsl .btn-outline-success:not(:disabled):not(.disabled):active:focus,.hsl .btn-outline-success:not(:disabled):not(.disabled).active:focus,.show>.hsl .btn-outline-success.dropdown-toggle:focus{box-shadow:0 0 0 .2rem #28a74580}.hsl .btn-outline-info{color:#17a2b8;border-color:#17a2b8}.hsl .btn-outline-info:hover{color:var(--white);background-color:#17a2b8;border-color:#17a2b8}.hsl .btn-outline-info:focus,.hsl .btn-outline-info.focus{box-shadow:0 0 0 .2rem #17a2b880}.hsl .btn-outline-info.disabled,.hsl .btn-outline-info:disabled{color:#17a2b8;background-color:transparent}.hsl .btn-outline-info:not(:disabled):not(.disabled):active,.hsl .btn-outline-info:not(:disabled):not(.disabled).active,.show>.hsl .btn-outline-info.dropdown-toggle{color:var(--white);background-color:#17a2b8;border-color:#17a2b8}.hsl .btn-outline-info:not(:disabled):not(.disabled):active:focus,.hsl .btn-outline-info:not(:disabled):not(.disabled).active:focus,.show>.hsl .btn-outline-info.dropdown-toggle:focus{box-shadow:0 0 0 .2rem #17a2b880}.hsl .btn-outline-warning{color:#ffc107;border-color:#ffc107}.hsl .btn-outline-warning:hover{color:var(--gray-900);background-color:#ffc107;border-color:#ffc107}.hsl .btn-outline-warning:focus,.hsl .btn-outline-warning.focus{box-shadow:0 0 0 .2rem #ffc10780}.hsl .btn-outline-warning.disabled,.hsl .btn-outline-warning:disabled{color:#ffc107;background-color:transparent}.hsl .btn-outline-warning:not(:disabled):not(.disabled):active,.hsl .btn-outline-warning:not(:disabled):not(.disabled).active,.show>.hsl .btn-outline-warning.dropdown-toggle{color:var(--gray-900);background-color:#ffc107;border-color:#ffc107}.hsl .btn-outline-warning:not(:disabled):not(.disabled):active:focus,.hsl .btn-outline-warning:not(:disabled):not(.disabled).active:focus,.show>.hsl .btn-outline-warning.dropdown-toggle:focus{box-shadow:0 0 0 .2rem #ffc10780}.hsl .btn-outline-danger{color:#dc3545;border-color:#dc3545}.hsl .btn-outline-danger:hover{color:var(--white);background-color:#dc3545;border-color:#dc3545}.hsl .btn-outline-danger:focus,.hsl .btn-outline-danger.focus{box-shadow:0 0 0 .2rem #dc354580}.hsl .btn-outline-danger.disabled,.hsl .btn-outline-danger:disabled{color:#dc3545;background-color:transparent}.hsl .btn-outline-danger:not(:disabled):not(.disabled):active,.hsl .btn-outline-danger:not(:disabled):not(.disabled).active,.show>.hsl .btn-outline-danger.dropdown-toggle{color:var(--white);background-color:#dc3545;border-color:#dc3545}.hsl .btn-outline-danger:not(:disabled):not(.disabled):active:focus,.hsl .btn-outline-danger:not(:disabled):not(.disabled).active:focus,.show>.hsl .btn-outline-danger.dropdown-toggle:focus{box-shadow:0 0 0 .2rem #dc354580}.hsl .btn-outline-light{color:var(--light);border-color:var(--light)}.hsl .btn-outline-light:hover{color:hsla(0,0%,calc(-100 * calc(var(--light-l) - 58.59375%)),1);background-color:var(--light);border-color:var(--light)}.hsl .btn-outline-light:focus,.hsl .btn-outline-light.focus{box-shadow:0 0 0 .2rem hsla(var(--light-h),var(--light-s),var(--light-l),.5)}.hsl .btn-outline-light.disabled,.hsl .btn-outline-light:disabled{color:var(--light);background-color:transparent}.hsl .btn-outline-light:not(:disabled):not(.disabled):active,.hsl .btn-outline-light:not(:disabled):not(.disabled).active,.show>.hsl .btn-outline-light.dropdown-toggle{color:hsla(0,0%,calc(-100 * calc(var(--light-l) - 58.59375%)),1);background-color:var(--light);border-color:var(--light)}.hsl .btn-outline-light:not(:disabled):not(.disabled):active:focus,.hsl .btn-outline-light:not(:disabled):not(.disabled).active:focus,.show>.hsl .btn-outline-light.dropdown-toggle:focus{box-shadow:0 0 0 .2rem hsla(var(--light-h),var(--light-s),var(--light-l),.5)}.hsl .btn-outline-dark{color:var(--gray-800);border-color:var(--gray-800)}.hsl .btn-outline-dark:hover{color:hsla(0,0%,calc(-100 * calc(var(--gray-800-l) - 58.59375%)),1);background-color:var(--gray-800);border-color:var(--gray-800)}.hsl .btn-outline-dark:focus,.hsl .btn-outline-dark.focus{box-shadow:0 0 0 .2rem hsla(var(--gray-800-h),var(--gray-800-s),var(--gray-800-l),.5)}.hsl .btn-outline-dark.disabled,.hsl .btn-outline-dark:disabled{color:var(--gray-800);background-color:transparent}.hsl .btn-outline-dark:not(:disabled):not(.disabled):active,.hsl .btn-outline-dark:not(:disabled):not(.disabled).active,.show>.hsl .btn-outline-dark.dropdown-toggle{color:hsla(0,0%,calc(-100 * calc(var(--gray-800-l) - 58.59375%)),1);background-color:var(--gray-800);border-color:var(--gray-800)}.hsl .btn-outline-dark:not(:disabled):not(.disabled):active:focus,.hsl .btn-outline-dark:not(:disabled):not(.disabled).active:focus,.show>.hsl .btn-outline-dark.dropdown-toggle:focus{box-shadow:0 0 0 .2rem hsla(var(--gray-800-h),var(--gray-800-s),var(--gray-800-l),.5)}.hsl .btn-outline-gray{color:var(--gray-900);border-color:var(--gray-900)}.hsl .btn-outline-gray:hover{color:hsla(0,0%,calc(-100 * calc(var(--gray-900-l) - 58.59375%)),1);background-color:var(--gray-900);border-color:var(--gray-900)}.hsl .btn-outline-gray:focus,.hsl .btn-outline-gray.focus{box-shadow:0 0 0 .2rem hsla(var(--gray-900-h),var(--gray-900-s),var(--gray-900-l),.5)}.hsl .btn-outline-gray.disabled,.hsl .btn-outline-gray:disabled{color:var(--gray-900);background-color:transparent}.hsl .btn-outline-gray:not(:disabled):not(.disabled):active,.hsl .btn-outline-gray:not(:disabled):not(.disabled).active,.show>.hsl .btn-outline-gray.dropdown-toggle{color:hsla(0,0%,calc(-100 * calc(var(--gray-900-l) - 58.59375%)),1);background-color:var(--gray-900);border-color:var(--gray-900)}.hsl .btn-outline-gray:not(:disabled):not(.disabled):active:focus,.hsl .btn-outline-gray:not(:disabled):not(.disabled).active:focus,.show>.hsl .btn-outline-gray.dropdown-toggle:focus{box-shadow:0 0 0 .2rem hsla(var(--gray-900-h),var(--gray-900-s),var(--gray-900-l),.5)}.hsl .btn-link{font-weight:400;color:var(--primary);text-decoration:none}.hsl .btn-link:hover{color:hsla(var(--primary-h),var(--primary-s),calc(var(--primary-l) + -15%),1);color:hsla(var(--primary-h),var(--primary-s),calc(var(--primary-l) + -15%),var(--primary-a, 1));text-decoration:underline}.hsl .btn-link:focus,.hsl .btn-link.focus{text-decoration:underline}.hsl .btn-link:disabled,.hsl .btn-link.disabled{color:#6c757d;pointer-events:none}.hsl .btn-lg,.hsl .btn-group-lg>.btn{padding:.5rem 1rem;font-size:1.25rem;line-height:1.5;border-radius:.3rem}.hsl .btn-sm,.hsl .btn-group-sm>.btn{padding:.25rem .5rem;font-size:.875rem;line-height:1.5;border-radius:.2rem}.hsl .btn-block{display:block;width:100%}.hsl .btn-block+.btn-block{margin-top:.5rem}.hsl input[type=submit].btn-block,.hsl input[type=reset].btn-block,.hsl input[type=button].btn-block{width:100%}.hsl .dropup,.hsl .dropright,.hsl .dropdown,.hsl .dropleft{position:relative}.hsl .dropdown-toggle{white-space:nowrap}.hsl .dropdown-toggle:after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid;border-right:.3em solid transparent;border-bottom:0;border-left:.3em solid transparent}.hsl .dropdown-toggle:empty:after{margin-left:0}.hsl .dropdown-menu{position:absolute;top:100%;left:0;z-index:1000;display:none;float:left;min-width:10rem;padding:.5rem 0;margin:.125rem 0 0;font-size:1rem;color:var(--gray-900);text-align:left;list-style:none;background-color:var(--white);background-clip:padding-box;border:1px solid rgba(0,0,0,.15);border-radius:.25rem}.hsl .dropdown-menu-left{right:auto;left:0}.hsl .dropdown-menu-right{right:0;left:auto}@media (min-width: 576px){.hsl .dropdown-menu-sm-left{right:auto;left:0}.hsl .dropdown-menu-sm-right{right:0;left:auto}}@media (min-width: 768px){.hsl .dropdown-menu-md-left{right:auto;left:0}.hsl .dropdown-menu-md-right{right:0;left:auto}}@media (min-width: 992px){.hsl .dropdown-menu-lg-left{right:auto;left:0}.hsl .dropdown-menu-lg-right{right:0;left:auto}}@media (min-width: 1200px){.hsl .dropdown-menu-xl-left{right:auto;left:0}.hsl .dropdown-menu-xl-right{right:0;left:auto}}.hsl .dropup .dropdown-menu{top:auto;bottom:100%;margin-top:0;margin-bottom:.125rem}.hsl .dropup .dropdown-toggle:after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:0;border-right:.3em solid transparent;border-bottom:.3em solid;border-left:.3em solid transparent}.hsl .dropup .dropdown-toggle:empty:after{margin-left:0}.hsl .dropright .dropdown-menu{top:0;right:auto;left:100%;margin-top:0;margin-left:.125rem}.hsl .dropright .dropdown-toggle:after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid transparent;border-right:0;border-bottom:.3em solid transparent;border-left:.3em solid}.hsl .dropright .dropdown-toggle:empty:after{margin-left:0}.hsl .dropright .dropdown-toggle:after{vertical-align:0}.hsl .dropleft .dropdown-menu{top:0;right:100%;left:auto;margin-top:0;margin-right:.125rem}.hsl .dropleft .dropdown-toggle:after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\"}.hsl .dropleft .dropdown-toggle:after{display:none}.hsl .dropleft .dropdown-toggle:before{display:inline-block;margin-right:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid transparent;border-right:.3em solid;border-bottom:.3em solid transparent}.hsl .dropleft .dropdown-toggle:empty:after{margin-left:0}.hsl .dropleft .dropdown-toggle:before{vertical-align:0}.hsl .dropdown-menu[x-placement^=top],.hsl .dropdown-menu[x-placement^=right],.hsl .dropdown-menu[x-placement^=bottom],.hsl .dropdown-menu[x-placement^=left]{right:auto;bottom:auto}.hsl .dropdown-divider{height:0;margin:.5rem 0;overflow:hidden;border-top:1px solid var(--gray-200)}.hsl .dropdown-item{display:block;width:100%;padding:.25rem 1.5rem;clear:both;font-weight:400;color:var(--gray-900);text-align:inherit;white-space:nowrap;background-color:transparent;border:0}.hsl .dropdown-item:hover,.hsl .dropdown-item:focus{color:hsla(var(--gray-900-h),var(--gray-900-s),calc(var(--gray-900-l) + -5%),1);color:hsla(var(--gray-900-h),var(--gray-900-s),calc(var(--gray-900-l) + -5%),var(--gray-900-a, 1));text-decoration:none;background-color:var(--gray-200)}.hsl .dropdown-item.active,.hsl .dropdown-item:active{color:var(--white);text-decoration:none;background-color:var(--primary)}.hsl .dropdown-item.disabled,.hsl .dropdown-item:disabled{color:#adb5bd;pointer-events:none;background-color:transparent}.hsl .dropdown-menu.show{display:block}.hsl .dropdown-header{display:block;padding:.5rem 1.5rem;margin-bottom:0;font-size:.875rem;color:#6c757d;white-space:nowrap}.hsl .dropdown-item-text{display:block;padding:.25rem 1.5rem;color:var(--gray-900)}.hsl .btn-group,.hsl .btn-group-vertical{position:relative;display:inline-flex;vertical-align:middle}.hsl .btn-group>.btn,.hsl .btn-group-vertical>.btn{position:relative;flex:1 1 auto}.hsl .btn-group>.btn:hover,.hsl .btn-group-vertical>.btn:hover{z-index:1}.hsl .btn-group>.btn:focus,.hsl .btn-group>.btn:active,.hsl .btn-group>.btn.active,.hsl .btn-group-vertical>.btn:focus,.hsl .btn-group-vertical>.btn:active,.hsl .btn-group-vertical>.btn.active{z-index:1}.hsl .btn-toolbar{display:flex;flex-wrap:wrap;justify-content:flex-start}.hsl .btn-toolbar .input-group{width:auto}.hsl .btn-group>.btn:not(:first-child),.hsl .btn-group>.btn-group:not(:first-child){margin-left:-1px}.hsl .btn-group>.btn:not(:last-child):not(.dropdown-toggle),.hsl .btn-group>.btn-group:not(:last-child)>.btn{border-top-right-radius:0;border-bottom-right-radius:0}.hsl .btn-group>.btn:not(:first-child),.hsl .btn-group>.btn-group:not(:first-child)>.btn{border-top-left-radius:0;border-bottom-left-radius:0}.hsl .dropdown-toggle-split{padding-right:.5625rem;padding-left:.5625rem}.hsl .dropdown-toggle-split:after,.dropup .hsl .dropdown-toggle-split:after,.dropright .hsl .dropdown-toggle-split:after{margin-left:0}.dropleft .hsl .dropdown-toggle-split:before{margin-right:0}.hsl .btn-sm+.dropdown-toggle-split,.hsl .btn-group-sm>.btn+.dropdown-toggle-split{padding-right:.375rem;padding-left:.375rem}.hsl .btn-lg+.dropdown-toggle-split,.hsl .btn-group-lg>.btn+.dropdown-toggle-split{padding-right:.75rem;padding-left:.75rem}.hsl .btn-group-vertical{flex-direction:column;align-items:flex-start;justify-content:center}.hsl .btn-group-vertical>.btn,.hsl .btn-group-vertical>.btn-group{width:100%}.hsl .btn-group-vertical>.btn:not(:first-child),.hsl .btn-group-vertical>.btn-group:not(:first-child){margin-top:-1px}.hsl .btn-group-vertical>.btn:not(:last-child):not(.dropdown-toggle),.hsl .btn-group-vertical>.btn-group:not(:last-child)>.btn{border-bottom-right-radius:0;border-bottom-left-radius:0}.hsl .btn-group-vertical>.btn:not(:first-child),.hsl .btn-group-vertical>.btn-group:not(:first-child)>.btn{border-top-left-radius:0;border-top-right-radius:0}.hsl .btn-group-toggle>.btn,.hsl .btn-group-toggle>.btn-group>.btn{margin-bottom:0}.hsl .btn-group-toggle>.btn input[type=radio],.hsl .btn-group-toggle>.btn input[type=checkbox],.hsl .btn-group-toggle>.btn-group>.btn input[type=radio],.hsl .btn-group-toggle>.btn-group>.btn input[type=checkbox]{position:absolute;clip:rect(0,0,0,0);pointer-events:none}.hsl .input-group{position:relative;display:flex;flex-wrap:wrap;align-items:stretch;width:100%}.hsl .input-group>.form-control,.hsl .input-group>.form-control-plaintext,.hsl .input-group>.custom-select,.hsl .input-group>.custom-file{position:relative;flex:1 1 auto;width:1%;min-width:0;margin-bottom:0}.hsl .input-group>.form-control+.form-control,.hsl .input-group>.form-control+.custom-select,.hsl .input-group>.form-control+.custom-file,.hsl .input-group>.form-control-plaintext+.form-control,.hsl .input-group>.form-control-plaintext+.custom-select,.hsl .input-group>.form-control-plaintext+.custom-file,.hsl .input-group>.custom-select+.form-control,.hsl .input-group>.custom-select+.custom-select,.hsl .input-group>.custom-select+.custom-file,.hsl .input-group>.custom-file+.form-control,.hsl .input-group>.custom-file+.custom-select,.hsl .input-group>.custom-file+.custom-file{margin-left:-1px}.hsl .input-group>.form-control:focus,.hsl .input-group>.custom-select:focus,.hsl .input-group>.custom-file .custom-file-input:focus~.custom-file-label{z-index:3}.hsl .input-group>.custom-file .custom-file-input:focus{z-index:4}.hsl .input-group>.form-control:not(:first-child),.hsl .input-group>.custom-select:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.hsl .input-group>.custom-file{display:flex;align-items:center}.hsl .input-group>.custom-file:not(:last-child) .custom-file-label,.hsl .input-group>.custom-file:not(:first-child) .custom-file-label{border-top-left-radius:0;border-bottom-left-radius:0}.hsl .input-group:not(.has-validation)>.form-control:not(:last-child),.hsl .input-group:not(.has-validation)>.custom-select:not(:last-child),.hsl .input-group:not(.has-validation)>.custom-file:not(:last-child) .custom-file-label:after{border-top-right-radius:0;border-bottom-right-radius:0}.hsl .input-group.has-validation>.form-control:nth-last-child(n+3),.hsl .input-group.has-validation>.custom-select:nth-last-child(n+3),.hsl .input-group.has-validation>.custom-file:nth-last-child(n+3) .custom-file-label:after{border-top-right-radius:0;border-bottom-right-radius:0}.hsl .input-group-prepend,.hsl .input-group-append{display:flex}.hsl .input-group-prepend .btn,.hsl .input-group-append .btn{position:relative;z-index:2}.hsl .input-group-prepend .btn:focus,.hsl .input-group-append .btn:focus{z-index:3}.hsl .input-group-prepend .btn+.btn,.hsl .input-group-prepend .btn+.input-group-text,.hsl .input-group-prepend .input-group-text+.input-group-text,.hsl .input-group-prepend .input-group-text+.btn,.hsl .input-group-append .btn+.btn,.hsl .input-group-append .btn+.input-group-text,.hsl .input-group-append .input-group-text+.input-group-text,.hsl .input-group-append .input-group-text+.btn{margin-left:-1px}.hsl .input-group-prepend{margin-right:-1px}.hsl .input-group-append{margin-left:-1px}.hsl .input-group-text{display:flex;align-items:center;padding:.375rem .75rem;margin-bottom:0;font-size:1rem;font-weight:400;line-height:1.5;color:var(--text-color);text-align:center;white-space:nowrap;background-color:var(--gray-200);border:1px solid #ced4da;border-radius:.25rem}.hsl .input-group-text input[type=radio],.hsl .input-group-text input[type=checkbox]{margin-top:0}.hsl .input-group-lg>.form-control:not(textarea),.hsl .input-group-lg>.custom-select{height:calc(1.5em + 1rem + 2px)}.hsl .input-group-lg>.form-control,.hsl .input-group-lg>.custom-select,.hsl .input-group-lg>.input-group-prepend>.input-group-text,.hsl .input-group-lg>.input-group-append>.input-group-text,.hsl .input-group-lg>.input-group-prepend>.btn,.hsl .input-group-lg>.input-group-append>.btn{padding:.5rem 1rem;font-size:1.25rem;line-height:1.5;border-radius:.3rem}.hsl .input-group-sm>.form-control:not(textarea),.hsl .input-group-sm>.custom-select{height:calc(1.5em + .5rem + 2px)}.hsl .input-group-sm>.form-control,.hsl .input-group-sm>.custom-select,.hsl .input-group-sm>.input-group-prepend>.input-group-text,.hsl .input-group-sm>.input-group-append>.input-group-text,.hsl .input-group-sm>.input-group-prepend>.btn,.hsl .input-group-sm>.input-group-append>.btn{padding:.25rem .5rem;font-size:.875rem;line-height:1.5;border-radius:.2rem}.hsl .input-group-lg>.custom-select,.hsl .input-group-sm>.custom-select{padding-right:1.75rem}.hsl .input-group>.input-group-prepend>.btn,.hsl .input-group>.input-group-prepend>.input-group-text,.hsl .input-group:not(.has-validation)>.input-group-append:not(:last-child)>.btn,.hsl .input-group:not(.has-validation)>.input-group-append:not(:last-child)>.input-group-text,.hsl .input-group.has-validation>.input-group-append:nth-last-child(n+3)>.btn,.hsl .input-group.has-validation>.input-group-append:nth-last-child(n+3)>.input-group-text,.hsl .input-group>.input-group-append:last-child>.btn:not(:last-child):not(.dropdown-toggle),.hsl .input-group>.input-group-append:last-child>.input-group-text:not(:last-child){border-top-right-radius:0;border-bottom-right-radius:0}.hsl .input-group>.input-group-append>.btn,.hsl .input-group>.input-group-append>.input-group-text,.hsl .input-group>.input-group-prepend:not(:first-child)>.btn,.hsl .input-group>.input-group-prepend:not(:first-child)>.input-group-text,.hsl .input-group>.input-group-prepend:first-child>.btn:not(:first-child),.hsl .input-group>.input-group-prepend:first-child>.input-group-text:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.hsl .nav{display:flex;flex-wrap:wrap;padding-left:0;margin-bottom:0;list-style:none}.hsl .nav-link{display:block;padding:.5rem 1rem}.hsl .nav-link:hover,.hsl .nav-link:focus{text-decoration:none}.hsl .nav-link.disabled{color:#6c757d;pointer-events:none;cursor:default}.hsl .nav-tabs{border-bottom:1px solid #dee2e6}.hsl .nav-tabs .nav-link{margin-bottom:-1px;border:1px solid transparent;border-top-left-radius:.25rem;border-top-right-radius:.25rem}.hsl .nav-tabs .nav-link:hover,.hsl .nav-tabs .nav-link:focus{border-color:var(--gray-200) var(--gray-200) #dee2e6}.hsl .nav-tabs .nav-link.disabled{color:#6c757d;background-color:transparent;border-color:transparent}.hsl .nav-tabs .nav-link.active,.hsl .nav-tabs .nav-item.show .nav-link{color:var(--text-color);background-color:var(--white);border-color:#dee2e6 #dee2e6 var(--white)}.hsl .nav-tabs .dropdown-menu{margin-top:-1px;border-top-left-radius:0;border-top-right-radius:0}.hsl .nav-pills .nav-link{border-radius:.25rem}.hsl .nav-pills .nav-link.active,.hsl .nav-pills .show>.nav-link{color:var(--white);background-color:var(--primary)}.hsl .nav-fill>.nav-link,.hsl .nav-fill .nav-item{flex:1 1 auto;text-align:center}.hsl .nav-justified>.nav-link,.hsl .nav-justified .nav-item{flex-basis:0;flex-grow:1;text-align:center}.hsl .tab-content>.tab-pane{display:none}.hsl .tab-content>.active{display:block}.hsl .navbar{position:relative;display:flex;flex-wrap:wrap;align-items:center;justify-content:space-between;padding:.5rem 1rem}.hsl .navbar .container,.hsl .navbar .container-fluid,.hsl .navbar .container-sm,.hsl .navbar .container-md,.hsl .navbar .container-lg,.hsl .navbar .container-xl{display:flex;flex-wrap:wrap;align-items:center;justify-content:space-between}.hsl .navbar-brand{display:inline-block;padding-top:.3125rem;padding-bottom:.3125rem;margin-right:1rem;font-size:1.25rem;line-height:inherit;white-space:nowrap}.hsl .navbar-brand:hover,.hsl .navbar-brand:focus{text-decoration:none}.hsl .navbar-nav{display:flex;flex-direction:column;padding-left:0;margin-bottom:0;list-style:none}.hsl .navbar-nav .nav-link{padding-right:0;padding-left:0}.hsl .navbar-nav .dropdown-menu{position:static;float:none}.hsl .navbar-text{display:inline-block;padding-top:.5rem;padding-bottom:.5rem}.hsl .navbar-collapse{flex-basis:100%;flex-grow:1;align-items:center}.hsl .navbar-toggler{padding:.25rem .75rem;font-size:1.25rem;line-height:1;background-color:transparent;border:1px solid transparent;border-radius:.25rem}.hsl .navbar-toggler:hover,.hsl .navbar-toggler:focus{text-decoration:none}.hsl .navbar-toggler-icon{display:inline-block;width:1.5em;height:1.5em;vertical-align:middle;content:\"\";background:50%/100% 100% no-repeat}.hsl .navbar-nav-scroll{max-height:75vh;overflow-y:auto}@media (max-width: 575.98px){.hsl .navbar-expand-sm>.container,.hsl .navbar-expand-sm>.container-fluid,.hsl .navbar-expand-sm>.container-sm,.hsl .navbar-expand-sm>.container-md,.hsl .navbar-expand-sm>.container-lg,.hsl .navbar-expand-sm>.container-xl{padding-right:0;padding-left:0}}@media (min-width: 576px){.hsl .navbar-expand-sm{flex-flow:row nowrap;justify-content:flex-start}.hsl .navbar-expand-sm .navbar-nav{flex-direction:row}.hsl .navbar-expand-sm .navbar-nav .dropdown-menu{position:absolute}.hsl .navbar-expand-sm .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem}.hsl .navbar-expand-sm>.container,.hsl .navbar-expand-sm>.container-fluid,.hsl .navbar-expand-sm>.container-sm,.hsl .navbar-expand-sm>.container-md,.hsl .navbar-expand-sm>.container-lg,.hsl .navbar-expand-sm>.container-xl{flex-wrap:nowrap}.hsl .navbar-expand-sm .navbar-nav-scroll{overflow:visible}.hsl .navbar-expand-sm .navbar-collapse{display:flex!important;flex-basis:auto}.hsl .navbar-expand-sm .navbar-toggler{display:none}}@media (max-width: 767.98px){.hsl .navbar-expand-md>.container,.hsl .navbar-expand-md>.container-fluid,.hsl .navbar-expand-md>.container-sm,.hsl .navbar-expand-md>.container-md,.hsl .navbar-expand-md>.container-lg,.hsl .navbar-expand-md>.container-xl{padding-right:0;padding-left:0}}@media (min-width: 768px){.hsl .navbar-expand-md{flex-flow:row nowrap;justify-content:flex-start}.hsl .navbar-expand-md .navbar-nav{flex-direction:row}.hsl .navbar-expand-md .navbar-nav .dropdown-menu{position:absolute}.hsl .navbar-expand-md .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem}.hsl .navbar-expand-md>.container,.hsl .navbar-expand-md>.container-fluid,.hsl .navbar-expand-md>.container-sm,.hsl .navbar-expand-md>.container-md,.hsl .navbar-expand-md>.container-lg,.hsl .navbar-expand-md>.container-xl{flex-wrap:nowrap}.hsl .navbar-expand-md .navbar-nav-scroll{overflow:visible}.hsl .navbar-expand-md .navbar-collapse{display:flex!important;flex-basis:auto}.hsl .navbar-expand-md .navbar-toggler{display:none}}@media (max-width: 991.98px){.hsl .navbar-expand-lg>.container,.hsl .navbar-expand-lg>.container-fluid,.hsl .navbar-expand-lg>.container-sm,.hsl .navbar-expand-lg>.container-md,.hsl .navbar-expand-lg>.container-lg,.hsl .navbar-expand-lg>.container-xl{padding-right:0;padding-left:0}}@media (min-width: 992px){.hsl .navbar-expand-lg{flex-flow:row nowrap;justify-content:flex-start}.hsl .navbar-expand-lg .navbar-nav{flex-direction:row}.hsl .navbar-expand-lg .navbar-nav .dropdown-menu{position:absolute}.hsl .navbar-expand-lg .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem}.hsl .navbar-expand-lg>.container,.hsl .navbar-expand-lg>.container-fluid,.hsl .navbar-expand-lg>.container-sm,.hsl .navbar-expand-lg>.container-md,.hsl .navbar-expand-lg>.container-lg,.hsl .navbar-expand-lg>.container-xl{flex-wrap:nowrap}.hsl .navbar-expand-lg .navbar-nav-scroll{overflow:visible}.hsl .navbar-expand-lg .navbar-collapse{display:flex!important;flex-basis:auto}.hsl .navbar-expand-lg .navbar-toggler{display:none}}@media (max-width: 1199.98px){.hsl .navbar-expand-xl>.container,.hsl .navbar-expand-xl>.container-fluid,.hsl .navbar-expand-xl>.container-sm,.hsl .navbar-expand-xl>.container-md,.hsl .navbar-expand-xl>.container-lg,.hsl .navbar-expand-xl>.container-xl{padding-right:0;padding-left:0}}@media (min-width: 1200px){.hsl .navbar-expand-xl{flex-flow:row nowrap;justify-content:flex-start}.hsl .navbar-expand-xl .navbar-nav{flex-direction:row}.hsl .navbar-expand-xl .navbar-nav .dropdown-menu{position:absolute}.hsl .navbar-expand-xl .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem}.hsl .navbar-expand-xl>.container,.hsl .navbar-expand-xl>.container-fluid,.hsl .navbar-expand-xl>.container-sm,.hsl .navbar-expand-xl>.container-md,.hsl .navbar-expand-xl>.container-lg,.hsl .navbar-expand-xl>.container-xl{flex-wrap:nowrap}.hsl .navbar-expand-xl .navbar-nav-scroll{overflow:visible}.hsl .navbar-expand-xl .navbar-collapse{display:flex!important;flex-basis:auto}.hsl .navbar-expand-xl .navbar-toggler{display:none}}.hsl .navbar-expand{flex-flow:row nowrap;justify-content:flex-start}.hsl .navbar-expand>.container,.hsl .navbar-expand>.container-fluid,.hsl .navbar-expand>.container-sm,.hsl .navbar-expand>.container-md,.hsl .navbar-expand>.container-lg,.hsl .navbar-expand>.container-xl{padding-right:0;padding-left:0}.hsl .navbar-expand .navbar-nav{flex-direction:row}.hsl .navbar-expand .navbar-nav .dropdown-menu{position:absolute}.hsl .navbar-expand .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem}.hsl .navbar-expand>.container,.hsl .navbar-expand>.container-fluid,.hsl .navbar-expand>.container-sm,.hsl .navbar-expand>.container-md,.hsl .navbar-expand>.container-lg,.hsl .navbar-expand>.container-xl{flex-wrap:nowrap}.hsl .navbar-expand .navbar-nav-scroll{overflow:visible}.hsl .navbar-expand .navbar-collapse{display:flex!important;flex-basis:auto}.hsl .navbar-expand .navbar-toggler{display:none}.hsl .navbar-light .navbar-brand{color:#000000e6}.hsl .navbar-light .navbar-brand:hover,.hsl .navbar-light .navbar-brand:focus{color:#000000e6}.hsl .navbar-light .navbar-nav .nav-link{color:#00000080}.hsl .navbar-light .navbar-nav .nav-link:hover,.hsl .navbar-light .navbar-nav .nav-link:focus{color:#000000b3}.hsl .navbar-light .navbar-nav .nav-link.disabled{color:#0000004d}.hsl .navbar-light .navbar-nav .show>.nav-link,.hsl .navbar-light .navbar-nav .active>.nav-link,.hsl .navbar-light .navbar-nav .nav-link.show,.hsl .navbar-light .navbar-nav .nav-link.active{color:#000000e6}.hsl .navbar-light .navbar-toggler{color:#00000080;border-color:#0000001a}.hsl .navbar-light .navbar-toggler-icon{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%280, 0, 0, 0.5%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\")}.hsl .navbar-light .navbar-text{color:#00000080}.hsl .navbar-light .navbar-text a{color:#000000e6}.hsl .navbar-light .navbar-text a:hover,.hsl .navbar-light .navbar-text a:focus{color:#000000e6}.hsl .navbar-dark .navbar-brand{color:var(--white)}.hsl .navbar-dark .navbar-brand:hover,.hsl .navbar-dark .navbar-brand:focus{color:var(--white)}.hsl .navbar-dark .navbar-nav .nav-link{color:hsla(var(--white-h),var(--white-s),var(--white-l),.5)}.hsl .navbar-dark .navbar-nav .nav-link:hover,.hsl .navbar-dark .navbar-nav .nav-link:focus{color:hsla(var(--white-h),var(--white-s),var(--white-l),.75)}.hsl .navbar-dark .navbar-nav .nav-link.disabled{color:hsla(var(--white-h),var(--white-s),var(--white-l),.25)}.hsl .navbar-dark .navbar-nav .show>.nav-link,.hsl .navbar-dark .navbar-nav .active>.nav-link,.hsl .navbar-dark .navbar-nav .nav-link.show,.hsl .navbar-dark .navbar-nav .nav-link.active{color:var(--white)}.hsl .navbar-dark .navbar-toggler{color:hsla(var(--white-h),var(--white-s),var(--white-l),.5);border-color:hsla(var(--white-h),var(--white-s),var(--white-l),.1)}.hsl .navbar-dark .navbar-toggler-icon{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'%3e%3cpath stroke='hsla%28var%28--white-h%29, var%28--white-s%29, var%28--white-l%29, 0.5%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\")}.hsl .navbar-dark .navbar-text{color:hsla(var(--white-h),var(--white-s),var(--white-l),.5)}.hsl .navbar-dark .navbar-text a{color:var(--white)}.hsl .navbar-dark .navbar-text a:hover,.hsl .navbar-dark .navbar-text a:focus{color:var(--white)}.hsl .card{position:relative;display:flex;flex-direction:column;min-width:0;word-wrap:break-word;background-color:var(--card-bg);background-clip:border-box;border:1px solid rgba(0,0,0,.125);border-radius:.25rem}.hsl .card>hr{margin-right:0;margin-left:0}.hsl .card>.list-group{border-top:inherit;border-bottom:inherit}.hsl .card>.list-group:first-child{border-top-width:0;border-top-left-radius:calc(.25rem - 1px);border-top-right-radius:calc(.25rem - 1px)}.hsl .card>.list-group:last-child{border-bottom-width:0;border-bottom-right-radius:calc(.25rem - 1px);border-bottom-left-radius:calc(.25rem - 1px)}.hsl .card>.card-header+.list-group,.hsl .card>.list-group+.card-footer{border-top:0}.hsl .card-body{flex:1 1 auto;min-height:1px;padding:1.25rem}.hsl .card-title{margin-bottom:.75rem}.hsl .card-subtitle{margin-top:-.375rem;margin-bottom:0}.hsl .card-text:last-child{margin-bottom:0}.hsl .card-link:hover{text-decoration:none}.hsl .card-link+.card-link{margin-left:1.25rem}.hsl .card-header{padding:.75rem 1.25rem;margin-bottom:0;color:var(--text-color);background-color:#00000008;border-bottom:1px solid rgba(0,0,0,.125)}.hsl .card-header:first-child{border-radius:calc(.25rem - 1px) calc(.25rem - 1px) 0 0}.hsl .card-footer{padding:.75rem 1.25rem;color:var(--text-color);background-color:#00000008;border-top:1px solid rgba(0,0,0,.125)}.hsl .card-footer:last-child{border-radius:0 0 calc(.25rem - 1px) calc(.25rem - 1px)}.hsl .card-header-tabs{margin-right:-.625rem;margin-bottom:-.75rem;margin-left:-.625rem;border-bottom:0}.hsl .card-header-pills{margin-right:-.625rem;margin-left:-.625rem}.hsl .card-img-overlay{position:absolute;top:0;right:0;bottom:0;left:0;padding:1.25rem;border-radius:calc(.25rem - 1px)}.hsl .card-img,.hsl .card-img-top,.hsl .card-img-bottom{flex-shrink:0;width:100%}.hsl .card-img,.hsl .card-img-top{border-top-left-radius:calc(.25rem - 1px);border-top-right-radius:calc(.25rem - 1px)}.hsl .card-img,.hsl .card-img-bottom{border-bottom-right-radius:calc(.25rem - 1px);border-bottom-left-radius:calc(.25rem - 1px)}.hsl .card-deck .card{margin-bottom:15px}@media (min-width: 576px){.hsl .card-deck{display:flex;flex-flow:row wrap;margin-right:-15px;margin-left:-15px}.hsl .card-deck .card{flex:1 0 0%;margin-right:15px;margin-bottom:0;margin-left:15px}}.hsl .card-group>.card{margin-bottom:15px}@media (min-width: 576px){.hsl .card-group{display:flex;flex-flow:row wrap}.hsl .card-group>.card{flex:1 0 0%;margin-bottom:0}.hsl .card-group>.card+.card{margin-left:0;border-left:0}.hsl .card-group>.card:not(:last-child){border-top-right-radius:0;border-bottom-right-radius:0}.hsl .card-group>.card:not(:last-child) .card-img-top,.hsl .card-group>.card:not(:last-child) .card-header{border-top-right-radius:0}.hsl .card-group>.card:not(:last-child) .card-img-bottom,.hsl .card-group>.card:not(:last-child) .card-footer{border-bottom-right-radius:0}.hsl .card-group>.card:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.hsl .card-group>.card:not(:first-child) .card-img-top,.hsl .card-group>.card:not(:first-child) .card-header{border-top-left-radius:0}.hsl .card-group>.card:not(:first-child) .card-img-bottom,.hsl .card-group>.card:not(:first-child) .card-footer{border-bottom-left-radius:0}}.hsl .card-columns .card{margin-bottom:.75rem}@media (min-width: 576px){.hsl .card-columns{-moz-column-count:3;column-count:3;grid-column-gap:1.25rem;-moz-column-gap:1.25rem;column-gap:1.25rem;orphans:1;widows:1}.hsl .card-columns .card{display:inline-block;width:100%}}.hsl .accordion{overflow-anchor:none}.hsl .accordion>.card{overflow:hidden}.hsl .accordion>.card:not(:last-of-type){border-bottom:0;border-bottom-right-radius:0;border-bottom-left-radius:0}.hsl .accordion>.card:not(:first-of-type){border-top-left-radius:0;border-top-right-radius:0}.hsl .accordion>.card>.card-header{border-radius:0;margin-bottom:-1px}.hsl .pagination{display:flex;padding-left:0;list-style:none;border-radius:.25rem}.hsl .page-link{position:relative;display:block;padding:.5rem .75rem;margin-left:-1px;line-height:1.25;color:var(--primary);background-color:var(--white);border:1px solid #dee2e6}.hsl .page-link:hover{z-index:2;color:hsla(var(--primary-h),var(--primary-s),calc(var(--primary-l) + -15%),1);color:hsla(var(--primary-h),var(--primary-s),calc(var(--primary-l) + -15%),var(--primary-a, 1));text-decoration:none;background-color:var(--gray-200);border-color:#dee2e6}.hsl .page-link:focus{z-index:3;outline:0;box-shadow:0 0 0 .2rem hsla(var(--primary-h),var(--primary-s),var(--primary-l),.25)}.hsl .page-item:first-child .page-link{margin-left:0;border-top-left-radius:.25rem;border-bottom-left-radius:.25rem}.hsl .page-item:last-child .page-link{border-top-right-radius:.25rem;border-bottom-right-radius:.25rem}.hsl .page-item.active .page-link{z-index:3;color:var(--white);background-color:var(--primary);border-color:var(--primary)}.hsl .page-item.disabled .page-link{color:#6c757d;pointer-events:none;cursor:auto;background-color:var(--white);border-color:#dee2e6}.hsl .pagination-lg .page-link{padding:.75rem 1.5rem;font-size:1.25rem;line-height:1.5}.hsl .pagination-lg .page-item:first-child .page-link{border-top-left-radius:.3rem;border-bottom-left-radius:.3rem}.hsl .pagination-lg .page-item:last-child .page-link{border-top-right-radius:.3rem;border-bottom-right-radius:.3rem}.hsl .pagination-sm .page-link{padding:.25rem .5rem;font-size:.875rem;line-height:1.5}.hsl .pagination-sm .page-item:first-child .page-link{border-top-left-radius:.2rem;border-bottom-left-radius:.2rem}.hsl .pagination-sm .page-item:last-child .page-link{border-top-right-radius:.2rem;border-bottom-right-radius:.2rem}.hsl .badge{display:inline-block;padding:.25em .4em;font-size:75%;font-weight:700;line-height:1;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:.25rem;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion: reduce){.hsl .badge{transition:none}}a.hsl .badge:hover,a.hsl .badge:focus{text-decoration:none}.hsl .badge:empty{display:none}.hsl .btn .badge{position:relative;top:-1px}.hsl .badge-pill{padding-right:.6em;padding-left:.6em;border-radius:10rem}.hsl .badge-primary{color:hsla(0,0%,calc(-100 * calc(var(--primary-l) - 58.59375%)),1);background-color:var(--primary)}a.hsl .badge-primary:hover,a.hsl .badge-primary:focus{color:hsla(0,0%,calc(-100 * calc(var(--primary-l) - 58.59375%)),1);background-color:hsla(var(--primary-h),var(--primary-s),calc(var(--primary-l) + -10%),1);background-color:hsla(var(--primary-h),var(--primary-s),calc(var(--primary-l) + -10%),var(--primary-a, 1))}a.hsl .badge-primary:focus,a.hsl .badge-primary.focus{outline:0;box-shadow:0 0 0 .2rem hsla(var(--primary-h),var(--primary-s),var(--primary-l),.5)}.hsl .badge-secondary{color:hsla(0,0%,calc(-100 * calc(var(--secondary-l) - 58.59375%)),1);background-color:var(--secondary)}a.hsl .badge-secondary:hover,a.hsl .badge-secondary:focus{color:hsla(0,0%,calc(-100 * calc(var(--secondary-l) - 58.59375%)),1);background-color:hsla(var(--secondary-h),var(--secondary-s),calc(var(--secondary-l) + -10%),1);background-color:hsla(var(--secondary-h),var(--secondary-s),calc(var(--secondary-l) + -10%),var(--secondary-a, 1))}a.hsl .badge-secondary:focus,a.hsl .badge-secondary.focus{outline:0;box-shadow:0 0 0 .2rem hsla(var(--secondary-h),var(--secondary-s),var(--secondary-l),.5)}.hsl .badge-success{color:var(--white);background-color:#28a745}a.hsl .badge-success:hover,a.hsl .badge-success:focus{color:var(--white);background-color:#24963e}a.hsl .badge-success:focus,a.hsl .badge-success.focus{outline:0;box-shadow:0 0 0 .2rem #28a74580}.hsl .badge-info{color:var(--white);background-color:#17a2b8}a.hsl .badge-info:hover,a.hsl .badge-info:focus{color:var(--white);background-color:#1592a6}a.hsl .badge-info:focus,a.hsl .badge-info.focus{outline:0;box-shadow:0 0 0 .2rem #17a2b880}.hsl .badge-warning{color:var(--gray-900);background-color:#ffc107}a.hsl .badge-warning:hover,a.hsl .badge-warning:focus{color:var(--gray-900);background-color:#ecb100}a.hsl .badge-warning:focus,a.hsl .badge-warning.focus{outline:0;box-shadow:0 0 0 .2rem #ffc10780}.hsl .badge-danger{color:var(--white);background-color:#dc3545}a.hsl .badge-danger:hover,a.hsl .badge-danger:focus{color:var(--white);background-color:#d12435}a.hsl .badge-danger:focus,a.hsl .badge-danger.focus{outline:0;box-shadow:0 0 0 .2rem #dc354580}.hsl .badge-light{color:hsla(0,0%,calc(-100 * calc(var(--light-l) - 58.59375%)),1);background-color:var(--light)}a.hsl .badge-light:hover,a.hsl .badge-light:focus{color:hsla(0,0%,calc(-100 * calc(var(--light-l) - 58.59375%)),1);background-color:hsla(var(--light-h),var(--light-s),calc(var(--light-l) + -10%),1);background-color:hsla(var(--light-h),var(--light-s),calc(var(--light-l) + -10%),var(--light-a, 1))}a.hsl .badge-light:focus,a.hsl .badge-light.focus{outline:0;box-shadow:0 0 0 .2rem hsla(var(--light-h),var(--light-s),var(--light-l),.5)}.hsl .badge-dark{color:hsla(0,0%,calc(-100 * calc(var(--gray-800-l) - 58.59375%)),1);background-color:var(--gray-800)}a.hsl .badge-dark:hover,a.hsl .badge-dark:focus{color:hsla(0,0%,calc(-100 * calc(var(--gray-800-l) - 58.59375%)),1);background-color:hsla(var(--gray-800-h),var(--gray-800-s),calc(var(--gray-800-l) + -10%),1);background-color:hsla(var(--gray-800-h),var(--gray-800-s),calc(var(--gray-800-l) + -10%),var(--gray-800-a, 1))}a.hsl .badge-dark:focus,a.hsl .badge-dark.focus{outline:0;box-shadow:0 0 0 .2rem hsla(var(--gray-800-h),var(--gray-800-s),var(--gray-800-l),.5)}.hsl .badge-gray{color:hsla(0,0%,calc(-100 * calc(var(--gray-900-l) - 58.59375%)),1);background-color:var(--gray-900)}a.hsl .badge-gray:hover,a.hsl .badge-gray:focus{color:hsla(0,0%,calc(-100 * calc(var(--gray-900-l) - 58.59375%)),1);background-color:hsla(var(--gray-900-h),var(--gray-900-s),calc(var(--gray-900-l) + -10%),1);background-color:hsla(var(--gray-900-h),var(--gray-900-s),calc(var(--gray-900-l) + -10%),var(--gray-900-a, 1))}a.hsl .badge-gray:focus,a.hsl .badge-gray.focus{outline:0;box-shadow:0 0 0 .2rem hsla(var(--gray-900-h),var(--gray-900-s),var(--gray-900-l),.5)}.hsl .alert{position:relative;padding:.75rem 1.25rem;margin-bottom:1rem;border:1px solid transparent;border-radius:.25rem}.hsl .alert-heading{color:inherit}.hsl .alert-link{font-weight:700}.hsl .alert-dismissible{padding-right:4rem}.hsl .alert-dismissible .close{position:absolute;top:0;right:0;z-index:2;padding:.75rem 1.25rem;color:inherit}.hsl .alert-primary{color:hsla(calc(var(--primary-h)),calc(var(--primary-s)),calc((0% + var(--primary-l)) / 2),calc((1 + 1) / 2));color:hsla(calc(var(--primary-h)),calc(var(--primary-s)),calc((0% + var(--primary-l)) / 2),calc((1 + var(--primary-a, 1)) / 2));background-color:hsla(calc(var(--primary-h)),calc(var(--primary-s)),calc((var(--white-l) + var(--primary-l)) / 2),calc((1 + 1) / 2));background-color:hsla(calc(var(--primary-h)),calc(var(--primary-s)),calc((var(--white-l) + var(--primary-l)) / 2),calc((var(--white-a, 1) + var(--primary-a, 1)) / 2));border-color:hsla(calc(var(--primary-h)),calc(var(--primary-s)),calc((var(--white-l) + var(--primary-l)) / 2),calc((1 + 1) / 2));border-color:hsla(calc(var(--primary-h)),calc(var(--primary-s)),calc((var(--white-l) + var(--primary-l)) / 2),calc((var(--white-a, 1) + var(--primary-a, 1)) / 2))}.hsl .alert-primary hr{border-top-color:hsla(calc(var(--primary-h)),calc(var(--primary-s)),calc(calc((var(--white-l) + var(--primary-l)) / 2) + -5%),calc((1 + 1) / 2));border-top-color:hsla(calc(var(--primary-h)),calc(var(--primary-s)),calc(calc((var(--white-l) + var(--primary-l)) / 2) + -5%),calc((var(--white-a, 1) + var(--primary-a, 1)) / 2))}.hsl .alert-primary .alert-link{color:hsla(calc(var(--primary-h)),calc(var(--primary-s)),calc(calc((0% + var(--primary-l)) / 2) + -10%),calc((1 + 1) / 2));color:hsla(calc(var(--primary-h)),calc(var(--primary-s)),calc(calc((0% + var(--primary-l)) / 2) + -10%),calc((1 + var(--primary-a, 1)) / 2))}.hsl .alert-secondary{color:hsla(calc(var(--secondary-h)),calc(var(--secondary-s)),calc((0% + var(--secondary-l)) / 2),calc((1 + 1) / 2));color:hsla(calc(var(--secondary-h)),calc(var(--secondary-s)),calc((0% + var(--secondary-l)) / 2),calc((1 + var(--secondary-a, 1)) / 2));background-color:hsla(calc(var(--secondary-h)),calc(var(--secondary-s)),calc((var(--white-l) + var(--secondary-l)) / 2),calc((1 + 1) / 2));background-color:hsla(calc(var(--secondary-h)),calc(var(--secondary-s)),calc((var(--white-l) + var(--secondary-l)) / 2),calc((var(--white-a, 1) + var(--secondary-a, 1)) / 2));border-color:hsla(calc(var(--secondary-h)),calc(var(--secondary-s)),calc((var(--white-l) + var(--secondary-l)) / 2),calc((1 + 1) / 2));border-color:hsla(calc(var(--secondary-h)),calc(var(--secondary-s)),calc((var(--white-l) + var(--secondary-l)) / 2),calc((var(--white-a, 1) + var(--secondary-a, 1)) / 2))}.hsl .alert-secondary hr{border-top-color:hsla(calc(var(--secondary-h)),calc(var(--secondary-s)),calc(calc((var(--white-l) + var(--secondary-l)) / 2) + -5%),calc((1 + 1) / 2));border-top-color:hsla(calc(var(--secondary-h)),calc(var(--secondary-s)),calc(calc((var(--white-l) + var(--secondary-l)) / 2) + -5%),calc((var(--white-a, 1) + var(--secondary-a, 1)) / 2))}.hsl .alert-secondary .alert-link{color:hsla(calc(var(--secondary-h)),calc(var(--secondary-s)),calc(calc((0% + var(--secondary-l)) / 2) + -10%),calc((1 + 1) / 2));color:hsla(calc(var(--secondary-h)),calc(var(--secondary-s)),calc(calc((0% + var(--secondary-l)) / 2) + -10%),calc((1 + var(--secondary-a, 1)) / 2))}.hsl .alert-success{color:hsla(calc(133.7007874016deg),calc(61.3526570048%),calc((0% + 40.5882352941%) / 2),calc((1 + 1) / 2));background-color:hsla(calc(133.7007874016deg),calc(61.3526570048%),calc((var(--white-l) + 40.5882352941%) / 2),calc((1 + 1) / 2));background-color:hsla(calc(133.7007874016deg),calc(61.3526570048%),calc((var(--white-l) + 40.5882352941%) / 2),calc((var(--white-a, 1) + 1) / 2));border-color:hsla(calc(133.7007874016deg),calc(61.3526570048%),calc((var(--white-l) + 40.5882352941%) / 2),calc((1 + 1) / 2));border-color:hsla(calc(133.7007874016deg),calc(61.3526570048%),calc((var(--white-l) + 40.5882352941%) / 2),calc((var(--white-a, 1) + 1) / 2))}.hsl .alert-success hr{border-top-color:hsla(calc(133.7007874016deg),calc(61.3526570048%),calc(calc((var(--white-l) + 40.5882352941%) / 2) + -5%),calc((1 + 1) / 2));border-top-color:hsla(calc(133.7007874016deg),calc(61.3526570048%),calc(calc((var(--white-l) + 40.5882352941%) / 2) + -5%),calc((var(--white-a, 1) + 1) / 2))}.hsl .alert-success .alert-link{color:hsla(calc(133.7007874016deg),calc(61.3526570048%),calc(calc((0% + 40.5882352941%) / 2) + -10%),)}.hsl .alert-info{color:hsla(calc(188.198757764deg),calc(77.7777777778%),calc((0% + 40.5882352941%) / 2),calc((1 + 1) / 2));background-color:hsla(calc(188.198757764deg),calc(77.7777777778%),calc((var(--white-l) + 40.5882352941%) / 2),calc((1 + 1) / 2));background-color:hsla(calc(188.198757764deg),calc(77.7777777778%),calc((var(--white-l) + 40.5882352941%) / 2),calc((var(--white-a, 1) + 1) / 2));border-color:hsla(calc(188.198757764deg),calc(77.7777777778%),calc((var(--white-l) + 40.5882352941%) / 2),calc((1 + 1) / 2));border-color:hsla(calc(188.198757764deg),calc(77.7777777778%),calc((var(--white-l) + 40.5882352941%) / 2),calc((var(--white-a, 1) + 1) / 2))}.hsl .alert-info hr{border-top-color:hsla(calc(188.198757764deg),calc(77.7777777778%),calc(calc((var(--white-l) + 40.5882352941%) / 2) + -5%),calc((1 + 1) / 2));border-top-color:hsla(calc(188.198757764deg),calc(77.7777777778%),calc(calc((var(--white-l) + 40.5882352941%) / 2) + -5%),calc((var(--white-a, 1) + 1) / 2))}.hsl .alert-info .alert-link{color:hsla(calc(188.198757764deg),calc(77.7777777778%),calc(calc((0% + 40.5882352941%) / 2) + -10%),)}.hsl .alert-warning{color:hsla(calc(45deg),calc(100%),calc((0% + 51.3725490196%) / 2),calc((1 + 1) / 2));background-color:hsla(calc(45deg),calc(100%),calc((var(--white-l) + 51.3725490196%) / 2),calc((1 + 1) / 2));background-color:hsla(calc(45deg),calc(100%),calc((var(--white-l) + 51.3725490196%) / 2),calc((var(--white-a, 1) + 1) / 2));border-color:hsla(calc(45deg),calc(100%),calc((var(--white-l) + 51.3725490196%) / 2),calc((1 + 1) / 2));border-color:hsla(calc(45deg),calc(100%),calc((var(--white-l) + 51.3725490196%) / 2),calc((var(--white-a, 1) + 1) / 2))}.hsl .alert-warning hr{border-top-color:hsla(calc(45deg),calc(100%),calc(calc((var(--white-l) + 51.3725490196%) / 2) + -5%),calc((1 + 1) / 2));border-top-color:hsla(calc(45deg),calc(100%),calc(calc((var(--white-l) + 51.3725490196%) / 2) + -5%),calc((var(--white-a, 1) + 1) / 2))}.hsl .alert-warning .alert-link{color:hsla(calc(45deg),calc(100%),calc(calc((0% + 51.3725490196%) / 2) + -10%),)}.hsl .alert-danger{color:hsla(calc(354.251497006deg),calc(70.4641350211%),calc((0% + 53.5294117647%) / 2),calc((1 + 1) / 2));background-color:hsla(calc(354.251497006deg),calc(70.4641350211%),calc((var(--white-l) + 53.5294117647%) / 2),calc((1 + 1) / 2));background-color:hsla(calc(354.251497006deg),calc(70.4641350211%),calc((var(--white-l) + 53.5294117647%) / 2),calc((var(--white-a, 1) + 1) / 2));border-color:hsla(calc(354.251497006deg),calc(70.4641350211%),calc((var(--white-l) + 53.5294117647%) / 2),calc((1 + 1) / 2));border-color:hsla(calc(354.251497006deg),calc(70.4641350211%),calc((var(--white-l) + 53.5294117647%) / 2),calc((var(--white-a, 1) + 1) / 2))}.hsl .alert-danger hr{border-top-color:hsla(calc(354.251497006deg),calc(70.4641350211%),calc(calc((var(--white-l) + 53.5294117647%) / 2) + -5%),calc((1 + 1) / 2));border-top-color:hsla(calc(354.251497006deg),calc(70.4641350211%),calc(calc((var(--white-l) + 53.5294117647%) / 2) + -5%),calc((var(--white-a, 1) + 1) / 2))}.hsl .alert-danger .alert-link{color:hsla(calc(354.251497006deg),calc(70.4641350211%),calc(calc((0% + 53.5294117647%) / 2) + -10%),)}.hsl .alert-light{color:hsla(calc(var(--light-h)),calc(var(--light-s)),calc((0% + var(--light-l)) / 2),calc((1 + 1) / 2));color:hsla(calc(var(--light-h)),calc(var(--light-s)),calc((0% + var(--light-l)) / 2),calc((1 + var(--light-a, 1)) / 2));background-color:hsla(calc(var(--light-h)),calc(var(--light-s)),calc((var(--white-l) + var(--light-l)) / 2),calc((1 + 1) / 2));background-color:hsla(calc(var(--light-h)),calc(var(--light-s)),calc((var(--white-l) + var(--light-l)) / 2),calc((var(--white-a, 1) + var(--light-a, 1)) / 2));border-color:hsla(calc(var(--light-h)),calc(var(--light-s)),calc((var(--white-l) + var(--light-l)) / 2),calc((1 + 1) / 2));border-color:hsla(calc(var(--light-h)),calc(var(--light-s)),calc((var(--white-l) + var(--light-l)) / 2),calc((var(--white-a, 1) + var(--light-a, 1)) / 2))}.hsl .alert-light hr{border-top-color:hsla(calc(var(--light-h)),calc(var(--light-s)),calc(calc((var(--white-l) + var(--light-l)) / 2) + -5%),calc((1 + 1) / 2));border-top-color:hsla(calc(var(--light-h)),calc(var(--light-s)),calc(calc((var(--white-l) + var(--light-l)) / 2) + -5%),calc((var(--white-a, 1) + var(--light-a, 1)) / 2))}.hsl .alert-light .alert-link{color:hsla(calc(var(--light-h)),calc(var(--light-s)),calc(calc((0% + var(--light-l)) / 2) + -10%),calc((1 + 1) / 2));color:hsla(calc(var(--light-h)),calc(var(--light-s)),calc(calc((0% + var(--light-l)) / 2) + -10%),calc((1 + var(--light-a, 1)) / 2))}.hsl .alert-dark{color:hsla(calc(var(--gray-800-h)),calc(var(--gray-800-s)),calc((0% + var(--gray-800-l)) / 2),calc((1 + 1) / 2));color:hsla(calc(var(--gray-800-h)),calc(var(--gray-800-s)),calc((0% + var(--gray-800-l)) / 2),calc((1 + var(--gray-800-a, 1)) / 2));background-color:hsla(calc(var(--gray-800-h)),calc(var(--gray-800-s)),calc((var(--white-l) + var(--gray-800-l)) / 2),calc((1 + 1) / 2));background-color:hsla(calc(var(--gray-800-h)),calc(var(--gray-800-s)),calc((var(--white-l) + var(--gray-800-l)) / 2),calc((var(--white-a, 1) + var(--gray-800-a, 1)) / 2));border-color:hsla(calc(var(--gray-800-h)),calc(var(--gray-800-s)),calc((var(--white-l) + var(--gray-800-l)) / 2),calc((1 + 1) / 2));border-color:hsla(calc(var(--gray-800-h)),calc(var(--gray-800-s)),calc((var(--white-l) + var(--gray-800-l)) / 2),calc((var(--white-a, 1) + var(--gray-800-a, 1)) / 2))}.hsl .alert-dark hr{border-top-color:hsla(calc(var(--gray-800-h)),calc(var(--gray-800-s)),calc(calc((var(--white-l) + var(--gray-800-l)) / 2) + -5%),calc((1 + 1) / 2));border-top-color:hsla(calc(var(--gray-800-h)),calc(var(--gray-800-s)),calc(calc((var(--white-l) + var(--gray-800-l)) / 2) + -5%),calc((var(--white-a, 1) + var(--gray-800-a, 1)) / 2))}.hsl .alert-dark .alert-link{color:hsla(calc(var(--gray-800-h)),calc(var(--gray-800-s)),calc(calc((0% + var(--gray-800-l)) / 2) + -10%),calc((1 + 1) / 2));color:hsla(calc(var(--gray-800-h)),calc(var(--gray-800-s)),calc(calc((0% + var(--gray-800-l)) / 2) + -10%),calc((1 + var(--gray-800-a, 1)) / 2))}.hsl .alert-gray{color:hsla(calc(var(--gray-900-h)),calc(var(--gray-900-s)),calc((0% + var(--gray-900-l)) / 2),calc((1 + 1) / 2));color:hsla(calc(var(--gray-900-h)),calc(var(--gray-900-s)),calc((0% + var(--gray-900-l)) / 2),calc((1 + var(--gray-900-a, 1)) / 2));background-color:hsla(calc(var(--gray-900-h)),calc(var(--gray-900-s)),calc((var(--white-l) + var(--gray-900-l)) / 2),calc((1 + 1) / 2));background-color:hsla(calc(var(--gray-900-h)),calc(var(--gray-900-s)),calc((var(--white-l) + var(--gray-900-l)) / 2),calc((var(--white-a, 1) + var(--gray-900-a, 1)) / 2));border-color:hsla(calc(var(--gray-900-h)),calc(var(--gray-900-s)),calc((var(--white-l) + var(--gray-900-l)) / 2),calc((1 + 1) / 2));border-color:hsla(calc(var(--gray-900-h)),calc(var(--gray-900-s)),calc((var(--white-l) + var(--gray-900-l)) / 2),calc((var(--white-a, 1) + var(--gray-900-a, 1)) / 2))}.hsl .alert-gray hr{border-top-color:hsla(calc(var(--gray-900-h)),calc(var(--gray-900-s)),calc(calc((var(--white-l) + var(--gray-900-l)) / 2) + -5%),calc((1 + 1) / 2));border-top-color:hsla(calc(var(--gray-900-h)),calc(var(--gray-900-s)),calc(calc((var(--white-l) + var(--gray-900-l)) / 2) + -5%),calc((var(--white-a, 1) + var(--gray-900-a, 1)) / 2))}.hsl .alert-gray .alert-link{color:hsla(calc(var(--gray-900-h)),calc(var(--gray-900-s)),calc(calc((0% + var(--gray-900-l)) / 2) + -10%),calc((1 + 1) / 2));color:hsla(calc(var(--gray-900-h)),calc(var(--gray-900-s)),calc(calc((0% + var(--gray-900-l)) / 2) + -10%),calc((1 + var(--gray-900-a, 1)) / 2))}@-webkit-keyframes progress-bar-stripes{0%{background-position:1rem 0}to{background-position:0 0}}@keyframes progress-bar-stripes{0%{background-position:1rem 0}to{background-position:0 0}}.hsl .progress{display:flex;height:1rem;overflow:hidden;line-height:0;font-size:.75rem;background-color:var(--gray-200);border-radius:.25rem}.hsl .progress-bar{display:flex;flex-direction:column;justify-content:center;overflow:hidden;color:var(--white);text-align:center;white-space:nowrap;background-color:var(--primary);transition:width .6s ease}@media (prefers-reduced-motion: reduce){.hsl .progress-bar{transition:none}}.hsl .progress-bar-striped{background-image:linear-gradient(45deg,hsla(var(--white-h),var(--white-s),var(--white-l),.15) 25%,transparent 25%,transparent 50%,hsla(var(--white-h),var(--white-s),var(--white-l),.15) 50%,hsla(var(--white-h),var(--white-s),var(--white-l),.15) 75%,transparent 75%,transparent);background-size:1rem 1rem}.hsl .progress-bar-animated{-webkit-animation:1s linear infinite progress-bar-stripes;animation:1s linear infinite progress-bar-stripes}@media (prefers-reduced-motion: reduce){.hsl .progress-bar-animated{-webkit-animation:none;animation:none}}.hsl .media{display:flex;align-items:flex-start}.hsl .media-body{flex:1}.hsl .list-group{display:flex;flex-direction:column;padding-left:0;margin-bottom:0;border-radius:.25rem}.hsl .list-group-item-action{width:100%;color:var(--text-color);text-align:inherit}.hsl .list-group-item-action:hover,.hsl .list-group-item-action:focus{z-index:1;color:var(--text-color);text-decoration:none;background-color:#f8f9fa}.hsl .list-group-item-action:active{color:var(--gray-900);background-color:var(--gray-200)}.hsl .list-group-item{position:relative;display:block;padding:.75rem 1.25rem;background-color:var(--white);border:1px solid rgba(0,0,0,.125)}.hsl .list-group-item:first-child{border-top-left-radius:inherit;border-top-right-radius:inherit}.hsl .list-group-item:last-child{border-bottom-right-radius:inherit;border-bottom-left-radius:inherit}.hsl .list-group-item.disabled,.hsl .list-group-item:disabled{color:#6c757d;pointer-events:none;background-color:var(--white)}.hsl .list-group-item.active{z-index:2;color:var(--white);background-color:var(--primary);border-color:var(--primary)}.hsl .list-group-item+.hsl .list-group-item{border-top-width:0}.hsl .list-group-item+.hsl .list-group-item.active{margin-top:-1px;border-top-width:1px}.hsl .list-group-horizontal{flex-direction:row}.hsl .list-group-horizontal>.list-group-item:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.hsl .list-group-horizontal>.list-group-item:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.hsl .list-group-horizontal>.list-group-item.active{margin-top:0}.hsl .list-group-horizontal>.list-group-item+.list-group-item{border-top-width:1px;border-left-width:0}.hsl .list-group-horizontal>.list-group-item+.list-group-item.active{margin-left:-1px;border-left-width:1px}@media (min-width: 576px){.hsl .list-group-horizontal-sm{flex-direction:row}.hsl .list-group-horizontal-sm>.list-group-item:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.hsl .list-group-horizontal-sm>.list-group-item:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.hsl .list-group-horizontal-sm>.list-group-item.active{margin-top:0}.hsl .list-group-horizontal-sm>.list-group-item+.list-group-item{border-top-width:1px;border-left-width:0}.hsl .list-group-horizontal-sm>.list-group-item+.list-group-item.active{margin-left:-1px;border-left-width:1px}}@media (min-width: 768px){.hsl .list-group-horizontal-md{flex-direction:row}.hsl .list-group-horizontal-md>.list-group-item:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.hsl .list-group-horizontal-md>.list-group-item:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.hsl .list-group-horizontal-md>.list-group-item.active{margin-top:0}.hsl .list-group-horizontal-md>.list-group-item+.list-group-item{border-top-width:1px;border-left-width:0}.hsl .list-group-horizontal-md>.list-group-item+.list-group-item.active{margin-left:-1px;border-left-width:1px}}@media (min-width: 992px){.hsl .list-group-horizontal-lg{flex-direction:row}.hsl .list-group-horizontal-lg>.list-group-item:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.hsl .list-group-horizontal-lg>.list-group-item:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.hsl .list-group-horizontal-lg>.list-group-item.active{margin-top:0}.hsl .list-group-horizontal-lg>.list-group-item+.list-group-item{border-top-width:1px;border-left-width:0}.hsl .list-group-horizontal-lg>.list-group-item+.list-group-item.active{margin-left:-1px;border-left-width:1px}}@media (min-width: 1200px){.hsl .list-group-horizontal-xl{flex-direction:row}.hsl .list-group-horizontal-xl>.list-group-item:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.hsl .list-group-horizontal-xl>.list-group-item:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.hsl .list-group-horizontal-xl>.list-group-item.active{margin-top:0}.hsl .list-group-horizontal-xl>.list-group-item+.list-group-item{border-top-width:1px;border-left-width:0}.hsl .list-group-horizontal-xl>.list-group-item+.list-group-item.active{margin-left:-1px;border-left-width:1px}}.hsl .list-group-flush{border-radius:0}.hsl .list-group-flush>.list-group-item{border-width:0 0 1px}.hsl .list-group-flush>.list-group-item:last-child{border-bottom-width:0}.hsl .list-group-item-primary{color:hsla(calc(var(--primary-h)),calc(var(--primary-s)),calc((0% + var(--primary-l)) / 2),calc((1 + 1) / 2));color:hsla(calc(var(--primary-h)),calc(var(--primary-s)),calc((0% + var(--primary-l)) / 2),calc((1 + var(--primary-a, 1)) / 2));background-color:hsla(calc(var(--primary-h)),calc(var(--primary-s)),calc((var(--white-l) + var(--primary-l)) / 2),calc((1 + 1) / 2));background-color:hsla(calc(var(--primary-h)),calc(var(--primary-s)),calc((var(--white-l) + var(--primary-l)) / 2),calc((var(--white-a, 1) + var(--primary-a, 1)) / 2))}.hsl .list-group-item-primary.list-group-item-action:hover,.hsl .list-group-item-primary.list-group-item-action:focus{color:hsla(calc(var(--primary-h)),calc(var(--primary-s)),calc((0% + var(--primary-l)) / 2),calc((1 + 1) / 2));color:hsla(calc(var(--primary-h)),calc(var(--primary-s)),calc((0% + var(--primary-l)) / 2),calc((1 + var(--primary-a, 1)) / 2));background-color:hsla(calc(var(--primary-h)),calc(var(--primary-s)),calc(calc((var(--white-l) + var(--primary-l)) / 2) + -5%),calc((1 + 1) / 2));background-color:hsla(calc(var(--primary-h)),calc(var(--primary-s)),calc(calc((var(--white-l) + var(--primary-l)) / 2) + -5%),calc((var(--white-a, 1) + var(--primary-a, 1)) / 2))}.hsl .list-group-item-primary.list-group-item-action.active{color:var(--white);background-color:hsla(calc(var(--primary-h)),calc(var(--primary-s)),calc((0% + var(--primary-l)) / 2),calc((1 + 1) / 2));background-color:hsla(calc(var(--primary-h)),calc(var(--primary-s)),calc((0% + var(--primary-l)) / 2),calc((1 + var(--primary-a, 1)) / 2));border-color:hsla(calc(var(--primary-h)),calc(var(--primary-s)),calc((0% + var(--primary-l)) / 2),calc((1 + 1) / 2));border-color:hsla(calc(var(--primary-h)),calc(var(--primary-s)),calc((0% + var(--primary-l)) / 2),calc((1 + var(--primary-a, 1)) / 2))}.hsl .list-group-item-secondary{color:hsla(calc(var(--secondary-h)),calc(var(--secondary-s)),calc((0% + var(--secondary-l)) / 2),calc((1 + 1) / 2));color:hsla(calc(var(--secondary-h)),calc(var(--secondary-s)),calc((0% + var(--secondary-l)) / 2),calc((1 + var(--secondary-a, 1)) / 2));background-color:hsla(calc(var(--secondary-h)),calc(var(--secondary-s)),calc((var(--white-l) + var(--secondary-l)) / 2),calc((1 + 1) / 2));background-color:hsla(calc(var(--secondary-h)),calc(var(--secondary-s)),calc((var(--white-l) + var(--secondary-l)) / 2),calc((var(--white-a, 1) + var(--secondary-a, 1)) / 2))}.hsl .list-group-item-secondary.list-group-item-action:hover,.hsl .list-group-item-secondary.list-group-item-action:focus{color:hsla(calc(var(--secondary-h)),calc(var(--secondary-s)),calc((0% + var(--secondary-l)) / 2),calc((1 + 1) / 2));color:hsla(calc(var(--secondary-h)),calc(var(--secondary-s)),calc((0% + var(--secondary-l)) / 2),calc((1 + var(--secondary-a, 1)) / 2));background-color:hsla(calc(var(--secondary-h)),calc(var(--secondary-s)),calc(calc((var(--white-l) + var(--secondary-l)) / 2) + -5%),calc((1 + 1) / 2));background-color:hsla(calc(var(--secondary-h)),calc(var(--secondary-s)),calc(calc((var(--white-l) + var(--secondary-l)) / 2) + -5%),calc((var(--white-a, 1) + var(--secondary-a, 1)) / 2))}.hsl .list-group-item-secondary.list-group-item-action.active{color:var(--white);background-color:hsla(calc(var(--secondary-h)),calc(var(--secondary-s)),calc((0% + var(--secondary-l)) / 2),calc((1 + 1) / 2));background-color:hsla(calc(var(--secondary-h)),calc(var(--secondary-s)),calc((0% + var(--secondary-l)) / 2),calc((1 + var(--secondary-a, 1)) / 2));border-color:hsla(calc(var(--secondary-h)),calc(var(--secondary-s)),calc((0% + var(--secondary-l)) / 2),calc((1 + 1) / 2));border-color:hsla(calc(var(--secondary-h)),calc(var(--secondary-s)),calc((0% + var(--secondary-l)) / 2),calc((1 + var(--secondary-a, 1)) / 2))}.hsl .list-group-item-success{color:hsla(calc(133.7007874016deg),calc(61.3526570048%),calc((0% + 40.5882352941%) / 2),calc((1 + 1) / 2));background-color:hsla(calc(133.7007874016deg),calc(61.3526570048%),calc((var(--white-l) + 40.5882352941%) / 2),calc((1 + 1) / 2));background-color:hsla(calc(133.7007874016deg),calc(61.3526570048%),calc((var(--white-l) + 40.5882352941%) / 2),calc((var(--white-a, 1) + 1) / 2))}.hsl .list-group-item-success.list-group-item-action:hover,.hsl .list-group-item-success.list-group-item-action:focus{color:hsla(calc(133.7007874016deg),calc(61.3526570048%),calc((0% + 40.5882352941%) / 2),calc((1 + 1) / 2));background-color:hsla(calc(133.7007874016deg),calc(61.3526570048%),calc(calc((var(--white-l) + 40.5882352941%) / 2) + -5%),calc((1 + 1) / 2));background-color:hsla(calc(133.7007874016deg),calc(61.3526570048%),calc(calc((var(--white-l) + 40.5882352941%) / 2) + -5%),calc((var(--white-a, 1) + 1) / 2))}.hsl .list-group-item-success.list-group-item-action.active{color:var(--white);background-color:hsla(calc(133.7007874016deg),calc(61.3526570048%),calc((0% + 40.5882352941%) / 2),calc((1 + 1) / 2));border-color:hsla(calc(133.7007874016deg),calc(61.3526570048%),calc((0% + 40.5882352941%) / 2),calc((1 + 1) / 2))}.hsl .list-group-item-info{color:hsla(calc(188.198757764deg),calc(77.7777777778%),calc((0% + 40.5882352941%) / 2),calc((1 + 1) / 2));background-color:hsla(calc(188.198757764deg),calc(77.7777777778%),calc((var(--white-l) + 40.5882352941%) / 2),calc((1 + 1) / 2));background-color:hsla(calc(188.198757764deg),calc(77.7777777778%),calc((var(--white-l) + 40.5882352941%) / 2),calc((var(--white-a, 1) + 1) / 2))}.hsl .list-group-item-info.list-group-item-action:hover,.hsl .list-group-item-info.list-group-item-action:focus{color:hsla(calc(188.198757764deg),calc(77.7777777778%),calc((0% + 40.5882352941%) / 2),calc((1 + 1) / 2));background-color:hsla(calc(188.198757764deg),calc(77.7777777778%),calc(calc((var(--white-l) + 40.5882352941%) / 2) + -5%),calc((1 + 1) / 2));background-color:hsla(calc(188.198757764deg),calc(77.7777777778%),calc(calc((var(--white-l) + 40.5882352941%) / 2) + -5%),calc((var(--white-a, 1) + 1) / 2))}.hsl .list-group-item-info.list-group-item-action.active{color:var(--white);background-color:hsla(calc(188.198757764deg),calc(77.7777777778%),calc((0% + 40.5882352941%) / 2),calc((1 + 1) / 2));border-color:hsla(calc(188.198757764deg),calc(77.7777777778%),calc((0% + 40.5882352941%) / 2),calc((1 + 1) / 2))}.hsl .list-group-item-warning{color:hsla(calc(45deg),calc(100%),calc((0% + 51.3725490196%) / 2),calc((1 + 1) / 2));background-color:hsla(calc(45deg),calc(100%),calc((var(--white-l) + 51.3725490196%) / 2),calc((1 + 1) / 2));background-color:hsla(calc(45deg),calc(100%),calc((var(--white-l) + 51.3725490196%) / 2),calc((var(--white-a, 1) + 1) / 2))}.hsl .list-group-item-warning.list-group-item-action:hover,.hsl .list-group-item-warning.list-group-item-action:focus{color:hsla(calc(45deg),calc(100%),calc((0% + 51.3725490196%) / 2),calc((1 + 1) / 2));background-color:hsla(calc(45deg),calc(100%),calc(calc((var(--white-l) + 51.3725490196%) / 2) + -5%),calc((1 + 1) / 2));background-color:hsla(calc(45deg),calc(100%),calc(calc((var(--white-l) + 51.3725490196%) / 2) + -5%),calc((var(--white-a, 1) + 1) / 2))}.hsl .list-group-item-warning.list-group-item-action.active{color:var(--white);background-color:hsla(calc(45deg),calc(100%),calc((0% + 51.3725490196%) / 2),calc((1 + 1) / 2));border-color:hsla(calc(45deg),calc(100%),calc((0% + 51.3725490196%) / 2),calc((1 + 1) / 2))}.hsl .list-group-item-danger{color:hsla(calc(354.251497006deg),calc(70.4641350211%),calc((0% + 53.5294117647%) / 2),calc((1 + 1) / 2));background-color:hsla(calc(354.251497006deg),calc(70.4641350211%),calc((var(--white-l) + 53.5294117647%) / 2),calc((1 + 1) / 2));background-color:hsla(calc(354.251497006deg),calc(70.4641350211%),calc((var(--white-l) + 53.5294117647%) / 2),calc((var(--white-a, 1) + 1) / 2))}.hsl .list-group-item-danger.list-group-item-action:hover,.hsl .list-group-item-danger.list-group-item-action:focus{color:hsla(calc(354.251497006deg),calc(70.4641350211%),calc((0% + 53.5294117647%) / 2),calc((1 + 1) / 2));background-color:hsla(calc(354.251497006deg),calc(70.4641350211%),calc(calc((var(--white-l) + 53.5294117647%) / 2) + -5%),calc((1 + 1) / 2));background-color:hsla(calc(354.251497006deg),calc(70.4641350211%),calc(calc((var(--white-l) + 53.5294117647%) / 2) + -5%),calc((var(--white-a, 1) + 1) / 2))}.hsl .list-group-item-danger.list-group-item-action.active{color:var(--white);background-color:hsla(calc(354.251497006deg),calc(70.4641350211%),calc((0% + 53.5294117647%) / 2),calc((1 + 1) / 2));border-color:hsla(calc(354.251497006deg),calc(70.4641350211%),calc((0% + 53.5294117647%) / 2),calc((1 + 1) / 2))}.hsl .list-group-item-light{color:hsla(calc(var(--light-h)),calc(var(--light-s)),calc((0% + var(--light-l)) / 2),calc((1 + 1) / 2));color:hsla(calc(var(--light-h)),calc(var(--light-s)),calc((0% + var(--light-l)) / 2),calc((1 + var(--light-a, 1)) / 2));background-color:hsla(calc(var(--light-h)),calc(var(--light-s)),calc((var(--white-l) + var(--light-l)) / 2),calc((1 + 1) / 2));background-color:hsla(calc(var(--light-h)),calc(var(--light-s)),calc((var(--white-l) + var(--light-l)) / 2),calc((var(--white-a, 1) + var(--light-a, 1)) / 2))}.hsl .list-group-item-light.list-group-item-action:hover,.hsl .list-group-item-light.list-group-item-action:focus{color:hsla(calc(var(--light-h)),calc(var(--light-s)),calc((0% + var(--light-l)) / 2),calc((1 + 1) / 2));color:hsla(calc(var(--light-h)),calc(var(--light-s)),calc((0% + var(--light-l)) / 2),calc((1 + var(--light-a, 1)) / 2));background-color:hsla(calc(var(--light-h)),calc(var(--light-s)),calc(calc((var(--white-l) + var(--light-l)) / 2) + -5%),calc((1 + 1) / 2));background-color:hsla(calc(var(--light-h)),calc(var(--light-s)),calc(calc((var(--white-l) + var(--light-l)) / 2) + -5%),calc((var(--white-a, 1) + var(--light-a, 1)) / 2))}.hsl .list-group-item-light.list-group-item-action.active{color:var(--white);background-color:hsla(calc(var(--light-h)),calc(var(--light-s)),calc((0% + var(--light-l)) / 2),calc((1 + 1) / 2));background-color:hsla(calc(var(--light-h)),calc(var(--light-s)),calc((0% + var(--light-l)) / 2),calc((1 + var(--light-a, 1)) / 2));border-color:hsla(calc(var(--light-h)),calc(var(--light-s)),calc((0% + var(--light-l)) / 2),calc((1 + 1) / 2));border-color:hsla(calc(var(--light-h)),calc(var(--light-s)),calc((0% + var(--light-l)) / 2),calc((1 + var(--light-a, 1)) / 2))}.hsl .list-group-item-dark{color:hsla(calc(var(--gray-800-h)),calc(var(--gray-800-s)),calc((0% + var(--gray-800-l)) / 2),calc((1 + 1) / 2));color:hsla(calc(var(--gray-800-h)),calc(var(--gray-800-s)),calc((0% + var(--gray-800-l)) / 2),calc((1 + var(--gray-800-a, 1)) / 2));background-color:hsla(calc(var(--gray-800-h)),calc(var(--gray-800-s)),calc((var(--white-l) + var(--gray-800-l)) / 2),calc((1 + 1) / 2));background-color:hsla(calc(var(--gray-800-h)),calc(var(--gray-800-s)),calc((var(--white-l) + var(--gray-800-l)) / 2),calc((var(--white-a, 1) + var(--gray-800-a, 1)) / 2))}.hsl .list-group-item-dark.list-group-item-action:hover,.hsl .list-group-item-dark.list-group-item-action:focus{color:hsla(calc(var(--gray-800-h)),calc(var(--gray-800-s)),calc((0% + var(--gray-800-l)) / 2),calc((1 + 1) / 2));color:hsla(calc(var(--gray-800-h)),calc(var(--gray-800-s)),calc((0% + var(--gray-800-l)) / 2),calc((1 + var(--gray-800-a, 1)) / 2));background-color:hsla(calc(var(--gray-800-h)),calc(var(--gray-800-s)),calc(calc((var(--white-l) + var(--gray-800-l)) / 2) + -5%),calc((1 + 1) / 2));background-color:hsla(calc(var(--gray-800-h)),calc(var(--gray-800-s)),calc(calc((var(--white-l) + var(--gray-800-l)) / 2) + -5%),calc((var(--white-a, 1) + var(--gray-800-a, 1)) / 2))}.hsl .list-group-item-dark.list-group-item-action.active{color:var(--white);background-color:hsla(calc(var(--gray-800-h)),calc(var(--gray-800-s)),calc((0% + var(--gray-800-l)) / 2),calc((1 + 1) / 2));background-color:hsla(calc(var(--gray-800-h)),calc(var(--gray-800-s)),calc((0% + var(--gray-800-l)) / 2),calc((1 + var(--gray-800-a, 1)) / 2));border-color:hsla(calc(var(--gray-800-h)),calc(var(--gray-800-s)),calc((0% + var(--gray-800-l)) / 2),calc((1 + 1) / 2));border-color:hsla(calc(var(--gray-800-h)),calc(var(--gray-800-s)),calc((0% + var(--gray-800-l)) / 2),calc((1 + var(--gray-800-a, 1)) / 2))}.hsl .list-group-item-gray{color:hsla(calc(var(--gray-900-h)),calc(var(--gray-900-s)),calc((0% + var(--gray-900-l)) / 2),calc((1 + 1) / 2));color:hsla(calc(var(--gray-900-h)),calc(var(--gray-900-s)),calc((0% + var(--gray-900-l)) / 2),calc((1 + var(--gray-900-a, 1)) / 2));background-color:hsla(calc(var(--gray-900-h)),calc(var(--gray-900-s)),calc((var(--white-l) + var(--gray-900-l)) / 2),calc((1 + 1) / 2));background-color:hsla(calc(var(--gray-900-h)),calc(var(--gray-900-s)),calc((var(--white-l) + var(--gray-900-l)) / 2),calc((var(--white-a, 1) + var(--gray-900-a, 1)) / 2))}.hsl .list-group-item-gray.list-group-item-action:hover,.hsl .list-group-item-gray.list-group-item-action:focus{color:hsla(calc(var(--gray-900-h)),calc(var(--gray-900-s)),calc((0% + var(--gray-900-l)) / 2),calc((1 + 1) / 2));color:hsla(calc(var(--gray-900-h)),calc(var(--gray-900-s)),calc((0% + var(--gray-900-l)) / 2),calc((1 + var(--gray-900-a, 1)) / 2));background-color:hsla(calc(var(--gray-900-h)),calc(var(--gray-900-s)),calc(calc((var(--white-l) + var(--gray-900-l)) / 2) + -5%),calc((1 + 1) / 2));background-color:hsla(calc(var(--gray-900-h)),calc(var(--gray-900-s)),calc(calc((var(--white-l) + var(--gray-900-l)) / 2) + -5%),calc((var(--white-a, 1) + var(--gray-900-a, 1)) / 2))}.hsl .list-group-item-gray.list-group-item-action.active{color:var(--white);background-color:hsla(calc(var(--gray-900-h)),calc(var(--gray-900-s)),calc((0% + var(--gray-900-l)) / 2),calc((1 + 1) / 2));background-color:hsla(calc(var(--gray-900-h)),calc(var(--gray-900-s)),calc((0% + var(--gray-900-l)) / 2),calc((1 + var(--gray-900-a, 1)) / 2));border-color:hsla(calc(var(--gray-900-h)),calc(var(--gray-900-s)),calc((0% + var(--gray-900-l)) / 2),calc((1 + 1) / 2));border-color:hsla(calc(var(--gray-900-h)),calc(var(--gray-900-s)),calc((0% + var(--gray-900-l)) / 2),calc((1 + var(--gray-900-a, 1)) / 2))}.hsl .close{float:right;font-size:1.5rem;font-weight:700;line-height:1;color:#000;text-shadow:0 1px 0 var(--white);opacity:.5}@media (max-width: 1200px){.hsl .close{font-size:calc(1.275rem + .3vw)}}.hsl .close:hover{color:#000;text-decoration:none}.hsl .close:not(:disabled):not(.disabled):hover,.hsl .close:not(:disabled):not(.disabled):focus{opacity:.75}.hsl button.close{padding:0;background-color:transparent;border:0}.hsl a.close.disabled{pointer-events:none}.hsl .toast{flex-basis:350px;max-width:350px;font-size:.875rem;background-color:hsla(var(--white-h),var(--white-s),var(--white-l),.85);background-clip:padding-box;border:1px solid rgba(0,0,0,.1);box-shadow:0 .25rem .75rem #0000001a;opacity:0;border-radius:.25rem}.hsl .toast:not(:last-child){margin-bottom:.75rem}.hsl .toast.showing{opacity:1}.hsl .toast.show{display:block;opacity:1}.hsl .toast.hide{display:none}.hsl .toast-header{display:flex;align-items:center;padding:.25rem .75rem;color:#6c757d;background-color:#fff;background-clip:padding-box;border-bottom:1px solid rgba(0,0,0,.05);border-top-left-radius:calc(.25rem - 1px);border-top-right-radius:calc(.25rem - 1px)}.hsl .toast-body{padding:.75rem}.hsl .modal-open{overflow:hidden}.hsl .modal-open .modal{overflow-x:hidden;overflow-y:auto}.hsl .modal{position:fixed;top:0;left:0;z-index:1050;display:none;width:100%;height:100%;overflow:hidden;outline:0}.hsl .modal-dialog{position:relative;width:auto;margin:.5rem;pointer-events:none}.modal.fade .hsl .modal-dialog{transition:transform .3s ease-out;transform:translateY(-50px)}@media (prefers-reduced-motion: reduce){.modal.fade .hsl .modal-dialog{transition:none}}.modal.show .hsl .modal-dialog{transform:none}.modal.modal-static .hsl .modal-dialog{transform:scale(1.02)}.hsl .modal-dialog-scrollable{display:flex;max-height:calc(100% - 1rem)}.hsl .modal-dialog-scrollable .modal-content{max-height:calc(100vh - 1rem);overflow:hidden}.hsl .modal-dialog-scrollable .modal-header,.hsl .modal-dialog-scrollable .modal-footer{flex-shrink:0}.hsl .modal-dialog-scrollable .modal-body{overflow-y:auto}.hsl .modal-dialog-centered{display:flex;align-items:center;min-height:calc(100% - 1rem)}.hsl .modal-dialog-centered:before{display:block;height:calc(100vh - 1rem);height:-webkit-min-content;height:-moz-min-content;height:min-content;content:\"\"}.hsl .modal-dialog-centered.modal-dialog-scrollable{flex-direction:column;justify-content:center;height:100%}.hsl .modal-dialog-centered.modal-dialog-scrollable .modal-content{max-height:none}.hsl .modal-dialog-centered.modal-dialog-scrollable:before{content:none}.hsl .modal-content{position:relative;display:flex;flex-direction:column;width:100%;pointer-events:auto;background-color:var(--white);background-clip:padding-box;border:1px solid rgba(0,0,0,.2);border-radius:.3rem;outline:0}.hsl .modal-backdrop{position:fixed;top:0;left:0;z-index:1040;width:100vw;height:100vh;background-color:#000}.hsl .modal-backdrop.fade{opacity:0}.hsl .modal-backdrop.show{opacity:.5}.hsl .modal-header{display:flex;align-items:flex-start;justify-content:space-between;padding:1rem;border-bottom:1px solid #dee2e6;border-top-left-radius:calc(.3rem - 1px);border-top-right-radius:calc(.3rem - 1px)}.hsl .modal-header .close{padding:1rem;margin:-1rem -1rem -1rem auto}.hsl .modal-title{margin-bottom:0;line-height:1.5}.hsl .modal-body{position:relative;flex:1 1 auto;padding:1rem}.hsl .modal-footer{display:flex;flex-wrap:wrap;align-items:center;justify-content:flex-end;padding:.75rem;border-top:1px solid #dee2e6;border-bottom-right-radius:calc(.3rem - 1px);border-bottom-left-radius:calc(.3rem - 1px)}.hsl .modal-footer>*{margin:.25rem}.hsl .modal-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}@media (min-width: 576px){.hsl .modal-dialog{max-width:500px;margin:1.75rem auto}.hsl .modal-dialog-scrollable{max-height:calc(100% - 3.5rem)}.hsl .modal-dialog-scrollable .modal-content{max-height:calc(100vh - 3.5rem)}.hsl .modal-dialog-centered{min-height:calc(100% - 3.5rem)}.hsl .modal-dialog-centered:before{height:calc(100vh - 3.5rem);height:-webkit-min-content;height:-moz-min-content;height:min-content}.hsl .modal-sm{max-width:300px}}@media (min-width: 992px){.hsl .modal-lg,.hsl .modal-xl{max-width:800px}}@media (min-width: 1200px){.hsl .modal-xl{max-width:1140px}}.hsl .tooltip{position:absolute;z-index:1070;display:block;margin:0;font-family:-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,\"Noto Sans\",\"Liberation Sans\",sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Noto Color Emoji\";font-style:normal;font-weight:400;line-height:1.5;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;white-space:normal;line-break:auto;font-size:.875rem;word-wrap:break-word;opacity:0}.hsl .tooltip.show{opacity:.9}.hsl .tooltip .arrow{position:absolute;display:block;width:.8rem;height:.4rem}.hsl .tooltip .arrow:before{position:absolute;content:\"\";border-color:transparent;border-style:solid}.hsl .bs-tooltip-top,.hsl .bs-tooltip-auto[x-placement^=top]{padding:.4rem 0}.hsl .bs-tooltip-top .arrow,.hsl .bs-tooltip-auto[x-placement^=top] .arrow{bottom:0}.hsl .bs-tooltip-top .arrow:before,.hsl .bs-tooltip-auto[x-placement^=top] .arrow:before{top:0;border-width:.4rem .4rem 0;border-top-color:#000}.hsl .bs-tooltip-right,.hsl .bs-tooltip-auto[x-placement^=right]{padding:0 .4rem}.hsl .bs-tooltip-right .arrow,.hsl .bs-tooltip-auto[x-placement^=right] .arrow{left:0;width:.4rem;height:.8rem}.hsl .bs-tooltip-right .arrow:before,.hsl .bs-tooltip-auto[x-placement^=right] .arrow:before{right:0;border-width:.4rem .4rem .4rem 0;border-right-color:#000}.hsl .bs-tooltip-bottom,.hsl .bs-tooltip-auto[x-placement^=bottom]{padding:.4rem 0}.hsl .bs-tooltip-bottom .arrow,.hsl .bs-tooltip-auto[x-placement^=bottom] .arrow{top:0}.hsl .bs-tooltip-bottom .arrow:before,.hsl .bs-tooltip-auto[x-placement^=bottom] .arrow:before{bottom:0;border-width:0 .4rem .4rem;border-bottom-color:#000}.hsl .bs-tooltip-left,.hsl .bs-tooltip-auto[x-placement^=left]{padding:0 .4rem}.hsl .bs-tooltip-left .arrow,.hsl .bs-tooltip-auto[x-placement^=left] .arrow{right:0;width:.4rem;height:.8rem}.hsl .bs-tooltip-left .arrow:before,.hsl .bs-tooltip-auto[x-placement^=left] .arrow:before{left:0;border-width:.4rem 0 .4rem .4rem;border-left-color:#000}.hsl .tooltip-inner{max-width:200px;padding:.25rem .5rem;color:var(--white);text-align:center;background-color:#000;border-radius:.25rem}.hsl .popover{position:absolute;top:0;left:0;z-index:1060;display:block;max-width:276px;font-family:-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,\"Noto Sans\",\"Liberation Sans\",sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Noto Color Emoji\";font-style:normal;font-weight:400;line-height:1.5;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;white-space:normal;line-break:auto;font-size:.875rem;word-wrap:break-word;background-color:var(--white);background-clip:padding-box;border:1px solid rgba(0,0,0,.2);border-radius:.3rem}.hsl .popover .arrow{position:absolute;display:block;width:1rem;height:.5rem;margin:0 .3rem}.hsl .popover .arrow:before,.hsl .popover .arrow:after{position:absolute;display:block;content:\"\";border-color:transparent;border-style:solid}.hsl .bs-popover-top,.hsl .bs-popover-auto[x-placement^=top]{margin-bottom:.5rem}.hsl .bs-popover-top>.arrow,.hsl .bs-popover-auto[x-placement^=top]>.arrow{bottom:calc(-.5rem - 1px)}.hsl .bs-popover-top>.arrow:before,.hsl .bs-popover-auto[x-placement^=top]>.arrow:before{bottom:0;border-width:.5rem .5rem 0;border-top-color:#00000040}.hsl .bs-popover-top>.arrow:after,.hsl .bs-popover-auto[x-placement^=top]>.arrow:after{bottom:1px;border-width:.5rem .5rem 0;border-top-color:var(--white)}.hsl .bs-popover-right,.hsl .bs-popover-auto[x-placement^=right]{margin-left:.5rem}.hsl .bs-popover-right>.arrow,.hsl .bs-popover-auto[x-placement^=right]>.arrow{left:calc(-.5rem - 1px);width:.5rem;height:1rem;margin:.3rem 0}.hsl .bs-popover-right>.arrow:before,.hsl .bs-popover-auto[x-placement^=right]>.arrow:before{left:0;border-width:.5rem .5rem .5rem 0;border-right-color:#00000040}.hsl .bs-popover-right>.arrow:after,.hsl .bs-popover-auto[x-placement^=right]>.arrow:after{left:1px;border-width:.5rem .5rem .5rem 0;border-right-color:var(--white)}.hsl .bs-popover-bottom,.hsl .bs-popover-auto[x-placement^=bottom]{margin-top:.5rem}.hsl .bs-popover-bottom>.arrow,.hsl .bs-popover-auto[x-placement^=bottom]>.arrow{top:calc(-.5rem - 1px)}.hsl .bs-popover-bottom>.arrow:before,.hsl .bs-popover-auto[x-placement^=bottom]>.arrow:before{top:0;border-width:0 .5rem .5rem .5rem;border-bottom-color:#00000040}.hsl .bs-popover-bottom>.arrow:after,.hsl .bs-popover-auto[x-placement^=bottom]>.arrow:after{top:1px;border-width:0 .5rem .5rem .5rem;border-bottom-color:var(--white)}.hsl .bs-popover-bottom .popover-header:before,.hsl .bs-popover-auto[x-placement^=bottom] .popover-header:before{position:absolute;top:0;left:50%;display:block;width:1rem;margin-left:-.5rem;content:\"\";border-bottom:1px solid hsla(var(--white-h),var(--white-s),calc(var(--white-l) + -3%),1);border-bottom:1px solid hsla(var(--white-h),var(--white-s),calc(var(--white-l) + -3%),var(--white-a, 1))}.hsl .bs-popover-left,.hsl .bs-popover-auto[x-placement^=left]{margin-right:.5rem}.hsl .bs-popover-left>.arrow,.hsl .bs-popover-auto[x-placement^=left]>.arrow{right:calc(-.5rem - 1px);width:.5rem;height:1rem;margin:.3rem 0}.hsl .bs-popover-left>.arrow:before,.hsl .bs-popover-auto[x-placement^=left]>.arrow:before{right:0;border-width:.5rem 0 .5rem .5rem;border-left-color:#00000040}.hsl .bs-popover-left>.arrow:after,.hsl .bs-popover-auto[x-placement^=left]>.arrow:after{right:1px;border-width:.5rem 0 .5rem .5rem;border-left-color:var(--white)}.hsl .popover-header{padding:.5rem .75rem;margin-bottom:0;font-size:1rem;background-color:hsla(var(--white-h),var(--white-s),calc(var(--white-l) + -3%),1);background-color:hsla(var(--white-h),var(--white-s),calc(var(--white-l) + -3%),var(--white-a, 1));border-bottom:1px solid hsla(var(--white-h),var(--white-s),calc(calc(var(--white-l) + -3%) + -5%),1);border-bottom:1px solid hsla(var(--white-h),var(--white-s),calc(calc(var(--white-l) + -3%) + -5%),var(--white-a, 1));border-top-left-radius:calc(.3rem - 1px);border-top-right-radius:calc(.3rem - 1px)}.hsl .popover-header:empty{display:none}.hsl .popover-body{padding:.5rem .75rem;color:var(--gray-900)}.hsl .align-baseline{vertical-align:baseline!important}.hsl .align-top{vertical-align:top!important}.hsl .align-middle{vertical-align:middle!important}.hsl .align-bottom{vertical-align:bottom!important}.hsl .align-text-bottom{vertical-align:text-bottom!important}.hsl .align-text-top{vertical-align:text-top!important}.hsl .bg-primary{background-color:var(--primary)!important}.hsl a.bg-primary:hover,.hsl a.bg-primary:focus,.hsl button.bg-primary:hover,.hsl button.bg-primary:focus{background-color:hsla(var(--primary-h),var(--primary-s),calc(var(--primary-l) + -10%),1)!important;background-color:hsla(var(--primary-h),var(--primary-s),calc(var(--primary-l) + -10%),var(--primary-a, 1))!important}.hsl .bg-secondary{background-color:var(--secondary)!important}.hsl a.bg-secondary:hover,.hsl a.bg-secondary:focus,.hsl button.bg-secondary:hover,.hsl button.bg-secondary:focus{background-color:hsla(var(--secondary-h),var(--secondary-s),calc(var(--secondary-l) + -10%),1)!important;background-color:hsla(var(--secondary-h),var(--secondary-s),calc(var(--secondary-l) + -10%),var(--secondary-a, 1))!important}.hsl .bg-success{background-color:#28a745!important}.hsl a.bg-success:hover,.hsl a.bg-success:focus,.hsl button.bg-success:hover,.hsl button.bg-success:focus{background-color:#24963e!important}.hsl .bg-info{background-color:#17a2b8!important}.hsl a.bg-info:hover,.hsl a.bg-info:focus,.hsl button.bg-info:hover,.hsl button.bg-info:focus{background-color:#1592a6!important}.hsl .bg-warning{background-color:#ffc107!important}.hsl a.bg-warning:hover,.hsl a.bg-warning:focus,.hsl button.bg-warning:hover,.hsl button.bg-warning:focus{background-color:#ecb100!important}.hsl .bg-danger{background-color:#dc3545!important}.hsl a.bg-danger:hover,.hsl a.bg-danger:focus,.hsl button.bg-danger:hover,.hsl button.bg-danger:focus{background-color:#d12435!important}.hsl .bg-light{background-color:var(--light)!important}.hsl a.bg-light:hover,.hsl a.bg-light:focus,.hsl button.bg-light:hover,.hsl button.bg-light:focus{background-color:hsla(var(--light-h),var(--light-s),calc(var(--light-l) + -10%),1)!important;background-color:hsla(var(--light-h),var(--light-s),calc(var(--light-l) + -10%),var(--light-a, 1))!important}.hsl .bg-dark{background-color:var(--gray-800)!important}.hsl a.bg-dark:hover,.hsl a.bg-dark:focus,.hsl button.bg-dark:hover,.hsl button.bg-dark:focus{background-color:hsla(var(--gray-800-h),var(--gray-800-s),calc(var(--gray-800-l) + -10%),1)!important;background-color:hsla(var(--gray-800-h),var(--gray-800-s),calc(var(--gray-800-l) + -10%),var(--gray-800-a, 1))!important}.hsl .bg-gray{background-color:var(--gray-900)!important}.hsl a.bg-gray:hover,.hsl a.bg-gray:focus,.hsl button.bg-gray:hover,.hsl button.bg-gray:focus{background-color:hsla(var(--gray-900-h),var(--gray-900-s),calc(var(--gray-900-l) + -10%),1)!important;background-color:hsla(var(--gray-900-h),var(--gray-900-s),calc(var(--gray-900-l) + -10%),var(--gray-900-a, 1))!important}.hsl .bg-white{background-color:var(--white)!important}.hsl .bg-transparent{background-color:transparent!important}.hsl .border{border:1px solid #dee2e6!important}.hsl .border-top{border-top:1px solid #dee2e6!important}.hsl .border-right{border-right:1px solid #dee2e6!important}.hsl .border-bottom{border-bottom:1px solid #dee2e6!important}.hsl .border-left{border-left:1px solid #dee2e6!important}.hsl .border-0{border:0!important}.hsl .border-top-0{border-top:0!important}.hsl .border-right-0{border-right:0!important}.hsl .border-bottom-0{border-bottom:0!important}.hsl .border-left-0{border-left:0!important}.hsl .border-primary{border-color:var(--primary)!important}.hsl .border-secondary{border-color:var(--secondary)!important}.hsl .border-success{border-color:#28a745!important}.hsl .border-info{border-color:#17a2b8!important}.hsl .border-warning{border-color:#ffc107!important}.hsl .border-danger{border-color:#dc3545!important}.hsl .border-light{border-color:var(--light)!important}.hsl .border-dark{border-color:var(--gray-800)!important}.hsl .border-gray{border-color:var(--gray-900)!important}.hsl .border-white{border-color:var(--white)!important}.hsl .rounded-sm{border-radius:.2rem!important}.hsl .rounded{border-radius:.25rem!important}.hsl .rounded-top{border-top-left-radius:.25rem!important;border-top-right-radius:.25rem!important}.hsl .rounded-right{border-top-right-radius:.25rem!important;border-bottom-right-radius:.25rem!important}.hsl .rounded-bottom{border-bottom-right-radius:.25rem!important;border-bottom-left-radius:.25rem!important}.hsl .rounded-left{border-top-left-radius:.25rem!important;border-bottom-left-radius:.25rem!important}.hsl .rounded-lg{border-radius:.3rem!important}.hsl .rounded-circle{border-radius:50%!important}.hsl .rounded-pill{border-radius:50rem!important}.hsl .rounded-0{border-radius:0!important}.hsl .clearfix:after{display:block;clear:both;content:\"\"}.hsl .d-none{display:none!important}.hsl .d-inline{display:inline!important}.hsl .d-inline-block{display:inline-block!important}.hsl .d-block{display:block!important}.hsl .d-table{display:table!important}.hsl .d-table-row{display:table-row!important}.hsl .d-table-cell{display:table-cell!important}.hsl .d-flex{display:flex!important}.hsl .d-inline-flex{display:inline-flex!important}@media (min-width: 576px){.hsl .d-sm-none{display:none!important}.hsl .d-sm-inline{display:inline!important}.hsl .d-sm-inline-block{display:inline-block!important}.hsl .d-sm-block{display:block!important}.hsl .d-sm-table{display:table!important}.hsl .d-sm-table-row{display:table-row!important}.hsl .d-sm-table-cell{display:table-cell!important}.hsl .d-sm-flex{display:flex!important}.hsl .d-sm-inline-flex{display:inline-flex!important}}@media (min-width: 768px){.hsl .d-md-none{display:none!important}.hsl .d-md-inline{display:inline!important}.hsl .d-md-inline-block{display:inline-block!important}.hsl .d-md-block{display:block!important}.hsl .d-md-table{display:table!important}.hsl .d-md-table-row{display:table-row!important}.hsl .d-md-table-cell{display:table-cell!important}.hsl .d-md-flex{display:flex!important}.hsl .d-md-inline-flex{display:inline-flex!important}}@media (min-width: 992px){.hsl .d-lg-none{display:none!important}.hsl .d-lg-inline{display:inline!important}.hsl .d-lg-inline-block{display:inline-block!important}.hsl .d-lg-block{display:block!important}.hsl .d-lg-table{display:table!important}.hsl .d-lg-table-row{display:table-row!important}.hsl .d-lg-table-cell{display:table-cell!important}.hsl .d-lg-flex{display:flex!important}.hsl .d-lg-inline-flex{display:inline-flex!important}}@media (min-width: 1200px){.hsl .d-xl-none{display:none!important}.hsl .d-xl-inline{display:inline!important}.hsl .d-xl-inline-block{display:inline-block!important}.hsl .d-xl-block{display:block!important}.hsl .d-xl-table{display:table!important}.hsl .d-xl-table-row{display:table-row!important}.hsl .d-xl-table-cell{display:table-cell!important}.hsl .d-xl-flex{display:flex!important}.hsl .d-xl-inline-flex{display:inline-flex!important}}@media print{.hsl .d-print-none{display:none!important}.hsl .d-print-inline{display:inline!important}.hsl .d-print-inline-block{display:inline-block!important}.hsl .d-print-block{display:block!important}.hsl .d-print-table{display:table!important}.hsl .d-print-table-row{display:table-row!important}.hsl .d-print-table-cell{display:table-cell!important}.hsl .d-print-flex{display:flex!important}.hsl .d-print-inline-flex{display:inline-flex!important}}.hsl .embed-responsive{position:relative;display:block;width:100%;padding:0;overflow:hidden}.hsl .embed-responsive:before{display:block;content:\"\"}.hsl .embed-responsive .embed-responsive-item,.hsl .embed-responsive iframe,.hsl .embed-responsive embed,.hsl .embed-responsive object,.hsl .embed-responsive video{position:absolute;top:0;bottom:0;left:0;width:100%;height:100%;border:0}.hsl .embed-responsive-21by9:before{padding-top:42.8571428571%}.hsl .embed-responsive-16by9:before{padding-top:56.25%}.hsl .embed-responsive-4by3:before{padding-top:75%}.hsl .embed-responsive-1by1:before{padding-top:100%}.hsl .flex-row{flex-direction:row!important}.hsl .flex-column{flex-direction:column!important}.hsl .flex-row-reverse{flex-direction:row-reverse!important}.hsl .flex-column-reverse{flex-direction:column-reverse!important}.hsl .flex-wrap{flex-wrap:wrap!important}.hsl .flex-nowrap{flex-wrap:nowrap!important}.hsl .flex-wrap-reverse{flex-wrap:wrap-reverse!important}.hsl .flex-fill{flex:1 1 auto!important}.hsl .flex-grow-0{flex-grow:0!important}.hsl .flex-grow-1{flex-grow:1!important}.hsl .flex-shrink-0{flex-shrink:0!important}.hsl .flex-shrink-1{flex-shrink:1!important}.hsl .justify-content-start{justify-content:flex-start!important}.hsl .justify-content-end{justify-content:flex-end!important}.hsl .justify-content-center{justify-content:center!important}.hsl .justify-content-between{justify-content:space-between!important}.hsl .justify-content-around{justify-content:space-around!important}.hsl .align-items-start{align-items:flex-start!important}.hsl .align-items-end{align-items:flex-end!important}.hsl .align-items-center{align-items:center!important}.hsl .align-items-baseline{align-items:baseline!important}.hsl .align-items-stretch{align-items:stretch!important}.hsl .align-content-start{align-content:flex-start!important}.hsl .align-content-end{align-content:flex-end!important}.hsl .align-content-center{align-content:center!important}.hsl .align-content-between{align-content:space-between!important}.hsl .align-content-around{align-content:space-around!important}.hsl .align-content-stretch{align-content:stretch!important}.hsl .align-self-auto{align-self:auto!important}.hsl .align-self-start{align-self:flex-start!important}.hsl .align-self-end{align-self:flex-end!important}.hsl .align-self-center{align-self:center!important}.hsl .align-self-baseline{align-self:baseline!important}.hsl .align-self-stretch{align-self:stretch!important}@media (min-width: 576px){.hsl .flex-sm-row{flex-direction:row!important}.hsl .flex-sm-column{flex-direction:column!important}.hsl .flex-sm-row-reverse{flex-direction:row-reverse!important}.hsl .flex-sm-column-reverse{flex-direction:column-reverse!important}.hsl .flex-sm-wrap{flex-wrap:wrap!important}.hsl .flex-sm-nowrap{flex-wrap:nowrap!important}.hsl .flex-sm-wrap-reverse{flex-wrap:wrap-reverse!important}.hsl .flex-sm-fill{flex:1 1 auto!important}.hsl .flex-sm-grow-0{flex-grow:0!important}.hsl .flex-sm-grow-1{flex-grow:1!important}.hsl .flex-sm-shrink-0{flex-shrink:0!important}.hsl .flex-sm-shrink-1{flex-shrink:1!important}.hsl .justify-content-sm-start{justify-content:flex-start!important}.hsl .justify-content-sm-end{justify-content:flex-end!important}.hsl .justify-content-sm-center{justify-content:center!important}.hsl .justify-content-sm-between{justify-content:space-between!important}.hsl .justify-content-sm-around{justify-content:space-around!important}.hsl .align-items-sm-start{align-items:flex-start!important}.hsl .align-items-sm-end{align-items:flex-end!important}.hsl .align-items-sm-center{align-items:center!important}.hsl .align-items-sm-baseline{align-items:baseline!important}.hsl .align-items-sm-stretch{align-items:stretch!important}.hsl .align-content-sm-start{align-content:flex-start!important}.hsl .align-content-sm-end{align-content:flex-end!important}.hsl .align-content-sm-center{align-content:center!important}.hsl .align-content-sm-between{align-content:space-between!important}.hsl .align-content-sm-around{align-content:space-around!important}.hsl .align-content-sm-stretch{align-content:stretch!important}.hsl .align-self-sm-auto{align-self:auto!important}.hsl .align-self-sm-start{align-self:flex-start!important}.hsl .align-self-sm-end{align-self:flex-end!important}.hsl .align-self-sm-center{align-self:center!important}.hsl .align-self-sm-baseline{align-self:baseline!important}.hsl .align-self-sm-stretch{align-self:stretch!important}}@media (min-width: 768px){.hsl .flex-md-row{flex-direction:row!important}.hsl .flex-md-column{flex-direction:column!important}.hsl .flex-md-row-reverse{flex-direction:row-reverse!important}.hsl .flex-md-column-reverse{flex-direction:column-reverse!important}.hsl .flex-md-wrap{flex-wrap:wrap!important}.hsl .flex-md-nowrap{flex-wrap:nowrap!important}.hsl .flex-md-wrap-reverse{flex-wrap:wrap-reverse!important}.hsl .flex-md-fill{flex:1 1 auto!important}.hsl .flex-md-grow-0{flex-grow:0!important}.hsl .flex-md-grow-1{flex-grow:1!important}.hsl .flex-md-shrink-0{flex-shrink:0!important}.hsl .flex-md-shrink-1{flex-shrink:1!important}.hsl .justify-content-md-start{justify-content:flex-start!important}.hsl .justify-content-md-end{justify-content:flex-end!important}.hsl .justify-content-md-center{justify-content:center!important}.hsl .justify-content-md-between{justify-content:space-between!important}.hsl .justify-content-md-around{justify-content:space-around!important}.hsl .align-items-md-start{align-items:flex-start!important}.hsl .align-items-md-end{align-items:flex-end!important}.hsl .align-items-md-center{align-items:center!important}.hsl .align-items-md-baseline{align-items:baseline!important}.hsl .align-items-md-stretch{align-items:stretch!important}.hsl .align-content-md-start{align-content:flex-start!important}.hsl .align-content-md-end{align-content:flex-end!important}.hsl .align-content-md-center{align-content:center!important}.hsl .align-content-md-between{align-content:space-between!important}.hsl .align-content-md-around{align-content:space-around!important}.hsl .align-content-md-stretch{align-content:stretch!important}.hsl .align-self-md-auto{align-self:auto!important}.hsl .align-self-md-start{align-self:flex-start!important}.hsl .align-self-md-end{align-self:flex-end!important}.hsl .align-self-md-center{align-self:center!important}.hsl .align-self-md-baseline{align-self:baseline!important}.hsl .align-self-md-stretch{align-self:stretch!important}}@media (min-width: 992px){.hsl .flex-lg-row{flex-direction:row!important}.hsl .flex-lg-column{flex-direction:column!important}.hsl .flex-lg-row-reverse{flex-direction:row-reverse!important}.hsl .flex-lg-column-reverse{flex-direction:column-reverse!important}.hsl .flex-lg-wrap{flex-wrap:wrap!important}.hsl .flex-lg-nowrap{flex-wrap:nowrap!important}.hsl .flex-lg-wrap-reverse{flex-wrap:wrap-reverse!important}.hsl .flex-lg-fill{flex:1 1 auto!important}.hsl .flex-lg-grow-0{flex-grow:0!important}.hsl .flex-lg-grow-1{flex-grow:1!important}.hsl .flex-lg-shrink-0{flex-shrink:0!important}.hsl .flex-lg-shrink-1{flex-shrink:1!important}.hsl .justify-content-lg-start{justify-content:flex-start!important}.hsl .justify-content-lg-end{justify-content:flex-end!important}.hsl .justify-content-lg-center{justify-content:center!important}.hsl .justify-content-lg-between{justify-content:space-between!important}.hsl .justify-content-lg-around{justify-content:space-around!important}.hsl .align-items-lg-start{align-items:flex-start!important}.hsl .align-items-lg-end{align-items:flex-end!important}.hsl .align-items-lg-center{align-items:center!important}.hsl .align-items-lg-baseline{align-items:baseline!important}.hsl .align-items-lg-stretch{align-items:stretch!important}.hsl .align-content-lg-start{align-content:flex-start!important}.hsl .align-content-lg-end{align-content:flex-end!important}.hsl .align-content-lg-center{align-content:center!important}.hsl .align-content-lg-between{align-content:space-between!important}.hsl .align-content-lg-around{align-content:space-around!important}.hsl .align-content-lg-stretch{align-content:stretch!important}.hsl .align-self-lg-auto{align-self:auto!important}.hsl .align-self-lg-start{align-self:flex-start!important}.hsl .align-self-lg-end{align-self:flex-end!important}.hsl .align-self-lg-center{align-self:center!important}.hsl .align-self-lg-baseline{align-self:baseline!important}.hsl .align-self-lg-stretch{align-self:stretch!important}}@media (min-width: 1200px){.hsl .flex-xl-row{flex-direction:row!important}.hsl .flex-xl-column{flex-direction:column!important}.hsl .flex-xl-row-reverse{flex-direction:row-reverse!important}.hsl .flex-xl-column-reverse{flex-direction:column-reverse!important}.hsl .flex-xl-wrap{flex-wrap:wrap!important}.hsl .flex-xl-nowrap{flex-wrap:nowrap!important}.hsl .flex-xl-wrap-reverse{flex-wrap:wrap-reverse!important}.hsl .flex-xl-fill{flex:1 1 auto!important}.hsl .flex-xl-grow-0{flex-grow:0!important}.hsl .flex-xl-grow-1{flex-grow:1!important}.hsl .flex-xl-shrink-0{flex-shrink:0!important}.hsl .flex-xl-shrink-1{flex-shrink:1!important}.hsl .justify-content-xl-start{justify-content:flex-start!important}.hsl .justify-content-xl-end{justify-content:flex-end!important}.hsl .justify-content-xl-center{justify-content:center!important}.hsl .justify-content-xl-between{justify-content:space-between!important}.hsl .justify-content-xl-around{justify-content:space-around!important}.hsl .align-items-xl-start{align-items:flex-start!important}.hsl .align-items-xl-end{align-items:flex-end!important}.hsl .align-items-xl-center{align-items:center!important}.hsl .align-items-xl-baseline{align-items:baseline!important}.hsl .align-items-xl-stretch{align-items:stretch!important}.hsl .align-content-xl-start{align-content:flex-start!important}.hsl .align-content-xl-end{align-content:flex-end!important}.hsl .align-content-xl-center{align-content:center!important}.hsl .align-content-xl-between{align-content:space-between!important}.hsl .align-content-xl-around{align-content:space-around!important}.hsl .align-content-xl-stretch{align-content:stretch!important}.hsl .align-self-xl-auto{align-self:auto!important}.hsl .align-self-xl-start{align-self:flex-start!important}.hsl .align-self-xl-end{align-self:flex-end!important}.hsl .align-self-xl-center{align-self:center!important}.hsl .align-self-xl-baseline{align-self:baseline!important}.hsl .align-self-xl-stretch{align-self:stretch!important}}.hsl .float-left{float:left!important}.hsl .float-right{float:right!important}.hsl .float-none{float:none!important}@media (min-width: 576px){.hsl .float-sm-left{float:left!important}.hsl .float-sm-right{float:right!important}.hsl .float-sm-none{float:none!important}}@media (min-width: 768px){.hsl .float-md-left{float:left!important}.hsl .float-md-right{float:right!important}.hsl .float-md-none{float:none!important}}@media (min-width: 992px){.hsl .float-lg-left{float:left!important}.hsl .float-lg-right{float:right!important}.hsl .float-lg-none{float:none!important}}@media (min-width: 1200px){.hsl .float-xl-left{float:left!important}.hsl .float-xl-right{float:right!important}.hsl .float-xl-none{float:none!important}}.hsl .user-select-all{-webkit-user-select:all!important;-moz-user-select:all!important;user-select:all!important}.hsl .user-select-auto{-webkit-user-select:auto!important;-moz-user-select:auto!important;user-select:auto!important}.hsl .user-select-none{-webkit-user-select:none!important;-moz-user-select:none!important;user-select:none!important}.hsl .overflow-auto{overflow:auto!important}.hsl .overflow-hidden{overflow:hidden!important}.hsl .position-static{position:static!important}.hsl .position-relative{position:relative!important}.hsl .position-absolute{position:absolute!important}.hsl .position-fixed{position:fixed!important}.hsl .position-sticky{position:sticky!important}.hsl .fixed-top{position:fixed;top:0;right:0;left:0;z-index:1030}.hsl .fixed-bottom{position:fixed;right:0;bottom:0;left:0;z-index:1030}@supports (position: sticky){.hsl .sticky-top{position:sticky;top:0;z-index:1020}}.hsl .sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0}.hsl .sr-only-focusable:active,.hsl .sr-only-focusable:focus{position:static;width:auto;height:auto;overflow:visible;clip:auto;white-space:normal}.hsl .shadow-sm{box-shadow:0 .125rem .25rem #00000013!important}.hsl .shadow{box-shadow:0 .5rem 1rem #00000026!important}.hsl .shadow-lg{box-shadow:0 1rem 3rem #0000002d!important}.hsl .shadow-none{box-shadow:none!important}.hsl .w-25{width:25%!important}.hsl .w-50{width:50%!important}.hsl .w-75{width:75%!important}.hsl .w-100{width:100%!important}.hsl .w-auto{width:auto!important}.hsl .h-25{height:25%!important}.hsl .h-50{height:50%!important}.hsl .h-75{height:75%!important}.hsl .h-100{height:100%!important}.hsl .h-auto{height:auto!important}.hsl .mw-100{max-width:100%!important}.hsl .mh-100{max-height:100%!important}.hsl .min-vw-100{min-width:100vw!important}.hsl .min-vh-100{min-height:100vh!important}.hsl .vw-100{width:100vw!important}.hsl .vh-100{height:100vh!important}.hsl .m-0{margin:0!important}.hsl .mt-0,.hsl .my-0{margin-top:0!important}.hsl .mr-0,.hsl .mx-0{margin-right:0!important}.hsl .mb-0,.hsl .my-0{margin-bottom:0!important}.hsl .ml-0,.hsl .mx-0{margin-left:0!important}.hsl .m-1{margin:.25rem!important}.hsl .mt-1,.hsl .my-1{margin-top:.25rem!important}.hsl .mr-1,.hsl .mx-1{margin-right:.25rem!important}.hsl .mb-1,.hsl .my-1{margin-bottom:.25rem!important}.hsl .ml-1,.hsl .mx-1{margin-left:.25rem!important}.hsl .m-2{margin:.5rem!important}.hsl .mt-2,.hsl .my-2{margin-top:.5rem!important}.hsl .mr-2,.hsl .mx-2{margin-right:.5rem!important}.hsl .mb-2,.hsl .my-2{margin-bottom:.5rem!important}.hsl .ml-2,.hsl .mx-2{margin-left:.5rem!important}.hsl .m-3{margin:1rem!important}.hsl .mt-3,.hsl .my-3{margin-top:1rem!important}.hsl .mr-3,.hsl .mx-3{margin-right:1rem!important}.hsl .mb-3,.hsl .my-3{margin-bottom:1rem!important}.hsl .ml-3,.hsl .mx-3{margin-left:1rem!important}.hsl .m-4{margin:1.5rem!important}.hsl .mt-4,.hsl .my-4{margin-top:1.5rem!important}.hsl .mr-4,.hsl .mx-4{margin-right:1.5rem!important}.hsl .mb-4,.hsl .my-4{margin-bottom:1.5rem!important}.hsl .ml-4,.hsl .mx-4{margin-left:1.5rem!important}.hsl .m-5{margin:3rem!important}.hsl .mt-5,.hsl .my-5{margin-top:3rem!important}.hsl .mr-5,.hsl .mx-5{margin-right:3rem!important}.hsl .mb-5,.hsl .my-5{margin-bottom:3rem!important}.hsl .ml-5,.hsl .mx-5{margin-left:3rem!important}.hsl .p-0{padding:0!important}.hsl .pt-0,.hsl .py-0{padding-top:0!important}.hsl .pr-0,.hsl .px-0{padding-right:0!important}.hsl .pb-0,.hsl .py-0{padding-bottom:0!important}.hsl .pl-0,.hsl .px-0{padding-left:0!important}.hsl .p-1{padding:.25rem!important}.hsl .pt-1,.hsl .py-1{padding-top:.25rem!important}.hsl .pr-1,.hsl .px-1{padding-right:.25rem!important}.hsl .pb-1,.hsl .py-1{padding-bottom:.25rem!important}.hsl .pl-1,.hsl .px-1{padding-left:.25rem!important}.hsl .p-2{padding:.5rem!important}.hsl .pt-2,.hsl .py-2{padding-top:.5rem!important}.hsl .pr-2,.hsl .px-2{padding-right:.5rem!important}.hsl .pb-2,.hsl .py-2{padding-bottom:.5rem!important}.hsl .pl-2,.hsl .px-2{padding-left:.5rem!important}.hsl .p-3{padding:1rem!important}.hsl .pt-3,.hsl .py-3{padding-top:1rem!important}.hsl .pr-3,.hsl .px-3{padding-right:1rem!important}.hsl .pb-3,.hsl .py-3{padding-bottom:1rem!important}.hsl .pl-3,.hsl .px-3{padding-left:1rem!important}.hsl .p-4{padding:1.5rem!important}.hsl .pt-4,.hsl .py-4{padding-top:1.5rem!important}.hsl .pr-4,.hsl .px-4{padding-right:1.5rem!important}.hsl .pb-4,.hsl .py-4{padding-bottom:1.5rem!important}.hsl .pl-4,.hsl .px-4{padding-left:1.5rem!important}.hsl .p-5{padding:3rem!important}.hsl .pt-5,.hsl .py-5{padding-top:3rem!important}.hsl .pr-5,.hsl .px-5{padding-right:3rem!important}.hsl .pb-5,.hsl .py-5{padding-bottom:3rem!important}.hsl .pl-5,.hsl .px-5{padding-left:3rem!important}.hsl .m-n1{margin:-.25rem!important}.hsl .mt-n1,.hsl .my-n1{margin-top:-.25rem!important}.hsl .mr-n1,.hsl .mx-n1{margin-right:-.25rem!important}.hsl .mb-n1,.hsl .my-n1{margin-bottom:-.25rem!important}.hsl .ml-n1,.hsl .mx-n1{margin-left:-.25rem!important}.hsl .m-n2{margin:-.5rem!important}.hsl .mt-n2,.hsl .my-n2{margin-top:-.5rem!important}.hsl .mr-n2,.hsl .mx-n2{margin-right:-.5rem!important}.hsl .mb-n2,.hsl .my-n2{margin-bottom:-.5rem!important}.hsl .ml-n2,.hsl .mx-n2{margin-left:-.5rem!important}.hsl .m-n3{margin:-1rem!important}.hsl .mt-n3,.hsl .my-n3{margin-top:-1rem!important}.hsl .mr-n3,.hsl .mx-n3{margin-right:-1rem!important}.hsl .mb-n3,.hsl .my-n3{margin-bottom:-1rem!important}.hsl .ml-n3,.hsl .mx-n3{margin-left:-1rem!important}.hsl .m-n4{margin:-1.5rem!important}.hsl .mt-n4,.hsl .my-n4{margin-top:-1.5rem!important}.hsl .mr-n4,.hsl .mx-n4{margin-right:-1.5rem!important}.hsl .mb-n4,.hsl .my-n4{margin-bottom:-1.5rem!important}.hsl .ml-n4,.hsl .mx-n4{margin-left:-1.5rem!important}.hsl .m-n5{margin:-3rem!important}.hsl .mt-n5,.hsl .my-n5{margin-top:-3rem!important}.hsl .mr-n5,.hsl .mx-n5{margin-right:-3rem!important}.hsl .mb-n5,.hsl .my-n5{margin-bottom:-3rem!important}.hsl .ml-n5,.hsl .mx-n5{margin-left:-3rem!important}.hsl .m-auto{margin:auto!important}.hsl .mt-auto,.hsl .my-auto{margin-top:auto!important}.hsl .mr-auto,.hsl .mx-auto{margin-right:auto!important}.hsl .mb-auto,.hsl .my-auto{margin-bottom:auto!important}.hsl .ml-auto,.hsl .mx-auto{margin-left:auto!important}@media (min-width: 576px){.hsl .m-sm-0{margin:0!important}.hsl .mt-sm-0,.hsl .my-sm-0{margin-top:0!important}.hsl .mr-sm-0,.hsl .mx-sm-0{margin-right:0!important}.hsl .mb-sm-0,.hsl .my-sm-0{margin-bottom:0!important}.hsl .ml-sm-0,.hsl .mx-sm-0{margin-left:0!important}.hsl .m-sm-1{margin:.25rem!important}.hsl .mt-sm-1,.hsl .my-sm-1{margin-top:.25rem!important}.hsl .mr-sm-1,.hsl .mx-sm-1{margin-right:.25rem!important}.hsl .mb-sm-1,.hsl .my-sm-1{margin-bottom:.25rem!important}.hsl .ml-sm-1,.hsl .mx-sm-1{margin-left:.25rem!important}.hsl .m-sm-2{margin:.5rem!important}.hsl .mt-sm-2,.hsl .my-sm-2{margin-top:.5rem!important}.hsl .mr-sm-2,.hsl .mx-sm-2{margin-right:.5rem!important}.hsl .mb-sm-2,.hsl .my-sm-2{margin-bottom:.5rem!important}.hsl .ml-sm-2,.hsl .mx-sm-2{margin-left:.5rem!important}.hsl .m-sm-3{margin:1rem!important}.hsl .mt-sm-3,.hsl .my-sm-3{margin-top:1rem!important}.hsl .mr-sm-3,.hsl .mx-sm-3{margin-right:1rem!important}.hsl .mb-sm-3,.hsl .my-sm-3{margin-bottom:1rem!important}.hsl .ml-sm-3,.hsl .mx-sm-3{margin-left:1rem!important}.hsl .m-sm-4{margin:1.5rem!important}.hsl .mt-sm-4,.hsl .my-sm-4{margin-top:1.5rem!important}.hsl .mr-sm-4,.hsl .mx-sm-4{margin-right:1.5rem!important}.hsl .mb-sm-4,.hsl .my-sm-4{margin-bottom:1.5rem!important}.hsl .ml-sm-4,.hsl .mx-sm-4{margin-left:1.5rem!important}.hsl .m-sm-5{margin:3rem!important}.hsl .mt-sm-5,.hsl .my-sm-5{margin-top:3rem!important}.hsl .mr-sm-5,.hsl .mx-sm-5{margin-right:3rem!important}.hsl .mb-sm-5,.hsl .my-sm-5{margin-bottom:3rem!important}.hsl .ml-sm-5,.hsl .mx-sm-5{margin-left:3rem!important}.hsl .p-sm-0{padding:0!important}.hsl .pt-sm-0,.hsl .py-sm-0{padding-top:0!important}.hsl .pr-sm-0,.hsl .px-sm-0{padding-right:0!important}.hsl .pb-sm-0,.hsl .py-sm-0{padding-bottom:0!important}.hsl .pl-sm-0,.hsl .px-sm-0{padding-left:0!important}.hsl .p-sm-1{padding:.25rem!important}.hsl .pt-sm-1,.hsl .py-sm-1{padding-top:.25rem!important}.hsl .pr-sm-1,.hsl .px-sm-1{padding-right:.25rem!important}.hsl .pb-sm-1,.hsl .py-sm-1{padding-bottom:.25rem!important}.hsl .pl-sm-1,.hsl .px-sm-1{padding-left:.25rem!important}.hsl .p-sm-2{padding:.5rem!important}.hsl .pt-sm-2,.hsl .py-sm-2{padding-top:.5rem!important}.hsl .pr-sm-2,.hsl .px-sm-2{padding-right:.5rem!important}.hsl .pb-sm-2,.hsl .py-sm-2{padding-bottom:.5rem!important}.hsl .pl-sm-2,.hsl .px-sm-2{padding-left:.5rem!important}.hsl .p-sm-3{padding:1rem!important}.hsl .pt-sm-3,.hsl .py-sm-3{padding-top:1rem!important}.hsl .pr-sm-3,.hsl .px-sm-3{padding-right:1rem!important}.hsl .pb-sm-3,.hsl .py-sm-3{padding-bottom:1rem!important}.hsl .pl-sm-3,.hsl .px-sm-3{padding-left:1rem!important}.hsl .p-sm-4{padding:1.5rem!important}.hsl .pt-sm-4,.hsl .py-sm-4{padding-top:1.5rem!important}.hsl .pr-sm-4,.hsl .px-sm-4{padding-right:1.5rem!important}.hsl .pb-sm-4,.hsl .py-sm-4{padding-bottom:1.5rem!important}.hsl .pl-sm-4,.hsl .px-sm-4{padding-left:1.5rem!important}.hsl .p-sm-5{padding:3rem!important}.hsl .pt-sm-5,.hsl .py-sm-5{padding-top:3rem!important}.hsl .pr-sm-5,.hsl .px-sm-5{padding-right:3rem!important}.hsl .pb-sm-5,.hsl .py-sm-5{padding-bottom:3rem!important}.hsl .pl-sm-5,.hsl .px-sm-5{padding-left:3rem!important}.hsl .m-sm-n1{margin:-.25rem!important}.hsl .mt-sm-n1,.hsl .my-sm-n1{margin-top:-.25rem!important}.hsl .mr-sm-n1,.hsl .mx-sm-n1{margin-right:-.25rem!important}.hsl .mb-sm-n1,.hsl .my-sm-n1{margin-bottom:-.25rem!important}.hsl .ml-sm-n1,.hsl .mx-sm-n1{margin-left:-.25rem!important}.hsl .m-sm-n2{margin:-.5rem!important}.hsl .mt-sm-n2,.hsl .my-sm-n2{margin-top:-.5rem!important}.hsl .mr-sm-n2,.hsl .mx-sm-n2{margin-right:-.5rem!important}.hsl .mb-sm-n2,.hsl .my-sm-n2{margin-bottom:-.5rem!important}.hsl .ml-sm-n2,.hsl .mx-sm-n2{margin-left:-.5rem!important}.hsl .m-sm-n3{margin:-1rem!important}.hsl .mt-sm-n3,.hsl .my-sm-n3{margin-top:-1rem!important}.hsl .mr-sm-n3,.hsl .mx-sm-n3{margin-right:-1rem!important}.hsl .mb-sm-n3,.hsl .my-sm-n3{margin-bottom:-1rem!important}.hsl .ml-sm-n3,.hsl .mx-sm-n3{margin-left:-1rem!important}.hsl .m-sm-n4{margin:-1.5rem!important}.hsl .mt-sm-n4,.hsl .my-sm-n4{margin-top:-1.5rem!important}.hsl .mr-sm-n4,.hsl .mx-sm-n4{margin-right:-1.5rem!important}.hsl .mb-sm-n4,.hsl .my-sm-n4{margin-bottom:-1.5rem!important}.hsl .ml-sm-n4,.hsl .mx-sm-n4{margin-left:-1.5rem!important}.hsl .m-sm-n5{margin:-3rem!important}.hsl .mt-sm-n5,.hsl .my-sm-n5{margin-top:-3rem!important}.hsl .mr-sm-n5,.hsl .mx-sm-n5{margin-right:-3rem!important}.hsl .mb-sm-n5,.hsl .my-sm-n5{margin-bottom:-3rem!important}.hsl .ml-sm-n5,.hsl .mx-sm-n5{margin-left:-3rem!important}.hsl .m-sm-auto{margin:auto!important}.hsl .mt-sm-auto,.hsl .my-sm-auto{margin-top:auto!important}.hsl .mr-sm-auto,.hsl .mx-sm-auto{margin-right:auto!important}.hsl .mb-sm-auto,.hsl .my-sm-auto{margin-bottom:auto!important}.hsl .ml-sm-auto,.hsl .mx-sm-auto{margin-left:auto!important}}@media (min-width: 768px){.hsl .m-md-0{margin:0!important}.hsl .mt-md-0,.hsl .my-md-0{margin-top:0!important}.hsl .mr-md-0,.hsl .mx-md-0{margin-right:0!important}.hsl .mb-md-0,.hsl .my-md-0{margin-bottom:0!important}.hsl .ml-md-0,.hsl .mx-md-0{margin-left:0!important}.hsl .m-md-1{margin:.25rem!important}.hsl .mt-md-1,.hsl .my-md-1{margin-top:.25rem!important}.hsl .mr-md-1,.hsl .mx-md-1{margin-right:.25rem!important}.hsl .mb-md-1,.hsl .my-md-1{margin-bottom:.25rem!important}.hsl .ml-md-1,.hsl .mx-md-1{margin-left:.25rem!important}.hsl .m-md-2{margin:.5rem!important}.hsl .mt-md-2,.hsl .my-md-2{margin-top:.5rem!important}.hsl .mr-md-2,.hsl .mx-md-2{margin-right:.5rem!important}.hsl .mb-md-2,.hsl .my-md-2{margin-bottom:.5rem!important}.hsl .ml-md-2,.hsl .mx-md-2{margin-left:.5rem!important}.hsl .m-md-3{margin:1rem!important}.hsl .mt-md-3,.hsl .my-md-3{margin-top:1rem!important}.hsl .mr-md-3,.hsl .mx-md-3{margin-right:1rem!important}.hsl .mb-md-3,.hsl .my-md-3{margin-bottom:1rem!important}.hsl .ml-md-3,.hsl .mx-md-3{margin-left:1rem!important}.hsl .m-md-4{margin:1.5rem!important}.hsl .mt-md-4,.hsl .my-md-4{margin-top:1.5rem!important}.hsl .mr-md-4,.hsl .mx-md-4{margin-right:1.5rem!important}.hsl .mb-md-4,.hsl .my-md-4{margin-bottom:1.5rem!important}.hsl .ml-md-4,.hsl .mx-md-4{margin-left:1.5rem!important}.hsl .m-md-5{margin:3rem!important}.hsl .mt-md-5,.hsl .my-md-5{margin-top:3rem!important}.hsl .mr-md-5,.hsl .mx-md-5{margin-right:3rem!important}.hsl .mb-md-5,.hsl .my-md-5{margin-bottom:3rem!important}.hsl .ml-md-5,.hsl .mx-md-5{margin-left:3rem!important}.hsl .p-md-0{padding:0!important}.hsl .pt-md-0,.hsl .py-md-0{padding-top:0!important}.hsl .pr-md-0,.hsl .px-md-0{padding-right:0!important}.hsl .pb-md-0,.hsl .py-md-0{padding-bottom:0!important}.hsl .pl-md-0,.hsl .px-md-0{padding-left:0!important}.hsl .p-md-1{padding:.25rem!important}.hsl .pt-md-1,.hsl .py-md-1{padding-top:.25rem!important}.hsl .pr-md-1,.hsl .px-md-1{padding-right:.25rem!important}.hsl .pb-md-1,.hsl .py-md-1{padding-bottom:.25rem!important}.hsl .pl-md-1,.hsl .px-md-1{padding-left:.25rem!important}.hsl .p-md-2{padding:.5rem!important}.hsl .pt-md-2,.hsl .py-md-2{padding-top:.5rem!important}.hsl .pr-md-2,.hsl .px-md-2{padding-right:.5rem!important}.hsl .pb-md-2,.hsl .py-md-2{padding-bottom:.5rem!important}.hsl .pl-md-2,.hsl .px-md-2{padding-left:.5rem!important}.hsl .p-md-3{padding:1rem!important}.hsl .pt-md-3,.hsl .py-md-3{padding-top:1rem!important}.hsl .pr-md-3,.hsl .px-md-3{padding-right:1rem!important}.hsl .pb-md-3,.hsl .py-md-3{padding-bottom:1rem!important}.hsl .pl-md-3,.hsl .px-md-3{padding-left:1rem!important}.hsl .p-md-4{padding:1.5rem!important}.hsl .pt-md-4,.hsl .py-md-4{padding-top:1.5rem!important}.hsl .pr-md-4,.hsl .px-md-4{padding-right:1.5rem!important}.hsl .pb-md-4,.hsl .py-md-4{padding-bottom:1.5rem!important}.hsl .pl-md-4,.hsl .px-md-4{padding-left:1.5rem!important}.hsl .p-md-5{padding:3rem!important}.hsl .pt-md-5,.hsl .py-md-5{padding-top:3rem!important}.hsl .pr-md-5,.hsl .px-md-5{padding-right:3rem!important}.hsl .pb-md-5,.hsl .py-md-5{padding-bottom:3rem!important}.hsl .pl-md-5,.hsl .px-md-5{padding-left:3rem!important}.hsl .m-md-n1{margin:-.25rem!important}.hsl .mt-md-n1,.hsl .my-md-n1{margin-top:-.25rem!important}.hsl .mr-md-n1,.hsl .mx-md-n1{margin-right:-.25rem!important}.hsl .mb-md-n1,.hsl .my-md-n1{margin-bottom:-.25rem!important}.hsl .ml-md-n1,.hsl .mx-md-n1{margin-left:-.25rem!important}.hsl .m-md-n2{margin:-.5rem!important}.hsl .mt-md-n2,.hsl .my-md-n2{margin-top:-.5rem!important}.hsl .mr-md-n2,.hsl .mx-md-n2{margin-right:-.5rem!important}.hsl .mb-md-n2,.hsl .my-md-n2{margin-bottom:-.5rem!important}.hsl .ml-md-n2,.hsl .mx-md-n2{margin-left:-.5rem!important}.hsl .m-md-n3{margin:-1rem!important}.hsl .mt-md-n3,.hsl .my-md-n3{margin-top:-1rem!important}.hsl .mr-md-n3,.hsl .mx-md-n3{margin-right:-1rem!important}.hsl .mb-md-n3,.hsl .my-md-n3{margin-bottom:-1rem!important}.hsl .ml-md-n3,.hsl .mx-md-n3{margin-left:-1rem!important}.hsl .m-md-n4{margin:-1.5rem!important}.hsl .mt-md-n4,.hsl .my-md-n4{margin-top:-1.5rem!important}.hsl .mr-md-n4,.hsl .mx-md-n4{margin-right:-1.5rem!important}.hsl .mb-md-n4,.hsl .my-md-n4{margin-bottom:-1.5rem!important}.hsl .ml-md-n4,.hsl .mx-md-n4{margin-left:-1.5rem!important}.hsl .m-md-n5{margin:-3rem!important}.hsl .mt-md-n5,.hsl .my-md-n5{margin-top:-3rem!important}.hsl .mr-md-n5,.hsl .mx-md-n5{margin-right:-3rem!important}.hsl .mb-md-n5,.hsl .my-md-n5{margin-bottom:-3rem!important}.hsl .ml-md-n5,.hsl .mx-md-n5{margin-left:-3rem!important}.hsl .m-md-auto{margin:auto!important}.hsl .mt-md-auto,.hsl .my-md-auto{margin-top:auto!important}.hsl .mr-md-auto,.hsl .mx-md-auto{margin-right:auto!important}.hsl .mb-md-auto,.hsl .my-md-auto{margin-bottom:auto!important}.hsl .ml-md-auto,.hsl .mx-md-auto{margin-left:auto!important}}@media (min-width: 992px){.hsl .m-lg-0{margin:0!important}.hsl .mt-lg-0,.hsl .my-lg-0{margin-top:0!important}.hsl .mr-lg-0,.hsl .mx-lg-0{margin-right:0!important}.hsl .mb-lg-0,.hsl .my-lg-0{margin-bottom:0!important}.hsl .ml-lg-0,.hsl .mx-lg-0{margin-left:0!important}.hsl .m-lg-1{margin:.25rem!important}.hsl .mt-lg-1,.hsl .my-lg-1{margin-top:.25rem!important}.hsl .mr-lg-1,.hsl .mx-lg-1{margin-right:.25rem!important}.hsl .mb-lg-1,.hsl .my-lg-1{margin-bottom:.25rem!important}.hsl .ml-lg-1,.hsl .mx-lg-1{margin-left:.25rem!important}.hsl .m-lg-2{margin:.5rem!important}.hsl .mt-lg-2,.hsl .my-lg-2{margin-top:.5rem!important}.hsl .mr-lg-2,.hsl .mx-lg-2{margin-right:.5rem!important}.hsl .mb-lg-2,.hsl .my-lg-2{margin-bottom:.5rem!important}.hsl .ml-lg-2,.hsl .mx-lg-2{margin-left:.5rem!important}.hsl .m-lg-3{margin:1rem!important}.hsl .mt-lg-3,.hsl .my-lg-3{margin-top:1rem!important}.hsl .mr-lg-3,.hsl .mx-lg-3{margin-right:1rem!important}.hsl .mb-lg-3,.hsl .my-lg-3{margin-bottom:1rem!important}.hsl .ml-lg-3,.hsl .mx-lg-3{margin-left:1rem!important}.hsl .m-lg-4{margin:1.5rem!important}.hsl .mt-lg-4,.hsl .my-lg-4{margin-top:1.5rem!important}.hsl .mr-lg-4,.hsl .mx-lg-4{margin-right:1.5rem!important}.hsl .mb-lg-4,.hsl .my-lg-4{margin-bottom:1.5rem!important}.hsl .ml-lg-4,.hsl .mx-lg-4{margin-left:1.5rem!important}.hsl .m-lg-5{margin:3rem!important}.hsl .mt-lg-5,.hsl .my-lg-5{margin-top:3rem!important}.hsl .mr-lg-5,.hsl .mx-lg-5{margin-right:3rem!important}.hsl .mb-lg-5,.hsl .my-lg-5{margin-bottom:3rem!important}.hsl .ml-lg-5,.hsl .mx-lg-5{margin-left:3rem!important}.hsl .p-lg-0{padding:0!important}.hsl .pt-lg-0,.hsl .py-lg-0{padding-top:0!important}.hsl .pr-lg-0,.hsl .px-lg-0{padding-right:0!important}.hsl .pb-lg-0,.hsl .py-lg-0{padding-bottom:0!important}.hsl .pl-lg-0,.hsl .px-lg-0{padding-left:0!important}.hsl .p-lg-1{padding:.25rem!important}.hsl .pt-lg-1,.hsl .py-lg-1{padding-top:.25rem!important}.hsl .pr-lg-1,.hsl .px-lg-1{padding-right:.25rem!important}.hsl .pb-lg-1,.hsl .py-lg-1{padding-bottom:.25rem!important}.hsl .pl-lg-1,.hsl .px-lg-1{padding-left:.25rem!important}.hsl .p-lg-2{padding:.5rem!important}.hsl .pt-lg-2,.hsl .py-lg-2{padding-top:.5rem!important}.hsl .pr-lg-2,.hsl .px-lg-2{padding-right:.5rem!important}.hsl .pb-lg-2,.hsl .py-lg-2{padding-bottom:.5rem!important}.hsl .pl-lg-2,.hsl .px-lg-2{padding-left:.5rem!important}.hsl .p-lg-3{padding:1rem!important}.hsl .pt-lg-3,.hsl .py-lg-3{padding-top:1rem!important}.hsl .pr-lg-3,.hsl .px-lg-3{padding-right:1rem!important}.hsl .pb-lg-3,.hsl .py-lg-3{padding-bottom:1rem!important}.hsl .pl-lg-3,.hsl .px-lg-3{padding-left:1rem!important}.hsl .p-lg-4{padding:1.5rem!important}.hsl .pt-lg-4,.hsl .py-lg-4{padding-top:1.5rem!important}.hsl .pr-lg-4,.hsl .px-lg-4{padding-right:1.5rem!important}.hsl .pb-lg-4,.hsl .py-lg-4{padding-bottom:1.5rem!important}.hsl .pl-lg-4,.hsl .px-lg-4{padding-left:1.5rem!important}.hsl .p-lg-5{padding:3rem!important}.hsl .pt-lg-5,.hsl .py-lg-5{padding-top:3rem!important}.hsl .pr-lg-5,.hsl .px-lg-5{padding-right:3rem!important}.hsl .pb-lg-5,.hsl .py-lg-5{padding-bottom:3rem!important}.hsl .pl-lg-5,.hsl .px-lg-5{padding-left:3rem!important}.hsl .m-lg-n1{margin:-.25rem!important}.hsl .mt-lg-n1,.hsl .my-lg-n1{margin-top:-.25rem!important}.hsl .mr-lg-n1,.hsl .mx-lg-n1{margin-right:-.25rem!important}.hsl .mb-lg-n1,.hsl .my-lg-n1{margin-bottom:-.25rem!important}.hsl .ml-lg-n1,.hsl .mx-lg-n1{margin-left:-.25rem!important}.hsl .m-lg-n2{margin:-.5rem!important}.hsl .mt-lg-n2,.hsl .my-lg-n2{margin-top:-.5rem!important}.hsl .mr-lg-n2,.hsl .mx-lg-n2{margin-right:-.5rem!important}.hsl .mb-lg-n2,.hsl .my-lg-n2{margin-bottom:-.5rem!important}.hsl .ml-lg-n2,.hsl .mx-lg-n2{margin-left:-.5rem!important}.hsl .m-lg-n3{margin:-1rem!important}.hsl .mt-lg-n3,.hsl .my-lg-n3{margin-top:-1rem!important}.hsl .mr-lg-n3,.hsl .mx-lg-n3{margin-right:-1rem!important}.hsl .mb-lg-n3,.hsl .my-lg-n3{margin-bottom:-1rem!important}.hsl .ml-lg-n3,.hsl .mx-lg-n3{margin-left:-1rem!important}.hsl .m-lg-n4{margin:-1.5rem!important}.hsl .mt-lg-n4,.hsl .my-lg-n4{margin-top:-1.5rem!important}.hsl .mr-lg-n4,.hsl .mx-lg-n4{margin-right:-1.5rem!important}.hsl .mb-lg-n4,.hsl .my-lg-n4{margin-bottom:-1.5rem!important}.hsl .ml-lg-n4,.hsl .mx-lg-n4{margin-left:-1.5rem!important}.hsl .m-lg-n5{margin:-3rem!important}.hsl .mt-lg-n5,.hsl .my-lg-n5{margin-top:-3rem!important}.hsl .mr-lg-n5,.hsl .mx-lg-n5{margin-right:-3rem!important}.hsl .mb-lg-n5,.hsl .my-lg-n5{margin-bottom:-3rem!important}.hsl .ml-lg-n5,.hsl .mx-lg-n5{margin-left:-3rem!important}.hsl .m-lg-auto{margin:auto!important}.hsl .mt-lg-auto,.hsl .my-lg-auto{margin-top:auto!important}.hsl .mr-lg-auto,.hsl .mx-lg-auto{margin-right:auto!important}.hsl .mb-lg-auto,.hsl .my-lg-auto{margin-bottom:auto!important}.hsl .ml-lg-auto,.hsl .mx-lg-auto{margin-left:auto!important}}@media (min-width: 1200px){.hsl .m-xl-0{margin:0!important}.hsl .mt-xl-0,.hsl .my-xl-0{margin-top:0!important}.hsl .mr-xl-0,.hsl .mx-xl-0{margin-right:0!important}.hsl .mb-xl-0,.hsl .my-xl-0{margin-bottom:0!important}.hsl .ml-xl-0,.hsl .mx-xl-0{margin-left:0!important}.hsl .m-xl-1{margin:.25rem!important}.hsl .mt-xl-1,.hsl .my-xl-1{margin-top:.25rem!important}.hsl .mr-xl-1,.hsl .mx-xl-1{margin-right:.25rem!important}.hsl .mb-xl-1,.hsl .my-xl-1{margin-bottom:.25rem!important}.hsl .ml-xl-1,.hsl .mx-xl-1{margin-left:.25rem!important}.hsl .m-xl-2{margin:.5rem!important}.hsl .mt-xl-2,.hsl .my-xl-2{margin-top:.5rem!important}.hsl .mr-xl-2,.hsl .mx-xl-2{margin-right:.5rem!important}.hsl .mb-xl-2,.hsl .my-xl-2{margin-bottom:.5rem!important}.hsl .ml-xl-2,.hsl .mx-xl-2{margin-left:.5rem!important}.hsl .m-xl-3{margin:1rem!important}.hsl .mt-xl-3,.hsl .my-xl-3{margin-top:1rem!important}.hsl .mr-xl-3,.hsl .mx-xl-3{margin-right:1rem!important}.hsl .mb-xl-3,.hsl .my-xl-3{margin-bottom:1rem!important}.hsl .ml-xl-3,.hsl .mx-xl-3{margin-left:1rem!important}.hsl .m-xl-4{margin:1.5rem!important}.hsl .mt-xl-4,.hsl .my-xl-4{margin-top:1.5rem!important}.hsl .mr-xl-4,.hsl .mx-xl-4{margin-right:1.5rem!important}.hsl .mb-xl-4,.hsl .my-xl-4{margin-bottom:1.5rem!important}.hsl .ml-xl-4,.hsl .mx-xl-4{margin-left:1.5rem!important}.hsl .m-xl-5{margin:3rem!important}.hsl .mt-xl-5,.hsl .my-xl-5{margin-top:3rem!important}.hsl .mr-xl-5,.hsl .mx-xl-5{margin-right:3rem!important}.hsl .mb-xl-5,.hsl .my-xl-5{margin-bottom:3rem!important}.hsl .ml-xl-5,.hsl .mx-xl-5{margin-left:3rem!important}.hsl .p-xl-0{padding:0!important}.hsl .pt-xl-0,.hsl .py-xl-0{padding-top:0!important}.hsl .pr-xl-0,.hsl .px-xl-0{padding-right:0!important}.hsl .pb-xl-0,.hsl .py-xl-0{padding-bottom:0!important}.hsl .pl-xl-0,.hsl .px-xl-0{padding-left:0!important}.hsl .p-xl-1{padding:.25rem!important}.hsl .pt-xl-1,.hsl .py-xl-1{padding-top:.25rem!important}.hsl .pr-xl-1,.hsl .px-xl-1{padding-right:.25rem!important}.hsl .pb-xl-1,.hsl .py-xl-1{padding-bottom:.25rem!important}.hsl .pl-xl-1,.hsl .px-xl-1{padding-left:.25rem!important}.hsl .p-xl-2{padding:.5rem!important}.hsl .pt-xl-2,.hsl .py-xl-2{padding-top:.5rem!important}.hsl .pr-xl-2,.hsl .px-xl-2{padding-right:.5rem!important}.hsl .pb-xl-2,.hsl .py-xl-2{padding-bottom:.5rem!important}.hsl .pl-xl-2,.hsl .px-xl-2{padding-left:.5rem!important}.hsl .p-xl-3{padding:1rem!important}.hsl .pt-xl-3,.hsl .py-xl-3{padding-top:1rem!important}.hsl .pr-xl-3,.hsl .px-xl-3{padding-right:1rem!important}.hsl .pb-xl-3,.hsl .py-xl-3{padding-bottom:1rem!important}.hsl .pl-xl-3,.hsl .px-xl-3{padding-left:1rem!important}.hsl .p-xl-4{padding:1.5rem!important}.hsl .pt-xl-4,.hsl .py-xl-4{padding-top:1.5rem!important}.hsl .pr-xl-4,.hsl .px-xl-4{padding-right:1.5rem!important}.hsl .pb-xl-4,.hsl .py-xl-4{padding-bottom:1.5rem!important}.hsl .pl-xl-4,.hsl .px-xl-4{padding-left:1.5rem!important}.hsl .p-xl-5{padding:3rem!important}.hsl .pt-xl-5,.hsl .py-xl-5{padding-top:3rem!important}.hsl .pr-xl-5,.hsl .px-xl-5{padding-right:3rem!important}.hsl .pb-xl-5,.hsl .py-xl-5{padding-bottom:3rem!important}.hsl .pl-xl-5,.hsl .px-xl-5{padding-left:3rem!important}.hsl .m-xl-n1{margin:-.25rem!important}.hsl .mt-xl-n1,.hsl .my-xl-n1{margin-top:-.25rem!important}.hsl .mr-xl-n1,.hsl .mx-xl-n1{margin-right:-.25rem!important}.hsl .mb-xl-n1,.hsl .my-xl-n1{margin-bottom:-.25rem!important}.hsl .ml-xl-n1,.hsl .mx-xl-n1{margin-left:-.25rem!important}.hsl .m-xl-n2{margin:-.5rem!important}.hsl .mt-xl-n2,.hsl .my-xl-n2{margin-top:-.5rem!important}.hsl .mr-xl-n2,.hsl .mx-xl-n2{margin-right:-.5rem!important}.hsl .mb-xl-n2,.hsl .my-xl-n2{margin-bottom:-.5rem!important}.hsl .ml-xl-n2,.hsl .mx-xl-n2{margin-left:-.5rem!important}.hsl .m-xl-n3{margin:-1rem!important}.hsl .mt-xl-n3,.hsl .my-xl-n3{margin-top:-1rem!important}.hsl .mr-xl-n3,.hsl .mx-xl-n3{margin-right:-1rem!important}.hsl .mb-xl-n3,.hsl .my-xl-n3{margin-bottom:-1rem!important}.hsl .ml-xl-n3,.hsl .mx-xl-n3{margin-left:-1rem!important}.hsl .m-xl-n4{margin:-1.5rem!important}.hsl .mt-xl-n4,.hsl .my-xl-n4{margin-top:-1.5rem!important}.hsl .mr-xl-n4,.hsl .mx-xl-n4{margin-right:-1.5rem!important}.hsl .mb-xl-n4,.hsl .my-xl-n4{margin-bottom:-1.5rem!important}.hsl .ml-xl-n4,.hsl .mx-xl-n4{margin-left:-1.5rem!important}.hsl .m-xl-n5{margin:-3rem!important}.hsl .mt-xl-n5,.hsl .my-xl-n5{margin-top:-3rem!important}.hsl .mr-xl-n5,.hsl .mx-xl-n5{margin-right:-3rem!important}.hsl .mb-xl-n5,.hsl .my-xl-n5{margin-bottom:-3rem!important}.hsl .ml-xl-n5,.hsl .mx-xl-n5{margin-left:-3rem!important}.hsl .m-xl-auto{margin:auto!important}.hsl .mt-xl-auto,.hsl .my-xl-auto{margin-top:auto!important}.hsl .mr-xl-auto,.hsl .mx-xl-auto{margin-right:auto!important}.hsl .mb-xl-auto,.hsl .my-xl-auto{margin-bottom:auto!important}.hsl .ml-xl-auto,.hsl .mx-xl-auto{margin-left:auto!important}}.hsl .stretched-link:after{position:absolute;top:0;right:0;bottom:0;left:0;z-index:1;pointer-events:auto;content:\"\";background-color:#0000}.hsl .text-monospace{font-family:SFMono-Regular,Menlo,Monaco,Consolas,\"Liberation Mono\",\"Courier New\",monospace!important}.hsl .text-justify{text-align:justify!important}.hsl .text-wrap{white-space:normal!important}.hsl .text-nowrap{white-space:nowrap!important}.hsl .text-truncate{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.hsl .text-left{text-align:left!important}.hsl .text-right{text-align:right!important}.hsl .text-center{text-align:center!important}@media (min-width: 576px){.hsl .text-sm-left{text-align:left!important}.hsl .text-sm-right{text-align:right!important}.hsl .text-sm-center{text-align:center!important}}@media (min-width: 768px){.hsl .text-md-left{text-align:left!important}.hsl .text-md-right{text-align:right!important}.hsl .text-md-center{text-align:center!important}}@media (min-width: 992px){.hsl .text-lg-left{text-align:left!important}.hsl .text-lg-right{text-align:right!important}.hsl .text-lg-center{text-align:center!important}}@media (min-width: 1200px){.hsl .text-xl-left{text-align:left!important}.hsl .text-xl-right{text-align:right!important}.hsl .text-xl-center{text-align:center!important}}.hsl .text-lowercase{text-transform:lowercase!important}.hsl .text-uppercase{text-transform:uppercase!important}.hsl .text-capitalize{text-transform:capitalize!important}.hsl .font-weight-light{font-weight:300!important}.hsl .font-weight-lighter{font-weight:lighter!important}.hsl .font-weight-normal{font-weight:400!important}.hsl .font-weight-bold{font-weight:700!important}.hsl .font-weight-bolder{font-weight:bolder!important}.hsl .font-italic{font-style:italic!important}.hsl .text-white{color:var(--white)!important}.hsl .text-primary{color:var(--primary)!important}.hsl a.text-primary:hover,.hsl a.text-primary:focus{color:hsla(var(--primary-h),var(--primary-s),calc(var(--primary-l) + -15%),1)!important;color:hsla(var(--primary-h),var(--primary-s),calc(var(--primary-l) + -15%),var(--primary-a, 1))!important}.hsl .text-secondary{color:var(--secondary)!important}.hsl a.text-secondary:hover,.hsl a.text-secondary:focus{color:hsla(var(--secondary-h),var(--secondary-s),calc(var(--secondary-l) + -15%),1)!important;color:hsla(var(--secondary-h),var(--secondary-s),calc(var(--secondary-l) + -15%),var(--secondary-a, 1))!important}.hsl .text-success{color:#28a745!important}.hsl a.text-success:hover,.hsl a.text-success:focus{color:#228e3b!important}.hsl .text-info{color:#17a2b8!important}.hsl a.text-info:hover,.hsl a.text-info:focus{color:#148a9c!important}.hsl .text-warning{color:#ffc107!important}.hsl a.text-warning:hover,.hsl a.text-warning:focus{color:#dfa700!important}.hsl .text-danger{color:#dc3545!important}.hsl a.text-danger:hover,.hsl a.text-danger:focus{color:#c62232!important}.hsl .text-light{color:var(--light)!important}.hsl a.text-light:hover,.hsl a.text-light:focus{color:hsla(var(--light-h),var(--light-s),calc(var(--light-l) + -15%),1)!important;color:hsla(var(--light-h),var(--light-s),calc(var(--light-l) + -15%),var(--light-a, 1))!important}.hsl .text-dark{color:var(--gray-800)!important}.hsl a.text-dark:hover,.hsl a.text-dark:focus{color:hsla(var(--gray-800-h),var(--gray-800-s),calc(var(--gray-800-l) + -15%),1)!important;color:hsla(var(--gray-800-h),var(--gray-800-s),calc(var(--gray-800-l) + -15%),var(--gray-800-a, 1))!important}.hsl .text-gray{color:var(--gray-900)!important}.hsl a.text-gray:hover,.hsl a.text-gray:focus{color:hsla(var(--gray-900-h),var(--gray-900-s),calc(var(--gray-900-l) + -15%),1)!important;color:hsla(var(--gray-900-h),var(--gray-900-s),calc(var(--gray-900-l) + -15%),var(--gray-900-a, 1))!important}.hsl .text-body{color:var(--gray-900)!important}.hsl .text-muted{color:#6c757d!important}.hsl .text-black-50{color:#00000080!important}.hsl .text-white-50{color:hsla(var(--white-h),var(--white-s),var(--white-l),.5)!important}.hsl .text-hide{font:0/0 a;color:transparent;text-shadow:none;background-color:transparent;border:0}.hsl .text-decoration-none{text-decoration:none!important}.hsl .text-break{word-break:break-word!important;word-wrap:break-word!important}.hsl .text-reset{color:inherit!important}.hsl .visible{visibility:visible!important}.hsl .invisible{visibility:hidden!important}.hsl .navbar-expand .nav-item{align-items:flex-start}.hsl .basemapGallery .dropdown-menu{overflow:visible}.hsl hs-add-data-catalogue .dropdown-menu{max-width:revert}.hsl .icon-spin{-webkit-animation:spin 1s infinite linear;animation:spin 1s infinite linear;position:relative;top:1px;display:inline-block;font-style:normal;font-weight:400;line-height:1;-webkit-font-smoothing:antialiased}.hsl .icon-primary{color:var(--primary)}@-webkit-keyframes spin{0%{transform:rotate(0)}to{transform:rotate(359deg)}}@keyframes spin{0%{transform:rotate(0)}to{transform:rotate(359deg)}}.hsl .hs-wms-expandedRow{white-space:break-spaces}.hsl .hs-wms-highlighted{cursor:pointer}.hsl .hs-wms-highlighted:hover{background-color:#d2d8dd96}.hsl .hs-flex-fill{flex:1 1 auto}.hsl .hs-grayscale{filter:grayscale(100%)}.hsl .grayed{color:#ccc}.hsl .hs-main-panel{border:none;margin-bottom:0;margin-top:.25rem!important}.hsl div.hs-main-panel:not(.hs-stc-mainpanel)>div.card-body{padding:0}.hsl .hs-map-space{flex:1 1 auto;position:relative}.hsl .flex-reverse{flex-direction:row-reverse}.hsl .fill{min-height:100%;height:100%}.hsl .x-large{font-size:x-large!important}.hsl .cursor-pointer{cursor:pointer}.hsl .hs-info-container{pointer-events:none}.hsl .hs-filter{border:0!important;border-top-left-radius:.25rem!important;border-bottom-left-radius:.25rem!important}.hsl .hs-layerpanel{max-height:27.875em;overflow-y:auto;border:0;margin-bottom:0;border-bottom:0;word-wrap:break-word}.hsl progress::-webkit-progress-value{-webkit-transition:width .1s ease;transition:width .1s ease}.hsl .hs-save-comp-advanced-panel{margin-top:10px}.hsl .hs-comp-ext-row{margin-left:0;margin-right:0}.hsl .hs-comp-ext{padding-left:3px;padding-right:3px}.hsl .hs-comp-ext input{text-align:center;padding:3px 6px}.hsl .hs-lm-header:first-child,.hsl .hs-lm-list:first-child,.hsl .hs-lm-item:first-child,.hsl .hs-comp-header:first-child,.hsl .hs-comp-list:first-child,.hsl .hs-comp-item:first-child{border-top-left-radius:0;border-top-right-radius:0}.hsl .hs-lm-list:last-child,.hsl .hs-lm-item:last-child,.hsl .hs-comp-list:last-child,.hsl .hs-comp-item:last-child{border-bottom-left-radius:0;border-bottom-right-radius:0}.hsl input.hs-waypoint-name{display:inline-block;width:calc(100% - 2.8125em)}.hsl .hs-tab-single-datasources a{cursor:pointer}.hsl ul.hs-comp-list{margin-bottom:0;overflow-y:auto}.hsl .modal.in{display:block;background-color:#0e0e0d38}.hsl .modal-backdrop{visibility:hidden}.hsl .form-control{border-radius:0}.hsl input[type=range].form-control{padding:0}.hsl .capabilities_label{padding-right:0;padding-left:0}.hsl .capabilities_input{padding-right:0;padding-left:15px}.hsl hr{margin-top:0;margin-bottom:5px}.hsl a{cursor:pointer}.hsl .input-group-append [class^=icon-]{font-size:.85rem}.hsl .but-title-sm{float:right;font-size:14px;font-weight:700;line-height:17px;color:var(--secondary);filter:alpha(opacity=20);opacity:.35}.hsl .but-title-sm:hover{text-decoration:none;cursor:pointer;filter:alpha(opacity=50);opacity:.8}.hsl button.but-title-sm{-webkit-appearance:none;cursor:pointer;background:0 0;border:0}.hsl .popover-content{min-width:230px}.hsl .popover{max-width:1000px;max-height:1000px}.hsl .thumbnail{margin-top:3px;margin-bottom:3px}.hsl .list-group-item.active a{color:#fff}.hsl .list-group-item.active{background-color:var(--sidebar-bg-color-active);border-color:var(--sidebar-bg-color-active);color:var(--sidebar-item-color-active)}.hsl .btn .close{font-size:20px}.hsl .modal{font-family:Roboto,\"Helvetica Neue\",sans-serif}.hsl .hs-checkmark,.hsl .hs-uncheckmark{position:relative;cursor:pointer;margin-right:.3em}.hsl .hs-checkmark:before{content:\"\\2713\"}.hsl .hs-uncheckmark:before{content:\"\\a0\"}.hsl .hs-checkmark:before,.hsl .hs-uncheckmark:before{color:#fff;display:inline-block;width:1.5em;height:1.5em;background-color:var(--primary);padding:.09em .4em .05em .35em;border-radius:.2em;font-weight:1000;font-size:small}.hsl .hs-uncheckmark:before{background-color:#fff;box-shadow:inset 0 0 0 .2em var(--primary)}.hsl .hs-checkmark.hs-btn-baselayers:before{color:var(--primary);background-color:#fff}.hsl .sublayerContainer .hs-checkmark:before,.hsl .sublayerContainer .hs-uncheckmark:before,.hsl .form-check .hs-checkmark:before,.hsl .form-check .hs-uncheckmark:before{margin-right:.5em}.hsl .hs-stc-footer{text-align:center;margin-top:10px}.hsl .hs-stc-footer button{width:100px}.hsl #hs-ows-abstract{resize:vertical;min-height:100px}.hsl .hs-ows-shp-advanced{margin-top:10px}.hsl .hs-ows-vector-advanced{margin-top:10px}.hsl .hs-ows-layerlistheading{background-color:#ededed}.hsl .hs-composition-share-dialog .modal-body,.hsl .composition-info-dialog .modal-body{font-size:14px}.hsl .list-group-item-primary{background-color:hsl(var(--primary-h),65%,calc(var(--light-l) - 5%));color:var(--text-color)}.hsl .list-group-item-secondary{background-color:hsl(var(--secondary-h),65%,calc(var(--light-l) - 5%));color:var(--text-color)}.hsl .list-group-item-success{background-color:hsl(133.7007874016deg,65%,calc(var(--light-l) - 5%));color:var(--text-color)}.hsl .list-group-item-info{background-color:hsl(188.198757764deg,65%,calc(var(--light-l) - 5%));color:var(--text-color)}.hsl .list-group-item-warning{background-color:hsl(45deg,65%,calc(var(--light-l) - 5%));color:var(--text-color)}.hsl .list-group-item-danger{background-color:hsl(354.251497006deg,65%,calc(var(--light-l) - 5%));color:var(--text-color)}.hsl .list-group-item-light{background-color:hsl(var(--light-h),65%,calc(var(--light-l) - 5%));color:var(--text-color)}.hsl .list-group-item-dark{background-color:hsl(var(--gray-800-h),65%,calc(var(--light-l) - 5%));color:var(--text-color)}.hsl .list-group-item-gray{background-color:hsl(var(--gray-900-h),65%,calc(var(--light-l) - 5%));color:var(--text-color)}.hsl hs-panel-header{background-color:var(--sidebar-bg-color)}@media only screen and (max-width: 767px){.hsl input[type=checkbox]{transform:scale(2);margin-right:.5em;margin-left:.5em}.hsl input[type=radio]{transform:scale(2)}.hsl div .form-check-inline{margin-right:0!important}.hsl .hs-content-wrapper{position:unset}.hsl .hs-sb-bottom .hs-ol-map{width:100%!important}.hsl .ol-viewport{position:absolute!important}.hsl .removeIcon{line-height:1.5;font-size:large}.hsl .panel-footer{padding:5px}.hsl .hs-filter{display:none!important}.hsl .ol-attribution.ol-uncollapsible{bottom:.2em}.hsl .ol-attribution ul{margin:0}.hsl .ol-control button{font-size:1.5em}.hsl .hs-ol-map .ol-zoom{bottom:.2em;top:auto;right:5px;left:auto}.hsl div.hs-info-container{display:none}.hsl .dropzone-container{flex-direction:column}.hsl .hs-draw-selectAll{font-size:medium}}.hsl ul[dnd-list],.hsl ul[dnd-list]>li{position:relative}.hsl ul[dnd-list]{min-height:42px;padding-left:0;margin-left:-23px;margin-right:-20px}.hsl ul[dnd-list] .dndDraggingSource{display:none}.hsl ul[dnd-list] .dndPlaceholder{display:block;background-color:#ddd;min-height:42px}.hsl ul[dnd-list] li{background-color:#fff;border:1px solid #ddd;border-top-right-radius:4px;border-top-left-radius:4px;display:block;margin-bottom:-1px;line-height:1em;padding:7px 2px 0 3px}.hsl ul[dnd-list] li.selected{background-color:#dff0d8;color:#3c763d}.hsl .hs-senslog-sensor{color:#333}.hsl .input-group-btn .btn{height:34px}.hsl .badge-warning{height:2.3em;width:2em;line-height:inherit}.hsl .btn-group>.btn{float:none;float:initial}.hsl .draw-buttons button{margin-left:.3em}.hsl .card-href{color:var(--gray-900);width:100%;display:inline-block}@media only screen and (min-width: 600px){.hsl .hs-layout .layout-row{position:relative}}.hsl #permalink-link{overflow-x:hidden}.hsl .hs-dotted-line{border:1px dotted #495057;border-style:none none dotted;color:#495057;background-color:#0003}.hsl .hs-extra-buttons{line-height:1em;float:right;margin-right:.5em}.hsl .dropdown-toggle.hs-custom-toggle:after{display:inline-block;width:.47em;height:.47em;margin:0 0 0 .4em;content:\"\";border:.3em solid;border-width:0 .15em .15em 0;transform:rotate(45deg);color:#495057}.hsl .dropdown-toggle.hs-custom-toggle:focus{box-shadow:0 0 0 .2rem #007bff40!important}.hsl .hs-background-alfa{background-color:var(--light)}.hsl hs-draw-layer-metadata .alert-danger{color:var(--text-color)}.hsl .hs-hover-popup{max-height:20em;min-width:10em;max-width:40em;overflow-y:scroll;visibility:visible;background:var(--white)}.hsl .hs-toolbar-button{height:2.4em}.hsl .dropdown-menu.datetime-picker-menu{min-width:22rem}.hsl a.hs-sensor-type{color:#000}.hsl a.hs-sensor-unit{color:#000;font-weight:bold}.hsl .hs-sensor{line-height:1.9em}.hsl .hs-date-time-chevron:not(*:root){visibility:hidden}.hsl .form-inline .ngb-tp-input{width:4em}.hsl hs-layer-editor .form-check{line-height:1.5}.hsl hs-layer-editor .card-body{padding:.65rem}.hsl hs-layer-editor hr{margin-top:.3rem;margin-bottom:.3rem}.hsl .hs-layerpanel{overflow-x:hidden}.hsl .hs-hover-popup-feature{font-size:small;line-height:1;margin-bottom:2px;border-bottom:1px solid #c7c7c7}.hsl .hs-draw-layer-toggle div{display:inline-block;max-width:7em;overflow-x:hidden;line-height:normal}.hsl .inputfile{width:.1px;height:.1px;opacity:0;overflow:hidden;position:absolute;z-index:-1}.hsl .inputfile+label{font-size:1.25em;font-weight:700;color:#fff;background-color:var(--primary);display:inline-block;cursor:pointer}.hsl .inputfile+label:hover{background-color:var(--secondary)}.hsl input[type=checkbox].checkbox-lg{transform:scale(1.3)}.hsl .dropzone-container{flex-direction:row}.hsl .dropzone{text-align:center;min-height:80px;border:dashed 3px var(--primary);border-radius:5px;color:#495057!important}.hsl .dropzone.active{border:solid 3px var(--secondary);color:#00000059!important;opacity:.4}.hsl .dropzone .dropzone-label{display:block;font-size:1em}.hsl .hs-endpoint-item-active{background-color:#0003}.hsl .hs-content-wrapper{position:relative;font-family:Roboto,\"Helvetica Neue\",sans-serif}.hsl .hs-panelspace{box-shadow:-36px -12px 61px -39px #0000004d;background-color:var(--panel-wrapper-bg-color);height:100%;overflow-x:visible;overflow-y:visible;padding-left:0;padding-right:0;pointer-events:auto;top:0;width:400px;z-index:2;transition:width .1s ease-out}.hsl .hs-sb-right .hs-panelspace{right:0}.hsl .hs-sb-left .hs-panelspace{left:0}.hsl div.hs-content-wrapper:not(.hs-open) div.hs-panelspace-wrapper{background-color:transparent;width:48px;overflow-x:hidden}.hsl .hs-panelspace-wrapper{height:100%;padding-left:0;padding-right:0;overflow-y:auto}.hsl .hs-content-wrapper label.form-group{display:block}@media only screen and (max-width: 767px){.hsl .hs-content-wrapper{flex-direction:column;position:unset}.hsl .hs-panelspace{left:0;bottom:0;height:auto;top:unset;width:100%;transition:none}.hsl .hs-panelspace.expanded{min-width:300px}.hsl .hs-panelspace-wrapper{display:flex;flex-direction:column;scrollbar-width:none;max-height:40vh;overflow-y:visible;font-size:x-large;width:100%}.hsl #panelspace{display:flex}}.hsl ul.hs-lm-baselayerlist{margin-bottom:0}.hsl ul.hs-lm-mapcontentlist{margin-top:0;margin-bottom:0;border-bottom:1px solid var(--panel-wrapper-bg-color)}.hsl ul.hs-lm-layerlist li.list-group-item.hs-lm-layerlist-header{padding:.3em;border-top-left-radius:0;border-top-right-radius:0;cursor:pointer;margin-left:-2px;margin-right:-2px}.hsl ul.hs-lm-layerlist li.list-group-item.hs-lm-layerlist-header span.glyphicon{font-size:x-small}.hsl li.hs-lm-item.hovering{text-decoration:underline}.hsl div.list-group-item.hs-lm-list{border:0;padding-top:0;padding-bottom:0}.hsl .hs-lm-list>ul.list-group.row{margin-bottom:0}.hsl .hs-lm-list li .info_btn{cursor:pointer}.hsl .hs-lm-list li .info_btn .icon-settingsthree-gears:hover:before{color:var(--primary)}.hsl .hs-layermanager-card li.hs-lm-item,.hsl li.hs-dr-item{word-wrap:break-word;border-left:0;border-right:0;padding:.4em .1em .1em .2em}.hsl div ul.hs-lm-baselayerlist .hs-lm-item-title,.hsl div.hs-lm-item-title.hover{cursor:pointer}.hsl .hs-layermanager-card .hs-lm-item-visibility{margin-top:-.42em}.hsl div ul.hs-lm-baselayerlist .hs-lm-item-title:hover,.hsl div.hs-lm-item-title.hover:hover{text-decoration:underline}.hsl .sublayerContainer input[type=checkbox].form-check-input{position:absolute;left:-9999px}.hsl .sublayerContainer{padding-bottom:2.5px}.hsl li.hs-lm-header{border-left:0;border-right:0;padding-left:2em;background-color:hsl(var(--primary-h),65%,calc(var(--light-l) - 10%))}.hsl .hs-lm-map-content-header{height:2.56em}.hsl .hs-lm-deactivated-layer{color:#ccc}@media only screen and (max-width: 767px){.hsl ul.hs-lm-layerlist li.list-group-item.hs-lm-layerlist-header span.glyphicon{font-size:small}}.hsl i.hs-lm-warning-scale{color:#f0ad4e;padding:.0625em .3125em;top:.125em;cursor:default}.hsl i.hs-lm-warning-error{position:static;cursor:default}.hsl i.hs-lm-queryable{cursor:default;color:#337ab7;padding:.0625em .3125em;border-radius:3px;line-height:1.5;font-size:12px;top:2px}.hsl .exclusive .hs-checkmark:before,.hsl .exclusive .hs-uncheckmark:before{border-radius:50%}.hsl .basemapGallery{display:flex;flex-direction:row;justify-content:flex-end;align-items:center;top:.7em;position:absolute;cursor:pointer;box-sizing:border-box;right:15px}.hsl .basemapGallery .galleryDropdown{width:11.5em}.hsl .basemapGallery .galleryDropdown img{height:4.5em}.hsl .basemapGallery .dropdown-item:not(.active){background:rgba(204,204,204,.51)}.hsl .basemapGallery .dropdown-item.active{color:#ffffffe3!important}.hsl .basemapGallery img.active,.hsl .basemapGallery div.active{border:.1rem solid #007bff}.hsl .basemapGallery div span.glyphicon{font-size:smaller}.hsl .basemapGallery .hs-miniMenu{width:100%;height:100%;background-color:#52657af0;border:.1rem solid #007bff;display:flex;flex-direction:column;justify-content:center;align-items:center;color:#fff;cursor:auto;right:0;transition:all .4s ease,right 0ms}.hsl .basemapGallery .hs-miniMenu>div{display:flex;flex-direction:row;background-color:#c1bebea4;cursor:pointer}.hsl .basemapGallery .hs-miniMenu p{cursor:pointer;font-size:\"medium\"}.hsl .basemapGallery .hs-miniMenu.expanded{width:30em;height:auto;z-index:4;padding-top:2em;padding-bottom:2em;border-radius:.25rem}.hsl .basemapGallery .hs-miniMenu>label{cursor:pointer;text-align:right}.hsl .basemapGallery .hs-miniMenu.expanded hs-layer-editor label{color:#fff}.hsl .galleryButton{opacity:.9!important;background-color:var(--map-controls-bg)!important;color:#fff!important}.hsl .galleryButton:hover{background-color:var(--primary)!important}@media only screen and (max-width: 767px){.hsl .basemapGallery a{font-size:x-large!important}.hsl .hs-content-wrapper>div.hs-map-space>hs.layermanager.gallery>div>div>div>button{font-size:x-large}.hsl .basemapGallery div span.glyphicon{font-size:large}.hsl .basemapGallery .galleryDropdown{width:15.5em}.hsl .basemapGallery .galleryDropdown img{height:6em}.hsl .basemapGallery .hs-miniMenu{max-width:90vw;font-size:larger}}.hsl .hs-sidebar-item{color:var(--sidebar-item-color);background-color:var(--sidebar-bg-color);cursor:pointer}.hsl .hs-sidebar-item [class*=\" icon-\"]{margin-left:-4px}.hsl hs-sidebar{bottom:0;position:absolute;top:0;background:var(--sidebar-bg-color);transition:width .1s ease-out;z-index:2}.hsl hs-sidebar div.hs-sidebar-list a:not(.active){background-color:transparent;color:var(--sidebar-item-color)}.hsl .hs-content-wrapper.hs-open .hs-panelspace:not(.labels) hs-sidebar{border-right:1px solid #dedede}.hsl .hs-panelspace.labels hs-sidebar{width:400px}.hsl .hs-panelspace:not(.buttons) hs-sidebar{display:none}.hsl .hs-content-wrapper.hs-sb-left:not(.hs-open) hs-sidebar{background-color:var(--sidebar-bg-color);right:auto;width:48px}.hsl .hs-content-wrapper.hs-sb-right:not(.hs-open) hs-sidebar{background-color:var(--sidebar-bg-color);left:auto;width:48px}.hsl .hs-content-wrapper:not(.hs-open) .hs-panelspace{width:48px;border-right:1px solid #dedede}.hsl .hs-content-wrapper.hs-open .hs-sidebar-list{width:100%}.hsl .hs-content-wrapper.hs-open div.hs-panelspace:not(.labels) hs-sidebar .hs-sidebar-list{width:48px}.hsl div.hs-panelplace{height:100%;overflow-y:auto;margin-left:49px}.hsl div.hs-panelplace>div{height:100%}.hsl div.hs-panelspace:not(.buttons) hs-sidebar~div.hs-panelplace{margin-left:0;width:400px}.hsl .hs-sidebar-list .list-group-item{border-left:0px;border-right:0px;white-space:nowrap}.hsl .hs-sidebar-list .list-group-item:first-child{border-top-left-radius:0;border-top-right-radius:0}.hsl .hs-sidebar-list .list-group-item:last-child{border-bottom-left-radius:0;border-bottom-right-radius:0}.hsl .hs-sidebar-item-title{margin-left:20px}.hsl .hs-panelspace:not(.labels) .hs-sidebar-list span.hs-sidebar-item-title{display:none}.hsl .hs-content-wrapper.hs-sb-right:not(.hs-open) .hs-sidebar-list{right:0}.hsl .hs-content-wrapper.hs-sb-left:not(.hs-open) .hs-sidebar-list{left:0}.hsl .hs-content-wrapper:not(.hs-open) .hs-sidebar-item-title{display:none}.hsl .hs-content-wrapper:not(.hs-open) .hs-panelplace{display:none}.hsl hs-sidebar hs-panel-header.sidebar-header{display:none}.hsl hs-sidebar .hs-sidebar-item.hs-panel-hidden{display:none!important}.hsl hs-mini-sidebar .hs-sidebar-item:not(.hs-panel-hidden){display:none!important}.hsl hs-mini-sidebar .hs-sidebar-list{height:auto;justify-content:center;align-items:center;flex-wrap:wrap;margin:auto}.hsl hs-mini-sidebar .hs-sidebar-item.hs-panel-hidden{display:flex;flex-direction:column;align-items:center;text-align:center;width:100%}.hsl hs-mini-sidebar .hs-sidebar-item-title{display:block!important;margin:0;font-size:10px}.hsl hs-sidebar~div.hs-panelplace{overflow-x:hidden}@media only screen and (max-width: 767px){.hsl .hs-content-wrapper .hs-sidebar-item-title:not(.hs-mini-sidebar){display:none}.hsl hs-sidebar{display:flex}.hsl hs-sidebar{position:unset;width:100%!important}.hsl hs-sidebar~div.hs-panelplace{margin:auto;height:35vh;padding-top:.5em;scrollbar-width:none;width:95%}.hsl hs-sidebar>div.list-group{flex-direction:row!important;justify-content:space-evenly}.hsl .hs-sidebar-list .list-group-item{white-space:normal}.hsl .hs-content-wrapper.hs-open div.hs-panelspace:not(.labels) hs-sidebar .hs-sidebar-list{width:100%}.hsl div.hs-content-wrapper:not(.hs-open) div.hs-panelspace-wrapper{width:100%}.hsl .hs-content-wrapper div.hs-panelspace:not(.labels) hs-sidebar .hs-sidebar-list{width:100%}.hsl .hs-content-wrapper div.hs-panelspace .hs-mini-sidebar .hs-sidebar-list{width:100%}.hsl a.hs-sidebar-item.list-group-item{flex-grow:1;display:flex;justify-content:center;padding:.55rem 1.05rem}.hsl .hs-sidebar-item [class*=\" icon-\"]{font-size:x-large}.hsl hs-mini-sidebar .hs-sidebar-list{flex-direction:row!important;justify-content:center;align-items:center;flex-wrap:wrap;margin:auto}.hsl hs-mini-sidebar hs-panel-header.sidebar-header{display:none}.hsl hs-mini-sidebar .hs-sidebar-item.hs-panel-hidden{width:25%;height:80px}.hsl hs-mini-sidebar .hs-sidebar-item-title{display:block!important;margin:0;font-size:10px}.hsl hs-mini-sidebar .list-group-item{border:none;background-color:unset}.hsl hs-sidebar .hs-panel-hidden{display:none!important}.hsl hs-mini-sidebar .hs-sidebar-item:not(.hs-panel-hidden){display:none!important}}.hsl .hs-locate:not(.ol-collapsed){background:rgba(255,255,255,.8)}.hsl .hs-locate,.hsl .ol-has-tooltip [role=tooltip],.hsl .ol-scale-line-inner{font-family:\"Lucida Grande\",Verdana,Geneva,Lucida,Arial,Helvetica,sans-serif}.hsl .hs-locate{text-align:right;bottom:9.2em;right:5px;max-width:calc(100% - 1.3em);z-index:100}.hsl .hs-locate ul{float:left}.hsl .hs-locate button{float:right}.hsl .hs-locate .btn-primary{background-color:#0069d9!important}.hsl .hs-locate.ol-collapsed ul,.hsl .hs-locate:not(.ol-collapsed) button:hover [role=tooltip]{display:none}.hsl .hs-locate ul{list-style:none}.hsl .ol-rotate{bottom:11.5em;left:auto;right:5px;top:auto}.hsl .ol-rotate.hidden{visibility:hidden;opacity:0%}.hsl .ol-rotate button:not(.active){background-color:#868888b3}.hsl .hs-impressum .hs-logo{max-width:100%;padding-left:5em;padding-right:5em}.hsl .hs-impressum .hs-logo img{width:100%}.hsl .hs-panelspace:not(.labels) .hs-impressum{display:none}.hsl .hs-content-wrapper:not(.hs-open) .hs-impressum{display:none}.hsl .hs-search-address{z-index:2}.hsl .hs-toolbar #hs-search-address{max-width:125px}.hsl #searchresults{top:45px;min-width:250px}.hsl .search-panel hs-search-input,.hsl .search-panel hs-search-results{width:100%}.hsl .clearSearch{position:absolute;right:.5rem;top:50%;transform:translateY(-50%);border:0;color:#000;z-index:5;background:transparent}.hsl .clearSearch:hover{color:var(--primary)}.hsl .hsl-search-result{z-index:2}@media only screen and (max-width: 767px){.hsl .hs-search-address-input{max-width:20vw!important}}.hsl div.hs-info-area{background-color:#2f588e66;border-radius:4px;bottom:1.7em;color:#fff;left:.5em;padding:1px;pointer-events:initial;position:absolute;vertical-align:bottom;z-index:3}.hsl div.hs-info-composition-image{background-size:76px 76px;font-size:15px;height:2em;position:absolute;text-align:center;width:2em;top:-30px;left:3px;background-color:#003c8a4d}.hsl div.hs-info-composition{display:flex;max-width:300px}.hsl div.hs-info-composition-container{font-size:12px;line-height:12px;padding:4px}.hsl div.hs-info-composition-title{font-weight:bold;padding-bottom:6px}.hsl div.hs-info-composition-image>span{line-height:30px;width:30px}.hsl .hs-info-layers,.hsl div.hs-info-composition-edited{font-size:12px;padding:0 12px 12px;text-overflow:ellipsis;height:29px;overflow:hidden;display:inline-block;position:relative;width:260px;white-space:nowrap}.hsl .hs-toolbar{position:absolute;top:10px;left:10px;max-width:636px;display:inline-block;z-index:101}@media only screen and (max-width: 767px){.hsl .hs-sb-left .hs-toolbar,.hsl .hs-sb-left .hs-toolbar{margin-left:0!important}}.hsl .hsl-custom-select{height:calc(1.5em + .75rem + 2px);min-height:1.5rem;padding:.375rem 1.75rem .375rem .75rem;display:inline-block;font-size:1rem;font-weight:400;width:100%;border:1px solid #ced4da}.hsl .ol-attribution{left:auto;right:5px;bottom:.2em}.hsl .ol-attribution.ol-uncollapsible{right:5px;bottom:.2em}.hsl .hs-ol-map .ol-scale-line{right:auto;left:.5em}.hsl .hs-ol-map .ol-zoom{bottom:2.4em;top:auto;right:5px;left:auto}.hsl .hs-ol-map .hs-defaultView{bottom:6.65em;top:auto;right:5px;left:auto}.hsl .ol-touch .ol-zoomslider{display:none}.hsl .ol-mouse-position{bottom:8px;left:170px;position:absolute;color:#fff;top:auto;right:auto}.hsl .ol-popup{display:none;position:absolute;background-color:#fff;padding:15px 25px 15px 15px;border:1px solid #cccccc;bottom:12px;left:-50px}.hsl .ol-popup:after,.hsl .ol-popup:before{top:100%;border:solid transparent;content:\" \";height:0;width:0;position:absolute;pointer-events:none}.hsl .ol-popup:after{border-top-color:#fff;border-width:10px;left:48px;margin-left:-10px}.hsl .ol-popup:before{border-top-color:#ccc;border-width:11px;left:48px;margin-left:-11px}.hsl .ol-popup-content{min-width:170px;max-height:200px;overflow-x:auto}.hsl .ol-popup-closer{position:absolute;top:2px;right:2px;font-size:150%;padding:0 4px;color:gray;text-decoration:none}.hsl .ol-popup-closer:after{content:\"\\2716\"}.hsl .ol-popup div.infoResult{min-width:130px}.hsl .ol-popup div.infoResult p{padding:.1em;margin:0}.hsl .ol-popup-content h3{margin:.25em 0}.hsl .ol-popup.marker{margin-bottom:30px}.hsl .ol-overlaycontainer-stopevent{pointer-events:none}.hsl .ol-overlaycontainer-stopevent *{pointer-events:auto}.hsl .ol-control button:hover{background-color:var(--primary)}.hsl .ol-control button{background-color:var(--map-controls-bg);font-family:\"Lucida Grande\",Verdana,Geneva,Lucida,Arial,Helvetica,sans-serif}\n", "@font-face{font-family:\"WebHostingHub-Glyphs\";src:url(data:font/opentype;charset=utf-8;base64,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) format(\"truetype\");font-weight:normal;font-style:normal;-moz-font-feature-settings:\"calt=0,liga=0\"}[class^=icon-],[class*=\" icon-\"]{font-family:\"WebHostingHub-Glyphs\";background:none;width:auto;height:auto;font-style:normal}.icon-indexmanager:before{content:\"\\f09e\"}.icon-alertpay:before{content:\"\\f269\"}.icon-brush:before{content:\"\\f1b8\"}.icon-analytics-piechart:before{content:\"\\f000\"}.icon-chevron-left:before{content:\"\\f489\"}.icon-chevron-right:before{content:\"\\f488\"}.icon-chevron-down:before{content:\"\\f48b\"}.icon-check:before{content:\"\\f310\"}.icon-database:before{content:\"\\f00b\"}.icon-download:before{content:\"\\f47b\"}.icon-edit:before{content:\"\\f47c\"}.icon-gpsoff-gps:before{content:\"\\f21e\"}.icon-info-sign:before{content:\"\\f315\"}.icon-layers:before{content:\"\\f1ca\"}.icon-line:before{content:\"\\f1bf\"}.icon-link:before{content:\"\\f022\"}.icon-map:before{content:\"\\f209\"}.icon-pencil:before{content:\"\\f1b7\"}.icon-pin:before{content:\"\\f20a\"}.icon-plus:before{content:\"+\"}.icon-polygonlasso:before{content:\"\\f397\"}.icon-print:before{content:\"\\f125\"}.icon-question-sign:before{content:\"\\f0a3\"}.icon-refresh:before{content:\"\\f078\"}.icon-remove:before{content:\"\\d7\"}.icon-remove-circle:before{content:\"\\f470\"}.icon-save-floppy:before{content:\"\\f0c8\"}.icon-screenshot:before{content:\"\\f109\"}.icon-search:before{content:\"\\f0c5\"}.icon-settingsandroid:before{content:\"\\f309\"}.icon-settingsthree-gears:before{content:\"\\f307\"}.icon-share-alt:before{content:\"\\f16c\"}.icon-trash:before{content:\"\\f0ce\"}.icon-upload:before{content:\"\\f47a\"}.icon-warning-sign:before{content:\"\\f316\"}.icon-dotlist:before{content:\"\\f4c2\"}.icon-design:before{content:\"\\f53d\"}.icon-calcplus:before{content:\"\\f571\"}.icon-calcminus:before{content:\"\\f572\"}.icon-fatredo:before{content:\"\\f692\"}.icon-circleloaderfull:before{content:\"\\f772\"}.icon-weightscale:before{content:\"\\f782\"}.icon-cloudaltsync:before{content:\"\\f7ac\"}.icon-textfield:before{content:\"\\f5d5\"}.icon-time:before{content:\"\\f210\"}.icon-calendarthree:before{content:\"\\f4d0\"}.icon-menu:before{content:\"\\f127\"}.icon-navigation:before{content:\"\\f23a\"}.icon-gpson:before{content:\"\\f21f\"}.icon-globealt:before{content:\"\\f36c\"}.icon-minus:before{content:\"\\2212\"}.icon-equals:before{content:\"\\f30c\"}.icon-globe:before{content:\"\\f01b\"}.icon-sextant:before{content:\"\\f6ec\"}.icon-cursor:before{content:\"\\f0dc\"}.icon-arrow-up:before{content:\"\\f301\"}.icon-arrow-down:before{content:\"\\f2fe\"}.icon-tabletscreensize:before{content:\"\\f675\"}.icon-moon-night:before{content:\"\\f207\"}.icon-sun-day:before{content:\"\\f206\"}.icon-timeline:before{content:\"\\f253\"}.icon-uploadalt:before{content:\"\\f11b\"}.icon-opennewwindow:before{content:\"\\f332\"}.icon-move:before{content:\"\\f322\"}.icon-filter:before{content:\"\\f05c\"}\n"], encapsulation: 2 });
HsLayoutComponent.ctorParameters = () => [
    { type: HsConfig },
    { type: HsLayoutService },
    { type: HsEventBusService },
    { type: HsThemeService },
    { type: ElementRef },
    { type: ChangeDetectorRef },
    { type: HsUtilsService },
    { type: HsPanelContainerService },
    { type: HsOverlayPanelContainerService }
];
HsLayoutComponent.propDecorators = {
    hslayout: [{ type: ViewChild, args: ['hslayout',] }],
    mapHost: [{ type: ViewChild, args: [HsMapHostDirective, { static: true },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsLayoutComponent, [{
        type: Component,
        args: [{
                selector: 'hs-layout',
                template: "<div #hslayout class=\"hs-page-wrapper hsl\" style=\"width: 100%; height: 100%;\">\n    <div class=\"hs-content-wrapper d-flex w-100 h-100\" [ngClass]=\"{'hs-open': HsLayoutService.sidebarExpanded && HsLayoutService.sidebarVisible(), 'hs-sb-right': HsConfig.sidebarPosition == 'right' && HsLayoutService.sidebarVisible(), 'hs-sb-left': HsConfig.sidebarPosition == 'left' && HsLayoutService.sidebarVisible(),'hs-sb-bottom':HsLayoutService.sidebarBottom()}\">\n        <!-- ng-if=\"HsLayoutService.componentEnabled('guiOverlay')\" -->\n        <div class=\"hs-map-space d-flex\">\n            <hs-map class=\"hs-flex-fill d-flex\"></hs-map>\n            <ng-template map-host></ng-template>\n            <hs-panel-container [service]=\"HsOverlayPanelContainerService\"></hs-panel-container>\n        </div>\n        <div class=\"hs-panelspace\" *ngIf=\"HsLayoutService.sidebarVisible()\" [ngClass]=\"{'labels': HsLayoutService.sidebarLabels, 'buttons': HsLayoutService.sidebarButtons}\" [ngStyle]=\"{width: panelSpaceWidth()+'px'}\">\n            <div class=\"hs-panelspace-wrapper mr-1\">\n                <hs-sidebar class=\"border-0\"></hs-sidebar>\n                <div class=\"hs-panelplace\">\n                    <hs-mini-sidebar *ngIf=\"HsLayoutService.minisidebar\" [hidden]=\"!panelVisible('sidebar', this)\"></hs-mini-sidebar>\n                    <hs-panel-container [service]=\"HsPanelContainerService\" class=\"hs-panelplace\" [ngStyle]=\"{width: (panelSpaceWidth()-50)+'px'}\">\n                    </hs-panel-container>\n                </div>\n            </div>\n        </div>\n        <hs-toast aria-live=\"polite\" aria-atomic=\"true\" [ngClass]=\"HsConfig.sidebarPosition == 'left' ? 'hs-sb-right' : 'hs-sb-left'\" ></hs-toast>\n        <div class=\"hs-dialog-area\"></div>\n    </div>\n    <hs-dialog-container></hs-dialog-container>\n</div>\n",
                encapsulation: ViewEncapsulation.None,
                styles: ["@charset \"UTF-8\";.ol-box{box-sizing:border-box;border-radius:2px;border:1.5px solid rgb(179,197,219);background-color:#fff6}.ol-mouse-position{top:8px;right:8px;position:absolute}.ol-scale-line{background:rgba(0,60,136,.3);border-radius:4px;bottom:8px;left:8px;padding:2px;position:absolute}.ol-scale-line-inner{border:1px solid #eee;border-top:none;color:#eee;font-size:10px;text-align:center;margin:1px;will-change:contents,width;transition:all .25s}.ol-scale-bar{position:absolute;bottom:8px;left:8px}.ol-scale-step-marker{width:1px;height:15px;background-color:#000;float:right;z-Index:10}.ol-scale-step-text{position:absolute;bottom:-5px;font-size:12px;z-Index:11;color:#000;text-shadow:-2px 0 #FFFFFF,0 2px #FFFFFF,2px 0 #FFFFFF,0 -2px #FFFFFF}.ol-scale-text{position:absolute;font-size:14px;text-align:center;bottom:25px;color:#000;text-shadow:-2px 0 #FFFFFF,0 2px #FFFFFF,2px 0 #FFFFFF,0 -2px #FFFFFF}.ol-scale-singlebar{position:relative;height:10px;z-Index:9;box-sizing:border-box;border:1px solid black}.ol-unsupported{display:none}.ol-viewport,.ol-unselectable{-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;user-select:none;-webkit-tap-highlight-color:rgba(0,0,0,0)}.ol-selectable{-webkit-touch-callout:default;-webkit-user-select:text;-moz-user-select:text;user-select:text}.ol-grabbing{cursor:-webkit-grabbing;cursor:grabbing}.ol-grab{cursor:move;cursor:-webkit-grab;cursor:grab}.ol-control{position:absolute;background-color:#fff6;border-radius:4px;padding:2px}.ol-control:hover{background-color:#fff9}.ol-zoom{top:.5em;left:.5em}.ol-rotate{top:.5em;right:.5em;transition:opacity .25s linear,visibility 0s linear}.ol-rotate.ol-hidden{opacity:0;visibility:hidden;transition:opacity .25s linear,visibility 0s linear .25s}.ol-zoom-extent{top:4.643em;left:.5em}.ol-full-screen{right:.5em;top:.5em}.ol-control button{display:block;margin:1px;padding:0;color:#fff;font-weight:bold;text-decoration:none;font-size:inherit;text-align:center;height:1.375em;width:1.375em;line-height:.4em;background-color:#003c8880;border:none;border-radius:2px}.ol-control button::-moz-focus-inner{border:none;padding:0}.ol-zoom-extent button{line-height:1.4em}.ol-compass{display:block;font-weight:normal;font-size:1.2em;will-change:transform}.ol-touch .ol-control button{font-size:1.5em}.ol-touch .ol-zoom-extent{top:5.5em}.ol-control button:hover,.ol-control button:focus{text-decoration:none;background-color:#003c88b3}.ol-zoom .ol-zoom-in{border-radius:2px 2px 0 0}.ol-zoom .ol-zoom-out{border-radius:0 0 2px 2px}.ol-attribution{text-align:right;bottom:.5em;right:.5em;max-width:calc(100% - 1.3em);display:flex;flex-flow:row-reverse;align-items:center}.ol-attribution a{color:#003c88b3;text-decoration:none}.ol-attribution ul{margin:0;padding:1px .5em;color:#000;text-shadow:0 0 2px #fff;font-size:12px}.ol-attribution li{display:inline;list-style:none}.ol-attribution li:not(:last-child):after{content:\" \"}.ol-attribution img{max-height:2em;max-width:inherit;vertical-align:middle}.ol-attribution button{flex-shrink:0}.ol-attribution.ol-collapsed ul{display:none}.ol-attribution:not(.ol-collapsed){background:rgba(255,255,255,.8)}.ol-attribution.ol-uncollapsible{bottom:0;right:0;border-radius:4px 0 0}.ol-attribution.ol-uncollapsible img{margin-top:-.2em;max-height:1.6em}.ol-attribution.ol-uncollapsible button{display:none}.ol-zoomslider{top:4.5em;left:.5em;height:200px}.ol-zoomslider button{position:relative;height:10px}.ol-touch .ol-zoomslider{top:5.5em}.ol-overviewmap{left:.5em;bottom:.5em}.ol-overviewmap.ol-uncollapsible{bottom:0;left:0;border-radius:0 4px 0 0}.ol-overviewmap .ol-overviewmap-map,.ol-overviewmap button{display:block}.ol-overviewmap .ol-overviewmap-map{border:1px solid #7b98bc;height:150px;margin:2px;width:150px}.ol-overviewmap:not(.ol-collapsed) button{bottom:2px;left:2px;position:absolute}.ol-overviewmap.ol-collapsed .ol-overviewmap-map,.ol-overviewmap.ol-uncollapsible button{display:none}.ol-overviewmap:not(.ol-collapsed){background:rgba(255,255,255,.8)}.ol-overviewmap-box{border:2px dotted rgba(0,60,136,.7)}.ol-overviewmap .ol-overviewmap-box:hover{cursor:move}.hsl,.hsl:before,.hsl:after,.hsl * .hsl *:before,.hsl *:after{all:revert}.hsl{color:var(--text-color)}.hsl :root{--blue: #007bff;--indigo: #6610f2;--purple: #6f42c1;--pink: #e83e8c;--red: #dc3545;--orange: #fd7e14;--yellow: #ffc107;--green: #28a745;--teal: #20c997;--cyan: #17a2b8;--white: var(--white);--gray: #6c757d;--gray-dark: var(--gray-800);--primary: var(--primary);--secondary: var(--secondary);--success: #28a745;--info: #17a2b8;--warning: #ffc107;--danger: #dc3545;--light: var(--light);--dark: var(--gray-800);--gray: var(--gray-900);--breakpoint-xs: 0;--breakpoint-sm: 576px;--breakpoint-md: 768px;--breakpoint-lg: 992px;--breakpoint-xl: 1200px;--font-family-sans-serif: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";--font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace}.hsl *,.hsl *:before,.hsl *:after{box-sizing:border-box}.hsl html{font-family:sans-serif;line-height:1.15;-webkit-text-size-adjust:100%;-webkit-tap-highlight-color:rgba(0,0,0,0)}.hsl article,.hsl aside,.hsl figcaption,.hsl figure,.hsl footer,.hsl header,.hsl hgroup,.hsl main,.hsl nav,.hsl section{display:block}.hsl body{margin:0;font-family:-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,\"Noto Sans\",\"Liberation Sans\",sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Noto Color Emoji\";font-size:1rem;font-weight:400;line-height:1.5;color:var(--gray-900);text-align:left;background-color:var(--white)}.hsl [tabindex=\"-1\"]:focus:not(:focus-visible){outline:0!important}.hsl hr{box-sizing:content-box;height:0;overflow:visible}.hsl h1,.hsl h2,.hsl h3,.hsl h4,.hsl h5,.hsl h6{margin-top:0;margin-bottom:.5rem}.hsl p{margin-top:0;margin-bottom:1rem}.hsl abbr[title],.hsl abbr[data-original-title]{text-decoration:underline;-webkit-text-decoration:underline dotted;text-decoration:underline dotted;cursor:help;border-bottom:0;-webkit-text-decoration-skip-ink:none;text-decoration-skip-ink:none}.hsl address{margin-bottom:1rem;font-style:normal;line-height:inherit}.hsl ol,.hsl ul,.hsl dl{margin-top:0;margin-bottom:1rem}.hsl ol ol,.hsl ul ul,.hsl ol ul,.hsl ul ol{margin-bottom:0}.hsl dt{font-weight:700}.hsl dd{margin-bottom:.5rem;margin-left:0}.hsl blockquote{margin:0 0 1rem}.hsl b,.hsl strong{font-weight:bolder}.hsl small{font-size:80%}.hsl sub,.hsl sup{position:relative;font-size:75%;line-height:0;vertical-align:baseline}.hsl sub{bottom:-.25em}.hsl sup{top:-.5em}.hsl a{color:var(--primary);text-decoration:none;background-color:transparent}.hsl a:hover{color:hsla(var(--primary-h),var(--primary-s),calc(var(--primary-l) + -15%),1);color:hsla(var(--primary-h),var(--primary-s),calc(var(--primary-l) + -15%),var(--primary-a, 1));text-decoration:underline}.hsl a:not([href]):not([class]){color:inherit;text-decoration:none}.hsl a:not([href]):not([class]):hover{color:inherit;text-decoration:none}.hsl pre,.hsl code,.hsl kbd,.hsl samp{font-family:SFMono-Regular,Menlo,Monaco,Consolas,\"Liberation Mono\",\"Courier New\",monospace;font-size:1em}.hsl pre{margin-top:0;margin-bottom:1rem;overflow:auto;-ms-overflow-style:scrollbar}.hsl figure{margin:0 0 1rem}.hsl img{vertical-align:middle;border-style:none}.hsl svg{overflow:hidden;vertical-align:middle}.hsl table{border-collapse:collapse}.hsl caption{padding-top:.75rem;padding-bottom:.75rem;color:#6c757d;text-align:left;caption-side:bottom}.hsl th{text-align:inherit;text-align:-webkit-match-parent}.hsl label{display:inline-block;margin-bottom:.5rem}.hsl button{border-radius:0}.hsl button:focus:not(:focus-visible){outline:0}.hsl input,.hsl button,.hsl select,.hsl optgroup,.hsl textarea{margin:0;font-family:inherit;font-size:inherit;line-height:inherit}.hsl button,.hsl input{overflow:visible}.hsl button,.hsl select{text-transform:none}.hsl [role=button]{cursor:pointer}.hsl select{word-wrap:normal}.hsl button,.hsl [type=button],.hsl [type=reset],.hsl [type=submit]{-webkit-appearance:button}.hsl button:not(:disabled),.hsl [type=button]:not(:disabled),.hsl [type=reset]:not(:disabled),.hsl [type=submit]:not(:disabled){cursor:pointer}.hsl button::-moz-focus-inner,.hsl [type=button]::-moz-focus-inner,.hsl [type=reset]::-moz-focus-inner,.hsl [type=submit]::-moz-focus-inner{padding:0;border-style:none}.hsl input[type=radio],.hsl input[type=checkbox]{box-sizing:border-box;padding:0}.hsl textarea{overflow:auto;resize:vertical}.hsl fieldset{min-width:0;padding:0;margin:0;border:0}.hsl legend{display:block;width:100%;max-width:100%;padding:0;margin-bottom:.5rem;font-size:1.5rem;line-height:inherit;color:inherit;white-space:normal}@media (max-width: 1200px){.hsl legend{font-size:calc(1.275rem + .3vw)}}.hsl progress{vertical-align:baseline}.hsl [type=number]::-webkit-inner-spin-button,.hsl [type=number]::-webkit-outer-spin-button{height:auto}.hsl [type=search]{outline-offset:-2px;-webkit-appearance:none}.hsl [type=search]::-webkit-search-decoration{-webkit-appearance:none}.hsl ::-webkit-file-upload-button{font:inherit;-webkit-appearance:button}.hsl output{display:inline-block}.hsl summary{display:list-item;cursor:pointer}.hsl template{display:none}.hsl [hidden]{display:none!important}.hsl h1,.hsl h2,.hsl h3,.hsl h4,.hsl h5,.hsl h6,.hsl .h1,.hsl .h2,.hsl .h3,.hsl .h4,.hsl .h5,.hsl .h6{margin-bottom:.5rem;font-weight:500;line-height:1.2}.hsl h1,.hsl .h1{font-size:2.5rem}@media (max-width: 1200px){.hsl h1,.hsl .h1{font-size:calc(1.375rem + 1.5vw)}}.hsl h2,.hsl .h2{font-size:2rem}@media (max-width: 1200px){.hsl h2,.hsl .h2{font-size:calc(1.325rem + .9vw)}}.hsl h3,.hsl .h3{font-size:1.75rem}@media (max-width: 1200px){.hsl h3,.hsl .h3{font-size:calc(1.3rem + .6vw)}}.hsl h4,.hsl .h4{font-size:1.5rem}@media (max-width: 1200px){.hsl h4,.hsl .h4{font-size:calc(1.275rem + .3vw)}}.hsl h5,.hsl .h5{font-size:1.25rem}.hsl h6,.hsl .h6{font-size:1rem}.hsl .lead{font-size:1.25rem;font-weight:300}.hsl .display-1{font-size:6rem;font-weight:300;line-height:1.2}@media (max-width: 1200px){.hsl .display-1{font-size:calc(1.725rem + 5.7vw)}}.hsl .display-2{font-size:5.5rem;font-weight:300;line-height:1.2}@media (max-width: 1200px){.hsl .display-2{font-size:calc(1.675rem + 5.1vw)}}.hsl .display-3{font-size:4.5rem;font-weight:300;line-height:1.2}@media (max-width: 1200px){.hsl .display-3{font-size:calc(1.575rem + 3.9vw)}}.hsl .display-4{font-size:3.5rem;font-weight:300;line-height:1.2}@media (max-width: 1200px){.hsl .display-4{font-size:calc(1.475rem + 2.7vw)}}.hsl hr{margin-top:1rem;margin-bottom:1rem;border:0;border-top:1px solid rgba(0,0,0,.1)}.hsl small,.hsl .small{font-size:80%;font-weight:400}.hsl mark,.hsl .mark{padding:.2em;background-color:#fcf8e3}.hsl .list-unstyled{padding-left:0;list-style:none}.hsl .list-inline{padding-left:0;list-style:none}.hsl .list-inline-item{display:inline-block}.hsl .list-inline-item:not(:last-child){margin-right:.5rem}.hsl .initialism{font-size:90%;text-transform:uppercase}.hsl .blockquote{margin-bottom:1rem;font-size:1.25rem}.hsl .blockquote-footer{display:block;font-size:80%;color:#6c757d}.hsl .blockquote-footer:before{content:\"\\2014\\a0\"}.hsl .img-fluid{max-width:100%;height:auto}.hsl .img-thumbnail{padding:.25rem;background-color:var(--white);border:1px solid #dee2e6;border-radius:.25rem;max-width:100%;height:auto}.hsl .figure{display:inline-block}.hsl .figure-img{margin-bottom:.5rem;line-height:1}.hsl .figure-caption{font-size:90%;color:#6c757d}.hsl code{font-size:87.5%;color:#e83e8c;word-wrap:break-word}a>.hsl code{color:inherit}.hsl kbd{padding:.2rem .4rem;font-size:87.5%;color:var(--white);background-color:var(--gray-900);border-radius:.2rem}.hsl kbd kbd{padding:0;font-size:100%;font-weight:700}.hsl pre{display:block;font-size:87.5%;color:var(--gray-900)}.hsl pre code{font-size:inherit;color:inherit;word-break:normal}.hsl .pre-scrollable{max-height:340px;overflow-y:scroll}.hsl .container,.hsl .container-fluid,.hsl .container-xl,.hsl .container-lg,.hsl .container-md,.hsl .container-sm{width:100%;padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto}@media (min-width: 576px){.hsl .container-sm,.hsl .container{max-width:540px}}@media (min-width: 768px){.hsl .container-md,.hsl .container-sm,.hsl .container{max-width:720px}}@media (min-width: 992px){.hsl .container-lg,.hsl .container-md,.hsl .container-sm,.hsl .container{max-width:960px}}@media (min-width: 1200px){.hsl .container-xl,.hsl .container-lg,.hsl .container-md,.hsl .container-sm,.hsl .container{max-width:1140px}}.hsl .row{display:flex;flex-wrap:wrap;margin-right:-15px;margin-left:-15px}.hsl .no-gutters{margin-right:0;margin-left:0}.hsl .no-gutters>.col,.hsl .no-gutters>[class*=col-]{padding-right:0;padding-left:0}.hsl .col-xl,.hsl .col-xl-auto,.hsl .col-xl-12,.hsl .col-xl-11,.hsl .col-xl-10,.hsl .col-xl-9,.hsl .col-xl-8,.hsl .col-xl-7,.hsl .col-xl-6,.hsl .col-xl-5,.hsl .col-xl-4,.hsl .col-xl-3,.hsl .col-xl-2,.hsl .col-xl-1,.hsl .col-lg,.hsl .col-lg-auto,.hsl .col-lg-12,.hsl .col-lg-11,.hsl .col-lg-10,.hsl .col-lg-9,.hsl .col-lg-8,.hsl .col-lg-7,.hsl .col-lg-6,.hsl .col-lg-5,.hsl .col-lg-4,.hsl .col-lg-3,.hsl .col-lg-2,.hsl .col-lg-1,.hsl .col-md,.hsl .col-md-auto,.hsl .col-md-12,.hsl .col-md-11,.hsl .col-md-10,.hsl .col-md-9,.hsl .col-md-8,.hsl .col-md-7,.hsl .col-md-6,.hsl .col-md-5,.hsl .col-md-4,.hsl .col-md-3,.hsl .col-md-2,.hsl .col-md-1,.hsl .col-sm,.hsl .col-sm-auto,.hsl .col-sm-12,.hsl .col-sm-11,.hsl .col-sm-10,.hsl .col-sm-9,.hsl .col-sm-8,.hsl .col-sm-7,.hsl .col-sm-6,.hsl .col-sm-5,.hsl .col-sm-4,.hsl .col-sm-3,.hsl .col-sm-2,.hsl .col-sm-1,.hsl .col,.hsl .col-auto,.hsl .col-12,.hsl .col-11,.hsl .col-10,.hsl .col-9,.hsl .col-8,.hsl .col-7,.hsl .col-6,.hsl .col-5,.hsl .col-4,.hsl .col-3,.hsl .col-2,.hsl .col-1{position:relative;width:100%;padding-right:15px;padding-left:15px}.hsl .col{flex-basis:0;flex-grow:1;max-width:100%}.hsl .row-cols-1>*{flex:0 0 100%;max-width:100%}.hsl .row-cols-2>*{flex:0 0 50%;max-width:50%}.hsl .row-cols-3>*{flex:0 0 33.3333333333%;max-width:33.3333333333%}.hsl .row-cols-4>*{flex:0 0 25%;max-width:25%}.hsl .row-cols-5>*{flex:0 0 20%;max-width:20%}.hsl .row-cols-6>*{flex:0 0 16.6666666667%;max-width:16.6666666667%}.hsl .col-auto{flex:0 0 auto;width:auto;max-width:100%}.hsl .col-1{flex:0 0 8.3333333333%;max-width:8.3333333333%}.hsl .col-2{flex:0 0 16.6666666667%;max-width:16.6666666667%}.hsl .col-3{flex:0 0 25%;max-width:25%}.hsl .col-4{flex:0 0 33.3333333333%;max-width:33.3333333333%}.hsl .col-5{flex:0 0 41.6666666667%;max-width:41.6666666667%}.hsl .col-6{flex:0 0 50%;max-width:50%}.hsl .col-7{flex:0 0 58.3333333333%;max-width:58.3333333333%}.hsl .col-8{flex:0 0 66.6666666667%;max-width:66.6666666667%}.hsl .col-9{flex:0 0 75%;max-width:75%}.hsl .col-10{flex:0 0 83.3333333333%;max-width:83.3333333333%}.hsl .col-11{flex:0 0 91.6666666667%;max-width:91.6666666667%}.hsl .col-12{flex:0 0 100%;max-width:100%}.hsl .order-first{order:-1}.hsl .order-last{order:13}.hsl .order-0{order:0}.hsl .order-1{order:1}.hsl .order-2{order:2}.hsl .order-3{order:3}.hsl .order-4{order:4}.hsl .order-5{order:5}.hsl .order-6{order:6}.hsl .order-7{order:7}.hsl .order-8{order:8}.hsl .order-9{order:9}.hsl .order-10{order:10}.hsl .order-11{order:11}.hsl .order-12{order:12}.hsl .offset-1{margin-left:8.3333333333%}.hsl .offset-2{margin-left:16.6666666667%}.hsl .offset-3{margin-left:25%}.hsl .offset-4{margin-left:33.3333333333%}.hsl .offset-5{margin-left:41.6666666667%}.hsl .offset-6{margin-left:50%}.hsl .offset-7{margin-left:58.3333333333%}.hsl .offset-8{margin-left:66.6666666667%}.hsl .offset-9{margin-left:75%}.hsl .offset-10{margin-left:83.3333333333%}.hsl .offset-11{margin-left:91.6666666667%}@media (min-width: 576px){.hsl .col-sm{flex-basis:0;flex-grow:1;max-width:100%}.hsl .row-cols-sm-1>*{flex:0 0 100%;max-width:100%}.hsl .row-cols-sm-2>*{flex:0 0 50%;max-width:50%}.hsl .row-cols-sm-3>*{flex:0 0 33.3333333333%;max-width:33.3333333333%}.hsl .row-cols-sm-4>*{flex:0 0 25%;max-width:25%}.hsl .row-cols-sm-5>*{flex:0 0 20%;max-width:20%}.hsl .row-cols-sm-6>*{flex:0 0 16.6666666667%;max-width:16.6666666667%}.hsl .col-sm-auto{flex:0 0 auto;width:auto;max-width:100%}.hsl .col-sm-1{flex:0 0 8.3333333333%;max-width:8.3333333333%}.hsl .col-sm-2{flex:0 0 16.6666666667%;max-width:16.6666666667%}.hsl .col-sm-3{flex:0 0 25%;max-width:25%}.hsl .col-sm-4{flex:0 0 33.3333333333%;max-width:33.3333333333%}.hsl .col-sm-5{flex:0 0 41.6666666667%;max-width:41.6666666667%}.hsl .col-sm-6{flex:0 0 50%;max-width:50%}.hsl .col-sm-7{flex:0 0 58.3333333333%;max-width:58.3333333333%}.hsl .col-sm-8{flex:0 0 66.6666666667%;max-width:66.6666666667%}.hsl .col-sm-9{flex:0 0 75%;max-width:75%}.hsl .col-sm-10{flex:0 0 83.3333333333%;max-width:83.3333333333%}.hsl .col-sm-11{flex:0 0 91.6666666667%;max-width:91.6666666667%}.hsl .col-sm-12{flex:0 0 100%;max-width:100%}.hsl .order-sm-first{order:-1}.hsl .order-sm-last{order:13}.hsl .order-sm-0{order:0}.hsl .order-sm-1{order:1}.hsl .order-sm-2{order:2}.hsl .order-sm-3{order:3}.hsl .order-sm-4{order:4}.hsl .order-sm-5{order:5}.hsl .order-sm-6{order:6}.hsl .order-sm-7{order:7}.hsl .order-sm-8{order:8}.hsl .order-sm-9{order:9}.hsl .order-sm-10{order:10}.hsl .order-sm-11{order:11}.hsl .order-sm-12{order:12}.hsl .offset-sm-0{margin-left:0}.hsl .offset-sm-1{margin-left:8.3333333333%}.hsl .offset-sm-2{margin-left:16.6666666667%}.hsl .offset-sm-3{margin-left:25%}.hsl .offset-sm-4{margin-left:33.3333333333%}.hsl .offset-sm-5{margin-left:41.6666666667%}.hsl .offset-sm-6{margin-left:50%}.hsl .offset-sm-7{margin-left:58.3333333333%}.hsl .offset-sm-8{margin-left:66.6666666667%}.hsl .offset-sm-9{margin-left:75%}.hsl .offset-sm-10{margin-left:83.3333333333%}.hsl .offset-sm-11{margin-left:91.6666666667%}}@media (min-width: 768px){.hsl .col-md{flex-basis:0;flex-grow:1;max-width:100%}.hsl .row-cols-md-1>*{flex:0 0 100%;max-width:100%}.hsl .row-cols-md-2>*{flex:0 0 50%;max-width:50%}.hsl .row-cols-md-3>*{flex:0 0 33.3333333333%;max-width:33.3333333333%}.hsl .row-cols-md-4>*{flex:0 0 25%;max-width:25%}.hsl .row-cols-md-5>*{flex:0 0 20%;max-width:20%}.hsl .row-cols-md-6>*{flex:0 0 16.6666666667%;max-width:16.6666666667%}.hsl .col-md-auto{flex:0 0 auto;width:auto;max-width:100%}.hsl .col-md-1{flex:0 0 8.3333333333%;max-width:8.3333333333%}.hsl .col-md-2{flex:0 0 16.6666666667%;max-width:16.6666666667%}.hsl .col-md-3{flex:0 0 25%;max-width:25%}.hsl .col-md-4{flex:0 0 33.3333333333%;max-width:33.3333333333%}.hsl .col-md-5{flex:0 0 41.6666666667%;max-width:41.6666666667%}.hsl .col-md-6{flex:0 0 50%;max-width:50%}.hsl .col-md-7{flex:0 0 58.3333333333%;max-width:58.3333333333%}.hsl .col-md-8{flex:0 0 66.6666666667%;max-width:66.6666666667%}.hsl .col-md-9{flex:0 0 75%;max-width:75%}.hsl .col-md-10{flex:0 0 83.3333333333%;max-width:83.3333333333%}.hsl .col-md-11{flex:0 0 91.6666666667%;max-width:91.6666666667%}.hsl .col-md-12{flex:0 0 100%;max-width:100%}.hsl .order-md-first{order:-1}.hsl .order-md-last{order:13}.hsl .order-md-0{order:0}.hsl .order-md-1{order:1}.hsl .order-md-2{order:2}.hsl .order-md-3{order:3}.hsl .order-md-4{order:4}.hsl .order-md-5{order:5}.hsl .order-md-6{order:6}.hsl .order-md-7{order:7}.hsl .order-md-8{order:8}.hsl .order-md-9{order:9}.hsl .order-md-10{order:10}.hsl .order-md-11{order:11}.hsl .order-md-12{order:12}.hsl .offset-md-0{margin-left:0}.hsl .offset-md-1{margin-left:8.3333333333%}.hsl .offset-md-2{margin-left:16.6666666667%}.hsl .offset-md-3{margin-left:25%}.hsl .offset-md-4{margin-left:33.3333333333%}.hsl .offset-md-5{margin-left:41.6666666667%}.hsl .offset-md-6{margin-left:50%}.hsl .offset-md-7{margin-left:58.3333333333%}.hsl .offset-md-8{margin-left:66.6666666667%}.hsl .offset-md-9{margin-left:75%}.hsl .offset-md-10{margin-left:83.3333333333%}.hsl .offset-md-11{margin-left:91.6666666667%}}@media (min-width: 992px){.hsl .col-lg{flex-basis:0;flex-grow:1;max-width:100%}.hsl .row-cols-lg-1>*{flex:0 0 100%;max-width:100%}.hsl .row-cols-lg-2>*{flex:0 0 50%;max-width:50%}.hsl .row-cols-lg-3>*{flex:0 0 33.3333333333%;max-width:33.3333333333%}.hsl .row-cols-lg-4>*{flex:0 0 25%;max-width:25%}.hsl .row-cols-lg-5>*{flex:0 0 20%;max-width:20%}.hsl .row-cols-lg-6>*{flex:0 0 16.6666666667%;max-width:16.6666666667%}.hsl .col-lg-auto{flex:0 0 auto;width:auto;max-width:100%}.hsl .col-lg-1{flex:0 0 8.3333333333%;max-width:8.3333333333%}.hsl .col-lg-2{flex:0 0 16.6666666667%;max-width:16.6666666667%}.hsl .col-lg-3{flex:0 0 25%;max-width:25%}.hsl .col-lg-4{flex:0 0 33.3333333333%;max-width:33.3333333333%}.hsl .col-lg-5{flex:0 0 41.6666666667%;max-width:41.6666666667%}.hsl .col-lg-6{flex:0 0 50%;max-width:50%}.hsl .col-lg-7{flex:0 0 58.3333333333%;max-width:58.3333333333%}.hsl .col-lg-8{flex:0 0 66.6666666667%;max-width:66.6666666667%}.hsl .col-lg-9{flex:0 0 75%;max-width:75%}.hsl .col-lg-10{flex:0 0 83.3333333333%;max-width:83.3333333333%}.hsl .col-lg-11{flex:0 0 91.6666666667%;max-width:91.6666666667%}.hsl .col-lg-12{flex:0 0 100%;max-width:100%}.hsl .order-lg-first{order:-1}.hsl .order-lg-last{order:13}.hsl .order-lg-0{order:0}.hsl .order-lg-1{order:1}.hsl .order-lg-2{order:2}.hsl .order-lg-3{order:3}.hsl .order-lg-4{order:4}.hsl .order-lg-5{order:5}.hsl .order-lg-6{order:6}.hsl .order-lg-7{order:7}.hsl .order-lg-8{order:8}.hsl .order-lg-9{order:9}.hsl .order-lg-10{order:10}.hsl .order-lg-11{order:11}.hsl .order-lg-12{order:12}.hsl .offset-lg-0{margin-left:0}.hsl .offset-lg-1{margin-left:8.3333333333%}.hsl .offset-lg-2{margin-left:16.6666666667%}.hsl .offset-lg-3{margin-left:25%}.hsl .offset-lg-4{margin-left:33.3333333333%}.hsl .offset-lg-5{margin-left:41.6666666667%}.hsl .offset-lg-6{margin-left:50%}.hsl .offset-lg-7{margin-left:58.3333333333%}.hsl .offset-lg-8{margin-left:66.6666666667%}.hsl .offset-lg-9{margin-left:75%}.hsl .offset-lg-10{margin-left:83.3333333333%}.hsl .offset-lg-11{margin-left:91.6666666667%}}@media (min-width: 1200px){.hsl .col-xl{flex-basis:0;flex-grow:1;max-width:100%}.hsl .row-cols-xl-1>*{flex:0 0 100%;max-width:100%}.hsl .row-cols-xl-2>*{flex:0 0 50%;max-width:50%}.hsl .row-cols-xl-3>*{flex:0 0 33.3333333333%;max-width:33.3333333333%}.hsl .row-cols-xl-4>*{flex:0 0 25%;max-width:25%}.hsl .row-cols-xl-5>*{flex:0 0 20%;max-width:20%}.hsl .row-cols-xl-6>*{flex:0 0 16.6666666667%;max-width:16.6666666667%}.hsl .col-xl-auto{flex:0 0 auto;width:auto;max-width:100%}.hsl .col-xl-1{flex:0 0 8.3333333333%;max-width:8.3333333333%}.hsl .col-xl-2{flex:0 0 16.6666666667%;max-width:16.6666666667%}.hsl .col-xl-3{flex:0 0 25%;max-width:25%}.hsl .col-xl-4{flex:0 0 33.3333333333%;max-width:33.3333333333%}.hsl .col-xl-5{flex:0 0 41.6666666667%;max-width:41.6666666667%}.hsl .col-xl-6{flex:0 0 50%;max-width:50%}.hsl .col-xl-7{flex:0 0 58.3333333333%;max-width:58.3333333333%}.hsl .col-xl-8{flex:0 0 66.6666666667%;max-width:66.6666666667%}.hsl .col-xl-9{flex:0 0 75%;max-width:75%}.hsl .col-xl-10{flex:0 0 83.3333333333%;max-width:83.3333333333%}.hsl .col-xl-11{flex:0 0 91.6666666667%;max-width:91.6666666667%}.hsl .col-xl-12{flex:0 0 100%;max-width:100%}.hsl .order-xl-first{order:-1}.hsl .order-xl-last{order:13}.hsl .order-xl-0{order:0}.hsl .order-xl-1{order:1}.hsl .order-xl-2{order:2}.hsl .order-xl-3{order:3}.hsl .order-xl-4{order:4}.hsl .order-xl-5{order:5}.hsl .order-xl-6{order:6}.hsl .order-xl-7{order:7}.hsl .order-xl-8{order:8}.hsl .order-xl-9{order:9}.hsl .order-xl-10{order:10}.hsl .order-xl-11{order:11}.hsl .order-xl-12{order:12}.hsl .offset-xl-0{margin-left:0}.hsl .offset-xl-1{margin-left:8.3333333333%}.hsl .offset-xl-2{margin-left:16.6666666667%}.hsl .offset-xl-3{margin-left:25%}.hsl .offset-xl-4{margin-left:33.3333333333%}.hsl .offset-xl-5{margin-left:41.6666666667%}.hsl .offset-xl-6{margin-left:50%}.hsl .offset-xl-7{margin-left:58.3333333333%}.hsl .offset-xl-8{margin-left:66.6666666667%}.hsl .offset-xl-9{margin-left:75%}.hsl .offset-xl-10{margin-left:83.3333333333%}.hsl .offset-xl-11{margin-left:91.6666666667%}}.hsl .table{width:100%;margin-bottom:1rem;color:var(--gray-900)}.hsl .table th,.hsl .table td{padding:.75rem;vertical-align:top;border-top:1px solid #dee2e6}.hsl .table thead th{vertical-align:bottom;border-bottom:2px solid #dee2e6}.hsl .table tbody+tbody{border-top:2px solid #dee2e6}.hsl .table-sm th,.hsl .table-sm td{padding:.3rem}.hsl .table-bordered{border:1px solid #dee2e6}.hsl .table-bordered th,.hsl .table-bordered td{border:1px solid #dee2e6}.hsl .table-bordered thead th,.hsl .table-bordered thead td{border-bottom-width:2px}.hsl .table-borderless th,.hsl .table-borderless td,.hsl .table-borderless thead th,.hsl .table-borderless tbody+tbody{border:0}.hsl .table-striped tbody tr:nth-of-type(odd){background-color:#0000000d}.hsl .table-hover tbody tr:hover{color:var(--gray-900);background-color:#00000013}.hsl .table-primary,.hsl .table-primary>th,.hsl .table-primary>td{background-color:hsla(calc(var(--primary-h)),calc(var(--primary-s)),calc((var(--white-l) + var(--primary-l)) / 2),calc((1 + 1) / 2));background-color:hsla(calc(var(--primary-h)),calc(var(--primary-s)),calc((var(--white-l) + var(--primary-l)) / 2),calc((var(--white-a, 1) + var(--primary-a, 1)) / 2))}.hsl .table-primary th,.hsl .table-primary td,.hsl .table-primary thead th,.hsl .table-primary tbody+tbody{border-color:hsla(calc(var(--primary-h)),calc(var(--primary-s)),calc((var(--white-l) + var(--primary-l)) / 2),calc((1 + 1) / 2));border-color:hsla(calc(var(--primary-h)),calc(var(--primary-s)),calc((var(--white-l) + var(--primary-l)) / 2),calc((var(--white-a, 1) + var(--primary-a, 1)) / 2))}.hsl .table-hover .table-primary:hover{background-color:hsla(calc(var(--primary-h)),calc(var(--primary-s)),calc(calc((var(--white-l) + var(--primary-l)) / 2) + -5%),calc((1 + 1) / 2));background-color:hsla(calc(var(--primary-h)),calc(var(--primary-s)),calc(calc((var(--white-l) + var(--primary-l)) / 2) + -5%),calc((var(--white-a, 1) + var(--primary-a, 1)) / 2))}.hsl .table-hover .table-primary:hover>td,.hsl .table-hover .table-primary:hover>th{background-color:hsla(calc(var(--primary-h)),calc(var(--primary-s)),calc(calc((var(--white-l) + var(--primary-l)) / 2) + -5%),calc((1 + 1) / 2));background-color:hsla(calc(var(--primary-h)),calc(var(--primary-s)),calc(calc((var(--white-l) + var(--primary-l)) / 2) + -5%),calc((var(--white-a, 1) + var(--primary-a, 1)) / 2))}.hsl .table-secondary,.hsl .table-secondary>th,.hsl .table-secondary>td{background-color:hsla(calc(var(--secondary-h)),calc(var(--secondary-s)),calc((var(--white-l) + var(--secondary-l)) / 2),calc((1 + 1) / 2));background-color:hsla(calc(var(--secondary-h)),calc(var(--secondary-s)),calc((var(--white-l) + var(--secondary-l)) / 2),calc((var(--white-a, 1) + var(--secondary-a, 1)) / 2))}.hsl .table-secondary th,.hsl .table-secondary td,.hsl .table-secondary thead th,.hsl .table-secondary tbody+tbody{border-color:hsla(calc(var(--secondary-h)),calc(var(--secondary-s)),calc((var(--white-l) + var(--secondary-l)) / 2),calc((1 + 1) / 2));border-color:hsla(calc(var(--secondary-h)),calc(var(--secondary-s)),calc((var(--white-l) + var(--secondary-l)) / 2),calc((var(--white-a, 1) + var(--secondary-a, 1)) / 2))}.hsl .table-hover .table-secondary:hover{background-color:hsla(calc(var(--secondary-h)),calc(var(--secondary-s)),calc(calc((var(--white-l) + var(--secondary-l)) / 2) + -5%),calc((1 + 1) / 2));background-color:hsla(calc(var(--secondary-h)),calc(var(--secondary-s)),calc(calc((var(--white-l) + var(--secondary-l)) / 2) + -5%),calc((var(--white-a, 1) + var(--secondary-a, 1)) / 2))}.hsl .table-hover .table-secondary:hover>td,.hsl .table-hover .table-secondary:hover>th{background-color:hsla(calc(var(--secondary-h)),calc(var(--secondary-s)),calc(calc((var(--white-l) + var(--secondary-l)) / 2) + -5%),calc((1 + 1) / 2));background-color:hsla(calc(var(--secondary-h)),calc(var(--secondary-s)),calc(calc((var(--white-l) + var(--secondary-l)) / 2) + -5%),calc((var(--white-a, 1) + var(--secondary-a, 1)) / 2))}.hsl .table-success,.hsl .table-success>th,.hsl .table-success>td{background-color:hsla(calc(133.7007874016deg),calc(61.3526570048%),calc((var(--white-l) + 40.5882352941%) / 2),calc((1 + 1) / 2));background-color:hsla(calc(133.7007874016deg),calc(61.3526570048%),calc((var(--white-l) + 40.5882352941%) / 2),calc((var(--white-a, 1) + 1) / 2))}.hsl .table-success th,.hsl .table-success td,.hsl .table-success thead th,.hsl .table-success tbody+tbody{border-color:hsla(calc(133.7007874016deg),calc(61.3526570048%),calc((var(--white-l) + 40.5882352941%) / 2),calc((1 + 1) / 2));border-color:hsla(calc(133.7007874016deg),calc(61.3526570048%),calc((var(--white-l) + 40.5882352941%) / 2),calc((var(--white-a, 1) + 1) / 2))}.hsl .table-hover .table-success:hover{background-color:hsla(calc(133.7007874016deg),calc(61.3526570048%),calc(calc((var(--white-l) + 40.5882352941%) / 2) + -5%),calc((1 + 1) / 2));background-color:hsla(calc(133.7007874016deg),calc(61.3526570048%),calc(calc((var(--white-l) + 40.5882352941%) / 2) + -5%),calc((var(--white-a, 1) + 1) / 2))}.hsl .table-hover .table-success:hover>td,.hsl .table-hover .table-success:hover>th{background-color:hsla(calc(133.7007874016deg),calc(61.3526570048%),calc(calc((var(--white-l) + 40.5882352941%) / 2) + -5%),calc((1 + 1) / 2));background-color:hsla(calc(133.7007874016deg),calc(61.3526570048%),calc(calc((var(--white-l) + 40.5882352941%) / 2) + -5%),calc((var(--white-a, 1) + 1) / 2))}.hsl .table-info,.hsl .table-info>th,.hsl .table-info>td{background-color:hsla(calc(188.198757764deg),calc(77.7777777778%),calc((var(--white-l) + 40.5882352941%) / 2),calc((1 + 1) / 2));background-color:hsla(calc(188.198757764deg),calc(77.7777777778%),calc((var(--white-l) + 40.5882352941%) / 2),calc((var(--white-a, 1) + 1) / 2))}.hsl .table-info th,.hsl .table-info td,.hsl .table-info thead th,.hsl .table-info tbody+tbody{border-color:hsla(calc(188.198757764deg),calc(77.7777777778%),calc((var(--white-l) + 40.5882352941%) / 2),calc((1 + 1) / 2));border-color:hsla(calc(188.198757764deg),calc(77.7777777778%),calc((var(--white-l) + 40.5882352941%) / 2),calc((var(--white-a, 1) + 1) / 2))}.hsl .table-hover .table-info:hover{background-color:hsla(calc(188.198757764deg),calc(77.7777777778%),calc(calc((var(--white-l) + 40.5882352941%) / 2) + -5%),calc((1 + 1) / 2));background-color:hsla(calc(188.198757764deg),calc(77.7777777778%),calc(calc((var(--white-l) + 40.5882352941%) / 2) + -5%),calc((var(--white-a, 1) + 1) / 2))}.hsl .table-hover .table-info:hover>td,.hsl .table-hover .table-info:hover>th{background-color:hsla(calc(188.198757764deg),calc(77.7777777778%),calc(calc((var(--white-l) + 40.5882352941%) / 2) + -5%),calc((1 + 1) / 2));background-color:hsla(calc(188.198757764deg),calc(77.7777777778%),calc(calc((var(--white-l) + 40.5882352941%) / 2) + -5%),calc((var(--white-a, 1) + 1) / 2))}.hsl .table-warning,.hsl .table-warning>th,.hsl .table-warning>td{background-color:hsla(calc(45deg),calc(100%),calc((var(--white-l) + 51.3725490196%) / 2),calc((1 + 1) / 2));background-color:hsla(calc(45deg),calc(100%),calc((var(--white-l) + 51.3725490196%) / 2),calc((var(--white-a, 1) + 1) / 2))}.hsl .table-warning th,.hsl .table-warning td,.hsl .table-warning thead th,.hsl .table-warning tbody+tbody{border-color:hsla(calc(45deg),calc(100%),calc((var(--white-l) + 51.3725490196%) / 2),calc((1 + 1) / 2));border-color:hsla(calc(45deg),calc(100%),calc((var(--white-l) + 51.3725490196%) / 2),calc((var(--white-a, 1) + 1) / 2))}.hsl .table-hover .table-warning:hover{background-color:hsla(calc(45deg),calc(100%),calc(calc((var(--white-l) + 51.3725490196%) / 2) + -5%),calc((1 + 1) / 2));background-color:hsla(calc(45deg),calc(100%),calc(calc((var(--white-l) + 51.3725490196%) / 2) + -5%),calc((var(--white-a, 1) + 1) / 2))}.hsl .table-hover .table-warning:hover>td,.hsl .table-hover .table-warning:hover>th{background-color:hsla(calc(45deg),calc(100%),calc(calc((var(--white-l) + 51.3725490196%) / 2) + -5%),calc((1 + 1) / 2));background-color:hsla(calc(45deg),calc(100%),calc(calc((var(--white-l) + 51.3725490196%) / 2) + -5%),calc((var(--white-a, 1) + 1) / 2))}.hsl .table-danger,.hsl .table-danger>th,.hsl .table-danger>td{background-color:hsla(calc(354.251497006deg),calc(70.4641350211%),calc((var(--white-l) + 53.5294117647%) / 2),calc((1 + 1) / 2));background-color:hsla(calc(354.251497006deg),calc(70.4641350211%),calc((var(--white-l) + 53.5294117647%) / 2),calc((var(--white-a, 1) + 1) / 2))}.hsl .table-danger th,.hsl .table-danger td,.hsl .table-danger thead th,.hsl .table-danger tbody+tbody{border-color:hsla(calc(354.251497006deg),calc(70.4641350211%),calc((var(--white-l) + 53.5294117647%) / 2),calc((1 + 1) / 2));border-color:hsla(calc(354.251497006deg),calc(70.4641350211%),calc((var(--white-l) + 53.5294117647%) / 2),calc((var(--white-a, 1) + 1) / 2))}.hsl .table-hover .table-danger:hover{background-color:hsla(calc(354.251497006deg),calc(70.4641350211%),calc(calc((var(--white-l) + 53.5294117647%) / 2) + -5%),calc((1 + 1) / 2));background-color:hsla(calc(354.251497006deg),calc(70.4641350211%),calc(calc((var(--white-l) + 53.5294117647%) / 2) + -5%),calc((var(--white-a, 1) + 1) / 2))}.hsl .table-hover .table-danger:hover>td,.hsl .table-hover .table-danger:hover>th{background-color:hsla(calc(354.251497006deg),calc(70.4641350211%),calc(calc((var(--white-l) + 53.5294117647%) / 2) + -5%),calc((1 + 1) / 2));background-color:hsla(calc(354.251497006deg),calc(70.4641350211%),calc(calc((var(--white-l) + 53.5294117647%) / 2) + -5%),calc((var(--white-a, 1) + 1) / 2))}.hsl .table-light,.hsl .table-light>th,.hsl .table-light>td{background-color:hsla(calc(var(--light-h)),calc(var(--light-s)),calc((var(--white-l) + var(--light-l)) / 2),calc((1 + 1) / 2));background-color:hsla(calc(var(--light-h)),calc(var(--light-s)),calc((var(--white-l) + var(--light-l)) / 2),calc((var(--white-a, 1) + var(--light-a, 1)) / 2))}.hsl .table-light th,.hsl .table-light td,.hsl .table-light thead th,.hsl .table-light tbody+tbody{border-color:hsla(calc(var(--light-h)),calc(var(--light-s)),calc((var(--white-l) + var(--light-l)) / 2),calc((1 + 1) / 2));border-color:hsla(calc(var(--light-h)),calc(var(--light-s)),calc((var(--white-l) + var(--light-l)) / 2),calc((var(--white-a, 1) + var(--light-a, 1)) / 2))}.hsl .table-hover .table-light:hover{background-color:hsla(calc(var(--light-h)),calc(var(--light-s)),calc(calc((var(--white-l) + var(--light-l)) / 2) + -5%),calc((1 + 1) / 2));background-color:hsla(calc(var(--light-h)),calc(var(--light-s)),calc(calc((var(--white-l) + var(--light-l)) / 2) + -5%),calc((var(--white-a, 1) + var(--light-a, 1)) / 2))}.hsl .table-hover .table-light:hover>td,.hsl .table-hover .table-light:hover>th{background-color:hsla(calc(var(--light-h)),calc(var(--light-s)),calc(calc((var(--white-l) + var(--light-l)) / 2) + -5%),calc((1 + 1) / 2));background-color:hsla(calc(var(--light-h)),calc(var(--light-s)),calc(calc((var(--white-l) + var(--light-l)) / 2) + -5%),calc((var(--white-a, 1) + var(--light-a, 1)) / 2))}.hsl .table-dark,.hsl .table-dark>th,.hsl .table-dark>td{background-color:hsla(calc(var(--gray-800-h)),calc(var(--gray-800-s)),calc((var(--white-l) + var(--gray-800-l)) / 2),calc((1 + 1) / 2));background-color:hsla(calc(var(--gray-800-h)),calc(var(--gray-800-s)),calc((var(--white-l) + var(--gray-800-l)) / 2),calc((var(--white-a, 1) + var(--gray-800-a, 1)) / 2))}.hsl .table-dark th,.hsl .table-dark td,.hsl .table-dark thead th,.hsl .table-dark tbody+tbody{border-color:hsla(calc(var(--gray-800-h)),calc(var(--gray-800-s)),calc((var(--white-l) + var(--gray-800-l)) / 2),calc((1 + 1) / 2));border-color:hsla(calc(var(--gray-800-h)),calc(var(--gray-800-s)),calc((var(--white-l) + var(--gray-800-l)) / 2),calc((var(--white-a, 1) + var(--gray-800-a, 1)) / 2))}.hsl .table-hover .table-dark:hover{background-color:hsla(calc(var(--gray-800-h)),calc(var(--gray-800-s)),calc(calc((var(--white-l) + var(--gray-800-l)) / 2) + -5%),calc((1 + 1) / 2));background-color:hsla(calc(var(--gray-800-h)),calc(var(--gray-800-s)),calc(calc((var(--white-l) + var(--gray-800-l)) / 2) + -5%),calc((var(--white-a, 1) + var(--gray-800-a, 1)) / 2))}.hsl .table-hover .table-dark:hover>td,.hsl .table-hover .table-dark:hover>th{background-color:hsla(calc(var(--gray-800-h)),calc(var(--gray-800-s)),calc(calc((var(--white-l) + var(--gray-800-l)) / 2) + -5%),calc((1 + 1) / 2));background-color:hsla(calc(var(--gray-800-h)),calc(var(--gray-800-s)),calc(calc((var(--white-l) + var(--gray-800-l)) / 2) + -5%),calc((var(--white-a, 1) + var(--gray-800-a, 1)) / 2))}.hsl .table-gray,.hsl .table-gray>th,.hsl .table-gray>td{background-color:hsla(calc(var(--gray-900-h)),calc(var(--gray-900-s)),calc((var(--white-l) + var(--gray-900-l)) / 2),calc((1 + 1) / 2));background-color:hsla(calc(var(--gray-900-h)),calc(var(--gray-900-s)),calc((var(--white-l) + var(--gray-900-l)) / 2),calc((var(--white-a, 1) + var(--gray-900-a, 1)) / 2))}.hsl .table-gray th,.hsl .table-gray td,.hsl .table-gray thead th,.hsl .table-gray tbody+tbody{border-color:hsla(calc(var(--gray-900-h)),calc(var(--gray-900-s)),calc((var(--white-l) + var(--gray-900-l)) / 2),calc((1 + 1) / 2));border-color:hsla(calc(var(--gray-900-h)),calc(var(--gray-900-s)),calc((var(--white-l) + var(--gray-900-l)) / 2),calc((var(--white-a, 1) + var(--gray-900-a, 1)) / 2))}.hsl .table-hover .table-gray:hover{background-color:hsla(calc(var(--gray-900-h)),calc(var(--gray-900-s)),calc(calc((var(--white-l) + var(--gray-900-l)) / 2) + -5%),calc((1 + 1) / 2));background-color:hsla(calc(var(--gray-900-h)),calc(var(--gray-900-s)),calc(calc((var(--white-l) + var(--gray-900-l)) / 2) + -5%),calc((var(--white-a, 1) + var(--gray-900-a, 1)) / 2))}.hsl .table-hover .table-gray:hover>td,.hsl .table-hover .table-gray:hover>th{background-color:hsla(calc(var(--gray-900-h)),calc(var(--gray-900-s)),calc(calc((var(--white-l) + var(--gray-900-l)) / 2) + -5%),calc((1 + 1) / 2));background-color:hsla(calc(var(--gray-900-h)),calc(var(--gray-900-s)),calc(calc((var(--white-l) + var(--gray-900-l)) / 2) + -5%),calc((var(--white-a, 1) + var(--gray-900-a, 1)) / 2))}.hsl .table-active,.hsl .table-active>th,.hsl .table-active>td{background-color:#00000013}.hsl .table-hover .table-active:hover{background-color:#00000013}.hsl .table-hover .table-active:hover>td,.hsl .table-hover .table-active:hover>th{background-color:#00000013}.hsl .table .thead-dark th{color:var(--white);background-color:var(--gray-800);border-color:hsla(var(--gray-800-h),var(--gray-800-s),calc(var(--gray-800-l) + 7.5%),1);border-color:hsla(var(--gray-800-h),var(--gray-800-s),calc(var(--gray-800-l) + 7.5%),var(--gray-800-a, 1))}.hsl .table .thead-light th{color:var(--text-color);background-color:var(--gray-200);border-color:#dee2e6}.hsl .table-dark{color:var(--white);background-color:var(--gray-800)}.hsl .table-dark th,.hsl .table-dark td,.hsl .table-dark thead th{border-color:hsla(var(--gray-800-h),var(--gray-800-s),calc(var(--gray-800-l) + 7.5%),1);border-color:hsla(var(--gray-800-h),var(--gray-800-s),calc(var(--gray-800-l) + 7.5%),var(--gray-800-a, 1))}.hsl .table-dark.table-bordered{border:0}.hsl .table-dark.table-striped tbody tr:nth-of-type(odd){background-color:hsla(var(--white-h),var(--white-s),var(--white-l),.05)}.hsl .table-dark.table-hover tbody tr:hover{color:var(--white);background-color:hsla(var(--white-h),var(--white-s),var(--white-l),.075)}@media (max-width: 575.98px){.hsl .table-responsive-sm{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch}.hsl .table-responsive-sm>.table-bordered{border:0}}@media (max-width: 767.98px){.hsl .table-responsive-md{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch}.hsl .table-responsive-md>.table-bordered{border:0}}@media (max-width: 991.98px){.hsl .table-responsive-lg{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch}.hsl .table-responsive-lg>.table-bordered{border:0}}@media (max-width: 1199.98px){.hsl .table-responsive-xl{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch}.hsl .table-responsive-xl>.table-bordered{border:0}}.hsl .table-responsive{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch}.hsl .table-responsive>.table-bordered{border:0}.hsl .form-control{display:block;width:100%;height:calc(1.5em + .75rem + 2px);padding:.375rem .75rem;font-size:1rem;font-weight:400;line-height:1.5;color:var(--text-color);background-color:var(--white);background-clip:padding-box;border:1px solid #ced4da;border-radius:.25rem;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion: reduce){.hsl .form-control{transition:none}}.hsl .form-control::-ms-expand{background-color:transparent;border:0}.hsl .form-control:-moz-focusring{color:transparent;text-shadow:0 0 0 var(--text-color)}.hsl .form-control:focus{color:var(--text-color);background-color:var(--white);border-color:hsla(var(--primary-h),var(--primary-s),calc(var(--primary-l) + 25%),1);border-color:hsla(var(--primary-h),var(--primary-s),calc(var(--primary-l) + 25%),var(--primary-a, 1));outline:0;box-shadow:0 0 0 .2rem hsla(var(--primary-h),var(--primary-s),var(--primary-l),.25)}.hsl .form-control::-moz-placeholder{color:#6c757d;opacity:1}.hsl .form-control::placeholder{color:#6c757d;opacity:1}.hsl .form-control:disabled,.hsl .form-control[readonly]{background-color:var(--gray-200);opacity:1}.hsl input[type=date].form-control,.hsl input[type=time].form-control,.hsl input[type=datetime-local].form-control,.hsl input[type=month].form-control{-webkit-appearance:none;-moz-appearance:none;appearance:none}.hsl select.form-control:focus::-ms-value{color:var(--text-color);background-color:var(--white)}.hsl .form-control-file,.hsl .form-control-range{display:block;width:100%}.hsl .col-form-label{padding-top:calc(.375rem + 1px);padding-bottom:calc(.375rem + 1px);margin-bottom:0;font-size:inherit;line-height:1.5}.hsl .col-form-label-lg{padding-top:calc(.5rem + 1px);padding-bottom:calc(.5rem + 1px);font-size:1.25rem;line-height:1.5}.hsl .col-form-label-sm{padding-top:calc(.25rem + 1px);padding-bottom:calc(.25rem + 1px);font-size:.875rem;line-height:1.5}.hsl .form-control-plaintext{display:block;width:100%;padding:.375rem 0;margin-bottom:0;font-size:1rem;line-height:1.5;color:var(--gray-900);background-color:transparent;border:solid transparent;border-width:1px 0}.hsl .form-control-plaintext.form-control-sm,.hsl .form-control-plaintext.form-control-lg{padding-right:0;padding-left:0}.hsl .form-control-sm{height:calc(1.5em + .5rem + 2px);padding:.25rem .5rem;font-size:.875rem;line-height:1.5;border-radius:.2rem}.hsl .form-control-lg{height:calc(1.5em + 1rem + 2px);padding:.5rem 1rem;font-size:1.25rem;line-height:1.5;border-radius:.3rem}.hsl select.form-control[size],.hsl select.form-control[multiple]{height:auto}.hsl textarea.form-control{height:auto}.hsl .form-group{margin-bottom:1rem}.hsl .form-text{display:block;margin-top:.25rem}.hsl .form-row{display:flex;flex-wrap:wrap;margin-right:-5px;margin-left:-5px}.hsl .form-row>.col,.hsl .form-row>[class*=col-]{padding-right:5px;padding-left:5px}.hsl .form-check{position:relative;display:block;padding-left:1.25rem}.hsl .form-check-input{position:absolute;margin-top:.3rem;margin-left:-1.25rem}.hsl .form-check-input[disabled]~.form-check-label,.hsl .form-check-input:disabled~.form-check-label{color:#6c757d}.hsl .form-check-label{margin-bottom:0}.hsl .form-check-inline{display:inline-flex;align-items:center;padding-left:0;margin-right:.75rem}.hsl .form-check-inline .form-check-input{position:static;margin-top:0;margin-right:.3125rem;margin-left:0}.hsl .valid-feedback{display:none;width:100%;margin-top:.25rem;font-size:80%;color:#28a745}.hsl .valid-tooltip{position:absolute;top:100%;left:0;z-index:5;display:none;max-width:100%;padding:.25rem .5rem;margin-top:.1rem;font-size:.875rem;line-height:1.5;color:var(--white);background-color:#28a745e6;border-radius:.25rem}.form-row>.col>.hsl .valid-tooltip,.form-row>[class*=col-]>.hsl .valid-tooltip{left:5px}.was-validated .hsl:valid~.valid-feedback,.was-validated .hsl:valid~.valid-tooltip,.hsl.is-valid~.valid-feedback,.hsl.is-valid~.valid-tooltip{display:block}.was-validated .hsl .form-control:valid,.hsl .form-control.is-valid{border-color:#28a745;padding-right:calc(1.5em + .75rem);background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%2328a745' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\");background-repeat:no-repeat;background-position:right calc(.375em + .1875rem) center;background-size:calc(.75em + .375rem) calc(.75em + .375rem)}.was-validated .hsl .form-control:valid:focus,.hsl .form-control.is-valid:focus{border-color:#28a745;box-shadow:0 0 0 .2rem #28a74540}.was-validated .hsl textarea.form-control:valid,.hsl textarea.form-control.is-valid{padding-right:calc(1.5em + .75rem);background-position:top calc(.375em + .1875rem) right calc(.375em + .1875rem)}.was-validated .hsl .custom-select:valid,.hsl .custom-select.is-valid{border-color:#28a745;padding-right:calc(.75em + 2.3125rem);background:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='var%28--gray-800%29' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e\") right .75rem center/8px 10px no-repeat,var(--white) url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%2328a745' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\") center right 1.75rem/calc(.75em + .375rem) calc(.75em + .375rem) no-repeat}.was-validated .hsl .custom-select:valid:focus,.hsl .custom-select.is-valid:focus{border-color:#28a745;box-shadow:0 0 0 .2rem #28a74540}.was-validated .hsl .form-check-input:valid~.form-check-label,.hsl .form-check-input.is-valid~.form-check-label{color:#28a745}.was-validated .hsl .form-check-input:valid~.valid-feedback,.was-validated .hsl .form-check-input:valid~.valid-tooltip,.hsl .form-check-input.is-valid~.valid-feedback,.hsl .form-check-input.is-valid~.valid-tooltip{display:block}.was-validated .hsl .custom-control-input:valid~.custom-control-label,.hsl .custom-control-input.is-valid~.custom-control-label{color:#28a745}.was-validated .hsl .custom-control-input:valid~.custom-control-label:before,.hsl .custom-control-input.is-valid~.custom-control-label:before{border-color:#28a745}.was-validated .hsl .custom-control-input:valid:checked~.custom-control-label:before,.hsl .custom-control-input.is-valid:checked~.custom-control-label:before{border-color:#2ebf4f;background-color:#2ebf4f}.was-validated .hsl .custom-control-input:valid:focus~.custom-control-label:before,.hsl .custom-control-input.is-valid:focus~.custom-control-label:before{box-shadow:0 0 0 .2rem #28a74540}.was-validated .hsl .custom-control-input:valid:focus:not(:checked)~.custom-control-label:before,.hsl .custom-control-input.is-valid:focus:not(:checked)~.custom-control-label:before{border-color:#28a745}.was-validated .hsl .custom-file-input:valid~.custom-file-label,.hsl .custom-file-input.is-valid~.custom-file-label{border-color:#28a745}.was-validated .hsl .custom-file-input:valid:focus~.custom-file-label,.hsl .custom-file-input.is-valid:focus~.custom-file-label{border-color:#28a745;box-shadow:0 0 0 .2rem #28a74540}.hsl .invalid-feedback{display:none;width:100%;margin-top:.25rem;font-size:80%;color:#dc3545}.hsl .invalid-tooltip{position:absolute;top:100%;left:0;z-index:5;display:none;max-width:100%;padding:.25rem .5rem;margin-top:.1rem;font-size:.875rem;line-height:1.5;color:var(--white);background-color:#dc3545e6;border-radius:.25rem}.form-row>.col>.hsl .invalid-tooltip,.form-row>[class*=col-]>.hsl .invalid-tooltip{left:5px}.was-validated .hsl:invalid~.invalid-feedback,.was-validated .hsl:invalid~.invalid-tooltip,.hsl.is-invalid~.invalid-feedback,.hsl.is-invalid~.invalid-tooltip{display:block}.was-validated .hsl .form-control:invalid,.hsl .form-control.is-invalid{border-color:#dc3545;padding-right:calc(1.5em + .75rem);background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23dc3545' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e\");background-repeat:no-repeat;background-position:right calc(.375em + .1875rem) center;background-size:calc(.75em + .375rem) calc(.75em + .375rem)}.was-validated .hsl .form-control:invalid:focus,.hsl .form-control.is-invalid:focus{border-color:#dc3545;box-shadow:0 0 0 .2rem #dc354540}.was-validated .hsl textarea.form-control:invalid,.hsl textarea.form-control.is-invalid{padding-right:calc(1.5em + .75rem);background-position:top calc(.375em + .1875rem) right calc(.375em + .1875rem)}.was-validated .hsl .custom-select:invalid,.hsl .custom-select.is-invalid{border-color:#dc3545;padding-right:calc(.75em + 2.3125rem);background:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='var%28--gray-800%29' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e\") right .75rem center/8px 10px no-repeat,var(--white) url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23dc3545' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e\") center right 1.75rem/calc(.75em + .375rem) calc(.75em + .375rem) no-repeat}.was-validated .hsl .custom-select:invalid:focus,.hsl .custom-select.is-invalid:focus{border-color:#dc3545;box-shadow:0 0 0 .2rem #dc354540}.was-validated .hsl .form-check-input:invalid~.form-check-label,.hsl .form-check-input.is-invalid~.form-check-label{color:#dc3545}.was-validated .hsl .form-check-input:invalid~.invalid-feedback,.was-validated .hsl .form-check-input:invalid~.invalid-tooltip,.hsl .form-check-input.is-invalid~.invalid-feedback,.hsl .form-check-input.is-invalid~.invalid-tooltip{display:block}.was-validated .hsl .custom-control-input:invalid~.custom-control-label,.hsl .custom-control-input.is-invalid~.custom-control-label{color:#dc3545}.was-validated .hsl .custom-control-input:invalid~.custom-control-label:before,.hsl .custom-control-input.is-invalid~.custom-control-label:before{border-color:#dc3545}.was-validated .hsl .custom-control-input:invalid:checked~.custom-control-label:before,.hsl .custom-control-input.is-invalid:checked~.custom-control-label:before{border-color:#e04958;background-color:#e04958}.was-validated .hsl .custom-control-input:invalid:focus~.custom-control-label:before,.hsl .custom-control-input.is-invalid:focus~.custom-control-label:before{box-shadow:0 0 0 .2rem #dc354540}.was-validated .hsl .custom-control-input:invalid:focus:not(:checked)~.custom-control-label:before,.hsl .custom-control-input.is-invalid:focus:not(:checked)~.custom-control-label:before{border-color:#dc3545}.was-validated .hsl .custom-file-input:invalid~.custom-file-label,.hsl .custom-file-input.is-invalid~.custom-file-label{border-color:#dc3545}.was-validated .hsl .custom-file-input:invalid:focus~.custom-file-label,.hsl .custom-file-input.is-invalid:focus~.custom-file-label{border-color:#dc3545;box-shadow:0 0 0 .2rem #dc354540}.hsl .form-inline{display:flex;flex-flow:row wrap;align-items:center}.hsl .form-inline .form-check{width:100%}@media (min-width: 576px){.hsl .form-inline label{display:flex;align-items:center;justify-content:center;margin-bottom:0}.hsl .form-inline .form-group{display:flex;flex:0 0 auto;flex-flow:row wrap;align-items:center;margin-bottom:0}.hsl .form-inline .form-control{display:inline-block;width:auto;vertical-align:middle}.hsl .form-inline .form-control-plaintext{display:inline-block}.hsl .form-inline .input-group,.hsl .form-inline .custom-select{width:auto}.hsl .form-inline .form-check{display:flex;align-items:center;justify-content:center;width:auto;padding-left:0}.hsl .form-inline .form-check-input{position:relative;flex-shrink:0;margin-top:0;margin-right:.25rem;margin-left:0}.hsl .form-inline .custom-control{align-items:center;justify-content:center}.hsl .form-inline .custom-control-label{margin-bottom:0}}.hsl .btn{display:inline-block;font-weight:400;color:var(--gray-900);text-align:center;vertical-align:middle;-webkit-user-select:none;-moz-user-select:none;user-select:none;background-color:transparent;border:1px solid transparent;padding:.375rem .75rem;font-size:1rem;line-height:1.5;border-radius:.25rem;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion: reduce){.hsl .btn{transition:none}}.hsl .btn:hover{color:var(--gray-900);text-decoration:none}.hsl .btn:focus,.hsl .btn.focus{outline:0;box-shadow:0 0 0 .2rem hsla(var(--primary-h),var(--primary-s),var(--primary-l),.25)}.hsl .btn.disabled,.hsl .btn:disabled{opacity:.65}.hsl .btn:not(:disabled):not(.disabled){cursor:pointer}.hsl a.btn.disabled,.hsl fieldset:disabled a.btn{pointer-events:none}.hsl .btn-primary{color:hsla(0,0%,calc(-100 * calc(var(--primary-l) - 58.59375%)),1);background-color:var(--primary);border-color:var(--primary)}.hsl .btn-primary:hover{color:hsla(0,0%,calc(-100 * calc(calc(var(--primary-l) + -7.5%) - 58.59375%)),1);background-color:hsla(var(--primary-h),var(--primary-s),calc(var(--primary-l) + -7.5%),1);background-color:hsla(var(--primary-h),var(--primary-s),calc(var(--primary-l) + -7.5%),var(--primary-a, 1));border-color:hsla(var(--primary-h),var(--primary-s),calc(var(--primary-l) + -10%),1);border-color:hsla(var(--primary-h),var(--primary-s),calc(var(--primary-l) + -10%),var(--primary-a, 1))}.hsl .btn-primary:focus,.hsl .btn-primary.focus{color:hsla(0,0%,calc(-100 * calc(calc(var(--primary-l) + -7.5%) - 58.59375%)),1);background-color:hsla(var(--primary-h),var(--primary-s),calc(var(--primary-l) + -7.5%),1);background-color:hsla(var(--primary-h),var(--primary-s),calc(var(--primary-l) + -7.5%),var(--primary-a, 1));border-color:hsla(var(--primary-h),var(--primary-s),calc(var(--primary-l) + -10%),1);border-color:hsla(var(--primary-h),var(--primary-s),calc(var(--primary-l) + -10%),var(--primary-a, 1));box-shadow:0 0 0 .2rem hsla(calc(var(--primary-h)),calc(var(--primary-s)),calc((calc(-100 * calc(var(--primary-l) - 58.59375%)) + var(--primary-l)) / 2),.5)}.hsl .btn-primary.disabled,.hsl .btn-primary:disabled{color:hsla(0,0%,calc(-100 * calc(var(--primary-l) - 58.59375%)),1);background-color:var(--primary);border-color:var(--primary)}.hsl .btn-primary:not(:disabled):not(.disabled):active,.hsl .btn-primary:not(:disabled):not(.disabled).active,.show>.hsl .btn-primary.dropdown-toggle{color:hsla(0,0%,calc(-100 * calc(calc(var(--primary-l) + -10%) - 58.59375%)),1);background-color:hsla(var(--primary-h),var(--primary-s),calc(var(--primary-l) + -10%),1);background-color:hsla(var(--primary-h),var(--primary-s),calc(var(--primary-l) + -10%),var(--primary-a, 1));border-color:hsla(var(--primary-h),var(--primary-s),calc(var(--primary-l) + -12.5%),1);border-color:hsla(var(--primary-h),var(--primary-s),calc(var(--primary-l) + -12.5%),var(--primary-a, 1))}.hsl .btn-primary:not(:disabled):not(.disabled):active:focus,.hsl .btn-primary:not(:disabled):not(.disabled).active:focus,.show>.hsl .btn-primary.dropdown-toggle:focus{box-shadow:0 0 0 .2rem hsla(calc(var(--primary-h)),calc(var(--primary-s)),calc((calc(-100 * calc(var(--primary-l) - 58.59375%)) + var(--primary-l)) / 2),.5)}.hsl .btn-secondary{color:hsla(0,0%,calc(-100 * calc(var(--secondary-l) - 58.59375%)),1);background-color:var(--secondary);border-color:var(--secondary)}.hsl .btn-secondary:hover{color:hsla(0,0%,calc(-100 * calc(calc(var(--secondary-l) + -7.5%) - 58.59375%)),1);background-color:hsla(var(--secondary-h),var(--secondary-s),calc(var(--secondary-l) + -7.5%),1);background-color:hsla(var(--secondary-h),var(--secondary-s),calc(var(--secondary-l) + -7.5%),var(--secondary-a, 1));border-color:hsla(var(--secondary-h),var(--secondary-s),calc(var(--secondary-l) + -10%),1);border-color:hsla(var(--secondary-h),var(--secondary-s),calc(var(--secondary-l) + -10%),var(--secondary-a, 1))}.hsl .btn-secondary:focus,.hsl .btn-secondary.focus{color:hsla(0,0%,calc(-100 * calc(calc(var(--secondary-l) + -7.5%) - 58.59375%)),1);background-color:hsla(var(--secondary-h),var(--secondary-s),calc(var(--secondary-l) + -7.5%),1);background-color:hsla(var(--secondary-h),var(--secondary-s),calc(var(--secondary-l) + -7.5%),var(--secondary-a, 1));border-color:hsla(var(--secondary-h),var(--secondary-s),calc(var(--secondary-l) + -10%),1);border-color:hsla(var(--secondary-h),var(--secondary-s),calc(var(--secondary-l) + -10%),var(--secondary-a, 1));box-shadow:0 0 0 .2rem hsla(calc(var(--secondary-h)),calc(var(--secondary-s)),calc((calc(-100 * calc(var(--secondary-l) - 58.59375%)) + var(--secondary-l)) / 2),.5)}.hsl .btn-secondary.disabled,.hsl .btn-secondary:disabled{color:hsla(0,0%,calc(-100 * calc(var(--secondary-l) - 58.59375%)),1);background-color:var(--secondary);border-color:var(--secondary)}.hsl .btn-secondary:not(:disabled):not(.disabled):active,.hsl .btn-secondary:not(:disabled):not(.disabled).active,.show>.hsl .btn-secondary.dropdown-toggle{color:hsla(0,0%,calc(-100 * calc(calc(var(--secondary-l) + -10%) - 58.59375%)),1);background-color:hsla(var(--secondary-h),var(--secondary-s),calc(var(--secondary-l) + -10%),1);background-color:hsla(var(--secondary-h),var(--secondary-s),calc(var(--secondary-l) + -10%),var(--secondary-a, 1));border-color:hsla(var(--secondary-h),var(--secondary-s),calc(var(--secondary-l) + -12.5%),1);border-color:hsla(var(--secondary-h),var(--secondary-s),calc(var(--secondary-l) + -12.5%),var(--secondary-a, 1))}.hsl .btn-secondary:not(:disabled):not(.disabled):active:focus,.hsl .btn-secondary:not(:disabled):not(.disabled).active:focus,.show>.hsl .btn-secondary.dropdown-toggle:focus{box-shadow:0 0 0 .2rem hsla(calc(var(--secondary-h)),calc(var(--secondary-s)),calc((calc(-100 * calc(var(--secondary-l) - 58.59375%)) + var(--secondary-l)) / 2),.5)}.hsl .btn-success{color:var(--white);background-color:#28a745;border-color:#28a745}.hsl .btn-success:hover{color:var(--white);background-color:#259a40;border-color:#24963e}.hsl .btn-success:focus,.hsl .btn-success.focus{color:var(--white);background-color:#259a40;border-color:#24963e;box-shadow:0 0 0 .2rem hsla(calc(133.7007874016deg),calc(61.3526570048%),calc((var(--white-l) + 40.5882352941%) / 2),.5)}.hsl .btn-success.disabled,.hsl .btn-success:disabled{color:var(--white);background-color:#28a745;border-color:#28a745}.hsl .btn-success:not(:disabled):not(.disabled):active,.hsl .btn-success:not(:disabled):not(.disabled).active,.show>.hsl .btn-success.dropdown-toggle{color:var(--white);background-color:#24963e;border-color:#23923c}.hsl .btn-success:not(:disabled):not(.disabled):active:focus,.hsl .btn-success:not(:disabled):not(.disabled).active:focus,.show>.hsl .btn-success.dropdown-toggle:focus{box-shadow:0 0 0 .2rem hsla(calc(133.7007874016deg),calc(61.3526570048%),calc((var(--white-l) + 40.5882352941%) / 2),.5)}.hsl .btn-info{color:var(--white);background-color:#17a2b8;border-color:#17a2b8}.hsl .btn-info:hover{color:var(--white);background-color:#1596aa;border-color:#1592a6}.hsl .btn-info:focus,.hsl .btn-info.focus{color:var(--white);background-color:#1596aa;border-color:#1592a6;box-shadow:0 0 0 .2rem hsla(calc(188.198757764deg),calc(77.7777777778%),calc((var(--white-l) + 40.5882352941%) / 2),.5)}.hsl .btn-info.disabled,.hsl .btn-info:disabled{color:var(--white);background-color:#17a2b8;border-color:#17a2b8}.hsl .btn-info:not(:disabled):not(.disabled):active,.hsl .btn-info:not(:disabled):not(.disabled).active,.show>.hsl .btn-info.dropdown-toggle{color:var(--white);background-color:#1592a6;border-color:#148ea1}.hsl .btn-info:not(:disabled):not(.disabled):active:focus,.hsl .btn-info:not(:disabled):not(.disabled).active:focus,.show>.hsl .btn-info.dropdown-toggle:focus{box-shadow:0 0 0 .2rem hsla(calc(188.198757764deg),calc(77.7777777778%),calc((var(--white-l) + 40.5882352941%) / 2),.5)}.hsl .btn-warning{color:var(--gray-900);background-color:#ffc107;border-color:#ffc107}.hsl .btn-warning:hover{color:var(--gray-900);background-color:#f2b600;border-color:#ecb100}.hsl .btn-warning:focus,.hsl .btn-warning.focus{color:var(--gray-900);background-color:#f2b600;border-color:#ecb100;box-shadow:0 0 0 .2rem hsla(calc(45deg),calc(100%),calc((var(--gray-900-l) + 51.3725490196%) / 2),.5)}.hsl .btn-warning.disabled,.hsl .btn-warning:disabled{color:var(--gray-900);background-color:#ffc107;border-color:#ffc107}.hsl .btn-warning:not(:disabled):not(.disabled):active,.hsl .btn-warning:not(:disabled):not(.disabled).active,.show>.hsl .btn-warning.dropdown-toggle{color:var(--gray-900);background-color:#ecb100;border-color:#e5ac00}.hsl .btn-warning:not(:disabled):not(.disabled):active:focus,.hsl .btn-warning:not(:disabled):not(.disabled).active:focus,.show>.hsl .btn-warning.dropdown-toggle:focus{box-shadow:0 0 0 .2rem hsla(calc(45deg),calc(100%),calc((var(--gray-900-l) + 51.3725490196%) / 2),.5)}.hsl .btn-danger{color:var(--white);background-color:#dc3545;border-color:#dc3545}.hsl .btn-danger:hover{color:var(--white);background-color:#d72536;border-color:#d12435}.hsl .btn-danger:focus,.hsl .btn-danger.focus{color:var(--white);background-color:#d72536;border-color:#d12435;box-shadow:0 0 0 .2rem hsla(calc(354.251497006deg),calc(70.4641350211%),calc((var(--white-l) + 53.5294117647%) / 2),.5)}.hsl .btn-danger.disabled,.hsl .btn-danger:disabled{color:var(--white);background-color:#dc3545;border-color:#dc3545}.hsl .btn-danger:not(:disabled):not(.disabled):active,.hsl .btn-danger:not(:disabled):not(.disabled).active,.show>.hsl .btn-danger.dropdown-toggle{color:var(--white);background-color:#d12435;border-color:#cc2333}.hsl .btn-danger:not(:disabled):not(.disabled):active:focus,.hsl .btn-danger:not(:disabled):not(.disabled).active:focus,.show>.hsl .btn-danger.dropdown-toggle:focus{box-shadow:0 0 0 .2rem hsla(calc(354.251497006deg),calc(70.4641350211%),calc((var(--white-l) + 53.5294117647%) / 2),.5)}.hsl .btn-light{color:hsla(0,0%,calc(-100 * calc(var(--light-l) - 58.59375%)),1);background-color:var(--light);border-color:var(--light)}.hsl .btn-light:hover{color:hsla(0,0%,calc(-100 * calc(calc(var(--light-l) + -7.5%) - 58.59375%)),1);background-color:hsla(var(--light-h),var(--light-s),calc(var(--light-l) + -7.5%),1);background-color:hsla(var(--light-h),var(--light-s),calc(var(--light-l) + -7.5%),var(--light-a, 1));border-color:hsla(var(--light-h),var(--light-s),calc(var(--light-l) + -10%),1);border-color:hsla(var(--light-h),var(--light-s),calc(var(--light-l) + -10%),var(--light-a, 1))}.hsl .btn-light:focus,.hsl .btn-light.focus{color:hsla(0,0%,calc(-100 * calc(calc(var(--light-l) + -7.5%) - 58.59375%)),1);background-color:hsla(var(--light-h),var(--light-s),calc(var(--light-l) + -7.5%),1);background-color:hsla(var(--light-h),var(--light-s),calc(var(--light-l) + -7.5%),var(--light-a, 1));border-color:hsla(var(--light-h),var(--light-s),calc(var(--light-l) + -10%),1);border-color:hsla(var(--light-h),var(--light-s),calc(var(--light-l) + -10%),var(--light-a, 1));box-shadow:0 0 0 .2rem hsla(calc(var(--light-h)),calc(var(--light-s)),calc((calc(-100 * calc(var(--light-l) - 58.59375%)) + var(--light-l)) / 2),.5)}.hsl .btn-light.disabled,.hsl .btn-light:disabled{color:hsla(0,0%,calc(-100 * calc(var(--light-l) - 58.59375%)),1);background-color:var(--light);border-color:var(--light)}.hsl .btn-light:not(:disabled):not(.disabled):active,.hsl .btn-light:not(:disabled):not(.disabled).active,.show>.hsl .btn-light.dropdown-toggle{color:hsla(0,0%,calc(-100 * calc(calc(var(--light-l) + -10%) - 58.59375%)),1);background-color:hsla(var(--light-h),var(--light-s),calc(var(--light-l) + -10%),1);background-color:hsla(var(--light-h),var(--light-s),calc(var(--light-l) + -10%),var(--light-a, 1));border-color:hsla(var(--light-h),var(--light-s),calc(var(--light-l) + -12.5%),1);border-color:hsla(var(--light-h),var(--light-s),calc(var(--light-l) + -12.5%),var(--light-a, 1))}.hsl .btn-light:not(:disabled):not(.disabled):active:focus,.hsl .btn-light:not(:disabled):not(.disabled).active:focus,.show>.hsl .btn-light.dropdown-toggle:focus{box-shadow:0 0 0 .2rem hsla(calc(var(--light-h)),calc(var(--light-s)),calc((calc(-100 * calc(var(--light-l) - 58.59375%)) + var(--light-l)) / 2),.5)}.hsl .btn-dark{color:hsla(0,0%,calc(-100 * calc(var(--gray-800-l) - 58.59375%)),1);background-color:var(--gray-800);border-color:var(--gray-800)}.hsl .btn-dark:hover{color:hsla(0,0%,calc(-100 * calc(calc(var(--gray-800-l) + -7.5%) - 58.59375%)),1);background-color:hsla(var(--gray-800-h),var(--gray-800-s),calc(var(--gray-800-l) + -7.5%),1);background-color:hsla(var(--gray-800-h),var(--gray-800-s),calc(var(--gray-800-l) + -7.5%),var(--gray-800-a, 1));border-color:hsla(var(--gray-800-h),var(--gray-800-s),calc(var(--gray-800-l) + -10%),1);border-color:hsla(var(--gray-800-h),var(--gray-800-s),calc(var(--gray-800-l) + -10%),var(--gray-800-a, 1))}.hsl .btn-dark:focus,.hsl .btn-dark.focus{color:hsla(0,0%,calc(-100 * calc(calc(var(--gray-800-l) + -7.5%) - 58.59375%)),1);background-color:hsla(var(--gray-800-h),var(--gray-800-s),calc(var(--gray-800-l) + -7.5%),1);background-color:hsla(var(--gray-800-h),var(--gray-800-s),calc(var(--gray-800-l) + -7.5%),var(--gray-800-a, 1));border-color:hsla(var(--gray-800-h),var(--gray-800-s),calc(var(--gray-800-l) + -10%),1);border-color:hsla(var(--gray-800-h),var(--gray-800-s),calc(var(--gray-800-l) + -10%),var(--gray-800-a, 1));box-shadow:0 0 0 .2rem hsla(calc(var(--gray-800-h)),calc(var(--gray-800-s)),calc((calc(-100 * calc(var(--gray-800-l) - 58.59375%)) + var(--gray-800-l)) / 2),.5)}.hsl .btn-dark.disabled,.hsl .btn-dark:disabled{color:hsla(0,0%,calc(-100 * calc(var(--gray-800-l) - 58.59375%)),1);background-color:var(--gray-800);border-color:var(--gray-800)}.hsl .btn-dark:not(:disabled):not(.disabled):active,.hsl .btn-dark:not(:disabled):not(.disabled).active,.show>.hsl .btn-dark.dropdown-toggle{color:hsla(0,0%,calc(-100 * calc(calc(var(--gray-800-l) + -10%) - 58.59375%)),1);background-color:hsla(var(--gray-800-h),var(--gray-800-s),calc(var(--gray-800-l) + -10%),1);background-color:hsla(var(--gray-800-h),var(--gray-800-s),calc(var(--gray-800-l) + -10%),var(--gray-800-a, 1));border-color:hsla(var(--gray-800-h),var(--gray-800-s),calc(var(--gray-800-l) + -12.5%),1);border-color:hsla(var(--gray-800-h),var(--gray-800-s),calc(var(--gray-800-l) + -12.5%),var(--gray-800-a, 1))}.hsl .btn-dark:not(:disabled):not(.disabled):active:focus,.hsl .btn-dark:not(:disabled):not(.disabled).active:focus,.show>.hsl .btn-dark.dropdown-toggle:focus{box-shadow:0 0 0 .2rem hsla(calc(var(--gray-800-h)),calc(var(--gray-800-s)),calc((calc(-100 * calc(var(--gray-800-l) - 58.59375%)) + var(--gray-800-l)) / 2),.5)}.hsl .btn-gray{color:hsla(0,0%,calc(-100 * calc(var(--gray-900-l) - 58.59375%)),1);background-color:var(--gray-900);border-color:var(--gray-900)}.hsl .btn-gray:hover{color:hsla(0,0%,calc(-100 * calc(calc(var(--gray-900-l) + -7.5%) - 58.59375%)),1);background-color:hsla(var(--gray-900-h),var(--gray-900-s),calc(var(--gray-900-l) + -7.5%),1);background-color:hsla(var(--gray-900-h),var(--gray-900-s),calc(var(--gray-900-l) + -7.5%),var(--gray-900-a, 1));border-color:hsla(var(--gray-900-h),var(--gray-900-s),calc(var(--gray-900-l) + -10%),1);border-color:hsla(var(--gray-900-h),var(--gray-900-s),calc(var(--gray-900-l) + -10%),var(--gray-900-a, 1))}.hsl .btn-gray:focus,.hsl .btn-gray.focus{color:hsla(0,0%,calc(-100 * calc(calc(var(--gray-900-l) + -7.5%) - 58.59375%)),1);background-color:hsla(var(--gray-900-h),var(--gray-900-s),calc(var(--gray-900-l) + -7.5%),1);background-color:hsla(var(--gray-900-h),var(--gray-900-s),calc(var(--gray-900-l) + -7.5%),var(--gray-900-a, 1));border-color:hsla(var(--gray-900-h),var(--gray-900-s),calc(var(--gray-900-l) + -10%),1);border-color:hsla(var(--gray-900-h),var(--gray-900-s),calc(var(--gray-900-l) + -10%),var(--gray-900-a, 1));box-shadow:0 0 0 .2rem hsla(calc(var(--gray-900-h)),calc(var(--gray-900-s)),calc((calc(-100 * calc(var(--gray-900-l) - 58.59375%)) + var(--gray-900-l)) / 2),.5)}.hsl .btn-gray.disabled,.hsl .btn-gray:disabled{color:hsla(0,0%,calc(-100 * calc(var(--gray-900-l) - 58.59375%)),1);background-color:var(--gray-900);border-color:var(--gray-900)}.hsl .btn-gray:not(:disabled):not(.disabled):active,.hsl .btn-gray:not(:disabled):not(.disabled).active,.show>.hsl .btn-gray.dropdown-toggle{color:hsla(0,0%,calc(-100 * calc(calc(var(--gray-900-l) + -10%) - 58.59375%)),1);background-color:hsla(var(--gray-900-h),var(--gray-900-s),calc(var(--gray-900-l) + -10%),1);background-color:hsla(var(--gray-900-h),var(--gray-900-s),calc(var(--gray-900-l) + -10%),var(--gray-900-a, 1));border-color:hsla(var(--gray-900-h),var(--gray-900-s),calc(var(--gray-900-l) + -12.5%),1);border-color:hsla(var(--gray-900-h),var(--gray-900-s),calc(var(--gray-900-l) + -12.5%),var(--gray-900-a, 1))}.hsl .btn-gray:not(:disabled):not(.disabled):active:focus,.hsl .btn-gray:not(:disabled):not(.disabled).active:focus,.show>.hsl .btn-gray.dropdown-toggle:focus{box-shadow:0 0 0 .2rem hsla(calc(var(--gray-900-h)),calc(var(--gray-900-s)),calc((calc(-100 * calc(var(--gray-900-l) - 58.59375%)) + var(--gray-900-l)) / 2),.5)}.hsl .btn-outline-primary{color:var(--primary);border-color:var(--primary)}.hsl .btn-outline-primary:hover{color:hsla(0,0%,calc(-100 * calc(var(--primary-l) - 58.59375%)),1);background-color:var(--primary);border-color:var(--primary)}.hsl .btn-outline-primary:focus,.hsl .btn-outline-primary.focus{box-shadow:0 0 0 .2rem hsla(var(--primary-h),var(--primary-s),var(--primary-l),.5)}.hsl .btn-outline-primary.disabled,.hsl .btn-outline-primary:disabled{color:var(--primary);background-color:transparent}.hsl .btn-outline-primary:not(:disabled):not(.disabled):active,.hsl .btn-outline-primary:not(:disabled):not(.disabled).active,.show>.hsl .btn-outline-primary.dropdown-toggle{color:hsla(0,0%,calc(-100 * calc(var(--primary-l) - 58.59375%)),1);background-color:var(--primary);border-color:var(--primary)}.hsl .btn-outline-primary:not(:disabled):not(.disabled):active:focus,.hsl .btn-outline-primary:not(:disabled):not(.disabled).active:focus,.show>.hsl .btn-outline-primary.dropdown-toggle:focus{box-shadow:0 0 0 .2rem hsla(var(--primary-h),var(--primary-s),var(--primary-l),.5)}.hsl .btn-outline-secondary{color:var(--secondary);border-color:var(--secondary)}.hsl .btn-outline-secondary:hover{color:hsla(0,0%,calc(-100 * calc(var(--secondary-l) - 58.59375%)),1);background-color:var(--secondary);border-color:var(--secondary)}.hsl .btn-outline-secondary:focus,.hsl .btn-outline-secondary.focus{box-shadow:0 0 0 .2rem hsla(var(--secondary-h),var(--secondary-s),var(--secondary-l),.5)}.hsl .btn-outline-secondary.disabled,.hsl .btn-outline-secondary:disabled{color:var(--secondary);background-color:transparent}.hsl .btn-outline-secondary:not(:disabled):not(.disabled):active,.hsl .btn-outline-secondary:not(:disabled):not(.disabled).active,.show>.hsl .btn-outline-secondary.dropdown-toggle{color:hsla(0,0%,calc(-100 * calc(var(--secondary-l) - 58.59375%)),1);background-color:var(--secondary);border-color:var(--secondary)}.hsl .btn-outline-secondary:not(:disabled):not(.disabled):active:focus,.hsl .btn-outline-secondary:not(:disabled):not(.disabled).active:focus,.show>.hsl .btn-outline-secondary.dropdown-toggle:focus{box-shadow:0 0 0 .2rem hsla(var(--secondary-h),var(--secondary-s),var(--secondary-l),.5)}.hsl .btn-outline-success{color:#28a745;border-color:#28a745}.hsl .btn-outline-success:hover{color:var(--white);background-color:#28a745;border-color:#28a745}.hsl .btn-outline-success:focus,.hsl .btn-outline-success.focus{box-shadow:0 0 0 .2rem #28a74580}.hsl .btn-outline-success.disabled,.hsl .btn-outline-success:disabled{color:#28a745;background-color:transparent}.hsl .btn-outline-success:not(:disabled):not(.disabled):active,.hsl .btn-outline-success:not(:disabled):not(.disabled).active,.show>.hsl .btn-outline-success.dropdown-toggle{color:var(--white);background-color:#28a745;border-color:#28a745}.hsl .btn-outline-success:not(:disabled):not(.disabled):active:focus,.hsl .btn-outline-success:not(:disabled):not(.disabled).active:focus,.show>.hsl .btn-outline-success.dropdown-toggle:focus{box-shadow:0 0 0 .2rem #28a74580}.hsl .btn-outline-info{color:#17a2b8;border-color:#17a2b8}.hsl .btn-outline-info:hover{color:var(--white);background-color:#17a2b8;border-color:#17a2b8}.hsl .btn-outline-info:focus,.hsl .btn-outline-info.focus{box-shadow:0 0 0 .2rem #17a2b880}.hsl .btn-outline-info.disabled,.hsl .btn-outline-info:disabled{color:#17a2b8;background-color:transparent}.hsl .btn-outline-info:not(:disabled):not(.disabled):active,.hsl .btn-outline-info:not(:disabled):not(.disabled).active,.show>.hsl .btn-outline-info.dropdown-toggle{color:var(--white);background-color:#17a2b8;border-color:#17a2b8}.hsl .btn-outline-info:not(:disabled):not(.disabled):active:focus,.hsl .btn-outline-info:not(:disabled):not(.disabled).active:focus,.show>.hsl .btn-outline-info.dropdown-toggle:focus{box-shadow:0 0 0 .2rem #17a2b880}.hsl .btn-outline-warning{color:#ffc107;border-color:#ffc107}.hsl .btn-outline-warning:hover{color:var(--gray-900);background-color:#ffc107;border-color:#ffc107}.hsl .btn-outline-warning:focus,.hsl .btn-outline-warning.focus{box-shadow:0 0 0 .2rem #ffc10780}.hsl .btn-outline-warning.disabled,.hsl .btn-outline-warning:disabled{color:#ffc107;background-color:transparent}.hsl .btn-outline-warning:not(:disabled):not(.disabled):active,.hsl .btn-outline-warning:not(:disabled):not(.disabled).active,.show>.hsl .btn-outline-warning.dropdown-toggle{color:var(--gray-900);background-color:#ffc107;border-color:#ffc107}.hsl .btn-outline-warning:not(:disabled):not(.disabled):active:focus,.hsl .btn-outline-warning:not(:disabled):not(.disabled).active:focus,.show>.hsl .btn-outline-warning.dropdown-toggle:focus{box-shadow:0 0 0 .2rem #ffc10780}.hsl .btn-outline-danger{color:#dc3545;border-color:#dc3545}.hsl .btn-outline-danger:hover{color:var(--white);background-color:#dc3545;border-color:#dc3545}.hsl .btn-outline-danger:focus,.hsl .btn-outline-danger.focus{box-shadow:0 0 0 .2rem #dc354580}.hsl .btn-outline-danger.disabled,.hsl .btn-outline-danger:disabled{color:#dc3545;background-color:transparent}.hsl .btn-outline-danger:not(:disabled):not(.disabled):active,.hsl .btn-outline-danger:not(:disabled):not(.disabled).active,.show>.hsl .btn-outline-danger.dropdown-toggle{color:var(--white);background-color:#dc3545;border-color:#dc3545}.hsl .btn-outline-danger:not(:disabled):not(.disabled):active:focus,.hsl .btn-outline-danger:not(:disabled):not(.disabled).active:focus,.show>.hsl .btn-outline-danger.dropdown-toggle:focus{box-shadow:0 0 0 .2rem #dc354580}.hsl .btn-outline-light{color:var(--light);border-color:var(--light)}.hsl .btn-outline-light:hover{color:hsla(0,0%,calc(-100 * calc(var(--light-l) - 58.59375%)),1);background-color:var(--light);border-color:var(--light)}.hsl .btn-outline-light:focus,.hsl .btn-outline-light.focus{box-shadow:0 0 0 .2rem hsla(var(--light-h),var(--light-s),var(--light-l),.5)}.hsl .btn-outline-light.disabled,.hsl .btn-outline-light:disabled{color:var(--light);background-color:transparent}.hsl .btn-outline-light:not(:disabled):not(.disabled):active,.hsl .btn-outline-light:not(:disabled):not(.disabled).active,.show>.hsl .btn-outline-light.dropdown-toggle{color:hsla(0,0%,calc(-100 * calc(var(--light-l) - 58.59375%)),1);background-color:var(--light);border-color:var(--light)}.hsl .btn-outline-light:not(:disabled):not(.disabled):active:focus,.hsl .btn-outline-light:not(:disabled):not(.disabled).active:focus,.show>.hsl .btn-outline-light.dropdown-toggle:focus{box-shadow:0 0 0 .2rem hsla(var(--light-h),var(--light-s),var(--light-l),.5)}.hsl .btn-outline-dark{color:var(--gray-800);border-color:var(--gray-800)}.hsl .btn-outline-dark:hover{color:hsla(0,0%,calc(-100 * calc(var(--gray-800-l) - 58.59375%)),1);background-color:var(--gray-800);border-color:var(--gray-800)}.hsl .btn-outline-dark:focus,.hsl .btn-outline-dark.focus{box-shadow:0 0 0 .2rem hsla(var(--gray-800-h),var(--gray-800-s),var(--gray-800-l),.5)}.hsl .btn-outline-dark.disabled,.hsl .btn-outline-dark:disabled{color:var(--gray-800);background-color:transparent}.hsl .btn-outline-dark:not(:disabled):not(.disabled):active,.hsl .btn-outline-dark:not(:disabled):not(.disabled).active,.show>.hsl .btn-outline-dark.dropdown-toggle{color:hsla(0,0%,calc(-100 * calc(var(--gray-800-l) - 58.59375%)),1);background-color:var(--gray-800);border-color:var(--gray-800)}.hsl .btn-outline-dark:not(:disabled):not(.disabled):active:focus,.hsl .btn-outline-dark:not(:disabled):not(.disabled).active:focus,.show>.hsl .btn-outline-dark.dropdown-toggle:focus{box-shadow:0 0 0 .2rem hsla(var(--gray-800-h),var(--gray-800-s),var(--gray-800-l),.5)}.hsl .btn-outline-gray{color:var(--gray-900);border-color:var(--gray-900)}.hsl .btn-outline-gray:hover{color:hsla(0,0%,calc(-100 * calc(var(--gray-900-l) - 58.59375%)),1);background-color:var(--gray-900);border-color:var(--gray-900)}.hsl .btn-outline-gray:focus,.hsl .btn-outline-gray.focus{box-shadow:0 0 0 .2rem hsla(var(--gray-900-h),var(--gray-900-s),var(--gray-900-l),.5)}.hsl .btn-outline-gray.disabled,.hsl .btn-outline-gray:disabled{color:var(--gray-900);background-color:transparent}.hsl .btn-outline-gray:not(:disabled):not(.disabled):active,.hsl .btn-outline-gray:not(:disabled):not(.disabled).active,.show>.hsl .btn-outline-gray.dropdown-toggle{color:hsla(0,0%,calc(-100 * calc(var(--gray-900-l) - 58.59375%)),1);background-color:var(--gray-900);border-color:var(--gray-900)}.hsl .btn-outline-gray:not(:disabled):not(.disabled):active:focus,.hsl .btn-outline-gray:not(:disabled):not(.disabled).active:focus,.show>.hsl .btn-outline-gray.dropdown-toggle:focus{box-shadow:0 0 0 .2rem hsla(var(--gray-900-h),var(--gray-900-s),var(--gray-900-l),.5)}.hsl .btn-link{font-weight:400;color:var(--primary);text-decoration:none}.hsl .btn-link:hover{color:hsla(var(--primary-h),var(--primary-s),calc(var(--primary-l) + -15%),1);color:hsla(var(--primary-h),var(--primary-s),calc(var(--primary-l) + -15%),var(--primary-a, 1));text-decoration:underline}.hsl .btn-link:focus,.hsl .btn-link.focus{text-decoration:underline}.hsl .btn-link:disabled,.hsl .btn-link.disabled{color:#6c757d;pointer-events:none}.hsl .btn-lg,.hsl .btn-group-lg>.btn{padding:.5rem 1rem;font-size:1.25rem;line-height:1.5;border-radius:.3rem}.hsl .btn-sm,.hsl .btn-group-sm>.btn{padding:.25rem .5rem;font-size:.875rem;line-height:1.5;border-radius:.2rem}.hsl .btn-block{display:block;width:100%}.hsl .btn-block+.btn-block{margin-top:.5rem}.hsl input[type=submit].btn-block,.hsl input[type=reset].btn-block,.hsl input[type=button].btn-block{width:100%}.hsl .dropup,.hsl .dropright,.hsl .dropdown,.hsl .dropleft{position:relative}.hsl .dropdown-toggle{white-space:nowrap}.hsl .dropdown-toggle:after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid;border-right:.3em solid transparent;border-bottom:0;border-left:.3em solid transparent}.hsl .dropdown-toggle:empty:after{margin-left:0}.hsl .dropdown-menu{position:absolute;top:100%;left:0;z-index:1000;display:none;float:left;min-width:10rem;padding:.5rem 0;margin:.125rem 0 0;font-size:1rem;color:var(--gray-900);text-align:left;list-style:none;background-color:var(--white);background-clip:padding-box;border:1px solid rgba(0,0,0,.15);border-radius:.25rem}.hsl .dropdown-menu-left{right:auto;left:0}.hsl .dropdown-menu-right{right:0;left:auto}@media (min-width: 576px){.hsl .dropdown-menu-sm-left{right:auto;left:0}.hsl .dropdown-menu-sm-right{right:0;left:auto}}@media (min-width: 768px){.hsl .dropdown-menu-md-left{right:auto;left:0}.hsl .dropdown-menu-md-right{right:0;left:auto}}@media (min-width: 992px){.hsl .dropdown-menu-lg-left{right:auto;left:0}.hsl .dropdown-menu-lg-right{right:0;left:auto}}@media (min-width: 1200px){.hsl .dropdown-menu-xl-left{right:auto;left:0}.hsl .dropdown-menu-xl-right{right:0;left:auto}}.hsl .dropup .dropdown-menu{top:auto;bottom:100%;margin-top:0;margin-bottom:.125rem}.hsl .dropup .dropdown-toggle:after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:0;border-right:.3em solid transparent;border-bottom:.3em solid;border-left:.3em solid transparent}.hsl .dropup .dropdown-toggle:empty:after{margin-left:0}.hsl .dropright .dropdown-menu{top:0;right:auto;left:100%;margin-top:0;margin-left:.125rem}.hsl .dropright .dropdown-toggle:after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid transparent;border-right:0;border-bottom:.3em solid transparent;border-left:.3em solid}.hsl .dropright .dropdown-toggle:empty:after{margin-left:0}.hsl .dropright .dropdown-toggle:after{vertical-align:0}.hsl .dropleft .dropdown-menu{top:0;right:100%;left:auto;margin-top:0;margin-right:.125rem}.hsl .dropleft .dropdown-toggle:after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\"}.hsl .dropleft .dropdown-toggle:after{display:none}.hsl .dropleft .dropdown-toggle:before{display:inline-block;margin-right:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid transparent;border-right:.3em solid;border-bottom:.3em solid transparent}.hsl .dropleft .dropdown-toggle:empty:after{margin-left:0}.hsl .dropleft .dropdown-toggle:before{vertical-align:0}.hsl .dropdown-menu[x-placement^=top],.hsl .dropdown-menu[x-placement^=right],.hsl .dropdown-menu[x-placement^=bottom],.hsl .dropdown-menu[x-placement^=left]{right:auto;bottom:auto}.hsl .dropdown-divider{height:0;margin:.5rem 0;overflow:hidden;border-top:1px solid var(--gray-200)}.hsl .dropdown-item{display:block;width:100%;padding:.25rem 1.5rem;clear:both;font-weight:400;color:var(--gray-900);text-align:inherit;white-space:nowrap;background-color:transparent;border:0}.hsl .dropdown-item:hover,.hsl .dropdown-item:focus{color:hsla(var(--gray-900-h),var(--gray-900-s),calc(var(--gray-900-l) + -5%),1);color:hsla(var(--gray-900-h),var(--gray-900-s),calc(var(--gray-900-l) + -5%),var(--gray-900-a, 1));text-decoration:none;background-color:var(--gray-200)}.hsl .dropdown-item.active,.hsl .dropdown-item:active{color:var(--white);text-decoration:none;background-color:var(--primary)}.hsl .dropdown-item.disabled,.hsl .dropdown-item:disabled{color:#adb5bd;pointer-events:none;background-color:transparent}.hsl .dropdown-menu.show{display:block}.hsl .dropdown-header{display:block;padding:.5rem 1.5rem;margin-bottom:0;font-size:.875rem;color:#6c757d;white-space:nowrap}.hsl .dropdown-item-text{display:block;padding:.25rem 1.5rem;color:var(--gray-900)}.hsl .btn-group,.hsl .btn-group-vertical{position:relative;display:inline-flex;vertical-align:middle}.hsl .btn-group>.btn,.hsl .btn-group-vertical>.btn{position:relative;flex:1 1 auto}.hsl .btn-group>.btn:hover,.hsl .btn-group-vertical>.btn:hover{z-index:1}.hsl .btn-group>.btn:focus,.hsl .btn-group>.btn:active,.hsl .btn-group>.btn.active,.hsl .btn-group-vertical>.btn:focus,.hsl .btn-group-vertical>.btn:active,.hsl .btn-group-vertical>.btn.active{z-index:1}.hsl .btn-toolbar{display:flex;flex-wrap:wrap;justify-content:flex-start}.hsl .btn-toolbar .input-group{width:auto}.hsl .btn-group>.btn:not(:first-child),.hsl .btn-group>.btn-group:not(:first-child){margin-left:-1px}.hsl .btn-group>.btn:not(:last-child):not(.dropdown-toggle),.hsl .btn-group>.btn-group:not(:last-child)>.btn{border-top-right-radius:0;border-bottom-right-radius:0}.hsl .btn-group>.btn:not(:first-child),.hsl .btn-group>.btn-group:not(:first-child)>.btn{border-top-left-radius:0;border-bottom-left-radius:0}.hsl .dropdown-toggle-split{padding-right:.5625rem;padding-left:.5625rem}.hsl .dropdown-toggle-split:after,.dropup .hsl .dropdown-toggle-split:after,.dropright .hsl .dropdown-toggle-split:after{margin-left:0}.dropleft .hsl .dropdown-toggle-split:before{margin-right:0}.hsl .btn-sm+.dropdown-toggle-split,.hsl .btn-group-sm>.btn+.dropdown-toggle-split{padding-right:.375rem;padding-left:.375rem}.hsl .btn-lg+.dropdown-toggle-split,.hsl .btn-group-lg>.btn+.dropdown-toggle-split{padding-right:.75rem;padding-left:.75rem}.hsl .btn-group-vertical{flex-direction:column;align-items:flex-start;justify-content:center}.hsl .btn-group-vertical>.btn,.hsl .btn-group-vertical>.btn-group{width:100%}.hsl .btn-group-vertical>.btn:not(:first-child),.hsl .btn-group-vertical>.btn-group:not(:first-child){margin-top:-1px}.hsl .btn-group-vertical>.btn:not(:last-child):not(.dropdown-toggle),.hsl .btn-group-vertical>.btn-group:not(:last-child)>.btn{border-bottom-right-radius:0;border-bottom-left-radius:0}.hsl .btn-group-vertical>.btn:not(:first-child),.hsl .btn-group-vertical>.btn-group:not(:first-child)>.btn{border-top-left-radius:0;border-top-right-radius:0}.hsl .btn-group-toggle>.btn,.hsl .btn-group-toggle>.btn-group>.btn{margin-bottom:0}.hsl .btn-group-toggle>.btn input[type=radio],.hsl .btn-group-toggle>.btn input[type=checkbox],.hsl .btn-group-toggle>.btn-group>.btn input[type=radio],.hsl .btn-group-toggle>.btn-group>.btn input[type=checkbox]{position:absolute;clip:rect(0,0,0,0);pointer-events:none}.hsl .input-group{position:relative;display:flex;flex-wrap:wrap;align-items:stretch;width:100%}.hsl .input-group>.form-control,.hsl .input-group>.form-control-plaintext,.hsl .input-group>.custom-select,.hsl .input-group>.custom-file{position:relative;flex:1 1 auto;width:1%;min-width:0;margin-bottom:0}.hsl .input-group>.form-control+.form-control,.hsl .input-group>.form-control+.custom-select,.hsl .input-group>.form-control+.custom-file,.hsl .input-group>.form-control-plaintext+.form-control,.hsl .input-group>.form-control-plaintext+.custom-select,.hsl .input-group>.form-control-plaintext+.custom-file,.hsl .input-group>.custom-select+.form-control,.hsl .input-group>.custom-select+.custom-select,.hsl .input-group>.custom-select+.custom-file,.hsl .input-group>.custom-file+.form-control,.hsl .input-group>.custom-file+.custom-select,.hsl .input-group>.custom-file+.custom-file{margin-left:-1px}.hsl .input-group>.form-control:focus,.hsl .input-group>.custom-select:focus,.hsl .input-group>.custom-file .custom-file-input:focus~.custom-file-label{z-index:3}.hsl .input-group>.custom-file .custom-file-input:focus{z-index:4}.hsl .input-group>.form-control:not(:first-child),.hsl .input-group>.custom-select:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.hsl .input-group>.custom-file{display:flex;align-items:center}.hsl .input-group>.custom-file:not(:last-child) .custom-file-label,.hsl .input-group>.custom-file:not(:first-child) .custom-file-label{border-top-left-radius:0;border-bottom-left-radius:0}.hsl .input-group:not(.has-validation)>.form-control:not(:last-child),.hsl .input-group:not(.has-validation)>.custom-select:not(:last-child),.hsl .input-group:not(.has-validation)>.custom-file:not(:last-child) .custom-file-label:after{border-top-right-radius:0;border-bottom-right-radius:0}.hsl .input-group.has-validation>.form-control:nth-last-child(n+3),.hsl .input-group.has-validation>.custom-select:nth-last-child(n+3),.hsl .input-group.has-validation>.custom-file:nth-last-child(n+3) .custom-file-label:after{border-top-right-radius:0;border-bottom-right-radius:0}.hsl .input-group-prepend,.hsl .input-group-append{display:flex}.hsl .input-group-prepend .btn,.hsl .input-group-append .btn{position:relative;z-index:2}.hsl .input-group-prepend .btn:focus,.hsl .input-group-append .btn:focus{z-index:3}.hsl .input-group-prepend .btn+.btn,.hsl .input-group-prepend .btn+.input-group-text,.hsl .input-group-prepend .input-group-text+.input-group-text,.hsl .input-group-prepend .input-group-text+.btn,.hsl .input-group-append .btn+.btn,.hsl .input-group-append .btn+.input-group-text,.hsl .input-group-append .input-group-text+.input-group-text,.hsl .input-group-append .input-group-text+.btn{margin-left:-1px}.hsl .input-group-prepend{margin-right:-1px}.hsl .input-group-append{margin-left:-1px}.hsl .input-group-text{display:flex;align-items:center;padding:.375rem .75rem;margin-bottom:0;font-size:1rem;font-weight:400;line-height:1.5;color:var(--text-color);text-align:center;white-space:nowrap;background-color:var(--gray-200);border:1px solid #ced4da;border-radius:.25rem}.hsl .input-group-text input[type=radio],.hsl .input-group-text input[type=checkbox]{margin-top:0}.hsl .input-group-lg>.form-control:not(textarea),.hsl .input-group-lg>.custom-select{height:calc(1.5em + 1rem + 2px)}.hsl .input-group-lg>.form-control,.hsl .input-group-lg>.custom-select,.hsl .input-group-lg>.input-group-prepend>.input-group-text,.hsl .input-group-lg>.input-group-append>.input-group-text,.hsl .input-group-lg>.input-group-prepend>.btn,.hsl .input-group-lg>.input-group-append>.btn{padding:.5rem 1rem;font-size:1.25rem;line-height:1.5;border-radius:.3rem}.hsl .input-group-sm>.form-control:not(textarea),.hsl .input-group-sm>.custom-select{height:calc(1.5em + .5rem + 2px)}.hsl .input-group-sm>.form-control,.hsl .input-group-sm>.custom-select,.hsl .input-group-sm>.input-group-prepend>.input-group-text,.hsl .input-group-sm>.input-group-append>.input-group-text,.hsl .input-group-sm>.input-group-prepend>.btn,.hsl .input-group-sm>.input-group-append>.btn{padding:.25rem .5rem;font-size:.875rem;line-height:1.5;border-radius:.2rem}.hsl .input-group-lg>.custom-select,.hsl .input-group-sm>.custom-select{padding-right:1.75rem}.hsl .input-group>.input-group-prepend>.btn,.hsl .input-group>.input-group-prepend>.input-group-text,.hsl .input-group:not(.has-validation)>.input-group-append:not(:last-child)>.btn,.hsl .input-group:not(.has-validation)>.input-group-append:not(:last-child)>.input-group-text,.hsl .input-group.has-validation>.input-group-append:nth-last-child(n+3)>.btn,.hsl .input-group.has-validation>.input-group-append:nth-last-child(n+3)>.input-group-text,.hsl .input-group>.input-group-append:last-child>.btn:not(:last-child):not(.dropdown-toggle),.hsl .input-group>.input-group-append:last-child>.input-group-text:not(:last-child){border-top-right-radius:0;border-bottom-right-radius:0}.hsl .input-group>.input-group-append>.btn,.hsl .input-group>.input-group-append>.input-group-text,.hsl .input-group>.input-group-prepend:not(:first-child)>.btn,.hsl .input-group>.input-group-prepend:not(:first-child)>.input-group-text,.hsl .input-group>.input-group-prepend:first-child>.btn:not(:first-child),.hsl .input-group>.input-group-prepend:first-child>.input-group-text:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.hsl .nav{display:flex;flex-wrap:wrap;padding-left:0;margin-bottom:0;list-style:none}.hsl .nav-link{display:block;padding:.5rem 1rem}.hsl .nav-link:hover,.hsl .nav-link:focus{text-decoration:none}.hsl .nav-link.disabled{color:#6c757d;pointer-events:none;cursor:default}.hsl .nav-tabs{border-bottom:1px solid #dee2e6}.hsl .nav-tabs .nav-link{margin-bottom:-1px;border:1px solid transparent;border-top-left-radius:.25rem;border-top-right-radius:.25rem}.hsl .nav-tabs .nav-link:hover,.hsl .nav-tabs .nav-link:focus{border-color:var(--gray-200) var(--gray-200) #dee2e6}.hsl .nav-tabs .nav-link.disabled{color:#6c757d;background-color:transparent;border-color:transparent}.hsl .nav-tabs .nav-link.active,.hsl .nav-tabs .nav-item.show .nav-link{color:var(--text-color);background-color:var(--white);border-color:#dee2e6 #dee2e6 var(--white)}.hsl .nav-tabs .dropdown-menu{margin-top:-1px;border-top-left-radius:0;border-top-right-radius:0}.hsl .nav-pills .nav-link{border-radius:.25rem}.hsl .nav-pills .nav-link.active,.hsl .nav-pills .show>.nav-link{color:var(--white);background-color:var(--primary)}.hsl .nav-fill>.nav-link,.hsl .nav-fill .nav-item{flex:1 1 auto;text-align:center}.hsl .nav-justified>.nav-link,.hsl .nav-justified .nav-item{flex-basis:0;flex-grow:1;text-align:center}.hsl .tab-content>.tab-pane{display:none}.hsl .tab-content>.active{display:block}.hsl .navbar{position:relative;display:flex;flex-wrap:wrap;align-items:center;justify-content:space-between;padding:.5rem 1rem}.hsl .navbar .container,.hsl .navbar .container-fluid,.hsl .navbar .container-sm,.hsl .navbar .container-md,.hsl .navbar .container-lg,.hsl .navbar .container-xl{display:flex;flex-wrap:wrap;align-items:center;justify-content:space-between}.hsl .navbar-brand{display:inline-block;padding-top:.3125rem;padding-bottom:.3125rem;margin-right:1rem;font-size:1.25rem;line-height:inherit;white-space:nowrap}.hsl .navbar-brand:hover,.hsl .navbar-brand:focus{text-decoration:none}.hsl .navbar-nav{display:flex;flex-direction:column;padding-left:0;margin-bottom:0;list-style:none}.hsl .navbar-nav .nav-link{padding-right:0;padding-left:0}.hsl .navbar-nav .dropdown-menu{position:static;float:none}.hsl .navbar-text{display:inline-block;padding-top:.5rem;padding-bottom:.5rem}.hsl .navbar-collapse{flex-basis:100%;flex-grow:1;align-items:center}.hsl .navbar-toggler{padding:.25rem .75rem;font-size:1.25rem;line-height:1;background-color:transparent;border:1px solid transparent;border-radius:.25rem}.hsl .navbar-toggler:hover,.hsl .navbar-toggler:focus{text-decoration:none}.hsl .navbar-toggler-icon{display:inline-block;width:1.5em;height:1.5em;vertical-align:middle;content:\"\";background:50%/100% 100% no-repeat}.hsl .navbar-nav-scroll{max-height:75vh;overflow-y:auto}@media (max-width: 575.98px){.hsl .navbar-expand-sm>.container,.hsl .navbar-expand-sm>.container-fluid,.hsl .navbar-expand-sm>.container-sm,.hsl .navbar-expand-sm>.container-md,.hsl .navbar-expand-sm>.container-lg,.hsl .navbar-expand-sm>.container-xl{padding-right:0;padding-left:0}}@media (min-width: 576px){.hsl .navbar-expand-sm{flex-flow:row nowrap;justify-content:flex-start}.hsl .navbar-expand-sm .navbar-nav{flex-direction:row}.hsl .navbar-expand-sm .navbar-nav .dropdown-menu{position:absolute}.hsl .navbar-expand-sm .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem}.hsl .navbar-expand-sm>.container,.hsl .navbar-expand-sm>.container-fluid,.hsl .navbar-expand-sm>.container-sm,.hsl .navbar-expand-sm>.container-md,.hsl .navbar-expand-sm>.container-lg,.hsl .navbar-expand-sm>.container-xl{flex-wrap:nowrap}.hsl .navbar-expand-sm .navbar-nav-scroll{overflow:visible}.hsl .navbar-expand-sm .navbar-collapse{display:flex!important;flex-basis:auto}.hsl .navbar-expand-sm .navbar-toggler{display:none}}@media (max-width: 767.98px){.hsl .navbar-expand-md>.container,.hsl .navbar-expand-md>.container-fluid,.hsl .navbar-expand-md>.container-sm,.hsl .navbar-expand-md>.container-md,.hsl .navbar-expand-md>.container-lg,.hsl .navbar-expand-md>.container-xl{padding-right:0;padding-left:0}}@media (min-width: 768px){.hsl .navbar-expand-md{flex-flow:row nowrap;justify-content:flex-start}.hsl .navbar-expand-md .navbar-nav{flex-direction:row}.hsl .navbar-expand-md .navbar-nav .dropdown-menu{position:absolute}.hsl .navbar-expand-md .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem}.hsl .navbar-expand-md>.container,.hsl .navbar-expand-md>.container-fluid,.hsl .navbar-expand-md>.container-sm,.hsl .navbar-expand-md>.container-md,.hsl .navbar-expand-md>.container-lg,.hsl .navbar-expand-md>.container-xl{flex-wrap:nowrap}.hsl .navbar-expand-md .navbar-nav-scroll{overflow:visible}.hsl .navbar-expand-md .navbar-collapse{display:flex!important;flex-basis:auto}.hsl .navbar-expand-md .navbar-toggler{display:none}}@media (max-width: 991.98px){.hsl .navbar-expand-lg>.container,.hsl .navbar-expand-lg>.container-fluid,.hsl .navbar-expand-lg>.container-sm,.hsl .navbar-expand-lg>.container-md,.hsl .navbar-expand-lg>.container-lg,.hsl .navbar-expand-lg>.container-xl{padding-right:0;padding-left:0}}@media (min-width: 992px){.hsl .navbar-expand-lg{flex-flow:row nowrap;justify-content:flex-start}.hsl .navbar-expand-lg .navbar-nav{flex-direction:row}.hsl .navbar-expand-lg .navbar-nav .dropdown-menu{position:absolute}.hsl .navbar-expand-lg .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem}.hsl .navbar-expand-lg>.container,.hsl .navbar-expand-lg>.container-fluid,.hsl .navbar-expand-lg>.container-sm,.hsl .navbar-expand-lg>.container-md,.hsl .navbar-expand-lg>.container-lg,.hsl .navbar-expand-lg>.container-xl{flex-wrap:nowrap}.hsl .navbar-expand-lg .navbar-nav-scroll{overflow:visible}.hsl .navbar-expand-lg .navbar-collapse{display:flex!important;flex-basis:auto}.hsl .navbar-expand-lg .navbar-toggler{display:none}}@media (max-width: 1199.98px){.hsl .navbar-expand-xl>.container,.hsl .navbar-expand-xl>.container-fluid,.hsl .navbar-expand-xl>.container-sm,.hsl .navbar-expand-xl>.container-md,.hsl .navbar-expand-xl>.container-lg,.hsl .navbar-expand-xl>.container-xl{padding-right:0;padding-left:0}}@media (min-width: 1200px){.hsl .navbar-expand-xl{flex-flow:row nowrap;justify-content:flex-start}.hsl .navbar-expand-xl .navbar-nav{flex-direction:row}.hsl .navbar-expand-xl .navbar-nav .dropdown-menu{position:absolute}.hsl .navbar-expand-xl .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem}.hsl .navbar-expand-xl>.container,.hsl .navbar-expand-xl>.container-fluid,.hsl .navbar-expand-xl>.container-sm,.hsl .navbar-expand-xl>.container-md,.hsl .navbar-expand-xl>.container-lg,.hsl .navbar-expand-xl>.container-xl{flex-wrap:nowrap}.hsl .navbar-expand-xl .navbar-nav-scroll{overflow:visible}.hsl .navbar-expand-xl .navbar-collapse{display:flex!important;flex-basis:auto}.hsl .navbar-expand-xl .navbar-toggler{display:none}}.hsl .navbar-expand{flex-flow:row nowrap;justify-content:flex-start}.hsl .navbar-expand>.container,.hsl .navbar-expand>.container-fluid,.hsl .navbar-expand>.container-sm,.hsl .navbar-expand>.container-md,.hsl .navbar-expand>.container-lg,.hsl .navbar-expand>.container-xl{padding-right:0;padding-left:0}.hsl .navbar-expand .navbar-nav{flex-direction:row}.hsl .navbar-expand .navbar-nav .dropdown-menu{position:absolute}.hsl .navbar-expand .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem}.hsl .navbar-expand>.container,.hsl .navbar-expand>.container-fluid,.hsl .navbar-expand>.container-sm,.hsl .navbar-expand>.container-md,.hsl .navbar-expand>.container-lg,.hsl .navbar-expand>.container-xl{flex-wrap:nowrap}.hsl .navbar-expand .navbar-nav-scroll{overflow:visible}.hsl .navbar-expand .navbar-collapse{display:flex!important;flex-basis:auto}.hsl .navbar-expand .navbar-toggler{display:none}.hsl .navbar-light .navbar-brand{color:#000000e6}.hsl .navbar-light .navbar-brand:hover,.hsl .navbar-light .navbar-brand:focus{color:#000000e6}.hsl .navbar-light .navbar-nav .nav-link{color:#00000080}.hsl .navbar-light .navbar-nav .nav-link:hover,.hsl .navbar-light .navbar-nav .nav-link:focus{color:#000000b3}.hsl .navbar-light .navbar-nav .nav-link.disabled{color:#0000004d}.hsl .navbar-light .navbar-nav .show>.nav-link,.hsl .navbar-light .navbar-nav .active>.nav-link,.hsl .navbar-light .navbar-nav .nav-link.show,.hsl .navbar-light .navbar-nav .nav-link.active{color:#000000e6}.hsl .navbar-light .navbar-toggler{color:#00000080;border-color:#0000001a}.hsl .navbar-light .navbar-toggler-icon{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%280, 0, 0, 0.5%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\")}.hsl .navbar-light .navbar-text{color:#00000080}.hsl .navbar-light .navbar-text a{color:#000000e6}.hsl .navbar-light .navbar-text a:hover,.hsl .navbar-light .navbar-text a:focus{color:#000000e6}.hsl .navbar-dark .navbar-brand{color:var(--white)}.hsl .navbar-dark .navbar-brand:hover,.hsl .navbar-dark .navbar-brand:focus{color:var(--white)}.hsl .navbar-dark .navbar-nav .nav-link{color:hsla(var(--white-h),var(--white-s),var(--white-l),.5)}.hsl .navbar-dark .navbar-nav .nav-link:hover,.hsl .navbar-dark .navbar-nav .nav-link:focus{color:hsla(var(--white-h),var(--white-s),var(--white-l),.75)}.hsl .navbar-dark .navbar-nav .nav-link.disabled{color:hsla(var(--white-h),var(--white-s),var(--white-l),.25)}.hsl .navbar-dark .navbar-nav .show>.nav-link,.hsl .navbar-dark .navbar-nav .active>.nav-link,.hsl .navbar-dark .navbar-nav .nav-link.show,.hsl .navbar-dark .navbar-nav .nav-link.active{color:var(--white)}.hsl .navbar-dark .navbar-toggler{color:hsla(var(--white-h),var(--white-s),var(--white-l),.5);border-color:hsla(var(--white-h),var(--white-s),var(--white-l),.1)}.hsl .navbar-dark .navbar-toggler-icon{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'%3e%3cpath stroke='hsla%28var%28--white-h%29, var%28--white-s%29, var%28--white-l%29, 0.5%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\")}.hsl .navbar-dark .navbar-text{color:hsla(var(--white-h),var(--white-s),var(--white-l),.5)}.hsl .navbar-dark .navbar-text a{color:var(--white)}.hsl .navbar-dark .navbar-text a:hover,.hsl .navbar-dark .navbar-text a:focus{color:var(--white)}.hsl .card{position:relative;display:flex;flex-direction:column;min-width:0;word-wrap:break-word;background-color:var(--card-bg);background-clip:border-box;border:1px solid rgba(0,0,0,.125);border-radius:.25rem}.hsl .card>hr{margin-right:0;margin-left:0}.hsl .card>.list-group{border-top:inherit;border-bottom:inherit}.hsl .card>.list-group:first-child{border-top-width:0;border-top-left-radius:calc(.25rem - 1px);border-top-right-radius:calc(.25rem - 1px)}.hsl .card>.list-group:last-child{border-bottom-width:0;border-bottom-right-radius:calc(.25rem - 1px);border-bottom-left-radius:calc(.25rem - 1px)}.hsl .card>.card-header+.list-group,.hsl .card>.list-group+.card-footer{border-top:0}.hsl .card-body{flex:1 1 auto;min-height:1px;padding:1.25rem}.hsl .card-title{margin-bottom:.75rem}.hsl .card-subtitle{margin-top:-.375rem;margin-bottom:0}.hsl .card-text:last-child{margin-bottom:0}.hsl .card-link:hover{text-decoration:none}.hsl .card-link+.card-link{margin-left:1.25rem}.hsl .card-header{padding:.75rem 1.25rem;margin-bottom:0;color:var(--text-color);background-color:#00000008;border-bottom:1px solid rgba(0,0,0,.125)}.hsl .card-header:first-child{border-radius:calc(.25rem - 1px) calc(.25rem - 1px) 0 0}.hsl .card-footer{padding:.75rem 1.25rem;color:var(--text-color);background-color:#00000008;border-top:1px solid rgba(0,0,0,.125)}.hsl .card-footer:last-child{border-radius:0 0 calc(.25rem - 1px) calc(.25rem - 1px)}.hsl .card-header-tabs{margin-right:-.625rem;margin-bottom:-.75rem;margin-left:-.625rem;border-bottom:0}.hsl .card-header-pills{margin-right:-.625rem;margin-left:-.625rem}.hsl .card-img-overlay{position:absolute;top:0;right:0;bottom:0;left:0;padding:1.25rem;border-radius:calc(.25rem - 1px)}.hsl .card-img,.hsl .card-img-top,.hsl .card-img-bottom{flex-shrink:0;width:100%}.hsl .card-img,.hsl .card-img-top{border-top-left-radius:calc(.25rem - 1px);border-top-right-radius:calc(.25rem - 1px)}.hsl .card-img,.hsl .card-img-bottom{border-bottom-right-radius:calc(.25rem - 1px);border-bottom-left-radius:calc(.25rem - 1px)}.hsl .card-deck .card{margin-bottom:15px}@media (min-width: 576px){.hsl .card-deck{display:flex;flex-flow:row wrap;margin-right:-15px;margin-left:-15px}.hsl .card-deck .card{flex:1 0 0%;margin-right:15px;margin-bottom:0;margin-left:15px}}.hsl .card-group>.card{margin-bottom:15px}@media (min-width: 576px){.hsl .card-group{display:flex;flex-flow:row wrap}.hsl .card-group>.card{flex:1 0 0%;margin-bottom:0}.hsl .card-group>.card+.card{margin-left:0;border-left:0}.hsl .card-group>.card:not(:last-child){border-top-right-radius:0;border-bottom-right-radius:0}.hsl .card-group>.card:not(:last-child) .card-img-top,.hsl .card-group>.card:not(:last-child) .card-header{border-top-right-radius:0}.hsl .card-group>.card:not(:last-child) .card-img-bottom,.hsl .card-group>.card:not(:last-child) .card-footer{border-bottom-right-radius:0}.hsl .card-group>.card:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.hsl .card-group>.card:not(:first-child) .card-img-top,.hsl .card-group>.card:not(:first-child) .card-header{border-top-left-radius:0}.hsl .card-group>.card:not(:first-child) .card-img-bottom,.hsl .card-group>.card:not(:first-child) .card-footer{border-bottom-left-radius:0}}.hsl .card-columns .card{margin-bottom:.75rem}@media (min-width: 576px){.hsl .card-columns{-moz-column-count:3;column-count:3;grid-column-gap:1.25rem;-moz-column-gap:1.25rem;column-gap:1.25rem;orphans:1;widows:1}.hsl .card-columns .card{display:inline-block;width:100%}}.hsl .accordion{overflow-anchor:none}.hsl .accordion>.card{overflow:hidden}.hsl .accordion>.card:not(:last-of-type){border-bottom:0;border-bottom-right-radius:0;border-bottom-left-radius:0}.hsl .accordion>.card:not(:first-of-type){border-top-left-radius:0;border-top-right-radius:0}.hsl .accordion>.card>.card-header{border-radius:0;margin-bottom:-1px}.hsl .pagination{display:flex;padding-left:0;list-style:none;border-radius:.25rem}.hsl .page-link{position:relative;display:block;padding:.5rem .75rem;margin-left:-1px;line-height:1.25;color:var(--primary);background-color:var(--white);border:1px solid #dee2e6}.hsl .page-link:hover{z-index:2;color:hsla(var(--primary-h),var(--primary-s),calc(var(--primary-l) + -15%),1);color:hsla(var(--primary-h),var(--primary-s),calc(var(--primary-l) + -15%),var(--primary-a, 1));text-decoration:none;background-color:var(--gray-200);border-color:#dee2e6}.hsl .page-link:focus{z-index:3;outline:0;box-shadow:0 0 0 .2rem hsla(var(--primary-h),var(--primary-s),var(--primary-l),.25)}.hsl .page-item:first-child .page-link{margin-left:0;border-top-left-radius:.25rem;border-bottom-left-radius:.25rem}.hsl .page-item:last-child .page-link{border-top-right-radius:.25rem;border-bottom-right-radius:.25rem}.hsl .page-item.active .page-link{z-index:3;color:var(--white);background-color:var(--primary);border-color:var(--primary)}.hsl .page-item.disabled .page-link{color:#6c757d;pointer-events:none;cursor:auto;background-color:var(--white);border-color:#dee2e6}.hsl .pagination-lg .page-link{padding:.75rem 1.5rem;font-size:1.25rem;line-height:1.5}.hsl .pagination-lg .page-item:first-child .page-link{border-top-left-radius:.3rem;border-bottom-left-radius:.3rem}.hsl .pagination-lg .page-item:last-child .page-link{border-top-right-radius:.3rem;border-bottom-right-radius:.3rem}.hsl .pagination-sm .page-link{padding:.25rem .5rem;font-size:.875rem;line-height:1.5}.hsl .pagination-sm .page-item:first-child .page-link{border-top-left-radius:.2rem;border-bottom-left-radius:.2rem}.hsl .pagination-sm .page-item:last-child .page-link{border-top-right-radius:.2rem;border-bottom-right-radius:.2rem}.hsl .badge{display:inline-block;padding:.25em .4em;font-size:75%;font-weight:700;line-height:1;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:.25rem;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion: reduce){.hsl .badge{transition:none}}a.hsl .badge:hover,a.hsl .badge:focus{text-decoration:none}.hsl .badge:empty{display:none}.hsl .btn .badge{position:relative;top:-1px}.hsl .badge-pill{padding-right:.6em;padding-left:.6em;border-radius:10rem}.hsl .badge-primary{color:hsla(0,0%,calc(-100 * calc(var(--primary-l) - 58.59375%)),1);background-color:var(--primary)}a.hsl .badge-primary:hover,a.hsl .badge-primary:focus{color:hsla(0,0%,calc(-100 * calc(var(--primary-l) - 58.59375%)),1);background-color:hsla(var(--primary-h),var(--primary-s),calc(var(--primary-l) + -10%),1);background-color:hsla(var(--primary-h),var(--primary-s),calc(var(--primary-l) + -10%),var(--primary-a, 1))}a.hsl .badge-primary:focus,a.hsl .badge-primary.focus{outline:0;box-shadow:0 0 0 .2rem hsla(var(--primary-h),var(--primary-s),var(--primary-l),.5)}.hsl .badge-secondary{color:hsla(0,0%,calc(-100 * calc(var(--secondary-l) - 58.59375%)),1);background-color:var(--secondary)}a.hsl .badge-secondary:hover,a.hsl .badge-secondary:focus{color:hsla(0,0%,calc(-100 * calc(var(--secondary-l) - 58.59375%)),1);background-color:hsla(var(--secondary-h),var(--secondary-s),calc(var(--secondary-l) + -10%),1);background-color:hsla(var(--secondary-h),var(--secondary-s),calc(var(--secondary-l) + -10%),var(--secondary-a, 1))}a.hsl .badge-secondary:focus,a.hsl .badge-secondary.focus{outline:0;box-shadow:0 0 0 .2rem hsla(var(--secondary-h),var(--secondary-s),var(--secondary-l),.5)}.hsl .badge-success{color:var(--white);background-color:#28a745}a.hsl .badge-success:hover,a.hsl .badge-success:focus{color:var(--white);background-color:#24963e}a.hsl .badge-success:focus,a.hsl .badge-success.focus{outline:0;box-shadow:0 0 0 .2rem #28a74580}.hsl .badge-info{color:var(--white);background-color:#17a2b8}a.hsl .badge-info:hover,a.hsl .badge-info:focus{color:var(--white);background-color:#1592a6}a.hsl .badge-info:focus,a.hsl .badge-info.focus{outline:0;box-shadow:0 0 0 .2rem #17a2b880}.hsl .badge-warning{color:var(--gray-900);background-color:#ffc107}a.hsl .badge-warning:hover,a.hsl .badge-warning:focus{color:var(--gray-900);background-color:#ecb100}a.hsl .badge-warning:focus,a.hsl .badge-warning.focus{outline:0;box-shadow:0 0 0 .2rem #ffc10780}.hsl .badge-danger{color:var(--white);background-color:#dc3545}a.hsl .badge-danger:hover,a.hsl .badge-danger:focus{color:var(--white);background-color:#d12435}a.hsl .badge-danger:focus,a.hsl .badge-danger.focus{outline:0;box-shadow:0 0 0 .2rem #dc354580}.hsl .badge-light{color:hsla(0,0%,calc(-100 * calc(var(--light-l) - 58.59375%)),1);background-color:var(--light)}a.hsl .badge-light:hover,a.hsl .badge-light:focus{color:hsla(0,0%,calc(-100 * calc(var(--light-l) - 58.59375%)),1);background-color:hsla(var(--light-h),var(--light-s),calc(var(--light-l) + -10%),1);background-color:hsla(var(--light-h),var(--light-s),calc(var(--light-l) + -10%),var(--light-a, 1))}a.hsl .badge-light:focus,a.hsl .badge-light.focus{outline:0;box-shadow:0 0 0 .2rem hsla(var(--light-h),var(--light-s),var(--light-l),.5)}.hsl .badge-dark{color:hsla(0,0%,calc(-100 * calc(var(--gray-800-l) - 58.59375%)),1);background-color:var(--gray-800)}a.hsl .badge-dark:hover,a.hsl .badge-dark:focus{color:hsla(0,0%,calc(-100 * calc(var(--gray-800-l) - 58.59375%)),1);background-color:hsla(var(--gray-800-h),var(--gray-800-s),calc(var(--gray-800-l) + -10%),1);background-color:hsla(var(--gray-800-h),var(--gray-800-s),calc(var(--gray-800-l) + -10%),var(--gray-800-a, 1))}a.hsl .badge-dark:focus,a.hsl .badge-dark.focus{outline:0;box-shadow:0 0 0 .2rem hsla(var(--gray-800-h),var(--gray-800-s),var(--gray-800-l),.5)}.hsl .badge-gray{color:hsla(0,0%,calc(-100 * calc(var(--gray-900-l) - 58.59375%)),1);background-color:var(--gray-900)}a.hsl .badge-gray:hover,a.hsl .badge-gray:focus{color:hsla(0,0%,calc(-100 * calc(var(--gray-900-l) - 58.59375%)),1);background-color:hsla(var(--gray-900-h),var(--gray-900-s),calc(var(--gray-900-l) + -10%),1);background-color:hsla(var(--gray-900-h),var(--gray-900-s),calc(var(--gray-900-l) + -10%),var(--gray-900-a, 1))}a.hsl .badge-gray:focus,a.hsl .badge-gray.focus{outline:0;box-shadow:0 0 0 .2rem hsla(var(--gray-900-h),var(--gray-900-s),var(--gray-900-l),.5)}.hsl .alert{position:relative;padding:.75rem 1.25rem;margin-bottom:1rem;border:1px solid transparent;border-radius:.25rem}.hsl .alert-heading{color:inherit}.hsl .alert-link{font-weight:700}.hsl .alert-dismissible{padding-right:4rem}.hsl .alert-dismissible .close{position:absolute;top:0;right:0;z-index:2;padding:.75rem 1.25rem;color:inherit}.hsl .alert-primary{color:hsla(calc(var(--primary-h)),calc(var(--primary-s)),calc((0% + var(--primary-l)) / 2),calc((1 + 1) / 2));color:hsla(calc(var(--primary-h)),calc(var(--primary-s)),calc((0% + var(--primary-l)) / 2),calc((1 + var(--primary-a, 1)) / 2));background-color:hsla(calc(var(--primary-h)),calc(var(--primary-s)),calc((var(--white-l) + var(--primary-l)) / 2),calc((1 + 1) / 2));background-color:hsla(calc(var(--primary-h)),calc(var(--primary-s)),calc((var(--white-l) + var(--primary-l)) / 2),calc((var(--white-a, 1) + var(--primary-a, 1)) / 2));border-color:hsla(calc(var(--primary-h)),calc(var(--primary-s)),calc((var(--white-l) + var(--primary-l)) / 2),calc((1 + 1) / 2));border-color:hsla(calc(var(--primary-h)),calc(var(--primary-s)),calc((var(--white-l) + var(--primary-l)) / 2),calc((var(--white-a, 1) + var(--primary-a, 1)) / 2))}.hsl .alert-primary hr{border-top-color:hsla(calc(var(--primary-h)),calc(var(--primary-s)),calc(calc((var(--white-l) + var(--primary-l)) / 2) + -5%),calc((1 + 1) / 2));border-top-color:hsla(calc(var(--primary-h)),calc(var(--primary-s)),calc(calc((var(--white-l) + var(--primary-l)) / 2) + -5%),calc((var(--white-a, 1) + var(--primary-a, 1)) / 2))}.hsl .alert-primary .alert-link{color:hsla(calc(var(--primary-h)),calc(var(--primary-s)),calc(calc((0% + var(--primary-l)) / 2) + -10%),calc((1 + 1) / 2));color:hsla(calc(var(--primary-h)),calc(var(--primary-s)),calc(calc((0% + var(--primary-l)) / 2) + -10%),calc((1 + var(--primary-a, 1)) / 2))}.hsl .alert-secondary{color:hsla(calc(var(--secondary-h)),calc(var(--secondary-s)),calc((0% + var(--secondary-l)) / 2),calc((1 + 1) / 2));color:hsla(calc(var(--secondary-h)),calc(var(--secondary-s)),calc((0% + var(--secondary-l)) / 2),calc((1 + var(--secondary-a, 1)) / 2));background-color:hsla(calc(var(--secondary-h)),calc(var(--secondary-s)),calc((var(--white-l) + var(--secondary-l)) / 2),calc((1 + 1) / 2));background-color:hsla(calc(var(--secondary-h)),calc(var(--secondary-s)),calc((var(--white-l) + var(--secondary-l)) / 2),calc((var(--white-a, 1) + var(--secondary-a, 1)) / 2));border-color:hsla(calc(var(--secondary-h)),calc(var(--secondary-s)),calc((var(--white-l) + var(--secondary-l)) / 2),calc((1 + 1) / 2));border-color:hsla(calc(var(--secondary-h)),calc(var(--secondary-s)),calc((var(--white-l) + var(--secondary-l)) / 2),calc((var(--white-a, 1) + var(--secondary-a, 1)) / 2))}.hsl .alert-secondary hr{border-top-color:hsla(calc(var(--secondary-h)),calc(var(--secondary-s)),calc(calc((var(--white-l) + var(--secondary-l)) / 2) + -5%),calc((1 + 1) / 2));border-top-color:hsla(calc(var(--secondary-h)),calc(var(--secondary-s)),calc(calc((var(--white-l) + var(--secondary-l)) / 2) + -5%),calc((var(--white-a, 1) + var(--secondary-a, 1)) / 2))}.hsl .alert-secondary .alert-link{color:hsla(calc(var(--secondary-h)),calc(var(--secondary-s)),calc(calc((0% + var(--secondary-l)) / 2) + -10%),calc((1 + 1) / 2));color:hsla(calc(var(--secondary-h)),calc(var(--secondary-s)),calc(calc((0% + var(--secondary-l)) / 2) + -10%),calc((1 + var(--secondary-a, 1)) / 2))}.hsl .alert-success{color:hsla(calc(133.7007874016deg),calc(61.3526570048%),calc((0% + 40.5882352941%) / 2),calc((1 + 1) / 2));background-color:hsla(calc(133.7007874016deg),calc(61.3526570048%),calc((var(--white-l) + 40.5882352941%) / 2),calc((1 + 1) / 2));background-color:hsla(calc(133.7007874016deg),calc(61.3526570048%),calc((var(--white-l) + 40.5882352941%) / 2),calc((var(--white-a, 1) + 1) / 2));border-color:hsla(calc(133.7007874016deg),calc(61.3526570048%),calc((var(--white-l) + 40.5882352941%) / 2),calc((1 + 1) / 2));border-color:hsla(calc(133.7007874016deg),calc(61.3526570048%),calc((var(--white-l) + 40.5882352941%) / 2),calc((var(--white-a, 1) + 1) / 2))}.hsl .alert-success hr{border-top-color:hsla(calc(133.7007874016deg),calc(61.3526570048%),calc(calc((var(--white-l) + 40.5882352941%) / 2) + -5%),calc((1 + 1) / 2));border-top-color:hsla(calc(133.7007874016deg),calc(61.3526570048%),calc(calc((var(--white-l) + 40.5882352941%) / 2) + -5%),calc((var(--white-a, 1) + 1) / 2))}.hsl .alert-success .alert-link{color:hsla(calc(133.7007874016deg),calc(61.3526570048%),calc(calc((0% + 40.5882352941%) / 2) + -10%),)}.hsl .alert-info{color:hsla(calc(188.198757764deg),calc(77.7777777778%),calc((0% + 40.5882352941%) / 2),calc((1 + 1) / 2));background-color:hsla(calc(188.198757764deg),calc(77.7777777778%),calc((var(--white-l) + 40.5882352941%) / 2),calc((1 + 1) / 2));background-color:hsla(calc(188.198757764deg),calc(77.7777777778%),calc((var(--white-l) + 40.5882352941%) / 2),calc((var(--white-a, 1) + 1) / 2));border-color:hsla(calc(188.198757764deg),calc(77.7777777778%),calc((var(--white-l) + 40.5882352941%) / 2),calc((1 + 1) / 2));border-color:hsla(calc(188.198757764deg),calc(77.7777777778%),calc((var(--white-l) + 40.5882352941%) / 2),calc((var(--white-a, 1) + 1) / 2))}.hsl .alert-info hr{border-top-color:hsla(calc(188.198757764deg),calc(77.7777777778%),calc(calc((var(--white-l) + 40.5882352941%) / 2) + -5%),calc((1 + 1) / 2));border-top-color:hsla(calc(188.198757764deg),calc(77.7777777778%),calc(calc((var(--white-l) + 40.5882352941%) / 2) + -5%),calc((var(--white-a, 1) + 1) / 2))}.hsl .alert-info .alert-link{color:hsla(calc(188.198757764deg),calc(77.7777777778%),calc(calc((0% + 40.5882352941%) / 2) + -10%),)}.hsl .alert-warning{color:hsla(calc(45deg),calc(100%),calc((0% + 51.3725490196%) / 2),calc((1 + 1) / 2));background-color:hsla(calc(45deg),calc(100%),calc((var(--white-l) + 51.3725490196%) / 2),calc((1 + 1) / 2));background-color:hsla(calc(45deg),calc(100%),calc((var(--white-l) + 51.3725490196%) / 2),calc((var(--white-a, 1) + 1) / 2));border-color:hsla(calc(45deg),calc(100%),calc((var(--white-l) + 51.3725490196%) / 2),calc((1 + 1) / 2));border-color:hsla(calc(45deg),calc(100%),calc((var(--white-l) + 51.3725490196%) / 2),calc((var(--white-a, 1) + 1) / 2))}.hsl .alert-warning hr{border-top-color:hsla(calc(45deg),calc(100%),calc(calc((var(--white-l) + 51.3725490196%) / 2) + -5%),calc((1 + 1) / 2));border-top-color:hsla(calc(45deg),calc(100%),calc(calc((var(--white-l) + 51.3725490196%) / 2) + -5%),calc((var(--white-a, 1) + 1) / 2))}.hsl .alert-warning .alert-link{color:hsla(calc(45deg),calc(100%),calc(calc((0% + 51.3725490196%) / 2) + -10%),)}.hsl .alert-danger{color:hsla(calc(354.251497006deg),calc(70.4641350211%),calc((0% + 53.5294117647%) / 2),calc((1 + 1) / 2));background-color:hsla(calc(354.251497006deg),calc(70.4641350211%),calc((var(--white-l) + 53.5294117647%) / 2),calc((1 + 1) / 2));background-color:hsla(calc(354.251497006deg),calc(70.4641350211%),calc((var(--white-l) + 53.5294117647%) / 2),calc((var(--white-a, 1) + 1) / 2));border-color:hsla(calc(354.251497006deg),calc(70.4641350211%),calc((var(--white-l) + 53.5294117647%) / 2),calc((1 + 1) / 2));border-color:hsla(calc(354.251497006deg),calc(70.4641350211%),calc((var(--white-l) + 53.5294117647%) / 2),calc((var(--white-a, 1) + 1) / 2))}.hsl .alert-danger hr{border-top-color:hsla(calc(354.251497006deg),calc(70.4641350211%),calc(calc((var(--white-l) + 53.5294117647%) / 2) + -5%),calc((1 + 1) / 2));border-top-color:hsla(calc(354.251497006deg),calc(70.4641350211%),calc(calc((var(--white-l) + 53.5294117647%) / 2) + -5%),calc((var(--white-a, 1) + 1) / 2))}.hsl .alert-danger .alert-link{color:hsla(calc(354.251497006deg),calc(70.4641350211%),calc(calc((0% + 53.5294117647%) / 2) + -10%),)}.hsl .alert-light{color:hsla(calc(var(--light-h)),calc(var(--light-s)),calc((0% + var(--light-l)) / 2),calc((1 + 1) / 2));color:hsla(calc(var(--light-h)),calc(var(--light-s)),calc((0% + var(--light-l)) / 2),calc((1 + var(--light-a, 1)) / 2));background-color:hsla(calc(var(--light-h)),calc(var(--light-s)),calc((var(--white-l) + var(--light-l)) / 2),calc((1 + 1) / 2));background-color:hsla(calc(var(--light-h)),calc(var(--light-s)),calc((var(--white-l) + var(--light-l)) / 2),calc((var(--white-a, 1) + var(--light-a, 1)) / 2));border-color:hsla(calc(var(--light-h)),calc(var(--light-s)),calc((var(--white-l) + var(--light-l)) / 2),calc((1 + 1) / 2));border-color:hsla(calc(var(--light-h)),calc(var(--light-s)),calc((var(--white-l) + var(--light-l)) / 2),calc((var(--white-a, 1) + var(--light-a, 1)) / 2))}.hsl .alert-light hr{border-top-color:hsla(calc(var(--light-h)),calc(var(--light-s)),calc(calc((var(--white-l) + var(--light-l)) / 2) + -5%),calc((1 + 1) / 2));border-top-color:hsla(calc(var(--light-h)),calc(var(--light-s)),calc(calc((var(--white-l) + var(--light-l)) / 2) + -5%),calc((var(--white-a, 1) + var(--light-a, 1)) / 2))}.hsl .alert-light .alert-link{color:hsla(calc(var(--light-h)),calc(var(--light-s)),calc(calc((0% + var(--light-l)) / 2) + -10%),calc((1 + 1) / 2));color:hsla(calc(var(--light-h)),calc(var(--light-s)),calc(calc((0% + var(--light-l)) / 2) + -10%),calc((1 + var(--light-a, 1)) / 2))}.hsl .alert-dark{color:hsla(calc(var(--gray-800-h)),calc(var(--gray-800-s)),calc((0% + var(--gray-800-l)) / 2),calc((1 + 1) / 2));color:hsla(calc(var(--gray-800-h)),calc(var(--gray-800-s)),calc((0% + var(--gray-800-l)) / 2),calc((1 + var(--gray-800-a, 1)) / 2));background-color:hsla(calc(var(--gray-800-h)),calc(var(--gray-800-s)),calc((var(--white-l) + var(--gray-800-l)) / 2),calc((1 + 1) / 2));background-color:hsla(calc(var(--gray-800-h)),calc(var(--gray-800-s)),calc((var(--white-l) + var(--gray-800-l)) / 2),calc((var(--white-a, 1) + var(--gray-800-a, 1)) / 2));border-color:hsla(calc(var(--gray-800-h)),calc(var(--gray-800-s)),calc((var(--white-l) + var(--gray-800-l)) / 2),calc((1 + 1) / 2));border-color:hsla(calc(var(--gray-800-h)),calc(var(--gray-800-s)),calc((var(--white-l) + var(--gray-800-l)) / 2),calc((var(--white-a, 1) + var(--gray-800-a, 1)) / 2))}.hsl .alert-dark hr{border-top-color:hsla(calc(var(--gray-800-h)),calc(var(--gray-800-s)),calc(calc((var(--white-l) + var(--gray-800-l)) / 2) + -5%),calc((1 + 1) / 2));border-top-color:hsla(calc(var(--gray-800-h)),calc(var(--gray-800-s)),calc(calc((var(--white-l) + var(--gray-800-l)) / 2) + -5%),calc((var(--white-a, 1) + var(--gray-800-a, 1)) / 2))}.hsl .alert-dark .alert-link{color:hsla(calc(var(--gray-800-h)),calc(var(--gray-800-s)),calc(calc((0% + var(--gray-800-l)) / 2) + -10%),calc((1 + 1) / 2));color:hsla(calc(var(--gray-800-h)),calc(var(--gray-800-s)),calc(calc((0% + var(--gray-800-l)) / 2) + -10%),calc((1 + var(--gray-800-a, 1)) / 2))}.hsl .alert-gray{color:hsla(calc(var(--gray-900-h)),calc(var(--gray-900-s)),calc((0% + var(--gray-900-l)) / 2),calc((1 + 1) / 2));color:hsla(calc(var(--gray-900-h)),calc(var(--gray-900-s)),calc((0% + var(--gray-900-l)) / 2),calc((1 + var(--gray-900-a, 1)) / 2));background-color:hsla(calc(var(--gray-900-h)),calc(var(--gray-900-s)),calc((var(--white-l) + var(--gray-900-l)) / 2),calc((1 + 1) / 2));background-color:hsla(calc(var(--gray-900-h)),calc(var(--gray-900-s)),calc((var(--white-l) + var(--gray-900-l)) / 2),calc((var(--white-a, 1) + var(--gray-900-a, 1)) / 2));border-color:hsla(calc(var(--gray-900-h)),calc(var(--gray-900-s)),calc((var(--white-l) + var(--gray-900-l)) / 2),calc((1 + 1) / 2));border-color:hsla(calc(var(--gray-900-h)),calc(var(--gray-900-s)),calc((var(--white-l) + var(--gray-900-l)) / 2),calc((var(--white-a, 1) + var(--gray-900-a, 1)) / 2))}.hsl .alert-gray hr{border-top-color:hsla(calc(var(--gray-900-h)),calc(var(--gray-900-s)),calc(calc((var(--white-l) + var(--gray-900-l)) / 2) + -5%),calc((1 + 1) / 2));border-top-color:hsla(calc(var(--gray-900-h)),calc(var(--gray-900-s)),calc(calc((var(--white-l) + var(--gray-900-l)) / 2) + -5%),calc((var(--white-a, 1) + var(--gray-900-a, 1)) / 2))}.hsl .alert-gray .alert-link{color:hsla(calc(var(--gray-900-h)),calc(var(--gray-900-s)),calc(calc((0% + var(--gray-900-l)) / 2) + -10%),calc((1 + 1) / 2));color:hsla(calc(var(--gray-900-h)),calc(var(--gray-900-s)),calc(calc((0% + var(--gray-900-l)) / 2) + -10%),calc((1 + var(--gray-900-a, 1)) / 2))}@-webkit-keyframes progress-bar-stripes{0%{background-position:1rem 0}to{background-position:0 0}}@keyframes progress-bar-stripes{0%{background-position:1rem 0}to{background-position:0 0}}.hsl .progress{display:flex;height:1rem;overflow:hidden;line-height:0;font-size:.75rem;background-color:var(--gray-200);border-radius:.25rem}.hsl .progress-bar{display:flex;flex-direction:column;justify-content:center;overflow:hidden;color:var(--white);text-align:center;white-space:nowrap;background-color:var(--primary);transition:width .6s ease}@media (prefers-reduced-motion: reduce){.hsl .progress-bar{transition:none}}.hsl .progress-bar-striped{background-image:linear-gradient(45deg,hsla(var(--white-h),var(--white-s),var(--white-l),.15) 25%,transparent 25%,transparent 50%,hsla(var(--white-h),var(--white-s),var(--white-l),.15) 50%,hsla(var(--white-h),var(--white-s),var(--white-l),.15) 75%,transparent 75%,transparent);background-size:1rem 1rem}.hsl .progress-bar-animated{-webkit-animation:1s linear infinite progress-bar-stripes;animation:1s linear infinite progress-bar-stripes}@media (prefers-reduced-motion: reduce){.hsl .progress-bar-animated{-webkit-animation:none;animation:none}}.hsl .media{display:flex;align-items:flex-start}.hsl .media-body{flex:1}.hsl .list-group{display:flex;flex-direction:column;padding-left:0;margin-bottom:0;border-radius:.25rem}.hsl .list-group-item-action{width:100%;color:var(--text-color);text-align:inherit}.hsl .list-group-item-action:hover,.hsl .list-group-item-action:focus{z-index:1;color:var(--text-color);text-decoration:none;background-color:#f8f9fa}.hsl .list-group-item-action:active{color:var(--gray-900);background-color:var(--gray-200)}.hsl .list-group-item{position:relative;display:block;padding:.75rem 1.25rem;background-color:var(--white);border:1px solid rgba(0,0,0,.125)}.hsl .list-group-item:first-child{border-top-left-radius:inherit;border-top-right-radius:inherit}.hsl .list-group-item:last-child{border-bottom-right-radius:inherit;border-bottom-left-radius:inherit}.hsl .list-group-item.disabled,.hsl .list-group-item:disabled{color:#6c757d;pointer-events:none;background-color:var(--white)}.hsl .list-group-item.active{z-index:2;color:var(--white);background-color:var(--primary);border-color:var(--primary)}.hsl .list-group-item+.hsl .list-group-item{border-top-width:0}.hsl .list-group-item+.hsl .list-group-item.active{margin-top:-1px;border-top-width:1px}.hsl .list-group-horizontal{flex-direction:row}.hsl .list-group-horizontal>.list-group-item:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.hsl .list-group-horizontal>.list-group-item:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.hsl .list-group-horizontal>.list-group-item.active{margin-top:0}.hsl .list-group-horizontal>.list-group-item+.list-group-item{border-top-width:1px;border-left-width:0}.hsl .list-group-horizontal>.list-group-item+.list-group-item.active{margin-left:-1px;border-left-width:1px}@media (min-width: 576px){.hsl .list-group-horizontal-sm{flex-direction:row}.hsl .list-group-horizontal-sm>.list-group-item:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.hsl .list-group-horizontal-sm>.list-group-item:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.hsl .list-group-horizontal-sm>.list-group-item.active{margin-top:0}.hsl .list-group-horizontal-sm>.list-group-item+.list-group-item{border-top-width:1px;border-left-width:0}.hsl .list-group-horizontal-sm>.list-group-item+.list-group-item.active{margin-left:-1px;border-left-width:1px}}@media (min-width: 768px){.hsl .list-group-horizontal-md{flex-direction:row}.hsl .list-group-horizontal-md>.list-group-item:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.hsl .list-group-horizontal-md>.list-group-item:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.hsl .list-group-horizontal-md>.list-group-item.active{margin-top:0}.hsl .list-group-horizontal-md>.list-group-item+.list-group-item{border-top-width:1px;border-left-width:0}.hsl .list-group-horizontal-md>.list-group-item+.list-group-item.active{margin-left:-1px;border-left-width:1px}}@media (min-width: 992px){.hsl .list-group-horizontal-lg{flex-direction:row}.hsl .list-group-horizontal-lg>.list-group-item:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.hsl .list-group-horizontal-lg>.list-group-item:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.hsl .list-group-horizontal-lg>.list-group-item.active{margin-top:0}.hsl .list-group-horizontal-lg>.list-group-item+.list-group-item{border-top-width:1px;border-left-width:0}.hsl .list-group-horizontal-lg>.list-group-item+.list-group-item.active{margin-left:-1px;border-left-width:1px}}@media (min-width: 1200px){.hsl .list-group-horizontal-xl{flex-direction:row}.hsl .list-group-horizontal-xl>.list-group-item:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.hsl .list-group-horizontal-xl>.list-group-item:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.hsl .list-group-horizontal-xl>.list-group-item.active{margin-top:0}.hsl .list-group-horizontal-xl>.list-group-item+.list-group-item{border-top-width:1px;border-left-width:0}.hsl .list-group-horizontal-xl>.list-group-item+.list-group-item.active{margin-left:-1px;border-left-width:1px}}.hsl .list-group-flush{border-radius:0}.hsl .list-group-flush>.list-group-item{border-width:0 0 1px}.hsl .list-group-flush>.list-group-item:last-child{border-bottom-width:0}.hsl .list-group-item-primary{color:hsla(calc(var(--primary-h)),calc(var(--primary-s)),calc((0% + var(--primary-l)) / 2),calc((1 + 1) / 2));color:hsla(calc(var(--primary-h)),calc(var(--primary-s)),calc((0% + var(--primary-l)) / 2),calc((1 + var(--primary-a, 1)) / 2));background-color:hsla(calc(var(--primary-h)),calc(var(--primary-s)),calc((var(--white-l) + var(--primary-l)) / 2),calc((1 + 1) / 2));background-color:hsla(calc(var(--primary-h)),calc(var(--primary-s)),calc((var(--white-l) + var(--primary-l)) / 2),calc((var(--white-a, 1) + var(--primary-a, 1)) / 2))}.hsl .list-group-item-primary.list-group-item-action:hover,.hsl .list-group-item-primary.list-group-item-action:focus{color:hsla(calc(var(--primary-h)),calc(var(--primary-s)),calc((0% + var(--primary-l)) / 2),calc((1 + 1) / 2));color:hsla(calc(var(--primary-h)),calc(var(--primary-s)),calc((0% + var(--primary-l)) / 2),calc((1 + var(--primary-a, 1)) / 2));background-color:hsla(calc(var(--primary-h)),calc(var(--primary-s)),calc(calc((var(--white-l) + var(--primary-l)) / 2) + -5%),calc((1 + 1) / 2));background-color:hsla(calc(var(--primary-h)),calc(var(--primary-s)),calc(calc((var(--white-l) + var(--primary-l)) / 2) + -5%),calc((var(--white-a, 1) + var(--primary-a, 1)) / 2))}.hsl .list-group-item-primary.list-group-item-action.active{color:var(--white);background-color:hsla(calc(var(--primary-h)),calc(var(--primary-s)),calc((0% + var(--primary-l)) / 2),calc((1 + 1) / 2));background-color:hsla(calc(var(--primary-h)),calc(var(--primary-s)),calc((0% + var(--primary-l)) / 2),calc((1 + var(--primary-a, 1)) / 2));border-color:hsla(calc(var(--primary-h)),calc(var(--primary-s)),calc((0% + var(--primary-l)) / 2),calc((1 + 1) / 2));border-color:hsla(calc(var(--primary-h)),calc(var(--primary-s)),calc((0% + var(--primary-l)) / 2),calc((1 + var(--primary-a, 1)) / 2))}.hsl .list-group-item-secondary{color:hsla(calc(var(--secondary-h)),calc(var(--secondary-s)),calc((0% + var(--secondary-l)) / 2),calc((1 + 1) / 2));color:hsla(calc(var(--secondary-h)),calc(var(--secondary-s)),calc((0% + var(--secondary-l)) / 2),calc((1 + var(--secondary-a, 1)) / 2));background-color:hsla(calc(var(--secondary-h)),calc(var(--secondary-s)),calc((var(--white-l) + var(--secondary-l)) / 2),calc((1 + 1) / 2));background-color:hsla(calc(var(--secondary-h)),calc(var(--secondary-s)),calc((var(--white-l) + var(--secondary-l)) / 2),calc((var(--white-a, 1) + var(--secondary-a, 1)) / 2))}.hsl .list-group-item-secondary.list-group-item-action:hover,.hsl .list-group-item-secondary.list-group-item-action:focus{color:hsla(calc(var(--secondary-h)),calc(var(--secondary-s)),calc((0% + var(--secondary-l)) / 2),calc((1 + 1) / 2));color:hsla(calc(var(--secondary-h)),calc(var(--secondary-s)),calc((0% + var(--secondary-l)) / 2),calc((1 + var(--secondary-a, 1)) / 2));background-color:hsla(calc(var(--secondary-h)),calc(var(--secondary-s)),calc(calc((var(--white-l) + var(--secondary-l)) / 2) + -5%),calc((1 + 1) / 2));background-color:hsla(calc(var(--secondary-h)),calc(var(--secondary-s)),calc(calc((var(--white-l) + var(--secondary-l)) / 2) + -5%),calc((var(--white-a, 1) + var(--secondary-a, 1)) / 2))}.hsl .list-group-item-secondary.list-group-item-action.active{color:var(--white);background-color:hsla(calc(var(--secondary-h)),calc(var(--secondary-s)),calc((0% + var(--secondary-l)) / 2),calc((1 + 1) / 2));background-color:hsla(calc(var(--secondary-h)),calc(var(--secondary-s)),calc((0% + var(--secondary-l)) / 2),calc((1 + var(--secondary-a, 1)) / 2));border-color:hsla(calc(var(--secondary-h)),calc(var(--secondary-s)),calc((0% + var(--secondary-l)) / 2),calc((1 + 1) / 2));border-color:hsla(calc(var(--secondary-h)),calc(var(--secondary-s)),calc((0% + var(--secondary-l)) / 2),calc((1 + var(--secondary-a, 1)) / 2))}.hsl .list-group-item-success{color:hsla(calc(133.7007874016deg),calc(61.3526570048%),calc((0% + 40.5882352941%) / 2),calc((1 + 1) / 2));background-color:hsla(calc(133.7007874016deg),calc(61.3526570048%),calc((var(--white-l) + 40.5882352941%) / 2),calc((1 + 1) / 2));background-color:hsla(calc(133.7007874016deg),calc(61.3526570048%),calc((var(--white-l) + 40.5882352941%) / 2),calc((var(--white-a, 1) + 1) / 2))}.hsl .list-group-item-success.list-group-item-action:hover,.hsl .list-group-item-success.list-group-item-action:focus{color:hsla(calc(133.7007874016deg),calc(61.3526570048%),calc((0% + 40.5882352941%) / 2),calc((1 + 1) / 2));background-color:hsla(calc(133.7007874016deg),calc(61.3526570048%),calc(calc((var(--white-l) + 40.5882352941%) / 2) + -5%),calc((1 + 1) / 2));background-color:hsla(calc(133.7007874016deg),calc(61.3526570048%),calc(calc((var(--white-l) + 40.5882352941%) / 2) + -5%),calc((var(--white-a, 1) + 1) / 2))}.hsl .list-group-item-success.list-group-item-action.active{color:var(--white);background-color:hsla(calc(133.7007874016deg),calc(61.3526570048%),calc((0% + 40.5882352941%) / 2),calc((1 + 1) / 2));border-color:hsla(calc(133.7007874016deg),calc(61.3526570048%),calc((0% + 40.5882352941%) / 2),calc((1 + 1) / 2))}.hsl .list-group-item-info{color:hsla(calc(188.198757764deg),calc(77.7777777778%),calc((0% + 40.5882352941%) / 2),calc((1 + 1) / 2));background-color:hsla(calc(188.198757764deg),calc(77.7777777778%),calc((var(--white-l) + 40.5882352941%) / 2),calc((1 + 1) / 2));background-color:hsla(calc(188.198757764deg),calc(77.7777777778%),calc((var(--white-l) + 40.5882352941%) / 2),calc((var(--white-a, 1) + 1) / 2))}.hsl .list-group-item-info.list-group-item-action:hover,.hsl .list-group-item-info.list-group-item-action:focus{color:hsla(calc(188.198757764deg),calc(77.7777777778%),calc((0% + 40.5882352941%) / 2),calc((1 + 1) / 2));background-color:hsla(calc(188.198757764deg),calc(77.7777777778%),calc(calc((var(--white-l) + 40.5882352941%) / 2) + -5%),calc((1 + 1) / 2));background-color:hsla(calc(188.198757764deg),calc(77.7777777778%),calc(calc((var(--white-l) + 40.5882352941%) / 2) + -5%),calc((var(--white-a, 1) + 1) / 2))}.hsl .list-group-item-info.list-group-item-action.active{color:var(--white);background-color:hsla(calc(188.198757764deg),calc(77.7777777778%),calc((0% + 40.5882352941%) / 2),calc((1 + 1) / 2));border-color:hsla(calc(188.198757764deg),calc(77.7777777778%),calc((0% + 40.5882352941%) / 2),calc((1 + 1) / 2))}.hsl .list-group-item-warning{color:hsla(calc(45deg),calc(100%),calc((0% + 51.3725490196%) / 2),calc((1 + 1) / 2));background-color:hsla(calc(45deg),calc(100%),calc((var(--white-l) + 51.3725490196%) / 2),calc((1 + 1) / 2));background-color:hsla(calc(45deg),calc(100%),calc((var(--white-l) + 51.3725490196%) / 2),calc((var(--white-a, 1) + 1) / 2))}.hsl .list-group-item-warning.list-group-item-action:hover,.hsl .list-group-item-warning.list-group-item-action:focus{color:hsla(calc(45deg),calc(100%),calc((0% + 51.3725490196%) / 2),calc((1 + 1) / 2));background-color:hsla(calc(45deg),calc(100%),calc(calc((var(--white-l) + 51.3725490196%) / 2) + -5%),calc((1 + 1) / 2));background-color:hsla(calc(45deg),calc(100%),calc(calc((var(--white-l) + 51.3725490196%) / 2) + -5%),calc((var(--white-a, 1) + 1) / 2))}.hsl .list-group-item-warning.list-group-item-action.active{color:var(--white);background-color:hsla(calc(45deg),calc(100%),calc((0% + 51.3725490196%) / 2),calc((1 + 1) / 2));border-color:hsla(calc(45deg),calc(100%),calc((0% + 51.3725490196%) / 2),calc((1 + 1) / 2))}.hsl .list-group-item-danger{color:hsla(calc(354.251497006deg),calc(70.4641350211%),calc((0% + 53.5294117647%) / 2),calc((1 + 1) / 2));background-color:hsla(calc(354.251497006deg),calc(70.4641350211%),calc((var(--white-l) + 53.5294117647%) / 2),calc((1 + 1) / 2));background-color:hsla(calc(354.251497006deg),calc(70.4641350211%),calc((var(--white-l) + 53.5294117647%) / 2),calc((var(--white-a, 1) + 1) / 2))}.hsl .list-group-item-danger.list-group-item-action:hover,.hsl .list-group-item-danger.list-group-item-action:focus{color:hsla(calc(354.251497006deg),calc(70.4641350211%),calc((0% + 53.5294117647%) / 2),calc((1 + 1) / 2));background-color:hsla(calc(354.251497006deg),calc(70.4641350211%),calc(calc((var(--white-l) + 53.5294117647%) / 2) + -5%),calc((1 + 1) / 2));background-color:hsla(calc(354.251497006deg),calc(70.4641350211%),calc(calc((var(--white-l) + 53.5294117647%) / 2) + -5%),calc((var(--white-a, 1) + 1) / 2))}.hsl .list-group-item-danger.list-group-item-action.active{color:var(--white);background-color:hsla(calc(354.251497006deg),calc(70.4641350211%),calc((0% + 53.5294117647%) / 2),calc((1 + 1) / 2));border-color:hsla(calc(354.251497006deg),calc(70.4641350211%),calc((0% + 53.5294117647%) / 2),calc((1 + 1) / 2))}.hsl .list-group-item-light{color:hsla(calc(var(--light-h)),calc(var(--light-s)),calc((0% + var(--light-l)) / 2),calc((1 + 1) / 2));color:hsla(calc(var(--light-h)),calc(var(--light-s)),calc((0% + var(--light-l)) / 2),calc((1 + var(--light-a, 1)) / 2));background-color:hsla(calc(var(--light-h)),calc(var(--light-s)),calc((var(--white-l) + var(--light-l)) / 2),calc((1 + 1) / 2));background-color:hsla(calc(var(--light-h)),calc(var(--light-s)),calc((var(--white-l) + var(--light-l)) / 2),calc((var(--white-a, 1) + var(--light-a, 1)) / 2))}.hsl .list-group-item-light.list-group-item-action:hover,.hsl .list-group-item-light.list-group-item-action:focus{color:hsla(calc(var(--light-h)),calc(var(--light-s)),calc((0% + var(--light-l)) / 2),calc((1 + 1) / 2));color:hsla(calc(var(--light-h)),calc(var(--light-s)),calc((0% + var(--light-l)) / 2),calc((1 + var(--light-a, 1)) / 2));background-color:hsla(calc(var(--light-h)),calc(var(--light-s)),calc(calc((var(--white-l) + var(--light-l)) / 2) + -5%),calc((1 + 1) / 2));background-color:hsla(calc(var(--light-h)),calc(var(--light-s)),calc(calc((var(--white-l) + var(--light-l)) / 2) + -5%),calc((var(--white-a, 1) + var(--light-a, 1)) / 2))}.hsl .list-group-item-light.list-group-item-action.active{color:var(--white);background-color:hsla(calc(var(--light-h)),calc(var(--light-s)),calc((0% + var(--light-l)) / 2),calc((1 + 1) / 2));background-color:hsla(calc(var(--light-h)),calc(var(--light-s)),calc((0% + var(--light-l)) / 2),calc((1 + var(--light-a, 1)) / 2));border-color:hsla(calc(var(--light-h)),calc(var(--light-s)),calc((0% + var(--light-l)) / 2),calc((1 + 1) / 2));border-color:hsla(calc(var(--light-h)),calc(var(--light-s)),calc((0% + var(--light-l)) / 2),calc((1 + var(--light-a, 1)) / 2))}.hsl .list-group-item-dark{color:hsla(calc(var(--gray-800-h)),calc(var(--gray-800-s)),calc((0% + var(--gray-800-l)) / 2),calc((1 + 1) / 2));color:hsla(calc(var(--gray-800-h)),calc(var(--gray-800-s)),calc((0% + var(--gray-800-l)) / 2),calc((1 + var(--gray-800-a, 1)) / 2));background-color:hsla(calc(var(--gray-800-h)),calc(var(--gray-800-s)),calc((var(--white-l) + var(--gray-800-l)) / 2),calc((1 + 1) / 2));background-color:hsla(calc(var(--gray-800-h)),calc(var(--gray-800-s)),calc((var(--white-l) + var(--gray-800-l)) / 2),calc((var(--white-a, 1) + var(--gray-800-a, 1)) / 2))}.hsl .list-group-item-dark.list-group-item-action:hover,.hsl .list-group-item-dark.list-group-item-action:focus{color:hsla(calc(var(--gray-800-h)),calc(var(--gray-800-s)),calc((0% + var(--gray-800-l)) / 2),calc((1 + 1) / 2));color:hsla(calc(var(--gray-800-h)),calc(var(--gray-800-s)),calc((0% + var(--gray-800-l)) / 2),calc((1 + var(--gray-800-a, 1)) / 2));background-color:hsla(calc(var(--gray-800-h)),calc(var(--gray-800-s)),calc(calc((var(--white-l) + var(--gray-800-l)) / 2) + -5%),calc((1 + 1) / 2));background-color:hsla(calc(var(--gray-800-h)),calc(var(--gray-800-s)),calc(calc((var(--white-l) + var(--gray-800-l)) / 2) + -5%),calc((var(--white-a, 1) + var(--gray-800-a, 1)) / 2))}.hsl .list-group-item-dark.list-group-item-action.active{color:var(--white);background-color:hsla(calc(var(--gray-800-h)),calc(var(--gray-800-s)),calc((0% + var(--gray-800-l)) / 2),calc((1 + 1) / 2));background-color:hsla(calc(var(--gray-800-h)),calc(var(--gray-800-s)),calc((0% + var(--gray-800-l)) / 2),calc((1 + var(--gray-800-a, 1)) / 2));border-color:hsla(calc(var(--gray-800-h)),calc(var(--gray-800-s)),calc((0% + var(--gray-800-l)) / 2),calc((1 + 1) / 2));border-color:hsla(calc(var(--gray-800-h)),calc(var(--gray-800-s)),calc((0% + var(--gray-800-l)) / 2),calc((1 + var(--gray-800-a, 1)) / 2))}.hsl .list-group-item-gray{color:hsla(calc(var(--gray-900-h)),calc(var(--gray-900-s)),calc((0% + var(--gray-900-l)) / 2),calc((1 + 1) / 2));color:hsla(calc(var(--gray-900-h)),calc(var(--gray-900-s)),calc((0% + var(--gray-900-l)) / 2),calc((1 + var(--gray-900-a, 1)) / 2));background-color:hsla(calc(var(--gray-900-h)),calc(var(--gray-900-s)),calc((var(--white-l) + var(--gray-900-l)) / 2),calc((1 + 1) / 2));background-color:hsla(calc(var(--gray-900-h)),calc(var(--gray-900-s)),calc((var(--white-l) + var(--gray-900-l)) / 2),calc((var(--white-a, 1) + var(--gray-900-a, 1)) / 2))}.hsl .list-group-item-gray.list-group-item-action:hover,.hsl .list-group-item-gray.list-group-item-action:focus{color:hsla(calc(var(--gray-900-h)),calc(var(--gray-900-s)),calc((0% + var(--gray-900-l)) / 2),calc((1 + 1) / 2));color:hsla(calc(var(--gray-900-h)),calc(var(--gray-900-s)),calc((0% + var(--gray-900-l)) / 2),calc((1 + var(--gray-900-a, 1)) / 2));background-color:hsla(calc(var(--gray-900-h)),calc(var(--gray-900-s)),calc(calc((var(--white-l) + var(--gray-900-l)) / 2) + -5%),calc((1 + 1) / 2));background-color:hsla(calc(var(--gray-900-h)),calc(var(--gray-900-s)),calc(calc((var(--white-l) + var(--gray-900-l)) / 2) + -5%),calc((var(--white-a, 1) + var(--gray-900-a, 1)) / 2))}.hsl .list-group-item-gray.list-group-item-action.active{color:var(--white);background-color:hsla(calc(var(--gray-900-h)),calc(var(--gray-900-s)),calc((0% + var(--gray-900-l)) / 2),calc((1 + 1) / 2));background-color:hsla(calc(var(--gray-900-h)),calc(var(--gray-900-s)),calc((0% + var(--gray-900-l)) / 2),calc((1 + var(--gray-900-a, 1)) / 2));border-color:hsla(calc(var(--gray-900-h)),calc(var(--gray-900-s)),calc((0% + var(--gray-900-l)) / 2),calc((1 + 1) / 2));border-color:hsla(calc(var(--gray-900-h)),calc(var(--gray-900-s)),calc((0% + var(--gray-900-l)) / 2),calc((1 + var(--gray-900-a, 1)) / 2))}.hsl .close{float:right;font-size:1.5rem;font-weight:700;line-height:1;color:#000;text-shadow:0 1px 0 var(--white);opacity:.5}@media (max-width: 1200px){.hsl .close{font-size:calc(1.275rem + .3vw)}}.hsl .close:hover{color:#000;text-decoration:none}.hsl .close:not(:disabled):not(.disabled):hover,.hsl .close:not(:disabled):not(.disabled):focus{opacity:.75}.hsl button.close{padding:0;background-color:transparent;border:0}.hsl a.close.disabled{pointer-events:none}.hsl .toast{flex-basis:350px;max-width:350px;font-size:.875rem;background-color:hsla(var(--white-h),var(--white-s),var(--white-l),.85);background-clip:padding-box;border:1px solid rgba(0,0,0,.1);box-shadow:0 .25rem .75rem #0000001a;opacity:0;border-radius:.25rem}.hsl .toast:not(:last-child){margin-bottom:.75rem}.hsl .toast.showing{opacity:1}.hsl .toast.show{display:block;opacity:1}.hsl .toast.hide{display:none}.hsl .toast-header{display:flex;align-items:center;padding:.25rem .75rem;color:#6c757d;background-color:#fff;background-clip:padding-box;border-bottom:1px solid rgba(0,0,0,.05);border-top-left-radius:calc(.25rem - 1px);border-top-right-radius:calc(.25rem - 1px)}.hsl .toast-body{padding:.75rem}.hsl .modal-open{overflow:hidden}.hsl .modal-open .modal{overflow-x:hidden;overflow-y:auto}.hsl .modal{position:fixed;top:0;left:0;z-index:1050;display:none;width:100%;height:100%;overflow:hidden;outline:0}.hsl .modal-dialog{position:relative;width:auto;margin:.5rem;pointer-events:none}.modal.fade .hsl .modal-dialog{transition:transform .3s ease-out;transform:translateY(-50px)}@media (prefers-reduced-motion: reduce){.modal.fade .hsl .modal-dialog{transition:none}}.modal.show .hsl .modal-dialog{transform:none}.modal.modal-static .hsl .modal-dialog{transform:scale(1.02)}.hsl .modal-dialog-scrollable{display:flex;max-height:calc(100% - 1rem)}.hsl .modal-dialog-scrollable .modal-content{max-height:calc(100vh - 1rem);overflow:hidden}.hsl .modal-dialog-scrollable .modal-header,.hsl .modal-dialog-scrollable .modal-footer{flex-shrink:0}.hsl .modal-dialog-scrollable .modal-body{overflow-y:auto}.hsl .modal-dialog-centered{display:flex;align-items:center;min-height:calc(100% - 1rem)}.hsl .modal-dialog-centered:before{display:block;height:calc(100vh - 1rem);height:-webkit-min-content;height:-moz-min-content;height:min-content;content:\"\"}.hsl .modal-dialog-centered.modal-dialog-scrollable{flex-direction:column;justify-content:center;height:100%}.hsl .modal-dialog-centered.modal-dialog-scrollable .modal-content{max-height:none}.hsl .modal-dialog-centered.modal-dialog-scrollable:before{content:none}.hsl .modal-content{position:relative;display:flex;flex-direction:column;width:100%;pointer-events:auto;background-color:var(--white);background-clip:padding-box;border:1px solid rgba(0,0,0,.2);border-radius:.3rem;outline:0}.hsl .modal-backdrop{position:fixed;top:0;left:0;z-index:1040;width:100vw;height:100vh;background-color:#000}.hsl .modal-backdrop.fade{opacity:0}.hsl .modal-backdrop.show{opacity:.5}.hsl .modal-header{display:flex;align-items:flex-start;justify-content:space-between;padding:1rem;border-bottom:1px solid #dee2e6;border-top-left-radius:calc(.3rem - 1px);border-top-right-radius:calc(.3rem - 1px)}.hsl .modal-header .close{padding:1rem;margin:-1rem -1rem -1rem auto}.hsl .modal-title{margin-bottom:0;line-height:1.5}.hsl .modal-body{position:relative;flex:1 1 auto;padding:1rem}.hsl .modal-footer{display:flex;flex-wrap:wrap;align-items:center;justify-content:flex-end;padding:.75rem;border-top:1px solid #dee2e6;border-bottom-right-radius:calc(.3rem - 1px);border-bottom-left-radius:calc(.3rem - 1px)}.hsl .modal-footer>*{margin:.25rem}.hsl .modal-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}@media (min-width: 576px){.hsl .modal-dialog{max-width:500px;margin:1.75rem auto}.hsl .modal-dialog-scrollable{max-height:calc(100% - 3.5rem)}.hsl .modal-dialog-scrollable .modal-content{max-height:calc(100vh - 3.5rem)}.hsl .modal-dialog-centered{min-height:calc(100% - 3.5rem)}.hsl .modal-dialog-centered:before{height:calc(100vh - 3.5rem);height:-webkit-min-content;height:-moz-min-content;height:min-content}.hsl .modal-sm{max-width:300px}}@media (min-width: 992px){.hsl .modal-lg,.hsl .modal-xl{max-width:800px}}@media (min-width: 1200px){.hsl .modal-xl{max-width:1140px}}.hsl .tooltip{position:absolute;z-index:1070;display:block;margin:0;font-family:-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,\"Noto Sans\",\"Liberation Sans\",sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Noto Color Emoji\";font-style:normal;font-weight:400;line-height:1.5;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;white-space:normal;line-break:auto;font-size:.875rem;word-wrap:break-word;opacity:0}.hsl .tooltip.show{opacity:.9}.hsl .tooltip .arrow{position:absolute;display:block;width:.8rem;height:.4rem}.hsl .tooltip .arrow:before{position:absolute;content:\"\";border-color:transparent;border-style:solid}.hsl .bs-tooltip-top,.hsl .bs-tooltip-auto[x-placement^=top]{padding:.4rem 0}.hsl .bs-tooltip-top .arrow,.hsl .bs-tooltip-auto[x-placement^=top] .arrow{bottom:0}.hsl .bs-tooltip-top .arrow:before,.hsl .bs-tooltip-auto[x-placement^=top] .arrow:before{top:0;border-width:.4rem .4rem 0;border-top-color:#000}.hsl .bs-tooltip-right,.hsl .bs-tooltip-auto[x-placement^=right]{padding:0 .4rem}.hsl .bs-tooltip-right .arrow,.hsl .bs-tooltip-auto[x-placement^=right] .arrow{left:0;width:.4rem;height:.8rem}.hsl .bs-tooltip-right .arrow:before,.hsl .bs-tooltip-auto[x-placement^=right] .arrow:before{right:0;border-width:.4rem .4rem .4rem 0;border-right-color:#000}.hsl .bs-tooltip-bottom,.hsl .bs-tooltip-auto[x-placement^=bottom]{padding:.4rem 0}.hsl .bs-tooltip-bottom .arrow,.hsl .bs-tooltip-auto[x-placement^=bottom] .arrow{top:0}.hsl .bs-tooltip-bottom .arrow:before,.hsl .bs-tooltip-auto[x-placement^=bottom] .arrow:before{bottom:0;border-width:0 .4rem .4rem;border-bottom-color:#000}.hsl .bs-tooltip-left,.hsl .bs-tooltip-auto[x-placement^=left]{padding:0 .4rem}.hsl .bs-tooltip-left .arrow,.hsl .bs-tooltip-auto[x-placement^=left] .arrow{right:0;width:.4rem;height:.8rem}.hsl .bs-tooltip-left .arrow:before,.hsl .bs-tooltip-auto[x-placement^=left] .arrow:before{left:0;border-width:.4rem 0 .4rem .4rem;border-left-color:#000}.hsl .tooltip-inner{max-width:200px;padding:.25rem .5rem;color:var(--white);text-align:center;background-color:#000;border-radius:.25rem}.hsl .popover{position:absolute;top:0;left:0;z-index:1060;display:block;max-width:276px;font-family:-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,\"Noto Sans\",\"Liberation Sans\",sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Noto Color Emoji\";font-style:normal;font-weight:400;line-height:1.5;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;white-space:normal;line-break:auto;font-size:.875rem;word-wrap:break-word;background-color:var(--white);background-clip:padding-box;border:1px solid rgba(0,0,0,.2);border-radius:.3rem}.hsl .popover .arrow{position:absolute;display:block;width:1rem;height:.5rem;margin:0 .3rem}.hsl .popover .arrow:before,.hsl .popover .arrow:after{position:absolute;display:block;content:\"\";border-color:transparent;border-style:solid}.hsl .bs-popover-top,.hsl .bs-popover-auto[x-placement^=top]{margin-bottom:.5rem}.hsl .bs-popover-top>.arrow,.hsl .bs-popover-auto[x-placement^=top]>.arrow{bottom:calc(-.5rem - 1px)}.hsl .bs-popover-top>.arrow:before,.hsl .bs-popover-auto[x-placement^=top]>.arrow:before{bottom:0;border-width:.5rem .5rem 0;border-top-color:#00000040}.hsl .bs-popover-top>.arrow:after,.hsl .bs-popover-auto[x-placement^=top]>.arrow:after{bottom:1px;border-width:.5rem .5rem 0;border-top-color:var(--white)}.hsl .bs-popover-right,.hsl .bs-popover-auto[x-placement^=right]{margin-left:.5rem}.hsl .bs-popover-right>.arrow,.hsl .bs-popover-auto[x-placement^=right]>.arrow{left:calc(-.5rem - 1px);width:.5rem;height:1rem;margin:.3rem 0}.hsl .bs-popover-right>.arrow:before,.hsl .bs-popover-auto[x-placement^=right]>.arrow:before{left:0;border-width:.5rem .5rem .5rem 0;border-right-color:#00000040}.hsl .bs-popover-right>.arrow:after,.hsl .bs-popover-auto[x-placement^=right]>.arrow:after{left:1px;border-width:.5rem .5rem .5rem 0;border-right-color:var(--white)}.hsl .bs-popover-bottom,.hsl .bs-popover-auto[x-placement^=bottom]{margin-top:.5rem}.hsl .bs-popover-bottom>.arrow,.hsl .bs-popover-auto[x-placement^=bottom]>.arrow{top:calc(-.5rem - 1px)}.hsl .bs-popover-bottom>.arrow:before,.hsl .bs-popover-auto[x-placement^=bottom]>.arrow:before{top:0;border-width:0 .5rem .5rem .5rem;border-bottom-color:#00000040}.hsl .bs-popover-bottom>.arrow:after,.hsl .bs-popover-auto[x-placement^=bottom]>.arrow:after{top:1px;border-width:0 .5rem .5rem .5rem;border-bottom-color:var(--white)}.hsl .bs-popover-bottom .popover-header:before,.hsl .bs-popover-auto[x-placement^=bottom] .popover-header:before{position:absolute;top:0;left:50%;display:block;width:1rem;margin-left:-.5rem;content:\"\";border-bottom:1px solid hsla(var(--white-h),var(--white-s),calc(var(--white-l) + -3%),1);border-bottom:1px solid hsla(var(--white-h),var(--white-s),calc(var(--white-l) + -3%),var(--white-a, 1))}.hsl .bs-popover-left,.hsl .bs-popover-auto[x-placement^=left]{margin-right:.5rem}.hsl .bs-popover-left>.arrow,.hsl .bs-popover-auto[x-placement^=left]>.arrow{right:calc(-.5rem - 1px);width:.5rem;height:1rem;margin:.3rem 0}.hsl .bs-popover-left>.arrow:before,.hsl .bs-popover-auto[x-placement^=left]>.arrow:before{right:0;border-width:.5rem 0 .5rem .5rem;border-left-color:#00000040}.hsl .bs-popover-left>.arrow:after,.hsl .bs-popover-auto[x-placement^=left]>.arrow:after{right:1px;border-width:.5rem 0 .5rem .5rem;border-left-color:var(--white)}.hsl .popover-header{padding:.5rem .75rem;margin-bottom:0;font-size:1rem;background-color:hsla(var(--white-h),var(--white-s),calc(var(--white-l) + -3%),1);background-color:hsla(var(--white-h),var(--white-s),calc(var(--white-l) + -3%),var(--white-a, 1));border-bottom:1px solid hsla(var(--white-h),var(--white-s),calc(calc(var(--white-l) + -3%) + -5%),1);border-bottom:1px solid hsla(var(--white-h),var(--white-s),calc(calc(var(--white-l) + -3%) + -5%),var(--white-a, 1));border-top-left-radius:calc(.3rem - 1px);border-top-right-radius:calc(.3rem - 1px)}.hsl .popover-header:empty{display:none}.hsl .popover-body{padding:.5rem .75rem;color:var(--gray-900)}.hsl .align-baseline{vertical-align:baseline!important}.hsl .align-top{vertical-align:top!important}.hsl .align-middle{vertical-align:middle!important}.hsl .align-bottom{vertical-align:bottom!important}.hsl .align-text-bottom{vertical-align:text-bottom!important}.hsl .align-text-top{vertical-align:text-top!important}.hsl .bg-primary{background-color:var(--primary)!important}.hsl a.bg-primary:hover,.hsl a.bg-primary:focus,.hsl button.bg-primary:hover,.hsl button.bg-primary:focus{background-color:hsla(var(--primary-h),var(--primary-s),calc(var(--primary-l) + -10%),1)!important;background-color:hsla(var(--primary-h),var(--primary-s),calc(var(--primary-l) + -10%),var(--primary-a, 1))!important}.hsl .bg-secondary{background-color:var(--secondary)!important}.hsl a.bg-secondary:hover,.hsl a.bg-secondary:focus,.hsl button.bg-secondary:hover,.hsl button.bg-secondary:focus{background-color:hsla(var(--secondary-h),var(--secondary-s),calc(var(--secondary-l) + -10%),1)!important;background-color:hsla(var(--secondary-h),var(--secondary-s),calc(var(--secondary-l) + -10%),var(--secondary-a, 1))!important}.hsl .bg-success{background-color:#28a745!important}.hsl a.bg-success:hover,.hsl a.bg-success:focus,.hsl button.bg-success:hover,.hsl button.bg-success:focus{background-color:#24963e!important}.hsl .bg-info{background-color:#17a2b8!important}.hsl a.bg-info:hover,.hsl a.bg-info:focus,.hsl button.bg-info:hover,.hsl button.bg-info:focus{background-color:#1592a6!important}.hsl .bg-warning{background-color:#ffc107!important}.hsl a.bg-warning:hover,.hsl a.bg-warning:focus,.hsl button.bg-warning:hover,.hsl button.bg-warning:focus{background-color:#ecb100!important}.hsl .bg-danger{background-color:#dc3545!important}.hsl a.bg-danger:hover,.hsl a.bg-danger:focus,.hsl button.bg-danger:hover,.hsl button.bg-danger:focus{background-color:#d12435!important}.hsl .bg-light{background-color:var(--light)!important}.hsl a.bg-light:hover,.hsl a.bg-light:focus,.hsl button.bg-light:hover,.hsl button.bg-light:focus{background-color:hsla(var(--light-h),var(--light-s),calc(var(--light-l) + -10%),1)!important;background-color:hsla(var(--light-h),var(--light-s),calc(var(--light-l) + -10%),var(--light-a, 1))!important}.hsl .bg-dark{background-color:var(--gray-800)!important}.hsl a.bg-dark:hover,.hsl a.bg-dark:focus,.hsl button.bg-dark:hover,.hsl button.bg-dark:focus{background-color:hsla(var(--gray-800-h),var(--gray-800-s),calc(var(--gray-800-l) + -10%),1)!important;background-color:hsla(var(--gray-800-h),var(--gray-800-s),calc(var(--gray-800-l) + -10%),var(--gray-800-a, 1))!important}.hsl .bg-gray{background-color:var(--gray-900)!important}.hsl a.bg-gray:hover,.hsl a.bg-gray:focus,.hsl button.bg-gray:hover,.hsl button.bg-gray:focus{background-color:hsla(var(--gray-900-h),var(--gray-900-s),calc(var(--gray-900-l) + -10%),1)!important;background-color:hsla(var(--gray-900-h),var(--gray-900-s),calc(var(--gray-900-l) + -10%),var(--gray-900-a, 1))!important}.hsl .bg-white{background-color:var(--white)!important}.hsl .bg-transparent{background-color:transparent!important}.hsl .border{border:1px solid #dee2e6!important}.hsl .border-top{border-top:1px solid #dee2e6!important}.hsl .border-right{border-right:1px solid #dee2e6!important}.hsl .border-bottom{border-bottom:1px solid #dee2e6!important}.hsl .border-left{border-left:1px solid #dee2e6!important}.hsl .border-0{border:0!important}.hsl .border-top-0{border-top:0!important}.hsl .border-right-0{border-right:0!important}.hsl .border-bottom-0{border-bottom:0!important}.hsl .border-left-0{border-left:0!important}.hsl .border-primary{border-color:var(--primary)!important}.hsl .border-secondary{border-color:var(--secondary)!important}.hsl .border-success{border-color:#28a745!important}.hsl .border-info{border-color:#17a2b8!important}.hsl .border-warning{border-color:#ffc107!important}.hsl .border-danger{border-color:#dc3545!important}.hsl .border-light{border-color:var(--light)!important}.hsl .border-dark{border-color:var(--gray-800)!important}.hsl .border-gray{border-color:var(--gray-900)!important}.hsl .border-white{border-color:var(--white)!important}.hsl .rounded-sm{border-radius:.2rem!important}.hsl .rounded{border-radius:.25rem!important}.hsl .rounded-top{border-top-left-radius:.25rem!important;border-top-right-radius:.25rem!important}.hsl .rounded-right{border-top-right-radius:.25rem!important;border-bottom-right-radius:.25rem!important}.hsl .rounded-bottom{border-bottom-right-radius:.25rem!important;border-bottom-left-radius:.25rem!important}.hsl .rounded-left{border-top-left-radius:.25rem!important;border-bottom-left-radius:.25rem!important}.hsl .rounded-lg{border-radius:.3rem!important}.hsl .rounded-circle{border-radius:50%!important}.hsl .rounded-pill{border-radius:50rem!important}.hsl .rounded-0{border-radius:0!important}.hsl .clearfix:after{display:block;clear:both;content:\"\"}.hsl .d-none{display:none!important}.hsl .d-inline{display:inline!important}.hsl .d-inline-block{display:inline-block!important}.hsl .d-block{display:block!important}.hsl .d-table{display:table!important}.hsl .d-table-row{display:table-row!important}.hsl .d-table-cell{display:table-cell!important}.hsl .d-flex{display:flex!important}.hsl .d-inline-flex{display:inline-flex!important}@media (min-width: 576px){.hsl .d-sm-none{display:none!important}.hsl .d-sm-inline{display:inline!important}.hsl .d-sm-inline-block{display:inline-block!important}.hsl .d-sm-block{display:block!important}.hsl .d-sm-table{display:table!important}.hsl .d-sm-table-row{display:table-row!important}.hsl .d-sm-table-cell{display:table-cell!important}.hsl .d-sm-flex{display:flex!important}.hsl .d-sm-inline-flex{display:inline-flex!important}}@media (min-width: 768px){.hsl .d-md-none{display:none!important}.hsl .d-md-inline{display:inline!important}.hsl .d-md-inline-block{display:inline-block!important}.hsl .d-md-block{display:block!important}.hsl .d-md-table{display:table!important}.hsl .d-md-table-row{display:table-row!important}.hsl .d-md-table-cell{display:table-cell!important}.hsl .d-md-flex{display:flex!important}.hsl .d-md-inline-flex{display:inline-flex!important}}@media (min-width: 992px){.hsl .d-lg-none{display:none!important}.hsl .d-lg-inline{display:inline!important}.hsl .d-lg-inline-block{display:inline-block!important}.hsl .d-lg-block{display:block!important}.hsl .d-lg-table{display:table!important}.hsl .d-lg-table-row{display:table-row!important}.hsl .d-lg-table-cell{display:table-cell!important}.hsl .d-lg-flex{display:flex!important}.hsl .d-lg-inline-flex{display:inline-flex!important}}@media (min-width: 1200px){.hsl .d-xl-none{display:none!important}.hsl .d-xl-inline{display:inline!important}.hsl .d-xl-inline-block{display:inline-block!important}.hsl .d-xl-block{display:block!important}.hsl .d-xl-table{display:table!important}.hsl .d-xl-table-row{display:table-row!important}.hsl .d-xl-table-cell{display:table-cell!important}.hsl .d-xl-flex{display:flex!important}.hsl .d-xl-inline-flex{display:inline-flex!important}}@media print{.hsl .d-print-none{display:none!important}.hsl .d-print-inline{display:inline!important}.hsl .d-print-inline-block{display:inline-block!important}.hsl .d-print-block{display:block!important}.hsl .d-print-table{display:table!important}.hsl .d-print-table-row{display:table-row!important}.hsl .d-print-table-cell{display:table-cell!important}.hsl .d-print-flex{display:flex!important}.hsl .d-print-inline-flex{display:inline-flex!important}}.hsl .embed-responsive{position:relative;display:block;width:100%;padding:0;overflow:hidden}.hsl .embed-responsive:before{display:block;content:\"\"}.hsl .embed-responsive .embed-responsive-item,.hsl .embed-responsive iframe,.hsl .embed-responsive embed,.hsl .embed-responsive object,.hsl .embed-responsive video{position:absolute;top:0;bottom:0;left:0;width:100%;height:100%;border:0}.hsl .embed-responsive-21by9:before{padding-top:42.8571428571%}.hsl .embed-responsive-16by9:before{padding-top:56.25%}.hsl .embed-responsive-4by3:before{padding-top:75%}.hsl .embed-responsive-1by1:before{padding-top:100%}.hsl .flex-row{flex-direction:row!important}.hsl .flex-column{flex-direction:column!important}.hsl .flex-row-reverse{flex-direction:row-reverse!important}.hsl .flex-column-reverse{flex-direction:column-reverse!important}.hsl .flex-wrap{flex-wrap:wrap!important}.hsl .flex-nowrap{flex-wrap:nowrap!important}.hsl .flex-wrap-reverse{flex-wrap:wrap-reverse!important}.hsl .flex-fill{flex:1 1 auto!important}.hsl .flex-grow-0{flex-grow:0!important}.hsl .flex-grow-1{flex-grow:1!important}.hsl .flex-shrink-0{flex-shrink:0!important}.hsl .flex-shrink-1{flex-shrink:1!important}.hsl .justify-content-start{justify-content:flex-start!important}.hsl .justify-content-end{justify-content:flex-end!important}.hsl .justify-content-center{justify-content:center!important}.hsl .justify-content-between{justify-content:space-between!important}.hsl .justify-content-around{justify-content:space-around!important}.hsl .align-items-start{align-items:flex-start!important}.hsl .align-items-end{align-items:flex-end!important}.hsl .align-items-center{align-items:center!important}.hsl .align-items-baseline{align-items:baseline!important}.hsl .align-items-stretch{align-items:stretch!important}.hsl .align-content-start{align-content:flex-start!important}.hsl .align-content-end{align-content:flex-end!important}.hsl .align-content-center{align-content:center!important}.hsl .align-content-between{align-content:space-between!important}.hsl .align-content-around{align-content:space-around!important}.hsl .align-content-stretch{align-content:stretch!important}.hsl .align-self-auto{align-self:auto!important}.hsl .align-self-start{align-self:flex-start!important}.hsl .align-self-end{align-self:flex-end!important}.hsl .align-self-center{align-self:center!important}.hsl .align-self-baseline{align-self:baseline!important}.hsl .align-self-stretch{align-self:stretch!important}@media (min-width: 576px){.hsl .flex-sm-row{flex-direction:row!important}.hsl .flex-sm-column{flex-direction:column!important}.hsl .flex-sm-row-reverse{flex-direction:row-reverse!important}.hsl .flex-sm-column-reverse{flex-direction:column-reverse!important}.hsl .flex-sm-wrap{flex-wrap:wrap!important}.hsl .flex-sm-nowrap{flex-wrap:nowrap!important}.hsl .flex-sm-wrap-reverse{flex-wrap:wrap-reverse!important}.hsl .flex-sm-fill{flex:1 1 auto!important}.hsl .flex-sm-grow-0{flex-grow:0!important}.hsl .flex-sm-grow-1{flex-grow:1!important}.hsl .flex-sm-shrink-0{flex-shrink:0!important}.hsl .flex-sm-shrink-1{flex-shrink:1!important}.hsl .justify-content-sm-start{justify-content:flex-start!important}.hsl .justify-content-sm-end{justify-content:flex-end!important}.hsl .justify-content-sm-center{justify-content:center!important}.hsl .justify-content-sm-between{justify-content:space-between!important}.hsl .justify-content-sm-around{justify-content:space-around!important}.hsl .align-items-sm-start{align-items:flex-start!important}.hsl .align-items-sm-end{align-items:flex-end!important}.hsl .align-items-sm-center{align-items:center!important}.hsl .align-items-sm-baseline{align-items:baseline!important}.hsl .align-items-sm-stretch{align-items:stretch!important}.hsl .align-content-sm-start{align-content:flex-start!important}.hsl .align-content-sm-end{align-content:flex-end!important}.hsl .align-content-sm-center{align-content:center!important}.hsl .align-content-sm-between{align-content:space-between!important}.hsl .align-content-sm-around{align-content:space-around!important}.hsl .align-content-sm-stretch{align-content:stretch!important}.hsl .align-self-sm-auto{align-self:auto!important}.hsl .align-self-sm-start{align-self:flex-start!important}.hsl .align-self-sm-end{align-self:flex-end!important}.hsl .align-self-sm-center{align-self:center!important}.hsl .align-self-sm-baseline{align-self:baseline!important}.hsl .align-self-sm-stretch{align-self:stretch!important}}@media (min-width: 768px){.hsl .flex-md-row{flex-direction:row!important}.hsl .flex-md-column{flex-direction:column!important}.hsl .flex-md-row-reverse{flex-direction:row-reverse!important}.hsl .flex-md-column-reverse{flex-direction:column-reverse!important}.hsl .flex-md-wrap{flex-wrap:wrap!important}.hsl .flex-md-nowrap{flex-wrap:nowrap!important}.hsl .flex-md-wrap-reverse{flex-wrap:wrap-reverse!important}.hsl .flex-md-fill{flex:1 1 auto!important}.hsl .flex-md-grow-0{flex-grow:0!important}.hsl .flex-md-grow-1{flex-grow:1!important}.hsl .flex-md-shrink-0{flex-shrink:0!important}.hsl .flex-md-shrink-1{flex-shrink:1!important}.hsl .justify-content-md-start{justify-content:flex-start!important}.hsl .justify-content-md-end{justify-content:flex-end!important}.hsl .justify-content-md-center{justify-content:center!important}.hsl .justify-content-md-between{justify-content:space-between!important}.hsl .justify-content-md-around{justify-content:space-around!important}.hsl .align-items-md-start{align-items:flex-start!important}.hsl .align-items-md-end{align-items:flex-end!important}.hsl .align-items-md-center{align-items:center!important}.hsl .align-items-md-baseline{align-items:baseline!important}.hsl .align-items-md-stretch{align-items:stretch!important}.hsl .align-content-md-start{align-content:flex-start!important}.hsl .align-content-md-end{align-content:flex-end!important}.hsl .align-content-md-center{align-content:center!important}.hsl .align-content-md-between{align-content:space-between!important}.hsl .align-content-md-around{align-content:space-around!important}.hsl .align-content-md-stretch{align-content:stretch!important}.hsl .align-self-md-auto{align-self:auto!important}.hsl .align-self-md-start{align-self:flex-start!important}.hsl .align-self-md-end{align-self:flex-end!important}.hsl .align-self-md-center{align-self:center!important}.hsl .align-self-md-baseline{align-self:baseline!important}.hsl .align-self-md-stretch{align-self:stretch!important}}@media (min-width: 992px){.hsl .flex-lg-row{flex-direction:row!important}.hsl .flex-lg-column{flex-direction:column!important}.hsl .flex-lg-row-reverse{flex-direction:row-reverse!important}.hsl .flex-lg-column-reverse{flex-direction:column-reverse!important}.hsl .flex-lg-wrap{flex-wrap:wrap!important}.hsl .flex-lg-nowrap{flex-wrap:nowrap!important}.hsl .flex-lg-wrap-reverse{flex-wrap:wrap-reverse!important}.hsl .flex-lg-fill{flex:1 1 auto!important}.hsl .flex-lg-grow-0{flex-grow:0!important}.hsl .flex-lg-grow-1{flex-grow:1!important}.hsl .flex-lg-shrink-0{flex-shrink:0!important}.hsl .flex-lg-shrink-1{flex-shrink:1!important}.hsl .justify-content-lg-start{justify-content:flex-start!important}.hsl .justify-content-lg-end{justify-content:flex-end!important}.hsl .justify-content-lg-center{justify-content:center!important}.hsl .justify-content-lg-between{justify-content:space-between!important}.hsl .justify-content-lg-around{justify-content:space-around!important}.hsl .align-items-lg-start{align-items:flex-start!important}.hsl .align-items-lg-end{align-items:flex-end!important}.hsl .align-items-lg-center{align-items:center!important}.hsl .align-items-lg-baseline{align-items:baseline!important}.hsl .align-items-lg-stretch{align-items:stretch!important}.hsl .align-content-lg-start{align-content:flex-start!important}.hsl .align-content-lg-end{align-content:flex-end!important}.hsl .align-content-lg-center{align-content:center!important}.hsl .align-content-lg-between{align-content:space-between!important}.hsl .align-content-lg-around{align-content:space-around!important}.hsl .align-content-lg-stretch{align-content:stretch!important}.hsl .align-self-lg-auto{align-self:auto!important}.hsl .align-self-lg-start{align-self:flex-start!important}.hsl .align-self-lg-end{align-self:flex-end!important}.hsl .align-self-lg-center{align-self:center!important}.hsl .align-self-lg-baseline{align-self:baseline!important}.hsl .align-self-lg-stretch{align-self:stretch!important}}@media (min-width: 1200px){.hsl .flex-xl-row{flex-direction:row!important}.hsl .flex-xl-column{flex-direction:column!important}.hsl .flex-xl-row-reverse{flex-direction:row-reverse!important}.hsl .flex-xl-column-reverse{flex-direction:column-reverse!important}.hsl .flex-xl-wrap{flex-wrap:wrap!important}.hsl .flex-xl-nowrap{flex-wrap:nowrap!important}.hsl .flex-xl-wrap-reverse{flex-wrap:wrap-reverse!important}.hsl .flex-xl-fill{flex:1 1 auto!important}.hsl .flex-xl-grow-0{flex-grow:0!important}.hsl .flex-xl-grow-1{flex-grow:1!important}.hsl .flex-xl-shrink-0{flex-shrink:0!important}.hsl .flex-xl-shrink-1{flex-shrink:1!important}.hsl .justify-content-xl-start{justify-content:flex-start!important}.hsl .justify-content-xl-end{justify-content:flex-end!important}.hsl .justify-content-xl-center{justify-content:center!important}.hsl .justify-content-xl-between{justify-content:space-between!important}.hsl .justify-content-xl-around{justify-content:space-around!important}.hsl .align-items-xl-start{align-items:flex-start!important}.hsl .align-items-xl-end{align-items:flex-end!important}.hsl .align-items-xl-center{align-items:center!important}.hsl .align-items-xl-baseline{align-items:baseline!important}.hsl .align-items-xl-stretch{align-items:stretch!important}.hsl .align-content-xl-start{align-content:flex-start!important}.hsl .align-content-xl-end{align-content:flex-end!important}.hsl .align-content-xl-center{align-content:center!important}.hsl .align-content-xl-between{align-content:space-between!important}.hsl .align-content-xl-around{align-content:space-around!important}.hsl .align-content-xl-stretch{align-content:stretch!important}.hsl .align-self-xl-auto{align-self:auto!important}.hsl .align-self-xl-start{align-self:flex-start!important}.hsl .align-self-xl-end{align-self:flex-end!important}.hsl .align-self-xl-center{align-self:center!important}.hsl .align-self-xl-baseline{align-self:baseline!important}.hsl .align-self-xl-stretch{align-self:stretch!important}}.hsl .float-left{float:left!important}.hsl .float-right{float:right!important}.hsl .float-none{float:none!important}@media (min-width: 576px){.hsl .float-sm-left{float:left!important}.hsl .float-sm-right{float:right!important}.hsl .float-sm-none{float:none!important}}@media (min-width: 768px){.hsl .float-md-left{float:left!important}.hsl .float-md-right{float:right!important}.hsl .float-md-none{float:none!important}}@media (min-width: 992px){.hsl .float-lg-left{float:left!important}.hsl .float-lg-right{float:right!important}.hsl .float-lg-none{float:none!important}}@media (min-width: 1200px){.hsl .float-xl-left{float:left!important}.hsl .float-xl-right{float:right!important}.hsl .float-xl-none{float:none!important}}.hsl .user-select-all{-webkit-user-select:all!important;-moz-user-select:all!important;user-select:all!important}.hsl .user-select-auto{-webkit-user-select:auto!important;-moz-user-select:auto!important;user-select:auto!important}.hsl .user-select-none{-webkit-user-select:none!important;-moz-user-select:none!important;user-select:none!important}.hsl .overflow-auto{overflow:auto!important}.hsl .overflow-hidden{overflow:hidden!important}.hsl .position-static{position:static!important}.hsl .position-relative{position:relative!important}.hsl .position-absolute{position:absolute!important}.hsl .position-fixed{position:fixed!important}.hsl .position-sticky{position:sticky!important}.hsl .fixed-top{position:fixed;top:0;right:0;left:0;z-index:1030}.hsl .fixed-bottom{position:fixed;right:0;bottom:0;left:0;z-index:1030}@supports (position: sticky){.hsl .sticky-top{position:sticky;top:0;z-index:1020}}.hsl .sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0}.hsl .sr-only-focusable:active,.hsl .sr-only-focusable:focus{position:static;width:auto;height:auto;overflow:visible;clip:auto;white-space:normal}.hsl .shadow-sm{box-shadow:0 .125rem .25rem #00000013!important}.hsl .shadow{box-shadow:0 .5rem 1rem #00000026!important}.hsl .shadow-lg{box-shadow:0 1rem 3rem #0000002d!important}.hsl .shadow-none{box-shadow:none!important}.hsl .w-25{width:25%!important}.hsl .w-50{width:50%!important}.hsl .w-75{width:75%!important}.hsl .w-100{width:100%!important}.hsl .w-auto{width:auto!important}.hsl .h-25{height:25%!important}.hsl .h-50{height:50%!important}.hsl .h-75{height:75%!important}.hsl .h-100{height:100%!important}.hsl .h-auto{height:auto!important}.hsl .mw-100{max-width:100%!important}.hsl .mh-100{max-height:100%!important}.hsl .min-vw-100{min-width:100vw!important}.hsl .min-vh-100{min-height:100vh!important}.hsl .vw-100{width:100vw!important}.hsl .vh-100{height:100vh!important}.hsl .m-0{margin:0!important}.hsl .mt-0,.hsl .my-0{margin-top:0!important}.hsl .mr-0,.hsl .mx-0{margin-right:0!important}.hsl .mb-0,.hsl .my-0{margin-bottom:0!important}.hsl .ml-0,.hsl .mx-0{margin-left:0!important}.hsl .m-1{margin:.25rem!important}.hsl .mt-1,.hsl .my-1{margin-top:.25rem!important}.hsl .mr-1,.hsl .mx-1{margin-right:.25rem!important}.hsl .mb-1,.hsl .my-1{margin-bottom:.25rem!important}.hsl .ml-1,.hsl .mx-1{margin-left:.25rem!important}.hsl .m-2{margin:.5rem!important}.hsl .mt-2,.hsl .my-2{margin-top:.5rem!important}.hsl .mr-2,.hsl .mx-2{margin-right:.5rem!important}.hsl .mb-2,.hsl .my-2{margin-bottom:.5rem!important}.hsl .ml-2,.hsl .mx-2{margin-left:.5rem!important}.hsl .m-3{margin:1rem!important}.hsl .mt-3,.hsl .my-3{margin-top:1rem!important}.hsl .mr-3,.hsl .mx-3{margin-right:1rem!important}.hsl .mb-3,.hsl .my-3{margin-bottom:1rem!important}.hsl .ml-3,.hsl .mx-3{margin-left:1rem!important}.hsl .m-4{margin:1.5rem!important}.hsl .mt-4,.hsl .my-4{margin-top:1.5rem!important}.hsl .mr-4,.hsl .mx-4{margin-right:1.5rem!important}.hsl .mb-4,.hsl .my-4{margin-bottom:1.5rem!important}.hsl .ml-4,.hsl .mx-4{margin-left:1.5rem!important}.hsl .m-5{margin:3rem!important}.hsl .mt-5,.hsl .my-5{margin-top:3rem!important}.hsl .mr-5,.hsl .mx-5{margin-right:3rem!important}.hsl .mb-5,.hsl .my-5{margin-bottom:3rem!important}.hsl .ml-5,.hsl .mx-5{margin-left:3rem!important}.hsl .p-0{padding:0!important}.hsl .pt-0,.hsl .py-0{padding-top:0!important}.hsl .pr-0,.hsl .px-0{padding-right:0!important}.hsl .pb-0,.hsl .py-0{padding-bottom:0!important}.hsl .pl-0,.hsl .px-0{padding-left:0!important}.hsl .p-1{padding:.25rem!important}.hsl .pt-1,.hsl .py-1{padding-top:.25rem!important}.hsl .pr-1,.hsl .px-1{padding-right:.25rem!important}.hsl .pb-1,.hsl .py-1{padding-bottom:.25rem!important}.hsl .pl-1,.hsl .px-1{padding-left:.25rem!important}.hsl .p-2{padding:.5rem!important}.hsl .pt-2,.hsl .py-2{padding-top:.5rem!important}.hsl .pr-2,.hsl .px-2{padding-right:.5rem!important}.hsl .pb-2,.hsl .py-2{padding-bottom:.5rem!important}.hsl .pl-2,.hsl .px-2{padding-left:.5rem!important}.hsl .p-3{padding:1rem!important}.hsl .pt-3,.hsl .py-3{padding-top:1rem!important}.hsl .pr-3,.hsl .px-3{padding-right:1rem!important}.hsl .pb-3,.hsl .py-3{padding-bottom:1rem!important}.hsl .pl-3,.hsl .px-3{padding-left:1rem!important}.hsl .p-4{padding:1.5rem!important}.hsl .pt-4,.hsl .py-4{padding-top:1.5rem!important}.hsl .pr-4,.hsl .px-4{padding-right:1.5rem!important}.hsl .pb-4,.hsl .py-4{padding-bottom:1.5rem!important}.hsl .pl-4,.hsl .px-4{padding-left:1.5rem!important}.hsl .p-5{padding:3rem!important}.hsl .pt-5,.hsl .py-5{padding-top:3rem!important}.hsl .pr-5,.hsl .px-5{padding-right:3rem!important}.hsl .pb-5,.hsl .py-5{padding-bottom:3rem!important}.hsl .pl-5,.hsl .px-5{padding-left:3rem!important}.hsl .m-n1{margin:-.25rem!important}.hsl .mt-n1,.hsl .my-n1{margin-top:-.25rem!important}.hsl .mr-n1,.hsl .mx-n1{margin-right:-.25rem!important}.hsl .mb-n1,.hsl .my-n1{margin-bottom:-.25rem!important}.hsl .ml-n1,.hsl .mx-n1{margin-left:-.25rem!important}.hsl .m-n2{margin:-.5rem!important}.hsl .mt-n2,.hsl .my-n2{margin-top:-.5rem!important}.hsl .mr-n2,.hsl .mx-n2{margin-right:-.5rem!important}.hsl .mb-n2,.hsl .my-n2{margin-bottom:-.5rem!important}.hsl .ml-n2,.hsl .mx-n2{margin-left:-.5rem!important}.hsl .m-n3{margin:-1rem!important}.hsl .mt-n3,.hsl .my-n3{margin-top:-1rem!important}.hsl .mr-n3,.hsl .mx-n3{margin-right:-1rem!important}.hsl .mb-n3,.hsl .my-n3{margin-bottom:-1rem!important}.hsl .ml-n3,.hsl .mx-n3{margin-left:-1rem!important}.hsl .m-n4{margin:-1.5rem!important}.hsl .mt-n4,.hsl .my-n4{margin-top:-1.5rem!important}.hsl .mr-n4,.hsl .mx-n4{margin-right:-1.5rem!important}.hsl .mb-n4,.hsl .my-n4{margin-bottom:-1.5rem!important}.hsl .ml-n4,.hsl .mx-n4{margin-left:-1.5rem!important}.hsl .m-n5{margin:-3rem!important}.hsl .mt-n5,.hsl .my-n5{margin-top:-3rem!important}.hsl .mr-n5,.hsl .mx-n5{margin-right:-3rem!important}.hsl .mb-n5,.hsl .my-n5{margin-bottom:-3rem!important}.hsl .ml-n5,.hsl .mx-n5{margin-left:-3rem!important}.hsl .m-auto{margin:auto!important}.hsl .mt-auto,.hsl .my-auto{margin-top:auto!important}.hsl .mr-auto,.hsl .mx-auto{margin-right:auto!important}.hsl .mb-auto,.hsl .my-auto{margin-bottom:auto!important}.hsl .ml-auto,.hsl .mx-auto{margin-left:auto!important}@media (min-width: 576px){.hsl .m-sm-0{margin:0!important}.hsl .mt-sm-0,.hsl .my-sm-0{margin-top:0!important}.hsl .mr-sm-0,.hsl .mx-sm-0{margin-right:0!important}.hsl .mb-sm-0,.hsl .my-sm-0{margin-bottom:0!important}.hsl .ml-sm-0,.hsl .mx-sm-0{margin-left:0!important}.hsl .m-sm-1{margin:.25rem!important}.hsl .mt-sm-1,.hsl .my-sm-1{margin-top:.25rem!important}.hsl .mr-sm-1,.hsl .mx-sm-1{margin-right:.25rem!important}.hsl .mb-sm-1,.hsl .my-sm-1{margin-bottom:.25rem!important}.hsl .ml-sm-1,.hsl .mx-sm-1{margin-left:.25rem!important}.hsl .m-sm-2{margin:.5rem!important}.hsl .mt-sm-2,.hsl .my-sm-2{margin-top:.5rem!important}.hsl .mr-sm-2,.hsl .mx-sm-2{margin-right:.5rem!important}.hsl .mb-sm-2,.hsl .my-sm-2{margin-bottom:.5rem!important}.hsl .ml-sm-2,.hsl .mx-sm-2{margin-left:.5rem!important}.hsl .m-sm-3{margin:1rem!important}.hsl .mt-sm-3,.hsl .my-sm-3{margin-top:1rem!important}.hsl .mr-sm-3,.hsl .mx-sm-3{margin-right:1rem!important}.hsl .mb-sm-3,.hsl .my-sm-3{margin-bottom:1rem!important}.hsl .ml-sm-3,.hsl .mx-sm-3{margin-left:1rem!important}.hsl .m-sm-4{margin:1.5rem!important}.hsl .mt-sm-4,.hsl .my-sm-4{margin-top:1.5rem!important}.hsl .mr-sm-4,.hsl .mx-sm-4{margin-right:1.5rem!important}.hsl .mb-sm-4,.hsl .my-sm-4{margin-bottom:1.5rem!important}.hsl .ml-sm-4,.hsl .mx-sm-4{margin-left:1.5rem!important}.hsl .m-sm-5{margin:3rem!important}.hsl .mt-sm-5,.hsl .my-sm-5{margin-top:3rem!important}.hsl .mr-sm-5,.hsl .mx-sm-5{margin-right:3rem!important}.hsl .mb-sm-5,.hsl .my-sm-5{margin-bottom:3rem!important}.hsl .ml-sm-5,.hsl .mx-sm-5{margin-left:3rem!important}.hsl .p-sm-0{padding:0!important}.hsl .pt-sm-0,.hsl .py-sm-0{padding-top:0!important}.hsl .pr-sm-0,.hsl .px-sm-0{padding-right:0!important}.hsl .pb-sm-0,.hsl .py-sm-0{padding-bottom:0!important}.hsl .pl-sm-0,.hsl .px-sm-0{padding-left:0!important}.hsl .p-sm-1{padding:.25rem!important}.hsl .pt-sm-1,.hsl .py-sm-1{padding-top:.25rem!important}.hsl .pr-sm-1,.hsl .px-sm-1{padding-right:.25rem!important}.hsl .pb-sm-1,.hsl .py-sm-1{padding-bottom:.25rem!important}.hsl .pl-sm-1,.hsl .px-sm-1{padding-left:.25rem!important}.hsl .p-sm-2{padding:.5rem!important}.hsl .pt-sm-2,.hsl .py-sm-2{padding-top:.5rem!important}.hsl .pr-sm-2,.hsl .px-sm-2{padding-right:.5rem!important}.hsl .pb-sm-2,.hsl .py-sm-2{padding-bottom:.5rem!important}.hsl .pl-sm-2,.hsl .px-sm-2{padding-left:.5rem!important}.hsl .p-sm-3{padding:1rem!important}.hsl .pt-sm-3,.hsl .py-sm-3{padding-top:1rem!important}.hsl .pr-sm-3,.hsl .px-sm-3{padding-right:1rem!important}.hsl .pb-sm-3,.hsl .py-sm-3{padding-bottom:1rem!important}.hsl .pl-sm-3,.hsl .px-sm-3{padding-left:1rem!important}.hsl .p-sm-4{padding:1.5rem!important}.hsl .pt-sm-4,.hsl .py-sm-4{padding-top:1.5rem!important}.hsl .pr-sm-4,.hsl .px-sm-4{padding-right:1.5rem!important}.hsl .pb-sm-4,.hsl .py-sm-4{padding-bottom:1.5rem!important}.hsl .pl-sm-4,.hsl .px-sm-4{padding-left:1.5rem!important}.hsl .p-sm-5{padding:3rem!important}.hsl .pt-sm-5,.hsl .py-sm-5{padding-top:3rem!important}.hsl .pr-sm-5,.hsl .px-sm-5{padding-right:3rem!important}.hsl .pb-sm-5,.hsl .py-sm-5{padding-bottom:3rem!important}.hsl .pl-sm-5,.hsl .px-sm-5{padding-left:3rem!important}.hsl .m-sm-n1{margin:-.25rem!important}.hsl .mt-sm-n1,.hsl .my-sm-n1{margin-top:-.25rem!important}.hsl .mr-sm-n1,.hsl .mx-sm-n1{margin-right:-.25rem!important}.hsl .mb-sm-n1,.hsl .my-sm-n1{margin-bottom:-.25rem!important}.hsl .ml-sm-n1,.hsl .mx-sm-n1{margin-left:-.25rem!important}.hsl .m-sm-n2{margin:-.5rem!important}.hsl .mt-sm-n2,.hsl .my-sm-n2{margin-top:-.5rem!important}.hsl .mr-sm-n2,.hsl .mx-sm-n2{margin-right:-.5rem!important}.hsl .mb-sm-n2,.hsl .my-sm-n2{margin-bottom:-.5rem!important}.hsl .ml-sm-n2,.hsl .mx-sm-n2{margin-left:-.5rem!important}.hsl .m-sm-n3{margin:-1rem!important}.hsl .mt-sm-n3,.hsl .my-sm-n3{margin-top:-1rem!important}.hsl .mr-sm-n3,.hsl .mx-sm-n3{margin-right:-1rem!important}.hsl .mb-sm-n3,.hsl .my-sm-n3{margin-bottom:-1rem!important}.hsl .ml-sm-n3,.hsl .mx-sm-n3{margin-left:-1rem!important}.hsl .m-sm-n4{margin:-1.5rem!important}.hsl .mt-sm-n4,.hsl .my-sm-n4{margin-top:-1.5rem!important}.hsl .mr-sm-n4,.hsl .mx-sm-n4{margin-right:-1.5rem!important}.hsl .mb-sm-n4,.hsl .my-sm-n4{margin-bottom:-1.5rem!important}.hsl .ml-sm-n4,.hsl .mx-sm-n4{margin-left:-1.5rem!important}.hsl .m-sm-n5{margin:-3rem!important}.hsl .mt-sm-n5,.hsl .my-sm-n5{margin-top:-3rem!important}.hsl .mr-sm-n5,.hsl .mx-sm-n5{margin-right:-3rem!important}.hsl .mb-sm-n5,.hsl .my-sm-n5{margin-bottom:-3rem!important}.hsl .ml-sm-n5,.hsl .mx-sm-n5{margin-left:-3rem!important}.hsl .m-sm-auto{margin:auto!important}.hsl .mt-sm-auto,.hsl .my-sm-auto{margin-top:auto!important}.hsl .mr-sm-auto,.hsl .mx-sm-auto{margin-right:auto!important}.hsl .mb-sm-auto,.hsl .my-sm-auto{margin-bottom:auto!important}.hsl .ml-sm-auto,.hsl .mx-sm-auto{margin-left:auto!important}}@media (min-width: 768px){.hsl .m-md-0{margin:0!important}.hsl .mt-md-0,.hsl .my-md-0{margin-top:0!important}.hsl .mr-md-0,.hsl .mx-md-0{margin-right:0!important}.hsl .mb-md-0,.hsl .my-md-0{margin-bottom:0!important}.hsl .ml-md-0,.hsl .mx-md-0{margin-left:0!important}.hsl .m-md-1{margin:.25rem!important}.hsl .mt-md-1,.hsl .my-md-1{margin-top:.25rem!important}.hsl .mr-md-1,.hsl .mx-md-1{margin-right:.25rem!important}.hsl .mb-md-1,.hsl .my-md-1{margin-bottom:.25rem!important}.hsl .ml-md-1,.hsl .mx-md-1{margin-left:.25rem!important}.hsl .m-md-2{margin:.5rem!important}.hsl .mt-md-2,.hsl .my-md-2{margin-top:.5rem!important}.hsl .mr-md-2,.hsl .mx-md-2{margin-right:.5rem!important}.hsl .mb-md-2,.hsl .my-md-2{margin-bottom:.5rem!important}.hsl .ml-md-2,.hsl .mx-md-2{margin-left:.5rem!important}.hsl .m-md-3{margin:1rem!important}.hsl .mt-md-3,.hsl .my-md-3{margin-top:1rem!important}.hsl .mr-md-3,.hsl .mx-md-3{margin-right:1rem!important}.hsl .mb-md-3,.hsl .my-md-3{margin-bottom:1rem!important}.hsl .ml-md-3,.hsl .mx-md-3{margin-left:1rem!important}.hsl .m-md-4{margin:1.5rem!important}.hsl .mt-md-4,.hsl .my-md-4{margin-top:1.5rem!important}.hsl .mr-md-4,.hsl .mx-md-4{margin-right:1.5rem!important}.hsl .mb-md-4,.hsl .my-md-4{margin-bottom:1.5rem!important}.hsl .ml-md-4,.hsl .mx-md-4{margin-left:1.5rem!important}.hsl .m-md-5{margin:3rem!important}.hsl .mt-md-5,.hsl .my-md-5{margin-top:3rem!important}.hsl .mr-md-5,.hsl .mx-md-5{margin-right:3rem!important}.hsl .mb-md-5,.hsl .my-md-5{margin-bottom:3rem!important}.hsl .ml-md-5,.hsl .mx-md-5{margin-left:3rem!important}.hsl .p-md-0{padding:0!important}.hsl .pt-md-0,.hsl .py-md-0{padding-top:0!important}.hsl .pr-md-0,.hsl .px-md-0{padding-right:0!important}.hsl .pb-md-0,.hsl .py-md-0{padding-bottom:0!important}.hsl .pl-md-0,.hsl .px-md-0{padding-left:0!important}.hsl .p-md-1{padding:.25rem!important}.hsl .pt-md-1,.hsl .py-md-1{padding-top:.25rem!important}.hsl .pr-md-1,.hsl .px-md-1{padding-right:.25rem!important}.hsl .pb-md-1,.hsl .py-md-1{padding-bottom:.25rem!important}.hsl .pl-md-1,.hsl .px-md-1{padding-left:.25rem!important}.hsl .p-md-2{padding:.5rem!important}.hsl .pt-md-2,.hsl .py-md-2{padding-top:.5rem!important}.hsl .pr-md-2,.hsl .px-md-2{padding-right:.5rem!important}.hsl .pb-md-2,.hsl .py-md-2{padding-bottom:.5rem!important}.hsl .pl-md-2,.hsl .px-md-2{padding-left:.5rem!important}.hsl .p-md-3{padding:1rem!important}.hsl .pt-md-3,.hsl .py-md-3{padding-top:1rem!important}.hsl .pr-md-3,.hsl .px-md-3{padding-right:1rem!important}.hsl .pb-md-3,.hsl .py-md-3{padding-bottom:1rem!important}.hsl .pl-md-3,.hsl .px-md-3{padding-left:1rem!important}.hsl .p-md-4{padding:1.5rem!important}.hsl .pt-md-4,.hsl .py-md-4{padding-top:1.5rem!important}.hsl .pr-md-4,.hsl .px-md-4{padding-right:1.5rem!important}.hsl .pb-md-4,.hsl .py-md-4{padding-bottom:1.5rem!important}.hsl .pl-md-4,.hsl .px-md-4{padding-left:1.5rem!important}.hsl .p-md-5{padding:3rem!important}.hsl .pt-md-5,.hsl .py-md-5{padding-top:3rem!important}.hsl .pr-md-5,.hsl .px-md-5{padding-right:3rem!important}.hsl .pb-md-5,.hsl .py-md-5{padding-bottom:3rem!important}.hsl .pl-md-5,.hsl .px-md-5{padding-left:3rem!important}.hsl .m-md-n1{margin:-.25rem!important}.hsl .mt-md-n1,.hsl .my-md-n1{margin-top:-.25rem!important}.hsl .mr-md-n1,.hsl .mx-md-n1{margin-right:-.25rem!important}.hsl .mb-md-n1,.hsl .my-md-n1{margin-bottom:-.25rem!important}.hsl .ml-md-n1,.hsl .mx-md-n1{margin-left:-.25rem!important}.hsl .m-md-n2{margin:-.5rem!important}.hsl .mt-md-n2,.hsl .my-md-n2{margin-top:-.5rem!important}.hsl .mr-md-n2,.hsl .mx-md-n2{margin-right:-.5rem!important}.hsl .mb-md-n2,.hsl .my-md-n2{margin-bottom:-.5rem!important}.hsl .ml-md-n2,.hsl .mx-md-n2{margin-left:-.5rem!important}.hsl .m-md-n3{margin:-1rem!important}.hsl .mt-md-n3,.hsl .my-md-n3{margin-top:-1rem!important}.hsl .mr-md-n3,.hsl .mx-md-n3{margin-right:-1rem!important}.hsl .mb-md-n3,.hsl .my-md-n3{margin-bottom:-1rem!important}.hsl .ml-md-n3,.hsl .mx-md-n3{margin-left:-1rem!important}.hsl .m-md-n4{margin:-1.5rem!important}.hsl .mt-md-n4,.hsl .my-md-n4{margin-top:-1.5rem!important}.hsl .mr-md-n4,.hsl .mx-md-n4{margin-right:-1.5rem!important}.hsl .mb-md-n4,.hsl .my-md-n4{margin-bottom:-1.5rem!important}.hsl .ml-md-n4,.hsl .mx-md-n4{margin-left:-1.5rem!important}.hsl .m-md-n5{margin:-3rem!important}.hsl .mt-md-n5,.hsl .my-md-n5{margin-top:-3rem!important}.hsl .mr-md-n5,.hsl .mx-md-n5{margin-right:-3rem!important}.hsl .mb-md-n5,.hsl .my-md-n5{margin-bottom:-3rem!important}.hsl .ml-md-n5,.hsl .mx-md-n5{margin-left:-3rem!important}.hsl .m-md-auto{margin:auto!important}.hsl .mt-md-auto,.hsl .my-md-auto{margin-top:auto!important}.hsl .mr-md-auto,.hsl .mx-md-auto{margin-right:auto!important}.hsl .mb-md-auto,.hsl .my-md-auto{margin-bottom:auto!important}.hsl .ml-md-auto,.hsl .mx-md-auto{margin-left:auto!important}}@media (min-width: 992px){.hsl .m-lg-0{margin:0!important}.hsl .mt-lg-0,.hsl .my-lg-0{margin-top:0!important}.hsl .mr-lg-0,.hsl .mx-lg-0{margin-right:0!important}.hsl .mb-lg-0,.hsl .my-lg-0{margin-bottom:0!important}.hsl .ml-lg-0,.hsl .mx-lg-0{margin-left:0!important}.hsl .m-lg-1{margin:.25rem!important}.hsl .mt-lg-1,.hsl .my-lg-1{margin-top:.25rem!important}.hsl .mr-lg-1,.hsl .mx-lg-1{margin-right:.25rem!important}.hsl .mb-lg-1,.hsl .my-lg-1{margin-bottom:.25rem!important}.hsl .ml-lg-1,.hsl .mx-lg-1{margin-left:.25rem!important}.hsl .m-lg-2{margin:.5rem!important}.hsl .mt-lg-2,.hsl .my-lg-2{margin-top:.5rem!important}.hsl .mr-lg-2,.hsl .mx-lg-2{margin-right:.5rem!important}.hsl .mb-lg-2,.hsl .my-lg-2{margin-bottom:.5rem!important}.hsl .ml-lg-2,.hsl .mx-lg-2{margin-left:.5rem!important}.hsl .m-lg-3{margin:1rem!important}.hsl .mt-lg-3,.hsl .my-lg-3{margin-top:1rem!important}.hsl .mr-lg-3,.hsl .mx-lg-3{margin-right:1rem!important}.hsl .mb-lg-3,.hsl .my-lg-3{margin-bottom:1rem!important}.hsl .ml-lg-3,.hsl .mx-lg-3{margin-left:1rem!important}.hsl .m-lg-4{margin:1.5rem!important}.hsl .mt-lg-4,.hsl .my-lg-4{margin-top:1.5rem!important}.hsl .mr-lg-4,.hsl .mx-lg-4{margin-right:1.5rem!important}.hsl .mb-lg-4,.hsl .my-lg-4{margin-bottom:1.5rem!important}.hsl .ml-lg-4,.hsl .mx-lg-4{margin-left:1.5rem!important}.hsl .m-lg-5{margin:3rem!important}.hsl .mt-lg-5,.hsl .my-lg-5{margin-top:3rem!important}.hsl .mr-lg-5,.hsl .mx-lg-5{margin-right:3rem!important}.hsl .mb-lg-5,.hsl .my-lg-5{margin-bottom:3rem!important}.hsl .ml-lg-5,.hsl .mx-lg-5{margin-left:3rem!important}.hsl .p-lg-0{padding:0!important}.hsl .pt-lg-0,.hsl .py-lg-0{padding-top:0!important}.hsl .pr-lg-0,.hsl .px-lg-0{padding-right:0!important}.hsl .pb-lg-0,.hsl .py-lg-0{padding-bottom:0!important}.hsl .pl-lg-0,.hsl .px-lg-0{padding-left:0!important}.hsl .p-lg-1{padding:.25rem!important}.hsl .pt-lg-1,.hsl .py-lg-1{padding-top:.25rem!important}.hsl .pr-lg-1,.hsl .px-lg-1{padding-right:.25rem!important}.hsl .pb-lg-1,.hsl .py-lg-1{padding-bottom:.25rem!important}.hsl .pl-lg-1,.hsl .px-lg-1{padding-left:.25rem!important}.hsl .p-lg-2{padding:.5rem!important}.hsl .pt-lg-2,.hsl .py-lg-2{padding-top:.5rem!important}.hsl .pr-lg-2,.hsl .px-lg-2{padding-right:.5rem!important}.hsl .pb-lg-2,.hsl .py-lg-2{padding-bottom:.5rem!important}.hsl .pl-lg-2,.hsl .px-lg-2{padding-left:.5rem!important}.hsl .p-lg-3{padding:1rem!important}.hsl .pt-lg-3,.hsl .py-lg-3{padding-top:1rem!important}.hsl .pr-lg-3,.hsl .px-lg-3{padding-right:1rem!important}.hsl .pb-lg-3,.hsl .py-lg-3{padding-bottom:1rem!important}.hsl .pl-lg-3,.hsl .px-lg-3{padding-left:1rem!important}.hsl .p-lg-4{padding:1.5rem!important}.hsl .pt-lg-4,.hsl .py-lg-4{padding-top:1.5rem!important}.hsl .pr-lg-4,.hsl .px-lg-4{padding-right:1.5rem!important}.hsl .pb-lg-4,.hsl .py-lg-4{padding-bottom:1.5rem!important}.hsl .pl-lg-4,.hsl .px-lg-4{padding-left:1.5rem!important}.hsl .p-lg-5{padding:3rem!important}.hsl .pt-lg-5,.hsl .py-lg-5{padding-top:3rem!important}.hsl .pr-lg-5,.hsl .px-lg-5{padding-right:3rem!important}.hsl .pb-lg-5,.hsl .py-lg-5{padding-bottom:3rem!important}.hsl .pl-lg-5,.hsl .px-lg-5{padding-left:3rem!important}.hsl .m-lg-n1{margin:-.25rem!important}.hsl .mt-lg-n1,.hsl .my-lg-n1{margin-top:-.25rem!important}.hsl .mr-lg-n1,.hsl .mx-lg-n1{margin-right:-.25rem!important}.hsl .mb-lg-n1,.hsl .my-lg-n1{margin-bottom:-.25rem!important}.hsl .ml-lg-n1,.hsl .mx-lg-n1{margin-left:-.25rem!important}.hsl .m-lg-n2{margin:-.5rem!important}.hsl .mt-lg-n2,.hsl .my-lg-n2{margin-top:-.5rem!important}.hsl .mr-lg-n2,.hsl .mx-lg-n2{margin-right:-.5rem!important}.hsl .mb-lg-n2,.hsl .my-lg-n2{margin-bottom:-.5rem!important}.hsl .ml-lg-n2,.hsl .mx-lg-n2{margin-left:-.5rem!important}.hsl .m-lg-n3{margin:-1rem!important}.hsl .mt-lg-n3,.hsl .my-lg-n3{margin-top:-1rem!important}.hsl .mr-lg-n3,.hsl .mx-lg-n3{margin-right:-1rem!important}.hsl .mb-lg-n3,.hsl .my-lg-n3{margin-bottom:-1rem!important}.hsl .ml-lg-n3,.hsl .mx-lg-n3{margin-left:-1rem!important}.hsl .m-lg-n4{margin:-1.5rem!important}.hsl .mt-lg-n4,.hsl .my-lg-n4{margin-top:-1.5rem!important}.hsl .mr-lg-n4,.hsl .mx-lg-n4{margin-right:-1.5rem!important}.hsl .mb-lg-n4,.hsl .my-lg-n4{margin-bottom:-1.5rem!important}.hsl .ml-lg-n4,.hsl .mx-lg-n4{margin-left:-1.5rem!important}.hsl .m-lg-n5{margin:-3rem!important}.hsl .mt-lg-n5,.hsl .my-lg-n5{margin-top:-3rem!important}.hsl .mr-lg-n5,.hsl .mx-lg-n5{margin-right:-3rem!important}.hsl .mb-lg-n5,.hsl .my-lg-n5{margin-bottom:-3rem!important}.hsl .ml-lg-n5,.hsl .mx-lg-n5{margin-left:-3rem!important}.hsl .m-lg-auto{margin:auto!important}.hsl .mt-lg-auto,.hsl .my-lg-auto{margin-top:auto!important}.hsl .mr-lg-auto,.hsl .mx-lg-auto{margin-right:auto!important}.hsl .mb-lg-auto,.hsl .my-lg-auto{margin-bottom:auto!important}.hsl .ml-lg-auto,.hsl .mx-lg-auto{margin-left:auto!important}}@media (min-width: 1200px){.hsl .m-xl-0{margin:0!important}.hsl .mt-xl-0,.hsl .my-xl-0{margin-top:0!important}.hsl .mr-xl-0,.hsl .mx-xl-0{margin-right:0!important}.hsl .mb-xl-0,.hsl .my-xl-0{margin-bottom:0!important}.hsl .ml-xl-0,.hsl .mx-xl-0{margin-left:0!important}.hsl .m-xl-1{margin:.25rem!important}.hsl .mt-xl-1,.hsl .my-xl-1{margin-top:.25rem!important}.hsl .mr-xl-1,.hsl .mx-xl-1{margin-right:.25rem!important}.hsl .mb-xl-1,.hsl .my-xl-1{margin-bottom:.25rem!important}.hsl .ml-xl-1,.hsl .mx-xl-1{margin-left:.25rem!important}.hsl .m-xl-2{margin:.5rem!important}.hsl .mt-xl-2,.hsl .my-xl-2{margin-top:.5rem!important}.hsl .mr-xl-2,.hsl .mx-xl-2{margin-right:.5rem!important}.hsl .mb-xl-2,.hsl .my-xl-2{margin-bottom:.5rem!important}.hsl .ml-xl-2,.hsl .mx-xl-2{margin-left:.5rem!important}.hsl .m-xl-3{margin:1rem!important}.hsl .mt-xl-3,.hsl .my-xl-3{margin-top:1rem!important}.hsl .mr-xl-3,.hsl .mx-xl-3{margin-right:1rem!important}.hsl .mb-xl-3,.hsl .my-xl-3{margin-bottom:1rem!important}.hsl .ml-xl-3,.hsl .mx-xl-3{margin-left:1rem!important}.hsl .m-xl-4{margin:1.5rem!important}.hsl .mt-xl-4,.hsl .my-xl-4{margin-top:1.5rem!important}.hsl .mr-xl-4,.hsl .mx-xl-4{margin-right:1.5rem!important}.hsl .mb-xl-4,.hsl .my-xl-4{margin-bottom:1.5rem!important}.hsl .ml-xl-4,.hsl .mx-xl-4{margin-left:1.5rem!important}.hsl .m-xl-5{margin:3rem!important}.hsl .mt-xl-5,.hsl .my-xl-5{margin-top:3rem!important}.hsl .mr-xl-5,.hsl .mx-xl-5{margin-right:3rem!important}.hsl .mb-xl-5,.hsl .my-xl-5{margin-bottom:3rem!important}.hsl .ml-xl-5,.hsl .mx-xl-5{margin-left:3rem!important}.hsl .p-xl-0{padding:0!important}.hsl .pt-xl-0,.hsl .py-xl-0{padding-top:0!important}.hsl .pr-xl-0,.hsl .px-xl-0{padding-right:0!important}.hsl .pb-xl-0,.hsl .py-xl-0{padding-bottom:0!important}.hsl .pl-xl-0,.hsl .px-xl-0{padding-left:0!important}.hsl .p-xl-1{padding:.25rem!important}.hsl .pt-xl-1,.hsl .py-xl-1{padding-top:.25rem!important}.hsl .pr-xl-1,.hsl .px-xl-1{padding-right:.25rem!important}.hsl .pb-xl-1,.hsl .py-xl-1{padding-bottom:.25rem!important}.hsl .pl-xl-1,.hsl .px-xl-1{padding-left:.25rem!important}.hsl .p-xl-2{padding:.5rem!important}.hsl .pt-xl-2,.hsl .py-xl-2{padding-top:.5rem!important}.hsl .pr-xl-2,.hsl .px-xl-2{padding-right:.5rem!important}.hsl .pb-xl-2,.hsl .py-xl-2{padding-bottom:.5rem!important}.hsl .pl-xl-2,.hsl .px-xl-2{padding-left:.5rem!important}.hsl .p-xl-3{padding:1rem!important}.hsl .pt-xl-3,.hsl .py-xl-3{padding-top:1rem!important}.hsl .pr-xl-3,.hsl .px-xl-3{padding-right:1rem!important}.hsl .pb-xl-3,.hsl .py-xl-3{padding-bottom:1rem!important}.hsl .pl-xl-3,.hsl .px-xl-3{padding-left:1rem!important}.hsl .p-xl-4{padding:1.5rem!important}.hsl .pt-xl-4,.hsl .py-xl-4{padding-top:1.5rem!important}.hsl .pr-xl-4,.hsl .px-xl-4{padding-right:1.5rem!important}.hsl .pb-xl-4,.hsl .py-xl-4{padding-bottom:1.5rem!important}.hsl .pl-xl-4,.hsl .px-xl-4{padding-left:1.5rem!important}.hsl .p-xl-5{padding:3rem!important}.hsl .pt-xl-5,.hsl .py-xl-5{padding-top:3rem!important}.hsl .pr-xl-5,.hsl .px-xl-5{padding-right:3rem!important}.hsl .pb-xl-5,.hsl .py-xl-5{padding-bottom:3rem!important}.hsl .pl-xl-5,.hsl .px-xl-5{padding-left:3rem!important}.hsl .m-xl-n1{margin:-.25rem!important}.hsl .mt-xl-n1,.hsl .my-xl-n1{margin-top:-.25rem!important}.hsl .mr-xl-n1,.hsl .mx-xl-n1{margin-right:-.25rem!important}.hsl .mb-xl-n1,.hsl .my-xl-n1{margin-bottom:-.25rem!important}.hsl .ml-xl-n1,.hsl .mx-xl-n1{margin-left:-.25rem!important}.hsl .m-xl-n2{margin:-.5rem!important}.hsl .mt-xl-n2,.hsl .my-xl-n2{margin-top:-.5rem!important}.hsl .mr-xl-n2,.hsl .mx-xl-n2{margin-right:-.5rem!important}.hsl .mb-xl-n2,.hsl .my-xl-n2{margin-bottom:-.5rem!important}.hsl .ml-xl-n2,.hsl .mx-xl-n2{margin-left:-.5rem!important}.hsl .m-xl-n3{margin:-1rem!important}.hsl .mt-xl-n3,.hsl .my-xl-n3{margin-top:-1rem!important}.hsl .mr-xl-n3,.hsl .mx-xl-n3{margin-right:-1rem!important}.hsl .mb-xl-n3,.hsl .my-xl-n3{margin-bottom:-1rem!important}.hsl .ml-xl-n3,.hsl .mx-xl-n3{margin-left:-1rem!important}.hsl .m-xl-n4{margin:-1.5rem!important}.hsl .mt-xl-n4,.hsl .my-xl-n4{margin-top:-1.5rem!important}.hsl .mr-xl-n4,.hsl .mx-xl-n4{margin-right:-1.5rem!important}.hsl .mb-xl-n4,.hsl .my-xl-n4{margin-bottom:-1.5rem!important}.hsl .ml-xl-n4,.hsl .mx-xl-n4{margin-left:-1.5rem!important}.hsl .m-xl-n5{margin:-3rem!important}.hsl .mt-xl-n5,.hsl .my-xl-n5{margin-top:-3rem!important}.hsl .mr-xl-n5,.hsl .mx-xl-n5{margin-right:-3rem!important}.hsl .mb-xl-n5,.hsl .my-xl-n5{margin-bottom:-3rem!important}.hsl .ml-xl-n5,.hsl .mx-xl-n5{margin-left:-3rem!important}.hsl .m-xl-auto{margin:auto!important}.hsl .mt-xl-auto,.hsl .my-xl-auto{margin-top:auto!important}.hsl .mr-xl-auto,.hsl .mx-xl-auto{margin-right:auto!important}.hsl .mb-xl-auto,.hsl .my-xl-auto{margin-bottom:auto!important}.hsl .ml-xl-auto,.hsl .mx-xl-auto{margin-left:auto!important}}.hsl .stretched-link:after{position:absolute;top:0;right:0;bottom:0;left:0;z-index:1;pointer-events:auto;content:\"\";background-color:#0000}.hsl .text-monospace{font-family:SFMono-Regular,Menlo,Monaco,Consolas,\"Liberation Mono\",\"Courier New\",monospace!important}.hsl .text-justify{text-align:justify!important}.hsl .text-wrap{white-space:normal!important}.hsl .text-nowrap{white-space:nowrap!important}.hsl .text-truncate{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.hsl .text-left{text-align:left!important}.hsl .text-right{text-align:right!important}.hsl .text-center{text-align:center!important}@media (min-width: 576px){.hsl .text-sm-left{text-align:left!important}.hsl .text-sm-right{text-align:right!important}.hsl .text-sm-center{text-align:center!important}}@media (min-width: 768px){.hsl .text-md-left{text-align:left!important}.hsl .text-md-right{text-align:right!important}.hsl .text-md-center{text-align:center!important}}@media (min-width: 992px){.hsl .text-lg-left{text-align:left!important}.hsl .text-lg-right{text-align:right!important}.hsl .text-lg-center{text-align:center!important}}@media (min-width: 1200px){.hsl .text-xl-left{text-align:left!important}.hsl .text-xl-right{text-align:right!important}.hsl .text-xl-center{text-align:center!important}}.hsl .text-lowercase{text-transform:lowercase!important}.hsl .text-uppercase{text-transform:uppercase!important}.hsl .text-capitalize{text-transform:capitalize!important}.hsl .font-weight-light{font-weight:300!important}.hsl .font-weight-lighter{font-weight:lighter!important}.hsl .font-weight-normal{font-weight:400!important}.hsl .font-weight-bold{font-weight:700!important}.hsl .font-weight-bolder{font-weight:bolder!important}.hsl .font-italic{font-style:italic!important}.hsl .text-white{color:var(--white)!important}.hsl .text-primary{color:var(--primary)!important}.hsl a.text-primary:hover,.hsl a.text-primary:focus{color:hsla(var(--primary-h),var(--primary-s),calc(var(--primary-l) + -15%),1)!important;color:hsla(var(--primary-h),var(--primary-s),calc(var(--primary-l) + -15%),var(--primary-a, 1))!important}.hsl .text-secondary{color:var(--secondary)!important}.hsl a.text-secondary:hover,.hsl a.text-secondary:focus{color:hsla(var(--secondary-h),var(--secondary-s),calc(var(--secondary-l) + -15%),1)!important;color:hsla(var(--secondary-h),var(--secondary-s),calc(var(--secondary-l) + -15%),var(--secondary-a, 1))!important}.hsl .text-success{color:#28a745!important}.hsl a.text-success:hover,.hsl a.text-success:focus{color:#228e3b!important}.hsl .text-info{color:#17a2b8!important}.hsl a.text-info:hover,.hsl a.text-info:focus{color:#148a9c!important}.hsl .text-warning{color:#ffc107!important}.hsl a.text-warning:hover,.hsl a.text-warning:focus{color:#dfa700!important}.hsl .text-danger{color:#dc3545!important}.hsl a.text-danger:hover,.hsl a.text-danger:focus{color:#c62232!important}.hsl .text-light{color:var(--light)!important}.hsl a.text-light:hover,.hsl a.text-light:focus{color:hsla(var(--light-h),var(--light-s),calc(var(--light-l) + -15%),1)!important;color:hsla(var(--light-h),var(--light-s),calc(var(--light-l) + -15%),var(--light-a, 1))!important}.hsl .text-dark{color:var(--gray-800)!important}.hsl a.text-dark:hover,.hsl a.text-dark:focus{color:hsla(var(--gray-800-h),var(--gray-800-s),calc(var(--gray-800-l) + -15%),1)!important;color:hsla(var(--gray-800-h),var(--gray-800-s),calc(var(--gray-800-l) + -15%),var(--gray-800-a, 1))!important}.hsl .text-gray{color:var(--gray-900)!important}.hsl a.text-gray:hover,.hsl a.text-gray:focus{color:hsla(var(--gray-900-h),var(--gray-900-s),calc(var(--gray-900-l) + -15%),1)!important;color:hsla(var(--gray-900-h),var(--gray-900-s),calc(var(--gray-900-l) + -15%),var(--gray-900-a, 1))!important}.hsl .text-body{color:var(--gray-900)!important}.hsl .text-muted{color:#6c757d!important}.hsl .text-black-50{color:#00000080!important}.hsl .text-white-50{color:hsla(var(--white-h),var(--white-s),var(--white-l),.5)!important}.hsl .text-hide{font:0/0 a;color:transparent;text-shadow:none;background-color:transparent;border:0}.hsl .text-decoration-none{text-decoration:none!important}.hsl .text-break{word-break:break-word!important;word-wrap:break-word!important}.hsl .text-reset{color:inherit!important}.hsl .visible{visibility:visible!important}.hsl .invisible{visibility:hidden!important}.hsl .navbar-expand .nav-item{align-items:flex-start}.hsl .basemapGallery .dropdown-menu{overflow:visible}.hsl hs-add-data-catalogue .dropdown-menu{max-width:revert}.hsl .icon-spin{-webkit-animation:spin 1s infinite linear;animation:spin 1s infinite linear;position:relative;top:1px;display:inline-block;font-style:normal;font-weight:400;line-height:1;-webkit-font-smoothing:antialiased}.hsl .icon-primary{color:var(--primary)}@-webkit-keyframes spin{0%{transform:rotate(0)}to{transform:rotate(359deg)}}@keyframes spin{0%{transform:rotate(0)}to{transform:rotate(359deg)}}.hsl .hs-wms-expandedRow{white-space:break-spaces}.hsl .hs-wms-highlighted{cursor:pointer}.hsl .hs-wms-highlighted:hover{background-color:#d2d8dd96}.hsl .hs-flex-fill{flex:1 1 auto}.hsl .hs-grayscale{filter:grayscale(100%)}.hsl .grayed{color:#ccc}.hsl .hs-main-panel{border:none;margin-bottom:0;margin-top:.25rem!important}.hsl div.hs-main-panel:not(.hs-stc-mainpanel)>div.card-body{padding:0}.hsl .hs-map-space{flex:1 1 auto;position:relative}.hsl .flex-reverse{flex-direction:row-reverse}.hsl .fill{min-height:100%;height:100%}.hsl .x-large{font-size:x-large!important}.hsl .cursor-pointer{cursor:pointer}.hsl .hs-info-container{pointer-events:none}.hsl .hs-filter{border:0!important;border-top-left-radius:.25rem!important;border-bottom-left-radius:.25rem!important}.hsl .hs-layerpanel{max-height:27.875em;overflow-y:auto;border:0;margin-bottom:0;border-bottom:0;word-wrap:break-word}.hsl progress::-webkit-progress-value{-webkit-transition:width .1s ease;transition:width .1s ease}.hsl .hs-save-comp-advanced-panel{margin-top:10px}.hsl .hs-comp-ext-row{margin-left:0;margin-right:0}.hsl .hs-comp-ext{padding-left:3px;padding-right:3px}.hsl .hs-comp-ext input{text-align:center;padding:3px 6px}.hsl .hs-lm-header:first-child,.hsl .hs-lm-list:first-child,.hsl .hs-lm-item:first-child,.hsl .hs-comp-header:first-child,.hsl .hs-comp-list:first-child,.hsl .hs-comp-item:first-child{border-top-left-radius:0;border-top-right-radius:0}.hsl .hs-lm-list:last-child,.hsl .hs-lm-item:last-child,.hsl .hs-comp-list:last-child,.hsl .hs-comp-item:last-child{border-bottom-left-radius:0;border-bottom-right-radius:0}.hsl input.hs-waypoint-name{display:inline-block;width:calc(100% - 2.8125em)}.hsl .hs-tab-single-datasources a{cursor:pointer}.hsl ul.hs-comp-list{margin-bottom:0;overflow-y:auto}.hsl .modal.in{display:block;background-color:#0e0e0d38}.hsl .modal-backdrop{visibility:hidden}.hsl .form-control{border-radius:0}.hsl input[type=range].form-control{padding:0}.hsl .capabilities_label{padding-right:0;padding-left:0}.hsl .capabilities_input{padding-right:0;padding-left:15px}.hsl hr{margin-top:0;margin-bottom:5px}.hsl a{cursor:pointer}.hsl .input-group-append [class^=icon-]{font-size:.85rem}.hsl .but-title-sm{float:right;font-size:14px;font-weight:700;line-height:17px;color:var(--secondary);filter:alpha(opacity=20);opacity:.35}.hsl .but-title-sm:hover{text-decoration:none;cursor:pointer;filter:alpha(opacity=50);opacity:.8}.hsl button.but-title-sm{-webkit-appearance:none;cursor:pointer;background:0 0;border:0}.hsl .popover-content{min-width:230px}.hsl .popover{max-width:1000px;max-height:1000px}.hsl .thumbnail{margin-top:3px;margin-bottom:3px}.hsl .list-group-item.active a{color:#fff}.hsl .list-group-item.active{background-color:var(--sidebar-bg-color-active);border-color:var(--sidebar-bg-color-active);color:var(--sidebar-item-color-active)}.hsl .btn .close{font-size:20px}.hsl .modal{font-family:Roboto,\"Helvetica Neue\",sans-serif}.hsl .hs-checkmark,.hsl .hs-uncheckmark{position:relative;cursor:pointer;margin-right:.3em}.hsl .hs-checkmark:before{content:\"\\2713\"}.hsl .hs-uncheckmark:before{content:\"\\a0\"}.hsl .hs-checkmark:before,.hsl .hs-uncheckmark:before{color:#fff;display:inline-block;width:1.5em;height:1.5em;background-color:var(--primary);padding:.09em .4em .05em .35em;border-radius:.2em;font-weight:1000;font-size:small}.hsl .hs-uncheckmark:before{background-color:#fff;box-shadow:inset 0 0 0 .2em var(--primary)}.hsl .hs-checkmark.hs-btn-baselayers:before{color:var(--primary);background-color:#fff}.hsl .sublayerContainer .hs-checkmark:before,.hsl .sublayerContainer .hs-uncheckmark:before,.hsl .form-check .hs-checkmark:before,.hsl .form-check .hs-uncheckmark:before{margin-right:.5em}.hsl .hs-stc-footer{text-align:center;margin-top:10px}.hsl .hs-stc-footer button{width:100px}.hsl #hs-ows-abstract{resize:vertical;min-height:100px}.hsl .hs-ows-shp-advanced{margin-top:10px}.hsl .hs-ows-vector-advanced{margin-top:10px}.hsl .hs-ows-layerlistheading{background-color:#ededed}.hsl .hs-composition-share-dialog .modal-body,.hsl .composition-info-dialog .modal-body{font-size:14px}.hsl .list-group-item-primary{background-color:hsl(var(--primary-h),65%,calc(var(--light-l) - 5%));color:var(--text-color)}.hsl .list-group-item-secondary{background-color:hsl(var(--secondary-h),65%,calc(var(--light-l) - 5%));color:var(--text-color)}.hsl .list-group-item-success{background-color:hsl(133.7007874016deg,65%,calc(var(--light-l) - 5%));color:var(--text-color)}.hsl .list-group-item-info{background-color:hsl(188.198757764deg,65%,calc(var(--light-l) - 5%));color:var(--text-color)}.hsl .list-group-item-warning{background-color:hsl(45deg,65%,calc(var(--light-l) - 5%));color:var(--text-color)}.hsl .list-group-item-danger{background-color:hsl(354.251497006deg,65%,calc(var(--light-l) - 5%));color:var(--text-color)}.hsl .list-group-item-light{background-color:hsl(var(--light-h),65%,calc(var(--light-l) - 5%));color:var(--text-color)}.hsl .list-group-item-dark{background-color:hsl(var(--gray-800-h),65%,calc(var(--light-l) - 5%));color:var(--text-color)}.hsl .list-group-item-gray{background-color:hsl(var(--gray-900-h),65%,calc(var(--light-l) - 5%));color:var(--text-color)}.hsl hs-panel-header{background-color:var(--sidebar-bg-color)}@media only screen and (max-width: 767px){.hsl input[type=checkbox]{transform:scale(2);margin-right:.5em;margin-left:.5em}.hsl input[type=radio]{transform:scale(2)}.hsl div .form-check-inline{margin-right:0!important}.hsl .hs-content-wrapper{position:unset}.hsl .hs-sb-bottom .hs-ol-map{width:100%!important}.hsl .ol-viewport{position:absolute!important}.hsl .removeIcon{line-height:1.5;font-size:large}.hsl .panel-footer{padding:5px}.hsl .hs-filter{display:none!important}.hsl .ol-attribution.ol-uncollapsible{bottom:.2em}.hsl .ol-attribution ul{margin:0}.hsl .ol-control button{font-size:1.5em}.hsl .hs-ol-map .ol-zoom{bottom:.2em;top:auto;right:5px;left:auto}.hsl div.hs-info-container{display:none}.hsl .dropzone-container{flex-direction:column}.hsl .hs-draw-selectAll{font-size:medium}}.hsl ul[dnd-list],.hsl ul[dnd-list]>li{position:relative}.hsl ul[dnd-list]{min-height:42px;padding-left:0;margin-left:-23px;margin-right:-20px}.hsl ul[dnd-list] .dndDraggingSource{display:none}.hsl ul[dnd-list] .dndPlaceholder{display:block;background-color:#ddd;min-height:42px}.hsl ul[dnd-list] li{background-color:#fff;border:1px solid #ddd;border-top-right-radius:4px;border-top-left-radius:4px;display:block;margin-bottom:-1px;line-height:1em;padding:7px 2px 0 3px}.hsl ul[dnd-list] li.selected{background-color:#dff0d8;color:#3c763d}.hsl .hs-senslog-sensor{color:#333}.hsl .input-group-btn .btn{height:34px}.hsl .badge-warning{height:2.3em;width:2em;line-height:inherit}.hsl .btn-group>.btn{float:none;float:initial}.hsl .draw-buttons button{margin-left:.3em}.hsl .card-href{color:var(--gray-900);width:100%;display:inline-block}@media only screen and (min-width: 600px){.hsl .hs-layout .layout-row{position:relative}}.hsl #permalink-link{overflow-x:hidden}.hsl .hs-dotted-line{border:1px dotted #495057;border-style:none none dotted;color:#495057;background-color:#0003}.hsl .hs-extra-buttons{line-height:1em;float:right;margin-right:.5em}.hsl .dropdown-toggle.hs-custom-toggle:after{display:inline-block;width:.47em;height:.47em;margin:0 0 0 .4em;content:\"\";border:.3em solid;border-width:0 .15em .15em 0;transform:rotate(45deg);color:#495057}.hsl .dropdown-toggle.hs-custom-toggle:focus{box-shadow:0 0 0 .2rem #007bff40!important}.hsl .hs-background-alfa{background-color:var(--light)}.hsl hs-draw-layer-metadata .alert-danger{color:var(--text-color)}.hsl .hs-hover-popup{max-height:20em;min-width:10em;max-width:40em;overflow-y:scroll;visibility:visible;background:var(--white)}.hsl .hs-toolbar-button{height:2.4em}.hsl .dropdown-menu.datetime-picker-menu{min-width:22rem}.hsl a.hs-sensor-type{color:#000}.hsl a.hs-sensor-unit{color:#000;font-weight:bold}.hsl .hs-sensor{line-height:1.9em}.hsl .hs-date-time-chevron:not(*:root){visibility:hidden}.hsl .form-inline .ngb-tp-input{width:4em}.hsl hs-layer-editor .form-check{line-height:1.5}.hsl hs-layer-editor .card-body{padding:.65rem}.hsl hs-layer-editor hr{margin-top:.3rem;margin-bottom:.3rem}.hsl .hs-layerpanel{overflow-x:hidden}.hsl .hs-hover-popup-feature{font-size:small;line-height:1;margin-bottom:2px;border-bottom:1px solid #c7c7c7}.hsl .hs-draw-layer-toggle div{display:inline-block;max-width:7em;overflow-x:hidden;line-height:normal}.hsl .inputfile{width:.1px;height:.1px;opacity:0;overflow:hidden;position:absolute;z-index:-1}.hsl .inputfile+label{font-size:1.25em;font-weight:700;color:#fff;background-color:var(--primary);display:inline-block;cursor:pointer}.hsl .inputfile+label:hover{background-color:var(--secondary)}.hsl input[type=checkbox].checkbox-lg{transform:scale(1.3)}.hsl .dropzone-container{flex-direction:row}.hsl .dropzone{text-align:center;min-height:80px;border:dashed 3px var(--primary);border-radius:5px;color:#495057!important}.hsl .dropzone.active{border:solid 3px var(--secondary);color:#00000059!important;opacity:.4}.hsl .dropzone .dropzone-label{display:block;font-size:1em}.hsl .hs-endpoint-item-active{background-color:#0003}.hsl .hs-content-wrapper{position:relative;font-family:Roboto,\"Helvetica Neue\",sans-serif}.hsl .hs-panelspace{box-shadow:-36px -12px 61px -39px #0000004d;background-color:var(--panel-wrapper-bg-color);height:100%;overflow-x:visible;overflow-y:visible;padding-left:0;padding-right:0;pointer-events:auto;top:0;width:400px;z-index:2;transition:width .1s ease-out}.hsl .hs-sb-right .hs-panelspace{right:0}.hsl .hs-sb-left .hs-panelspace{left:0}.hsl div.hs-content-wrapper:not(.hs-open) div.hs-panelspace-wrapper{background-color:transparent;width:48px;overflow-x:hidden}.hsl .hs-panelspace-wrapper{height:100%;padding-left:0;padding-right:0;overflow-y:auto}.hsl .hs-content-wrapper label.form-group{display:block}@media only screen and (max-width: 767px){.hsl .hs-content-wrapper{flex-direction:column;position:unset}.hsl .hs-panelspace{left:0;bottom:0;height:auto;top:unset;width:100%;transition:none}.hsl .hs-panelspace.expanded{min-width:300px}.hsl .hs-panelspace-wrapper{display:flex;flex-direction:column;scrollbar-width:none;max-height:40vh;overflow-y:visible;font-size:x-large;width:100%}.hsl #panelspace{display:flex}}.hsl ul.hs-lm-baselayerlist{margin-bottom:0}.hsl ul.hs-lm-mapcontentlist{margin-top:0;margin-bottom:0;border-bottom:1px solid var(--panel-wrapper-bg-color)}.hsl ul.hs-lm-layerlist li.list-group-item.hs-lm-layerlist-header{padding:.3em;border-top-left-radius:0;border-top-right-radius:0;cursor:pointer;margin-left:-2px;margin-right:-2px}.hsl ul.hs-lm-layerlist li.list-group-item.hs-lm-layerlist-header span.glyphicon{font-size:x-small}.hsl li.hs-lm-item.hovering{text-decoration:underline}.hsl div.list-group-item.hs-lm-list{border:0;padding-top:0;padding-bottom:0}.hsl .hs-lm-list>ul.list-group.row{margin-bottom:0}.hsl .hs-lm-list li .info_btn{cursor:pointer}.hsl .hs-lm-list li .info_btn .icon-settingsthree-gears:hover:before{color:var(--primary)}.hsl .hs-layermanager-card li.hs-lm-item,.hsl li.hs-dr-item{word-wrap:break-word;border-left:0;border-right:0;padding:.4em .1em .1em .2em}.hsl div ul.hs-lm-baselayerlist .hs-lm-item-title,.hsl div.hs-lm-item-title.hover{cursor:pointer}.hsl .hs-layermanager-card .hs-lm-item-visibility{margin-top:-.42em}.hsl div ul.hs-lm-baselayerlist .hs-lm-item-title:hover,.hsl div.hs-lm-item-title.hover:hover{text-decoration:underline}.hsl .sublayerContainer input[type=checkbox].form-check-input{position:absolute;left:-9999px}.hsl .sublayerContainer{padding-bottom:2.5px}.hsl li.hs-lm-header{border-left:0;border-right:0;padding-left:2em;background-color:hsl(var(--primary-h),65%,calc(var(--light-l) - 10%))}.hsl .hs-lm-map-content-header{height:2.56em}.hsl .hs-lm-deactivated-layer{color:#ccc}@media only screen and (max-width: 767px){.hsl ul.hs-lm-layerlist li.list-group-item.hs-lm-layerlist-header span.glyphicon{font-size:small}}.hsl i.hs-lm-warning-scale{color:#f0ad4e;padding:.0625em .3125em;top:.125em;cursor:default}.hsl i.hs-lm-warning-error{position:static;cursor:default}.hsl i.hs-lm-queryable{cursor:default;color:#337ab7;padding:.0625em .3125em;border-radius:3px;line-height:1.5;font-size:12px;top:2px}.hsl .exclusive .hs-checkmark:before,.hsl .exclusive .hs-uncheckmark:before{border-radius:50%}.hsl .basemapGallery{display:flex;flex-direction:row;justify-content:flex-end;align-items:center;top:.7em;position:absolute;cursor:pointer;box-sizing:border-box;right:15px}.hsl .basemapGallery .galleryDropdown{width:11.5em}.hsl .basemapGallery .galleryDropdown img{height:4.5em}.hsl .basemapGallery .dropdown-item:not(.active){background:rgba(204,204,204,.51)}.hsl .basemapGallery .dropdown-item.active{color:#ffffffe3!important}.hsl .basemapGallery img.active,.hsl .basemapGallery div.active{border:.1rem solid #007bff}.hsl .basemapGallery div span.glyphicon{font-size:smaller}.hsl .basemapGallery .hs-miniMenu{width:100%;height:100%;background-color:#52657af0;border:.1rem solid #007bff;display:flex;flex-direction:column;justify-content:center;align-items:center;color:#fff;cursor:auto;right:0;transition:all .4s ease,right 0ms}.hsl .basemapGallery .hs-miniMenu>div{display:flex;flex-direction:row;background-color:#c1bebea4;cursor:pointer}.hsl .basemapGallery .hs-miniMenu p{cursor:pointer;font-size:\"medium\"}.hsl .basemapGallery .hs-miniMenu.expanded{width:30em;height:auto;z-index:4;padding-top:2em;padding-bottom:2em;border-radius:.25rem}.hsl .basemapGallery .hs-miniMenu>label{cursor:pointer;text-align:right}.hsl .basemapGallery .hs-miniMenu.expanded hs-layer-editor label{color:#fff}.hsl .galleryButton{opacity:.9!important;background-color:var(--map-controls-bg)!important;color:#fff!important}.hsl .galleryButton:hover{background-color:var(--primary)!important}@media only screen and (max-width: 767px){.hsl .basemapGallery a{font-size:x-large!important}.hsl .hs-content-wrapper>div.hs-map-space>hs.layermanager.gallery>div>div>div>button{font-size:x-large}.hsl .basemapGallery div span.glyphicon{font-size:large}.hsl .basemapGallery .galleryDropdown{width:15.5em}.hsl .basemapGallery .galleryDropdown img{height:6em}.hsl .basemapGallery .hs-miniMenu{max-width:90vw;font-size:larger}}.hsl .hs-sidebar-item{color:var(--sidebar-item-color);background-color:var(--sidebar-bg-color);cursor:pointer}.hsl .hs-sidebar-item [class*=\" icon-\"]{margin-left:-4px}.hsl hs-sidebar{bottom:0;position:absolute;top:0;background:var(--sidebar-bg-color);transition:width .1s ease-out;z-index:2}.hsl hs-sidebar div.hs-sidebar-list a:not(.active){background-color:transparent;color:var(--sidebar-item-color)}.hsl .hs-content-wrapper.hs-open .hs-panelspace:not(.labels) hs-sidebar{border-right:1px solid #dedede}.hsl .hs-panelspace.labels hs-sidebar{width:400px}.hsl .hs-panelspace:not(.buttons) hs-sidebar{display:none}.hsl .hs-content-wrapper.hs-sb-left:not(.hs-open) hs-sidebar{background-color:var(--sidebar-bg-color);right:auto;width:48px}.hsl .hs-content-wrapper.hs-sb-right:not(.hs-open) hs-sidebar{background-color:var(--sidebar-bg-color);left:auto;width:48px}.hsl .hs-content-wrapper:not(.hs-open) .hs-panelspace{width:48px;border-right:1px solid #dedede}.hsl .hs-content-wrapper.hs-open .hs-sidebar-list{width:100%}.hsl .hs-content-wrapper.hs-open div.hs-panelspace:not(.labels) hs-sidebar .hs-sidebar-list{width:48px}.hsl div.hs-panelplace{height:100%;overflow-y:auto;margin-left:49px}.hsl div.hs-panelplace>div{height:100%}.hsl div.hs-panelspace:not(.buttons) hs-sidebar~div.hs-panelplace{margin-left:0;width:400px}.hsl .hs-sidebar-list .list-group-item{border-left:0px;border-right:0px;white-space:nowrap}.hsl .hs-sidebar-list .list-group-item:first-child{border-top-left-radius:0;border-top-right-radius:0}.hsl .hs-sidebar-list .list-group-item:last-child{border-bottom-left-radius:0;border-bottom-right-radius:0}.hsl .hs-sidebar-item-title{margin-left:20px}.hsl .hs-panelspace:not(.labels) .hs-sidebar-list span.hs-sidebar-item-title{display:none}.hsl .hs-content-wrapper.hs-sb-right:not(.hs-open) .hs-sidebar-list{right:0}.hsl .hs-content-wrapper.hs-sb-left:not(.hs-open) .hs-sidebar-list{left:0}.hsl .hs-content-wrapper:not(.hs-open) .hs-sidebar-item-title{display:none}.hsl .hs-content-wrapper:not(.hs-open) .hs-panelplace{display:none}.hsl hs-sidebar hs-panel-header.sidebar-header{display:none}.hsl hs-sidebar .hs-sidebar-item.hs-panel-hidden{display:none!important}.hsl hs-mini-sidebar .hs-sidebar-item:not(.hs-panel-hidden){display:none!important}.hsl hs-mini-sidebar .hs-sidebar-list{height:auto;justify-content:center;align-items:center;flex-wrap:wrap;margin:auto}.hsl hs-mini-sidebar .hs-sidebar-item.hs-panel-hidden{display:flex;flex-direction:column;align-items:center;text-align:center;width:100%}.hsl hs-mini-sidebar .hs-sidebar-item-title{display:block!important;margin:0;font-size:10px}.hsl hs-sidebar~div.hs-panelplace{overflow-x:hidden}@media only screen and (max-width: 767px){.hsl .hs-content-wrapper .hs-sidebar-item-title:not(.hs-mini-sidebar){display:none}.hsl hs-sidebar{display:flex}.hsl hs-sidebar{position:unset;width:100%!important}.hsl hs-sidebar~div.hs-panelplace{margin:auto;height:35vh;padding-top:.5em;scrollbar-width:none;width:95%}.hsl hs-sidebar>div.list-group{flex-direction:row!important;justify-content:space-evenly}.hsl .hs-sidebar-list .list-group-item{white-space:normal}.hsl .hs-content-wrapper.hs-open div.hs-panelspace:not(.labels) hs-sidebar .hs-sidebar-list{width:100%}.hsl div.hs-content-wrapper:not(.hs-open) div.hs-panelspace-wrapper{width:100%}.hsl .hs-content-wrapper div.hs-panelspace:not(.labels) hs-sidebar .hs-sidebar-list{width:100%}.hsl .hs-content-wrapper div.hs-panelspace .hs-mini-sidebar .hs-sidebar-list{width:100%}.hsl a.hs-sidebar-item.list-group-item{flex-grow:1;display:flex;justify-content:center;padding:.55rem 1.05rem}.hsl .hs-sidebar-item [class*=\" icon-\"]{font-size:x-large}.hsl hs-mini-sidebar .hs-sidebar-list{flex-direction:row!important;justify-content:center;align-items:center;flex-wrap:wrap;margin:auto}.hsl hs-mini-sidebar hs-panel-header.sidebar-header{display:none}.hsl hs-mini-sidebar .hs-sidebar-item.hs-panel-hidden{width:25%;height:80px}.hsl hs-mini-sidebar .hs-sidebar-item-title{display:block!important;margin:0;font-size:10px}.hsl hs-mini-sidebar .list-group-item{border:none;background-color:unset}.hsl hs-sidebar .hs-panel-hidden{display:none!important}.hsl hs-mini-sidebar .hs-sidebar-item:not(.hs-panel-hidden){display:none!important}}.hsl .hs-locate:not(.ol-collapsed){background:rgba(255,255,255,.8)}.hsl .hs-locate,.hsl .ol-has-tooltip [role=tooltip],.hsl .ol-scale-line-inner{font-family:\"Lucida Grande\",Verdana,Geneva,Lucida,Arial,Helvetica,sans-serif}.hsl .hs-locate{text-align:right;bottom:9.2em;right:5px;max-width:calc(100% - 1.3em);z-index:100}.hsl .hs-locate ul{float:left}.hsl .hs-locate button{float:right}.hsl .hs-locate .btn-primary{background-color:#0069d9!important}.hsl .hs-locate.ol-collapsed ul,.hsl .hs-locate:not(.ol-collapsed) button:hover [role=tooltip]{display:none}.hsl .hs-locate ul{list-style:none}.hsl .ol-rotate{bottom:11.5em;left:auto;right:5px;top:auto}.hsl .ol-rotate.hidden{visibility:hidden;opacity:0%}.hsl .ol-rotate button:not(.active){background-color:#868888b3}.hsl .hs-impressum .hs-logo{max-width:100%;padding-left:5em;padding-right:5em}.hsl .hs-impressum .hs-logo img{width:100%}.hsl .hs-panelspace:not(.labels) .hs-impressum{display:none}.hsl .hs-content-wrapper:not(.hs-open) .hs-impressum{display:none}.hsl .hs-search-address{z-index:2}.hsl .hs-toolbar #hs-search-address{max-width:125px}.hsl #searchresults{top:45px;min-width:250px}.hsl .search-panel hs-search-input,.hsl .search-panel hs-search-results{width:100%}.hsl .clearSearch{position:absolute;right:.5rem;top:50%;transform:translateY(-50%);border:0;color:#000;z-index:5;background:transparent}.hsl .clearSearch:hover{color:var(--primary)}.hsl .hsl-search-result{z-index:2}@media only screen and (max-width: 767px){.hsl .hs-search-address-input{max-width:20vw!important}}.hsl div.hs-info-area{background-color:#2f588e66;border-radius:4px;bottom:1.7em;color:#fff;left:.5em;padding:1px;pointer-events:initial;position:absolute;vertical-align:bottom;z-index:3}.hsl div.hs-info-composition-image{background-size:76px 76px;font-size:15px;height:2em;position:absolute;text-align:center;width:2em;top:-30px;left:3px;background-color:#003c8a4d}.hsl div.hs-info-composition{display:flex;max-width:300px}.hsl div.hs-info-composition-container{font-size:12px;line-height:12px;padding:4px}.hsl div.hs-info-composition-title{font-weight:bold;padding-bottom:6px}.hsl div.hs-info-composition-image>span{line-height:30px;width:30px}.hsl .hs-info-layers,.hsl div.hs-info-composition-edited{font-size:12px;padding:0 12px 12px;text-overflow:ellipsis;height:29px;overflow:hidden;display:inline-block;position:relative;width:260px;white-space:nowrap}.hsl .hs-toolbar{position:absolute;top:10px;left:10px;max-width:636px;display:inline-block;z-index:101}@media only screen and (max-width: 767px){.hsl .hs-sb-left .hs-toolbar,.hsl .hs-sb-left .hs-toolbar{margin-left:0!important}}.hsl .hsl-custom-select{height:calc(1.5em + .75rem + 2px);min-height:1.5rem;padding:.375rem 1.75rem .375rem .75rem;display:inline-block;font-size:1rem;font-weight:400;width:100%;border:1px solid #ced4da}.hsl .ol-attribution{left:auto;right:5px;bottom:.2em}.hsl .ol-attribution.ol-uncollapsible{right:5px;bottom:.2em}.hsl .hs-ol-map .ol-scale-line{right:auto;left:.5em}.hsl .hs-ol-map .ol-zoom{bottom:2.4em;top:auto;right:5px;left:auto}.hsl .hs-ol-map .hs-defaultView{bottom:6.65em;top:auto;right:5px;left:auto}.hsl .ol-touch .ol-zoomslider{display:none}.hsl .ol-mouse-position{bottom:8px;left:170px;position:absolute;color:#fff;top:auto;right:auto}.hsl .ol-popup{display:none;position:absolute;background-color:#fff;padding:15px 25px 15px 15px;border:1px solid #cccccc;bottom:12px;left:-50px}.hsl .ol-popup:after,.hsl .ol-popup:before{top:100%;border:solid transparent;content:\" \";height:0;width:0;position:absolute;pointer-events:none}.hsl .ol-popup:after{border-top-color:#fff;border-width:10px;left:48px;margin-left:-10px}.hsl .ol-popup:before{border-top-color:#ccc;border-width:11px;left:48px;margin-left:-11px}.hsl .ol-popup-content{min-width:170px;max-height:200px;overflow-x:auto}.hsl .ol-popup-closer{position:absolute;top:2px;right:2px;font-size:150%;padding:0 4px;color:gray;text-decoration:none}.hsl .ol-popup-closer:after{content:\"\\2716\"}.hsl .ol-popup div.infoResult{min-width:130px}.hsl .ol-popup div.infoResult p{padding:.1em;margin:0}.hsl .ol-popup-content h3{margin:.25em 0}.hsl .ol-popup.marker{margin-bottom:30px}.hsl .ol-overlaycontainer-stopevent{pointer-events:none}.hsl .ol-overlaycontainer-stopevent *{pointer-events:auto}.hsl .ol-control button:hover{background-color:var(--primary)}.hsl .ol-control button{background-color:var(--map-controls-bg);font-family:\"Lucida Grande\",Verdana,Geneva,Lucida,Arial,Helvetica,sans-serif}\n", "@font-face{font-family:\"WebHostingHub-Glyphs\";src:url(data:font/opentype;charset=utf-8;base64,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) format(\"truetype\");font-weight:normal;font-style:normal;-moz-font-feature-settings:\"calt=0,liga=0\"}[class^=icon-],[class*=\" icon-\"]{font-family:\"WebHostingHub-Glyphs\";background:none;width:auto;height:auto;font-style:normal}.icon-indexmanager:before{content:\"\\f09e\"}.icon-alertpay:before{content:\"\\f269\"}.icon-brush:before{content:\"\\f1b8\"}.icon-analytics-piechart:before{content:\"\\f000\"}.icon-chevron-left:before{content:\"\\f489\"}.icon-chevron-right:before{content:\"\\f488\"}.icon-chevron-down:before{content:\"\\f48b\"}.icon-check:before{content:\"\\f310\"}.icon-database:before{content:\"\\f00b\"}.icon-download:before{content:\"\\f47b\"}.icon-edit:before{content:\"\\f47c\"}.icon-gpsoff-gps:before{content:\"\\f21e\"}.icon-info-sign:before{content:\"\\f315\"}.icon-layers:before{content:\"\\f1ca\"}.icon-line:before{content:\"\\f1bf\"}.icon-link:before{content:\"\\f022\"}.icon-map:before{content:\"\\f209\"}.icon-pencil:before{content:\"\\f1b7\"}.icon-pin:before{content:\"\\f20a\"}.icon-plus:before{content:\"+\"}.icon-polygonlasso:before{content:\"\\f397\"}.icon-print:before{content:\"\\f125\"}.icon-question-sign:before{content:\"\\f0a3\"}.icon-refresh:before{content:\"\\f078\"}.icon-remove:before{content:\"\\d7\"}.icon-remove-circle:before{content:\"\\f470\"}.icon-save-floppy:before{content:\"\\f0c8\"}.icon-screenshot:before{content:\"\\f109\"}.icon-search:before{content:\"\\f0c5\"}.icon-settingsandroid:before{content:\"\\f309\"}.icon-settingsthree-gears:before{content:\"\\f307\"}.icon-share-alt:before{content:\"\\f16c\"}.icon-trash:before{content:\"\\f0ce\"}.icon-upload:before{content:\"\\f47a\"}.icon-warning-sign:before{content:\"\\f316\"}.icon-dotlist:before{content:\"\\f4c2\"}.icon-design:before{content:\"\\f53d\"}.icon-calcplus:before{content:\"\\f571\"}.icon-calcminus:before{content:\"\\f572\"}.icon-fatredo:before{content:\"\\f692\"}.icon-circleloaderfull:before{content:\"\\f772\"}.icon-weightscale:before{content:\"\\f782\"}.icon-cloudaltsync:before{content:\"\\f7ac\"}.icon-textfield:before{content:\"\\f5d5\"}.icon-time:before{content:\"\\f210\"}.icon-calendarthree:before{content:\"\\f4d0\"}.icon-menu:before{content:\"\\f127\"}.icon-navigation:before{content:\"\\f23a\"}.icon-gpson:before{content:\"\\f21f\"}.icon-globealt:before{content:\"\\f36c\"}.icon-minus:before{content:\"\\2212\"}.icon-equals:before{content:\"\\f30c\"}.icon-globe:before{content:\"\\f01b\"}.icon-sextant:before{content:\"\\f6ec\"}.icon-cursor:before{content:\"\\f0dc\"}.icon-arrow-up:before{content:\"\\f301\"}.icon-arrow-down:before{content:\"\\f2fe\"}.icon-tabletscreensize:before{content:\"\\f675\"}.icon-moon-night:before{content:\"\\f207\"}.icon-sun-day:before{content:\"\\f206\"}.icon-timeline:before{content:\"\\f253\"}.icon-uploadalt:before{content:\"\\f11b\"}.icon-opennewwindow:before{content:\"\\f332\"}.icon-move:before{content:\"\\f322\"}.icon-filter:before{content:\"\\f05c\"}\n"]
            }]
    }], function () { return [{ type: HsConfig }, { type: HsLayoutService }, { type: HsEventBusService }, { type: HsThemeService }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.ChangeDetectorRef }, { type: HsUtilsService }, { type: HsPanelContainerService }, { type: HsOverlayPanelContainerService }]; }, { hslayout: [{
            type: ViewChild,
            args: ['hslayout']
        }], mapHost: [{
            type: ViewChild,
            args: [HsMapHostDirective, { static: true }]
        }] }); })();

class HsLayoutHostDirective {
    constructor(viewContainerRef) {
        this.viewContainerRef = viewContainerRef;
    }
}
HsLayoutHostDirective.ɵfac = function HsLayoutHostDirective_Factory(t) { return new (t || HsLayoutHostDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef)); };
HsLayoutHostDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: HsLayoutHostDirective, selectors: [["", "hslayout", ""]] });
HsLayoutHostDirective.ctorParameters = () => [
    { type: ViewContainerRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsLayoutHostDirective, [{
        type: Directive,
        args: [{
                selector: '[hslayout]'
            }]
    }], function () { return [{ type: ɵngcc0.ViewContainerRef }]; }, null); })();

class HsConfirmModule {
}
HsConfirmModule.ɵfac = function HsConfirmModule_Factory(t) { return new (t || HsConfirmModule)(); };
HsConfirmModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: HsConfirmModule });
HsConfirmModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, TranslateModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsConfirmModule, [{
        type: NgModule,
        args: [{
                declarations: [HsConfirmDialogComponent],
                imports: [CommonModule, TranslateModule],
                entryComponents: [HsConfirmDialogComponent],
                exports: [HsConfirmDialogComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(HsConfirmModule, { declarations: function () { return [HsConfirmDialogComponent]; }, imports: function () { return [CommonModule, TranslateModule]; }, exports: function () { return [HsConfirmDialogComponent]; } }); })();

class HsMapComponent {
    constructor(HsMapService, HsPermalinkUrlService, HsCoreService, HsConfig, HsEventBusService, zone) {
        this.HsMapService = HsMapService;
        this.HsPermalinkUrlService = HsPermalinkUrlService;
        this.HsCoreService = HsCoreService;
        this.HsConfig = HsConfig;
        this.HsEventBusService = HsEventBusService;
        this.zone = zone;
        this.unregisterMapSyncCenterHandlerSubscription =
            this.HsEventBusService.mapCenterSynchronizations.subscribe((data) => {
                this.onCenterSync(data);
            });
    }
    ngAfterViewInit() {
        this.HsMapService.mapElement = this.map.nativeElement;
        const visibleLayersParam = this.HsPermalinkUrlService.getParamValue(HS_PRMS.visibleLayers);
        if (visibleLayersParam) {
            this.HsMapService.visibleLayersInUrl = visibleLayersParam.split(';');
        }
        this.zone.runOutsideAngular(() => this.HsMapService.init());
        const pos = this.HsPermalinkUrlService.getParamValues([
            HS_PRMS.x,
            HS_PRMS.y,
            HS_PRMS.zoom,
        ]);
        if (!Object.keys(pos).some((k) => pos[k] == undefined || pos[k] == 'NaN')) {
            this.HsMapService.moveToAndZoom(parseFloat(pos[HS_PRMS.x]), parseFloat(pos[HS_PRMS.y]), parseInt(pos[HS_PRMS.zoom]));
        }
        if (this.HsPermalinkUrlService.getParamValue(HS_PRMS.pureMap) ||
            this.HsConfig.pureMap == true) {
            this.HsCoreService.puremapApp = true;
        }
        this.HsMapService.map.updateSize();
    }
    ngOnDestroy() {
        this.unregisterMapSyncCenterHandlerSubscription.unsubscribe();
    }
    /**
     * @param data Coordinates in lon/lat and resolution
     * This gets called from Cesium map, to
     * synchronize center and resolution between Ol and Cesium maps
     */
    onCenterSync(data) {
        const center = data.center;
        if (!center) {
            return;
        }
        const toProj = this.HsMapService.getCurrentProj();
        const transformed = transform([center[0], center[1]], 'EPSG:4326', toProj);
        this.HsMapService.moveToAndZoom(transformed[0], transformed[1], this.zoomForResolution(center[2]));
    }
    /**
     * @param resolution Resolution
     * Calculates zoom level for a given resolution
     * @returns Zoom level for resolution. If resolution
     * was greater than 156543.03390625 return 0
     */
    zoomForResolution(resolution) {
        let zoom = 0;
        //Sometimes resolution is under 0. Ratis
        resolution = Math.abs(resolution);
        let r = 156543.03390625; // resolution for zoom 0
        while (resolution < r) {
            r /= 2.0;
            zoom++;
            if (resolution > r) {
                return zoom;
            }
        }
        return zoom; // resolution was greater than 156543.03390625 so return 0
    }
}
HsMapComponent.ɵfac = function HsMapComponent_Factory(t) { return new (t || HsMapComponent)(ɵngcc0.ɵɵdirectiveInject(HsMapService), ɵngcc0.ɵɵdirectiveInject(HsShareUrlService), ɵngcc0.ɵɵdirectiveInject(HsCoreService), ɵngcc0.ɵɵdirectiveInject(HsConfig), ɵngcc0.ɵɵdirectiveInject(HsEventBusService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
HsMapComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsMapComponent, selectors: [["hs-map"]], viewQuery: function HsMapComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c9, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.map = _t.first);
    } }, decls: 2, vars: 0, consts: [[1, "hs-ol-map", "hs-flex-fill", "d-flex"], ["map", ""]], template: function HsMapComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "div", 0, 1);
    } }, encapsulation: 2 });
HsMapComponent.ctorParameters = () => [
    { type: HsMapService },
    { type: HsShareUrlService },
    { type: HsCoreService },
    { type: HsConfig },
    { type: HsEventBusService },
    { type: NgZone }
];
HsMapComponent.propDecorators = {
    map: [{ type: ViewChild, args: ['map',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsMapComponent, [{
        type: Component,
        args: [{
                selector: 'hs-map',
                template: "<div #map class=\"hs-ol-map hs-flex-fill d-flex\"></div>\n"
            }]
    }], function () { return [{ type: HsMapService }, { type: HsShareUrlService }, { type: HsCoreService }, { type: HsConfig }, { type: HsEventBusService }, { type: ɵngcc0.NgZone }]; }, { map: [{
            type: ViewChild,
            args: ['map']
        }] }); })();

class HsMapDirective {
    constructor(viewContainerRef) {
        this.viewContainerRef = viewContainerRef;
    }
}
HsMapDirective.ɵfac = function HsMapDirective_Factory(t) { return new (t || HsMapDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef)); };
HsMapDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: HsMapDirective, selectors: [["", "map", ""]] });
HsMapDirective.ctorParameters = () => [
    { type: ViewContainerRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsMapDirective, [{
        type: Directive,
        args: [{
                selector: '[map]'
            }]
    }], function () { return [{ type: ɵngcc0.ViewContainerRef }]; }, null); })();

class HsMapModule {
}
HsMapModule.ɵfac = function HsMapModule_Factory(t) { return new (t || HsMapModule)(); };
HsMapModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: HsMapModule });
HsMapModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsMapModule, [{
        type: NgModule,
        args: [{
                schemas: [CUSTOM_ELEMENTS_SCHEMA],
                declarations: [HsMapComponent, HsMapDirective],
                imports: [CommonModule],
                exports: [HsMapComponent],
                entryComponents: [HsMapComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(HsMapModule, { declarations: function () { return [HsMapComponent, HsMapDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [HsMapComponent]; } }); })();

var name = "hslayers-ng";
var version = "6.1.0";
var packageJson = {
	name: name,
	version: version
};

class HsImpressumComponent {
    constructor(hsUtilsService) {
        this.hsUtilsService = hsUtilsService;
        this.version = 'dev';
        this.logo = '';
        this.logoDisabled = false;
        this.version = packageJson.version;
    }
}
HsImpressumComponent.ɵfac = function HsImpressumComponent_Factory(t) { return new (t || HsImpressumComponent)(ɵngcc0.ɵɵdirectiveInject(HsUtilsService)); };
HsImpressumComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsImpressumComponent, selectors: [["hs-impressum"]], decls: 12, vars: 4, consts: [[1, "hs-impressum", "pl-3", "pr-3", "pb-2"], [1, "text-dark"], [1, "hs-logo"], ["href", "https://ng.hslayers.org/", "target", "_blank"], ["alt", "HSLayers-NG", 3, "src", "hidden"], [1, "text-right"], ["target", "_blank", 3, "href"]], template: function HsImpressumComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div");
        ɵngcc0.ɵɵelementStart(2, "span", 1);
        ɵngcc0.ɵɵtext(3, "Powered by");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 2);
        ɵngcc0.ɵɵelementStart(5, "a", 3);
        ɵngcc0.ɵɵelement(6, "img", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 5);
        ɵngcc0.ɵɵelementStart(8, "span", 1);
        ɵngcc0.ɵɵtext(9, "version ");
        ɵngcc0.ɵɵelementStart(10, "a", 6);
        ɵngcc0.ɵɵtext(11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("src", ctx.hsUtilsService.getAssetsPath() + "img/hslayers-ng-logo.png", ɵngcc0.ɵɵsanitizeUrl)("hidden", ctx.logoDisabled);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵpropertyInterpolate1("href", "https://github.com/hslayers/hslayers-ng/releases/tag/", ctx.version, "", ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.version);
    } }, encapsulation: 2 });
HsImpressumComponent.ctorParameters = () => [
    { type: HsUtilsService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsImpressumComponent, [{
        type: Component,
        args: [{
                selector: 'hs-impressum',
                template: "<div class=\"hs-impressum pl-3 pr-3 pb-2\">\n  <div>\n    <span class=\"text-dark\">Powered by</span>\n    <div class=\"hs-logo\">\n      <a href=\"https://ng.hslayers.org/\" target=\"_blank\">\n        <img [src]=\"hsUtilsService.getAssetsPath() + 'img/hslayers-ng-logo.png'\" alt=\"HSLayers-NG\" [hidden]=\"logoDisabled\">\n      </a>\n    </div>\n    <div class=\"text-right\">\n      <span class=\"text-dark\">version <a href=\"https://github.com/hslayers/hslayers-ng/releases/tag/{{version}}\" target=\"_blank\">{{version}}</a></span>\n    </div>\n  </div>\n</div>\n"
            }]
    }], function () { return [{ type: HsUtilsService }]; }, null); })();

class HsMiniSidebarComponent {
    constructor(HsCoreService, HsSidebarService, HsLayoutService, HsConfig) {
        this.HsCoreService = HsCoreService;
        this.HsSidebarService = HsSidebarService;
        this.HsLayoutService = HsLayoutService;
        this.HsConfig = HsConfig;
    }
    ngOnInit() {
        if (this.HsCoreService.config.createExtraMenu !== undefined) {
            this.HsCoreService.config.createExtraMenu(this.HsSidebarService);
        }
    }
    /**
     * Seat weather to show all sidebar buttons or just a
     * subset of important ones
     */
    toggleUnimportant() {
        this.HsSidebarService.showUnimportant =
            !this.HsSidebarService.showUnimportant;
    }
    /**
     * Toggle sidebar mode between expanded and narrow
     */
    toggleSidebar() {
        this.HsLayoutService.sidebarExpanded =
            !this.HsLayoutService.sidebarExpanded;
        setTimeout(() => {
            this.HsCoreService.updateMapSize();
        }, 110);
    }
}
HsMiniSidebarComponent.ɵfac = function HsMiniSidebarComponent_Factory(t) { return new (t || HsMiniSidebarComponent)(ɵngcc0.ɵɵdirectiveInject(HsCoreService), ɵngcc0.ɵɵdirectiveInject(HsSidebarService), ɵngcc0.ɵɵdirectiveInject(HsLayoutService), ɵngcc0.ɵɵdirectiveInject(HsConfig)); };
HsMiniSidebarComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsMiniSidebarComponent, selectors: [["hs-mini-sidebar"]], decls: 7, vars: 8, consts: [[1, "hs-sidebar-list", "hs-main-panel", "list-group"], ["class", "sidebar-header w-100", "name", "additional", 3, "title", 4, "ngIf"], ["class", "hs-sidebar-item list-group-item", 3, "click", 4, "ngIf"], ["class", "hs-sidebar-item list-group-item", 3, "hidden", "ngClass", "title", "click", 4, "ngFor", "ngForOf"], ["class", "hs-sidebar-item  list-group-item", 3, "ngClass", "click", 4, "ngIf"], [1, "mt-auto"], ["name", "additional", 1, "sidebar-header", "w-100", 3, "title"], [1, "hs-sidebar-item", "list-group-item", 3, "click"], [1, "menu-icon", 3, "ngClass"], [1, "hs-sidebar-item", "list-group-item", 3, "hidden", "ngClass", "title", "click"], ["data-toggle", "tooltip", "data-container", "body", "data-placement", "auto", 3, "class", 4, "ngIf"], ["data-toggle", "tooltip", "data-container", "body", "data-placement", "auto", "class", "", 3, "title", 4, "ngIf"], [1, "hs-sidebar-item-title", 3, "ngStyle"], ["data-toggle", "tooltip", "data-container", "body", "data-placement", "auto"], ["data-toggle", "tooltip", "data-container", "body", "data-placement", "auto", 1, "", 3, "title"], [1, "hs-sidebar-item", "list-group-item", 3, "ngClass", "click"], ["data-toggle", "tooltip", "data-container", "body", "data-placement", "auto", "title", "Menu", 1, "menu-icon", "icon-equals", 2, "margin-left", "0px !important"], [1, "hs-sidebar-item-title"]], template: function HsMiniSidebarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, HsMiniSidebarComponent_hs_panel_header_1_Template, 2, 3, "hs-panel-header", 1);
        ɵngcc0.ɵɵtemplate(2, HsMiniSidebarComponent_span_2_Template, 2, 1, "span", 2);
        ɵngcc0.ɵɵtemplate(3, HsMiniSidebarComponent_span_3_Template, 5, 12, "span", 3);
        ɵngcc0.ɵɵpipe(4, "sortBy");
        ɵngcc0.ɵɵtemplate(5, HsMiniSidebarComponent_span_5_Template, 4, 4, "span", 4);
        ɵngcc0.ɵɵelement(6, "hs-impressum", 5);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.HsLayoutService.minisidebar);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.HsLayoutService.sidebarToggleable);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind3(4, 4, ctx.HsSidebarService.buttons, "asc", "order"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.HsLayoutService.minisidebar);
    } }, directives: function () { return [ɵngcc3.NgIf, ɵngcc3.NgForOf, HsImpressumComponent, HsPanelHeaderComponent, ɵngcc3.NgClass, ɵngcc3.NgStyle]; }, pipes: function () { return [SortByPipe, ɵngcc1.TranslatePipe]; }, encapsulation: 2 });
HsMiniSidebarComponent.ctorParameters = () => [
    { type: HsCoreService },
    { type: HsSidebarService },
    { type: HsLayoutService },
    { type: HsConfig }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsMiniSidebarComponent, [{
        type: Component,
        args: [{
                selector: 'hs-mini-sidebar',
                template: "<div class=\"hs-sidebar-list hs-main-panel list-group\">\n    <hs-panel-header class=\"sidebar-header w-100\" *ngIf=\"HsLayoutService.minisidebar\" name=\"additional\" [title]=\"'SIDEBAR.additionalPanels' | translate\"></hs-panel-header>\n\n    <span class=\"hs-sidebar-item list-group-item\" *ngIf=\"HsLayoutService.sidebarToggleable\" (click)=\"toggleSidebar()\">\n        <i class=\"menu-icon\" [ngClass]=\"HsLayoutService.sidebarExpanded ? (HsConfig.sidebarPosition === 'left' ? 'icon-chevron-left' : 'icon-chevron-right') : (HsConfig.sidebarPosition === 'left' ? 'icon-chevron-right' : 'icon-chevron-left')\"></i>\n    </span>\n\n    <span *ngFor=\"let button of HsSidebarService.buttons | sortBy: 'asc': 'order'\" class=\"hs-sidebar-item list-group-item\" [hidden]=\"!button.visible\" (click)=\"HsSidebarService.buttonClicked(button)\"\n        [ngClass]=\"{'active': HsLayoutService.mainpanel === button.panel,  'hs-panel-hidden' : !button.fits}\" title=\"{{HsSidebarService.getButtonDescription(button)}}\">\n        <i *ngIf=\"button.icon\" class=\"menu-icon {{button.icon}}\" data-toggle=\"tooltip\" data-container=\"body\" data-placement=\"auto\"></i>\n        <span *ngIf=\"button.content\" data-toggle=\"tooltip\" data-container=\"body\" data-placement=\"auto\" class=\"\" title=\"{{HsSidebarService.getButtonDescription(button)}}\">{{button.content()}}</span>\n        <span [ngStyle]=\"{'margin-left' : button.panel === 'language' ? '14px' : '20px'}\" class=\"hs-sidebar-item-title\">{{HsSidebarService.getButtonTitle(button)}}</span>\n    </span>\n\n    <span class=\"hs-sidebar-item  list-group-item\" *ngIf=\"HsLayoutService.minisidebar\" (click)=\"HsLayoutService.setMainPanel('sidebar', true)\" [ngClass]=\"{'active': HsLayoutService.mainpanel === 'sidebar'}\">\n        <i class=\"menu-icon icon-equals\" data-toggle=\"tooltip\" data-container=\"body\" data-placement=\"auto\" title=\"Menu\" style=\"margin-left: 0px !important;\"></i>\n        <span class=\"hs-sidebar-item-title\">{{HsSidebarService.getButtonTitle(HsSidebarService.miniSidebarButton)}}</span>\n    </span>\n    <hs-impressum class=\"mt-auto\"></hs-impressum>\n</div>\n"
            }]
    }], function () { return [{ type: HsCoreService }, { type: HsSidebarService }, { type: HsLayoutService }, { type: HsConfig }]; }, null); })();

class HsSidebarComponent {
    constructor(HsLayoutService, HsCoreService, HsSidebarService, HsPermalinkUrlService, HsConfig) {
        this.HsLayoutService = HsLayoutService;
        this.HsCoreService = HsCoreService;
        this.HsSidebarService = HsSidebarService;
        this.HsPermalinkUrlService = HsPermalinkUrlService;
        this.HsConfig = HsConfig;
    }
    ngOnDestroy() {
        this.configChangesSubscription.unsubscribe();
    }
    ngOnInit() {
        if (this.HsCoreService.config.createExtraMenu !== undefined) {
            this.HsCoreService.config.createExtraMenu(this.HsSidebarService);
        }
        const panel = this.HsPermalinkUrlService.getParamValue(HS_PRMS.panel);
        if (panel) {
            if (!this.HsLayoutService.minisidebar) {
                this.HsLayoutService.setMainPanel(panel);
            }
        }
        this.HsSidebarService.setPanelState(this.HsSidebarService.buttons);
        this.configChangesSubscription = this.HsConfig.configChanges.subscribe((_) => {
            this.HsSidebarService.setPanelState(this.HsSidebarService.buttons);
        });
        this.HsSidebarService.sidebarLoad.next();
    }
    /**
     * Seat whether to show all sidebar buttons or just a
     * subset of important ones
     */
    toggleUnimportant() {
        this.HsSidebarService.showUnimportant =
            !this.HsSidebarService.showUnimportant;
    }
    /**
     * Toggle sidebar mode between expanded and narrow
     */
    toggleSidebar() {
        this.HsLayoutService.sidebarExpanded =
            !this.HsLayoutService.sidebarExpanded;
        setTimeout(() => {
            this.HsCoreService.updateMapSize();
        }, 110);
    }
}
HsSidebarComponent.ɵfac = function HsSidebarComponent_Factory(t) { return new (t || HsSidebarComponent)(ɵngcc0.ɵɵdirectiveInject(HsLayoutService), ɵngcc0.ɵɵdirectiveInject(HsCoreService), ɵngcc0.ɵɵdirectiveInject(HsSidebarService), ɵngcc0.ɵɵdirectiveInject(HsShareUrlService), ɵngcc0.ɵɵdirectiveInject(HsConfig)); };
HsSidebarComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsSidebarComponent, selectors: [["hs-sidebar"]], decls: 7, vars: 8, consts: [[1, "hs-sidebar-list", "hs-main-panel", "list-group"], ["class", "sidebar-header w-100", "name", "additional", 3, "title", 4, "ngIf"], ["class", "hs-sidebar-item list-group-item", 3, "click", 4, "ngIf"], ["class", "hs-sidebar-item list-group-item", 3, "hidden", "ngClass", "title", "click", 4, "ngFor", "ngForOf"], ["class", "hs-sidebar-item  list-group-item", 3, "ngClass", "click", 4, "ngIf"], [1, "mt-auto"], ["name", "additional", 1, "sidebar-header", "w-100", 3, "title"], [1, "hs-sidebar-item", "list-group-item", 3, "click"], [1, "menu-icon", 3, "ngClass"], [1, "hs-sidebar-item", "list-group-item", 3, "hidden", "ngClass", "title", "click"], ["data-toggle", "tooltip", "data-container", "body", "data-placement", "auto", 3, "class", 4, "ngIf"], ["data-toggle", "tooltip", "data-container", "body", "data-placement", "auto", "class", "", 3, "title", 4, "ngIf"], [1, "hs-sidebar-item-title", 3, "ngStyle"], ["data-toggle", "tooltip", "data-container", "body", "data-placement", "auto"], ["data-toggle", "tooltip", "data-container", "body", "data-placement", "auto", 1, "", 3, "title"], [1, "hs-sidebar-item", "list-group-item", 3, "ngClass", "click"], ["data-toggle", "tooltip", "data-container", "body", "data-placement", "auto", "title", "Menu", 1, "menu-icon", "icon-equals", 2, "margin-left", "0px !important"], [1, "hs-sidebar-item-title"]], template: function HsSidebarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, HsSidebarComponent_hs_panel_header_1_Template, 2, 3, "hs-panel-header", 1);
        ɵngcc0.ɵɵtemplate(2, HsSidebarComponent_span_2_Template, 2, 1, "span", 2);
        ɵngcc0.ɵɵtemplate(3, HsSidebarComponent_span_3_Template, 5, 12, "span", 3);
        ɵngcc0.ɵɵpipe(4, "sortBy");
        ɵngcc0.ɵɵtemplate(5, HsSidebarComponent_span_5_Template, 4, 4, "span", 4);
        ɵngcc0.ɵɵelement(6, "hs-impressum", 5);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.HsLayoutService.minisidebar);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.HsLayoutService.sidebarToggleable);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind3(4, 4, ctx.HsSidebarService.buttons, "asc", "order"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.HsLayoutService.minisidebar);
    } }, directives: function () { return [ɵngcc3.NgIf, ɵngcc3.NgForOf, HsImpressumComponent, HsPanelHeaderComponent, ɵngcc3.NgClass, ɵngcc3.NgStyle]; }, pipes: function () { return [SortByPipe, ɵngcc1.TranslatePipe]; }, encapsulation: 2 });
HsSidebarComponent.ctorParameters = () => [
    { type: HsLayoutService },
    { type: HsCoreService },
    { type: HsSidebarService },
    { type: HsShareUrlService },
    { type: HsConfig }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsSidebarComponent, [{
        type: Component,
        args: [{
                selector: 'hs-sidebar',
                template: "<div class=\"hs-sidebar-list hs-main-panel list-group\">\n    <hs-panel-header class=\"sidebar-header w-100\" *ngIf=\"HsLayoutService.minisidebar\" name=\"additional\" [title]=\"'SIDEBAR.additionalPanels' | translate\"></hs-panel-header>\n\n    <span class=\"hs-sidebar-item list-group-item\" *ngIf=\"HsLayoutService.sidebarToggleable\" (click)=\"toggleSidebar()\">\n        <i class=\"menu-icon\" [ngClass]=\"HsLayoutService.sidebarExpanded ? (HsConfig.sidebarPosition === 'left' ? 'icon-chevron-left' : 'icon-chevron-right') : (HsConfig.sidebarPosition === 'left' ? 'icon-chevron-right' : 'icon-chevron-left')\"></i>\n    </span>\n\n    <span *ngFor=\"let button of HsSidebarService.buttons | sortBy: 'asc': 'order'\" class=\"hs-sidebar-item list-group-item\" [hidden]=\"!button.visible\" (click)=\"HsSidebarService.buttonClicked(button)\"\n        [ngClass]=\"{'active': HsLayoutService.mainpanel === button.panel,  'hs-panel-hidden' : !button.fits}\" title=\"{{HsSidebarService.getButtonDescription(button)}}\">\n        <i *ngIf=\"button.icon\" class=\"menu-icon {{button.icon}}\" data-toggle=\"tooltip\" data-container=\"body\" data-placement=\"auto\"></i>\n        <span *ngIf=\"button.content\" data-toggle=\"tooltip\" data-container=\"body\" data-placement=\"auto\" class=\"\" title=\"{{HsSidebarService.getButtonDescription(button)}}\">{{button.content()}}</span>\n        <span [ngStyle]=\"{'margin-left' : button.panel === 'language' ? '14px' : '20px'}\" class=\"hs-sidebar-item-title\">{{HsSidebarService.getButtonTitle(button)}}</span>\n    </span>\n\n    <span class=\"hs-sidebar-item  list-group-item\" *ngIf=\"HsLayoutService.minisidebar\" (click)=\"HsLayoutService.setMainPanel('sidebar', true)\" [ngClass]=\"{'active': HsLayoutService.mainpanel === 'sidebar'}\">\n        <i class=\"menu-icon icon-equals\" data-toggle=\"tooltip\" data-container=\"body\" data-placement=\"auto\" title=\"Menu\" style=\"margin-left: 0px !important;\"></i>\n        <span class=\"hs-sidebar-item-title\">{{HsSidebarService.getButtonTitle(HsSidebarService.miniSidebarButton)}}</span>\n    </span>\n    <hs-impressum class=\"mt-auto\"></hs-impressum>\n</div>\n"
            }]
    }], function () { return [{ type: HsLayoutService }, { type: HsCoreService }, { type: HsSidebarService }, { type: HsShareUrlService }, { type: HsConfig }]; }, null); })();

class SortByPipe {
    transform(value, order = '', column = '') {
        if (value.length <= 1) {
            return value;
        } // array with only one item
        if (order === undefined || order == '') {
            value ? (column ? this.ascendingOrder(value, column) : value) : [];
            return value;
        }
        if (column === undefined || column == '') {
            return value;
        }
        if (column || column !== '') {
            value
                ? order === 'asc'
                    ? this.ascendingOrder(value, column)
                    : this.descendingOrder(value, column)
                : [];
            return value;
        }
    }
    ascendingOrder(array, column) {
        return array.sort((a, b) => {
            return a[column] - b[column];
        });
    }
    descendingOrder(array, column) {
        return array.sort((a, b) => {
            return b[column] - a[column];
        });
    }
}
SortByPipe.ɵfac = function SortByPipe_Factory(t) { return new (t || SortByPipe)(); };
SortByPipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "sortBy", type: SortByPipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SortByPipe, [{
        type: Pipe,
        args: [{ name: 'sortBy' }]
    }], null, null); })();

class HsSidebarModule {
}
HsSidebarModule.ɵfac = function HsSidebarModule_Factory(t) { return new (t || HsSidebarModule)(); };
HsSidebarModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: HsSidebarModule });
HsSidebarModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, HsPanelHelpersModule, TranslateModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsSidebarModule, [{
        type: NgModule,
        args: [{
                schemas: [CUSTOM_ELEMENTS_SCHEMA],
                declarations: [
                    HsImpressumComponent,
                    HsMiniSidebarComponent,
                    HsSidebarComponent,
                    SortByPipe,
                ],
                imports: [CommonModule, HsPanelHelpersModule, TranslateModule],
                exports: [HsMiniSidebarComponent, HsSidebarComponent],
                entryComponents: [
                    HsImpressumComponent,
                    HsMiniSidebarComponent,
                    HsSidebarComponent,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(HsSidebarModule, { declarations: function () { return [HsImpressumComponent, HsMiniSidebarComponent, HsSidebarComponent, SortByPipe]; }, imports: function () { return [CommonModule, HsPanelHelpersModule, TranslateModule]; }, exports: function () { return [HsMiniSidebarComponent, HsSidebarComponent]; } }); })();

class HsLayoutModule {
    ngDoBootstrap() { }
}
HsLayoutModule.ɵfac = function HsLayoutModule_Factory(t) { return new (t || HsLayoutModule)(); };
HsLayoutModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: HsLayoutModule });
HsLayoutModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            TranslateModule,
            HsConfirmModule,
            HsMapModule,
            HsSidebarModule,
            HsPanelHelpersModule,
            HsToastModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsLayoutModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    HsDialogContainerComponent,
                    HsDialogHostDirective,
                    HsMapHostDirective,
                    HsLayoutComponent,
                    HsLayoutHostDirective,
                ],
                schemas: [CUSTOM_ELEMENTS_SCHEMA],
                imports: [
                    CommonModule,
                    TranslateModule,
                    HsConfirmModule,
                    HsMapModule,
                    HsSidebarModule,
                    HsPanelHelpersModule,
                    HsToastModule,
                ],
                entryComponents: [HsDialogContainerComponent, HsLayoutComponent],
                exports: [HsDialogContainerComponent, HsLayoutComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(HsLayoutModule, { declarations: function () { return [HsDialogContainerComponent, HsDialogHostDirective, HsMapHostDirective, HsLayoutComponent, HsLayoutHostDirective]; }, imports: function () { return [CommonModule,
        TranslateModule, HsConfirmModule, HsMapModule, HsSidebarModule, HsPanelHelpersModule, HsToastModule]; }, exports: function () { return [HsDialogContainerComponent, HsLayoutComponent]; } }); })();

class HsDrawLayerMetadataDialogComponent {
    constructor(HsMapService, HsDialogContainerService) {
        this.HsMapService = HsMapService;
        this.HsDialogContainerService = HsDialogContainerService;
        this.attributes = [];
        this.folderVisible = false;
        this.access_rights = {
            'access_rights.write': 'private',
            'access_rights.read': 'EVERYONE',
        };
        this.onlyMineFilterVisible = false;
    }
    ngOnInit() {
        this.layer = this.data.selectedLayer;
        this.title = getTitle(this.layer);
        this.path = getPath(this.layer);
        this.endpoint = this.data.laymanEndpoint;
        this.type = 'draw';
    }
    titleChanged() {
        setTitle(this.layer, this.title);
    }
    confirm() {
        const dic = {};
        setName(this.layer, getLaymanFriendlyLayerName(getTitle(this.layer)));
        const tmpLayer = this.HsMapService.findLayerByTitle('tmpDrawLayer') || null;
        if (tmpLayer) {
            this.HsMapService.map.removeLayer(tmpLayer);
        }
        this.attributes.forEach((a) => {
            dic[a.name] = a.value;
        });
        let editorConfig = getEditor(this.layer);
        if (!editorConfig) {
            editorConfig = {};
            setEditor(this.layer, editorConfig);
        }
        editorConfig.defaultAttributes = dic;
        this.layer.getSource().forEachFeature((f) => {
            f.setProperties(dic);
        });
        setAccessRights(this.layer, this.access_rights);
        this.data.changeDrawSource();
        this.data.addDrawLayer(this.layer);
        this.data.fillDrawableLayers();
        this.tmpFeatures = this.layer.getSource().getFeatures();
        //Dispatch add feature event in order to trigger sync
        this.awaitLayerSync(this.layer).then(() => {
            const event = this.tmpFeatures ? this.getEventType() : 'addfeature';
            this.layer.getSource().dispatchEvent(event);
        });
        this.data.tmpDrawLayer = false;
        this.HsDialogContainerService.destroy(this);
    }
    getEventType() {
        return this.layer.getSource().getFeatures().length > this.tmpFeatures.length
            ? //Existing layer
                { type: 'addfeature', feature: this.tmpFeatures }
            : //New layer
                'addfeature';
    }
    cancel() {
        this.data.selectedLayer = this.data.previouslySelected;
        this.HsDialogContainerService.destroy(this);
    }
    awaitLayerSync(layer) {
        return __awaiter(this, void 0, void 0, function* () {
            while (getHsLaymanSynchronizing(layer)) {
                yield new Promise((r) => setTimeout(r, 200));
            }
            return true;
        });
    }
    pathChanged() {
        setPath(this.layer, this.path);
    }
    addAttr() {
        this.attributes.push({ id: Math.random(), name: '', value: '' });
    }
    selectLayer(layer) {
        this.data.selectLayer(layer);
        this.HsDialogContainerService.destroy(this);
    }
}
HsDrawLayerMetadataDialogComponent.ɵfac = function HsDrawLayerMetadataDialogComponent_Factory(t) { return new (t || HsDrawLayerMetadataDialogComponent)(ɵngcc0.ɵɵdirectiveInject(HsMapService), ɵngcc0.ɵɵdirectiveInject(HsDialogContainerService)); };
HsDrawLayerMetadataDialogComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsDrawLayerMetadataDialogComponent, selectors: [["hs-draw-layer-metadata"]], inputs: { data: "data" }, decls: 27, vars: 17, consts: [["tabindex", "-1", "role", "dialog", "aria-hidden", "true", 1, "modal", "in", "hs-draw-layer-metadata"], [1, "modal-dialog"], [1, "modal-content"], [1, "modal-header", "d-flex", "flex-column", 2, "height", "auto"], [1, "d-flex", "w-100", "align-items-center"], [1, "modal-title"], ["type", "button", "data-dismiss", "modal", 1, "close", 3, "click"], ["aria-hidden", "true"], [1, "sr-only"], [1, "m-0", "p-0", 2, "font-size", "small", "color", "red"], ["class", "alert alert-danger", "role", "alert", 4, "ngIf"], ["class", "d-flex w-75 m-auto p-4 justify-content-around", "style", "white-space: nowrap;", 4, "ngIf"], [1, "modal-body", 2, "max-height", "400px", "overflow-y", "auto"], [4, "ngIf"], [1, "modal-footer"], ["type", "button", "class", "btn btn-primary", "data-dismiss", "modal", 3, "click", 4, "ngIf"], ["type", "button", "data-dismiss", "modal", 1, "btn", "btn-primary", 3, "click"], ["role", "alert", 1, "alert", "alert-danger"], [1, "text-center"], [3, "endpoint"], [1, "d-flex", "w-75", "m-auto", "p-4", "justify-content-around", 2, "white-space", "nowrap"], ["type", "button", 1, "btn", "btn-sm", "rounded", "hs-toolbar-button", 3, "ngClass", "click"], ["type", "button", 1, "btn", "ml-1", "btn-sm", "rounded", "hs-toolbar-button", 3, "ngClass", "click"], [1, "form-group"], [1, "control-label"], [1, "mb-3"], ["name", "title", 1, "form-control", 3, "ngModel", "ngModelChange"], [3, "access_rights", "access_rightsChange", 4, "ngIf"], [1, "flex-row", "w-75", "align-items-center", 2, "display", "flex"], [1, "p-1", "mb-1", 3, "click"], [3, "hidden"], ["name", "path", 1, "form-control", 3, "ngModel", "placeholder", "ngModelChange"], [1, "card"], [1, "card-header"], [1, "card-body"], [1, "table", "table-condensed"], [4, "ngFor", "ngForOf"], [1, "btn", "btn-primary", 3, "click"], [1, "icon-plus"], [3, "access_rights", "access_rightsChange"], [1, "form-control", 3, "ngModel", "ngModelOptions", "ngModelChange"], ["class", "d-flex align-items-center w-100 flex-column", 4, "ngIf"], [1, "d-flex", "align-items-center", "w-100", "flex-column"], [1, "bg-primary", "w-100", "text-light", "m-0", "p-1"], [1, "d-flex", "justify-content-between", "m-1"], [2, "cursor", "pointer", 3, "click"], [1, "icon-settingsthree-gears"], ["class", "input-group-text border-0 justify-content-center bg-white", 4, "ngIf"], [1, "list-group", "w-100"], ["class", "clearfix", 3, "ngClass", 4, "ngFor", "ngForOf"], [1, "input-group-text", "border-0", "justify-content-center", "bg-white"], [1, "m-0"], ["type", "checkbox", "name", "onlyMine", 3, "ngModel", "ngModelChange"], [1, "clearfix", 3, "ngClass"], ["data-toggle", "tooltip", 3, "title"], [1, "float-right"], ["type", "button", "data-toggle", "tooltip", 1, "btn", "btn-sm", "btn-primary", 3, "title", "click"]], template: function HsDrawLayerMetadataDialogComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelementStart(4, "div", 4);
        ɵngcc0.ɵɵelementStart(5, "h4", 5);
        ɵngcc0.ɵɵtext(6);
        ɵngcc0.ɵɵpipe(7, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "button", 6);
        ɵngcc0.ɵɵlistener("click", function HsDrawLayerMetadataDialogComponent_Template_button_click_8_listener() { return ctx.cancel(); });
        ɵngcc0.ɵɵelementStart(9, "span", 7);
        ɵngcc0.ɵɵtext(10, "\u00D7");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "span", 8);
        ɵngcc0.ɵɵtext(12);
        ɵngcc0.ɵɵpipe(13, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(14, "p", 9);
        ɵngcc0.ɵɵtext(15);
        ɵngcc0.ɵɵpipe(16, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(17, HsDrawLayerMetadataDialogComponent_div_17_Template, 5, 4, "div", 10);
        ɵngcc0.ɵɵtemplate(18, HsDrawLayerMetadataDialogComponent_div_18_Template, 7, 8, "div", 11);
        ɵngcc0.ɵɵelementStart(19, "div", 12);
        ɵngcc0.ɵɵtemplate(20, HsDrawLayerMetadataDialogComponent_form_20_Template, 35, 26, "form", 13);
        ɵngcc0.ɵɵtemplate(21, HsDrawLayerMetadataDialogComponent_form_21_Template, 2, 1, "form", 13);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(22, "div", 14);
        ɵngcc0.ɵɵtemplate(23, HsDrawLayerMetadataDialogComponent_button_23_Template, 3, 3, "button", 15);
        ɵngcc0.ɵɵelementStart(24, "button", 16);
        ɵngcc0.ɵɵlistener("click", function HsDrawLayerMetadataDialogComponent_Template_button_click_24_listener() { return ctx.cancel(); });
        ɵngcc0.ɵɵtext(25);
        ɵngcc0.ɵɵpipe(26, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(7, 9, "COMMON.newDrawingLayer"), " ");
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(13, 11, "COMMON.close"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(16, 13, "DRAW.drawLayerMetadata.layerWillBeAdded"), "");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.data.isAuthorized && ctx.data.laymanEndpoint !== undefined);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.data.drawableLaymanLayers.length > 0 && ctx.data.isAuthorized);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.type === "draw");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.type === "layman");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.type === "draw");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(26, 15, "COMMON.cancel"));
    } }, directives: function () { return [ɵngcc3.NgIf, HsLaymanCurrentUserComponent, ɵngcc3.NgClass, ɵngcc5.ɵNgNoValidate, ɵngcc5.NgControlStatusGroup, ɵngcc5.NgForm, ɵngcc5.DefaultValueAccessor, ɵngcc5.NgControlStatus, ɵngcc5.NgModel, ɵngcc3.NgForOf, HsCommonLaymanAccessRightsComponent, ɵngcc5.CheckboxControlValueAccessor]; }, pipes: function () { return [ɵngcc1.TranslatePipe]; }, encapsulation: 2 });
HsDrawLayerMetadataDialogComponent.ctorParameters = () => [
    { type: HsMapService },
    { type: HsDialogContainerService }
];
HsDrawLayerMetadataDialogComponent.propDecorators = {
    data: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsDrawLayerMetadataDialogComponent, [{
        type: Component,
        args: [{
                selector: 'hs-draw-layer-metadata',
                template: "<div class=\"modal in hs-draw-layer-metadata\" tabindex=\"-1\" role=\"dialog\"\n    aria-hidden=\"true\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header d-flex flex-column\" style=\"height: auto\">\n                <div class=\"d-flex w-100 align-items-center\">\n                    <h4 class=\"modal-title\">\n                        {{'COMMON.newDrawingLayer' | translate}}\n                    </h4>\n                    <button type=\"button\" (click)=\"cancel()\" class=\"close\"\n                        data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span><span\n                            class=\"sr-only\">{{'COMMON.close' | translate}}</span></button>\n                </div>\n                <p class=\"m-0 p-0\" style=\"font-size: small; color: red;\">\n                    {{'DRAW.drawLayerMetadata.layerWillBeAdded' | translate}}</p>\n            </div>\n            <div *ngIf=\"!data.isAuthorized && this.data.laymanEndpoint !== undefined\" class=\"alert alert-danger\" role=\"alert\">\n                <p class=\"text-center\">\n                    {{'DRAW.notAuthorized' | translate}}\n                </p>\n                <hs-layman-current-user [endpoint]=\"endpoint\"></hs-layman-current-user>\n            </div>\n            <div class=\"d-flex w-75 m-auto p-4 justify-content-around\" style=\"white-space: nowrap;\"\n                *ngIf=\"data.drawableLaymanLayers.length > 0 && data.isAuthorized\">\n                <button type=\"button\" class=\"btn btn-sm rounded  hs-toolbar-button\" (click)=\"type = 'draw'\"\n                    [ngClass]=\"type === 'draw' ? 'btn-primary' : 'btn-secondary'\">\n                    {{'DRAW.drawToolbar.addDrawLayer' | translate}}\n                </button>\n                <button type=\"button\" class=\"btn ml-1 btn-sm rounded hs-toolbar-button\"\n                    (click)=\"type = 'layman'\" [ngClass]=\"type === 'layman' ? 'btn-primary' : 'btn-secondary'\">\n                    {{'DRAW.drawLayerMetadata.loadServerLayers' | translate}}\n                </button>\n            </div>\n            <div class=\"modal-body\" style=\"max-height:400px; overflow-y:auto\">\n                <form *ngIf=\"type === 'draw'\">\n                    <div class=\"form-group\">\n                        <label class=\"control-label\">{{'DRAW.drawLayerMetadata.layerTitle' | translate}}</label>\n                        <div class=\"mb-3\">\n                            <input class=\"form-control\" [(ngModel)]=\"title\" (ngModelChange)=\"titleChanged()\"\n                                name=\"title\" />\n                        </div>\n                    </div>\n                    <hs-layman-access-rights  *ngIf=\"data.isAuthorized\" [(access_rights)]=\"access_rights\"></hs-layman-access-rights>\n                    <div class=\"flex-row w-75 align-items-center\" style=\"display: flex;\">\n                        <a class=\"p-1 mb-1\"\n                            (click)=\"folderVisible = !folderVisible\">{{'COMMON.advancedOptions' | translate}}</a>\n                    </div>\n                    <div [hidden]=\"!folderVisible\">\n                        <div class=\"form-group\">\n                            <label class=\"control-label\">{{'COMMON.folder' | translate}}</label>\n                            <input class=\"form-control\" [(ngModel)]=\"path\" (ngModelChange)=\"pathChanged()\" name=\"path\"\n                                [placeholder]=\"'DRAW.drawLayerMetadata.nameOfFolder' | translate\" />\n                        </div>\n                        <div class=\"card\">\n                            <h5 class=\"card-header\">{{'DRAW.drawLayerMetadata.defaultAttributes' | translate}}</h5>\n                            <div class=\"card-body\">\n                                <table class=\"table table-condensed\">\n                                    <tr>\n                                        <th>{{'COMMON.attribute' | translate}}</th>\n                                        <th>{{'DRAW.drawLayerMetadata.defaultValue' | translate}}</th>\n                                    </tr>\n                                    <tr *ngFor=\"let attr of attributes\">\n                                        <td><input class=\"form-control\" [(ngModel)]=\"attr.name\"\n                                                [ngModelOptions]=\"{standalone: true}\" /></td>\n                                        <td><input class=\"form-control\" [(ngModel)]=\"attr.value\"\n                                                [ngModelOptions]=\"{standalone: true}\" /></td>\n                                    </tr>\n                                </table>\n                                <button class=\"btn btn-primary\" (click)=\"addAttr()\"><i class=\"icon-plus\"></i></button>\n                            </div>\n                        </div>\n                    </div>\n                </form>\n                <form *ngIf=\"type === 'layman'\">\n                    <div class=\"d-flex align-items-center w-100 flex-column\" *ngIf=\"data.drawableLaymanLayers.length > 0\">\n                        <div class=\" bg-primary w-100 text-light m-0 p-1\">\n                            <div class=\"d-flex justify-content-between m-1\">\n                                {{'DRAW.serverLayers' | translate}}\n                                <span (click)=\"onlyMineFilterVisible = !onlyMineFilterVisible\" style=\"cursor: pointer;\">\n                                    <i class=\"icon-settingsthree-gears\"></i>\n                                </span>\n                            </div>\n                        \n                            <div class=\"input-group-text border-0 justify-content-center bg-white\" *ngIf=\"onlyMineFilterVisible\">\n                                <label class=\"m-0\">\n                                    <input type=\"checkbox\" name=\"onlyMine\" [(ngModel)]=\"data.onlyMine\"\n                                        (ngModelChange)=\"data.fillDrawableLayers(); onlyMineFilterVisible = !onlyMineFilterVisible\">\n                                    {{'COMPOSITIONS.onlyMine' | translate}}\n                                </label>\n                            </div>\n                        </div>\n                        <ul class=\"list-group w-100\">\n                            <li *ngFor=\"let layer of data.drawableLaymanLayers\" class=\"clearfix\"\n                                [ngClass]=\"'list-group-item'+(layer.highlighted ? ' active' : '')\">\n                                <b><a  data-toggle=\"tooltip\"\n                                        title=\"{{layer.description}}\">{{layer.title}}</a></b>\n                                <span class=\"float-right\">\n                                    <button type=\"button\" class=\"btn btn-sm btn-primary\" (click)=\"selectLayer(layer)\"\n                                        data-toggle=\"tooltip\" [title]=\"'ADDLAYERS.WFS.addToMap' | translate\"><i\n                                            class=\"icon-plus\"></i></button>\n                                </span>\n                            </li>\n                        </ul>\n                    </div>\n                </form>\n            </div>\n            <div class=\"modal-footer\">\n                <button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\" *ngIf=\"type === 'draw'\"\n                    (click)=\"confirm()\">{{'DRAW.drawToolbar.addLayer' | translate}}</button>\n                <button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\"\n                    (click)=\"cancel()\">{{'COMMON.cancel' | translate}}</button>\n            </div>\n        </div>\n    </div>\n</div>\n"
            }]
    }], function () { return [{ type: HsMapService }, { type: HsDialogContainerService }]; }, { data: [{
            type: Input
        }] }); })();

class HsDrawComponent extends HsPanelBaseComponent {
    constructor(HsDrawService, hsLayoutService, HsLayerUtilsService, HsQueryBaseService, hsUtilsService, HsLanguageService, hsSidebarService, HsDialogContainerService) {
        super(hsLayoutService);
        this.HsDrawService = HsDrawService;
        this.hsLayoutService = hsLayoutService;
        this.HsLayerUtilsService = HsLayerUtilsService;
        this.HsQueryBaseService = HsQueryBaseService;
        this.hsUtilsService = hsUtilsService;
        this.HsLanguageService = HsLanguageService;
        this.selectionMenuExpanded = false;
        this.opacity = 0.2;
        this.linewidth = 1;
        this.fillcolor = { 'background-color': 'rgba(0, 153, 255, 1)' };
        this.onlyMineFilterVisible = false;
        this.getTitle = getTitle;
        this.name = 'draw';
        hsSidebarService.buttons.push({
            panel: 'draw',
            module: 'hs.draw',
            order: 16,
            fits: true,
            title: () => this.HsLanguageService.getTranslation('PANEL_HEADER.DRAW'),
            description: () => this.HsLanguageService.getTranslation('SIDEBAR.descriptions.DRAW'),
            icon: 'icon-pencil',
        });
        this.HsDrawService.init();
        this.HsDrawService.layerMetadataDialog.subscribe(() => {
            HsDialogContainerService.create(HsDrawLayerMetadataDialogComponent, this.HsDrawService);
        });
    }
    selectionMenuToggled() {
        this.setType(this.HsDrawService.type);
        this.selectionMenuExpanded = !this.selectionMenuExpanded;
    }
    translateString(module, text) {
        return this.HsLanguageService.getTranslationIgnoreNonExisting(module, text);
    }
    activateDrawing(withStyle) {
        this.HsDrawService.activateDrawing({
            changeStyle: withStyle ? () => this.changeStyle() : undefined,
        });
    }
    setType(what) {
        const type = this.HsDrawService.setType(what);
        if (type) {
            this.activateDrawing(this.hsLayoutService.panelVisible('draw'));
        }
    }
    selectLayer(layer) {
        this.HsDrawService.selectLayer(layer);
        this.layersExpanded = false;
    }
    changeSnapSource(layer) {
        this.HsDrawService.changeSnapSource(layer);
        this.snapLayersExpanded = false;
    }
    updateStyle() {
        this.HsDrawService.updateStyle(() => this.changeStyle());
    }
    /**
     * @param {Event} e optional parameter passed when changeStyle is called
     * for 'ondrawend' event features
     * @description Dynamically create draw feature style according to parameters selected in
     * hs.styler.colorDirective
     * @returns {Array} Array of style definitions
     */
    changeStyle(e = null) {
        const newStyle = new Style({
            stroke: new Stroke({
                color: this.fillcolor['background-color'],
                width: this.linewidth,
            }),
            fill: new Fill({
                color: this.fillcolor['background-color'].slice(0, -2) + this.opacity + ')',
            }),
            image: new Circle({
                radius: 5,
                fill: new Fill({
                    color: this.fillcolor['background-color'].slice(0, -2) +
                        this.opacity +
                        ')',
                }),
                stroke: new Stroke({
                    color: this.fillcolor['background-color'],
                    width: this.linewidth,
                }),
            }),
        });
        return newStyle;
    }
    drawStyle() {
        return {
            'background-color': this.fillcolor['background-color'].slice(0, -2) + this.opacity + ')',
            border: this.linewidth + 'px solid ' + this.fillcolor['background-color'],
        };
    }
}
HsDrawComponent.ɵfac = function HsDrawComponent_Factory(t) { return new (t || HsDrawComponent)(ɵngcc0.ɵɵdirectiveInject(HsDrawService), ɵngcc0.ɵɵdirectiveInject(HsLayoutService), ɵngcc0.ɵɵdirectiveInject(HsLayerUtilsService), ɵngcc0.ɵɵdirectiveInject(HsQueryBaseService), ɵngcc0.ɵɵdirectiveInject(HsUtilsService), ɵngcc0.ɵɵdirectiveInject(HsLanguageService), ɵngcc0.ɵɵdirectiveInject(HsSidebarService), ɵngcc0.ɵɵdirectiveInject(HsDialogContainerService)); };
HsDrawComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsDrawComponent, selectors: [["hs-draw"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 57, vars: 78, consts: [[1, "card", "hs-main-panel", 3, "hidden"], ["name", "draw", 3, "title"], ["data-toggle", "tooltip", 1, "but-title-sm", 3, "title"], [1, "icon-question-sign"], [1, "d-flex", "flex-column"], [1, "d-flex", "w-75", "m-auto", "py-2", "justify-content-around", 2, "white-space", "nowrap"], ["type", "button", 1, "btn", "rounded", "btn-primary", "hs-toolbar-button", 3, "ngClass", "click"], ["type", "button", 1, "btn", "ml-1", "rounded", "btn-primary", "hs-toolbar-button", 3, "ngClass", "disabled", "click"], [1, "btn-group", "w-100", "m-auto", "justify-content-center", 3, "ngClass"], ["noLayerAvailable", ""], ["class", "flex-row w-100 m-auto justify-content-center align-items-center", "style", "display: flex;", 4, "ngIf", "ngIfElse"], [1, "btn-block", "rounded-0", "my-1", "draw-buttons", "d-flex", "justify-content-center", 3, "ngClass"], ["data-toggle", "tooltip", 1, "btn", "btn-light", "btn-outline-primary", 3, "ngClass", "title", "click"], [1, "icon-pin"], [1, "icon-polygonlasso"], [1, "icon-line"], [1, "icon-circleloaderfull"], ["type", "button", "data-toggle", "dropdown", "data-display", "static", "data-flip", "false", "aria-haspopup", "true", 1, "btn", "btn-light", "btn-outline-primary", "dropdown-toggle", 3, "ngClass", "title", "click"], [1, "icon-cursor"], [1, "dropdown", 2, "white-space", "nowrap"], [1, "dropdown-menu", "dropdown-menu-right", "flex-column", "px-1", "py-2", 3, "ngClass"], [1, "d-flex", "flex-row", "justify-content-around", "align-items-baseline"], ["for", "draw-boxSelection", 1, "ml-1", "cursor-pointer"], ["type", "checkbox", "id", "draw-boxSelection", "name", "filterByExtent", 1, "cursor-pointer", 3, "ngModel", "ngModelChange", "change"], ["data-toggle", "tooltip", 1, "btn", "btn-primary", "btn-sm", "hs-draw-selectAll", 3, "disabled", "title", "click"], [1, "pt-2"], [2, "font-size", "smaller"], [1, "pb-2"], [1, "form-check"], ["type", "checkbox", "id", "hs-draw-snap", 1, "d-none", 3, "ngModel", "ngModelChange", "change"], ["for", "hs-draw-snap", 3, "ngClass"], ["class", "d-flex align-items-center card flex-row justify-content-around mx-3", 4, "ngIf"], ["class", "m-auto w-100 p-3", 4, "ngIf"], [1, "mh-75", "pt-2"], [3, "features"], [1, "m-0", "text-danger"], [1, "flex-row", "w-100", "m-auto", "justify-content-center", "align-items-center", 2, "display", "flex"], [1, "m-0", "p-0", 2, "color", "var(--primary)"], [1, "dropdown", 2, "max-width", "50%"], ["type", "button", "data-toggle", "dropdown", "aria-haspopup", "true", 1, "btn", "btn-sm", "rounded-0", "hs-toolbar-button", "dropdown-toggle", "d-flex", "align-items-center", "mw-100", 3, "ngClass", "disabled", "click"], [1, "text-truncate"], [1, "dropdown-menu", "dropdown-menu-right", 2, "transform", "translateX(25%)", "width", "15em", 3, "ngClass"], ["class", "d-flex align-items-center w-100 flex-column", 4, "ngIf"], ["type", "button", "class", "btn btn-light btn-outline-primary border-0 btn-sm", 3, "title", "click", 4, "ngIf"], ["type", "button", "class", "btn btn-light  btn-outline-danger btn-sm", "style", "border: none !important;", 3, "title", "click", 4, "ngIf"], [1, "d-flex", "align-items-center", "w-100", "flex-column"], [1, "bg-primary", "w-100", "text-light", "m-0", "p-1"], ["class", "dropdown-item text-truncate", "data-toggle", "tooltip", 3, "title", "click", 4, "ngFor", "ngForOf"], ["data-toggle", "tooltip", 1, "dropdown-item", "text-truncate", 3, "title", "click"], [1, "d-flex", "justify-content-between"], [2, "cursor", "pointer", 3, "click"], [1, "icon-settingsthree-gears"], ["class", "p-0 input-group-text border-0 justify-content-center bg-white", 4, "ngIf"], [1, "p-0", "input-group-text", "border-0", "justify-content-center", "bg-white"], [1, "m-0"], ["type", "checkbox", "name", "onlyMine", 3, "ngModel", "ngModelChange"], ["type", "button", 1, "btn", "btn-light", "btn-outline-primary", "border-0", "btn-sm", 3, "title", "click"], [1, "glyphicon", "icon-save-floppy"], ["type", "button", 1, "btn", "btn-light", "btn-outline-danger", "btn-sm", 2, "border", "none !important", 3, "title", "click"], [1, "glyphicon", "icon-trash"], [1, "d-flex", "align-items-center", "card", "flex-row", "justify-content-around", "mx-3"], [1, "dropdown", "w-50", "d-flex", "justify-content-center"], ["type", "button", "data-toggle", "dropdown", "aria-haspopup", "true", 1, "btn", "btn-sm", "rounded-0", "hs-toolbar-button", "dropdown-toggle", "d-flex", "align-items-center", "mw-100", 2, "font-size", "small", 3, "click"], [1, "mw-100", "text-truncate"], [1, "dropdown-menu", "dropdown-menu-right", 2, "max-width", "150%", 3, "ngClass"], [1, "m-auto", "w-100", "p-3"], [1, "alert", "alert-warning", "text-justify"], [4, "ngFor", "ngForOf"], [1, "d-flex", "justify-content-center", "pt-3"], [3, "src"]], template: function HsDrawComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "hs-panel-header", 1);
        ɵngcc0.ɵɵpipe(2, "translate");
        ɵngcc0.ɵɵelementStart(3, "extra-buttons");
        ɵngcc0.ɵɵelementStart(4, "button", 2);
        ɵngcc0.ɵɵpipe(5, "translate");
        ɵngcc0.ɵɵelement(6, "i", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 4);
        ɵngcc0.ɵɵelementStart(8, "div", 5);
        ɵngcc0.ɵɵelementStart(9, "button", 6);
        ɵngcc0.ɵɵlistener("click", function HsDrawComponent_Template_button_click_9_listener() { return ctx.HsDrawService.saveDrawingLayer(); });
        ɵngcc0.ɵɵtext(10);
        ɵngcc0.ɵɵpipe(11, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "button", 7);
        ɵngcc0.ɵɵlistener("click", function HsDrawComponent_Template_button_click_12_listener() { return ctx.HsDrawService.setType(ctx.HsDrawService.type); });
        ɵngcc0.ɵɵtext(13);
        ɵngcc0.ɵɵpipe(14, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(15, "div", 8);
        ɵngcc0.ɵɵtemplate(16, HsDrawComponent_ng_template_16_Template, 3, 3, "ng-template", null, 9, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(18, HsDrawComponent_div_18_Template, 13, 17, "div", 10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(19, "div", 11);
        ɵngcc0.ɵɵelementStart(20, "button", 12);
        ɵngcc0.ɵɵlistener("click", function HsDrawComponent_Template_button_click_20_listener() { return ctx.setType("Point"); });
        ɵngcc0.ɵɵpipe(21, "translate");
        ɵngcc0.ɵɵelement(22, "i", 13);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(23, "button", 12);
        ɵngcc0.ɵɵlistener("click", function HsDrawComponent_Template_button_click_23_listener() { return ctx.setType("Polygon"); });
        ɵngcc0.ɵɵpipe(24, "translate");
        ɵngcc0.ɵɵelement(25, "i", 14);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(26, "button", 12);
        ɵngcc0.ɵɵlistener("click", function HsDrawComponent_Template_button_click_26_listener() { return ctx.setType("LineString"); });
        ɵngcc0.ɵɵpipe(27, "translate");
        ɵngcc0.ɵɵelement(28, "i", 15);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(29, "button", 12);
        ɵngcc0.ɵɵlistener("click", function HsDrawComponent_Template_button_click_29_listener() { return ctx.setType("Circle"); });
        ɵngcc0.ɵɵpipe(30, "translate");
        ɵngcc0.ɵɵelement(31, "i", 16);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(32, "button", 17);
        ɵngcc0.ɵɵlistener("click", function HsDrawComponent_Template_button_click_32_listener() { return ctx.selectionMenuToggled(); });
        ɵngcc0.ɵɵpipe(33, "translate");
        ɵngcc0.ɵɵelement(34, "i", 18);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(35, "div", 19);
        ɵngcc0.ɵɵelementStart(36, "div", 20);
        ɵngcc0.ɵɵelementStart(37, "div", 21);
        ɵngcc0.ɵɵelementStart(38, "label", 22);
        ɵngcc0.ɵɵtext(39);
        ɵngcc0.ɵɵpipe(40, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(41, "input", 23);
        ɵngcc0.ɵɵlistener("ngModelChange", function HsDrawComponent_Template_input_ngModelChange_41_listener($event) { return ctx.HsDrawService.boxSelectionActive = $event; })("change", function HsDrawComponent_Template_input_change_41_listener() { ctx.HsDrawService.toggleBoxSelection(); return ctx.selectionMenuExpanded = !ctx.selectionMenuExpanded; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(42, "button", 24);
        ɵngcc0.ɵɵlistener("click", function HsDrawComponent_Template_button_click_42_listener() { ctx.HsDrawService.selectAllFeatures(); return ctx.selectionMenuExpanded = !ctx.selectionMenuExpanded; });
        ɵngcc0.ɵɵpipe(43, "translate");
        ɵngcc0.ɵɵtext(44);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(45, "div", 25);
        ɵngcc0.ɵɵelementStart(46, "div", 26);
        ɵngcc0.ɵɵelementStart(47, "div", 27);
        ɵngcc0.ɵɵelementStart(48, "div", 28);
        ɵngcc0.ɵɵelementStart(49, "input", 29);
        ɵngcc0.ɵɵlistener("ngModelChange", function HsDrawComponent_Template_input_ngModelChange_49_listener($event) { return ctx.HsDrawService.snapActive = $event; })("change", function HsDrawComponent_Template_input_change_49_listener() { return ctx.HsDrawService.toggleSnapping(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(50, "label", 30);
        ɵngcc0.ɵɵtext(51);
        ɵngcc0.ɵɵpipe(52, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(53, HsDrawComponent_div_53_Template, 11, 9, "div", 31);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(54, HsDrawComponent_div_54_Template, 8, 5, "div", 32);
        ɵngcc0.ɵɵelementStart(55, "div", 33);
        ɵngcc0.ɵɵelement(56, "hs-query-feature-list", 34);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r0 = ɵngcc0.ɵɵreference(17);
        ɵngcc0.ɵɵproperty("hidden", !ctx.isVisible());
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(2, 35, "PANEL_HEADER.DRAW"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(5, 37, "DRAW.drawInfo"));
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(59, _c15, !ctx.hsLayoutService.sidebarBottom()));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(11, 39, "COMMON.newDrawingLayer"), " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(61, _c15, !ctx.hsLayoutService.sidebarBottom()))("disabled", !ctx.HsDrawService.type);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(14, 41, "DRAW.disableDrawing"), " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ctx.hsLayoutService.sidebarBottom() ? "btn-group-lg" : "btn-group-sm");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.HsDrawService.hasSomeDrawables || ctx.HsDrawService.tmpDrawLayer)("ngIfElse", _r0);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ctx.hsLayoutService.sidebarBottom() ? "btn-group-lg" : "btn-group-sm");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(63, _c16, ctx.HsDrawService.type === "Point"))("title", ɵngcc0.ɵɵpipeBind1(21, 43, "COMMON.point"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(65, _c16, ctx.HsDrawService.type === "Polygon"))("title", ɵngcc0.ɵɵpipeBind1(24, 45, "COMMON.polygon"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(67, _c16, ctx.HsDrawService.type === "LineString"))("title", ɵngcc0.ɵɵpipeBind1(27, 47, "COMMON.line"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(69, _c16, ctx.HsDrawService.type === "Circle"))("title", ɵngcc0.ɵɵpipeBind1(30, 49, "COMMON.circle"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(71, _c16, !ctx.HsDrawService.type))("title", ɵngcc0.ɵɵpipeBind1(33, 51, "STYLER.selection"));
        ɵngcc0.ɵɵattribute("aria-expanded", ctx.selectionMenuExpanded);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(73, _c14, ctx.selectionMenuExpanded));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(40, 53, "DRAW.boxSelection"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngModel", ctx.HsDrawService.boxSelectionActive);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("disabled", !ctx.HsDrawService.selectedLayer)("title", ɵngcc0.ɵɵpipeBind1(43, 55, "DRAW.deselectAllFeatures"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.translateString("DRAW", ctx.HsDrawService.toggleSelectionString), " ");
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.HsDrawService.snapActive);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(75, _c17, ctx.HsDrawService.snapActive, !ctx.HsDrawService.snapActive));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(52, 57, "DRAW.allowSnapping"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.HsDrawService.snapActive && ctx.HsDrawService.drawableLayers.length > 1);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.HsDrawService.pendingLayers.length > 0);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("features", ctx.HsQueryBaseService.data.features);
    } }, directives: function () { return [HsPanelHeaderComponent, ɵngcc3.NgClass, ɵngcc3.NgIf, ɵngcc5.CheckboxControlValueAccessor, ɵngcc5.NgControlStatus, ɵngcc5.NgModel, HsQueryFeatureListComponent, ɵngcc3.NgForOf]; }, pipes: function () { return [ɵngcc1.TranslatePipe]; }, encapsulation: 2 });
HsDrawComponent.ctorParameters = () => [
    { type: HsDrawService },
    { type: HsLayoutService },
    { type: HsLayerUtilsService },
    { type: HsQueryBaseService },
    { type: HsUtilsService },
    { type: HsLanguageService },
    { type: HsSidebarService },
    { type: HsDialogContainerService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsDrawComponent, [{
        type: Component,
        args: [{
                selector: 'hs-draw',
                template: "<div class=\"card hs-main-panel\" [hidden]=\"!isVisible()\">\n    <hs-panel-header name=\"draw\" [title]=\"'PANEL_HEADER.DRAW' | translate\">\n        <extra-buttons>\n            <button class=\"but-title-sm\" data-toggle=\"tooltip\" [title]=\"'DRAW.drawInfo' | translate\">\n                <i class=\"icon-question-sign\"></i>\n            </button>\n        </extra-buttons>\n    </hs-panel-header>\n\n    <div class=\"d-flex flex-column\">\n        <div class=\"d-flex w-75 m-auto py-2 justify-content-around\" style=\"white-space: nowrap;\" >\n            <button type=\"button\" class=\"btn rounded btn-primary hs-toolbar-button\"\n                (click)=\"HsDrawService.saveDrawingLayer()\" [ngClass]=\"{'btn-sm' : !hsLayoutService.sidebarBottom()}\">\n                {{'COMMON.newDrawingLayer' | translate}}\n            </button>\n            <button type=\"button\" (click)=\"HsDrawService.setType(HsDrawService.type)\" [ngClass]=\"{'btn-sm' : !hsLayoutService.sidebarBottom()}\"\n                class=\"btn ml-1 rounded btn-primary hs-toolbar-button\" [disabled]=\"!HsDrawService.type\">\n                {{'DRAW.disableDrawing' | translate}}\n            </button>\n        </div>\n        <!-- <p class=\"m-auto p-0 w-75\" style=\"color:crimson; font-size: smaller;text-align: center;\"\n            [hidden]=\"HsDrawService.type\">{{'DRAW.activateDrawing' | translate}}</p> -->\n        <div class=\"btn-group w-100  m-auto justify-content-center\"\n            [ngClass]=\"hsLayoutService.sidebarBottom() ? 'btn-group-lg' : 'btn-group-sm'\">\n            <ng-template #noLayerAvailable>\n                <p class=\"m-0 text-danger\">{{'DRAW.noSuitableLayer' | translate}}</p>\n            </ng-template>\n\n            <div *ngIf=\"HsDrawService.hasSomeDrawables || HsDrawService.tmpDrawLayer; else noLayerAvailable\"\n                class=\"flex-row w-100 m-auto justify-content-center align-items-center\" style=\"display: flex;\">\n                <p class=\"m-0 p-0\" style=\"color: var(--primary);\">{{'DRAW.drawingTo' | translate}}</p>\n                <div class=\"dropdown\" style=\"max-width: 50%;\">\n                    <button type=\"button\" class=\"btn btn-sm rounded-0 hs-toolbar-button dropdown-toggle d-flex align-items-center mw-100\"\n                        data-toggle=\"dropdown\" aria-haspopup=\"true\"\n                        (click)=\"layersExpanded = !layersExpanded; HsDrawService.fillDrawableLayers() \"\n                        [attr.aria-expanded]=\"layersExpanded\" [ngClass]=\"{'btn-light btn-outline-danger border-0' : HsDrawService.tmpDrawLayer,\n                                                'dropdown-toggle' : HsDrawService.hasSomeDrawables }\"\n                        [disabled]=\"!HsDrawService.hasSomeDrawables\">\n                        <div class=\"text-truncate\">{{HsDrawService.selectedLayerString()}}</div>\n                    </button>\n                    <div class=\"dropdown-menu dropdown-menu-right\"  [ngClass]=\"{'show': layersExpanded}\"\n                        style=\" transform: translateX(25%); width: 15em;\">\n                        <div class=\"d-flex align-items-center w-100 flex-column\"\n                            *ngIf=\"HsDrawService.drawableLayers.length > 0\">\n                            <label class=\" bg-primary w-100 text-light m-0 p-1\">{{'DRAW.activeLayers' |\n                                translate}}</label>\n                            <a class=\"dropdown-item text-truncate\" *ngFor=\"let layer of HsDrawService.drawableLayers\"\n                                data-toggle=\"tooltip\" title=\"{{HsLayerUtilsService.translateTitle(getTitle(layer))}}\"\n                                (click)=\"selectLayer(layer)\">{{HsLayerUtilsService.translateTitle(getTitle(layer))}}</a>\n                        </div>\n                        <div class=\"d-flex align-items-center w-100 flex-column\"\n                            *ngIf=\"HsDrawService.drawableLaymanLayers.length > 0\">\n                            <div class=\" bg-primary w-100 text-light m-0 p-1\">\n                                <div class=\"d-flex justify-content-between\">\n                                    {{'DRAW.serverLayers' | translate}}\n                                    <span (click)=\"onlyMineFilterVisible = !onlyMineFilterVisible\"\n                                        style=\"cursor: pointer;\">\n                                        <i class=\"icon-settingsthree-gears\"></i>\n                                    </span>\n                                </div>\n                                <div class=\"p-0 input-group-text border-0 justify-content-center bg-white\"\n                                    *ngIf=\"onlyMineFilterVisible\">\n                                    <label class=\"m-0\">\n                                        <input type=\"checkbox\" name=\"onlyMine\" [(ngModel)]=\"HsDrawService.onlyMine\"\n                                            (ngModelChange)=\"HsDrawService.fillDrawableLayers(); onlyMineFilterVisible = !onlyMineFilterVisible\">\n                                        {{'COMPOSITIONS.onlyMine' | translate}}\n                                    </label>\n                                </div>\n                            </div>\n                            <a class=\"dropdown-item text-truncate\"\n                                *ngFor=\"let layer of HsDrawService.drawableLaymanLayers\" data-toggle=\"tooltip\"\n                                title=\"{{HsLayerUtilsService.translateTitle(layer.title)}}\"\n                                (click)=\"selectLayer(layer)\">{{HsLayerUtilsService.translateTitle(layer.title)}}</a>\n                        </div>\n                    </div>\n                </div>\n                <button type=\"button\" *ngIf=\"HsDrawService.tmpDrawLayer\"\n                    class=\"btn btn-light btn-outline-primary border-0 btn-sm\" (click)=\"HsDrawService.saveDrawingLayer()\"\n                    [title]=\"'DRAW.saveDrawingToLayer' | translate\">\n                    <i class=\"glyphicon icon-save-floppy\"></i>\n                </button>\n                <button type=\"button\" *ngIf=\"HsDrawService.selectedLayer\"\n                    class=\"btn btn-light  btn-outline-danger btn-sm\" (click)=\"HsDrawService.removeLayer()\"\n                    [title]=\"'COMMON.removeLayer' | translate\" style=\"border: none !important;\">\n                    <i class=\"glyphicon icon-trash\"></i>\n                </button>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"btn-block rounded-0 my-1 draw-buttons d-flex justify-content-center\"\n        [ngClass]=\"hsLayoutService.sidebarBottom() ? 'btn-group-lg' : 'btn-group-sm'\">\n        <button class=\"btn btn-light btn-outline-primary\" [ngClass]=\"{active: HsDrawService.type==='Point' }\"\n            (click)=\"setType('Point')\" data-toggle=\"tooltip\" [title]=\"'COMMON.point' | translate\">\n            <i class=\"icon-pin\"></i>\n        </button>\n        <button class=\"btn btn-light btn-outline-primary\" [ngClass]=\"{active: HsDrawService.type==='Polygon' }\"\n            (click)=\"setType('Polygon')\" data-toggle=\"tooltip\" [title]=\"'COMMON.polygon' | translate\">\n            <i class=\"icon-polygonlasso\"></i>\n        </button>\n        <button class=\"btn btn-light btn-outline-primary\" [ngClass]=\"{active: HsDrawService.type==='LineString' }\"\n            (click)=\"setType('LineString')\" data-toggle=\"tooltip\" [title]=\"'COMMON.line' | translate\">\n            <i class=\"icon-line\"></i>\n        </button>\n        <button class=\"btn btn-light btn-outline-primary\" [ngClass]=\"{active: HsDrawService.type==='Circle' }\"\n            (click)=\"setType('Circle')\" data-toggle=\"tooltip\" [title]=\"'COMMON.circle' | translate\">\n            <i class=\"icon-circleloaderfull\"></i>\n        </button>\n        <button type=\"button\" [ngClass]=\"{active: !HsDrawService.type }\" [title]=\"'STYLER.selection' | translate\"\n            class=\"btn btn-light btn-outline-primary  dropdown-toggle\" data-toggle=\"dropdown\" data-display=\"static\" data-flip=\"false\" aria-haspopup=\"true\"\n            (click)=\"selectionMenuToggled()\" [attr.aria-expanded]=\"selectionMenuExpanded\" >\n            <i class=\"icon-cursor\"></i>\n        </button>\n        <div class=\"dropdown\" style=\"white-space: nowrap;\">\n            <div class=\"dropdown-menu dropdown-menu-right flex-column px-1 py-2\"\n                [ngClass]=\"{'show':  selectionMenuExpanded}\">\n                <div class=\"d-flex flex-row justify-content-around align-items-baseline\">\n                    <label class=\"ml-1 cursor-pointer\" for=\"draw-boxSelection\">{{'DRAW.boxSelection' | translate}}</label>\n                    <input type=\"checkbox\" [(ngModel)]=\"HsDrawService.boxSelectionActive\"\n                        (change)=\"HsDrawService.toggleBoxSelection();selectionMenuExpanded = !selectionMenuExpanded;\"\n                        id=\"draw-boxSelection\" name=\"filterByExtent\" class=\"cursor-pointer\">\n                </div>\n                <button class=\"btn btn-primary btn-sm hs-draw-selectAll\" [disabled]=\"!HsDrawService.selectedLayer\"\n                    (click)=\"HsDrawService.selectAllFeatures();selectionMenuExpanded = !selectionMenuExpanded;\"\n                    data-toggle=\"tooltip\" [title]=\"'DRAW.deselectAllFeatures' | translate\">\n                    {{translateString('DRAW',HsDrawService.toggleSelectionString)}} \n                </button>\n            </div>\n        </div>\n    </div>\n    <div class=\"pt-2\">\n        <div style=\"font-size: smaller\">\n            <div class=\"pb-2\">\n                <div class=\"form-check\">\n                    <input class=\"d-none\" type=\"checkbox\" id=\"hs-draw-snap\" [(ngModel)]=\"HsDrawService.snapActive\"\n                        (change)=\"HsDrawService.toggleSnapping()\" />\n                    <label for=\"hs-draw-snap\"\n                        [ngClass]=\"{'hs-checkmark':HsDrawService.snapActive,'hs-uncheckmark':!HsDrawService.snapActive}\">{{'DRAW.allowSnapping'\n                        | translate}}</label>\n                </div>\n                <div *ngIf=\"HsDrawService.snapActive && HsDrawService.drawableLayers.length > 1\"\n                    class=\"d-flex align-items-center card flex-row justify-content-around mx-3\">\n                    <p class=\"m-0 p-0\" style=\"color: var(--primary);\">{{'DRAW.snapTo' | translate}}:</p>\n                    <div class=\"dropdown w-50 d-flex justify-content-center\">\n                        <button type=\"button\"\n                            class=\"btn btn-sm rounded-0 hs-toolbar-button dropdown-toggle d-flex align-items-center mw-100\"\n                            data-toggle=\"dropdown\" aria-haspopup=\"true\"\n                            (click)=\"snapLayersExpanded = !snapLayersExpanded; HsDrawService.fillDrawableLayers() \"\n                            [attr.aria-expanded]=\"snapLayersExpanded\" style=\" font-size: small;\">\n                            <div class=\"mw-100 text-truncate\">{{HsDrawService.snapLayerString()}}</div>\n                        </button>\n                        <div class=\"dropdown-menu  dropdown-menu-right\" [ngClass]=\"{'show': snapLayersExpanded}\"\n                            style=\"max-width: 150%;\">\n                            <div class=\"d-flex align-items-center w-100 flex-column\">\n                                <a class=\"dropdown-item text-truncate\"\n                                    *ngFor=\"let layer of HsDrawService.drawableLayers\" data-toggle=\"tooltip\"\n                                    title=\"{{HsLayerUtilsService.translateTitle(getTitle(layer))}}\"\n                                    (click)=\"changeSnapSource(layer)\">{{HsLayerUtilsService.translateTitle(getTitle(layer))}}</a>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div *ngIf=\"HsDrawService.pendingLayers.length > 0\" class=\"m-auto w-100 p-3\">\n        <div class=\"alert alert-warning text-justify\">\n            <ol>\n                <li *ngFor=\"let layer of HsDrawService.pendingLayers\">\n                    {{'DRAW.loadingLayer' | translate}} <strong>{{layer}}</strong>\n                </li>\n            </ol>\n            {{'DRAW.longerLoading' | translate}}\n            <div class=\"d-flex justify-content-center pt-3\">\n                <img [src]=\"hsUtilsService.getAjaxLoaderIcon()\" />\n            </div>\n        </div>\n    </div>\n    <div class=\"mh-75 pt-2\">\n        <hs-query-feature-list [features]=\"HsQueryBaseService.data.features\"></hs-query-feature-list>\n    </div>\n</div>\n"
            }]
    }], function () { return [{ type: HsDrawService }, { type: HsLayoutService }, { type: HsLayerUtilsService }, { type: HsQueryBaseService }, { type: HsUtilsService }, { type: HsLanguageService }, { type: HsSidebarService }, { type: HsDialogContainerService }]; }, null); })();

class HsToolbarPanelBaseComponent {
    constructor(hsLayoutService) {
        this.hsLayoutService = hsLayoutService;
    }
    isVisible() {
        return this.hsLayoutService.componentEnabled(this.name);
    }
}
HsToolbarPanelBaseComponent.ɵfac = function HsToolbarPanelBaseComponent_Factory(t) { return new (t || HsToolbarPanelBaseComponent)(ɵngcc0.ɵɵdirectiveInject(HsLayoutService)); };
HsToolbarPanelBaseComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsToolbarPanelBaseComponent, selectors: [["ng-component"]], decls: 1, vars: 0, template: function HsToolbarPanelBaseComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "div");
    } }, encapsulation: 2 });
HsToolbarPanelBaseComponent.ctorParameters = () => [
    { type: HsLayoutService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsToolbarPanelBaseComponent, [{
        type: Component,
        args: [{
                template: '<div></div>'
            }]
    }], function () { return [{ type: HsLayoutService }]; }, null); })();

class HsDrawToolbarComponent extends HsToolbarPanelBaseComponent {
    constructor(HsDrawService, HsLayoutService, HsLayerUtilsService, //Used in template
    HsConfig, HsLanguageService) {
        super(HsLayoutService);
        this.HsDrawService = HsDrawService;
        this.HsLayoutService = HsLayoutService;
        this.HsLayerUtilsService = HsLayerUtilsService;
        this.HsConfig = HsConfig;
        this.HsLanguageService = HsLanguageService;
        this.drawToolbarExpanded = false;
        this.drawTypeExpanded = false;
        this.selectionMenuExpanded = false;
        this.onlyMineFilterVisible = false;
        this.getTitle = getTitle;
    }
    isVisible() {
        return true;
    }
    selectionMenuToggled() {
        this.setType(this.HsDrawService.type);
        this.selectionMenuExpanded = !this.selectionMenuExpanded;
    }
    translateString(module, text) {
        return this.HsLanguageService.getTranslationIgnoreNonExisting(module, text);
    }
    toggleDrawToolbar() {
        this.HsDrawService.highlightDrawButton = false;
        if (this.HsLayoutService.layoutElement.clientWidth > 767 &&
            this.HsLayoutService.layoutElement.clientWidth < 870 &&
            !this.drawToolbarExpanded) {
            this.HsLayoutService.sidebarExpanded = false;
        }
        this.drawToolbarExpanded = !this.drawToolbarExpanded;
        if (!this.drawToolbarExpanded) {
            this.HsDrawService.stopDrawing();
        }
        this.HsDrawService.fillDrawableLayers();
    }
    selectLayer(layer) {
        this.HsDrawService.selectLayer(layer);
        this.layersExpanded = false;
    }
    controlLayerListAction() {
        if (!this.HsDrawService.hasSomeDrawables &&
            this.HsDrawService.tmpDrawLayer) {
            this.HsDrawService.saveDrawingLayer();
        }
        else {
            this.layersExpanded = !this.layersExpanded;
        }
    }
    setType(what) {
        const type = this.HsDrawService.setType(what);
        if (type) {
            this.HsDrawService.activateDrawing({});
        }
    }
    finishDrawing() {
        this.HsDrawService.stopDrawing();
    }
}
HsDrawToolbarComponent.ɵfac = function HsDrawToolbarComponent_Factory(t) { return new (t || HsDrawToolbarComponent)(ɵngcc0.ɵɵdirectiveInject(HsDrawService), ɵngcc0.ɵɵdirectiveInject(HsLayoutService), ɵngcc0.ɵɵdirectiveInject(HsLayerUtilsService), ɵngcc0.ɵɵdirectiveInject(HsConfig), ɵngcc0.ɵɵdirectiveInject(HsLanguageService)); };
HsDrawToolbarComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsDrawToolbarComponent, selectors: [["hs-draw-toolbar"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 5, vars: 9, consts: [[1, "btn-group"], [1, "btn", "rounded-0", "btn-light", "hs-toolbar-button", 3, "ngClass", "click"], ["data-toggle", "tooltip", 3, "ngClass", "title"], ["class", "btn-group", 4, "ngIf"], ["type", "button", "data-toggle", "dropdown", "aria-haspopup", "true", 1, "btn", "btn-light", "rounded-0", "btn-secondary", "dropdown-toggle", "hs-draw-layer-toggle", "d-flex", "align-items-center", 2, "max-width", "125px", "overflow", "hidden", "font-size", "smaller", "z-index", "2", 3, "hidden", "ngClass", "click"], [1, "text-truncate", "pr-1"], [1, "dropdown-menu", 3, "ngClass"], ["class", "d-flex align-items-center w-100 flex-column", 4, "ngIf"], ["data-toggle", "tooltip", 1, "btn", "btn-light", "hs-toolbar-button", "btn-outline-secondary", 3, "hidden", "title", "click"], [1, "icon-plus"], ["type", "button", "class", "btn btn-light  hs-toolbar-button  btn-outline-secondary", 3, "title", "click", 4, "ngIf"], ["type", "button", "class", "btn btn-light hs-toolbar-button  btn-outline-secondary", 3, "title", "click", 4, "ngIf"], ["type", "button", "data-toggle", "dropdown", "aria-haspopup", "true", 1, "btn", "btn-light", "hs-toolbar-button", "btn-outline-secondary", "rounded-0", "dropdown-toggle", 3, "ngClass", "title", "click"], [1, "icon-cursor"], [1, "dropdown", 2, "white-space", "nowrap"], [1, "dropdown-menu", "dropdown-menu-right", "flex-column", "px-1", "py-2", 3, "ngClass"], [1, "d-flex", "flex-row", "justify-content-around", "align-items-baseline"], ["for", "draw-boxSelection", 1, "ml-1", "cursor-pointer"], ["type", "checkbox", "id", "draw-boxSelection", "name", "filterByExtent", 1, "cursor-pointer", 3, "ngModel", "ngModelChange", "change"], ["data-toggle", "tooltip", 1, "btn", "btn-primary", "btn-sm", "hs-draw-selectAll", 3, "disabled", "title", "click"], [1, "d-flex", "align-items-center", "w-100", "flex-column"], [1, "bg-primary", "w-100", "text-light", "m-0", "p-1"], ["class", "dropdown-item", 3, "click", 4, "ngFor", "ngForOf"], [1, "dropdown-item", 3, "click"], [1, "d-flex", "justify-content-between"], [2, "cursor", "pointer", 3, "click"], [1, "icon-settingsthree-gears"], ["class", "p-0 input-group-text border-0 justify-content-center bg-white", 4, "ngIf"], [1, "p-0", "input-group-text", "border-0", "justify-content-center", "bg-white"], [1, "m-0"], ["type", "checkbox", "name", "onlyMine", 3, "ngModel", "ngModelChange"], ["type", "button", 1, "btn", "btn-light", "hs-toolbar-button", "btn-outline-secondary", 3, "title", "click"], [1, "glyphicon", "icon-save-floppy"], [1, "glyphicon", "icon-trash"], ["role", "group", 1, "btn-group-vertical", "position-fixed", "d-flex", "flex-column", 2, "top", "35vh", 3, "ngStyle"], ["class", "btn btn-secondary", "data-toggle", "tooltip", 3, "title", "click", 4, "ngIf"], ["type", "button", "aria-haspopup", "true", 1, "btn", "btn-light", "dropright", "rounded-0", "btn-outline-secondary", "dropdown-toggle", 2, "line-height", "1 !important", 3, "ngClass", "click"], ["class", "m-0", 4, "ngIf"], [3, "ngClass"], [1, "dropdown-menu", "p-0", 2, "min-width", "unset", 3, "ngClass"], ["data-toggle", "tooltip", 1, "btn", "btn-light", "hs-toolbar-button", "btn-outline-secondary", 3, "ngClass", "title", "click"], [1, "icon-pin"], [1, "icon-polygonlasso"], [1, "icon-line"], ["data-toggle", "tooltip", 1, "btn", "btn-secondary", 3, "title", "click"], [1, "icon-remove-circle"], [1, "icon-check"]], template: function HsDrawToolbarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "button", 1);
        ɵngcc0.ɵɵlistener("click", function HsDrawToolbarComponent_Template_button_click_1_listener() { return ctx.toggleDrawToolbar(); });
        ɵngcc0.ɵɵelement(2, "i", 2);
        ɵngcc0.ɵɵpipe(3, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(4, HsDrawToolbarComponent_div_4_Template, 27, 35, "div", 3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ctx.HsDrawService.highlightDrawButton ? "btn-outline-danger" : "btn-outline-secondary");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(6, _c22, !ctx.drawToolbarExpanded, ctx.drawToolbarExpanded))("title", ɵngcc0.ɵɵpipeBind1(3, 4, "PANEL_HEADER.DRAW"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.drawToolbarExpanded);
    } }, directives: [ɵngcc3.NgClass, ɵngcc3.NgIf, ɵngcc5.CheckboxControlValueAccessor, ɵngcc5.NgControlStatus, ɵngcc5.NgModel, ɵngcc3.NgForOf, ɵngcc3.NgStyle], pipes: [ɵngcc1.TranslatePipe], encapsulation: 2 });
HsDrawToolbarComponent.ctorParameters = () => [
    { type: HsDrawService },
    { type: HsLayoutService },
    { type: HsLayerUtilsService },
    { type: HsConfig },
    { type: HsLanguageService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsDrawToolbarComponent, [{
        type: Component,
        args: [{
                selector: 'hs-draw-toolbar',
                template: "<div class=\"btn-group\"  >\n    <button class=\"btn rounded-0 btn-light hs-toolbar-button\"\n        [ngClass]=\"HsDrawService.highlightDrawButton ? 'btn-outline-danger' : 'btn-outline-secondary'\"\n        (click)=\"toggleDrawToolbar()\">\n        <i [ngClass]=\"{'icon-pencil':!drawToolbarExpanded, 'icon-remove':drawToolbarExpanded}\" data-toggle=\"tooltip\"\n            [title]=\"'PANEL_HEADER.DRAW' | translate\"></i></button>\n    <div class=\"btn-group\" *ngIf=\"drawToolbarExpanded\">\n        <button type=\"button\"\n            class=\"btn btn-light rounded-0 btn-secondary dropdown-toggle hs-draw-layer-toggle d-flex align-items-center\"\n            data-toggle=\"dropdown\" aria-haspopup=\"true\"\n            [hidden]=\"!(HsDrawService.drawableLayers.length > 0 || HsDrawService.tmpDrawLayer)\"\n            (click)=\"controlLayerListAction(); HsDrawService.fillDrawableLayers() \" [attr.aria-expanded]=\"layersExpanded\"\n            style=\"max-width: 125px; overflow: hidden; font-size: smaller; z-index: 2;\"\n            [ngClass]=\"HsDrawService.tmpDrawLayer ? 'btn-outline-danger' : 'btn-outline-primary'\">\n            <div class=\"text-truncate pr-1\">{{HsDrawService.selectedLayerString()}}</div>\n        </button>\n        <div class=\"dropdown-menu\" [ngClass]=\"{'show': layersExpanded}\">\n            <div class=\"d-flex align-items-center w-100 flex-column\" *ngIf=\"HsDrawService.drawableLayers.length > 0\">\n                <label class=\" bg-primary w-100 text-light m-0 p-1\">{{'DRAW.activeLayers' | translate}}</label>\n                <a class=\"dropdown-item\"  *ngFor=\"let layer of HsDrawService.drawableLayers\"\n                    (click)=\"selectLayer(layer)\">{{HsLayerUtilsService.translateTitle(getTitle(layer))}}</a>\n            </div>\n            <div class=\"d-flex align-items-center w-100 flex-column\"\n                *ngIf=\"HsDrawService.drawableLaymanLayers.length > 0\">\n                <div class=\" bg-primary w-100 text-light m-0 p-1\">\n                    <div class=\"d-flex justify-content-between\">\n                        {{'DRAW.serverLayers' | translate}}\n                        <span (click)=\"onlyMineFilterVisible = !onlyMineFilterVisible\" style=\"cursor: pointer;\">\n                            <i class=\"icon-settingsthree-gears\"></i>\n                        </span>\n                    </div>\n                    <div class=\"p-0 input-group-text border-0 justify-content-center bg-white\" *ngIf=\"onlyMineFilterVisible\">\n                        <label class=\"m-0\">\n                            <input type=\"checkbox\" name=\"onlyMine\" [(ngModel)]=\"HsDrawService.onlyMine\"\n                                (ngModelChange)=\"HsDrawService.fillDrawableLayers(); onlyMineFilterVisible = !onlyMineFilterVisible\">\n                            {{'COMPOSITIONS.onlyMine' | translate}}\n                        </label>\n                    </div>\n                </div>\n                <a class=\"dropdown-item\"  *ngFor=\"let layer of HsDrawService.drawableLaymanLayers\"\n                    (click)=\"selectLayer(layer)\">{{HsLayerUtilsService.translateTitle(layer.title)}}</a>\n            </div>\n        </div>\n        <button class=\"btn btn-light hs-toolbar-button btn-outline-secondary\" [hidden]=\"HsDrawService.tmpDrawLayer\"\n            (click)=\"HsDrawService.saveDrawingLayer()\" data-toggle=\"tooltip\"\n            [title]=\"'DRAW.drawToolbar.addDrawLayer' | translate\">\n            <i class=\"icon-plus\"></i></button>\n        <button type=\"button\" *ngIf=\"HsDrawService.tmpDrawLayer\" class=\"btn btn-light  hs-toolbar-button  btn-outline-secondary\" (click)=\"HsDrawService.saveDrawingLayer()\"\n        [title]=\"'DRAW.saveDrawingToLayer' | translate\">\n        <i class=\"glyphicon icon-save-floppy\"></i>\n        </button>\n        <button type=\"button\" *ngIf=\"HsDrawService.selectedLayer\"\n            class=\"btn btn-light hs-toolbar-button  btn-outline-secondary\" (click)=\"HsDrawService.removeLayer()\"\n            [title]=\"'COMMON.removeLayer' | translate\">\n            <i class=\"glyphicon icon-trash\"></i>\n        </button>\n        <div class=\"btn-group\">\n            <button type=\"button\" [ngClass]=\"{active: !HsDrawService.type }\" [title]=\"'STYLER.selection' | translate\"\n                class=\"btn btn-light hs-toolbar-button btn-outline-secondary rounded-0 dropdown-toggle\" data-toggle=\"dropdown\" aria-haspopup=\"true\"\n                (click)=\"$event.preventDefault(); selectionMenuToggled()\" [attr.aria-expanded]=\"selectionMenuExpanded\">\n                <i class=\"icon-cursor\"></i>\n            </button>\n            <div class=\"dropdown\" style=\"white-space: nowrap;\">\n                <div class=\"dropdown-menu dropdown-menu-right flex-column px-1 py-2\"\n                    [ngClass]=\"{'d-flex': selectionMenuExpanded}\">\n                    <div class=\"d-flex flex-row justify-content-around align-items-baseline\">\n                        <label class=\"ml-1 cursor-pointer\" for=\"draw-boxSelection\"> {{'DRAW.boxSelection' | translate}}</label>\n                        <input type=\"checkbox\" [(ngModel)]=\"HsDrawService.boxSelectionActive\"\n                            (change)=\"HsDrawService.toggleBoxSelection();selectionMenuExpanded = !selectionMenuExpanded;\"\n                            id=\"draw-boxSelection\" name=\"filterByExtent\" class=\"cursor-pointer\">\n                    </div>\n                    <button class=\"btn btn-primary btn-sm hs-draw-selectAll\" [disabled]=\"!HsDrawService.selectedLayer\"\n                        (click)=\"HsDrawService.selectAllFeatures();selectionMenuExpanded = !selectionMenuExpanded;\"\n                        data-toggle=\"tooltip\" [title]=\"'STYLER.selection' | translate\">\n                        {{translateString('DRAW',HsDrawService.toggleSelectionString)}}\n                    </button>\n                </div>\n            </div>\n        </div>\n        <div class=\"btn-group\" *ngIf=\"drawToolbarExpanded\">\n            <div style=\"top: 35vh;\" role=\"group\" class=\"btn-group-vertical position-fixed d-flex flex-column\" [ngStyle]=\"HsConfig.sidebarPosition !== 'left' || HsLayoutService.sidebarBottom() ? {'left': 0} : {'right': 0} \">\n                <button class=\"btn btn-secondary\" *ngIf=\"HsDrawService.drawActive\"\n                    (click)=\"HsDrawService.removeLastPoint()\" data-toggle=\"tooltip\"\n                    [title]=\"'DRAW.drawToolbar.removeLastPoint' | translate\">\n                    <i class=\"icon-remove-circle\"></i></button>\n                <button class=\"btn btn-secondary\" *ngIf=\"HsDrawService.drawActive\"\n                    (click)=\"finishDrawing()\" data-toggle=\"tooltip\" [title]=\"'DRAW.drawToolbar.finishFeature' | translate\">\n                    <i class=\"icon-check\"></i></button>\n            </div>\n            <button type=\"button\" (click)=\"drawTypeExpanded = !drawTypeExpanded\" style=\"line-height: 1 !important;\"\n                [ngClass]=\"{active: HsDrawService.type }\"\n                class=\"btn  btn-light dropright rounded-0 btn-outline-secondary dropdown-toggle\" aria-haspopup=\"true\">\n                <label *ngIf=\"!HsDrawService.type\" class=\"m-0\">{{'DRAW.drawToolbar.selectType' | translate}}</label>\n                <i [ngClass]=\"{\n                    'icon-pin': HsDrawService.type==='Point',\n                    'icon-polygonlasso': HsDrawService.type==='Polygon',\n                    'icon-line': HsDrawService.type==='LineString'\n                }\"></i>\n            </button>\n            <div  class=\"dropdown-menu  p-0\" style=\"min-width: unset;\" [ngClass]=\"{'show': drawTypeExpanded}\">\n                <div class=\"btn-group\" >\n                    <button class=\"btn btn-light hs-toolbar-button btn-outline-secondary\"\n                        [ngClass]=\"{active: HsDrawService.type==='Point' }\" (click)=\"setType('Point');drawTypeExpanded = !drawTypeExpanded\" data-toggle=\"tooltip\"\n                        [title]=\"'COMMON.point' | translate\"><i class=\"icon-pin\"></i></button>\n                    <button class=\"btn btn-light hs-toolbar-button btn-outline-secondary\"\n                        [ngClass]=\"{active: HsDrawService.type==='Polygon' }\" (click)=\"setType('Polygon');drawTypeExpanded = !drawTypeExpanded\"\n                        data-toggle=\"tooltip\" [title]=\"'COMMON.polygon' | translate\"><i\n                            class=\"icon-polygonlasso\"></i></button>\n                    <button class=\"btn btn-light hs-toolbar-button btn-outline-secondary\"\n                        [ngClass]=\"{active: HsDrawService.type==='LineString' }\" (click)=\"setType('LineString');drawTypeExpanded = !drawTypeExpanded\"\n                        data-toggle=\"tooltip\" [title]=\"'COMMON.line' | translate\">\n                        <i class=\"icon-line\"></i></button>\n                </div>\n            </div>\n        </div>\n    </div>\n\n</div>\n"
            }]
    }], function () { return [{ type: HsDrawService }, { type: HsLayoutService }, { type: HsLayerUtilsService }, { type: HsConfig }, { type: HsLanguageService }]; }, null); })();

class HsFeatureTableService {
    constructor(HsUtilsService, HsLayerUtilsService, HsQueryVectorService, HsLanguageService) {
        this.HsUtilsService = HsUtilsService;
        this.HsLayerUtilsService = HsLayerUtilsService;
        this.HsQueryVectorService = HsQueryVectorService;
        this.HsLanguageService = HsLanguageService;
        this.sortReverse = false; //trigger for reverse sorting
        this.lastSortValue = ''; //last sorting value selected
        this.features = []; //all feature attributes for html table
    }
    /**
     * @param layer Layer from HsConfig.layersInFeatureTable
     * @description Checks if layer is vectorLayer and is visible in layer_manager, to exclude layers, such as, point Clicked
     * @returns {any} Returns layer
     */
    addLayer(layer) {
        if (!getBase(layer) &&
            this.HsUtilsService.instOf(layer, Vector$1) &&
            (getShowInLayerManager(layer) === undefined ||
                getShowInLayerManager(layer) == true)) {
            return this.wrapLayer(layer);
        }
        return;
    }
    /**
     * @param layer Layer from HsConfig.layersInFeatureTable
     * @description Wrap layer object
     * @returns {any} Returns wrapped layer object
     */
    wrapLayer(layer) {
        return {
            title: getTitle(layer),
            lyr: layer,
            type: 'vector',
        };
    }
    /**
     * @param layer Layer from HsConfig.layersInFeatureTable
     * @description Search all layers feature attributes and map them into new objects for html table
     */
    fillFeatureList(layer) {
        const source = this.HsLayerUtilsService.isLayerClustered(layer)
            ? layer.getSource().getSource()
            : layer.getSource();
        this.features = source
            .getFeatures()
            .map((f) => this.describeFeature(f))
            .filter((f) => { var _a; return ((_a = f === null || f === void 0 ? void 0 : f.attributes) === null || _a === void 0 ? void 0 : _a.length) > 0; });
    }
    updateFeatureDescription(feature) {
        const newDescriptor = this.describeFeature(feature);
        const currentIx = this.features.findIndex((f) => f.feature == feature);
        if (newDescriptor && currentIx > -1) {
            this.features[currentIx] = newDescriptor;
        }
    }
    addFeatureDescription(feature) {
        const newDescriptor = this.describeFeature(feature);
        if (newDescriptor) {
            this.features.push(newDescriptor);
        }
    }
    removeFeatureDescription(feature) {
        const currentIx = this.features.findIndex((f) => f.feature == feature);
        if (currentIx > -1) {
            this.features.splice(currentIx, 1);
        }
    }
    describeFeature(feature) {
        const attribWrapper = this.HsQueryVectorService.getFeatureAttributes(feature).pop();
        if (!attribWrapper) {
            return null;
        }
        return {
            name: this.setFeatureName(attribWrapper.attributes),
            feature,
            attributes: this.attributesWithoutFeatureName(attribWrapper.attributes),
            stats: attribWrapper.stats,
        };
    }
    /**
     * @param attributes layers feature attributes
     * @description Find feature name attribute and seperate it from other attributes for html table purposes
     * @returns {any} feature name
     */
    setFeatureName(attributes) {
        if (attributes.length > 0) {
            let name = 'Feature';
            for (const attribute of attributes) {
                if (attribute.name === 'name') {
                    name = attribute.value;
                }
            }
            return name;
        }
        else {
            return 'Feature';
        }
    }
    /**
     * @param attributes layers feature attributes
     * @description Remove feature name attribute from feature attributes array
     * @returns {any} feature attributes
     */
    attributesWithoutFeatureName(attributes) {
        return attributes.filter((attr) => attr.name !== 'name');
    }
    /**
     * @param valueName Requested value to sort the feature table list
     * @description Sort features by requested value
     */
    sortFeaturesBy(valueName) {
        if (this.features !== undefined && this.features.length > 1) {
            this.lastSortValue === valueName //if last sort by value is the same as current sort table list in reverse
                ? (this.sortReverse = !this.sortReverse)
                : (this.sortReverse = false);
            this.features = this.features.sort((a, b) => this.sortFeatures(a, b, valueName));
        }
    }
    /**
     * @param a First input feature
     * @param b second input feature
     * @param valueName Sorting value
     * @description Sorting algorithm
     * @returns {number} Returns each features relative position in the table
     */
    sortFeatures(a, b, valueName) {
        let aFeature, bFeature;
        let position;
        if (valueName === 'name') {
            //check if table is being sorted by name
            aFeature = a[valueName];
            bFeature = b[valueName];
        }
        else {
            aFeature = this.getValue(a.attributes, valueName); //get requested attribute value
            bFeature = this.getValue(b.attributes, valueName);
        }
        if (aFeature === null) {
            position = 1;
        }
        if (bFeature === null) {
            position = -1;
        }
        if (typeof aFeature == 'string' && typeof bFeature == 'string') {
            position =
                aFeature.charAt(0) > bFeature.charAt(0)
                    ? 1
                    : aFeature.charAt(0) < bFeature.charAt(0)
                        ? -1
                        : 0;
        }
        if (typeof aFeature == 'number' && typeof bFeature == 'number') {
            position = aFeature - bFeature;
        }
        this.sortReverse ? (position = position * -1) : position;
        this.lastSortValue = valueName;
        return position;
    }
    /**
     * @param attributes features attributes
     * @param valueName Sorting value
     * @description Get requested features attribute value, which will be used in the sorting algorithm
     * @returns {number | string} Returns attributes value
     */
    getValue(attributes, valueName) {
        let value = attributes //get requested attribute value
            .filter((attr) => attr.name == valueName)
            .map((attr) => attr.value);
        if (value.length == 0 || value === undefined) {
            value = null;
        }
        else {
            value = value[0];
        }
        return value;
    }
    translate(text) {
        const translation = this.HsLanguageService.getTranslationIgnoreNonExisting('FEATURE_TABLE', text);
        return translation;
    }
}
HsFeatureTableService.ɵfac = function HsFeatureTableService_Factory(t) { return new (t || HsFeatureTableService)(ɵngcc0.ɵɵinject(HsUtilsService), ɵngcc0.ɵɵinject(HsLayerUtilsService), ɵngcc0.ɵɵinject(HsQueryVectorService), ɵngcc0.ɵɵinject(HsLanguageService)); };
HsFeatureTableService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HsFeatureTableService_Factory() { return new HsFeatureTableService(i0.ɵɵinject(HsUtilsService), i0.ɵɵinject(HsLayerUtilsService), i0.ɵɵinject(HsQueryVectorService), i0.ɵɵinject(HsLanguageService)); }, token: HsFeatureTableService, providedIn: "root" });
HsFeatureTableService.ctorParameters = () => [
    { type: HsUtilsService },
    { type: HsLayerUtilsService },
    { type: HsQueryVectorService },
    { type: HsLanguageService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsFeatureTableService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: HsUtilsService }, { type: HsLayerUtilsService }, { type: HsQueryVectorService }, { type: HsLanguageService }]; }, null); })();

class HsFeatureTableComponent extends HsPanelBaseComponent {
    constructor(HsFeatureTableService, HsConfig, HsMapService, hsLayoutService, hsLanguageService, hsSidebarService) {
        super(hsLayoutService);
        this.HsFeatureTableService = HsFeatureTableService;
        this.HsConfig = HsConfig;
        this.HsMapService = HsMapService;
        this.layers = [];
        this.name = 'feature_table';
        hsSidebarService.buttons.push({
            panel: 'feature_table',
            module: 'hs.feature-table',
            order: 14,
            fits: true,
            title: () => hsLanguageService.getTranslation('PANEL_HEADER.FEATURE_TABLE'),
            description: () => hsLanguageService.getTranslation('SIDEBAR.descriptions.FEATURE_TABLE'),
            icon: 'icon-indexmanager',
        });
    }
    ngOnInit() {
        this.HsMapService.loaded().then(() => {
            for (const layer of this.HsConfig.layersInFeatureTable || []) {
                this.addLayerToTable(layer);
            }
        });
    }
    addLayerToTable(layer) {
        const layerDescriptor = this.HsFeatureTableService.addLayer(layer);
        if (layerDescriptor) {
            this.layers.push(layerDescriptor);
        }
    }
}
HsFeatureTableComponent.ɵfac = function HsFeatureTableComponent_Factory(t) { return new (t || HsFeatureTableComponent)(ɵngcc0.ɵɵdirectiveInject(HsFeatureTableService), ɵngcc0.ɵɵdirectiveInject(HsConfig), ɵngcc0.ɵɵdirectiveInject(HsMapService), ɵngcc0.ɵɵdirectiveInject(HsLayoutService), ɵngcc0.ɵɵdirectiveInject(HsLanguageService), ɵngcc0.ɵɵdirectiveInject(HsSidebarService)); };
HsFeatureTableComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsFeatureTableComponent, selectors: [["hs-feature-table"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 5, vars: 5, consts: [[1, "card", "hs-main-panel", 3, "hidden"], ["name", "feature_table", 3, "title"], [1, "card-body"], [4, "ngFor", "ngForOf"], [3, "layer"]], template: function HsFeatureTableComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "hs-panel-header", 1);
        ɵngcc0.ɵɵpipe(2, "translate");
        ɵngcc0.ɵɵelementStart(3, "div", 2);
        ɵngcc0.ɵɵtemplate(4, HsFeatureTableComponent_div_4_Template, 2, 1, "div", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("hidden", !ctx.isVisible());
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(2, 3, "PANEL_HEADER.FEATURE_TABLE"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.layers);
    } }, directives: function () { return [HsPanelHeaderComponent, ɵngcc3.NgForOf, HsLayerFeaturesComponent]; }, pipes: function () { return [ɵngcc1.TranslatePipe]; }, encapsulation: 2 });
HsFeatureTableComponent.ctorParameters = () => [
    { type: HsFeatureTableService },
    { type: HsConfig },
    { type: HsMapService },
    { type: HsLayoutService },
    { type: HsLanguageService },
    { type: HsSidebarService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsFeatureTableComponent, [{
        type: Component,
        args: [{
                selector: 'hs-feature-table',
                template: "<div class=\"card hs-main-panel\" [hidden]=\"!isVisible()\">\n    <hs-panel-header name=\"feature_table\" [title]=\"'PANEL_HEADER.FEATURE_TABLE' | translate\"></hs-panel-header>\n    <div class=\"card-body\">\n        <div *ngFor=\"let layer of layers\">\n            <hs-layer-features [layer]=\"layer\"></hs-layer-features>\n        </div>\n    </div>\n</div>"
            }]
    }], function () { return [{ type: HsFeatureTableService }, { type: HsConfig }, { type: HsMapService }, { type: HsLayoutService }, { type: HsLanguageService }, { type: HsSidebarService }]; }, null); })();

class HsGeolocationService {
    constructor(HsMapService, HsLayoutService, hsLog, HsUtilsService) {
        this.HsMapService = HsMapService;
        this.HsLayoutService = HsLayoutService;
        this.hsLog = hsLog;
        this.HsUtilsService = HsUtilsService;
        /**
         * @public
         * @type {boolean} false
         * @description Represents geolocalization state (on/off)
         */
        this.localization = false;
        /**
         * @public
         * @type {boolean} false
         * @description Represents geolocalization tracking option (on/off).
         * Used to determine state of tracking in directive's html
         */
        this.following = false;
        this.gn = null;
        this.accuracyFeature = new Feature({
            known: false,
            geometry: new Circle$1([0, 0], 1),
        });
        this.positionFeature = new Feature({
            known: false,
            geometry: new Point([0, 0]),
        });
        this.style = new Style({
            image: new Circle({
                fill: new Fill({
                    color: [242, 121, 0, 0.7],
                }),
                stroke: new Stroke({
                    color: [0xbb, 0x33, 0x33, 0.7],
                }),
                radius: 5,
            }),
            fill: new Fill({
                color: [0xbb, 0xbb, 0xbb, 0.2],
            }),
            stroke: new Stroke({
                color: [0x66, 0x66, 0x00, 0.8],
            }),
        });
        this.HsMapService.loaded().then((map) => this.init(map));
    }
    getRotate() {
        for (const control of this.HsMapService.map.getControls().getArray()) {
            if (control instanceof Rotate) {
                return control;
            }
        }
    }
    /**
     * @public
     * @description Reset all geolocalization parameters concerning position tracking
     */
    stopTracking() {
        this.following = false;
        const rotate = this.getRotate();
        rotate.element.classList.add('hidden');
        this.HsMapService.map.on('pointermove', () => {
            this.centering = false;
        });
        this.geolocation.setTracking(false);
        if (this.gn !== null) {
            this.gn.stop();
        }
        this.HsMapService.map.getView().setRotation(0);
    }
    /**
     * @public
     * @description Toggles tracking/following
     * Takes care of the distinction between click and double-click on mobile
     */
    toggleTracking() {
        if (this.clicked) {
            this.cancelClick = true;
            if (this.HsLayoutService.sidebarBottom()) {
                this.HsLayoutService.contentWrapper
                    .querySelector('.hs-locationButton')
                    .dispatchEvent(new Event('dblclick'));
            }
            return;
        }
        this.clicked = true;
        setTimeout(() => {
            if (this.cancelClick) {
                this.cancelClick = false;
                this.clicked = false;
                return;
            }
            if (this.isCentered()) {
                if (!this.following) {
                    //position
                    this.geolocation.on('change:position', () => this.setNewPosition());
                    this.geolocation.setTracking(true);
                    this.following = true;
                    //rotation
                    this.setRotation();
                    this.geolocation.on('change:heading', () => this.newRotation());
                    this.centering = true;
                    this.HsMapService.map.on('pointermove', () => {
                        this.centering = false;
                    });
                    const rotate = this.getRotate();
                    rotate.element.classList.remove('hidden');
                    this.HsLayoutService.contentWrapper
                        .querySelector('button.ol-rotate')
                        .classList.add('active');
                }
                else {
                    this.HsLayoutService.contentWrapper
                        .querySelector('button.ol-rotate')
                        .classList.remove('active');
                    this.stopTracking();
                }
            }
            else {
                if (this.geolocation.getPosition()) {
                    this.HsMapService.map
                        .getView()
                        .setCenter(this.geolocation.getPosition());
                    this.centering = true;
                }
            }
            //clean up
            this.cancelClick = false;
            this.clicked = false;
        }, 500);
    }
    /**
     * @public
     * @description Reset all geolocalization parameters
     */
    stopLocalization() {
        this.localization = false;
        this.HsMapService.map.removeLayer(this.position_layer);
        this.stopTracking();
    }
    /**
     * @public
     * @description Display current position by querying geolocation, once
     */
    startLocalization() {
        if (!this.localization) {
            this.geolocation.setTracking(true);
            this.localization = true;
            this.geolocation.once('change:position', () => {
                this.setNewPosition();
                this.HsMapService.map
                    .getView()
                    .setCenter(this.geolocation.getPosition());
                this.HsMapService.map.addLayer(this.position_layer);
                this.position_layer.setZIndex(99);
                //stop tracking position
                this.geolocation.setTracking(false);
            });
        }
    }
    /**
     * @public
     * @description Function which determines whether map is centered on current position or not
     */
    isCentered() {
        return (JSON.stringify(this.HsMapService.map.getView().getCenter()) ===
            JSON.stringify(this.positionFeature.getGeometry().getCoordinates()));
    }
    /**
     * @public
     * @description Callback function handling geolocation change:position event
     */
    setNewPosition() {
        const position = this.geolocation.getPosition();
        this.positionFeature.getGeometry().setCoordinates(position);
        this.accuracyFeature
            .getGeometry()
            .setCenterAndRadius(position, this.geolocation.getAccuracy());
        if (this.centering) {
            this.HsMapService.map.getView().setCenter(position);
        }
    }
    /**
     * @public
     * @description Callback function handling geolocation change:heading event
     * @param e
     */
    newRotation() {
        this.HsUtilsService.debounce(() => {
            const heading = this.geolocation.getHeading()
                ? this.geolocation.getHeading()
                : null;
            if (heading) {
                this.HsMapService.map.getView().setRotation(heading);
            }
        }, 150, false, this);
    }
    setRotation() {
        this.hsLog.error('Device rotation tracking currently not implemented');
    }
    /**
     * @param map
     * @public
     * @description Init function of service, establish instance of geolocation object and layer.
     * Sets rotate map control.
     */
    init(map) {
        this.geolocation = new Geolocation({
            projection: this.HsMapService.getCurrentProj(),
            trackingOptions: {
                enableHighAccuracy: true,
            },
        });
        this.accuracyFeature.setStyle(this.style);
        this.positionFeature.setStyle(this.style);
        this.position_layer = new VectorLayer({
            source: new Vector(),
        });
        setTitle(this.position_layer, 'Position');
        setShowInLayerManager(this.position_layer, false);
        setRemovable(this.position_layer, false);
        const src = this.position_layer.getSource();
        src.addFeature(this.accuracyFeature);
        src.addFeature(this.positionFeature);
        const reset = function () {
            if (this.gn !== undefined) {
                if (this.gn.isRunning() && this.gn !== null) {
                    this.gn.stop();
                    map.getView().setRotation(0);
                    this.HsLayoutService.contentWrapper
                        .querySelector('button.ol-rotate')
                        .classList.remove('active');
                }
                else {
                    this.setRotation();
                    this.HsLayoutService.contentWrapper
                        .querySelector('button.ol-rotate')
                        .classList.add('active');
                }
            }
        };
        map.addControl(new Rotate({
            resetNorth: reset,
            className: 'ol-rotate hidden',
            autoHide: false,
        }));
    }
}
HsGeolocationService.ɵfac = function HsGeolocationService_Factory(t) { return new (t || HsGeolocationService)(ɵngcc0.ɵɵinject(HsMapService), ɵngcc0.ɵɵinject(HsLayoutService), ɵngcc0.ɵɵinject(HsLogService), ɵngcc0.ɵɵinject(HsUtilsService)); };
HsGeolocationService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HsGeolocationService_Factory() { return new HsGeolocationService(i0.ɵɵinject(HsMapService), i0.ɵɵinject(HsLayoutService), i0.ɵɵinject(HsLogService), i0.ɵɵinject(HsUtilsService)); }, token: HsGeolocationService, providedIn: "root" });
HsGeolocationService.ctorParameters = () => [
    { type: HsMapService },
    { type: HsLayoutService },
    { type: HsLogService },
    { type: HsUtilsService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsGeolocationService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: HsMapService }, { type: HsLayoutService }, { type: HsLogService }, { type: HsUtilsService }]; }, null); })();

class HsGeolocationComponent extends HsPanelBaseComponent {
    constructor(HsGeolocationService, HsLayoutService) {
        super(HsLayoutService);
        this.HsGeolocationService = HsGeolocationService;
        this.HsLayoutService = HsLayoutService;
    }
    ngOnInit() {
        this.collapsed = true;
    }
    isVisible() {
        return (this.HsLayoutService.componentEnabled('geolocationButton') &&
            this.HsLayoutService.componentEnabled('guiOverlay'));
    }
}
HsGeolocationComponent.ɵfac = function HsGeolocationComponent_Factory(t) { return new (t || HsGeolocationComponent)(ɵngcc0.ɵɵdirectiveInject(HsGeolocationService), ɵngcc0.ɵɵdirectiveInject(HsLayoutService)); };
HsGeolocationComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsGeolocationComponent, selectors: [["hs-geolocation"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 3, vars: 6, consts: [[1, "hs-locate", "ol-unselectable", "ol-control", "hs-locateToggler", 3, "hidden", "ngClass"], ["class", "ol-has-tooltip blocate hs-locateToggler", "type", "button", 3, "title", "click", 4, "ngIf"], ["class", "ol-has-tooltip blocate hs-locateToggler hs-locationButton", "type", "button", 3, "title", "click", "dblclick", 4, "ngIf"], ["type", "button", 1, "ol-has-tooltip", "blocate", "hs-locateToggler", 3, "title", "click"], [1, "glyphicon", "icon-gpsoff-gps", "hs-locateToggler"], ["type", "button", 1, "ol-has-tooltip", "blocate", "hs-locateToggler", "hs-locationButton", 3, "title", "click", "dblclick"], [1, "glyphicon", "hs-locateToggler", 3, "ngClass"]], template: function HsGeolocationComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, HsGeolocationComponent_button_1_Template, 3, 3, "button", 1);
        ɵngcc0.ɵɵtemplate(2, HsGeolocationComponent_button_2_Template, 3, 4, "button", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("hidden", !ctx.isVisible())("ngClass", ɵngcc0.ɵɵpureFunction1(4, _c23, ctx.collapsed));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.HsGeolocationService.localization);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.HsGeolocationService.localization);
    } }, directives: [ɵngcc3.NgClass, ɵngcc3.NgIf], pipes: [ɵngcc1.TranslatePipe], encapsulation: 2 });
HsGeolocationComponent.ctorParameters = () => [
    { type: HsGeolocationService },
    { type: HsLayoutService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsGeolocationComponent, [{
        type: Component,
        args: [{
                selector: 'hs-geolocation',
                template: "<div class=\"hs-locate ol-unselectable ol-control hs-locateToggler\" [hidden]=\"!isVisible()\"\n    [ngClass]=\"{'ol-collapsed': collapsed}\">\n    <button class=\"ol-has-tooltip blocate hs-locateToggler\" [title]=\"'GEOLOCATION.locateMe' | translate\" *ngIf=\"!HsGeolocationService.localization\"\n        type=\"button\" (click)=\"HsGeolocationService.startLocalization()\">\n        <i class=\"glyphicon icon-gpsoff-gps hs-locateToggler\"></i>\n    </button>\n    <button *ngIf=\"HsGeolocationService.localization\" class=\"ol-has-tooltip blocate hs-locateToggler hs-locationButton\"\n        type=\"button\" (click)=\"HsGeolocationService.toggleTracking()\" [title]=\"'GEOLOCATION.locateMe' | translate\"\n        (dblclick)=\"HsGeolocationService.stopLocalization()\">\n        <i class=\"glyphicon hs-locateToggler\"\n            [ngClass]=\"(HsGeolocationService.following && HsGeolocationService.localization) ? 'icon-navigation' : 'icon-gpson'\"></i>\n    </button>\n</div>\n"
            }]
    }], function () { return [{ type: HsGeolocationService }, { type: HsLayoutService }]; }, null); })();

/**
 * HsInfoComponent
 */
class HsInfoComponent extends HsPanelBaseComponent {
    constructor(HsUtilsService, HsEventBusService, HsLayoutService) {
        super(HsLayoutService);
        this.HsUtilsService = HsUtilsService;
        this.HsEventBusService = HsEventBusService;
        this.HsLayoutService = HsLayoutService;
        /**
         * @type {boolean} true
         * Store if composition is loaded
         */
        this.composition_loaded = true;
        /**
         * @type {Array} null
         * @description List of layers which are currently loading.
         */
        this.layer_loading = [];
        this.ngUnsubscribe = new Subject();
        this.HsEventBusService.compositionLoading
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((data) => {
            if (data.error === undefined) {
                if (data.data !== undefined) {
                    this.composition_abstract = data.data.abstract;
                    this.composition_title = data.data.title;
                    this.composition_id = data.data.id;
                }
                else {
                    this.composition_abstract = data.abstract;
                    this.composition_title = data.title;
                    this.composition_id = data.id;
                }
                this.composition_loaded = false;
                //Composition image (should be glyphicon?)
                this.info_image = 'icon-map';
            }
        });
        this.HsEventBusService.compositionLoads
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((data) => {
            if (data.error !== undefined) {
                const temp_abstract = this.composition_abstract;
                const temp_title = this.composition_title;
                this.composition_abstract = data.abstract;
                this.composition_title = data.title;
                this.info_image = 'icon-warning-sign';
                this.composition_title = temp_title;
                this.composition_abstract = temp_abstract;
                this.info_image = 'icon-map';
            }
            this.composition_loaded = true;
            this.composition_edited = false;
        });
        this.HsEventBusService.layerLoadings
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(({ layer, progress }) => {
            if (!this.layer_loading.includes(getTitle(layer))) {
                this.layer_loading.push(getTitle(layer));
                this.composition_loaded = false;
            }
        });
        this.HsEventBusService.layerLoads
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((layer) => {
            for (let i = 0; i < this.layer_loading.length; i++) {
                if (this.layer_loading[i] == getTitle(layer)) {
                    this.layer_loading.splice(i, 1);
                }
            }
            if (this.layer_loading.length == 0 && !this.composition_loaded) {
                this.composition_loaded = true;
            }
        });
        this.HsEventBusService.compositionDeletes
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((composition) => {
            if (composition.id == this.composition_id) {
                delete this.composition_title;
                delete this.composition_abstract;
            }
        });
        this.HsEventBusService.mapResets
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(() => {
            delete this.composition_title;
            delete this.composition_abstract;
            this.layer_loading.length = 0;
            this.composition_loaded = true;
            this.composition_edited = false;
        });
        this.HsEventBusService.compositionEdits
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(() => {
            this.composition_edited = true;
        });
    }
    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
    trackByFn(index) {
        return index; // or item.id
    }
    /**
  
     * @returns {boolean} Returns true if composition title available
     * @description Test if composition is loaded, to change info template.
     */
    compositionLoaded() {
        return this.composition_title !== undefined;
    }
    isVisible() {
        return this.HsLayoutService.panelEnabled('compositionLoadingProgress');
    }
}
HsInfoComponent.ɵfac = function HsInfoComponent_Factory(t) { return new (t || HsInfoComponent)(ɵngcc0.ɵɵdirectiveInject(HsUtilsService), ɵngcc0.ɵɵdirectiveInject(HsEventBusService), ɵngcc0.ɵɵdirectiveInject(HsLayoutService)); };
HsInfoComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsInfoComponent, selectors: [["hs-info"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 34, vars: 31, consts: [[1, "hs-info-container", 3, "hidden"], [1, "hs-info-area"], [1, "hs-info-composition", "hs-main-panel", 3, "hidden"], [1, "hs-info-composition-image", 3, "hidden"], [1, "icon-refresh", "icon-spin"], [1, "glyphicon", 3, "ngClass", "hidden"], ["class", "hs-info-composition-container", 4, "ngIf"], [1, "hs-info-composition", 3, "hidden"], [1, "hs-info-composition-image"], [1, "icon-refresh", "icon-spin", 3, "hidden"], [1, "hs-info-composition-container"], [1, "hs-info-composition-title"], [1, "hs-info-composition-abstract"], [1, "hs-info-layers", 3, "hidden"], [4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "hs-info-composition-edited", 3, "hidden"], [3, "title"], ["property", "og:title", 3, "content"], ["property", "twitter:title", 3, "content"], ["itemprop", "title", 3, "content"], ["name", "description", 3, "content"], ["property", "og:description", 3, "content"], ["property", "twitter:description", 3, "content"], ["itemprop", "description", 3, "content"], [1, "hs-info-composition-title", 3, "title"], [1, "hs-info-composition-abstract", 3, "hidden"]], template: function HsInfoComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelement(4, "span", 4);
        ɵngcc0.ɵɵelement(5, "span", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(6, HsInfoComponent_div_6_Template, 5, 6, "div", 6);
        ɵngcc0.ɵɵtemplate(7, HsInfoComponent_div_7_Template, 7, 7, "div", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "div", 7);
        ɵngcc0.ɵɵelementStart(9, "div", 8);
        ɵngcc0.ɵɵelement(10, "span", 9);
        ɵngcc0.ɵɵelement(11, "span", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "div", 10);
        ɵngcc0.ɵɵelementStart(13, "div", 11);
        ɵngcc0.ɵɵtext(14);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(15, "div", 12);
        ɵngcc0.ɵɵtext(16);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(17, "div", 13);
        ɵngcc0.ɵɵelementStart(18, "span");
        ɵngcc0.ɵɵtext(19);
        ɵngcc0.ɵɵpipe(20, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(21, HsInfoComponent_span_21_Template, 2, 1, "span", 14);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(22, "div", 15);
        ɵngcc0.ɵɵelementStart(23, "span");
        ɵngcc0.ɵɵtext(24);
        ɵngcc0.ɵɵpipe(25, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(26, "update-title", 16);
        ɵngcc0.ɵɵelement(27, "update-meta", 17);
        ɵngcc0.ɵɵelement(28, "update-meta", 18);
        ɵngcc0.ɵɵelement(29, "update-meta", 19);
        ɵngcc0.ɵɵelement(30, "update-meta", 20);
        ɵngcc0.ɵɵelement(31, "update-meta", 21);
        ɵngcc0.ɵɵelement(32, "update-meta", 22);
        ɵngcc0.ɵɵelement(33, "update-meta", 23);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("hidden", !ctx.isVisible());
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("hidden", !!ctx.compositionLoaded());
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", !!ctx.composition_loaded);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ctx.info_image)("hidden", !ctx.composition_loaded);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.composition_edited);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.composition_edited);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", !ctx.compositionLoaded());
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("hidden", !!ctx.composition_loaded);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ctx.info_image)("hidden", !ctx.composition_loaded);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.composition_title);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.composition_abstract);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", !ctx.layer_loading.length);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(20, 27, "COMMON.loading"), ": ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.layer_loading)("ngForTrackBy", ctx.trackByFn);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", !(!ctx.layer_loading.length && ctx.composition_edited));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(25, 29, "INFOCOMPONENT.youHaveUnsavedChanges"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵpropertyInterpolate("title", ctx.composition_title);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵpropertyInterpolate("content", ctx.composition_title);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵpropertyInterpolate("content", ctx.composition_title);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵpropertyInterpolate("content", ctx.composition_title);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵpropertyInterpolate("content", ctx.composition_abstract);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵpropertyInterpolate("content", ctx.composition_abstract);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵpropertyInterpolate("content", ctx.composition_abstract);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵpropertyInterpolate("content", ctx.composition_abstract);
    } }, directives: [ɵngcc3.NgClass, ɵngcc3.NgIf, ɵngcc3.NgForOf], pipes: [ɵngcc1.TranslatePipe], encapsulation: 2 });
HsInfoComponent.ctorParameters = () => [
    { type: HsUtilsService },
    { type: HsEventBusService },
    { type: HsLayoutService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsInfoComponent, [{
        type: Component,
        args: [{
                selector: 'hs-info',
                template: "<div class=\"hs-info-container\" [hidden]=\"!isVisible()\">\n    <div class=\"hs-info-area\">\n        <div class=\"hs-info-composition hs-main-panel\" [hidden]=\"!!compositionLoaded()\">\n            <div class=\"hs-info-composition-image\" [hidden]=\"!!composition_loaded\">\n                <span class=\"icon-refresh icon-spin\"></span>\n                <span class=\"glyphicon\" [ngClass]=\"info_image\" [hidden]=\"!composition_loaded\"></span>\n            </div>\n            <div class=\"hs-info-composition-container\" *ngIf=\"!composition_edited\">\n                <div class=\"hs-info-composition-title\" title=\"{{'INFOCOMPONENT.viewComposeAndAnalyse' | translate}}\">{{'INFOCOMPONENT.newMap' | translate}}</div>\n            </div>\n            <div class=\"hs-info-composition-container\" *ngIf=\"composition_edited\">\n                <div class=\"hs-info-composition-title\">{{'INFOCOMPONENT.unsavedMap' | translate}}</div>\n                <div class=\"hs-info-composition-abstract\" [hidden]=\"!!(!layer_loading.length && composition_edited)\">\n                    {{'INFOCOMPONENT.youHaveUnsavedChanges' | translate}}</div>\n            </div>\n        </div>\n\n        <div class=\"hs-info-composition\" [hidden]=\"!compositionLoaded()\">\n            <div class=\"hs-info-composition-image\">\n                <span class=\"icon-refresh icon-spin\" [hidden]=\"!!composition_loaded\"></span>\n                <span class=\"glyphicon\" [ngClass]=\"info_image\" [hidden]=\"!composition_loaded\"></span>\n            </div>\n            <div class=\"hs-info-composition-container\">\n                <div class=\"hs-info-composition-title\">{{composition_title}}</div>\n                <div class=\"hs-info-composition-abstract\">{{composition_abstract}}</div>\n            </div>\n        </div>\n\n        <div class=\"hs-info-layers\" [hidden]=\"!layer_loading.length\">\n            <span>{{'COMMON.loading' | translate}}: </span>\n            <span *ngFor=\"let layer of layer_loading; trackBy: trackByFn\">{{layer}} </span>\n        </div>\n\n        <div class=\"hs-info-composition-edited\" [hidden]=\"!(!layer_loading.length && composition_edited)\">\n            <span>{{'INFOCOMPONENT.youHaveUnsavedChanges' | translate}}</span>\n        </div>\n\n        <update-title title=\"{{composition_title}}\"></update-title>\n        <update-meta property=\"og:title\" content=\"{{composition_title}}\"></update-meta>\n        <update-meta property=\"twitter:title\" content=\"{{composition_title}}\"></update-meta>\n        <update-meta itemprop=\"title\" content=\"{{composition_title}}\"></update-meta>\n\n        <update-meta name=\"description\" content=\"{{composition_abstract}}\"></update-meta>\n        <update-meta property=\"og:description\" content=\"{{composition_abstract}}\"></update-meta>\n        <update-meta property=\"twitter:description\" content=\"{{composition_abstract}}\"></update-meta>\n        <update-meta itemprop=\"description\" content=\"{{composition_abstract}}\"></update-meta>\n    </div>\n</div>"
            }]
    }], function () { return [{ type: HsUtilsService }, { type: HsEventBusService }, { type: HsLayoutService }]; }, null); })();

class HsLanguageComponent extends HsPanelBaseComponent {
    constructor(HsLanguageService, HsLayoutService, hsSidebarService) {
        super(HsLayoutService);
        this.HsLanguageService = HsLanguageService;
        this.name = 'language';
        hsSidebarService.buttons.push({
            panel: 'language',
            module: 'hs.language',
            order: 13,
            fits: true,
            title: () => this.HsLanguageService.getTranslation('PANEL_HEADER.LANGUAGE'),
            description: () => this.HsLanguageService.getTranslation('SIDEBAR.descriptions.LANGUAGE'),
            content: () => {
                return this.HsLanguageService.getCurrentLanguageCode().toUpperCase();
            },
        });
    }
    ngOnInit() {
        this.available_languages = this.HsLanguageService.listAvailableLanguages();
    }
}
HsLanguageComponent.ɵfac = function HsLanguageComponent_Factory(t) { return new (t || HsLanguageComponent)(ɵngcc0.ɵɵdirectiveInject(HsLanguageService), ɵngcc0.ɵɵdirectiveInject(HsLayoutService), ɵngcc0.ɵɵdirectiveInject(HsSidebarService)); };
HsLanguageComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsLanguageComponent, selectors: [["hs-language"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 6, vars: 5, consts: [[1, "card", "hs-main-panel", 3, "hidden"], ["name", "language", 3, "title"], [1, "card-body"], [1, "m-3", "hs-senslog-list", "list-group"], [3, "ngClass", "click", 4, "ngFor", "ngForOf"], [3, "ngClass", "click"]], template: function HsLanguageComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "hs-panel-header", 1);
        ɵngcc0.ɵɵpipe(2, "translate");
        ɵngcc0.ɵɵelementStart(3, "div", 2);
        ɵngcc0.ɵɵelementStart(4, "ul", 3);
        ɵngcc0.ɵɵtemplate(5, HsLanguageComponent_button_5_Template, 2, 2, "button", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("hidden", !ctx.isVisible());
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(2, 3, "PANEL_HEADER.LANGUAGE"));
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.available_languages);
    } }, directives: [HsPanelHeaderComponent, ɵngcc3.NgForOf, ɵngcc3.NgClass], pipes: [ɵngcc1.TranslatePipe], encapsulation: 2 });
HsLanguageComponent.ctorParameters = () => [
    { type: HsLanguageService },
    { type: HsLayoutService },
    { type: HsSidebarService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsLanguageComponent, [{
        type: Component,
        args: [{
                selector: 'hs-language',
                template: "<div class=\"card hs-main-panel\" [hidden]=\"!isVisible()\">\n    <hs-panel-header name=\"language\" [title]=\"'PANEL_HEADER.LANGUAGE' | translate\"></hs-panel-header>\n    <div class=\"card-body\">\n        <ul class=\"m-3 hs-senslog-list list-group\">\n            <button *ngFor=\"let lang of available_languages\"\n                [ngClass]=\"'btn btn-block'+(HsLanguageService.language==lang.key.substr(0,2).toLowerCase() ? ' btn-primary' : ' btn-secondary')\"\n                (click)=\"HsLanguageService.setLanguage(lang.key)\">{{lang.name}}</button>\n        </ul>\n    </div>\n</div>\n"
            }]
    }], function () { return [{ type: HsLanguageService }, { type: HsLayoutService }, { type: HsSidebarService }]; }, null); })();

class HsLayerEditorSublayerService {
    constructor(HsLayerManagerService, HsLayerSelectorService, HsLayerUtilsService) {
        this.HsLayerManagerService = HsLayerManagerService;
        this.HsLayerSelectorService = HsLayerSelectorService;
        this.HsLayerUtilsService = HsLayerUtilsService;
        this.checkedSubLayers = {};
        this.withChildren = {};
        this.populatedLayers = [];
        this.withChildrenTmp = {};
        this.checkedSubLayersTmp = {};
        this.HsLayerSelectorService.layerSelected.subscribe((layer) => {
            this.resetSublayers(layer);
        });
    }
    resetSublayers(layer) {
        if (this.HsLayerManagerService.currentLayer) {
            this.checkedSubLayers = layer.checkedSubLayers;
            this.checkedSubLayersTmp = layer.checkedSubLayersTmp;
            this.withChildren = layer.withChildren;
            this.withChildrenTmp = layer.withChildrenTmp;
        }
    }
    hasSubLayers() {
        const subLayers = this.HsLayerManagerService.currentLayer.layer.get('Layer');
        return subLayers != undefined && subLayers.length > 0;
    }
    getSubLayers() {
        var _a;
        if (this.HsLayerManagerService.currentLayer === null) {
            return;
        }
        this.populateSubLayers();
        return (((_a = getCachedCapabilities(this.HsLayerManagerService.currentLayer.layer)) === null || _a === void 0 ? void 0 : _a.Layer) || []);
    }
    populateSubLayers() {
        var _a;
        const wrapper = this.HsLayerManagerService.currentLayer;
        const layer = wrapper.layer;
        if (this.populatedLayers.includes(wrapper.uid)) {
            return;
        }
        const subLayers = (_a = getCachedCapabilities(layer)) === null || _a === void 0 ? void 0 : _a.Layer;
        if ((subLayers === null || subLayers === void 0 ? void 0 : subLayers.length) > 0) {
            //Visibility of leaf layers the same as oldest ancestor
            const visible = layer.getVisible();
            //We don't want to overwrite saved sub-layer states when changing current layer
            const clone = (src) => Object.assign({}, src);
            //Function which converts list of layers to dictionary of their names and visibility
            const toDictionary = (d, layer) => ((d[layer.Name] = visible), d);
            this.populatedLayers.push(wrapper.uid);
            const subLayersWithChild = subLayers.filter((sl) => sl.Layer);
            const subSubLayers = subLayersWithChild.map((sl) => sl.Layer).flat();
            wrapper.withChildren = subLayersWithChild.reduce(toDictionary, {});
            //List either 3rd level layers or second if no 3rd level layer exists
            const leafs = subSubLayers.length > 0 ? subSubLayers : subLayers;
            wrapper.checkedSubLayers = leafs.reduce(toDictionary, {});
            this.checkedSubLayers = wrapper.checkedSubLayers;
            this.withChildren = wrapper.withChildren;
            this.checkedSubLayersTmp = clone(this.checkedSubLayers);
            wrapper.checkedSubLayersTmp = this.checkedSubLayersTmp;
            this.withChildrenTmp = clone(this.withChildren);
            wrapper.withChildrenTmp = this.withChildrenTmp;
            if (!this.HsLayerManagerService.currentLayer.visible) {
                for (const dict of [this.checkedSubLayersTmp, this.withChildrenTmp]) {
                    Object.keys(dict).forEach((v) => (dict[v] = true));
                }
            }
        }
    }
    subLayerSelected() {
        const layer = this.HsLayerManagerService.currentLayer;
        const params = this.HsLayerUtilsService.getLayerParams(layer.layer);
        params.LAYERS = Object.keys(this.checkedSubLayers)
            .filter((key) => this.checkedSubLayers[key] && !this.withChildren[key])
            .join(',');
        if (params.LAYERS == '') {
            this.HsLayerManagerService.changeLayerVisibility(!layer.visible, layer);
            return;
        }
        if (layer.visible == false) {
            this.HsLayerManagerService.changeLayerVisibility(!layer.visible, layer);
        }
        this.HsLayerUtilsService.updateLayerParams(layer.layer, params);
    }
}
HsLayerEditorSublayerService.ɵfac = function HsLayerEditorSublayerService_Factory(t) { return new (t || HsLayerEditorSublayerService)(ɵngcc0.ɵɵinject(HsLayerManagerService), ɵngcc0.ɵɵinject(HsLayerSelectorService), ɵngcc0.ɵɵinject(HsLayerUtilsService)); };
HsLayerEditorSublayerService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HsLayerEditorSublayerService_Factory() { return new HsLayerEditorSublayerService(i0.ɵɵinject(HsLayerManagerService), i0.ɵɵinject(HsLayerSelectorService), i0.ɵɵinject(HsLayerUtilsService)); }, token: HsLayerEditorSublayerService, providedIn: "root" });
HsLayerEditorSublayerService.ctorParameters = () => [
    { type: HsLayerManagerService },
    { type: HsLayerSelectorService },
    { type: HsLayerUtilsService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsLayerEditorSublayerService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: HsLayerManagerService }, { type: HsLayerSelectorService }, { type: HsLayerUtilsService }]; }, null); })();

class HsLayerManagerRemoveAllDialogComponent {
    constructor(HsLayerManagerService, HsDialogContainerService, HsEventBusService) {
        this.HsLayerManagerService = HsLayerManagerService;
        this.HsDialogContainerService = HsDialogContainerService;
        this.HsEventBusService = HsEventBusService;
    }
    removeAllLayers(reloadComposition) {
        this.HsLayerManagerService.removeAllLayers();
        if (reloadComposition) {
            this.HsEventBusService.compositionLoadStarts.next(this.HsLayerManagerService.composition_id);
        }
        this.close();
    }
    close() {
        this.HsDialogContainerService.destroy(this);
    }
}
HsLayerManagerRemoveAllDialogComponent.ɵfac = function HsLayerManagerRemoveAllDialogComponent_Factory(t) { return new (t || HsLayerManagerRemoveAllDialogComponent)(ɵngcc0.ɵɵdirectiveInject(HsLayerManagerService), ɵngcc0.ɵɵdirectiveInject(HsDialogContainerService), ɵngcc0.ɵɵdirectiveInject(HsEventBusService)); };
HsLayerManagerRemoveAllDialogComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsLayerManagerRemoveAllDialogComponent, selectors: [["hs-layermanager-remove-all-dialog"]], inputs: { data: "data" }, decls: 23, vars: 16, consts: [["tabindex", "-1", "role", "dialog", "aria-hidden", "true", 1, "modal", "hs-remove-all-dialog", "in"], [1, "modal-dialog"], [1, "modal-content"], [1, "modal-header"], [1, "modal-title"], ["data-dismiss", "modal", 1, "close", 3, "click"], ["aria-hidden", "true"], [1, "sr-only"], [1, "modal-body", 2, "max-height", "600px", "overflow-y", "auto"], [1, "modal-footer"], ["data-dismiss", "modal", 1, "btn", "btn-primary", 3, "click"], ["class", "btn btn-primary", "data-dismiss", "modal", 3, "click", 4, "ngIf"], ["data-dismiss", "modal", 1, "btn", "btn-secondary", 3, "click"]], template: function HsLayerManagerRemoveAllDialogComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelementStart(4, "h4", 4);
        ɵngcc0.ɵɵtext(5);
        ɵngcc0.ɵɵpipe(6, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "button", 5);
        ɵngcc0.ɵɵlistener("click", function HsLayerManagerRemoveAllDialogComponent_Template_button_click_7_listener() { return ctx.close(); });
        ɵngcc0.ɵɵelement(8, "span", 6);
        ɵngcc0.ɵɵelementStart(9, "span", 7);
        ɵngcc0.ɵɵtext(10);
        ɵngcc0.ɵɵpipe(11, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "div", 8);
        ɵngcc0.ɵɵtext(13);
        ɵngcc0.ɵɵpipe(14, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(15, "div", 9);
        ɵngcc0.ɵɵelementStart(16, "button", 10);
        ɵngcc0.ɵɵlistener("click", function HsLayerManagerRemoveAllDialogComponent_Template_button_click_16_listener() { return ctx.removeAllLayers(false); });
        ɵngcc0.ɵɵtext(17);
        ɵngcc0.ɵɵpipe(18, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(19, HsLayerManagerRemoveAllDialogComponent_button_19_Template, 3, 3, "button", 11);
        ɵngcc0.ɵɵelementStart(20, "button", 12);
        ɵngcc0.ɵɵlistener("click", function HsLayerManagerRemoveAllDialogComponent_Template_button_click_20_listener() { return ctx.close(); });
        ɵngcc0.ɵɵtext(21);
        ɵngcc0.ɵɵpipe(22, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(6, 6, "PANEL_HEADER.LM"), " ");
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(11, 8, "COMMON.close"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(14, 10, "LAYERMANAGER.dialogRemoveAll.dialogMessage"), "");
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(18, 12, "LAYERMANAGER.dialogRemoveAll.removeAllAdded"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.HsEventBusService.currentComposition.value);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(22, 14, "COMMON.no"));
    } }, directives: [ɵngcc3.NgIf], pipes: [ɵngcc1.TranslatePipe], encapsulation: 2 });
HsLayerManagerRemoveAllDialogComponent.ctorParameters = () => [
    { type: HsLayerManagerService },
    { type: HsDialogContainerService },
    { type: HsEventBusService }
];
HsLayerManagerRemoveAllDialogComponent.propDecorators = {
    data: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsLayerManagerRemoveAllDialogComponent, [{
        type: Component,
        args: [{
                selector: 'hs-layermanager-remove-all-dialog',
                template: "<div class=\"modal hs-remove-all-dialog in\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <h4 class=\"modal-title\">\n                    {{'PANEL_HEADER.LM' | translate}}\n                </h4>\n                <button (click)=\"close()\" class=\"close\" data-dismiss=\"modal\"><span\n                        aria-hidden=\"true\"></span><span class=\"sr-only\">{{'COMMON.close' | translate}}</span></button>\n            </div>\n            <div class=\"modal-body\" style=\"max-height:600px; overflow-y:auto\">\n                {{'LAYERMANAGER.dialogRemoveAll.dialogMessage' | translate}}</div>\n            <div class=\"modal-footer\">\n                <button class=\"btn btn-primary\" (click)=\"removeAllLayers(false);\"\n                    data-dismiss=\"modal\">{{'LAYERMANAGER.dialogRemoveAll.removeAllAdded' | translate}}</button>\n                <button class=\"btn btn-primary\" *ngIf=\"HsEventBusService.currentComposition.value\" (click)=\"removeAllLayers(true)\"\n                    data-dismiss=\"modal\">{{'LAYERMANAGER.dialogRemoveAll.reloadComposition' | translate}}</button>\n                <button class=\"btn btn-secondary\" (click)=\"close()\"\n                    data-dismiss=\"modal\">{{'COMMON.no' | translate}}</button>\n            </div>\n        </div>\n    </div>\n</div>\n"
            }]
    }], function () { return [{ type: HsLayerManagerService }, { type: HsDialogContainerService }, { type: HsEventBusService }]; }, { data: [{
            type: Input
        }] }); })();

class HsLayerSynchronizerService {
    constructor(HsUtilsService, HsLaymanService, HsCommonEndpointsService, HsDialogContainerService, HsMapService, HsCommonLaymanService, HsToastService, HsLanguageService, HsLogService) {
        this.HsUtilsService = HsUtilsService;
        this.HsLaymanService = HsLaymanService;
        this.HsCommonEndpointsService = HsCommonEndpointsService;
        this.HsDialogContainerService = HsDialogContainerService;
        this.HsMapService = HsMapService;
        this.HsCommonLaymanService = HsCommonLaymanService;
        this.HsToastService = HsToastService;
        this.HsLanguageService = HsLanguageService;
        this.HsLogService = HsLogService;
        this.debounceInterval = 1000;
        this.syncedLayers = [];
    }
    init(map) {
        const layerAdded = (e) => this.addLayer(e.element);
        map.getLayers().on('add', layerAdded);
        map.getLayers().on('remove', (e) => {
            this.removeLayer(e.element);
        });
        map.getLayers().forEach((lyr) => {
            layerAdded({
                element: lyr,
            });
        });
        this.HsCommonLaymanService.authChange.subscribe((_) => {
            this.reloadLayersOnAuthChange();
        });
        this.crs = this.HsMapService.getCurrentProj().getCode();
        this.HsLaymanService.crs = this.crs;
    }
    reloadLayersOnAuthChange() {
        for (const layer of this.syncedLayers) {
            const layerSource = layer.getSource();
            setLaymanLayerDescriptor(layer, undefined);
            layerSource.clear();
            this.pull(layer, layerSource);
        }
    }
    /**
     * Start synchronizing layer to database
     * @param {object} layer Layer to add
     */
    addLayer(layer) {
        if (this.isLayerSynchronizable(layer)) {
            this.syncedLayers.push(layer);
            this.startMonitoringIfNeeded(layer);
        }
    }
    isLayerSynchronizable(layer) {
        var _a;
        const definition = getDefinition(layer);
        return (this.HsUtilsService.instOf(layer.getSource(), Vector) &&
            //Test whether fromat cointains 'wfs' AND does not contian 'external'. Case insensitive
            new RegExp('^(?=.*wfs)(?:(?!external).)*$', 'i').test((_a = definition === null || definition === void 0 ? void 0 : definition.format) === null || _a === void 0 ? void 0 : _a.toLowerCase()));
    }
    /**
     * Keep track of synchronized vector layers by listening to
     * VectorSources change events. Initially also get features from server
     * @param layer Layer to add
     * @returns If layer is synchronizable
     */
    startMonitoringIfNeeded(layer) {
        return __awaiter(this, void 0, void 0, function* () {
            const layerSource = layer.getSource();
            yield this.pull(layer, layerSource);
            layer.on('propertychange', (e) => {
                if (e.key == 'sld' || e.key == 'title') {
                    this.HsLaymanService.upsertLayer(this.findLaymanForWfsLayer(layer), layer, false);
                }
            });
            layerSource.forEachFeature((f) => this.observeFeature(f));
            layerSource.on('addfeature', (e) => {
                this.sync(Array.isArray(e.feature) ? e.feature : [e.feature], [], [], layer);
            });
            layerSource.on('removefeature', (e) => {
                this.sync([], [], [e.feature], layer);
            });
            return true;
        });
    }
    findLaymanForWfsLayer(layer) {
        const layerDefinition = getDefinition(layer);
        return (this.HsCommonEndpointsService.endpoints || [])
            .filter((ds) => ds.type == 'layman' && (layerDefinition === null || layerDefinition === void 0 ? void 0 : layerDefinition.url.includes(ds.url)))
            .pop();
    }
    /**
     * Get features from Layman endpoint as WFS string, parse and add
     * them to OpenLayers VectorSource
     * @param layer Layer to get Layman friendly name for
     * @param source OpenLayers VectorSource to store features in
     */
    pull(layer, source) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                setEventsSuspended(layer, (getEventsSuspended(layer) || 0) + 1);
                const laymanEndpoint = this.findLaymanForWfsLayer(layer);
                if (laymanEndpoint) {
                    setHsLaymanSynchronizing(layer, true);
                    const response = yield this.HsLaymanService.makeGetLayerRequest(laymanEndpoint, layer);
                    let featureString;
                    if (response) {
                        featureString = response;
                    }
                    setHsLaymanSynchronizing(layer, false);
                    if (featureString) {
                        source.loading = true;
                        const format = new WFS();
                        featureString = featureString.replace(/urn:x-ogc:def:crs:EPSG:3857/gm, 'EPSG:3857');
                        featureString = featureString.replaceAll('http://www.opengis.net/gml/srs/epsg.xml#', 'EPSG:');
                        try {
                            const features = format.readFeatures(featureString);
                            source.addFeatures(features);
                            features.forEach((f) => this.observeFeature(f));
                        }
                        catch (ex) {
                            console.warn(featureString, ex);
                        }
                        source.loading = false;
                    }
                }
            }
            catch (ex) {
                this.HsLogService.warn(`Layer ${layer} could not be pulled.`);
            }
            finally {
                setEventsSuspended(layer, (getEventsSuspended(layer) || 0) - 1);
            }
        });
    }
    /**
     * @param f
     */
    observeFeature(f) {
        f.getGeometry().on('change', this.HsUtilsService.debounce((geom) => {
            this.handleFeatureChange(f);
        }, this.debounceInterval, false, this));
        f.on('propertychange', (e) => this.handleFeaturePropertyChange(e.target));
    }
    /**
     * @param Feature
     * @param feature
     */
    handleFeatureChange(feature) {
        this.sync([], [feature], [], this.HsMapService.getLayerForFeature(feature));
    }
    handleFeaturePropertyChange(feature) {
        //NOTE Due to WFS specification, attribute addition is not possible, so we must delete the feature before.
        this.sync([], [], [feature], this.HsMapService.getLayerForFeature(feature));
        //NOTE only then we can add feature with new attributes again.
        this.sync([feature], [], [], this.HsMapService.getLayerForFeature(feature));
    }
    /**
     * @param add
     * @param upd
     * @param del
     * @param layer
     */
    sync(add, upd, del, layer) {
        if ((getEventsSuspended(layer) || 0) > 0) {
            return;
        }
        const ep = this.findLaymanForWfsLayer(layer);
        if (ep) {
            setHsLaymanSynchronizing(layer, true);
            this.HsLaymanService.sync({ ep, add, upd, del, layer }).then((response) => {
                if (response === null || response === void 0 ? void 0 : response.includes('Exception')) {
                    this.displaySyncErrorDialog(response);
                    return;
                }
                if (add[0]) {
                    const id = new DOMParser()
                        .parseFromString(response, 'application/xml')
                        .getElementsByTagName('ogc:FeatureId')[0]
                        .getAttribute('fid');
                    add[0].setId(id);
                    const geometry = add[0].getGeometry();
                    add[0].setGeometryName('wkb_geometry');
                    add[0].setGeometry(geometry);
                    add[0].unset('geometry', true);
                    this.observeFeature(add[0]);
                }
                setHsLaymanSynchronizing(layer, false);
            });
        }
    }
    displaySyncErrorDialog(error) {
        const exception = xml2Json.xml2js(error, { compact: true });
        this.HsToastService.createToastPopupMessage(this.HsLanguageService.getTranslation('SAVECOMPOSITION.syncErrorDialog.errorWhenSyncing'), exception['ows:ExceptionReport']['ows:Exception']['ows:ExceptionText']
            ._text, {
            disableLocalization: true,
            serviceCalledFrom: 'HsLayerSynchronizerService',
        });
    }
    /**
     * Stop synchronizing layer to database
     * @param {Layer} layer Layer to remove from legend
     */
    removeLayer(layer) {
        for (let i = 0; i < this.syncedLayers.length; i++) {
            if (this.syncedLayers[i] == layer) {
                this.syncedLayers.splice(i, 1);
                break;
            }
        }
    }
}
HsLayerSynchronizerService.ɵfac = function HsLayerSynchronizerService_Factory(t) { return new (t || HsLayerSynchronizerService)(ɵngcc0.ɵɵinject(HsUtilsService), ɵngcc0.ɵɵinject(HsLaymanService), ɵngcc0.ɵɵinject(HsCommonEndpointsService), ɵngcc0.ɵɵinject(HsDialogContainerService), ɵngcc0.ɵɵinject(HsMapService), ɵngcc0.ɵɵinject(HsCommonLaymanService), ɵngcc0.ɵɵinject(HsToastService), ɵngcc0.ɵɵinject(HsLanguageService), ɵngcc0.ɵɵinject(HsLogService)); };
HsLayerSynchronizerService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HsLayerSynchronizerService_Factory() { return new HsLayerSynchronizerService(i0.ɵɵinject(HsUtilsService), i0.ɵɵinject(HsLaymanService), i0.ɵɵinject(HsCommonEndpointsService), i0.ɵɵinject(HsDialogContainerService), i0.ɵɵinject(HsMapService), i0.ɵɵinject(HsCommonLaymanService), i0.ɵɵinject(HsToastService), i0.ɵɵinject(HsLanguageService), i0.ɵɵinject(HsLogService)); }, token: HsLayerSynchronizerService, providedIn: "root" });
HsLayerSynchronizerService.ctorParameters = () => [
    { type: HsUtilsService },
    { type: HsLaymanService },
    { type: HsCommonEndpointsService },
    { type: HsDialogContainerService },
    { type: HsMapService },
    { type: HsCommonLaymanService },
    { type: HsToastService },
    { type: HsLanguageService },
    { type: HsLogService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsLayerSynchronizerService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: HsUtilsService }, { type: HsLaymanService }, { type: HsCommonEndpointsService }, { type: HsDialogContainerService }, { type: HsMapService }, { type: HsCommonLaymanService }, { type: HsToastService }, { type: HsLanguageService }, { type: HsLogService }]; }, null); })();

class HsLayerManagerComponent extends HsPanelBaseComponent {
    constructor(HsCore, HsUtilsService, HsLayerUtilsService, HsMapService, HsLayerManagerService, HsDimensionTimeService, HsLayoutService, HsLayerEditorSublayerService, HsLayerSynchronizerService, HsEventBusService, HsDialogContainerService, HsLanguageService, HsConfig, hsSidebarService) {
        super(HsLayoutService);
        this.HsCore = HsCore;
        this.HsUtilsService = HsUtilsService;
        this.HsLayerUtilsService = HsLayerUtilsService;
        this.HsMapService = HsMapService;
        this.HsLayerManagerService = HsLayerManagerService;
        this.HsDimensionTimeService = HsDimensionTimeService;
        this.HsLayoutService = HsLayoutService;
        this.HsLayerEditorSublayerService = HsLayerEditorSublayerService;
        this.HsLayerSynchronizerService = HsLayerSynchronizerService;
        this.HsEventBusService = HsEventBusService;
        this.HsDialogContainerService = HsDialogContainerService;
        this.HsLanguageService = HsLanguageService;
        this.HsConfig = HsConfig;
        this.shiftDown = false;
        this.physicalLayerListEnabled = false;
        this.icons = [
            'bag1.svg',
            'banking4.svg',
            'bar.svg',
            'beach17.svg',
            'bicycles.svg',
            'building103.svg',
            'bus4.svg',
            'cabinet9.svg',
            'camping13.svg',
            'caravan.svg',
            'church15.svg',
            'church1.svg',
            'coffee-shop1.svg',
            'disabled.svg',
            'favourite28.svg',
            'football1.svg',
            'footprint.svg',
            'gift-shop.svg',
            'gps40.svg',
            'gps41.svg',
            'gps42.svg',
            'gps43.svg',
            'gps5.svg',
            'hospital.svg',
            'hot-air-balloon2.svg',
            'information78.svg',
            'library21.svg',
            'location6.svg',
            'luggage13.svg',
            'monument1.svg',
            'mountain42.svg',
            'museum35.svg',
            'park11.svg',
            'parking28.svg',
            'pharmacy17.svg',
            'port2.svg',
            'restaurant52.svg',
            'road-sign1.svg',
            'sailing-boat2.svg',
            'ski1.svg',
            'swimming26.svg',
            'telephone119.svg',
            'toilets2.svg',
            'train-station.svg',
            'university2.svg',
            'warning.svg',
            'wifi8.svg',
        ];
        this.getActive = getActive;
        this.getTitle = getTitle;
        this.getThumbnail = getThumbnail;
        this.name = 'layermanager';
        this.ngUnsubscribe = new Subject();
        this.baselayerFilter = (item) => {
            const r = new RegExp(this.HsLayerManagerService.data.filter, 'i');
            return r.test(item.title);
        };
        hsSidebarService.buttons.push({
            panel: 'layermanager',
            module: 'hs.layermanager',
            order: 0,
            fits: true,
            title: () => this.HsLanguageService.getTranslation('PANEL_HEADER.LM'),
            description: () => this.HsLanguageService.getTranslation('SIDEBAR.descriptions.LM'),
            icon: 'icon-layers',
        });
        this.data = this.HsLayerManagerService.data;
        this.HsMapService.loaded().then((map) => this.init(map));
        this.HsEventBusService.layerRemovals
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((layer) => {
            var _a, _b;
            if (((_b = (_a = this.HsLayerManagerService) === null || _a === void 0 ? void 0 : _a.currentLayer) === null || _b === void 0 ? void 0 : _b.layer) == layer &&
                this.HsUtilsService.runningInBrowser()) {
                const layerNode = document.getElementsByClassName('hs-lm-mapcontentlist')[0];
                this.HsUtilsService.insertAfter(this.layerEditorRef.nativeElement, layerNode);
                this.HsLayerManagerService.currentLayer = null;
            }
        });
        this.HsEventBusService.compositionLoads
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((data) => {
            if (data.error == undefined) {
                if (data.data != undefined && data.data.id != undefined) {
                    this.HsLayerManagerService.composition_id = data.data.id;
                }
                else if (data.id != undefined) {
                    this.HsLayerManagerService.composition_id = data.id;
                }
                else {
                    this.HsLayerManagerService.composition_id = null;
                }
            }
        });
        this.HsEventBusService.compositionDeletes
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((composition) => {
            if (composition.id == this.HsLayerManagerService.composition_id) {
                this.HsLayerManagerService.composition_id = null;
            }
        });
    }
    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
    ngOnInit() {
        this.layerlistVisible = true;
    }
    ngAfterViewInit() {
        this.HsLayerManagerService.layerEditorElement =
            this.layerEditorRef.nativeElement;
    }
    changeBaseLayerVisibility(e, layer) {
        return this.HsLayerManagerService.changeBaseLayerVisibility(e, layer);
    }
    changeTerrainLayerVisibility(e, layer) {
        return this.HsLayerManagerService.changeTerrainLayerVisibility(e, layer);
    }
    changeLayerVisibility(toWhat, layer) {
        return this.HsLayerManagerService.changeLayerVisibility(toWhat, layer);
    }
    setProp(layer, property, value) {
        layer.set(property, value);
    }
    activateTheme(e) {
        return this.HsLayerManagerService.activateTheme(e);
    }
    filterLayerTitles() {
        this.HsEventBusService.layerManagerUpdates.next();
    }
    /**
     * Removes layer from map object
     * @param layer - Layer to remove
     */
    removeLayer(layer) {
        this.map.removeLayer(layer);
    }
    /**
     * Removes all layers which don't have 'removable' attribute
     * set to false if user confirms the removal. Might reload composition again.
     */
    removeAllLayers() {
        this.HsDialogContainerService.create(HsLayerManagerRemoveAllDialogComponent, {});
    }
    /**
     * Determines if layer has copyright information available *
     * @param layer - Selected layer (HsLayerManagerService.currentLayer)
     */
    hasCopyright(layer) {
        var _a;
        if (!this.HsLayerManagerService.currentLayer) {
            return;
        }
        else {
            return ((_a = getAttribution(layer.layer)) === null || _a === void 0 ? void 0 : _a.onlineResource) != undefined;
        }
    }
    /**
     * Test if box layers are loaded
     */
    hasBoxImages() {
        var _a;
        return (_a = this.data.box_layers) === null || _a === void 0 ? void 0 : _a.some((layer) => getThumbnail(layer) !== undefined);
    }
    /**
     * Test if layer (WMS) resolution is within map resolution interval
     * @param layer - Selected layer
     */
    isLayerInResolutionInterval(layer) {
        return this.HsLayerManagerService.isLayerInResolutionInterval(layer);
    }
    /**
     * Test if selected layer is loaded in map
     * @param layer - Selected layer
     */
    layerLoaded(layer) {
        return this.HsLayerUtilsService.layerLoaded(layer);
    }
    /**
     * @param m
     */
    init(m) {
        this.map = this.HsMapService.map;
        this.HsLayerSynchronizerService.init(this.map);
        this.HsEventBusService.mapResets
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(() => {
            this.HsLayerManagerService.composition_id = null;
        });
    }
}
HsLayerManagerComponent.ɵfac = function HsLayerManagerComponent_Factory(t) { return new (t || HsLayerManagerComponent)(ɵngcc0.ɵɵdirectiveInject(HsCoreService), ɵngcc0.ɵɵdirectiveInject(HsUtilsService), ɵngcc0.ɵɵdirectiveInject(HsLayerUtilsService), ɵngcc0.ɵɵdirectiveInject(HsMapService), ɵngcc0.ɵɵdirectiveInject(HsLayerManagerService), ɵngcc0.ɵɵdirectiveInject(HsDimensionTimeService), ɵngcc0.ɵɵdirectiveInject(HsLayoutService), ɵngcc0.ɵɵdirectiveInject(HsLayerEditorSublayerService), ɵngcc0.ɵɵdirectiveInject(HsLayerSynchronizerService), ɵngcc0.ɵɵdirectiveInject(HsEventBusService), ɵngcc0.ɵɵdirectiveInject(HsDialogContainerService), ɵngcc0.ɵɵdirectiveInject(HsLanguageService), ɵngcc0.ɵɵdirectiveInject(HsConfig), ɵngcc0.ɵɵdirectiveInject(HsSidebarService)); };
HsLayerManagerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsLayerManagerComponent, selectors: [["hs-layer-manager"]], viewQuery: function HsLayerManagerComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c24, 5, ElementRef);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.layerEditorRef = _t.first);
    } }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 37, vars: 35, consts: [[1, "card", "panel-default", "hs-main-panel", "hs-layermanager-card", 3, "hidden"], ["name", "layermanager", 3, "title"], ["type", "button", 1, "but-title-sm", 3, "title", "click"], [1, "glyphicon", "icon-edit"], [1, "glyphicon", "icon-trash"], [1, "glyphicon", "icon-fatredo"], [1, "card-body", "hs-lm-panel"], [1, "nav", "nav-pills", 3, "hidden"], ["class", "col-xs-2 col-md-2 list-group-item-primary", "style", "padding-right: 2px; padding-left: 2px;", 4, "ngFor", "ngForOf"], ["type", "text", 1, "form-control", "hs-filter", 3, "placeholder", "ngModel", "ngModelOptions", "ngModelChange", "input"], ["class", "list-group hs-lm-baselayerlist", 4, "ngIf"], [1, "list-group", "hs-lm-baselayerlist", 3, "hidden"], [1, "list-group-item", "hs-lm-item", "hs-lm-header", "clearfix", "list-group-item-primary"], [1, "d-flex"], [1, "p-0", "flex-grow-1", "hs-lm-item-title"], [1, "align-middle", 2, "line-height", "2em"], ["class", "list-group-item hs-lm-item", 3, "ngClass", "click", "mouseenter", "mouseleave", 4, "ngFor", "ngForOf"], [1, "list-group", "hs-lm-mapcontentlist"], ["class", "hs-lm-header hs-lm-item list-group-item-primary hs-lm-map-content-header list-group-item", "style", "margin-bottom: 0.2em;", 4, "ngIf"], ["class", "list-group hs-lm-layerlist mb-1", 3, "hidden", 4, "ngFor", "ngForOf"], [1, "list-group", "hs-lm-layerlist", "mb-1", 3, "hidden"], [1, "hs-layerpanel", 3, "current-layer", "hidden"], ["layerEditor", ""], [1, "col-xs-2", "col-md-2", "list-group-item-primary", 2, "padding-right", "2px", "padding-left", "2px"], [3, "ngClass", "title", "click"], [3, "src", "alt"], [1, "list-group", "hs-lm-baselayerlist"], [1, "p-0"], ["type", "button", 1, "btn", "btn-sm", "hs-btn-baselayers", 3, "ngClass", "click"], ["class", "list-group-item hs-lm-item", 3, "ngClass", "id", 4, "ngFor", "ngForOf"], [1, "list-group-item", "hs-lm-item", 3, "ngClass", "id"], ["type", "button", 1, "btn", "btn-sm", "btn-light", "hs-lm-item-visibility", 3, "ngClass", "click"], ["abstractTooltip", ""], [1, "align-items-center", "p-0", "flex-grow-1", "hs-lm-item-title", 2, "cursor", "context-menu", 3, "ngClass", "ngbTooltip", "closeDelay"], [1, "pl-1", "info_btn", 2, "cursor", "pointer"], ["data-toggle", "tooltip", "data-container", "body", "data-placement", "auto", 1, "icon-settingsthree-gears", "text-secondary", 3, "title", "click"], ["type", "secondary", "height", "2px", 3, "value", 4, "ngIf"], [3, "innerHtml"], ["type", "secondary", "height", "2px", 3, "value"], [1, "list-group-item", "hs-lm-item", 3, "ngClass", "click", "mouseenter", "mouseleave"], ["type", "button", 1, "btn", "btn-sm", "btn-light", "hs-lm-item-visibility", 3, "ngClass"], [1, "align-items-center", "p-0", "flex-grow-1", "hs-lm-item-title", 3, "ngClass", "ngbTooltip", "closeDelay"], [1, "hs-lm-header", "hs-lm-item", "list-group-item-primary", "hs-lm-map-content-header", "list-group-item", 2, "margin-bottom", "0.2em"], ["class", "list-group-item hs-lm-layerlist-header list-group-item-primary", 3, "click", 4, "ngIf"], [3, "hidden"], [3, "folder"], [1, "list-group-item", "hs-lm-layerlist-header", "list-group-item-primary", 3, "click"], [1, "glyphicon", 3, "ngClass"]], template: function HsLayerManagerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "hs-panel-header", 1);
        ɵngcc0.ɵɵpipe(2, "translate");
        ɵngcc0.ɵɵelementStart(3, "extra-buttons");
        ɵngcc0.ɵɵelementStart(4, "button", 2);
        ɵngcc0.ɵɵlistener("click", function HsLayerManagerComponent_Template_button_click_4_listener() { return ctx.physicalLayerListEnabled = !ctx.physicalLayerListEnabled; });
        ɵngcc0.ɵɵpipe(5, "translate");
        ɵngcc0.ɵɵelement(6, "i", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "button", 2);
        ɵngcc0.ɵɵlistener("click", function HsLayerManagerComponent_Template_button_click_7_listener() { return ctx.removeAllLayers(); });
        ɵngcc0.ɵɵpipe(8, "translate");
        ɵngcc0.ɵɵelement(9, "i", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "button", 2);
        ɵngcc0.ɵɵlistener("click", function HsLayerManagerComponent_Template_button_click_10_listener() { return ctx.HsCore.resetMap(); });
        ɵngcc0.ɵɵpipe(11, "translate");
        ɵngcc0.ɵɵelement(12, "i", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(13, "div", 6);
        ɵngcc0.ɵɵelementStart(14, "div", 7);
        ɵngcc0.ɵɵtemplate(15, HsLayerManagerComponent_div_15_Template, 3, 6, "div", 8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(16, "div");
        ɵngcc0.ɵɵelementStart(17, "input", 9);
        ɵngcc0.ɵɵlistener("ngModelChange", function HsLayerManagerComponent_Template_input_ngModelChange_17_listener($event) { return ctx.data.filter = $event; })("input", function HsLayerManagerComponent_Template_input_input_17_listener() { return ctx.filterLayerTitles(); });
        ɵngcc0.ɵɵpipe(18, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(19, HsLayerManagerComponent_ul_19_Template, 11, 8, "ul", 10);
        ɵngcc0.ɵɵelementStart(20, "ul", 11);
        ɵngcc0.ɵɵelementStart(21, "li", 12);
        ɵngcc0.ɵɵelementStart(22, "div", 13);
        ɵngcc0.ɵɵelementStart(23, "div", 14);
        ɵngcc0.ɵɵelementStart(24, "span", 15);
        ɵngcc0.ɵɵtext(25);
        ɵngcc0.ɵɵpipe(26, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(27, HsLayerManagerComponent_li_27_Template, 8, 11, "li", 16);
        ɵngcc0.ɵɵpipe(28, "filter");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(29, "ul", 17);
        ɵngcc0.ɵɵtemplate(30, HsLayerManagerComponent_li_30_Template, 4, 3, "li", 18);
        ɵngcc0.ɵɵtemplate(31, HsLayerManagerComponent_ul_31_Template, 7, 6, "ul", 19);
        ɵngcc0.ɵɵelementStart(32, "ul", 20);
        ɵngcc0.ɵɵelementStart(33, "li");
        ɵngcc0.ɵɵelement(34, "hs-layermanager-physical-layer-list");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(35, "hs-layer-editor", 21, 22);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("hidden", !ctx.isVisible());
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(2, 19, "PANEL_HEADER.LM"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(5, 21, "LAYERMANAGER.enablePhysicalLayerList"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(8, 23, "LAYERMANAGER.dialogRemoveAll.removeAllAdded"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(11, 25, "LAYERMANAGER.resetMap"));
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("hidden", !ctx.hasBoxImages());
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.data.box_layers);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("placeholder", ɵngcc0.ɵɵpipeBind1(18, 27, "COMMON.filter"))("ngModel", ctx.data.filter)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(34, _c2));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.HsLayoutService.componentEnabled("basemapGallery"));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", !(ctx.data.terrainlayers.length > 0));
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(26, 29, "LAYERMANAGER.terrains"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind2(28, 31, ctx.data.terrainlayers, ctx.baselayerFilter));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.HsLayoutService.componentEnabled("basemapGallery"));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.data.folders.sub_folders);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", !ctx.physicalLayerListEnabled);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("current-layer", ctx.HsLayerManagerService.currentLayer)("hidden", !(ctx.HsLayerManagerService.currentLayer !== null) || ctx.HsLayerManagerService.menuExpanded);
    } }, directives: function () { return [HsPanelHeaderComponent, ɵngcc3.NgForOf, ɵngcc5.DefaultValueAccessor, ɵngcc5.NgControlStatus, ɵngcc5.NgModel, ɵngcc3.NgIf, HsLayerPhysicalListComponent, HsLayerEditorComponent, ɵngcc3.NgClass, ɵngcc6.NgbTooltip, ɵngcc6.NgbProgressbar, HsLayerManagerFolderComponent, HsLayerListComponent]; }, pipes: function () { return [ɵngcc1.TranslatePipe, FilterPipe]; }, encapsulation: 2 });
HsLayerManagerComponent.ctorParameters = () => [
    { type: HsCoreService },
    { type: HsUtilsService },
    { type: HsLayerUtilsService },
    { type: HsMapService },
    { type: HsLayerManagerService },
    { type: HsDimensionTimeService },
    { type: HsLayoutService },
    { type: HsLayerEditorSublayerService },
    { type: HsLayerSynchronizerService },
    { type: HsEventBusService },
    { type: HsDialogContainerService },
    { type: HsLanguageService },
    { type: HsConfig },
    { type: HsSidebarService }
];
HsLayerManagerComponent.propDecorators = {
    layerEditorRef: [{ type: ViewChild, args: ['layerEditor', { static: false, read: ElementRef },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsLayerManagerComponent, [{
        type: Component,
        args: [{
                selector: 'hs-layer-manager',
                template: "<div class=\"card panel-default hs-main-panel hs-layermanager-card\" [hidden]=\"!isVisible()\">\n    <hs-panel-header name=\"layermanager\" [title]=\"'PANEL_HEADER.LM' | translate\">\n        <extra-buttons>\n            <button type=\"button\" class=\"but-title-sm\" (click)=\"physicalLayerListEnabled = !physicalLayerListEnabled\"\n                [title]=\"'LAYERMANAGER.enablePhysicalLayerList' | translate\">\n                <i class=\"glyphicon icon-edit\"></i>\n            </button>\n            <button type=\"button\" class=\"but-title-sm\" (click)=\"removeAllLayers()\"\n                [title]=\"'LAYERMANAGER.dialogRemoveAll.removeAllAdded' | translate\">\n                <i class=\"glyphicon icon-trash\"></i>\n            </button>\n            <button type=\"button\" class=\"but-title-sm\" (click)=\"HsCore.resetMap()\"\n                [title]=\"'LAYERMANAGER.resetMap' | translate\">\n                <i class=\"glyphicon icon-fatredo\"></i>\n            </button>\n        </extra-buttons>\n    </hs-panel-header>\n    <div class=\"card-body hs-lm-panel\">\n        <div class=\"nav nav-pills\" [hidden]=\"!hasBoxImages()\">\n            <div *ngFor=\"let box of data.box_layers\" class=\"col-xs-2 col-md-2 list-group-item-primary\"\n                style=\"padding-right: 2px; padding-left: 2px;\">\n                <a  [ngClass]=\"{ 'thumbnail': true, 'alert-info': getActive(box)}\"\n                    title=\"{{getTitle(box)}}\" (click)=\"activateTheme(box)\">\n                    <img src=\"{{getThumbnail(box)}}\" alt=\"{{getTitle(box)}}\">\n                </a>\n            </div>\n        </div>\n        <div><input type=\"text\" class=\"form-control hs-filter\" [placeholder]=\"'COMMON.filter' | translate\"\n                [(ngModel)]=\"data.filter\" [ngModelOptions]=\"{standalone: true}\" (input)=\"filterLayerTitles()\"></div>\n\n        <ul *ngIf=\"!HsLayoutService.componentEnabled('basemapGallery')\" class=\"list-group hs-lm-baselayerlist\">\n            <li class=\"list-group-item hs-lm-item hs-lm-header clearfix list-group-item-primary\">\n                <div class=\"d-flex\">\n                    <div class=\"p-0 flex-grow-1 hs-lm-item-title\">\n                        <span class=\"align-middle\"\n                            style=\"line-height: 2em;\">{{'LAYERMANAGER.baselayers' | translate }}</span>\n                    </div>\n                    <div class=\"p-0\">\n                        <button type=\"button\" class=\"btn btn-sm hs-btn-baselayers\" (click)=\"changeBaseLayerVisibility()\"\n                            [ngClass]=\"data.baselayersVisible ? 'hs-checkmark' : 'hs-uncheckmark'\"></button>\n                    </div>\n                </div>\n            </li>\n            <li class=\"list-group-item hs-lm-item\" *ngFor=\"let layer of data.baselayers | filter:baselayerFilter\"\n                [ngClass]=\"{'hs-lm-deactivated-layer': !layer.visible || !layer.active}\" id=\"{{layer.idString()}}\">\n                <div class=\"d-flex\">\n                    <div class=\"p-0\">\n                        <button type=\"button\" class=\"btn btn-sm btn-light hs-lm-item-visibility\"\n                            (click)=\"changeBaseLayerVisibility($event, layer);\"\n                            [ngClass]=\"(data.baselayersVisible && layer.visible) ? 'hs-checkmark' : 'hs-uncheckmark'\"></button>\n                    </div>\n                    <ng-template #abstractTooltip>\n                        <span [innerHtml]=\"HsLayerManagerService.makeSafeAndTranslate('LAYERS', layer.abstract)\"></span>\n                    </ng-template>\n                    <div class=\"align-items-center p-0 flex-grow-1 hs-lm-item-title\" style=\"cursor:context-menu\"\n                        [ngClass]=\"{'font-weight-bold': layer.active, 'text-muted' : layer.grayed}\"\n                        [ngbTooltip]=\"layer.abstract ? abstractTooltip : ''\"\n                        [closeDelay]=\"HsConfig.layerTooltipDelay || 0\">\n                        {{HsLayerUtilsService.translateTitle(layer.title)}}\n                    </div>\n                    <div class=\"pl-1 info_btn\" style=\"cursor: pointer;\">\n                        <span class=\"icon-settingsthree-gears text-secondary\"\n                            (click)=\"HsLayerManagerService.toggleLayerEditor(layer,'settings','sublayers')\"\n                            [title]=\"'COMMON.info' | translate\" data-toggle=\"tooltip\" data-container=\"body\"\n                            data-placement=\"auto\"></span>\n                    </div>\n                </div>\n                <ngb-progressbar type=\"secondary\" *ngIf=\"layer.loadProgress?.loadTotal > 0\" [value]=\"layer.loadProgress.percents\" height=\"2px\"></ngb-progressbar>\n            </li>\n        </ul>\n\n        <ul class=\"list-group hs-lm-baselayerlist\" [hidden]=\"!(data.terrainlayers.length > 0)\">\n            <li class=\"list-group-item hs-lm-item hs-lm-header clearfix list-group-item-primary\">\n                <div class=\"d-flex\">\n                    <div class=\"p-0 flex-grow-1 hs-lm-item-title\">\n                        <span class=\"align-middle\"\n                            style=\"line-height: 2em;\">{{ 'LAYERMANAGER.terrains' | translate }}</span>\n                    </div>\n                </div>\n            </li>\n            <li class=\"list-group-item hs-lm-item\" *ngFor=\"let layer of data.terrainlayers | filter:baselayerFilter\"\n                (click)=\"changeTerrainLayerVisibility($event, layer)\" (mouseenter)=\"hovering=true\"\n                (mouseleave)=\"hovering=false\" [ngClass]=\"{'hovering': (hovering && !layer.active)}\">\n                <div class=\"d-flex \">\n                    <!-- <div class=\"p-0\" ng-show=\"layer.active || hovering\"\n                        ng-style=\"hovering && !layer.active && {'opacity':'0.5'}\">\n                        <button class=\"btn btn-sm btn-link hs-lm-baseitem-visibility\"><i\n                                class=\"icon-globe\"></i></button>\n                    </div> -->\n                    <div class=\"p-0\">\n                        <button type=\"button\" class=\"btn btn-sm btn-light hs-lm-item-visibility\"\n                            [ngClass]=\"(data.baselayersVisible && layer.visible) ? 'hs-checkmark' : 'hs-uncheckmark'\"></button>\n                    </div>\n                    <ng-template #abstractTooltip>\n                        <span [innerHtml]=\"HsLayerManagerService.makeSafeAndTranslate('LAYERS', layer.abstract)\"></span>\n                    </ng-template>\n                    <div class=\"align-items-center p-0 flex-grow-1 hs-lm-item-title\"\n                        [ngClass]=\"{'font-weight-bold': layer.active, 'text-muted': layer.grayed}\"\n                        [ngbTooltip]=\"layer.abstract ? abstractTooltip : ''\" \n                        [closeDelay]=\"HsConfig.layerTooltipDelay || 0\">\n                        {{HsLayerUtilsService.translateTitle(layer.title)}}\n                    </div>\n                </div>\n            </li>\n        </ul>\n\n        <ul class=\"list-group hs-lm-mapcontentlist\" >\n            <li *ngIf=\"!HsLayoutService.componentEnabled('basemapGallery')\"\n                class=\"hs-lm-header hs-lm-item list-group-item-primary hs-lm-map-content-header list-group-item\"\n                style=\"margin-bottom: 0.2em;\">\n                <span class=\"align-middle\" style=\"line-height: 2em;\">{{ 'LAYERMANAGER.mapContent' | translate }}</span>\n            </li>\n            <ul class=\"list-group hs-lm-layerlist mb-1\" *ngFor=\"let value of data.folders.sub_folders\" [hidden]=\"physicalLayerListEnabled\">\n                <li class=\"list-group-item hs-lm-layerlist-header list-group-item-primary\" *ngIf=\"data.folders.sub_folders.length > 1\"\n                    (click)=\"value.visible = !value.visible\">\n                    <span>{{HsLanguageService.getTranslationIgnoreNonExisting('LAYERMANAGER', value.name)}}&nbsp;</span>\n                    <span class=\"glyphicon\"\n                        [ngClass]=\"value.visible ? 'icon-chevron-right' : 'icon-chevron-down'\"></span>\n                </li>\n                <div [hidden]=\"!value.visible\">\n                    <li [hidden]=\"!(value.sub_folders.length > 0)\">\n                        <hs-layer-manager-folder [folder]=\"value\"></hs-layer-manager-folder>\n                    </li>\n                    <li>\n                        <hs-layermanager-layer-list [folder]=\"value\"></hs-layermanager-layer-list>\n                    </li>\n                </div>\n            </ul>\n            <ul class=\"list-group hs-lm-layerlist mb-1\" [hidden]=\"!physicalLayerListEnabled\">\n                <li>\n                    <hs-layermanager-physical-layer-list></hs-layermanager-physical-layer-list>\n                </li>\n            </ul>\n            <!--\n        <div class=\"btn-group\" data-toggle=\"buttons\">\n            <label class=\"btn btn-secondary active\">\n            <input type=\"radio\" name=\"options\" id=\"option1\" checked> Logical order\n            </label>\n            <label class=\"btn btn-secondary\">\n            <input type=\"radio\" name=\"options\" id=\"option2\"> Physical order\n            </label>\n        </div> -->\n        </ul>\n        <hs-layer-editor [current-layer]=\"HsLayerManagerService.currentLayer\" #layerEditor\n            [hidden]=\"!(HsLayerManagerService.currentLayer !== null) || HsLayerManagerService.menuExpanded\" class=\"hs-layerpanel\">\n        </hs-layer-editor>\n    </div>\n</div>\n"
            }]
    }], function () { return [{ type: HsCoreService }, { type: HsUtilsService }, { type: HsLayerUtilsService }, { type: HsMapService }, { type: HsLayerManagerService }, { type: HsDimensionTimeService }, { type: HsLayoutService }, { type: HsLayerEditorSublayerService }, { type: HsLayerSynchronizerService }, { type: HsEventBusService }, { type: HsDialogContainerService }, { type: HsLanguageService }, { type: HsConfig }, { type: HsSidebarService }]; }, { layerEditorRef: [{
            type: ViewChild,
            args: ['layerEditor', { static: false, read: ElementRef }]
        }] }); })();

class HsLayerManagerGalleryComponent extends HsPanelBaseComponent {
    constructor(HsLayoutService, HsLayerManagerService, HsConfig, HsLayerUtilsService //Used in template
    ) {
        super(HsLayoutService);
        this.HsLayoutService = HsLayoutService;
        this.HsLayerManagerService = HsLayerManagerService;
        this.HsConfig = HsConfig;
        this.HsLayerUtilsService = HsLayerUtilsService;
        this.baseLayersExpanded = false;
        this.menuExpanded = false;
        this.data = this.HsLayerManagerService.data;
    }
    changeBaseLayerVisibility(toWhat, layer) {
        this.HsLayerManagerService.changeBaseLayerVisibility(toWhat, layer);
    }
    toggleMiniMenu(layer) {
        if (layer.galleryMiniMenu) {
            layer.galleryMiniMenu = !layer.galleryMiniMenu;
        }
        else {
            layer.galleryMiniMenu = true;
        }
    }
    toggleBasemap(layer) {
        var _a;
        if (layer) {
            if (!layer.active) {
                this.HsLayerManagerService.changeBaseLayerVisibility(true, layer);
                this.baseLayersExpanded = false;
                this.HsLayerManagerService.menuExpanded = false;
                const olLayer = (_a = this.HsLayerManagerService.currentLayer) === null || _a === void 0 ? void 0 : _a.layer;
                if (!olLayer || getBase(olLayer)) {
                    this.HsLayerManagerService.currentLayer = null;
                }
            }
        }
        else {
            this.baseLayersExpanded = false;
            this.HsLayerManagerService.currentLayer = null;
            this.HsLayerManagerService.changeBaseLayerVisibility();
        }
    }
    expandMenu(layer) {
        this.HsLayerManagerService.toggleLayerEditor(layer, 'settings', 'sublayers');
        this.HsLayerManagerService.menuExpanded =
            !this.HsLayerManagerService.menuExpanded;
    }
    isVisible() {
        return (this.HsLayoutService.componentEnabled('basemapGallery') &&
            this.HsLayoutService.componentEnabled('guiOverlay'));
    }
}
HsLayerManagerGalleryComponent.ɵfac = function HsLayerManagerGalleryComponent_Factory(t) { return new (t || HsLayerManagerGalleryComponent)(ɵngcc0.ɵɵdirectiveInject(HsLayoutService), ɵngcc0.ɵɵdirectiveInject(HsLayerManagerService), ɵngcc0.ɵɵdirectiveInject(HsConfig), ɵngcc0.ɵɵdirectiveInject(HsLayerUtilsService)); };
HsLayerManagerGalleryComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsLayerManagerGalleryComponent, selectors: [["hs-layermanager-gallery"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 11, vars: 15, consts: [[1, "basemapGallery", 2, "z-index", "101", 3, "hidden"], ["role", "group", 1, "btn-group", "btn-group-sm"], ["type", "button", "data-toggle", "dropdown", "aria-haspopup", "true", 1, "btn", "rounded", "galleryButton", "pt-0", "pb-0", 3, "click"], [1, "glyphicon", "icon-map", "x-large", "p-0"], [1, "dropdown-menu", "dropdown-menu-right", "p-0", "galleryDropdown", "bg-light", "rounded", 3, "ngClass"], ["class", "m-0", 3, "ngStyle", "click", 4, "ngFor", "ngForOf"], [3, "click"], ["alt", "", 2, "height", "4em", "width", "100%", "background", "white", 3, "ngClass"], [1, "dropdown-item", 3, "ngClass"], [1, "m-0", 3, "ngStyle", "click"], ["style", "position:absolute;top:5px; right:5px;z-index:5", 3, "ngStyle", "click", 4, "ngIf"], [1, "hs-miniMenu", 3, "hidden", "ngStyle", "ngClass"], ["class", "pl-1 w-100", 3, "click", 4, "ngIf"], [1, "pl-2", "mb-0", "w-100", 3, "ngStyle", "click"], ["class", "hs-layerpanel w-100", 3, "current-layer", 4, "ngIf"], ["alt", "Basemap thumbnail", 2, "width", "100%", 3, "ngClass", "src"], [1, "dropdown-item", 2, "white-space", "pre-line", "overflow-wrap", "anywhere", 3, "ngClass"], [2, "position", "absolute", "top", "5px", "right", "5px", "z-index", "5", 3, "ngStyle", "click"], [1, "glyphicon", "icon-menu", "icon-small"], [1, "pl-1", "w-100", 3, "click"], [1, "form-check-label", "m-0", 3, "ngClass"], [1, "ml-1", "mb-0"], [1, "hs-layerpanel", "w-100", 3, "current-layer"], ["layerEditor", ""]], template: function HsLayerManagerGalleryComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "button", 2);
        ɵngcc0.ɵɵlistener("click", function HsLayerManagerGalleryComponent_Template_button_click_2_listener() { return ctx.baseLayersExpanded = !ctx.baseLayersExpanded; });
        ɵngcc0.ɵɵelement(3, "i", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 4);
        ɵngcc0.ɵɵtemplate(5, HsLayerManagerGalleryComponent_div_5_Template, 10, 23, "div", 5);
        ɵngcc0.ɵɵelementStart(6, "div", 6);
        ɵngcc0.ɵɵlistener("click", function HsLayerManagerGalleryComponent_Template_div_click_6_listener() { return ctx.toggleBasemap(); });
        ɵngcc0.ɵɵelement(7, "div", 7);
        ɵngcc0.ɵɵelementStart(8, "a", 8);
        ɵngcc0.ɵɵtext(9);
        ɵngcc0.ɵɵpipe(10, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("hidden", !ctx.isVisible());
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵattribute("aria-expanded", ctx.baseLayersExpanded);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(9, _c14, ctx.baseLayersExpanded));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.HsLayerManagerService.data.baselayers);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(11, _c12, !ctx.data.baselayersVisible));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(13, _c12, !ctx.data.baselayersVisible));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(10, 7, "LAYERMANAGER.baseMapGallery.noBaseMap"));
    } }, directives: function () { return [ɵngcc3.NgClass, ɵngcc3.NgForOf, ɵngcc3.NgStyle, ɵngcc3.NgIf, HsLayerEditorComponent]; }, pipes: function () { return [ɵngcc1.TranslatePipe]; }, encapsulation: 2 });
HsLayerManagerGalleryComponent.ctorParameters = () => [
    { type: HsLayoutService },
    { type: HsLayerManagerService },
    { type: HsConfig },
    { type: HsLayerUtilsService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsLayerManagerGalleryComponent, [{
        type: Component,
        args: [{
                selector: 'hs-layermanager-gallery',
                template: "<div class=\"basemapGallery\" style=\"z-index: 101;\" [hidden]=\"!isVisible()\">\n    <div class=\"btn-group btn-group-sm\" role=\"group\">\n        <button type=\"button\" (click)=\"baseLayersExpanded=!baseLayersExpanded\"\n            class=\"btn rounded galleryButton pt-0 pb-0\" data-toggle=\"dropdown\" aria-haspopup=\"true\"\n            [attr.aria-expanded]=\"baseLayersExpanded\">\n            <i class=\"glyphicon icon-map x-large p-0\"></i>\n        </button>\n        <div class=\"dropdown-menu dropdown-menu-right p-0 galleryDropdown bg-light rounded\"\n            [ngClass]=\"{'show': baseLayersExpanded}\">\n            <div *ngFor=\"let layer of HsLayerManagerService.data.baselayers\" (click)=\"toggleBasemap(layer)\"\n                [ngStyle]=\"{'position':'relative'}\" class=\"m-0\">\n                <div style=\"position:absolute;top:5px; right:5px;z-index:5\"\n                    [ngStyle]=\"layer.galleryMiniMenu && {'color':'white'} || {'color': 'var(--primary)'}\"\n                    *ngIf=\"layer.active\" (click)=\"toggleMiniMenu(layer)\">\n                    <span class=\"glyphicon icon-menu icon-small\"></span>\n                </div>\n                <div class=\"hs-miniMenu\" [hidden]=\"!(layer.galleryMiniMenu == true && layer.active)\"\n                    [ngStyle]=\"{'position':'absolute'}\" [ngClass]=\"{'expanded': HsLayerManagerService.menuExpanded}\">\n                    <div class=\"pl-1 w-100\" *ngIf=\"!HsLayerManagerService.menuExpanded\"\n                        (click)=\"HsLayerManagerService.setGreyscale(layer)\">\n                        <label class=\"form-check-label m-0\"\n                            [ngClass]=\"{'hs-checkmark': layer.grayscale,'hs-uncheckmark':!layer.grayscale}\"></label>\n                        <p class=\"ml-1 mb-0\">\n                            {{'LAYERMANAGER.baseMapGallery.grayscale' | translate}}</p>\n                    </div>\n                    <label class=\"pl-2 mb-0 w-100\" [ngStyle]=\"{'background-color':'rgba(192, 189, 189, 0.644)'}\"\n                        (click)=\"expandMenu(layer)\">\n\n                        {{HsLayerManagerService.menuExpanded ? 'Less ': 'More'}}</label>\n                    <hs-layer-editor [current-layer]=\"layer\" *ngIf=\"HsLayerManagerService.menuExpanded\"\n                        class=\"hs-layerpanel w-100\" #layerEditor>\n                    </hs-layer-editor>\n                </div>\n\n                <img [ngClass]=\"{'active': layer.active, 'hs-ale': !layer.active}\" src=\"{{layer.thumbnail}}\"\n                    alt=\"Basemap thumbnail\" style=\"width:100%\">\n                <a class=\"dropdown-item\"  [ngClass]=\"{'active': layer.active}\"\n                    style=\"white-space: pre-line; overflow-wrap: anywhere;\">{{HsLayerUtilsService.translateTitle(layer.title)}}</a>\n            </div>\n            <div (click)=\"toggleBasemap()\">\n                <div style=\"height: 4em; width: 100%; background: white\" [ngClass]=\"{'active': !data.baselayersVisible}\" alt=\"\"></div>\n                <a class=\"dropdown-item\" \n                    [ngClass]=\"{'active': !data.baselayersVisible}\">{{'LAYERMANAGER.baseMapGallery.noBaseMap' | translate}}</a>\n            </div>\n        </div>\n    </div>\n</div>\n"
            }]
    }], function () { return [{ type: HsLayoutService }, { type: HsLayerManagerService }, { type: HsConfig }, { type: HsLayerUtilsService }]; }, null); })();

class HsLegendService {
    constructor(hsUtilsService, hsLayerUtilsService, hsLayerSelectorService, sanitizer) {
        this.hsUtilsService = hsUtilsService;
        this.hsLayerUtilsService = hsLayerUtilsService;
        this.hsLayerSelectorService = hsLayerSelectorService;
        this.sanitizer = sanitizer;
        this.hsLayerSelectorService.layerSelected.subscribe((layer) => {
            this.getLayerLegendDescriptor(layer.layer);
        });
    }
    /**
     * Test if layer is visible and has supported type (conditions for displaying legend)
     * @param layer - Layer to test
     * @returns Return if legend might exist for layer and layer is visible
     */
    legendValid(layer) {
        if (layer === undefined || layer.type == undefined) {
            return false;
        }
        if (['vector', 'wms', 'static'].indexOf(layer.type) > -1 &&
            layer.lyr.getVisible()) {
            return true;
        }
        return false;
    }
    /**
     * Get vector layer feature geometries
     * @param currentLayer - Layer of interest
     * @returns Array of simplified lowercase names of geometry types encountered in layer
     */
    getVectorFeatureGeometry(currentLayer) {
        if (currentLayer === undefined || !currentLayer.getSource().getFeatures) {
            return;
        }
        const found = this.findFeatureGeomTypes(currentLayer.getSource().getFeatures());
        if (this.hsLayerUtilsService.isLayerClustered(currentLayer)) {
            //Clustered layer?
            const subFeatureTypes = this.findFeatureGeomTypes(currentLayer.getSource().getSource().getFeatures());
            for (const type of Object.keys(subFeatureTypes)) {
                found[type] = subFeatureTypes[type] || found[type];
            }
        }
        const tmp = Object.keys(found).filter((key) => found[key]);
        return tmp;
    }
    findFeatureGeomTypes(features) {
        const found = {
            line: false,
            point: false,
            polygon: false,
        };
        for (const feature of features) {
            if (feature.getGeometry()) {
                const type = feature.getGeometry().getType();
                switch (type) {
                    case 'LineString' || 'MultiLineString':
                        found.line = true;
                        break;
                    case 'Polygon' || 'MultiPolygon':
                        found.polygon = true;
                        break;
                    case 'Point' || 'MultiPoint':
                        found.point = true;
                        break;
                    default:
                }
            }
        }
        return found;
    }
    /**
     * Get vector layer styles for first 100 features
     * @param currentLayer - Layer of interest
     * @returns Array of serialized unique style descriptions encountered when looping through first 100 features
     */
    getStyleVectorLayer(currentLayer) {
        var _a, _b;
        if (currentLayer === undefined) {
            return;
        }
        let styleArray = [];
        if (!currentLayer.getStyle) {
            return;
        }
        const layerStyle = currentLayer.getStyle();
        if (!this.hsUtilsService.isFunction(layerStyle)) {
            styleArray.push(layerStyle);
        }
        else {
            if (((_b = (_a = currentLayer.getSource()) === null || _a === void 0 ? void 0 : _a.getFeatures()) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                styleArray = styleArray.concat(this.stylesForFeatures(currentLayer.getSource().getFeatures(), layerStyle));
                if (this.hsLayerUtilsService.isLayerClustered(currentLayer)) {
                    //Clustered layer?
                    styleArray = styleArray.concat(this.stylesForFeatures(currentLayer.getSource().getSource().getFeatures(), layerStyle));
                }
            }
        }
        const filtered = styleArray.filter((style) => style.getText === undefined || !style.getText());
        let serializedStyles = filtered
            .map((style) => this.serializeStyle(style))
            .filter((style) => style); //We don't want undefined values here, it breaks removeDuplicates
        serializedStyles = this.hsUtilsService.removeDuplicates(serializedStyles, 'hashcode');
        return serializedStyles;
    }
    stylesForFeatures(features, layerStyle) {
        let featureStyles = features.map((feature) => layerStyle(feature));
        if (featureStyles.length > 1000) {
            featureStyles = featureStyles.slice(0, 100);
        }
        if (Array.isArray(featureStyles[0])) {
            featureStyles = [...featureStyles];
        }
        return featureStyles;
    }
    /**
     * Serialize styles
     * @param style - OpenLayers style
     * @returns Simplified description of style used by template to draw legend
     */
    serializeStyle(style) {
        let ch = {};
        if (Array.isArray(style)) {
            for (const s of style) {
                const tempCh = this.getStyleChildren(s, ch);
                ch = tempCh;
            }
        }
        else {
            ch = this.getStyleChildren(style, ch);
        }
        const genStyle = this.setUpLegendStyle(ch.fill, ch.stroke, ch.image);
        return genStyle;
    }
    getStyleChildren(style, ch) {
        const newChildren = {};
        style.getImage && style.getImage()
            ? (newChildren.image = style.getImage())
            : (newChildren.image = ch.image);
        style.getFill && style.getFill()
            ? (newChildren.fill = style.getFill())
            : (newChildren.fill = ch.fill);
        style.getStroke && style.getStroke()
            ? (newChildren.stroke = style.getStroke())
            : (newChildren.stroke = ch.stroke);
        return newChildren;
    }
    /**
     * Create object of parameters used for creation of svg content for legend using retrieved styles
     * @param fill - Fill description
     * @param stroke - Stroke description
     * @param image - Image description
     * @returns Simplified description of style used by template to draw legend
     */
    setUpLegendStyle(fill, stroke, image) {
        const row = {};
        row.style = { maxWidth: '35px', maxHeight: '35px', marginBottom: '10px' };
        if (image && this.hsUtilsService.instOf(image, Icon)) {
            const icon = image;
            row.icon = {
                type: 'icon',
                src: this.sanitizer.bypassSecurityTrustResourceUrl(icon.getSrc()),
            };
        }
        else if (image &&
            (this.hsUtilsService.instOf(image, Circle) ||
                this.hsUtilsService.instOf(image, CircleStyle))) {
            const circle = image;
            row.customCircle = {
                fill: 'white',
                type: 'circle',
                cx: '17.5px',
                cy: '17.5px',
                r: '15px',
            };
            if (circle.getStroke()) {
                Object.assign(row.customCircle, {
                    fill: circle.getFill().getColor(),
                    stroke: circle.getStroke().getColor(),
                    strokeWidth: circle.getStroke().getWidth(),
                });
            }
            if (circle.getFill()) {
                Object.assign(row.customCircle, {
                    fill: circle.getFill().getColor(),
                });
            }
        }
        if (!stroke && !fill) {
            row.defaultLine = { type: 'line', stroke: 'blue', strokeWidth: '1' };
            row.defaultPolygon = {
                type: 'polygon',
                fill: 'blue',
                stroke: 'purple',
                strokeWidth: '1',
            };
        }
        else if (stroke && fill) {
            row.fullPolygon = {
                type: 'polygon',
                stroke: stroke.getColor(),
                strokeWidth: stroke.getWidth() / 2,
                fill: fill.getColor(),
            };
            row.line = {
                type: 'line',
                stroke: stroke.getColor(),
                strokeWidth: stroke.getWidth() / 2,
            };
        }
        else {
            if (fill) {
                row.polygon = { type: 'polygon', fill: fill.getColor() };
                row.defaultLine = { type: 'line', stroke: 'blue', strokeWidth: '1' };
            }
            else {
                row.line = {
                    type: 'line',
                    stroke: stroke.getColor(),
                    strokeWidth: stroke.getWidth() / 2,
                };
                row.defaultPolygon = {
                    type: 'polygon',
                    fill: 'blue',
                    stroke: 'purple',
                    strokeWidth: '1',
                };
            }
        }
        row.hashcode = this.hsUtilsService.hashCode(JSON.stringify(row));
        return row;
    }
    /**
     * Generate url for GetLegendGraphic request of WMS service for selected layer
     * @param source - Source of wms layer
     * @param layer_name - Name of layer for which legend is requested
     * @param layer - Layer to get legend for
     * @returns Url of the legend graphics
     */
    getLegendUrl(source, layer_name, layer) {
        if (!this.hsLayerUtilsService.isLayerWMS(layer)) {
            return '';
        }
        const params = this.hsLayerUtilsService.getLayerParams(layer);
        const version = params.VERSION || '1.3.0';
        let source_url = this.hsLayerUtilsService.getURL(layer);
        if (source_url.indexOf('proxy4ows') > -1) {
            const params = this.hsUtilsService.getParamsFromUrl(source_url);
            source_url = params.OWSURL;
        }
        const legendImage = getLegends(layer);
        if (legendImage !== undefined) {
            if (typeof legendImage == 'string') {
                return legendImage;
            }
            if (Array.isArray(legendImage)) {
                return legendImage[0];
            }
        }
        source_url +=
            (source_url.indexOf('?') > 0 ? '' : '?') +
                '&version=' +
                version +
                '&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer=' +
                layer_name +
                '&format=image%2Fpng';
        if (getEnableProxy(layer) === undefined || getEnableProxy(layer) == true) {
            source_url = this.hsUtilsService.proxify(source_url, false);
        }
        return source_url;
    }
    /**
     * (PRIVATE) Generate url for GetLegendGraphic request of WMS service for selected layer
     * @param layer - OpenLayers layer
     * @returns Description of layer to be used for creating the legend. It contains type of layer, sublayer legends, title, visibility etc.
     */
    getLayerLegendDescriptor(layer) {
        var _a;
        if (getBase(layer)) {
            return;
        }
        if (this.hsLayerUtilsService.isLayerWMS(layer)) {
            const subLayerLegends = this.hsLayerUtilsService
                .getLayerParams(layer)
                .LAYERS.split(',');
            for (let i = 0; i < subLayerLegends.length; i++) {
                subLayerLegends[i] = this.getLegendUrl(layer.getSource(), subLayerLegends[i], layer);
            }
            return {
                title: getTitle(layer),
                lyr: layer,
                type: 'wms',
                subLayerLegends: subLayerLegends,
                visible: layer.getVisible(),
            };
        }
        else if (this.hsUtilsService.instOf(layer, Vector$1) &&
            (getShowInLayerManager(layer) === undefined ||
                getShowInLayerManager(layer) == true)) {
            return {
                autoLegend: (_a = getAutoLegend(layer)) !== null && _a !== void 0 ? _a : true,
                title: getTitle(layer),
                lyr: layer,
                type: 'vector',
                visible: layer.getVisible(),
            };
        }
        else if (this.hsUtilsService.instOf(layer, Image$1) &&
            this.hsUtilsService.instOf(layer.getSource(), ImageStatic)) {
            return {
                title: getTitle(layer),
                lyr: layer,
                type: 'static',
                visible: layer.getVisible(),
            };
        }
        else if (this.hsUtilsService.instOf(layer.getSource(), XYZ)) {
            return {
                title: getTitle(layer),
                lyr: layer,
                type: 'static',
                visible: layer.getVisible(),
            };
        }
        else {
            return undefined;
        }
    }
}
HsLegendService.ɵfac = function HsLegendService_Factory(t) { return new (t || HsLegendService)(ɵngcc0.ɵɵinject(HsUtilsService), ɵngcc0.ɵɵinject(HsLayerUtilsService), ɵngcc0.ɵɵinject(HsLayerSelectorService), ɵngcc0.ɵɵinject(ɵngcc4.DomSanitizer)); };
HsLegendService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HsLegendService_Factory() { return new HsLegendService(i0.ɵɵinject(HsUtilsService), i0.ɵɵinject(HsLayerUtilsService), i0.ɵɵinject(HsLayerSelectorService), i0.ɵɵinject(i8.DomSanitizer)); }, token: HsLegendService, providedIn: "root" });
HsLegendService.ctorParameters = () => [
    { type: HsUtilsService },
    { type: HsLayerUtilsService },
    { type: HsLayerSelectorService },
    { type: DomSanitizer }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsLegendService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: HsUtilsService }, { type: HsLayerUtilsService }, { type: HsLayerSelectorService }, { type: ɵngcc4.DomSanitizer }]; }, null); })();

class HsLegendComponent extends HsPanelBaseComponent {
    constructor(hsLegendService, hsMapService, hsLayerUtilsService, hsUtilsService, hsQueuesService, hsLayoutService, hsLanguageService, hsSidebarService) {
        super(hsLayoutService);
        this.hsLegendService = hsLegendService;
        this.hsMapService = hsMapService;
        this.hsLayerUtilsService = hsLayerUtilsService;
        this.hsUtilsService = hsUtilsService;
        this.hsQueuesService = hsQueuesService;
        this.layerDescriptors = [];
        this.titleSearch = '';
        this.name = 'legend';
        this.legendFilter = (item) => {
            const r = new RegExp(this.titleSearch, 'i');
            return r.test(item.title);
        };
        hsSidebarService.buttons.push({
            panel: 'legend',
            module: 'hs.legend',
            order: 1,
            fits: true,
            title: () => hsLanguageService.getTranslation('PANEL_HEADER.LEGEND'),
            description: () => hsLanguageService.getTranslation('SIDEBAR.descriptions.LEGEND'),
            icon: 'icon-dotlist',
        });
        this.hsMapService.loaded().then((map) => this.init(map));
    }
    /**
     * Add selected layer to the list of layers in legend (with event listener
     * to display/hide legend item when layer visibility change)
     * @param layer - Layer to add legend for
     */
    addLayerToLegends(layer) {
        const descriptor = this.hsLegendService.getLayerLegendDescriptor(layer);
        if (descriptor) {
            this.layerDescriptors.push(descriptor);
            this.refreshList();
            layer.on('change:visible', (e) => this.layerVisibilityChanged(e));
            layer.on('change', (e) => {
                const layer = e.target;
                const oldDescriptor = this.findLayerDescriptor(layer);
                this.layerDescriptors[this.layerDescriptors.indexOf(oldDescriptor)] =
                    this.hsLegendService.getLayerLegendDescriptor(layer);
            });
            layer.getSource().on('change', (e) => this.layerSourcePropChanged(e));
        }
    }
    rebuildLegends() {
        this.layerDescriptors = [];
        this.buildLegendsForLayers(this.hsMapService.map);
    }
    filterDescriptors() {
        return this.layerDescriptors;
    }
    /**
     * Check if there is any visible layer
     * @returns Returns true if no layers with legend exist
     */
    noLayerExists() {
        const visibleLayers = this.layerDescriptors.filter((check) => check.visible);
        return visibleLayers.length == 0;
    }
    /**
     * Remove selected layer from legend items
     * @param layer - Layer to remove from legend
     */
    removeLayerFromLegends(layer) {
        for (let i = 0; i < this.layerDescriptors.length; i++) {
            if (this.layerDescriptors[i].lyr == layer) {
                this.layerDescriptors.splice(i, 1);
                this.refreshList();
                break;
            }
        }
    }
    /**
     * @param map
     */
    init(map) {
        map.getLayers().on('add', (e) => this.layerAdded(e));
        map.getLayers().on('remove', (e) => {
            this.removeLayerFromLegends(e.element);
        });
        this.buildLegendsForLayers(map);
    }
    buildLegendsForLayers(map) {
        map.getLayers().forEach((lyr) => {
            this.layerAdded({
                element: lyr,
            });
        });
    }
    /**
     * (PRIVATE) Callback function for adding layer to map, add layers legend
     * @param e - Event object, should have element property
     */
    layerAdded(e) {
        const que = this.hsQueuesService.ensureQueue('addLayerToLegends', 3);
        que.push((cb) => __awaiter(this, void 0, void 0, function* () {
            this.addLayerToLegends(e.element);
            cb(null);
        }));
    }
    /**
     * @param e - event description
     */
    layerVisibilityChanged(e) {
        const descriptor = this.findLayerDescriptor(e.target);
        if (descriptor) {
            descriptor.visible = e.target.getVisible();
        }
    }
    /**
     * @param e - event description
     */
    layerSourcePropChanged(e) {
        const descriptor = this.findLayerDescriptorBySource(e.target);
        if (descriptor) {
            const newDescriptor = this.hsLegendService.getLayerLegendDescriptor(descriptor.lyr);
            if (newDescriptor.subLayerLegends != descriptor.subLayerLegends ||
                newDescriptor.title != descriptor.title) {
                this.layerDescriptors[this.layerDescriptors.indexOf(descriptor)] =
                    newDescriptor;
            }
        }
    }
    /**
     * Finds layer descriptor for OpenLayers layer
     * @param layer - OpenLayers layer
     * @returns Object describing the legend
     */
    findLayerDescriptor(layer) {
        return this.layerDescriptors.find((ld) => ld.lyr == layer);
    }
    /**
     * @param source -
     */
    findLayerDescriptorBySource(source) {
        const found = this.layerDescriptors.filter((ld) => ld.lyr.getSource() == source);
        if (found.length > 0) {
            return found[0];
        }
    }
    refreshList() {
        this.layerDescriptors = Array.from(this.layerDescriptors);
    }
}
HsLegendComponent.ɵfac = function HsLegendComponent_Factory(t) { return new (t || HsLegendComponent)(ɵngcc0.ɵɵdirectiveInject(HsLegendService), ɵngcc0.ɵɵdirectiveInject(HsMapService), ɵngcc0.ɵɵdirectiveInject(HsLayerUtilsService), ɵngcc0.ɵɵdirectiveInject(HsUtilsService), ɵngcc0.ɵɵdirectiveInject(HsQueuesService), ɵngcc0.ɵɵdirectiveInject(HsLayoutService), ɵngcc0.ɵɵdirectiveInject(HsLanguageService), ɵngcc0.ɵɵdirectiveInject(HsSidebarService)); };
HsLegendComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsLegendComponent, selectors: [["hs-legend"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 16, vars: 16, consts: [[1, "card", "hs-main-panel", 3, "hidden"], ["name", "legend", 3, "title"], [1, "card-body"], ["type", "text", 1, "form-control", "hs-filter", 3, "placeholder", "ngModel", "ngModelChange", "input"], [4, "ngIf"], [1, "list-group"], ["class", "list-group-item", 3, "hidden", 4, "ngFor", "ngForOf"], [1, "row", "justify-content-center"], [1, "col", "col-md-2", "d-flex", "justify-content-center"], ["type", "button", 1, "btn", "btn-light", "btn-outline", "ng-scope", 3, "title", "click"], [1, "icon-refresh"], [2, "text-align", "center"], [1, "list-group-item", 3, "hidden"], [3, "layer"]], template: function HsLegendComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "hs-panel-header", 1);
        ɵngcc0.ɵɵpipe(2, "translate");
        ɵngcc0.ɵɵelementStart(3, "div", 2);
        ɵngcc0.ɵɵelementStart(4, "p");
        ɵngcc0.ɵɵelementStart(5, "input", 3);
        ɵngcc0.ɵɵlistener("ngModelChange", function HsLegendComponent_Template_input_ngModelChange_5_listener($event) { return ctx.titleSearch = $event; })("input", function HsLegendComponent_Template_input_input_5_listener() { return ctx.refreshList(); });
        ɵngcc0.ɵɵpipe(6, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(7, HsLegendComponent_span_7_Template, 4, 3, "span", 4);
        ɵngcc0.ɵɵelementStart(8, "ul", 5);
        ɵngcc0.ɵɵtemplate(9, HsLegendComponent_li_9_Template, 4, 3, "li", 6);
        ɵngcc0.ɵɵpipe(10, "filter");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "div", 7);
        ɵngcc0.ɵɵelementStart(12, "div", 8);
        ɵngcc0.ɵɵelementStart(13, "button", 9);
        ɵngcc0.ɵɵlistener("click", function HsLegendComponent_Template_button_click_13_listener() { return ctx.rebuildLegends(); });
        ɵngcc0.ɵɵpipe(14, "translate");
        ɵngcc0.ɵɵelement(15, "i", 10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("hidden", !ctx.isVisible());
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(2, 7, "PANEL_HEADER.LEGEND"));
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("placeholder", ɵngcc0.ɵɵpipeBind1(6, 9, "COMMON.filter"))("ngModel", ctx.titleSearch);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.noLayerExists());
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind2(10, 11, ctx.filterDescriptors(), ctx.legendFilter));
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(14, 14, "COMMON.reload"));
    } }, directives: function () { return [HsPanelHeaderComponent, ɵngcc5.DefaultValueAccessor, ɵngcc5.NgControlStatus, ɵngcc5.NgModel, ɵngcc3.NgIf, ɵngcc3.NgForOf, HsLegendLayerComponent]; }, pipes: function () { return [ɵngcc1.TranslatePipe, FilterPipe]; }, encapsulation: 2 });
HsLegendComponent.ctorParameters = () => [
    { type: HsLegendService },
    { type: HsMapService },
    { type: HsLayerUtilsService },
    { type: HsUtilsService },
    { type: HsQueuesService },
    { type: HsLayoutService },
    { type: HsLanguageService },
    { type: HsSidebarService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsLegendComponent, [{
        type: Component,
        args: [{
                selector: 'hs-legend',
                template: "<div class=\"card hs-main-panel\" [hidden]=\"!isVisible()\">\n    <hs-panel-header name=\"legend\" [title]=\"'PANEL_HEADER.LEGEND' | translate\"></hs-panel-header>\n    <div class=\"card-body\">\n        <p><input type=\"text\" class=\"form-control hs-filter\" [placeholder]=\"'COMMON.filter' | translate\"\n                [(ngModel)]=\"titleSearch\" (input)=\"refreshList()\"></p>\n        <span *ngIf=\"noLayerExists()\">\n            <p style=\"text-align: center\">{{'LEGEND.noLegendExists' | translate}}</p>\n        </span>\n        <ul class=\"list-group\">\n            <li *ngFor=\"let layer of filterDescriptors() | filter:legendFilter\" class=\"list-group-item\"\n                [hidden]=\"!hsLegendService.legendValid(layer)\">\n                <div>\n                    {{hsLayerUtilsService.translateTitle(layer.title)}}\n                    <hs-legend-layer-directive [layer]=\"layer\"></hs-legend-layer-directive>\n                </div>\n\n            </li>\n        </ul>\n        <div class=\"row justify-content-center\">\n            <div class=\"col col-md-2 d-flex justify-content-center\">\n                <button type=\"button\" class=\"btn btn-light btn-outline ng-scope\" [title]=\"'COMMON.reload' | translate\"\n                    (click)=\"rebuildLegends()\">\n                    <i class=\"icon-refresh\"></i>\n                </button>\n            </div>\n        </div>\n    </div>\n</div>"
            }]
    }], function () { return [{ type: HsLegendService }, { type: HsMapService }, { type: HsLayerUtilsService }, { type: HsUtilsService }, { type: HsQueuesService }, { type: HsLayoutService }, { type: HsLanguageService }, { type: HsSidebarService }]; }, null); })();

class HsMeasureService {
    constructor(HsMapService, HsUtilsService, HsEventBusService) {
        this.HsMapService = HsMapService;
        this.HsUtilsService = HsUtilsService;
        this.HsEventBusService = HsEventBusService;
        this.data = {
            measurements: [],
            multipleShapeMode: false,
        };
        /**
         * @property {Feature[]} sketches Array of measure sketches
         */
        this.sketches = [];
        this.measureVector = new VectorLayer({
            source: new VectorSource(),
            style: new Style({
                fill: new Fill({
                    color: 'rgba(255, 255, 255, 0.2)',
                }),
                stroke: new Stroke({
                    color: '#ffcc33',
                    width: 2,
                }),
            }),
        });
        setTitle(this.measureVector, 'Measurement sketches');
        HsMapService.loaded().then((m) => {
            this.map = m;
        });
    }
    /**
     * @public
     * @param {boolean?} mode Optional parameter if multiple shape mode should be enabled
     * @description Enable/disable multiple shape mode for measuring (switch without parameter)
     */
    switchMultipleMode(mode) {
        if (mode !== undefined) {
            this.data.multipleShapeMode = mode;
        }
        else {
            this.data.multipleShapeMode = !this.data.multipleShapeMode;
        }
    }
    /**
     * @public
     * @param {string} type Geometry type of measurement ('area' for polygon, 'line' for linestring)
     * @description Change geometry type of measurement without deleting of old ones
     */
    changeMeasureParams(type) {
        this.map.removeInteraction(this.draw);
        this.sketches = [];
        this.addInteraction(type);
    }
    /**
     * @public
     * @description Clear all measurements and restart measuring
     */
    clearMeasurement() {
        this.draw.setActive(false);
        this.data.measurements = [];
        this.measureVector.getSource().clear();
        this.sketches = [];
        this.draw.setActive(true);
    }
    /**
     * @public
     * @param type
     * @description Start measuring interaction in app
     */
    activateMeasuring(type) {
        if (!this.map) {
            setTimeout(() => {
                this.activateMeasuring(type);
            }, 500);
            return;
        }
        this.map.addLayer(this.measureVector);
        this.map.getViewport().addEventListener('mousemove', (evt) => {
            this.mouseMoveHandler(evt);
        });
        this.map.getViewport().addEventListener('touchmove', (evt) => {
            this.mouseMoveHandler(evt);
        });
        this.map.getViewport().addEventListener('touchend', (evt) => {
            this.mouseMoveHandler(evt);
        });
        this.addInteraction(type);
    }
    /**
     * @public
     * @description Stop measuring interaction in app
     */
    deactivateMeasuring() {
        this.HsMapService.loaded().then((map) => {
            map.getViewport().removeEventListener('mousemove', (evt) => {
                this.mouseMoveHandler(evt);
            });
            map.getViewport().removeEventListener('touchmove', (evt) => {
                this.mouseMoveHandler(evt);
            });
            map.getViewport().removeEventListener('touchend', (evt) => {
                this.mouseMoveHandler(evt);
            });
            map.removeInteraction(this.draw);
            map.removeLayer(this.measureVector);
        });
        this.HsEventBusService.measurementEnds.next(); //better emit drawingEnds here
    }
    /**
     * @private
     * @param {object} evt Callback param for mouse move event
     * @description Callback for mouse and touch move event, compute live measurement results
     */
    mouseMoveHandler(evt) {
        if (this.sketches.length > 0) {
            let output;
            for (const sketch of this.sketches) {
                const geom = sketch.getGeometry();
                if (this.HsUtilsService.instOf(geom, Polygon)) {
                    output = this.addMultiple(this.HsUtilsService.formatArea(geom, this.HsMapService.getCurrentProj()), output);
                }
                else if (this.HsUtilsService.instOf(geom, LineString)) {
                    output = this.addMultiple(this.HsUtilsService.formatLength(geom, this.HsMapService.getCurrentProj()), output);
                }
            }
            //output.geom = this.sketch;
            setTimeout(() => {
                this.data.measurements[this.lastMeasurementId] = output;
            }, 0);
        }
    }
    /**
     * @private
     * @param {Measurement} val1 Output of new object
     * @param {Measurement} val2 Old value
     * @returns {Measurement}
     * @description Adds two measure results for multiple shape mode to display joined result
     */
    addMultiple(val1, val2) {
        if (val2 == undefined) {
            return val1;
        }
        let unit = val1.unit;
        const type = val1.type;
        let value;
        if (val1.unit == val2.unit) {
            value = Math.round((val1.size + val2.size) * 100) / 100;
            if (unit == 'm' && type == 'length' && value > 1000) {
                value = Math.round((value / 1000) * 100) / 100;
                unit = 'km';
            }
            else if (unit == 'm' && type == 'area' && value > 10000) {
                value = Math.round((value / 1000000) * 100) / 100;
                unit = 'km';
            }
        }
        else {
            const arr = [val1, val2];
            for (let i = 0; i < arr.length; i++) {
                if (arr[i].unit == 'm') {
                    type == 'length' ? (arr[i].size /= 1000) : (arr[i].size /= 1000000);
                }
            }
            value = Math.round((arr[0].size + arr[1].size) * 100) / 100;
            unit = 'km';
        }
        return {
            size: value,
            type: type,
            unit: unit,
        };
    }
    /**
     * @private
     * @param {string} type Geometry type
     * @description Initialize draw interaction on Ol.map and event handlers for handling start and end of drawing
     */
    addInteraction(type) {
        const drawType = type == 'area' ? 'Polygon' : 'LineString';
        this.draw = new Draw({
            source: this.measureVector.getSource(),
            type: /** @type {GeometryType} */ drawType,
            dragVertexDelay: 150,
        });
        this.map.addInteraction(this.draw);
        this.draw.on('drawstart', (evt) => {
            this.HsEventBusService.measurementStarts.next();
            if (this.data.multipleShapeMode) {
                if (!Array.isArray(this.sketches)) {
                    this.sketches = [];
                    this.data.measurements.push({
                        size: 0,
                        unit: '',
                    });
                }
                this.sketches.push(evt.feature);
            }
            else {
                this.sketches = [evt.feature];
                this.data.measurements.push({
                    size: 0,
                    unit: '',
                });
            }
            this.lastMeasurementId = this.data.measurements.length - 1;
        });
        this.draw.on('drawend', (evt) => {
            this.HsEventBusService.measurementEnds.next();
        });
    }
}
HsMeasureService.ɵfac = function HsMeasureService_Factory(t) { return new (t || HsMeasureService)(ɵngcc0.ɵɵinject(HsMapService), ɵngcc0.ɵɵinject(HsUtilsService), ɵngcc0.ɵɵinject(HsEventBusService)); };
HsMeasureService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HsMeasureService_Factory() { return new HsMeasureService(i0.ɵɵinject(HsMapService), i0.ɵɵinject(HsUtilsService), i0.ɵɵinject(HsEventBusService)); }, token: HsMeasureService, providedIn: "root" });
HsMeasureService.ctorParameters = () => [
    { type: HsMapService },
    { type: HsUtilsService },
    { type: HsEventBusService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsMeasureService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: HsMapService }, { type: HsUtilsService }, { type: HsEventBusService }]; }, null); })();

class HsMeasureComponent extends HsPanelBaseComponent {
    constructor(HsEventBusService, HsLayoutService, HsMeasureService, HsUtilsService, hsLanguageService, hsSidebarService) {
        super(HsLayoutService);
        this.HsEventBusService = HsEventBusService;
        this.HsLayoutService = HsLayoutService;
        this.HsMeasureService = HsMeasureService;
        this.HsUtilsService = HsUtilsService;
        this.name = 'measure';
        this.ngUnsubscribe = new Subject();
        this.data = this.HsMeasureService.data;
        this.type = 'distance';
        hsSidebarService.buttons.push({
            panel: 'measure',
            module: 'hs.measure',
            order: 2,
            fits: true,
            title: () => hsLanguageService.getTranslation('PANEL_HEADER.MEASURE'),
            description: () => hsLanguageService.getTranslation('SIDEBAR.descriptions.MEASURE'),
            icon: 'icon-design',
            condition: true,
        });
        if (this.HsUtilsService.runningInBrowser()) {
            document.addEventListener('keyup', (e) => {
                if (e.key == 'Control') {
                    //ControlLeft
                    setTimeout(() => {
                        this.HsMeasureService.switchMultipleMode();
                    }, 0);
                }
            });
        }
        this.HsEventBusService.measurementStarts
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(() => {
            this.HsLayoutService.panelEnabled('toolbar', false);
        });
        this.HsEventBusService.measurementEnds
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(() => {
            this.HsLayoutService.panelEnabled('toolbar', true);
        });
        this.HsEventBusService.mainPanelChanges
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(() => {
            if (HsLayoutService.mainpanel == 'measure') {
                this.HsMeasureService.activateMeasuring(this.type);
            }
            else {
                this.HsMeasureService.deactivateMeasuring();
            }
        });
        //Temporary fix when measure panel is loaded as default (e.g. reloading page with parameters in link)
        if (this.HsLayoutService.mainpanel == 'measure') {
            this.HsMeasureService.activateMeasuring(this.type);
        }
        //$scope.$emit('scope_loaded', 'Measure');
    }
    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
    changeMeasureParams() {
        if (this.HsLayoutService.mainpanel != 'measure') {
            return;
        }
        this.HsMeasureService.changeMeasureParams(this.type);
    }
    /**
     * Reset sketch and all measurements to start new drawing
     */
    clearAll() {
        this.HsMeasureService.clearMeasurement();
    }
}
HsMeasureComponent.ɵfac = function HsMeasureComponent_Factory(t) { return new (t || HsMeasureComponent)(ɵngcc0.ɵɵdirectiveInject(HsEventBusService), ɵngcc0.ɵɵdirectiveInject(HsLayoutService), ɵngcc0.ɵɵdirectiveInject(HsMeasureService), ɵngcc0.ɵɵdirectiveInject(HsUtilsService), ɵngcc0.ɵɵdirectiveInject(HsLanguageService), ɵngcc0.ɵɵdirectiveInject(HsSidebarService)); };
HsMeasureComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsMeasureComponent, selectors: [["hs-measure"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 23, vars: 26, consts: [[1, "card", "hs-main-panel", 3, "hidden"], ["name", "measure", 3, "title"], [3, "hidden"], [1, "card-body", "p-2"], [1, "btn-group", "btn-group-toggle", 2, "margin-bottom", "10px"], ["for", "hs-measure-distance", 1, "btn", "btn-secondary", 3, "ngClass"], ["type", "radio", "name", "type", "id", "hs-measure-distance", "value", "distance", 3, "ngModel", "ngModelChange"], ["for", "hs-measure-area", 1, "btn", "btn-secondary", 3, "ngClass"], ["type", "radio", "name", "type", "id", "hs-measure-area", "value", "area", 3, "ngModel", "ngModelChange"], [1, "btn", "btn-secondary", 2, "float", "right", 3, "click"], [1, "list-group"], ["class", "list-group-item", 4, "ngFor", "ngForOf"], [1, "list-group-item"], [4, "ngIf"]], template: function HsMeasureComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "hs-panel-header", 1);
        ɵngcc0.ɵɵpipe(2, "translate");
        ɵngcc0.ɵɵelementStart(3, "extra-title");
        ɵngcc0.ɵɵtext(4, "\u00A0");
        ɵngcc0.ɵɵelementStart(5, "span", 2);
        ɵngcc0.ɵɵtext(6);
        ɵngcc0.ɵɵpipe(7, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "div", 3);
        ɵngcc0.ɵɵelementStart(9, "div", 4);
        ɵngcc0.ɵɵelementStart(10, "label", 5);
        ɵngcc0.ɵɵtext(11);
        ɵngcc0.ɵɵpipe(12, "translate");
        ɵngcc0.ɵɵelementStart(13, "input", 6);
        ɵngcc0.ɵɵlistener("ngModelChange", function HsMeasureComponent_Template_input_ngModelChange_13_listener($event) { return ctx.type = $event; })("ngModelChange", function HsMeasureComponent_Template_input_ngModelChange_13_listener() { return ctx.changeMeasureParams(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(14, "label", 7);
        ɵngcc0.ɵɵtext(15);
        ɵngcc0.ɵɵpipe(16, "translate");
        ɵngcc0.ɵɵelementStart(17, "input", 8);
        ɵngcc0.ɵɵlistener("ngModelChange", function HsMeasureComponent_Template_input_ngModelChange_17_listener($event) { return ctx.type = $event; })("ngModelChange", function HsMeasureComponent_Template_input_ngModelChange_17_listener() { return ctx.changeMeasureParams(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(18, "button", 9);
        ɵngcc0.ɵɵlistener("click", function HsMeasureComponent_Template_button_click_18_listener() { return ctx.clearAll(); });
        ɵngcc0.ɵɵtext(19);
        ɵngcc0.ɵɵpipe(20, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(21, "ul", 10);
        ɵngcc0.ɵɵtemplate(22, HsMeasureComponent_li_22_Template, 3, 3, "li", 11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("hidden", !ctx.isVisible());
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(2, 12, "PANEL_HEADER.MEASURE"));
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("hidden", !ctx.HsMeasureService.data.multipleShapeMode);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(7, 14, "MEASURE.multipleShapes"));
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(22, _c12, ctx.type === "distance"));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(12, 16, "COMMON.distance"), " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngModel", ctx.type);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(24, _c12, ctx.type === "area"));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(16, 18, "COMMON.area"), " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngModel", ctx.type);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(20, 20, "COMMON.clear"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.data.measurements);
    } }, directives: [HsPanelHeaderComponent, ɵngcc3.NgClass, ɵngcc5.RadioControlValueAccessor, ɵngcc5.DefaultValueAccessor, ɵngcc5.NgControlStatus, ɵngcc5.NgModel, ɵngcc3.NgForOf, ɵngcc3.NgIf], pipes: [ɵngcc1.TranslatePipe], encapsulation: 2 });
HsMeasureComponent.ctorParameters = () => [
    { type: HsEventBusService },
    { type: HsLayoutService },
    { type: HsMeasureService },
    { type: HsUtilsService },
    { type: HsLanguageService },
    { type: HsSidebarService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsMeasureComponent, [{
        type: Component,
        args: [{
                selector: 'hs-measure',
                template: "<div class=\"card hs-main-panel\" [hidden]=\"!isVisible()\">\n  <hs-panel-header name=\"measure\" [title]=\"'PANEL_HEADER.MEASURE' | translate\">\n    <extra-title>&nbsp;<span [hidden]=\"!HsMeasureService.data.multipleShapeMode\">{{'MEASURE.multipleShapes' | translate}}</span></extra-title>\n  </hs-panel-header>\n  <div class=\"card-body p-2\">\n    <div class=\"btn-group btn-group-toggle\" style=\"margin-bottom: 10px\">\n      <label class=\"btn btn-secondary\" [ngClass]=\"{'active': type === 'distance'}\" for=\"hs-measure-distance\">\n        {{'COMMON.distance' | translate}}\n        <input type=\"radio\" name=\"type\" id=\"hs-measure-distance\" value=\"distance\" [(ngModel)]=\"type\" (ngModelChange)=\"changeMeasureParams()\">\n      </label>\n      <label class=\"btn btn-secondary\" [ngClass]=\"{'active': type === 'area'}\" for=\"hs-measure-area\">\n        {{'COMMON.area' | translate}}\n        <input type=\"radio\" name=\"type\" id=\"hs-measure-area\" value=\"area\" [(ngModel)]=\"type\" (ngModelChange)=\"changeMeasureParams()\">\n      </label>\n    </div>\n    <button class=\"btn btn-secondary\" style=\"float:right\" (click)=\"clearAll()\">{{'COMMON.clear' | translate}}</button>\n    <ul class=\"list-group\">\n      <li *ngFor=\"let measurement of data.measurements\" class=\"list-group-item\">\n        {{measurement.size}}&nbsp;{{measurement.unit}}<span *ngIf=\"measurement.type === 'Area'\"><sup>2</sup></span>\n      </li>\n    </ul>\n  </div>\n</div>\n"
            }]
    }], function () { return [{ type: HsEventBusService }, { type: HsLayoutService }, { type: HsMeasureService }, { type: HsUtilsService }, { type: HsLanguageService }, { type: HsSidebarService }]; }, null); })();

class HsMeasureToolbarComponent extends HsToolbarPanelBaseComponent {
    constructor(HsLayoutService) {
        super(HsLayoutService);
        this.HsLayoutService = HsLayoutService;
        this.name = 'measureToolbar';
    }
    isVisible() {
        return (this.HsLayoutService.panelEnabled('measure') &&
            this.HsLayoutService.componentEnabled('measureToolbar'));
    }
    measureButtonClicked() {
        this.HsLayoutService.setMainPanel('measure', true);
    }
}
HsMeasureToolbarComponent.ɵfac = function HsMeasureToolbarComponent_Factory(t) { return new (t || HsMeasureToolbarComponent)(ɵngcc0.ɵɵdirectiveInject(HsLayoutService)); };
HsMeasureToolbarComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsMeasureToolbarComponent, selectors: [["hs-measure-toolbar"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 5, vars: 4, consts: [[1, "nav-item", 3, "hidden"], [1, "btn-group"], [1, "btn", "rounded-0", "hs-toolbar-button", "btn-light", "btn-outline-secondary", 3, "title", "click"], [1, "icon-design"]], template: function HsMeasureToolbarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "button", 2);
        ɵngcc0.ɵɵlistener("click", function HsMeasureToolbarComponent_Template_button_click_2_listener() { return ctx.measureButtonClicked(); });
        ɵngcc0.ɵɵpipe(3, "translate");
        ɵngcc0.ɵɵelement(4, "i", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("hidden", !ctx.isVisible());
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(3, 2, "TOOLBAR.measureLinesAndPolygon"));
    } }, pipes: [ɵngcc1.TranslatePipe], encapsulation: 2 });
HsMeasureToolbarComponent.ctorParameters = () => [
    { type: HsLayoutService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsMeasureToolbarComponent, [{
        type: Component,
        args: [{
                selector: 'hs-measure-toolbar',
                template: "<div class=\"nav-item\" [hidden]=\"!isVisible()\">\n    <div class=\"btn-group\">\n        <button class=\"btn rounded-0 hs-toolbar-button btn-light btn-outline-secondary\" [title]=\"'TOOLBAR.measureLinesAndPolygon' | translate\" (click)=\"measureButtonClicked()\">\n            <i class=\"icon-design\"></i>\n        </button>\n    </div>\n</div>"
            }]
    }], function () { return [{ type: HsLayoutService }]; }, null); })();

class HsPrintService {
    constructor(HsMapService) {
        this.HsMapService = HsMapService;
    }
    /**
     * @public
     * @param {string} title Heading of printed page
     * @description Basic print implementation
     */
    print(title) {
        const canvases = this.HsMapService.getCanvases();
        const composition = document.createElement('canvas');
        composition.width = canvases[0].clientWidth;
        composition.height = canvases[0].clientHeight;
        canvases.forEach((canvas) => {
            if (canvas.clientWidth > 0 && canvas.clientHeight > 0) {
                composition.getContext('2d').drawImage(canvas, 0, 0);
            }
        });
        const img = composition.toDataURL('image/png');
        const win = window.open();
        const html = `<html><head></head><body><h2>${title}</h2><br><img src='${img}'/></body></html>`;
        win.document.write(html);
        setTimeout(() => {
            win.print();
            //win.location.reload();
        }, 250);
    }
}
HsPrintService.ɵfac = function HsPrintService_Factory(t) { return new (t || HsPrintService)(ɵngcc0.ɵɵinject(HsMapService)); };
HsPrintService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HsPrintService_Factory() { return new HsPrintService(i0.ɵɵinject(HsMapService)); }, token: HsPrintService, providedIn: "root" });
HsPrintService.ctorParameters = () => [
    { type: HsMapService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsPrintService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: HsMapService }]; }, null); })();

class HsPrintComponent extends HsPanelBaseComponent {
    constructor(HsPrintService, HsConfig, HsLayoutService, hsLanguageService, hsSidebarService) {
        super(HsLayoutService);
        this.HsPrintService = HsPrintService;
        this.HsConfig = HsConfig;
        this.title = '';
        this.name = 'print';
        hsSidebarService.buttons.push({
            panel: 'print',
            module: 'hs.print',
            order: 10,
            fits: true,
            title: () => hsLanguageService.getTranslation('PANEL_HEADER.PRINT'),
            description: () => hsLanguageService.getTranslation('SIDEBAR.descriptions.PRINT'),
            icon: 'icon-print',
        });
    }
    /**
     * Set title of print
     * @param {string} title Title of printed page
     */
    setTitle(title) {
        this.title = title;
    }
    print() {
        this.HsPrintService.print(this.title);
    }
}
HsPrintComponent.ɵfac = function HsPrintComponent_Factory(t) { return new (t || HsPrintComponent)(ɵngcc0.ɵɵdirectiveInject(HsPrintService), ɵngcc0.ɵɵdirectiveInject(HsConfig), ɵngcc0.ɵɵdirectiveInject(HsLayoutService), ɵngcc0.ɵɵdirectiveInject(HsLanguageService), ɵngcc0.ɵɵdirectiveInject(HsSidebarService)); };
HsPrintComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsPrintComponent, selectors: [["hs-print"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 13, vars: 11, consts: [[1, "card", "hs-main-panel", 3, "hidden"], ["name", "print", 3, "title"], [1, "card-body"], [1, "form-group"], ["for", "print-title", 1, "control-label"], ["type", "text", "id", "print-title", 1, "form-control", 3, "ngModel", "ngModelChange"], ["type", "button", 1, "btn", "btn-primary", 3, "click"]], template: function HsPrintComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "hs-panel-header", 1);
        ɵngcc0.ɵɵpipe(2, "translate");
        ɵngcc0.ɵɵelementStart(3, "div", 2);
        ɵngcc0.ɵɵelementStart(4, "div", 2);
        ɵngcc0.ɵɵelementStart(5, "div", 3);
        ɵngcc0.ɵɵelementStart(6, "label", 4);
        ɵngcc0.ɵɵtext(7);
        ɵngcc0.ɵɵpipe(8, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "input", 5);
        ɵngcc0.ɵɵlistener("ngModelChange", function HsPrintComponent_Template_input_ngModelChange_9_listener($event) { return ctx.title = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "button", 6);
        ɵngcc0.ɵɵlistener("click", function HsPrintComponent_Template_button_click_10_listener() { return ctx.print(); });
        ɵngcc0.ɵɵtext(11);
        ɵngcc0.ɵɵpipe(12, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("hidden", !ctx.isVisible());
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(2, 5, "PANEL_HEADER.PRINT"));
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(8, 7, "COMMON.title"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngModel", ctx.title);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(12, 9, "COMMON.print"));
    } }, directives: [HsPanelHeaderComponent, ɵngcc5.DefaultValueAccessor, ɵngcc5.NgControlStatus, ɵngcc5.NgModel], pipes: [ɵngcc1.TranslatePipe], encapsulation: 2 });
HsPrintComponent.ctorParameters = () => [
    { type: HsPrintService },
    { type: HsConfig },
    { type: HsLayoutService },
    { type: HsLanguageService },
    { type: HsSidebarService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsPrintComponent, [{
        type: Component,
        args: [{
                selector: 'hs-print',
                template: "<div class=\"card hs-main-panel\" [hidden]=\"!isVisible()\">\n    <hs-panel-header name=\"print\" [title]=\"'PANEL_HEADER.PRINT' | translate\"></hs-panel-header>\n    <div class=\"card-body\">\n        <div class=\"card-body\">\n            <div class=\"form-group\">\n                <label for=\"print-title\" class=\"control-label\">{{'COMMON.title' | translate}}</label>\n                <input type=\"text\" class=\"form-control\" id=\"print-title\" [(ngModel)]=\"title\" />\n            </div>\n            <button type=\"button\" class=\"btn btn-primary\" (click)=\"print()\">{{'COMMON.print' | translate}}</button>\n        </div>\n    </div>\n</div>\n"
            }]
    }], function () { return [{ type: HsPrintService }, { type: HsConfig }, { type: HsLayoutService }, { type: HsLanguageService }, { type: HsSidebarService }]; }, null); })();

class HsQueryFeaturePopupComponent {
    constructor(HsQueryBaseService, HsQueryVectorService, HsEventBusService, HsLanguageService, HsLayerUtilsService, //Used in template
    HsDialogContainerService, HsMapService, ElementRef) {
        this.HsQueryBaseService = HsQueryBaseService;
        this.HsQueryVectorService = HsQueryVectorService;
        this.HsEventBusService = HsEventBusService;
        this.HsLanguageService = HsLanguageService;
        this.HsLayerUtilsService = HsLayerUtilsService;
        this.HsDialogContainerService = HsDialogContainerService;
        this.HsMapService = HsMapService;
        this.ElementRef = ElementRef;
        this.getFeatures = getFeatures;
        this.attributesForHover = [];
        this.olMapLoadsSubscription = this.HsEventBusService.olMapLoads.subscribe((map) => {
            map.addOverlay(this.HsQueryBaseService.hoverPopup);
        });
    }
    ngAfterViewInit() {
        this.HsQueryBaseService.hoverPopup = new Overlay({
            element: this.ElementRef.nativeElement,
        });
    }
    ngOnDestroy() {
        this.HsMapService.map.removeOverlay(this.HsQueryBaseService.hoverPopup);
        this.olMapLoadsSubscription.unsubscribe();
    }
    popupVisible() {
        const featuresWithPopup = this.HsQueryBaseService.featuresUnderMouse.filter((f) => {
            const layer = this.HsMapService.getLayerForFeature(f);
            if (!layer) {
                return false;
            }
            return getPopUp(layer) != undefined;
        });
        const featureCount = featuresWithPopup.length;
        if (featureCount > 0) {
            this.HsQueryBaseService.featuresUnderMouse.forEach((feature) => {
                this.attributesForHover =
                    this.HsQueryBaseService.serializeFeatureAttributes(feature);
                if (getFeatures(feature)) {
                    getFeatures(feature).forEach((subfeature) => {
                        const subFeatureObj = {};
                        subFeatureObj.feature = subfeature;
                        subFeatureObj.attributes =
                            this.HsQueryBaseService.serializeFeatureAttributes(subfeature);
                        this.attributesForHover.push(subFeatureObj);
                    });
                }
            });
        }
        return {
            'display': featureCount > 0 ? 'block' : 'none',
        };
    }
    closePopup() {
        this.HsQueryBaseService.featuresUnderMouse = [];
    }
    isClustered(feature) {
        return getFeatures(feature) && getFeatures(feature).length > 0;
    }
    serializeFeatureName(feature) {
        if (getFeatureName(feature)) {
            return getFeatureName(feature);
        }
        if (getFeatureTitle(feature)) {
            return getFeatureTitle(feature);
        }
        if (getFeatureLabel(feature)) {
            return getFeatureLabel(feature);
        }
        if (getFeatures(feature)) {
            return this.HsLanguageService.getTranslation('QUERY.clusterContaining', {
                count: getFeatures(feature).length,
            });
        }
        return this.HsLanguageService.getTranslation('QUERY.untitledFeature');
    }
    removeFeature(feature) {
        return __awaiter(this, void 0, void 0, function* () {
            const dialog = this.HsDialogContainerService.create(HsConfirmDialogComponent, {
                message: this.HsLanguageService.getTranslation('QUERY.reallyDelete'),
                title: this.HsLanguageService.getTranslation('QUERY.confirmDelete'),
            });
            const confirmed = yield dialog.waitResult();
            if (confirmed == 'yes') {
                this.HsQueryVectorService.removeFeature(feature);
                this.HsQueryBaseService.featuresUnderMouse = [];
            }
        });
    }
    //Deprecated
    clearLayer(layer) {
        return __awaiter(this, void 0, void 0, function* () {
            const dialog = this.HsDialogContainerService.create(HsConfirmDialogComponent, {
                message: this.HsLanguageService.getTranslation('QUERY.reallyDeleteAllFeaturesFrom').replace('{0}', getTitle(layer)),
                title: this.HsLanguageService.getTranslation('QUERY.confirmClear'),
            });
            const confirmed = yield dialog.waitResult();
            if (confirmed == 'yes') {
                if (layer.getSource().getSource) {
                    //Clear clustered?
                    layer.getSource().getSource().clear();
                }
                layer.getSource().clear();
                this.HsQueryBaseService.featuresUnderMouse = [];
            }
        });
    }
}
HsQueryFeaturePopupComponent.ɵfac = function HsQueryFeaturePopupComponent_Factory(t) { return new (t || HsQueryFeaturePopupComponent)(ɵngcc0.ɵɵdirectiveInject(HsQueryBaseService), ɵngcc0.ɵɵdirectiveInject(HsQueryVectorService), ɵngcc0.ɵɵdirectiveInject(HsEventBusService), ɵngcc0.ɵɵdirectiveInject(HsLanguageService), ɵngcc0.ɵɵdirectiveInject(HsLayerUtilsService), ɵngcc0.ɵɵdirectiveInject(HsDialogContainerService), ɵngcc0.ɵɵdirectiveInject(HsMapService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
HsQueryFeaturePopupComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsQueryFeaturePopupComponent, selectors: [["hs-query-feature-popup"]], decls: 7, vars: 2, consts: [["featureHeader", ""], ["featureAttribute", ""], [1, "hs-hover-popup", 3, "ngStyle"], [1, "card", 2, "padding", "5px"], ["style", "line-height: 1.2", 4, "ngFor", "ngForOf"], [1, "d-flex", "flex-row", 2, "background-color", "aliceblue"], [1, "p-1", "flex-grow-1"], ["class", "p-1", "data-toggle", "tooltip", 3, "title", "click", 4, "ngIf"], ["data-toggle", "tooltip", 1, "p-1", 3, "title", "click"], [1, "icon-remove-circle", 2, "color", "rgb(228, 99, 99)"], [4, "ngIf"], ["class", "d-flex flex-row", 4, "ngFor", "ngForOf"], [1, "d-flex", "flex-row"], [1, "p-1", 3, "innerHtml"], [2, "line-height", "1.2"], ["data-toggle", "tooltip", 1, "p-1", 3, "hidden", "title", "click"], [1, "icon-remove-circle", 2, "color", "rgb(73, 80, 87)"], [2, "font-size", "small"], [4, "ngFor", "ngForOf"], ["style", "font-size: small; line-height: 1; margin-bottom: 2px; border-bottom: 2px solid rgb(199, 199, 199)", 4, "ngIf", "ngIfElse"], ["nonClusteredPopUp", ""], [2, "font-size", "small", "line-height", "1", "margin-bottom", "2px", "border-bottom", "2px solid rgb(199, 199, 199)"], [1, "d-flex", "flex-column"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "ml-1", "mt-1", 3, "hidden"], ["class", "d-flex flex-column hs-hover-popup-feature", 4, "ngFor", "ngForOf"], [1, "d-flex", "flex-column", "hs-hover-popup-feature"], [1, "hs-hover-popup-feature"]], template: function HsQueryFeaturePopupComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, HsQueryFeaturePopupComponent_ng_template_0_Template, 5, 2, "ng-template", null, 0, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(2, HsQueryFeaturePopupComponent_ng_template_2_Template, 1, 1, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementStart(4, "div", 2);
        ɵngcc0.ɵɵelementStart(5, "div", 3);
        ɵngcc0.ɵɵtemplate(6, HsQueryFeaturePopupComponent_div_6_Template, 8, 6, "div", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngStyle", ctx.popupVisible());
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.HsQueryBaseService.featureLayersUnderMouse);
    } }, directives: [ɵngcc3.NgStyle, ɵngcc3.NgForOf, ɵngcc3.NgIf, ɵngcc3.NgTemplateOutlet], pipes: [ɵngcc1.TranslatePipe], encapsulation: 2 });
HsQueryFeaturePopupComponent.ctorParameters = () => [
    { type: HsQueryBaseService },
    { type: HsQueryVectorService },
    { type: HsEventBusService },
    { type: HsLanguageService },
    { type: HsLayerUtilsService },
    { type: HsDialogContainerService },
    { type: HsMapService },
    { type: ElementRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsQueryFeaturePopupComponent, [{
        type: Component,
        args: [{
                selector: 'hs-query-feature-popup',
                template: "<!-- Feature header template -->\n<ng-template #featureHeader let-feature=\"feature\" let-type=\"type\">\n    <div class=\"d-flex flex-row\" style=\"background-color: aliceblue;\">\n        <div class=\"p-1 flex-grow-1\"><em>{{serializeFeatureName(feature)}}</em></div>\n        <a class=\"p-1\"  *ngIf=\"HsQueryVectorService.isFeatureRemovable(feature) && type\" (click)=\"removeFeature(feature)\" data-toggle=\"tooltip\" [title]=\"'QUERY.featurePopup.' + type | translate\">\n            <i class=\"icon-remove-circle\" style=\"color: rgb(228, 99, 99)\"></i>\n        </a>\n    </div>\n</ng-template>\n\n<!-- Feature attribute row template -->\n<ng-template #featureAttribute let-attributes=\"attributes\">\n    <div *ngIf=\"attributes.length > 0\">\n        <div *ngFor=\"let attribute of attributes\" class=\"d-flex flex-row\">\n            <div class=\"p-1 flex-grow-1\">\n                {{HsLanguageService.getTranslationIgnoreNonExisting(\n                    'FEATURE_TABLE',\n                    attribute.key\n                  )}}\u2003\n            </div>\n            <div class=\"p-1\" [innerHtml]=\"attribute.displayFunction(attribute.value)\"></div>\n        </div>\n    </div>\n</ng-template>\n\n\n<div [ngStyle]=\"popupVisible()\" class=\"hs-hover-popup\">\n    <div class=\"card\" style=\"padding: 5px;\">\n        <div *ngFor=\"let layerDesc of HsQueryBaseService.featureLayersUnderMouse; let i = index\" style=\"line-height: 1.2\">\n            <a class=\"p-1\"  (click)=\"closePopup()\" data-toggle=\"tooltip\" [hidden]=\"i !== 0\"\n                [title]=\"'QUERY.featurePopup.closePopup' | translate\">\n                <i class=\"icon-remove-circle\" style=\"color: rgb(73, 80, 87)\"></i>\n            </a>\n            <strong style=\"font-size: small;\">{{HsLayerUtilsService.translateTitle(layerDesc.title)}}</strong>\n            <br>\n            <div *ngFor=\"let feature of layerDesc.features\">\n                <!-- Layout for clustered layers -->\n                <div *ngIf=\"isClustered(feature); else nonClusteredPopUp\" style=\"font-size: small; line-height: 1; margin-bottom: 2px; border-bottom: 2px solid rgb(199, 199, 199)\">\n                    <div class=\"d-flex flex-column\">\n                        <ng-container *ngTemplateOutlet=\"featureHeader;context:{feature: feature}\"></ng-container>\n                        <div [hidden]=\"!(attributesForHover.length > 0)\" class=\"ml-1 mt-1\">\n                            <div *ngFor=\"let attribute of attributesForHover\" class=\"d-flex flex-column hs-hover-popup-feature\">\n                                <ng-container *ngTemplateOutlet=\"featureHeader;context:{feature: attribute.feature, type: 'removeClusterPart'}\"></ng-container>\n                                <ng-container *ngTemplateOutlet=\"featureAttribute;context:{attributes: attribute.attributes}\"></ng-container>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <!-- Layout for non-clustered layers -->\n                <ng-template #nonClusteredPopUp>\n                    <div  class=\"hs-hover-popup-feature\">\n                        <ng-container *ngTemplateOutlet=\"featureHeader;context:{feature: feature, type: 'removeFeature'}\"></ng-container>\n                        <ng-container *ngTemplateOutlet=\"featureAttribute;context:{attributes: attributesForHover}\"></ng-container>\n                    </div>\n                </ng-template>\n            </div>\n        </div>\n    </div>\n</div>\n"
            }]
    }], function () { return [{ type: HsQueryBaseService }, { type: HsQueryVectorService }, { type: HsEventBusService }, { type: HsLanguageService }, { type: HsLayerUtilsService }, { type: HsDialogContainerService }, { type: HsMapService }, { type: ɵngcc0.ElementRef }]; }, null); })();

class HsQueryWmtsService {
    constructor(HsMapService, HsUtilsService) {
        this.HsMapService = HsMapService;
        this.HsUtilsService = HsUtilsService;
    }
    parseRequestUrl(layer, coordinate) {
        return __awaiter(this, void 0, void 0, function* () {
            const source = layer.getSource();
            coordinate = transform(coordinate, this.HsMapService.getCurrentProj(), source.getProjection());
            const tileGrid = source.getTileGrid();
            const tileCoord = tileGrid.getTileCoordForCoordAndResolution(coordinate, this.HsMapService.map.getView().getResolution());
            const tileExtent = tileGrid.getTileCoordExtent(tileCoord);
            const tileResolution = tileGrid.getResolution(tileCoord[0]);
            const tileMatrix = tileGrid.getMatrixIds()[tileCoord[0]];
            // I.J params (clicked pixel position relative to tile)
            const x = Math.floor((coordinate[0] - tileExtent[0]) / (tileResolution / 1)); //pixelRatio
            const y = Math.floor((tileExtent[3] - coordinate[1]) / (tileResolution / 1)); //pixelRatio
            const urls = source.getUrls()[0];
            const params = {
                LAYER: source.getLayer(),
                service: 'WMTS',
                INFOFORMAT: getInfoFormat(layer),
                REQUEST: 'GetFeatureInfo',
                TileCol: tileCoord[1],
                TileRow: tileCoord[2],
                I: x,
                J: y,
                TILEMATRIXSET: source.getMatrixSet(),
                TileMatrix: tileMatrix,
            };
            const url = [urls, this.HsUtilsService.paramsToURLWoEncode(params)].join('');
            return {
                url: url,
                format: params.INFOFORMAT,
            };
        });
    }
}
HsQueryWmtsService.ɵfac = function HsQueryWmtsService_Factory(t) { return new (t || HsQueryWmtsService)(ɵngcc0.ɵɵinject(HsMapService), ɵngcc0.ɵɵinject(HsUtilsService)); };
HsQueryWmtsService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HsQueryWmtsService_Factory() { return new HsQueryWmtsService(i0.ɵɵinject(HsMapService), i0.ɵɵinject(HsUtilsService)); }, token: HsQueryWmtsService, providedIn: "root" });
HsQueryWmtsService.ctorParameters = () => [
    { type: HsMapService },
    { type: HsUtilsService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsQueryWmtsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: HsMapService }, { type: HsUtilsService }]; }, null); })();

class HsQueryWmsService {
    constructor(HsQueryBaseService, HsMapService, HsConfig, HsLayerUtilsService, HsLanguageService, HsUtilsService, HsEventBusService, HttpClient, HsLogService, HsQueryWmtsService) {
        this.HsQueryBaseService = HsQueryBaseService;
        this.HsMapService = HsMapService;
        this.HsConfig = HsConfig;
        this.HsLayerUtilsService = HsLayerUtilsService;
        this.HsLanguageService = HsLanguageService;
        this.HsUtilsService = HsUtilsService;
        this.HsEventBusService = HsEventBusService;
        this.HttpClient = HttpClient;
        this.HsLogService = HsLogService;
        this.HsQueryWmtsService = HsQueryWmtsService;
        this.infoCounter = 0;
        this.HsQueryBaseService.getFeatureInfoStarted.subscribe((evt) => {
            this.infoCounter = 0;
            this.HsMapService.getLayersArray().forEach((layer) => {
                if (getBase(layer) == true || layer.get('queryable') == false) {
                    return;
                }
                if (getQueryFilter(layer) != undefined) {
                    const filter = getQueryFilter(layer);
                    if (!filter(HsMapService.map, layer, evt.pixel)) {
                        return;
                    }
                }
                this.queryWmsLayer(this.HsUtilsService.instOf(layer, Tile)
                    ? layer
                    : layer, evt.coordinate);
            });
        });
    }
    /**
     * @param updated
     * @param customInfoTemplate
     * @param Base
     * @param group
     */
    updateFeatureList(updated, customInfoTemplate, Base, group) {
        if (updated) {
            if (customInfoTemplate) {
                Base.setData(group, 'customFeatures');
                Base.dataCleared = false;
            }
            else {
                Base.setData(group, 'features');
            }
        }
    }
    request(url, infoFormat, coordinate, layer) {
        return __awaiter(this, void 0, void 0, function* () {
            const req_url = this.HsUtilsService.proxify(url, true);
            const reqHash = this.HsQueryBaseService.currentQuery;
            try {
                const headers = new Headers({ 'Content-Type': 'text' });
                headers.set('Accept', 'text');
                const response = yield this.HttpClient.get(req_url, {
                    headers: new HttpHeaders().set('Content-Type', 'text'),
                    responseType: 'text',
                }).toPromise();
                if (reqHash != this.HsQueryBaseService.currentQuery) {
                    return;
                }
                this.featureInfoReceived(response, infoFormat, url, coordinate, layer);
            }
            catch (exception) {
                if (reqHash != this.HsQueryBaseService.currentQuery) {
                    return;
                }
                this.featureInfoError(coordinate, exception);
            }
        });
    }
    /**
     * Error callback to decrease infoCounter
     * @param exception
     * @param coordinate
     */
    featureInfoError(coordinate, exception) {
        this.infoCounter--;
        this.HsLogService.warn(exception);
        if (this.infoCounter === 0) {
            this.queriesCollected(coordinate);
        }
    }
    /**
     * @description Parse Information from GetFeatureInfo request. If result came in xml format, Infopanel data are updated. If response is in html, popup window is updated and shown.
     * @param {Object} response Response of GetFeatureInfoRequest
     * @param {string} infoFormat Format of GetFeatureInfoResponse
     * @param {string} url Url of request
     * @param {Ol.coordinate object} coordinate Coordinate of request
     * @param layer
     */
    featureInfoReceived(response, infoFormat, url, coordinate, layer) {
        /* Maybe this will work in future OL versions
         * var format = new GML();
         *  console.log(format.readFeatures(response, {}));
         */
        const customInfoTemplate = getCustomInfoTemplate(layer) || false;
        if (infoFormat.includes('xml') || infoFormat.includes('gml')) {
            const oParser = new DOMParser();
            const oDOM = oParser.parseFromString(response, 'application/xml');
            const doc = oDOM.documentElement;
            if (infoFormat.includes('gml') ||
                this.HsUtilsService.instOf(layer.getSource(), WMTS)) {
                this.parseGmlResponse(doc, layer, customInfoTemplate);
            }
            else if (infoFormat == 'text/xml' ||
                infoFormat === 'application/vnd.ogc.wms_xml') {
                if (doc.childNodes[1]['attributes'] != undefined) {
                    const group = {
                        name: 'Feature',
                        attributes: doc.childNodes[1]['attributes'],
                        layer: getTitle(layer) || getName(layer),
                        customInfoTemplate: customInfoTemplate,
                    };
                    if (customInfoTemplate) {
                        this.HsQueryBaseService.setData(group, 'customFeatures');
                        this.HsQueryBaseService.dataCleared = false;
                    }
                    else {
                        this.HsQueryBaseService.setData(group, 'features');
                    }
                }
                else {
                    return;
                }
            }
        }
        if (infoFormat.includes('html')) {
            if (response.length <= 1) {
                return;
            }
            if (getFeatureInfoTarget(layer) == 'info-panel') {
                this.HsQueryBaseService.pushFeatureInfoHtml(response);
            }
            else {
                this.HsQueryBaseService.fillIframeAndResize(response, true);
                if (getPopupClass(layer) != undefined) {
                    this.HsQueryBaseService.popupClassname =
                        'ol-popup ' + getPopupClass(layer);
                }
            }
        }
        if (infoFormat.includes('json')) {
            const resJSON = JSON.parse(response);
            this.HsQueryBaseService.setData(resJSON.features, 'customFeatures');
            console.log('jsonquery');
        }
        this.infoCounter--;
        if (this.infoCounter === 0) {
            this.queriesCollected(coordinate);
        }
    }
    parseGmlResponse(doc, layer, customInfoTemplate) {
        let updated = false;
        let features = doc.querySelectorAll('gml\\:featureMember');
        if (features.length == 0) {
            features = doc.querySelectorAll('featureMember');
        }
        for (const feature of features) {
            const layerName = getTitle(layer) || getName(layer);
            const layers = feature.getElementsByTagName('Layer');
            for (const fioLayer of layers) {
                const featureName = fioLayer.attributes[0].nodeValue;
                const attrs = fioLayer.getElementsByTagName('Attribute');
                const attributes = [];
                for (const attr of attrs) {
                    attributes.push({
                        'name': attr.attributes[0].nodeValue,
                        'value': attr.innerHTML,
                    });
                }
                const group = {
                    layer: layerName,
                    name: featureName,
                    attributes: attributes,
                    customInfoTemplate: customInfoTemplate,
                };
                this.updateFeatureList(updated, customInfoTemplate, this.HsQueryBaseService, group);
            }
            const featureNode = feature.firstChild;
            const group = {
                name: 'Feature',
                layer: this.HsLayerUtilsService.getLayerName(layer),
                attributes: [],
            };
            for (const attribute in featureNode.children) {
                if (featureNode.children[attribute].childElementCount == 0) {
                    group.attributes.push({
                        'name': featureNode.children[attribute].localName,
                        'value': featureNode.children[attribute].innerHTML,
                    });
                    updated = true;
                }
            }
            this.updateFeatureList(updated, customInfoTemplate, this.HsQueryBaseService, group);
        }
        doc.querySelectorAll('msGMLOutput').forEach(($this) => {
            for (const layer_i in $this.children) {
                const layer = $this.children[layer_i];
                let layer_name = '';
                if (layer.children == undefined) {
                    continue;
                }
                for (let feature_i = 0; feature_i < layer.children.length; feature_i++) {
                    const feature = layer.children[feature_i];
                    if (feature.nodeName == 'gml:name') {
                        layer_name = feature.innerHTML;
                    }
                    else {
                        const group = {
                            name: layer_name + ' Feature',
                            attributes: [],
                        };
                        for (const attribute in feature.children) {
                            if (feature.children[attribute].childElementCount == 0) {
                                group.attributes.push({
                                    'name': feature.children[attribute].localName,
                                    'value': feature.children[attribute].innerHTML,
                                });
                                updated = true;
                            }
                        }
                        this.updateFeatureList(updated, customInfoTemplate, this.HsQueryBaseService, group);
                    }
                }
            }
        });
    }
    /**
     * @param coordinate
     */
    queriesCollected(coordinate) {
        const invisiblePopup = this.HsQueryBaseService.getInvisiblePopup();
        if (this.HsQueryBaseService.data.features.length > 0 ||
            invisiblePopup.contentDocument.body.innerHTML.length > 30) {
            this.HsQueryBaseService.getFeatureInfoCollected.next(coordinate);
        }
    }
    /**
     * @description Get FeatureInfo from WMS queryable layer (only if format of response is XML/GML/HTML). Use hs.query.service_getwmsfeatureinfo service for request and parsing response.
     * @param {Ol.Layer} layer Layer to Query
     * @param {Ol.coordinate} coordinate
     */
    queryWmsLayer(layer, coordinate) {
        if (this.isLayerWmsQueryable(layer)) {
            if (this.HsUtilsService.instOf(layer.getSource(), WMTS)) {
                this.HsQueryWmtsService.parseRequestUrl(layer, coordinate).then((res) => {
                    console.log(res);
                    this.infoCounter++;
                    this.request(res.url, res.format, coordinate, layer);
                });
                return;
            }
            const source = layer.getSource();
            const map = this.HsMapService.map;
            const viewResolution = map.getView().getResolution();
            let url = source.getFeatureInfoUrl(coordinate, viewResolution, source.getProjection()
                ? source.getProjection()
                : this.HsMapService.getCurrentProj(), {
                INFO_FORMAT: source.getParams().INFO_FORMAT,
            });
            if (getFeatureInfoLang(layer) &&
                getFeatureInfoLang(layer)[this.HsLanguageService.language]) {
                if (this.HsUtilsService.instOf(source, TileWMS)) {
                    url = url.replace(source.getUrls()[0], getFeatureInfoLang(layer)[this.HsLanguageService.language]);
                }
                else {
                    url = url.replace(source.getUrl(), getFeatureInfoLang(layer)[this.HsLanguageService.language]);
                }
            }
            if (url) {
                this.HsLogService.log(url);
                if (source.getParams().INFO_FORMAT.includes('xml') ||
                    source.getParams().INFO_FORMAT.includes('html') ||
                    source.getParams().INFO_FORMAT.includes('gml') ||
                    source.getParams().INFO_FORMAT.includes('json')) {
                    this.infoCounter++;
                    this.request(url, source.getParams().INFO_FORMAT, coordinate, layer);
                }
            }
        }
    }
    /**
     * @param layer
     */
    isLayerWmsQueryable(layer) {
        if (!layer.getVisible()) {
            return false;
        }
        if (this.HsUtilsService.instOf(layer, Tile)) {
            if (this.HsUtilsService.instOf(layer.getSource(), TileWMS) &&
                layer.getSource().getParams().INFO_FORMAT) {
                return true;
            }
            if (this.HsUtilsService.instOf(layer.getSource(), WMTS) &&
                getInfoFormat(layer)) {
                return true;
            }
        }
        if (this.HsUtilsService.instOf(layer, Image$1) &&
            this.HsUtilsService.instOf(layer.getSource(), ImageWMS) &&
            layer.getSource().getParams().INFO_FORMAT) {
            return true;
        }
        return false;
    }
}
HsQueryWmsService.ɵfac = function HsQueryWmsService_Factory(t) { return new (t || HsQueryWmsService)(ɵngcc0.ɵɵinject(HsQueryBaseService), ɵngcc0.ɵɵinject(HsMapService), ɵngcc0.ɵɵinject(HsConfig), ɵngcc0.ɵɵinject(HsLayerUtilsService), ɵngcc0.ɵɵinject(HsLanguageService), ɵngcc0.ɵɵinject(HsUtilsService), ɵngcc0.ɵɵinject(HsEventBusService), ɵngcc0.ɵɵinject(ɵngcc2.HttpClient), ɵngcc0.ɵɵinject(HsLogService), ɵngcc0.ɵɵinject(HsQueryWmtsService)); };
HsQueryWmsService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HsQueryWmsService_Factory() { return new HsQueryWmsService(i0.ɵɵinject(HsQueryBaseService), i0.ɵɵinject(HsMapService), i0.ɵɵinject(HsConfig), i0.ɵɵinject(HsLayerUtilsService), i0.ɵɵinject(HsLanguageService), i0.ɵɵinject(HsUtilsService), i0.ɵɵinject(HsEventBusService), i0.ɵɵinject(i1$1.HttpClient), i0.ɵɵinject(HsLogService), i0.ɵɵinject(HsQueryWmtsService)); }, token: HsQueryWmsService, providedIn: "root" });
HsQueryWmsService.ctorParameters = () => [
    { type: HsQueryBaseService },
    { type: HsMapService },
    { type: HsConfig },
    { type: HsLayerUtilsService },
    { type: HsLanguageService },
    { type: HsUtilsService },
    { type: HsEventBusService },
    { type: HttpClient },
    { type: HsLogService },
    { type: HsQueryWmtsService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsQueryWmsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: HsQueryBaseService }, { type: HsMapService }, { type: HsConfig }, { type: HsLayerUtilsService }, { type: HsLanguageService }, { type: HsUtilsService }, { type: HsEventBusService }, { type: ɵngcc2.HttpClient }, { type: HsLogService }, { type: HsQueryWmtsService }]; }, null); })();

//TODO: Check if this import is still needed. Breaks production though
class HsQueryComponent extends HsPanelBaseComponent {
    constructor(HsConfig, HsQueryBaseService, HsLayoutService, HsMapService, HsEventBusService, HsQueryVectorService, HsQueryWmsService, HsDrawService, HsDialogContainerService, hsSidebarService, hsLanguageService) {
        super(HsLayoutService);
        this.HsConfig = HsConfig;
        this.HsQueryBaseService = HsQueryBaseService;
        this.HsLayoutService = HsLayoutService;
        this.HsMapService = HsMapService;
        this.HsEventBusService = HsEventBusService;
        this.HsQueryVectorService = HsQueryVectorService;
        this.HsQueryWmsService = HsQueryWmsService;
        this.HsDrawService = HsDrawService;
        this.HsDialogContainerService = HsDialogContainerService;
        this.popup = new Popup();
        this.popupOpens = new Subject();
        this.name = 'info';
        this.ngUnsubscribe = new Subject();
        hsSidebarService.buttons.push({
            panel: 'info',
            module: 'hs.query',
            order: 7,
            fits: true,
            title: () => hsLanguageService.getTranslation('PANEL_HEADER.INFO'),
            description: () => hsLanguageService.getTranslation('SIDEBAR.descriptions.INFO'),
            icon: 'icon-info-sign',
        });
        this.HsMapService.loaded().then((map) => {
            map.addOverlay(this.popup);
        });
        this.HsDialogContainerService.create(HsQueryFeaturePopupComponent, {});
        //add current panel queryable - activate/deactivate
        this.HsEventBusService.mainPanelChanges
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((closed) => {
            if (this.HsQueryBaseService.currentPanelQueryable()) {
                if (!this.HsQueryBaseService.queryActive &&
                    !this.HsDrawService.drawActive) {
                    this.HsQueryBaseService.activateQueries();
                }
            }
            else {
                if (this.HsQueryBaseService.queryActive) {
                    this.HsQueryBaseService.deactivateQueries();
                }
            }
        });
        this.HsQueryBaseService.queryStatusChanges
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(() => {
            this.HsQueryBaseService.getFeatureInfoStarted
                .pipe(takeUntil(this.ngUnsubscribe))
                .subscribe((e) => {
                this.popup.hide();
                if (this.HsQueryBaseService.currentPanelQueryable() &&
                    this.HsLayoutService.mainpanel != 'draw') {
                    this.HsLayoutService.setMainPanel('info');
                }
            });
            this.HsQueryBaseService.getFeatureInfoCollected
                .pipe(takeUntil(this.ngUnsubscribe))
                .subscribe((coordinate) => {
                const invisiblePopup = this.HsQueryBaseService.getInvisiblePopup();
                if (!invisiblePopup) {
                    return;
                }
                const bodyElementsFound = this.checkForBodyElements(invisiblePopup.contentDocument.body.children);
                if (bodyElementsFound) {
                    //TODO: don't count style, title, meta towards length
                    if (this.HsQueryBaseService.popupClassname.length > 0) {
                        this.popup.getElement().className =
                            this.HsQueryBaseService.popupClassname;
                    }
                    else {
                        this.popup.getElement().className = 'ol-popup';
                    }
                    this.popup.show(coordinate, invisiblePopup.contentDocument.body.innerHTML);
                    this.popupOpens.next('hs.query');
                }
            });
        });
        this.popupOpens.pipe(takeUntil(this.ngUnsubscribe)).subscribe((source) => {
            if (source && source != 'hs.query' && this.popup !== undefined) {
                this.popup.hide();
            }
        });
        this.HsQueryVectorService.featureRemovals
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((feature) => {
            this.HsQueryBaseService.data.features.splice(this.HsQueryBaseService.data.features.indexOf(feature), 1);
        });
    }
    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
    checkForBodyElements(docChildren) {
        return Array.from(docChildren).some((ch) => {
            if (ch.tagName == 'TITLE' && ch.title == '') {
                return false;
            }
            return (ch.tagName != 'SERVICEEXCEPTIONREPORT' &&
                ch.tagName != 'META' &&
                ch.tagName != 'STYLE');
        });
    }
    noFeatureSelected() {
        return (this.HsQueryBaseService.data.features.length == 0 &&
            (this.HsQueryBaseService.data.coordinates === undefined ||
                this.HsQueryBaseService.data.coordinates.length == 0));
    }
    showQueryDialog(ev) {
        //TODO Rewrite this to new material design
        /* this.$mdDialog
          .show({
            scope: this,
            preserveScope: true,
            templateUrl: './partials/infopanel.html',
            parent: document.body,
            targetEvent: ev,
            clickOutsideToClose: true,
          })
          .then(
            () => {
              console.log('Closed.');
            },
            () => {
              console.log('Cancelled.');
            }
          ); */
    }
    cancelQueryDialog() {
        //this.$mdDialog.cancel();
    }
    showNoImagesWarning() {
        /*this.$mdToast.show(
          this.$mdToast.simple().textContent('No images matched the query.')
          // .position(pinTo )
          // .hideDelay(3000)
        );*/
    }
}
HsQueryComponent.ɵfac = function HsQueryComponent_Factory(t) { return new (t || HsQueryComponent)(ɵngcc0.ɵɵdirectiveInject(HsConfig), ɵngcc0.ɵɵdirectiveInject(HsQueryBaseService), ɵngcc0.ɵɵdirectiveInject(HsLayoutService), ɵngcc0.ɵɵdirectiveInject(HsMapService), ɵngcc0.ɵɵdirectiveInject(HsEventBusService), ɵngcc0.ɵɵdirectiveInject(HsQueryVectorService), ɵngcc0.ɵɵdirectiveInject(HsQueryWmsService), ɵngcc0.ɵɵdirectiveInject(HsDrawService), ɵngcc0.ɵɵdirectiveInject(HsDialogContainerService), ɵngcc0.ɵɵdirectiveInject(HsSidebarService), ɵngcc0.ɵɵdirectiveInject(HsLanguageService)); };
HsQueryComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsQueryComponent, selectors: [["hs-query"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 6, vars: 8, consts: [["name", "info", 3, "title", "hidden"], ["class", "card hs-main-panel", 3, "hidden", 4, "ngIf"], [3, "hidden", 4, "ngIf"], [3, "hidden"], ["class", "container-fluid", 3, "hidden", 4, "ngIf"], [1, "card", "hs-main-panel", 3, "hidden"], [1, "d-flex", "flex-column", "align-items-center", "p-4"], [1, "icon-cursor", "bg-primary", "p-3", "text-white", "rounded", 2, "font-size", "x-large", "color", "hsl(208, 100%, 97%)"], [1, "h4"], [1, "small"], [1, "container-fluid", 3, "hidden"], [1, "row"], [1, "col-12", "m-2"], [1, "input-group", "m-1"], [1, "input-group-prepend"], ["class", "form-control", 3, "ngModel", "ngModelOptions", "ngModelChange", 4, "ngIf"], ["readonly", "", 1, "form-control", 3, "value"], [1, "form-control", 3, "ngModel", "ngModelOptions", "ngModelChange"], [3, "ngValue", 4, "ngFor", "ngForOf"], [3, "ngValue"]], template: function HsQueryComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "hs-panel-header", 0);
        ɵngcc0.ɵɵpipe(1, "translate");
        ɵngcc0.ɵɵtemplate(2, HsQueryComponent_div_2_Template, 8, 4, "div", 1);
        ɵngcc0.ɵɵtemplate(3, HsQueryComponent_hs_query_default_info_panel_body_3_Template, 1, 1, "hs-query-default-info-panel-body", 2);
        ɵngcc0.ɵɵelement(4, "hs-custom-info-panel-body", 3);
        ɵngcc0.ɵɵtemplate(5, HsQueryComponent_div_5_Template, 10, 4, "div", 4);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(1, 6, "PANEL_HEADER.INFO"))("hidden", !ctx.isVisible());
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.noFeatureSelected());
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.HsLayoutService.mainpanel === "info");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", !ctx.isVisible());
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.HsQueryBaseService.data.coordinates !== undefined && ctx.HsQueryBaseService.data.coordinates.length > 0);
    } }, directives: function () { return [HsPanelHeaderComponent, ɵngcc3.NgIf, HsQueryDefaultInfoPanelBodyComponent, ɵngcc5.SelectControlValueAccessor, ɵngcc5.NgControlStatus, ɵngcc5.NgModel, ɵngcc3.NgForOf, ɵngcc5.NgSelectOption, ɵngcc5.ɵNgSelectMultipleOption]; }, pipes: function () { return [ɵngcc1.TranslatePipe]; }, encapsulation: 2 });
HsQueryComponent.ctorParameters = () => [
    { type: HsConfig },
    { type: HsQueryBaseService },
    { type: HsLayoutService },
    { type: HsMapService },
    { type: HsEventBusService },
    { type: HsQueryVectorService },
    { type: HsQueryWmsService },
    { type: HsDrawService },
    { type: HsDialogContainerService },
    { type: HsSidebarService },
    { type: HsLanguageService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsQueryComponent, [{
        type: Component,
        args: [{
                selector: 'hs-query',
                template: "<hs-panel-header name=\"info\" [title]=\"'PANEL_HEADER.INFO' | translate\" [hidden]=\"!isVisible()\"></hs-panel-header>\n<div class=\"card hs-main-panel\" *ngIf=\"noFeatureSelected()\" [hidden]=\"!isVisible()\">\n    <div class=\"d-flex flex-column align-items-center p-4\">\n        <i class=\"icon-cursor bg-primary p-3 text-white rounded \" style=\"font-size: x-large; color:hsl(208, 100%, 97%)\"></i>\n        <p class=\"h4\">No features selected</p>\n        <p class=\"small\">{{'QUERY.infoPanel.clickOnMap' | translate}}</p>\n    </div>\n</div>\n<hs-query-default-info-panel-body *ngIf=\"HsLayoutService.mainpanel === 'info'\" [hidden]=\"!isVisible()\"></hs-query-default-info-panel-body>\n<hs-custom-info-panel-body [hidden]=\"!isVisible()\"></hs-custom-info-panel-body>\n<div class=\"container-fluid\" [hidden]=\"!isVisible()\" *ngIf=\"HsQueryBaseService.data.coordinates !== undefined && HsQueryBaseService.data.coordinates.length > 0\">\n    <div class=\"row\">\n        <div class=\"col-12 m-2\"><strong>{{HsQueryBaseService.data.coordinates[0].name}}</strong></div>\n    </div>\n    <div class=\"row\">\n        <div class=\"input-group m-1\">\n            <div class=\"input-group-prepend\">\n                <select class=\"form-control\" [(ngModel)]=\"HsQueryBaseService.data.selectedProj\" [ngModelOptions]=\"{standalone: true}\" *ngIf=\"HsQueryBaseService.data.coordinates.length>0\">\n                    <option *ngFor=\"let projection of HsQueryBaseService.data.coordinates[0].projections\"  [ngValue]=\"projection\">{{projection.name}}</option>\n                </select>\n            </div>\n            <input class=\"form-control\" [value]=\"HsQueryBaseService.data.selectedProj.value\" readonly=\"\">\n        </div>\n    </div>\n</div>\n"
            }]
    }], function () { return [{ type: HsConfig }, { type: HsQueryBaseService }, { type: HsLayoutService }, { type: HsMapService }, { type: HsEventBusService }, { type: HsQueryVectorService }, { type: HsQueryWmsService }, { type: HsDrawService }, { type: HsDialogContainerService }, { type: HsSidebarService }, { type: HsLanguageService }]; }, null); })();

class HsSaveMapDialogComponent {
    constructor(HsDialogContainerService, HsSaveMapManagerService) {
        this.HsDialogContainerService = HsDialogContainerService;
        this.HsSaveMapManagerService = HsSaveMapManagerService;
    }
    close() {
        this.HsDialogContainerService.destroy(this);
    }
}
HsSaveMapDialogComponent.ɵfac = function HsSaveMapDialogComponent_Factory(t) { return new (t || HsSaveMapDialogComponent)(ɵngcc0.ɵɵdirectiveInject(HsDialogContainerService), ɵngcc0.ɵɵdirectiveInject(HsSaveMapManagerService)); };
HsSaveMapDialogComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsSaveMapDialogComponent, selectors: [["hs-save-map-dialog-save"]], decls: 22, vars: 13, consts: [["tabindex", "-1", "role", "dialog", "aria-hidden", "true", 1, "modal", "hs-status-creator-save-dialog", "in"], [1, "modal-dialog"], [1, "modal-content"], [1, "modal-header"], [1, "modal-title"], ["type", "button", "data-dismiss", "modal", 1, "close", 3, "click"], ["aria-hidden", "true"], [1, "sr-only"], [1, "modal-body", 2, "max-height", "600px", "overflow-y", "auto", "text-align", "center", "font-size", "16px"], [4, "ngIf"], ["type", "button", "data-dismiss", "modal", 1, "btn", "btn-secondary", "btn-lg", 3, "click"], ["type", "button", 1, "btn", "btn-secondary", "btn-lg", 3, "click"], ["type", "text", 1, "form-control", "hs-stc-title", 3, "ngModel", "ngModelChange"]], template: function HsSaveMapDialogComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelementStart(4, "h4", 4);
        ɵngcc0.ɵɵtext(5);
        ɵngcc0.ɵɵpipe(6, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "button", 5);
        ɵngcc0.ɵɵlistener("click", function HsSaveMapDialogComponent_Template_button_click_7_listener() { return ctx.close(); });
        ɵngcc0.ɵɵelement(8, "span", 6);
        ɵngcc0.ɵɵelementStart(9, "span", 7);
        ɵngcc0.ɵɵtext(10);
        ɵngcc0.ɵɵpipe(11, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "div", 8);
        ɵngcc0.ɵɵelementStart(13, "div");
        ɵngcc0.ɵɵtext(14);
        ɵngcc0.ɵɵpipe(15, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(16, "div");
        ɵngcc0.ɵɵelementStart(17, "b");
        ɵngcc0.ɵɵtext(18);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(19, HsSaveMapDialogComponent_div_19_Template, 14, 10, "div", 9);
        ɵngcc0.ɵɵtemplate(20, HsSaveMapDialogComponent_div_20_Template, 10, 7, "div", 9);
        ɵngcc0.ɵɵtemplate(21, HsSaveMapDialogComponent_div_21_Template, 8, 5, "div", 9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(6, 7, "SAVECOMPOSITION.dialogSave.saveComposition"), " ");
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(11, 9, "COMMON.close"));
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(15, 11, "SAVECOMPOSITION.dialogSave.areYouAttempting"), " ");
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate(ctx.HsSaveMapManagerService.compoData.title);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !(ctx.HsSaveMapManagerService.statusData == null ? null : ctx.HsSaveMapManagerService.statusData.titleFree) && (ctx.HsSaveMapManagerService.statusData == null ? null : ctx.HsSaveMapManagerService.statusData.hasPermission) && !(ctx.HsSaveMapManagerService.statusData == null ? null : ctx.HsSaveMapManagerService.statusData.changeTitle));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !(ctx.HsSaveMapManagerService.statusData == null ? null : ctx.HsSaveMapManagerService.statusData.titleFree) && (ctx.HsSaveMapManagerService.statusData == null ? null : ctx.HsSaveMapManagerService.statusData.hasPermission) && (ctx.HsSaveMapManagerService.statusData == null ? null : ctx.HsSaveMapManagerService.statusData.changeTitle));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !(ctx.HsSaveMapManagerService.statusData == null ? null : ctx.HsSaveMapManagerService.statusData.titleFree) || !(ctx.HsSaveMapManagerService.statusData == null ? null : ctx.HsSaveMapManagerService.statusData.hasPermission));
    } }, directives: [ɵngcc3.NgIf, ɵngcc5.DefaultValueAccessor, ɵngcc5.NgControlStatus, ɵngcc5.NgModel], pipes: [ɵngcc1.TranslatePipe], encapsulation: 2 });
HsSaveMapDialogComponent.ctorParameters = () => [
    { type: HsDialogContainerService },
    { type: HsSaveMapManagerService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsSaveMapDialogComponent, [{
        type: Component,
        args: [{
                selector: 'hs-save-map-dialog-save',
                template: "<div class=\"modal hs-status-creator-save-dialog in\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <h4 class=\"modal-title\">\n                    {{'SAVECOMPOSITION.dialogSave.saveComposition' | translate}}\n                </h4>\n                <button type=\"button\" (click)=\"close()\" class=\"close\" data-dismiss=\"modal\"><span\n                        aria-hidden=\"true\"></span><span class=\"sr-only\">{{'COMMON.close' | translate}}</span></button>\n            </div>\n            <div class=\"modal-body\" style=\"max-height: 600px; overflow-y: auto; text-align: center; font-size: 16px\">\n                <div>\n                    {{'SAVECOMPOSITION.dialogSave.areYouAttempting' | translate}}\n                </div>\n                <div>\n                    <b>{{HsSaveMapManagerService.compoData.title}}</b>\n                </div>\n                <div *ngIf=\"!HsSaveMapManagerService.statusData?.titleFree && HsSaveMapManagerService.statusData?.hasPermission && !HsSaveMapManagerService.statusData?.changeTitle\">\n                    <div>\n                        {{'SAVECOMPOSITION.dialogSave.wantToOverwrite' | translate}} <b>{{HsSaveMapManagerService.compoData.title}}</b>\n                    </div>\n                    <p>\n                        <button type=\"button\" class=\"btn btn-secondary btn-lg\" data-dismiss=\"modal\"\n                            (click)=\"HsSaveMapManagerService.save(false, data.endpoint); close()\">{{'SAVECOMPOSITION.dialogSave.yesSave' | translate}}</button>\n                    </p>\n                    <p>\n                        <button type=\"button\" class=\"btn btn-secondary btn-lg\"\n                            (click)=\"HsSaveMapManagerService.selectNewTitle()\">{{'SAVECOMPOSITION.dialogSave.noSaveAs' | translate}}</button>\n                    </p>\n                </div>\n\n                <div *ngIf=\"!HsSaveMapManagerService.statusData?.titleFree && HsSaveMapManagerService.statusData?.hasPermission && HsSaveMapManagerService.statusData?.changeTitle\">\n                    <div>{{'SAVECOMPOSITION.dialogSave.selectNewNameForMap' | translate}}</div>\n                    <p>\n                        <input type=\"text\" class=\"form-control hs-stc-title\" [(ngModel)]=\"HsSaveMapManagerService.compoData.title\">\n                    </p>\n                    <p>\n                        <button type=\"button\" class=\"btn btn-secondary btn-lg\" data-dismiss=\"modal\"\n                            (click)=\"HsSaveMapManagerService.save(true, data.endpoint); close()\">{{'COMMON.save' | translate}}</button>\n                    </p>\n                </div>\n\n                <div *ngIf=\"!HsSaveMapManagerService.statusData?.titleFree || !HsSaveMapManagerService.statusData?.hasPermission\">\n                    <div>\n                        <p *ngIf=\"!HsSaveMapManagerService.statusData?.hasPermission\">{{'SAVECOMPOSITION.dialogSave.youDoNotHave' | translate}}\n                        </p>\n                        <p *ngIf=\"!HsSaveMapManagerService.statusData?.titleFree\">{{'SAVECOMPOSITION.dialogSave.useDifferentName' | translate}}\n                        </p>\n                    </div>\n                    <p>\n                        <button type=\"button\" class=\"btn btn-secondary btn-lg\" data-dismiss=\"modal\"\n                            (click)=\"HsSaveMapManagerService.focusTitle(); close()\">{{'COMMON.ok' | translate}}</button>\n                    </p>\n                </div>\n\n            </div>\n        </div>\n    </div>\n</div>\n"
            }]
    }], function () { return [{ type: HsDialogContainerService }, { type: HsSaveMapManagerService }]; }, null); })();

class HsSaveMapResultDialogComponent {
    constructor(HsDialogContainerService, HsSaveMapManagerService) {
        this.HsDialogContainerService = HsDialogContainerService;
        this.HsSaveMapManagerService = HsSaveMapManagerService;
    }
    close() {
        this.HsDialogContainerService.destroy(this);
    }
    initiateSave(newSave) {
        this.HsSaveMapManagerService.initiateSave(newSave);
        this.close();
    }
    changeName() {
        this.HsSaveMapManagerService.saveMapResulted.next('rename');
        this.close();
    }
}
HsSaveMapResultDialogComponent.ɵfac = function HsSaveMapResultDialogComponent_Factory(t) { return new (t || HsSaveMapResultDialogComponent)(ɵngcc0.ɵɵdirectiveInject(HsDialogContainerService), ɵngcc0.ɵɵdirectiveInject(HsSaveMapManagerService)); };
HsSaveMapResultDialogComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsSaveMapResultDialogComponent, selectors: [["hs-save-map-dialog-result"]], decls: 36, vars: 34, consts: [["tabindex", "-1", "role", "dialog", "aria-hidden", "true", 1, "modal", "hs-status-creator-result-dialog", "in"], [1, "modal-dialog"], [1, "modal-content"], [1, "modal-header"], [1, "modal-title"], ["type", "button", "data-dismiss", "modal", 1, "close", 3, "click"], ["aria-hidden", "true"], [1, "sr-only"], [1, "modal-body", 2, "max-height", "600px", "overflow-y", "auto"], [1, "alert", "alert-status", 3, "hidden"], [1, "alert", "alert-danger", 3, "hidden"], [4, "ngFor", "ngForOf"], [1, "modal-footer", 3, "ngClass"], [4, "ngIf"], ["type", "button", "data-dismiss", "modal", 1, "btn", "btn-primary", 3, "click"], [3, "value"], ["type", "button", 1, "btn", "btn-primary", 3, "click"], ["type", "button", 1, "btn", "btn-primary", "ml-2", 3, "click"]], template: function HsSaveMapResultDialogComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelementStart(4, "h4", 4);
        ɵngcc0.ɵɵtext(5);
        ɵngcc0.ɵɵpipe(6, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "button", 5);
        ɵngcc0.ɵɵlistener("click", function HsSaveMapResultDialogComponent_Template_button_click_7_listener() { return ctx.close(); });
        ɵngcc0.ɵɵelementStart(8, "span", 6);
        ɵngcc0.ɵɵtext(9, "\u00D7");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "span", 7);
        ɵngcc0.ɵɵtext(11);
        ɵngcc0.ɵɵpipe(12, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(13, "div", 8);
        ɵngcc0.ɵɵelementStart(14, "div", 9);
        ɵngcc0.ɵɵtext(15);
        ɵngcc0.ɵɵpipe(16, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(17, "div", 10);
        ɵngcc0.ɵɵtext(18);
        ɵngcc0.ɵɵpipe(19, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(20, "div", 10);
        ɵngcc0.ɵɵtext(21);
        ɵngcc0.ɵɵpipe(22, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(23, "div", 10);
        ɵngcc0.ɵɵtext(24, " Map already exists ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(25, "div", 10);
        ɵngcc0.ɵɵtext(26);
        ɵngcc0.ɵɵpipe(27, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(28, "div", 10);
        ɵngcc0.ɵɵtemplate(29, HsSaveMapResultDialogComponent_dl_29_Template, 5, 2, "dl", 11);
        ɵngcc0.ɵɵpipe(30, "keyvalue");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(31, "div", 12);
        ɵngcc0.ɵɵtemplate(32, HsSaveMapResultDialogComponent_div_32_Template, 7, 6, "div", 13);
        ɵngcc0.ɵɵelementStart(33, "button", 14);
        ɵngcc0.ɵɵlistener("click", function HsSaveMapResultDialogComponent_Template_button_click_33_listener() { return ctx.close(); });
        ɵngcc0.ɵɵtext(34);
        ɵngcc0.ɵɵpipe(35, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(6, 16, "SAVECOMPOSITION.dialogResult.savingCompositionStatus"), " ");
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(12, 18, "COMMON.close"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("hidden", !ctx.HsSaveMapManagerService.statusData.status);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(16, 20, "SAVECOMPOSITION.dialogResult.compositionSavedSuccessfully"), "");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("hidden", !!ctx.HsSaveMapManagerService.statusData.status);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(19, 22, "SAVECOMPOSITION.dialogResult.compositionFailedToSave"), "");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("hidden", !(!ctx.HsSaveMapManagerService.statusData.status && ctx.HsSaveMapManagerService.statusData.resultCode == "not-saved"));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(22, 24, "SAVECOMPOSITION.dialogResult.requestWasProcessed"), "");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("hidden", !(!ctx.HsSaveMapManagerService.statusData.status && ctx.HsSaveMapManagerService.statusData.resultCode == "exists"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("hidden", !(!ctx.HsSaveMapManagerService.statusData.status && ctx.HsSaveMapManagerService.statusData.resultCode == "error"));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(27, 26, "SAVECOMPOSITION.dialogResult.serverDidNotRespond"), "");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("hidden", !(!ctx.HsSaveMapManagerService.statusData.status && ctx.HsSaveMapManagerService.statusData.resultCode == "error"));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind1(30, 28, ctx.HsSaveMapManagerService.statusData.error));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(32, _c40, ctx.HsSaveMapManagerService.statusData.resultCode == "exists"));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.HsSaveMapManagerService.statusData.status && ctx.HsSaveMapManagerService.statusData.resultCode == "exists");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(35, 30, "COMMON.close"));
    } }, directives: function () { return [ɵngcc3.NgForOf, ɵngcc3.NgClass, ɵngcc3.NgIf, HsUiExtensionsRecursiveDdComponent]; }, pipes: function () { return [ɵngcc1.TranslatePipe, ɵngcc3.KeyValuePipe]; }, encapsulation: 2 });
HsSaveMapResultDialogComponent.ctorParameters = () => [
    { type: HsDialogContainerService },
    { type: HsSaveMapManagerService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsSaveMapResultDialogComponent, [{
        type: Component,
        args: [{
                selector: 'hs-save-map-dialog-result',
                template: "<div class=\"modal hs-status-creator-result-dialog in\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <h4 class=\"modal-title\">\n                    {{'SAVECOMPOSITION.dialogResult.savingCompositionStatus' | translate}}\n                </h4>\n              <button type=\"button\" (click)=\"close()\" class=\"close\" data-dismiss=\"modal\"><span\n                        aria-hidden=\"true\">&times;</span><span\n                        class=\"sr-only\">{{'COMMON.close' | translate}}</span></button>\n            </div>\n            <div class=\"modal-body\" style=\"max-height:600px; overflow-y:auto\">\n                <div class=\"alert alert-status\" [hidden]=\"!HsSaveMapManagerService.statusData.status\">\n                    {{'SAVECOMPOSITION.dialogResult.compositionSavedSuccessfully' | translate}}</div>\n                <div class=\"alert alert-danger\" [hidden]=\"!!HsSaveMapManagerService.statusData.status\">\n                    {{'SAVECOMPOSITION.dialogResult.compositionFailedToSave' | translate}}</div>\n                <div class=\"alert alert-danger\"\n                    [hidden]=\"!(!HsSaveMapManagerService.statusData.status && HsSaveMapManagerService.statusData.resultCode == 'not-saved')\">\n                    {{'SAVECOMPOSITION.dialogResult.requestWasProcessed' | translate}}</div>\n                <div class=\"alert alert-danger\"\n                [hidden]=\"!(!HsSaveMapManagerService.statusData.status && HsSaveMapManagerService.statusData.resultCode == 'exists')\">\n                Map already exists\n\n                </div>\n                <div class=\"alert alert-danger\"\n                    [hidden]=\"!(!HsSaveMapManagerService.statusData.status && HsSaveMapManagerService.statusData.resultCode == 'error')\">\n                    {{'SAVECOMPOSITION.dialogResult.serverDidNotRespond' | translate}}</div>\n                <div class=\"alert alert-danger\"\n                    [hidden]=\"!(!HsSaveMapManagerService.statusData.status && HsSaveMapManagerService.statusData.resultCode == 'error')\">\n                    <dl *ngFor=\"let item of HsSaveMapManagerService.statusData.error | keyvalue\">\n                        <dt>{{item.key}} </dt>\n                        <dd>\n                            <hs-widgets-recursive-dd [value]=\"item.value\"></hs-widgets-recursive-dd>\n                        </dd>\n                    </dl>\n                </div>\n            </div>\n            <div class=\"modal-footer\" [ngClass]=\"{'justify-content-between' : HsSaveMapManagerService.statusData.resultCode == 'exists' }\">\n                <div *ngIf=\"!HsSaveMapManagerService.statusData.status && HsSaveMapManagerService.statusData.resultCode == 'exists'\">\n                    <button type=\"button\" class=\"btn btn-primary\" (click)=\"initiateSave(false)\">{{'SAVECOMPOSITION.form.overwrite' | translate}}</button>\n                    <button type=\"button\" class=\"btn btn-primary ml-2\" (click)=\"changeName()\">{{'SAVECOMPOSITION.form.changeName' | translate}}</button>\n                </div>\n                    <button type=\"button\" class=\"btn btn-primary\" (click)=\"close()\"\n                    data-dismiss=\"modal\">{{'COMMON.close' | translate}}</button>\n            </div>\n        </div>\n    </div>\n</div>\n"
            }]
    }], function () { return [{ type: HsDialogContainerService }, { type: HsSaveMapManagerService }]; }, null); })();

class HsSaveMapDialogSpawnerService {
    constructor(HsDialogContainerService, HsSaveMapManagerService) {
        this.HsDialogContainerService = HsDialogContainerService;
        this.HsSaveMapManagerService = HsSaveMapManagerService;
        this.HsSaveMapManagerService.saveMapResulted.subscribe((statusData) => {
            if (typeof statusData != 'string') {
                this.HsDialogContainerService.create(HsSaveMapResultDialogComponent, {
                    statusData,
                });
            }
        });
        this.HsSaveMapManagerService.preSaveCheckCompleted.subscribe(({ endpoint }) => {
            this.HsDialogContainerService.create(HsSaveMapDialogComponent, {
                endpoint,
            });
        });
    }
}
HsSaveMapDialogSpawnerService.ɵfac = function HsSaveMapDialogSpawnerService_Factory(t) { return new (t || HsSaveMapDialogSpawnerService)(ɵngcc0.ɵɵinject(HsDialogContainerService), ɵngcc0.ɵɵinject(HsSaveMapManagerService)); };
HsSaveMapDialogSpawnerService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HsSaveMapDialogSpawnerService_Factory() { return new HsSaveMapDialogSpawnerService(i0.ɵɵinject(HsDialogContainerService), i0.ɵɵinject(HsSaveMapManagerService)); }, token: HsSaveMapDialogSpawnerService, providedIn: "root" });
HsSaveMapDialogSpawnerService.ctorParameters = () => [
    { type: HsDialogContainerService },
    { type: HsSaveMapManagerService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsSaveMapDialogSpawnerService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: HsDialogContainerService }, { type: HsSaveMapManagerService }]; }, null); })();

class HsSaveMapComponent extends HsPanelBaseComponent {
    constructor(
    //Used in template
    HsConfig, HsSaveMapManagerService, HsLayoutService, HsCommonLaymanService, HsCommonEndpointsService, 
    //Running in background and watching observables
    HsSaveMapDialogSpawnerService, hsLanguageService, hsSidebarService) {
        super(HsLayoutService);
        this.HsConfig = HsConfig;
        this.HsSaveMapManagerService = HsSaveMapManagerService;
        this.HsCommonLaymanService = HsCommonLaymanService;
        this.HsCommonEndpointsService = HsCommonEndpointsService;
        this.HsSaveMapDialogSpawnerService = HsSaveMapDialogSpawnerService;
        this.endpoint = null;
        this.isAuthorized = false;
        this.name = 'saveMap';
        this.ngUnsubscribe = new Subject();
        hsSidebarService.buttons.push({
            panel: 'saveMap',
            module: 'hs.save-map',
            order: 12,
            fits: true,
            title: () => hsLanguageService.getTranslation('PANEL_HEADER.SAVECOMPOSITION'),
            description: () => hsLanguageService.getTranslation('SIDEBAR.descriptions.SAVECOMPOSITION'),
            icon: 'icon-save-floppy',
        });
        this.advancedForm =
            HsConfig.advancedForm == undefined || HsConfig.advancedForm
                ? true
                : false;
        this.HsSaveMapManagerService.panelOpened
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((composition) => {
            if (composition && composition.endpoint) {
                const openedType = composition.endpoint.type;
                const found = this.HsCommonEndpointsService.endpoints.filter((ep) => ep.type == openedType);
                if (found.length > 0) {
                    this.HsSaveMapManagerService.selectEndpoint(found[0]);
                }
            }
        });
        this.HsCommonEndpointsService.endpointsFilled
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((value) => {
            if (value.length > 0 && !this.endpoint) {
                const laymans = value.filter((ep) => ep.type == 'layman');
                if (laymans.length > 0) {
                    this.HsSaveMapManagerService.selectEndpoint(laymans[0]);
                }
                else {
                    this.HsSaveMapManagerService.selectEndpoint(value[0]);
                }
                if (this.endpoint && this.endpoint.type == 'layman') {
                    this.HsCommonLaymanService.detectAuthChange(this.endpoint);
                }
            }
        });
        this.HsSaveMapManagerService.endpointSelected
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((endpoint) => {
            if (endpoint) {
                this.endpoint = endpoint;
                if (endpoint.getCurrentUserIfNeeded) {
                    endpoint.getCurrentUserIfNeeded(endpoint);
                }
            }
        });
        this.HsCommonLaymanService.authChange
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((endpoint) => {
            this.isAuthorized =
                endpoint.user !== 'anonymous' && endpoint.user !== 'browser';
            this.HsSaveMapManagerService.currentUser = endpoint.user;
        });
    }
    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
}
HsSaveMapComponent.ɵfac = function HsSaveMapComponent_Factory(t) { return new (t || HsSaveMapComponent)(ɵngcc0.ɵɵdirectiveInject(HsConfig), ɵngcc0.ɵɵdirectiveInject(HsSaveMapManagerService), ɵngcc0.ɵɵdirectiveInject(HsLayoutService), ɵngcc0.ɵɵdirectiveInject(HsCommonLaymanService), ɵngcc0.ɵɵdirectiveInject(HsCommonEndpointsService), ɵngcc0.ɵɵdirectiveInject(HsSaveMapDialogSpawnerService), ɵngcc0.ɵɵdirectiveInject(HsLanguageService), ɵngcc0.ɵɵdirectiveInject(HsSidebarService)); };
HsSaveMapComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsSaveMapComponent, selectors: [["hs-save-map"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 19, vars: 16, consts: [[1, "card", "panel-default", "hs-main-panel", "mainpanel", "hs-stc-mainpanel", 3, "hidden"], ["name", "saveMap", 3, "title"], [1, "card-body"], [1, "form-group"], [1, "input-group"], [1, "input-group-prepend"], [1, "input-group-text", "control-label"], ["name", "endpoint", 1, "form-control", 3, "ngModel", "ngModelChange", "change"], [3, "ngValue", 4, "ngFor", "ngForOf"], [3, "hidden"], ["translate", "", 1, "alert", "alert-info", "text-gray"], [3, "endpoint", 4, "ngIf"], ["class", "d-block pt-5", 4, "ngIf"], [4, "ngIf"], [3, "ngValue"], [3, "endpoint"], [1, "d-block", "pt-5"]], template: function HsSaveMapComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "hs-panel-header", 1);
        ɵngcc0.ɵɵpipe(2, "translate");
        ɵngcc0.ɵɵelementStart(3, "div", 2);
        ɵngcc0.ɵɵelementStart(4, "div", 3);
        ɵngcc0.ɵɵelementStart(5, "div", 4);
        ɵngcc0.ɵɵelementStart(6, "div", 5);
        ɵngcc0.ɵɵelementStart(7, "span", 6);
        ɵngcc0.ɵɵtext(8);
        ɵngcc0.ɵɵpipe(9, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "select", 7);
        ɵngcc0.ɵɵlistener("ngModelChange", function HsSaveMapComponent_Template_select_ngModelChange_10_listener($event) { return ctx.endpoint = $event; })("change", function HsSaveMapComponent_Template_select_change_10_listener() { return ctx.HsSaveMapManagerService.selectEndpoint(ctx.endpoint); });
        ɵngcc0.ɵɵtemplate(11, HsSaveMapComponent_option_11_Template, 2, 2, "option", 8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "div", 9);
        ɵngcc0.ɵɵelementStart(13, "div", 10);
        ɵngcc0.ɵɵtext(14);
        ɵngcc0.ɵɵpipe(15, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(16, HsSaveMapComponent_hs_layman_current_user_16_Template, 1, 1, "hs-layman-current-user", 11);
        ɵngcc0.ɵɵtemplate(17, HsSaveMapComponent_hs_save_map_advanced_form_17_Template, 1, 0, "hs-save-map-advanced-form", 12);
        ɵngcc0.ɵɵtemplate(18, HsSaveMapComponent_hs_save_map_simple_form_18_Template, 1, 0, "hs-save-map-simple-form", 13);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("hidden", !ctx.isVisible());
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(2, 10, "PANEL_HEADER.SAVECOMPOSITION"));
        ɵngcc0.ɵɵadvance(7);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(9, 12, "COMMON.saveTo"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngModel", ctx.endpoint);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.HsCommonEndpointsService.endpoints);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", (ctx.endpoint == null ? null : ctx.endpoint.type) !== "layman" || ctx.isAuthorized);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(15, 14, "SAVECOMPOSITION.panelMd.youAreNotAuthorized"), " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", (ctx.endpoint == null ? null : ctx.endpoint.type) === "layman");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.advancedForm && (ctx.isAuthorized || (ctx.endpoint == null ? null : ctx.endpoint.type) !== "layman"));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.advancedForm);
    } }, directives: function () { return [HsPanelHeaderComponent, ɵngcc5.SelectControlValueAccessor, ɵngcc5.NgControlStatus, ɵngcc5.NgModel, ɵngcc3.NgForOf, ɵngcc1.TranslateDirective, ɵngcc3.NgIf, ɵngcc5.NgSelectOption, ɵngcc5.ɵNgSelectMultipleOption, HsLaymanCurrentUserComponent, HsSaveMapAdvancedFormComponent, HsSaveMapSimpleFormComponent]; }, pipes: function () { return [ɵngcc1.TranslatePipe]; }, encapsulation: 2 });
HsSaveMapComponent.ctorParameters = () => [
    { type: HsConfig },
    { type: HsSaveMapManagerService },
    { type: HsLayoutService },
    { type: HsCommonLaymanService },
    { type: HsCommonEndpointsService },
    { type: HsSaveMapDialogSpawnerService },
    { type: HsLanguageService },
    { type: HsSidebarService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsSaveMapComponent, [{
        type: Component,
        args: [{
                selector: 'hs-save-map',
                template: "<div class=\"card panel-default hs-main-panel mainpanel hs-stc-mainpanel\" [hidden]=\"!isVisible()\">\n    <hs-panel-header name=\"saveMap\" [title]=\"'PANEL_HEADER.SAVECOMPOSITION' | translate\">\n    </hs-panel-header>\n    <div class=\"card-body\">\n        <div class=\"form-group\">\n            <div class=\"input-group\">\n                <div class=\"input-group-prepend\">\n                    <span class=\"input-group-text control-label\">{{'COMMON.saveTo' | translate}}</span>\n                </div>\n                <select class=\"form-control\" [(ngModel)]=\"endpoint\"\n                    (change)=\"HsSaveMapManagerService.selectEndpoint(endpoint)\" name=\"endpoint\">\n                    <option *ngFor=\"let e of HsCommonEndpointsService.endpoints\" [ngValue]=\"e\">{{e.title}}</option>\n                </select>\n            </div>\n        </div>\n        <div [hidden]=\"endpoint?.type !== 'layman' || isAuthorized\">\n            <div class=\"alert alert-info text-gray\" translate>\n                {{'SAVECOMPOSITION.panelMd.youAreNotAuthorized' | translate}} </div>\n        </div>\n        <hs-layman-current-user *ngIf=\"endpoint?.type === 'layman'\" [endpoint]=\"endpoint\"></hs-layman-current-user>\n        <hs-save-map-advanced-form class=\"d-block pt-5\" *ngIf=\"advancedForm && (isAuthorized || endpoint?.type !== 'layman')\">\n        </hs-save-map-advanced-form>\n        <hs-save-map-simple-form *ngIf=\"!advancedForm\"></hs-save-map-simple-form>\n    </div>\n</div>\n"
            }]
    }], function () { return [{ type: HsConfig }, { type: HsSaveMapManagerService }, { type: HsLayoutService }, { type: HsCommonLaymanService }, { type: HsCommonEndpointsService }, { type: HsSaveMapDialogSpawnerService }, { type: HsLanguageService }, { type: HsSidebarService }]; }, null); })();

class HsSearchService {
    constructor(http, HsUtilsService, HsConfig, HsMapService, HsStylerService, HsEventBusService) {
        this.http = http;
        this.HsUtilsService = HsUtilsService;
        this.HsConfig = HsConfig;
        this.HsMapService = HsMapService;
        this.HsStylerService = HsStylerService;
        this.HsEventBusService = HsEventBusService;
        this.data = {
            providers: {},
        };
        this.formatWKT = new WKT();
        this.canceler = new Subject();
        this.searchResultsLayer = new VectorLayer({
            source: new Vector({}),
            style: this.HsStylerService.pin_white_blue_highlight,
        });
        setTitle(this.searchResultsLayer, 'Search results');
        setShowInLayerManager(this.searchResultsLayer, false);
    }
    /**
     * @public
     * @param {string} query Place name or part of it
     * @description Send geolocation request to Geolocation server (based on app config), pass response to results function
     */
    request(query) {
        let url = null;
        let providers = [];
        if (this.HsConfig.search_provider !== undefined &&
            this.HsConfig.searchProvider === undefined) {
            this.HsConfig.searchProvider = this.HsConfig.search_provider;
        }
        if (this.HsConfig.searchProvider === undefined) {
            providers = ['geonames'];
        }
        else if (typeof this.HsConfig.searchProvider === 'string' ||
            typeof this.HsConfig.searchProvider === 'function') {
            providers = [this.HsConfig.searchProvider];
        }
        else if (typeof this.HsConfig.searchProvider === 'object') {
            providers = this.HsConfig.searchProvider;
        }
        this.cleanResults();
        for (const provider of providers) {
            let providerId = provider;
            if (provider == 'geonames') {
                if (this.HsConfig.geonamesUser !== undefined) {
                    url = `http://api.geonames.org/searchJSON?&name_startsWith=${query}&username=${this.HsConfig.geonamesUser}`;
                }
                else {
                    //Username will have to be set in proxy
                    url = this.HsUtilsService.proxify(`http://api.geonames.org/searchJSON?&name_startsWith=${query}`);
                }
                if (window.location.protocol == 'https:') {
                    url = this.HsUtilsService.proxify(url);
                }
            }
            else if (provider == 'sdi4apps_openapi') {
                url = 'http://portal.sdi4apps.eu/openapi/search?q=' + query;
            }
            else if (typeof provider === 'function') {
                url = provider(query);
                if (provider.name == 'searchProvider') {
                    //Anonymous function?
                    providerId = 'geonames';
                }
                else {
                    providerId = provider.name;
                }
            }
            //url = utils.proxify(url);
            if (this.canceler[providerId] !== undefined) {
                this.canceler[providerId].unsubscribe();
            }
            this.canceler[providerId] = this.http.get(url).subscribe((data) => {
                this.searchResultsReceived(data, providerId);
            }, () => {
                //
            });
        }
    }
    /**
     * @public
     * @param {object} response Response object of Geolocation request
     * @param {string} providerName Name of request provider
     * @description Maintain inner results object and parse response with correct provider parser
     */
    searchResultsReceived(response, providerName) {
        if (this.data.providers[providerName] === undefined) {
            this.data.providers[providerName] = {
                results: [],
                name: providerName,
            };
        }
        const provider = this.data.providers[providerName];
        if (providerName.indexOf('geonames') > -1) {
            this.parseGeonamesResults(response, provider);
        }
        else if (providerName == 'sdi4apps_openapi') {
            this.parseOpenApiResults(response, provider);
        }
        else {
            this.parseGeonamesResults(response, provider);
        }
        this.HsEventBusService.searchResultsReceived.next({
            layer: this.searchResultsLayer,
            providers: this.data.providers,
        });
    }
    /**
     * @public
     * @description Remove results layer from map
     */
    hideResultsLayer() {
        this.HsMapService.map.removeLayer(this.searchResultsLayer);
    }
    /**
     * @public
     * @description Send geolocation request to Geolocation server (based on app config), pass response to results function
     */
    showResultsLayer() {
        this.hideResultsLayer();
        this.HsMapService.map.addLayer(this.searchResultsLayer);
    }
    /**
     * @public
     * @description Clean all search results from results variable and results layer
     */
    cleanResults() {
        if (this.data.providers !== undefined) {
            for (const key of Object.keys(this.data.providers)) {
                const provider = this.data.providers[key];
                if (provider.results !== undefined) {
                    provider.results.length = 0;
                }
            }
            this.searchResultsLayer.getSource().clear();
            this.hideResultsLayer();
        }
    }
    /**
     * @public
     * @param {object} result Entity of selected result
     * @param {number} zoomLevel Zoom level to zoom on
     * @description Move map and zoom on selected search result
     */
    selectResult(result, zoomLevel) {
        const coordinate = this.getResultCoordinate(result);
        this.HsMapService.map.getView().setCenter(coordinate);
        if (zoomLevel === undefined) {
            zoomLevel = 10;
        }
        this.HsMapService.map.getView().setZoom(zoomLevel);
        this.HsEventBusService.searchZoomTo.next({
            coordinate: transform(coordinate, this.HsMapService.getCurrentProj(), 'EPSG:4326'),
            zoom: zoomLevel,
        });
    }
    /**
     * @public
     * @param {object} result Entity of selected result
     * @returns {object} Ol.coordinate of selected result
     * @description Parse coordinate of selected result
     */
    getResultCoordinate(result) {
        const currentProj = this.HsMapService.getCurrentProj();
        if (result.provider_name.indexOf('geonames') > -1 ||
            result.provider_name == 'searchFunctionsearchProvider') {
            return transform([parseFloat(result.lng), parseFloat(result.lat)], 'EPSG:4326', currentProj);
        }
        else if (result.provider_name == 'sdi4apps_openapi') {
            const g_feature = this.formatWKT.readFeature(result.FullGeom.toUpperCase());
            return g_feature
                .getGeometry()
                .transform('EPSG:4326', currentProj)
                .getCoordinates();
        }
    }
    /**
     * @private
     * @param {object} response Result of search request
     * @param {object} provider Which provider sent the search results
     * @description Result parser of results from Geonames service
     */
    parseGeonamesResults(response, provider) {
        provider.results = response.geonames;
        this.generateGeonamesFeatures(provider);
    }
    /**
     * @param provider
     */
    generateGeonamesFeatures(provider) {
        const src = this.searchResultsLayer.getSource();
        for (const result of provider.results) {
            //angular.forEach(provider.results, (result) =>
            result.provider_name = provider.name;
            const feature = new Feature({
                geometry: new Point(this.getResultCoordinate(result)),
                record: result,
            });
            src.addFeature(feature);
            result.feature = feature;
        }
    }
    /**
     * @private
     * @param {object} response Result of search request
     * @param {object} provider Which provider sent the search results
     * @description Result parser of results from OpenApi service
     */
    parseOpenApiResults(response, provider) {
        provider.results = response.data;
        this.generateOpenApiFeatures(provider);
    }
    /**
     * @param provider
     */
    generateOpenApiFeatures(provider) {
        const src = this.searchResultsLayer.getSource();
        for (const result of provider.results) {
            // angular.forEach(provider.results, (result) => {
            result.provider_name = provider.name;
            const feature = new Feature({
                geometry: new Point(this.getResultCoordinate(result)),
                record: result,
            });
            src.addFeature(feature);
            result.feature = feature;
        }
    }
}
HsSearchService.ɵfac = function HsSearchService_Factory(t) { return new (t || HsSearchService)(ɵngcc0.ɵɵinject(ɵngcc2.HttpClient), ɵngcc0.ɵɵinject(HsUtilsService), ɵngcc0.ɵɵinject(HsConfig), ɵngcc0.ɵɵinject(HsMapService), ɵngcc0.ɵɵinject(HsStylerService), ɵngcc0.ɵɵinject(HsEventBusService)); };
HsSearchService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HsSearchService_Factory() { return new HsSearchService(i0.ɵɵinject(i1$1.HttpClient), i0.ɵɵinject(HsUtilsService), i0.ɵɵinject(HsConfig), i0.ɵɵinject(HsMapService), i0.ɵɵinject(HsStylerService), i0.ɵɵinject(HsEventBusService)); }, token: HsSearchService, providedIn: "root" });
HsSearchService.ctorParameters = () => [
    { type: HttpClient },
    { type: HsUtilsService },
    { type: HsConfig },
    { type: HsMapService },
    { type: HsStylerService },
    { type: HsEventBusService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsSearchService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc2.HttpClient }, { type: HsUtilsService }, { type: HsConfig }, { type: HsMapService }, { type: HsStylerService }, { type: HsEventBusService }]; }, null); })();

class HsSearchComponent extends HsPanelBaseComponent {
    constructor(HsSearchService, HsEventBusService, HsShareUrlService, hsLayoutService, hsLanguageService, hsSidebarService) {
        super(hsLayoutService);
        this.HsSearchService = HsSearchService;
        this.HsEventBusService = HsEventBusService;
        this.HsShareUrlService = HsShareUrlService;
        this.replace = false;
        this.clearVisible = false;
        this.name = 'search';
        hsSidebarService.buttons.push({
            panel: 'search',
            module: 'hs.search',
            order: 15,
            fits: true,
            title: () => hsLanguageService.getTranslation('PANEL_HEADER.SEARCH'),
            description: () => hsLanguageService.getTranslation('SIDEBAR.descriptions.SEARCH'),
            icon: 'icon-search',
        });
        this.searchResultsReceivedSubscription =
            this.HsEventBusService.searchResultsReceived.subscribe(() => {
                this.clearVisible = true;
            });
    }
    ngOnDestroy() {
        this.searchResultsReceivedSubscription.unsubscribe();
    }
    ngOnInit() {
        window.innerWidth < 767
            ? (this.searchInputVisible = false)
            : (this.searchInputVisible = true);
    }
}
HsSearchComponent.ɵfac = function HsSearchComponent_Factory(t) { return new (t || HsSearchComponent)(ɵngcc0.ɵɵdirectiveInject(HsSearchService), ɵngcc0.ɵɵdirectiveInject(HsEventBusService), ɵngcc0.ɵɵdirectiveInject(HsShareUrlService), ɵngcc0.ɵɵdirectiveInject(HsLayoutService), ɵngcc0.ɵɵdirectiveInject(HsLanguageService), ɵngcc0.ɵɵdirectiveInject(HsSidebarService)); };
HsSearchComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsSearchComponent, selectors: [["hs-search"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 6, vars: 4, consts: [[3, "hidden"], ["name", "Search", 3, "title"], [1, "input-group", "search-panel", "hs-search-address", "pt-1", "pb-1", "d-flex"]], template: function HsSearchComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "hs-panel-header", 1);
        ɵngcc0.ɵɵpipe(2, "translate");
        ɵngcc0.ɵɵelementStart(3, "div", 2);
        ɵngcc0.ɵɵelement(4, "hs-search-input");
        ɵngcc0.ɵɵelement(5, "hs-search-results");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("hidden", !ctx.isVisible());
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(2, 2, "PANEL_HEADER.SEARCH"));
    } }, directives: function () { return [HsPanelHeaderComponent, HsSearchInputComponent, HsSearchResultsComponent]; }, pipes: function () { return [ɵngcc1.TranslatePipe]; }, encapsulation: 2 });
HsSearchComponent.ctorParameters = () => [
    { type: HsSearchService },
    { type: HsEventBusService },
    { type: HsShareUrlService },
    { type: HsLayoutService },
    { type: HsLanguageService },
    { type: HsSidebarService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsSearchComponent, [{
        type: Component,
        args: [{
                selector: 'hs-search',
                template: "<div [hidden]=\"!isVisible()\">\n    <hs-panel-header name=\"Search\" [title]=\"'PANEL_HEADER.SEARCH' | translate\"></hs-panel-header>\n    <div class=\"input-group search-panel hs-search-address pt-1 pb-1 d-flex\">\n        <hs-search-input></hs-search-input>\n        <hs-search-results></hs-search-results>\n    </div>\n</div>\n"
            }]
    }], function () { return [{ type: HsSearchService }, { type: HsEventBusService }, { type: HsShareUrlService }, { type: HsLayoutService }, { type: HsLanguageService }, { type: HsSidebarService }]; }, null); })();

class HsSearchToolbarComponent extends HsToolbarPanelBaseComponent {
    constructor(HsLayoutService) {
        super(HsLayoutService);
        this.HsLayoutService = HsLayoutService;
        this.name = 'searchToolbar';
    }
}
HsSearchToolbarComponent.ɵfac = function HsSearchToolbarComponent_Factory(t) { return new (t || HsSearchToolbarComponent)(ɵngcc0.ɵɵdirectiveInject(HsLayoutService)); };
HsSearchToolbarComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsSearchToolbarComponent, selectors: [["hs-search-toolbar"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 4, vars: 1, consts: [[1, "nav-item", 3, "hidden"]], template: function HsSearchToolbarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div");
        ɵngcc0.ɵɵelement(2, "hs-search-input");
        ɵngcc0.ɵɵelement(3, "hs-search-results");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("hidden", !ctx.isVisible());
    } }, directives: function () { return [HsSearchInputComponent, HsSearchResultsComponent]; }, encapsulation: 2 });
HsSearchToolbarComponent.ctorParameters = () => [
    { type: HsLayoutService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsSearchToolbarComponent, [{
        type: Component,
        args: [{
                selector: 'hs-search-toolbar',
                template: "<div class=\"nav-item\" [hidden]=\"!isVisible()\">\n    <div>\n        <hs-search-input></hs-search-input>\n        <hs-search-results></hs-search-results>\n    </div>\n</div>"
            }]
    }], function () { return [{ type: HsLayoutService }]; }, null); })();

class HsShareService {
    constructor(HsConfig, HsShareUrlService, HsUtilsService, HsMapService, HsStatusManagerService, HsLayoutService, HsSaveMapService, HsEventBusService, HsLanguageService, HsToastService, HsLogService, HttpClient, rendererFactory) {
        this.HsConfig = HsConfig;
        this.HsShareUrlService = HsShareUrlService;
        this.HsUtilsService = HsUtilsService;
        this.HsMapService = HsMapService;
        this.HsStatusManagerService = HsStatusManagerService;
        this.HsLayoutService = HsLayoutService;
        this.HsSaveMapService = HsSaveMapService;
        this.HsEventBusService = HsEventBusService;
        this.HsLanguageService = HsLanguageService;
        this.HsToastService = HsToastService;
        this.HsLogService = HsLogService;
        this.HttpClient = HttpClient;
        /**
         * @public
         * @description variables which describe sharable link: url, title, abstract etc.
         */
        this.data = {
            pureMapUrl: '',
            permalinkUrl: '',
            shareLink: 'permalink',
            embedCode: '',
            shareUrlValid: false,
            title: '',
            abstract: '',
            shareUrl: '',
        };
        this.renderer = rendererFactory.createRenderer(null, null);
        this.HsEventBusService.mainPanelChanges.subscribe(() => __awaiter(this, void 0, void 0, function* () {
            if (this.HsLayoutService.mainpanel == 'permalink') {
                this.HsShareUrlService.statusSaving = true;
                const status_url = this.HsStatusManagerService.endpointUrl();
                const layers = this.HsMapService.getLayersArray()
                    .filter((l) => getShowInLayerManager(l) == undefined || getShowInLayerManager(l))
                    .sort((a, b) => {
                    return a.getZIndex() - b.getZIndex();
                });
                try {
                    yield this.HttpClient.post(status_url, JSON.stringify({
                        data: this.HsSaveMapService.map2json(this.HsMapService.map, { layers: layers }, {}, {}),
                        permalink: true,
                        id: this.HsShareUrlService.id,
                        project: this.HsConfig.project_name,
                        request: 'save',
                    })).toPromise();
                    this.HsShareUrlService.statusSaving = false;
                    this.HsShareUrlService.permalinkRequestUrl =
                        status_url + '?request=load&id=' + this.HsShareUrlService.id;
                    this.HsShareUrlService.update();
                }
                catch (ex) {
                    this.HsLogService.error('Error saving permalink layers.', ex);
                    throw ex;
                }
            }
        }));
        this.HsShareUrlService.browserUrlUpdated.subscribe(() => __awaiter(this, void 0, void 0, function* () {
            if (this.HsLayoutService.mainpanel == 'permalink' ||
                this.HsLayoutService.mainpanel == 'shareMap') {
                this.data.shareUrlValid = false;
                try {
                    this.data.pureMapUrl = yield this.HsUtilsService.shortUrl(this.HsShareUrlService.getPureMapUrl());
                    this.data.permalinkUrl = yield this.HsUtilsService.shortUrl(this.HsShareUrlService.getPermalinkUrl());
                    this.getEmbedCode();
                }
                catch (ex) {
                    this.HsLogService.log('Error creating short Url', ex);
                    this.data.pureMapUrl = this.HsShareUrlService.getPureMapUrl();
                    this.data.permalinkUrl = this.HsShareUrlService.getPermalinkUrl();
                }
            }
        }));
        this.HsEventBusService.mainPanelChanges.subscribe(() => {
            if (this.HsLayoutService.mainpanel == 'permalink') {
                this.generateThumbnail(this.HsLayoutService.contentWrapper.querySelector('.hs-permalink-thumbnail'), false);
            }
        });
        this.HsEventBusService.olMapLoads.subscribe((map) => {
            map.on('postcompose', this.HsUtilsService.debounce(() => {
                this.generateThumbnail(this.HsLayoutService.contentWrapper.querySelector('.hs-permalink-thumbnail'), false);
            }, 300, false, this));
        });
        this.HsEventBusService.compositionLoads.subscribe((data) => {
            if (data.data) {
                data = data.data;
                this.data.title = data.title;
                if (this.HsConfig.social_hashtag) {
                    this.data.title += ' ' + this.HsConfig.social_hashtag;
                }
                this.data.abstract = data.abstract;
            }
        });
    }
    /**
     * @public
     * @description Get correct Embed code with correct share link type
     * @returns {string} embeddable iframe html code
     */
    getEmbedCode() {
        this.data.embedCode =
            '<iframe src="' +
                this.getShareUrl() +
                '" width="1000" height="700"></iframe>';
        return this.data.embedCode;
    }
    /**
     * @public
     * @returns {string} Share URL
     * @description Get share Url based on app choice
     */
    getShareUrl() {
        let tmp;
        if (this.data.shareLink == 'permalink') {
            tmp = this.data.permalinkUrl;
        }
        else if (this.data.shareLink == 'puremap') {
            tmp = this.data.pureMapUrl;
        }
        return tmp;
    }
    /**
     * @public
     * @returns {string} Encoded share URL
     * @description Get encoded share Url based on app choice
     */
    getShareUrlEncoded() {
        return encodeURIComponent(this.getShareUrl());
    }
    /**
     * @public
     * @description Make current share url invalid for social sharing
     */
    invalidateShareUrl() {
        this.data.shareUrlValid = false;
    }
    /**
     * @public
     * @param {string} provider Social share provider (twitter/facebook)
     * @param {boolean} newShare If new share record on server should be created
     * @description Share map on social network
     */
    shareOnSocial(newShare) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.data.shareUrlValid) {
                if (this.HsShareUrlService.shareId === null || newShare) {
                    this.HsShareUrlService.shareId = this.HsUtilsService.generateUuid();
                }
                try {
                    const endpointUrl = this.HsStatusManagerService.endpointUrl();
                    const headers = new HttpHeaders().set('Content-Type', 'text/plain; charset=utf-8');
                    yield this.HttpClient.post(endpointUrl, JSON.stringify({
                        request: 'socialShare',
                        id: this.HsShareUrlService.shareId,
                        url: encodeURIComponent(this.getShareUrl()),
                        title: this.data.title,
                        description: this.data.abstract,
                        image: this.data.thumbnail,
                    }), { headers, responseType: 'text' }).toPromise();
                    const shortUrl = yield this.HsUtilsService.shortUrl(`${endpointUrl}?request=socialshare&id=${this.HsShareUrlService.shareId}`);
                    const shareUrl = shortUrl;
                    this.openInShareApi(this.data.title, this.data.abstract, shareUrl);
                    this.data.shareUrlValid = true;
                }
                catch (ex) {
                    this.HsLogService.log('Error creating short Url', ex);
                }
            }
            else {
                this.openInShareApi(this.data.title, this.data.abstract, this.getShareUrl());
            }
        });
    }
    openInShareApi(title, abstract, url) {
        navigator
            .share({
            title,
            text: abstract || title,
            url,
        })
            .then((response) => {
            console.log(response);
        })
            .catch((error) => {
            this.HsToastService.createToastPopupMessage(this.HsLanguageService.getTranslation('COMPOSITIONS.errorWhileSharingOnSocialNetwork'), this.HsLanguageService.getTranslationIgnoreNonExisting('ERRORMESSAGES', error), { disableLocalization: true, serviceCalledFrom: 'HsShareService' });
        });
    }
    /**
     * @public
     * @param {object} $element DOM img element where to place the thumbnail
     * @param {boolean} newRender Force synchronous rendering again or use last canvas state
     * @description Generate thumbnail of current map and save it to variable and selected element
     */
    generateThumbnail($element, newRender) {
        this.rendered($element, newRender);
        if (this.HsLayoutService.mainpanel == 'saveMap' ||
            this.HsLayoutService.mainpanel == 'permalink' ||
            this.HsLayoutService.mainpanel == 'shareMap') {
            if ($element === null) {
                return;
            }
            $element.setAttribute('crossOrigin', 'Anonymous');
            if (newRender) {
                this.rendered.bind(this);
                this.HsMapService.map.once('postcompose', () => this.rendered($element, newRender));
                this.HsMapService.map.renderSync();
            }
            else {
                this.rendered($element, newRender);
            }
        }
    }
    /**
     * @param canvas
     * @param width
     * @param height
     */
    setCanvasSize(canvas, width, height) {
        canvas.width = width;
        canvas.height = height;
        canvas.style.width = width + 'px';
        canvas.style.height = height + 'px';
    }
    /**
     * @param ctx
     */
    setupContext(ctx) {
        ctx.mozImageSmoothingEnabled = false;
        ctx.webkitImageSmoothingEnabled = false;
        ctx.msImageSmoothingEnabled = false;
        ctx.imageSmoothingEnabled = false;
    }
    rendered($element, newRender) {
        if (!$element) {
            return;
        }
        const collectorCanvas = this.renderer.createElement('canvas');
        const targetCanvas = this.renderer.createElement('canvas');
        const width = 256, height = 256;
        const firstCanvas = this.HsMapService.mapElement.querySelector('.ol-layer canvas');
        this.setCanvasSize(targetCanvas, width, height);
        this.setCanvasSize(collectorCanvas, firstCanvas.width, firstCanvas.height);
        const ctxCollector = collectorCanvas.getContext('2d');
        const ctxTarget = targetCanvas.getContext('2d');
        this.setupContext(ctxTarget);
        this.setupContext(ctxCollector);
        Array.prototype.forEach.call(this.HsMapService.mapElement.querySelectorAll('.ol-layer canvas'), (canvas) => {
            if (canvas.width > 0) {
                //console.log('canvas loop', this.isCanvasTainted(canvas), canvas);
                /* canvases retrieved from mapElement might be already tainted because they can contain
                 * images (i.e. maps) retrieved from another sources without CORS
                 */
                const opacity = canvas.parentNode.style.opacity;
                ctxCollector.globalAlpha = opacity === '' ? 1 : Number(opacity);
                const transform = canvas.style.transform;
                // Get the transform parameters from the style's transform matrix
                const matrix = transform
                    .match(/^matrix\(([^\(]*)\)$/)[1]
                    .split(',')
                    .map(Number);
                // Apply the transform to the export map context
                CanvasRenderingContext2D.prototype.setTransform.apply(ctxCollector, matrix);
                ctxCollector.drawImage(canvas, 0, 0);
            }
        });
        /* Final render pass */
        ctxTarget.drawImage(collectorCanvas, Math.floor(collectorCanvas.width / 2 - width / 2), Math.floor(collectorCanvas.height / 2 - height / 2), width, height, 0, 0, width, height);
        //console.log('image drawn', this.isCanvasTainted(targetCanvas));
        /**
         * from now on, the targetCanvas is also tainted because another tainted canvas was used
         * to draw inside it
         */
        try {
            /**
             * targetCanvas.toDataURL() fires a SecurityError here
             * see https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image#security_and_tainted_canvases
             */
            $element.setAttribute('src', targetCanvas.toDataURL('image/png'));
            this.data.thumbnail = targetCanvas.toDataURL('image/jpeg', 0.85);
        }
        catch (e) {
            console.log('catched, is tainted?', this.isCanvasTainted(targetCanvas));
            //console.log(targetCanvas);
            this.HsLogService.warn(e);
            $element.setAttribute('src', this.HsUtilsService.getAssetsPath() + 'img/notAvailable.png');
        }
        $element.style.width = width + 'px';
        $element.style.height = height + 'px';
    }
    isCanvasTainted(canvas) {
        try {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const pixel = canvas.getContext('2d').getImageData(0, 0, 1, 1);
            return false;
        }
        catch (err) {
            return err.code === 18;
        }
    }
}
HsShareService.ɵfac = function HsShareService_Factory(t) { return new (t || HsShareService)(ɵngcc0.ɵɵinject(HsConfig), ɵngcc0.ɵɵinject(HsShareUrlService), ɵngcc0.ɵɵinject(HsUtilsService), ɵngcc0.ɵɵinject(HsMapService), ɵngcc0.ɵɵinject(HsStatusManagerService), ɵngcc0.ɵɵinject(HsLayoutService), ɵngcc0.ɵɵinject(HsSaveMapService), ɵngcc0.ɵɵinject(HsEventBusService), ɵngcc0.ɵɵinject(HsLanguageService), ɵngcc0.ɵɵinject(HsToastService), ɵngcc0.ɵɵinject(HsLogService), ɵngcc0.ɵɵinject(ɵngcc2.HttpClient), ɵngcc0.ɵɵinject(ɵngcc0.RendererFactory2)); };
HsShareService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HsShareService_Factory() { return new HsShareService(i0.ɵɵinject(HsConfig), i0.ɵɵinject(HsShareUrlService), i0.ɵɵinject(HsUtilsService), i0.ɵɵinject(HsMapService), i0.ɵɵinject(HsStatusManagerService), i0.ɵɵinject(HsLayoutService), i0.ɵɵinject(HsSaveMapService), i0.ɵɵinject(HsEventBusService), i0.ɵɵinject(HsLanguageService), i0.ɵɵinject(HsToastService), i0.ɵɵinject(HsLogService), i0.ɵɵinject(i1$1.HttpClient), i0.ɵɵinject(i0.RendererFactory2)); }, token: HsShareService, providedIn: "root" });
HsShareService.ctorParameters = () => [
    { type: HsConfig },
    { type: HsShareUrlService },
    { type: HsUtilsService },
    { type: HsMapService },
    { type: HsStatusManagerService },
    { type: HsLayoutService },
    { type: HsSaveMapService },
    { type: HsEventBusService },
    { type: HsLanguageService },
    { type: HsToastService },
    { type: HsLogService },
    { type: HttpClient },
    { type: RendererFactory2 }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsShareService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: HsConfig }, { type: HsShareUrlService }, { type: HsUtilsService }, { type: HsMapService }, { type: HsStatusManagerService }, { type: HsLayoutService }, { type: HsSaveMapService }, { type: HsEventBusService }, { type: HsLanguageService }, { type: HsToastService }, { type: HsLogService }, { type: ɵngcc2.HttpClient }, { type: ɵngcc0.RendererFactory2 }]; }, null); })();

class HsShareComponent extends HsPanelBaseComponent {
    constructor(HsShareService, HsCore, HsLayoutService, hsLanguageService, hsSidebarService) {
        super(HsLayoutService);
        this.HsShareService = HsShareService;
        this.HsCore = HsCore;
        this.new_share = false;
        this.name = 'permalink';
        hsSidebarService.buttons.push({
            panel: 'permalink',
            module: 'hs.permalink',
            order: 11,
            fits: true,
            title: () => hsLanguageService.getTranslation('PANEL_HEADER.PERMALINK'),
            description: () => hsLanguageService.getTranslation('SIDEBAR.descriptions.PERMALINK'),
            icon: 'icon-share-alt',
        });
    }
    /**
     * @returns {string} Iframe tag with src attribute on embed Url and default width and height (1000x700px)
     * @description Create Iframe tag for embedded map
     */
    updateEmbedCode() {
        return this.HsShareService.getEmbedCode();
    }
    /**
     * @returns {string} Right share Url
     * @description Select right share Url based on shareLink property (either Permalink Url or PureMap url)
     */
    getShareUrl() {
        return this.HsShareService.getShareUrl();
    }
    /**
     * @description Set share Url state invalid
     */
    invalidateShareUrl() {
        this.HsShareService.invalidateShareUrl();
    }
    /**
     * @description Create share post on selected social network
     */
    shareOnSocial() {
        this.HsShareService.shareOnSocial(this.new_share);
    }
}
HsShareComponent.ɵfac = function HsShareComponent_Factory(t) { return new (t || HsShareComponent)(ɵngcc0.ɵɵdirectiveInject(HsShareService), ɵngcc0.ɵɵdirectiveInject(HsCoreService), ɵngcc0.ɵɵdirectiveInject(HsLayoutService), ɵngcc0.ɵɵdirectiveInject(HsLanguageService), ɵngcc0.ɵɵdirectiveInject(HsSidebarService)); };
HsShareComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsShareComponent, selectors: [["hs-share"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 88, vars: 78, consts: [[1, "card", "panel-default", "hs-main-panel", 3, "hidden"], ["name", "permalink", 3, "title"], [1, "card-body"], [1, "form-group"], ["for", "pure-map-link", 1, "control-label"], ["target", "_blank", "id", "pure-map-link", 3, "href"], [1, "text-danger"], ["for", "permalink-link", 1, "control-label"], ["target", "_blank", "id", "permalink-link", 2, "overflow-x", "hidden", 3, "href"], ["for", "share-link"], [3, "hidden"], [1, "form-check"], [1, "form-check-label"], ["type", "radio", "name", "share-link", "value", "puremap", 1, "form-check-input", 3, "ngModel", "ngModelChange", "click"], ["type", "radio", "name", "share-link", "value", "permalink", 1, "form-check-input", 3, "ngModel", "ngModelChange", "click"], [1, "form-group", 3, "hidden"], ["for", "permalink-embed", 1, "control-label"], ["id", "permalink-embed", 1, "form-control", 2, "height", "80px", 3, "ngModel", "ngModelOptions", "ngModelChange"], ["for", "hs-prmlnk-title", 1, "control-label"], ["type", "text", "id", "hs-prmlnk-title", 1, "form-control", 3, "placeholder", "ngModel", "ngModelOptions", "change", "ngModelChange"], ["for", "hs-prmlnk-abstract", 1, "control-label"], ["id", "hs-prmlnk-abstract", 1, "form-control", 3, "placeholder", "ngModel", "ngModelOptions", "change", "ngModelChange"], [1, "control-label"], ["type", "checkbox", 3, "ngModel", "ngModelOptions", "ngModelChange"], [1, "ng-scope"], ["role", "group", 1, "btn-group"], [1, "btn", "btn-secondary", 3, "click"], [1, "icon-share-alt"], ["alt", "Thumbnail", "width", "256", "height", "256", 1, "img-thumbnail", "hs-permalink-thumbnail"]], template: function HsShareComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "hs-panel-header", 1);
        ɵngcc0.ɵɵpipe(2, "translate");
        ɵngcc0.ɵɵelementStart(3, "div", 2);
        ɵngcc0.ɵɵelementStart(4, "div", 2);
        ɵngcc0.ɵɵelementStart(5, "div", 3);
        ɵngcc0.ɵɵelementStart(6, "label", 4);
        ɵngcc0.ɵɵtext(7);
        ɵngcc0.ɵɵpipe(8, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "a", 5);
        ɵngcc0.ɵɵtext(10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "p");
        ɵngcc0.ɵɵelementStart(12, "sub", 6);
        ɵngcc0.ɵɵtext(13);
        ɵngcc0.ɵɵpipe(14, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(15, "br");
        ɵngcc0.ɵɵelementStart(16, "div", 3);
        ɵngcc0.ɵɵelementStart(17, "label", 7);
        ɵngcc0.ɵɵtext(18);
        ɵngcc0.ɵɵpipe(19, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(20, "br");
        ɵngcc0.ɵɵelementStart(21, "a", 8);
        ɵngcc0.ɵɵtext(22);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(23, "p");
        ɵngcc0.ɵɵelementStart(24, "sub", 6);
        ɵngcc0.ɵɵtext(25);
        ɵngcc0.ɵɵpipe(26, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(27, "hr");
        ɵngcc0.ɵɵelementStart(28, "fieldset", 3);
        ɵngcc0.ɵɵelementStart(29, "h4", 9);
        ɵngcc0.ɵɵtext(30);
        ɵngcc0.ɵɵpipe(31, "translate");
        ɵngcc0.ɵɵelementStart(32, "span", 10);
        ɵngcc0.ɵɵtext(33);
        ɵngcc0.ɵɵpipe(34, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(35);
        ɵngcc0.ɵɵpipe(36, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(37, "div", 11);
        ɵngcc0.ɵɵelementStart(38, "label", 12);
        ɵngcc0.ɵɵelementStart(39, "input", 13);
        ɵngcc0.ɵɵlistener("ngModelChange", function HsShareComponent_Template_input_ngModelChange_39_listener($event) { return ctx.HsShareService.data.shareLink = $event; })("click", function HsShareComponent_Template_input_click_39_listener() { return ctx.updateEmbedCode(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(40);
        ɵngcc0.ɵɵpipe(41, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(42, "div", 11);
        ɵngcc0.ɵɵelementStart(43, "label", 12);
        ɵngcc0.ɵɵelementStart(44, "input", 14);
        ɵngcc0.ɵɵlistener("ngModelChange", function HsShareComponent_Template_input_ngModelChange_44_listener($event) { return ctx.HsShareService.data.shareLink = $event; })("click", function HsShareComponent_Template_input_click_44_listener() { return ctx.updateEmbedCode(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(45);
        ɵngcc0.ɵɵpipe(46, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(47, "div", 15);
        ɵngcc0.ɵɵelementStart(48, "label", 16);
        ɵngcc0.ɵɵtext(49);
        ɵngcc0.ɵɵpipe(50, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(51, "textarea", 17);
        ɵngcc0.ɵɵlistener("ngModelChange", function HsShareComponent_Template_textarea_ngModelChange_51_listener($event) { return ctx.HsShareService.data.embedCode = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(52, "br");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(53, "hr");
        ɵngcc0.ɵɵelementStart(54, "fieldset");
        ɵngcc0.ɵɵelementStart(55, "h4");
        ɵngcc0.ɵɵtext(56);
        ɵngcc0.ɵɵpipe(57, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(58, "div", 3);
        ɵngcc0.ɵɵelementStart(59, "label", 18);
        ɵngcc0.ɵɵtext(60);
        ɵngcc0.ɵɵpipe(61, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(62, "input", 19);
        ɵngcc0.ɵɵlistener("change", function HsShareComponent_Template_input_change_62_listener() { return ctx.invalidateShareUrl(); })("ngModelChange", function HsShareComponent_Template_input_ngModelChange_62_listener($event) { return ctx.HsShareService.data.title = $event; });
        ɵngcc0.ɵɵpipe(63, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(64, "div", 3);
        ɵngcc0.ɵɵelementStart(65, "label", 20);
        ɵngcc0.ɵɵtext(66);
        ɵngcc0.ɵɵpipe(67, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(68, "textarea", 21);
        ɵngcc0.ɵɵlistener("change", function HsShareComponent_Template_textarea_change_68_listener() { return ctx.invalidateShareUrl(); })("ngModelChange", function HsShareComponent_Template_textarea_ngModelChange_68_listener($event) { return ctx.HsShareService.data.abstract = $event; });
        ɵngcc0.ɵɵpipe(69, "translate");
        ɵngcc0.ɵɵtext(70, "                    ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(71, "div", 3);
        ɵngcc0.ɵɵelementStart(72, "div", 3);
        ɵngcc0.ɵɵelementStart(73, "label", 22);
        ɵngcc0.ɵɵelementStart(74, "input", 23);
        ɵngcc0.ɵɵlistener("ngModelChange", function HsShareComponent_Template_input_ngModelChange_74_listener($event) { return ctx.new_share = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(75, "span", 24);
        ɵngcc0.ɵɵtext(76);
        ɵngcc0.ɵɵpipe(77, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(78, "div", 25);
        ɵngcc0.ɵɵelementStart(79, "button", 26);
        ɵngcc0.ɵɵlistener("click", function HsShareComponent_Template_button_click_79_listener() { return ctx.shareOnSocial(); });
        ɵngcc0.ɵɵelement(80, "i", 27);
        ɵngcc0.ɵɵtext(81);
        ɵngcc0.ɵɵpipe(82, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(83, "div", 3);
        ɵngcc0.ɵɵelementStart(84, "label", 22);
        ɵngcc0.ɵɵtext(85);
        ɵngcc0.ɵɵpipe(86, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(87, "img", 28);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("hidden", !ctx.isVisible());
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(2, 36, "PANEL_HEADER.PERMALINK"));
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(8, 38, "PERMALINK.sharePureMap"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("href", ctx.HsShareService.data.pureMapUrl, ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.HsShareService.data.pureMapUrl);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(14, 40, "PERMALINK.sharesOnlyMap"));
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(19, 42, "PERMALINK.permalink"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("href", ctx.HsShareService.data.permalinkUrl, ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.HsShareService.data.permalinkUrl);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(26, 44, "PERMALINK.sharesMapWith"));
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(31, 46, "PERMALINK.linkFor"), "\u00A0");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("hidden", !ctx.HsCore.embeddedEnabled);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(34, 48, "PERMALINK.embed"), "/");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(36, 50, "PERMALINK.socialShare"), " ");
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngModel", ctx.HsShareService.data.shareLink);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(41, 52, "PERMALINK.pureMap"), " ");
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngModel", ctx.HsShareService.data.shareLink);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(46, 54, "PERMALINK.permalink"), " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("hidden", !ctx.HsCore.embeddedEnabled);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(50, 56, "PERMALINK.embedCode"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngModel", ctx.HsShareService.data.embedCode)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(74, _c2));
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(57, 58, "PERMALINK.shareOnSocialNetwork"));
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(61, 60, "COMMON.name"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("placeholder", ɵngcc0.ɵɵpipeBind1(63, 62, "COMMON.fillInName"))("ngModel", ctx.HsShareService.data.title)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(75, _c2));
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(67, 64, "COMMON.abstract"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("placeholder", ɵngcc0.ɵɵpipeBind1(69, 66, "COMMON.fillInDescriptive"))("ngModel", ctx.HsShareService.data.abstract)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(76, _c2));
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("ngModel", ctx.new_share)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(77, _c2));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(77, 68, "PERMALINK.newShare"));
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(82, 70, "COMMON.share"), " ");
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(86, 72, "COMMON.thumbnail"));
    } }, directives: [HsPanelHeaderComponent, ɵngcc5.RadioControlValueAccessor, ɵngcc5.DefaultValueAccessor, ɵngcc5.NgControlStatus, ɵngcc5.NgModel, ɵngcc5.CheckboxControlValueAccessor], pipes: [ɵngcc1.TranslatePipe], encapsulation: 2 });
HsShareComponent.ctorParameters = () => [
    { type: HsShareService },
    { type: HsCoreService },
    { type: HsLayoutService },
    { type: HsLanguageService },
    { type: HsSidebarService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsShareComponent, [{
        type: Component,
        args: [{
                selector: 'hs-share',
                template: "<div class=\"card panel-default hs-main-panel\" [hidden]=\"!isVisible()\">\n    <hs-panel-header name=\"permalink\" [title]=\"'PANEL_HEADER.PERMALINK' | translate\"></hs-panel-header>\n    <div class=\"card-body\">\n        <div class=\"card-body\">\n\n            <div class=\"form-group\">\n                <label for=\"pure-map-link\" class=\"control-label\">{{'PERMALINK.sharePureMap' | translate}}</label>\n                <a [href]=\"HsShareService.data.pureMapUrl\" target=\"_blank\"\n                    id=\"pure-map-link\">{{HsShareService.data.pureMapUrl}}</a>\n                <p><sub class=\"text-danger\">{{'PERMALINK.sharesOnlyMap' | translate}}</sub></p>\n            </div>\n            <br>\n            <div class=\"form-group\">\n                <label for=\"permalink-link\" class=\"control-label\">{{'PERMALINK.permalink' | translate}}</label><br />\n                <a [href]=\"HsShareService.data.permalinkUrl\" target=\"_blank\"  style=\"overflow-x: hidden;\"\n                    id=\"permalink-link\">{{HsShareService.data.permalinkUrl}}</a>\n                <p><sub class=\"text-danger\">{{'PERMALINK.sharesMapWith' | translate}}</sub></p>\n            </div>\n            <hr>\n\n            <fieldset class=\"form-group\">\n                <h4 for=\"share-link\">{{'PERMALINK.linkFor' | translate}}&nbsp;<span\n                        [hidden]=\"!HsCore.embeddedEnabled\">{{'PERMALINK.embed' | translate}}/</span>{{'PERMALINK.socialShare' | translate}}\n                </h4>\n                <div class=\"form-check\">\n                    <label class=\"form-check-label\">\n                        <input type=\"radio\" class=\"form-check-input\" name=\"share-link\" value=\"puremap\"\n                            [(ngModel)]=\"HsShareService.data.shareLink\" (click)=\"updateEmbedCode()\">\n                        {{'PERMALINK.pureMap' | translate}}\n                    </label>\n                </div>\n                <div class=\"form-check\">\n                    <label class=\"form-check-label\">\n                        <input type=\"radio\" class=\"form-check-input\" name=\"share-link\" value=\"permalink\"\n                            [(ngModel)]=\"HsShareService.data.shareLink\" (click)=\"updateEmbedCode()\">\n                        {{'PERMALINK.permalink' | translate}}\n                    </label>\n                </div>\n            </fieldset>\n            <div class=\"form-group\" [hidden]=\"!HsCore.embeddedEnabled\">\n                <label for=\"permalink-embed\" class=\"control-label\">{{'PERMALINK.embedCode' | translate}}</label>\n                <textarea class=\"form-control\" style=\"height: 80px\" id=\"permalink-embed\"\n                    [(ngModel)]=\"HsShareService.data.embedCode\" [ngModelOptions]=\"{standalone: true}\"></textarea>\n                <br>\n            </div>\n\n            <hr>\n\n            <fieldset>\n                <h4>{{'PERMALINK.shareOnSocialNetwork' | translate}}</h4>\n                <div class=\"form-group\">\n                    <label for=\"hs-prmlnk-title\" class=\"control-label\">{{'COMMON.name' | translate}}</label>\n                    <input type=\"text\" class=\"form-control\" id=\"hs-prmlnk-title\"\n                        [placeholder]=\"'COMMON.fillInName' | translate\" (change)=\"invalidateShareUrl()\"\n                        [(ngModel)]=\"HsShareService.data.title\" [ngModelOptions]=\"{standalone: true}\">\n                </div>\n                <div class=\"form-group\">\n                    <label for=\"hs-prmlnk-abstract\" class=\"control-label\">{{'COMMON.abstract' | translate}}</label>\n\n                    <textarea class=\"form-control\" id=\"hs-prmlnk-abstract\"\n                        [placeholder]=\"'COMMON.fillInDescriptive' | translate\" (change)=\"invalidateShareUrl()\"\n                        [(ngModel)]=\"HsShareService.data.abstract\" [ngModelOptions]=\"{standalone: true}\">                    </textarea>\n                </div>\n\n                <div class=\"form-group\">\n                    <div class=\"form-group\">\n                        <label class=\"control-label\"><input type=\"checkbox\" [(ngModel)]=\"new_share\" [ngModelOptions]=\"{standalone: true}\" /><span\n                                class=\"ng-scope\">{{'PERMALINK.newShare' | translate}}</span></label>\n                    </div>\n                    <div class=\"btn-group\" role=\"group\">\n                        <button class=\"btn btn-secondary\" (click)=\"shareOnSocial()\">\n                            <i class=\"icon-share-alt\"></i> {{'COMMON.share' | translate}}\n                        </button>\n                    </div>\n                </div>\n\n                <div class=\"form-group\">\n                    <label class=\"control-label\">{{'COMMON.thumbnail'   | translate}}</label>\n                    <img class=\"img-thumbnail hs-permalink-thumbnail\" alt=\"Thumbnail\" width=\"256\" height=\"256\">\n                </div>\n            </fieldset>\n        </div>\n    </div>\n</div>\n"
            }]
    }], function () { return [{ type: HsShareService }, { type: HsCoreService }, { type: HsLayoutService }, { type: HsLanguageService }, { type: HsSidebarService }]; }, null); })();

class HsStylerComponent extends HsPanelBaseComponent {
    constructor(hsStylerService, hsLayoutService, hsEventBusService, sanitizer, hsLayerUtilsService, hsUtilsService, hsSaveMapService) {
        super(hsLayoutService);
        this.hsStylerService = hsStylerService;
        this.hsLayoutService = hsLayoutService;
        this.hsEventBusService = hsEventBusService;
        this.sanitizer = sanitizer;
        this.hsLayerUtilsService = hsLayerUtilsService;
        this.hsUtilsService = hsUtilsService;
        this.hsSaveMapService = hsSaveMapService;
        this.ngUnsubscribe = new Subject();
        this.uploaderVisible = false;
        this.name = 'styler';
        this.hsEventBusService.layerSelectedFromUrl
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((layer) => {
            if (layer !== null && this.hsUtilsService.instOf(layer, VectorLayer)) {
                this.hsStylerService.fill(layer);
            }
        });
        this.hsEventBusService.mainPanelChanges
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((e) => {
            if (e == 'styler') {
                this.hsStylerService.fill(this.hsStylerService.layer);
            }
        });
    }
    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
    layermanager() {
        this.hsLayoutService.setMainPanel('layermanager');
    }
    uploadSld() {
        this.uploaderVisible = !this.uploaderVisible;
    }
    clear() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.hsStylerService.reset();
        });
    }
    drop(event) {
        moveItemInArray(this.hsStylerService.styleObject.rules, event.previousIndex, event.currentIndex);
    }
    handleFileUpload(evt) {
        const files = Array.from(evt.fileList);
        const promises = files.map((file) => {
            return new Promise((resolve) => {
                const reader = new FileReader();
                reader.onload = () => resolve(reader.result);
                reader.readAsText(file);
            });
        });
        Promise.all(promises).then((fileContents) => __awaiter(this, void 0, void 0, function* () {
            const sld = fileContents[0];
            yield this.hsStylerService.loadSld(sld);
        }));
    }
}
HsStylerComponent.ɵfac = function HsStylerComponent_Factory(t) { return new (t || HsStylerComponent)(ɵngcc0.ɵɵdirectiveInject(HsStylerService), ɵngcc0.ɵɵdirectiveInject(HsLayoutService), ɵngcc0.ɵɵdirectiveInject(HsEventBusService), ɵngcc0.ɵɵdirectiveInject(ɵngcc4.DomSanitizer), ɵngcc0.ɵɵdirectiveInject(HsLayerUtilsService), ɵngcc0.ɵɵdirectiveInject(HsUtilsService), ɵngcc0.ɵɵdirectiveInject(HsSaveMapService)); };
HsStylerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsStylerComponent, selectors: [["hs-styles"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 44, vars: 40, consts: [[1, "card", "hs-main-panel", 3, "hidden"], [1, "card-header", "d-flex", "align-items-center", "justify-content-between"], [1, "panel-title"], ["type", "button", 1, "close", 3, "title", "click"], ["aria-hidden", "true"], [1, "sr-only"], [1, "card-body"], ["class", "form-control", "type", "text", "placeholder", "Style name", 3, "ngModel", "ngModelChange", 4, "ngIf"], [1, "d-flex", "flex-row", "justify-content-end"], [1, "p-1", "flex-grow-1"], [1, "p-1"], ["ngbDropdown", "", 1, "d-inline-block"], ["id", "dropdownAddRule", "ngbDropdownToggle", "", 1, "btn", "btn-outline-primary", "btn-sm", 3, "title"], [1, "icon-plus"], ["ngbDropdownMenu", "", "aria-labelledby", "dropdownAddRule"], ["ngbDropdownItem", "", 3, "click"], [4, "ngIf"], [1, "card-footer"], ["class", "form-group m-3", 4, "ngIf"], ["role", "group", 1, "btn-group"], ["download", "style.sld", "mimeType", "text/plain", 1, "btn", "btn-secondary", 3, "hsDownload", "href", "title", "downloadPrepared"], [1, "icon-download"], ["data-toggle", "tooltip", 1, "btn", "btn-secondary", 3, "title", "click"], [1, "icon-upload"], ["data-toggle", "tooltip", 1, "btn", "btn-danger", 3, "title", "click"], [1, "icon-trash"], ["type", "text", "placeholder", "Style name", 1, "form-control", 3, "ngModel", "ngModelChange"], ["cdkDropList", "", 1, "list-group", "hs-styler-content-list", 3, "cdkDropListData", "cdkDropListDropped"], [4, "ngFor", "ngForOf"], ["cdkDrag", "", 3, "rule"], [1, "form-group", "m-3"], ["uploader", "hs-sld-upload", "acceptedFormats", ".sld", 3, "uploaded"]], template: function HsStylerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "span", 2);
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵpipe(4, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "button", 3);
        ɵngcc0.ɵɵlistener("click", function HsStylerComponent_Template_button_click_5_listener() { return ctx.layermanager(); });
        ɵngcc0.ɵɵpipe(6, "translate");
        ɵngcc0.ɵɵelementStart(7, "span", 4);
        ɵngcc0.ɵɵtext(8, "\u00D7");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "span", 5);
        ɵngcc0.ɵɵtext(10);
        ɵngcc0.ɵɵpipe(11, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "div", 6);
        ɵngcc0.ɵɵtemplate(13, HsStylerComponent_input_13_Template, 1, 1, "input", 7);
        ɵngcc0.ɵɵelementStart(14, "div", 8);
        ɵngcc0.ɵɵelementStart(15, "div", 9);
        ɵngcc0.ɵɵtext(16);
        ɵngcc0.ɵɵpipe(17, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(18, "div", 10);
        ɵngcc0.ɵɵelementStart(19, "div", 11);
        ɵngcc0.ɵɵelementStart(20, "button", 12);
        ɵngcc0.ɵɵpipe(21, "translate");
        ɵngcc0.ɵɵelement(22, "span", 13);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(23, "div", 14);
        ɵngcc0.ɵɵelementStart(24, "button", 15);
        ɵngcc0.ɵɵlistener("click", function HsStylerComponent_Template_button_click_24_listener() { return ctx.hsStylerService.addRule("Simple"); });
        ɵngcc0.ɵɵtext(25);
        ɵngcc0.ɵɵpipe(26, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(27, "button", 15);
        ɵngcc0.ɵɵlistener("click", function HsStylerComponent_Template_button_click_27_listener() { return ctx.hsStylerService.addRule("Cluster"); });
        ɵngcc0.ɵɵtext(28);
        ɵngcc0.ɵɵpipe(29, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(30, HsStylerComponent_ng_container_30_Template, 3, 2, "ng-container", 16);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(31, "div", 17);
        ɵngcc0.ɵɵtemplate(32, HsStylerComponent_div_32_Template, 2, 0, "div", 18);
        ɵngcc0.ɵɵelementStart(33, "div", 19);
        ɵngcc0.ɵɵpipe(34, "translate");
        ɵngcc0.ɵɵelementStart(35, "a", 20);
        ɵngcc0.ɵɵlistener("downloadPrepared", function HsStylerComponent_Template_a_downloadPrepared_35_listener($event) { return ctx.downloadData = $event; });
        ɵngcc0.ɵɵpipe(36, "translate");
        ɵngcc0.ɵɵelement(37, "i", 21);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(38, "button", 22);
        ɵngcc0.ɵɵlistener("click", function HsStylerComponent_Template_button_click_38_listener() { return ctx.uploadSld(); });
        ɵngcc0.ɵɵpipe(39, "translate");
        ɵngcc0.ɵɵelement(40, "i", 23);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(41, "button", 24);
        ɵngcc0.ɵɵlistener("click", function HsStylerComponent_Template_button_click_41_listener() { return ctx.clear(); });
        ɵngcc0.ɵɵpipe(42, "translate");
        ɵngcc0.ɵɵelement(43, "i", 25);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("hidden", !ctx.isVisible());
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate2(" ", ɵngcc0.ɵɵpipeBind1(4, 18, "LAYERMANAGER.layerEditor.styleLayer"), " ", ctx.hsStylerService.layerTitle, " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(6, 20, "COMMON.close"));
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(11, 22, "COMMON.close"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hsStylerService.styleObject);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(17, 24, "STYLER.rules"), ":");
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(21, 26, "STYLER.addRule"));
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(26, 28, "STYLER.simpleRule"), " ");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(29, 30, "STYLER.clusterRule"), " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hsStylerService.styleObject);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.uploaderVisible);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("aria-label", ɵngcc0.ɵɵpipeBind1(34, 32, "STYLER.manageStyle"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("hsDownload", ctx.hsStylerService.sld)("href", ctx.downloadData, ɵngcc0.ɵɵsanitizeUrl)("title", ɵngcc0.ɵɵpipeBind1(36, 34, "STYLER.downloadSld"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(39, 36, "STYLER.uploadSld"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(42, 38, "STYLER.clear"));
    } }, directives: function () { return [ɵngcc3.NgIf, ɵngcc6.NgbDropdown, ɵngcc6.NgbDropdownToggle, ɵngcc6.NgbDropdownMenu, ɵngcc6.NgbDropdownItem, HsDownloadDirective, ɵngcc5.DefaultValueAccessor, ɵngcc5.NgControlStatus, ɵngcc5.NgModel, ɵngcc7.CdkDropList, ɵngcc3.NgForOf, HsRuleListItemComponent, ɵngcc7.CdkDrag, HsUploadComponent]; }, pipes: function () { return [ɵngcc1.TranslatePipe]; }, styles: [_c57] });
HsStylerComponent.ctorParameters = () => [
    { type: HsStylerService },
    { type: HsLayoutService },
    { type: HsEventBusService },
    { type: DomSanitizer },
    { type: HsLayerUtilsService },
    { type: HsUtilsService },
    { type: HsSaveMapService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsStylerComponent, [{
        type: Component,
        args: [{
                selector: 'hs-styles',
                template: "<div class=\"card hs-main-panel\" [hidden]=\"!isVisible()\">\n  <div class=\"card-header d-flex align-items-center justify-content-between\">\n    <span class=\"panel-title\">\n      {{'LAYERMANAGER.layerEditor.styleLayer' | translate}}\n      {{hsStylerService.layerTitle}}\n    </span>\n    <button type=\"button\" class=\"close\" (click)=\"layermanager()\" [title]=\"'COMMON.close' | translate\">\n      <span aria-hidden=\"true\">\u00D7</span>\n      <span class=\"sr-only\">{{'COMMON.close' | translate}}</span>\n    </button>\n  </div>\n  <div class=\"card-body\">\n    <input class=\"form-control\" *ngIf=\"hsStylerService.styleObject\" type=\"text\" placeholder=\"Style name\"\n      [(ngModel)]=\"hsStylerService.styleObject.name\" />\n    <div class=\"d-flex flex-row justify-content-end\">\n      <div class=\"p-1 flex-grow-1\">{{'STYLER.rules' | translate}}:</div>\n      <div class=\"p-1\">\n        <div ngbDropdown class=\"d-inline-block\">\n          <button class=\"btn btn-outline-primary btn-sm\" [title]=\"'STYLER.addRule' | translate\" id=\"dropdownAddRule\"\n            ngbDropdownToggle>\n            <span class=\"icon-plus\"></span>\n          </button>\n          <div ngbDropdownMenu aria-labelledby=\"dropdownAddRule\">\n            <button ngbDropdownItem (click)=\"hsStylerService.addRule('Simple')\">\n              {{'STYLER.simpleRule' | translate}}\n            </button>\n            <button ngbDropdownItem (click)=\"hsStylerService.addRule('Cluster')\">\n              {{'STYLER.clusterRule' | translate}}\n            </button>\n          </div>\n        </div>\n      </div>\n    </div>\n    <ng-container *ngIf=\"hsStylerService.styleObject\">\n      <ul class=\"list-group hs-styler-content-list\" cdkDropList (cdkDropListDropped)=\"drop($event)\"\n        [cdkDropListData]=\"hsStylerService.styleObject.rules\">\n        <ng-container *ngFor=\"let rule of hsStylerService.styleObject.rules\">\n          <hs-rule-list-item cdkDrag [rule]=\"rule\"></hs-rule-list-item>\n        </ng-container>\n      </ul>\n    </ng-container>\n  </div>\n  <div class=\"card-footer\">\n    <div class=\"form-group m-3\" *ngIf=\"uploaderVisible\">\n      <hs-file-upload (uploaded)=\"handleFileUpload($event)\" uploader=\"hs-sld-upload\" acceptedFormats=\".sld\">\n      </hs-file-upload>\n    </div>\n    <div class=\"btn-group\" role=\"group\" [attr.aria-label]=\"'STYLER.manageStyle' | translate\">\n      <a class=\"btn btn-secondary\" download=\"style.sld\" [hsDownload]=\"hsStylerService.sld\" mimeType=\"text/plain\"\n        [href]=\"downloadData\" (downloadPrepared)=\"downloadData = $event\" [title]=\"'STYLER.downloadSld' | translate\">\n        <i class=\"icon-download\"></i></a>\n\n      <button class=\"btn btn-secondary\" (click)=\"uploadSld()\" data-toggle=\"tooltip\"\n        [title]=\"'STYLER.uploadSld' | translate\">\n        <i class=\"icon-upload\"></i>\n      </button>\n      <button class=\"btn btn-danger\" (click)=\"clear()\" data-toggle=\"tooltip\" [title]=\"'STYLER.clear' | translate\">\n        <i class=\"icon-trash\"></i>\n      </button>\n    </div>\n  </div>\n</div>",
                styles: [".cdk-drag-preview{box-sizing:content-box;border-radius:0;background-color:#b9b9b9bf;border:1px solid #b9b9b9;overflow:hidden;display:flex;align-items:center;color:#000;box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f}.cdk-drag-placeholder{opacity:0}.cdk-drag-animating{transition:transform 125ms cubic-bezier(0,0,.2,1)}.list-group.hs-styler-content-list.cdk-drop-list-dragging hs-rule-list-item:not(.cdk-drag-placeholder){transition:transform .25s cubic-bezier(0,0,.2,1)}.list-group.hs-styler-content-list.cdk-drop-list-dragging hs-symbolizer-list-item:not(.cdk-drag-placeholder){transition:transform .25s cubic-bezier(0,0,.2,1)}ul.hs-styler-content-list{margin-top:0;margin-bottom:0;border-bottom:1px solid var(--panel-wrapper-bg-color)}li.list-group-item.hs-list-item-header{padding:.3em;width:100%;cursor:pointer;display:flex;justify-content:space-between;align-items:center;border-radius:0}li.list-group-item.hs-list-item-header .btn-danger{margin-right:1rem}li.list-group-item.hs-list-item-header span.glyphicon{font-size:x-small}li.list-group-item.hs-list-item-header:hover{background-color:#b9b9b9bf}\n"]
            }]
    }], function () { return [{ type: HsStylerService }, { type: HsLayoutService }, { type: HsEventBusService }, { type: ɵngcc4.DomSanitizer }, { type: HsLayerUtilsService }, { type: HsUtilsService }, { type: HsSaveMapService }]; }, null); })();

class HsThemeToolbarComponent extends HsToolbarPanelBaseComponent {
    constructor(HsLayoutService, HsThemeService) {
        super(HsLayoutService);
        this.HsLayoutService = HsLayoutService;
        this.HsThemeService = HsThemeService;
        this.name = 'themeToggle';
    }
    toggleTheme() {
        if (this.HsThemeService.isDarkTheme()) {
            this.HsThemeService.setLightTheme();
        }
        else {
            this.HsThemeService.setDarkTheme();
        }
    }
}
HsThemeToolbarComponent.ɵfac = function HsThemeToolbarComponent_Factory(t) { return new (t || HsThemeToolbarComponent)(ɵngcc0.ɵɵdirectiveInject(HsLayoutService), ɵngcc0.ɵɵdirectiveInject(HsThemeService)); };
HsThemeToolbarComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsThemeToolbarComponent, selectors: [["hs-theme-toolbar"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 3, vars: 2, consts: [[1, "nav-item", 3, "hidden"], [1, "btn", "rounded-0", "hs-toolbar-button", "btn-light", "btn-outline-secondary", 3, "click"], [3, "ngClass"]], template: function HsThemeToolbarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "button", 1);
        ɵngcc0.ɵɵlistener("click", function HsThemeToolbarComponent_Template_button_click_1_listener() { return ctx.toggleTheme(); });
        ɵngcc0.ɵɵelement(2, "i", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("hidden", !ctx.isVisible());
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ctx.HsThemeService.active.name === "light" ? "icon-moon-night" : "icon-sun-day");
    } }, directives: [ɵngcc3.NgClass], encapsulation: 2 });
HsThemeToolbarComponent.ctorParameters = () => [
    { type: HsLayoutService },
    { type: HsThemeService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsThemeToolbarComponent, [{
        type: Component,
        args: [{
                selector: 'hs-theme-toolbar',
                template: "<div class=\"nav-item\" [hidden]=\"!isVisible()\"> \n    <button (click)=\"toggleTheme()\" class=\"btn rounded-0 hs-toolbar-button btn-light btn-outline-secondary\">\n        <i [ngClass]=\"HsThemeService.active.name === 'light' ? 'icon-moon-night' : 'icon-sun-day'\" ></i></button>\n</div>"
            }]
    }], function () { return [{ type: HsLayoutService }, { type: HsThemeService }]; }, null); })();

class HsToolbarPanelContainerService extends HsPanelContainerService {
    constructor() {
        super();
    }
}
HsToolbarPanelContainerService.ɵfac = function HsToolbarPanelContainerService_Factory(t) { return new (t || HsToolbarPanelContainerService)(); };
HsToolbarPanelContainerService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HsToolbarPanelContainerService_Factory() { return new HsToolbarPanelContainerService(); }, token: HsToolbarPanelContainerService, providedIn: "root" });
HsToolbarPanelContainerService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsToolbarPanelContainerService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class HsToolbarComponent extends HsPanelBaseComponent {
    constructor(HsEventBusService, HsLayoutService, HsCoreService, HsThemeService, HsToolbarPanelContainerService) {
        super(HsLayoutService);
        this.HsEventBusService = HsEventBusService;
        this.HsLayoutService = HsLayoutService;
        this.HsCoreService = HsCoreService;
        this.HsThemeService = HsThemeService;
        this.HsToolbarPanelContainerService = HsToolbarPanelContainerService;
        this.collapsed = false;
        this.mapResetsSubscription = this.HsEventBusService.mapResets.subscribe(() => {
            setTimeout(() => {
                delete this.composition_title;
                delete this.composition_abstract;
            });
        });
    }
    ngOnDestroy() {
        this.mapResetsSubscription.unsubscribe();
    }
    /**
     * Change/read collapsed setting
     *
     * @returns Collapsed state
     * @param is Value to set collapsed state to
     */
    isCollapsed(is) {
        if (arguments.length > 0) {
            this.collapsed = is;
        }
        return this.collapsed;
    }
    isVisible() {
        return (this.HsLayoutService.panelEnabled('toolbar') &&
            this.HsLayoutService.componentEnabled('toolbar') &&
            this.HsLayoutService.componentEnabled('guiOverlay'));
    }
}
HsToolbarComponent.ɵfac = function HsToolbarComponent_Factory(t) { return new (t || HsToolbarComponent)(ɵngcc0.ɵɵdirectiveInject(HsEventBusService), ɵngcc0.ɵɵdirectiveInject(HsLayoutService), ɵngcc0.ɵɵdirectiveInject(HsCoreService), ɵngcc0.ɵɵdirectiveInject(HsThemeService), ɵngcc0.ɵɵdirectiveInject(HsToolbarPanelContainerService)); };
HsToolbarComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsToolbarComponent, selectors: [["hs-toolbar"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 3, vars: 2, consts: [[1, "hs-toolbar", 3, "hidden"], [1, "navbar", "navbar-expand", "p-0"], [1, "navbar-nav", 3, "service"]], template: function HsToolbarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "nav", 1);
        ɵngcc0.ɵɵelement(2, "hs-panel-container", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("hidden", !ctx.isVisible());
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("service", ctx.HsToolbarPanelContainerService);
    } }, directives: [ɵngcc6.NgbNavbar, HsPanelContainerComponent], encapsulation: 2 });
HsToolbarComponent.ctorParameters = () => [
    { type: HsEventBusService },
    { type: HsLayoutService },
    { type: HsCoreService },
    { type: HsThemeService },
    { type: HsToolbarPanelContainerService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsToolbarComponent, [{
        type: Component,
        args: [{
                selector: 'hs-toolbar',
                template: "<div class=\"hs-toolbar\" [hidden]=\"!isVisible()\">\n    <nav class=\"navbar navbar-expand p-0\">\n        <hs-panel-container \n            class=\"navbar-nav\"\n            [service]=\"HsToolbarPanelContainerService\">\n        </hs-panel-container >\n    </nav>\n</div>\n"
            }]
    }], function () { return [{ type: HsEventBusService }, { type: HsLayoutService }, { type: HsCoreService }, { type: HsThemeService }, { type: HsToolbarPanelContainerService }]; }, null); })();

const WAYPOINT = 'wp';
function setWaypoint(feature, wp) {
    feature.set(WAYPOINT, wp);
}
function getWaypoint(feature) {
    return feature.get(WAYPOINT);
}
class HsTripPlannerService {
    constructor(HsMapService, HsUtilsService, $http, HsShareUrlService, HsEventBusService, HsToastService, HsLanguageService, HsLayerUtilsService, HsLayoutService) {
        this.HsMapService = HsMapService;
        this.HsUtilsService = HsUtilsService;
        this.$http = $http;
        this.HsShareUrlService = HsShareUrlService;
        this.HsEventBusService = HsEventBusService;
        this.HsToastService = HsToastService;
        this.HsLanguageService = HsLanguageService;
        this.HsLayerUtilsService = HsLayerUtilsService;
        this.HsLayoutService = HsLayoutService;
        this.waypoints = [];
        this.trip = {};
        this.movable_features = new Collection();
        this.modify = new Modify({
            features: this.movable_features,
        });
        this.selectedLayerWrapper = {};
        this.waypointRouteStyle = (feature, resolution) => {
            return [
                new Style({
                    fill: new Fill({
                        color: 'rgba(255, 255, 255, 0.6)',
                    }),
                    stroke: new Stroke({
                        color: '#337AB7',
                        width: 3,
                    }),
                    image: new Icon({
                        src: getHighlighted(feature)
                            ? this.HsUtilsService.getAssetsPath() + 'img/pin_white_red32.png'
                            : this.HsUtilsService.getAssetsPath() + 'img/pin_white_blue32.png',
                        crossOrigin: 'anonymous',
                        anchor: [0.5, 1],
                    }),
                    text: new Text({
                        font: '12px Calibri,sans-serif',
                        overflow: true,
                        fill: new Fill({
                            color: '#000',
                        }),
                        stroke: new Stroke({
                            color: '#fff',
                            width: 3,
                        }),
                        offsetY: -40,
                        text: this.getTextOnFeature(feature),
                    }),
                }),
            ];
        };
        this.HsMapService.loaded().then((map) => {
            map.addInteraction(this.modify);
        });
        this.HsEventBusService.mapClicked.subscribe(({ coordinates }) => {
            if (this.HsLayoutService.mainpanel != 'tripPlanner') {
                return;
            }
            if (!this.waypointLayer) {
                this.createWaypointLayer();
            }
            if (!this.routeLayer) {
                this.createRouteLayer();
            }
            //Don't add waypoints when drawing and measuring
            if (this.HsMapService.map
                .getInteractions()
                .getArray()
                .find((i) => i.getActive() && this.HsUtilsService.instOf(i, Draw))) {
                return;
            }
            this.addWaypoint({
                x: coordinates.mapProjCoordinate[0],
                y: coordinates.mapProjCoordinate[1],
                lon: coordinates.epsg4326Coordinate[0],
                lat: coordinates.epsg4326Coordinate[1],
            });
        });
    }
    fillVectorLayers() {
        return __awaiter(this, void 0, void 0, function* () {
            this.HsMapService.loaded().then((map) => {
                this.vectorLayers = [
                    {
                        layer: null,
                        title: 'newLayer',
                    },
                    ...this.HsMapService.getLayersArray()
                        .filter((layer) => this.HsLayerUtilsService.isLayerDrawable(layer))
                        .map((layer) => {
                        return { layer, title: getTitle(layer) };
                    }),
                ];
                this.fillDefaultLayerWrapper('route');
                this.fillDefaultLayerWrapper('waypoints');
            });
        });
    }
    fillDefaultLayerWrapper(usage) {
        if (this.selectedLayerWrapper[usage]) {
            this.selectedLayerWrapper[usage] = this.vectorLayers.find((w) => w.layer == this.selectedLayerWrapper[usage].layer);
        }
        else {
            this.selectedLayerWrapper[usage] = this.vectorLayers[0];
        }
    }
    createWaypointLayer() {
        this.waypointSource = new VectorSource();
        this.waypointLayer = new VectorLayer({
            source: this.waypointSource,
            style: this.waypointRouteStyle,
        });
        setTitle(this.waypointLayer, this.HsLanguageService.getTranslation('TRIP_PLANNER.waypoints'));
        this.HsMapService.map.addLayer(this.waypointLayer);
    }
    createRouteLayer() {
        this.routeSource = new VectorSource();
        this.routeLayer = new VectorLayer({
            source: this.routeSource,
            style: this.waypointRouteStyle,
        });
        setTitle(this.routeLayer, this.HsLanguageService.getTranslation('TRIP_PLANNER.travelRoute'));
        this.HsMapService.map.addLayer(this.routeLayer);
    }
    /**
     * Select layer for storing route or waypoint features
     * @param layer - Wrapper object which contains OL layer and its title
     * @param usage - route or waypoints
     */
    selectLayer(layer, usage) {
        return __awaiter(this, void 0, void 0, function* () {
            if (usage == 'route') {
                this.routeLayer = layer.layer;
                if (this.routeLayer) {
                    this.routeSource = this.routeLayer.getSource();
                }
                this.selectedLayerWrapper.route = layer;
            }
            if (usage == 'waypoints') {
                this.waypointLayer = layer.layer;
                if (this.waypointLayer) {
                    this.waypointSource = this.waypointLayer.getSource();
                }
                this.routeSource.clear();
                this.waypoints.length = 0;
                this.selectedLayerWrapper.waypoints = layer;
                for (const feature of this.waypointSource.getFeatures()) {
                    const new_cords = transform(feature.getGeometry().getCoordinates(), this.HsMapService.getCurrentProj().getCode(), 'EPSG:4326');
                    const wp = {
                        lon: new_cords[0],
                        lat: new_cords[1],
                        name: 'Waypoint ' + (this.waypoints.length + 1),
                        hash: this.HsUtilsService.hashCode(JSON.stringify('Waypoint ' + this.waypoints.length + Math.random())),
                        routes: { from: null, to: null },
                        featureId: feature.getId(),
                        loading: false,
                    };
                    this.waypoints.push(wp);
                    if (this.waypointAdded !== undefined) {
                        this.waypointAdded(wp);
                    }
                    yield this.calculateRoutes();
                }
            }
        });
    }
    getTextOnFeature(feature) {
        var _a;
        let tmp = '';
        const wp = getWaypoint(feature);
        if (wp) {
            tmp = wp.name;
            if ((_a = wp === null || wp === void 0 ? void 0 : wp.routes) === null || _a === void 0 ? void 0 : _a.to) {
                tmp += ` (${this.formatDistance(wp, 'to')})`;
            }
        }
        return tmp;
    }
    /**
     * Add waypoint to waypoint list and recalculate route
     * @param {number} lon Longitude number (part of Ol.coordinate Array)
     * @param {number} lat Latitude number (part of Ol.coordinate Array)
     */
    addWaypoint({ x, y, lon, lat }) {
        const wp = {
            lon,
            lat,
            name: 'Waypoint ' + (this.waypoints.length + 1),
            hash: this.HsUtilsService.hashCode(JSON.stringify('Waypoint ' + this.waypoints.length + Math.random())),
            routes: { from: null, to: null },
            featureId: null,
            loading: false,
        };
        const feature = new Feature({
            'wp': wp,
            geometry: new Point([x, y]),
            id: this.HsUtilsService.generateUuid(),
        });
        feature.setId(feature.get('id'));
        wp.featureId = feature.getId();
        this.waypointSource.addFeature(feature);
        this.waypoints.push(wp);
        if (this.waypointAdded !== undefined) {
            this.waypointAdded(wp);
        }
        this.calculateRoutes();
    }
    /**
     * Handler of adding waypoint in connected service
     * @param wp - Waypoint object, with lat, lon and routes array
     */
    waypointAdded(wp) {
        const feature = this.waypointSource.getFeatureById(wp.featureId);
        this.movable_features.push(feature);
        feature.getGeometry().on('change', (e) => {
            this.removeRoutesForWaypoint(wp);
            const new_cords = transform(feature.getGeometry().getCoordinates(), this.HsMapService.getCurrentProj().getCode(), 'EPSG:4326');
            wp.lon = new_cords[0];
            wp.lat = new_cords[1];
            const prev_index = this.waypoints.indexOf(wp) - 1;
            if (prev_index > -1) {
                this.waypoints[prev_index].routes.from = null;
                this.routeRemoved(this.waypoints[prev_index].routes.from);
            }
            if (this.timer !== null) {
                clearTimeout(this.timer);
            }
            this.timer = setTimeout(() => {
                this.calculateRoutes();
            }, 500);
        });
    }
    /**
     * Remove selected route from source
     * @param feature - Route feature to remove
     */
    routeRemoved(feature) {
        try {
            if (feature) {
                this.routeSource.removeFeature(feature);
            }
        }
        catch (ex) {
            throw ex;
        }
    }
    /**
     * (PRIVATE) Remove routes from selected waypoint
     * @param wp - Waypoint to remove routes
     */
    removeRoutesForWaypoint(wp) {
        this.routeRemoved(wp.routes.from);
        this.routeRemoved(wp.routes.to);
        wp.routes = { from: null, to: null };
    }
    /**
     * Remove selected waypoint from source
     * @param wp - Waypoint feature to remove
     */
    waypointRemoved(wp) {
        try {
            this.waypointSource.removeFeature(this.waypointSource.getFeatureById(wp.featureId));
        }
        catch (ex) {
            throw ex;
        }
    }
    /**
     * Remove selected waypoint from trip
     * @param {object} wp Waypoint object to remove
     */
    removeWaypoint(wp) {
        const wpIndex = this.waypoints.indexOf(wp);
        const prev_index = wpIndex - 1;
        if (prev_index > -1) {
            this.waypoints[prev_index].routes.from = null;
        }
        this.routeRemoved(wp.routes.from);
        this.routeRemoved(wp.routes.to);
        const next_index = wpIndex + 1;
        if (next_index < this.waypoints.length) {
            this.waypoints[next_index].routes.to = null;
        }
        this.waypointRemoved(wp);
        this.waypoints.splice(this.waypoints.indexOf(wp), 1);
        this.calculateRoutes();
    }
    /**
     * Clear all waypoints from service and layer
     */
    clearAll() {
        this.waypoints = [];
        this.waypointSource.clear();
        this.routeSource.clear();
    }
    /**
     * Handler of adding computed route to layer
     * @param feature - Route to add
     */
    routeAdded(features) {
        this.routeSource.addFeatures(features);
    }
    /**
     * Calculate routes between stored waypoints
     */
    calculateRoutes() {
        return __awaiter(this, void 0, void 0, function* () {
            for (let i = 0; i < this.waypoints.length - 1; i++) {
                const wpf = this.waypoints[i];
                if (wpf.routes.from === null) {
                    const wpt = this.waypoints[i + 1];
                    wpt.loading = true;
                    const url = this.HsUtilsService.proxify('https://api.openrouteservice.org/v2/directions/driving-car/geojson');
                    const response = yield this.$http
                        .post(url, {
                        'coordinates': [
                            [wpf.lon, wpf.lat],
                            [wpt.lon, wpt.lat],
                        ],
                    })
                        .pipe(timeout(10000), catchError((e) => {
                        let title = this.HsLanguageService.getTranslation('TRIP_PLANNER.serviceDown');
                        if (e.status == 404) {
                            title = this.HsLanguageService.getTranslation('TRIP_PLANNER.missingAuth');
                        }
                        this.HsToastService.createToastPopupMessage(title, this.HsLanguageService.getTranslationIgnoreNonExisting('ERRORMESSAGES', e.message, { url: url }), {
                            disableLocalization: true,
                            serviceCalledFrom: 'HsTripPlannerService',
                        });
                        return of(null);
                    }))
                        .toPromise();
                    if (!response) {
                        return;
                    }
                    wpt.loading = false;
                    const format = new GeoJSON();
                    const features = format.readFeatures(response);
                    features[0]
                        .getGeometry()
                        .transform('EPSG:4326', this.HsMapService.getCurrentProj());
                    wpf.routes.from = features[0];
                    wpt.routes.to = features[0];
                    if (this.routeAdded !== undefined) {
                        this.routeAdded(features);
                    }
                }
            }
        });
    }
    /**
     * Format waypoint route distance in a human friendly way
     * @param wp - Wayoint
     * @param which
     * @returns Distance
     */
    formatDistance(wp, which) {
        which = which !== undefined ? which : 'from';
        if (wp.routes[which]) {
            const route = wp.routes[which];
            const distance = (route === null || route === void 0 ? void 0 : route.get('summary').distance) / 1000.0;
            if (distance == undefined) {
                return '';
            }
            else {
                return distance.toFixed(2) + 'km';
            }
        }
    }
}
HsTripPlannerService.ɵfac = function HsTripPlannerService_Factory(t) { return new (t || HsTripPlannerService)(ɵngcc0.ɵɵinject(HsMapService), ɵngcc0.ɵɵinject(HsUtilsService), ɵngcc0.ɵɵinject(ɵngcc2.HttpClient), ɵngcc0.ɵɵinject(HsShareUrlService), ɵngcc0.ɵɵinject(HsEventBusService), ɵngcc0.ɵɵinject(HsToastService), ɵngcc0.ɵɵinject(HsLanguageService), ɵngcc0.ɵɵinject(HsLayerUtilsService), ɵngcc0.ɵɵinject(HsLayoutService)); };
HsTripPlannerService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HsTripPlannerService_Factory() { return new HsTripPlannerService(i0.ɵɵinject(HsMapService), i0.ɵɵinject(HsUtilsService), i0.ɵɵinject(i1$1.HttpClient), i0.ɵɵinject(HsShareUrlService), i0.ɵɵinject(HsEventBusService), i0.ɵɵinject(HsToastService), i0.ɵɵinject(HsLanguageService), i0.ɵɵinject(HsLayerUtilsService), i0.ɵɵinject(HsLayoutService)); }, token: HsTripPlannerService, providedIn: "root" });
HsTripPlannerService.ctorParameters = () => [
    { type: HsMapService },
    { type: HsUtilsService },
    { type: HttpClient },
    { type: HsShareUrlService },
    { type: HsEventBusService },
    { type: HsToastService },
    { type: HsLanguageService },
    { type: HsLayerUtilsService },
    { type: HsLayoutService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsTripPlannerService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: HsMapService }, { type: HsUtilsService }, { type: ɵngcc2.HttpClient }, { type: HsShareUrlService }, { type: HsEventBusService }, { type: HsToastService }, { type: HsLanguageService }, { type: HsLayerUtilsService }, { type: HsLayoutService }]; }, null); })();

class HsTripPlannerComponent extends HsPanelBaseComponent {
    constructor(HsMapService, HsCoreService, HsTripPlannerService, HsConfig, hsLayoutService, HsUtilsService, HsLayerUtilsService, hsLanguageService, hsSidebarService) {
        super(hsLayoutService);
        this.HsMapService = HsMapService;
        this.HsCoreService = HsCoreService;
        this.HsTripPlannerService = HsTripPlannerService;
        this.HsConfig = HsConfig;
        this.HsUtilsService = HsUtilsService;
        this.HsLayerUtilsService = HsLayerUtilsService;
        this.name = 'tripPlanner';
        hsSidebarService.buttons.push({
            panel: 'tripPlanner',
            module: 'hs-trip-planner',
            order: 17,
            fits: true,
            title: () => hsLanguageService.getTranslation('PANEL_HEADER.TRIP_PLANNER'),
            description: () => hsLanguageService.getTranslation('SIDEBAR.descriptions.TRIP_PLANNER'),
            icon: 'icon-sextant',
        });
    }
    ngOnInit() {
        if (this.HsConfig.default_layers === undefined) {
            this.HsConfig.default_layers = [];
        }
        else {
            this.HsConfig.default_layers.push(this.HsTripPlannerService.routeLayer);
        }
        this.HsTripPlannerService.fillVectorLayers();
    }
    /**
     * Format waypoint route distance in a human friendly way
     * @param {float} wp Wayoint
     * @returns {string} Distance
     */
    formatDistance(wp) {
        return this.HsTripPlannerService.formatDistance(wp);
    }
    /**
     * Get the total distance for all waypoint routes
     * @returns {string} Distance
     */
    totalDistance() {
        let tmp = 0;
        this.HsTripPlannerService.waypoints.forEach((wp) => {
            if (wp.routes.from) {
                tmp += wp.routes.from.get('summary').distance / 1000.0;
            }
        });
        return tmp.toFixed(2) + 'km';
    }
    /**
     * Remove selected waypoint from source
     * @param {object} waypoint
     */
    toggleEdit(waypoint) {
        waypoint.editMode = !waypoint.editMode;
        const src = this.HsTripPlannerService.waypointLayer.getSource();
        setHighlighted(src.getFeatureById(waypoint.featureId), waypoint.editMode);
    }
}
HsTripPlannerComponent.ɵfac = function HsTripPlannerComponent_Factory(t) { return new (t || HsTripPlannerComponent)(ɵngcc0.ɵɵdirectiveInject(HsMapService), ɵngcc0.ɵɵdirectiveInject(HsCoreService), ɵngcc0.ɵɵdirectiveInject(HsTripPlannerService), ɵngcc0.ɵɵdirectiveInject(HsConfig), ɵngcc0.ɵɵdirectiveInject(HsLayoutService), ɵngcc0.ɵɵdirectiveInject(HsUtilsService), ɵngcc0.ɵɵdirectiveInject(HsLayerUtilsService), ɵngcc0.ɵɵdirectiveInject(HsLanguageService), ɵngcc0.ɵɵdirectiveInject(HsSidebarService)); };
HsTripPlannerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsTripPlannerComponent, selectors: [["hs-trip-planner"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 22, vars: 21, consts: [[1, "card", "hs-main-panel", 3, "hidden"], ["name", "tripPlaner", 3, "title"], [1, "card-body"], ["usage", "route", 3, "label", "selectedwrapper"], ["usage", "waypoints", 3, "label", "selectedwrapper"], ["class", "d-flex flex-row", 4, "ngFor", "ngForOf"], ["class", "alert alert-primary", "role", "alert", 4, "ngIf"], [3, "click"], [1, "d-flex", "flex-row"], [1, "p-1", "flex-grow-1"], [1, "p-1"], [3, "hidden", "click"], [1, "form-control", "hs-waypoint-name", 3, "ngModel", "ngModelOptions", "hidden", "ngModelChange", "blur"], [3, "hidden", "src"], [1, "p-1", 2, "height", "1.7em"], [2, "margin-top", "1em"], ["data-toggle", "tooltip", 1, "p-1", 3, "title", "click"], [1, "icon-remove-circle", 2, "color", "rgb(228, 99, 99)"], ["role", "alert", 1, "alert", "alert-primary"]], template: function HsTripPlannerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "hs-panel-header", 1);
        ɵngcc0.ɵɵpipe(2, "translate");
        ɵngcc0.ɵɵelementStart(3, "div", 2);
        ɵngcc0.ɵɵelement(4, "hs-trip-planner-layer-selector", 3);
        ɵngcc0.ɵɵpipe(5, "translate");
        ɵngcc0.ɵɵelement(6, "hs-trip-planner-layer-selector", 4);
        ɵngcc0.ɵɵpipe(7, "translate");
        ɵngcc0.ɵɵtemplate(8, HsTripPlannerComponent_div_8_Template, 14, 12, "div", 5);
        ɵngcc0.ɵɵtemplate(9, HsTripPlannerComponent_div_9_Template, 3, 3, "div", 6);
        ɵngcc0.ɵɵelement(10, "br");
        ɵngcc0.ɵɵelementStart(11, "a", 7);
        ɵngcc0.ɵɵlistener("click", function HsTripPlannerComponent_Template_a_click_11_listener() { return ctx.HsTripPlannerService.clearAll(); });
        ɵngcc0.ɵɵtext(12);
        ɵngcc0.ɵɵpipe(13, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(14, "br");
        ɵngcc0.ɵɵelementStart(15, "div", 8);
        ɵngcc0.ɵɵelementStart(16, "div", 9);
        ɵngcc0.ɵɵelementStart(17, "strong");
        ɵngcc0.ɵɵtext(18);
        ɵngcc0.ɵɵpipe(19, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(20, "div", 10);
        ɵngcc0.ɵɵtext(21);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("hidden", !ctx.isVisible());
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(2, 11, "PANEL_HEADER.TRIP_PLANNER"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵpropertyInterpolate("label", ɵngcc0.ɵɵpipeBind1(5, 13, "TRIP_PLANNER.routerLayer"));
        ɵngcc0.ɵɵproperty("selectedwrapper", ctx.HsTripPlannerService.selectedLayerWrapper.route);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵpropertyInterpolate("label", ɵngcc0.ɵɵpipeBind1(7, 15, "TRIP_PLANNER.waypointLayer"));
        ɵngcc0.ɵɵproperty("selectedwrapper", ctx.HsTripPlannerService.selectedLayerWrapper.waypoints);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.HsTripPlannerService.waypoints);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.HsTripPlannerService.waypoints.length === 0);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(13, 17, "TRIP_PLANNER.clearWaypoints"));
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(19, 19, "TRIP_PLANNER.totalDistance"), ":");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.totalDistance());
    } }, directives: function () { return [HsPanelHeaderComponent, HsTripPlannerLayerSelectorComponent, ɵngcc3.NgForOf, ɵngcc3.NgIf, ɵngcc5.DefaultValueAccessor, ɵngcc5.NgControlStatus, ɵngcc5.NgModel]; }, pipes: function () { return [ɵngcc1.TranslatePipe]; }, encapsulation: 2 });
HsTripPlannerComponent.ctorParameters = () => [
    { type: HsMapService },
    { type: HsCoreService },
    { type: HsTripPlannerService },
    { type: HsConfig },
    { type: HsLayoutService },
    { type: HsUtilsService },
    { type: HsLayerUtilsService },
    { type: HsLanguageService },
    { type: HsSidebarService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsTripPlannerComponent, [{
        type: Component,
        args: [{
                selector: 'hs-trip-planner',
                template: "<div class=\"card hs-main-panel\" [hidden]=\"!isVisible()\">\n  <hs-panel-header\n    name=\"tripPlaner\"\n    [title]=\"'PANEL_HEADER.TRIP_PLANNER' | translate\"\n  ></hs-panel-header>\n  <div class=\"card-body\">\n    <hs-trip-planner-layer-selector usage=\"route\" label=\"{{'TRIP_PLANNER.routerLayer' | translate}}\" [selectedwrapper]=\"HsTripPlannerService.selectedLayerWrapper.route\"></hs-trip-planner-layer-selector>\n    <hs-trip-planner-layer-selector usage=\"waypoints\" label=\"{{'TRIP_PLANNER.waypointLayer' | translate}}\" [selectedwrapper]=\"HsTripPlannerService.selectedLayerWrapper.waypoints\"></hs-trip-planner-layer-selector>\n\n    <div\n      *ngFor=\"let waypoint of HsTripPlannerService.waypoints\"\n      class=\"d-flex flex-row\"\n    >\n      <div class=\"p-1 flex-grow-1\">\n        <a (click)=\"toggleEdit(waypoint)\" [hidden]=\"!!waypoint.editMode\"\n          >{{waypoint.name}}</a\n        >\n        <input\n          [(ngModel)]=\"waypoint.name\"\n          class=\"form-control hs-waypoint-name\"\n          [ngModelOptions]=\"{standalone: true}\"\n          [hidden]=\"!waypoint.editMode\"\n          (blur)=\"toggleEdit(waypoint)\"\n        />\n      </div>\n      <div class=\"p-1\">\n        <img\n          [hidden]=\"!waypoint.loading\"\n          [src]=\"HsUtilsService.getAjaxLoaderIcon()\"\n        />\n      </div>\n      <div class=\"p-1\" style=\"height: 1.7em\">\n        <div style=\"margin-top: 1em\">{{ formatDistance(waypoint) }}</div>\n      </div>\n      <div class=\"p-1\">\n        <a\n          class=\"p-1\"\n          (click)=\"HsTripPlannerService.removeWaypoint(waypoint)\"\n          data-toggle=\"tooltip\"\n          [title]=\"'TRIP_PLANNER.removeWaypoint' | translate\"\n        >\n          <i class=\"icon-remove-circle\" style=\"color: rgb(228, 99, 99)\"></i>\n        </a>\n      </div>\n    </div>\n    <div\n      class=\"alert alert-primary\"\n      role=\"alert\"\n      *ngIf=\"HsTripPlannerService.waypoints.length===0\"\n    >\n      {{'TRIP_PLANNER.waypointDrawingHint' | translate}}\n    </div>\n    <br />\n    <a (click)=\"HsTripPlannerService.clearAll()\"\n      >{{'TRIP_PLANNER.clearWaypoints' | translate}}</a\n    >\n    <br />\n    <div class=\"d-flex flex-row\">\n      <div class=\"p-1 flex-grow-1\">\n        <strong>{{'TRIP_PLANNER.totalDistance' | translate}}:</strong>\n      </div>\n      <div class=\"p-1\">{{totalDistance()}}</div>\n    </div>\n  </div>\n</div>\n"
            }]
    }], function () { return [{ type: HsMapService }, { type: HsCoreService }, { type: HsTripPlannerService }, { type: HsConfig }, { type: HsLayoutService }, { type: HsUtilsService }, { type: HsLayerUtilsService }, { type: HsLanguageService }, { type: HsSidebarService }]; }, null); })();

class HslayersComponent {
    constructor(hsConfig, hsLayoutService, HsLayerManagerService, hsToolbarPanelContainerService) {
        this.hsConfig = hsConfig;
        this.hsLayoutService = hsLayoutService;
        this.HsLayerManagerService = HsLayerManagerService;
        this.hsToolbarPanelContainerService = hsToolbarPanelContainerService;
    }
    createPanel(name, panelComponent, data) {
        const panelsEnabled = this.hsConfig.panelsEnabled;
        if (panelsEnabled[name] ||
            (panelsEnabled[name] == undefined &&
                this.hsLayoutService.panelsEnabledDefaults[name])) {
            this.hsLayoutService.createPanel(panelComponent, data || {});
        }
    }
    ngOnInit() {
        if (this.config) {
            this.hsConfig.update(this.config);
        }
        if (!this.hsLayoutService.initializedOnce) {
            this.createPanel('tripPlanner', HsTripPlannerComponent);
            this.createPanel('addData', HsAddDataComponent);
            this.createPanel('draw', HsDrawComponent);
            this.createPanel('search', HsSearchComponent);
            this.createPanel('feature_table', HsFeatureTableComponent);
            this.createPanel('saveMap', HsSaveMapComponent);
            this.createPanel('language', HsLanguageComponent);
            this.createPanel('info', HsQueryComponent);
            this.createPanel('permalink', HsShareComponent);
            this.createPanel('print', HsPrintComponent);
            this.createPanel('measure', HsMeasureComponent);
            this.createPanel('composition_browser', HsCompositionsComponent);
            this.createPanel('legend', HsLegendComponent);
            this.createPanel('layermanager', HsLayerManagerComponent, this.HsLayerManagerService.data);
            this.hsLayoutService.createPanel(HsStylerComponent, {});
            this.hsToolbarPanelContainerService.create(HsSearchToolbarComponent, {});
            this.hsToolbarPanelContainerService.create(HsDrawToolbarComponent, {});
            this.hsToolbarPanelContainerService.create(HsMeasureToolbarComponent, {});
            this.hsToolbarPanelContainerService.create(HsThemeToolbarComponent, {});
            this.hsLayoutService.createOverlay(HsGeolocationComponent, {});
            this.hsLayoutService.createOverlay(HsInfoComponent, {});
            this.hsLayoutService.createOverlay(HsLayerManagerGalleryComponent, {});
            this.hsLayoutService.createOverlay(HsToolbarComponent, {});
            this.hsLayoutService.initializedOnce = true;
        }
    }
}
HslayersComponent.ɵfac = function HslayersComponent_Factory(t) { return new (t || HslayersComponent)(ɵngcc0.ɵɵdirectiveInject(HsConfig), ɵngcc0.ɵɵdirectiveInject(HsLayoutService), ɵngcc0.ɵɵdirectiveInject(HsLayerManagerService), ɵngcc0.ɵɵdirectiveInject(HsToolbarPanelContainerService)); };
HslayersComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HslayersComponent, selectors: [["hslayers"]], viewQuery: function HslayersComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(HsLayoutComponent, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.layout = _t.first);
    } }, inputs: { config: "config" }, decls: 2, vars: 0, consts: [["layout", "column", 1, "hs-layout", 2, "height", "100%", "max-height", "100vh", "position", "relative", "width", "100%", "display", "block"], ["hslayout", ""]], template: function HslayersComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "hs-layout", 0, 1);
    } }, directives: [HsLayoutComponent], encapsulation: 2 });
HslayersComponent.ctorParameters = () => [
    { type: HsConfig },
    { type: HsLayoutService },
    { type: HsLayerManagerService },
    { type: HsToolbarPanelContainerService }
];
HslayersComponent.propDecorators = {
    config: [{ type: Input }],
    layout: [{ type: ViewChild, args: [HsLayoutComponent,] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HslayersComponent, [{
        type: Component,
        args: [{
                // eslint-disable-next-line @angular-eslint/component-selector
                selector: 'hslayers',
                template: "<hs-layout class=\"hs-layout\" #hslayout layout=\"column\" style=\"height:100%; max-height:100vh; position: relative;width:100%; display:block\"></hs-layout>\n"
            }]
    }], function () { return [{ type: HsConfig }, { type: HsLayoutService }, { type: HsLayerManagerService }, { type: HsToolbarPanelContainerService }]; }, { config: [{
            type: Input
        }], layout: [{
            type: ViewChild,
            args: [HsLayoutComponent]
        }] }); })();

class HsAddDataCatalogueMapService {
    constructor(hsMapService, hsLogService, hsSaveMapService, zone) {
        this.hsMapService = hsMapService;
        this.hsLogService = hsLogService;
        this.hsSaveMapService = hsSaveMapService;
        this.zone = zone;
        this.extentLayer = new VectorLayer({
            source: new Vector(),
            style: function (feature, resolution) {
                return [
                    new Style({
                        stroke: new Stroke({
                            color: '#005CB6',
                            width: getHighlighted(feature) ? 4 : 1,
                        }),
                        fill: new Fill({
                            color: 'rgba(0, 0, 255, 0.01)',
                        }),
                    }),
                ];
            },
        });
        setTitle(this.extentLayer, 'Datasources extents');
        setShowInLayerManager(this.extentLayer, false);
        this.hsMapService.loaded().then((map) => this.init(map));
    }
    /**
     * @param evt -
     */
    mapPointerMoved(evt) {
        const featuresUnderMouse = this.extentLayer
            .getSource()
            .getFeaturesAtCoordinate(evt.coordinate);
        const highlightedFeatures = this.extentLayer
            .getSource()
            .getFeatures()
            .filter((feature) => getRecord(feature).highlighted);
        const dontHighlight = highlightedFeatures.filter((feature) => !featuresUnderMouse.includes(feature));
        const highlight = featuresUnderMouse.filter((feature) => !highlightedFeatures.includes(feature));
        if (dontHighlight.length > 0 || highlight.length > 0) {
            this.zone.run(() => {
                for (const feature of highlight) {
                    getRecord(feature).highlighted = true;
                }
                for (const feature of dontHighlight) {
                    getRecord(feature).highlighted = false;
                }
            });
        }
    }
    /**
     * @param map -
     */
    init(map) {
        map.on('pointermove', (evt) => this.mapPointerMoved(evt));
        map.addLayer(this.extentLayer);
        this.hsSaveMapService.internalLayers.push(this.extentLayer);
    }
    clearExtentLayer() {
        this.extentLayer.getSource().clear();
    }
    /**
     * @param dataset - Configuration of selected datasource (from app config)
     * Remove layer extent features from map
     */
    clearDatasetFeatures(dataset) {
        if (dataset.layers) {
            dataset.layers.forEach((val) => {
                try {
                    if (val) {
                        this.extentLayer.getSource().clear();
                    }
                }
                catch (ex) {
                    this.hsLogService.warn(ex);
                }
            });
        }
    }
    /**
     * Test if it possible to zoom to layer overview (bbox has to be defined
     * in metadata of selected layer)
     * @param layer - TODO
     * @returns Returns if bbox is specified and thus layer is zoomable
     */
    isZoomable(layer) {
        return layer.bbox !== undefined;
    }
    /**
     * Callback function which gets executed when extent feature
     * is created. It should add the feature to vector layer source
     * @param extentFeature - OpenLayers Feature
     */
    addExtentFeature(extentFeature) {
        this.extentLayer.getSource().addFeatures([extentFeature]);
    }
    highlightLayer(composition, state) {
        if (composition.feature !== undefined) {
            setHighlighted(composition.feature, state);
        }
    }
    /**
     * ZoomTo / MoveTo to selected layer overview
     * @param bbox - Bounding box of selected layer
     */
    zoomTo(bbox) {
        if (bbox === undefined) {
            return;
        }
        let b = null;
        if (typeof bbox === 'string') {
            b = bbox.split(' ');
        }
        else if (Array.isArray(bbox)) {
            b = bbox;
        }
        let first_pair = [parseFloat(b[0]), parseFloat(b[1])];
        let second_pair = [parseFloat(b[2]), parseFloat(b[3])];
        first_pair = transform(first_pair, 'EPSG:4326', this.hsMapService.map.getView().getProjection());
        second_pair = transform(second_pair, 'EPSG:4326', this.hsMapService.map.getView().getProjection());
        if (isNaN(first_pair[0]) ||
            isNaN(first_pair[1]) ||
            isNaN(second_pair[0]) ||
            isNaN(second_pair[1])) {
            return;
        }
        const extent = [
            first_pair[0],
            first_pair[1],
            second_pair[0],
            second_pair[1],
        ];
        this.hsMapService.fitExtent(extent);
    }
}
HsAddDataCatalogueMapService.ɵfac = function HsAddDataCatalogueMapService_Factory(t) { return new (t || HsAddDataCatalogueMapService)(ɵngcc0.ɵɵinject(HsMapService), ɵngcc0.ɵɵinject(HsLogService), ɵngcc0.ɵɵinject(HsSaveMapService), ɵngcc0.ɵɵinject(ɵngcc0.NgZone)); };
HsAddDataCatalogueMapService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HsAddDataCatalogueMapService_Factory() { return new HsAddDataCatalogueMapService(i0.ɵɵinject(HsMapService), i0.ɵɵinject(HsLogService), i0.ɵɵinject(HsSaveMapService), i0.ɵɵinject(i0.NgZone)); }, token: HsAddDataCatalogueMapService, providedIn: "root" });
HsAddDataCatalogueMapService.ctorParameters = () => [
    { type: HsMapService },
    { type: HsLogService },
    { type: HsSaveMapService },
    { type: NgZone }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsAddDataCatalogueMapService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: HsMapService }, { type: HsLogService }, { type: HsSaveMapService }, { type: ɵngcc0.NgZone }]; }, null); })();

class EndpointsWithDatasourcesPipe {
    transform(endpoints, typeToFilter = 'statusmanager', filterType = 'exclusive') {
        switch (filterType) {
            case 'exclusive':
                return endpoints.filter((ep) => ep.type != typeToFilter);
            case 'inclusive':
                return endpoints.filter((ep) => ep.type == typeToFilter);
            default:
                return endpoints;
        }
    }
}
EndpointsWithDatasourcesPipe.ɵfac = function EndpointsWithDatasourcesPipe_Factory(t) { return new (t || EndpointsWithDatasourcesPipe)(); };
EndpointsWithDatasourcesPipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "endpointsWithDatasources", type: EndpointsWithDatasourcesPipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EndpointsWithDatasourcesPipe, [{
        type: Pipe,
        args: [{
                name: 'endpointsWithDatasources'
            }]
    }], null, null); })();

class HsMickaBrowserService {
    constructor(http, log, hsMapService, hsUtilsService, hsToastService, hsLanguageService) {
        this.http = http;
        this.log = log;
        this.hsMapService = hsMapService;
        this.hsUtilsService = hsUtilsService;
        this.hsToastService = hsToastService;
        this.hsLanguageService = hsLanguageService;
    }
    /**
     * @param dataset - Configuration of selected datasource (from app config)
     * @param data - Query properties
     * @param extentFeatureCreated - Function which gets called
     * @param textField - Name of the field to search in
     * extent feature is created. Has one parameter: feature
     * Loads datasets metadata from selected source (CSW server).
     * Currently supports only "Micka" type of source.
     * Use all query params (search text, bbox, params.., sorting, start)
     * @returns
     */
    queryCatalog(dataset, data, extentFeatureCreated, textField) {
        const url = this.createRequestUrl(dataset, data, textField);
        dataset.datasourcePaging.loaded = false;
        dataset.httpCall = this.http
            .get(url, {
            responseType: 'json',
        })
            .pipe(timeout(5000), map((x) => {
            x.dataset = dataset;
            x.extentFeatureCreated = extentFeatureCreated;
            this.datasetsReceived(x);
            return x;
        }), catchError((e) => {
            var _a, _b, _c;
            if (isErrorHandlerFunction((_a = dataset.onError) === null || _a === void 0 ? void 0 : _a.compositionLoad)) {
                ((_b = dataset.onError) === null || _b === void 0 ? void 0 : _b.compositionLoad).handle(dataset, e);
                return of(e);
            }
            switch ((_c = dataset.onError) === null || _c === void 0 ? void 0 : _c.compositionLoad) {
                case EndpointErrorHandling.ignore:
                    break;
                case EndpointErrorHandling.toast:
                default:
                    this.hsToastService.createToastPopupMessage(this.hsLanguageService.getTranslation('ADDLAYERS.ERROR.errorWhileRequestingLayers'), dataset.title +
                        ': ' +
                        this.hsLanguageService.getTranslationIgnoreNonExisting('ERRORMESSAGES', e.status ? e.status.toString() : e.message, { url: url }), {
                        disableLocalization: true,
                        serviceCalledFrom: 'HsMickaBrowserService',
                    });
            }
            dataset.datasourcePaging.loaded = true;
            return of(e);
        }));
        // .subscribe(()=>{console.log('sub')});
        return dataset.httpCall;
    }
    createRequestUrl(dataset, data, textField) {
        const query = data.query;
        const b = transformExtent(this.hsMapService.map
            .getView()
            .calculateExtent(this.hsMapService.map.getSize()), this.hsMapService.map.getView().getProjection(), 'EPSG:4326');
        const bbox = data.filterByExtent ? "BBOX='" + b.join(' ') + "'" : '';
        const sortBy = query.sortby !== undefined && query.sortby != ''
            ? query.sortby == 'date'
                ? 'date:D'
                : query.sortby
            : 'date:D';
        const text = query.textFilter !== undefined && query.textFilter.length > 0
            ? query.textFilter
            : query.title;
        const sql = [
            // 'validservice>0',
            text != '' ? `${textField} like '*${text}*'` : '',
            bbox,
            //param2Query('type'),
            this.param2Query('ServiceType', query),
            // this.param2Query('topicCategory', query),
            // this.param2Query('Subject', query),
            // this.param2Query('Denominator', query),
            // this.param2Query('OrganisationName', query),
            // this.param2Query('keywords', query),
        ]
            .filter((n) => {
            return n != '';
        })
            .join(' AND ');
        const url = dataset.url +
            '?' +
            this.hsUtilsService.paramsToURL({
                request: 'GetRecords',
                format: 'application/json',
                language: dataset.language,
                query: sql,
                sortby: sortBy,
                limit: dataset.datasourcePaging.limit,
                start: dataset.datasourcePaging.start,
                validservice: '>0',
            });
        return this.hsUtilsService.proxify(url);
    }
    /**
     * @param data - HTTP response containing all the layers
     * Callback for catalogue http query
     */
    datasetsReceived(data) {
        if (!data.dataset || !data.extentFeatureCreated) {
            return;
        }
        const dataset = data.dataset;
        dataset.loading = false;
        dataset.layers = [];
        dataset.datasourcePaging.loaded = true;
        if (data.records.length == 0) {
            dataset.datasourcePaging.matched = 0;
            return false;
        }
        else {
            dataset.datasourcePaging.matched = data.matched;
            dataset.datasourcePaging.next = data.next;
            for (const lyr of data.records) {
                dataset.layers.push(lyr);
                if (data.extentFeatureCreated) {
                    const extentFeature = addExtentFeature(lyr, this.hsMapService.getCurrentProj());
                    if (extentFeature) {
                        lyr.feature = extentFeature;
                        data.extentFeatureCreated(extentFeature);
                    }
                }
            }
            return true;
        }
    }
    /**
     * @param which - Parameter name to parse
     * @param query -
     * @returns
     * Parse query parameter into encoded key value pair.
     */
    param2Query(which, query) {
        const dataset = 'type=dataset OR type=nonGeographicDataset OR type=series OR type=tile';
        if (query[which] !== undefined) {
            if (which == 'type' && query[which] == 'data') {
                //Special case for type 'data' because it can contain many things
                return `(${dataset})`;
            }
            return query[which] != '' ? which + "='" + query[which] + "'" : '';
        }
        else {
            if (which == 'ServiceType') {
                const service = 'type=service';
                switch (query.type) {
                    case 'service':
                        return `(${service})`;
                    case 'dataset':
                        return `(${dataset})`;
                    case 'all':
                    default:
                        return `(${service} OR ${dataset})`;
                }
            }
            else {
                return '';
            }
        }
    }
    /**
     * @param type -
     * @param layer - Micka layer for which to get metadata
     * @param type - Optional service type specification
     * @returns Url of service or resource
     * Get first link from records links array or link
     * property of record in older Micka versions
     * in a common format for use in add-layers component
     */
    getLayerLink(layer, type) {
        var _a;
        if (((_a = layer.links) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            if (type) {
                layer.links = layer.links.filter((link) => link.url.toLowerCase().includes(type) ||
                    (!Array.isArray(link) && link.includes(type)));
            }
            if (layer.links[0].url !== undefined) {
                return layer.links[0].url;
            }
            else {
                return layer.links[0];
            }
        }
        if (layer.link) {
            return layer.link;
        }
        this.log.warn('Layer does not contain any links or link properties');
    }
    /**
     * @param ds - Configuration of selected datasource (from app config)
     * @param layer - Micka layer for which to get metadata
     * @returns Promise which describes layer
     * in a common format for use in add-layers component
     * Gets layer metadata and returns promise which describes layer
     * in a common format for use in add-layers component
     */
    describeWhatToAdd(ds, layer) {
        return __awaiter(this, void 0, void 0, function* () {
            let whatToAdd = { type: 'none' };
            const type = layer.type || layer.trida;
            const layerLink = this.getLayerLink(layer);
            if (!layerLink) {
                return false;
            }
            if (type == 'service') {
                if (['WMS', 'OGC:WMS', 'view'].includes(layer.serviceType)) {
                    whatToAdd.type = 'WMS';
                    whatToAdd.link = layerLink;
                }
                else if (layerLink.toLowerCase().includes('sparql')) {
                    whatToAdd = {
                        type: 'sparql',
                        link: layerLink,
                        projection: 'EPSG:4326',
                    };
                }
                else if (['WFS', 'OGC:WFS', 'download'].includes(layer.serviceType)) {
                    whatToAdd.type = 'WFS';
                    whatToAdd.link = layerLink;
                    whatToAdd.dsType = ds.type;
                }
                else if (layer.formats &&
                    ['kml', 'geojson', 'json'].includes(layer.formats[0].toLowerCase())) {
                    whatToAdd = {
                        type: layer.formats[0].toUpperCase() == 'KML' ? 'kml' : 'geojson',
                        link: layerLink,
                        projection: 'EPSG:4326',
                        extractStyles: layer.formats[0].toLowerCase() == 'kml',
                    };
                }
                else {
                    alert(`Service type "${layer.serviceType}" not supported.`);
                    return false;
                }
            }
            else if (type == 'dataset') {
                if (layer.links) {
                    //Filter invalid links
                    //TODO: possible kml, geojson, shp
                    layer.links = layer.links.filter((link) => ['wms', 'wfs'].some((type) => { var _a; return (_a = link.protocol) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(type); }));
                    //Check WMS endpoints
                    if (layer.links.some((link) => { var _a; return (_a = link.protocol) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes('wms'); })) {
                        whatToAdd = {
                            type: 'WMS',
                        };
                    }
                    //Check WFS endpoints
                    if (layer.links.some((link) => { var _a; return (_a = link.protocol) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes('wfs'); })) {
                        whatToAdd.type = whatToAdd.type == 'WMS' ? ['WMS', 'WFS'] : 'WFS';
                    }
                    //Parse links
                    whatToAdd.link = Array.isArray(whatToAdd.type)
                        ? layer.links.map((link) => link.url)
                        : this.getLayerLink(layer, 'wfs');
                }
                else {
                    return false;
                }
                // else if (
                //   ['kml', 'geojson', 'json'].includes(layer.formats[0].toLowerCase())
                // ) {
                //   whatToAdd = {
                //     type: layer.formats[0].toUpperCase() == 'KML' ? 'kml' : 'geojson',
                //     link: layerLink,
                //     projection: 'EPSG:4326',
                //     extractStyles: layer.formats[0].toLowerCase() == 'kml',
                //   };
                // }
            }
            else {
                alert(`Datasource type "${type}" not supported.`);
                return false;
            }
            whatToAdd.title = layer.title || 'Layer';
            whatToAdd.name = layer.title || 'Layer';
            whatToAdd.abstract = layer.abstract || 'Layer';
            return whatToAdd;
        });
    }
}
HsMickaBrowserService.ɵfac = function HsMickaBrowserService_Factory(t) { return new (t || HsMickaBrowserService)(ɵngcc0.ɵɵinject(ɵngcc2.HttpClient), ɵngcc0.ɵɵinject(HsLogService), ɵngcc0.ɵɵinject(HsMapService), ɵngcc0.ɵɵinject(HsUtilsService), ɵngcc0.ɵɵinject(HsToastService), ɵngcc0.ɵɵinject(HsLanguageService)); };
HsMickaBrowserService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HsMickaBrowserService_Factory() { return new HsMickaBrowserService(i0.ɵɵinject(i1$1.HttpClient), i0.ɵɵinject(HsLogService), i0.ɵɵinject(HsMapService), i0.ɵɵinject(HsUtilsService), i0.ɵɵinject(HsToastService), i0.ɵɵinject(HsLanguageService)); }, token: HsMickaBrowserService, providedIn: "root" });
HsMickaBrowserService.ctorParameters = () => [
    { type: HttpClient },
    { type: HsLogService },
    { type: HsMapService },
    { type: HsUtilsService },
    { type: HsToastService },
    { type: HsLanguageService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsMickaBrowserService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc2.HttpClient }, { type: HsLogService }, { type: HsMapService }, { type: HsUtilsService }, { type: HsToastService }, { type: HsLanguageService }]; }, null); })();

class HsAddDataCatalogueService {
    constructor(hsConfig, hsAddDataVectorService, hsEventBusService, hsMickaBrowserService, hsLaymanBrowserService, hsLayoutService, hsCommonEndpointsService, hsUtilsService, hsMapService, hsAddDataCatalogueMapService, hsAddDataService, endpointsWithDatasourcesPipe, zone, hsCommonLaymanService) {
        this.hsConfig = hsConfig;
        this.hsAddDataVectorService = hsAddDataVectorService;
        this.hsEventBusService = hsEventBusService;
        this.hsMickaBrowserService = hsMickaBrowserService;
        this.hsLaymanBrowserService = hsLaymanBrowserService;
        this.hsLayoutService = hsLayoutService;
        this.hsCommonEndpointsService = hsCommonEndpointsService;
        this.hsUtilsService = hsUtilsService;
        this.hsMapService = hsMapService;
        this.hsAddDataCatalogueMapService = hsAddDataCatalogueMapService;
        this.hsAddDataService = hsAddDataService;
        this.endpointsWithDatasourcesPipe = endpointsWithDatasourcesPipe;
        this.zone = zone;
        this.hsCommonLaymanService = hsCommonLaymanService;
        this.data = {};
        this.catalogEntries = [];
        this.itemsPerPage = 20;
        this.listStart = 0;
        this.listNext = this.itemsPerPage;
        this.extentChangeSuppressed = false;
        this.data.query = {
            textFilter: '',
            title: '',
            type: 'service',
            Subject: '',
            sortby: 'date',
        };
        this.data.textField = 'AnyText';
        this.data.selectedLayer = null;
        this.data.wms_connecting = false;
        this.data.id_selected = 'OWS';
        this.data.filterByExtent = true;
        this.data.onlyMine = false;
        if (this.dataSourceExistsAndEmpty() && this.panelVisible()) {
            this.queryCatalogs();
            // this.hsMickaFilterService.fillCodesets();
        }
        if (this.hsConfig.allowAddExternalDatasets === undefined) {
            this.hsConfig.allowAddExternalDatasets = true;
        }
        this.endpointsWithDatasources = this.endpointsWithDatasourcesPipe.transform(this.hsCommonEndpointsService.endpoints);
        this.hsEventBusService.mapExtentChanges.subscribe(this.hsUtilsService.debounce((e) => {
            if (!this.panelVisible() || this.extentChangeSuppressed) {
                this.extentChangeSuppressed = false;
                return;
            }
            if (this.data.filterByExtent) {
                this.zone.run(() => {
                    this.reloadData();
                });
            }
        }, 500, false, this));
        this.hsEventBusService.mainPanelChanges.subscribe(() => {
            if (this.dataSourceExistsAndEmpty() && this.panelVisible()) {
                this.reloadData();
                this.extentChangeSuppressed = true;
            }
            this.calcExtentLayerVisibility();
        });
        this.hsCommonLaymanService.authChange.subscribe(() => {
            if (this.panelVisible()) {
                this.reloadData();
            }
        });
        this.hsAddDataService.datasetSelected.subscribe(({ type }) => {
            if (type == 'catalogue' && this.panelVisible()) {
                this.reloadData();
            }
        });
    }
    resetList() {
        this.listStart = 0;
        this.listNext = this.itemsPerPage;
        this.selectedLayer = {};
        this.endpointsWithDatasources.forEach((ep) => {
            ep.datasourcePaging.start = 0;
            ep.datasourcePaging.next = ep.datasourcePaging.limit;
            ep.datasourcePaging.matched = 0;
        });
    }
    reloadData() {
        this.endpointsWithDatasources = this.endpointsWithDatasourcesPipe.transform(this.hsCommonEndpointsService.endpoints);
        this.resetList();
        this.queryCatalogs();
        // this.hsMickaFilterService.fillCodesets();
        this.calcExtentLayerVisibility();
    }
    /**
     * Queries all configured catalogs for datasources (layers)
     * @param suspendLimitCalculation -
     */
    queryCatalogs(suspendLimitCalculation) {
        if (this.endpointsWithDatasources.length > 0) {
            if (this.catalogQuery) {
                this.catalogQuery.unsubscribe();
                delete this.catalogQuery;
            }
            this.clearLoadedData();
            this.hsMapService.loaded().then(() => {
                this.dataLoading = true;
                this.hsAddDataCatalogueMapService.clearExtentLayer();
                const observables = [];
                //TODO Mark non functional endpoint
                for (const endpoint of this.endpointsWithDatasources) {
                    if (!this.data.onlyMine || endpoint.type == 'layman') {
                        const promise = this.queryCatalog(endpoint);
                        observables.push(promise);
                    }
                }
                this.catalogQuery = forkJoin(observables).subscribe(() => {
                    suspendLimitCalculation
                        ? this.createLayerList()
                        : this.calculateEndpointLimits();
                });
            });
        }
    }
    /**
     * Calculates each endpoint layer request limit, based on the matched layers ratio
     * from all endpoint matched layers
     */
    calculateEndpointLimits() {
        this.matchedRecords = 0;
        this.itemsPerPage = 20;
        this.endpointsWithDatasources = this.endpointsWithDatasources.filter((ep) => ep.datasourcePaging.matched != 0);
        if (this.endpointsWithDatasources.length == 0) {
            this.dataLoading = false;
            return;
        }
        this.endpointsWithDatasources.forEach((ep) => (this.matchedRecords += ep.datasourcePaging.matched));
        let sumLimits = 0;
        this.endpointsWithDatasources.forEach((ep) => {
            ep.datasourcePaging.limit = Math.floor((ep.datasourcePaging.matched / this.matchedRecords) * this.itemsPerPage);
            if (ep.datasourcePaging.limit == 0) {
                ep.datasourcePaging.limit = 1;
            }
            sumLimits += ep.datasourcePaging.limit;
        });
        this.itemsPerPage = sumLimits;
        this.queryCatalogs(true);
    }
    createLayerList() {
        for (const endpoint of this.endpointsWithDatasources) {
            if (!this.data.onlyMine || endpoint.type == 'layman') {
                if (endpoint.layers) {
                    endpoint.layers.forEach((layer) => {
                        layer.endpoint = endpoint;
                        // this.catalogEntries.push(layer);
                    });
                    if (this.catalogEntries.length > 0) {
                        this.filterDuplicates(endpoint);
                    }
                    else {
                        this.catalogEntries = this.catalogEntries.concat(endpoint.layers);
                    }
                }
            }
        }
        if (this.matchedRecords < this.itemsPerPage) {
            this.listNext = this.matchedRecords;
        }
        this.catalogEntries.sort((a, b) => a.title.localeCompare(b.title));
        this.dataLoading = false;
    }
    filterDuplicates(endpoint) {
        var _a;
        if (endpoint.layers === undefined || ((_a = endpoint.layers) === null || _a === void 0 ? void 0 : _a.length) == 0) {
            return [];
        }
        const filteredLayers = endpoint.layers.filter((layer) => this.catalogEntries.filter((u) => u.id == layer.id).length == 0);
        if (endpoint.type != 'layman') {
            this.matchedRecords -= endpoint.layers.length - filteredLayers.length;
        }
        this.catalogEntries = this.catalogEntries.concat(filteredLayers);
    }
    getNextRecords() {
        this.listStart += this.itemsPerPage;
        this.listNext += this.itemsPerPage;
        if (this.listNext > this.matchedRecords) {
            this.listNext = this.matchedRecords;
        }
        this.endpointsWithDatasources.forEach((ep) => (ep.datasourcePaging.start += ep.datasourcePaging.limit));
        this.queryCatalogs(true);
    }
    getPreviousRecords() {
        if (this.listStart - this.itemsPerPage <= 0) {
            this.listStart = 0;
            this.listNext = this.itemsPerPage;
            this.endpointsWithDatasources.forEach((ep) => (ep.datasourcePaging.start = 0));
        }
        else {
            this.listStart -= this.itemsPerPage;
            this.listNext = this.listStart + this.itemsPerPage;
            this.endpointsWithDatasources.forEach((ep) => (ep.datasourcePaging.start -= ep.datasourcePaging.limit));
        }
        this.queryCatalogs(true);
    }
    clearLoadedData() {
        this.catalogEntries = [];
        this.endpointsWithDatasources.forEach((ep) => (ep.layers = []));
    }
    /**
     * Loads datasets metadata from selected source (CSW server).
     * Uses pagination set by 'start' attribute of 'dataset' param.
     * Currently supports only "Micka" type of source.
     * Use all query params (search text, bbox, params.., sorting, start)
     * @param catalog - Configuration of selected datasource (from app config)
     */
    queryCatalog(catalog) {
        this.hsAddDataCatalogueMapService.clearDatasetFeatures(catalog);
        let query;
        switch (catalog.type) {
            case 'micka':
                query = this.hsMickaBrowserService.queryCatalog(catalog, this.data, (feature) => this.hsAddDataCatalogueMapService.addExtentFeature(feature), this.data.textField);
                return query;
            case 'layman':
                query = this.hsLaymanBrowserService.queryCatalog(catalog, this.data, (feature) => this.hsAddDataCatalogueMapService.addExtentFeature(feature));
                return query;
            default:
                break;
        }
    }
    /**
     * Test if layer of selected record is downloadable (KML and JSON files, with direct URL) and gives URL.
     * @param ds - Datasource of selected layer
     * @param layer - Metadata record of selected layer
     * @returns Download URL of layer if possible
     */
    layerDownload(ds, layer) {
        if (ds.download == true) {
            if (['kml', 'geojson', 'json'].includes(layer.formats[0].toLowerCase()) &&
                layer.url.length > 0) {
                return layer.url;
            }
        }
        return '#';
    }
    /**
     * Get URL for RDF-DCAT record of selected layer
     * @param ds - Datasource of selected layer
     * @param layer - Metadata record of selected layer
     * @returns URL to record file
     */
    layerRDF(ds, layer) {
        return `${ds.url}?request=GetRecordById&id=${layer.id}&outputschema=http://www.w3.org/ns/dcat%23`;
    }
    /**
     * Add selected layer to map (into layer manager) if possible
     * @param ds - Datasource of selected layer
     * @param layer - Metadata record of selected layer
     * @param type - Type of layer (supported values: WMS, WFS, Sparql, kml, geojson, json)
     * @returns Type or array of types in which this layer can be added to map
     */
    addLayerToMap(ds, layer, type) {
        return __awaiter(this, void 0, void 0, function* () {
            let whatToAdd;
            if (ds.type == 'micka') {
                whatToAdd = yield this.hsMickaBrowserService.describeWhatToAdd(ds, layer);
            }
            else if (ds.type == 'layman') {
                whatToAdd = yield this.hsLaymanBrowserService.describeWhatToAdd(ds, layer);
            }
            else {
                whatToAdd = { type: 'none' };
            }
            if (!whatToAdd) {
                return;
            }
            if (type) {
                whatToAdd.type = type;
            }
            if (Array.isArray(whatToAdd.type)) {
                return whatToAdd.type;
            }
            if (whatToAdd.type == 'WMS') {
                whatToAdd.link = Array.isArray(whatToAdd.link)
                    ? whatToAdd.link.filter((link) => link.toLowerCase().includes('wms'))[0]
                    : whatToAdd.link;
                this.datasetSelect('url');
                setTimeout(() => {
                    this.hsEventBusService.owsFilling.next({
                        type: whatToAdd.type.toLowerCase(),
                        uri: decodeURIComponent(whatToAdd.link),
                        layer: ds.type == 'layman' ? layer.name : undefined,
                    });
                });
            }
            else if (whatToAdd.type == 'WFS') {
                this.datasetSelect('url');
                if (ds.type == 'micka') {
                    whatToAdd.link = Array.isArray(whatToAdd.link)
                        ? whatToAdd.link.filter((link) => link.toLowerCase().includes('wfs'))[0]
                        : whatToAdd.link;
                    setTimeout(() => {
                        this.hsEventBusService.owsFilling.next({
                            type: whatToAdd.type.toLowerCase(),
                            uri: decodeURIComponent(whatToAdd.link),
                            layer: undefined, //layer.title || layer.name ||
                        });
                    });
                }
                else {
                    //Layman layers of logged user/ with write access
                    if (whatToAdd.editable) {
                        const layer = yield this.hsAddDataVectorService.addVectorLayer('wfs', whatToAdd.link.replace('_wms/ows', '/wfs'), whatToAdd.name, whatToAdd.title, whatToAdd.abstract, whatToAdd.projection, {
                            extractStyles: whatToAdd.extractStyles,
                            workspace: whatToAdd.workspace,
                            sld: whatToAdd.sld,
                        });
                        this.hsAddDataVectorService.fitExtent(layer);
                    }
                    else {
                        //Layman layers without write access
                        setTimeout(() => {
                            this.hsEventBusService.owsFilling.next({
                                type: 'wfs',
                                uri: whatToAdd.link.replace('_wms/ows', '/wfs'),
                                sld: whatToAdd.sld,
                                layer: `${whatToAdd.workspace}:${whatToAdd.name}`,
                            });
                        });
                    }
                    this.hsLayoutService.setMainPanel('layermanager');
                }
            }
            else if (['KML', 'GEOJSON'].includes(whatToAdd.type)) {
                const layer = yield this.hsAddDataVectorService.addVectorLayer(whatToAdd.type.toLowerCase(), whatToAdd.link, whatToAdd.name, whatToAdd.title, whatToAdd.abstract, whatToAdd.projection, { extractStyles: whatToAdd.extractStyles });
                this.hsAddDataVectorService.fitExtent(layer);
            }
            else {
                this.hsLayoutService.setMainPanel('layermanager');
            }
            return whatToAdd.type;
        });
    }
    datasetSelect(id_selected) {
        this.data.wms_connecting = false;
        this.data.id_selected = id_selected;
        this.hsAddDataService.selectType(id_selected);
        this.calcExtentLayerVisibility();
    }
    /**
     * Clear query variable
     */
    clear() {
        this.data.query.textFilter = '';
        this.data.query.title = '';
        this.data.query.Subject = '';
        this.data.query.keywords = '';
        this.data.query.OrganisationName = '';
        this.data.query.sortby = '';
    }
    /**
     *
     */
    dataSourceExistsAndEmpty() {
        return !!this.endpointsWithDatasources;
    }
    /**
     *
     */
    panelVisible() {
        return this.hsLayoutService.panelVisible('addData');
    }
    calcExtentLayerVisibility() {
        this.hsAddDataCatalogueMapService.extentLayer.setVisible(this.panelVisible() && this.hsAddDataService.typeSelected == 'catalogue');
    }
}
HsAddDataCatalogueService.ɵfac = function HsAddDataCatalogueService_Factory(t) { return new (t || HsAddDataCatalogueService)(ɵngcc0.ɵɵinject(HsConfig), ɵngcc0.ɵɵinject(HsAddDataVectorService), ɵngcc0.ɵɵinject(HsEventBusService), ɵngcc0.ɵɵinject(HsMickaBrowserService), ɵngcc0.ɵɵinject(HsLaymanBrowserService), ɵngcc0.ɵɵinject(HsLayoutService), ɵngcc0.ɵɵinject(HsCommonEndpointsService), ɵngcc0.ɵɵinject(HsUtilsService), ɵngcc0.ɵɵinject(HsMapService), ɵngcc0.ɵɵinject(HsAddDataCatalogueMapService), ɵngcc0.ɵɵinject(HsAddDataService), ɵngcc0.ɵɵinject(EndpointsWithDatasourcesPipe), ɵngcc0.ɵɵinject(ɵngcc0.NgZone), ɵngcc0.ɵɵinject(HsCommonLaymanService)); };
HsAddDataCatalogueService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HsAddDataCatalogueService_Factory() { return new HsAddDataCatalogueService(i0.ɵɵinject(HsConfig), i0.ɵɵinject(HsAddDataVectorService), i0.ɵɵinject(HsEventBusService), i0.ɵɵinject(HsMickaBrowserService), i0.ɵɵinject(HsLaymanBrowserService), i0.ɵɵinject(HsLayoutService), i0.ɵɵinject(HsCommonEndpointsService), i0.ɵɵinject(HsUtilsService), i0.ɵɵinject(HsMapService), i0.ɵɵinject(HsAddDataCatalogueMapService), i0.ɵɵinject(HsAddDataService), i0.ɵɵinject(EndpointsWithDatasourcesPipe), i0.ɵɵinject(i0.NgZone), i0.ɵɵinject(HsCommonLaymanService)); }, token: HsAddDataCatalogueService, providedIn: "root" });
HsAddDataCatalogueService.ctorParameters = () => [
    { type: HsConfig },
    { type: HsAddDataVectorService },
    { type: HsEventBusService },
    { type: HsMickaBrowserService },
    { type: HsLaymanBrowserService },
    { type: HsLayoutService },
    { type: HsCommonEndpointsService },
    { type: HsUtilsService },
    { type: HsMapService },
    { type: HsAddDataCatalogueMapService },
    { type: HsAddDataService },
    { type: EndpointsWithDatasourcesPipe },
    { type: NgZone },
    { type: HsCommonLaymanService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsAddDataCatalogueService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: HsConfig }, { type: HsAddDataVectorService }, { type: HsEventBusService }, { type: HsMickaBrowserService }, { type: HsLaymanBrowserService }, { type: HsLayoutService }, { type: HsCommonEndpointsService }, { type: HsUtilsService }, { type: HsMapService }, { type: HsAddDataCatalogueMapService }, { type: HsAddDataService }, { type: EndpointsWithDatasourcesPipe }, { type: ɵngcc0.NgZone }, { type: HsCommonLaymanService }]; }, null); })();

// import {HsDragDropLayerService} from './drag-drop-layer.service';
class HsAddDataCatalogueComponent {
    constructor(hsLanguageService, hsCommonEndpointsService, //Used in template
    hsConfig, //Used in template
    hsCore, //Used in template
    hsAddDataCatalogueService, hsAddDataCatalogueMapService, //Used in template
    hsEventBusService, hsLayoutService, hsUtilsService, hsLaymanService //Used in template
    ) {
        this.hsLanguageService = hsLanguageService;
        this.hsCommonEndpointsService = hsCommonEndpointsService;
        this.hsConfig = hsConfig;
        this.hsCore = hsCore;
        this.hsAddDataCatalogueService = hsAddDataCatalogueService;
        this.hsAddDataCatalogueMapService = hsAddDataCatalogueMapService;
        this.hsEventBusService = hsEventBusService;
        this.hsLayoutService = hsLayoutService;
        this.hsUtilsService = hsUtilsService;
        this.hsLaymanService = hsLaymanService;
        this.textFieldTypes = ['AnyText', 'Abstract', 'Title'];
        this.dataTypes = ['all', 'service', 'dataset'];
        this.sortbyTypes = ['date', 'title', 'bbox'];
        this.optionsButtonLabel = 'more';
        this.data = hsAddDataCatalogueService.data;
        this.advancedSearch = false;
        this.queryCatalogs = () => hsAddDataCatalogueService.queryCatalogs();
        this.owsConnectingSubscription =
            this.hsEventBusService.owsConnecting.subscribe(({ type, uri, layer }) => {
                if (type == 'wms') {
                    this.data.wms_connecting = true;
                }
            });
        this.loaderImage =
            this.hsUtilsService.getAssetsPath() + 'img/ajax-loader.gif';
    }
    ngOnDestroy() {
        this.owsConnectingSubscription.unsubscribe();
    }
    layerSelected(layer) {
        this.hsAddDataCatalogueService.selectedLayer =
            this.hsAddDataCatalogueService.selectedLayer == layer
                ? {}
                : layer;
    }
    translateString(module, text) {
        return this.hsLanguageService.getTranslationIgnoreNonExisting(module, text);
    }
    openOptionsMenu() {
        this.filterTypeMenu = !this.filterTypeMenu;
        if (this.filterTypeMenu) {
            this.optionsButtonLabel = 'less';
        }
        else {
            this.optionsButtonLabel = 'more';
        }
    }
    queryByFilter() {
        this.hsAddDataCatalogueService.reloadData();
    }
    selectType(type) {
        this.data.textField = type;
        if (this.data.query.textFilter.length > 0) {
            this.queryByFilter();
        }
        this.filterTypeMenu = !this.filterTypeMenu;
    }
    selectQueryType(type, query) {
        this.data.query[query] = type;
        this.queryByFilter();
        this.filterTypeMenu = !this.filterTypeMenu;
    }
    highlightLayer(layer, state) {
        layer.highlighted = state;
        this.hsAddDataCatalogueMapService.highlightLayer(layer, state);
    }
    datasetSelect(id_selected, endpoint) {
        this.hsAddDataCatalogueService.datasetSelect(id_selected);
        if (endpoint) {
            this.hsAddDataCatalogueService.selectedEndpoint = endpoint;
        }
    }
}
HsAddDataCatalogueComponent.ɵfac = function HsAddDataCatalogueComponent_Factory(t) { return new (t || HsAddDataCatalogueComponent)(ɵngcc0.ɵɵdirectiveInject(HsLanguageService), ɵngcc0.ɵɵdirectiveInject(HsCommonEndpointsService), ɵngcc0.ɵɵdirectiveInject(HsConfig), ɵngcc0.ɵɵdirectiveInject(HsCoreService), ɵngcc0.ɵɵdirectiveInject(HsAddDataCatalogueService), ɵngcc0.ɵɵdirectiveInject(HsAddDataCatalogueMapService), ɵngcc0.ɵɵdirectiveInject(HsEventBusService), ɵngcc0.ɵɵdirectiveInject(HsLayoutService), ɵngcc0.ɵɵdirectiveInject(HsUtilsService), ɵngcc0.ɵɵdirectiveInject(HsLaymanService)); };
HsAddDataCatalogueComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsAddDataCatalogueComponent, selectors: [["hs-add-data-catalogue"]], decls: 67, vars: 40, consts: [[1, "card", "hs-main-panel"], [1, "mt-3", "mx-3", "pl-1", "d-flex", "justify-content-between"], [1, "input-group", "w-50"], ["type", "search", "name", "search", 1, "form-control", "w-50", 3, "placeholder", "ngModel", "ngModelChange"], [1, "input-group-append"], [1, "btn", "input-group-text", "text-secondary", "hs-light-background", "border-left-0", 3, "click"], [1, "icon-search", "icon-primary"], [3, "endpoint"], [1, "d-flex", "ml-4", "mr-3", "justify-content-between", "py-1"], [1, "d-flex"], [1, "input-group-text", "border-0", "pl-0"], ["type", "checkbox", "name", "filterByExtent", 3, "ngModel", "ngModelChange", "change"], [1, "ml-1"], ["class", "input-group-text border-0", 4, "ngIf"], ["ngbDropdown", "", "display", "dynamic", "placement", "bottom-right", 1, "d-inline-block"], ["ngbDropdownToggle", "", 1, "btn", "btn-light", "hs-white-background", "hs-custom-toggle", 3, "click"], ["ngbDropdownMenu", "", "aria-labelledby", "filtersDropdown", 1, "dropdown-menu-right", "p-2", "m-1", 2, "min-width", "23rem", "max-width", "23rem", "overflow", "visible"], [1, "p-1", "pl-3", 2, "border-collapse", "separate", "border-spacing", "0.5rem 0.5rem"], [1, "tdbreak"], ["ngbDropdown", "", "display", "dynamic", "placement", "bottom-right"], ["searchTypeDropdown", "ngbDropdown"], ["type", "button", "ngbDropdownToggle", "", 1, "btn", "btn-light", "btn-sm", "hs-custom-toggle", "hs-background-alfa", "p-2", "pl-1", "border-0", 2, "text-align", "start", "min-width", "11rem", "max-width", "11rem", "border-radius", "0px", "justify-content", "space-between", "display", "flex", "align-items", "center"], ["ngbDropdownMenu", "", "aria-labelledby", "searchType", 1, "pl-2", 2, "overflow-y", "auto", "max-height", "10rem", "min-width", "10rem"], [4, "ngFor", "ngForOf"], ["resourceType", "ngbDropdown"], ["ngbDropdownMenu", "", "aria-labelledby", "type", 1, "pl-2", 2, "overflow-y", "auto", "max-height", "10rem", "min-width", "10rem"], ["sortByDrop", "ngbDropdown"], ["ngbDropdownMenu", "", "aria-labelledby", "sortBy", 1, "pl-2", 2, "overflow-y", "auto", "max-height", "10rem", "min-width", "10rem"], [1, "tab-content"], [1, "card", "d-flex", 2, "font-size", "1rem !important"], [1, "card-body"], [1, "list-group"], [1, "list-group-item", "text-primary", "text-center", "py-2", 3, "hidden"], [1, "pr-2", 3, "src"], [1, "list-group-item", 3, "hidden"], ["style", "cursor: pointer;", "class", "clearfix list-group-item", 3, "hidden", "ngClass", "click", "mouseover", "mouseleave", 4, "ngFor", "ngForOf", "ngForTrackBy"], [3, "pagerService"], [1, "input-group-text", "border-0"], ["type", "checkbox", "name", "onlyMine", 3, "ngModel", "ngModelChange"], [2, "cursor", "pointer"], ["type", "radio", "name", "searchType-index", 1, "mr-2", 3, "checked", "change"], ["type", "radio", "name", "type-index", 1, "mr-2", 3, "checked", "change"], ["type", "radio", "name", "sort-index", 1, "mr-2", 3, "checked", "change"], [1, "clearfix", "list-group-item", 2, "cursor", "pointer", 3, "hidden", "ngClass", "click", "mouseover", "mouseleave"], [3, "layer"]], template: function HsAddDataCatalogueComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "input", 3);
        ɵngcc0.ɵɵlistener("ngModelChange", function HsAddDataCatalogueComponent_Template_input_ngModelChange_3_listener($event) { return ctx.data.query.textFilter = $event; })("ngModelChange", function HsAddDataCatalogueComponent_Template_input_ngModelChange_3_listener() { return ctx.queryByFilter(); });
        ɵngcc0.ɵɵpipe(4, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 4);
        ɵngcc0.ɵɵelementStart(6, "button", 5);
        ɵngcc0.ɵɵlistener("click", function HsAddDataCatalogueComponent_Template_button_click_6_listener() { return ctx.queryByFilter(); });
        ɵngcc0.ɵɵelement(7, "i", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(8, "hs-layman-current-user", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "div", 8);
        ɵngcc0.ɵɵelementStart(10, "div", 9);
        ɵngcc0.ɵɵelementStart(11, "div", 10);
        ɵngcc0.ɵɵelementStart(12, "input", 11);
        ɵngcc0.ɵɵlistener("ngModelChange", function HsAddDataCatalogueComponent_Template_input_ngModelChange_12_listener($event) { return ctx.data.filterByExtent = $event; })("change", function HsAddDataCatalogueComponent_Template_input_change_12_listener() { return ctx.queryByFilter(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(13, "span", 12);
        ɵngcc0.ɵɵtext(14);
        ɵngcc0.ɵɵpipe(15, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(16, HsAddDataCatalogueComponent_div_16_Template, 5, 4, "div", 13);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(17, "div", 14);
        ɵngcc0.ɵɵelementStart(18, "button", 15);
        ɵngcc0.ɵɵlistener("click", function HsAddDataCatalogueComponent_Template_button_click_18_listener() { return ctx.openOptionsMenu(); });
        ɵngcc0.ɵɵtext(19);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(20, "div", 16);
        ɵngcc0.ɵɵelementStart(21, "table", 17);
        ɵngcc0.ɵɵelementStart(22, "tbody");
        ɵngcc0.ɵɵelementStart(23, "tr");
        ɵngcc0.ɵɵelementStart(24, "td", 18);
        ɵngcc0.ɵɵtext(25);
        ɵngcc0.ɵɵpipe(26, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(27, "td", 19, 20);
        ɵngcc0.ɵɵelementStart(29, "button", 21);
        ɵngcc0.ɵɵtext(30);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(31, "ul", 22);
        ɵngcc0.ɵɵtemplate(32, HsAddDataCatalogueComponent_li_32_Template, 4, 2, "li", 23);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(33, "tr");
        ɵngcc0.ɵɵelementStart(34, "td", 18);
        ɵngcc0.ɵɵtext(35);
        ɵngcc0.ɵɵpipe(36, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(37, "td", 19, 24);
        ɵngcc0.ɵɵelementStart(39, "button", 21);
        ɵngcc0.ɵɵtext(40);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(41, "ul", 25);
        ɵngcc0.ɵɵtemplate(42, HsAddDataCatalogueComponent_li_42_Template, 4, 2, "li", 23);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(43, "tr");
        ɵngcc0.ɵɵelementStart(44, "td", 18);
        ɵngcc0.ɵɵtext(45);
        ɵngcc0.ɵɵpipe(46, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(47, "td", 19, 26);
        ɵngcc0.ɵɵelementStart(49, "button", 21);
        ɵngcc0.ɵɵtext(50);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(51, "ul", 27);
        ɵngcc0.ɵɵtemplate(52, HsAddDataCatalogueComponent_li_52_Template, 4, 2, "li", 23);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(53, "div", 28);
        ɵngcc0.ɵɵelementStart(54, "div", 29);
        ɵngcc0.ɵɵelementStart(55, "div", 30);
        ɵngcc0.ɵɵelementStart(56, "ul", 31);
        ɵngcc0.ɵɵelementStart(57, "li", 32);
        ɵngcc0.ɵɵelement(58, "img", 33);
        ɵngcc0.ɵɵtext(59);
        ɵngcc0.ɵɵpipe(60, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(61, "li", 34);
        ɵngcc0.ɵɵtext(62);
        ɵngcc0.ɵɵpipe(63, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(64, HsAddDataCatalogueComponent_li_64_Template, 2, 5, "li", 35);
        ɵngcc0.ɵɵpipe(65, "trackByProperty");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(66, "hs-pager", 36);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("placeholder", ɵngcc0.ɵɵpipeBind1(4, 24, "COMMON.search"))("ngModel", ctx.data.query.textFilter);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("endpoint", ctx.hsLaymanService.getLaymanEndpoint());
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngModel", ctx.data.filterByExtent);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(15, 26, "COMPOSITIONS.filterByMap"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hsLaymanService.getLaymanEndpoint() && !ctx.hsLaymanService.isLaymanGuest());
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.translateString("COMMON", ctx.optionsButtonLabel));
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(26, 28, "ADDDATA.CATALOGUE.filterType"), " ");
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.translateString("ADDDATA.CATALOGUE.searchFilterTypes", ctx.data.textField), " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.textFieldTypes);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(36, 30, "ADDDATA.CATALOGUE.resourceType"), " ");
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.translateString("ADDDATA.CATALOGUE.queryDataTypes", ctx.data.query.type), " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.dataTypes);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(46, 32, "COMMON.sortBy"), " ");
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.translateString("ADDDATA.CATALOGUE.sortbyTypes", ctx.data.query.sortby), " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.sortbyTypes);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("hidden", !ctx.hsAddDataCatalogueService.dataLoading);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("src", ctx.loaderImage, ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(60, 34, "ADDDATA.CATALOGUE.loading"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("hidden", ctx.hsAddDataCatalogueService.catalogEntries.length > 0 || ctx.hsAddDataCatalogueService.dataLoading);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(63, 36, "DATASOURCE_SELECTOR.noResults"), "");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.hsAddDataCatalogueService.catalogEntries)("ngForTrackBy", ɵngcc0.ɵɵpipeBind1(65, 38, "id"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("pagerService", ctx.hsAddDataCatalogueService);
    } }, directives: function () { return [ɵngcc5.DefaultValueAccessor, ɵngcc5.NgControlStatus, ɵngcc5.NgModel, HsLaymanCurrentUserComponent, ɵngcc5.CheckboxControlValueAccessor, ɵngcc3.NgIf, ɵngcc6.NgbDropdown, ɵngcc6.NgbDropdownToggle, ɵngcc6.NgbDropdownMenu, ɵngcc3.NgForOf, HsPagerComponent, ɵngcc3.NgClass, HsCatalogueListItemComponent]; }, pipes: function () { return [ɵngcc1.TranslatePipe, TrackByPropertyPipe]; }, encapsulation: 2 });
HsAddDataCatalogueComponent.ctorParameters = () => [
    { type: HsLanguageService },
    { type: HsCommonEndpointsService },
    { type: HsConfig },
    { type: HsCoreService },
    { type: HsAddDataCatalogueService },
    { type: HsAddDataCatalogueMapService },
    { type: HsEventBusService },
    { type: HsLayoutService },
    { type: HsUtilsService },
    { type: HsLaymanService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsAddDataCatalogueComponent, [{
        type: Component,
        args: [{
                selector: 'hs-add-data-catalogue',
                template: "<div class=\"card hs-main-panel\">\n    <div class=\"mt-3 mx-3 pl-1 d-flex justify-content-between\">\n        <div class=\"input-group w-50\">\n            <input type=\"search\" class=\"form-control w-50\" [placeholder]=\"'COMMON.search' | translate\" name=\"search\"\n                [(ngModel)]=\"data.query.textFilter\" (ngModelChange)=\"queryByFilter()\">\n            <div class=\"input-group-append\">\n                <button class=\"btn input-group-text text-secondary hs-light-background border-left-0\"\n                    (click)=\"queryByFilter()\">\n                    <i class=\"icon-search icon-primary\"></i>\n                </button>\n            </div>\n        </div>\n        <hs-layman-current-user [endpoint]=\"hsLaymanService.getLaymanEndpoint()\"></hs-layman-current-user>\n    </div>\n    <div class=\"d-flex ml-4 mr-3 justify-content-between py-1 \">\n        <div class=\"d-flex\">\n            <div class=\"input-group-text border-0 pl-0\">\n                <input type=\"checkbox\" [(ngModel)]=\"data.filterByExtent\" (change)=\"queryByFilter()\"\n                    name=\"filterByExtent\">\n                <span class=\"ml-1\">{{'COMPOSITIONS.filterByMap' | translate}}</span>\n            </div>\n            <div class=\"input-group-text border-0\"\n                *ngIf=\"hsLaymanService.getLaymanEndpoint() && !hsLaymanService.isLaymanGuest()\">\n                <input type=\"checkbox\" [(ngModel)]=\"data.onlyMine\" (ngModelChange)=\"queryByFilter()\" name=\"onlyMine\">\n                <span class=\"ml-1\">{{'COMPOSITIONS.onlyMine' | translate}}</span>\n            </div>\n        </div>\n\n        <div ngbDropdown display=\"dynamic\" placement=\"bottom-right\" class=\"d-inline-block\">\n            <button class=\"btn btn-light hs-white-background hs-custom-toggle\" (click)=\"openOptionsMenu()\"\n                ngbDropdownToggle>{{translateString('COMMON',optionsButtonLabel)}}</button>\n            <div ngbDropdownMenu class=\"dropdown-menu-right p-2 m-1\"\n                style=\"min-width: 23rem; max-width: 23rem;  overflow: visible\" aria-labelledby=\"filtersDropdown\">\n                <table class=\"p-1 pl-3\" style=\"border-collapse:separate; border-spacing:0.5rem 0.5rem;\">\n                    <tbody>\n                        <tr>\n                            <td class=\"tdbreak\">\n                                {{'ADDDATA.CATALOGUE.filterType' | translate}}\n                            </td>\n                            <td ngbDropdown display=\"dynamic\" placement=\"bottom-right\"\n                                #searchTypeDropdown=\"ngbDropdown\">\n                                <button type=\"button\" ngbDropdownToggle\n                                    class=\"btn btn-light btn-sm hs-custom-toggle hs-background-alfa p-2 pl-1 border-0\"\n                                    style=\"text-align:start; min-width: 11rem; max-width: 11rem; border-radius: 0px; justify-content: space-between; display:flex; align-items: center;\">\n                                    {{translateString('ADDDATA.CATALOGUE.searchFilterTypes',\n                                    data.textField)}}\n                                </button>\n                                <ul ngbDropdownMenu aria-labelledby=\"searchType\" class=\"pl-2\"\n                                    style=\"overflow-y: auto; max-height: 10rem; min-width:10rem\">\n                                    <li *ngFor=\"let searchType of textFieldTypes; let index = index\">\n                                        <label style=\"cursor: pointer;\"><input class=\"mr-2\" type=\"radio\"\n                                                name=\"searchType-index\" [checked]=\"(index === 0)\"\n                                                (change)=\"selectType(searchType);searchTypeDropdown.close()\">{{translateString('ADDDATA.CATALOGUE.searchFilterTypes',\n                                            searchType)}}</label>\n                                    </li>\n                                </ul>\n                            </td>\n                        </tr>\n                        <tr>\n                            <td class=\"tdbreak\">\n                                {{'ADDDATA.CATALOGUE.resourceType' | translate}}\n                            </td>\n                            <td ngbDropdown display=\"dynamic\" placement=\"bottom-right\" #resourceType=\"ngbDropdown\">\n                                <button type=\"button\" ngbDropdownToggle\n                                    class=\"btn btn-light btn-sm hs-custom-toggle hs-background-alfa p-2 pl-1 border-0\"\n                                    style=\"text-align:start; min-width: 11rem; max-width: 11rem; border-radius: 0px; justify-content: space-between; display:flex; align-items: center;\">\n                                    {{translateString('ADDDATA.CATALOGUE.queryDataTypes',\n                                    data.query.type)}}\n                                </button>\n                                <ul ngbDropdownMenu aria-labelledby=\"type\" class=\"pl-2\"\n                                    style=\"overflow-y: auto; max-height: 10rem; min-width:10rem\">\n                                    <li *ngFor=\"let type of dataTypes; let index = index\">\n                                        <label style=\"cursor: pointer;\"><input class=\"mr-2\" type=\"radio\"\n                                                name=\"type-index\" [checked]=\"(index === 1)\"\n                                                (change)=\"selectQueryType(type, 'type');resourceType.close()\">{{translateString('ADDDATA.CATALOGUE.queryDataTypes',\n                                            type)}}</label>\n                                    </li>\n                                </ul>\n                            </td>\n                        </tr>\n                        <tr>\n                            <td class=\"tdbreak\">\n                                {{'COMMON.sortBy' | translate}}\n                            </td>\n                            <td ngbDropdown display=\"dynamic\" placement=\"bottom-right\" #sortByDrop=\"ngbDropdown\">\n                                <button type=\"button\" ngbDropdownToggle\n                                    class=\"btn btn-light btn-sm hs-custom-toggle hs-background-alfa p-2 pl-1 border-0\"\n                                    style=\"text-align:start; min-width: 11rem; max-width: 11rem; border-radius: 0px; justify-content: space-between; display:flex; align-items: center;\">\n                                    {{translateString('ADDDATA.CATALOGUE.sortbyTypes', data.query.sortby)}}\n                                </button>\n                                <ul ngbDropdownMenu aria-labelledby=\"sortBy\" class=\"pl-2\"\n                                    style=\"overflow-y: auto; max-height: 10rem; min-width:10rem\">\n                                    <li *ngFor=\"let sortType of sortbyTypes, let index = index;\">\n                                        <label style=\"cursor: pointer;\"><input class=\"mr-2\" type=\"radio\"\n                                                name=\"sort-index\" [checked]=\"(index === 0)\"\n                                                (change)=\"selectQueryType(sortType, 'sortby');sortByDrop.close()\">{{translateString('ADDDATA.CATALOGUE.sortbyTypes',\n                                            sortType)}}</label>\n                                    </li>\n                                </ul>\n                            </td>\n                        </tr>\n                    </tbody>\n                </table>\n            </div>\n        </div>\n    </div>\n    <div class=\"tab-content\">\n        <div class=\"card d-flex\" style=\"font-size: 1rem !important;\">\n            <div class=\"card-body\">\n                <!-- <div *ngIf=\"endpoint.type == 'micka'\">\n                        <hs-micka-filters micka-dataset-config=\"{url: endpoint.url}\"></hs-micka-filters>\n                    </div>\n                -->\n                <ul class=\"list-group\">\n                    <li class='list-group-item text-primary text-center py-2'\n                        [hidden]=\"!hsAddDataCatalogueService.dataLoading\"><img class=\"pr-2\"\n                            [src]=\"loaderImage\" />{{'ADDDATA.CATALOGUE.loading' | translate}}</li>\n                    <li [hidden]='hsAddDataCatalogueService.catalogEntries.length > 0 || hsAddDataCatalogueService.dataLoading'\n                        class='list-group-item '>\n                        {{'DATASOURCE_SELECTOR.noResults' | translate}}</li>\n                    <li [hidden]=\"hsAddDataCatalogueService.dataLoading\" style=\"cursor: pointer;\"\n                        *ngFor=\"let layer of hsAddDataCatalogueService.catalogEntries; trackBy:( 'id' | trackByProperty )\" class=\"clearfix list-group-item\"\n                        [ngClass]=\"{'hs-endpoint-item-active': layer.highlighted}\" (click)=\"layerSelected(layer)\"\n                        (mouseover)=\"highlightLayer(layer, true)\" (mouseleave)=\"highlightLayer(layer, false)\">\n                        <hs-catalogue-list-item [layer]=\"layer\"></hs-catalogue-list-item>\n                    </li>\n                </ul>\n            </div>\n            <hs-pager [pagerService]=\"hsAddDataCatalogueService\"></hs-pager>\n        </div>\n    </div>\n</div>\n"
            }]
    }], function () { return [{ type: HsLanguageService }, { type: HsCommonEndpointsService }, { type: HsConfig }, { type: HsCoreService }, { type: HsAddDataCatalogueService }, { type: HsAddDataCatalogueMapService }, { type: HsEventBusService }, { type: HsLayoutService }, { type: HsUtilsService }, { type: HsLaymanService }]; }, null); })();

class HsCatalogueMetadataComponent {
    constructor(hsConfig, // used in template
    hsAddDataCatalogueService, //used in template
    hsAddDataCatalogueMapService, //used in template
    hsDialogContainerService) {
        this.hsConfig = hsConfig;
        this.hsAddDataCatalogueService = hsAddDataCatalogueService;
        this.hsAddDataCatalogueMapService = hsAddDataCatalogueMapService;
        this.hsDialogContainerService = hsDialogContainerService;
    }
    ngOnInit() {
        this.selectedDS = this.data.selectedDS;
        this.selectedLayer = this.data.selectedLayer;
        this.selectedLayerKeys = Object.keys(this.selectedLayer);
        this.selectedLayerKeys = this.selectedLayerKeys.filter((e) => e !== 'endpoint');
    }
    /**
     * @param ds - Datasource (i.e. endpoint)
     * @param layer - Description of a layer to be added
     * @param type - Type in which the layer shall be added (WMS, WFS, etc.)
     */
    addLayerToMap(ds, layer, type) {
        this.hsAddDataCatalogueService.addLayerToMap(ds, layer, type);
        this.close();
    }
    close() {
        this.hsDialogContainerService.destroy(this);
    }
}
HsCatalogueMetadataComponent.ɵfac = function HsCatalogueMetadataComponent_Factory(t) { return new (t || HsCatalogueMetadataComponent)(ɵngcc0.ɵɵdirectiveInject(HsConfig), ɵngcc0.ɵɵdirectiveInject(HsAddDataCatalogueService), ɵngcc0.ɵɵdirectiveInject(HsAddDataCatalogueMapService), ɵngcc0.ɵɵdirectiveInject(HsDialogContainerService)); };
HsCatalogueMetadataComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsCatalogueMetadataComponent, selectors: [["hs-catalogue-metadata"]], inputs: { data: "data" }, decls: 27, vars: 21, consts: [["tabindex", "-1", "role", "dialog", "aria-hidden", "true", 1, "modal", "in", "hs-datasource_selector-metadata-dialog"], [1, "modal-dialog", "modal-lg"], [1, "modal-content"], [1, "modal-header"], [1, "modal-title"], ["type", "button", "data-dismiss", "modal", 1, "close", 3, "click"], ["aria-hidden", "true"], [1, "sr-only"], [1, "modal-body", 2, "max-height", "400px", "overflow-y", "auto"], [4, "ngFor", "ngForOf"], [1, "modal-footer"], ["role", "button", "data-toggle", "tooltip", "title", "GeoDCAT-AP", "target", "_blank", 1, "btn", "btn-success", 3, "href", "hidden"], [1, "icon-share-alt"], ["type", "button", 1, "btn", "btn-success", 3, "hidden", "click"], [4, "ngIf"], ["type", "button", "data-dismiss", "modal", 1, "btn", "btn-secondary", 3, "title", "click"], [3, "value"], ["type", "button", "class", "btn btn-primary ml-2", "data-dismiss", "modal", 3, "click", 4, "ngFor", "ngForOf"], ["type", "button", "data-dismiss", "modal", 1, "btn", "btn-primary", "ml-2", 3, "click"], [1, "icon-plus"]], template: function HsCatalogueMetadataComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelementStart(4, "h4", 4);
        ɵngcc0.ɵɵtext(5);
        ɵngcc0.ɵɵpipe(6, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "button", 5);
        ɵngcc0.ɵɵlistener("click", function HsCatalogueMetadataComponent_Template_button_click_7_listener() { return ctx.close(); });
        ɵngcc0.ɵɵelementStart(8, "span", 6);
        ɵngcc0.ɵɵtext(9, "\u00D7");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "span", 7);
        ɵngcc0.ɵɵtext(11);
        ɵngcc0.ɵɵpipe(12, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(13, "div", 8);
        ɵngcc0.ɵɵtemplate(14, HsCatalogueMetadataComponent_ng_container_14_Template, 2, 1, "ng-container", 9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(15, "div", 10);
        ɵngcc0.ɵɵelementStart(16, "a", 11);
        ɵngcc0.ɵɵelement(17, "i", 12);
        ɵngcc0.ɵɵtext(18, " RDF ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(19, "button", 13);
        ɵngcc0.ɵɵlistener("click", function HsCatalogueMetadataComponent_Template_button_click_19_listener() { return ctx.hsAddDataCatalogueMapService.zoomTo(ctx.selectedLayer.bbox); });
        ɵngcc0.ɵɵtext(20);
        ɵngcc0.ɵɵpipe(21, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(22, HsCatalogueMetadataComponent_div_22_Template, 2, 1, "div", 14);
        ɵngcc0.ɵɵelementStart(23, "button", 15);
        ɵngcc0.ɵɵlistener("click", function HsCatalogueMetadataComponent_Template_button_click_23_listener() { return ctx.close(); });
        ɵngcc0.ɵɵpipe(24, "translate");
        ɵngcc0.ɵɵtext(25);
        ɵngcc0.ɵɵpipe(26, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate2(" ", ɵngcc0.ɵɵpipeBind1(6, 11, "DATASOURCE_SELECTOR.metadataFor"), " ", ctx.selectedLayer.title, " ");
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(12, 13, "COMMON.close"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.selectedLayerKeys);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("href", ctx.hsAddDataCatalogueService.layerRDF(ctx.selectedDS, ctx.selectedLayer), ɵngcc0.ɵɵsanitizeUrl)("hidden", ctx.selectedDS.type !== "micka" || ctx.hsAddDataCatalogueService.layerRDF(ctx.selectedDS, ctx.selectedLayer) === "#");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("hidden", !ctx.hsAddDataCatalogueMapService.isZoomable(ctx.selectedLayer));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(21, 15, "COMMON.zoomTo"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.selectedDS.type === "layman");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(24, 17, "COMMON.close"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(26, 19, "COMMON.close"), " ");
    } }, directives: function () { return [ɵngcc3.NgForOf, ɵngcc3.NgIf, HsUiExtensionsRecursiveDdComponent]; }, pipes: function () { return [ɵngcc1.TranslatePipe]; }, encapsulation: 2 });
HsCatalogueMetadataComponent.ctorParameters = () => [
    { type: HsConfig },
    { type: HsAddDataCatalogueService },
    { type: HsAddDataCatalogueMapService },
    { type: HsDialogContainerService }
];
HsCatalogueMetadataComponent.propDecorators = {
    data: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsCatalogueMetadataComponent, [{
        type: Component,
        args: [{
                selector: 'hs-catalogue-metadata',
                template: "<div class=\"modal in hs-datasource_selector-metadata-dialog\" tabindex=\"-1\"\n    role=\"dialog\" aria-hidden=\"true\">\n    <div class=\"modal-dialog modal-lg\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <h4 class=\"modal-title\">\n                    {{'DATASOURCE_SELECTOR.metadataFor' | translate}} {{ selectedLayer.title}}\n                </h4>\n                <button type=\"button\" (click)=\"close()\" class=\"close\" data-dismiss=\"modal\">\n                    <span aria-hidden=\"true\">&times;</span>\n                    <span class=\"sr-only\">{{'COMMON.close' | translate}}</span>\n                </button>\n            </div>\n            <div class=\"modal-body\" style=\"max-height:400px; overflow-y:auto\">\n                <ng-container *ngFor=\"let key of selectedLayerKeys\">\n                    <dl *ngIf=\"key!=='feature'\">\n                        <dt>{{key}}</dt>\n                        <hs-widgets-recursive-dd [value]=\"selectedLayer[key]\"></hs-widgets-recursive-dd>\n                    </dl>\n                </ng-container>\n            </div>\n            <div class=\"modal-footer\">\n                <a role=\"button\" class=\"btn btn-success\"\n                    [href]='hsAddDataCatalogueService.layerRDF(selectedDS, selectedLayer)' data-toggle=\"tooltip\"\n                    title=\"GeoDCAT-AP\" target=\"_blank\"\n                    [hidden]='selectedDS.type!==\"micka\" || hsAddDataCatalogueService.layerRDF(selectedDS, selectedLayer) === \"#\"'>\n                    <i class=\"icon-share-alt\"></i> RDF\n                </a>\n                <button type=\"button\" class=\"btn btn-success\"\n                    [hidden]=\"!hsAddDataCatalogueMapService.isZoomable(selectedLayer)\"\n                    (click)=\"hsAddDataCatalogueMapService.zoomTo(selectedLayer.bbox)\">{{'COMMON.zoomTo' | translate}}</button>\n                <div *ngIf=\"selectedDS.type === 'layman'\">\n                    <button type=\"button\" class=\"btn btn-primary ml-2\" *ngFor=\"let type of selectedLayer.type\"\n                        (click)=\"addLayerToMap(selectedDS, selectedLayer, type)\" data-dismiss=\"modal\">\n                        <span class=\"icon-plus\"></span><span>{{'DATASOURCE_SELECTOR.addToMapAs' | translate}}\n                            {{type}}</span>\n                    </button>\n                </div>\n                <button type=\"button\" class=\"btn btn-secondary\" (click)=\"close()\" data-dismiss=\"modal\"\n                    [title]=\"'COMMON.close' | translate\">\n                    {{'COMMON.close' | translate}}\n                </button>\n            </div>\n        </div>\n    </div>\n</div>\n"
            }]
    }], function () { return [{ type: HsConfig }, { type: HsAddDataCatalogueService }, { type: HsAddDataCatalogueMapService }, { type: HsDialogContainerService }]; }, { data: [{
            type: Input
        }] }); })();

/* eslint-disable @typescript-eslint/no-unused-vars */
class HsCatalogueMetadataService {
    constructor(hsUtilsService) {
        this.hsUtilsService = hsUtilsService;
    }
    /**
     * @param input -
     * @param prestring -
     */
    decomposeMetadata(input, prestring) {
        console.log(input);
        if (this.hsUtilsService.isPOJO(input)) {
            console.log('Decomposing OBJ');
            return this.decomposeObject(input, prestring);
        }
        else if (Array.isArray(input)) {
            console.log('Decomposing Arr');
            return this.decomposeArray(input, prestring);
        }
        else {
            return false;
        }
    }
    /**
     * @param obj -
     * @param substring -
     */
    decomposeObject(obj, substring) {
        let decomposed = {};
        let subvalue = undefined;
        Object.entries(obj).forEach((entry) => {
            const [key, value] = entry;
            console.log('deco', decomposed);
            console.log(key, value);
            if (key == 'feature') {
                return;
            }
            let newstring = '';
            if (substring !== undefined) {
                newstring = substring + ' - ' + key;
            }
            else {
                newstring = key;
            }
            if (this.hsUtilsService.isPOJO(value)) {
                console.log('decomposing obj ', value);
                subvalue = this.decomposeObject(value, newstring);
            }
            else if (Array.isArray(value)) {
                console.log('decomposing arr ', value);
                subvalue = this.decomposeArray(value, newstring);
            }
            else {
                subvalue = value;
            }
            if (this.hsUtilsService.isPOJO(subvalue)) {
                decomposed = this.hsUtilsService.structuredClone(subvalue, decomposed);
            }
            else {
                decomposed[newstring] = subvalue;
            }
        });
        return decomposed;
    }
    /**
     * @param arr -
     * @param substring -
     */
    decomposeArray(arr, substring) {
        console.log('decomposing array ', arr, 'with substring ', substring);
        let decomposed = undefined;
        let sub = '';
        arr.forEach((value) => {
            console.log(value);
            if (this.hsUtilsService.isPOJO(value)) {
                sub = this.decomposeObject(value, substring);
            }
            else if (Array.isArray(value)) {
                sub = this.decomposeArray(value, substring);
            }
            else {
                sub += value;
            }
            console.log(sub);
            if (this.hsUtilsService.isPOJO(sub)) {
                decomposed = this.hsUtilsService.structuredClone(sub, decomposed);
            }
            else {
                decomposed[substring] = sub;
            }
        });
        return decomposed;
    }
}
HsCatalogueMetadataService.ɵfac = function HsCatalogueMetadataService_Factory(t) { return new (t || HsCatalogueMetadataService)(ɵngcc0.ɵɵinject(HsUtilsService)); };
HsCatalogueMetadataService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HsCatalogueMetadataService_Factory() { return new HsCatalogueMetadataService(i0.ɵɵinject(HsUtilsService)); }, token: HsCatalogueMetadataService, providedIn: "root" });
HsCatalogueMetadataService.ctorParameters = () => [
    { type: HsUtilsService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsCatalogueMetadataService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: HsUtilsService }]; }, null); })();

class HsCatalogueListItemComponent {
    constructor(hsConfig, //used in template
    hsDatasourcesMetadataService, hsAddDataCatalogueService, hsDialogContainerService, hsLaymanBrowserService, hsLogService, hsLanguageService, hsLaymanService, hsUtilsService) {
        this.hsConfig = hsConfig;
        this.hsDatasourcesMetadataService = hsDatasourcesMetadataService;
        this.hsAddDataCatalogueService = hsAddDataCatalogueService;
        this.hsDialogContainerService = hsDialogContainerService;
        this.hsLaymanBrowserService = hsLaymanBrowserService;
        this.hsLogService = hsLogService;
        this.hsLanguageService = hsLanguageService;
        this.hsLaymanService = hsLaymanService;
        this.hsUtilsService = hsUtilsService;
        this.loadingInfo = false;
    }
    /**
     * Add selected layer to map (into layer manager) if possible (supported formats: WMS, WFS, Sparql, kml, geojson, json)
     * @param ds - Datasource of selected layer
     * @param layer - Metadata record of selected layer
     */
    addLayerToMap(ds, layer) {
        return __awaiter(this, void 0, void 0, function* () {
            this.loadingInfo = true;
            const availableTypes = yield this.hsAddDataCatalogueService.addLayerToMap(ds, layer, this.selectedType);
            this.loadingInfo = false;
            if (Array.isArray(availableTypes)) {
                this.whatToAddTypes = availableTypes;
                this.selectTypeToAddLayerVisible = true;
            }
            else {
                this.selectTypeToAddLayerVisible = false;
                this.selectedType = null;
            }
            this.explanationsVisible = false;
        });
    }
    abortAdd() {
        this.selectTypeToAddLayerVisible = false;
        this.explanationsVisible = false;
        this.selectedType = null;
    }
    /**
     * Add layer by type click wrapper. Prevents bubbling of DOM event
     * @param type - One of 'WMS', 'WFS'
     * @param event - Mouse click event
     */
    selectTypeAndAdd(type, event) {
        event.preventDefault();
        this.selectedType = type;
        this.addLayerToMap(this.layer.endpoint, this.layer);
    }
    /**
     * For a stringified type of service, it returns its description
     * @param module -
     * @param text -
     * @returns A brief description of a given type with its main advantage and disadvantage notes
     */
    translateString(module, text) {
        return this.hsLanguageService.getTranslationIgnoreNonExisting(module, text);
    }
    toggleExplanations() {
        this.explanationsVisible = !this.explanationsVisible;
    }
    /**
     * Show metadata record dialog window for selected layer.
     * @param endpoint - Datasource of selected layer
     * @param layer - Metadata record of selected layer
     */
    showMetadata(endpoint, layer) {
        return __awaiter(this, void 0, void 0, function* () {
            this.selected_layer = layer;
            this.selected_ds = endpoint;
            if (endpoint.type == 'layman') {
                yield this.hsLaymanBrowserService.fillLayerMetadata(endpoint, layer);
            }
            //this.metadata = this.hsDatasourcesMetadataService.decomposeMetadata(layer);
            //console.log(this.metadata);
            this.hsDialogContainerService.create(HsCatalogueMetadataComponent, {
                selectedLayer: this.selected_layer,
                selectedDS: this.selected_ds,
            });
        });
    }
    /**
     * Removes selected drawing layer from both Layermanager and Layman
     * @param layer - Metadata record of selected layer
     */
    removeLayer(layer) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!layer.editable) {
                return;
            }
            const dialog = this.hsDialogContainerService.create(HsConfirmDialogComponent, {
                message: this.hsLanguageService.getTranslation('DRAW.reallyDeleteThisLayer'),
                note: this.hsLanguageService.getTranslation('DRAW.deleteNote'),
                title: this.hsLanguageService.getTranslation('COMMON.confirmDelete'),
            });
            const confirmed = yield dialog.waitResult();
            if (confirmed == 'yes') {
                this.hsLaymanService.removeLayer(layer.name);
                this.hsAddDataCatalogueService.catalogEntries =
                    this.hsAddDataCatalogueService.catalogEntries.filter((item) => {
                        return item.id != layer.id;
                    });
            }
        });
    }
}
HsCatalogueListItemComponent.ɵfac = function HsCatalogueListItemComponent_Factory(t) { return new (t || HsCatalogueListItemComponent)(ɵngcc0.ɵɵdirectiveInject(HsConfig), ɵngcc0.ɵɵdirectiveInject(HsCatalogueMetadataService), ɵngcc0.ɵɵdirectiveInject(HsAddDataCatalogueService), ɵngcc0.ɵɵdirectiveInject(HsDialogContainerService), ɵngcc0.ɵɵdirectiveInject(HsLaymanBrowserService), ɵngcc0.ɵɵdirectiveInject(HsLogService), ɵngcc0.ɵɵdirectiveInject(HsLanguageService), ɵngcc0.ɵɵdirectiveInject(HsLaymanService), ɵngcc0.ɵɵdirectiveInject(HsUtilsService)); };
HsCatalogueListItemComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsCatalogueListItemComponent, selectors: [["hs-catalogue-list-item"]], inputs: { layer: "layer" }, decls: 26, vars: 18, consts: [[1, "d-flex", "flex-column"], [1, ""], ["data-toggle", "tooltip", 3, "title"], ["class", "d-flex flex-column w-100 justify-content-around mt-2", 4, "ngIf"], [1, "d-none"], [1, "p-0", 3, "hidden"], ["data-toggle", "tooltip", 1, "btn", "btn-sm", "btn-secondary", 3, "href", "title"], [1, "icon-download"], [1, "card", "bg-light", "align-items-center", 3, "hidden"], [1, "d-flex", "flex-row", "justify-content-between", "align-items-center", "w-100"], [1, "px-3"], ["disabled", "true", "aria-disabled", "true", 1, "btn", "btn-sm"], ["data-toggle", "buttons", 1, "btn-group", "btn-group-toggle", "h-100", "pr-2", "align-items-center"], ["class", "btn btn-sm btn-outline-secondary", "style", "width:6em", 3, "click", 4, "ngFor", "ngForOf"], [1, "btn", "btn-sm", 3, "title", "click"], [1, "icon-question-sign", "text-primary"], [1, "d-flex"], [1, "ml-auto", "p-2", "list-unstyled", 3, "hidden"], ["class", "text-secondary small", 4, "ngFor", "ngForOf"], [1, "d-flex", "flex-column", "w-100", "justify-content-around", "mt-2"], [1, "hs-dotted-line", "w-100"], [1, "d-flex", "flex-row", "justify-content-around", "align-items-end"], [1, "btn", "btn-sm", 3, "hidden", "click"], [1, "icon-plus", "icon-primary", 3, "hidden"], [3, "hidden", "src"], [1, "ml-1"], [1, "btn", "btn-sm", 3, "title", "hidden", "click"], [1, "icon-remove", "text-danger"], [1, "btn", "btn-sm", 3, "click"], [1, "icon-info-sign", "icon-primary"], ["data-toggle", "tooltip", "data-placement", "bottom", 1, "btn", "btn-sm", 3, "title", "click"], [1, "icon-trash", "text-danger", 3, "ngClass", "ngStyle"], ["class", "ml-1", 4, "ngIf"], [1, "btn", "btn-sm", "btn-outline-secondary", 2, "width", "6em", 3, "click"], ["type", "radio", "name", "options"], [1, "text-secondary", "small"]], template: function HsCatalogueListItemComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "a", 2);
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(4, HsCatalogueListItemComponent_div_4_Template, 24, 25, "div", 3);
        ɵngcc0.ɵɵelementStart(5, "div", 4);
        ɵngcc0.ɵɵelementStart(6, "div", 5);
        ɵngcc0.ɵɵelementStart(7, "a", 6);
        ɵngcc0.ɵɵpipe(8, "translate");
        ɵngcc0.ɵɵelement(9, "i", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "div");
        ɵngcc0.ɵɵelementStart(11, "div", 8);
        ɵngcc0.ɵɵelementStart(12, "div", 9);
        ɵngcc0.ɵɵelementStart(13, "div", 10);
        ɵngcc0.ɵɵelementStart(14, "span", 11);
        ɵngcc0.ɵɵtext(15);
        ɵngcc0.ɵɵpipe(16, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(17, "div", 12);
        ɵngcc0.ɵɵtemplate(18, HsCatalogueListItemComponent_label_18_Template, 3, 1, "label", 13);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(19, "div");
        ɵngcc0.ɵɵelementStart(20, "a", 14);
        ɵngcc0.ɵɵlistener("click", function HsCatalogueListItemComponent_Template_a_click_20_listener($event) { $event.stopPropagation(); return ctx.toggleExplanations(); });
        ɵngcc0.ɵɵpipe(21, "translate");
        ɵngcc0.ɵɵelement(22, "i", 15);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(23, "div", 16);
        ɵngcc0.ɵɵelementStart(24, "ul", 17);
        ɵngcc0.ɵɵtemplate(25, HsCatalogueListItemComponent_li_25_Template, 2, 2, "li", 18);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("title", ctx.layer.description || "");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.layer.title || ctx.layer.description);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", (ctx.hsAddDataCatalogueService.selectedLayer == null ? null : ctx.hsAddDataCatalogueService.selectedLayer.id) === ctx.layer.id);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("hidden", ctx.hsAddDataCatalogueService.layerDownload(ctx.layer.endpoint, ctx.layer) === "#");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("href", ctx.hsAddDataCatalogueService.layerDownload(ctx.layer.endpoint, ctx.layer), ɵngcc0.ɵɵsanitizeUrl)("title", ɵngcc0.ɵɵpipeBind1(8, 12, "COMMON.download"));
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("hidden", !ctx.selectTypeToAddLayerVisible);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(16, 14, "ADDDATA.CATALOGUE.addAs"), "\u00A0");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.whatToAddTypes);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(21, 16, "DATASOURCE_SELECTOR.datasourceListItem.whatDoesItMean"));
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("hidden", !ctx.explanationsVisible);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.whatToAddTypes);
    } }, directives: [ɵngcc3.NgIf, ɵngcc3.NgForOf, ɵngcc3.NgClass, ɵngcc3.NgStyle], pipes: [ɵngcc1.TranslatePipe], encapsulation: 2 });
HsCatalogueListItemComponent.ctorParameters = () => [
    { type: HsConfig },
    { type: HsCatalogueMetadataService },
    { type: HsAddDataCatalogueService },
    { type: HsDialogContainerService },
    { type: HsLaymanBrowserService },
    { type: HsLogService },
    { type: HsLanguageService },
    { type: HsLaymanService },
    { type: HsUtilsService }
];
HsCatalogueListItemComponent.propDecorators = {
    layer: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsCatalogueListItemComponent, [{
        type: Component,
        args: [{
                selector: 'hs-catalogue-list-item',
                template: "<div class=\"d-flex flex-column\">\n    <div class=\"\">\n        <a data-toggle=\"tooltip\" [title]=\"layer.description || ''\">{{layer.title || layer.description}}</a>\n    </div>\n    <div class=\"d-flex flex-column w-100 justify-content-around mt-2\"\n        *ngIf=\"hsAddDataCatalogueService.selectedLayer?.id === layer.id\">\n        <hr class=\"hs-dotted-line w-100 \">\n        <div class=\"d-flex flex-row justify-content-around align-items-end\">\n            <!-- <div class=\"p-0\" [hidden]=\"(selectTypeToAddLayerVisible)\">\n                            <button type=\"button\" class=\"btn btn-sm btn-primary align-middle\" (click)=\"addLayerToMap(layer.endpoint, layer)\"\n                                data-toggle=\"tooltip\" [title]=\"'DATASOURCE_SELECTOR.datasourceListItem.addToMap' | translate\"\n                                [ngClass]=\"{' btn-light text-primary' : layer.highlighted }\">\n                                <i class=\"icon-plus\"></i>\n                            </button>\n                            <span class=\"ml-2\">{{'DATASOURCE_SELECTOR.datasourceListItem.addToMap' | translate}}</span>\n                        </div> -->\n            <a class=\"btn btn-sm\" [hidden]=\"selectTypeToAddLayerVisible\"\n                (click)=\"$event.stopPropagation();addLayerToMap(layer.endpoint, layer)\">\n                <i [hidden]=\"loadingInfo\" class=\"icon-plus icon-primary\"></i>\n                <img [hidden]=\"!loadingInfo\" [src]=\"hsUtilsService.getAjaxLoaderIcon()\" />\n                <span class=\"ml-1\">{{'DATASOURCE_SELECTOR.datasourceListItem.addToMap' |\n                    translate}}</span>\n            </a>\n            <a class=\"btn btn-sm\" [title]=\"'DATASOURCE_SELECTOR.datasourceListItem.abortAdd' | translate\"\n                (click)=\"$event.stopPropagation();abortAdd()\" [hidden]=\"!selectTypeToAddLayerVisible\">\n                <i class=\"icon-remove text-danger\"></i><span\n                    class=\"ml-1\">{{'DATASOURCE_SELECTOR.datasourceListItem.abortAdd' |\n                    translate}}</span>\n            </a>\n            <a class=\"btn btn-sm\" (click)=\"showMetadata(layer.endpoint, layer)\">\n                <i class=\"icon-info-sign icon-primary\"></i><span class=\"ml-1\">{{'COMMON.metadata' |\n                    translate}}</span>\n            </a>\n            <a class=\"btn btn-sm\" (click)=\"$event.stopPropagation();removeLayer(layer)\" data-toggle=\"tooltip\" data-placement=\"bottom\"\n                [title]=\"layer.editable ? '' : 'DATASOURCE_SELECTOR.datasourceListItem.notAllowedToEditLayer' | translate\">\n                <i class=\"icon-trash text-danger\" [ngClass]=\"layer.editable ? 'text-danger' : 'text-muted'\"\n                    [ngStyle]=\"{'cursor' : layer.editable ? 'pointer' : 'default'}\"></i><span class=\"ml-1\"\n                    *ngIf=\"layer.editable\">{{'COMMON.removeLayer' | translate}}</span>\n            </a>\n        </div>\n    </div>\n    <div class=\"d-none\">\n        <div class=\"p-0\" [hidden]='hsAddDataCatalogueService.layerDownload(layer.endpoint,layer) === \"#\"'>\n            <a class=\"btn btn-sm btn-secondary\" [href]='hsAddDataCatalogueService.layerDownload(layer.endpoint, layer)'\n                data-toggle=\"tooltip\" [title]=\"'COMMON.download' | translate\"><i class=\"icon-download\"></i></a>\n        </div>\n        <!-- <div class=\"p-0\" [hidden]='layer.endpoint.type != \"micka\" || hsAddDataCatalogueService.layerRDF(layer.endpoint, layer) == \"#\"'>\n            <a class=\"btn btn-sm btn-secondary\" [href]='hsAddDataCatalogueService.layerRDF(layer.endpoint, layer)'\n                data-toggle=\"tooltip\" title=\"GeoDCAT-AP\" target=\"_blank\"><i class=\"icon-share-alt\"></i></a>\n        </div> -->\n    </div>\n</div>\n<div>\n    <!-- <div class=\"p-0\" [hidden]=\"!selectTypeToAddLayerVisible || selectedType\">\n        <button type=\"button\" class=\"btn btn-sm btn-danger\" (click)=\"$event.stopPropagation();abortAdd()\" data-toggle=\"tooltip\"\n            [title]=\"'DATASOURCE_SELECTOR.datasourceListItem.abortAdd' | translate\">\n            <i class=\"icon-remove\"></i>\n        </button>\n    </div> -->\n    <div class=\"card bg-light align-items-center\"\n        [hidden]=\"!selectTypeToAddLayerVisible\">\n        <div class=\"d-flex flex-row justify-content-between align-items-center w-100\">\n            <div class=\"px-3\">\n                <span class=\"btn btn-sm\" disabled=\"true\" aria-disabled=\"true\">{{\n                    'ADDDATA.CATALOGUE.addAs' |\n                    translate}}&nbsp;</span>\n                <div class=\"btn-group btn-group-toggle h-100 pr-2 align-items-center\" data-toggle=\"buttons\">\n                    <label class=\"btn btn-sm btn-outline-secondary\" *ngFor=\"let type of whatToAddTypes\"\n                        style=\"width:6em\"\n                        (click)=\"selectTypeAndAdd(type,$event)\">\n                        <input type=\"radio\" name=\"options\" />\n                        {{type}}\n                    </label>\n                </div>\n            </div>\n            <div>\n                <a class=\"btn btn-sm\" (click)=\"$event.stopPropagation();toggleExplanations()\"\n                    [title]=\"'DATASOURCE_SELECTOR.datasourceListItem.whatDoesItMean' | translate\">\n                    <i class=\"icon-question-sign text-primary\"></i>\n                </a>\n            </div>\n        </div>\n        <div class=\"d-flex\">\n            <ul class=\"ml-auto p-2 list-unstyled\" [hidden]=\"!explanationsVisible\">\n                <li class=\"text-secondary small\" *ngFor=\"let type of whatToAddTypes\">\n                    {{type}} &ndash; {{translateString('ADDDATA.CATALOGUE.DESC', type)}}\n                </li>\n            </ul>\n        </div>\n    </div>\n\n</div>\n"
            }]
    }], function () { return [{ type: HsConfig }, { type: HsCatalogueMetadataService }, { type: HsAddDataCatalogueService }, { type: HsDialogContainerService }, { type: HsLaymanBrowserService }, { type: HsLogService }, { type: HsLanguageService }, { type: HsLaymanService }, { type: HsUtilsService }]; }, { layer: [{
            type: Input
        }] }); })();

class FilterPipe {
    transform(items, filterCallback) {
        return items.filter((item) => filterCallback(item));
    }
}
FilterPipe.ɵfac = function FilterPipe_Factory(t) { return new (t || FilterPipe)(); };
FilterPipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "filter", type: FilterPipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FilterPipe, [{
        type: Pipe,
        args: [{
                name: 'filter'
            }]
    }], null, null); })();

class HsUiExtensionsRecursiveDdComponent {
    constructor(hsDSMapService // used in template
    ) {
        this.hsDSMapService = hsDSMapService;
    }
    isIterable() {
        if (this.value && typeof this.value === 'object') {
            this.entries = Object.entries(this.value);
            return true;
        }
        return false;
    }
}
HsUiExtensionsRecursiveDdComponent.ɵfac = function HsUiExtensionsRecursiveDdComponent_Factory(t) { return new (t || HsUiExtensionsRecursiveDdComponent)(ɵngcc0.ɵɵdirectiveInject(HsAddDataCatalogueMapService)); };
HsUiExtensionsRecursiveDdComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsUiExtensionsRecursiveDdComponent, selectors: [["hs-widgets-recursive-dd"]], inputs: { value: "value" }, decls: 2, vars: 2, consts: function () { let i18n_42; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        const MSG_EXTERNAL_4197449861951442159$$FESM2015_HSLAYERS_NG_JS___43 = goog.getMsg("Zoom to");
        i18n_42 = MSG_EXTERNAL_4197449861951442159$$FESM2015_HSLAYERS_NG_JS___43;
    }
    else {
        i18n_42 = $localize `:␟aaf818a466302589f180fcca592ec5ef367f505b␟4197449861951442159:Zoom to`;
    } return [[4, "ngIf"], [4, "ngFor", "ngForOf"], [3, "value"], ["class", "btn btn-secondary", 3, "click", 4, "ngIf"], [1, "btn", "btn-secondary", 3, "click"], i18n_42]; }, template: function HsUiExtensionsRecursiveDdComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, HsUiExtensionsRecursiveDdComponent_dd_0_Template, 2, 1, "dd", 0);
        ɵngcc0.ɵɵtemplate(1, HsUiExtensionsRecursiveDdComponent_dl_1_Template, 5, 3, "dl", 1);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", !ctx.isIterable());
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.entries);
    } }, directives: [ɵngcc3.NgIf, ɵngcc3.NgForOf, HsUiExtensionsRecursiveDdComponent], encapsulation: 2 });
HsUiExtensionsRecursiveDdComponent.ctorParameters = () => [
    { type: HsAddDataCatalogueMapService }
];
HsUiExtensionsRecursiveDdComponent.propDecorators = {
    value: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsUiExtensionsRecursiveDdComponent, [{
        type: Component,
        args: [{
                selector: 'hs-widgets-recursive-dd',
                template: "<dd *ngIf=\"!isIterable()\">{{value}}</dd>\n<dl *ngFor=\"let item of entries\">\n    <dt>{{item.key || item[0]}}</dt>\n    <hs-widgets-recursive-dd [value]=\"item.value || item[1]\"></hs-widgets-recursive-dd>\n    <button *ngIf=\"item.key=='bbox'\" (click)=\"hsDSMapService.zoomTo(value)\" class='btn btn-secondary' i18n>Zoom to</button>\n</dl>\n"
            }]
    }], function () { return [{ type: HsAddDataCatalogueMapService }]; }, { value: [{
            type: Input
        }] }); })();

//@ https://www.bennadel.com/blog/3579-using-pure-pipes-to-generate-ngfor-trackby-identity-functions-in-angular-7-2-7.html
const cache = {};
class TrackByPropertyPipe {
    transform(propertyName) {
        if (!cache[propertyName]) {
            cache[propertyName] = function trackByProperty(index, item) {
                return item[propertyName];
            };
        }
        return cache[propertyName];
    }
}
TrackByPropertyPipe.ɵfac = function TrackByPropertyPipe_Factory(t) { return new (t || TrackByPropertyPipe)(); };
TrackByPropertyPipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "trackByProperty", type: TrackByPropertyPipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TrackByPropertyPipe, [{
        type: Pipe,
        args: [{
                name: 'trackByProperty',
                pure: true
            }]
    }], null, null); })();

class HsUiExtensionsModule {
}
HsUiExtensionsModule.ɵfac = function HsUiExtensionsModule_Factory(t) { return new (t || HsUiExtensionsModule)(); };
HsUiExtensionsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: HsUiExtensionsModule });
HsUiExtensionsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [EndpointsWithDatasourcesPipe], imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsUiExtensionsModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    HsUiExtensionsRecursiveDdComponent,
                    EndpointsWithDatasourcesPipe,
                    FilterPipe,
                    TrackByPropertyPipe,
                ],
                imports: [CommonModule],
                providers: [EndpointsWithDatasourcesPipe],
                entryComponents: [HsUiExtensionsRecursiveDdComponent],
                exports: [
                    HsUiExtensionsRecursiveDdComponent,
                    EndpointsWithDatasourcesPipe,
                    FilterPipe,
                    TrackByPropertyPipe,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(HsUiExtensionsModule, { declarations: function () { return [HsUiExtensionsRecursiveDdComponent, EndpointsWithDatasourcesPipe, FilterPipe, TrackByPropertyPipe]; }, imports: function () { return [CommonModule]; }, exports: function () { return [HsUiExtensionsRecursiveDdComponent, EndpointsWithDatasourcesPipe, FilterPipe, TrackByPropertyPipe]; } }); })();

class HsCatalogueMetadataModule {
}
HsCatalogueMetadataModule.ɵfac = function HsCatalogueMetadataModule_Factory(t) { return new (t || HsCatalogueMetadataModule)(); };
HsCatalogueMetadataModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: HsCatalogueMetadataModule });
HsCatalogueMetadataModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [], imports: [[CommonModule, FormsModule, TranslateModule, HsUiExtensionsModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsCatalogueMetadataModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, FormsModule, TranslateModule, HsUiExtensionsModule],
                exports: [HsCatalogueMetadataComponent],
                declarations: [HsCatalogueMetadataComponent],
                providers: []
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(HsCatalogueMetadataModule, { declarations: function () { return [HsCatalogueMetadataComponent]; }, imports: function () { return [CommonModule, FormsModule, TranslateModule, HsUiExtensionsModule]; }, exports: function () { return [HsCatalogueMetadataComponent]; } }); })();

class HsCommonLaymanAccessRightsComponent {
    constructor() { }
    accessRightChanged(access_rights, type, value) {
        access_rights[type] = value;
        if (access_rights['access_rights.read'] == 'private' &&
            access_rights['access_rights.write'] != 'private') {
            access_rights['access_rights.write'] = 'private';
        }
        return access_rights;
    }
}
HsCommonLaymanAccessRightsComponent.ɵfac = function HsCommonLaymanAccessRightsComponent_Factory(t) { return new (t || HsCommonLaymanAccessRightsComponent)(); };
HsCommonLaymanAccessRightsComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsCommonLaymanAccessRightsComponent, selectors: [["hs-layman-access-rights"]], inputs: { access_rights: "access_rights" }, decls: 22, vars: 31, consts: [[1, "form-group", "d-flex", "justify-content-between"], [1, "pt-2", 2, "margin-bottom", "0"], [1, "btn-group"], ["type", "button", 1, "btn", "btn-light", "hs-toolbar-button", "btn-outline-secondary", 3, "ngClass", "click"], ["type", "button", 1, "btn", "btn-light", "hs-toolbar-button", "btn-outline-secondary", 3, "disabled", "ngClass", "click"]], template: function HsCommonLaymanAccessRightsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "label", 1);
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵpipe(3, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 2);
        ɵngcc0.ɵɵelementStart(5, "button", 3);
        ɵngcc0.ɵɵlistener("click", function HsCommonLaymanAccessRightsComponent_Template_button_click_5_listener() { return ctx.accessRightChanged(ctx.access_rights, "access_rights.read", "EVERYONE"); });
        ɵngcc0.ɵɵtext(6);
        ɵngcc0.ɵɵpipe(7, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "button", 3);
        ɵngcc0.ɵɵlistener("click", function HsCommonLaymanAccessRightsComponent_Template_button_click_8_listener() { return ctx.accessRightChanged(ctx.access_rights, "access_rights.read", "private"); });
        ɵngcc0.ɵɵtext(9);
        ɵngcc0.ɵɵpipe(10, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "div", 0);
        ɵngcc0.ɵɵelementStart(12, "label", 1);
        ɵngcc0.ɵɵtext(13);
        ɵngcc0.ɵɵpipe(14, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(15, "div", 2);
        ɵngcc0.ɵɵelementStart(16, "button", 4);
        ɵngcc0.ɵɵlistener("click", function HsCommonLaymanAccessRightsComponent_Template_button_click_16_listener() { return ctx.accessRightChanged(ctx.access_rights, "access_rights.write", "EVERYONE"); });
        ɵngcc0.ɵɵtext(17);
        ɵngcc0.ɵɵpipe(18, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(19, "button", 3);
        ɵngcc0.ɵɵlistener("click", function HsCommonLaymanAccessRightsComponent_Template_button_click_19_listener() { return ctx.accessRightChanged(ctx.access_rights, "access_rights.write", "private"); });
        ɵngcc0.ɵɵtext(20);
        ɵngcc0.ɵɵpipe(21, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(3, 11, "SAVECOMPOSITION.readAccessRights"), " ");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(23, _c12, ctx.access_rights["access_rights.read"] == "EVERYONE"));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(7, 13, "SAVECOMPOSITION.public"), " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(25, _c12, ctx.access_rights["access_rights.read"] == "private"));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(10, 15, "SAVECOMPOSITION.private"), " ");
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(14, 17, "SAVECOMPOSITION.writeAccessRights"), " ");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("disabled", ctx.access_rights["access_rights.read"] == "private")("ngClass", ɵngcc0.ɵɵpureFunction1(27, _c12, ctx.access_rights["access_rights.write"] == "EVERYONE"));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(18, 19, "SAVECOMPOSITION.public"), " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(29, _c12, ctx.access_rights["access_rights.write"] == "private"));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(21, 21, "SAVECOMPOSITION.private"), " ");
    } }, directives: [ɵngcc3.NgClass], pipes: [ɵngcc1.TranslatePipe], encapsulation: 2 });
HsCommonLaymanAccessRightsComponent.ctorParameters = () => [];
HsCommonLaymanAccessRightsComponent.propDecorators = {
    access_rights: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsCommonLaymanAccessRightsComponent, [{
        type: Component,
        args: [{
                selector: 'hs-layman-access-rights',
                template: "<div class=\"form-group d-flex justify-content-between\">\n    <label class=\"pt-2\" style=\"margin-bottom: 0;\">\n        {{'SAVECOMPOSITION.readAccessRights' | translate}}\n    </label>\n    <div class=\"btn-group\">\n        <button type=\"button\" class=\"btn btn-light hs-toolbar-button  btn-outline-secondary\"\n        (click)=\"accessRightChanged(access_rights,'access_rights.read','EVERYONE')\"\n        [ngClass]=\"{'active':access_rights['access_rights.read'] == 'EVERYONE'}\">\n        {{'SAVECOMPOSITION.public' | translate}}\n    </button>\n    <button type=\"button\" class=\"btn btn-light hs-toolbar-button  btn-outline-secondary\"\n        (click)=\"accessRightChanged(access_rights,'access_rights.read','private')\"\n        [ngClass]=\"{'active':access_rights['access_rights.read'] == 'private'}\">\n        {{'SAVECOMPOSITION.private' | translate}}\n    </button>\n    </div>\n</div>\n<div class=\"form-group d-flex justify-content-between\" >\n    <label class=\"pt-2\" style=\"margin-bottom: 0;\">\n        {{'SAVECOMPOSITION.writeAccessRights' | translate}}\n    </label>\n    <div class=\"btn-group\">\n        <button type=\"button\" class=\"btn btn-light hs-toolbar-button  btn-outline-secondary\"\n        [disabled]=\"access_rights['access_rights.read'] == 'private'\"\n        (click)=\"accessRightChanged(access_rights,'access_rights.write','EVERYONE')\"\n            [ngClass]=\"{'active':access_rights['access_rights.write'] == 'EVERYONE'}\">\n            {{'SAVECOMPOSITION.public' | translate}}\n        </button>\n        <button type=\"button\" class=\"btn btn-light hs-toolbar-button  btn-outline-secondary\"\n        (click)=\"accessRightChanged(access_rights,'access_rights.write','private')\"\n            [ngClass]=\"{'active':access_rights['access_rights.write'] == 'private'}\">\n            {{'SAVECOMPOSITION.private' | translate}}\n        </button>\n    </div>\n</div>\n"
            }]
    }], function () { return []; }, { access_rights: [{
            type: Input
        }] }); })();

class HsLaymanLoginComponent {
    constructor(HsCommonLaymanService, HsDialogContainerService, sanitizer) {
        this.HsCommonLaymanService = HsCommonLaymanService;
        this.HsDialogContainerService = HsDialogContainerService;
        this.sanitizer = sanitizer;
        this.authChangeSubscription =
            this.HsCommonLaymanService.authChange.subscribe((endpoint) => {
                this.close();
            });
    }
    ngOnDestroy() {
        this.authChangeSubscription.unsubscribe();
    }
    ngOnInit() {
        this.url = this.sanitizer.bypassSecurityTrustResourceUrl(this.data);
    }
    close() {
        this.HsDialogContainerService.destroy(this);
    }
}
HsLaymanLoginComponent.ɵfac = function HsLaymanLoginComponent_Factory(t) { return new (t || HsLaymanLoginComponent)(ɵngcc0.ɵɵdirectiveInject(HsCommonLaymanService), ɵngcc0.ɵɵdirectiveInject(HsDialogContainerService), ɵngcc0.ɵɵdirectiveInject(ɵngcc4.DomSanitizer)); };
HsLaymanLoginComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsLaymanLoginComponent, selectors: [["hs-layman-login"]], inputs: { data: "data" }, decls: 15, vars: 7, consts: [["tabindex", "-1", "role", "dialog", "aria-hidden", "true", 1, "modal", "in"], [1, "modal-dialog", "modal-lg"], [1, "modal-content"], [1, "modal-header"], [1, "modal-title"], ["type", "button", "data-dismiss", "modal", 1, "close", 3, "click"], ["aria-hidden", "true"], [1, "sr-only"], [1, "modal-body", 2, "max-height", "600px", "height", "35em", "overflow-y", "auto"], [2, "width", "100%", "height", "100%", "border", "0", 3, "src"]], template: function HsLaymanLoginComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelementStart(4, "h4", 4);
        ɵngcc0.ɵɵtext(5);
        ɵngcc0.ɵɵpipe(6, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "button", 5);
        ɵngcc0.ɵɵlistener("click", function HsLaymanLoginComponent_Template_button_click_7_listener() { return ctx.close(); });
        ɵngcc0.ɵɵelementStart(8, "span", 6);
        ɵngcc0.ɵɵtext(9, "\u00D7");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "span", 7);
        ɵngcc0.ɵɵtext(11);
        ɵngcc0.ɵɵpipe(12, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(13, "div", 8);
        ɵngcc0.ɵɵelement(14, "iframe", 9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(6, 3, "COMMON.Login"), " ");
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(12, 5, "COMMON.close"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("src", ctx.url, ɵngcc0.ɵɵsanitizeResourceUrl);
    } }, pipes: [ɵngcc1.TranslatePipe], encapsulation: 2 });
HsLaymanLoginComponent.ctorParameters = () => [
    { type: HsCommonLaymanService },
    { type: HsDialogContainerService },
    { type: DomSanitizer }
];
HsLaymanLoginComponent.propDecorators = {
    data: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsLaymanLoginComponent, [{
        type: Component,
        args: [{
                selector: 'hs-layman-login',
                template: "<div class=\"modal in\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\">\n    <div class=\"modal-dialog modal-lg\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <h4 class=\"modal-title\">\n                    {{'COMMON.Login' | translate }}\n                </h4>\n                <button type=\"button\" (click)=\"close()\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">{{'COMMON.close' | translate }}</span></button>\n            </div>\n            <div class=\"modal-body\" style=\"max-height:600px; height: 35em; overflow-y:auto\">\n                <iframe [src]=\"url\" style=\"width:100%; height:100%;border:0\"></iframe>\n            </div>\n        </div>\n    </div>\n</div>\n"
            }]
    }], function () { return [{ type: HsCommonLaymanService }, { type: HsDialogContainerService }, { type: ɵngcc4.DomSanitizer }]; }, { data: [{
            type: Input
        }] }); })();

class HsLaymanCurrentUserComponent {
    constructor($http, HsCommonLaymanService, HsDialogContainerService) {
        this.$http = $http;
        this.HsCommonLaymanService = HsCommonLaymanService;
        this.HsDialogContainerService = HsDialogContainerService;
        this.monitorTries = 0;
        this.DEFAULT_TIMER_INTERVAL = 2000;
        this.MAX_MONITOR_TRIES = 100;
        this.timerInterval = this.DEFAULT_TIMER_INTERVAL;
    }
    isGuest() {
        return this.endpoint.user == 'anonymous' || this.endpoint.user == 'browser';
    }
    logout() {
        this.monitorUser();
        this.HsCommonLaymanService.logout(this.endpoint);
    }
    sameDomain() {
        const endpointUrl = new URL(this.endpoint.url);
        return (location.protocol == endpointUrl.protocol &&
            location.host == endpointUrl.host);
    }
    authUrl() {
        return this.endpoint.url + '/login';
    }
    /**
     * Periodically poll layman client endpoint for auth change.
     * This is used for hiding login iframe and toggling state for login buttons,
     * which is done in separate modules by subscribing to HsCommonLaymanService.authChange
     */
    monitorUser() {
        if (this.getCurrentUserTimer) {
            clearTimeout(this.getCurrentUserTimer);
        }
        this.monitorTries = 0;
        this.timerInterval = this.DEFAULT_TIMER_INTERVAL;
        const poll = () => {
            this.HsCommonLaymanService.detectAuthChange(this.endpoint).then((somethingChanged) => {
                if (somethingChanged && this.getCurrentUserTimer) {
                    clearTimeout(this.getCurrentUserTimer);
                    this.monitorTries = this.MAX_MONITOR_TRIES;
                }
            });
            this.monitorTries++;
            if (this.monitorTries > this.MAX_MONITOR_TRIES) {
                clearTimeout(this.getCurrentUserTimer);
            }
            this.getCurrentUserTimer = setTimeout(poll, this.timerInterval);
        };
        this.getCurrentUserTimer = setTimeout(poll, this.timerInterval);
    }
    login() {
        this.monitorUser();
        if (!this.sameDomain()) {
            return;
        }
        this.HsDialogContainerService.create(HsLaymanLoginComponent, this.authUrl());
    }
}
HsLaymanCurrentUserComponent.ɵfac = function HsLaymanCurrentUserComponent_Factory(t) { return new (t || HsLaymanCurrentUserComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc2.HttpClient), ɵngcc0.ɵɵdirectiveInject(HsCommonLaymanService), ɵngcc0.ɵɵdirectiveInject(HsDialogContainerService)); };
HsLaymanCurrentUserComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsLaymanCurrentUserComponent, selectors: [["hs-layman-current-user"]], inputs: { endpoint: "endpoint" }, decls: 1, vars: 1, consts: [["style", "margin-left: 1em; float: right; ", 4, "ngIf"], [2, "margin-left", "1em", "float", "right"], ["class", "btn btn-block btn-primary", "style", "border-radius: 0.25rem; color: #fff;", 3, "click", 4, "ngIf"], ["class", "btn btn-block btn-primary", "style", "border-radius: 0.25rem; color: #fff;", "target", "_blank", 3, "href", "click", 4, "ngIf"], [1, "btn", "btn-block", "btn-primary", 2, "border-radius", "0.25rem", "color", "#fff", 3, "click"], ["target", "_blank", 1, "btn", "btn-block", "btn-primary", 2, "border-radius", "0.25rem", "color", "#fff", 3, "href", "click"]], template: function HsLaymanCurrentUserComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, HsLaymanCurrentUserComponent_div_0_Template, 4, 3, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.endpoint);
    } }, directives: [ɵngcc3.NgIf], pipes: [ɵngcc1.TranslatePipe], encapsulation: 2 });
HsLaymanCurrentUserComponent.ctorParameters = () => [
    { type: HttpClient },
    { type: HsCommonLaymanService },
    { type: HsDialogContainerService }
];
HsLaymanCurrentUserComponent.propDecorators = {
    endpoint: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsLaymanCurrentUserComponent, [{
        type: Component,
        args: [{
                selector: 'hs-layman-current-user',
                template: "<div *ngIf=\"endpoint\" style=\"margin-left: 1em; float: right; \">\n    <a class=\"btn btn-block btn-primary\" style=\"border-radius: 0.25rem; color: #fff;\" (click)=\"login();\" *ngIf=\"isGuest() && sameDomain()\">\n        {{'COMPOSITIONS.loginToCatalogue' | translate}}</a>\n    <a class=\"btn btn-block btn-primary\" style=\"border-radius: 0.25rem; color: #fff;\" (click)=\"login();\" *ngIf=\"isGuest() && !sameDomain()\" href=\"{{authUrl()}}\" target=\"_blank\">\n        {{'COMPOSITIONS.loginToCatalogue' | translate}}</a>\n    <a class=\"btn btn-block btn-primary\" style=\"border-radius: 0.25rem; color: #fff;\" (click)=\"logout()\" *ngIf=\"!isGuest()\">{{'COMMON.Logout' | translate }}\n        {{endpoint.user}}</a>\n</div>\n"
            }]
    }], function () { return [{ type: ɵngcc2.HttpClient }, { type: HsCommonLaymanService }, { type: HsDialogContainerService }]; }, { endpoint: [{
            type: Input
        }] }); })();

class HsLaymanModule {
}
HsLaymanModule.ɵfac = function HsLaymanModule_Factory(t) { return new (t || HsLaymanModule)(); };
HsLaymanModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: HsLaymanModule });
HsLaymanModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, TranslateModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsLaymanModule, [{
        type: NgModule,
        args: [{
                schemas: [CUSTOM_ELEMENTS_SCHEMA],
                declarations: [
                    HsLaymanLoginComponent,
                    HsLaymanCurrentUserComponent,
                    HsCommonLaymanAccessRightsComponent,
                ],
                imports: [CommonModule, TranslateModule],
                exports: [
                    HsLaymanLoginComponent,
                    HsLaymanCurrentUserComponent,
                    HsCommonLaymanAccessRightsComponent,
                ],
                entryComponents: [
                    HsLaymanLoginComponent,
                    HsLaymanCurrentUserComponent,
                    HsCommonLaymanAccessRightsComponent,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(HsLaymanModule, { declarations: function () { return [HsLaymanLoginComponent, HsLaymanCurrentUserComponent, HsCommonLaymanAccessRightsComponent]; }, imports: function () { return [CommonModule, TranslateModule]; }, exports: function () { return [HsLaymanLoginComponent, HsLaymanCurrentUserComponent, HsCommonLaymanAccessRightsComponent]; } }); })();

class HsPagerComponent {
    constructor() { }
    /**
     * Checks if next page for pagination is available
     */
    nextPageAvailable() {
        if (this.pagerService.listNext == this.pagerService.matchedRecords ||
            this.pagerService.matchedRecords == 0) {
            return true;
        }
        else {
            return false;
        }
    }
    /**
     * Load previous list of compositions to display on pager
     */
    getPreviousRecords() {
        this.pagerService.getPreviousRecords();
    }
    /**
     * Load next list of compositions to display on pager
     */
    getNextRecords() {
        this.pagerService.getNextRecords();
    }
    resultsVisible() {
        return this.pagerService.listNext && this.pagerService.matchedRecords
            ? true
            : false;
    }
}
HsPagerComponent.ɵfac = function HsPagerComponent_Factory(t) { return new (t || HsPagerComponent)(); };
HsPagerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsPagerComponent, selectors: [["hs-pager"]], inputs: { pagerService: "pagerService" }, decls: 1, vars: 1, consts: [["class", "card-footer", 4, "ngIf"], [1, "card-footer"], [1, "pagination", "d-flex", "justify-content-center"], [1, "page-item", 3, "ngClass", "ngStyle"], [1, "page-link", 3, "click"], ["aria-hidden", "true"], ["class", "page-item", 4, "ngIf"], [1, "page-item"], [1, "page-link"]], template: function HsPagerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, HsPagerComponent_div_0_Template, 12, 14, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.pagerService.matchedRecords !== 0 && !ctx.pagerService.dataLoading);
    } }, directives: [ɵngcc3.NgIf, ɵngcc3.NgClass, ɵngcc3.NgStyle], pipes: [ɵngcc1.TranslatePipe], encapsulation: 2 });
HsPagerComponent.ctorParameters = () => [];
HsPagerComponent.propDecorators = {
    pagerService: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsPagerComponent, [{
        type: Component,
        args: [{
                selector: 'hs-pager',
                template: "<div class=\"card-footer\"\n  *ngIf=\"pagerService.matchedRecords !== 0 && !pagerService.dataLoading\">\n  <ul class=\"pagination d-flex justify-content-center\">\n    <li class=\"page-item\" [ngClass]=\"{'disabled': pagerService.listStart === 0 }\"\n      [ngStyle]=\"{'color' : pagerService.listStart === 0 ? '#555' : '#007bff'}\">\n      <a class=\"page-link\" (click)=\"getPreviousRecords()\"><span aria-hidden=\"true\">&laquo;</span></a>\n    </li>\n    <li class=\"page-item\"\n      *ngIf=\"resultsVisible() && pagerService.listNext !== pagerService.matchedRecords\">\n      <span class=\"page-link\">\n        {{'COMMON.results' | translate}}\n        {{pagerService.listStart + 1}} -\n        {{pagerService.listNext}}</span>\n    </li>\n    <li class=\"page-item\"\n      *ngIf=\"resultsVisible() && pagerService.listNext === pagerService.matchedRecords\">\n      <span class=\"page-link\">\n        {{'COMMON.results' | translate}}\n        {{pagerService.listStart + 1}} -\n        {{pagerService.matchedRecords}}</span>\n    </li>\n    <li class=\"page-item\" [ngClass]=\"{'disabled': nextPageAvailable() }\"\n      [ngStyle]=\"{'color' : nextPageAvailable() ? '#555' : '#007bff'}\">\n      <a class=\"page-link\" (click)=\"getNextRecords()\"><span aria-hidden=\"true\">&raquo;</span></a>\n    </li>\n  </ul>\n</div>"
            }]
    }], function () { return []; }, { pagerService: [{
            type: Input
        }] }); })();

class HsPagerModule {
}
HsPagerModule.ɵfac = function HsPagerModule_Factory(t) { return new (t || HsPagerModule)(); };
HsPagerModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: HsPagerModule });
HsPagerModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, TranslateModule, FormsModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsPagerModule, [{
        type: NgModule,
        args: [{
                declarations: [HsPagerComponent],
                imports: [CommonModule, TranslateModule, FormsModule],
                exports: [HsPagerComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(HsPagerModule, { declarations: function () { return [HsPagerComponent]; }, imports: function () { return [CommonModule, TranslateModule, FormsModule]; }, exports: function () { return [HsPagerComponent]; } }); })();

class HsAddDataCatalogueModule {
}
HsAddDataCatalogueModule.ɵfac = function HsAddDataCatalogueModule_Factory(t) { return new (t || HsAddDataCatalogueModule)(); };
HsAddDataCatalogueModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: HsAddDataCatalogueModule });
HsAddDataCatalogueModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule,
            TranslateModule,
            HsUiExtensionsModule,
            HsLaymanModule,
            NgbModule,
            HsPagerModule,
            HsCatalogueMetadataModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsAddDataCatalogueModule, [{
        type: NgModule,
        args: [{
                schemas: [CUSTOM_ELEMENTS_SCHEMA],
                declarations: [HsAddDataCatalogueComponent, HsCatalogueListItemComponent],
                imports: [
                    CommonModule,
                    FormsModule,
                    TranslateModule,
                    HsUiExtensionsModule,
                    HsLaymanModule,
                    NgbModule,
                    HsPagerModule,
                    HsCatalogueMetadataModule,
                ],
                exports: [
                    HsAddDataCatalogueComponent,
                    HsCatalogueListItemComponent,
                    HsCatalogueMetadataComponent,
                ],
                entryComponents: [
                    HsAddDataCatalogueComponent,
                    HsCatalogueListItemComponent,
                    HsCatalogueMetadataComponent,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(HsAddDataCatalogueModule, { declarations: function () { return [HsAddDataCatalogueComponent, HsCatalogueListItemComponent]; }, imports: function () { return [CommonModule,
        FormsModule,
        TranslateModule, HsUiExtensionsModule, HsLaymanModule, NgbModule, HsPagerModule, HsCatalogueMetadataModule]; }, exports: function () { return [HsAddDataCatalogueComponent, HsCatalogueListItemComponent, HsCatalogueMetadataComponent]; } }); })();

// import {HsDragDropLayerService} from './drag-drop-layer.service';
class HsAddDataFileComponent {
    constructor(hsConfig, hsLanguageService) {
        this.hsConfig = hsConfig;
        this.hsLanguageService = hsLanguageService;
        if (Array.isArray(this.hsConfig.connectTypes)) {
            this.types = this.hsConfig.connectTypes;
        }
        else {
            this.types = [
                {
                    id: 'kml',
                    text: 'KML',
                },
                {
                    id: 'geojson',
                    text: 'GeoJSON',
                },
                {
                    id: 'shp',
                    text: 'Shapefile',
                },
            ];
        }
        this.typeSelected = '';
    }
    selectType(type) {
        this.typeSelected = type;
    }
}
HsAddDataFileComponent.ɵfac = function HsAddDataFileComponent_Factory(t) { return new (t || HsAddDataFileComponent)(ɵngcc0.ɵɵdirectiveInject(HsConfig), ɵngcc0.ɵɵdirectiveInject(HsLanguageService)); };
HsAddDataFileComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsAddDataFileComponent, selectors: [["hs-add-data-file"]], decls: 8, vars: 4, consts: [[1, "d-flex", "justify-content-center", "flex-column", "align-items-center", "m-3"], [1, "container"], [1, "row", "justify-content-center"], ["style", "margin: 3px;", "class", "btn btn-light btn-outline-secondary rounded btn-sm mt-1 col-sm-3", 3, "ngClass", "click", 4, "ngFor", "ngForOf"], [1, "w-100", "pt-3"], [3, "dataType", 4, "ngIf"], [4, "ngIf"], [1, "btn", "btn-light", "btn-outline-secondary", "rounded", "btn-sm", "mt-1", "col-sm-3", 2, "margin", "3px", 3, "ngClass", "click"], [3, "dataType"]], template: function HsAddDataFileComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵtemplate(3, HsAddDataFileComponent_button_3_Template, 2, 4, "button", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 4);
        ɵngcc0.ɵɵtemplate(5, HsAddDataFileComponent_hs_add_data_url_vector_5_Template, 1, 1, "hs-add-data-url-vector", 5);
        ɵngcc0.ɵɵtemplate(6, HsAddDataFileComponent_hs_add_data_url_vector_6_Template, 1, 1, "hs-add-data-url-vector", 5);
        ɵngcc0.ɵɵtemplate(7, HsAddDataFileComponent_hs_add_data_file_shp_7_Template, 1, 0, "hs-add-data-file-shp", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.types);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.typeSelected === "geojson");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.typeSelected === "kml");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.typeSelected === "shp");
    } }, directives: function () { return [ɵngcc3.NgForOf, ɵngcc3.NgIf, ɵngcc3.NgClass, HsAddDataVectorComponent, HsAddDataFileShpComponent]; }, encapsulation: 2 });
HsAddDataFileComponent.ctorParameters = () => [
    { type: HsConfig },
    { type: HsLanguageService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsAddDataFileComponent, [{
        type: Component,
        args: [{
                selector: 'hs-add-data-file',
                template: "<div class=\"d-flex justify-content-center flex-column align-items-center m-3\">\n    <div class=\"container \">\n        <div class=\"row justify-content-center\">\n            <button *ngFor=\"let type of types\" [ngClass]=\"{'active': type.id === typeSelected }\"\n                (click)=\"selectType(type.id)\" style=\"margin: 3px;\"\n                class=\"btn btn-light btn-outline-secondary rounded btn-sm mt-1 col-sm-3\">\n                {{type.text}}\n            </button>\n        </div>\n    </div>\n    <div class=\"w-100 pt-3\">\n        <hs-add-data-url-vector [dataType]=\"typeSelected\" *ngIf=\"typeSelected === 'geojson' \"></hs-add-data-url-vector>\n        <hs-add-data-url-vector [dataType]=\"typeSelected\" *ngIf=\"typeSelected === 'kml' \"></hs-add-data-url-vector>\n        <hs-add-data-file-shp *ngIf=\"typeSelected === 'shp'\"></hs-add-data-file-shp>\n    </div>\n</div>\n"
            }]
    }], function () { return [{ type: HsConfig }, { type: HsLanguageService }]; }, null); })();

class HsAddDataTargetPositionComponent {
    constructor(hsLayerUtilsService, hsLayerManagerService) {
        this.hsLayerUtilsService = hsLayerUtilsService;
        this.hsLayerManagerService = hsLayerManagerService;
        this.addUnderChange = new EventEmitter();
    }
    updateChanges() {
        this.addUnderChange.next(this.addUnder);
    }
}
HsAddDataTargetPositionComponent.ɵfac = function HsAddDataTargetPositionComponent_Factory(t) { return new (t || HsAddDataTargetPositionComponent)(ɵngcc0.ɵɵdirectiveInject(HsLayerUtilsService), ɵngcc0.ɵɵdirectiveInject(HsLayerManagerService)); };
HsAddDataTargetPositionComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsAddDataTargetPositionComponent, selectors: [["hs-add-data-target-position"]], inputs: { addUnder: "addUnder" }, outputs: { addUnderChange: "addUnderChange" }, decls: 11, vars: 9, consts: [[1, "form-group"], [1, "input-group"], [1, "input-group-prepend"], [1, "input-group-text", "control-label"], ["name", "addUnder", 1, "form-control", 3, "ngModel", "ngModelChange"], ["selected", "", 3, "ngValue"], [3, "ngValue", 4, "ngFor", "ngForOf"], [3, "ngValue"]], template: function HsAddDataTargetPositionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "span", 3);
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵpipe(5, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "select", 4);
        ɵngcc0.ɵɵlistener("ngModelChange", function HsAddDataTargetPositionComponent_Template_select_ngModelChange_6_listener($event) { return ctx.addUnder = $event; })("ngModelChange", function HsAddDataTargetPositionComponent_Template_select_ngModelChange_6_listener() { return ctx.updateChanges(); });
        ɵngcc0.ɵɵelementStart(7, "option", 5);
        ɵngcc0.ɵɵtext(8);
        ɵngcc0.ɵɵpipe(9, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(10, HsAddDataTargetPositionComponent_option_10_Template, 2, 2, "option", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(5, 5, "ADDLAYERS.under"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngModel", ctx.addUnder);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngValue", null);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(9, 7, "ADDLAYERS.none"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.hsLayerManagerService.data.layers);
    } }, directives: [ɵngcc5.SelectControlValueAccessor, ɵngcc5.NgControlStatus, ɵngcc5.NgModel, ɵngcc5.NgSelectOption, ɵngcc5.ɵNgSelectMultipleOption, ɵngcc3.NgForOf], pipes: [ɵngcc1.TranslatePipe], encapsulation: 2 });
HsAddDataTargetPositionComponent.ctorParameters = () => [
    { type: HsLayerUtilsService },
    { type: HsLayerManagerService }
];
HsAddDataTargetPositionComponent.propDecorators = {
    addUnder: [{ type: Input }],
    addUnderChange: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsAddDataTargetPositionComponent, [{
        type: Component,
        args: [{
                selector: 'hs-add-data-target-position',
                template: "<div class=\"form-group\">\n    <div class=\"input-group\">\n        <div class=\"input-group-prepend\">\n            <span class=\"input-group-text control-label\">{{'ADDLAYERS.under' | translate}}</span>\n        </div>\n        <select class=\"form-control\" [(ngModel)]=\"addUnder\" (ngModelChange)=\"updateChanges()\" name=\"addUnder\">\n            <option [ngValue]=\"null\" selected>{{'ADDLAYERS.none' | translate}}</option>\n            <option [ngValue]=\"layer.layer\" *ngFor=\"let layer of hsLayerManagerService.data.layers\">{{hsLayerUtilsService.translateTitle(layer.title)}}</option>\n        </select>\n    </div>\n</div>"
            }]
    }], function () { return [{ type: HsLayerUtilsService }, { type: HsLayerManagerService }]; }, { addUnderChange: [{
            type: Output
        }], addUnder: [{
            type: Input
        }] }); })();

class HsCommonUrlAddComponent {
    constructor(hsAddDataUrlService) {
        this.hsAddDataUrlService = hsAddDataUrlService;
        this.selectAll = true;
    }
    /**
     * Select all layers from service.
     */
    selectAllLayers() {
        this.selectAll = !this.selectAll;
        this.checkAllLayers(this.layers);
    }
    checkAllLayers(layers) {
        if (!layers) {
            return;
        }
        for (const layer of layers) {
            layer.checked = false;
            layer.checked = !this.selectAll;
            if (layer.Layer) {
                this.checkAllLayers(layer.Layer);
            }
        }
        this.changed();
    }
    addLayers(checked) {
        this.injectedService.addLayers(checked);
        //FIXME: to implement
        // this.injectedService.zoomToLayers();
    }
    changed() {
        this.hsAddDataUrlService.searchForChecked(this.layers);
    }
}
HsCommonUrlAddComponent.ɵfac = function HsCommonUrlAddComponent_Factory(t) { return new (t || HsCommonUrlAddComponent)(ɵngcc0.ɵɵdirectiveInject(HsAddDataUrlService)); };
HsCommonUrlAddComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsCommonUrlAddComponent, selectors: [["hs-common-url-add"]], inputs: { layers: "layers", injectedService: "injectedService" }, decls: 8, vars: 10, consts: [[1, "w-100", "d-flex", "justify-content-between", "pb-2", 2, "position", "sticky", "bottom", "0", "background", "var(--panel-wrapper-bg-color)"], [1, "btn", "btn-primary", 3, "click"], [1, "btn", "btn-primary", 3, "disabled", "title", "click"]], template: function HsCommonUrlAddComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "button", 1);
        ɵngcc0.ɵɵlistener("click", function HsCommonUrlAddComponent_Template_button_click_1_listener() { return ctx.selectAllLayers(); });
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵpipe(3, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "button", 2);
        ɵngcc0.ɵɵlistener("click", function HsCommonUrlAddComponent_Template_button_click_4_listener() { return ctx.addLayers(true); });
        ɵngcc0.ɵɵpipe(5, "translate");
        ɵngcc0.ɵɵtext(6);
        ɵngcc0.ɵɵpipe(7, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 4, "ADDLAYERS.selectAllLayers"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("disabled", !ctx.hsAddDataUrlService.hasAnyChecked)("title", ɵngcc0.ɵɵpipeBind1(5, 6, "ADDLAYERS.addSelected"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(7, 8, "ADDLAYERS.WFS.addToMap"));
    } }, pipes: [ɵngcc1.TranslatePipe], encapsulation: 2 });
HsCommonUrlAddComponent.ctorParameters = () => [
    { type: HsAddDataUrlService }
];
HsCommonUrlAddComponent.propDecorators = {
    layers: [{ type: Input }],
    injectedService: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsCommonUrlAddComponent, [{
        type: Component,
        args: [{
                selector: 'hs-common-url-add',
                template: "<div class=\"w-100 d-flex justify-content-between pb-2\" style=\"position: sticky;\n                bottom: 0; background: var(--panel-wrapper-bg-color)\">\n  <button class=\"btn btn-primary\" (click)=\"selectAllLayers()\">{{'ADDLAYERS.selectAllLayers' |\n    translate}}</button>\n  <button class=\"btn btn-primary\" [disabled]=\"!hsAddDataUrlService.hasAnyChecked\" [title]=\"'ADDLAYERS.addSelected' | translate\"\n    (click)=\"addLayers(true)\">{{'ADDLAYERS.WFS.addToMap' | translate}}</button>\n</div>"
            }]
    }], function () { return [{ type: HsAddDataUrlService }]; }, { layers: [{
            type: Input
        }], injectedService: [{
            type: Input
        }] }); })();

class HsHistoryListService {
    constructor(CookieService) {
        this.CookieService = CookieService;
        this.items = {};
    }
    readSourceHistory(forWhat) {
        if (forWhat !== undefined) {
            let sourceString = this.CookieService.get(`last${forWhat}Sources`);
            if (sourceString !== undefined) {
                this.items[forWhat] = {
                    history: [],
                };
                if (sourceString !== '') {
                    sourceString = sourceString.replace(/[\[\]\"]/gi, '');
                    const historyArray = sourceString.split(',');
                    for (const item of historyArray) {
                        this.items[forWhat].history.push(item);
                    }
                }
            }
            else {
                this.items[forWhat].history = [];
            }
            return this.items[forWhat].history;
        }
    }
    uniq(a) {
        return a.sort().filter((item, pos, ary) => {
            return !pos || item != ary[pos - 1];
        });
    }
    addSourceHistory(forWhat, url) {
        var _a, _b, _c;
        if (url === null || url === undefined) {
            return;
        }
        if (((_a = this.items[forWhat]) === null || _a === void 0 ? void 0 : _a.history) === undefined) {
            this.items[forWhat] = {
                history: [],
            };
        }
        if (!((_c = (_b = this.items[forWhat]) === null || _b === void 0 ? void 0 : _b.history) === null || _c === void 0 ? void 0 : _c.includes(url))) {
            this.items[forWhat].history.push(url);
            this.CookieService.set(`last${forWhat}Sources`, JSON.stringify(this.items[forWhat].history));
        }
    }
}
HsHistoryListService.ɵfac = function HsHistoryListService_Factory(t) { return new (t || HsHistoryListService)(ɵngcc0.ɵɵinject(ɵngcc8.CookieService)); };
HsHistoryListService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HsHistoryListService_Factory() { return new HsHistoryListService(i0.ɵɵinject(i1$2.CookieService)); }, token: HsHistoryListService, providedIn: "root" });
HsHistoryListService.ctorParameters = () => [
    { type: CookieService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsHistoryListService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc8.CookieService }]; }, null); })();

class HsCommonUrlComponent {
    constructor(historyListService) {
        this.historyListService = historyListService;
        this.urlChange = new EventEmitter();
        this.connect = new EventEmitter();
        this.items = this.historyListService.readSourceHistory(this.what);
    }
    emitConnect() {
        this.connect.emit();
    }
    change() {
        this.urlChange.emit(this.url.trim());
    }
    historySelected(url) {
        this.url = url;
        this.change();
    }
}
HsCommonUrlComponent.ɵfac = function HsCommonUrlComponent_Factory(t) { return new (t || HsCommonUrlComponent)(ɵngcc0.ɵɵdirectiveInject(HsHistoryListService)); };
HsCommonUrlComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsCommonUrlComponent, selectors: [["hs-common-url"]], inputs: { url: "url", type: "type" }, outputs: { urlChange: "urlChange", connect: "connect" }, decls: 8, vars: 6, consts: [[1, "form-group"], [1, "input-group"], ["type", "url", "name", "url", "required", "", 1, "form-control", 2, "height", "auto", 3, "ngModel", "placeholder", "ngModelChange", "change"], ["uri", "ngModel"], [1, "input-group-append"], ["type", "button", "class", "btn btn-secondary", 3, "click", 4, "ngIf"], [3, "what", "historyUrlSelected", "whatChange"], ["type", "button", 1, "btn", "btn-secondary", 3, "click"], [1, "icon-link"]], template: function HsCommonUrlComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "input", 2, 3);
        ɵngcc0.ɵɵlistener("ngModelChange", function HsCommonUrlComponent_Template_input_ngModelChange_2_listener($event) { return ctx.url = $event; })("change", function HsCommonUrlComponent_Template_input_change_2_listener() { return ctx.change(); });
        ɵngcc0.ɵɵpipe(4, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 4);
        ɵngcc0.ɵɵtemplate(6, HsCommonUrlComponent_button_6_Template, 2, 0, "button", 5);
        ɵngcc0.ɵɵelementStart(7, "hs-history-list", 6);
        ɵngcc0.ɵɵlistener("historyUrlSelected", function HsCommonUrlComponent_Template_hs_history_list_historyUrlSelected_7_listener($event) { return ctx.historySelected($event); })("whatChange", function HsCommonUrlComponent_Template_hs_history_list_whatChange_7_listener($event) { return ctx.type = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r0 = ɵngcc0.ɵɵreference(3);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngModel", ctx.url)("placeholder", ɵngcc0.ɵɵpipeBind1(4, 4, "ADDLAYERS.externalDataSource"));
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", _r0.valid);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("what", ctx.type);
    } }, directives: function () { return [ɵngcc5.DefaultValueAccessor, ɵngcc5.RequiredValidator, ɵngcc5.NgControlStatus, ɵngcc5.NgModel, ɵngcc3.NgIf, HsHistoryListComponent]; }, pipes: function () { return [ɵngcc1.TranslatePipe]; }, encapsulation: 2 });
HsCommonUrlComponent.ctorParameters = () => [
    { type: HsHistoryListService }
];
HsCommonUrlComponent.propDecorators = {
    type: [{ type: Input }],
    url: [{ type: Input }],
    urlChange: [{ type: Output }],
    connect: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsCommonUrlComponent, [{
        type: Component,
        args: [{
                selector: 'hs-common-url',
                template: "<div class=\"form-group\">\n    <div class=\"input-group\">\n        <input type=\"url\" class=\"form-control\" name=\"url\" [(ngModel)]=\"url\" (change)=\"change()\"\n            [placeholder]=\"'ADDLAYERS.externalDataSource' | translate\" required #uri=\"ngModel\" style=\"height: auto;\" />\n\n        <div class=\"input-group-append\">\n\n            <button type=\"button\" class=\"btn btn-secondary\" *ngIf=\"uri.valid\" (click)=\"emitConnect()\"><i\n                    class=\"icon-link\"></i></button>\n\n            <!-- TODO: Folllowing should be validating URL and warning user if URL is invalid -->\n\n            <!-- <button type=\"button\" class=\"btn btn-danger\" *ngIf=\"uri && !uri.valid\"><i\n                    class=\"icon-alertalt\"></i></button> -->\n            <hs-history-list (historyUrlSelected)=\"historySelected($event)\" [(what)]=\"type\"></hs-history-list>\n        </div>\n    </div>\n</div>\n"
            }]
    }], function () { return [{ type: HsHistoryListService }]; }, { urlChange: [{
            type: Output
        }], connect: [{
            type: Output
        }], url: [{
            type: Input
        }], type: [{
            type: Input
        }] }); })();

/**
 * Replace Urls in text by anchor html tag with url, useful for attribution to be clickable
 *
 * @param url - String to look for Urls
 * @returns Text with added anchors
 */
function addAnchors(url) {
    if (!url) {
        return null;
    }
    const exp = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
    return url.replace(exp, "<a href='$1'>$1</a>");
}

class HsAddDataUrlWmsService {
    constructor(hsMapService, hsWmsGetCapabilitiesService, hsDimensionService, hsLayoutService, hsUtilsService, hsConfig, hsAddDataService, hsEventBusService, hsAddDataUrlService, hsAddDataCommonUrlService) {
        this.hsMapService = hsMapService;
        this.hsWmsGetCapabilitiesService = hsWmsGetCapabilitiesService;
        this.hsDimensionService = hsDimensionService;
        this.hsLayoutService = hsLayoutService;
        this.hsUtilsService = hsUtilsService;
        this.hsConfig = hsConfig;
        this.hsAddDataService = hsAddDataService;
        this.hsEventBusService = hsEventBusService;
        this.hsAddDataUrlService = hsAddDataUrlService;
        this.hsAddDataCommonUrlService = hsAddDataCommonUrlService;
        this.data = {
            add_under: null,
            map_projection: '',
            register_metadata: true,
            tile_size: 512,
            use_resampling: false,
            use_tiles: true,
            visible: true,
        };
        this.hsEventBusService.olMapLoads.subscribe(() => {
            this.data.map_projection = this.hsMapService.map
                .getView()
                .getProjection()
                .getCode()
                .toUpperCase();
        });
    }
    addLayerFromCapabilities(wrapper) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!wrapper.response && !wrapper.error) {
                return;
            }
            if (wrapper.error) {
                this.hsAddDataCommonUrlService.throwParsingError(wrapper.response.message);
                return;
            }
            try {
                yield this.capabilitiesReceived(wrapper.response, this.hsAddDataCommonUrlService.layerToSelect);
                if (this.hsAddDataCommonUrlService.layerToSelect) {
                    this.addLayers(true);
                }
            }
            catch (e) {
                this.hsAddDataCommonUrlService.throwParsingError(e);
            }
        });
    }
    /**
     * Expands all sibling cells belonging to the same row after overflown cell is clicked
     */
    expandTableRow(e) {
        const action = e.target.className.includes('hs-wms-expandedRow')
            ? 'remove'
            : 'add';
        if (this.hsUtilsService.isOverflown(e.target) || action == 'remove') {
            const selectedRow = e.target.parentElement;
            for (const el of selectedRow.children) {
                el.classList[action]('hs-wms-expandedRow');
            }
        }
    }
    /**
     * Fills list of available projections
     */
    fillProjections(caps, response) {
        if (caps.Capability.Layer.CRS !== undefined) {
            this.data.srss = caps.Capability.Layer.CRS;
        }
        else if (caps.Capability.Layer.Layer &&
            caps.Capability.Layer.Layer.length > 0 &&
            caps.Capability.Layer.Layer[0].CRS) {
            this.data.srss = caps.Capability.Layer.Layer[0].CRS;
        }
        else {
            const oParser = new DOMParser();
            const oDOM = oParser.parseFromString(response, 'application/xml');
            const doc = oDOM.documentElement;
            doc.querySelectorAll('Capability>Layer CRS').forEach((srs) => {
                this.data.srss.push(srs.innerHTML);
            });
            /**
             * SRS is a malformed input and an error but let's be generous...
             */
            if (this.data.srss.length == 0) {
                doc.querySelectorAll('Capability>Layer SRS').forEach((srs) => {
                    this.data.srss.push(srs.innerHTML);
                });
            }
            //filter out duplicate records
            this.data.srss = [...new Set(this.data.srss)];
        }
        if (this.data.srss.length == 0) {
            this.data.srss = ['EPSG:4326'];
            this.hsAddDataCommonUrlService.throwParsingError("No CRS found in the service's Capabilities. This is an error on the provider's site. Guessing WGS84 will be supported. This may or may not be correct.");
        }
    }
    capabilitiesReceived(response, layerToSelect) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const parser = new WMSCapabilities();
                const caps = parser.read(response);
                this.data.map_projection = this.hsMapService.map
                    .getView()
                    .getProjection()
                    .getCode()
                    .toUpperCase();
                this.data.title = caps.Service.Title || 'Wms layer';
                this.data.description = addAnchors(caps.Service.Abstract);
                this.data.version = caps.Version || caps.version;
                this.data.image_formats = caps.Capability.Request.GetMap.Format
                    ? caps.Capability.Request.GetMap.Format
                    : [];
                this.data.query_formats = caps.Capability.Request.GetFeatureInfo
                    ? caps.Capability.Request.GetFeatureInfo.Format
                    : [];
                this.data.exceptions = caps.Capability.Exception;
                this.data.srss = [];
                this.fillProjections(caps, response);
                //TODO: WHY?
                if (this.data.srss.includes('CRS:84')) {
                    this.data.srss.splice(this.data.srss.indexOf('CRS:84'), 1);
                }
                if (this.hsAddDataCommonUrlService.currentProjectionSupported(this.data.srss)) {
                    this.data.srs = this.data.srss.includes(this.hsMapService.map.getView().getProjection().getCode())
                        ? this.hsMapService.map.getView().getProjection().getCode()
                        : this.hsMapService.map
                            .getView()
                            .getProjection()
                            .getCode()
                            .toLowerCase();
                }
                else if (this.data.srss.includes('EPSG:4326')) {
                    this.data.srs = 'EPSG:4326';
                }
                else {
                    this.data.srs = this.data.srss[0];
                }
                this.data.resample_warning = this.hsAddDataCommonUrlService.srsChanged(this.data.srs);
                this.data.services = this.filterCapabilitiesLayers(caps.Capability.Layer);
                //Make sure every service has a title to be displayed in table
                for (const service of this.data.services) {
                    if (service.Title.length == 0) {
                        service.Title = service.Name;
                    }
                }
                const serviceLayer = this.hsAddDataUrlService.selectLayerByName(layerToSelect, this.data.services, 'Name');
                //TODO: shalln't we move this logic after the layer is added to map?
                if (layerToSelect) {
                    this.data.extent = this.getLayerBBox(serviceLayer);
                }
                else {
                    this.data.extent = this.calcAllLayersExtent(this.data.services);
                }
                this.hsAddDataUrlService.selectLayerByName(layerToSelect, this.data.services, 'Name');
                this.hsDimensionService.fillDimensionValues(caps.Capability.Layer);
                this.data.get_map_url = this.removePortIfProxified(caps.Capability.Request.GetMap.DCPType[0].HTTP.Get.OnlineResource);
                this.data.image_format = getPreferredFormat(this.data.image_formats, [
                    'image/png; mode=8bit',
                    'image/png',
                    'image/gif',
                    'image/jpeg',
                ]);
                this.data.query_format = getPreferredFormat(this.data.query_formats, [
                    'application/vnd.esri.wms_featureinfo_xml',
                    'application/vnd.ogc.gml',
                    'application/vnd.ogc.wms_xml',
                    'text/plain',
                    'text/html',
                ]);
                this.hsAddDataCommonUrlService.loadingInfo = false;
            }
            catch (e) {
                throw new Error(e);
            }
        });
    }
    /**
     * For given array of layers (service layer definitions) it calculates a cumulative bounding box which encloses all the layers
     */
    calcAllLayersExtent(serviceLayers) {
        if (!Array.isArray(serviceLayers)) {
            return this.getLayerBBox(serviceLayers);
        }
        return serviceLayers
            .map((lyr) => this.getLayerBBox(lyr))
            .reduce((acc, curr) => {
            //some services define layer bboxes beyond the canonical 180/90 degrees intervals, the checks are necessary then
            const [west, south, east, north] = curr;
            //minimum easting
            if (-180 <= west < acc[0]) {
                acc[0] = west;
            }
            //minimum northing
            if (-90 <= south < acc[1]) {
                acc[1] = south;
            }
            //maximum easting
            if (180 >= east > acc[2]) {
                acc[2] = east;
            }
            //maximum northing
            if (90 >= north > acc[3]) {
                acc[3] = north;
            }
            return acc;
        });
    }
    getLayerBBox(serviceLayer) {
        return serviceLayer.EX_GeographicBoundingBox; // TODO: ?? serviceLayer.BoundingBox; (is more complex, contains SRS definition etc.)
    }
    //TODO: what is the reason to do such things?
    filterCapabilitiesLayers(layers) {
        if (Array.isArray(layers)) {
            return layers;
        }
        let tmp = [];
        if (typeof layers == 'object') {
            if (layers.Layer && Array.isArray(layers.Layer)) {
                const layersWithNameParam = layers.Layer.filter((layer) => layer.Name);
                if (layersWithNameParam.length > 0) {
                    return layersWithNameParam;
                }
                for (const layer of layers.Layer) {
                    if (Array.isArray(layer === null || layer === void 0 ? void 0 : layer.Layer)) {
                        tmp.push(...layer.Layer.filter((layer) => layer.Name));
                    }
                }
            }
            else {
                tmp = [layers];
            }
        }
        return tmp;
    }
    /**
     * Removes extra port which is added to the getMap request when
     * GetCapabilities is queried through proxy. <GetMap><DCPType><HTTP><Get>
     * \<OnlineResource xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="http://gis.lesprojekt.cz/cgi-bin/mapserv?map=/home/maps"/\>
     * then becomes <GetMap><DCPType><HTTP><Get>
     * \<OnlineResource xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="http://gis.lesprojekt.cz:8085/cgi-bin/mapserv?map=/home/maps"/\>
     * which is wrong.
     * @param url - URL for which to remove port but only when proxified
     * with port in proxy path.
     * @returns URL without proxy services port added to it.
     */
    removePortIfProxified(url) {
        if (this.hsConfig.proxyPrefix === undefined) {
            return url;
        }
        const proxyPort = parseInt(this.hsUtilsService.getPortFromUrl(this.hsConfig.proxyPrefix));
        if (proxyPort > 0) {
            return url.replace(':' + proxyPort.toString(), '');
        }
        return url;
    }
    /**
     * Second step in adding layers to the map, with resampling or without. Loops through the list of layers and calls addLayer.
     * @param checkedOnly - Add all available layers or only checked ones. checkedOnly=false=all
     */
    addLayers(checkedOnly) {
        if (this.data.services === undefined) {
            return;
        }
        //Limit visible layers to 10 to not freeze accidentally
        this.data.visible =
            this.data.services.filter((l) => l.checked === true).length <= 10;
        if (this.data.base) {
            this.addLayer({}, {
                layerName: this.data.title.replace(/\//g, '&#47;'),
                layerTitle: this.hsUtilsService.undefineEmptyString(this.data.folder_name),
                imageFormat: this.data.image_format,
                queryFormat: this.data.query_format,
                tileSize: this.data.tile_size,
                crs: this.data.srs,
                subLayers: null,
            });
        }
        else {
            for (const layer of this.data.services) {
                this.addLayersRecursively(layer, { checkedOnly: checkedOnly });
            }
            this.zoomToLayers();
        }
        this.data.base = false;
        this.hsLayoutService.setMainPanel('layermanager');
    }
    /**
     * Add selected layer to map
     * @param layer - capabilities layer object
     * @param layerName - layer name in the map
     * @param path - Path (folder) name
     * @param imageFormat - Format in which to serve image. Usually: image/png
     * @param queryFormat - See info_format in https://docs.geoserver.org/stable/en/user/services/wms/reference.html
     * @param tileSize - Tile size in pixels
     * @param crs - of the layer
     * @param subLayers - Static sub-layers of the layer
     */
    addLayer(layer, options) {
        let attributions = [];
        if (layer.Attribution) {
            attributions = [
                `<a href="${layer.Attribution.OnlineResource}">${layer.Attribution.Title}</a>`,
            ];
        }
        let boundingbox = layer.BoundingBox;
        let preferred;
        if (Array.isArray(layer.BoundingBox)) {
            preferred = boundingbox.filter((bboxInCrs) => {
                return bboxInCrs.crs == this.data.map_projection;
            })[0];
        }
        if (preferred) {
            boundingbox = preferred.extent;
        }
        else if (options.crs !== undefined) {
            if (layer.EX_GeographicBoundingBox !== undefined) {
                boundingbox = transformExtent(layer.EX_GeographicBoundingBox, 'EPSG:4326', this.hsMapService.map.getView().getProjection());
            }
        }
        else {
            if (this.data.map_projection != options.crs) {
                boundingbox = layer.LatLonBoundingBox;
            }
        }
        const dimensions = {};
        if (layer.Dimension) {
            for (const val of layer.Dimension) {
                dimensions[val.name] = val;
            }
        }
        const { styles, legends } = this.getLayerStyles(layer);
        const sourceOptions = {
            url: this.data.get_map_url,
            attributions,
            projection: this.data.srs,
            params: Object.assign({ LAYERS: this.data.base
                    ? this.hsAddDataCommonUrlService.createBasemapName(this.data.services, 'Name')
                    : layer.Name, INFO_FORMAT: layer.queryable ? options.queryFormat : undefined, FORMAT: options.imageFormat, VERSION: this.data.version, STYLES: styles }, this.hsDimensionService.paramsFromDimensions(layer)),
            crossOrigin: 'anonymous',
        };
        const source = !this.data.use_tiles
            ? new ImageWMS(sourceOptions)
            : new TileWMS(sourceOptions);
        const metadata = this.hsWmsGetCapabilitiesService.getMetadataObjectWithUrls(layer);
        const layerOptions = {
            title: options.layerName,
            name: options.layerName,
            source,
            minResolution: layer.MinScaleDenominator,
            maxResolution: layer.MaxScaleDenominator,
            removable: true,
            abstract: layer.Abstract,
            metadata,
            extent: boundingbox,
            path: options.path,
            dimensions: dimensions,
            legends: legends,
            subLayers: options.subLayers,
            base: this.data.base,
            visible: this.data.visible,
        };
        const new_layer = !this.data.use_tiles
            ? new Image$1(layerOptions)
            : new Tile(layerOptions);
        this.hsMapService.proxifyLayerLoader(new_layer, this.data.use_tiles);
        this.hsAddDataService.addLayer(new_layer, this.data.add_under);
    }
    getLayerStyles(layer) {
        var _a;
        const legends = [];
        let styles = undefined;
        if (layer.styleSelected) {
            styles = layer.styleSelected.Name;
            if (((_a = layer.styleSelected.LegendURL) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                legends.push(layer.styleSelected.LegendURL[0].OnlineResource);
            }
        }
        else if (layer.Style && layer.Style.length > 0) {
            const firstStyle = layer.Style[0];
            styles = firstStyle.Name;
            if (firstStyle.LegendURL) {
                legends.push(firstStyle.LegendURL[0].OnlineResource);
            }
        }
        else {
            styles = '';
        }
        return { styles, legends };
    }
    /**
     * FIXME: UNUSED
     * Add service and its layers to project
     * @param url - Service URL
     * @param addUnder - OL layer before which to add new layer
     * @param path - Folder name with path to group layers
     * @param group - Group layer to which add layer to
     * @param layerName - Name of layer to add. If not specified then all layers are added
     */
    addService(url, group, layerName, addUnder, path) {
        return __awaiter(this, void 0, void 0, function* () {
            const wrapper = yield this.hsWmsGetCapabilitiesService.request(url);
            let ol_layers = this.hsWmsGetCapabilitiesService.service2layers(wrapper.response, path);
            if (layerName) {
                ol_layers = ol_layers.filter((layer) => getName(layer) == layerName ||
                    (getName(layer) == undefined && //Backwards compatibility with layman when title==name
                        getTitle(layer) == layerName));
            }
            ol_layers.forEach((layer) => {
                if (group !== undefined) {
                    group.getLayers().push(layer);
                }
                else {
                    this.hsAddDataService.addLayer(layer, addUnder);
                }
            });
        });
    }
    addLayersRecursively(layer, options = { checkedOnly: true }) {
        if (!options.checkedOnly || layer.checked) {
            if (layer.Layer === undefined) {
                this.addLayer(layer, {
                    layerName: layer.Title.replace(/\//g, '&#47;'),
                    layerTitle: this.hsUtilsService.undefineEmptyString(this.data.folder_name),
                    imageFormat: this.data.image_format,
                    queryFormat: this.data.query_format,
                    tileSize: this.data.tile_size,
                    crs: this.data.srs,
                    subLayers: this.hsAddDataCommonUrlService.getSublayerNames(layer),
                });
            }
            else {
                const clone = this.hsUtilsService.structuredClone(layer);
                delete clone.Layer;
                this.addLayer(layer, {
                    layerName: layer.Title.replace(/\//g, '&#47;'),
                    layerTitle: this.hsUtilsService.undefineEmptyString(this.data.folder_name),
                    imageFormat: this.data.image_format,
                    queryFormat: this.data.query_format,
                    tileSize: this.data.tile_size,
                    crs: this.data.srs,
                    subLayers: this.hsAddDataCommonUrlService.getSublayerNames(layer),
                });
            }
        }
        if (layer.Layer) {
            for (const sublayer of layer.Layer) {
                this.addLayersRecursively(sublayer, { checkedOnly: options.checkedOnly });
            }
        }
    }
    zoomToLayers() {
        if (this.data.extent) {
            const extent = transformExtent(this.data.extent, 'EPSG:4326', this.hsMapService.map.getView().getProjection());
            if (extent) {
                this.hsMapService.fitExtent(extent);
            }
        }
    }
}
HsAddDataUrlWmsService.ɵfac = function HsAddDataUrlWmsService_Factory(t) { return new (t || HsAddDataUrlWmsService)(ɵngcc0.ɵɵinject(HsMapService), ɵngcc0.ɵɵinject(HsWmsGetCapabilitiesService), ɵngcc0.ɵɵinject(HsDimensionService), ɵngcc0.ɵɵinject(HsLayoutService), ɵngcc0.ɵɵinject(HsUtilsService), ɵngcc0.ɵɵinject(HsConfig), ɵngcc0.ɵɵinject(HsAddDataService), ɵngcc0.ɵɵinject(HsEventBusService), ɵngcc0.ɵɵinject(HsAddDataUrlService), ɵngcc0.ɵɵinject(HsAddDataCommonUrlService)); };
HsAddDataUrlWmsService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HsAddDataUrlWmsService_Factory() { return new HsAddDataUrlWmsService(i0.ɵɵinject(HsMapService), i0.ɵɵinject(HsWmsGetCapabilitiesService), i0.ɵɵinject(HsDimensionService), i0.ɵɵinject(HsLayoutService), i0.ɵɵinject(HsUtilsService), i0.ɵɵinject(HsConfig), i0.ɵɵinject(HsAddDataService), i0.ɵɵinject(HsEventBusService), i0.ɵɵinject(HsAddDataUrlService), i0.ɵɵinject(HsAddDataCommonUrlService)); }, token: HsAddDataUrlWmsService, providedIn: "root" });
HsAddDataUrlWmsService.ctorParameters = () => [
    { type: HsMapService },
    { type: HsWmsGetCapabilitiesService },
    { type: HsDimensionService },
    { type: HsLayoutService },
    { type: HsUtilsService },
    { type: HsConfig },
    { type: HsAddDataService },
    { type: HsEventBusService },
    { type: HsAddDataUrlService },
    { type: HsAddDataCommonUrlService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsAddDataUrlWmsService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: HsMapService }, { type: HsWmsGetCapabilitiesService }, { type: HsDimensionService }, { type: HsLayoutService }, { type: HsUtilsService }, { type: HsConfig }, { type: HsAddDataService }, { type: HsEventBusService }, { type: HsAddDataUrlService }, { type: HsAddDataCommonUrlService }]; }, null); })();

class HsCommonUrlDetailsComponent {
    constructor(hsAddDataUrlService, hsUtilsService, hsLayerUtilsService, hsAddDataService, hsLanguageService, hsAddDataUrlWmsService, hsAddDataCommonUrlService) {
        this.hsAddDataUrlService = hsAddDataUrlService;
        this.hsUtilsService = hsUtilsService;
        this.hsLayerUtilsService = hsLayerUtilsService;
        this.hsAddDataService = hsAddDataService;
        this.hsLanguageService = hsLanguageService;
        this.hsAddDataUrlWmsService = hsAddDataUrlWmsService;
        this.hsAddDataCommonUrlService = hsAddDataCommonUrlService;
        this.checkedSubLayers = {};
        this.limitShown = 100;
    }
    ngAfterContentInit() {
        this.hsAddDataUrlService.hasAnyChecked = false;
        this.data = this.injectedService.data;
        this.hasNestedLayers = this.hsLayerUtilsService.hasNestedLayers;
        this.getDimensionValues = this.hsAddDataCommonUrlService.getDimensionValues;
    }
    srsChanged() {
        this.data.resample_warning = this.hsAddDataCommonUrlService.srsChanged(this.data.srs);
    }
    searchForChecked(service) {
        this.checkedSubLayers[service.Name] = service.checked;
        this.hsAddDataUrlService.hasAnyChecked = Object.values(this.checkedSubLayers).some((value) => value === true);
    }
    reachedLimit() {
        var _a;
        if (((_a = this.data.services) === null || _a === void 0 ? void 0 : _a.length) > this.limitShown) {
            return true;
        }
        else {
            return false;
        }
    }
    changed() {
        this.hsAddDataUrlService.searchForChecked(this.data.services);
    }
}
HsCommonUrlDetailsComponent.ɵfac = function HsCommonUrlDetailsComponent_Factory(t) { return new (t || HsCommonUrlDetailsComponent)(ɵngcc0.ɵɵdirectiveInject(HsAddDataUrlService), ɵngcc0.ɵɵdirectiveInject(HsUtilsService), ɵngcc0.ɵɵdirectiveInject(HsLayerUtilsService), ɵngcc0.ɵɵdirectiveInject(HsAddDataService), ɵngcc0.ɵɵdirectiveInject(HsLanguageService), ɵngcc0.ɵɵdirectiveInject(HsAddDataUrlWmsService), ɵngcc0.ɵɵdirectiveInject(HsAddDataCommonUrlService)); };
HsCommonUrlDetailsComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsCommonUrlDetailsComponent, selectors: [["hs-common-url-details"]], inputs: { injectedService: "injectedService", type: "type" }, decls: 43, vars: 41, consts: [[3, "hidden"], [4, "ngIf"], [1, "form-group", 3, "hidden"], [1, "input-group"], [1, "input-group-prepend"], [1, "input-group-text", "control-label"], ["name", "folderName", 1, "form-control", 3, "ngModel", "ngModelChange"], [1, "form-group"], [1, "capabilities_input", "d-flex", "flex-column"], [1, "capabilities_label", "control-label"], ["type", "checkbox", "name", "registerMetadata", 1, "mr-2", "checkbox-lg", 3, "ngModel", "ngModelChange"], [1, "d-flex", "flex-column", "my-3"], [1, "d-flex", "flex-row", "justify-content-start", "align-items-baseline", "mb-1"], [1, "btn-group", "ml-2"], ["type", "button", 1, "btn", "btn-sm", "btn-light", "btn-outline-secondary", 3, "ngClass", "click"], [1, "input-group", 3, "hidden"], ["name", "baseTitle", 1, "form-control", 3, "ngModel", "ngModelChange"], [4, "ngIf", "ngIfElse"], ["simpleTable", ""], [1, "w-100", 3, "injectedService", "layers"], ["name", "imageFormat", 1, "form-control", 3, "ngModel", "ngModelChange"], [4, "ngFor", "ngForOf"], ["name", "queryFormat", 1, "form-control", 3, "ngModel", "ngModelChange"], ["name", "srs", 1, "form-control", 3, "ngModel", "ngModelChange", "change"], [1, "col-sm-12", "alert", "alert-danger", 3, "hidden"], ["type", "checkbox", "name", "useTiles", 1, "mr-1", "checkbox-lg", 3, "ngModel", "ngModelChange"], [1, "col-sm-12", "alert", "alert-warning", 3, "hidden"], ["name", "tileSize", 1, "form-control", 3, "ngModel", "ngModelChange"], [3, "addUnder", "addUnderChange"], [1, "table", "table-sm", "table-striped", "table-bordered"], [1, "bg-secondary", "text-light"], [2, "width", "1.5em"], [4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "align-middle"], [3, "ngClass"], ["type", "checkbox", "name", "service", 1, "checkbox-lg", 3, "ngModel", "ngModelChange", "change"], ["hsWmsLayerHighlight", "", 1, "text-truncate", 2, "max-width", "25.375em", 3, "title", "click"], ["hsWmsLayerHighlight", "", 1, "text-truncate", 2, "max-width", "10.875em", "width", "30%", 3, "title", "click"], ["colspan", "3", 2, "padding-left", "1em"], [2, "display", "block", 3, "layers", "layerChecked"], ["colspan", "3"], [1, "d-flex", "align-items-baseline", "px-2", "w-100"], [1, "d-flex", "align-items-baseline", 2, "flex-grow", "1"], [1, "control-label"], [1, "form-control", "form-control-sm", 3, "ngModel", "ngModelOptions", "ngModelChange"], [3, "ngValue", 4, "ngFor", "ngForOf"], [3, "ngValue"], [2, "width", "1em"], ["type", "checkbox", "name", "service", 1, "checkbox-lg", 3, "ngModel", "change", "ngModelChange"], ["class", "d-flex justify-content-around align-items-center m-3", 4, "ngIf"], [1, "d-flex", "justify-content-around", "align-items-center", "m-3"], [3, "translate", "translateParams"], ["type", "button", 1, "btn", "btn-sm", "btn-light", "btn-outline-secondary", 3, "click"]], template: function HsCommonUrlDetailsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, HsCommonUrlDetailsComponent_ng_container_1_Template, 26, 20, "ng-container", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelementStart(4, "div", 4);
        ɵngcc0.ɵɵelementStart(5, "span", 5);
        ɵngcc0.ɵɵtext(6);
        ɵngcc0.ɵɵpipe(7, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "input", 6);
        ɵngcc0.ɵɵlistener("ngModelChange", function HsCommonUrlDetailsComponent_Template_input_ngModelChange_8_listener($event) { return ctx.data.folder_name = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(9, HsCommonUrlDetailsComponent_ng_container_9_Template, 4, 4, "ng-container", 1);
        ɵngcc0.ɵɵelementStart(10, "div", 7);
        ɵngcc0.ɵɵelementStart(11, "div", 8);
        ɵngcc0.ɵɵtemplate(12, HsCommonUrlDetailsComponent_ng_container_12_Template, 5, 4, "ng-container", 1);
        ɵngcc0.ɵɵelementStart(13, "label", 9);
        ɵngcc0.ɵɵelementStart(14, "input", 10);
        ɵngcc0.ɵɵlistener("ngModelChange", function HsCommonUrlDetailsComponent_Template_input_ngModelChange_14_listener($event) { return ctx.data.register_metadata = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(15);
        ɵngcc0.ɵɵpipe(16, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(17, HsCommonUrlDetailsComponent_ng_container_17_Template, 4, 4, "ng-container", 1);
        ɵngcc0.ɵɵtemplate(18, HsCommonUrlDetailsComponent_ng_container_18_Template, 8, 4, "ng-container", 1);
        ɵngcc0.ɵɵelementStart(19, "div", 11);
        ɵngcc0.ɵɵelementStart(20, "div", 12);
        ɵngcc0.ɵɵtext(21);
        ɵngcc0.ɵɵpipe(22, "translate");
        ɵngcc0.ɵɵelementStart(23, "div", 13);
        ɵngcc0.ɵɵelementStart(24, "button", 14);
        ɵngcc0.ɵɵlistener("click", function HsCommonUrlDetailsComponent_Template_button_click_24_listener() { return ctx.data.base = true; });
        ɵngcc0.ɵɵtext(25);
        ɵngcc0.ɵɵpipe(26, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(27, "button", 14);
        ɵngcc0.ɵɵlistener("click", function HsCommonUrlDetailsComponent_Template_button_click_27_listener() { return ctx.data.base = false; });
        ɵngcc0.ɵɵtext(28);
        ɵngcc0.ɵɵpipe(29, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(30, "div", 15);
        ɵngcc0.ɵɵelementStart(31, "div", 4);
        ɵngcc0.ɵɵelementStart(32, "span", 5);
        ɵngcc0.ɵɵtext(33);
        ɵngcc0.ɵɵpipe(34, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(35, "input", 16);
        ɵngcc0.ɵɵlistener("ngModelChange", function HsCommonUrlDetailsComponent_Template_input_ngModelChange_35_listener($event) { return ctx.data.title = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(36, HsCommonUrlDetailsComponent_ng_container_36_Template, 2, 1, "ng-container", 1);
        ɵngcc0.ɵɵelement(37, "hr");
        ɵngcc0.ɵɵtemplate(38, HsCommonUrlDetailsComponent_ng_container_38_Template, 14, 14, "ng-container", 17);
        ɵngcc0.ɵɵtemplate(39, HsCommonUrlDetailsComponent_ng_template_39_Template, 9, 7, "ng-template", null, 18, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(41, HsCommonUrlDetailsComponent_ng_container_41_Template, 2, 1, "ng-container", 1);
        ɵngcc0.ɵɵelement(42, "hs-common-url-add", 19);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r7 = ɵngcc0.ɵɵreference(40);
        ɵngcc0.ɵɵproperty("hidden", !ctx.hsAddDataCommonUrlService.showDetails || ctx.hsAddDataCommonUrlService.loadingInfo);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.type !== "arcgis");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", ctx.data.base === true);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(7, 25, "ADDLAYERS.folderName"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngModel", ctx.data.folder_name);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.type === "wms");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.type === "wms");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngModel", ctx.data.register_metadata);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(16, 27, "ADDLAYERS.registerMetadata"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.type === "wms");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.type === "wms");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(22, 29, "ADDDATA.CATALOGUE.addAs"), " ");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(37, _c12, ctx.data.base));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(26, 31, "COMPOSITONKEYWORDS.Basemap"), " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(39, _c12, !ctx.data.base));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(29, 33, "COMMON.layer"), " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("hidden", !ctx.data.base);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(34, 35, "COMMON.title"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngModel", ctx.data.title);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.type === "wms");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.type === "wms")("ngIfElse", _r7);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.type === "wms");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("injectedService", ctx.injectedService)("layers", ctx.data.services);
    } }, directives: function () { return [ɵngcc3.NgIf, ɵngcc5.DefaultValueAccessor, ɵngcc5.NgControlStatus, ɵngcc5.NgModel, ɵngcc5.CheckboxControlValueAccessor, ɵngcc3.NgClass, HsCommonUrlAddComponent, ɵngcc5.SelectControlValueAccessor, ɵngcc3.NgForOf, ɵngcc5.NgSelectOption, ɵngcc5.ɵNgSelectMultipleOption, WmsLayerHighlightDirective, HsNestedLayersTableComponent, ɵngcc1.TranslateDirective]; }, pipes: function () { return [ɵngcc1.TranslatePipe, ɵngcc3.SlicePipe, TrackByPropertyPipe]; }, encapsulation: 2 });
HsCommonUrlDetailsComponent.ctorParameters = () => [
    { type: HsAddDataUrlService },
    { type: HsUtilsService },
    { type: HsLayerUtilsService },
    { type: HsAddDataService },
    { type: HsLanguageService },
    { type: HsAddDataUrlWmsService },
    { type: HsAddDataCommonUrlService }
];
HsCommonUrlDetailsComponent.propDecorators = {
    injectedService: [{ type: Input }],
    type: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsCommonUrlDetailsComponent, [{
        type: Component,
        args: [{
                selector: 'hs-common-url-details',
                template: "<div [hidden]=\"!hsAddDataCommonUrlService.showDetails || hsAddDataCommonUrlService.loadingInfo\">\n  <ng-container *ngIf=\"type !== 'arcgis'\">\n    <div class=\"form-group\">\n      <div class=\"input-group\">\n        <div class=\"input-group-prepend\">\n          <span class=\"input-group-text control-label\">{{'ADDLAYERS.imageFormat' | translate}}</span>\n        </div>\n        <select class=\"form-control\" name=\"imageFormat\" [(ngModel)]=\"data.image_format\">\n          <option *ngFor=\"let format of data.image_formats\">{{format}}</option>\n        </select>\n      </div>\n    </div>\n\n    <div class=\"form-group\">\n      <div class=\"input-group\">\n        <div class=\"input-group-prepend\">\n          <span class=\"input-group-text control-label\">{{'ADDLAYERS.queryFormat' | translate}}</span>\n        </div>\n        <select class=\"form-control\" name=\"queryFormat\" [(ngModel)]=\"data.query_format\">\n          <option *ngFor=\"let format of data.query_formats\">{{format}}</option>\n        </select>\n      </div>\n    </div>\n\n    <div class=\"form-group\" [hidden]=\"!data.srs || data.srs.toUpperCase() === data.map_projection\">\n      <div class=\"input-group\">\n        <div class=\"input-group-prepend\">\n          <span class=\"input-group-text control-label\">{{'ADDLAYERS.srs' | translate}}</span>\n        </div>\n        <select class=\"form-control\" name=\"srs\" [(ngModel)]=\"data.srs\" (change)=\"srsChanged()\">\n          <option *ngFor=\"let i of data.srss | slice:0:50\">{{i}}</option>\n        </select>\n      </div>\n    </div>\n  </ng-container>\n\n  <div class=\"form-group\" [hidden]=\"data.base === true\">\n    <div class=\"input-group\">\n      <div class=\"input-group-prepend\">\n        <span class=\"input-group-text control-label\">{{'ADDLAYERS.folderName' | translate}}</span>\n      </div>\n      <input class=\"form-control\" name=\"folderName\" [(ngModel)]=\"data.folder_name\" />\n    </div>\n  </div>\n  <ng-container *ngIf=\"type === 'wms'\">\n    <p class=\"col-sm-12 alert alert-danger\" [hidden]=\"!data.use_resampling\">\n      {{'ADDLAYERS.mapAndLayerProjection' | translate}}\n    </p>\n  </ng-container>\n  <div class=\"form-group\">\n    <div class=\"capabilities_input d-flex flex-column\">\n      <ng-container *ngIf=\"type === 'wms'\">\n        <label class=\"capabilities_label control-label\"> <input type=\"checkbox\" class=\"mr-1 checkbox-lg\" name=\"useTiles\"\n            [(ngModel)]=\"data.use_tiles\" />\n          {{'ADDLAYERS.useTiles' | translate}}\n        </label>\n      </ng-container>\n\n      <label class=\"capabilities_label control-label\"> <input type=\"checkbox\" class=\"mr-2 checkbox-lg\"\n          [(ngModel)]=\"data.register_metadata\" name=\"registerMetadata\" />{{'ADDLAYERS.registerMetadata' |\n        translate}}</label>\n    </div>\n  </div>\n  <ng-container *ngIf=\"type === 'wms'\">\n    <p class=\"col-sm-12 alert alert-warning\" [hidden]=\"data.use_tiles\">\n      {{'ADDLAYERS.considerUsingTiles' | translate}}\n    </p>\n  </ng-container>\n  <ng-container *ngIf=\"type === 'wms'\">\n    <div class=\"form-group\">\n      <div class=\"input-group\">\n        <div class=\"input-group-prepend\">\n          <span class=\"input-group-text control-label\">{{'ADDLAYERS.tileSize' | translate}}</span>\n        </div>\n        <input class=\"form-control\" name=\"tileSize\" [(ngModel)]=\"data.tile_size\" />\n      </div>\n    </div>\n  </ng-container>\n  <div class=\"d-flex flex-column my-3\">\n    <div class=\"d-flex flex-row justify-content-start align-items-baseline mb-1\">\n      {{'ADDDATA.CATALOGUE.addAs' | translate}}\n      <div class=\"btn-group ml-2\">\n        <button type=\"button\" class=\"btn btn-sm btn-light  btn-outline-secondary\" (click)=\"data.base = true\"\n          [ngClass]=\"{'active':data.base}\">\n          {{'COMPOSITONKEYWORDS.Basemap' | translate}}\n        </button>\n        <button type=\"button\" class=\"btn btn-sm btn-light  btn-outline-secondary\" (click)=\"data.base = false\"\n          [ngClass]=\"{'active': !data.base}\">\n          {{'COMMON.layer' | translate}}\n        </button>\n      </div>\n    </div>\n    <div [hidden]=\"!data.base\" class=\"input-group\">\n      <div class=\"input-group-prepend\">\n        <span class=\"input-group-text control-label\">{{'COMMON.title' | translate}}</span>\n      </div>\n      <input class=\"form-control\" name=\"baseTitle\" [(ngModel)]=\"data.title\" />\n    </div>\n  </div>\n  <ng-container *ngIf=\"type === 'wms'\">\n    <hs-add-layers-target-position [(addUnder)]=\"data.add_under\"></hs-add-layers-target-position>\n  </ng-container>\n  <hr />\n  <ng-container *ngIf=\"type === 'wms'; else simpleTable\">\n    <table class=\"table table-sm table-striped table-bordered\">\n      <thead class=\"bg-secondary text-light\">\n        <th style=\"width:1.5em\">&nbsp;</th>\n        <th>{{'COMMON.title' | translate}}</th>\n        <!-- <th style=\"width:30%\">{{'COMMON.name' | translate}}</th> -->\n        <th>{{'COMMON.abstract' | translate}}</th>\n      </thead>\n      <tbody *ngFor=\"let service of data.services | slice:0:limitShown; trackBy:( 'Name' | trackByProperty )\">\n        <tr class=\"align-middle\">\n          <td [attr.rowspan]=\"service.Style?.length ? 3 : 2\" [ngClass]=\"{'align-middle': !hasNestedLayers(service)}\">\n            <input type=\"checkbox\" class=\"checkbox-lg\" [(ngModel)]=\"service.checked\" name=\"service\"\n              (change)=\"searchForChecked(service)\" />\n          </td>\n          <td hsWmsLayerHighlight style=\"max-width: 25.375em\" class=\"text-truncate\"\n            [title]=\"'Title: ' + service.Title  + '\\nName: ' + service.Name\"\n            (click)=\"hsAddDataUrlWmsService.expandTableRow($event)\">{{service.Title}}</td>\n          <!-- <td style=\"max-width: 13.75em\" class=\"text-truncate\" [title]=\"service.Name\">{{service.Name}}</td> -->\n          <td hsWmsLayerHighlight style=\"max-width: 10.875em; width:30%\" class=\"text-truncate\"\n            [title]=\"service.Abstract\" (click)=\"hsAddDataUrlWmsService.expandTableRow($event)\">\n            {{service.Abstract}}</td>\n        </tr>\n        <tr *ngIf=\"service.Style?.length > 1 && service.checked\">\n          <td colspan=\"3\">\n            <div class=\"d-flex align-items-baseline px-2 w-100\">\n              <div class=\"d-flex align-items-baseline\" style=\"flex-grow: 1;\">\n                <label class=\"control-label\">{{'COMMON.style' | translate}}:</label>\n                <select class=\"form-control form-control-sm\" [(ngModel)]=\"service.styleSelected\"\n                  [ngModelOptions]=\"{standalone: true}\">\n                  <option *ngFor=\"let style of service.Style\" [ngValue]=\"style\">{{style.Name}}\n                  </option>\n                </select>\n              </div>\n            </div>\n          </td>\n        </tr>\n        <tr [hidden]=\"!hasNestedLayers(service)\">\n          <td colspan=\"3\" style=\"padding-left: 1em\">\n            <hs-nested-layers-table style=\"display: block;\" [layers]=\"service.Layer\"\n              (layerChecked)=\"searchForChecked($event)\">\n            </hs-nested-layers-table>\n          </td>\n        </tr>\n      </tbody>\n    </table>\n  </ng-container>\n  <ng-template #simpleTable>\n    <table class=\"table table-sm table-striped table-bordered\">\n      <thead>\n        <th style=\"width:1em\">&nbsp;</th>\n        <th>{{'COMMON.name' | translate}}</th>\n      </thead>\n      <tbody *ngFor=\"let service of data.services; trackBy:( 'id' | trackByProperty )\">\n        <tr>\n          <td><input class=\"checkbox-lg\" type=\"checkbox\" name=\"service\" (change)=\"changed()\"\n              [(ngModel)]=\"service.checked\" /></td>\n          <td>{{service.name}}</td>\n        </tr>\n      </tbody>\n    </table>\n  </ng-template>\n  <ng-container *ngIf=\"type === 'wms'\">\n    <div *ngIf=\"reachedLimit()\" class=\"d-flex justify-content-around align-items-center m-3\"><span\n        [translate]=\"'ADDDATA.CATALOGUE.showingSubset'\"\n        [translateParams]=\"{limitShown: limitShown, total: data.services.length}\"></span>\n      <div class=\"btn-group ml-2\">\n        <button type=\"button\" class=\"btn btn-sm btn-light  btn-outline-secondary\" (click)=\"limitShown = limitShown + 100\">\n          {{'ADDDATA.CATALOGUE.showNext100' | translate}}\n        </button>\n        <button type=\"button\" class=\"btn btn-sm btn-light  btn-outline-secondary\"\n          (click)=\"limitShown = data.services.length\">\n          {{'ADDDATA.CATALOGUE.showAll' | translate}}\n        </button>\n      </div>\n    </div>\n  </ng-container>\n  <hs-common-url-add class=\"w-100\" [injectedService]=\"injectedService\"\n    [layers]=\"data.services\">\n  </hs-common-url-add>\n</div>\n"
            }]
    }], function () { return [{ type: HsAddDataUrlService }, { type: HsUtilsService }, { type: HsLayerUtilsService }, { type: HsAddDataService }, { type: HsLanguageService }, { type: HsAddDataUrlWmsService }, { type: HsAddDataCommonUrlService }]; }, { injectedService: [{
            type: Input
        }], type: [{
            type: Input
        }] }); })();

class HsCommonUrlProgressComponent {
    constructor(hsAddDataService, hsUtilsService) {
        this.hsAddDataService = hsAddDataService;
        this.hsUtilsService = hsUtilsService;
    }
}
HsCommonUrlProgressComponent.ɵfac = function HsCommonUrlProgressComponent_Factory(t) { return new (t || HsCommonUrlProgressComponent)(ɵngcc0.ɵɵdirectiveInject(HsAddDataService), ɵngcc0.ɵɵdirectiveInject(HsUtilsService)); };
HsCommonUrlProgressComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsCommonUrlProgressComponent, selectors: [["hs-common-url-progress"]], decls: 7, vars: 4, consts: [[1, "row", "d-flex", "justify-content-center", "btn-group", "w-75", "m-auto"], [1, "btn", "btn-primary", "btn-block", "w-75"], [1, "ml-2", 3, "src"], [1, "btn", "btn-secondary", 3, "click"]], template: function HsCommonUrlProgressComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "button", 1);
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵpipe(3, "translate");
        ɵngcc0.ɵɵelement(4, "img", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "button", 3);
        ɵngcc0.ɵɵlistener("click", function HsCommonUrlProgressComponent_Template_button_click_5_listener() { return ctx.hsAddDataService.cancelUrlRequest.next(); });
        ɵngcc0.ɵɵtext(6, "\u2716 ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 2, "ADDDATA.CATALOGUE.loading"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("src", ctx.hsUtilsService.getAjaxLoaderIcon(), ɵngcc0.ɵɵsanitizeUrl);
    } }, pipes: [ɵngcc1.TranslatePipe], encapsulation: 2, changeDetection: 0 });
HsCommonUrlProgressComponent.ctorParameters = () => [
    { type: HsAddDataService },
    { type: HsUtilsService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsCommonUrlProgressComponent, [{
        type: Component,
        args: [{
                selector: 'hs-common-url-progress',
                template: "<div class=\"row d-flex justify-content-center btn-group w-75 m-auto\">\n  <button class=\"btn btn-primary btn-block w-75\">{{'ADDDATA.CATALOGUE.loading' | translate}}<img class=\"ml-2\"\n      [src]=\"hsUtilsService.getAjaxLoaderIcon()\" /></button>\n  <button class=\"btn btn-secondary\" (click)=\"hsAddDataService.cancelUrlRequest.next()\">&#10006;\n  </button>\n</div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: HsAddDataService }, { type: HsUtilsService }]; }, null); })();

class HsHistoryListComponent {
    constructor(HsHistoryListService) {
        this.HsHistoryListService = HsHistoryListService;
        this.historyUrlSelected = new EventEmitter(); //output
        this.historyDropdownVisible = false;
    }
    ngOnChanges(changes) {
        this.items = this.HsHistoryListService.readSourceHistory(changes.what.currentValue);
    }
    historyUrlClicked(value) {
        this.historyUrlSelected.emit(value);
    }
}
HsHistoryListComponent.ɵfac = function HsHistoryListComponent_Factory(t) { return new (t || HsHistoryListComponent)(ɵngcc0.ɵɵdirectiveInject(HsHistoryListService)); };
HsHistoryListComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsHistoryListComponent, selectors: [["hs-history-list"]], inputs: { what: "what" }, outputs: { historyUrlSelected: "historyUrlSelected" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 5, vars: 9, consts: [["type", "button", "data-toggle", "dropdown", "aria-haspopup", "true", "aria-expanded", "false", 1, "btn", "btn-outline-secondary", "dropdown-toggle", "dropdown-toggle-split", "rounded-0", 3, "title", "click"], [1, "dropdown-menu", 2, "left", "auto", "right", "0", "width", "325px", "overflow", "hidden", 3, "ngClass"], ["class", "dropdown-item", 3, "click", 4, "ngFor", "ngForOf"], [1, "dropdown-item", 3, "click"]], template: function HsHistoryListComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "button", 0);
        ɵngcc0.ɵɵlistener("click", function HsHistoryListComponent_Template_button_click_0_listener() { return ctx.historyDropdownVisible = !ctx.historyDropdownVisible; });
        ɵngcc0.ɵɵpipe(1, "translate");
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵtemplate(3, HsHistoryListComponent_a_3_Template, 2, 1, "a", 2);
        ɵngcc0.ɵɵpipe(4, "keyvalue");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(1, 3, "HISTORY.toggleDropdown"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(7, _c14, ctx.historyDropdownVisible));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind1(4, 5, ctx.items));
    } }, directives: [ɵngcc3.NgClass, ɵngcc3.NgForOf], pipes: [ɵngcc1.TranslatePipe, ɵngcc3.KeyValuePipe], encapsulation: 2 });
HsHistoryListComponent.ctorParameters = () => [
    { type: HsHistoryListService }
];
HsHistoryListComponent.propDecorators = {
    what: [{ type: Input }],
    historyUrlSelected: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsHistoryListComponent, [{
        type: Component,
        args: [{
                selector: 'hs-history-list',
                template: "<button type=\"button\" (click)=\"historyDropdownVisible=!historyDropdownVisible\"\n    class=\"btn btn-outline-secondary dropdown-toggle dropdown-toggle-split rounded-0\" [title]=\"'HISTORY.toggleDropdown' | translate\"\n    data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">\n    <div class=\"dropdown-menu\" style=\"left: auto; right:0; width:325px; overflow: hidden\"\n        [ngClass]=\"{'show': historyDropdownVisible}\">\n        <a class=\"dropdown-item\" *ngFor=\"let item of items | keyvalue\" (click)=\"historyUrlClicked(item.value)\" >{{item.value}}</a>\n    </div>\n</button>\n"
            }]
    }], function () { return [{ type: HsHistoryListService }]; }, { historyUrlSelected: [{
            type: Output
        }], what: [{
            type: Input
        }] }); })();

class HsHistoryListModule {
}
HsHistoryListModule.ɵfac = function HsHistoryListModule_Factory(t) { return new (t || HsHistoryListModule)(); };
HsHistoryListModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: HsHistoryListModule });
HsHistoryListModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [CookieService], imports: [[FormsModule, CommonModule, TranslateModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsHistoryListModule, [{
        type: NgModule,
        args: [{
                schemas: [CUSTOM_ELEMENTS_SCHEMA],
                declarations: [HsHistoryListComponent],
                imports: [FormsModule, CommonModule, TranslateModule],
                exports: [HsHistoryListComponent],
                providers: [CookieService],
                entryComponents: [HsHistoryListComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(HsHistoryListModule, { declarations: function () { return [HsHistoryListComponent]; }, imports: function () { return [FormsModule, CommonModule, TranslateModule]; }, exports: function () { return [HsHistoryListComponent]; } }); })();

class HsNestedLayersTableComponent {
    constructor(hsAddDataUrlWmsService) {
        this.hsAddDataUrlWmsService = hsAddDataUrlWmsService;
        this.layerChecked = new EventEmitter(); //output
    }
    checked(layer) {
        this.layerChecked.emit(layer);
    }
    isArray(maybeArray) {
        return Array.isArray(maybeArray);
    }
}
HsNestedLayersTableComponent.ɵfac = function HsNestedLayersTableComponent_Factory(t) { return new (t || HsNestedLayersTableComponent)(ɵngcc0.ɵɵdirectiveInject(HsAddDataUrlWmsService)); };
HsNestedLayersTableComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsNestedLayersTableComponent, selectors: [["hs-nested-layers-table"]], inputs: { layers: "layers" }, outputs: { layerChecked: "layerChecked" }, decls: 3, vars: 4, consts: [[1, "table", "table-sm", "table-striped", "table-bordered", 2, "width", "100%"], [4, "ngFor", "ngForOf", "ngForTrackBy"], [2, "width", "1em"], ["type", "checkbox", 3, "ngModel", "ngModelOptions", "ngModelChange", "change"], ["hsWmsLayerHighlight", "", 1, "text-truncate", 2, "max-width", "12em", 3, "id", "title", "click"], ["hsWmsLayerHighlight", "", 1, "text-truncate", 2, "max-width", "10.875em", "width", "30%", 3, "title", "click"], [4, "ngIf"], ["colspan", "3"], [1, "d-flex", "align-items-baseline", "px-2", "w-100"], [1, "d-flex", "align-items-baseline", 2, "flex-grow", "1"], [1, "control-label"], [1, "form-control", "form-control-sm", 3, "ngModel", "ngModelOptions", "ngModelChange"], [4, "ngFor", "ngForOf"], [1, "form"], ["class", "form-group", 4, "ngFor", "ngForOf"], [1, "form-group"], [4, "ngIf", "ngIfElse"], ["unsupported_dim_format", ""], [1, "form-control", 3, "ngModel", "ngModelOptions", "ngModelChange"], [3, "value", 4, "ngFor", "ngForOf"], [3, "value"], [1, "text-muted"], ["colspan", "3", 2, "padding-left", "1em"], [2, "display", "block", 3, "layers", "layerChecked"]], template: function HsNestedLayersTableComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "table", 0);
        ɵngcc0.ɵɵtemplate(1, HsNestedLayersTableComponent_tbody_1_Template, 11, 11, "tbody", 1);
        ɵngcc0.ɵɵpipe(2, "trackByProperty");
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.layers)("ngForTrackBy", ɵngcc0.ɵɵpipeBind1(2, 2, "Name"));
    } }, directives: function () { return [ɵngcc3.NgForOf, ɵngcc5.CheckboxControlValueAccessor, ɵngcc5.NgControlStatus, ɵngcc5.NgModel, WmsLayerHighlightDirective, ɵngcc3.NgIf, ɵngcc5.SelectControlValueAccessor, ɵngcc5.NgSelectOption, ɵngcc5.ɵNgSelectMultipleOption, ɵngcc5.ɵNgNoValidate, ɵngcc5.NgControlStatusGroup, ɵngcc5.NgForm, HsNestedLayersTableComponent]; }, pipes: function () { return [TrackByPropertyPipe, ɵngcc1.TranslatePipe]; }, encapsulation: 2 });
HsNestedLayersTableComponent.ctorParameters = () => [
    { type: HsAddDataUrlWmsService }
];
HsNestedLayersTableComponent.propDecorators = {
    layers: [{ type: Input }],
    layerChecked: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsNestedLayersTableComponent, [{
        type: Component,
        args: [{
                selector: 'hs-nested-layers-table',
                template: "<table class=\"table table-sm table-striped table-bordered\" style=\"width: 100%\">\n    <tbody *ngFor=\"let sub_layer of layers; trackBy:( 'Name' | trackByProperty )\">\n        <tr>\n            <td  style=\"width: 1em\"><input type=\"checkbox\" [(ngModel)]=\"sub_layer.checked\" (change)=\"checked(sub_layer)\"\n                    [ngModelOptions]=\"{standalone: true}\" /></td>\n            <td hsWmsLayerHighlight class=\"text-truncate\" style=\"max-width: 12em;\" id=\"hs-add-layer-{{sub_layer.Name}}\"\n            [title]=\"'Title: ' + sub_layer.Title  + '\\nName: ' + sub_layer.Name\" (click)=\"hsAddDataUrlWmsService.expandTableRow($event)\">{{sub_layer.Title}}\n            </td>\n            <!-- <td class=\"text-truncate\" id=\"hs-add-layer-{{sub_layer.Name}}\" style=\"width: 30%; padding-left: 1em\">{{sub_layer.Name}}</td> -->\n            <td hsWmsLayerHighlight class=\"text-truncate\" style=\"max-width: 10.875em;width: 30%;\" [title]=\"sub_layer.Abstract\"\n                (click)=\"hsAddDataUrlWmsService.expandTableRow($event)\">{{sub_layer.Abstract}}</td>\n        </tr>\n        <tr *ngIf=\"sub_layer.Style?.length > 1 && sub_layer.checked\">\n            <td colspan=\"3\">\n                <div class=\"d-flex align-items-baseline px-2 w-100\">\n                    <div class=\"d-flex align-items-baseline\" style=\"flex-grow: 1;\">\n                        <label class=\"control-label\">{{'COMMON.style' | translate}}:</label>\n                        <select class=\"form-control form-control-sm\" [(ngModel)]=\"sub_layer.styleSelected\"\n                            [ngModelOptions]=\"{standalone: true}\">\n                            <option *ngFor=\"let style of sub_layer.Style\">{{style.Name}}</option>\n                        </select>\n                    </div>\n                </div>\n            </td>\n        </tr>\n        <tr *ngIf=\"!!sub_layer.Dimension\">\n            <td colspan=\"3\">\n                <form class=\"form\">\n                    <div class=\"form-group\" *ngFor=\"let dimension of sub_layer.Dimension\">\n                        <ng-container *ngIf=\"isArray(dimension.values); else unsupported_dim_format\">\n                            <label class=\"control-label\">{{dimension.name}}:</label>\n                            <div>\n                                <select class=\"form-control\" [(ngModel)]=\"dimension.value\" [ngModelOptions]=\"{standalone: true}\">\n                                    <option [value]=\"dimension_value\" *ngFor=\"let dimension_value of dimension.values\">\n                                        {{dimension_value}}</option>\n                                </select>\n                            </div>\n                        </ng-container>\n                        <ng-template #unsupported_dim_format><span class=\"text-muted\">{{'ADDLAYERS.unknownDimesion'| translate}}: {{dimension.name}}</span></ng-template>\n                    </div>\n                </form>\n            </td>\n        </tr>\n\n        <tr *ngIf=\"!!sub_layer.Layer\">\n            <td colspan=\"3\" style=\"padding-left: 1em\">\n                <hs-nested-layers-table style=\"display: block;\" (layerChecked)=\"checked($event)\"\n                    [layers]=\"sub_layer.Layer\"></hs-nested-layers-table>\n            </td>\n        </tr>\n    </tbody>\n</table>\n"
            }]
    }], function () { return [{ type: HsAddDataUrlWmsService }]; }, { layerChecked: [{
            type: Output
        }], layers: [{
            type: Input
        }] }); })();

class WmsLayerHighlightDirective {
    constructor(hsUtilsService, elRef) {
        this.hsUtilsService = hsUtilsService;
        this.elRef = elRef;
        this.highlighted = false;
        setTimeout(() => {
            this.highlighted = this.hsUtilsService.isOverflown(this.elRef.nativeElement);
        }, 500);
    }
}
WmsLayerHighlightDirective.ɵfac = function WmsLayerHighlightDirective_Factory(t) { return new (t || WmsLayerHighlightDirective)(ɵngcc0.ɵɵdirectiveInject(HsUtilsService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
WmsLayerHighlightDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: WmsLayerHighlightDirective, selectors: [["", "hsWmsLayerHighlight", ""]], hostVars: 2, hostBindings: function WmsLayerHighlightDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("hs-wms-highlighted", ctx.highlighted);
    } } });
WmsLayerHighlightDirective.ctorParameters = () => [
    { type: HsUtilsService },
    { type: ElementRef }
];
WmsLayerHighlightDirective.propDecorators = {
    highlighted: [{ type: HostBinding, args: ['class.hs-wms-highlighted',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(WmsLayerHighlightDirective, [{
        type: Directive,
        args: [{
                selector: '[hsWmsLayerHighlight]'
            }]
    }], function () { return [{ type: HsUtilsService }, { type: ɵngcc0.ElementRef }]; }, { highlighted: [{
            type: HostBinding,
            args: ['class.hs-wms-highlighted']
        }] }); })();

class HsAddDataCommonModule {
}
HsAddDataCommonModule.ɵfac = function HsAddDataCommonModule_Factory(t) { return new (t || HsAddDataCommonModule)(); };
HsAddDataCommonModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: HsAddDataCommonModule });
HsAddDataCommonModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule,
            TranslateModule,
            HsHistoryListModule,
            HsUiExtensionsModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsAddDataCommonModule, [{
        type: NgModule,
        args: [{
                schemas: [CUSTOM_ELEMENTS_SCHEMA],
                imports: [
                    CommonModule,
                    FormsModule,
                    TranslateModule,
                    HsHistoryListModule,
                    HsUiExtensionsModule,
                ],
                exports: [
                    HsCommonUrlAddComponent,
                    HsCommonUrlProgressComponent,
                    HsCommonUrlComponent,
                    HsAddDataTargetPositionComponent,
                    HsGetCapabilitiesErrorComponent,
                    HsNestedLayersTableComponent,
                    WmsLayerHighlightDirective,
                    HsCommonUrlDetailsComponent,
                ],
                declarations: [
                    HsCommonUrlAddComponent,
                    HsCommonUrlDetailsComponent,
                    HsCommonUrlComponent,
                    HsAddDataTargetPositionComponent,
                    HsGetCapabilitiesErrorComponent,
                    HsNestedLayersTableComponent,
                    WmsLayerHighlightDirective,
                    HsCommonUrlProgressComponent,
                ],
                entryComponents: [HsGetCapabilitiesErrorComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(HsAddDataCommonModule, { declarations: function () { return [HsCommonUrlAddComponent, HsCommonUrlDetailsComponent, HsCommonUrlComponent, HsAddDataTargetPositionComponent, HsGetCapabilitiesErrorComponent, HsNestedLayersTableComponent, WmsLayerHighlightDirective, HsCommonUrlProgressComponent]; }, imports: function () { return [CommonModule,
        FormsModule,
        TranslateModule, HsHistoryListModule, HsUiExtensionsModule]; }, exports: function () { return [HsCommonUrlAddComponent, HsCommonUrlProgressComponent, HsCommonUrlComponent, HsAddDataTargetPositionComponent, HsGetCapabilitiesErrorComponent, HsNestedLayersTableComponent, WmsLayerHighlightDirective, HsCommonUrlDetailsComponent]; } }); })();

class HsAddDataFileShpService {
    constructor(httpClient, hsLog, HsLaymanService) {
        this.httpClient = httpClient;
        this.hsLog = hsLog;
        this.HsLaymanService = HsLaymanService;
    }
    /**
     * Load non-wms OWS data and create layer
     * @param endpoint - Layman endpoint description (url, name, user)
     * @param files - Array of shp files (shp, dbf, shx)
     * @param name - Name of new layer
     * @param title - Title of new layer
     * @param abstract - Abstract of new layer
     * @param srs - EPSG code of selected projection (eg. "EPSG:4326")
     * @param sld - Array of sld files
     * @returns
     */
    add(endpoint, files, name, title, abstract, srs, sld, access_rights) {
        return new Promise((resolve, reject) => {
            const formdata = new FormData();
            files.forEach((file) => {
                formdata.append('file', new Blob([file.content], { type: file.type }), file.name);
            });
            const files_to_async_upload = [];
            const sumFileSize = formdata
                .getAll('file')
                .filter((f) => f.name)
                .reduce((prev, f) => prev + f.size, 0);
            this.asyncLoading = sumFileSize >= PREFER_RESUMABLE_SIZE_LIMIT;
            if (this.asyncLoading) {
                this.HsLaymanService.switchFormDataToFileNames(formdata, files_to_async_upload);
            }
            if (sld) {
                formdata.append('sld', new Blob([sld.content], { type: sld.type }), sld.name);
            }
            formdata.append('name', name);
            title = title == '' ? name : title;
            formdata.append('title', title);
            formdata.append('abstract', abstract);
            formdata.append('crs', srs);
            const write = access_rights['access_rights.write'] == 'private'
                ? endpoint.user
                : access_rights['access_rights.write'];
            const read = access_rights['access_rights.read'] == 'private'
                ? endpoint.user
                : access_rights['access_rights.read'];
            formdata.append('access_rights.write', write);
            formdata.append('access_rights.read', read);
            this.httpClient
                .post(`${endpoint.url}/rest/workspaces/${endpoint.user}/layers?${Math.random()}`, formdata, { withCredentials: true })
                .toPromise()
                .then((data) => __awaiter(this, void 0, void 0, function* () {
                //CHECK IF OK not auth etc.
                if (data && data.length > 0) {
                    if (this.asyncLoading) {
                        const promise = yield this.HsLaymanService.asyncUpload(files_to_async_upload, data, endpoint);
                        resolve(promise);
                    }
                    else {
                        resolve(data);
                    }
                }
                else {
                    reject(data);
                }
            }))
                .catch((err) => {
                this.hsLog.error(err);
                reject(err);
            });
        });
    }
}
HsAddDataFileShpService.ɵfac = function HsAddDataFileShpService_Factory(t) { return new (t || HsAddDataFileShpService)(ɵngcc0.ɵɵinject(ɵngcc2.HttpClient), ɵngcc0.ɵɵinject(HsLogService), ɵngcc0.ɵɵinject(HsLaymanService)); };
HsAddDataFileShpService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HsAddDataFileShpService_Factory() { return new HsAddDataFileShpService(i0.ɵɵinject(i1$1.HttpClient), i0.ɵɵinject(HsLogService), i0.ɵɵinject(HsLaymanService)); }, token: HsAddDataFileShpService, providedIn: "root" });
HsAddDataFileShpService.ctorParameters = () => [
    { type: HttpClient },
    { type: HsLogService },
    { type: HsLaymanService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsAddDataFileShpService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc2.HttpClient }, { type: HsLogService }, { type: HsLaymanService }]; }, null); })();

class HsAddDataFileShpComponent {
    constructor(hsAddDataFileShpService, hsLayoutService, hsLaymanService, hsLog, hsAddDataUrlWmsService, hsCommonEndpointsService, hsUtilsService, hsAddDataService, hsEventBusService, hsCommonLaymanService, hsLanguageService) {
        this.hsAddDataFileShpService = hsAddDataFileShpService;
        this.hsLayoutService = hsLayoutService;
        this.hsLaymanService = hsLaymanService;
        this.hsLog = hsLog;
        this.hsAddDataUrlWmsService = hsAddDataUrlWmsService;
        this.hsCommonEndpointsService = hsCommonEndpointsService;
        this.hsUtilsService = hsUtilsService;
        this.hsAddDataService = hsAddDataService;
        this.hsEventBusService = hsEventBusService;
        this.hsCommonLaymanService = hsCommonLaymanService;
        this.hsLanguageService = hsLanguageService;
        this.endpoint = null;
        this.errorDetails = [];
        this.extract_styles = false;
        this.files = [];
        this.sld = null;
        this.srs = 'EPSG:4326';
        this.title = '';
        this.folder_name = '';
        this.advancedPanelVisible = false;
        this.addUnder = null;
        this.dropzoneActive = false;
        this.errorOccurred = false;
        this.showDetails = false;
        this.access_rights = {
            'access_rights.write': 'private',
            'access_rights.read': 'EVERYONE',
        };
        const layman = this.hsCommonEndpointsService.endpoints.filter((ep) => ep.type == 'layman')[0];
        if (layman) {
            this.hsCommonLaymanService.authChange.subscribe((endpoint) => {
                this.isAuthorized =
                    endpoint.user !== 'anonymous' && endpoint.user !== 'browser';
            });
            this.isAuthorized =
                layman.user !== 'anonymous' && layman.user !== 'browser';
        }
    }
    ngOnInit() {
        this.pickEndpoint();
    }
    isSRSSupported() {
        return ['4326', '3857'].some((epsg) => this.srs.endsWith(epsg));
    }
    loadingText() {
        return this.loading
            ? this.hsLanguageService.getTranslationIgnoreNonExisting('COMMON', 'uploading')
            : this.hsLanguageService.getTranslationIgnoreNonExisting('COMMON', 'add');
    }
    dropZoneState($event) {
        this.dropzoneActive = $event;
    }
    /**
     * From available endpoints picks one
     * - either Layman endpoint if available or any other if not
     */
    pickEndpoint() {
        const endpoints = this.hsCommonEndpointsService.endpoints;
        if (endpoints && endpoints.length > 0) {
            const laymans = endpoints.filter((ep) => ep.type == 'layman');
            if (laymans.length > 0) {
                this.endpoint = laymans[0];
            }
            else {
                this.endpoint = endpoints[0];
            }
            if (this.endpoint && this.endpoint.type == 'layman') {
                this.endpoint.getCurrentUserIfNeeded(this.endpoint);
            }
        }
    }
    /**
     * @param endpoint Selected endpoint (should be Layman)
     * @param layerName Name of the layer to describe
     * @returns {Promise} Description of Layman layer
     */
    describeNewLayer(endpoint, layerName) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const descriptor = yield this.hsLaymanService.describeLayer(endpoint, layerName, endpoint.user);
                if (['STARTED', 'PENDING', 'SUCCESS'].includes(descriptor.wms.status)) {
                    return new Promise((resolve) => {
                        setTimeout(() => {
                            resolve(this.describeNewLayer(endpoint, layerName));
                        }, 2000);
                    });
                }
                else {
                    return descriptor;
                }
            }
            catch (ex) {
                this.hsLog.error(ex);
                throw ex;
            }
        });
    }
    /**
     * Handler for button click to send shape file to layman and wait for
     * answer with wms service url to add to map
     */
    add() {
        try {
            this.loading = true;
            if (!this.endpoint) {
                this.pickEndpoint();
            }
            if (!this.isSRSSupported()) {
                throw new Error(this.hsLanguageService.getTranslationIgnoreNonExisting('ADDLAYERS.ERROR', 'srsNotSupported'));
            }
            this.hsAddDataFileShpService
                .add(this.endpoint, this.files, this.name, this.title, this.abstract, this.srs, this.sld, this.access_rights)
                .then((data) => {
                this.name = data[0].name; //Name translated to Layman-safe name
                return this.describeNewLayer(this.endpoint, this.name);
            })
                .then((descriptor) => {
                this.hsLaymanService.totalProgress = 0;
                this.resultCode = 'success';
                this.hsAddDataService.selectType('url');
                setTimeout(() => {
                    this.hsEventBusService.owsFilling.next({
                        type: 'wms',
                        uri: descriptor.wms.url,
                        layer: this.name,
                    });
                }, 500);
                this.hsLayoutService.setMainPanel('layermanager');
            })
                .catch((err) => {
                var _a, _b, _c;
                console.error(err);
                const errorMessage = ((_b = (_a = err === null || err === void 0 ? void 0 : err.error) === null || _a === void 0 ? void 0 : _a.message) !== null && _b !== void 0 ? _b : (err === null || err === void 0 ? void 0 : err.message) == 'Wrong parameter value')
                    ? `${err === null || err === void 0 ? void 0 : err.message} : ${err === null || err === void 0 ? void 0 : err.detail.parameter}`
                    : err === null || err === void 0 ? void 0 : err.message;
                const errorDetails = ((_c = err === null || err === void 0 ? void 0 : err.error) === null || _c === void 0 ? void 0 : _c.detail.missing_extensions)
                    ? Object.values(err.error.detail.missing_extensions)
                    : [];
                this.showError({ message: errorMessage, details: errorDetails });
            });
        }
        catch (err) {
            this.showError({ message: err.message, details: null });
        }
    }
    showError(e) {
        this.loading = false;
        this.resultCode = 'error';
        this.errorMessage = e.message;
        this.errorDetails = e.details;
        this.hsLaymanService.totalProgress = 0;
        setTimeout(() => {
            this.resultCode = null;
        }, 5000);
    }
    read(evt) {
        const filesRead = [];
        const files = Array.from(evt.fileList);
        const promises = [];
        for (const file of files) {
            const filePromise = new Promise((resolve) => {
                const reader = new FileReader();
                reader.onload = (loadEvent) => {
                    filesRead.push({
                        name: file.name,
                        type: file.type,
                        content: loadEvent.target.result,
                    });
                    resolve(reader.result);
                };
                reader.readAsArrayBuffer(file);
            });
            promises.push(filePromise);
        }
        Promise.all(promises).then((fileContents) => {
            if (evt.uploader === 'sld') {
                this.sld = filesRead[0];
            }
            else {
                if (this.files.length == 3) {
                    this.showDetails = true;
                    this.name = this.files[0].name.slice(0, -4);
                    this.title = this.files[0].name.slice(0, -4);
                    this.resultCode = 'success';
                }
                else if (this.files.length > 3) {
                    this.showDetails = false;
                    this.resultCode = 'error';
                    this.errorMessage = `Maximum number of 3 files allowed but ${this.files.length} selected`;
                    setTimeout(() => {
                        this.resultCode = '';
                    }, 6000);
                }
                else {
                    this.showDetails = false;
                    this.resultCode = 'error';
                    this.errorMessage =
                        'Missing one or more ShapeFile files.. Load files with extensions *.shp, *.shx, *.dbf';
                    setTimeout(() => {
                        this.resultCode = '';
                    }, 6000);
                }
            }
        });
        if (evt.uploader === 'shpdbfshx') {
            this.files = filesRead;
        }
        console.log(this.files);
    }
    sldTitle() {
        return this.sld
            ? this.sld.name
            : this.hsLanguageService.getTranslationIgnoreNonExisting('ADDLAYERS.Vector', 'addSld');
    }
    addShpTooltip() {
        return this.title
            ? this.hsLanguageService.getTranslationIgnoreNonExisting('DRAW.drawToolbar', 'addLayer')
            : this.hsLanguageService.getTranslationIgnoreNonExisting('ADDLAYERS.SHP', 'nameRequired');
    }
}
HsAddDataFileShpComponent.ɵfac = function HsAddDataFileShpComponent_Factory(t) { return new (t || HsAddDataFileShpComponent)(ɵngcc0.ɵɵdirectiveInject(HsAddDataFileShpService), ɵngcc0.ɵɵdirectiveInject(HsLayoutService), ɵngcc0.ɵɵdirectiveInject(HsLaymanService), ɵngcc0.ɵɵdirectiveInject(HsLogService), ɵngcc0.ɵɵdirectiveInject(HsAddDataUrlWmsService), ɵngcc0.ɵɵdirectiveInject(HsCommonEndpointsService), ɵngcc0.ɵɵdirectiveInject(HsUtilsService), ɵngcc0.ɵɵdirectiveInject(HsAddDataService), ɵngcc0.ɵɵdirectiveInject(HsEventBusService), ɵngcc0.ɵɵdirectiveInject(HsCommonLaymanService), ɵngcc0.ɵɵdirectiveInject(HsLanguageService)); };
HsAddDataFileShpComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsAddDataFileShpComponent, selectors: [["hs-add-data-file-shp"]], decls: 53, vars: 40, consts: [["role", "form", 1, "form-horizontal", "m-3"], [1, "form-group", "justify-content-center"], ["acceptedFormats", ".shp, .shx, .dbf, .sbn", "uploader", "shpdbfshx", 3, "uploaded"], ["class", "text-light text-center bg-danger", 4, "ngIf"], [3, "hidden"], [1, "d-flex", "flex-row", "justify-content-around"], [1, "d-flex", "flex-column", "justify-content-center"], [1, "p-2", "bg-success", "rounded", 2, "color", "white"], [1, "d-flex", "flex-column", "mw-75"], [4, "ngFor", "ngForOf"], [1, "text-danger"], [1, "form-group"], [1, "capabilities_label", "control-label"], ["name", "name", 1, "form-control", 3, "ngModel", "ngModelChange"], ["name", "title", 1, "form-control", 3, "placeholder", "ngModel", "ngModelChange"], ["id", "hs-ows-abstract", "name", "abstract", 1, "form-control", 3, "placeholder", "ngModel", "ngModelChange"], [3, "access_rights", "access_rightsChange", 4, "ngIf"], [1, "d-flex", "justify-content-between", "align-items-center"], [1, "dropzone-label"], ["name", "file", "type", "file", "accept", ".sld", "id", "sld", 1, "inputfile", 3, "change"], ["for", "sld", 1, "p-2", "rounded", 2, "font-size", "1em", 3, "ngClass"], [1, "icon-uploadalt", "pr-2"], ["type", "button", 1, "btn", "btn-block", "btn-outline-secondary", "dropdown-toggle", "dropdown-toggle-split", 3, "click"], ["class", "hs-ows-shp-advanced", 4, "ngIf"], ["class", "btn btn-primary btn-block", 3, "disabled", "title", "click", 4, "ngIf"], ["class", "alert alert-warning d-flex align-items-center mt-2 justify-content-between", 4, "ngIf"], [1, "alert", "alert-danger", "mt-1", 3, "hidden"], [1, "alert", "alert-danger"], [1, "text-light", "text-center", "bg-danger"], [3, "access_rights", "access_rightsChange"], [1, "hs-ows-shp-advanced"], ["name", "srs", 1, "form-control", 3, "ngModel", "ngModelChange"], ["name", "folderName", 1, "form-control", 3, "ngModel", "ngModelChange"], [1, "btn", "btn-primary", "btn-block", 3, "disabled", "title", "click"], [1, "icon-plus", 3, "hidden"], [3, "src", "hidden"], ["showValue", "true", "class", "rounded-0 mb-1", "type", "secondary", 3, "max", "value", 4, "ngIf"], ["showValue", "true", "type", "secondary", 1, "rounded-0", "mb-1", 3, "max", "value"], [1, "alert", "alert-warning", "d-flex", "align-items-center", "mt-2", "justify-content-between"], [1, "m-0"], [3, "endpoint"]], template: function HsAddDataFileShpComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "form", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "hs-file-upload", 2);
        ɵngcc0.ɵɵlistener("uploaded", function HsAddDataFileShpComponent_Template_hs_file_upload_uploaded_2_listener($event) { return ctx.read($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(3, HsAddDataFileShpComponent_div_3_Template, 4, 3, "div", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 4);
        ɵngcc0.ɵɵelementStart(5, "div", 5);
        ɵngcc0.ɵɵelementStart(6, "div", 6);
        ɵngcc0.ɵɵelementStart(7, "p", 7);
        ɵngcc0.ɵɵtext(8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "div", 8);
        ɵngcc0.ɵɵtemplate(10, HsAddDataFileShpComponent_p_10_Template, 2, 1, "p", 9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "p");
        ɵngcc0.ɵɵelementStart(12, "sub", 10);
        ɵngcc0.ɵɵtext(13);
        ɵngcc0.ɵɵpipe(14, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(15, "div", 11);
        ɵngcc0.ɵɵelementStart(16, "label", 12);
        ɵngcc0.ɵɵtext(17);
        ɵngcc0.ɵɵpipe(18, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(19, "input", 13);
        ɵngcc0.ɵɵlistener("ngModelChange", function HsAddDataFileShpComponent_Template_input_ngModelChange_19_listener($event) { return ctx.name = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(20, "div", 11);
        ɵngcc0.ɵɵelementStart(21, "label", 12);
        ɵngcc0.ɵɵtext(22);
        ɵngcc0.ɵɵpipe(23, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(24, "input", 14);
        ɵngcc0.ɵɵlistener("ngModelChange", function HsAddDataFileShpComponent_Template_input_ngModelChange_24_listener($event) { return ctx.title = $event; });
        ɵngcc0.ɵɵpipe(25, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(26, "div", 11);
        ɵngcc0.ɵɵelementStart(27, "label", 12);
        ɵngcc0.ɵɵtext(28);
        ɵngcc0.ɵɵpipe(29, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(30, "textarea", 15);
        ɵngcc0.ɵɵlistener("ngModelChange", function HsAddDataFileShpComponent_Template_textarea_ngModelChange_30_listener($event) { return ctx.abstract = $event; });
        ɵngcc0.ɵɵpipe(31, "translate");
        ɵngcc0.ɵɵtext(32, "            ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(33, HsAddDataFileShpComponent_hs_layman_access_rights_33_Template, 1, 1, "hs-layman-access-rights", 16);
        ɵngcc0.ɵɵelementStart(34, "div", 17);
        ɵngcc0.ɵɵelementStart(35, "p");
        ɵngcc0.ɵɵtext(36);
        ɵngcc0.ɵɵpipe(37, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(38, "label", 18);
        ɵngcc0.ɵɵelementStart(39, "input", 19);
        ɵngcc0.ɵɵlistener("change", function HsAddDataFileShpComponent_Template_input_change_39_listener($event) { return ctx.read({ fileList: $event.target.files, uploader: "sld", dropped: false }); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(40, "label", 20);
        ɵngcc0.ɵɵelement(41, "i", 21);
        ɵngcc0.ɵɵtext(42);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(43, "button", 22);
        ɵngcc0.ɵɵlistener("click", function HsAddDataFileShpComponent_Template_button_click_43_listener() { return ctx.advancedPanelVisible = !ctx.advancedPanelVisible; });
        ɵngcc0.ɵɵtext(44);
        ɵngcc0.ɵɵpipe(45, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(46, HsAddDataFileShpComponent_div_46_Template, 11, 8, "div", 23);
        ɵngcc0.ɵɵtemplate(47, HsAddDataFileShpComponent_button_47_Template, 5, 7, "button", 24);
        ɵngcc0.ɵɵtemplate(48, HsAddDataFileShpComponent_div_48_Template, 5, 4, "div", 25);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(49, "div", 26);
        ɵngcc0.ɵɵelementStart(50, "div", 27);
        ɵngcc0.ɵɵtext(51);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(52, HsAddDataFileShpComponent_dl_52_Template, 3, 1, "dl", 9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.errorOccurred);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", !ctx.showDetails);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.files.length, " files selected");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.files);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(14, 24, "ADDLAYERS.Vector.note"));
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(18, 26, "COMMON.name"), "*");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngModel", ctx.name);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(23, 28, "COMMON.title"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵpropertyInterpolate("placeholder", ɵngcc0.ɵɵpipeBind1(25, 30, "ADDDATA.URL.submitLayerTitle"));
        ɵngcc0.ɵɵproperty("ngModel", ctx.title);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(29, 32, "COMMON.abstract"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("placeholder", ɵngcc0.ɵɵpipeBind1(31, 34, "COMMON.fillInDescriptive"))("ngModel", ctx.abstract);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isAuthorized);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(37, 36, "ADDLAYERS.SHP.SLDStyleFile"));
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngClass", ctx.sld ? "bg-success" : "bg-primary");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.sldTitle());
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(45, 38, "COMMON.advancedOptions"), " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.advancedPanelVisible);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isAuthorized);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.isAuthorized);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", ctx.resultCode !== "error");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.errorMessage);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.errorDetails);
    } }, directives: function () { return [ɵngcc5.ɵNgNoValidate, ɵngcc5.NgControlStatusGroup, ɵngcc5.NgForm, HsUploadComponent, ɵngcc3.NgIf, ɵngcc3.NgForOf, ɵngcc5.DefaultValueAccessor, ɵngcc5.NgControlStatus, ɵngcc5.NgModel, ɵngcc3.NgClass, HsCommonLaymanAccessRightsComponent, ɵngcc6.NgbProgressbar, HsLaymanCurrentUserComponent]; }, pipes: function () { return [ɵngcc1.TranslatePipe]; }, encapsulation: 2 });
HsAddDataFileShpComponent.ctorParameters = () => [
    { type: HsAddDataFileShpService },
    { type: HsLayoutService },
    { type: HsLaymanService },
    { type: HsLogService },
    { type: HsAddDataUrlWmsService },
    { type: HsCommonEndpointsService },
    { type: HsUtilsService },
    { type: HsAddDataService },
    { type: HsEventBusService },
    { type: HsCommonLaymanService },
    { type: HsLanguageService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsAddDataFileShpComponent, [{
        type: Component,
        args: [{
                selector: 'hs-add-data-file-shp',
                template: "<form class=\"form-horizontal m-3\" role=\"form\">\n    <!-- <div class=\"form-group\">\n        <div class=\"input-group\">\n            <div class=\"input-group-prepend\">\n                <span class=\"input-group-text control-label\">{{'COMMON.saveTo' | translate}}</span>\n            </div>\n            <select class=\"form-control\" name=\"endpoint\" [(ngModel)]=\"endpoint\">\n                <option *ngFor=\"let endpoint of hsCommonEndpointsService.endpoints | endpointsWithDatasources:'layman':'inclusive'\"\n                    [ngValue]=\"endpoint\">{{endpoint.title}}</option>\n            </select>\n        </div>\n    </div> -->\n\n    <!-- <div class=\"form-group\">\n        <label class=\"capabilities_label control-label\">{{'ADDLAYERS.SHP.shapeFile' | translate}} </label>\n        <input name=\"file\" type=\"file\" (change)=\"read($event)\" id=\"shpdbfshx\" multiple>\n    </div> -->\n    <div class=\"form-group justify-content-center\">\n        <hs-file-upload (uploaded)=\"read($event)\" acceptedFormats=\".shp, .shx, .dbf, .sbn\" uploader=\"shpdbfshx\">\n        </hs-file-upload>\n        <!-- TODO: Replace this with upcomming toast directive -->\n        <div class=\"text-light text-center bg-danger\" *ngIf=\"errorOccurred\">\n            <p>{{'ADDLAYERS.couldNotUploadSelectedFile' | translate}}</p>\n        </div>\n    </div>\n\n    <div [hidden]=\"!showDetails\">\n        <div class=\"d-flex flex-row justify-content-around\">\n            <div class=\"d-flex flex-column justify-content-center\">\n                <p class=\"p-2 bg-success rounded\" style=\"color: white;\"> {{files.length}} files selected</p>\n            </div>\n            <div class=\"d-flex flex-column mw-75\">\n                <p *ngFor=\"let file of files\">{{file.name}}</p>\n            </div>\n        </div>\n        <p><sub class=\"text-danger\">{{'ADDLAYERS.Vector.note' | translate}}</sub></p>\n\n        <div class=\"form-group\">\n            <label class=\"capabilities_label control-label\">{{'COMMON.name' | translate}}*</label>\n            <input class=\"form-control\" name=\"name\" [(ngModel)]=\"name\" />\n        </div>\n\n        <div class=\"form-group\">\n            <label class=\"capabilities_label control-label\">{{'COMMON.title' | translate}}</label>\n            <input class=\"form-control\" name=\"title\" placeholder=\"{{'ADDDATA.URL.submitLayerTitle' | translate}}\"\n                [(ngModel)]=\"title\" />\n        </div>\n\n        <div class=\"form-group\">\n            <label class=\"capabilities_label control-label\">{{'COMMON.abstract' | translate}}</label>\n            <textarea class=\"form-control\" id='hs-ows-abstract' name=\"abstract\"\n                [placeholder]=\"'COMMON.fillInDescriptive'| translate\" [(ngModel)]=\"abstract\">\n            </textarea>\n        </div>\n\n        <hs-layman-access-rights *ngIf=\"isAuthorized\" [(access_rights)]=\"access_rights\"></hs-layman-access-rights>\n\n        <div class=\"d-flex justify-content-between align-items-center\">\n            <p>{{'ADDLAYERS.SHP.SLDStyleFile' | translate}}</p>\n            <label class=\"dropzone-label\">\n                <input name=\"file\" type=\"file\" accept=\".sld\" class=\"inputfile\"\n                    (change)=\"read({fileList: $event.target.files, uploader: 'sld', dropped: false})\" id=\"sld\">\n                <label for=\"sld\" class=\"p-2 rounded\" style=\"font-size: 1em;\"\n                    [ngClass]=\"sld ? 'bg-success' : 'bg-primary'\"> <i\n                        class=\"icon-uploadalt pr-2\"></i>{{sldTitle()}}</label>\n            </label>\n        </div>\n\n        <button type=\"button\" class=\"btn btn-block btn-outline-secondary dropdown-toggle dropdown-toggle-split\"\n            (click)=\"advancedPanelVisible = !advancedPanelVisible\">\n            {{'COMMON.advancedOptions' | translate}}\n        </button>\n\n        <div class=\"hs-ows-shp-advanced\" *ngIf=\"advancedPanelVisible\">\n            <div class=\"form-group\">\n                <label class=\"capabilities_label control-label\">{{'ADDLAYERS.srs' | translate}}</label>\n                <input class=\"form-control\" name=\"srs\" [(ngModel)]=\"srs\" />\n            </div>\n\n            <div class=\"form-group\">\n                <label class=\"capabilities_label control-label\">{{'ADDLAYERS.folderName' | translate}}</label>\n                <input class=\"form-control\" name=\"folderName\" [(ngModel)]=\"folder_name\" />\n            </div>\n        </div>\n        <button *ngIf=\"isAuthorized\" class=\"btn btn-primary btn-block\" [disabled]=\"!name\" (click)=\"add()\"\n            title=\"{{addShpTooltip()}}\">\n            <i class=\"icon-plus\" [hidden]=\"loading\"></i>\n            <img [src]=\"hsUtilsService.getAjaxLoaderIcon()\" [hidden]=\"!loading\" />\n            {{loadingText()}}\n            <ngb-progressbar *ngIf=\"loading && hsAddDataFileShpService.asyncLoading\" showValue=\"true\"\n                class=\"rounded-0 mb-1\" type=\"secondary\" [max]=\"1\" [value]=\"hsLaymanService.totalProgress\">\n            </ngb-progressbar>\n        </button>\n\n        <div *ngIf=\"!isAuthorized\" class=\"alert alert-warning d-flex align-items-center mt-2 justify-content-between\">\n            <p class=\"m-0\"> {{'ADDLAYERS.SHP.loginRequired' | translate}}</p>\n            <hs-layman-current-user [endpoint]=\"hsLaymanService.getLaymanEndpoint()\"></hs-layman-current-user>\n        </div>\n    </div>\n    <div class=\"alert alert-danger mt-1\" [hidden]=\"resultCode !== 'error'\">\n        <div class=\"alert alert-danger\">{{errorMessage}}</div>\n        <dl *ngFor=\"let item of errorDetails\">\n            <dt>{{item}}</dt>\n            <!-- <hs-widgets-recursive-dd [value]=\"item.value\"></hs-widgets-recursive-dd> -->\n        </dl>\n    </div>\n</form>\n"
            }]
    }], function () { return [{ type: HsAddDataFileShpService }, { type: HsLayoutService }, { type: HsLaymanService }, { type: HsLogService }, { type: HsAddDataUrlWmsService }, { type: HsCommonEndpointsService }, { type: HsUtilsService }, { type: HsAddDataService }, { type: HsEventBusService }, { type: HsCommonLaymanService }, { type: HsLanguageService }]; }, null); })();

class HsFileDropDirective {
    constructor() {
        this.filesDropped = new EventEmitter();
        this.filesHovered = new EventEmitter();
    }
    onDrop($event) {
        $event.preventDefault();
        const transfer = $event.dataTransfer;
        this.filesDropped.emit(transfer.files);
        this.filesHovered.emit(false);
    }
    onDragOver($event) {
        $event.preventDefault();
        this.filesHovered.emit(true);
    }
    onDragLeave($event) {
        this.filesHovered.emit(false);
    }
}
HsFileDropDirective.ɵfac = function HsFileDropDirective_Factory(t) { return new (t || HsFileDropDirective)(); };
HsFileDropDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: HsFileDropDirective, selectors: [["", "fileDrop", ""]], hostBindings: function HsFileDropDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("drop", function HsFileDropDirective_drop_HostBindingHandler($event) { return ctx.onDrop($event); })("dragover", function HsFileDropDirective_dragover_HostBindingHandler($event) { return ctx.onDragOver($event); })("dragleave", function HsFileDropDirective_dragleave_HostBindingHandler($event) { return ctx.onDragLeave($event); });
    } }, outputs: { filesDropped: "filesDropped", filesHovered: "filesHovered" } });
HsFileDropDirective.ctorParameters = () => [];
HsFileDropDirective.propDecorators = {
    filesDropped: [{ type: Output }],
    filesHovered: [{ type: Output }],
    onDrop: [{ type: HostListener, args: ['drop', ['$event'],] }],
    onDragOver: [{ type: HostListener, args: ['dragover', ['$event'],] }],
    onDragLeave: [{ type: HostListener, args: ['dragleave', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsFileDropDirective, [{
        type: Directive,
        args: [{
                selector: '[fileDrop]'
            }]
    }], function () { return []; }, { filesDropped: [{
            type: Output
        }], filesHovered: [{
            type: Output
        }], onDrop: [{
            type: HostListener,
            args: ['drop', ['$event']]
        }], onDragOver: [{
            type: HostListener,
            args: ['dragover', ['$event']]
        }], onDragLeave: [{
            type: HostListener,
            args: ['dragleave', ['$event']]
        }] }); })();

class HsUploadComponent {
    constructor() {
        this.uploaded = new EventEmitter();
        this.dropzoneActive = false;
    }
    emitHandleUpload(fileList, dropped) {
        this.uploaded.emit({ fileList, uploader: this.uploader, dropped });
    }
    dropZoneState($event) {
        this.dropzoneActive = $event;
    }
}
HsUploadComponent.ɵfac = function HsUploadComponent_Factory(t) { return new (t || HsUploadComponent)(); };
HsUploadComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsUploadComponent, selectors: [["hs-file-upload"]], inputs: { acceptedFormats: "acceptedFormats", uploader: "uploader" }, outputs: { uploaded: "uploaded" }, decls: 15, vars: 15, consts: [[1, "d-flex", "justify-content-center", "align-items-center", "w-100", "dropzone-container"], ["fileDrop", "", 1, "dropzone", "p-4", 3, "ngClass", "filesDropped", "filesHovered"], [1, "dropzone-label", "mt-2", "text-primary"], [1, "px-5"], [1, "dropzone-label"], ["type", "file", "multiple", "", 1, "inputfile", 3, "accept", "id", "change"], ["vectorFileInput", ""], [1, "p-2", "rounded", 3, "for"], [1, "icon-uploadalt", "pr-2"]], template: function HsUploadComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵlistener("filesDropped", function HsUploadComponent_Template_div_filesDropped_1_listener($event) { return ctx.emitHandleUpload($event, true); })("filesHovered", function HsUploadComponent_Template_div_filesHovered_1_listener($event) { return ctx.dropZoneState($event); });
        ɵngcc0.ɵɵelementStart(2, "p", 2);
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵpipe(4, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "p", 3);
        ɵngcc0.ɵɵtext(6);
        ɵngcc0.ɵɵpipe(7, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "label", 4);
        ɵngcc0.ɵɵelementStart(9, "input", 5, 6);
        ɵngcc0.ɵɵlistener("change", function HsUploadComponent_Template_input_change_9_listener($event) { return ctx.emitHandleUpload($event.target.files, false); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "label", 7);
        ɵngcc0.ɵɵelement(12, "i", 8);
        ɵngcc0.ɵɵtext(13);
        ɵngcc0.ɵɵpipe(14, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(13, _c12, ctx.dropzoneActive));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(4, 7, "ADDLAYERS.Vector.dragAndDropFiles"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(7, 9, "COMMON.or"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("accept", ctx.acceptedFormats)("id", ctx.uploader);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("for", ctx.uploader);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(14, 11, "ADDLAYERS.Vector.chooseFiles"), "");
    } }, directives: [HsFileDropDirective, ɵngcc3.NgClass], pipes: [ɵngcc1.TranslatePipe], encapsulation: 2 });
HsUploadComponent.ctorParameters = () => [];
HsUploadComponent.propDecorators = {
    uploaded: [{ type: Output }],
    acceptedFormats: [{ type: Input }],
    uploader: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsUploadComponent, [{
        type: Component,
        args: [{
                selector: 'hs-file-upload',
                template: "<div class=\"d-flex justify-content-center align-items-center w-100 dropzone-container\">\n    <div class=\"dropzone p-4\" fileDrop (filesDropped)=\"emitHandleUpload($event, true)\"\n        (filesHovered)=\"dropZoneState($event)\" [ngClass]=\"{'active': dropzoneActive}\">\n        <p class=\"dropzone-label mt-2 text-primary\">{{'ADDLAYERS.Vector.dragAndDropFiles' | translate}}</p>\n    </div>\n    <p class=\"px-5\">{{'COMMON.or' | translate}}</p>\n    <label class=\"dropzone-label\">\n        <input #vectorFileInput type=\"file\" [accept]=\"acceptedFormats\" [id]=\"uploader\"\n            class=\"inputfile\" (change)=\"emitHandleUpload($event.target.files, false)\" multiple>\n        <label [for]=\"uploader\" class=\"p-2 rounded\"> <i class=\"icon-uploadalt pr-2\"></i>\n            {{'ADDLAYERS.Vector.chooseFiles' | translate}}</label>\n    </label>\n\n</div>"
            }]
    }], function () { return []; }, { uploaded: [{
            type: Output
        }], acceptedFormats: [{
            type: Input
        }], uploader: [{
            type: Input
        }] }); })();

class HsUploadModule {
}
HsUploadModule.ɵfac = function HsUploadModule_Factory(t) { return new (t || HsUploadModule)(); };
HsUploadModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: HsUploadModule });
HsUploadModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [], imports: [[CommonModule, TranslateModule, FormsModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsUploadModule, [{
        type: NgModule,
        args: [{
                declarations: [HsUploadComponent, HsFileDropDirective],
                imports: [CommonModule, TranslateModule, FormsModule],
                providers: [],
                entryComponents: [],
                exports: [HsUploadComponent, HsFileDropDirective]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(HsUploadModule, { declarations: function () { return [HsUploadComponent, HsFileDropDirective]; }, imports: function () { return [CommonModule, TranslateModule, FormsModule]; }, exports: function () { return [HsUploadComponent, HsFileDropDirective]; } }); })();

class HsAddDataFileShpModule {
}
HsAddDataFileShpModule.ɵfac = function HsAddDataFileShpModule_Factory(t) { return new (t || HsAddDataFileShpModule)(); };
HsAddDataFileShpModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: HsAddDataFileShpModule });
HsAddDataFileShpModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule,
            TranslateModule,
            HsUiExtensionsModule,
            HsUploadModule,
            HsAddDataCommonModule,
            HsLaymanModule,
            NgbProgressbarModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsAddDataFileShpModule, [{
        type: NgModule,
        args: [{
                schemas: [CUSTOM_ELEMENTS_SCHEMA],
                imports: [
                    CommonModule,
                    FormsModule,
                    TranslateModule,
                    HsUiExtensionsModule,
                    HsUploadModule,
                    HsAddDataCommonModule,
                    HsLaymanModule,
                    NgbProgressbarModule,
                ],
                exports: [HsAddDataFileShpComponent],
                declarations: [HsAddDataFileShpComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(HsAddDataFileShpModule, { declarations: function () { return [HsAddDataFileShpComponent]; }, imports: function () { return [CommonModule,
        FormsModule,
        TranslateModule, HsUiExtensionsModule, HsUploadModule, HsAddDataCommonModule, HsLaymanModule, NgbProgressbarModule]; }, exports: function () { return [HsAddDataFileShpComponent]; } }); })();

class HsAddDataVectorComponent {
    constructor(hsAddDataVectorService, hsHistoryListService, hsLayoutService, hsUtilsService, hsAddDataService, hsToastService, hsLanguageService, hsCommonEndpointsService, hsCommonLaymanService, hsLayerManagerService, hsLayerUtilsService) {
        this.hsAddDataVectorService = hsAddDataVectorService;
        this.hsHistoryListService = hsHistoryListService;
        this.hsLayoutService = hsLayoutService;
        this.hsUtilsService = hsUtilsService;
        this.hsAddDataService = hsAddDataService;
        this.hsToastService = hsToastService;
        this.hsLanguageService = hsLanguageService;
        this.hsCommonEndpointsService = hsCommonEndpointsService;
        this.hsCommonLaymanService = hsCommonLaymanService;
        this.hsLayerManagerService = hsLayerManagerService;
        this.hsLayerUtilsService = hsLayerUtilsService;
        this.srs = 'EPSG:4326';
        this.title = '';
        this.extract_styles = true;
        this.name = '';
        this.advancedPanelVisible = false;
        this.folder_name = '';
        this.features = [];
        this.featureCount = 0;
        this.type = '';
        this.errorOccurred = false;
        this.addUnder = null;
        this.showDetails = false;
        this.isAuthorized = false;
        this.access_rights = {
            'access_rights.write': 'private',
            'access_rights.read': 'EVERYONE',
        };
        this.uploadType = 'new';
        this.sourceLayer = null;
        this.connect = () => __awaiter(this, void 0, void 0, function* () {
            this.hsHistoryListService.addSourceHistory('vector', this.url);
            this.showDetails = true;
        });
        const layman = this.hsCommonEndpointsService.endpoints.filter((ep) => ep.type == 'layman')[0];
        if (layman) {
            this.hsCommonLaymanService.authChange.subscribe((endpoint) => {
                this.isAuthorized =
                    endpoint.user !== 'anonymous' && endpoint.user !== 'browser';
            });
            this.isAuthorized =
                layman.user !== 'anonymous' && layman.user !== 'browser';
        }
    }
    ngOnInit() {
        this.acceptedFormats =
            this.dataType == 'kml' ? '.kml, .gpx' : '.geojson, .json';
    }
    isKml() {
        var _a;
        if (this.type == 'kml' || ((_a = this.url) === null || _a === void 0 ? void 0 : _a.endsWith('kml'))) {
            return true;
        }
        else {
            return false;
        }
    }
    setUploadType(type) {
        this.uploadType = type;
        if (type == 'existing') {
            this.vectorLayers = this.hsLayerManagerService.data.layers.filter((layer) => {
                return this.hsLayerUtilsService.isLayerVectorLayer(layer.layer);
            });
        }
    }
    /**
     * Handler for adding non-wms service, file in template.
     */
    add() {
        return __awaiter(this, void 0, void 0, function* () {
            this.uploadType == 'new'
                ? yield this.addNewLayer()
                : yield this.updateExistingLayer();
            this.hsLayoutService.setMainPanel('layermanager');
            this.setToDefault();
        });
    }
    updateExistingLayer() {
        return __awaiter(this, void 0, void 0, function* () {
            let features = this.features.length > 0 ? this.features : [];
            if (this.dataType != 'geojson') {
                const kml = yield this.hsAddDataVectorService.convertUploadedData(this.vectorFileInput.nativeElement.files[0]);
                features = kml.features; //proper typing will get rid of this
            }
            this.hsLayerUtilsService.isLayerClustered(this.sourceLayer)
                ? this.sourceLayer.getSource().getSource().addFeatures(features)
                : this.sourceLayer.getSource().addFeatures(features);
        });
    }
    addNewLayer() {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const layer = yield this.hsAddDataVectorService.addVectorLayer(this.features.length != 0 ? this.type : this.dataType, this.url || this.base64url, this.name, this.title, this.abstract, this.srs, {
                extractStyles: this.extract_styles,
                features: this.features,
                path: this.hsUtilsService.undefineEmptyString(this.folder_name),
                access_rights: this.access_rights,
                workspace: (_a = this.hsCommonEndpointsService.endpoints.filter((ep) => ep.type == 'layman')[0]) === null || _a === void 0 ? void 0 : _a.user,
                queryCapabilities: this.dataType != 'kml' && !((_b = this.url) === null || _b === void 0 ? void 0 : _b.endsWith('json')),
            }, this.addUnder);
            this.hsAddDataVectorService.fitExtent(layer);
            if (this.saveToLayman) {
                this.awaitLayerSync(layer).then(() => {
                    layer.getSource().dispatchEvent('addfeature');
                });
            }
            return layer;
        });
    }
    awaitLayerSync(layer) {
        return __awaiter(this, void 0, void 0, function* () {
            while (getHsLaymanSynchronizing(layer)) {
                yield new Promise((r) => setTimeout(r, 200));
            }
            return true;
        });
    }
    handleFileUpload(evt) {
        Array.from(evt.fileList).forEach((f) => __awaiter(this, void 0, void 0, function* () {
            const uploadedData = yield this.hsAddDataVectorService.readUploadedFile(f);
            if (uploadedData !== undefined) {
                uploadedData.url !== undefined
                    ? (this.base64url = uploadedData.url)
                    : ((this.url = ''), (this.base64url = ''));
                uploadedData.name !== undefined
                    ? (this.name = uploadedData.name)
                    : (this.name = '');
                uploadedData.title !== undefined
                    ? (this.title = uploadedData.title)
                    : (this.title = '');
                uploadedData.srs !== undefined
                    ? (this.srs = uploadedData.srs.getCode())
                    : (this.srs = 'EPSG:4326');
                uploadedData.abstract !== undefined
                    ? (this.abstract = uploadedData.abstract)
                    : (this.abstract = '');
                if (uploadedData.features !== undefined) {
                    this.features = uploadedData.features;
                    this.featureCount = uploadedData.features.length;
                }
                else {
                    this.features = [];
                    this.featureCount = 0;
                }
                if (uploadedData.type !== undefined) {
                    this.type = uploadedData.type;
                }
                else {
                    this.type = '';
                }
                if (this.isKml()) {
                    this.saveToLayman = false;
                    this.saveAvailable = false;
                }
                else {
                    this.saveAvailable = true;
                    this.saveToLayman = this.isAuthorized;
                }
                //add layman endpoint url as url to allow sync
                if (this.url == '' && this.saveToLayman) {
                    this.url = this.hsCommonEndpointsService.endpoints.filter((ep) => ep.type == 'layman')[0].url;
                }
                this.showDetails = true;
            }
            else {
                this.setToDefault();
                this.hsToastService.createToastPopupMessage(this.hsLanguageService.getTranslation('ADDLAYERS.ERROR.someErrorHappened'), this.hsLanguageService.getTranslationIgnoreNonExisting('ADDLAYERS', 'couldNotUploadSelectedFile'), { disableLocalization: true });
            }
        }));
    }
    setToDefault() {
        this.srs = 'EPSG:4326';
        this.title = '';
        this.extract_styles = true;
        this.abstract = '';
        this.url = '';
        this.base64url = '';
        this.name = '';
        this.advancedPanelVisible = false;
        this.folder_name = '';
        this.features = [];
        this.featureCount = 0;
        this.type = '';
        this.showDetails = false;
        this.sourceLayer = null;
        this.vectorLayers = null;
        this.uploadType = 'new';
        if (this.vectorFileInput) {
            this.vectorFileInput.nativeElement.value = '';
        }
    }
}
HsAddDataVectorComponent.ɵfac = function HsAddDataVectorComponent_Factory(t) { return new (t || HsAddDataVectorComponent)(ɵngcc0.ɵɵdirectiveInject(HsAddDataVectorService), ɵngcc0.ɵɵdirectiveInject(HsHistoryListService), ɵngcc0.ɵɵdirectiveInject(HsLayoutService), ɵngcc0.ɵɵdirectiveInject(HsUtilsService), ɵngcc0.ɵɵdirectiveInject(HsAddDataService), ɵngcc0.ɵɵdirectiveInject(HsToastService), ɵngcc0.ɵɵdirectiveInject(HsLanguageService), ɵngcc0.ɵɵdirectiveInject(HsCommonEndpointsService), ɵngcc0.ɵɵdirectiveInject(HsCommonLaymanService), ɵngcc0.ɵɵdirectiveInject(HsLayerManagerService), ɵngcc0.ɵɵdirectiveInject(HsLayerUtilsService)); };
HsAddDataVectorComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsAddDataVectorComponent, selectors: [["hs-add-data-url-vector"]], viewQuery: function HsAddDataVectorComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c48, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.vectorFileInput = _t.first);
    } }, inputs: { dataType: "dataType" }, decls: 4, vars: 3, consts: [["role", "form", 1, "form-horizontal"], ["type", "vector", 3, "url", "urlChange", "connect", 4, "ngIf"], ["class", "form-group m-3", 4, "ngIf"], [4, "ngIf"], ["type", "vector", 3, "url", "urlChange", "connect"], [1, "form-group", "m-3"], ["uploader", "hs-vector-file", 3, "acceptedFormats", "uploaded"], ["class", "border-bottom d-flex flex-row justify-content-between", 4, "ngIf"], [3, "hidden"], [1, "form-group", "my-3"], [1, "capabilities_label", "control-label"], ["name", "sourceLayer", 1, "hsl-custom-select", 2, "flex-grow", "1", 3, "ngModel", "ngModelChange"], ["selected", "", "hidden", "", 3, "ngValue", "disabled"], [3, "ngValue", 4, "ngFor", "ngForOf"], [1, "text-danger"], [1, "form-group"], ["name", "title", 1, "form-control", 3, "placeholder", "ngModel", "ngModelChange"], ["name", "name", 1, "form-control", 3, "placeholder", "ngModel", "ngModelChange"], ["id", "hs-ows-abstract", "name", "abstract", 1, "form-control", 3, "placeholder", "ngModel", "ngModelChange"], ["class", "d-flex flex-row justify-content-between align-items-baseline mb-1 ", 4, "ngIf"], [1, "pl-4"], [3, "access_rights", "access_rightsChange", 4, "ngIf"], ["type", "button", 1, "btn", "btn-block", "btn-outline-secondary", "dropdown-toggle", "dropdown-toggle-split", 3, "click"], ["class", "hs-ows-vector-advanced", 4, "ngIf"], [1, "btn", "btn-primary", "btn-block", 3, "disabled", "click"], [1, "icon-plus"], [1, "border-bottom", "d-flex", "flex-row", "justify-content-between"], [1, "align-self-center", "m-0"], [1, "nav", "nav-tabs", "justify-content-end"], [1, "nav-item"], [1, "nav-link", "text-secondary", 3, "ngClass", "click"], [3, "ngValue"], [1, "d-flex", "flex-row", "justify-content-between", "align-items-baseline", "mb-1"], [1, "btn-group", "ml-2"], ["type", "button", 1, "btn", "btn-light", "btn-outline-secondary", 3, "ngClass", "click"], [3, "access_rights", "access_rightsChange"], [1, "hs-ows-vector-advanced"], ["name", "srs", 1, "form-control", 3, "ngModel", "ngModelChange"], ["name", "folder", 1, "form-control", 3, "ngModel", "ngModelChange"], ["class", "form-group", 4, "ngIf"], [3, "addUnder", "addUnderChange"], ["type", "checkbox", "name", "extractStyles", 3, "ngModel", "ngModelChange"]], template: function HsAddDataVectorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "form", 0);
        ɵngcc0.ɵɵtemplate(1, HsAddDataVectorComponent_hs_common_url_1_Template, 1, 1, "hs-common-url", 1);
        ɵngcc0.ɵɵtemplate(2, HsAddDataVectorComponent_div_2_Template, 2, 1, "div", 2);
        ɵngcc0.ɵɵtemplate(3, HsAddDataVectorComponent_div_3_Template, 47, 47, "div", 3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hsAddDataService.typeSelected === "url");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hsAddDataService.typeSelected === "file");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showDetails);
    } }, directives: [ɵngcc5.ɵNgNoValidate, ɵngcc5.NgControlStatusGroup, ɵngcc5.NgForm, ɵngcc3.NgIf, HsCommonUrlComponent, HsUploadComponent, ɵngcc5.SelectControlValueAccessor, ɵngcc5.NgControlStatus, ɵngcc5.NgModel, ɵngcc5.NgSelectOption, ɵngcc5.ɵNgSelectMultipleOption, ɵngcc3.NgForOf, ɵngcc5.DefaultValueAccessor, ɵngcc3.NgClass, HsCommonLaymanAccessRightsComponent, ɵngcc5.CheckboxControlValueAccessor], pipes: [ɵngcc1.TranslatePipe], encapsulation: 2 });
HsAddDataVectorComponent.ctorParameters = () => [
    { type: HsAddDataVectorService },
    { type: HsHistoryListService },
    { type: HsLayoutService },
    { type: HsUtilsService },
    { type: HsAddDataService },
    { type: HsToastService },
    { type: HsLanguageService },
    { type: HsCommonEndpointsService },
    { type: HsCommonLaymanService },
    { type: HsLayerManagerService },
    { type: HsLayerUtilsService }
];
HsAddDataVectorComponent.propDecorators = {
    dataType: [{ type: Input }],
    vectorFileInput: [{ type: ViewChild, args: ['vectorFileInput',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsAddDataVectorComponent, [{
        type: Component,
        args: [{
                selector: 'hs-add-data-url-vector',
                template: "<form class=\"form-horizontal\" role=\"form\">\n    <hs-common-url *ngIf=\"hsAddDataService.typeSelected === 'url'\" type=\"vector\" [(url)]=\"url\"\n        (connect)=\"connect()\"></hs-common-url>\n\n    <div class=\"form-group m-3\" *ngIf=\"hsAddDataService.typeSelected === 'file'\">\n       <hs-file-upload (uploaded)=\"handleFileUpload($event)\" uploader=\"hs-vector-file\" [acceptedFormats]=\"acceptedFormats\"></hs-file-upload>\n    </div>\n\n    <div *ngIf=\"showDetails\">\n        <div *ngIf=\"hsAddDataService.typeSelected === 'file'\" class=\"border-bottom d-flex flex-row justify-content-between\">\n            <p class=\"align-self-center m-0\">\n                {{hsLanguageService.getTranslationIgnoreNonExisting('ADDLAYERS.Vector','addingFiles',{featuresCount:featureCount})}}\n            </p>\n            <ul class=\"nav nav-tabs justify-content-end\">\n                <li class=\"nav-item\">\n                    <a class=\"nav-link text-secondary\" [ngClass]=\"{'active': uploadType === 'new'}\"\n                        (click)=\"setUploadType('new')\">{{'LAYERS.newLayer' | translate}}</a>\n                </li>\n                <li class=\"nav-item\">\n                    <a class=\"nav-link text-secondary\" [ngClass]=\"{'active': uploadType === 'existing'}\"\n                        (click)=\"setUploadType('existing')\">{{'LAYERS.existingLayer' | translate}}</a>\n                </li>\n            </ul>\n        </div>\n            <div [hidden]=\"uploadType === 'new'\">\n                <div class=\"form-group my-3\">\n                    <label class=\"capabilities_label control-label\">{{'LAYERS.existingLayer' | translate}}</label>\n                    <select class=\"hsl-custom-select\" name=\"sourceLayer\" [(ngModel)]=\"sourceLayer\" style=\"flex-grow: 1;\">\n                        <option  [ngValue]=\"null\" [disabled]=\"true\" selected hidden> {{'ADDLAYERS.Vector.chooseLayer' | translate}}</option>\n                        <option *ngFor=\"let lyr of vectorLayers\" [ngValue]=\"lyr.layer\">{{ lyr.title }} </option>\n                    </select>\n                </div>\n            </div>\n            <div [hidden]=\"uploadType === 'existing'\">\n                <p><sub class=\"text-danger\">{{'ADDLAYERS.Vector.note' | translate}}</sub></p>\n\n                <div class=\"form-group\">\n                    <label class=\"capabilities_label control-label\">{{'COMMON.title' | translate}}</label>\n                    <input [placeholder]=\"'ADDDATA.URL.submitLayerTitle' | translate\" class=\"form-control\" name=\"title\"\n                        [(ngModel)]=\"title\" />\n                </div>\n\n                <div class=\"form-group\">\n                    <label class=\"capabilities_label control-label\">{{'COMMON.name' | translate}}</label>\n                    <input [placeholder]=\"'ADDDATA.URL.submitLayerName' | translate\" class=\"form-control\" name=\"name\"\n                        [(ngModel)]=\"name\" />\n                </div>\n                <div class=\"form-group\">\n                    <label class=\"capabilities_label control-label\">{{'COMMON.abstract' | translate}}</label>\n                    <textarea class=\"form-control\" id='hs-ows-abstract'\n                        [placeholder]=\"'COMMON.fillInDescriptive' | translate\" name=\"abstract\" [(ngModel)]=\"abstract\">\n                    </textarea>\n                </div>\n                <div class=\"d-flex flex-row justify-content-between align-items-baseline mb-1 \"\n                    *ngIf=\"isAuthorized && saveAvailable\">\n                    {{'ADDDATA.saveToDatabase' | translate}}\n                    <div class=\"btn-group ml-2\">\n                        <button type=\"button\" class=\"btn btn-light  btn-outline-secondary\" (click)=\"saveToLayman = true\"\n                            [ngClass]=\"{'active':saveToLayman}\">\n                            {{'COMMON.yes' | translate}}\n                        </button>\n                        <button type=\"button\" class=\"btn btn-light  btn-outline-secondary\"\n                            (click)=\"saveToLayman = false\" [ngClass]=\"{'active': !saveToLayman}\">\n                            {{'COMMON.no' | translate}}\n                        </button>\n                    </div>\n                </div>\n                <div class=\"pl-4\">\n                    <hs-layman-access-rights *ngIf=\"saveToLayman\" [(access_rights)]=\"access_rights\">\n                    </hs-layman-access-rights>\n                </div>\n\n                <button type=\"button\" class=\"btn btn-block btn-outline-secondary dropdown-toggle dropdown-toggle-split\"\n                    (click)=\"advancedPanelVisible = !advancedPanelVisible\">\n                    {{'COMMON.advancedOptions' | translate}}\n                </button>\n\n                <div class=\"hs-ows-vector-advanced\" *ngIf=\"advancedPanelVisible\">\n                    <div class=\"form-group\">\n                        <label class=\"capabilities_label control-label\">{{'ADDLAYERS.srs' | translate}}</label>\n                        <input class=\"form-control\" name=\"srs\" [(ngModel)]=\"srs\" />\n                    </div>\n\n                    <div class=\"form-group\">\n                        <label class=\"capabilities_label control-label\">{{'ADDLAYERS.folderName' | translate}}</label>\n                        <input class=\"form-control\" name=\"folder\" [(ngModel)]=\"folder_name\" />\n                    </div>\n\n                    <div class=\"form-group\" *ngIf=\"isKml()\">\n                        <label class=\"capabilities_label control-label\">{{'ADDLAYERS.VECTOR.extractStyles' |\n                            translate}}</label>\n                        <input type=\"checkbox\" name=\"extractStyles\" [(ngModel)]=\"extract_styles\" />\n                    </div>\n                    <div class=\"form-group\">\n                        <hs-add-layers-target-position [(addUnder)]=\"addUnder\"></hs-add-layers-target-position>\n                    </div>\n                </div>\n            </div>\n\n\n            <button class=\"btn btn-primary btn-block\" [disabled]=\"uploadType === 'new' ? !title : !sourceLayer\" (click)=\"add()\"><i class=\"icon-plus\"></i>\n                {{'COMMON.add' | translate}}\n            </button>\n\n    </div>\n</form>\n"
            }]
    }], function () { return [{ type: HsAddDataVectorService }, { type: HsHistoryListService }, { type: HsLayoutService }, { type: HsUtilsService }, { type: HsAddDataService }, { type: HsToastService }, { type: HsLanguageService }, { type: HsCommonEndpointsService }, { type: HsCommonLaymanService }, { type: HsLayerManagerService }, { type: HsLayerUtilsService }]; }, { dataType: [{
            type: Input
        }], vectorFileInput: [{
            type: ViewChild,
            args: ['vectorFileInput']
        }] }); })();

class HsAddDataVectorModule {
}
HsAddDataVectorModule.ɵfac = function HsAddDataVectorModule_Factory(t) { return new (t || HsAddDataVectorModule)(); };
HsAddDataVectorModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: HsAddDataVectorModule });
HsAddDataVectorModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule,
            TranslateModule,
            HsAddDataCommonModule,
            HsLaymanModule,
            HsUploadModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsAddDataVectorModule, [{
        type: NgModule,
        args: [{
                schemas: [CUSTOM_ELEMENTS_SCHEMA],
                imports: [
                    CommonModule,
                    FormsModule,
                    TranslateModule,
                    HsAddDataCommonModule,
                    HsLaymanModule,
                    HsUploadModule,
                ],
                exports: [HsAddDataVectorComponent],
                declarations: [HsAddDataVectorComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(HsAddDataVectorModule, { declarations: function () { return [HsAddDataVectorComponent]; }, imports: function () { return [CommonModule,
        FormsModule,
        TranslateModule, HsAddDataCommonModule, HsLaymanModule, HsUploadModule]; }, exports: function () { return [HsAddDataVectorComponent]; } }); })();

class HsAddDataFileModule {
}
HsAddDataFileModule.ɵfac = function HsAddDataFileModule_Factory(t) { return new (t || HsAddDataFileModule)(); };
HsAddDataFileModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: HsAddDataFileModule });
HsAddDataFileModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule,
            TranslateModule,
            //
            HsAddDataFileShpModule,
            HsAddDataVectorModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsAddDataFileModule, [{
        type: NgModule,
        args: [{
                schemas: [CUSTOM_ELEMENTS_SCHEMA],
                declarations: [HsAddDataFileComponent],
                imports: [
                    CommonModule,
                    FormsModule,
                    TranslateModule,
                    //
                    HsAddDataFileShpModule,
                    HsAddDataVectorModule,
                ],
                exports: [HsAddDataFileComponent],
                entryComponents: [HsAddDataFileComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(HsAddDataFileModule, { declarations: function () { return [HsAddDataFileComponent]; }, imports: function () { return [CommonModule,
        FormsModule,
        TranslateModule, HsAddDataFileShpModule, HsAddDataVectorModule]; }, exports: function () { return [HsAddDataFileComponent]; } }); })();

class HsArcgisGetCapabilitiesService {
    constructor(httpClient, hsEventBusService, hsMapService, hsUtilsService, hsLogService, hsAddDataService, hsCapabilityCacheService) {
        this.httpClient = httpClient;
        this.hsEventBusService = hsEventBusService;
        this.hsMapService = hsMapService;
        this.hsUtilsService = hsUtilsService;
        this.hsLogService = hsLogService;
        this.hsAddDataService = hsAddDataService;
        this.hsCapabilityCacheService = hsCapabilityCacheService;
    }
    /**
     * Get WMS service location without parameters from url string
     *
     * @param str - Url string to parse
     * @returns WMS service Url
     */
    getPathFromUrl(str) {
        if (str.indexOf('?') > -1) {
            return str.substring(0, str.indexOf('?'));
        }
        else {
            return str;
        }
    }
    /**
     * Create WMS parameter string from parameter object
     * TODO: Probably the same as utils.paramsToURL
     *
     * @param obj - Object with stored WMS service parameters
     * @returns Parameter string or empty string if no object given
     */
    params2String(obj) {
        return obj
            ? Object.keys(obj)
                .map((key) => {
                const val = obj[key];
                if (Array.isArray(val)) {
                    return val
                        .map((val2) => {
                        return (encodeURIComponent(key) + '=' + encodeURIComponent(val2));
                    })
                        .join('&');
                }
                return encodeURIComponent(key) + '=' + encodeURIComponent(val);
            })
                .join('&')
            : '';
    }
    /**
     * Parse added service url and sends GetCapabilities request to WMS service
     *
     * @param service_url - Raw Url localization of service
     * @returns Promise object - Response to GetCapabilities request
     */
    request(service_url) {
        return __awaiter(this, void 0, void 0, function* () {
            service_url = service_url.replace(/&amp;/g, '&');
            const params = this.hsUtilsService.getParamsFromUrl(service_url);
            const path = this.getPathFromUrl(service_url);
            params.f = 'json';
            let url = [path, this.params2String(params)].join('?');
            url = this.hsUtilsService.proxify(url);
            if (this.hsCapabilityCacheService.get(url)) {
                return this.hsCapabilityCacheService.get(url);
            }
            try {
                const r = yield this.httpClient
                    .get(url, {
                    responseType: 'json',
                })
                    .pipe(takeUntil(this.hsAddDataService.cancelUrlRequest))
                    .toPromise();
                const wrap = { response: r };
                this.hsCapabilityCacheService.set(url, wrap);
                return wrap;
            }
            catch (e) {
                return { response: e, error: true };
            }
        });
    }
    /**
     * Load all layers of selected service to the map
     *
     * @param caps - XML response of GetCapabilities of selected service
     * @returns List of layers from service
     */
    service2layers(caps) {
        const service = caps.layers;
        //onst srss = caps.spatialReference.wkid;
        const image_formats = caps.supportedImageFormatTypes.split(',');
        const query_formats = caps.supportedQueryFormats
            ? caps.supportedQueryFormats.split(',')
            : [];
        const image_format = getPreferredFormat(image_formats, [
            'image/png; mode=8bit',
            'image/png',
            'image/gif',
            'image/jpeg',
        ]);
        const query_format = getPreferredFormat(query_formats, [
            'application/vnd.esri.wms_featureinfo_xml',
            'application/vnd.ogc.gml',
            'application/vnd.ogc.wms_xml',
            'text/plain',
            'text/html',
        ]);
        const tmp = [];
        for (const subservice of service) {
            this.hsLogService.log('Load service', subservice);
            for (const layer of subservice.Layer) {
                this.hsLogService.log('Load service', this);
                let attributions = [];
                if (layer.Attribution) {
                    attributions = [
                        `<a href="${layer.Attribution.OnlineResource}">${layer.Attribution.Title}</a>`,
                    ];
                }
                const new_layer = new Tile({
                    properties: {
                        title: layer.Title.replace(/\//g, '&#47;'),
                        abstract: layer.Abstract,
                    },
                    source: new TileWMS({
                        url: caps.Capability.Request.GetMap.DCPType[0].HTTP.Get
                            .OnlineResource,
                        attributions: attributions,
                        params: {
                            LAYERS: layer.Name,
                            INFO_FORMAT: layer.queryable ? query_format : undefined,
                            FORMAT: image_format,
                            styles: layer.Style && layer.Style.length > 0
                                ? layer.Style[0].Name
                                : undefined,
                        },
                        crossOrigin: 'anonymous',
                    }),
                    useInterimTilesOnError: false,
                    extent: layer.BoundingBox,
                });
                this.hsMapService.proxifyLayerLoader(new_layer, true);
                tmp.push(new_layer);
            }
        }
        return tmp;
    }
}
HsArcgisGetCapabilitiesService.ɵfac = function HsArcgisGetCapabilitiesService_Factory(t) { return new (t || HsArcgisGetCapabilitiesService)(ɵngcc0.ɵɵinject(ɵngcc2.HttpClient), ɵngcc0.ɵɵinject(HsEventBusService), ɵngcc0.ɵɵinject(HsMapService), ɵngcc0.ɵɵinject(HsUtilsService), ɵngcc0.ɵɵinject(HsLogService), ɵngcc0.ɵɵinject(HsAddDataService), ɵngcc0.ɵɵinject(HsCapabilityCacheService)); };
HsArcgisGetCapabilitiesService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HsArcgisGetCapabilitiesService_Factory() { return new HsArcgisGetCapabilitiesService(i0.ɵɵinject(i1$1.HttpClient), i0.ɵɵinject(HsEventBusService), i0.ɵɵinject(HsMapService), i0.ɵɵinject(HsUtilsService), i0.ɵɵinject(HsLogService), i0.ɵɵinject(HsAddDataService), i0.ɵɵinject(HsCapabilityCacheService)); }, token: HsArcgisGetCapabilitiesService, providedIn: "root" });
HsArcgisGetCapabilitiesService.ctorParameters = () => [
    { type: HttpClient },
    { type: HsEventBusService },
    { type: HsMapService },
    { type: HsUtilsService },
    { type: HsLogService },
    { type: HsAddDataService },
    { type: HsCapabilityCacheService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsArcgisGetCapabilitiesService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc2.HttpClient }, { type: HsEventBusService }, { type: HsMapService }, { type: HsUtilsService }, { type: HsLogService }, { type: HsAddDataService }, { type: HsCapabilityCacheService }]; }, null); })();

class HsAddDataArcGisService {
    constructor(hsArcgisGetCapabilitiesService, hsLayoutService, hsMapService, hsUtilsService, hsAddDataUrlService, hsAddDataCommonUrlService) {
        this.hsArcgisGetCapabilitiesService = hsArcgisGetCapabilitiesService;
        this.hsLayoutService = hsLayoutService;
        this.hsMapService = hsMapService;
        this.hsUtilsService = hsUtilsService;
        this.hsAddDataUrlService = hsAddDataUrlService;
        this.hsAddDataCommonUrlService = hsAddDataCommonUrlService;
        this.data = {
            map_projection: '',
            register_metadata: true,
            tile_size: 512,
            use_resampling: false,
            use_tiles: true,
        };
    }
    addLayerFromCapabilities(wrapper) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!wrapper.response && !wrapper.error) {
                return;
            }
            if (wrapper.error) {
                this.hsAddDataCommonUrlService.throwParsingError(wrapper.response.message);
                return;
            }
            try {
                yield this.createLayer(wrapper.response, this.hsAddDataCommonUrlService.layerToSelect);
                if (this.hsAddDataCommonUrlService.layerToSelect) {
                    this.addLayers(true);
                }
            }
            catch (e) {
                this.hsAddDataCommonUrlService.throwParsingError(e);
            }
        });
    }
    createLayer(response, layerToSelect) {
        return new Promise(() => {
            var _a;
            try {
                const caps = response;
                this.data.map_projection = this.hsMapService.map
                    .getView()
                    .getProjection()
                    .getCode()
                    .toUpperCase();
                this.data.title = caps.mapName || 'Arcgis layer';
                this.data.description = addAnchors(caps.description);
                this.data.version = caps.currentVersion;
                this.data.image_formats = caps.supportedImageFormatTypes
                    ? caps.supportedImageFormatTypes.split(',')
                    : [];
                this.data.query_formats = caps.supportedQueryFormats
                    ? caps.supportedQueryFormats.split(',')
                    : [];
                this.data.srss = ((_a = caps.spatialReference) === null || _a === void 0 ? void 0 : _a.wkid)
                    ? [caps.spatialReference.wkid.toString()]
                    : [];
                this.data.services = caps.layers || caps.services;
                this.data.srs = (() => {
                    for (const srs of this.data.srss) {
                        if (srs.includes('3857')) {
                            return srs;
                        }
                    }
                    return this.data.srss[0];
                })();
                this.data.resample_warning = this.hsAddDataCommonUrlService.srsChanged(this.data.srs);
                this.hsAddDataUrlService.selectLayerByName(layerToSelect, this.data.services, 'Name');
                this.data.image_format = getPreferredFormat(this.data.image_formats, [
                    'PNG32',
                    'PNG',
                    'GIF',
                    'JPG',
                ]);
                this.data.query_format = getPreferredFormat(this.data.query_formats, [
                    'geoJSON',
                    'JSON',
                ]);
                this.hsAddDataCommonUrlService.loadingInfo = false;
            }
            catch (e) {
                throw new Error(e);
            }
        });
    }
    /**
     * @param checkedOnly -
     * Seconds step in adding layers to the map, with resampling or without. Lops through the list of layers and calls addLayer.
     * @param checked - Add all available layers or only checked ones. Checked=false=all
     */
    addLayers(checkedOnly) {
        if (this.data.services === undefined) {
            return;
        }
        if (this.data.base) {
            this.addLayer({}, {
                layerTitle: this.data.title.replace(/\//g, '&#47;'),
                path: this.hsUtilsService.undefineEmptyString(this.data.folder_name),
                imageFormat: this.data.image_format,
                queryFormat: this.data.query_format,
                tileSize: this.data.tile_size,
                crs: this.data.srs,
                subLayers: null,
            });
        }
        else {
            for (const layer of this.data.services) {
                this.addLayersRecursively(layer, { checkedOnly: checkedOnly });
            }
        }
        this.data.base = false;
        this.hsLayoutService.setMainPanel('layermanager');
    }
    addLayersRecursively(layer, options = { checkedOnly: true }) {
        if (!options.checkedOnly || layer.checked) {
            if (layer.Layer === undefined) {
                this.addLayer(layer, {
                    layerTitle: layer.name.replace(/\//g, '&#47;'),
                    path: this.hsUtilsService.undefineEmptyString(this.data.folder_name),
                    imageFormat: this.data.image_format,
                    queryFormat: this.data.query_format,
                    tileSize: this.data.tile_size,
                    crs: this.data.srs,
                    subLayers: this.hsAddDataCommonUrlService.getSublayerNames(layer),
                });
            }
            else {
                const clone = this.hsUtilsService.structuredClone(layer);
                delete clone.Layer;
                this.addLayer(layer, {
                    layerTitle: layer.name.replace(/\//g, '&#47;'),
                    path: this.hsUtilsService.undefineEmptyString(this.data.folder_name),
                    imageFormat: this.data.image_format,
                    queryFormat: this.data.query_format,
                    tileSize: this.data.tile_size,
                    crs: this.data.srs,
                    subLayers: this.hsAddDataCommonUrlService.getSublayerNames(layer),
                });
            }
        }
        if (layer.Layer) {
            for (const sublayer of layer.Layer) {
                this.addLayersRecursively(sublayer, { checkedOnly: options.checkedOnly });
            }
        }
    }
    /**
     * Add selected layer to map
     * @param layer - capabilities layer object
     * @param layerTitle - layer name in the map
     * @param path - Path name
     * @param imageFormat - Format in which to serve image. Usually: image/png
     * @param queryFormat - See info_format in https://docs.geoserver.org/stable/en/user/services/wms/reference.html
     * @param tileSize - Tile size in pixels
     * @param crs - of the layer
     * @param subLayers - Static sub-layers of the layer
     */
    addLayer(layer, options) {
        let attributions = [];
        if (layer.Attribution) {
            attributions = [
                `<a href="${layer.Attribution.OnlineResource}">${layer.Attribution.Title}</a>`,
            ];
        }
        const dimensions = {};
        if (layer.Dimension) {
            for (const val of layer.Dimension) {
                dimensions[val.name] = val;
            }
        }
        const legends = [];
        if (layer.Style && layer.Style[0].LegendURL) {
            legends.push(layer.Style[0].LegendURL[0].OnlineResource);
        }
        const source = new TileArcGISRest({
            url: this.data.get_map_url,
            attributions,
            //projection: me.data.srs,
            params: Object.assign({
                LAYERS: this.data.base
                    ? `show:${this.hsAddDataCommonUrlService.createBasemapName(this.data.services, 'name')}`
                    : `show:${layer.name}`,
                INFO_FORMAT: layer.queryable ? options.queryFormat : undefined,
                FORMAT: options.imageFormat,
            }, {}),
            crossOrigin: 'anonymous',
        });
        const new_layer = new Tile({
            properties: {
                title: options.layerTitle,
                removable: true,
                path: options.path,
                base: this.data.base,
                dimensions,
            },
            source,
            maxResolution: layer.minScale > 0 ? layer.minScale : undefined,
        });
        //OlMap.proxifyLayerLoader(new_layer, me.data.use_tiles);
        this.hsMapService.map.addLayer(new_layer);
    }
    /**
     * FIXME: UNUSED
     * Add service and its layers to project TODO
     * @param url - Service url
     * @param group - Group layer to which add layer to
     */
    addService(url, group) {
        return __awaiter(this, void 0, void 0, function* () {
            const wrapper = yield this.hsArcgisGetCapabilitiesService.request(url);
            const ol_layers = this.hsArcgisGetCapabilitiesService.service2layers(wrapper.response);
            ol_layers.forEach((layer) => {
                if (group !== undefined) {
                    group.getLayers().push(layer);
                }
                else {
                    this.hsMapService.addLayer(layer);
                }
            });
        });
    }
}
HsAddDataArcGisService.ɵfac = function HsAddDataArcGisService_Factory(t) { return new (t || HsAddDataArcGisService)(ɵngcc0.ɵɵinject(HsArcgisGetCapabilitiesService), ɵngcc0.ɵɵinject(HsLayoutService), ɵngcc0.ɵɵinject(HsMapService), ɵngcc0.ɵɵinject(HsUtilsService), ɵngcc0.ɵɵinject(HsAddDataUrlService), ɵngcc0.ɵɵinject(HsAddDataCommonUrlService)); };
HsAddDataArcGisService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HsAddDataArcGisService_Factory() { return new HsAddDataArcGisService(i0.ɵɵinject(HsArcgisGetCapabilitiesService), i0.ɵɵinject(HsLayoutService), i0.ɵɵinject(HsMapService), i0.ɵɵinject(HsUtilsService), i0.ɵɵinject(HsAddDataUrlService), i0.ɵɵinject(HsAddDataCommonUrlService)); }, token: HsAddDataArcGisService, providedIn: "root" });
HsAddDataArcGisService.ctorParameters = () => [
    { type: HsArcgisGetCapabilitiesService },
    { type: HsLayoutService },
    { type: HsMapService },
    { type: HsUtilsService },
    { type: HsAddDataUrlService },
    { type: HsAddDataCommonUrlService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsAddDataArcGisService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: HsArcgisGetCapabilitiesService }, { type: HsLayoutService }, { type: HsMapService }, { type: HsUtilsService }, { type: HsAddDataUrlService }, { type: HsAddDataCommonUrlService }]; }, null); })();

class HsAddDataWfsComponent {
    constructor(hsAddDataWfsService, hsEventBusService, hsWfsGetCapabilitiesService, hsUtilsService, //used in template,
    hsAddDataUrlService, hsAddDataService, hsHistoryListService, hsAddDataCommonUrlService) {
        this.hsAddDataWfsService = hsAddDataWfsService;
        this.hsEventBusService = hsEventBusService;
        this.hsWfsGetCapabilitiesService = hsWfsGetCapabilitiesService;
        this.hsUtilsService = hsUtilsService;
        this.hsAddDataUrlService = hsAddDataUrlService;
        this.hsAddDataService = hsAddDataService;
        this.hsHistoryListService = hsHistoryListService;
        this.hsAddDataCommonUrlService = hsAddDataCommonUrlService;
        this.title = ''; //FIXME: unused
        this.data = this.hsAddDataWfsService.data;
        //Merge subscriptions in order to easily unsubscribe on destroy
        this.owsConnectingSubscription =
            this.hsEventBusService.owsConnecting.subscribe(({ type, uri, layer, sld }) => {
                if (type == 'wfs') {
                    this.hsAddDataCommonUrlService.layerToSelect = layer;
                    this.setUrlAndConnect(uri, sld);
                }
            });
    }
    ngOnDestroy() {
        this.owsConnectingSubscription.unsubscribe();
    }
    connect(sld) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = this.hsAddDataCommonUrlService.url;
            if (!url || url === '') {
                return;
            }
            this.hsAddDataUrlService.hasAnyChecked = false;
            this.hsHistoryListService.addSourceHistory('wfs', url);
            Object.assign(this.hsAddDataCommonUrlService, {
                services: [],
                showDetails: true,
                loadingInfo: true,
            });
            const wrapper = yield this.hsWfsGetCapabilitiesService.request(url);
            this.hsAddDataWfsService.addLayerFromCapabilities(wrapper, sld);
        });
    }
    /**
     * Connect to service of specified Url
     * @param url - URL of requested service
     */
    setUrlAndConnect(url, sld) {
        this.hsAddDataCommonUrlService.updateUrl(url);
        this.connect(sld);
    }
    changed() {
        this.hsAddDataUrlService.searchForChecked(this.data.services);
    }
}
HsAddDataWfsComponent.ɵfac = function HsAddDataWfsComponent_Factory(t) { return new (t || HsAddDataWfsComponent)(ɵngcc0.ɵɵdirectiveInject(HsAddDataWfsService), ɵngcc0.ɵɵdirectiveInject(HsEventBusService), ɵngcc0.ɵɵdirectiveInject(HsWfsGetCapabilitiesService), ɵngcc0.ɵɵdirectiveInject(HsUtilsService), ɵngcc0.ɵɵdirectiveInject(HsAddDataUrlService), ɵngcc0.ɵɵdirectiveInject(HsAddDataService), ɵngcc0.ɵɵdirectiveInject(HsHistoryListService), ɵngcc0.ɵɵdirectiveInject(HsAddDataCommonUrlService)); };
HsAddDataWfsComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsAddDataWfsComponent, selectors: [["hs-add-data-url-wfs"]], decls: 4, vars: 3, consts: [["name", "frmConnectWfs", "role", "form", 1, "form-horizontal"], ["type", "wfs", 3, "url", "urlChange", "connect"], [4, "ngIf"], ["class", "card", 4, "ngIf"], [1, "card"], [1, "card-title", "text-center", "font-weight-bold"], [1, "form-group"], [1, "capabilities_label", "col-sm-4", "control-label"], [1, "capabilities_input", "col-sm-8"], [1, "form-control", 3, "ngModel", "ngModelOptions", "ngModelChange"], [1, "list-group"], ["class", "list-group-item py-2 clearfix", 4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "list-group-item", "hs-ows-layerlistheading", "clearfix", 2, "background", "var(--panel-wrapper-bg-color)"], [1, "d-flex", "justify-content-center"], [1, "w-100", 3, "injectedService", "layers"], ["class", "btn btn-primary btn-block w-75", 4, "ngIf"], [1, "list-group-item", "py-2", "clearfix"], ["type", "checkbox", "name", "checkedLayer", 3, "ngModel", "ngModelChange", "change"], ["class", "alert alert-primary d-flex m-1", "role", "alert", 4, "ngIf"], ["role", "alert", 1, "alert", "alert-primary", "d-flex", "m-1"], [1, "w-100"], [1, "mb-0", 3, "hidden"], [1, "btn", "btn-primary", "btn-block", "w-75"], [1, "ml-2", 3, "src"]], template: function HsAddDataWfsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "form", 0);
        ɵngcc0.ɵɵelementStart(1, "hs-common-url", 1);
        ɵngcc0.ɵɵlistener("urlChange", function HsAddDataWfsComponent_Template_hs_common_url_urlChange_1_listener($event) { return ctx.hsAddDataCommonUrlService.url = $event; })("connect", function HsAddDataWfsComponent_Template_hs_common_url_connect_1_listener() { return ctx.connect(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(2, HsAddDataWfsComponent_hs_common_url_progress_2_Template, 1, 0, "hs-common-url-progress", 2);
        ɵngcc0.ɵɵtemplate(3, HsAddDataWfsComponent_div_3_Template, 17, 14, "div", 3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("url", ctx.hsAddDataCommonUrlService.url);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hsAddDataCommonUrlService.loadingInfo);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hsAddDataCommonUrlService.showDetails && !ctx.hsAddDataCommonUrlService.loadingInfo);
    } }, directives: [ɵngcc5.ɵNgNoValidate, ɵngcc5.NgControlStatusGroup, ɵngcc5.NgForm, HsCommonUrlComponent, ɵngcc3.NgIf, HsCommonUrlProgressComponent, ɵngcc5.DefaultValueAccessor, ɵngcc5.NgControlStatus, ɵngcc5.NgModel, ɵngcc3.NgForOf, HsCommonUrlAddComponent, ɵngcc5.CheckboxControlValueAccessor], pipes: [ɵngcc1.TranslatePipe, TrackByPropertyPipe], encapsulation: 2 });
HsAddDataWfsComponent.ctorParameters = () => [
    { type: HsAddDataWfsService },
    { type: HsEventBusService },
    { type: HsWfsGetCapabilitiesService },
    { type: HsUtilsService },
    { type: HsAddDataUrlService },
    { type: HsAddDataService },
    { type: HsHistoryListService },
    { type: HsAddDataCommonUrlService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsAddDataWfsComponent, [{
        type: Component,
        args: [{
                selector: 'hs-add-data-url-wfs',
                template: "<form class=\"form-horizontal\" name=\"frmConnectWfs\" role=\"form\">\n    <hs-common-url type=\"wfs\" [(url)]=\"hsAddDataCommonUrlService.url\" (connect)=\"connect()\"></hs-common-url>\n\n    <hs-common-url-progress *ngIf=\"hsAddDataCommonUrlService.loadingInfo\"></hs-common-url-progress>\n    \n    <div *ngIf=\"hsAddDataCommonUrlService.showDetails && !hsAddDataCommonUrlService.loadingInfo\" class=\"card\">\n\n        <!-- FIXME: unused -->\n        <div class=\"card-title text-center font-weight-bold\">{{title}}</div>\n        <div class=\"form-group\">\n            <label class=\"capabilities_label col-sm-4 control-label\">{{'ADDLAYERS.folderName' | translate}}</label>\n            <div class=\"capabilities_input col-sm-8\">\n                <input class=\"form-control\" [(ngModel)]=\"data.folder_name\"\n                    [ngModelOptions]=\"{standalone: true}\" />\n            </div>\n        </div>\n        <hr />\n        <ul class=\"list-group\">\n            <li *ngFor=\"let layer of data.services; trackBy:( 'Name' | trackByProperty )\" class=\"list-group-item py-2 clearfix\">\n                <div>\n                    <input type=\"checkbox\" [(ngModel)]=\"layer.checked\" name=\"checkedLayer\" (change)=\"changed()\" />\n                    {{layer.Title}}\n                </div>\n                <div class=\"alert alert-primary d-flex m-1\" role=\"alert\"\n                    *ngIf=\"layer.featureCount > 1000 && layer.checked\">\n                    <div class=\"w-100\">\n                        <p class=\"mb-0\" [hidden]=\"!layer.limitFeatureCount\">{{'ADDLAYERS.WFS.selectedLayerContains' |\n                            translate}}\n                            {{layer.featureCount}} {{'ADDLAYERS.WFS.loadingToManyAtOnce' | translate}}\n                        </p>\n                    </div>\n                </div>\n            </li>\n            <li class=\"list-group-item hs-ows-layerlistheading clearfix\"\n                style=\"background: var(--panel-wrapper-bg-color);\">\n                <div class=\"d-flex justify-content-center\">\n                    <hs-common-url-add class=\"w-100\" [injectedService]=\"hsAddDataWfsService\"\n                        [layers]=\"data.services\">\n                    </hs-common-url-add>\n                    <button *ngIf=\"hsAddDataWfsService.loadingFeatures\"\n                        class=\"btn btn-primary btn-block w-75\">{{'ADDLAYERS.loadingFeaturePleaseWait' | translate}}<img\n                            class=\"ml-2\" [src]=\"hsUtilsService.getAjaxLoaderIcon()\" /></button>\n                </div>\n            </li>\n\n        </ul>\n    </div>\n</form>\n"
            }]
    }], function () { return [{ type: HsAddDataWfsService }, { type: HsEventBusService }, { type: HsWfsGetCapabilitiesService }, { type: HsUtilsService }, { type: HsAddDataUrlService }, { type: HsAddDataService }, { type: HsHistoryListService }, { type: HsAddDataCommonUrlService }]; }, null); })();

class HsAddDataWfsModule {
}
HsAddDataWfsModule.ɵfac = function HsAddDataWfsModule_Factory(t) { return new (t || HsAddDataWfsModule)(); };
HsAddDataWfsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: HsAddDataWfsModule });
HsAddDataWfsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule,
            TranslateModule,
            HsAddDataCommonModule,
            HsUiExtensionsModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsAddDataWfsModule, [{
        type: NgModule,
        args: [{
                schemas: [CUSTOM_ELEMENTS_SCHEMA],
                imports: [
                    CommonModule,
                    FormsModule,
                    TranslateModule,
                    HsAddDataCommonModule,
                    HsUiExtensionsModule,
                ],
                exports: [HsAddDataWfsComponent],
                declarations: [HsAddDataWfsComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(HsAddDataWfsModule, { declarations: function () { return [HsAddDataWfsComponent]; }, imports: function () { return [CommonModule,
        FormsModule,
        TranslateModule, HsAddDataCommonModule, HsUiExtensionsModule]; }, exports: function () { return [HsAddDataWfsComponent]; } }); })();

class HsAddDataWmsComponent {
    constructor(hsAddDataUrlWmsService, hsEventBusService, hsHistoryListService, hsWmsGetCapabilitiesService, hsAddDataCommonUrlService) {
        this.hsAddDataUrlWmsService = hsAddDataUrlWmsService;
        this.hsEventBusService = hsEventBusService;
        this.hsHistoryListService = hsHistoryListService;
        this.hsWmsGetCapabilitiesService = hsWmsGetCapabilitiesService;
        this.hsAddDataCommonUrlService = hsAddDataCommonUrlService;
        this.owsConnectingSubscription =
            this.hsEventBusService.owsConnecting.subscribe(({ type, uri, layer }) => {
                if (type == 'wms') {
                    this.hsAddDataCommonUrlService.layerToSelect = layer;
                    this.setUrlAndConnect(uri, layer);
                }
            });
    }
    ngOnDestroy() {
        this.owsConnectingSubscription.unsubscribe();
    }
    connect(layerToSelect) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = this.hsAddDataCommonUrlService.url;
            if (!url || url === '') {
                return;
            }
            this.hsHistoryListService.addSourceHistory('wms', url);
            Object.assign(this.hsAddDataCommonUrlService, {
                layerToSelect,
                loadingInfo: true,
                showDetails: true,
            });
            const wrapper = yield this.hsWmsGetCapabilitiesService.request(url);
            this.hsAddDataUrlWmsService.addLayerFromCapabilities(wrapper);
        });
    }
    /**
     * Connect to service of specified Url
     * @param url - Url of requested service
     * @param layer - Optional layer to select, when
     * getCapabilities arrives
     */
    setUrlAndConnect(url, layer) {
        this.hsAddDataCommonUrlService.updateUrl(url);
        this.connect(layer);
    }
}
HsAddDataWmsComponent.ɵfac = function HsAddDataWmsComponent_Factory(t) { return new (t || HsAddDataWmsComponent)(ɵngcc0.ɵɵdirectiveInject(HsAddDataUrlWmsService), ɵngcc0.ɵɵdirectiveInject(HsEventBusService), ɵngcc0.ɵɵdirectiveInject(HsHistoryListService), ɵngcc0.ɵɵdirectiveInject(HsWmsGetCapabilitiesService), ɵngcc0.ɵɵdirectiveInject(HsAddDataCommonUrlService)); };
HsAddDataWmsComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsAddDataWmsComponent, selectors: [["hs-add-data-url-wms"]], decls: 4, vars: 3, consts: [["name", "frmConnectWms", "role", "form", 1, "form-horizontal"], ["type", "wms", 3, "url", "urlChange", "connect"], [4, "ngIf"], ["type", "wms", 3, "injectedService"]], template: function HsAddDataWmsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "form", 0);
        ɵngcc0.ɵɵelementStart(1, "hs-common-url", 1);
        ɵngcc0.ɵɵlistener("urlChange", function HsAddDataWmsComponent_Template_hs_common_url_urlChange_1_listener($event) { return ctx.hsAddDataCommonUrlService.url = $event; })("connect", function HsAddDataWmsComponent_Template_hs_common_url_connect_1_listener() { return ctx.connect(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(2, HsAddDataWmsComponent_hs_common_url_progress_2_Template, 1, 0, "hs-common-url-progress", 2);
        ɵngcc0.ɵɵelement(3, "hs-common-url-details", 3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("url", ctx.hsAddDataCommonUrlService.url);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hsAddDataCommonUrlService.loadingInfo);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("injectedService", ctx.hsAddDataUrlWmsService);
    } }, directives: [ɵngcc5.ɵNgNoValidate, ɵngcc5.NgControlStatusGroup, ɵngcc5.NgForm, HsCommonUrlComponent, ɵngcc3.NgIf, HsCommonUrlDetailsComponent, HsCommonUrlProgressComponent], encapsulation: 2 });
HsAddDataWmsComponent.ctorParameters = () => [
    { type: HsAddDataUrlWmsService },
    { type: HsEventBusService },
    { type: HsHistoryListService },
    { type: HsWmsGetCapabilitiesService },
    { type: HsAddDataCommonUrlService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsAddDataWmsComponent, [{
        type: Component,
        args: [{
                selector: 'hs-add-data-url-wms',
                template: "<form class=\"form-horizontal\" name=\"frmConnectWms\" role=\"form\">\n    <hs-common-url type=\"wms\" [(url)]=\"hsAddDataCommonUrlService.url\" (connect)=\"connect()\">\n    </hs-common-url>\n    <hs-common-url-progress *ngIf=\"hsAddDataCommonUrlService.loadingInfo\"></hs-common-url-progress>\n    <hs-common-url-details [injectedService]=\"hsAddDataUrlWmsService\" type=\"wms\"></hs-common-url-details>\n</form>\n"
            }]
    }], function () { return [{ type: HsAddDataUrlWmsService }, { type: HsEventBusService }, { type: HsHistoryListService }, { type: HsWmsGetCapabilitiesService }, { type: HsAddDataCommonUrlService }]; }, null); })();

class HsAddDataUrlWmsModule {
}
HsAddDataUrlWmsModule.ɵfac = function HsAddDataUrlWmsModule_Factory(t) { return new (t || HsAddDataUrlWmsModule)(); };
HsAddDataUrlWmsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: HsAddDataUrlWmsModule });
HsAddDataUrlWmsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, FormsModule, TranslateModule, HsAddDataCommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsAddDataUrlWmsModule, [{
        type: NgModule,
        args: [{
                schemas: [CUSTOM_ELEMENTS_SCHEMA],
                imports: [CommonModule, FormsModule, TranslateModule, HsAddDataCommonModule],
                exports: [HsAddDataWmsComponent],
                declarations: [HsAddDataWmsComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(HsAddDataUrlWmsModule, { declarations: function () { return [HsAddDataWmsComponent]; }, imports: function () { return [CommonModule, FormsModule, TranslateModule, HsAddDataCommonModule]; }, exports: function () { return [HsAddDataWmsComponent]; } }); })();

class HsAddDataUrlWmtsService {
    constructor(hsMapService, hsLayoutService, hsAddDataUrlService, hsAddDataCommonUrlService) {
        this.hsMapService = hsMapService;
        this.hsLayoutService = hsLayoutService;
        this.hsAddDataUrlService = hsAddDataUrlService;
        this.hsAddDataCommonUrlService = hsAddDataCommonUrlService;
        this.data = {
            add_all: null,
            caps: null,
            description: '',
            image_format: '',
            services: [],
            title: '',
            version: '',
        };
    }
    addLayerFromCapabilities(wrapper) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = wrapper.response;
            const error = wrapper.error;
            if (!response && !error) {
                return;
            }
            if (error) {
                this.hsAddDataCommonUrlService.throwParsingError(response.message);
                return;
            }
            try {
                //TODO AWAIT and add-layer if layerToSelect
                yield this.capabilitiesReceived(response);
                if (this.hsAddDataCommonUrlService.layerToSelect) {
                    for (const layer of this.data.services) {
                        this.addLayers(true);
                    }
                }
            }
            catch (e) {
                this.hsAddDataCommonUrlService.throwParsingError(e);
            }
        });
    }
    /**
     * Parse information received in WMTS getCapabilities respond
     * @param response - Url of requested service
     */
    capabilitiesReceived(response) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const parser = new WMTSCapabilities();
                const caps = parser.read(response);
                this.data.caps = caps;
                this.data.title = caps.ServiceIdentification.Title || 'Wmts layer';
                this.data.description = addAnchors(caps.ServiceIdentification.Abstract);
                this.data.version = caps.Version || caps.version;
                this.data.services = caps.Contents.Layer;
                this.hsAddDataUrlService.selectLayerByName(this.hsAddDataCommonUrlService.layerToSelect, this.data.services, 'Title');
                //TODO Layer to select
                this.hsAddDataCommonUrlService.loadingInfo = false;
                return this.data.title;
            }
            catch (e) {
                throw new Error(e);
            }
        });
    }
    addLayersRecursively(layer) {
        if (!this.data.add_all || layer.checked) {
            this.addLayer(layer);
        }
        if (layer.Layer) {
            for (const sublayer of layer.Layer) {
                this.addLayersRecursively(sublayer);
            }
        }
    }
    addLayers(checkedOnly) {
        this.data.add_all = checkedOnly;
        for (const layer of this.data.services) {
            this.addLayersRecursively(layer);
        }
        this.hsLayoutService.setMainPanel('layermanager');
        //FIX ME: to implement
        // this.zoomToLayers();
    }
    /**
     * Returns preferred tile format
     * @param formats - Set of available formats for layer being added
     */
    getPreferredFormat(formats) {
        const preferred = formats.find((format) => format.includes('png'));
        return preferred ? preferred : formats[0];
    }
    /**
     * Returns preferred tile tileMatrixSet
     * Looks for the occurrence of supported CRS's, if possible picks CRS of current view
     * otherwise returns 3857 as trial(some services support 3857 matrix set even though its not clear from capabilities )
     * @param sets - Set of available matrixSets
     */
    getPreferredMatrixSet(sets) {
        const supportedFormats = ['3857', '4326', '5514'];
        const preferred = sets.filter((set) => supportedFormats.some((v) => set.TileMatrixSet.includes(v)));
        if (preferred.length != 0) {
            const preferCurrent = preferred.find((set) => set.TileMatrixSet.includes(this.hsMapService.map.getView().getProjection().getCode()));
            return preferCurrent
                ? preferCurrent.TileMatrixSet
                : preferred[0].TileMatrixSet;
        }
        return 'EPSG:3857';
    }
    /**
     * Returns preferred info format
     * Looks for the occurrence of supported formats (query.wms)
     * if possible picks HTML, otherwise first from the list of supported is selected
     * @param response - Set of available info formats for layer being added
     */
    getPreferredInfoFormat(formats) {
        if (formats) {
            const supportedFormats = ['html', 'xml', 'gml'];
            const infos = formats.filter((format) => format.resourceType == 'FeatureInfo' &&
                supportedFormats.some((v) => format.format.includes(v)));
            if (infos.length != 0) {
                const preferHTML = infos.find((format) => format.format.includes('html'));
                return preferHTML ? preferHTML.format : infos[0].format;
            }
        }
    }
    /**
     * Add WMTS layer to the map
     * Uses previously received capabilities response as a reference for the source
     * @param response - Set of available info formats for layer being added
     */
    addLayer(layer) {
        try {
            const wmts = new Tile({
                properties: {
                    title: layer.Title,
                    info_format: this.getPreferredInfoFormat(layer.ResourceURL),
                    queryCapabilities: false,
                    removable: true,
                    base: layer.base,
                },
                source: new WMTS$1({}),
            });
            // Get WMTS Capabilities and create WMTS source base on it
            const options = optionsFromCapabilities(this.data.caps, {
                layer: layer.Identifier,
                matrixSet: this.getPreferredMatrixSet(layer.TileMatrixSetLink),
                format: this.getPreferredFormat(layer.Format),
            });
            // WMTS source for raster tiles layer
            const wmtsSource = new WMTS$1(options);
            // set the data source for raster and vector tile layers
            wmts.setSource(wmtsSource);
            this.hsMapService.addLayer(wmts, DuplicateHandling.RemoveOriginal);
            layer.base = false;
        }
        catch (e) {
            throw new Error(e);
        }
    }
}
HsAddDataUrlWmtsService.ɵfac = function HsAddDataUrlWmtsService_Factory(t) { return new (t || HsAddDataUrlWmtsService)(ɵngcc0.ɵɵinject(HsMapService), ɵngcc0.ɵɵinject(HsLayoutService), ɵngcc0.ɵɵinject(HsAddDataUrlService), ɵngcc0.ɵɵinject(HsAddDataCommonUrlService)); };
HsAddDataUrlWmtsService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HsAddDataUrlWmtsService_Factory() { return new HsAddDataUrlWmtsService(i0.ɵɵinject(HsMapService), i0.ɵɵinject(HsLayoutService), i0.ɵɵinject(HsAddDataUrlService), i0.ɵɵinject(HsAddDataCommonUrlService)); }, token: HsAddDataUrlWmtsService, providedIn: "root" });
HsAddDataUrlWmtsService.ctorParameters = () => [
    { type: HsMapService },
    { type: HsLayoutService },
    { type: HsAddDataUrlService },
    { type: HsAddDataCommonUrlService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsAddDataUrlWmtsService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: HsMapService }, { type: HsLayoutService }, { type: HsAddDataUrlService }, { type: HsAddDataCommonUrlService }]; }, null); })();

class HsAddDataWmtsComponent {
    constructor(hsMapService, hsUtilsService, hsWmtsGetCapabilitiesService, hsEventBusService, hsLogService, hsDialogContainerService, hsLanguageService, hsAddDataUrlWmtsService, hsAddDataUrlService, hsAddDataService, hsHistoryListService, hsAddDataCommonUrlService) {
        this.hsMapService = hsMapService;
        this.hsUtilsService = hsUtilsService;
        this.hsWmtsGetCapabilitiesService = hsWmtsGetCapabilitiesService;
        this.hsEventBusService = hsEventBusService;
        this.hsLogService = hsLogService;
        this.hsDialogContainerService = hsDialogContainerService;
        this.hsLanguageService = hsLanguageService;
        this.hsAddDataUrlWmtsService = hsAddDataUrlWmtsService;
        this.hsAddDataUrlService = hsAddDataUrlService;
        this.hsAddDataService = hsAddDataService;
        this.hsHistoryListService = hsHistoryListService;
        this.hsAddDataCommonUrlService = hsAddDataCommonUrlService;
        this.data = this.hsAddDataUrlWmtsService.data;
        //Merge subscriptions in order to easily unsubscribe on destroy
        this.owsConnectingSubscription =
            this.hsEventBusService.owsConnecting.subscribe(({ type, uri, layer }) => {
                if (type == 'wmts') {
                    this.hsAddDataCommonUrlService.layerToSelect = layer;
                    this.setUrlAndConnect(uri, layer);
                }
            });
    }
    ngOnDestroy() {
        this.owsConnectingSubscription.unsubscribe();
    }
    connect(layerToSelect) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = this.hsAddDataCommonUrlService.url;
            if (!url || url === '') {
                return;
            }
            this.hsAddDataUrlService.hasAnyChecked = false;
            this.hsHistoryListService.addSourceHistory('wmts', url);
            Object.assign(this.hsAddDataCommonUrlService, {
                layerToSelect,
                loadingInfo: true,
                showDetails: true,
            });
            const response = yield this.hsWmtsGetCapabilitiesService.request(url);
            this.hsAddDataUrlWmtsService.addLayerFromCapabilities(response);
        });
    }
    setUrlAndConnect(url, layer) {
        this.hsAddDataCommonUrlService.updateUrl(url);
        this.connect(layer);
    }
    changed() {
        this.hsAddDataUrlService.searchForChecked(this.data.services);
    }
}
HsAddDataWmtsComponent.ɵfac = function HsAddDataWmtsComponent_Factory(t) { return new (t || HsAddDataWmtsComponent)(ɵngcc0.ɵɵdirectiveInject(HsMapService), ɵngcc0.ɵɵdirectiveInject(HsUtilsService), ɵngcc0.ɵɵdirectiveInject(HsWmtsGetCapabilitiesService), ɵngcc0.ɵɵdirectiveInject(HsEventBusService), ɵngcc0.ɵɵdirectiveInject(HsLogService), ɵngcc0.ɵɵdirectiveInject(HsDialogContainerService), ɵngcc0.ɵɵdirectiveInject(HsLanguageService), ɵngcc0.ɵɵdirectiveInject(HsAddDataUrlWmtsService), ɵngcc0.ɵɵdirectiveInject(HsAddDataUrlService), ɵngcc0.ɵɵdirectiveInject(HsAddDataService), ɵngcc0.ɵɵdirectiveInject(HsHistoryListService), ɵngcc0.ɵɵdirectiveInject(HsAddDataCommonUrlService)); };
HsAddDataWmtsComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsAddDataWmtsComponent, selectors: [["hs-add-data-url-wmts"]], decls: 4, vars: 3, consts: [["name", "frmConnectWmts", "role", "form", 1, "form-horizontal"], ["type", "wmts", 3, "url", "urlChange", "connect"], [4, "ngIf"], ["class", "card", 4, "ngIf"], [1, "card"], [1, "list-group"], [1, "list-group-item", "hs-ows-layerlistheading", "clearfix", 2, "background", "var(--white)"], ["class", "list-group-item clearfix", 4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "list-group-item", "hs-ows-layerlistheading", "clearfix", 2, "position", "sticky", "bottom", "0", "background", "var(--panel-wrapper-bg-color)", "z-index", "10"], [1, "d-flex", "justify-content-center"], [1, "w-100", 3, "injectedService", "layers"], [1, "list-group-item", "clearfix"], ["type", "checkbox", 1, "d-none", 3, "ngModel", "name", "ngModelChange", "change"], [1, "form-check-label", "m-0", "pl-4", "mw-100", "d-flex", "align-items-center", 3, "ngClass"], [1, "ml-2", 2, "max-width", "90%"], ["class", "d-flex flex-row justify-content-end align-items-baseline", 4, "ngIf"], [1, "d-flex", "flex-row", "justify-content-end", "align-items-baseline"], [1, "btn-group", "ml-2"], ["type", "button", 1, "btn", "btn-sm", "btn-light", "btn-outline-secondary", 3, "ngClass", "click"]], template: function HsAddDataWmtsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "form", 0);
        ɵngcc0.ɵɵelementStart(1, "hs-common-url", 1);
        ɵngcc0.ɵɵlistener("urlChange", function HsAddDataWmtsComponent_Template_hs_common_url_urlChange_1_listener($event) { return ctx.hsAddDataCommonUrlService.url = $event; })("connect", function HsAddDataWmtsComponent_Template_hs_common_url_connect_1_listener() { return ctx.connect(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(2, HsAddDataWmtsComponent_hs_common_url_progress_2_Template, 1, 0, "hs-common-url-progress", 2);
        ɵngcc0.ɵɵtemplate(3, HsAddDataWmtsComponent_div_3_Template, 10, 7, "div", 3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("url", ctx.hsAddDataCommonUrlService.url);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hsAddDataCommonUrlService.loadingInfo);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hsAddDataCommonUrlService.showDetails && !ctx.hsAddDataCommonUrlService.loadingInfo);
    } }, directives: [ɵngcc5.ɵNgNoValidate, ɵngcc5.NgControlStatusGroup, ɵngcc5.NgForm, HsCommonUrlComponent, ɵngcc3.NgIf, HsCommonUrlProgressComponent, ɵngcc3.NgForOf, HsCommonUrlAddComponent, ɵngcc5.CheckboxControlValueAccessor, ɵngcc5.NgControlStatus, ɵngcc5.NgModel, ɵngcc3.NgClass], pipes: [TrackByPropertyPipe, ɵngcc1.TranslatePipe], encapsulation: 2 });
HsAddDataWmtsComponent.ctorParameters = () => [
    { type: HsMapService },
    { type: HsUtilsService },
    { type: HsWmtsGetCapabilitiesService },
    { type: HsEventBusService },
    { type: HsLogService },
    { type: HsDialogContainerService },
    { type: HsLanguageService },
    { type: HsAddDataUrlWmtsService },
    { type: HsAddDataUrlService },
    { type: HsAddDataService },
    { type: HsHistoryListService },
    { type: HsAddDataCommonUrlService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsAddDataWmtsComponent, [{
        type: Component,
        args: [{
                selector: 'hs-add-data-url-wmts',
                template: "<form class=\"form-horizontal\" name=\"frmConnectWmts\" role=\"form\">\n    <hs-common-url type=\"wmts\" [(url)]=\"hsAddDataCommonUrlService.url\" (connect)=\"connect()\">\n    </hs-common-url>\n\n    <hs-common-url-progress *ngIf=\"hsAddDataCommonUrlService.loadingInfo\"></hs-common-url-progress>\n    <div *ngIf=\"hsAddDataCommonUrlService.showDetails && !hsAddDataCommonUrlService.loadingInfo\" class=\"card\">\n        <ul class=\"list-group\">\n            <li class=\"list-group-item hs-ows-layerlistheading clearfix\" style=\"background: var(--white);\">\n                <div>{{data.title}}</div>\n            </li>\n            <li *ngFor=\"let layer of data.services; trackBy:( 'Identifier' | trackByProperty ); let index = index\"\n                class=\"list-group-item clearfix\">\n                <input class=\"d-none\" type=\"checkbox\" [(ngModel)]=\"layer.checked\" (change)=\"changed()\"\n                    [attr.id]=\"'wmtslayer-'+index\" name=\"wmtslayer-{{index}}\" />\n                <label class=\"form-check-label m-0 pl-4 mw-100 d-flex align-items-center\"\n                    [attr.for]=\"'wmtslayer-'+index\"\n                    [ngClass]=\"{'hs-checkmark': layer.checked,'hs-uncheckmark':!layer.checked}\"><span class=\"ml-2\"\n                        style=\"max-width: 90%;\">{{layer.Title}}</span></label>\n\n                <div *ngIf=\"layer.checked\" class=\"d-flex flex-row justify-content-end align-items-baseline\">\n                    {{'ADDDATA.CATALOGUE.addAs' | translate}}\n                    <div class=\"btn-group ml-2\">\n                        <button type=\"button\" class=\"btn btn-sm btn-light  btn-outline-secondary\"\n                            (click)=\"layer.base = true\" [ngClass]=\"{'active':layer.base}\">\n                            {{'COMPOSITONKEYWORDS.Basemap' | translate}}\n                        </button>\n                        <button type=\"button\" class=\"btn btn-sm btn-light  btn-outline-secondary\"\n                            (click)=\"layer.base = false\" [ngClass]=\"{'active': !layer.base}\">\n                            {{'COMMON.layer' | translate}}\n                        </button>\n                    </div>\n                </div>\n            </li>\n        </ul>\n        <li class=\"list-group-item hs-ows-layerlistheading clearfix\" style=\"position: sticky;\n        bottom: 0; background: var(--panel-wrapper-bg-color); z-index:10\">\n            <div class=\"d-flex justify-content-center\">\n                <hs-common-url-add class=\"w-100\" [injectedService]=\"hsAddDataUrlWmtsService\"\n                    [layers]=\"data.services\">\n                </hs-common-url-add>\n            </div>\n        </li>\n    </div>\n\n</form>\n"
            }]
    }], function () { return [{ type: HsMapService }, { type: HsUtilsService }, { type: HsWmtsGetCapabilitiesService }, { type: HsEventBusService }, { type: HsLogService }, { type: HsDialogContainerService }, { type: HsLanguageService }, { type: HsAddDataUrlWmtsService }, { type: HsAddDataUrlService }, { type: HsAddDataService }, { type: HsHistoryListService }, { type: HsAddDataCommonUrlService }]; }, null); })();

class HsAddDataWmtsModule {
}
HsAddDataWmtsModule.ɵfac = function HsAddDataWmtsModule_Factory(t) { return new (t || HsAddDataWmtsModule)(); };
HsAddDataWmtsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: HsAddDataWmtsModule });
HsAddDataWmtsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule,
            TranslateModule,
            HsAddDataCommonModule,
            HsUiExtensionsModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsAddDataWmtsModule, [{
        type: NgModule,
        args: [{
                schemas: [CUSTOM_ELEMENTS_SCHEMA],
                imports: [
                    CommonModule,
                    FormsModule,
                    TranslateModule,
                    HsAddDataCommonModule,
                    HsUiExtensionsModule,
                ],
                exports: [HsAddDataWmtsComponent],
                declarations: [HsAddDataWmtsComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(HsAddDataWmtsModule, { declarations: function () { return [HsAddDataWmtsComponent]; }, imports: function () { return [CommonModule,
        FormsModule,
        TranslateModule, HsAddDataCommonModule, HsUiExtensionsModule]; }, exports: function () { return [HsAddDataWmtsComponent]; } }); })();

class HsAddDataUrlComponent {
    constructor(hsConfig, hsLanguageService, hsEventBusService, hsShareUrlService, hsAddDataService, hsLayoutService, hsAddDataCommonUrlService) {
        this.hsConfig = hsConfig;
        this.hsLanguageService = hsLanguageService;
        this.hsEventBusService = hsEventBusService;
        this.hsShareUrlService = hsShareUrlService;
        this.hsAddDataService = hsAddDataService;
        this.hsLayoutService = hsLayoutService;
        this.hsAddDataCommonUrlService = hsAddDataCommonUrlService;
        if (Array.isArray(this.hsConfig.connectTypes)) {
            this.types = this.hsConfig.connectTypes;
        }
        else {
            this.types = [
                {
                    id: 'wms',
                    text: 'WMS',
                },
                {
                    id: 'wmts',
                    text: 'WMTS',
                },
                {
                    id: 'wfs',
                    text: 'WFS',
                },
                {
                    id: 'kml',
                    text: 'KML',
                },
                {
                    id: 'geojson',
                    text: 'GeoJSON',
                },
                {
                    id: 'arcgis',
                    text: 'ArcGIS Map Server',
                },
            ];
        }
        this.owsFillingSubscription = this.hsEventBusService.owsFilling.subscribe(({ type, uri, layer, sld }) => {
            this.typeSelected = type.toLowerCase();
            this.hsEventBusService.owsConnecting.next({
                type,
                uri,
                layer,
                sld,
            });
        });
        //This component initializes after add-data.component which already set the urlType so *should* be fine to connect now
        if (this.hsAddDataService.urlType) {
            this.selectType(this.hsAddDataService.urlType);
            this.connectServiceFromUrlParam(this.hsAddDataService.urlType);
        }
    }
    ngOnDestroy() {
        this.owsFillingSubscription.unsubscribe();
    }
    selectType(type) {
        this.typeSelected = type;
        this.hsAddDataCommonUrlService.clear();
    }
    connectServiceFromUrlParam(type) {
        const layers = this.hsShareUrlService.getParamValue(`hs-${type}-layers`);
        const url = this.hsShareUrlService.getParamValue(`hs-${type}-to-connect`);
        // const serviceName = `hsAddLayersWmsService`;
        if (layers) {
            for (const layer of layers.split(';')) {
                this.hsEventBusService.owsConnecting.next({
                    type,
                    uri: url,
                    layer,
                    sld: undefined,
                });
            }
        }
        else {
            this.hsEventBusService.owsConnecting.next({ type, uri: url });
            this.hsLayoutService.setMainPanel('addData');
        }
    }
}
HsAddDataUrlComponent.ɵfac = function HsAddDataUrlComponent_Factory(t) { return new (t || HsAddDataUrlComponent)(ɵngcc0.ɵɵdirectiveInject(HsConfig), ɵngcc0.ɵɵdirectiveInject(HsLanguageService), ɵngcc0.ɵɵdirectiveInject(HsEventBusService), ɵngcc0.ɵɵdirectiveInject(HsShareUrlService), ɵngcc0.ɵɵdirectiveInject(HsAddDataService), ɵngcc0.ɵɵdirectiveInject(HsLayoutService), ɵngcc0.ɵɵdirectiveInject(HsAddDataCommonUrlService)); };
HsAddDataUrlComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsAddDataUrlComponent, selectors: [["hs-add-data-url"]], decls: 10, vars: 6, consts: [[1, "d-flex", "justify-content-center", "flex-column", "align-items-center", "m-3"], [1, "container"], [1, "row", "justify-content-center"], ["style", "margin: 3px;", "class", "btn btn-light btn-outline-secondary rounded btn-sm mt-1 col-sm-3", 3, "ngClass", "click", 4, "ngFor", "ngForOf"], [1, "w-100", "pt-3"], [4, "ngIf"], [3, "dataType", 4, "ngIf"], [1, "btn", "btn-light", "btn-outline-secondary", "rounded", "btn-sm", "mt-1", "col-sm-3", 2, "margin", "3px", 3, "ngClass", "click"], [3, "dataType"]], template: function HsAddDataUrlComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵtemplate(3, HsAddDataUrlComponent_button_3_Template, 2, 4, "button", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 4);
        ɵngcc0.ɵɵtemplate(5, HsAddDataUrlComponent_hs_add_data_url_arcgis_5_Template, 1, 0, "hs-add-data-url-arcgis", 5);
        ɵngcc0.ɵɵtemplate(6, HsAddDataUrlComponent_hs_add_data_url_wfs_6_Template, 1, 0, "hs-add-data-url-wfs", 5);
        ɵngcc0.ɵɵtemplate(7, HsAddDataUrlComponent_hs_add_data_url_wms_7_Template, 1, 0, "hs-add-data-url-wms", 5);
        ɵngcc0.ɵɵtemplate(8, HsAddDataUrlComponent_hs_add_data_url_wmts_8_Template, 1, 0, "hs-add-data-url-wmts", 5);
        ɵngcc0.ɵɵtemplate(9, HsAddDataUrlComponent_hs_add_data_url_vector_9_Template, 1, 1, "hs-add-data-url-vector", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.types);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.typeSelected === "arcgis");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.typeSelected === "wfs");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.typeSelected === "wms");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.typeSelected === "wmts");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.typeSelected === "kml" || ctx.typeSelected === "geojson");
    } }, directives: function () { return [ɵngcc3.NgForOf, ɵngcc3.NgIf, ɵngcc3.NgClass, HsAddDataArcGisComponent, HsAddDataWfsComponent, HsAddDataWmsComponent, HsAddDataWmtsComponent, HsAddDataVectorComponent]; }, encapsulation: 2 });
HsAddDataUrlComponent.ctorParameters = () => [
    { type: HsConfig },
    { type: HsLanguageService },
    { type: HsEventBusService },
    { type: HsShareUrlService },
    { type: HsAddDataService },
    { type: HsLayoutService },
    { type: HsAddDataCommonUrlService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsAddDataUrlComponent, [{
        type: Component,
        args: [{
                selector: 'hs-add-data-url',
                template: "<div class=\"d-flex justify-content-center flex-column align-items-center m-3\">\n    <div class=\"container \">\n        <div class=\"row justify-content-center\">\n            <button *ngFor=\"let type of types\" [ngClass]=\"{'active': type.id === typeSelected }\"\n                (click)=\"selectType(type.id)\" style=\"margin: 3px;\"\n                class=\"btn btn-light btn-outline-secondary rounded btn-sm mt-1 col-sm-3\">\n                {{type.text}}\n            </button>\n        </div>\n    </div>\n\n    <div class=\"w-100 pt-3\">\n        <hs-add-data-url-arcgis *ngIf=\"typeSelected === 'arcgis'\"></hs-add-data-url-arcgis>\n        <hs-add-data-url-wfs *ngIf=\"typeSelected === 'wfs'\"></hs-add-data-url-wfs>\n        <hs-add-data-url-wms *ngIf=\"typeSelected === 'wms'\"></hs-add-data-url-wms>\n        <hs-add-data-url-wmts *ngIf=\"typeSelected === 'wmts'\"></hs-add-data-url-wmts>\n        <hs-add-data-url-vector *ngIf=\"typeSelected === 'kml' || typeSelected === 'geojson' \" [dataType]=\"typeSelected\"></hs-add-data-url-vector>\n    </div>\n</div>\n"
            }]
    }], function () { return [{ type: HsConfig }, { type: HsLanguageService }, { type: HsEventBusService }, { type: HsShareUrlService }, { type: HsAddDataService }, { type: HsLayoutService }, { type: HsAddDataCommonUrlService }]; }, null); })();

class HsVectorUrlParserService {
    constructor(hsMapService, hsShareUrlService, hsAddDataVectorService) {
        this.hsMapService = hsMapService;
        this.hsShareUrlService = hsShareUrlService;
        this.hsAddDataVectorService = hsAddDataVectorService;
        this.checkUrlParamsAndAdd = function () {
            return __awaiter(this, void 0, void 0, function* () {
                const title = decodeURIComponent(this.HsShareUrlService.getParamValue('title')) ||
                    'Layer';
                const abstract = decodeURIComponent(this.HsShareUrlService.getParamValue('abstract'));
                if (this.HsShareUrlService.getParamValue('geojson_to_connect')) {
                    const url = this.HsShareUrlService.getParamValue('geojson_to_connect');
                    let type = 'geojson';
                    if (url.indexOf('gpx') > 0) {
                        type = 'gpx';
                    }
                    if (url.indexOf('kml') > 0) {
                        type = 'kml';
                    }
                    const lyr = yield this.HsAddDataVectorService.addVectorLayer(type, url, title, title, abstract, 'EPSG:4326');
                    this.HsAddDataVectorService.fitExtent(lyr);
                }
                if (this.HsShareUrlService.getParamValue('kml_to_connect')) {
                    const url = this.HsShareUrlService.getParamValue('kml_to_connect');
                    const lyr = yield this.HsAddDataVectorService.addVectorLayer('kml', url, title, title, abstract, 'EPSG:4326', { extractStyles: true });
                    this.HsAddDataVectorService.fitExtent(lyr);
                }
            });
        };
        this.hsMapService.loaded().then((map) => {
            this.checkUrlParamsAndAdd();
        });
    }
}
HsVectorUrlParserService.ɵfac = function HsVectorUrlParserService_Factory(t) { return new (t || HsVectorUrlParserService)(ɵngcc0.ɵɵinject(HsMapService), ɵngcc0.ɵɵinject(HsShareUrlService), ɵngcc0.ɵɵinject(HsAddDataVectorService)); };
HsVectorUrlParserService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HsVectorUrlParserService_Factory() { return new HsVectorUrlParserService(i0.ɵɵinject(HsMapService), i0.ɵɵinject(HsShareUrlService), i0.ɵɵinject(HsAddDataVectorService)); }, token: HsVectorUrlParserService, providedIn: "root" });
HsVectorUrlParserService.ctorParameters = () => [
    { type: HsMapService },
    { type: HsShareUrlService },
    { type: HsAddDataVectorService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsVectorUrlParserService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: HsMapService }, { type: HsShareUrlService }, { type: HsAddDataVectorService }]; }, null); })();

class HsAddDataArcGisComponent {
    constructor(hsAddDataArcGisService, hsAddDataCommonUrlService, hsEventBusService, hsHistoryListService, hsArcgisGetCapabilitiesService) {
        this.hsAddDataArcGisService = hsAddDataArcGisService;
        this.hsAddDataCommonUrlService = hsAddDataCommonUrlService;
        this.hsEventBusService = hsEventBusService;
        this.hsHistoryListService = hsHistoryListService;
        this.hsArcgisGetCapabilitiesService = hsArcgisGetCapabilitiesService;
        this.owsConnectingSubscription =
            this.hsEventBusService.owsConnecting.subscribe(({ type, uri, layer }) => {
                if (type === 'arcgis') {
                    this.hsAddDataCommonUrlService.layerToSelect = layer;
                    this.setUrlAndConnect(uri, layer);
                }
            });
    }
    ngOnDestroy() {
        this.owsConnectingSubscription.unsubscribe();
    }
    connect(layerToSelect) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = this.hsAddDataCommonUrlService.url;
            if (!url || url === '') {
                return;
            }
            this.hsHistoryListService.addSourceHistory('arcgis', url);
            Object.assign(this.hsAddDataCommonUrlService, {
                layerToSelect,
                loadingInfo: true,
                showDetails: true,
            });
            this.hsAddDataArcGisService.data.get_map_url = url;
            const wrapper = yield this.hsArcgisGetCapabilitiesService.request(url);
            this.hsAddDataArcGisService.addLayerFromCapabilities(wrapper);
        });
    }
    /**
     * Connect to service of specified Url
     * @param url - Url of requested service
     * @param layer - Optional layer to select, when
     * getCapabilities arrives
     */
    setUrlAndConnect(url, layer) {
        this.hsAddDataCommonUrlService.updateUrl(url);
        this.connect(layer);
    }
}
HsAddDataArcGisComponent.ɵfac = function HsAddDataArcGisComponent_Factory(t) { return new (t || HsAddDataArcGisComponent)(ɵngcc0.ɵɵdirectiveInject(HsAddDataArcGisService), ɵngcc0.ɵɵdirectiveInject(HsAddDataCommonUrlService), ɵngcc0.ɵɵdirectiveInject(HsEventBusService), ɵngcc0.ɵɵdirectiveInject(HsHistoryListService), ɵngcc0.ɵɵdirectiveInject(HsArcgisGetCapabilitiesService)); };
HsAddDataArcGisComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsAddDataArcGisComponent, selectors: [["hs-add-data-url-arcgis"]], decls: 4, vars: 3, consts: [["name", "frmConnectArcgis", "role", "form", 1, "form-horizontal"], ["type", "arcgis", 3, "url", "urlChange", "connect"], [4, "ngIf"], ["type", "arcgis", 3, "injectedService"]], template: function HsAddDataArcGisComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "form", 0);
        ɵngcc0.ɵɵelementStart(1, "hs-common-url", 1);
        ɵngcc0.ɵɵlistener("urlChange", function HsAddDataArcGisComponent_Template_hs_common_url_urlChange_1_listener($event) { return ctx.hsAddDataCommonUrlService.url = $event; })("connect", function HsAddDataArcGisComponent_Template_hs_common_url_connect_1_listener() { return ctx.connect(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(2, HsAddDataArcGisComponent_hs_common_url_progress_2_Template, 1, 0, "hs-common-url-progress", 2);
        ɵngcc0.ɵɵelement(3, "hs-common-url-details", 3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("url", ctx.hsAddDataCommonUrlService.url);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hsAddDataCommonUrlService.loadingInfo);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("injectedService", ctx.hsAddDataArcGisService);
    } }, directives: [ɵngcc5.ɵNgNoValidate, ɵngcc5.NgControlStatusGroup, ɵngcc5.NgForm, HsCommonUrlComponent, ɵngcc3.NgIf, HsCommonUrlDetailsComponent, HsCommonUrlProgressComponent], encapsulation: 2 });
HsAddDataArcGisComponent.ctorParameters = () => [
    { type: HsAddDataArcGisService },
    { type: HsAddDataCommonUrlService },
    { type: HsEventBusService },
    { type: HsHistoryListService },
    { type: HsArcgisGetCapabilitiesService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsAddDataArcGisComponent, [{
        type: Component,
        args: [{
                selector: 'hs-add-data-url-arcgis',
                template: "<form class=\"form-horizontal\" name=\"frmConnectArcgis\" role=\"form\">\n    <hs-common-url type=\"arcgis\" [(url)]=\"hsAddDataCommonUrlService.url\" (connect)=\"connect()\">\n    </hs-common-url>\n    <hs-common-url-progress *ngIf=\"hsAddDataCommonUrlService.loadingInfo\"></hs-common-url-progress>\n    <hs-common-url-details [injectedService]=\"hsAddDataArcGisService\" type=\"arcgis\"></hs-common-url-details>\n</form>\n"
            }]
    }], function () { return [{ type: HsAddDataArcGisService }, { type: HsAddDataCommonUrlService }, { type: HsEventBusService }, { type: HsHistoryListService }, { type: HsArcgisGetCapabilitiesService }]; }, null); })();

class HsAddDataArcGisModule {
}
HsAddDataArcGisModule.ɵfac = function HsAddDataArcGisModule_Factory(t) { return new (t || HsAddDataArcGisModule)(); };
HsAddDataArcGisModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: HsAddDataArcGisModule });
HsAddDataArcGisModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, FormsModule, TranslateModule, HsAddDataCommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsAddDataArcGisModule, [{
        type: NgModule,
        args: [{
                schemas: [CUSTOM_ELEMENTS_SCHEMA],
                imports: [CommonModule, FormsModule, TranslateModule, HsAddDataCommonModule],
                exports: [HsAddDataArcGisComponent],
                declarations: [HsAddDataArcGisComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(HsAddDataArcGisModule, { declarations: function () { return [HsAddDataArcGisComponent]; }, imports: function () { return [CommonModule, FormsModule, TranslateModule, HsAddDataCommonModule]; }, exports: function () { return [HsAddDataArcGisComponent]; } }); })();

class HsAddDataUrlModule {
}
HsAddDataUrlModule.ɵfac = function HsAddDataUrlModule_Factory(t) { return new (t || HsAddDataUrlModule)(); };
HsAddDataUrlModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: HsAddDataUrlModule });
HsAddDataUrlModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule,
            TranslateModule,
            //
            HsAddDataUrlWmsModule,
            HsAddDataArcGisModule,
            HsAddDataWfsModule,
            HsAddDataVectorModule,
            HsAddDataWmtsModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsAddDataUrlModule, [{
        type: NgModule,
        args: [{
                schemas: [CUSTOM_ELEMENTS_SCHEMA],
                declarations: [HsAddDataUrlComponent],
                imports: [
                    CommonModule,
                    FormsModule,
                    TranslateModule,
                    //
                    HsAddDataUrlWmsModule,
                    HsAddDataArcGisModule,
                    HsAddDataWfsModule,
                    HsAddDataVectorModule,
                    HsAddDataWmtsModule,
                ],
                exports: [HsAddDataUrlComponent],
                entryComponents: [HsAddDataUrlComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(HsAddDataUrlModule, { declarations: function () { return [HsAddDataUrlComponent]; }, imports: function () { return [CommonModule,
        FormsModule,
        TranslateModule, HsAddDataUrlWmsModule, HsAddDataArcGisModule, HsAddDataWfsModule, HsAddDataVectorModule, HsAddDataWmtsModule]; }, exports: function () { return [HsAddDataUrlComponent]; } }); })();

class HsAddDataModule {
}
HsAddDataModule.ɵfac = function HsAddDataModule_Factory(t) { return new (t || HsAddDataModule)(); };
HsAddDataModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: HsAddDataModule });
HsAddDataModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule,
            TranslateModule,
            HsPanelHelpersModule,
            HsAddDataUrlModule,
            HsAddDataFileModule,
            HsAddDataCatalogueModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsAddDataModule, [{
        type: NgModule,
        args: [{
                schemas: [CUSTOM_ELEMENTS_SCHEMA],
                declarations: [HsAddDataComponent],
                imports: [
                    CommonModule,
                    FormsModule,
                    TranslateModule,
                    HsPanelHelpersModule,
                    HsAddDataUrlModule,
                    HsAddDataFileModule,
                    HsAddDataCatalogueModule,
                ],
                exports: [HsAddDataComponent],
                entryComponents: [HsAddDataComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(HsAddDataModule, { declarations: function () { return [HsAddDataComponent]; }, imports: function () { return [CommonModule,
        FormsModule,
        TranslateModule, HsPanelHelpersModule, HsAddDataUrlModule, HsAddDataFileModule, HsAddDataCatalogueModule]; }, exports: function () { return [HsAddDataComponent]; } }); })();

class HsCompositionsDeleteDialogComponent {
    constructor(HsDialogContainerService, HsCompositionsService) {
        this.HsDialogContainerService = HsDialogContainerService;
        this.HsCompositionsService = HsCompositionsService;
    }
    close() {
        this.HsDialogContainerService.destroy(this);
    }
    /**
     * @public
     * @param {object} composition Composition selected for deletion
     * @description Delete selected composition from project (including deletion from composition server, useful for user created compositions)
     */
    delete(composition) {
        this.HsCompositionsService.deleteComposition(composition);
        this.close();
    }
}
HsCompositionsDeleteDialogComponent.ɵfac = function HsCompositionsDeleteDialogComponent_Factory(t) { return new (t || HsCompositionsDeleteDialogComponent)(ɵngcc0.ɵɵdirectiveInject(HsDialogContainerService), ɵngcc0.ɵɵdirectiveInject(HsCompositionsService)); };
HsCompositionsDeleteDialogComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsCompositionsDeleteDialogComponent, selectors: [["hs-compositions-delete-dialog"]], decls: 25, vars: 16, consts: [["tabindex", "-1", "role", "dialog", "aria-hidden", "true", 1, "modal", "in", "hs-composition-delete-dialog"], [1, "modal-dialog"], [1, "modal-content"], [1, "modal-header"], [1, "modal-title"], ["type", "button", "data-dismiss", "modal", 1, "close", 3, "click"], ["aria-hidden", "true"], [1, "sr-only"], [1, "modal-body", 2, "max-height", "600px", "overflow-y", "auto"], [1, "modal-footer"], ["type", "button", 1, "btn", "btn-danger", 3, "click"], ["type", "button", "data-dismiss", "modal", 1, "btn", "btn-secondary", 3, "click"]], template: function HsCompositionsDeleteDialogComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelementStart(4, "h4", 4);
        ɵngcc0.ɵɵtext(5);
        ɵngcc0.ɵɵpipe(6, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "button", 5);
        ɵngcc0.ɵɵlistener("click", function HsCompositionsDeleteDialogComponent_Template_button_click_7_listener() { return ctx.close(); });
        ɵngcc0.ɵɵelementStart(8, "span", 6);
        ɵngcc0.ɵɵtext(9, "\u00D7");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "span", 7);
        ɵngcc0.ɵɵtext(11);
        ɵngcc0.ɵɵpipe(12, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(13, "div", 8);
        ɵngcc0.ɵɵelementStart(14, "span");
        ɵngcc0.ɵɵtext(15);
        ɵngcc0.ɵɵpipe(16, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(17);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(18, "div", 9);
        ɵngcc0.ɵɵelementStart(19, "button", 10);
        ɵngcc0.ɵɵlistener("click", function HsCompositionsDeleteDialogComponent_Template_button_click_19_listener() { return ctx.delete(ctx.data.compositionToDelete); });
        ɵngcc0.ɵɵtext(20);
        ɵngcc0.ɵɵpipe(21, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(22, "button", 11);
        ɵngcc0.ɵɵlistener("click", function HsCompositionsDeleteDialogComponent_Template_button_click_22_listener() { return ctx.close(); });
        ɵngcc0.ɵɵtext(23);
        ɵngcc0.ɵɵpipe(24, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(6, 6, "COMMON.confirm"), " ");
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(12, 8, "COMMON.close"));
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(16, 10, "COMPOSITIONS.dialogDelete.doYouWantToDeleteMap"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.data.compositionToDelete.title, " ");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(21, 12, "COMMON.ok"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(24, 14, "COMMON.close"));
    } }, pipes: [ɵngcc1.TranslatePipe], encapsulation: 2 });
HsCompositionsDeleteDialogComponent.ctorParameters = () => [
    { type: HsDialogContainerService },
    { type: HsCompositionsService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsCompositionsDeleteDialogComponent, [{
        type: Component,
        args: [{
                selector: 'hs-compositions-delete-dialog',
                template: "<div class=\"modal in hs-composition-delete-dialog\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <h4 class=\"modal-title\">\n                    {{'COMMON.confirm' | translate}}\n                </h4>\n                <button type=\"button\" (click)=\"close()\" class=\"close\" data-dismiss=\"modal\"><span\n                        aria-hidden=\"true\">&times;</span><span\n                        class=\"sr-only\">{{'COMMON.close' | translate}}</span></button>\n            </div>\n            <div class=\"modal-body\" style=\"max-height: 600px; overflow-y: auto\">\n                <span>{{'COMPOSITIONS.dialogDelete.doYouWantToDeleteMap' | translate}}</span>\n                {{data.compositionToDelete.title}}\n            </div>\n            <div class=\"modal-footer\">\n                <button type=\"button\" class=\"btn btn-danger\"\n                    (click)=\"delete(data.compositionToDelete)\">{{'COMMON.ok' | translate}}</button>\n                <button type=\"button\" class=\"btn btn-secondary\" data-dismiss=\"modal\"\n                    (click)=\"close()\">{{'COMMON.close' | translate}}</button>\n            </div>\n        </div>\n    </div>\n</div>"
            }]
    }], function () { return [{ type: HsDialogContainerService }, { type: HsCompositionsService }]; }, null); })();

//TODO: Is this module declaration needed at all?
class HsCompositionsLayerParserModule {
}
HsCompositionsLayerParserModule.ɵfac = function HsCompositionsLayerParserModule_Factory(t) { return new (t || HsCompositionsLayerParserModule)(); };
HsCompositionsLayerParserModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: HsCompositionsLayerParserModule });
HsCompositionsLayerParserModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[TranslateModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsCompositionsLayerParserModule, [{
        type: NgModule,
        args: [{
                schemas: [CUSTOM_ELEMENTS_SCHEMA],
                declarations: [],
                imports: [TranslateModule],
                exports: [],
                entryComponents: []
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(HsCompositionsLayerParserModule, { imports: function () { return [TranslateModule]; } }); })();

class HsCompositionsShareDialogComponent {
    constructor(HsDialogContainerService, HsShareService) {
        this.HsDialogContainerService = HsDialogContainerService;
        this.HsShareService = HsShareService;
    }
    close() {
        this.HsDialogContainerService.destroy(this);
    }
    shareOnSocial() {
        this.HsShareService.openInShareApi(this.data.title, this.data.abstract, this.data.url);
    }
}
HsCompositionsShareDialogComponent.ɵfac = function HsCompositionsShareDialogComponent_Factory(t) { return new (t || HsCompositionsShareDialogComponent)(ɵngcc0.ɵɵdirectiveInject(HsDialogContainerService), ɵngcc0.ɵɵdirectiveInject(HsShareService)); };
HsCompositionsShareDialogComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsCompositionsShareDialogComponent, selectors: [["hs-compositions-share-dialog"]], decls: 40, vars: 22, consts: [["tabindex", "-1", "role", "dialog", "aria-hidden", "true", 1, "modal", "in", "hs-composition-share-dialog"], [1, "modal-dialog"], [1, "modal-content"], [1, "modal-header"], [1, "modal-title"], ["type", "button", "data-dismiss", "modal", 1, "close", 3, "click"], ["aria-hidden", "true"], [1, "sr-only"], [1, "modal-body", 2, "max-height", "600px", "overflow-y", "auto"], [1, "row"], [1, "col-md-3"], [1, "col-md-9"], [3, "href"], [1, "modal-footer"], ["role", "group", 1, "btn-group"], [1, "btn", "btn-secondary", 3, "click"], [1, "icon-share-alt"], ["type", "button", "data-dismiss", "modal", 1, "btn", "btn-secondary", 3, "click"]], template: function HsCompositionsShareDialogComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelementStart(4, "h4", 4);
        ɵngcc0.ɵɵelementStart(5, "span");
        ɵngcc0.ɵɵtext(6);
        ɵngcc0.ɵɵpipe(7, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "button", 5);
        ɵngcc0.ɵɵlistener("click", function HsCompositionsShareDialogComponent_Template_button_click_9_listener() { return ctx.close(); });
        ɵngcc0.ɵɵelementStart(10, "span", 6);
        ɵngcc0.ɵɵtext(11, "\u00D7");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "span", 7);
        ɵngcc0.ɵɵtext(13);
        ɵngcc0.ɵɵpipe(14, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(15, "div", 8);
        ɵngcc0.ɵɵelementStart(16, "div", 9);
        ɵngcc0.ɵɵelementStart(17, "div", 10);
        ɵngcc0.ɵɵelementStart(18, "b");
        ɵngcc0.ɵɵtext(19);
        ɵngcc0.ɵɵpipe(20, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(21, "div", 11);
        ɵngcc0.ɵɵtext(22);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(23, "div", 9);
        ɵngcc0.ɵɵelementStart(24, "div", 10);
        ɵngcc0.ɵɵelementStart(25, "b");
        ɵngcc0.ɵɵtext(26);
        ɵngcc0.ɵɵpipe(27, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(28, "div", 11);
        ɵngcc0.ɵɵelementStart(29, "a", 12);
        ɵngcc0.ɵɵtext(30);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(31, "div", 13);
        ɵngcc0.ɵɵelementStart(32, "div", 14);
        ɵngcc0.ɵɵelementStart(33, "button", 15);
        ɵngcc0.ɵɵlistener("click", function HsCompositionsShareDialogComponent_Template_button_click_33_listener() { return ctx.shareOnSocial(); });
        ɵngcc0.ɵɵelement(34, "i", 16);
        ɵngcc0.ɵɵtext(35);
        ɵngcc0.ɵɵpipe(36, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(37, "button", 17);
        ɵngcc0.ɵɵlistener("click", function HsCompositionsShareDialogComponent_Template_button_click_37_listener() { return ctx.close(); });
        ɵngcc0.ɵɵtext(38);
        ɵngcc0.ɵɵpipe(39, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(7, 10, "COMPOSITIONS.dialogShare.shareMap"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.data.title, " ");
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(14, 12, "COMMON.close"));
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(20, 14, "COMMON.abstract"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.data.abstract);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(27, 16, "COMMON.url"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("href", ctx.data.url, ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.data.url);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(36, 18, "COMMON.share"), " ");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(39, 20, "COMMON.close"));
    } }, pipes: [ɵngcc1.TranslatePipe], encapsulation: 2 });
HsCompositionsShareDialogComponent.ctorParameters = () => [
    { type: HsDialogContainerService },
    { type: HsShareService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsCompositionsShareDialogComponent, [{
        type: Component,
        args: [{
                selector: 'hs-compositions-share-dialog',
                template: "<div class=\"modal in hs-composition-share-dialog\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <h4 class=\"modal-title\">\n                    <span>{{'COMPOSITIONS.dialogShare.shareMap' | translate}}</span> {{data.title}}\n                </h4>\n                <button type=\"button\" (click)=\"close()\" class=\"close\" data-dismiss=\"modal\"><span\n                        aria-hidden=\"true\">&times;</span><span\n                        class=\"sr-only\">{{'COMMON.close' | translate}}</span></button>\n            </div>\n            <div class=\"modal-body\" style=\"max-height: 600px; overflow-y: auto\">\n                <div class=\"row\">\n                    <div class=\"col-md-3\"><b>{{'COMMON.abstract' | translate}}</b></div>\n                    <div class=\"col-md-9\">{{data.abstract}}</div>\n                </div>\n                <div class=\"row\">\n                    <div class=\"col-md-3\"><b>{{'COMMON.url' | translate}}</b></div>\n                    <div class=\"col-md-9\"><a [href]=\"data.url\">{{data.url}}</a></div>\n                </div>\n            </div>\n            <div class=\"modal-footer\">\n                <div class=\"btn-group\" role=\"group\">\n                    <button class=\"btn btn-secondary\" (click)=\"shareOnSocial()\">\n                        <i class=\"icon-share-alt\"></i> {{'COMMON.share' | translate}}\n                    </button>\n                </div>\n                <button type=\"button\" class=\"btn btn-secondary\" (click)=\"close()\"\n                    data-dismiss=\"modal\">{{'COMMON.close' | translate}}</button>\n            </div>\n        </div>\n    </div>\n</div>"
            }]
    }], function () { return [{ type: HsDialogContainerService }, { type: HsShareService }]; }, null); })();

class HsCompositionsListItemComponent {
    constructor(HsCompositionsService, HsLayoutService, HsToastService, HsDialogContainerService, HsConfig, HsLanguageService) {
        this.HsCompositionsService = HsCompositionsService;
        this.HsLayoutService = HsLayoutService;
        this.HsToastService = HsToastService;
        this.HsDialogContainerService = HsDialogContainerService;
        this.HsConfig = HsConfig;
        this.HsLanguageService = HsLanguageService;
    }
    /**
     * Load selected composition
     * @param composition - Selected composition
     */
    openComposition(composition) {
        this.HsCompositionsService.loadCompositionParser(composition)
            .then(() => {
            //This should not be needed, as for that is the save map button created
            // this.HsSaveMapManagerService.openPanel(composition);
            this.HsLayoutService.setMainPanel('layermanager');
        })
            .catch(() => {
            //Do nothing
        });
    }
    /**
     * @param record Composition to show details
     * Load info about composition through service and display composition info dialog
     */
    detailComposition(record) {
        return __awaiter(this, void 0, void 0, function* () {
            const info = yield this.HsCompositionsService.getCompositionInfo(record);
            if (info !== undefined) {
                this.infoDialogBootstrap(info);
            }
        });
    }
    /**
     * @param record Composition to share
     * Prepare share object on server and display share dialog to share composition
     */
    shareComposition(record) {
        return __awaiter(this, void 0, void 0, function* () {
            let url;
            try {
                yield this.HsCompositionsService.shareComposition(record).then(() => __awaiter(this, void 0, void 0, function* () {
                    url = yield this.HsCompositionsService.getShareUrl();
                    if (url !== undefined) {
                        this.shareDialogBootstrap(record, url);
                    }
                    else {
                        throw new Error('COMPOSITIONS.sharingUrlIsNotAvailable');
                    }
                }));
            }
            catch (e) {
                this.HsToastService.createToastPopupMessage(this.HsLanguageService.getTranslation('COMPOSITIONS.errorWhileSharingOnSocialNetwork'), this.HsLanguageService.getTranslationIgnoreNonExisting('ERRORMESSAGES', e.message, { url: url }), { disableLocalization: true });
            }
        });
    }
    /**
     * @param composition Composition selected for deletion
     * @description Display delete dialog of composition
     */
    confirmDelete(composition) {
        if (!composition.editable) {
            return;
        }
        this.deleteDialogBootstrap(composition);
    }
    /**
     * @param composition
     */
    deleteDialogBootstrap(composition) {
        this.HsDialogContainerService.create(HsCompositionsDeleteDialogComponent, {
            compositionToDelete: composition,
        });
    }
    /**
     * @param record
     * @param url
     */
    shareDialogBootstrap(record, url) {
        this.HsDialogContainerService.create(HsCompositionsShareDialogComponent, {
            url,
            title: this.HsConfig.social_hashtag &&
                !record.title.includes(this.HsConfig.social_hashtag)
                ? record.title + ' ' + this.HsConfig.social_hashtag
                : record.title,
            abstract: record.abstract,
        });
    }
    infoDialogBootstrap(info) {
        this.HsDialogContainerService.create(HsCompositionsInfoDialogComponent, {
            info,
        });
    }
}
HsCompositionsListItemComponent.ɵfac = function HsCompositionsListItemComponent_Factory(t) { return new (t || HsCompositionsListItemComponent)(ɵngcc0.ɵɵdirectiveInject(HsCompositionsService), ɵngcc0.ɵɵdirectiveInject(HsLayoutService), ɵngcc0.ɵɵdirectiveInject(HsToastService), ɵngcc0.ɵɵdirectiveInject(HsDialogContainerService), ɵngcc0.ɵɵdirectiveInject(HsConfig), ɵngcc0.ɵɵdirectiveInject(HsLanguageService)); };
HsCompositionsListItemComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsCompositionsListItemComponent, selectors: [["hs-compositions-list-item"]], inputs: { composition: "composition", selectedCompId: "selectedCompId" }, decls: 26, vars: 26, consts: [[1, "hs-comp-item-title"], [1, "mt-2", 3, "ngClass"], [1, "hs-dotted-line"], ["role", "group", 1, "btn-group", "btn-block"], [1, "btn", "btn-sm", 3, "click"], [1, "icon-map", "icon-primary"], [1, "ml-1"], [1, "icon-info-sign", "icon-primary"], [1, "icon-share-alt", "icon-primary"], ["data-toggle", "tooltip", "data-placement", "bottom", 1, "btn", "btn-sm", 3, "title", "click"], [1, "icon-trash", "icon-primary", 3, "ngClass", "ngStyle"], [1, "ml-1", 3, "hidden"]], template: function HsCompositionsListItemComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵelement(3, "hr", 2);
        ɵngcc0.ɵɵelementStart(4, "div", 3);
        ɵngcc0.ɵɵelementStart(5, "a", 4);
        ɵngcc0.ɵɵlistener("click", function HsCompositionsListItemComponent_Template_a_click_5_listener($event) { $event.stopPropagation(); return ctx.openComposition(ctx.composition); });
        ɵngcc0.ɵɵelement(6, "i", 5);
        ɵngcc0.ɵɵelementStart(7, "span", 6);
        ɵngcc0.ɵɵtext(8);
        ɵngcc0.ɵɵpipe(9, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "a", 4);
        ɵngcc0.ɵɵlistener("click", function HsCompositionsListItemComponent_Template_a_click_10_listener($event) { $event.stopPropagation(); return ctx.detailComposition(ctx.composition); });
        ɵngcc0.ɵɵelement(11, "i", 7);
        ɵngcc0.ɵɵelementStart(12, "span", 6);
        ɵngcc0.ɵɵtext(13);
        ɵngcc0.ɵɵpipe(14, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(15, "a", 4);
        ɵngcc0.ɵɵlistener("click", function HsCompositionsListItemComponent_Template_a_click_15_listener($event) { $event.stopPropagation(); return ctx.shareComposition(ctx.composition); });
        ɵngcc0.ɵɵelement(16, "i", 8);
        ɵngcc0.ɵɵelementStart(17, "span", 6);
        ɵngcc0.ɵɵtext(18);
        ɵngcc0.ɵɵpipe(19, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(20, "a", 9);
        ɵngcc0.ɵɵlistener("click", function HsCompositionsListItemComponent_Template_a_click_20_listener($event) { $event.stopPropagation(); return ctx.confirmDelete(ctx.composition); });
        ɵngcc0.ɵɵpipe(21, "translate");
        ɵngcc0.ɵɵelement(22, "i", 10);
        ɵngcc0.ɵɵelementStart(23, "span", 11);
        ɵngcc0.ɵɵtext(24);
        ɵngcc0.ɵɵpipe(25, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.composition.title || ctx.composition.name);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(20, _c50, ctx.HsCompositionsService.commonId(ctx.composition) != ctx.selectedCompId));
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(9, 10, "COMMON.open"));
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(14, 12, "COMMON.metadata"));
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(19, 14, "COMMON.share"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("title", ctx.composition.editable ? "" : ɵngcc0.ɵɵpipeBind1(21, 16, "COMPOSITIONS.notAllowedToEditLayer"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(22, _c51, !ctx.composition.editable))("ngStyle", ɵngcc0.ɵɵpureFunction1(24, _c41, ctx.composition.editable ? "pointer" : "default"));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", !ctx.composition.editable);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(25, 18, "COMMON.delete"));
    } }, directives: [ɵngcc3.NgClass, ɵngcc3.NgStyle], pipes: [ɵngcc1.TranslatePipe], encapsulation: 2 });
HsCompositionsListItemComponent.ctorParameters = () => [
    { type: HsCompositionsService },
    { type: HsLayoutService },
    { type: HsToastService },
    { type: HsDialogContainerService },
    { type: HsConfig },
    { type: HsLanguageService }
];
HsCompositionsListItemComponent.propDecorators = {
    composition: [{ type: Input }],
    selectedCompId: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsCompositionsListItemComponent, [{
        type: Component,
        args: [{
                selector: 'hs-compositions-list-item',
                template: "<div class=\"hs-comp-item-title\">{{composition.title || composition.name}}</div>\n<div class=\"mt-2\" [ngClass]=\"{'d-none': HsCompositionsService.commonId(composition) != selectedCompId}\">\n    <hr class=\"hs-dotted-line\">\n    <div class=\"btn-group btn-block\" role=\"group\">\n        <a class=\"btn btn-sm\"\n            (click)=\"$event.stopPropagation();openComposition(composition)\">\n            <i class=\"icon-map icon-primary\"></i><span class=\"ml-1\">{{'COMMON.open' |\n                translate}}</span>\n        </a>\n        <a class=\"btn btn-sm\"\n            (click)=\"$event.stopPropagation();detailComposition(composition)\">\n            <i class=\"icon-info-sign icon-primary\"></i><span class=\"ml-1\">{{'COMMON.metadata' |\n                translate}}</span>\n        </a>\n        <a class=\"btn btn-sm\" (click)=\"$event.stopPropagation();shareComposition(composition)\">\n            <i class=\"icon-share-alt icon-primary\"></i><span class=\"ml-1\">{{'COMMON.share' |\n                translate}}</span>\n        </a>\n        <a class=\"btn btn-sm\" (click)=\"$event.stopPropagation();confirmDelete(composition)\" data-toggle=\"tooltip\"\n            data-placement=\"bottom\" [title]=\"composition.editable ? '' : 'COMPOSITIONS.notAllowedToEditLayer' | translate\">\n            <i class=\"icon-trash icon-primary\" [ngClass]=\"{'text-muted': !composition.editable}\"\n                [ngStyle]=\"{'cursor' : composition.editable ? 'pointer' : 'default'}\"></i><span [hidden]=\"!composition.editable\"\n                class=\"ml-1\">{{'COMMON.delete' |\n                translate}}</span>\n        </a>\n    </div>       \n</div>\n"
            }]
    }], function () { return [{ type: HsCompositionsService }, { type: HsLayoutService }, { type: HsToastService }, { type: HsDialogContainerService }, { type: HsConfig }, { type: HsLanguageService }]; }, { composition: [{
            type: Input
        }], selectedCompId: [{
            type: Input
        }] }); })();

class HsCompositionsModule {
}
HsCompositionsModule.ɵfac = function HsCompositionsModule_Factory(t) { return new (t || HsCompositionsModule)(); };
HsCompositionsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: HsCompositionsModule });
HsCompositionsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule,
            HsPanelHelpersModule,
            TranslateModule,
            HsCompositionsLayerParserModule,
            NgbModule,
            HsLaymanModule,
            HsPagerModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsCompositionsModule, [{
        type: NgModule,
        args: [{
                schemas: [CUSTOM_ELEMENTS_SCHEMA],
                declarations: [
                    HsCompositionsComponent,
                    HsCompositionsOverwriteDialogComponent,
                    HsCompositionsDeleteDialogComponent,
                    HsCompositionsShareDialogComponent,
                    HsCompositionsInfoDialogComponent,
                    HsCompositionsWarningDialogComponent,
                    HsCompositionsListItemComponent,
                ],
                imports: [
                    CommonModule,
                    FormsModule,
                    HsPanelHelpersModule,
                    TranslateModule,
                    HsCompositionsLayerParserModule,
                    NgbModule,
                    HsLaymanModule,
                    HsPagerModule,
                ],
                exports: [HsCompositionsComponent],
                entryComponents: [
                    HsCompositionsComponent,
                    HsCompositionsOverwriteDialogComponent,
                    HsCompositionsWarningDialogComponent,
                    HsCompositionsDeleteDialogComponent,
                    HsCompositionsShareDialogComponent,
                    HsCompositionsInfoDialogComponent,
                    HsCompositionsListItemComponent,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(HsCompositionsModule, { declarations: function () { return [HsCompositionsComponent, HsCompositionsOverwriteDialogComponent, HsCompositionsDeleteDialogComponent, HsCompositionsShareDialogComponent, HsCompositionsInfoDialogComponent, HsCompositionsWarningDialogComponent, HsCompositionsListItemComponent]; }, imports: function () { return [CommonModule,
        FormsModule, HsPanelHelpersModule, TranslateModule, HsCompositionsLayerParserModule, NgbModule, HsLaymanModule, HsPagerModule]; }, exports: function () { return [HsCompositionsComponent]; } }); })();

var ADDDATA$3 = {
	catalogue: "Datový katalog",
	CATALOGUE: {
		addAs: "Přidat jako",
		DESC: {
			WFS: "Web Feature Service - stahovací: slouží pro práci s geografickými daty ve vektorové reprezentaci. Je výkonostne naročnejší, především při rozsáhlejších vrstvách, umožňuje však editaci, či zobrazení individuálních informacií ke každému prvku zvlášť.",
			WMS: "Web Map Service - prohlížecí: data nahraje v podobě rastru. Přenášená data jsou obvykle menší co má za následek rychlejší načítání, no na druhou stranu ich není možné upravovat."
		},
		filterType: "Typ vyhledávání",
		loading: "Načítání dat",
		queryDataTypes: {
			all: "Vše",
			dataset: "Datasety",
			service: "Služby"
		},
		resourceType: "Typ zdroje",
		searchFilterTypes: {
			Abstract: "Abstrakt",
			AnyText: "Vše",
			Title: "Titulek"
		},
		searchType: "Typ vyhledávání",
		selectFilterType: "Změnit nastavení vyhledávání",
		sortbyTypes: {
			bbox: "BBOX",
			date: "Datum",
			title: "Titulek"
		},
		showAll: "Všechny",
		showNext100: "Dalších 100",
		showingSubset: "Aktuálně se zobrazuje {{limitShown}} z {{total}} služeb. Ukázat"
	},
	file: "Soubor",
	saveToDatabase: "Uložit do databáze",
	URL: {
		selectAll: "Označit všechny vrstvy",
		submitLayerName: "Zadejte název vrsty",
		submitLayerTitle: "Zadejte titulek vrstvy"
	}
};
var ADDLAYERS$3 = {
	addSelected: "Přidat označené vrstvy do mapy",
	Basemap: "Přidat jako podkladovú vrstvu",
	capabilitiesParsingProblem: "Problém při načítání informací o službě",
	chooseFormat: "Vyberte formát",
	chooseType: "Vyberte typ",
	considerUsingTiles: "Zvažte použití dlaždic. Některé servery mají omezenou maximální velikost obrazu.",
	couldNotUploadSelectedFile: "Při načítání souboru došlo k chybě!",
	ERROR: {
		errorWhileRequestingLayers: "Chyba při žádání vrstev ze serveru",
		someErrorHappened: "Nastala nespecifikovaná chyba nebo je chybný vstup",
		thereWasErrorWhile: "Nastala chyba při syntaktické analýze odpovědi Capabilities z dané URL",
		urlInvalid: "Chybějící nebo neplatná adresa URL požadované vrstvy!",
		srsNotSupported: "Vybraný souřadnicový systém (CRS/SRS) není podporován. Pokračujte poskytnutím souboru v systému EPSG:3857 nebo EPSG:4326."
	},
	externalDataSource: "Zdroj externích dat (URL)",
	featureCount: "Počet prvků",
	folderName: "Název složky",
	imageFormat: "Formát obrazu",
	loadingFeaturePleaseWait: "Načítání prvků, prosím, čekejte",
	mapAndLayerProjection: "Mapová zobrazení mapy a vrstvy si neodpovídají! Bude použito převzorkování. To může vést k neočekávaným výsledkům.",
	mapProjectionAndLayerProjection: "Mapové zobrazení mapy a vrstvy si neodpovídají. Přidat vrstvu do mapy a použít převzorkovací program na straně serveru?",
	none: "Žádnou (nahoru)",
	queryFormat: "Formát dotazu",
	registerMetadata: "Registrovat metadata",
	resampleLayer: "Převzorkovat vrstvu",
	selectAllLayers: "Vybrat všechny vrstvy",
	serviceTypeNotMatching: "Typ služby URL se neshoduje s vybranou kategorií",
	SHP: {
		loginRequired: "Před načtením vrstvy je vyžadováno přihlášení",
		nameRequired: "Pro pokračování je nutné vyplnit pole 'Název'!",
		shapeFile: "Soubory Shapefile (shp+dbf+shx)",
		SLDStyleFile: "Soubor se styly"
	},
	srs: "SRS",
	thisIsRequired: "Toto je vyžadováno!",
	tileSize: "Velikost dlaždice",
	TYPES: {
		ArcGIS: "ArcGIS Map Server",
		shapeFile: "Shapefile",
		vectorFile: "vektorový soubor (GeoJSON, KML)",
		WFS: "Web Feature Service (WFS)",
		WMS: "Web Map Service (WMS)"
	},
	under: "Přidat pod vrstvu",
	unknownDimesion: "Tato vrstva definuje dimenzi, kterou momentálně nelze přečíst",
	useProxy: "Použít proxy",
	useTiles: "Použít dlaždice",
	Vector: {
		addingFiles: "Přidávání {{featuresCount}} prvku do:",
		addSld: "Přidat soubor SLD",
		chooseFiles: "Vyberte soubory...",
		chooseLayer: "Vyberte prosím vrstvu ze seznamu ...",
		dragAndDropFiles: "Přetáhněte soubory",
		note: "*Poznámka: Pokud připojíte soubor se souřadnicemi v jiném systému, než WGS84 (délka/šířka), pak prosím nastavte SRS v sekci \"POKROČILÉ MOŽNOSTI\"",
		uploadVectorFiles: "Nahrajte vektorové soubory"
	},
	VECTOR: {
		extractStyles: "Extrahovat styly"
	},
	WFS: {
		addToMap: "Přidat do mapy",
		loadingToManyAtOnce: "prvků. Načítání příliš mnoha prvků najednou (při oddálení) může ovlivnit výkon aplikace",
		selectedLayerContains: "Vybraná vrstva obsahuje"
	},
	WMTS: {
		tileMatrix: "Matice dlaždic"
	}
};
var COMMON$3 = {
	abstract: "Abstrakt",
	add: "Přidat",
	addAs: "Přidat jako",
	advancedOptions: "Pokročilé možnosti",
	all: "Vše",
	application: "Aplikace",
	area: "Plocha",
	attribute: "Atribut",
	attributes: "Atributy",
	"Authentication failed. Login to the catalogue.": "Chyba ověření. Přihlaste se do katalogu.",
	boundingBox: "Rozsah v mapě",
	cancel: "Zrušit",
	category: "Kategorie",
	circle: "Kruh",
	clear: "Vyčistit",
	close: "Zavřít",
	closeDialog: "Zavřít okno",
	color: "Barva",
	confirm: "Potvrdit",
	confirmDelete: "Potvrďte smazání",
	connect: "Spojení",
	contactInformation: "Kontaktní informace",
	"continue": "Pokračovat",
	data: "Data",
	dataset: "Datová sada",
	date: "Datum",
	"delete": "Vymazat",
	description: "Popis",
	distance: "Vzdálenost",
	download: "Ke stažení",
	drawNewFeatures: "Nakreslit nové prvky",
	east: "Východní",
	extent: "Rozsah",
	fill: "Výplň",
	fillInDescriptive: "Vyplňte stručný popis mapy",
	fillInName: "Vyplňte název",
	filter: "Filtr:",
	folder: "Složka",
	from: "Od",
	fullText: "Fulltext",
	hide: "Skrýt",
	icon: "Ikona",
	ignoreAndContinue: "Ignorovat a pokračovat",
	info: "Další informace",
	keywords: "Klíčová slova",
	layer: "Vrstva",
	layers: "Vrstvy",
	legend: "Legenda",
	less: "Méně",
	line: "Linie",
	lineColor: "Barva linie",
	lineWidth: "Šířka linie",
	loading: "Načítání",
	Login: "Přihlásit se",
	Logout: "Odhlásit",
	mapExtentFilterMissing: "Řazení výsledků dle rozsahu dat je možné jen po aktivaci 'filtrace na rozsah okna'. Aktivujte ji prosím.",
	menu: "Menu",
	metadata: "Metadata",
	more: "Více",
	name: "Název",
	"new": "Nový",
	newDrawingLayer: "Nová vrstva pro kreslení",
	next: "Další",
	no: "Ne",
	noDataReceived: "Nebyla přijata žádná data!",
	north: "Severní",
	ok: "Ok",
	open: "Otevřít",
	or: "anebo",
	orderBy: "Seřadit podle",
	photo: "Foto",
	point: "Bod",
	polygon: "Polygon",
	print: "Tisk",
	projection: "Zobrazení",
	radius: "Poloměr",
	reload: "Znovu načíst",
	removeLayer: "Odstranit vrstvu",
	renameLayer: "Přejmenovat vrstvu",
	reset: "Resetovat",
	results: "Výsledky",
	rotation: "Rotace",
	save: "Uložit",
	saveAs: "Uložit jako..",
	saveTo: "Uložit do",
	scale: "Měřítko",
	search: "Hledat:",
	service: "Služba",
	settings: "Nastavení",
	share: "Sdílet",
	showMore: "Zobrazit více",
	Sort: "Seřadit",
	sortBy: "Řadit podle",
	south: "Jižní",
	stop: "Konec",
	stroke: "Obrys",
	strokeWidth: "Šířka obrysu",
	style: "Style",
	theme: "Téma",
	thumbnail: "Miniatura",
	title: "Titulek",
	to: "do",
	type: "Typ",
	unknownError: "Neznámá chyba. Zkuste to znovu, prosím.",
	until: "Až do",
	url: "URL",
	value: "Hodnota",
	warning: "Varování",
	west: "Západní",
	width: "Šířka",
	wrongCombinationOfParams: "Neplatná kombinace parametrů",
	yes: "Ano",
	zoomTo: "zvětšit na",
	into: " do",
	uploading: "Odesílání dat"
};
var COMPOSITIONS$3 = {
	addByAddress: "Přidat kompozici z adresy",
	Address: "Adresa",
	clearFilters: "Vyčistit filtry",
	compostionsNameAttributeIsNotDefined: "Atribut název kompozice není definován!",
	dialogDelete: {
		doYouWantToDeleteMap: "Chcete smazat tuto mapu?"
	},
	dialogInfo: {
		details: "detaily",
		metadata: {
			comparison_url: "Srovnávací URL",
			csw_url: "CSW URL",
			identifier: "Identifikátor",
			record_url: "Zaznamenejte URL"
		},
		metadataAboutMetadata: "Metadata o metadatech"
	},
	dialogoverwriteConfirm: {
		mergeCompositions: "Spojit kompozice",
		overwriteExistingMap: "Přepsat existující mapu?",
		saveChangesFirst: "Nejprve uložit změny",
		thereAreCurrentlyUnsavedChanges: "V mapovém okně jsou neuložené změny.",
		whatDoYouWant: "Co chcete provést před otevřením vybrané mapové kompozice?",
		youAreOpeningMap: "Otevíráte mapu."
	},
	dialogShare: {
		shareMap: "Sdílet mapu"
	},
	dialogWarning: {
		outOfBounds: "Rozsah kompozice je mimo rozsah systému EPSG:4326",
		toContinue: "Na základě dané velikosti mapy nebude mapa zobrazovat geometrii nebo rozsah dané kompozice"
	},
	endpointUrlIsNotDefined: "Není definováno URL serveru!",
	endpointUserIsNotDefined: "Není definován uživatel katalogu",
	errorWhileLoadingCompositionMetadata: "Chyba při načítání metadat kompozice",
	errorWhileRequestingCompositions: "Chyba při žádosti o kompozice",
	errorWhileSharingOnSocialNetwork: "Chyba při sdílení kompozice na sociální síť",
	filterByMap: "Filtrovat na rozsah okna",
	"import": "Importovat kompozici ze souboru v tomto zařízení",
	inspireTheme: "Téma INSPIRE",
	loginToCatalogue: "Přihlásit do katalogu",
	metadataNotAvailable: "Metadata nejsou dostupná!",
	notAllowedToEditLayer: "Tuto kompozici nemáte oprávnění editovat",
	onlyMine: "Jen moje vlastní",
	selectKeywords: "Vybrat klíčová slova",
	selectThemes: "Vybrat témata",
	sharingUrlIsNotAvailable: "Adresa URL pro sdílení není dostupná!"
};
var COMPOSITONINSPIRETHEMES$3 = {
	Addresses: "Adresy",
	"Administrative units": "Územní správní jednotky",
	"Agricultural and aquaculture facilities": "Zemědělská a vodohospodářská zařízení",
	"Area management/restriction/regulation zones and reporting units": "Správní oblasti/chráněná pásma/regulovaná území a jednotky podávající hlášení",
	"Atmospheric conditions": "Stav ovzduší",
	"Atmospheric Conditions and meteorological geographical features": "Stav ovzduší a zeměpisné meteorologické prvky",
	"Bio-geographical regions": "Bioregiony",
	Buildings: "Budovy",
	"Cadastral parcels": "Parcely",
	"Coordinate reference systems": "Souřadnicové referenční systémy",
	Elevation: "Nadmořská výška",
	"Energy resources": "Energetické zdroje",
	"Environmental monitoring facilities": "Zařízení pro sledování životního prostředí",
	"Geographical grid systems": "Zeměpisné soustavy souřadnicových sítí",
	"Geographical names": "Zeměpisná jména",
	Geology: "Geologie",
	"Habitants and biotopes": "Stanoviště a biotopy",
	"Human health and safety": "Lidské zdraví a bezpečnost",
	Hydrography: "Hydrografie",
	"Land cover": "Krajinný pokryv",
	"Land use": "Využití území",
	"Meteorological geographical features": "Zeměpisné meteorologické prvky",
	"Mineral resources": "Nerostné suroviny",
	"Natural risk zones": "Oblasti ohrožené přírodními riziky",
	None: "Žádné",
	"Oceanographic geographical features": "Zeměpisné oceánografické prvky",
	Orthoimagery: "Ortofotosnímky",
	"Population distribution - demography": "Rozložení obyvatelstva – demografie",
	"Production and industrial facilities": "Výrobní a průmyslová zařízení",
	"Protected sites": "Chráněná území",
	"Sea regions": "Mořské oblasti",
	Soil: "Půda",
	"Species distribution": "Rozložení druhů",
	"Statistical units": "Statistické jednotky",
	"Transport networks": "Dopravní sítě",
	"Utility and governmental services": "Veřejné služby a služby veřejné správy"
};
var COMPOSITONKEYWORDS$3 = {
	Basemap: "Podkladová mapa",
	Borders: "Hranice",
	Cadastre: "Katastr",
	"Complex information": "Komplexní informace",
	Culture: "Kultura",
	Demographics: "Demografie",
	Economics: "Hospodářství",
	Environment: "Životní prostředí",
	Hazards: "Rizika",
	Infrastructure: "Infrastruktura",
	"Land use": "Využití území",
	"Physical geography": "Fyzická geografie",
	Planning: "Plánování",
	"Real estate": "Nemovitosti",
	"Socio political conditions": "Socio-politické podmínky",
	Transport: "Doprava",
	Water: "Voda"
};
var COMPOSITONSORTVALUES$3 = {
	Bbox: "Rozsah mapy",
	"Date": "Datum",
	None: "Žádný",
	Title: "Název"
};
var COMPOSITONTYPES$3 = {
	Application: "Aplikace",
	Datasource: "Zdroj dat",
	"Feature catalogue": "Katalog prvků",
	None: "Žádný",
	Service: "Služba"
};
var DATASOURCE_SELECTOR$3 = {
	addToMapAs: "Přidat do mapy jako",
	advancedMicka: {
		applicationType: "Application type",
		dateStamp: "Date stamp",
		extendedSearchParameters: "Rozšířené vyhledávání",
		extentSimilarity: "Extent similarity",
		featureCatalogue: "Katalog prvků",
		organizationName: "název organizace",
		serviceType: "Typ služby",
		topicCategory: "Topic category"
	},
	datasourceListItem: {
		abortAdd: "Zrušit přidání",
		addToMap: "Přidat do mapy",
		notAllowedToEditLayer: "Tuto datovou sadu nemáte oprávnění editovat",
		whatDoesItMean: "Co to znamená?"
	},
	externalData: "Externí data",
	layerRDF: "RDF vrstva",
	metadataFor: "Metadata o",
	noResults: "Žádné výsledky",
	suggestions: "Návrhy"
};
var DRAW$3 = {
	activateDrawing: "Aktivujte kreslení výběrem typu prvku",
	activeLayers: "Aktivní vrstvy",
	allowSnapping: "Povolit přichytávání",
	boxSelection: "Výběr polygonem",
	boxSelectionActivated: "Výběr polygonem aktivní",
	definedStyle: "Definovaný styl",
	deleteNote: "*Vrstva bude kompletně vymazána. V případe, že ji chcete vymazat jenom z aktuální kompozice (ne i z databáze) můžete tak udelat v panelu 'Správce vrstev'",
	deselectAllFeatures: "Odznačit všechny prvky",
	disableDrawing: "Vypnout kreslení",
	drawInfo: "Při kreslení mnohoúhelníku nebo linie můžete držet klávesu SHIFT pro kreslení rukou; Poslední bod můžete vymazat klávesou Backspace",
	drawingTo: "Kreslím do:",
	drawLayer: "Kreslicí vrstva",
	drawLayerMetadata: {
		defaultAttributes: "Výchozí atributy",
		defaultValue: "Výchozí hodnota",
		layerTitle: "Název vrstvy",
		layerWillBeAdded: "*Vrstva bude přidána do mapy a lze ji dále spravovat v panelu \"Správce vrstev\"",
		loadServerLayers: "Načíst vrstvu ze serveru",
		nameOfFolder: "Název složky v hierarchii správce vrstev"
	},
	drawToolbar: {
		addDrawLayer: "Přidat novou vrstvu pro kreslení",
		addLayer: "Přidat vrstvu",
		finishFeature: "Ukončit prvek",
		removeLastPoint: "Odebrat poslední bod",
		selectType: "Typ geometrie"
	},
	fillOpacity: "Vyplňte neprůhlednost:",
	loadingLayer: "Načítá se vrstva",
	longerLoading: "Zdá se, že načítání trvá déle než obvykle. \nPočkejte chvíli, prosím!",
	newGPS: "Nové GPS",
	noSuitableLayer: "Není k dispozici žádná vhodná vrstva",
	notAuthorized: "Uživatel neautorizován, změny nebudou uloženy",
	reallyDeleteThisLayer: "Opravdu odstranit vybranou vrstvu?",
	saveDrawingToLayer: "Uložit do vrstvy",
	"Select layer": "Vybrat vrstvu",
	selectAllFeatures: "Označit všechny prvky",
	serverLayers: "Servrové vrstvy",
	snapTo: "Přichytávat na vrstvu",
	stylingMissing: "Chybí správný styl",
	stylingMissingWarning: "Geometrii {{type}} NELZE vizualizovat.Nejprve vytvořte symboliku pro {{symbolizer}}. Můžete to udělat v panelu {{panel}}.",
	unsavedDrawing: "Neuložená kresba",
	useModifierToSelectWithBox: "Stiskněte {{platformModifierKey}} a potažením označte oblast výběru"
};
var ERRORMESSAGES$3 = {
	"0": "Chybná odpověď pro {{url}}: 0 Neznámá chyba",
	"400": "Chybná odpověď pro {{url}}: 400 Špatný požadavek",
	"403": "Chybná odpověď pro {{url}}: 403 Odmítnuto",
	"404": "Chybná odpověď pro {{url}}: 404 Nenalezeno",
	"502": "Chybná odpověď pro {{url}}: 502 Špatná brána",
	"Invalid Params": "Před sdílením mapy se ujistěte zda jsou všechna vyžadovaná pole správně vyplněná!",
	"Timeout has occurred": "Chybná odpověď pro {{url}}: Čas vypršel"
};
var FEATURE_TABLE$3 = {
	"delete": "delete",
	showFeatureStats: "Expand",
	sortFeaturesByValue: "Zobrazte statistiky prvku",
	"zoom to": "zoom to"
};
var GEOLOCATION$3 = {
	altitude: "Nadmořská výška",
	follow: "Následovat",
	locateMe: "Najdi mě",
	precision: "Přesnost",
	speed: "Rychlost"
};
var HISTORY$3 = {
	toggleDropdown: "Rozbalovací nabídka"
};
var INFOCOMPONENT$3 = {
	newMap: "Nová mapa",
	unsavedMap: "Neuložená mapa",
	viewComposeAndAnalyse: "Prohlížet, kombinovat a analyzovat prostorová data",
	youHaveUnsavedChanges: "Máte neuložené změny!"
};
var LAYERMANAGER$3 = {
	baselayers: "Podkladové vrstvy",
	baseMapGallery: {
		grayscale: "Šedotón",
		noBaseMap: "Bez podkladu"
	},
	dialogRemoveAll: {
		dialogMessage: "Opravdu chcete odstranit všechny vámi přidané vrstvy?",
		reloadComposition: "Obnovit kompozici",
		removeAllAdded: "Odstranit všechny přidané vrstvy"
	},
	dimensions: "Dimenze",
	editorButtons: "Editační tlačítka",
	enablePhysicalLayerList: "Vypnout/Zapnout fyzický seznam vrstev",
	layerEditor: {
		cluster: "Shlukovat",
		copyright: "Autorská práva",
		layerFrom: "vrstva z",
		memory: "mezipaměti",
		metadataOfLayer: "Metadata vrstvy v ",
		metadataOfService: "Metadata služby",
		opacity: "Průhlednost",
		savegeojson: "Stáhnout obsah vrstvy jako GeoJSON",
		styleLayer: "Stylovat vrstvu",
		vector: "Vektorová",
		"vector (GeoJSON)": "Vektorová (GeoJSON)",
		"vector (KML)": "Vektorová (KML)",
		"vector (TopoJSON)": "Vektorová (TopoJSON)",
		zoomToLayer: "Přiblížit na vrstvu"
	},
	layerList: {
		layerIsQueryable: "Tato vrstva je dotazovatelná",
		layerNotAvailable: "Tato vrstva není k dispozici",
		moveLayerDown: "Přesunout vrstvy dolů v seznamu",
		moveLayerUp: "Posunout vrstvy nahoru v seznamu",
		noAvailableInScale: "Tato vrstva není v tomto měřítku k dispozici",
		sendingToLayman: "Odesílam na Layman"
	},
	layermanagerMd: {
		aboutLayer: "O vrstvě",
		changeLayerOpacity: "Změnit neprůhlednost vrstvy",
		changeLineWidht: "Změnit šířku linie",
		filterFeatures: "Filtrovat prvky",
		imageLayer: "Vrstva obrazu",
		innerRadius: "Vnitřní poloměr",
		layerName: "Název vrstvy",
		layerOpacity: "Průhlednost vrstvy",
		layerOptions: "Možnosti vrstvy",
		layerStyle: "Styl vrstvy",
		layerVisibility: "Viditelnost vrstvy",
		lineFeatures: "Liniové prvky",
		moveLayerDown: "Posunout vrstvu dolů",
		moveLayerDownward: "Přesunutí vrstvy dolů, shift-klik dolů",
		moveLayerUp: "Posunout vrstvu nahoru",
		moveLayerUpward: "Přesunutí vrstvy nahoru, shift-klik na začátek",
		outerRadius: "Vnější poloměr",
		pointFeatures: "Bodové prvky",
		polygonFeatures: "Polygonové prvky",
		sidesNumber: "Číslo stran",
		star: "Hvězda"
	},
	mapContent: "Mapový obsah",
	other: "Jiný",
	removeAllLayers: "Odstranit všechny vrstvy",
	resetMap: "Obnovit mapu",
	terrains: "Terény",
	time: {
		outOfRange: "Vybraný čas je mimo meze",
		outOfRangeDescription: "Tato vrstva může zobrazovat různá data v závislosti na vybraném čase. Čas se může dostat \"mimo meze\" pokud je synchronizován s jinou vrstvou, ale tato vrstva nemá žádná data pro daný okamžik. Klikněte pro vybrání platného data a času. Také můžete vypnout synchronizaci času vrstev.",
		syncTimes: "Synchronizovat časy",
		syncTimesTooltip: "Synchronizovat čas všech vrstev"
	},
	"User generated": "Uživatelský",
	dialogRemoveLayer: {
		dialogMessage: "Opravdu chcete odstranit vybranou vrstvu?"
	}
};
var LAYERS$3 = {
	existingLayer: "Existující vrstva",
	newLayer: "Nová vrstva"
};
var LEGEND$3 = {
	noLegendExists: "Žádná vrstva s legendou neexistuje!"
};
var MAP$3 = {
	zoomKeyModifier: "Stiskněte {{platformModifierKey}} + použijte kolečko myši pro přiblížení mapy.",
	zoomToInitialWindow: "Přiblížit na úvodní pohled"
};
var MEASURE$3 = {
	measureMd: {
		deleteAllMeasurements: "Odstranit všechna měření",
		measureType: "Typ měření",
		saveMeasurementToLayer: "Uložte měření do vrstvy"
	},
	multipleShapes: "Více tvarů"
};
var PANEL_HEADER$3 = {
	ADDLAYERS: "Přidat externí data",
	APPLICATIONSETTINGS: "Nastavení aplikace",
	COMPOSITIONS: "Kompozice",
	DATASOURCE_SELECTOR: "Datové zdroje",
	DRAW: "Kreslit",
	FEATURE_TABLE: "Tabulka prvků",
	FILTERFEATURES: "Filtrovat prvky",
	INFO: "Info",
	LANGUAGE: "Změnit jazyk",
	LEGEND: "Legenda",
	LM: "Správce vrstev",
	MAPCOMPOSITIONS: "Mapové kompozice",
	MEASURE: "Měření",
	PERMALINK: "Sdílet mapu",
	PRINT: "Tisk",
	ROUTING: "Směrování",
	SAVECOMPOSITION: "Uložit aktuální mapu",
	SEARCH: "Hledání",
	SENSORS: "Senzory",
	TRIP_PLANNER: "Plánovač tras"
};
var PERMALINK$3 = {
	directiveMd: {
		copyToClipboard: "Zkopírovat do schránky"
	},
	embed: "vložení",
	embedCode: "Vložit kód",
	linkFor: "Odkaz pro",
	newShare: "Nové sdílení",
	permalink: "Trvalý odkaz",
	pureMap: "Pouze mapa",
	shareOnSocialNetwork: "Sdílejte na sociální síti",
	sharePureMap: "Sdílet pouze mapu",
	sharesMapWith: "*Sdílí mapu se (všemi) funkcemi portálu",
	sharesOnlyMap: "*Sdílí mapu pouze jako obrázek",
	socialShare: "sdílení"
};
var QUERY$3 = {
	confirmClear: "Potvrďte vymazání",
	confirmDelete: "Potvrďte smazání",
	coordinates: "Souřadnice",
	deleteAllSelected: "Odstranit všechny vybrané prvky",
	downloadAs: "Stáhnout jako",
	feature: {
		attributeName: "Název atributu",
		attributeValue: "Hodnota atributu",
		copyFeature: "Zkopírovat  prvek",
		featurecopySucc: "Prvek byl úspěšně skopírován do vrstvy: ",
		featureEdited: "Změna prvku byla úspěšná",
		featuremoveSucc: "Prvek byl úspěšně přesunut do vrstvy: ",
		moveFeature: "Přesunout prvek",
		copyFeatures: "Zkopírovat  prvky",
		moveFeatures: "Přesunout prvky"
	},
	featureInfo: "Informace o prvku",
	featurePopup: {
		clearLayer: "Vyčistit vrstvu",
		closePopup: "Zavřít vyskakovací okno",
		removeClusterPart: "Odstranit část shluku",
		removeFeature: "Odebrat prvek"
	},
	featuresSelected: "Vybrané prvky: ",
	infoPanel: {
		clickOnMap: "Kliknutím do mapy zobrazíte výsledky dotazu"
	},
	reallyDelete: "Opravdu smazat tento prvek?",
	reallyDeleteAllFeaturesFrom: "Opravdu odstranit všechny prvky z vrstvy {0}?",
	reallyDeleteAllSelectedLayers: "Opravdu odstranit všechny vybrané prvky?",
	untitledFeature: "Prvek bez názvu",
	clusterContaining: "Klastr obsahující {{count}} prvků"
};
var SAVECOMPOSITION$3 = {
	dialogResult: {
		compositionFailedToSave: "Uložení kompozice se nezdařilo",
		compositionSavedSuccessfully: "Kompozice byla úspěšně uložena",
		requestWasProcessed: "Žádost byla zpracována, ale mapa nebyla uložena kvůli chybějící autorizaci",
		savingCompositionStatus: "Ukládání kompozice",
		serverDidNotRespond: "Server nereagoval nebo došlo k jiné chybě"
	},
	dialogSave: {
		areYouAttempting: "Pokoušíte se uložit změny mapy do",
		noSaveAs: "Ne, uložit jako",
		saveComposition: "Uložit kompozici",
		selectNewNameForMap: "Vyberte nový název pro mapu",
		useDifferentName: "K uložení mapy použijte jiný název",
		wantToOverwrite: "Opravdu chcete přepsat?",
		yesSave: "Ano, uložte",
		youDoNotHave: "K tomu nemáte dostatečná práva. Možná relace skončila?"
	},
	form: {
		address: "Adresa",
		changeName: "Změnit jméno",
		city: "Město",
		country: "Země",
		email: "E-mail",
		organization: "Organizace",
		overwrite: "Přepsat",
		person: "Osoba",
		phone: "Telefon",
		position: "Pozice",
		postalCode: "Poštovní směrovací číslo",
		read: "Číst",
		state: "Stát",
		toggleAll: "Přepnout vše",
		userCurrentMapExtent: "Použít aktuální rozsah mapy",
		write: "Zápis"
	},
	panelMd: {
		fillKeywords: "Vyplňte klíčová slova",
		makePublic: "Zveřejnit",
		saveMap: "Uložit mapu",
		showThumbnail: "Zobrazit miniaturu",
		thumbnailSwitch: "Přepnout náhled",
		useMapExtent: "Použijte rozsah mapy",
		youAreNotAuthorized: "Nemáte oprávnění k uložení kompozic. Přihlaste se nebo se obraťte na administrátora pro vaše přihlašovací údaje."
	},
	"private": "Soukromé",
	"public": "Veřejné",
	readAccessRights: "Právo čtení",
	removeLayerError: "Vrstva '{{layer}}' nebyla odstraněna z databáze. {{error}}",
	saveOrOverwrite: "Tato kompozice byla vytvořená jiným uživatelem",
	syncErrorDialog: {
		errorWhenSyncing: "Chyba při synchronizaci"
	},
	writeAccessRights: "Právo zápisu"
};
var SENSORS$3 = {
	"1D": "1D",
	"1H": "1H",
	"1M": "1M",
	"1W": "1W",
	"6M": "6M",
	at: "v",
	avg: "Prům.",
	max: "Max",
	measure: "Měření",
	min: "Min",
	oneHour: "1 hodina",
	phenomena: "Jevy",
	sensors: "Senzory",
	sensorUnit: "Senzorová jednotka"
};
var SIDEBAR$3 = {
	additionalPanels: "Další panely",
	descriptions: {
		ADDLAYERS: "Vybrat data nebo služby pro vaši mapovou kompozici",
		APPLICATIONSETTINGS: "Zadat uživatelské nastavení aplikace",
		DRAW: "Nakreslit nové prvky",
		FEATURE_TABLE: "Zobrazit prvky vrstvy v tabulce",
		FILTERFEATURES: "Crossfilter",
		INFO: "Zobrazit informace o výsledku mapového dotazu",
		LANGUAGE: "Změnit jazyk",
		LEGEND: "Zobrazit legendu",
		LM: "Spravovat a stylovat vaše vrstvy",
		MAPCOMPOSITIONS: "Seznam dostupných mapových kompozic",
		MEASURE: "Měřit vzdálenost nebo plochu na mapě",
		PERMALINK: "Sdílet mapu",
		PRINT: "Tisk mapy",
		SAVECOMPOSITION: "Uložit obsah mapy do kompozice",
		SEARCH: "Vyhledat místo",
		TRIP_PLANNER: "Vytvořit novou trasu výletu"
	}
};
var STYLER$3 = {
	addFilter: "Přidat filtr",
	addRule: "Přidat pravidlo",
	addSymbolizer: "Přidat symboliku",
	anchor: "Uchycení",
	anchorX: "Odsazení X",
	anchorY: "Odsazení Y",
	andFilter: "A",
	blur: "Rozostření",
	cap: "Typ konce",
	clusterRule: "Pravidlo pro shluky",
	color: "Barva",
	comparisonFilter: "POROVNAT",
	dashPattern: "Vzor přerušení",
	features: "Prvky",
	fillColor: "Barva výplně",
	fillOpacity: "Průhlednost výplně",
	fillSymbolizer: "Symbolika výplně",
	filtersAndScales: "Filtry a měřítka",
	font: "Font",
	fontStyle: "Styl fontu",
	fontWeight: "Tloušťka písma",
	gapWidth: "Šířka mezery",
	graphicFill: "Grafická výplň",
	graphicStroke: "Grafický obrys",
	haloColor: "Barva obalu",
	haloWidth: "Šířka obalu",
	iconSymbolizer: "Symbolika ikony",
	join: "Napojení",
	justify: "Zarovnat",
	kind: "Typ",
	layer: "Vrstva",
	level: "Úroveň",
	lineSymbolizer: "Symbolika linie",
	markSymbolizer: "Symbolika značky",
	maxScale: "Max. měřítko",
	minScale: "Min. měřítko",
	miterLimit: "Limit pro ostré napojení",
	name: "Jméno",
	notFilter: "NE",
	offsetX: "Odsazení X",
	offsetY: "Odsazení Y",
	opacity: "Průhlednost",
	orFilter: "NEBO",
	outlineColor: "Barva obrysu",
	outlineOpacity: "Průhlednost obrysu",
	outlineWidth: "Šířka obrysu",
	perpendicularOffset: "Kolmý ofset",
	radius: "Poloměr",
	removeFilter: "Vymazat filtr",
	removeRule: "Vymazat pravidlo",
	removeSymbolizer: "Vymazat symboliku",
	rotation: "Rotace",
	roundLimit: "Limit pro kulaté napojení",
	rules: "Pravidla",
	selectIcon: "Vyberte ikonu",
	selection: "Výběr",
	simpleRule: "Jednoduché pravidlo",
	size: "Velikost",
	source: "URL",
	spacing: "Vzdálenost",
	strokeColor: "Barva obrysu",
	strokeOpacity: "Průhlednost obrysu",
	strokeWidth: "Šířka obrysu",
	symbol: "Značka",
	symbolizers: "Symboliky",
	template: "Šablona",
	textColor: "Barva textu",
	textSize: "Velikost textu",
	textSymbolizer: "Symbolika textu",
	toggleFilters: "Přepnout filtry",
	toggleScaleDenominators: "Přepnout rozsah měřítka",
	transform: "Transformace",
	warningAttribNotStoredNotVisualized: "Atribut není aktuálně zobrazen správně a není uložen v SLD",
	warningAttribStoredNotVisualized: "Atribut uložený v SLD, ale aktuálně není zobrazen správně",
	width: "Šířka",
	clear: "Obnovit výchozí styl",
	downloadSld: "Stáhnout styl jako soubor SLD",
	manageStyle: "Spravovat styl",
	unknownSymbolizer: "Neznámá symbolika",
	warningAttribNotStoredVisualized: "Atribut je vizualizován, ale není uložen v SLD",
	uploadSld: "Nahrajte styl jako soubor SLD"
};
var TOOLBAR$3 = {
	measureLinesAndPolygon: "Měřit linie a polygony"
};
var TRIP_PLANNER$3 = {
	clearWaypoints: "Vyčistit body trasy",
	missingAuth: "Přístup k navigační službě nepovolen",
	removeWaypoint: "Odebrat bod trasy",
	routerLayer: "Vrstva s trasou",
	serviceDown: "Navigační služba zdá se nefunguje. Je nám líto!",
	totalDistance: "Celková vzdálenost",
	travelRoute: "Trasa výletu",
	waypointDrawingHint: "Klikněte prosím do mapy pro přidání bodů trasy",
	waypointLayer: "Vrstva s body trasy",
	waypoints: "Body trasy"
};
var cs = {
	ADDDATA: ADDDATA$3,
	ADDLAYERS: ADDLAYERS$3,
	COMMON: COMMON$3,
	COMPOSITIONS: COMPOSITIONS$3,
	COMPOSITONINSPIRETHEMES: COMPOSITONINSPIRETHEMES$3,
	COMPOSITONKEYWORDS: COMPOSITONKEYWORDS$3,
	COMPOSITONSORTVALUES: COMPOSITONSORTVALUES$3,
	COMPOSITONTYPES: COMPOSITONTYPES$3,
	DATASOURCE_SELECTOR: DATASOURCE_SELECTOR$3,
	DRAW: DRAW$3,
	ERRORMESSAGES: ERRORMESSAGES$3,
	FEATURE_TABLE: FEATURE_TABLE$3,
	GEOLOCATION: GEOLOCATION$3,
	HISTORY: HISTORY$3,
	INFOCOMPONENT: INFOCOMPONENT$3,
	LAYERMANAGER: LAYERMANAGER$3,
	LAYERS: LAYERS$3,
	LEGEND: LEGEND$3,
	MAP: MAP$3,
	MEASURE: MEASURE$3,
	PANEL_HEADER: PANEL_HEADER$3,
	PERMALINK: PERMALINK$3,
	QUERY: QUERY$3,
	SAVECOMPOSITION: SAVECOMPOSITION$3,
	SENSORS: SENSORS$3,
	SIDEBAR: SIDEBAR$3,
	STYLER: STYLER$3,
	TOOLBAR: TOOLBAR$3,
	TRIP_PLANNER: TRIP_PLANNER$3
};

var ADDDATA$2 = {
	catalogue: "Data Catalogue",
	CATALOGUE: {
		addAs: "Add as",
		DESC: {
			WFS: "Web Feature Service: it adds the layer as a set of vector features. It is more power-consuming, especially with large layers, but it allows to edit features or to display individual feature info.",
			WMS: "Web Map Service: it adds the layer as a raster image. The transferred data is usually smaller so it generally loads faster. Yet it does not give you the access to the underlaying layer features."
		},
		filterType: "Search within",
		loading: "Loading data",
		queryDataTypes: {
			all: "All",
			dataset: "Datasets",
			service: "Services"
		},
		resourceType: "Resource type",
		searchFilterTypes: {
			Abstract: "Abstract",
			AnyText: "All",
			Title: "Title"
		},
		searchType: "Search filter type",
		selectFilterType: "Change search filter type",
		sortbyTypes: {
			bbox: "Extent",
			date: "Date",
			title: "Title"
		},
		showNext100: "Next 100",
		showAll: "All",
		showingSubset: "Currently showing {{limitShown}} of {{total}} services. Show"
	},
	file: "File",
	saveToDatabase: "Save to database",
	URL: {
		selectAll: "Select all Layers",
		submitLayerName: "Fill in layer name",
		submitLayerTitle: "Fill in layer title"
	}
};
var ADDLAYERS$2 = {
	addSelected: "Add selected layers to the map",
	Basemap: "Add as basemap",
	capabilitiesParsingProblem: "Capabilities parsing problem",
	chooseFormat: "Choose format",
	chooseType: "Choose type",
	considerUsingTiles: "Consider using tiles. Some servers has restricted max size of picture.",
	couldNotUploadSelectedFile: "There was a problem uploading the selected file!",
	ERROR: {
		errorWhileRequestingLayers: "Error while requesting layers",
		someErrorHappened: "Some error happened or input missing",
		thereWasErrorWhile: "There was error while parsing Capabilities response from given URL",
		urlInvalid: "Missing or invalid endpoint URL of requested layer!",
		srsNotSupported: "Selected Coordinate reference systems (CRS/SRS) is not supported. Please provide file in EPSG:3857 or EPSG:4326 to proceed."
	},
	externalDataSource: "External data source (URL)",
	featureCount: "Feature count",
	folderName: "Folder name",
	imageFormat: "Image format",
	loadingFeaturePleaseWait: "Loading features, please wait",
	mapAndLayerProjection: "Map and layer projection do not match! Resampling will be used. This may lead to unexpectable results.",
	mapProjectionAndLayerProjection: "Map projection and layer projection do not match. Add the layer to map and use server-side resampling program?",
	none: "None (at top)",
	queryFormat: "Query format",
	registerMetadata: "Register metadata",
	resampleLayer: "Resample layer",
	selectAllLayers: "Select All layers",
	serviceTypeNotMatching: "URL service type does not match selected category",
	SHP: {
		loginRequired: "User login is required before layer can be loaded",
		nameRequired: "'Name' field required to proceed!",
		shapeFile: "Shape file (shp+dbf+shx)",
		SLDStyleFile: "Style file"
	},
	srs: "SRS",
	thisIsRequired: "This is required!",
	tileSize: "Tile size",
	TYPES: {
		ArcGIS: "ArcGIS Map Server",
		shapeFile: "Shapefile",
		vectorFile: "Vector file (GeoJSON, KML)",
		WFS: "Web feature service (WFS)",
		WMS: "Web map service (WMS)"
	},
	under: "Add under layer",
	unknownDimesion: "This layer defines some dimension, which cannot be currently parsed",
	useProxy: "Use proxy",
	useTiles: "Use tiles",
	Vector: {
		addingFiles: "Adding {{featuresCount}} features into:",
		addSld: "Add SLD file",
		chooseFiles: "Choose files...",
		chooseLayer: "Please, choose a layer from list...",
		dragAndDropFiles: "Drag and drop files",
		note: "*Note: if you link a file with coordinates other than World Geodetic System (lon/lat), please set the SRS in the \"ADVANCED OPTIONS\"",
		uploadVectorFiles: "Upload vector files"
	},
	VECTOR: {
		extractStyles: "Extract styles"
	},
	WFS: {
		addToMap: "Add to map",
		loadingToManyAtOnce: "features. Loading too many at once (while zoomed out) may affect app performance",
		selectedLayerContains: "Selected layer contains"
	},
	WMTS: {
		tileMatrix: "Tile matrix"
	},
	unauthorizedAccess: "Unauthorized access. You are not authorized to query data from this service"
};
var COMMON$2 = {
	abstract: "Abstract",
	add: "Add",
	addAs: "Add as",
	advancedOptions: "Advanced options",
	all: "All",
	application: "Application",
	area: "Area",
	attribute: "Attribute",
	attributes: "Attributes",
	"Authentication failed. Login to the catalogue.": "Authentication failed. Login to the catalogue.",
	boundingBox: "Bounding box",
	cancel: "Cancel",
	category: "Category",
	circle: "Circle",
	clear: "Clear",
	close: "Close",
	closeDialog: "Close dialog",
	color: "Color",
	confirm: "Confirm",
	confirmDelete: "Confirm delete",
	connect: "Connect",
	contactInformation: "Contact Information",
	"continue": "Continue",
	data: "Data",
	dataset: "Dataset",
	date: "Date",
	"delete": "Delete",
	description: "Description",
	distance: "Distance",
	download: "Download",
	drawNewFeatures: "Draw new features",
	east: "East",
	extent: "Extent",
	fill: "Fill",
	fillInDescriptive: "Fill in descriptive text about map",
	fillInName: "Fill in name",
	filter: "Filter:",
	folder: "Folder",
	from: "From",
	fullText: "Full text",
	hide: "Hide",
	icon: "Icon",
	ignoreAndContinue: "Ignore and continue",
	info: "Additional information",
	keywords: "Keywords",
	layer: "Layer",
	layers: "Layers",
	legend: "Legend",
	less: "Less",
	line: "Line",
	lineColor: "Line color",
	lineWidth: "Line width",
	loading: "Loading",
	Login: "Log in",
	Logout: "Log out",
	mapExtentFilterMissing: "Please enable Filter by map extent checkbox to be able to sort data by Bounding box",
	menu: "Menu",
	metadata: "Metadata",
	more: "More",
	name: "Name",
	"new": "New",
	newDrawingLayer: "New drawing layer",
	next: "Next",
	no: "No",
	noDataReceived: "No data received!",
	north: "North",
	ok: "Ok",
	open: "Open",
	or: "or",
	orderBy: "Order by",
	photo: "Photo",
	point: "Point",
	polygon: "Polygon",
	print: "Print",
	projection: "Projection",
	radius: "Radius",
	reload: "Reload",
	removeLayer: "Remove layer",
	renameLayer: "Rename layer",
	reset: "Reset",
	results: "Results",
	rotation: "Rotation",
	save: "Save",
	saveAs: "Save as..",
	saveTo: "Save to",
	scale: "Scale",
	search: "Search:",
	service: "Service",
	settings: "Settings",
	share: "Share",
	showMore: "Show more",
	Sort: "Sort",
	sortBy: "Sort by",
	south: "South",
	stop: "Stop",
	stroke: "Stroke",
	strokeWidth: "Stroke width",
	style: "Style",
	theme: "Theme",
	thumbnail: "Thumbnail",
	title: "Title",
	to: "to",
	type: "Type",
	unknownError: "Unknown error. Please try again.",
	until: "Until",
	url: "URL",
	value: "Value",
	warning: "Warning",
	west: "West",
	width: "Width",
	wrongCombinationOfParams: "Wrong combination of parameters",
	yes: "Yes",
	zoomTo: "zoom to",
	into: " into",
	uploading: "Uploading data"
};
var COMPOSITIONS$2 = {
	addByAddress: "Add composition by address",
	Address: "Address",
	clearFilters: "Clear all filters",
	compostionsNameAttributeIsNotDefined: "Compositions name attribute is not defined!",
	dialogDelete: {
		doYouWantToDeleteMap: "Do you want to delete map?"
	},
	dialogInfo: {
		details: "details",
		metadata: {
			comparison_url: "Comparison URL",
			csw_url: "CSW URL",
			identifier: "Identifier",
			record_url: "Record URL"
		},
		metadataAboutMetadata: "Metadata about metadata"
	},
	dialogoverwriteConfirm: {
		mergeCompositions: "Merge compositions",
		overwriteExistingMap: "Overwrite existing map?",
		saveChangesFirst: "Save changes first",
		thereAreCurrentlyUnsavedChanges: "There are currently unsaved changes.",
		whatDoYouWant: "What do you want to do before opening the selected map composition?",
		youAreOpeningMap: "You are opening map"
	},
	dialogShare: {
		shareMap: "Share map"
	},
	dialogWarning: {
		outOfBounds: "Compostion extent is out of EPSG:4326 boundaries.",
		toContinue: "Map will not fit the given composition geometry or extent based on the given map size and borders."
	},
	endpointUrlIsNotDefined: "Endpoint url is not defined!",
	endpointUserIsNotDefined: "Endpoint user is not defined!",
	errorWhileLoadingCompositionMetadata: "Error while loading composition metadata",
	errorWhileRequestingCompositions: "Error while requesting compositions",
	errorWhileSharingOnSocialNetwork: "Error while sharing composition on social network",
	filterByMap: "Filter by map extent",
	"import": "Import composition from a file on device",
	inspireTheme: "INSPIRE theme",
	loginToCatalogue: "Login to catalogue",
	metadataNotAvailable: "Metadata are not available!",
	notAllowedToEditLayer: "You are not allowed to edit this composition",
	onlyMine: "Only mine",
	selectKeywords: "Select keywords",
	selectThemes: "Select themes",
	sharingUrlIsNotAvailable: "Sharing URL is not available!"
};
var COMPOSITONINSPIRETHEMES$2 = {
	Addresses: "Addresses",
	"Administrative units": "Administrative units",
	"Agricultural and aquaculture facilities": "Agricultural and aquaculture facilities",
	"Area management/restriction/regulation zones and reporting units": "Area management/restriction/regulation zones and reporting units",
	"Atmospheric conditions": "Atmospheric conditions",
	"Atmospheric Conditions and meteorological geographical features": "Atmospheric Conditions and meteorological geographical features",
	"Bio-geographical regions": "Bio-geographical regions",
	Buildings: "Buildings",
	"Cadastral parcels": "Cadastral parcels",
	"Coordinate reference systems": "Coordinate reference systems",
	Elevation: "Elevation",
	"Energy resources": "Energy resources",
	"Environmental monitoring facilities": "Environmental monitoring facilities",
	"Geographical grid systems": "Geographical grid systems",
	"Geographical names": "Geographical names",
	Geology: "Geology",
	"Habitants and biotopes": "Habitats and biotopes",
	"Human health and safety": "Human health and safety",
	Hydrography: "Hydrography",
	"Land cover": "Land cover",
	"Land use": "Land use",
	"Meteorological geographical features": "Meteorological geographical features",
	"Mineral resources": "Mineral resources",
	"Natural risk zones": "Natural risk zones",
	None: "None",
	"Oceanographic geographical features": "Oceanographic geographical features",
	Orthoimagery: "Orthoimagery",
	"Population distribution - demography": "Population distribution - demography",
	"Production and industrial facilities": "Production and industrial facilities",
	"Protected sites": "Protected sites",
	"Sea regions": "Sea regions",
	Soil: "Soil",
	"Species distribution": "Species distribution",
	"Statistical units": "Statistical units",
	"Transport networks": "Transport networks",
	"Utility and governmental services": "Utility and governmental services"
};
var COMPOSITONKEYWORDS$2 = {
	Basemap: "Basemap",
	Borders: "Borders",
	Cadastre: "Cadastre",
	"Complex information": "Complex information",
	Culture: "Culture",
	Demographics: "Demographics",
	Economics: "Economics",
	Environment: "Environment",
	Hazards: "Hazards",
	Infrastructure: "Infrastructure",
	"Land use": "Land use",
	"Physical geography": "Physical geography",
	Planning: "Planning",
	"Real estate": "Real estate",
	"Socio political conditions": "Socio political conditions",
	Transport: "Transport",
	Water: "Water"
};
var COMPOSITONSORTVALUES$2 = {
	Bbox: "Bounding box",
	"Date": "Date",
	None: "None",
	Title: "Title"
};
var COMPOSITONTYPES$2 = {
	Application: "Application",
	Datasource: "Data",
	"Feature catalogue": "Feature catalogue",
	None: "None",
	Service: "Service"
};
var DATASOURCE_SELECTOR$2 = {
	addToMapAs: "Add to map as",
	advancedMicka: {
		applicationType: "Application type",
		dateStamp: "Date stamp",
		extendedSearchParameters: "Extended search parameters for Micka",
		extentSimilarity: "Extent similarity",
		featureCatalogue: "Feature catalogue",
		organizationName: "Organization name",
		serviceType: "Service type",
		topicCategory: "Topic category"
	},
	datasourceListItem: {
		abortAdd: "Abort add",
		addToMap: "Add to map",
		notAllowedToEditLayer: "You are not allowed to edit this layer",
		whatDoesItMean: "What does it mean?"
	},
	externalData: "External data",
	layerRDF: "Layer RDF",
	metadataFor: "Metadata for",
	noResults: "No results",
	suggestions: "Suggestions"
};
var DRAW$2 = {
	activateDrawing: "Activate drawing by choosing a feature type",
	activeLayers: "Active layers",
	allowSnapping: "Allow snapping",
	boxSelection: "Box selection",
	boxSelectionActivated: "Box selection activated",
	definedStyle: "Defined style",
	deleteNote: "*Layer will be deleted completely. In case you want to delete layer from the current compositon only (preserving it in database) do so in 'Layermanager' panel.",
	deselectAllFeatures: "Deselect all features",
	disableDrawing: "Disable drawing",
	drawInfo: "While drawing polygon or line you can hold SHIFT to free-hand draw; You can delete last point with Backspace key",
	drawingTo: "Drawing to:",
	drawLayer: "Draw layer",
	drawLayerMetadata: {
		defaultAttributes: "Default attributes",
		defaultValue: "Default value",
		layerTitle: "Layer title",
		layerWillBeAdded: "*Layer will be added to the map and can be further managed in \"Layermanager\" panel",
		loadServerLayers: "Load layer from server",
		nameOfFolder: "Name of folder in layer-manager hierararchy"
	},
	drawToolbar: {
		addDrawLayer: "Add new draw layer",
		addLayer: "Add layer",
		finishFeature: "Finish feature",
		removeLastPoint: "Remove last point",
		selectType: "Geometry type"
	},
	fillOpacity: "Fill opacity:",
	loadingLayer: "Loading layer ",
	longerLoading: "Seems like loading takes longer than usual. Wait a moment please!\n",
	newGPS: "New GPS",
	noSuitableLayer: "No suitable layer available",
	notAuthorized: "User not authorized, drawings won´t be preserved",
	reallyDeleteThisLayer: "Really delete this layer?",
	saveDrawingToLayer: "Save drawing to layer",
	"Select layer": "Select layer",
	selectAllFeatures: "Select all features",
	serverLayers: "Server layers",
	snapTo: "Snap to features of layer",
	stylingMissing: "Proper styling missing",
	stylingMissingWarning: "{{type}} geometry can NOT be visualized. Create {{symbolizer}} symbolizer first. You can do so in {{panel}} panel.",
	unsavedDrawing: "Unsaved drawing",
	useModifierToSelectWithBox: "Use {{platformModifierKey}} and drag to select features with box"
};
var ERRORMESSAGES$2 = {
	"0": "Http failure response for {{url}}: 0 Unknown Error",
	"400": "Http failure response for {{url}}: 400 Bad Request",
	"403": "Http failure response for {{url}}: 403 Forbidden",
	"404": "Http failure response for {{url}}: 404 Not Found",
	"502": "Http failure response for {{url}}: 502 Bad Gateway",
	"Invalid Params": "Please check if all the required text fields are filled in before sharing the map!",
	"Timeout has occurred": "Http failure response for {{url}}: Timeout Out"
};
var FEATURE_TABLE$2 = {
	"delete": "delete",
	showFeatureStats: "Expand",
	sortFeaturesByValue: "Sort features by value",
	"zoom to": "zoom to"
};
var GEOLOCATION$2 = {
	altitude: "Altitude",
	follow: "Follow",
	locateMe: "Locate me",
	precision: "Precision",
	speed: "Speed"
};
var HISTORY$2 = {
	toggleDropdown: "Toggle dropdown"
};
var INFOCOMPONENT$2 = {
	newMap: "New map",
	unsavedMap: "Unsaved map",
	viewComposeAndAnalyse: "View, Compose and analyse spatial data",
	youHaveUnsavedChanges: "You have unsaved changes!"
};
var LAYERMANAGER$2 = {
	baselayers: "Baselayers",
	baseMapGallery: {
		grayscale: "Grayscale",
		noBaseMap: "No basemap"
	},
	dialogRemoveAll: {
		dialogMessage: "Do you really want to remove all your layers?",
		reloadComposition: "Reload composition",
		removeAllAdded: "Remove all added layers"
	},
	dialogRemoveLayer: {
		dialogMessage: "Do You really want to remove the selected layer?"
	},
	dimensions: "Dimensions",
	editorButtons: "Editor buttons",
	enablePhysicalLayerList: "Enable/Disable physical layer list",
	layerEditor: {
		cluster: "Cluster",
		copyright: "Copyright",
		layerFrom: "layer from",
		memory: "memory",
		metadataOfLayer: "Metadata of layer in",
		metadataOfService: "Metadata of service",
		opacity: "Opacity",
		savegeojson: "Download layer content as GeoJSON",
		styleLayer: "Style layer",
		vector: "Vector",
		"vector (GeoJSON)": "Vector (GeoJSON)",
		"vector (KML)": "Vector (KML)",
		"vector (TopoJSON)": "Vector (TopoJSON)",
		zoomToLayer: "Zoom to layer"
	},
	layerList: {
		layerIsQueryable: "This layer is queryable",
		layerNotAvailable: "This layer is not available",
		moveLayerDown: "Move layer down the list",
		moveLayerUp: "Move layer up the list",
		noAvailableInScale: "This layer is not available in this scale",
		sendingToLayman: "Sending to layman"
	},
	layermanagerMd: {
		aboutLayer: "About layer",
		changeLayerOpacity: "Change layer opacity",
		changeLineWidht: "Change line width",
		filterFeatures: "Filter features",
		imageLayer: "Image layer",
		innerRadius: "Inner radius",
		layerName: "Layer name",
		layerOpacity: "Layer Opacity",
		layerOptions: "Layer options",
		layerStyle: "Layer Style",
		layerVisibility: "Layer visibility",
		lineFeatures: "Line features",
		moveLayerDown: "Move layer down",
		moveLayerDownward: "Move layer downward, SHIFT-click to bottom",
		moveLayerUp: "Move layer up",
		moveLayerUpward: "Move layer upward, SHIFT-click to top",
		outerRadius: "Outer radius",
		pointFeatures: "Point features",
		polygonFeatures: "Polygon features",
		sidesNumber: "Sides number",
		star: "Star"
	},
	mapContent: "Map content",
	other: "Other",
	removeAllLayers: "Remove all layers",
	resetMap: "Reset map",
	terrains: "Terrains",
	time: {
		outOfRange: "Selected time is out of range",
		outOfRangeDescription: "This layer can show different data based on a selected time. The time can get \"out of range\" when it is synchronized with another layer but this layer has no data for that point in time. Click to pick a valid date and time. You can also disable the layer time synchronization.",
		syncTimes: "Synchronize times",
		syncTimesTooltip: "Synchronize time for all layers"
	},
	"User generated": "User generated"
};
var LAYERS$2 = {
	existingLayer: "Existing layer",
	newLayer: "New layer"
};
var LEGEND$2 = {
	noLegendExists: "No layer with legend exists!"
};
var MAP$2 = {
	zoomKeyModifier: "Use {{platformModifierKey}} + mouse-wheel to zoom the map",
	zoomToInitialWindow: "Zoom to initial window"
};
var MEASURE$2 = {
	measureMd: {
		deleteAllMeasurements: "Delete all measurements",
		measureType: "Measure type",
		saveMeasurementToLayer: "Save measurement to layer"
	},
	multipleShapes: "Multiple shapes"
};
var PANEL_HEADER$2 = {
	ADDLAYERS: "Add external data",
	APPLICATIONSETTINGS: "Application settings",
	COMPOSITIONS: "Compositions",
	DATASOURCE_SELECTOR: "Datasources",
	DRAW: "Draw",
	FEATURE_TABLE: "Feature table",
	FILTERFEATURES: "Filter features",
	INFO: "Info",
	LANGUAGE: "Change language",
	LEGEND: "Legend",
	LM: "Layermanager",
	MAPCOMPOSITIONS: "Map compositions",
	MEASURE: "Measurement",
	PERMALINK: "Share map",
	PRINT: "Print",
	ROUTING: "Routing",
	SAVECOMPOSITION: "Save current map",
	SEARCH: "Search",
	SENSORS: "Sensors",
	TRIP_PLANNER: "Trip planner"
};
var PERMALINK$2 = {
	directiveMd: {
		copyToClipboard: "Copy to clipboard"
	},
	embed: "embed",
	embedCode: "Embed code",
	linkFor: "Link for",
	newShare: "New share",
	permalink: "Permalink",
	pureMap: "Pure map",
	shareOnSocialNetwork: "Share on social network",
	sharePureMap: "Share pure map",
	sharesMapWith: "*Shares map with (all )portal functionality",
	sharesOnlyMap: "*Shares only map as picture",
	socialShare: "Social share"
};
var QUERY$2 = {
	clusterContaining: "Cluster containing {{count}} features",
	confirmClear: "Confirm clear",
	confirmDelete: "Confirm delete",
	coordinates: "Coordinates",
	deleteAllSelected: "Delete all selected features",
	downloadAs: "Download as",
	feature: {
		attributeName: "Attribute name",
		attributeValue: "Attribute value",
		copyFeature: "Copy feature",
		featurecopySucc: "Feature was successfully copied into layer: ",
		featureEdited: "Feature change successfull",
		featuremoveSucc: "Feature was successfully moved to layer: ",
		moveFeature: "Move feature",
		copyFeatures: "Copy features",
		moveFeatures: "Move features"
	},
	featureInfo: "Feature info",
	featurePopup: {
		clearLayer: "Clear layer",
		closePopup: "Close popup",
		removeClusterPart: "Remove cluster part",
		removeFeature: "Remove feature"
	},
	featuresSelected: "Features selected: ",
	infoPanel: {
		clickOnMap: "Click on map for query results"
	},
	reallyDelete: "Really delete this feature?",
	reallyDeleteAllFeaturesFrom: "Really delete all features from layer {0}?",
	reallyDeleteAllSelectedLayers: "Really delete all selected features?",
	untitledFeature: "Untitled feature"
};
var SAVECOMPOSITION$2 = {
	dialogResult: {
		compositionFailedToSave: "Composition failed to save",
		compositionSavedSuccessfully: "Composition saved successfully",
		requestWasProcessed: "Request was processed, but map was not saved due to authorization missing",
		savingCompositionStatus: "Saving composition status",
		serverDidNotRespond: "Server didn't respond or other error occurred"
	},
	dialogSave: {
		areYouAttempting: "You are attempting to save map changes to",
		noSaveAs: "No, save as",
		saveComposition: "Save composition",
		selectNewNameForMap: "Select new name for map",
		useDifferentName: "Use a different name to save the map",
		wantToOverwrite: "Do you really want to overwrite?",
		yesSave: "Yes, save",
		youDoNotHave: "You don't have sufficient rights to do so. Maybe the session has ended?"
	},
	form: {
		address: "Address",
		changeName: "Change name",
		city: "City",
		country: "Country",
		email: "Email",
		organization: "Organization",
		overwrite: "Overwrite",
		person: "Person",
		phone: "Phone",
		position: "Position",
		postalCode: "Postal code",
		read: "Read",
		state: "State",
		toggleAll: "Toggle all",
		userCurrentMapExtent: "Use current map extent",
		write: "Write"
	},
	panelMd: {
		fillKeywords: "Fill keywords",
		makePublic: "Make public",
		saveMap: "Save map",
		showThumbnail: "Show thumbnail",
		thumbnailSwitch: "Thumbnail switch",
		useMapExtent: "Use map extent",
		youAreNotAuthorized: "You are not authorized to store composition. Please sign in or contact administrator for your credentials."
	},
	"private": "Private",
	"public": "Public",
	readAccessRights: "Read access rights",
	removeLayerError: "Layer {{layer}} was not deleted from the database. {{error}}",
	saveOrOverwrite: "This compositon was created by another user",
	syncErrorDialog: {
		errorWhenSyncing: "Error when syncing"
	},
	writeAccessRights: "Write access rights"
};
var SENSORS$2 = {
	"1D": "1D",
	"1H": "1H",
	"1M": "1M",
	"1W": "1W",
	"6M": "6M",
	at: "at",
	avg: "Avg.",
	max: "Max",
	measure: "Measure",
	min: "Min",
	oneHour: "1 hour",
	phenomena: "Phenomena",
	sensors: "Sensors",
	sensorUnit: "Sensor unit"
};
var SIDEBAR$2 = {
	additionalPanels: "Additional panels",
	descriptions: {
		ADDLAYERS: "Select data or services for your map composition",
		APPLICATIONSETTINGS: "Specify application user settings",
		DRAW: "Draw new features",
		FEATURE_TABLE: "Display layer features in html table",
		FILTERFEATURES: "Crossfilter",
		INFO: "Display map-query result information",
		LANGUAGE: "Change language",
		LEGEND: "Legend",
		LM: "Manage and style your layers in composition",
		MAPCOMPOSITIONS: "List available map compositions",
		MEASURE: "Measure distance or area at map",
		PERMALINK: "Share map",
		PRINT: "Print map",
		SAVECOMPOSITION: "Save content of map to composition",
		SEARCH: "Search for location",
		TRIP_PLANNER: "Create new trip routes"
	}
};
var STYLER$2 = {
	addFilter: "Add filter",
	addRule: "Add rule",
	addSymbolizer: "Add symbolizer",
	anchor: "Anchor",
	anchorX: "Offset X",
	anchorY: "Offset Y",
	andFilter: "AND",
	blur: "Blur",
	cap: "Cap",
	clear: "Reset to default style",
	clusterRule: "Rule for clusters",
	color: "Color",
	comparisonFilter: "COMPARE",
	dashPattern: "Dash pattern",
	downloadSld: "Download style as SLD file",
	features: "Features",
	fillColor: "Fill color",
	fillOpacity: "Fill opacity",
	fillSymbolizer: "Fill symbolizer",
	unknownSymbolizer: "Unknown symbolizer",
	filtersAndScales: "Filters & scales",
	font: "Font",
	fontStyle: "Font style",
	fontWeight: "Font weight",
	gapWidth: "Gap width",
	graphicFill: "Graphic fill",
	graphicStroke: "Graphic stroke",
	haloColor: "Halo color",
	haloWidth: "Halo width",
	iconSymbolizer: "Icon symbolizer",
	join: "Join",
	justify: "Justify",
	kind: "Kind",
	layer: "Layer",
	level: "Level",
	lineSymbolizer: "Line symbolizer",
	manageStyle: "Manage style",
	markSymbolizer: "Mark symbolizer",
	maxScale: "Max. scale",
	minScale: "Min. scale",
	miterLimit: "Miter limit",
	name: "Name",
	notFilter: "NOT",
	offsetX: "Offset X",
	offsetY: "Offset Y",
	opacity: "Opacity",
	orFilter: "OR",
	outlineColor: "Outline color",
	outlineOpacity: "Outline opacity",
	outlineWidth: "Outline width",
	perpendicularOffset: "Perpendicular offset",
	radius: "Radius",
	removeFilter: "Remove filter",
	removeRule: "Remove rule",
	removeSymbolizer: "Remove symbolizer",
	rotation: "Rotation",
	roundLimit: "Round limit",
	rules: "Rules",
	selectIcon: "Select icon",
	selection: "Selection",
	simpleRule: "Simple rule",
	size: "Size",
	source: "URL",
	spacing: "Spacing",
	strokeColor: "Stroke color",
	strokeOpacity: "Stroke opacity",
	strokeWidth: "Stroke width",
	symbol: "Symbol",
	symbolizers: "Symbolizers",
	template: "Template",
	textColor: "Text color",
	textSize: "Text size",
	textSymbolizer: "Text symbolizer",
	toggleFilters: "Toggle filters",
	toggleScaleDenominators: "Toggle scale denominators",
	transform: "Transform",
	uploadSld: "Upload style as SLD file",
	warningAttribNotStoredNotVisualized: "Attribute currently not visualized correctly and not stored in SLD",
	warningAttribStoredNotVisualized: "Attribute stored in SLD, but currently is not visualized correctly",
	width: "Width",
	warningAttribNotStoredVisualized: "Attribute visualized, but not stored in SLD"
};
var TOOLBAR$2 = {
	measureLinesAndPolygon: "Measure lines and polygon"
};
var TRIP_PLANNER$2 = {
	clearWaypoints: "Clear waypoints",
	missingAuth: "Routing service not authorized",
	removeWaypoint: "Remove waypoint",
	routerLayer: "Route layer",
	serviceDown: "Navigation service seems to be down. We are sorry!",
	totalDistance: "Total distance",
	travelRoute: "Travel route",
	waypointDrawingHint: "Please click on map to add waypoints",
	waypointLayer: "Waypoint layer",
	waypoints: "Waypoints"
};
var en = {
	ADDDATA: ADDDATA$2,
	ADDLAYERS: ADDLAYERS$2,
	COMMON: COMMON$2,
	COMPOSITIONS: COMPOSITIONS$2,
	COMPOSITONINSPIRETHEMES: COMPOSITONINSPIRETHEMES$2,
	COMPOSITONKEYWORDS: COMPOSITONKEYWORDS$2,
	COMPOSITONSORTVALUES: COMPOSITONSORTVALUES$2,
	COMPOSITONTYPES: COMPOSITONTYPES$2,
	DATASOURCE_SELECTOR: DATASOURCE_SELECTOR$2,
	DRAW: DRAW$2,
	ERRORMESSAGES: ERRORMESSAGES$2,
	FEATURE_TABLE: FEATURE_TABLE$2,
	GEOLOCATION: GEOLOCATION$2,
	HISTORY: HISTORY$2,
	INFOCOMPONENT: INFOCOMPONENT$2,
	LAYERMANAGER: LAYERMANAGER$2,
	LAYERS: LAYERS$2,
	LEGEND: LEGEND$2,
	MAP: MAP$2,
	MEASURE: MEASURE$2,
	PANEL_HEADER: PANEL_HEADER$2,
	PERMALINK: PERMALINK$2,
	QUERY: QUERY$2,
	SAVECOMPOSITION: SAVECOMPOSITION$2,
	SENSORS: SENSORS$2,
	SIDEBAR: SIDEBAR$2,
	STYLER: STYLER$2,
	TOOLBAR: TOOLBAR$2,
	TRIP_PLANNER: TRIP_PLANNER$2
};

var ADDDATA$1 = {
	catalogue: "Datu katalogs",
	CATALOGUE: {
		addAs: "Pievienot kā",
		DESC: {
			WFS: "Web Feature Service - pievieno slāni kā vektoru grafisko objektu kopumu. Tas ir vairāk resursu patērējošs, it īpaši ar lieliem slāņiem, taču tas ļauj rediģēt objektus vai parādīt atsevišķu informāciju par objektiem",
			WMS: "Web Map Service - pievieno slāni kā rastra attēlu. Pārsūtītie dati parasti ir mazāki, tāpēc tie parasti tiek ielādēti ātrāk. Tomēr tas nedod Jums piekļuvi pamata slāņa funkcijām."
		},
		filterType: "Meklēt pēc",
		loading: "Notiek ielāde",
		queryDataTypes: {
			all: "Visi",
			dataset: "Datukopa",
			service: "Serviss"
		},
		resourceType: "Resursu tips",
		searchFilterTypes: {
			Abstract: "Apraksta",
			AnyText: "Visa teksta",
			Title: "Nosaukuma"
		},
		searchType: "Filtra tips",
		selectFilterType: "Nomainīt filtra tipu",
		sortbyTypes: {
			bbox: "Mērogojuma",
			date: "Datuma",
			title: "Nosaukuma"
		},
		showAll: "Visus",
		showNext100: "Nākošos 100",
		showingSubset: "Pašlaik rādu {{limitShown}} no {total}} servisiem. Rādīt"
	},
	file: "Fails",
	saveToDatabase: "Saglabāt datubāzē",
	URL: {
		selectAll: "Izvēlēties visus slāņus",
		submitLayerName: "Ievadiet slāņa nosaukumu",
		submitLayerTitle: "Ievadiet slāņa nosaukumu"
	}
};
var ADDLAYERS$1 = {
	addSelected: "Pievienot izvēlētos slāņus kartei",
	Basemap: "Pievienot kā pamatslāni",
	capabilitiesParsingProblem: "WMS Capabilities parsēšanas problēma",
	chooseFormat: "Izvēlieties formātu",
	chooseType: "Izvēlieties tipu",
	considerUsingTiles: "Apsveriet \"flīžu\" izmantošanu. Dažos serveros ir ierobežots maksimālais attēla lielums.",
	couldNotUploadSelectedFile: "Radās problēma mēģinot ielādēt Jūsu izvēlēto failu!",
	ERROR: {
		errorWhileRequestingLayers: "Radusies kļūda pieprasot slāņus",
		someErrorHappened: "Radās kļūda vai trūkst ievades",
		thereWasErrorWhile: "Parsējot (Capabilities) atbildi no norādītās hipersaites, radās kļūda",
		urlInvalid: "Nav pieejama vai ari nav derīga pieprasītā slāņa URL adrese!",
		srsNotSupported: "Atlasītās koordinātu atskaites sistēmas (CRS/SRS) netiek atbalstītas. Lai turpinātu, lūdzu, norādiet failu EPSG: 3857 vai EPSG: 4326 projekcijā."
	},
	externalDataSource: "Ārējais datu avots (hipersaite)",
	featureCount: "Grafisko objektu skaits",
	folderName: "Mapes nosaukums",
	imageFormat: "Attēla formāts",
	loadingFeaturePleaseWait: "Notiek grafisko objektu ielāde, lūdzu uzgaidiet!",
	mapAndLayerProjection: "Kartes un slāņa projekcija nesakrīt! Tiks izmantota atkārtota paraugu ņemšana. Tas var novest pie negaidītiem rezultātiem.",
	mapProjectionAndLayerProjection: "Kartes projekcija un slāņa projekcija nesakrīt. Pievienojiet slāni kartei un izmantojiet servera puses atkārtotas atlases programmu?",
	none: "Neviena (pievienot augšā)",
	queryFormat: "Vaicājuma formāts",
	registerMetadata: "Reģistrēt metadatus",
	resampleLayer: "Atkārtojiet slāņa atlasi",
	selectAllLayers: "Atlasīt visus slāņus",
	serviceTypeNotMatching: "URL servisa tips neatbilsts izvēlētajaai kategorijai",
	SHP: {
		loginRequired: "Pirms slāņa ielādes ir nepieciešama lietotāja autentifikācija",
		nameRequired: "Lai turpinātu, ir jānorāda lauks 'Nosaukums'!",
		shapeFile: "Ģeometrijas datne (shp+dbf+shx)",
		SLDStyleFile: "Stila datne"
	},
	srs: "Ģeodēziskā atskaites sistēma",
	thisIsRequired: "Šis ir nepieciešams!",
	tileSize: "\"Flīžu\" izmērs",
	TYPES: {
		ArcGIS: "ArcGIS karšu serveris",
		shapeFile: "Ģeometrijas datne (Shapefile)",
		vectorFile: "Vektoru datne (GeoJSON, KML)",
		WFS: "Tīmekļa grafisko objektu pakalpojums (WFS)",
		WMS: "Tīmekļa karšu pakalpojums (WMS)"
	},
	under: "Pievienot zem slāņa",
	unknownDimesion: "Šis slānis nosaka kādu dimensiju, kuru pašlaik nevar parsēt",
	useProxy: "Izmantojiet starpniekserveri",
	useTiles: "Izmantojiet \"flīzes\"",
	Vector: {
		addingFiles: "Pievienot {{featuresCount}} grafiskos objektus iekš",
		addSld: "Pievienot SLD failu",
		chooseFiles: "Izvēlieties failus...",
		chooseLayer: "Lūdzu, izvēlieties slāni no saraksta...",
		dragAndDropFiles: "Velciet un nometiet failus",
		note: "*Piezīme: ja pievienojat failu ar koordinātām, kas nav Pasaules ģeodēziskā sistēma (ģeo.garums / ģeo.platums), lūdzu, iestatiet to (SRS) sadaļā \"Papildu iespējas\"",
		uploadVectorFiles: "Augšuplādēt vektordatu failus"
	},
	VECTOR: {
		extractStyles: "Izvilkt stilus"
	},
	WFS: {
		addToMap: "Pievienot kartei",
		loadingToManyAtOnce: "grafiskie objekti. Pārāk daudzu objektu ielāde vienlaikus (kamēr karte ir tālināta) var ietekmēt lietotnes veiktspēju",
		selectedLayerContains: "Atlasītajā slānī ir"
	},
	WMTS: {
		tileMatrix: "\"Flīžu\" matrica"
	},
	unauthorizedAccess: "Neatļauta piekļuve. Jūs neesat pilnvarots pieprasīt datus no šī pakalpojuma"
};
var COMMON$1 = {
	abstract: "Apraksts",
	add: "Pievienot",
	addAs: "Pievienot kā",
	advancedOptions: "Advancētas opcijas",
	all: "visi",
	application: "Lietotne",
	area: "Platība",
	attribute: "Atribūts",
	attributes: "Atribūts",
	"Authentication failed. Login to the catalogue.": "Neveiksmīga autentifikācija. Pieslēdzieties katalogam.",
	boundingBox: "Robežu taisnstūris",
	cancel: "Atcelt",
	category: "Kategorija",
	circle: "Aplis",
	clear: "Notīrīt",
	close: "Aizvērt",
	closeDialog: "Aizvērt logu",
	color: "Krāsa",
	confirm: "Apstiprināt",
	confirmDelete: "Aptipriniet dzēšanu",
	connect: "Izveidot savienojumu",
	contactInformation: "Kontaktinformācija",
	"continue": "turpināt",
	data: "Dati",
	dataset: "Datu kopa",
	date: "Datums",
	"delete": "Dzēst",
	description: "Apraksts",
	distance: "Distance",
	download: "Lejuplādēt",
	drawNewFeatures: "Zīmēt jaunus objektus",
	east: "Austrumi",
	extent: "Apjoms",
	fill: "Aizpildījums",
	fillInDescriptive: "Aizpildiet aprakstošu tekstu par karti",
	fillInName: "Norādiet nosaukumu",
	filter: "Filtrs:",
	folder: "Datne",
	from: "No",
	fullText: "Full text",
	hide: "Paslēpt",
	icon: "Ikona",
	ignoreAndContinue: "Ignorēt un turpināt",
	info: "Papildu informācija",
	keywords: "Atslēgvārdi",
	layer: "Slānis",
	layers: "Slāņi",
	legend: "Leģenda",
	less: "Mazāk",
	line: "Līnija",
	lineColor: "Līnijas krāsa",
	lineWidth: "Līnijas platums",
	loading: "Notiek ielāde",
	Login: "Autorizēties",
	Logout: "Atteikties",
	mapExtentFilterMissing: "Lūdzu, iespējojiet izvēles rūtiņu Filtrēt pēc kartes apjoma, lai varētu kārtot datus pēc mērogojuma (Bounding box)",
	menu: "Izvēlne",
	metadata: "Metadati",
	more: "Vairāk",
	name: "Nosaukums",
	"new": "Jauna/s",
	newDrawingLayer: "Jauns zīmēšanas slānis",
	next: "Nākamais",
	no: "No",
	noDataReceived: "Dati nav saņemti!",
	north: "Ziemeļi",
	ok: "Labi",
	open: "Atvērt",
	or: "vai",
	orderBy: "Kārtot pēc",
	photo: "Bilde",
	point: "Punkts",
	polygon: "Daudzstūris",
	print: "Printēt",
	projection: "Projekcija",
	radius: "Rādiuss",
	reload: "Pārlādēt",
	removeLayer: "Noņemt slāni",
	renameLayer: "Pārsaukt slāni",
	reset: "Atiestatīt",
	results: "Rezultāti",
	rotation: "Rotācija",
	save: "Saglabāt",
	saveAs: "Saglabāt kā..",
	saveTo: "Saglabāt",
	scale: "Mērogs",
	search: "Meklēt:",
	service: "Service",
	settings: "Uzstādījumi",
	share: "Kopīgot",
	showMore: "Rādīt vairāk",
	Sort: "Kārtot",
	sortBy: "Kārtot pēc",
	south: "Dienvidi",
	stop: "Apturēt",
	stroke: "Līnija",
	strokeWidth: "Līnjas platums",
	style: "Stils",
	theme: "tēma",
	thumbnail: "Sīktēls",
	title: "Virsraksts",
	to: "līdz",
	type: "Tips",
	unknownError: "Nezināma kļūda. Lūdzu mēģiniet vēlreiz.",
	until: "Līdz",
	url: "URL",
	value: "Vērtība",
	warning: "Brīdinājums",
	west: "Rietumi",
	width: "Platums",
	wrongCombinationOfParams: "Nepareiza parametru kombinācija",
	yes: "Jā",
	zoomTo: "pietuvināt",
	into: "iekš",
	uploading: "Augšupielādē datus"
};
var COMPOSITIONS$1 = {
	addByAddress: "Pievienot kompozīciju pēc adreses",
	Address: "Adrese",
	clearFilters: "Notīrīt filtrus",
	compostionsNameAttributeIsNotDefined: "Kompozīcijas nosaukums nav definēts!",
	dialogDelete: {
		doYouWantToDeleteMap: "Vai vēlaties dzēst karti?"
	},
	dialogInfo: {
		details: "detaļas",
		metadata: {
			comparison_url: "Salīdzinājuma saite",
			csw_url: "CSW saite",
			identifier: "Identifikators",
			record_url: "Ieraksta saite"
		},
		metadataAboutMetadata: "Metadati par metadatiem"
	},
	dialogoverwriteConfirm: {
		mergeCompositions: "Apvienot kompozīcijas",
		overwriteExistingMap: "Pārrakstīt esošo karti?",
		saveChangesFirst: "Vispirms saglabājiet izmaiņas",
		thereAreCurrentlyUnsavedChanges: "Pašlaik ir nesaglabātas izmaiņas.",
		whatDoYouWant: "Ko Jūs vēlaties izdarīt pirms atlasītās kartes kompozīcijas atvēršanas?",
		youAreOpeningMap: "Jūs atverat karti"
	},
	dialogShare: {
		shareMap: "Koplietot karti"
	},
	dialogWarning: {
		outOfBounds: "Kompozīcijas apjoms ir ārpus EPSG:4326 robežām.",
		toContinue: "Norādītā kompozīcijas ģeometrija vai tās apjoms var netikt iekļauts dotajā kartē un tās robežās."
	},
	endpointUrlIsNotDefined: "Saites galapunkts nav definēts!",
	endpointUserIsNotDefined: "Galapunkta lietotājs nav definēts!",
	errorWhileLoadingCompositionMetadata: "Radusies kļūda ielādējot kompozīcijas metadatus",
	errorWhileRequestingCompositions: "Radusies kļūda pieprasot kompozīcijas",
	errorWhileSharingOnSocialNetwork: "Radusies kļūda koplietojot kompozīciju sociālajos tīklos",
	filterByMap: "Filtrēt pēc kartes",
	"import": "Importēt kompozīciju no faila vai ierīces",
	inspireTheme: "INSPIRE tēma",
	loginToCatalogue: "Pieslēgties katalogam",
	metadataNotAvailable: "Metadati nav pieejami!",
	notAllowedToEditLayer: "Jums nav rediģēšanas tiesību, lai labotu šo slāni",
	onlyMine: "Tikai manas",
	selectKeywords: "Izvēlēties atslēgvārdus",
	selectThemes: "Izvēlēties tēmas",
	sharingUrlIsNotAvailable: "Kopīgošanas saite nav pieejama!"
};
var COMPOSITONINSPIRETHEMES$1 = {
	Addresses: "Adreses",
	"Administrative units": "Administratīvās vienības",
	"Agricultural and aquaculture facilities": "Lauksaimniecības un akvakultūras objekti",
	"Area management/restriction/regulation zones and reporting units": "Teritorijas pārvaldības/ierobežošanas/regulēšanas zonas un ziņošanas vienības",
	"Atmospheric conditions": "Atmosfēras apstākļi",
	"Atmospheric Conditions and meteorological geographical features": "Atmosfēras apstākļi un meteoroloģiskās, ģeogrāfiskās pazīmes",
	"Bio-geographical regions": "Bioģeogrāfiskie reģioni",
	Buildings: "Ēkas",
	"Cadastral parcels": "Kadastra pakas",
	"Coordinate reference systems": "Koordinātu atskaites sistēmas",
	Elevation: "Paaugstinājums",
	"Energy resources": "Enerģijas resursi",
	"Environmental monitoring facilities": "Vides monitoringa objekti",
	"Geographical grid systems": "Ģeogrāfiskās režģu sistēmas",
	"Geographical names": "Ģeogrāfiskie nosaukumi",
	Geology: "Ģeoloģija",
	"Habitants and biotopes": "Iedzīvotāji un biotopi",
	"Human health and safety": "Cilvēku veselība un drošība",
	Hydrography: "Hidrogrāfija",
	"Land cover": "Zemes segums",
	"Land use": "Zemes izmantošana",
	"Meteorological geographical features": "Meteoroloģiskās, ģeogrāfiskās pazīmes",
	"Mineral resources": "Minerālie resursi",
	"Natural risk zones": "Dabas riska zonas",
	None: "Neviens",
	"Oceanographic geographical features": "Okeanogrāfiskās, ģeogrāfiskās iezīmes",
	Orthoimagery: "Ortofotogrāfija",
	"Population distribution - demography": "Iedzīvotāju sadalījums - demogrāfija",
	"Production and industrial facilities": "Ražošanas un rūpniecības objekti",
	"Protected sites": "Aizsargājamās vietas",
	"Sea regions": "Jūras reģioni",
	Soil: "Augsne",
	"Species distribution": "Sugu izplatība",
	"Statistical units": "Statistikas vienības",
	"Transport networks": "Transporta tīkli",
	"Utility and governmental services": "Komunālie un valsts dienesti"
};
var COMPOSITONKEYWORDS$1 = {
	Basemap: "Pamatkarte",
	Borders: "Robežas",
	Cadastre: "Kadastrs",
	"Complex information": "Sarežģīta informācija",
	Culture: "Kultūra",
	Demographics: "Demogrāfiskie dati",
	Economics: "Ekonomika",
	Environment: "Vide",
	Hazards: "Apdraudējumi",
	Infrastructure: "Infrastruktūra",
	"Land use": "Zemes izmantošana",
	"Physical geography": "Fiziskā geogrāfija",
	Planning: "Plānošana",
	"Real estate": "Nekustamais īpašums",
	"Socio political conditions": "Sociāli politiskie apstākļi",
	Transport: "Transports",
	Water: "Ūdens"
};
var COMPOSITONSORTVALUES$1 = {
	Bbox: "Mērogojuma",
	"Date": "Datuma",
	None: "Neviena",
	Title: "Nosaukuma"
};
var COMPOSITONTYPES$1 = {
	Application: "Lietotne",
	Datasource: "Datu avots",
	"Feature catalogue": "Funkciju katalogs",
	None: "Neviens",
	Service: "Serviss"
};
var DATASOURCE_SELECTOR$1 = {
	addToMapAs: "Pievienot kartē kā",
	advancedMicka: {
		applicationType: "Lietotnes tips",
		dateStamp: "Datuma zīmogs",
		extendedSearchParameters: "Paplašināti Micka meklēšanas parametri",
		extentSimilarity: "Apjoma līdzība",
		featureCatalogue: "Grafisko objektu katalogs",
		organizationName: "Organizācijas nosaukums",
		serviceType: "Servisa tips",
		topicCategory: "Tēmas kategorija"
	},
	datasourceListItem: {
		abortAdd: "Atcelt pievienošanu",
		addToMap: "Pievienot kartei",
		notAllowedToEditLayer: "Jums nav rediģēšanas tiesību, lai labotu šo slāni",
		whatDoesItMean: "Ko tas nozīmē?"
	},
	externalData: "Ārējie resursi",
	layerRDF: "Slāņa RDF",
	metadataFor: "Metadati priekš",
	noResults: "Nav rezultātu",
	suggestions: "Ieteikumi"
};
var DRAW$1 = {
	activateDrawing: "Aktivizējiet zīmēšanu, izvēloties objekta tipu",
	activeLayers: "Aktīvie slāņi",
	allowSnapping: "Atļaut pieķeršanos",
	boxSelection: "Iezīmēšana ar lodziņu",
	boxSelectionActivated: "Iezīmēšana ar lodziņu aktivizēta",
	definedStyle: "Definētais stils",
	deleteNote: "*Slānis tiks neatgriezeniski izdzēsts. Gadījuma, ja vēlaties izdzēst slāni tikai no pašreizējās kompozīcijas (saglabājot to datubāzē), dariet to 'Slāņu pārvaldība' panelī.",
	deselectAllFeatures: "Atcelt visu grafisko objektu atzīmi",
	disableDrawing: "Atspējot zīmēšanu",
	drawInfo: "Zīmējot daudzstūri vai līniju, Jūs varat turēt taustiņu SHIFT, lai zīmētu brīvroku režīmā; Pēdējo punktu var izdzēst ar Backspace taustiņu",
	drawingTo: "Zīmējums uz:",
	drawLayer: "Zīmēt slāni",
	drawLayerMetadata: {
		defaultAttributes: "Noklusējuma atribūti",
		defaultValue: "Noklusējuma vērtības",
		layerTitle: "Slāņa virsraksts",
		layerWillBeAdded: "*Slānis tiks pievienots kartei, un to varēs turpmāk pārvaldīt \"Slāņu pārvaldība\" panelī",
		loadServerLayers: "Ielādēt slāni no servera",
		nameOfFolder: "Mapes nosaukums slāņu pārvaldnieka hierarhijā"
	},
	drawToolbar: {
		addDrawLayer: "Pievienot jaunu slāni",
		addLayer: "Pievienot slāni",
		finishFeature: "Pabeigt objektu",
		removeLastPoint: "Noņemt pēdējo punktu",
		selectType: "Izvēlieties tipu"
	},
	fillOpacity: "Aizpildījuma necaurredzamība:",
	loadingLayer: "Notiek slāņa ielāde",
	longerLoading: "Izskatās, ka slāņa ielāde notiek ilgāk nekā ierasts. Lūdzu uzgaidiet!",
	newGPS: "Jauns GPS",
	noSuitableLayer: "Nav pieejams piemērots slānis",
	notAuthorized: "Lietotājs nav autorizējies, pievienotie zīmējumi netiks saglabāti!",
	reallyDeleteThisLayer: "Vai tiešām vēlaties izdzēst šo slāni?",
	saveDrawingToLayer: "Saglabāt zīmēšanas slāni",
	"Select layer": "Izvēlieties slāni",
	selectAllFeatures: "Atlasīt visus grafiskos objektus",
	serverLayers: "Servera slāņi",
	snapTo: "Pieķerties slāņa grafiskajam objektam",
	stylingMissing: "Trūkst pareizais stils",
	stylingMissingWarning: "\n{{type}} ģeometriju NAV iespējams vizualizēt. Vispirms izveidojiet {{symbolizer}} simbolizētāju. To var izdarīt panelī {{panel}}.",
	unsavedDrawing: "Nesaglabāts zīmējums",
	useModifierToSelectWithBox: "Izmantojiet {{platformModifierKey}} un velciet, lai atlasītu grafiskos objektus ar lodziņu"
};
var ERRORMESSAGES$1 = {
	"0": "Http pieprasījuma kļūda uz {{url}}: 0 Nezināma kļūda",
	"400": "Http pieprasījuma kļūda uz {{url}}: 400 Neizdevies pieprasījums",
	"403": "Http pieprasījuma kļūda uz {{url}}: 403 Aizliegta darbība",
	"404": "Http pieprasījuma kļūda uz {{url}}: 404 Serveris nevarēja atrast pieprasītos datus",
	"502": "Http pieprasījuma kļūda uz {{url}}: 502 Nederīga vārteja",
	"Invalid Params": "Lūdzu, pārbaudiet, vai ir aizpildīti visi nepieciešamie teksta lauki pirms kartes koplietošanas!",
	"Timeout has occurred": "Http pieprasījuma kļūda uz {{url}}: Iestājās pieprasījuma noilgums"
};
var FEATURE_TABLE$1 = {
	"delete": "dzēst",
	showFeatureStats: "Izvērst",
	sortFeaturesByValue: "Kārtot pēc objektu vērtības",
	"zoom to": "Pietuvināt"
};
var GEOLOCATION$1 = {
	altitude: "Augstums",
	follow: "Sekot",
	locateMe: "Mana atrašanās vieta",
	precision: "Precizitāte",
	speed: "Ātrums"
};
var HISTORY$1 = {
	toggleDropdown: "Pārslēgt nolaižamo izvēlni"
};
var INFOCOMPONENT$1 = {
	newMap: "Jauna karte",
	unsavedMap: "Nesaglabāta karte",
	viewComposeAndAnalyse: "Skatiet, sastādiet un analizējiet telpiskos datus",
	youHaveUnsavedChanges: "Jums ir nesaglabātas izmaiņas"
};
var LAYERMANAGER$1 = {
	baselayers: "Pamatslāņi",
	baseMapGallery: {
		grayscale: "Pelēktoņu",
		noBaseMap: "Nav pamatkartes"
	},
	dialogRemoveAll: {
		dialogMessage: "Vai Jūs tiešām vēlaties noņemt visus slāņus?",
		reloadComposition: "Pārlādēt kompozīciju",
		removeAllAdded: "Noņemt visus pievienotos slāņus"
	},
	dialogRemoveLayer: {
		dialogMessage: "Vai Jūs tiešām vēlaties noņemt atlasīto slāni?"
	},
	dimensions: "Dimensijas",
	editorButtons: "Redaktora pogas",
	enablePhysicalLayerList: "Ieslēgt/Izslēgt slāņu secības sarakstu",
	layerEditor: {
		cluster: "Apvienot blakusesošos",
		copyright: "Autortiesības",
		layerFrom: "slānis no",
		memory: "atmiņas",
		metadataOfLayer: "Slāņa metadati iekš",
		metadataOfService: "Servisa metadati",
		opacity: "Necaurredzamība",
		savegeojson: "Lejupielādējiet slāņa saturu kā GeoJSON",
		styleLayer: "Stilizēt slāni",
		vector: "Vektoru",
		"vector (GeoJSON)": "Vektoru (GeoJSON)",
		"vector (KML)": "Vektoru (KML)",
		"vector (TopoJSON)": "Vektoru (TopoJSON)",
		zoomToLayer: "Tuvināt līdz slānim"
	},
	layerList: {
		layerIsQueryable: "Šis slānis ir vaicājams",
		layerNotAvailable: "Šis slānis nav pieejams",
		moveLayerDown: "Pārvietot slāni uz leju",
		moveLayerUp: "Pārvietot slāni uz augšu",
		noAvailableInScale: "Šis slānis šajā mērogā nav pieejams",
		sendingToLayman: "Sūta uz layman"
	},
	layermanagerMd: {
		aboutLayer: "Par slāni",
		changeLayerOpacity: "Mainīt slāņa necaurredzamību",
		changeLineWidht: "Mainīt līnijas platumu",
		filterFeatures: "Filtrēt objektus",
		imageLayer: "Attēla slānis",
		innerRadius: "Iekšējais rādiuss",
		layerName: "Slāņa nosaukums",
		layerOpacity: "Slāņa necaurredzamība",
		layerOptions: "Slāņa opcijas",
		layerStyle: "Slāņa stils",
		layerVisibility: "Slāņa redzamība",
		lineFeatures: "Līnijas objekts",
		moveLayerDown: "Pārvietot slāni uz leju",
		moveLayerDownward: "Pārvietojiet slāni uz leju, SHIFT-peles klikšķis uz leju",
		moveLayerUp: "Pārvietot slāni uz augšu",
		moveLayerUpward: "Pārvietojiet slāni uz augšu, SHIFT-peles klikšķis uz augšu",
		outerRadius: "Ārējais rādiuss",
		pointFeatures: "Punkta objekts",
		polygonFeatures: "Daudzstūra objekts",
		sidesNumber: "Sānu numurs",
		star: "Zvaigzne"
	},
	mapContent: "Kartes saturs",
	other: "Cits",
	removeAllLayers: "Noņemt visus slāņus",
	resetMap: "Atiestatīt karti",
	terrains: "Reljefi",
	time: {
		outOfRange: "Atlasītais laiks ir ārpus diapazona",
		outOfRangeDescription: "Šis slānis var parādīt dažādus datus, pamatojoties uz izvēlēto laiku. Laiks var nonākt \"ārpus diapazona\", ja tas tiek sinhronizēts ar citu slāni, taču šim slānim nav datu par šo laika periodu. Noklikšķiniet, lai izvēlētos derīgu datumu un laiku. Varat arī atspējot slāņa laika sinhronizāciju.",
		syncTimes: "Sinhronizēt laikus",
		syncTimesTooltip: "Sinhronizēt laiku visiem slāņiem"
	},
	"User generated": "Lietotāja ģenerēti"
};
var LAYERS$1 = {
	existingLayer: "Eksistējošs slānis",
	newLayer: "Jauns slānis"
};
var LEGEND$1 = {
	noLegendExists: "Nav neviena slāņa ar leģendu!"
};
var MAP$1 = {
	zoomKeyModifier: "Lietojiet {{platformModifierKey}} + peles rullīti, lai pietuvinātu karti",
	zoomToInitialWindow: "Pietuvināt sākotnējo logu"
};
var MEASURE$1 = {
	measureMd: {
		deleteAllMeasurements: "Dzēst visus mērījumus",
		measureType: "Mērījuma tips",
		saveMeasurementToLayer: "Saglabāt mērījumu slānī"
	},
	multipleShapes: "Vairākas formas"
};
var PANEL_HEADER$1 = {
	ADDLAYERS: "Pievienot ārējos datus",
	APPLICATIONSETTINGS: "Lietojumprogrammas iestatījumi",
	COMPOSITIONS: "Kompozīcijas",
	DATASOURCE_SELECTOR: "Datu avoti",
	DRAW: "Zīmēt",
	FEATURE_TABLE: "Grafisko objektu tabula",
	FILTERFEATURES: "Filtrēt objektus",
	INFO: "Informācija",
	LANGUAGE: "Nomainīt valodu",
	LEGEND: "Leģenda",
	LM: "Slāņu pārvaldība",
	MAPCOMPOSITIONS: "Kartes kompozīcijas",
	MEASURE: "Mērījumi",
	PERMALINK: "Kopīgot karti",
	PRINT: "Printēt",
	ROUTING: "Maršrutēšana",
	SAVECOMPOSITION: "Saglabāt pašreizējo karti",
	SEARCH: "Meklēt",
	SENSORS: "Sensori",
	TRIP_PLANNER: "Maršruta plānotājs"
};
var PERMALINK$1 = {
	directiveMd: {
		copyToClipboard: "Kopēt starpliktuvē"
	},
	embed: "Fiksētās",
	embedCode: "Fiksēt kodu",
	linkFor: "Saite priekš",
	newShare: "Jauna kopīgošana",
	permalink: "Pastāvīgā saite",
	pureMap: "Tikai karte",
	shareOnSocialNetwork: "Kopīgot sociālajā tīklā",
	sharePureMap: "Kopīgot tikai karti",
	sharesMapWith: "*Kopīgot karti ar (visa) portāla funkcionalitāti",
	sharesOnlyMap: "*Kopīgot tikai karti kā attēlu",
	socialShare: "Sociālās kopīgošanas"
};
var QUERY$1 = {
	clusterContaining: "Objektu apvienojums, kas satur {{count}} objektus",
	confirmClear: "Apstiprināt notīrīšanu",
	confirmDelete: "Apstiprināt dzēšanu",
	coordinates: "Koordinātes",
	deleteAllSelected: "Dzēst visus atlasītos grafiskos objektus",
	downloadAs: "Lejupielādēt kā",
	feature: {
		attributeName: "Atribūtu nosaukums",
		attributeValue: "Atribūta vērtība",
		copyFeature: "Kopēt grafiskos objektus",
		featurecopySucc: "Grafiskais objekts tika veiksmīgi nokopēts slānī:",
		featureEdited: "Grafiskā objekta rediģēšana veiksmīga",
		featuremoveSucc: "Grafiskais objekts tika veiksmīgi pārvietots uz slāni:",
		moveFeature: "Pārvietot grafisko objektu",
		copyFeatures: "Kopēt grafiskos objektus",
		moveFeatures: "Pārvietot grafiskos objektus"
	},
	featureInfo: "Objektu informācija",
	featurePopup: {
		clearLayer: "Notīrīt slāni",
		closePopup: "Aizvērt uznirstošo logu",
		removeClusterPart: "Noņemt blakusesošo objektu apvienošanu",
		removeFeature: "Noņemt objektu"
	},
	featuresSelected: "Atlasītie grafiskie objekti: ",
	infoPanel: {
		clickOnMap: "Noklikšķiniet uz kartes, lai iegūtu vaicājuma rezultātus"
	},
	reallyDelete: "Vai tiešām vēlaties dzēst šo objektu?",
	reallyDeleteAllFeaturesFrom: "Vai tiešām vēlaties izdzēst visus objektus no slāņa {0}?",
	reallyDeleteAllSelectedLayers: "Vai tiešām dzēst visus atlasītos grafiskos objektus?",
	untitledFeature: "Objekts bez nosaukuma"
};
var SAVECOMPOSITION$1 = {
	dialogResult: {
		compositionFailedToSave: "Kompozīciju neizdevās saglabāt",
		compositionSavedSuccessfully: "Kompozīcija veiksmīgi saglabāta",
		requestWasProcessed: "Pieprasījums tika apstrādāts, taču karte netika saglabāta, jo trūka autorizācijas",
		savingCompositionStatus: "Saglabā kompozīcijas statusu",
		serverDidNotRespond: "Serveris neatbildēja vai radās cita kļūda"
	},
	dialogSave: {
		areYouAttempting: "Jūs mēģināt saglabāt kartes izmaiņas mapē",
		noSaveAs: "Nē, saglabāt kā",
		saveComposition: "Save composition",
		selectNewNameForMap: "Atlasiet jaunu kartes nosaukumu",
		useDifferentName: "Kartes saglabāšanai izmantojiet citu nosaukumu",
		wantToOverwrite: "Vai tiešām vēlaties pārrakstīt?",
		yesSave: "Jā, saglabāt",
		youDoNotHave: "Jums nav pietiekamu tiesību to darīt. Varbūt sesija ir beigusies?"
	},
	form: {
		address: "Adrese",
		changeName: "Mainīt nosaukumu",
		city: "Pilsēta",
		country: "Valsts",
		email: "E-pasts",
		organization: "Organizācija",
		overwrite: "Pārrakstīt",
		person: "Persona",
		phone: "Telefona numurs",
		position: "Pozīcija",
		postalCode: "Pasta indekss",
		read: "Lasīt",
		state: "Novads",
		toggleAll: "Pārslēgt visu",
		userCurrentMapExtent: "Izmantot pašreizējo kartes apmēru",
		write: "Rakstīt"
	},
	panelMd: {
		fillKeywords: "Ievadiet atslēgvārdus",
		makePublic: "Publiskot",
		saveMap: "Saglabāt karti",
		showThumbnail: "Rādīt sīktēlu",
		thumbnailSwitch: "Sīktēlu slēdzis",
		useMapExtent: "Izmantot kartes apmēru",
		youAreNotAuthorized: "Jums nav atļauts saglabāt kompozīciju. Lūdzu, pierakstieties vai sazinieties ar administratoru, lai iegūtu Jūsu akreditācijas datus."
	},
	"private": "Privāts",
	"public": "Publisks",
	readAccessRights: "Lasīšanas piekļuves tiesības",
	removeLayerError: "Slānis {{layer}} netika izdzēsts no datubāzes. {{error}}",
	saveOrOverwrite: "Šo kompozīciju izveidoja cits lietotājs",
	syncErrorDialog: {
		errorWhenSyncing: "Sinhronizējot radās kļūda"
	},
	writeAccessRights: "Rakstīšanas piekļuves tiesības"
};
var SENSORS$1 = {
	"1D": "1d",
	"1H": "1st",
	"1M": "1m",
	"1W": "1ned",
	"6M": "6m",
	at: "pie",
	avg: "Vid.",
	max: "Maks.",
	measure: "mēra",
	min: "Min",
	oneHour: "1 stunda",
	phenomena: "Parādība",
	sensors: "Sensori",
	sensorUnit: "Sensoru vienība"
};
var SIDEBAR$1 = {
	additionalPanels: "Papildu paneļi",
	descriptions: {
		ADDLAYERS: "Atlasīt kartes sastāva datus vai pakalpojumus",
		APPLICATIONSETTINGS: "Norādīt lietojumprogrammas lietotāja iestatījumus",
		DRAW: "Zīmēt jaunus objektus",
		FEATURE_TABLE: "Parādīt slāņa objektus tabulā",
		FILTERFEATURES: "Šķērsfiltrs",
		INFO: "Parādīt kartes vaicājuma rezultātu informāciju",
		LANGUAGE: "Nomainīt valodu",
		LEGEND: "Leģenda",
		LM: "Pārvaldīt un noformēt slāņus kompozīcijā",
		MAPCOMPOSITIONS: "Uzskaitīt pieejamās karšu kompozīcijas",
		MEASURE: "Izmērīt attālumu vai platību kartē",
		PERMALINK: "Kopīgot karti",
		PRINT: "Printēt karti",
		SAVECOMPOSITION: "Saglabāt kartes saturu kompozīcijā",
		SEARCH: "Meklēt atrašanās vietu",
		TRIP_PLANNER: "Izveidojiet jaunus ceļojuma maršrutus"
	}
};
var STYLER$1 = {
	addFilter: "Pievienot filtru",
	addRule: "Pievienot noteikumu",
	addSymbolizer: "Pievienot simbolizētāju",
	anchor: "Enkurot",
	anchorX: "X nobīde",
	anchorY: "Y nobīde",
	andFilter: "AND",
	blur: "Aizpludināt",
	cap: "Limits",
	clear: "Atiestatīt uz noklusēto stilu",
	clusterRule: "Noteikums kopām",
	color: "Krāsa",
	comparisonFilter: "SALĪDZINĀT",
	dashPattern: "Domuzīmes paterns",
	downloadSld: "Lejuplādēt stilu kā SLD failu",
	features: "Objekti",
	fillColor: "Aizpildīt krāsu",
	fillOpacity: "Aizpildīt necaurredzamību",
	fillSymbolizer: "Aizpildīt simbolētāju",
	filtersAndScales: "Filtri un mērogi",
	font: "Fonts",
	fontStyle: "Fonta stils",
	fontWeight: "Fonta izcēlums",
	gapWidth: "Atstarpes platums",
	graphicFill: "Grafiskais aizpildījums",
	graphicStroke: "Grafiskā līnija",
	haloColor: "Oreola krāsa",
	haloWidth: "Oreola platums",
	iconSymbolizer: "Ikonu simbolētājs",
	join: "Pievienot",
	justify: "Slīpraksts",
	kind: "Veids",
	layer: "Slānis",
	level: "Līmenis",
	lineSymbolizer: "Līniju simbolizētājs",
	manageStyle: "Pārvaldīt stilu",
	markSymbolizer: "Atzīmju simbolizētājs",
	maxScale: "Maks. mērogs",
	minScale: "Min. mērogs",
	miterLimit: "Dekoru limits",
	name: "Nosaukums",
	notFilter: "NOT",
	offsetX: "X nobīde",
	offsetY: "Y nobīde",
	opacity: "Necaurredzamība",
	orFilter: "OR",
	outlineColor: "Kontūras krāsa",
	outlineOpacity: "Kontūras necaurredzamība",
	outlineWidth: "Kontūras platums",
	perpendicularOffset: "Perpendikulāra nobīde",
	radius: "Radiuss",
	removeFilter: "Noņemt filtru",
	removeRule: "Noņemt noteikumu",
	removeSymbolizer: "Noņemt simbolētāju",
	rotation: "Rotācija",
	roundLimit: "Apļa robežas",
	rules: "Noteikumi",
	selectIcon: "Izvēlēties ikonu",
	selection: "Izv. objekts",
	simpleRule: "Vienkāršs noteikums",
	size: "Izmērs",
	source: "URL",
	spacing: "Atstarpe",
	strokeColor: "Līnijas krāsa",
	strokeOpacity: "Līnijas necaurredzamība",
	strokeWidth: "Līnijas platums",
	symbol: "Simbols",
	symbolizers: "Simbolētājs",
	template: "Veidne",
	textColor: "Teksta krāsa",
	textSize: "Teksta izmērs",
	textSymbolizer: "Teksta simbolētājs",
	toggleFilters: "Pārslēgt filtrus",
	toggleScaleDenominators: "Pārslēgt mēroga saucējus",
	transform: "Transformēt",
	uploadSld: "Augšupielādēt stilu kā SLD failu",
	warningAttribNotStoredNotVisualized: "Atribūts pašlaik nav pareizi vizualizēts un nav saglabāts SLD",
	warningAttribStoredNotVisualized: "Atribūts saglabāts SLD, bet pašlaik tas nav pareizi vizualizēts",
	width: "Platums",
	warningAttribNotStoredVisualized: "Atribūts ir vizualizēts, bet nav saglabāts SLD",
	unknownSymbolizer: "Nezināms simbolizētājs"
};
var TOOLBAR$1 = {
	measureLinesAndPolygon: "Izmērīt līnijas un daudzstūrus"
};
var TRIP_PLANNER$1 = {
	clearWaypoints: "Dzēst pieturas",
	missingAuth: "Maršrutēšanas pakalpojums nav atļauts",
	removeWaypoint: "Dzēst pieturu",
	routerLayer: "Maršruta slānis",
	serviceDown: "Šķiet, ka navigācijas pakalpojums nav pieejams. Atvainojamies par sagādātajām neērtībām!",
	totalDistance: "Kopējais attālums",
	travelRoute: "Ceļojuma maršruts",
	waypointDrawingHint: "Lūdzu spiediet uz kartes, lai pievienotu pieturas punktus",
	waypointLayer: "Galapunktu slānis",
	waypoints: "Pieturas punkti"
};
var lv = {
	ADDDATA: ADDDATA$1,
	ADDLAYERS: ADDLAYERS$1,
	COMMON: COMMON$1,
	COMPOSITIONS: COMPOSITIONS$1,
	COMPOSITONINSPIRETHEMES: COMPOSITONINSPIRETHEMES$1,
	COMPOSITONKEYWORDS: COMPOSITONKEYWORDS$1,
	COMPOSITONSORTVALUES: COMPOSITONSORTVALUES$1,
	COMPOSITONTYPES: COMPOSITONTYPES$1,
	DATASOURCE_SELECTOR: DATASOURCE_SELECTOR$1,
	DRAW: DRAW$1,
	ERRORMESSAGES: ERRORMESSAGES$1,
	FEATURE_TABLE: FEATURE_TABLE$1,
	GEOLOCATION: GEOLOCATION$1,
	HISTORY: HISTORY$1,
	INFOCOMPONENT: INFOCOMPONENT$1,
	LAYERMANAGER: LAYERMANAGER$1,
	LAYERS: LAYERS$1,
	LEGEND: LEGEND$1,
	MAP: MAP$1,
	MEASURE: MEASURE$1,
	PANEL_HEADER: PANEL_HEADER$1,
	PERMALINK: PERMALINK$1,
	QUERY: QUERY$1,
	SAVECOMPOSITION: SAVECOMPOSITION$1,
	SENSORS: SENSORS$1,
	SIDEBAR: SIDEBAR$1,
	STYLER: STYLER$1,
	TOOLBAR: TOOLBAR$1,
	TRIP_PLANNER: TRIP_PLANNER$1
};

var ADDDATA = {
	catalogue: "Dátový katalóg",
	CATALOGUE: {
		addAs: "Pridať ako",
		DESC: {
			WFS: "Web Feature Service - sťahovacia: slúži na prácu s geografickými dátami vo vektorovej reprezentácií. Je výkonostne naročnejšia, predovšetkým pri rozsiahlejšich vrstvách, umožňuje však editáciu, či zobrazenie individuálnych informacií ku každému prvku zvlášť.",
			WMS: "Web Map Service - prehliadacia: dáta nahráva v podobe rastru. Prenášané dáta sú obvykle menie čo má za následok rychlejšie načítanie, no na druhú stranu neumožňuje ich editáciu."
		},
		filterType: "Typ vyhľadávania",
		loading: "Načítanie dát",
		queryDataTypes: {
			all: "Všetko",
			dataset: "Datasety",
			service: "Služby"
		},
		resourceType: "Typ zdroja",
		searchFilterTypes: {
			Abstract: "Abstrakt",
			AnyText: "Všetko",
			Title: "Titulok"
		},
		searchType: "Typ vyhľadávania",
		selectFilterType: "Zmeniť nastavenie vyhľadávania",
		sortbyTypes: {
			bbox: "BBOX",
			date: "Dátum",
			title: "Titulok"
		},
		showAll: "Všetky",
		showNext100: "Dalších 100",
		showingSubset: "Aktuálne sa zobrazuje {{limitShown}} z {{total}} služieb. \nŠou"
	},
	file: "Súbor",
	saveToDatabase: "Uložit do databázy",
	URL: {
		selectAll: "Označiť všetky vrstvy",
		submitLayerName: "Zadajte názov vrstvy",
		submitLayerTitle: "Zadajte titulok vrstvy"
	}
};
var ADDLAYERS = {
	addSelected: "Pridať označené vrstvy do mapy",
	Basemap: "Pridať ako podkladovú vrstvu",
	capabilitiesParsingProblem: "Problém pri načítaní informácii o službě",
	chooseFormat: "Vyberte formát",
	chooseType: "Vyberte typ",
	considerUsingTiles: "Zvážte použitie dlaždíc. Niektoré servery majú obmedzenú maximálnu veľkosť obrazu.",
	couldNotUploadSelectedFile: "Pri načítaní súboru došlo k chybe!",
	ERROR: {
		errorWhileRequestingLayers: "Chyba pri žiadaní vrstiev zo servera",
		someErrorHappened: "Nastala nešpecifikovaná chyba alebo je chybný vstup",
		thereWasErrorWhile: "Nastala chyba pri syntaktickej analýze odpovede Capabilities z danej URL",
		urlInvalid: "Chýbajúca alebo neplatná URL požadovanej vrstvy!",
		srsNotSupported: "Vybraný súradnícový systém (CRS/SRS) nie je podporovaný.Ak chete pokračovať, zadajte súbor v systéme EPSG:3857 alebo EPSG:4326."
	},
	externalDataSource: "Zdroj externých dát (URL)",
	featureCount: "Počet prvkov",
	folderName: "Názov zložky",
	imageFormat: "Formát obrazu",
	loadingFeaturePleaseWait: "Načítanie prvkov, prosím, čekajte",
	mapAndLayerProjection: "Mapové zobrazenie mapy a vrstvy si nezodpovedajú! Bude požité prevzorkovanie. To môže viesť k neočakávaným výsledkom.",
	mapProjectionAndLayerProjection: "Mapové zobrazenie mapy a vrstvy si nezodpovedajú. Pridať vrstvu do mapy a použít prevzorkovací program na strane servera?",
	none: "Žiadnu (hore)",
	queryFormat: "Formát dotazu",
	registerMetadata: "Registrovať metadáta",
	resampleLayer: "Prevzorkovať vrstvu",
	selectAllLayers: "Vybrať všetky vrstvy",
	serviceTypeNotMatching: "Typ služby URL se nezhoduje s vybranou kategóriou",
	SHP: {
		loginRequired: "Pred načítaním vrstvy je potrebné prihlásiť sa ",
		nameRequired: "Pre pokračovanie je potrebné pole 'Názov'!",
		shapeFile: "Súbory Shapefile (shp+dbf+shx)",
		SLDStyleFile: "Súbor so štýlmi"
	},
	srs: "SRS",
	thisIsRequired: "Toto je vyžadované!",
	tileSize: "Veľkosť dlaždice",
	TYPES: {
		ArcGIS: "ArcGIS Map Server",
		shapeFile: "Shapefile",
		vectorFile: "vektorový súbor (GeoJSON, KML)",
		WFS: "Web Feature Service (WFS)",
		WMS: "Web Map Service (WMS)"
	},
	under: "Pridať pod vrstvu",
	useProxy: "Použíť proxy",
	useTiles: "Použíť dlaždice",
	Vector: {
		addingFiles: "Pridávanie {{featuresCount}} prvkov do:",
		addSld: "Pridať súbor SLD",
		chooseFiles: "Vyberte súbory...",
		chooseLayer: "Vyberte vrstvu zo zoznamu ...",
		dragAndDropFiles: "Pretiahnite súbory",
		note: "*Poznámka: Ak pripojíte súbor so súradnicami v inom systéme než WGS84 (dĺžka/šírka) nastavte prosím SRS v skecií \"POKROČILÉ MOŽNOSTI\"",
		uploadVectorFiles: "Nahrajte vektorové súbory"
	},
	VECTOR: {
		extractStyles: "Extrahovať štýly"
	},
	WFS: {
		addToMap: "Pridať do mapy",
		loadingToManyAtOnce: "prvkov. Načítanie příliš veľkého množstva prvkov naraz (pri oddialení) môže ovplyvniť výkon aplikácie",
		selectedLayerContains: "Vybraná vrstva obsahuje"
	},
	WMTS: {
		tileMatrix: "Matica dlaždíc"
	},
	unknownDimesion: "Táto vrstva definuje dimenziu, ktorú nemožno v súčasnosti načítať"
};
var COMMON = {
	abstract: "Abstrakt",
	add: "Pridať",
	addAs: "Pridať ako",
	advancedOptions: "Pokročilé možnosti",
	all: "Všetko",
	application: "Aplikácia",
	area: "Plocha",
	attribute: "Atribút",
	attributes: "Atribúty",
	"Authentication failed. Login to the catalogue.": "Neuspešné overenie. Prihláste sa do katalógu.",
	boundingBox: "Rozsah v mape",
	cancel: "Zrušiť",
	category: "Kategórie",
	circle: "Kruh",
	clear: "Vyčistiť",
	close: "Zavrieť",
	closeDialog: "Zavrieť okno",
	color: "Farba",
	confirm: "Potvrdiť",
	confirmDelete: "Potvrďte vymazanie",
	connect: "Pripojiť",
	contactInformation: "Kontaktné informácie",
	"continue": "Pokračovať",
	data: "Dáta",
	dataset: "Dátová sada",
	date: "Dátum",
	"delete": "Vymazať",
	description: "Popis",
	distance: "Vzdialenosť",
	download: "Na stiahnutie",
	drawNewFeatures: "Nakresliť nové prvky",
	east: "Východný",
	extent: "Rozsah",
	fill: "Výplň",
	fillInDescriptive: "Vyplňte stručný popis mapy",
	fillInName: "Vyplňte názov",
	filter: "Filter:",
	folder: "Zložka",
	from: "Od",
	fullText: "Fulltext",
	hide: "Skryť",
	icon: "Ikona",
	ignoreAndContinue: "Ignorovať a pokračovať",
	info: "Dalšie informácie",
	keywords: "Kľúčové slová",
	layer: "Vrstva",
	layers: "Vrstvy",
	legend: "Legenda",
	less: "Menej",
	line: "Línie",
	lineColor: "Farba línie",
	lineWidth: "Šířka línie",
	loading: "Načítanie",
	Login: "Prihlásiť sa",
	Logout: "Odhlásiť",
	mapExtentFilterMissing: "Radenie výsledkov podľa rozsahu dát (BBOX) je možné jedine po aktivácií 'filtrácie na rozsah okna'. Aktivujte ho prosím.",
	menu: "Menu",
	metadata: "Metadáta",
	more: "Viac",
	name: "Názov",
	"new": "Nový",
	newDrawingLayer: "Nová vrstva na kreslenie",
	next: "Ďalšie",
	no: "Nie",
	noDataReceived: "Neboli prijaté židane dáta!",
	north: "Severný",
	ok: "Ok",
	open: "Otvoriť",
	or: "alebo",
	orderBy: "Zoradiť podľa",
	photo: "Foto",
	point: "Bod",
	polygon: "Polygón",
	print: "Tlač",
	projection: "Zobrazenie",
	radius: "Polomer",
	reload: "Znovu načítať",
	removeLayer: "Odstrániť vrstvu",
	renameLayer: "Premenovať vrstvu",
	reset: "Resetovať",
	results: "Výsledky",
	rotation: "Rotácia",
	save: "Uložiť",
	saveAs: "Uložiť ako..",
	saveTo: "Uložiť do",
	scale: "Mierka",
	search: "Hľadať:",
	service: "Služba",
	settings: "Nastavenie",
	share: "Zdieľať",
	showMore: "Zobraziť viac",
	Sort: "Zoradiť",
	sortBy: "Radiť podľa",
	south: "Južný",
	stop: "Koniec",
	stroke: "Obrys",
	strokeWidth: "Šířka obrysu",
	style: "Style",
	theme: "Téma",
	thumbnail: "Miniatúra",
	title: "Titulok",
	to: "do",
	type: "Typ",
	unknownError: "Neznáma chyba. Skúste to znova, prosím.",
	until: "Až do",
	url: "URL",
	value: "Hodnota",
	warning: "Varovanie",
	west: "Západný",
	width: "Šírka",
	wrongCombinationOfParams: "Neplatná kombinácia parametrov",
	yes: "Áno",
	zoomTo: "zväčšiť na",
	into: " do",
	uploading: "Nahrávanie údajov"
};
var COMPOSITIONS = {
	addByAddress: "Pridať kompozíciu z adresy",
	Address: "Adresa",
	clearFilters: "Vyčistiť filtre",
	compostionsNameAttributeIsNotDefined: "Atribút názov kompozície nie je definovaný!",
	dialogDelete: {
		doYouWantToDeleteMap: "Chcete zmazať túto mapu?"
	},
	dialogInfo: {
		details: "detaily",
		metadata: {
			comparison_url: "Porovnávacia URL",
			csw_url: "CSW URL",
			identifier: "Identifikátor",
			record_url: "Zaznamenajte URL"
		},
		metadataAboutMetadata: "Metadáta o metadátach"
	},
	dialogoverwriteConfirm: {
		mergeCompositions: "Spojiť kompozície",
		overwriteExistingMap: "Prepísať existujúcu mapu?",
		saveChangesFirst: "Najskôr uložiť zmeny",
		thereAreCurrentlyUnsavedChanges: "V mapovom okne sú neuložené zmeny.",
		whatDoYouWant: "Čo chcete vykonať pred otvorením vybranej mapovej kompozície?",
		youAreOpeningMap: "Otvárate mapu."
	},
	dialogShare: {
		shareMap: "Zdieľať mapu"
	},
	dialogWarning: {
		outOfBounds: "Rozsah kompozície je mimo rozsah systému EPSG:4326",
		toContinue: "Na základe danej veľkosti mapy nebude mapa zobrazovať geometriu alebo rozsah danej kompozície"
	},
	endpointUrlIsNotDefined: "Nie je definovaná URL adresa servera!",
	endpointUserIsNotDefined: "Nie je definovaný užívateľ katalógu",
	errorWhileLoadingCompositionMetadata: "Chyba pri načítaní metadát kompozície",
	errorWhileRequestingCompositions: "Chyba pri žiadosti o kompozíciu",
	errorWhileSharingOnSocialNetwork: "Chyba pri zdeiľaní kompozície na sociálnu sieť",
	filterByMap: "Filtrovať na rozsah okna",
	"import": "Importovať kompozíciu zo súboru v tomto zariadení",
	inspireTheme: "Téma INSPIRE",
	loginToCatalogue: "Prihlásiť do katalógu",
	metadataNotAvailable: "Metadáta nie sú dostupné!",
	notAllowedToEditLayer: "Nemáte oprávnenie editovať túto kompozíciu",
	onlyMine: "Len moje vlastné",
	selectKeywords: "Vybrať kľúčové slová",
	selectThemes: "Vybrať témy",
	sharingUrlIsNotAvailable: "Adresa URL pre zdieľanie nie je dostupná!"
};
var COMPOSITONINSPIRETHEMES = {
	Addresses: "Adresy",
	"Administrative units": "Územne správne jednotky",
	"Agricultural and aquaculture facilities": "Poľnohospodárske a vodohospodárske zariadenia",
	"Area management/restriction/regulation zones and reporting units": "Správne oblasti/chránené pásma/regulované územia a jednotky podávajúce hlásenia",
	"Atmospheric conditions": "Stav ovzdušia",
	"Atmospheric Conditions and meteorological geographical features": "Stav ovzdušia a zemepisné meteorologické prvky",
	"Bio-geographical regions": "Bioregiony",
	Buildings: "Budovy",
	"Cadastral parcels": "Parcely",
	"Coordinate reference systems": "Súradnicové referenčné systémy",
	Elevation: "Nadmorská výška",
	"Energy resources": "Energetické zdroje",
	"Environmental monitoring facilities": "Zariadenia pre sledovanie životného prostredia",
	"Geographical grid systems": "Zemepisné sústavy súradnicových sietí",
	"Geographical names": "Zemepisné mená",
	Geology: "Geológia",
	"Habitants and biotopes": "Stanovištia a biotopy",
	"Human health and safety": "Ľudské zdravie bezpečnosť",
	Hydrography: "Hydrografia",
	"Land cover": "Krajinný pokryv",
	"Land use": "Využitie územia",
	"Meteorological geographical features": "Zemepisné meteorologické prvky",
	"Mineral resources": "Nerastné suroviny",
	"Natural risk zones": "Oblasti ohrozené prírodnými rizikami",
	None: "Žiadne",
	"Oceanographic geographical features": "Zemepisné oceánografické prvky",
	Orthoimagery: "Ortofotosnímky",
	"Population distribution - demography": "Rozloženie obyvateľstva – demografia",
	"Production and industrial facilities": "Výrobné a priemyselné zariadenia",
	"Protected sites": "Chránené územia",
	"Sea regions": "Morské oblasti",
	Soil: "Pôda",
	"Species distribution": "Rozloženie druhov",
	"Statistical units": "Štatistické jednotky",
	"Transport networks": "Dopravné siete",
	"Utility and governmental services": "Verejné služby a služby verejnej správy"
};
var COMPOSITONKEYWORDS = {
	Basemap: "Podkladová mapa",
	Borders: "Hranice",
	Cadastre: "Kataster",
	"Complex information": "Komplexné informácie",
	Culture: "Kultúra",
	Demographics: "Demografia",
	Economics: "Hospodárstvo",
	Environment: "Životné prostredie",
	Hazards: "Riziká",
	Infrastructure: "Infraštruktúra",
	"Land use": "Využitie územia",
	"Physical geography": "Fyzická geografia",
	Planning: "Plánovanie",
	"Real estate": "Nehnuteľnosti",
	"Socio political conditions": "Socio-politické podmienky",
	Transport: "Doprava",
	Water: "Voda"
};
var COMPOSITONSORTVALUES = {
	Bbox: "Rozsah mapy",
	"Date": "Dátum",
	None: "Žiadny",
	Title: "Názov"
};
var COMPOSITONTYPES = {
	Application: "Aplikácia",
	Datasource: "Zdroj dát",
	"Feature catalogue": "Katalóg prvkov",
	None: "Žiadny",
	Service: "Služba"
};
var DATASOURCE_SELECTOR = {
	addToMapAs: "Pridať do mapy ako",
	advancedMicka: {
		applicationType: "Application type",
		dateStamp: "Date stamp",
		extendedSearchParameters: "Rozšířené vyhledávání",
		extentSimilarity: "Extent similarity",
		featureCatalogue: "Katalog prvků",
		organizationName: "název organizace",
		serviceType: "Typ služby",
		topicCategory: "Topic category"
	},
	datasourceListItem: {
		abortAdd: "Zrušiť pridanie",
		addToMap: "Pridať do mapy",
		notAllowedToEditLayer: "Nemáte oprávnenie editovať túto dátovú sadu",
		whatDoesItMean: "Čo to znamená?"
	},
	externalData: "Externé dáta",
	layerRDF: "RDF vrstva",
	metadataFor: "Metadáta o",
	noResults: "Žiadne výsledky",
	suggestions: "Návrhy"
};
var DRAW = {
	activateDrawing: "Aktivujte kreslenie výberom typu prvku",
	activeLayers: "Aktívne vrstvy",
	allowSnapping: "Povoliť prichytávanie",
	boxSelection: "Výber polygónom",
	boxSelectionActivated: "Tu mi nenapadá ako by sme to preložili",
	definedStyle: "Definovaný štýl",
	deleteNote: "*Vrstva bude kompletne vymazaná. V prípade, že ju chcete vymazať len z aktuálnej kompozíce (nie aj z databázy) môžete tak urobiť v panele 'Správca vrstiev'",
	deselectAllFeatures: "Odznačiť všetky prvky",
	disableDrawing: "Vypnúť kreslenie",
	drawInfo: "Pri kreslení mnohoúhelníku ale línie môžete podržať klávesu SHIFT pre krslenie rukou; Posledný bod môžete vymazať klávesou Backspace",
	drawingTo: "Kreslím do:",
	drawLayer: "Kresliaca vrstva",
	drawLayerMetadata: {
		defaultAttributes: "Východzie atribúty",
		defaultValue: "Východzia hodnota",
		layerTitle: "Názov vrstvy",
		layerWillBeAdded: "*Vrstva bude pridaná do mapy a je možné ju ďalej spravovať v paneli \"Správca vrstiev\"",
		loadServerLayers: "Načítať vrstvu zo servera",
		nameOfFolder: "Názov zložky v hierarchii správcu vrstiev"
	},
	drawToolbar: {
		addDrawLayer: "Pridať novú vrstvu na kreslenie",
		addLayer: "Pridať vrstvu",
		finishFeature: "Ukončiť prvok",
		removeLastPoint: "Odobrať posledný bod",
		selectType: "Typ geometrie"
	},
	fillOpacity: "Vyplňte nepriehľadnosť:",
	loadingLayer: "Načítava sa vrstva",
	longerLoading: "Zdá sa, že načítanie trvá dlhšie ako zvyčajne. \nPočkaj chvíľu, prosím!",
	newGPS: "Nové GPS",
	noSuitableLayer: "Nie je k dispozícii žiadna vhodná vrstva",
	notAuthorized: "Neautorizovaný uživateľ, zmeny nebudú uložené",
	reallyDeleteThisLayer: "Naozaj odstrániť vybranú vrstvu?",
	saveDrawingToLayer: "Uložiť do vrstvy",
	"Select layer": "Vybrať vrstvu",
	selectAllFeatures: "Označiť všetky prvky",
	serverLayers: "Serverové vrstvy",
	snapTo: "Prichytávať na vrstvu",
	stylingMissing: "Chýba správny styling",
	stylingMissingWarning: "Geometriu {{type}} NIE je možné vizualizovať.Najprv vytvorte symboliku úre {{symbolizer}}. Môžete to urobiť v paneli {{panel}}.",
	unsavedDrawing: "Neuložená kresba",
	useModifierToSelectWithBox: "Stlačte {{platformModifierKey}} a ťahaním vyznačte oblasť výberu"
};
var ERRORMESSAGES = {
	"0": "Chybná odpoveď pre {{url}}: 0 Neznáma chyba",
	"400": "Chybná odpoveď pre {{url}}: 400 Nesprávna požiadavka",
	"403": "Chybná odpoveď pre {{url}}: 403 Odmietnuté",
	"404": "Chybná odpoveď pre {{url}}: 404 Nenájdené",
	"502": "Chybná odpoveď pre {{url}}: 502 Nesprávna brána",
	"Invalid Params": "Pred zdieľaním mapy sa uistite, či sú všetky vyžadovené polia správne vyplnené!",
	"Timeout has occurred": "Chybná odpoveď pre {{url}}: Čas vypršal"
};
var FEATURE_TABLE = {
	"delete": "vymazať",
	showFeatureStats: "Otvoriť",
	sortFeaturesByValue: "Zobrazte štatistiky prvku",
	"zoom to": "priblížiť na"
};
var GEOLOCATION = {
	altitude: "Nadmorská výška",
	follow: "Sledovať",
	locateMe: "Nájdi ma",
	precision: "Presnosť",
	speed: "Rýchlosť"
};
var HISTORY = {
	toggleDropdown: "Rozbaľovacia ponuka"
};
var INFOCOMPONENT = {
	newMap: "Nová mapa",
	unsavedMap: "Neuložená mapa",
	viewComposeAndAnalyse: "Prehliadať, kombinovať a analyzovať priestorové dáta",
	youHaveUnsavedChanges: "Máte neuložené zmeny!"
};
var LAYERMANAGER = {
	baselayers: "Podkladové vrstvy",
	baseMapGallery: {
		grayscale: "Šedotón",
		noBaseMap: "Bez podkladov"
	},
	dialogRemoveAll: {
		dialogMessage: "Naozaj chcete odstrániť všetky vami pridané vrstvy?",
		reloadComposition: "Obnoviť kompozíciu",
		removeAllAdded: "Odstrániť všetky pridané vrstvy"
	},
	dimensions: "Dimenzie",
	editorButtons: "Editačné tlačidlá",
	enablePhysicalLayerList: "Povoliť/zakázať fyzický zoznam vrstiev",
	layerEditor: {
		cluster: "Zhlukovať",
		copyright: "Autorské práva",
		layerFrom: "vrstva z",
		memory: "medzipamäť",
		metadataOfLayer: "Metadáta vrstvy v ",
		metadataOfService: "Metadáta služby",
		opacity: "Priehľadnosť",
		savegeojson: "Stiahnuť obsah vrstvy ako GeoJSON",
		styleLayer: "Štýlovať vrstvu",
		vector: "Vektorová",
		"vector (GeoJSON)": "Vektorová (GeoJSON)",
		"vector (KML)": "Vektorová (KML)",
		"vector (TopoJSON)": "Vektorová (TopoJSON)",
		zoomToLayer: "Priblížiť na vrstvu"
	},
	layerList: {
		layerIsQueryable: "Táto vrstva je dotazovateľná",
		layerNotAvailable: "Táto vrstva nie je k dispozícii",
		moveLayerDown: "Presunúť vrstvy nižšie",
		moveLayerUp: "Posunúť vrstvy vyššie",
		noAvailableInScale: "Táto vrstva nie je v tejto mierke k dispozícii",
		sendingToLayman: "Odosielam na Layman"
	},
	layermanagerMd: {
		aboutLayer: "O vrstve",
		changeLayerOpacity: "Zmeniť priehľadnosť vrstvy",
		changeLineWidht: "Zmeniť šírku línie",
		filterFeatures: "Filtrovať prvky",
		imageLayer: "Vrstva obrazu",
		innerRadius: "Vnútorný polomer",
		layerName: "Názov vrstvy",
		layerOpacity: "Priehľadnosť vrstvy",
		layerOptions: "Možnosti vrstvy",
		layerStyle: "Štýl vrstvy",
		layerVisibility: "Viditeľnosť vrstvy",
		lineFeatures: "Líniové prvky",
		moveLayerDown: "Posunúť vrstvu dole",
		moveLayerDownward: "Presunutie vrstvy dole, shift-klik dole",
		moveLayerUp: "Posunúť vrstvu hore",
		moveLayerUpward: "Presunutie vrstvy hore, shift-klik na začiatok",
		outerRadius: "Vonkajší polomer",
		pointFeatures: "Bodové prvky",
		polygonFeatures: "Polygónové prvky",
		sidesNumber: "Číslo strán",
		star: "Hviezda"
	},
	mapContent: "Mapový obsah",
	other: "Iný",
	removeAllLayers: "Odstrániť všetky vrstvy",
	resetMap: "Obnoviť mapu",
	terrains: "Terény",
	time: {
		outOfRange: "Vybraný čas je mimo rozsah",
		syncTimes: "Synchronizovať časy",
		syncTimesTooltip: "Synchronizovať čas všetkých vrstiev",
		outOfRangeDescription: "Táto vrstva môže zobrazovať rôzne údaje na základe vybratého času. Čas sa môže dostať „mimo rozsah“, keď je synchronizovaný s inou vrstvou, ale táto vrstva pre daný časový úsek nemá žiadne údaje. Kliknutím vyberte platný dátum a čas. Môžete tiež vypnúť synchronizáciu času vo vrstve."
	},
	"User generated": "Užívateľské",
	dialogRemoveLayer: {
		dialogMessage: "Naozaj chcete odstrániť vybratú vrstvu?"
	}
};
var LAYERS = {
	existingLayer: "Existujúca vrstva",
	newLayer: "Nová vrstva"
};
var LEGEND = {
	noLegendExists: "Žiadna vrstva s legendou neexistuje!"
};
var MAP = {
	zoomKeyModifier: "Stlačte {{platformModifierKey}} + použite koliesko myši pre priblíženie mapy.",
	zoomToInitialWindow: "Priblížiť na úvodný pohľad"
};
var MEASURE = {
	measureMd: {
		deleteAllMeasurements: "Odstrániť všetky merania",
		measureType: "Typ merania",
		saveMeasurementToLayer: "Uložte meranie do vrstvy"
	},
	multipleShapes: "Viac tvarov"
};
var PANEL_HEADER = {
	ADDLAYERS: "Pridať externé dáta",
	APPLICATIONSETTINGS: "Nastavenia aplikácie",
	COMPOSITIONS: "Kompozície",
	DATASOURCE_SELECTOR: "Dátové zdroje",
	DRAW: "Kresliť",
	FEATURE_TABLE: "Tabuľka prvkov",
	FILTERFEATURES: "Filtrovať prvky",
	INFO: "Info",
	LANGUAGE: "Zmeniť jazyk",
	LEGEND: "Legenda",
	LM: "Správca vrstiev",
	MAPCOMPOSITIONS: "Mapové kompozície",
	MEASURE: "Meranie",
	PERMALINK: "Zdieľať mapu",
	PRINT: "Tlač",
	ROUTING: "Smerovanie",
	SAVECOMPOSITION: "Uložiť aktuálnu mapu",
	SEARCH: "Hľadanie",
	SENSORS: "Senzory",
	TRIP_PLANNER: "Plánovač tras"
};
var PERMALINK = {
	directiveMd: {
		copyToClipboard: "Skopírovať do schránky"
	},
	embed: "vloženie",
	embedCode: "Vložiť kód",
	linkFor: "Odkaz pre",
	newShare: "Nové zdieľanie",
	permalink: "Trvalý odkaz",
	pureMap: "Iba mapa",
	shareOnSocialNetwork: "Zdieľajte na sociálnej sieti",
	sharePureMap: "Zdieľať iba mapu",
	sharesMapWith: "*Zdieľať mapu so (všetkými) funkciami portálu",
	sharesOnlyMap: "*Zdieľať mapu iba ako obrázok",
	socialShare: "zdieľanie"
};
var QUERY = {
	confirmClear: "Potvrďte vymazanie",
	confirmDelete: "Potvrďte zmazanie",
	coordinates: "Súradnice",
	deleteAllSelected: "Odstrániť všetky vybraté prvky",
	downloadAs: "Stiahnuť ako",
	feature: {
		attributeName: "Názov atribútu",
		attributeValue: "Hodnota atribútu",
		copyFeature: "Okopírovať prvok",
		featurecopySucc: "Prvok bol úspešne skopírovaný do vrstvy: ",
		featureEdited: "Zmena prvku bola úspešná",
		featuremoveSucc: "Prvok bol úspešne presunutý do vrstvy: ",
		moveFeature: "Presunúť prvok",
		copyFeatures: "Okopírovať prvky",
		moveFeatures: "Presunúť prvky"
	},
	featureInfo: "Informácie o funkcii",
	featurePopup: {
		clearLayer: "Vyčistiť vrstvu",
		closePopup: "Zavrieť vyskakovacie okno",
		removeClusterPart: "Odstrániť časť zhluku",
		removeFeature: "Odobrať prvok"
	},
	featuresSelected: "Vybraté prvky: ",
	infoPanel: {
		clickOnMap: "Kliknutím do mapy zobrazíte výsledky dotazu"
	},
	reallyDelete: "Naozaj zmazať tento prvok?",
	reallyDeleteAllFeaturesFrom: "Naozaj odstrániť všetky prvky z vrstvy {0}?",
	reallyDeleteAllSelectedLayers: "Naozaj odstrániť všetky vybrané prvky?",
	untitledFeature: "Prvok bez názvu",
	clusterContaining: "Klaster obsahujúci {{count}} prvkov"
};
var SAVECOMPOSITION = {
	dialogResult: {
		compositionFailedToSave: "Uloženie kompozície sa nepodarilo",
		compositionSavedSuccessfully: "Kompozícia bola úspešne uložená",
		requestWasProcessed: "Žiadosť bola spracovaná, ale mapa nebola uložená kvôli chýbajúcej autorizácii",
		savingCompositionStatus: "Ukladanie kompozície",
		serverDidNotRespond: "Server nereagoval alebo došlo k inej chybe"
	},
	dialogSave: {
		areYouAttempting: "Pokúšate sa uložiť zmeny mapy do",
		noSaveAs: "Nie, uložiť ako",
		saveComposition: "Uložiť kompozíciu",
		selectNewNameForMap: "Vyberte nový názov pre mapu",
		useDifferentName: "K uloženiu mapy použije iný názov",
		wantToOverwrite: "Naozaj chcete prepísať?",
		yesSave: "Áno, uložte",
		youDoNotHave: "K tomu nemáte dostatočné práva. Možno skončila relácia?"
	},
	form: {
		address: "Adresa",
		changeName: "Zmeniť meno",
		city: "Mesto",
		country: "Krajina",
		email: "E-mail",
		organization: "Organizácia",
		overwrite: "Prepísať",
		person: "Osoba",
		phone: "Telefón",
		position: "Pozícia",
		postalCode: "Poštovné smerovacie číslo",
		read: "Čítať",
		state: "Štát",
		toggleAll: "Prepnúť všetko",
		userCurrentMapExtent: "Použiť aktuálny rozsah mapy",
		write: "Zápis"
	},
	panelMd: {
		fillKeywords: "Vyplňte kľúčove slová",
		makePublic: "Zverejniť",
		saveMap: "Uložiť mapu",
		showThumbnail: "Zobraziť miniatúru",
		thumbnailSwitch: "Prepnúť náhľad",
		useMapExtent: "Použije rozsah mapy",
		youAreNotAuthorized: "Nemáte oprávnenie k uloženiu kompozícii. Prihláste sa alebo sa obráťte na administrátora pre vaše prihlasovacie údaje."
	},
	"private": "Súkromné",
	"public": "Verejné",
	readAccessRights: "Právo čítať",
	removeLayerError: "Vrstva '{{layer}}' nebola odstránená z databáze. {{error}}",
	saveOrOverwrite: "Táto kompozícia bola vytvorená iným užívateľom",
	syncErrorDialog: {
		errorWhenSyncing: "Chyba pri synchronizácii"
	},
	writeAccessRights: "Právo zápisu"
};
var SENSORS = {
	"1D": "1D",
	"1H": "1H",
	"1M": "1M",
	"1W": "1W",
	"6M": "6M",
	at: "v",
	avg: "Priem.",
	max: "Max",
	measure: "Meranie",
	min: "Min",
	oneHour: "1 hodina",
	phenomena: "Javy",
	sensors: "Senzory",
	sensorUnit: "Senzorová jednotka"
};
var SIDEBAR = {
	additionalPanels: "Ďalšie panely",
	descriptions: {
		ADDLAYERS: "Vybrať dáta alebo služby pre vašu mapovou kompozíciu",
		APPLICATIONSETTINGS: "Zadať užívateľské nastavenia aplikácie",
		DRAW: "Nakresliť nové prvky",
		FEATURE_TABLE: "Zobraziť prvky vrstvy v tabuľke",
		FILTERFEATURES: "Crossfilter",
		INFO: "Zobraziť informácie o výsledku mapového dotazu",
		LANGUAGE: "Zmeniť jazyk",
		LEGEND: "Zobraziť legendu",
		LM: "Spravovať a štýlovať vaše vrstvy",
		MAPCOMPOSITIONS: "Zoznam dostupných mapových kompozícii",
		MEASURE: "Merať vzdialenosť nebo plochu na mape",
		PERMALINK: "Zdieľať mapu",
		PRINT: "Tlačiť mapy",
		SAVECOMPOSITION: "Uložiť obsah mapy do kompozície",
		SEARCH: "Vyhľadať miesto",
		TRIP_PLANNER: "Vytvoriť novú trasu výletu"
	}
};
var STYLER = {
	addFilter: "Pridať filter",
	addRule: "Pridať pravidlo",
	addSymbolizer: "Pridať symboliku",
	anchor: "Uchytenie",
	anchorX: "Odsadenie X",
	anchorY: "Odsadenie Y",
	andFilter: "A",
	blur: "Rozostrenie",
	cap: "Typ konca",
	clusterRule: "Pravidlo pre zhluky",
	color: "Farba",
	comparisonFilter: "POROVNAŤ",
	dashPattern: "Vzor prerušenia",
	features: "Prvky",
	fillColor: "Farba výplne",
	fillOpacity: "Priehľadnosť výplne",
	fillSymbolizer: "Symbolika výplne",
	filtersAndScales: "Filtre a mierky",
	font: "Font",
	fontStyle: "Štýl fontu",
	fontWeight: "Hrúbka písma",
	gapWidth: "Šírka medzery",
	graphicFill: "Grafická výplň",
	graphicStroke: "Grafický obrys",
	haloColor: "Farba obalu",
	haloWidth: "Šírka obalu",
	iconSymbolizer: "Symbolika ikony",
	join: "Napojenie",
	justify: "Zarovnať",
	kind: "Typ",
	layer: "Vrstva",
	level: "Úroveň",
	lineSymbolizer: "Symbolika línie",
	markSymbolizer: "Symbolika značky",
	maxScale: "Max. mierka",
	minScale: "Min. mierka",
	miterLimit: "Limit pre ostré napojenie",
	name: "Meno",
	notFilter: "NIE",
	offsetX: "Odsadenie X",
	offsetY: "Odsadenie ",
	opacity: "Priehľadnosť",
	orFilter: "ALEBO",
	outlineColor: "Farba obrysu",
	outlineOpacity: "PriehĽadnosť obrysu",
	outlineWidth: "Šírka obrysu",
	perpendicularOffset: "Kolmý ofset",
	radius: "Polomer",
	removeFilter: "Vymazať filter",
	removeRule: "Vymazať pravidlo",
	removeSymbolizer: "Vymazať symboliku",
	rotation: "Otočenie",
	roundLimit: "Limit pre guľaté napojenie",
	rules: "Pravidlá",
	selectIcon: "Vybrete ikonu",
	selection: "Výber",
	simpleRule: "Jednoduché pravidlo",
	size: "Veľkosť",
	source: "URL",
	spacing: "Vzdialenosť",
	strokeColor: "Farba obrysu",
	strokeOpacity: "Priehľadnosť obrysu",
	strokeWidth: "Šírka obrysu",
	symbol: "Značka",
	symbolizers: "Symboliky",
	template: "Šablóna",
	textColor: "Farba textu",
	textSize: "Veľkosť textu",
	textSymbolizer: "Symbolika textu",
	toggleFilters: "Prepnúť filtre",
	toggleScaleDenominators: "Prepnúť rozsah mierky",
	transform: "Transformácia",
	warningAttribNotStoredNotVisualized: "Atribút momentálne nie je zorazený správne a nie je uložený v SLD",
	warningAttribStoredNotVisualized: "Atribút uložený v SLD, ale aktuálne nie je zobrazený správne",
	width: "Šírka",
	clear: "Obnoviť predvolený štýl",
	downloadSld: "Stiahnuť štýl ako súbor SLD",
	manageStyle: "Spravovať štýl",
	unknownSymbolizer: "Neznáma symboliku",
	warningAttribNotStoredVisualized: "Atribút je vizualizovaný, ale nie je uložený v SLD",
	uploadSld: "Nahrajte štýl ako súbor SLD"
};
var TOOLBAR = {
	measureLinesAndPolygon: "Merať línie a polygóny"
};
var TRIP_PLANNER = {
	clearWaypoints: "Vyčistiť body trasy",
	missingAuth: "Prístup k navigačnej službe nepovolený",
	removeWaypoint: "Odobrať bod trasy",
	routerLayer: "Vrstva s trasou",
	serviceDown: "Zdá sa, že navigačná služba nefunguje. Je nám to ľúto!",
	totalDistance: "Celková vzdialenosť",
	travelRoute: "Trasa výletu",
	waypointDrawingHint: "Kliknite prosím do mapy pre pridanie bodov trasy",
	waypointLayer: "Vrstva s bodmi trasy",
	waypoints: "Body trasy"
};
var sk = {
	ADDDATA: ADDDATA,
	ADDLAYERS: ADDLAYERS,
	COMMON: COMMON,
	COMPOSITIONS: COMPOSITIONS,
	COMPOSITONINSPIRETHEMES: COMPOSITONINSPIRETHEMES,
	COMPOSITONKEYWORDS: COMPOSITONKEYWORDS,
	COMPOSITONSORTVALUES: COMPOSITONSORTVALUES,
	COMPOSITONTYPES: COMPOSITONTYPES,
	DATASOURCE_SELECTOR: DATASOURCE_SELECTOR,
	DRAW: DRAW,
	ERRORMESSAGES: ERRORMESSAGES,
	FEATURE_TABLE: FEATURE_TABLE,
	GEOLOCATION: GEOLOCATION,
	HISTORY: HISTORY,
	INFOCOMPONENT: INFOCOMPONENT,
	LAYERMANAGER: LAYERMANAGER,
	LAYERS: LAYERS,
	LEGEND: LEGEND,
	MAP: MAP,
	MEASURE: MEASURE,
	PANEL_HEADER: PANEL_HEADER,
	PERMALINK: PERMALINK,
	QUERY: QUERY,
	SAVECOMPOSITION: SAVECOMPOSITION,
	SENSORS: SENSORS,
	SIDEBAR: SIDEBAR,
	STYLER: STYLER,
	TOOLBAR: TOOLBAR,
	TRIP_PLANNER: TRIP_PLANNER
};

//TODO: Is this module declaration needed at all?
class HsCommonEndpointsModule {
}
HsCommonEndpointsModule.ɵfac = function HsCommonEndpointsModule_Factory(t) { return new (t || HsCommonEndpointsModule)(); };
HsCommonEndpointsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: HsCommonEndpointsModule });
HsCommonEndpointsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsCommonEndpointsModule, [{
        type: NgModule,
        args: [{
                declarations: [],
                imports: [CommonModule],
                entryComponents: [],
                exports: []
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(HsCommonEndpointsModule, { imports: function () { return [CommonModule]; } }); })();

//TODO: Is this module declaration needed at all?
class HsLogModule {
}
HsLogModule.ɵfac = function HsLogModule_Factory(t) { return new (t || HsLogModule)(); };
HsLogModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: HsLogModule });
HsLogModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsLogModule, [{
        type: NgModule,
        args: [{
                declarations: [],
                imports: [],
                bootstrap: []
            }]
    }], null, null); })();

class HsUtilsModule {
}
HsUtilsModule.ɵfac = function HsUtilsModule_Factory(t) { return new (t || HsUtilsModule)(); };
HsUtilsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: HsUtilsModule });
HsUtilsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [HsLayerUtilsService, HsUtilsService], imports: [[]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsUtilsModule, [{
        type: NgModule,
        args: [{
                schemas: [CUSTOM_ELEMENTS_SCHEMA],
                imports: [],
                providers: [HsLayerUtilsService, HsUtilsService]
            }]
    }], null, null); })();

class WebpackTranslateLoader {
    constructor(HsConfig) {
        this.HsConfig = HsConfig;
    }
    getTranslation(lang) {
        const hsConfig = this.HsConfig;
        //Idea taken from https://github.com/denniske/ngx-translate-multi-http-loader/blob/master/projects/ngx-translate/multi-http-loader/src/lib/multi-http-loader.ts
        const requests = [
            from(new Promise((resolve) => {
                switch (lang) {
                    case 'lv':
                        resolve(lv);
                        break;
                    default:
                    case 'en':
                        resolve(en);
                        break;
                    case 'cs':
                        resolve(cs);
                        break;
                    case 'sk':
                        resolve(sk);
                        break;
                }
            })),
            from(new Promise((resolve) => {
                //Wait a bit for the HsConfig to be set from container app
                setTimeout((_) => {
                    if (hsConfig.translationOverrides &&
                        hsConfig.translationOverrides[lang]) {
                        resolve(hsConfig.translationOverrides[lang]);
                    }
                    else {
                        resolve({});
                    }
                }, 200);
            })),
        ];
        const tmp = forkJoin(requests).pipe(map((response) => {
            return merge.all(response);
        }));
        return tmp;
    }
}
/**
 * @param HsConfig
 */
function getWebpackTranslateLoader(HsConfig) {
    return new WebpackTranslateLoader(HsConfig);
}
class HsCoreModule {
    constructor() { }
}
HsCoreModule.ɵfac = function HsCoreModule_Factory(t) { return new (t || HsCoreModule)(); };
HsCoreModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: HsCoreModule });
HsCoreModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [TranslateStore, TranslateService, HsConfig], imports: [[
            HttpClientModule,
            HsLayoutModule,
            HsSidebarModule,
            HsHistoryListModule,
            HsLogModule,
            HsUtilsModule,
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useFactory: getWebpackTranslateLoader,
                    multi: false,
                    deps: [HsConfig]
                }
            }),
            HsConfirmModule,
            HsMapModule,
            HsCommonEndpointsModule,
        ], TranslateModule] });
HsCoreModule.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsCoreModule, [{
        type: NgModule,
        args: [{
                declarations: [],
                imports: [
                    HttpClientModule,
                    HsLayoutModule,
                    HsSidebarModule,
                    HsHistoryListModule,
                    HsLogModule,
                    HsUtilsModule,
                    TranslateModule.forRoot({
                        loader: {
                            provide: TranslateLoader,
                            useFactory: getWebpackTranslateLoader,
                            multi: false,
                            deps: [HsConfig]
                        }
                    }),
                    HsConfirmModule,
                    HsMapModule,
                    HsCommonEndpointsModule,
                ],
                exports: [TranslateModule],
                providers: [TranslateStore, TranslateService, HsConfig],
                entryComponents: []
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(HsCoreModule, { imports: function () { return [HttpClientModule, HsLayoutModule, HsSidebarModule, HsHistoryListModule, HsLogModule, HsUtilsModule, ɵngcc1.TranslateModule, HsConfirmModule, HsMapModule, HsCommonEndpointsModule]; }, exports: function () { return [TranslateModule]; } }); })();

class HsAddFilterButtonComponent {
    constructor() {
        this.clicks = new EventEmitter();
    }
    emitClick(kind) {
        this.clicks.emit({ kind });
    }
}
HsAddFilterButtonComponent.ɵfac = function HsAddFilterButtonComponent_Factory(t) { return new (t || HsAddFilterButtonComponent)(); };
HsAddFilterButtonComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsAddFilterButtonComponent, selectors: [["hs-add-filter-button"]], outputs: { clicks: "clicks" }, decls: 18, vars: 15, consts: [[1, "p-1"], ["ngbDropdown", "", 1, "d-inline-block"], ["id", "dropdownAddFilter", "ngbDropdownToggle", "", 1, "btn", "btn-outline-primary", "btn-sm", 3, "title"], [1, "icon-plus"], ["ngbDropdownMenu", "", "aria-labelledby", "dropdownAddFilter"], ["ngbDropdownItem", "", 3, "click"]], template: function HsAddFilterButtonComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "button", 2);
        ɵngcc0.ɵɵpipe(3, "translate");
        ɵngcc0.ɵɵelement(4, "span", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 4);
        ɵngcc0.ɵɵelementStart(6, "button", 5);
        ɵngcc0.ɵɵlistener("click", function HsAddFilterButtonComponent_Template_button_click_6_listener() { return ctx.emitClick("AND"); });
        ɵngcc0.ɵɵtext(7);
        ɵngcc0.ɵɵpipe(8, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "button", 5);
        ɵngcc0.ɵɵlistener("click", function HsAddFilterButtonComponent_Template_button_click_9_listener() { return ctx.emitClick("OR"); });
        ɵngcc0.ɵɵtext(10);
        ɵngcc0.ɵɵpipe(11, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "button", 5);
        ɵngcc0.ɵɵlistener("click", function HsAddFilterButtonComponent_Template_button_click_12_listener() { return ctx.emitClick("NOT"); });
        ɵngcc0.ɵɵtext(13);
        ɵngcc0.ɵɵpipe(14, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(15, "button", 5);
        ɵngcc0.ɵɵlistener("click", function HsAddFilterButtonComponent_Template_button_click_15_listener() { return ctx.emitClick("COMPARE"); });
        ɵngcc0.ɵɵtext(16);
        ɵngcc0.ɵɵpipe(17, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(3, 5, "STYLER.addFilter"));
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(8, 7, "STYLER.andFilter"), " ");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(11, 9, "STYLER.orFilter"), " ");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(14, 11, "STYLER.notFilter"), " ");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(17, 13, "STYLER.comparisonFilter"), " ");
    } }, directives: [ɵngcc6.NgbDropdown, ɵngcc6.NgbDropdownToggle, ɵngcc6.NgbDropdownMenu, ɵngcc6.NgbDropdownItem], pipes: [ɵngcc1.TranslatePipe], encapsulation: 2 });
HsAddFilterButtonComponent.propDecorators = {
    clicks: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsAddFilterButtonComponent, [{
        type: Component,
        args: [{
                selector: 'hs-add-filter-button',
                template: "<div class=\"p-1\">\n  <div ngbDropdown class=\"d-inline-block\">\n    <button class=\"btn btn-outline-primary btn-sm\" [title]=\"'STYLER.addFilter' | translate\" id=\"dropdownAddFilter\"\n      ngbDropdownToggle>\n      <span class=\"icon-plus\"></span>\n    </button>\n    <div ngbDropdownMenu aria-labelledby=\"dropdownAddFilter\">\n      <button ngbDropdownItem (click)=\"emitClick('AND')\">\n        {{'STYLER.andFilter' | translate}}\n      </button>\n      <button ngbDropdownItem (click)=\"emitClick('OR')\">\n        {{'STYLER.orFilter' | translate}}\n      </button>\n      <button ngbDropdownItem (click)=\"emitClick('NOT')\">\n        {{'STYLER.notFilter' | translate}}\n      </button>\n      <button ngbDropdownItem (click)=\"emitClick('COMPARE')\">\n        {{'STYLER.comparisonFilter' | translate}}\n      </button>\n    </div>\n  </div>\n</div>"
            }]
    }], function () { return []; }, { clicks: [{
            type: Output
        }] }); })();

class HsStylerPartBaseComponent {
    constructor() {
        this.changes = new EventEmitter();
    }
    emitChange() {
        this.changes.emit();
    }
}
HsStylerPartBaseComponent.ɵfac = function HsStylerPartBaseComponent_Factory(t) { return new (t || HsStylerPartBaseComponent)(); };
HsStylerPartBaseComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsStylerPartBaseComponent, selectors: [["ng-component"]], inputs: { warning: "warning" }, outputs: { changes: "changes" }, decls: 1, vars: 0, template: function HsStylerPartBaseComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "div");
    } }, encapsulation: 2 });
HsStylerPartBaseComponent.propDecorators = {
    changes: [{ type: Output }],
    warning: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsStylerPartBaseComponent, [{
        type: Component,
        args: [{
                template: '<div></div>'
            }]
    }], function () { return []; }, { changes: [{
            type: Output
        }], warning: [{
            type: Input
        }] }); })();

class HsColorPickerComponent extends HsStylerPartBaseComponent {
    constructor() {
        super(...arguments);
        this.fontColor = 'white';
        this.pickerVisible = false;
    }
    onPick($event) {
        this.symbolizer[this.attribute] = $event.color.hex;
        if (this.opacityAttribute) {
            this.symbolizer[this.opacityAttribute] = $event.color.rgb.a;
        }
        this.fontColor = this.generateFontColor([
            $event.color.rgb.r,
            $event.color.rgb.g,
            $event.color.rgb.b,
        ]);
        this.emitChange();
    }
    addAlpha(color, opacity) {
        if (opacity == undefined) {
            return color;
        }
        const t = Object.assign(Object.assign({}, this.hex2Rgb(color)), { a: opacity });
        return `rgba(${t.r}, ${t.g}, ${t.b}, ${t.a})`;
    }
    hex2Rgb(aRgbHex) {
        if (!aRgbHex) {
            return { r: 0, g: 0, b: 0 };
        }
        const rgb = aRgbHex.replace('#', '').match(/.{1,2}/g);
        return {
            r: parseInt(rgb[0], 16),
            g: parseInt(rgb[1], 16),
            b: parseInt(rgb[2], 16),
        };
    }
    generateFontColor(rgbColor) {
        const [r, g, b] = rgbColor;
        const hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));
        return hsp > 127.5 ? 'black' : 'white';
    }
    colorPickerStyle() {
        return {
            'background-color': this.symbolizer[this.attribute],
            'color': this.fontColor,
        };
    }
}
HsColorPickerComponent.ɵfac = /*@__PURE__*/ function () { let ɵHsColorPickerComponent_BaseFactory; return function HsColorPickerComponent_Factory(t) { return (ɵHsColorPickerComponent_BaseFactory || (ɵHsColorPickerComponent_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(HsColorPickerComponent)))(t || HsColorPickerComponent); }; }();
HsColorPickerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsColorPickerComponent, selectors: [["hs-symbolizer-color-picker"]], inputs: { symbolizer: "symbolizer", attribute: "attribute", opacityAttribute: "opacityAttribute", label: "label" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 8, vars: 7, consts: [[1, "d-flex", "flex-row"], [1, "p-1", "w-25", "mt-2"], [1, "p-1", "w-75"], [1, "form-control", "form-control-sm", 3, "ngStyle", "ngModelOptions", "ngModel", "click", "ngModelChange"], [3, "color", "onChangeComplete", 4, "ngIf"], [3, "onChangeComplete", 4, "ngIf"], [3, "color", "onChangeComplete"], [3, "onChangeComplete"]], template: function HsColorPickerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵelementStart(1, "div", 0);
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 2);
        ɵngcc0.ɵɵelementStart(5, "input", 3);
        ɵngcc0.ɵɵlistener("click", function HsColorPickerComponent_Template_input_click_5_listener() { return ctx.pickerVisible = !ctx.pickerVisible; })("ngModelChange", function HsColorPickerComponent_Template_input_ngModelChange_5_listener($event) { return (ctx.symbolizer[ctx.attribute] = $event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(6, HsColorPickerComponent_color_sketch_6_Template, 1, 1, "color-sketch", 4);
        ɵngcc0.ɵɵtemplate(7, HsColorPickerComponent_color_sketch_7_Template, 1, 0, "color-sketch", 5);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.label);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngStyle", ctx.colorPickerStyle())("ngModelOptions", ɵngcc0.ɵɵpureFunction0(6, _c2))("ngModel", ctx.symbolizer[ctx.attribute]);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.pickerVisible && ctx.symbolizer[ctx.attribute] !== undefined);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.pickerVisible && ctx.symbolizer[ctx.attribute] === undefined);
    } }, directives: [ɵngcc5.DefaultValueAccessor, ɵngcc3.NgStyle, ɵngcc5.NgControlStatus, ɵngcc5.NgModel, ɵngcc3.NgIf, ɵngcc9.SketchComponent], encapsulation: 2 });
HsColorPickerComponent.propDecorators = {
    symbolizer: [{ type: Input }],
    attribute: [{ type: Input }],
    opacityAttribute: [{ type: Input }],
    label: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsColorPickerComponent, [{
        type: Component,
        args: [{
                selector: 'hs-symbolizer-color-picker',
                template: "<div>\n  <div class=\"d-flex flex-row\">\n    <div class=\"p-1 w-25 mt-2\">{{label}}</div>\n    <div class=\"p-1 w-75\">\n      <input class=\"form-control form-control-sm\" (click)=\"pickerVisible = !pickerVisible\"\n        [ngStyle]=\"colorPickerStyle()\" [ngModelOptions]=\"{standalone: true}\" [(ngModel)]=\"symbolizer[attribute]\" />\n    </div>\n  </div>\n  <color-sketch [color]=\"addAlpha(symbolizer[attribute], symbolizer[opacityAttribute])\"\n    *ngIf=\"pickerVisible && symbolizer[attribute] !== undefined\" (onChangeComplete)=\"onPick($event)\"></color-sketch>\n  <color-sketch *ngIf=\"pickerVisible && symbolizer[attribute] === undefined\" (onChangeComplete)=\"onPick($event)\">\n  </color-sketch>\n</div>"
            }]
    }], null, { symbolizer: [{
            type: Input
        }], attribute: [{
            type: Input
        }], opacityAttribute: [{
            type: Input
        }], label: [{
            type: Input
        }] }); })();

class HsComparisonFilterComponent extends HsStylerPartBaseComponent {
    constructor() {
        super();
    }
    remove() {
        this.parent.splice(this.parent.indexOf(this.filter), 1);
        this.emitChange();
    }
}
HsComparisonFilterComponent.ɵfac = function HsComparisonFilterComponent_Factory(t) { return new (t || HsComparisonFilterComponent)(); };
HsComparisonFilterComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsComparisonFilterComponent, selectors: [["hs-comparison-filter"]], inputs: { filter: "filter", parent: "parent" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 10, vars: 9, consts: [[1, "d-flex", "flex-row"], [1, "form-control", 3, "ngModelOptions", "ngModel", "ngModelChange", "change"], [1, "btn", "btn-outline-danger", "btn-sm", "rounded-0", 2, "height", "100%", 3, "click"], [1, "icon-trash"]], template: function HsComparisonFilterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div");
        ɵngcc0.ɵɵelementStart(2, "input", 1);
        ɵngcc0.ɵɵlistener("ngModelChange", function HsComparisonFilterComponent_Template_input_ngModelChange_2_listener($event) { return (ctx.filter[1] = $event); })("change", function HsComparisonFilterComponent_Template_input_change_2_listener() { return ctx.emitChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div");
        ɵngcc0.ɵɵelementStart(4, "input", 1);
        ɵngcc0.ɵɵlistener("ngModelChange", function HsComparisonFilterComponent_Template_input_ngModelChange_4_listener($event) { return (ctx.filter[0] = $event); })("change", function HsComparisonFilterComponent_Template_input_change_4_listener() { return ctx.emitChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div");
        ɵngcc0.ɵɵelementStart(6, "input", 1);
        ɵngcc0.ɵɵlistener("ngModelChange", function HsComparisonFilterComponent_Template_input_ngModelChange_6_listener($event) { return (ctx.filter[2] = $event); })("change", function HsComparisonFilterComponent_Template_input_change_6_listener() { return ctx.emitChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div");
        ɵngcc0.ɵɵelementStart(8, "button", 2);
        ɵngcc0.ɵɵlistener("click", function HsComparisonFilterComponent_Template_button_click_8_listener() { return ctx.remove(); });
        ɵngcc0.ɵɵelement(9, "span", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngModelOptions", ɵngcc0.ɵɵpureFunction0(6, _c2))("ngModel", ctx.filter[1]);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngModelOptions", ɵngcc0.ɵɵpureFunction0(7, _c2))("ngModel", ctx.filter[0]);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngModelOptions", ɵngcc0.ɵɵpureFunction0(8, _c2))("ngModel", ctx.filter[2]);
    } }, directives: [ɵngcc5.DefaultValueAccessor, ɵngcc5.NgControlStatus, ɵngcc5.NgModel], encapsulation: 2 });
HsComparisonFilterComponent.ctorParameters = () => [];
HsComparisonFilterComponent.propDecorators = {
    filter: [{ type: Input }],
    parent: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsComparisonFilterComponent, [{
        type: Component,
        args: [{
                selector: 'hs-comparison-filter',
                template: "<div class=\"d-flex flex-row\">\n  <div>\n    <input class=\"form-control\" [ngModelOptions]=\"{standalone: true}\" [(ngModel)]=\"filter[1]\" (change)=\"emitChange()\" />\n  </div>\n  <div>\n    <input class=\"form-control\" [ngModelOptions]=\"{standalone: true}\" [(ngModel)]=\"filter[0]\" (change)=\"emitChange()\" />\n  </div>\n  <div>\n    <input class=\"form-control\" [ngModelOptions]=\"{standalone: true}\" [(ngModel)]=\"filter[2]\" (change)=\"emitChange()\" />\n  </div>\n  <div>\n    <button class=\"btn btn-outline-danger btn-sm rounded-0\" style=\"height: 100%\" (click)=\"remove()\">\n      <span class=\"icon-trash\"></span>\n    </button>\n  </div>\n</div>"
            }]
    }], function () { return []; }, { filter: [{
            type: Input
        }], parent: [{
            type: Input
        }] }); })();

class HsDownloadDirective {
    constructor(DomSanitizer) {
        this.DomSanitizer = DomSanitizer;
        this.hsDownload = '';
        this.mimeType = '';
        this.downloadPrepared = new EventEmitter();
    }
    ngOnChanges(changes) {
        const data = new Blob([this.hsDownload], { type: this.mimeType });
        const url = URL.createObjectURL(data);
        if (this.exportedHref) {
            URL.revokeObjectURL(this.exportedHref);
        }
        this.exportedHref = this.DomSanitizer.bypassSecurityTrustResourceUrl(url);
        //Timeout is needed, otherwise the hsDownload will be from previous digest i.e undefined
        setTimeout(() => {
            this.downloadPrepared.emit(this.exportedHref);
        }, 0);
    }
}
HsDownloadDirective.ɵfac = function HsDownloadDirective_Factory(t) { return new (t || HsDownloadDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc4.DomSanitizer)); };
HsDownloadDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: HsDownloadDirective, selectors: [["", "hsDownload", ""]], inputs: { hsDownload: "hsDownload", mimeType: "mimeType" }, outputs: { downloadPrepared: "downloadPrepared" }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
HsDownloadDirective.ctorParameters = () => [
    { type: DomSanitizer }
];
HsDownloadDirective.propDecorators = {
    hsDownload: [{ type: Input }],
    mimeType: [{ type: Input }],
    downloadPrepared: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsDownloadDirective, [{
        type: Directive,
        args: [{
                selector: '[hsDownload]'
            }]
    }], function () { return [{ type: ɵngcc4.DomSanitizer }]; }, { hsDownload: [{
            type: Input
        }], mimeType: [{
            type: Input
        }], downloadPrepared: [{
            type: Output
        }] }); })();

class HsDownloadModule {
}
HsDownloadModule.ɵfac = function HsDownloadModule_Factory(t) { return new (t || HsDownloadModule)(); };
HsDownloadModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: HsDownloadModule });
HsDownloadModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [], imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsDownloadModule, [{
        type: NgModule,
        args: [{
                declarations: [HsDownloadDirective],
                imports: [CommonModule],
                providers: [],
                entryComponents: [],
                exports: [HsDownloadDirective]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(HsDownloadModule, { declarations: function () { return [HsDownloadDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [HsDownloadDirective]; } }); })();

class HsFillSymbolizerComponent extends HsStylerPartBaseComponent {
    addSymbolizer(attribute, kind) {
        this.symbolizer[attribute] = { kind };
        this.menuRef.close();
    }
    opacityFix() {
        this.symbolizer.fillOpacity = this.symbolizer.opacity;
    }
}
HsFillSymbolizerComponent.ɵfac = /*@__PURE__*/ function () { let ɵHsFillSymbolizerComponent_BaseFactory; return function HsFillSymbolizerComponent_Factory(t) { return (ɵHsFillSymbolizerComponent_BaseFactory || (ɵHsFillSymbolizerComponent_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(HsFillSymbolizerComponent)))(t || HsFillSymbolizerComponent); }; }();
HsFillSymbolizerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsFillSymbolizerComponent, selectors: [["hs-fill-symbolizer"]], viewQuery: function HsFillSymbolizerComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c52, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.menuRef = _t.first);
    } }, inputs: { symbolizer: "symbolizer" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 29, vars: 27, consts: [[1, "form"], ["attribute", "color", "opacityAttribute", "opacity", 3, "symbolizer", "label", "changes"], ["attribute", "opacity", "step", "0.05", "min", "0", "max", "1", 3, "symbolizer", "label", "changes"], ["attribute", "outlineColor", "opacityAttribute", "outlineOpacity", 3, "symbolizer", "label", "changes"], ["attribute", "outlineOpacity", "step", "0.05", "min", "0", "max", "1", 3, "symbolizer", "label", "changes"], ["attribute", "outlineWidth", "step", "0.1", "min", "0", "max", "20", 3, "symbolizer", "label", "changes"], [1, "d-flex", "flex-row", "justify-content-end"], [1, "p-1", "flex-grow-1"], [1, "badge", "badge-warning", "mt-2", 3, "title"], [1, "p-1"], ["ngbDropdown", "", "placement", "top-right", 1, "d-inline-block"], ["graphicFillMenu", "ngbDropdown"], ["id", "dropdownAddFillSymbolizer", "ngbDropdownToggle", "", 1, "btn", "btn-outline-primary", "btn-sm"], [1, "icon-plus"], ["ngbDropdownMenu", "", "aria-labelledby", "dropdownAddFillSymbolizer"], ["ngbDropdownItem", "", 3, "click"], [3, "symbolizer", "changes", "remove", 4, "ngIf"], [3, "symbolizer", "changes", "remove"]], template: function HsFillSymbolizerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "form", 0);
        ɵngcc0.ɵɵelementStart(1, "hs-symbolizer-color-picker", 1);
        ɵngcc0.ɵɵlistener("changes", function HsFillSymbolizerComponent_Template_hs_symbolizer_color_picker_changes_1_listener() { ctx.opacityFix(); return ctx.emitChange(); });
        ɵngcc0.ɵɵpipe(2, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "hs-symbolizer-slider", 2);
        ɵngcc0.ɵɵlistener("changes", function HsFillSymbolizerComponent_Template_hs_symbolizer_slider_changes_3_listener() { ctx.opacityFix(); return ctx.emitChange(); });
        ɵngcc0.ɵɵpipe(4, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "hs-symbolizer-color-picker", 3);
        ɵngcc0.ɵɵlistener("changes", function HsFillSymbolizerComponent_Template_hs_symbolizer_color_picker_changes_5_listener() { return ctx.emitChange(); });
        ɵngcc0.ɵɵpipe(6, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "hs-symbolizer-slider", 4);
        ɵngcc0.ɵɵlistener("changes", function HsFillSymbolizerComponent_Template_hs_symbolizer_slider_changes_7_listener() { return ctx.emitChange(); });
        ɵngcc0.ɵɵpipe(8, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "hs-symbolizer-slider", 5);
        ɵngcc0.ɵɵlistener("changes", function HsFillSymbolizerComponent_Template_hs_symbolizer_slider_changes_9_listener() { return ctx.emitChange(); });
        ɵngcc0.ɵɵpipe(10, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "div", 6);
        ɵngcc0.ɵɵelementStart(12, "div", 7);
        ɵngcc0.ɵɵtext(13);
        ɵngcc0.ɵɵpipe(14, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(15, "span", 8);
        ɵngcc0.ɵɵpipe(16, "translate");
        ɵngcc0.ɵɵtext(17, "!");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(18, "div", 9);
        ɵngcc0.ɵɵelementStart(19, "div", 10, 11);
        ɵngcc0.ɵɵelementStart(21, "button", 12);
        ɵngcc0.ɵɵelement(22, "span", 13);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(23, "div", 14);
        ɵngcc0.ɵɵelementStart(24, "button", 15);
        ɵngcc0.ɵɵlistener("click", function HsFillSymbolizerComponent_Template_button_click_24_listener() { return ctx.addSymbolizer("graphicFill", "Mark"); });
        ɵngcc0.ɵɵtext(25, "Mark");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(26, "button", 15);
        ɵngcc0.ɵɵlistener("click", function HsFillSymbolizerComponent_Template_button_click_26_listener() { return ctx.addSymbolizer("graphicFill", "Icon"); });
        ɵngcc0.ɵɵtext(27, "Icon");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(28, HsFillSymbolizerComponent_hs_symbolizer_28_Template, 1, 1, "hs-symbolizer", 16);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵpropertyInterpolate("label", ɵngcc0.ɵɵpipeBind1(2, 13, "STYLER.fillColor"));
        ɵngcc0.ɵɵproperty("symbolizer", ctx.symbolizer);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵpropertyInterpolate("label", ɵngcc0.ɵɵpipeBind1(4, 15, "STYLER.opacity"));
        ɵngcc0.ɵɵproperty("symbolizer", ctx.symbolizer);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵpropertyInterpolate("label", ɵngcc0.ɵɵpipeBind1(6, 17, "STYLER.outlineColor"));
        ɵngcc0.ɵɵproperty("symbolizer", ctx.symbolizer);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵpropertyInterpolate("label", ɵngcc0.ɵɵpipeBind1(8, 19, "STYLER.outlineOpacity"));
        ɵngcc0.ɵɵproperty("symbolizer", ctx.symbolizer);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵpropertyInterpolate("label", ɵngcc0.ɵɵpipeBind1(10, 21, "STYLER.outlineWidth"));
        ɵngcc0.ɵɵproperty("symbolizer", ctx.symbolizer);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(14, 23, "STYLER.graphicFill"), ":");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵpropertyInterpolate("title", ɵngcc0.ɵɵpipeBind1(16, 25, "STYLER.warningAttribStoredNotVisualized"));
        ɵngcc0.ɵɵadvance(13);
        ɵngcc0.ɵɵproperty("ngIf", ctx.symbolizer.graphicFill !== undefined);
    } }, directives: function () { return [ɵngcc5.ɵNgNoValidate, ɵngcc5.NgControlStatusGroup, ɵngcc5.NgForm, HsColorPickerComponent, HsSliderComponent, ɵngcc6.NgbDropdown, ɵngcc6.NgbDropdownToggle, ɵngcc6.NgbDropdownMenu, ɵngcc6.NgbDropdownItem, ɵngcc3.NgIf, HsSymbolizerComponent]; }, pipes: function () { return [ɵngcc1.TranslatePipe]; }, encapsulation: 2 });
HsFillSymbolizerComponent.propDecorators = {
    symbolizer: [{ type: Input }],
    menuRef: [{ type: ViewChild, args: ['graphicFillMenu',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsFillSymbolizerComponent, [{
        type: Component,
        args: [{
                selector: 'hs-fill-symbolizer',
                template: "<form class=\"form\">\n  <hs-symbolizer-color-picker [symbolizer]=\"symbolizer\" attribute=\"color\" opacityAttribute=\"opacity\"\n    (changes)=\"opacityFix(); emitChange()\" label=\"{{'STYLER.fillColor' | translate}}\"></hs-symbolizer-color-picker>\n\n  <hs-symbolizer-slider [symbolizer]=\"symbolizer\" attribute=\"opacity\" (changes)=\"opacityFix(); emitChange()\" step=\"0.05\"\n    min=\"0\" max=\"1\" label=\"{{'STYLER.opacity' | translate}}\"></hs-symbolizer-slider>\n\n  <hs-symbolizer-color-picker [symbolizer]=\"symbolizer\" attribute=\"outlineColor\" opacityAttribute=\"outlineOpacity\"\n    (changes)=\"emitChange()\" label=\"{{'STYLER.outlineColor' | translate}}\"></hs-symbolizer-color-picker>\n\n  <hs-symbolizer-slider [symbolizer]=\"symbolizer\" attribute=\"outlineOpacity\" (changes)=\"emitChange()\" step=\"0.05\"\n    min=\"0\" max=\"1\" label=\"{{'STYLER.outlineOpacity' | translate}}\"></hs-symbolizer-slider>\n\n  <hs-symbolizer-slider [symbolizer]=\"symbolizer\" attribute=\"outlineWidth\" (changes)=\"emitChange()\" step=\"0.1\" min=\"0\"\n    max=\"20\" label=\"{{'STYLER.outlineWidth' | translate}}\"></hs-symbolizer-slider>\n\n  <div class=\"d-flex flex-row justify-content-end\">\n    <div class=\"p-1 flex-grow-1\">{{'STYLER.graphicFill' | translate}}:</div>\n    <span class=\"badge badge-warning mt-2\" title=\"{{'STYLER.warningAttribStoredNotVisualized' | translate}}\">!</span>\n    <div class=\"p-1\">\n      <div ngbDropdown #graphicFillMenu=\"ngbDropdown\" class=\"d-inline-block\" placement=\"top-right\">\n        <button class=\"btn btn-outline-primary btn-sm\" id=\"dropdownAddFillSymbolizer\" ngbDropdownToggle>\n          <span class=\"icon-plus\"></span>\n        </button>\n        <div ngbDropdownMenu aria-labelledby=\"dropdownAddFillSymbolizer\">\n          <button ngbDropdownItem (click)=\"addSymbolizer('graphicFill', 'Mark')\">Mark</button>\n          <button ngbDropdownItem (click)=\"addSymbolizer('graphicFill', 'Icon')\">Icon</button>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <hs-symbolizer *ngIf=\"symbolizer.graphicFill !== undefined\" [symbolizer]=\"symbolizer.graphicFill\"\n    (changes)=\"emitChange()\" (remove)=\"symbolizer.graphicFill = undefined\"></hs-symbolizer>\n</form>"
            }]
    }], null, { symbolizer: [{
            type: Input
        }], menuRef: [{
            type: ViewChild,
            args: ['graphicFillMenu']
        }] }); })();

class HsFiltersService {
    add(kind, append, collection) {
        let filter;
        switch (kind) {
            case 'AND':
                filter = ['&&', ['==', '<attribute>', '<value>']];
                break;
            case 'OR':
                filter = ['||', ['==', '<attribute>', '<value>']];
                break;
            case 'COMPARE':
                filter = ['==', '<attribute>', '<value>'];
                break;
            default:
        }
        if (append) {
            collection.push(filter);
        }
        else {
            collection.length = 0;
            collection.push(...filter);
        }
    }
    humanReadableLogOp(logOp) {
        return { '&&': 'AND', '||': 'OR', '!': 'NOT' }[logOp];
    }
    isLogOp(filters) {
        return (filters === null || filters === void 0 ? void 0 : filters.length) > 0 && ['&&', '||'].includes(filters[0]);
    }
}
HsFiltersService.ɵfac = function HsFiltersService_Factory(t) { return new (t || HsFiltersService)(); };
HsFiltersService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HsFiltersService_Factory() { return new HsFiltersService(); }, token: HsFiltersService, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsFiltersService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], null, null); })();

class HsFilterComponent extends HsStylerPartBaseComponent {
    constructor(hsFiltersService) {
        super();
        this.hsFiltersService = hsFiltersService;
    }
    remove() {
        this.parent.splice(this.parent.indexOf(this.filter), 1);
        this.emitChange();
    }
}
HsFilterComponent.ɵfac = function HsFilterComponent_Factory(t) { return new (t || HsFilterComponent)(ɵngcc0.ɵɵdirectiveInject(HsFiltersService)); };
HsFilterComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsFilterComponent, selectors: [["hs-filter"]], inputs: { filter: "filter", parent: "parent" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 3, vars: 2, consts: [["class", "card m-2", 4, "ngIf"], [3, "filter", "parent", "changes", 4, "ngIf"], [1, "card", "m-2"], [1, "d-flex", "flex-row", "card-header", "p-0"], [1, "p-2"], [3, "clicks"], [1, "btn", "btn-outline-danger", "btn-sm", "m-1", 3, "title", "click"], [1, "icon-trash"], ["class", "d-flex flex-row", 4, "ngFor", "ngForOf"], [1, "d-flex", "flex-row"], [3, "filter", "parent", 4, "ngIf"], [3, "filter", "parent"], [3, "filter", "parent", "changes"]], template: function HsFilterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵtemplate(1, HsFilterComponent_div_1_Template, 9, 5, "div", 0);
        ɵngcc0.ɵɵtemplate(2, HsFilterComponent_hs_comparison_filter_2_Template, 1, 2, "hs-comparison-filter", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hsFiltersService.isLogOp(ctx.filter));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.filter.length > 1 && !ctx.hsFiltersService.isLogOp(ctx.filter));
    } }, directives: [ɵngcc3.NgIf, HsAddFilterButtonComponent, ɵngcc3.NgForOf, HsFilterComponent, HsComparisonFilterComponent], pipes: [ɵngcc1.TranslatePipe], encapsulation: 2 });
HsFilterComponent.ctorParameters = () => [
    { type: HsFiltersService }
];
HsFilterComponent.propDecorators = {
    filter: [{ type: Input }],
    parent: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsFilterComponent, [{
        type: Component,
        args: [{
                selector: 'hs-filter',
                template: "<div>\n  <div *ngIf=\"hsFiltersService.isLogOp(filter)\" class=\"card m-2\">\n    <div class=\"d-flex flex-row card-header p-0\">\n      <div class=\"p-2\">{{hsFiltersService.humanReadableLogOp(filter[0])}}</div>\n      <hs-add-filter-button (clicks)=\"hsFiltersService.add($event.kind, true, filter)\"></hs-add-filter-button>\n      <button class=\"btn btn-outline-danger btn-sm m-1\" [title]=\"'STYLER.removeFilter' | translate\" (click)=\"remove()\">\n        <span class=\"icon-trash\"></span>\n      </button>\n    </div>\n    <div class=\"d-flex flex-row\" *ngFor=\"let item of filter; let i = index\">\n      <hs-filter *ngIf=\"i>0\" [filter]=\"item\" [parent]=\"filter\"></hs-filter>\n    </div>\n  </div>\n  <hs-comparison-filter *ngIf=\"filter.length > 1 && !(hsFiltersService.isLogOp(filter))\" [filter]=\"filter\"\n    (changes)=\"emitChange()\" [parent]=\"parent\"></hs-comparison-filter>\n</div>"
            }]
    }], function () { return [{ type: HsFiltersService }]; }, { filter: [{
            type: Input
        }], parent: [{
            type: Input
        }] }); })();

class HsFiltersComponent extends HsStylerPartBaseComponent {
    constructor(hsFiltersService) {
        super();
        this.hsFiltersService = hsFiltersService;
    }
    add(kind, append) {
        if (this.rule.filter == undefined) {
            this.rule.filter = [];
        }
        this.hsFiltersService.add(kind, append, this.rule.filter);
    }
    remove() {
        delete this.rule.filter;
        this.emitChange();
    }
}
HsFiltersComponent.ɵfac = function HsFiltersComponent_Factory(t) { return new (t || HsFiltersComponent)(ɵngcc0.ɵɵdirectiveInject(HsFiltersService)); };
HsFiltersComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsFiltersComponent, selectors: [["hs-filters"]], inputs: { rule: "rule" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 5, vars: 2, consts: [[1, "d-flex", "flex-row", "justify-content-end"], [3, "clicks"], ["class", "card", 4, "ngIf"], [3, "filter", "changes", 4, "ngIf"], [1, "card"], [1, "d-flex", "flex-row", "card-header", "p-0"], [1, "p-2"], [1, "btn", "btn-outline-danger", "btn-sm", "m-1", 3, "title", "click"], [1, "icon-trash"], ["class", "d-flex flex-row", 4, "ngFor", "ngForOf"], [1, "d-flex", "flex-row"], [3, "filter", "parent", "changes", 4, "ngIf"], [3, "filter", "parent", "changes"], [3, "filter", "changes"]], template: function HsFiltersComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵelementStart(1, "div", 0);
        ɵngcc0.ɵɵelementStart(2, "hs-add-filter-button", 1);
        ɵngcc0.ɵɵlistener("clicks", function HsFiltersComponent_Template_hs_add_filter_button_clicks_2_listener($event) { return ctx.add($event.kind, false); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(3, HsFiltersComponent_div_3_Template, 8, 3, "div", 2);
        ɵngcc0.ɵɵtemplate(4, HsFiltersComponent_hs_comparison_filter_4_Template, 1, 1, "hs-comparison-filter", 3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hsFiltersService.isLogOp(ctx.rule.filter));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", (ctx.rule.filter == null ? null : ctx.rule.filter.length) > 0 && !ctx.hsFiltersService.isLogOp(ctx.rule.filter));
    } }, directives: [HsAddFilterButtonComponent, ɵngcc3.NgIf, ɵngcc3.NgForOf, HsFilterComponent, HsComparisonFilterComponent], encapsulation: 2 });
HsFiltersComponent.ctorParameters = () => [
    { type: HsFiltersService }
];
HsFiltersComponent.propDecorators = {
    rule: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsFiltersComponent, [{
        type: Component,
        args: [{
                selector: 'hs-filters',
                template: "<div>\n  <div class=\"d-flex flex-row justify-content-end\">\n    <hs-add-filter-button (clicks)=\"add($event.kind, false)\"></hs-add-filter-button>\n  </div>\n  <div *ngIf=\"hsFiltersService.isLogOp(rule.filter)\" class=\"card\">\n    <div class=\"d-flex flex-row card-header p-0\">\n      <div class=\"p-2\">\n        {{hsFiltersService.humanReadableLogOp(rule.filter[0])}}\n      </div>\n      <hs-add-filter-button (clicks)=\"add($event.kind, true)\"></hs-add-filter-button>\n      <button class=\"btn btn-outline-danger btn-sm m-1\" [title]=\"'STYLER.removeFilter'\" (click)=\"remove()\">\n        <span class=\"icon-trash\"></span>\n      </button>\n    </div>\n    <div class=\"d-flex flex-row\" *ngFor=\"let item of rule.filter; let i = index\">\n      <hs-filter (changes)=\"emitChange()\" *ngIf=\"i>0\" [filter]=\"item\" [parent]=\"rule.filter\"></hs-filter>\n    </div>\n  </div>\n  <hs-comparison-filter *ngIf=\"rule.filter?.length > 0 && !(hsFiltersService.isLogOp(rule.filter))\"\n    (changes)=\"emitChange()\" [filter]=\"rule.filter\"></hs-comparison-filter>\n</div>"
            }]
    }], function () { return [{ type: HsFiltersService }]; }, { rule: [{
            type: Input
        }] }); })();

class HsSelectIconDialogComponent {
    constructor(hsDialogContainerService, hsConfig) {
        this.hsDialogContainerService = hsDialogContainerService;
        this.hsConfig = hsConfig;
    }
    cancel() {
        this.data.selectedIcon = null;
        this.hsDialogContainerService.destroy(this);
    }
    confirm() {
        if (this.data.selectedIcon) {
            this.data.symbolizer.image = this.data.selectedIcon.url;
            this.data.emitChange();
        }
        this.hsDialogContainerService.destroy(this);
    }
    iconSelected(icon) {
        this.data.selectedIcon = icon;
    }
}
HsSelectIconDialogComponent.ɵfac = function HsSelectIconDialogComponent_Factory(t) { return new (t || HsSelectIconDialogComponent)(ɵngcc0.ɵɵdirectiveInject(HsDialogContainerService), ɵngcc0.ɵɵdirectiveInject(HsConfig)); };
HsSelectIconDialogComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsSelectIconDialogComponent, selectors: [["hs-select-icon-dialog"]], decls: 24, vars: 13, consts: [["tabindex", "-1", "role", "dialog", "aria-hidden", "true", 1, "modal", "in", "hs-select-icon"], [1, "modal-dialog"], [1, "modal-content"], [1, "modal-header", "d-flex", "flex-column"], [1, "d-flex", "w-100", "align-items-center"], [1, "modal-title"], ["type", "button", "data-dismiss", "modal", 1, "close", 3, "click"], ["aria-hidden", "true"], [1, "sr-only"], [1, "modal-body", 2, "max-height", "400px", "overflow-y", "auto"], [1, "d-flex", "flex-wrap"], ["class", "p-1", 3, "ngClass", "click", 4, "ngFor", "ngForOf"], [1, "modal-footer"], ["type", "button", "data-dismiss", "modal", 1, "btn", "btn-primary", 3, "click"], [1, "p-1", 3, "ngClass", "click"], [3, "src"]], template: function HsSelectIconDialogComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelementStart(4, "div", 4);
        ɵngcc0.ɵɵelementStart(5, "h4", 5);
        ɵngcc0.ɵɵtext(6);
        ɵngcc0.ɵɵpipe(7, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "button", 6);
        ɵngcc0.ɵɵlistener("click", function HsSelectIconDialogComponent_Template_button_click_8_listener() { return ctx.cancel(); });
        ɵngcc0.ɵɵelementStart(9, "span", 7);
        ɵngcc0.ɵɵtext(10, "\u00D7");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "span", 8);
        ɵngcc0.ɵɵtext(12);
        ɵngcc0.ɵɵpipe(13, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(14, "div", 9);
        ɵngcc0.ɵɵelementStart(15, "div", 10);
        ɵngcc0.ɵɵtemplate(16, HsSelectIconDialogComponent_div_16_Template, 2, 4, "div", 11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(17, "div", 12);
        ɵngcc0.ɵɵelementStart(18, "button", 13);
        ɵngcc0.ɵɵlistener("click", function HsSelectIconDialogComponent_Template_button_click_18_listener() { return ctx.confirm(); });
        ɵngcc0.ɵɵtext(19);
        ɵngcc0.ɵɵpipe(20, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(21, "button", 13);
        ɵngcc0.ɵɵlistener("click", function HsSelectIconDialogComponent_Template_button_click_21_listener() { return ctx.cancel(); });
        ɵngcc0.ɵɵtext(22);
        ɵngcc0.ɵɵpipe(23, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(7, 5, "STYLER.selectIcon"));
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(13, 7, "COMMON.close"));
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.hsConfig.symbolizerIcons);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(20, 9, "COMMON.ok"), " ");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(23, 11, "COMMON.cancel"), " ");
    } }, directives: [ɵngcc3.NgForOf, ɵngcc3.NgClass], pipes: [ɵngcc1.TranslatePipe], encapsulation: 2 });
HsSelectIconDialogComponent.ctorParameters = () => [
    { type: HsDialogContainerService },
    { type: HsConfig }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsSelectIconDialogComponent, [{
        type: Component,
        args: [{
                selector: 'hs-select-icon-dialog',
                template: "<div class=\"modal in hs-select-icon\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\">\n  <div class=\"modal-dialog\">\n    <div class=\"modal-content\">\n      <div class=\"modal-header d-flex flex-column\">\n        <div class=\"d-flex w-100 align-items-center\">\n          <h4 class=\"modal-title\">{{'STYLER.selectIcon' | translate}}</h4>\n          <button type=\"button\" (click)=\"cancel()\" class=\"close\" data-dismiss=\"modal\">\n            <span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">{{'COMMON.close' | translate}}</span>\n          </button>\n        </div>\n      </div>\n      <div class=\"modal-body\" style=\"max-height: 400px; overflow-y: auto\">\n        <div class=\"d-flex flex-wrap\">\n          <div *ngFor=\"let icon of hsConfig.symbolizerIcons\" [ngClass]=\"{'bg-primary': data.selectedIcon === icon}\"\n            class=\"p-1\" (click)=\"iconSelected(icon)\">\n            <img [src]=\"icon.url\" />\n          </div>\n        </div>\n      </div>\n      <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\" (click)=\"confirm()\">\n          {{'COMMON.ok' | translate}}\n        </button>\n        <button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\" (click)=\"cancel()\">\n          {{'COMMON.cancel' | translate}}\n        </button>\n      </div>\n    </div>\n  </div>\n</div>"
            }]
    }], function () { return [{ type: HsDialogContainerService }, { type: HsConfig }]; }, null); })();

class HsIconSymbolizerComponent extends HsStylerPartBaseComponent {
    constructor(hsDialogContainerService) {
        super();
        this.hsDialogContainerService = hsDialogContainerService;
        this.anchors = [
            'center',
            'left',
            'right',
            'top',
            'bottom',
            'top-left',
            'top-right',
            'bottom-left',
            'bottom-right',
        ];
    }
    showIconSelector() {
        this.hsDialogContainerService.create(HsSelectIconDialogComponent, this);
    }
}
HsIconSymbolizerComponent.ɵfac = function HsIconSymbolizerComponent_Factory(t) { return new (t || HsIconSymbolizerComponent)(ɵngcc0.ɵɵdirectiveInject(HsDialogContainerService)); };
HsIconSymbolizerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsIconSymbolizerComponent, selectors: [["hs-icon-symbolizer"]], inputs: { symbolizer: "symbolizer" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 41, vars: 36, consts: [[1, "form"], [1, "d-flex", "flex-row"], [1, "p-1", "w-25"], [1, "p-1", "w-75"], [1, "input-group", "mb-3"], [1, "form-control", 3, "ngModelOptions", "ngModel", "ngModelChange", "change"], [1, "input-group-append"], ["type", "button", 1, "btn", "btn-outline-secondary", 3, "click"], [1, "p-1", "w-25", "mt-2"], [1, "badge", "badge-warning", "mt-2", 3, "title"], [1, "form-control", 3, "ngModel", "ngModelOptions", "ngModelChange", "change"], [4, "ngFor", "ngForOf"], ["type", "range", "step", "0.05", "min", "0", "max", "1", 1, "form-control", 3, "ngModelOptions", "ngModel", "ngModelChange", "change"], ["type", "range", "step", "0.2", "min", "0.1", "max", "10", 1, "form-control", 3, "ngModelOptions", "ngModel", "ngModelChange", "change"], ["class", "d-flex flex-row", 4, "ngIf"], ["type", "range", "step", "1", "min", "0", "max", "360", 1, "form-control", 3, "ngModelOptions", "ngModel", "ngModelChange", "change"], ["class", "form-control", "type", "range", "step", "0.05", "min", "-1.0", "max", "1.0", 3, "ngModelOptions", "ngModel", "ngModelChange", "change", 4, "ngIf"], ["type", "range", "step", "0.05", "min", "-1.0", "max", "1.0", 1, "form-control", 3, "ngModelOptions", "ngModel", "ngModelChange", "change"]], template: function HsIconSymbolizerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "form", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵpipe(4, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 3);
        ɵngcc0.ɵɵelementStart(6, "div", 4);
        ɵngcc0.ɵɵelementStart(7, "input", 5);
        ɵngcc0.ɵɵlistener("ngModelChange", function HsIconSymbolizerComponent_Template_input_ngModelChange_7_listener($event) { return ctx.symbolizer.image = $event; })("change", function HsIconSymbolizerComponent_Template_input_change_7_listener() { return ctx.emitChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "div", 6);
        ɵngcc0.ɵɵelementStart(9, "button", 7);
        ɵngcc0.ɵɵlistener("click", function HsIconSymbolizerComponent_Template_button_click_9_listener() { return ctx.showIconSelector(); });
        ɵngcc0.ɵɵtext(10, " ... ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "div", 1);
        ɵngcc0.ɵɵelementStart(12, "div", 8);
        ɵngcc0.ɵɵtext(13);
        ɵngcc0.ɵɵpipe(14, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(15, "span", 9);
        ɵngcc0.ɵɵpipe(16, "translate");
        ɵngcc0.ɵɵtext(17, "!");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(18, "div", 3);
        ɵngcc0.ɵɵelementStart(19, "select", 10);
        ɵngcc0.ɵɵlistener("ngModelChange", function HsIconSymbolizerComponent_Template_select_ngModelChange_19_listener($event) { return ctx.symbolizer.anchor = $event; })("change", function HsIconSymbolizerComponent_Template_select_change_19_listener() { return ctx.emitChange(); });
        ɵngcc0.ɵɵtemplate(20, HsIconSymbolizerComponent_option_20_Template, 2, 1, "option", 11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(21, "div", 1);
        ɵngcc0.ɵɵelementStart(22, "div", 2);
        ɵngcc0.ɵɵtext(23);
        ɵngcc0.ɵɵpipe(24, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(25, "div", 3);
        ɵngcc0.ɵɵelementStart(26, "input", 12);
        ɵngcc0.ɵɵlistener("ngModelChange", function HsIconSymbolizerComponent_Template_input_ngModelChange_26_listener($event) { return ctx.symbolizer.opacity = $event; })("change", function HsIconSymbolizerComponent_Template_input_change_26_listener() { return ctx.emitChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(27, "div", 1);
        ɵngcc0.ɵɵelementStart(28, "div", 2);
        ɵngcc0.ɵɵtext(29);
        ɵngcc0.ɵɵpipe(30, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(31, "div", 3);
        ɵngcc0.ɵɵelementStart(32, "input", 13);
        ɵngcc0.ɵɵlistener("ngModelChange", function HsIconSymbolizerComponent_Template_input_ngModelChange_32_listener($event) { return ctx.symbolizer.size = $event; })("change", function HsIconSymbolizerComponent_Template_input_change_32_listener() { return ctx.emitChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(33, HsIconSymbolizerComponent_div_33_Template, 9, 7, "div", 14);
        ɵngcc0.ɵɵtemplate(34, HsIconSymbolizerComponent_div_34_Template, 9, 7, "div", 14);
        ɵngcc0.ɵɵelementStart(35, "div", 1);
        ɵngcc0.ɵɵelementStart(36, "div", 2);
        ɵngcc0.ɵɵtext(37);
        ɵngcc0.ɵɵpipe(38, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(39, "div", 3);
        ɵngcc0.ɵɵelementStart(40, "input", 15);
        ɵngcc0.ɵɵlistener("ngModelChange", function HsIconSymbolizerComponent_Template_input_ngModelChange_40_listener($event) { return ctx.symbolizer.rotate = $event; })("change", function HsIconSymbolizerComponent_Template_input_change_40_listener() { return ctx.emitChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(4, 19, "STYLER.source"), ":");
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngModelOptions", ɵngcc0.ɵɵpureFunction0(31, _c2))("ngModel", ctx.symbolizer.image);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(14, 21, "STYLER.anchor"), ":");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵpropertyInterpolate("title", ɵngcc0.ɵɵpipeBind1(16, 23, "STYLER.warningAttribNotStoredNotVisualized"));
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngModel", ctx.symbolizer.anchor)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(32, _c2));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.anchors);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(24, 25, "STYLER.opacity"), ":");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngModelOptions", ɵngcc0.ɵɵpureFunction0(33, _c2))("ngModel", ctx.symbolizer.opacity);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(30, 27, "STYLER.size"), ":");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngModelOptions", ɵngcc0.ɵɵpureFunction0(34, _c2))("ngModel", ctx.symbolizer.size);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.symbolizer.offset !== undefined);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.symbolizer.offset !== undefined);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(38, 29, "STYLER.rotation"), ":");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngModelOptions", ɵngcc0.ɵɵpureFunction0(35, _c2))("ngModel", ctx.symbolizer.rotate);
    } }, directives: [ɵngcc5.ɵNgNoValidate, ɵngcc5.NgControlStatusGroup, ɵngcc5.NgForm, ɵngcc5.DefaultValueAccessor, ɵngcc5.NgControlStatus, ɵngcc5.NgModel, ɵngcc5.SelectControlValueAccessor, ɵngcc3.NgForOf, ɵngcc5.RangeValueAccessor, ɵngcc3.NgIf, ɵngcc5.NgSelectOption, ɵngcc5.ɵNgSelectMultipleOption], pipes: [ɵngcc1.TranslatePipe], encapsulation: 2 });
HsIconSymbolizerComponent.ctorParameters = () => [
    { type: HsDialogContainerService }
];
HsIconSymbolizerComponent.propDecorators = {
    symbolizer: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsIconSymbolizerComponent, [{
        type: Component,
        args: [{
                selector: 'hs-icon-symbolizer',
                template: "<form class=\"form\">\n  <div class=\"d-flex flex-row\">\n    <div class=\"p-1 w-25\">{{'STYLER.source' | translate}}:</div>\n    <div class=\"p-1 w-75\">\n      <div class=\"input-group mb-3\">\n        <input class=\"form-control\" [ngModelOptions]=\"{standalone: true}\" [(ngModel)]=\"symbolizer.image\"\n          (change)=\"emitChange()\" />\n        <div class=\"input-group-append\">\n          <button class=\"btn btn-outline-secondary\" (click)=\"showIconSelector()\" type=\"button\">\n            ...\n          </button>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"d-flex flex-row\">\n    <div class=\"p-1 w-25 mt-2\">{{'STYLER.anchor' | translate}}:</div>\n    <span class=\"badge badge-warning mt-2\" title=\"{{'STYLER.warningAttribNotStoredNotVisualized' | translate}}\">!</span>\n    <div class=\"p-1 w-75\">\n      <select class=\"form-control\" [(ngModel)]=\"symbolizer.anchor\" (change)=\"emitChange()\"\n        [ngModelOptions]=\"{standalone: true}\">\n        <option *ngFor=\"let anchor of anchors\">{{anchor}}</option>\n      </select>\n    </div>\n  </div>\n\n  <div class=\"d-flex flex-row\">\n    <div class=\"p-1 w-25\">{{'STYLER.opacity' | translate}}:</div>\n    <div class=\"p-1 w-75\">\n      <input class=\"form-control\" type=\"range\" step=\"0.05\" min=\"0\" max=\"1\" [ngModelOptions]=\"{standalone: true}\"\n        [(ngModel)]=\"symbolizer.opacity\" (change)=\"emitChange()\" />\n    </div>\n  </div>\n\n  <div class=\"d-flex flex-row\">\n    <div class=\"p-1 w-25\">{{'STYLER.size' | translate}}:</div>\n    <div class=\"p-1 w-75\">\n      <input class=\"form-control\" type=\"range\" step=\"0.2\" min=\"0.1\" max=\"10\" [ngModelOptions]=\"{standalone: true}\"\n        [(ngModel)]=\"symbolizer.size\" (change)=\"emitChange()\" />\n    </div>\n  </div>\n\n  <div class=\"d-flex flex-row\" *ngIf=\"symbolizer.offset !== undefined\">\n    <div class=\"p-1 w-25 mt-2\">{{'STYLER.anchorX' | translate}}:</div>\n    <span class=\"badge badge-warning mt-2\" title=\"{{'STYLER.warningAttribNotStoredNotVisualized' | translate}}\">!</span>\n    <div class=\"p-1 w-75\">\n      <input class=\"form-control\" type=\"range\" step=\"0.05\" min=\"-1.0\" max=\"1.0\" [ngModelOptions]=\"{standalone: true}\"\n        [(ngModel)]=\"symbolizer.offset[0]\" *ngIf=\"symbolizer.offset !== undefined\" (change)=\"emitChange()\" />\n    </div>\n  </div>\n\n\n  <div class=\"d-flex flex-row\" *ngIf=\"symbolizer.offset !== undefined\">\n    <div class=\"p-1 w-25 mt-2\">{{'STYLER.anchorY' | translate}}:</div>\n    <span class=\"badge badge-warning mt-2\" title=\"{{'STYLER.warningAttribNotStoredNotVisualized' | translate}}\">!</span>\n    <div class=\"p-1 w-75\">\n      <input class=\"form-control\" type=\"range\" step=\"0.05\" min=\"-1.0\" max=\"1.0\" [ngModelOptions]=\"{standalone: true}\"\n        [(ngModel)]=\"symbolizer.offset[1]\" *ngIf=\"symbolizer.offset !== undefined\" (change)=\"emitChange()\" />\n    </div>\n  </div>\n\n  <div class=\"d-flex flex-row\">\n    <div class=\"p-1 w-25\">{{'STYLER.rotation' | translate}}:</div>\n    <div class=\"p-1 w-75\">\n      <input class=\"form-control\" type=\"range\" step=\"1\" min=\"0\" max=\"360\" [ngModelOptions]=\"{standalone: true}\"\n        [(ngModel)]=\"symbolizer.rotate\" (change)=\"emitChange()\" />\n    </div>\n  </div>\n</form>"
            }]
    }], function () { return [{ type: HsDialogContainerService }]; }, { symbolizer: [{
            type: Input
        }] }); })();

class HsLineSymbolizerComponent extends HsStylerPartBaseComponent {
    constructor() {
        super(...arguments);
        this.caps = ['butt', 'round', 'square'];
        this.joins = ['bevel', 'round', 'miter'];
    }
    addSymbolizer(attribute, kind) {
        this.symbolizer[attribute] = { kind };
        this.lineMenuRef.close();
        this.strokeMenuRef.close();
    }
    addDashItem() {
        if (!this.symbolizer.dasharray) {
            this.symbolizer.dasharray = [1];
        }
        else {
            this.symbolizer.dasharray.push(1);
        }
    }
    removeDashItem() {
        if (this.symbolizer.dasharray.length > 0) {
            this.symbolizer.dasharray.length--;
        }
    }
}
HsLineSymbolizerComponent.ɵfac = /*@__PURE__*/ function () { let ɵHsLineSymbolizerComponent_BaseFactory; return function HsLineSymbolizerComponent_Factory(t) { return (ɵHsLineSymbolizerComponent_BaseFactory || (ɵHsLineSymbolizerComponent_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(HsLineSymbolizerComponent)))(t || HsLineSymbolizerComponent); }; }();
HsLineSymbolizerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsLineSymbolizerComponent, selectors: [["hs-line-symbolizer"]], viewQuery: function HsLineSymbolizerComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c54, 5);
        ɵngcc0.ɵɵviewQuery(_c55, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.lineMenuRef = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.strokeMenuRef = _t.first);
    } }, inputs: { symbolizer: "symbolizer" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 86, vars: 89, consts: [[1, "form"], ["attribute", "color", "opacityAttribute", "opacity", 3, "symbolizer", "label", "changes"], ["attribute", "opacity", "step", "0.05", "min", "0", "max", "1", 3, "symbolizer", "label", "changes"], ["attribute", "width", "step", "0.1", "min", "0", "max", "20", 3, "symbolizer", "label", "changes"], [1, "d-flex", "flex-row", "flex-wrap"], [1, "p-1", "flex-grow-1", "mt-2"], ["class", "form-control mr-1 form-control-sm", "style", "width: 3em", 3, "ngModelOptions", "ngModel", "ngModelChange", "change", 4, "ngFor", "ngForOf"], ["role", "group", 1, "btn-group"], [1, "btn", "btn-outline-primary", "btn-sm", 3, "click"], [1, "icon-plus"], [1, "btn", "btn-outline-danger", "btn-sm", 3, "click"], [1, "icon-minus"], ["attribute", "blur", "step", "0.1", "min", "0", "max", "20", 3, "symbolizer", "label", "warning", "changes"], [1, "d-flex", "flex-row"], [1, "p-1", "w-25", "mt-2"], [1, "p-1", "w-75"], [1, "form-control", "form-control-sm", 3, "ngModel", "ngModelOptions", "ngModelChange", "change"], [4, "ngFor", "ngForOf"], ["attribute", "gapWidth", "step", "1", "min", "0", "max", "10", 3, "symbolizer", "label", "warning", "changes"], ["attribute", "miterLimit", "step", "1", "min", "0", "max", "90", 3, "symbolizer", "label", "warning", "changes"], ["attribute", "perpendicularOffset", "step", "1", "min", "0", "max", "20", 3, "symbolizer", "label", "warning", "changes"], ["attribute", "roundLimit", "step", "1", "min", "0", "max", "90", 3, "symbolizer", "label", "warning", "changes"], ["attribute", "spacing", "step", "1", "min", "0", "max", "20", 3, "symbolizer", "label", "warning", "changes"], [1, "d-flex", "flex-row", "justify-content-end"], [1, "badge", "badge-warning", "mt-2", 3, "title"], [1, "p-1"], ["ngbDropdown", "", "placement", "top-right", 1, "d-inline-block"], ["graphicLineMenu", "ngbDropdown"], ["id", "dropdownAddFillSymbolizer", "ngbDropdownToggle", "", 1, "btn", "btn-outline-primary", "btn-sm"], ["ngbDropdownMenu", "", "aria-labelledby", "dropdownAddFillSymbolizer"], ["ngbDropdownItem", "", 3, "click"], [3, "symbolizer", "changes", "remove", 4, "ngIf"], ["graphicStrokeMenu", "ngbDropdown"], ["id", "dropdownAddStrokeSymbolizer", "ngbDropdownToggle", "", 1, "btn", "btn-outline-primary", "btn-sm"], ["ngbDropdownMenu", "", "aria-labelledby", "dropdownAddStrokeSymbolizer"], [1, "form-control", "mr-1", "form-control-sm", 2, "width", "3em", 3, "ngModelOptions", "ngModel", "ngModelChange", "change"], [3, "symbolizer", "changes", "remove"]], template: function HsLineSymbolizerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "form", 0);
        ɵngcc0.ɵɵelementStart(1, "hs-symbolizer-color-picker", 1);
        ɵngcc0.ɵɵlistener("changes", function HsLineSymbolizerComponent_Template_hs_symbolizer_color_picker_changes_1_listener() { return ctx.emitChange(); });
        ɵngcc0.ɵɵpipe(2, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "hs-symbolizer-slider", 2);
        ɵngcc0.ɵɵlistener("changes", function HsLineSymbolizerComponent_Template_hs_symbolizer_slider_changes_3_listener() { return ctx.emitChange(); });
        ɵngcc0.ɵɵpipe(4, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "hs-symbolizer-slider", 3);
        ɵngcc0.ɵɵlistener("changes", function HsLineSymbolizerComponent_Template_hs_symbolizer_slider_changes_5_listener() { return ctx.emitChange(); });
        ɵngcc0.ɵɵpipe(6, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 4);
        ɵngcc0.ɵɵelementStart(8, "div", 5);
        ɵngcc0.ɵɵtext(9);
        ɵngcc0.ɵɵpipe(10, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(11, HsLineSymbolizerComponent_input_11_Template, 1, 3, "input", 6);
        ɵngcc0.ɵɵelementStart(12, "div", 7);
        ɵngcc0.ɵɵpipe(13, "translate");
        ɵngcc0.ɵɵelementStart(14, "button", 8);
        ɵngcc0.ɵɵlistener("click", function HsLineSymbolizerComponent_Template_button_click_14_listener() { return ctx.addDashItem(); });
        ɵngcc0.ɵɵelement(15, "span", 9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(16, "button", 10);
        ɵngcc0.ɵɵlistener("click", function HsLineSymbolizerComponent_Template_button_click_16_listener() { return ctx.removeDashItem(); });
        ɵngcc0.ɵɵelement(17, "span", 11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(18, "hs-symbolizer-slider", 12);
        ɵngcc0.ɵɵlistener("changes", function HsLineSymbolizerComponent_Template_hs_symbolizer_slider_changes_18_listener() { return ctx.emitChange(); });
        ɵngcc0.ɵɵpipe(19, "translate");
        ɵngcc0.ɵɵpipe(20, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(21, "div", 13);
        ɵngcc0.ɵɵelementStart(22, "div", 14);
        ɵngcc0.ɵɵtext(23);
        ɵngcc0.ɵɵpipe(24, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(25, "div", 15);
        ɵngcc0.ɵɵelementStart(26, "select", 16);
        ɵngcc0.ɵɵlistener("ngModelChange", function HsLineSymbolizerComponent_Template_select_ngModelChange_26_listener($event) { return ctx.symbolizer.cap = $event; })("change", function HsLineSymbolizerComponent_Template_select_change_26_listener() { return ctx.emitChange(); });
        ɵngcc0.ɵɵtemplate(27, HsLineSymbolizerComponent_option_27_Template, 2, 1, "option", 17);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(28, "hs-symbolizer-slider", 18);
        ɵngcc0.ɵɵlistener("changes", function HsLineSymbolizerComponent_Template_hs_symbolizer_slider_changes_28_listener() { return ctx.emitChange(); });
        ɵngcc0.ɵɵpipe(29, "translate");
        ɵngcc0.ɵɵpipe(30, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(31, "div", 13);
        ɵngcc0.ɵɵelementStart(32, "div", 14);
        ɵngcc0.ɵɵtext(33);
        ɵngcc0.ɵɵpipe(34, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(35, "div", 15);
        ɵngcc0.ɵɵelementStart(36, "select", 16);
        ɵngcc0.ɵɵlistener("ngModelChange", function HsLineSymbolizerComponent_Template_select_ngModelChange_36_listener($event) { return ctx.symbolizer.join = $event; })("change", function HsLineSymbolizerComponent_Template_select_change_36_listener() { return ctx.emitChange(); });
        ɵngcc0.ɵɵtemplate(37, HsLineSymbolizerComponent_option_37_Template, 2, 1, "option", 17);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(38, "hs-symbolizer-slider", 19);
        ɵngcc0.ɵɵlistener("changes", function HsLineSymbolizerComponent_Template_hs_symbolizer_slider_changes_38_listener() { return ctx.emitChange(); });
        ɵngcc0.ɵɵpipe(39, "translate");
        ɵngcc0.ɵɵpipe(40, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(41, "hs-symbolizer-slider", 20);
        ɵngcc0.ɵɵlistener("changes", function HsLineSymbolizerComponent_Template_hs_symbolizer_slider_changes_41_listener() { return ctx.emitChange(); });
        ɵngcc0.ɵɵpipe(42, "translate");
        ɵngcc0.ɵɵpipe(43, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(44, "hs-symbolizer-slider", 21);
        ɵngcc0.ɵɵlistener("changes", function HsLineSymbolizerComponent_Template_hs_symbolizer_slider_changes_44_listener() { return ctx.emitChange(); });
        ɵngcc0.ɵɵpipe(45, "translate");
        ɵngcc0.ɵɵpipe(46, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(47, "hs-symbolizer-slider", 22);
        ɵngcc0.ɵɵlistener("changes", function HsLineSymbolizerComponent_Template_hs_symbolizer_slider_changes_47_listener() { return ctx.emitChange(); });
        ɵngcc0.ɵɵpipe(48, "translate");
        ɵngcc0.ɵɵpipe(49, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(50, "div", 23);
        ɵngcc0.ɵɵelementStart(51, "div", 5);
        ɵngcc0.ɵɵtext(52);
        ɵngcc0.ɵɵpipe(53, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(54, "span", 24);
        ɵngcc0.ɵɵpipe(55, "translate");
        ɵngcc0.ɵɵtext(56, "!");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(57, "div", 25);
        ɵngcc0.ɵɵelementStart(58, "div", 26, 27);
        ɵngcc0.ɵɵelementStart(60, "button", 28);
        ɵngcc0.ɵɵelement(61, "span", 9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(62, "div", 29);
        ɵngcc0.ɵɵelementStart(63, "button", 30);
        ɵngcc0.ɵɵlistener("click", function HsLineSymbolizerComponent_Template_button_click_63_listener() { return ctx.addSymbolizer("graphicFill", "Mark"); });
        ɵngcc0.ɵɵtext(64, " Mark ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(65, "button", 30);
        ɵngcc0.ɵɵlistener("click", function HsLineSymbolizerComponent_Template_button_click_65_listener() { return ctx.addSymbolizer("graphicFill", "Icon"); });
        ɵngcc0.ɵɵtext(66, " Icon ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(67, HsLineSymbolizerComponent_hs_symbolizer_67_Template, 1, 1, "hs-symbolizer", 31);
        ɵngcc0.ɵɵelementStart(68, "div", 23);
        ɵngcc0.ɵɵelementStart(69, "div", 5);
        ɵngcc0.ɵɵtext(70);
        ɵngcc0.ɵɵpipe(71, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(72, "span", 24);
        ɵngcc0.ɵɵpipe(73, "translate");
        ɵngcc0.ɵɵtext(74, "!");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(75, "div", 25);
        ɵngcc0.ɵɵelementStart(76, "div", 26, 32);
        ɵngcc0.ɵɵelementStart(78, "button", 33);
        ɵngcc0.ɵɵelement(79, "span", 9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(80, "div", 34);
        ɵngcc0.ɵɵelementStart(81, "button", 30);
        ɵngcc0.ɵɵlistener("click", function HsLineSymbolizerComponent_Template_button_click_81_listener() { return ctx.addSymbolizer("graphicStroke", "Mark"); });
        ɵngcc0.ɵɵtext(82, " Mark ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(83, "button", 30);
        ɵngcc0.ɵɵlistener("click", function HsLineSymbolizerComponent_Template_button_click_83_listener() { return ctx.addSymbolizer("graphicStroke", "Icon"); });
        ɵngcc0.ɵɵtext(84, " Icon ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(85, HsLineSymbolizerComponent_hs_symbolizer_85_Template, 1, 1, "hs-symbolizer", 31);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵpropertyInterpolate("label", ɵngcc0.ɵɵpipeBind1(2, 41, "STYLER.color"));
        ɵngcc0.ɵɵproperty("symbolizer", ctx.symbolizer);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵpropertyInterpolate("label", ɵngcc0.ɵɵpipeBind1(4, 43, "STYLER.opacity"));
        ɵngcc0.ɵɵproperty("symbolizer", ctx.symbolizer);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵpropertyInterpolate("label", ɵngcc0.ɵɵpipeBind1(6, 45, "STYLER.width"));
        ɵngcc0.ɵɵproperty("symbolizer", ctx.symbolizer);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(10, 47, "STYLER.dashPattern"), ":");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.symbolizer.dasharray);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("aria-label", ɵngcc0.ɵɵpipeBind1(13, 49, "STYLER.dashPattern"));
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵpropertyInterpolate("label", ɵngcc0.ɵɵpipeBind1(19, 51, "STYLER.blur"));
        ɵngcc0.ɵɵpropertyInterpolate("warning", ɵngcc0.ɵɵpipeBind1(20, 53, "STYLER.warningAttribNotStoredNotVisualized"));
        ɵngcc0.ɵɵproperty("symbolizer", ctx.symbolizer);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(24, 55, "STYLER.cap"), ":");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngModel", ctx.symbolizer.cap)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(87, _c2));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.caps);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵpropertyInterpolate("label", ɵngcc0.ɵɵpipeBind1(29, 57, "STYLER.gapWidth"));
        ɵngcc0.ɵɵpropertyInterpolate("warning", ɵngcc0.ɵɵpipeBind1(30, 59, "STYLER.warningAttribNotStoredNotVisualized"));
        ɵngcc0.ɵɵproperty("symbolizer", ctx.symbolizer);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(34, 61, "STYLER.join"), ":");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngModel", ctx.symbolizer.join)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(88, _c2));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.joins);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵpropertyInterpolate("label", ɵngcc0.ɵɵpipeBind1(39, 63, "STYLER.miterLimit"));
        ɵngcc0.ɵɵpropertyInterpolate("warning", ɵngcc0.ɵɵpipeBind1(40, 65, "STYLER.warningAttribNotStoredNotVisualized"));
        ɵngcc0.ɵɵproperty("symbolizer", ctx.symbolizer);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵpropertyInterpolate("label", ɵngcc0.ɵɵpipeBind1(42, 67, "STYLER.perpendicularOffset"));
        ɵngcc0.ɵɵpropertyInterpolate("warning", ɵngcc0.ɵɵpipeBind1(43, 69, "STYLER.warningAttribStoredNotVisualized"));
        ɵngcc0.ɵɵproperty("symbolizer", ctx.symbolizer);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵpropertyInterpolate("label", ɵngcc0.ɵɵpipeBind1(45, 71, "STYLER.roundLimit"));
        ɵngcc0.ɵɵpropertyInterpolate("warning", ɵngcc0.ɵɵpipeBind1(46, 73, "STYLER.warningAttribNotStoredNotVisualized"));
        ɵngcc0.ɵɵproperty("symbolizer", ctx.symbolizer);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵpropertyInterpolate("label", ɵngcc0.ɵɵpipeBind1(48, 75, "STYLER.spacing"));
        ɵngcc0.ɵɵpropertyInterpolate("warning", ɵngcc0.ɵɵpipeBind1(49, 77, "STYLER.warningAttribNotStoredNotVisualized"));
        ɵngcc0.ɵɵproperty("symbolizer", ctx.symbolizer);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(53, 79, "STYLER.graphicFill"), ": ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵpropertyInterpolate("title", ɵngcc0.ɵɵpipeBind1(55, 81, "STYLER.warningAttribStoredNotVisualized"));
        ɵngcc0.ɵɵadvance(13);
        ɵngcc0.ɵɵproperty("ngIf", ctx.symbolizer.graphicFill !== undefined);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(71, 83, "STYLER.graphicStroke"), ": ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵpropertyInterpolate("title", ɵngcc0.ɵɵpipeBind1(73, 85, "STYLER.warningAttribStoredNotVisualized"));
        ɵngcc0.ɵɵadvance(13);
        ɵngcc0.ɵɵproperty("ngIf", ctx.symbolizer.graphicStroke !== undefined);
    } }, directives: function () { return [ɵngcc5.ɵNgNoValidate, ɵngcc5.NgControlStatusGroup, ɵngcc5.NgForm, HsColorPickerComponent, HsSliderComponent, ɵngcc3.NgForOf, ɵngcc5.SelectControlValueAccessor, ɵngcc5.NgControlStatus, ɵngcc5.NgModel, ɵngcc6.NgbDropdown, ɵngcc6.NgbDropdownToggle, ɵngcc6.NgbDropdownMenu, ɵngcc6.NgbDropdownItem, ɵngcc3.NgIf, ɵngcc5.DefaultValueAccessor, ɵngcc5.NgSelectOption, ɵngcc5.ɵNgSelectMultipleOption, HsSymbolizerComponent]; }, pipes: function () { return [ɵngcc1.TranslatePipe]; }, encapsulation: 2 });
HsLineSymbolizerComponent.propDecorators = {
    symbolizer: [{ type: Input }],
    lineMenuRef: [{ type: ViewChild, args: ['graphicLineMenu',] }],
    strokeMenuRef: [{ type: ViewChild, args: ['graphicStrokeMenu',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsLineSymbolizerComponent, [{
        type: Component,
        args: [{
                selector: 'hs-line-symbolizer',
                template: "<form class=\"form\">\n  <hs-symbolizer-color-picker [symbolizer]=\"symbolizer\" attribute=\"color\" opacityAttribute=\"opacity\"\n    (changes)=\"emitChange()\" label=\"{{'STYLER.color' | translate}}\"></hs-symbolizer-color-picker>\n\n  <hs-symbolizer-slider [symbolizer]=\"symbolizer\" attribute=\"opacity\" (changes)=\"emitChange()\" step=\"0.05\" min=\"0\"\n    max=\"1\" label=\"{{'STYLER.opacity' | translate}}\"></hs-symbolizer-slider>\n\n  <hs-symbolizer-slider [symbolizer]=\"symbolizer\" attribute=\"width\" (changes)=\"emitChange()\" step=\"0.1\" min=\"0\" max=\"20\"\n    label=\"{{'STYLER.width' | translate}}\"></hs-symbolizer-slider>\n\n  <div class=\"d-flex flex-row flex-wrap\">\n    <div class=\"p-1 flex-grow-1 mt-2\">{{'STYLER.dashPattern' | translate}}:</div>\n    <input class=\"form-control mr-1 form-control-sm\" style=\"width: 3em\"\n      *ngFor=\"let dash of symbolizer.dasharray; let i = index\" [ngModelOptions]=\"{standalone: true}\"\n      [(ngModel)]=\"symbolizer.dasharray[i]\" (change)=\"emitChange()\" />\n    <div class=\"btn-group\" role=\"group\" attr.aria-label=\"{{'STYLER.dashPattern' | translate}}\">\n      <button class=\"btn btn-outline-primary btn-sm\" (click)=\"addDashItem()\">\n        <span class=\"icon-plus\"></span>\n      </button>\n      <button class=\"btn btn-outline-danger btn-sm\" (click)=\"removeDashItem()\">\n        <span class=\"icon-minus\"></span>\n      </button>\n    </div>\n  </div>\n\n  <hs-symbolizer-slider [symbolizer]=\"symbolizer\" attribute=\"blur\" (changes)=\"emitChange()\" step=\"0.1\" min=\"0\" max=\"20\"\n    label=\"{{'STYLER.blur' | translate}}\" warning=\"{{'STYLER.warningAttribNotStoredNotVisualized' | translate}}\">\n  </hs-symbolizer-slider>\n\n  <div class=\"d-flex flex-row\">\n    <div class=\"p-1 w-25 mt-2\">{{'STYLER.cap' | translate}}:</div>\n    <div class=\"p-1 w-75\">\n      <select class=\"form-control form-control-sm\" [(ngModel)]=\"symbolizer.cap\" (change)=\"emitChange()\"\n        [ngModelOptions]=\"{standalone: true}\">\n        <option *ngFor=\"let cap of caps\">{{cap}}</option>\n      </select>\n    </div>\n  </div>\n\n  <hs-symbolizer-slider [symbolizer]=\"symbolizer\" attribute=\"gapWidth\" (changes)=\"emitChange()\" step=\"1\" min=\"0\"\n    max=\"10\" label=\"{{'STYLER.gapWidth' | translate}}\"\n    warning=\"{{'STYLER.warningAttribNotStoredNotVisualized' | translate}}\"></hs-symbolizer-slider>\n\n  <div class=\"d-flex flex-row\">\n    <div class=\"p-1 w-25 mt-2\">{{'STYLER.join' | translate}}:</div>\n    <div class=\"p-1 w-75\">\n      <select class=\"form-control form-control-sm\" [(ngModel)]=\"symbolizer.join\" (change)=\"emitChange()\"\n        [ngModelOptions]=\"{standalone: true}\">\n        <option *ngFor=\"let join of joins\">{{join}}</option>\n      </select>\n    </div>\n  </div>\n\n  <hs-symbolizer-slider [symbolizer]=\"symbolizer\" attribute=\"miterLimit\" (changes)=\"emitChange()\" step=\"1\" min=\"0\"\n    max=\"90\" label=\"{{'STYLER.miterLimit' | translate}}\"\n    warning=\"{{'STYLER.warningAttribNotStoredNotVisualized' | translate}}\"></hs-symbolizer-slider>\n\n  <hs-symbolizer-slider [symbolizer]=\"symbolizer\" attribute=\"perpendicularOffset\" (changes)=\"emitChange()\" step=\"1\"\n    min=\"0\" max=\"20\" label=\"{{'STYLER.perpendicularOffset' | translate}}\"\n    warning=\"{{'STYLER.warningAttribStoredNotVisualized' | translate}}\"></hs-symbolizer-slider>\n\n  <hs-symbolizer-slider [symbolizer]=\"symbolizer\" attribute=\"roundLimit\" (changes)=\"emitChange()\" step=\"1\" min=\"0\"\n    max=\"90\" label=\"{{'STYLER.roundLimit' | translate}}\"\n    warning=\"{{'STYLER.warningAttribNotStoredNotVisualized' | translate}}\"></hs-symbolizer-slider>\n\n  <hs-symbolizer-slider [symbolizer]=\"symbolizer\" attribute=\"spacing\" (changes)=\"emitChange()\" step=\"1\" min=\"0\" max=\"20\"\n    label=\"{{'STYLER.spacing' | translate}}\" warning=\"{{'STYLER.warningAttribNotStoredNotVisualized' | translate}}\">\n  </hs-symbolizer-slider>\n\n  <div class=\"d-flex flex-row justify-content-end\">\n    <div class=\"p-1 flex-grow-1 mt-2\">\n      {{'STYLER.graphicFill' | translate}}:\n    </div>\n    <span class=\"badge badge-warning mt-2\" title=\"{{'STYLER.warningAttribStoredNotVisualized' | translate}}\">!</span>\n    <div class=\"p-1\">\n      <div ngbDropdown #graphicLineMenu=\"ngbDropdown\"  class=\"d-inline-block\" placement=\"top-right\">\n        <button class=\"btn btn-outline-primary btn-sm\" id=\"dropdownAddFillSymbolizer\" ngbDropdownToggle>\n          <span class=\"icon-plus\"></span>\n        </button>\n        <div ngbDropdownMenu aria-labelledby=\"dropdownAddFillSymbolizer\">\n          <button ngbDropdownItem (click)=\"addSymbolizer('graphicFill', 'Mark')\">\n            Mark\n          </button>\n          <button ngbDropdownItem (click)=\"addSymbolizer('graphicFill', 'Icon')\">\n            Icon\n          </button>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <hs-symbolizer *ngIf=\"symbolizer.graphicFill !== undefined\" [symbolizer]=\"symbolizer.graphicFill\"\n    (changes)=\"emitChange()\" (remove)=\"symbolizer.graphicFill = undefined\"></hs-symbolizer>\n\n  <div class=\"d-flex flex-row justify-content-end\">\n    <div class=\"p-1 flex-grow-1 mt-2\">\n      {{'STYLER.graphicStroke' | translate}}:\n    </div>\n    <span class=\"badge badge-warning mt-2\" title=\"{{'STYLER.warningAttribStoredNotVisualized' | translate}}\">!</span>\n    <div class=\"p-1\">\n      <div ngbDropdown #graphicStrokeMenu=\"ngbDropdown\" class=\"d-inline-block\" placement=\"top-right\">\n        <button class=\"btn btn-outline-primary btn-sm\" id=\"dropdownAddStrokeSymbolizer\" ngbDropdownToggle>\n          <span class=\"icon-plus\"></span>\n        </button>\n        <div ngbDropdownMenu aria-labelledby=\"dropdownAddStrokeSymbolizer\">\n          <button ngbDropdownItem (click)=\"addSymbolizer('graphicStroke', 'Mark')\">\n            Mark\n          </button>\n          <button ngbDropdownItem (click)=\"addSymbolizer('graphicStroke', 'Icon')\">\n            Icon\n          </button>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <hs-symbolizer *ngIf=\"symbolizer.graphicStroke !== undefined\" [symbolizer]=\"symbolizer.graphicStroke\"\n    (changes)=\"emitChange()\" (remove)=\"symbolizer.graphicStroke = undefined\"></hs-symbolizer>\n</form>"
            }]
    }], null, { symbolizer: [{
            type: Input
        }], lineMenuRef: [{
            type: ViewChild,
            args: ['graphicLineMenu']
        }], strokeMenuRef: [{
            type: ViewChild,
            args: ['graphicStrokeMenu']
        }] }); })();

class HsMarkSymbolizerComponent extends HsStylerPartBaseComponent {
    constructor() {
        super(...arguments);
        this.wellKnownNames = [
            'circle',
            'square',
            'triangle',
            'star',
            'cross',
            'x',
            'shape://vertline',
            'shape://horline',
            'shape://slash',
            'shape://backslash',
            'shape://dot',
            'shape://plus',
            'shape://times',
            'shape://oarrow',
            'shape://carrow',
        ];
        this.fillColorPickerVisible = false;
        this.strokeColorPickerVisible = false;
    }
}
HsMarkSymbolizerComponent.ɵfac = /*@__PURE__*/ function () { let ɵHsMarkSymbolizerComponent_BaseFactory; return function HsMarkSymbolizerComponent_Factory(t) { return (ɵHsMarkSymbolizerComponent_BaseFactory || (ɵHsMarkSymbolizerComponent_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(HsMarkSymbolizerComponent)))(t || HsMarkSymbolizerComponent); }; }();
HsMarkSymbolizerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsMarkSymbolizerComponent, selectors: [["hs-mark-symbolizer"]], inputs: { symbolizer: "symbolizer" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 22, vars: 35, consts: [[1, "form"], [1, "d-flex", "flex-row"], [1, "p-1", "w-25"], [1, "p-1", "w-75"], [1, "form-control", "form-control-sm", 3, "ngModel", "ngModelOptions", "ngModelChange", "change"], [4, "ngFor", "ngForOf"], ["attribute", "color", "opacityAttribute", "opacity", 3, "symbolizer", "label", "changes"], ["attribute", "opacity", "step", "0.05", "min", "0", "max", "1", 3, "symbolizer", "label", "changes"], ["attribute", "radius", "step", "1", "min", "0", "max", "100", 3, "symbolizer", "label", "changes"], ["attribute", "strokeColor", "opacityAttribute", "strokeOpacity", 3, "symbolizer", "label", "changes"], ["attribute", "strokeOpacity", "step", "0.05", "min", "0", "max", "1", 3, "symbolizer", "label", "changes"], ["attribute", "strokeWidth", "step", "0.1", "min", "0", "max", "20", 3, "symbolizer", "label", "changes"], ["attribute", "rotate", "step", "1", "min", "0", "max", "360", 3, "symbolizer", "label", "changes"]], template: function HsMarkSymbolizerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "form", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵpipe(4, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 3);
        ɵngcc0.ɵɵelementStart(6, "select", 4);
        ɵngcc0.ɵɵlistener("ngModelChange", function HsMarkSymbolizerComponent_Template_select_ngModelChange_6_listener($event) { return ctx.symbolizer.wellKnownName = $event; })("change", function HsMarkSymbolizerComponent_Template_select_change_6_listener() { return ctx.emitChange(); });
        ɵngcc0.ɵɵtemplate(7, HsMarkSymbolizerComponent_option_7_Template, 2, 1, "option", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "hs-symbolizer-color-picker", 6);
        ɵngcc0.ɵɵlistener("changes", function HsMarkSymbolizerComponent_Template_hs_symbolizer_color_picker_changes_8_listener() { return ctx.emitChange(); });
        ɵngcc0.ɵɵpipe(9, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "hs-symbolizer-slider", 7);
        ɵngcc0.ɵɵlistener("changes", function HsMarkSymbolizerComponent_Template_hs_symbolizer_slider_changes_10_listener() { return ctx.emitChange(); });
        ɵngcc0.ɵɵpipe(11, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "hs-symbolizer-slider", 8);
        ɵngcc0.ɵɵlistener("changes", function HsMarkSymbolizerComponent_Template_hs_symbolizer_slider_changes_12_listener() { return ctx.emitChange(); });
        ɵngcc0.ɵɵpipe(13, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(14, "hs-symbolizer-color-picker", 9);
        ɵngcc0.ɵɵlistener("changes", function HsMarkSymbolizerComponent_Template_hs_symbolizer_color_picker_changes_14_listener() { return ctx.emitChange(); });
        ɵngcc0.ɵɵpipe(15, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(16, "hs-symbolizer-slider", 10);
        ɵngcc0.ɵɵlistener("changes", function HsMarkSymbolizerComponent_Template_hs_symbolizer_slider_changes_16_listener() { return ctx.emitChange(); });
        ɵngcc0.ɵɵpipe(17, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(18, "hs-symbolizer-slider", 11);
        ɵngcc0.ɵɵlistener("changes", function HsMarkSymbolizerComponent_Template_hs_symbolizer_slider_changes_18_listener() { return ctx.emitChange(); });
        ɵngcc0.ɵɵpipe(19, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(20, "hs-symbolizer-slider", 12);
        ɵngcc0.ɵɵlistener("changes", function HsMarkSymbolizerComponent_Template_hs_symbolizer_slider_changes_20_listener() { return ctx.emitChange(); });
        ɵngcc0.ɵɵpipe(21, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(4, 18, "STYLER.symbol"), ":");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngModel", ctx.symbolizer.wellKnownName)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(34, _c2));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.wellKnownNames);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵpropertyInterpolate("label", ɵngcc0.ɵɵpipeBind1(9, 20, "STYLER.fillColor"));
        ɵngcc0.ɵɵproperty("symbolizer", ctx.symbolizer);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵpropertyInterpolate("label", ɵngcc0.ɵɵpipeBind1(11, 22, "STYLER.opacity"));
        ɵngcc0.ɵɵproperty("symbolizer", ctx.symbolizer);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵpropertyInterpolate("label", ɵngcc0.ɵɵpipeBind1(13, 24, "STYLER.radius"));
        ɵngcc0.ɵɵproperty("symbolizer", ctx.symbolizer);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵpropertyInterpolate("label", ɵngcc0.ɵɵpipeBind1(15, 26, "STYLER.strokeColor"));
        ɵngcc0.ɵɵproperty("symbolizer", ctx.symbolizer);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵpropertyInterpolate("label", ɵngcc0.ɵɵpipeBind1(17, 28, "STYLER.strokeOpacity"));
        ɵngcc0.ɵɵproperty("symbolizer", ctx.symbolizer);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵpropertyInterpolate("label", ɵngcc0.ɵɵpipeBind1(19, 30, "STYLER.strokeWidth"));
        ɵngcc0.ɵɵproperty("symbolizer", ctx.symbolizer);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵpropertyInterpolate("label", ɵngcc0.ɵɵpipeBind1(21, 32, "STYLER.rotation"));
        ɵngcc0.ɵɵproperty("symbolizer", ctx.symbolizer);
    } }, directives: function () { return [ɵngcc5.ɵNgNoValidate, ɵngcc5.NgControlStatusGroup, ɵngcc5.NgForm, ɵngcc5.SelectControlValueAccessor, ɵngcc5.NgControlStatus, ɵngcc5.NgModel, ɵngcc3.NgForOf, HsColorPickerComponent, HsSliderComponent, ɵngcc5.NgSelectOption, ɵngcc5.ɵNgSelectMultipleOption]; }, pipes: function () { return [ɵngcc1.TranslatePipe]; }, encapsulation: 2 });
HsMarkSymbolizerComponent.propDecorators = {
    symbolizer: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsMarkSymbolizerComponent, [{
        type: Component,
        args: [{
                selector: 'hs-mark-symbolizer',
                template: "<form class=\"form\">\n  <div class=\"d-flex flex-row\">\n    <div class=\"p-1 w-25\">{{'STYLER.symbol' | translate}}:</div>\n    <div class=\"p-1 w-75\">\n      <select class=\"form-control form-control-sm\" [(ngModel)]=\"symbolizer.wellKnownName\" (change)=\"emitChange()\"\n        [ngModelOptions]=\"{standalone: true}\">\n        <option *ngFor=\"let wellKnownName of wellKnownNames\">\n          {{wellKnownName}}\n        </option>\n      </select>\n    </div>\n  </div>\n\n  <hs-symbolizer-color-picker [symbolizer]=\"symbolizer\" attribute=\"color\" opacityAttribute=\"opacity\"\n    (changes)=\"emitChange()\" label=\"{{'STYLER.fillColor' | translate}}\"></hs-symbolizer-color-picker>\n\n  <hs-symbolizer-slider [symbolizer]=\"symbolizer\" attribute=\"opacity\" (changes)=\"emitChange()\" step=\"0.05\" min=\"0\"\n    max=\"1\" label=\"{{'STYLER.opacity' | translate}}\"></hs-symbolizer-slider>\n\n  <hs-symbolizer-slider [symbolizer]=\"symbolizer\" attribute=\"radius\" (changes)=\"emitChange()\" step=\"1\" min=\"0\" max=\"100\"\n    label=\"{{'STYLER.radius' | translate}}\"></hs-symbolizer-slider>\n\n  <hs-symbolizer-color-picker [symbolizer]=\"symbolizer\" attribute=\"strokeColor\" opacityAttribute=\"strokeOpacity\"\n    (changes)=\"emitChange()\" label=\"{{'STYLER.strokeColor' | translate}}\"></hs-symbolizer-color-picker>\n\n  <hs-symbolizer-slider [symbolizer]=\"symbolizer\" attribute=\"strokeOpacity\" (changes)=\"emitChange()\" step=\"0.05\" min=\"0\"\n    max=\"1\" label=\"{{'STYLER.strokeOpacity' | translate}}\"></hs-symbolizer-slider>\n\n  <hs-symbolizer-slider [symbolizer]=\"symbolizer\" attribute=\"strokeWidth\" (changes)=\"emitChange()\" step=\"0.1\" min=\"0\"\n    max=\"20\" label=\"{{'STYLER.strokeWidth' | translate}}\"></hs-symbolizer-slider>\n\n  <hs-symbolizer-slider [symbolizer]=\"symbolizer\" attribute=\"rotate\" (changes)=\"emitChange()\" step=\"1\" min=\"0\" max=\"360\"\n    label=\"{{'STYLER.rotation' | translate}}\"></hs-symbolizer-slider>\n</form>"
            }]
    }], null, { symbolizer: [{
            type: Input
        }] }); })();

var Kinds;
(function (Kinds) {
    Kinds["fill"] = "Fill";
    Kinds["icon"] = "Icon";
    Kinds["line"] = "Line";
    Kinds["text"] = "Text";
    Kinds["mark"] = "Mark";
})(Kinds || (Kinds = {}));

class HsRuleComponent extends HsStylerPartBaseComponent {
    constructor(hsStylerService) {
        super();
        this.hsStylerService = hsStylerService;
        this.changes = new EventEmitter();
        this.filtersVisible = false;
        this.scalesVisible = false;
    }
    addSymbolizer(kind) {
        return __awaiter(this, void 0, void 0, function* () {
            const symbolizer = { kind, color: '#000' };
            if (kind === Kinds.text) {
                Object.assign(symbolizer, { size: 12, offset: [0, 0] });
            }
            if (kind === Kinds.fill) {
                Object.assign(symbolizer, { outlineColor: '#000' });
            }
            if (kind == Kinds.icon) {
                Object.assign(symbolizer, { offset: [0.5, 0.5] });
            }
            if (kind == Kinds.mark) {
                Object.assign(symbolizer, { wellKnownName: 'circle' });
            }
            if (kind == Kinds.icon) {
                Object.assign(symbolizer, { image: 'assets/img/icons/information78.svg' });
            }
            this.rule.symbolizers.push(symbolizer);
            this.menuRef.close();
            this.emitChange();
        });
    }
    drop(event) {
        return __awaiter(this, void 0, void 0, function* () {
            moveItemInArray(this.rule.symbolizers, event.previousIndex, event.currentIndex);
            this.emitChange();
        });
    }
}
HsRuleComponent.ɵfac = function HsRuleComponent_Factory(t) { return new (t || HsRuleComponent)(ɵngcc0.ɵɵdirectiveInject(HsStylerService)); };
HsRuleComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsRuleComponent, selectors: [["hs-rule"]], viewQuery: function HsRuleComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c56, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.menuRef = _t.first);
    } }, inputs: { rule: "rule" }, outputs: { changes: "changes" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 43, vars: 24, consts: [[1, "d-flex", "flex-row"], [1, "p-1", "w-25"], [1, "p-1", "w-75"], [1, "form-control", 3, "ngModelOptions", "ngModel", "ngModelChange", "change"], [1, "d-flex", "flex-row", "justify-content-end"], [1, "p-1", "flex-grow-1"], [1, "p-1"], ["role", "group", "aria-label", "Filters and scales", 1, "btn-group"], [1, "btn", "btn-outline-primary", "btn-sm", 3, "title", "click"], [1, "icon-filter"], [1, "icon-design"], [3, "rule", "changes", 4, "ngIf"], ["ngbDropdown", "", "placement", "bottom-right", 1, "d-inline-block"], ["addSymMenu", "ngbDropdown"], ["id", "dropdownAddSymbolizer", "ngbDropdownToggle", "", 1, "btn", "btn-outline-primary", "btn-sm", 3, "title"], [1, "icon-plus"], ["ngbDropdownMenu", "", "aria-labelledby", "dropdownAddSymbolizer"], ["ngbDropdownItem", "", 3, "click"], [4, "ngIf"], [3, "rule", "changes"], ["cdkDropList", "", 1, "list-group", "hs-styler-content-list", 3, "cdkDropListData", "cdkDropListDropped"], [4, "ngFor", "ngForOf"], ["cdkDrag", "", 3, "rule", "symbolizer", "changes"]], template: function HsRuleComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵelementStart(1, "div", 0);
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵpipe(4, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 2);
        ɵngcc0.ɵɵelementStart(6, "input", 3);
        ɵngcc0.ɵɵlistener("ngModelChange", function HsRuleComponent_Template_input_ngModelChange_6_listener($event) { return ctx.rule.name = $event; })("change", function HsRuleComponent_Template_input_change_6_listener() { return ctx.emitChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 4);
        ɵngcc0.ɵɵelementStart(8, "div", 5);
        ɵngcc0.ɵɵtext(9);
        ɵngcc0.ɵɵpipe(10, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "div", 6);
        ɵngcc0.ɵɵelementStart(12, "div", 7);
        ɵngcc0.ɵɵelementStart(13, "button", 8);
        ɵngcc0.ɵɵlistener("click", function HsRuleComponent_Template_button_click_13_listener() { return ctx.filtersVisible = !ctx.filtersVisible; });
        ɵngcc0.ɵɵpipe(14, "translate");
        ɵngcc0.ɵɵelement(15, "span", 9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(16, "button", 8);
        ɵngcc0.ɵɵlistener("click", function HsRuleComponent_Template_button_click_16_listener() { return ctx.scalesVisible = !ctx.scalesVisible; });
        ɵngcc0.ɵɵpipe(17, "translate");
        ɵngcc0.ɵɵelement(18, "span", 10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(19, HsRuleComponent_hs_filters_19_Template, 1, 1, "hs-filters", 11);
        ɵngcc0.ɵɵtemplate(20, HsRuleComponent_hs_scale_denominator_20_Template, 1, 1, "hs-scale-denominator", 11);
        ɵngcc0.ɵɵelementStart(21, "div", 4);
        ɵngcc0.ɵɵelementStart(22, "div", 5);
        ɵngcc0.ɵɵtext(23);
        ɵngcc0.ɵɵpipe(24, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(25, "div", 6);
        ɵngcc0.ɵɵelementStart(26, "div", 12, 13);
        ɵngcc0.ɵɵelementStart(28, "button", 14);
        ɵngcc0.ɵɵpipe(29, "translate");
        ɵngcc0.ɵɵelement(30, "span", 15);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(31, "div", 16);
        ɵngcc0.ɵɵelementStart(32, "button", 17);
        ɵngcc0.ɵɵlistener("click", function HsRuleComponent_Template_button_click_32_listener() { return ctx.addSymbolizer("Mark"); });
        ɵngcc0.ɵɵtext(33, "Mark");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(34, "button", 17);
        ɵngcc0.ɵɵlistener("click", function HsRuleComponent_Template_button_click_34_listener() { return ctx.addSymbolizer("Icon"); });
        ɵngcc0.ɵɵtext(35, "Icon");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(36, "button", 17);
        ɵngcc0.ɵɵlistener("click", function HsRuleComponent_Template_button_click_36_listener() { return ctx.addSymbolizer("Text"); });
        ɵngcc0.ɵɵtext(37, "Text");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(38, "button", 17);
        ɵngcc0.ɵɵlistener("click", function HsRuleComponent_Template_button_click_38_listener() { return ctx.addSymbolizer("Line"); });
        ɵngcc0.ɵɵtext(39, "Line");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(40, "button", 17);
        ɵngcc0.ɵɵlistener("click", function HsRuleComponent_Template_button_click_40_listener() { return ctx.addSymbolizer("Fill"); });
        ɵngcc0.ɵɵtext(41, "Fill");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(42, HsRuleComponent_ng_container_42_Template, 3, 2, "ng-container", 18);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(4, 11, "STYLER.name"), ":");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngModelOptions", ɵngcc0.ɵɵpureFunction0(23, _c2))("ngModel", ctx.rule.name);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(10, 13, "STYLER.filtersAndScales"), ": ");
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(14, 15, "STYLER.toggleFilters"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(17, 17, "STYLER.toggleScaleDenominators"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.filtersVisible);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.scalesVisible);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(24, 19, "STYLER.symbolizers"), ":");
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(29, 21, "STYLER.addSymbolizer"));
        ɵngcc0.ɵɵadvance(14);
        ɵngcc0.ɵɵproperty("ngIf", ctx.rule.symbolizers.length > 0);
    } }, directives: function () { return [ɵngcc5.DefaultValueAccessor, ɵngcc5.NgControlStatus, ɵngcc5.NgModel, ɵngcc3.NgIf, ɵngcc6.NgbDropdown, ɵngcc6.NgbDropdownToggle, ɵngcc6.NgbDropdownMenu, ɵngcc6.NgbDropdownItem, HsFiltersComponent, HsScaleDenominatorComponent, ɵngcc7.CdkDropList, ɵngcc3.NgForOf, HsSymbolizerListItemComponent, ɵngcc7.CdkDrag]; }, pipes: function () { return [ɵngcc1.TranslatePipe]; }, styles: [_c57] });
HsRuleComponent.ctorParameters = () => [
    { type: HsStylerService }
];
HsRuleComponent.propDecorators = {
    rule: [{ type: Input }],
    changes: [{ type: Output }],
    menuRef: [{ type: ViewChild, args: ['addSymMenu',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsRuleComponent, [{
        type: Component,
        args: [{
                selector: 'hs-rule',
                template: "<div>\n  <div class=\"d-flex flex-row\">\n    <div class=\"p-1 w-25\">{{'STYLER.name' | translate}}:</div>\n    <div class=\"p-1 w-75\">\n      <input class=\"form-control\" [ngModelOptions]=\"{standalone: true}\" [(ngModel)]=\"rule.name\"\n        (change)=\"emitChange()\" />\n    </div>\n  </div>\n  <div class=\"d-flex flex-row justify-content-end\">\n    <div class=\"p-1 flex-grow-1\">\n      {{'STYLER.filtersAndScales' | translate}}:\n    </div>\n    <div class=\"p-1\">\n      <div class=\"btn-group\" role=\"group\" aria-label=\"Filters and scales\">\n        <button [title]=\"'STYLER.toggleFilters' | translate\" class=\"btn btn-outline-primary btn-sm\"\n          (click)=\"filtersVisible = !filtersVisible\">\n          <span class=\"icon-filter\"></span>\n        </button>\n        <button [title]=\"'STYLER.toggleScaleDenominators' | translate\" class=\"btn btn-outline-primary btn-sm\"\n          (click)=\"scalesVisible = !scalesVisible\">\n          <span class=\"icon-design\"></span>\n        </button>\n      </div>\n    </div>\n  </div>\n  <hs-filters (changes)=\"emitChange()\" *ngIf=\"filtersVisible\" [rule]=\"rule\"></hs-filters>\n  <hs-scale-denominator (changes)=\"emitChange()\" *ngIf=\"scalesVisible\" [rule]=\"rule\"></hs-scale-denominator>\n  <div class=\"d-flex flex-row justify-content-end\">\n    <div class=\"p-1 flex-grow-1\">{{'STYLER.symbolizers' | translate}}:</div>\n    <div class=\"p-1\">\n      <div #addSymMenu=\"ngbDropdown\" ngbDropdown class=\"d-inline-block\" placement=\"bottom-right\">\n        <button class=\"btn btn-outline-primary btn-sm\" [title]=\"'STYLER.addSymbolizer' | translate\"\n          id=\"dropdownAddSymbolizer\" ngbDropdownToggle>\n          <span class=\"icon-plus\"></span>\n        </button>\n        <div ngbDropdownMenu aria-labelledby=\"dropdownAddSymbolizer\">\n          <button ngbDropdownItem (click)=\"addSymbolizer('Mark')\">Mark</button>\n          <button ngbDropdownItem (click)=\"addSymbolizer('Icon')\">Icon</button>\n          <button ngbDropdownItem (click)=\"addSymbolizer('Text')\">Text</button>\n          <button ngbDropdownItem (click)=\"addSymbolizer('Line')\">Line</button>\n          <button ngbDropdownItem (click)=\"addSymbolizer('Fill')\">Fill</button>\n        </div>\n      </div>\n    </div>\n  </div>\n  <ng-container *ngIf=\"rule.symbolizers.length > 0\">\n    <ul class=\"list-group hs-styler-content-list\" cdkDropList (cdkDropListDropped)=\"drop($event)\"\n      [cdkDropListData]=\"rule.symbolizers\">\n      <ng-container *ngFor=\"let symbolizer of rule.symbolizers\">\n        <hs-symbolizer-list-item cdkDrag [rule]=\"rule\" [symbolizer]=\"symbolizer\" (changes)=\"emitChange()\">\n        </hs-symbolizer-list-item>\n      </ng-container>\n    </ul>\n  </ng-container>\n</div>",
                styles: [".cdk-drag-preview{box-sizing:content-box;border-radius:0;background-color:#b9b9b9bf;border:1px solid #b9b9b9;overflow:hidden;display:flex;align-items:center;color:#000;box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f}.cdk-drag-placeholder{opacity:0}.cdk-drag-animating{transition:transform 125ms cubic-bezier(0,0,.2,1)}.list-group.hs-styler-content-list.cdk-drop-list-dragging hs-rule-list-item:not(.cdk-drag-placeholder){transition:transform .25s cubic-bezier(0,0,.2,1)}.list-group.hs-styler-content-list.cdk-drop-list-dragging hs-symbolizer-list-item:not(.cdk-drag-placeholder){transition:transform .25s cubic-bezier(0,0,.2,1)}ul.hs-styler-content-list{margin-top:0;margin-bottom:0;border-bottom:1px solid var(--panel-wrapper-bg-color)}li.list-group-item.hs-list-item-header{padding:.3em;width:100%;cursor:pointer;display:flex;justify-content:space-between;align-items:center;border-radius:0}li.list-group-item.hs-list-item-header .btn-danger{margin-right:1rem}li.list-group-item.hs-list-item-header span.glyphicon{font-size:x-small}li.list-group-item.hs-list-item-header:hover{background-color:#b9b9b9bf}\n"]
            }]
    }], function () { return [{ type: HsStylerService }]; }, { changes: [{
            type: Output
        }], rule: [{
            type: Input
        }], menuRef: [{
            type: ViewChild,
            args: ['addSymMenu']
        }] }); })();

class HsRuleListItemComponent {
    constructor(hsStylerService) {
        this.hsStylerService = hsStylerService;
        this.ruleVisible = false;
    }
}
HsRuleListItemComponent.ɵfac = function HsRuleListItemComponent_Factory(t) { return new (t || HsRuleListItemComponent)(ɵngcc0.ɵɵdirectiveInject(HsStylerService)); };
HsRuleListItemComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsRuleListItemComponent, selectors: [["hs-rule-list-item"]], inputs: { rule: "rule" }, decls: 12, vars: 6, consts: [[1, "list-group-item", "hs-list-item-header", "list-group-item-primary", "d-flex", "justify-content-between", "align-items-center", "mb-1", 3, "click"], ["type", "button", 2, "border", "none", "background-color", "transparent", "cursor", "move"], [1, "icon-move", "text-secondary"], [1, "glyphicon", "mr-2", 3, "ngClass"], ["data-toggle", "tooltip", 1, "btn", "btn-danger", "btn-sm", "mr-0", 3, "title", "click"], [1, "icon-trash"], [4, "ngIf"], [3, "rule", "changes", "mousedown"]], template: function HsRuleListItemComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "li", 0);
        ɵngcc0.ɵɵlistener("click", function HsRuleListItemComponent_Template_li_click_0_listener() { return ctx.ruleVisible = !ctx.ruleVisible; });
        ɵngcc0.ɵɵelementStart(1, "div");
        ɵngcc0.ɵɵelementStart(2, "button", 1);
        ɵngcc0.ɵɵelement(3, "i", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "span");
        ɵngcc0.ɵɵtext(5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "div");
        ɵngcc0.ɵɵelement(7, "span", 3);
        ɵngcc0.ɵɵelementStart(8, "button", 4);
        ɵngcc0.ɵɵlistener("click", function HsRuleListItemComponent_Template_button_click_8_listener() { return ctx.hsStylerService.removeRule(ctx.rule); });
        ɵngcc0.ɵɵpipe(9, "translate");
        ɵngcc0.ɵɵelement(10, "i", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(11, HsRuleListItemComponent_ng_container_11_Template, 2, 1, "ng-container", 6);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate1("", ctx.rule.name || "untitled rule", "\u00A0");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ctx.ruleVisible ? "icon-chevron-right" : "icon-chevron-down");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(9, 4, "STYLER.removeRule"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.ruleVisible);
    } }, directives: [ɵngcc3.NgClass, ɵngcc3.NgIf, HsRuleComponent], pipes: [ɵngcc1.TranslatePipe], styles: [_c57] });
HsRuleListItemComponent.ctorParameters = () => [
    { type: HsStylerService }
];
HsRuleListItemComponent.propDecorators = {
    rule: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsRuleListItemComponent, [{
        type: Component,
        args: [{
                selector: 'hs-rule-list-item',
                template: "<li\n  class=\"list-group-item hs-list-item-header list-group-item-primary d-flex justify-content-between align-items-center mb-1\"\n  (click)=\"ruleVisible = !ruleVisible\">\n  <div>\n    <button type=\"button\" style=\"border: none; background-color: transparent; cursor: move\">\n      <i class=\"icon-move text-secondary\"></i>\n    </button>\n    <span>{{rule.name || 'untitled rule'}}&nbsp;</span>\n  </div>\n  <div>\n    <span class=\"glyphicon mr-2\" [ngClass]=\"ruleVisible ? 'icon-chevron-right' : 'icon-chevron-down'\"></span>\n    <button class=\"btn btn-danger btn-sm mr-0\" (click)=\"hsStylerService.removeRule(rule)\" data-toggle=\"tooltip\"\n      [title]=\"'STYLER.removeRule' | translate\">\n      <i class=\"icon-trash\"></i>\n    </button>\n  </div>\n</li>\n\n<ng-container *ngIf=\"ruleVisible\">\n  <hs-rule [rule]=\"rule\" (changes)=\"hsStylerService.save()\"  (mousedown)=\"$event.stopPropagation()\"></hs-rule>\n</ng-container>",
                styles: [".cdk-drag-preview{box-sizing:content-box;border-radius:0;background-color:#b9b9b9bf;border:1px solid #b9b9b9;overflow:hidden;display:flex;align-items:center;color:#000;box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f}.cdk-drag-placeholder{opacity:0}.cdk-drag-animating{transition:transform 125ms cubic-bezier(0,0,.2,1)}.list-group.hs-styler-content-list.cdk-drop-list-dragging hs-rule-list-item:not(.cdk-drag-placeholder){transition:transform .25s cubic-bezier(0,0,.2,1)}.list-group.hs-styler-content-list.cdk-drop-list-dragging hs-symbolizer-list-item:not(.cdk-drag-placeholder){transition:transform .25s cubic-bezier(0,0,.2,1)}ul.hs-styler-content-list{margin-top:0;margin-bottom:0;border-bottom:1px solid var(--panel-wrapper-bg-color)}li.list-group-item.hs-list-item-header{padding:.3em;width:100%;cursor:pointer;display:flex;justify-content:space-between;align-items:center;border-radius:0}li.list-group-item.hs-list-item-header .btn-danger{margin-right:1rem}li.list-group-item.hs-list-item-header span.glyphicon{font-size:x-small}li.list-group-item.hs-list-item-header:hover{background-color:#b9b9b9bf}\n"]
            }]
    }], function () { return [{ type: HsStylerService }]; }, { rule: [{
            type: Input
        }] }); })();

class HsScaleDenominatorComponent extends HsStylerPartBaseComponent {
    constructor() {
        super(...arguments);
        this.scaleDenominator = { min: null, max: null };
    }
    ngOnInit() {
        Object.assign(this.scaleDenominator, this.rule.scaleDenominator);
    }
    emitChange() {
        if (this.scaleDenominator.min === null &&
            this.scaleDenominator.max === null) {
            delete this.rule.scaleDenominator;
            super.emitChange();
            return;
        }
        if (this.rule.scaleDenominator == undefined) {
            this.rule.scaleDenominator = {};
        }
        Object.assign(this.rule.scaleDenominator, this.scaleDenominator);
        //After assign to keep max input empty -> prevent 'out of range' warning
        if (this.rule.scaleDenominator.max === null &&
            this.rule.scaleDenominator.min !== null) {
            this.rule.scaleDenominator.max = Infinity;
        }
        super.emitChange();
    }
}
HsScaleDenominatorComponent.ɵfac = /*@__PURE__*/ function () { let ɵHsScaleDenominatorComponent_BaseFactory; return function HsScaleDenominatorComponent_Factory(t) { return (ɵHsScaleDenominatorComponent_BaseFactory || (ɵHsScaleDenominatorComponent_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(HsScaleDenominatorComponent)))(t || HsScaleDenominatorComponent); }; }();
HsScaleDenominatorComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsScaleDenominatorComponent, selectors: [["hs-scale-denominator"]], inputs: { rule: "rule" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 21, vars: 12, consts: [[1, "form"], [1, "d-flex", "flex-row"], [1, "p-2", "w-50"], [1, "p-1", "w-50"], [1, "input-group"], [1, "input-group-prepend"], [1, "input-group-text"], ["type", "number", 1, "form-control", 3, "ngModelOptions", "ngModel", "ngModelChange", "change"]], template: function HsScaleDenominatorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "form", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵpipe(4, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 3);
        ɵngcc0.ɵɵelementStart(6, "div", 4);
        ɵngcc0.ɵɵelementStart(7, "div", 5);
        ɵngcc0.ɵɵelementStart(8, "div", 6);
        ɵngcc0.ɵɵtext(9, "1:");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "input", 7);
        ɵngcc0.ɵɵlistener("ngModelChange", function HsScaleDenominatorComponent_Template_input_ngModelChange_10_listener($event) { return ctx.scaleDenominator.min = $event; })("change", function HsScaleDenominatorComponent_Template_input_change_10_listener() { return ctx.emitChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "div", 1);
        ɵngcc0.ɵɵelementStart(12, "div", 2);
        ɵngcc0.ɵɵtext(13);
        ɵngcc0.ɵɵpipe(14, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(15, "div", 3);
        ɵngcc0.ɵɵelementStart(16, "div", 4);
        ɵngcc0.ɵɵelementStart(17, "div", 5);
        ɵngcc0.ɵɵelementStart(18, "div", 6);
        ɵngcc0.ɵɵtext(19, "1:");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(20, "input", 7);
        ɵngcc0.ɵɵlistener("ngModelChange", function HsScaleDenominatorComponent_Template_input_ngModelChange_20_listener($event) { return ctx.scaleDenominator.max = $event; })("change", function HsScaleDenominatorComponent_Template_input_change_20_listener() { return ctx.emitChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(4, 6, "STYLER.minScale"), ":");
        ɵngcc0.ɵɵadvance(7);
        ɵngcc0.ɵɵproperty("ngModelOptions", ɵngcc0.ɵɵpureFunction0(10, _c2))("ngModel", ctx.scaleDenominator.min);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(14, 8, "STYLER.maxScale"), ":");
        ɵngcc0.ɵɵadvance(7);
        ɵngcc0.ɵɵproperty("ngModelOptions", ɵngcc0.ɵɵpureFunction0(11, _c2))("ngModel", ctx.scaleDenominator.max);
    } }, directives: [ɵngcc5.ɵNgNoValidate, ɵngcc5.NgControlStatusGroup, ɵngcc5.NgForm, ɵngcc5.NumberValueAccessor, ɵngcc5.DefaultValueAccessor, ɵngcc5.NgControlStatus, ɵngcc5.NgModel], pipes: [ɵngcc1.TranslatePipe], encapsulation: 2 });
HsScaleDenominatorComponent.propDecorators = {
    rule: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsScaleDenominatorComponent, [{
        type: Component,
        args: [{
                selector: 'hs-scale-denominator',
                template: "<form class=\"form\">\n  <div class=\"d-flex flex-row\">\n    <div class=\"p-2 w-50\">{{'STYLER.minScale' | translate}}:</div>\n    <div class=\"p-1 w-50\">\n      <div class=\"input-group\">\n        <div class=\"input-group-prepend\">\n          <div class=\"input-group-text\">1:</div>\n        </div>\n        <input class=\"form-control\" type=\"number\" [ngModelOptions]=\"{standalone: true}\"\n          [(ngModel)]=\"scaleDenominator.min\" (change)=\"emitChange()\" />\n      </div>\n    </div>\n  </div>\n  <div class=\"d-flex flex-row\">\n    <div class=\"p-2 w-50\">{{'STYLER.maxScale' | translate}}:</div>\n    <div class=\"p-1 w-50\">\n      <div class=\"input-group\">\n        <div class=\"input-group-prepend\">\n          <div class=\"input-group-text\">1:</div>\n        </div>\n        <input class=\"form-control\" type=\"number\" [ngModelOptions]=\"{standalone: true}\"\n          [(ngModel)]=\"scaleDenominator.max\" (change)=\"emitChange()\" />\n      </div>\n    </div>\n  </div>\n</form>"
            }]
    }], null, { rule: [{
            type: Input
        }] }); })();

class HsSliderComponent extends HsStylerPartBaseComponent {
}
HsSliderComponent.ɵfac = /*@__PURE__*/ function () { let ɵHsSliderComponent_BaseFactory; return function HsSliderComponent_Factory(t) { return (ɵHsSliderComponent_BaseFactory || (ɵHsSliderComponent_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(HsSliderComponent)))(t || HsSliderComponent); }; }();
HsSliderComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsSliderComponent, selectors: [["hs-symbolizer-slider"]], inputs: { symbolizer: "symbolizer", attribute: "attribute", label: "label", min: "min", max: "max", step: "step" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 7, vars: 8, consts: [[1, "d-flex", "flex-row"], [1, "p-1", "w-25", "mt-1"], ["class", "badge badge-warning mt-2", 3, "title", 4, "ngIf"], [1, "p-1", "w-75"], ["type", "range", 1, "form-control", "form-control-sm", 3, "step", "min", "max", "ngModelOptions", "ngModel", "ngModelChange", "change"], [1, "badge", "badge-warning", "mt-2", 3, "title"]], template: function HsSliderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵelementStart(1, "div", 0);
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(4, HsSliderComponent_span_4_Template, 2, 1, "span", 2);
        ɵngcc0.ɵɵelementStart(5, "div", 3);
        ɵngcc0.ɵɵelementStart(6, "input", 4);
        ɵngcc0.ɵɵlistener("ngModelChange", function HsSliderComponent_Template_input_ngModelChange_6_listener($event) { return (ctx.symbolizer[ctx.attribute] = $event); })("change", function HsSliderComponent_Template_input_change_6_listener() { return ctx.emitChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.label);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.warning !== undefined);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("step", ctx.step)("min", ctx.min)("max", ctx.max)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(7, _c2))("ngModel", ctx.symbolizer[ctx.attribute]);
    } }, directives: [ɵngcc3.NgIf, ɵngcc5.RangeValueAccessor, ɵngcc5.DefaultValueAccessor, ɵngcc5.NgControlStatus, ɵngcc5.NgModel], encapsulation: 2 });
HsSliderComponent.propDecorators = {
    symbolizer: [{ type: Input }],
    attribute: [{ type: Input }],
    label: [{ type: Input }],
    min: [{ type: Input }],
    max: [{ type: Input }],
    step: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsSliderComponent, [{
        type: Component,
        args: [{
                selector: 'hs-symbolizer-slider',
                template: "<div>\n  <div class=\"d-flex flex-row\">\n    <div class=\"p-1 w-25 mt-1\">{{label}}</div>\n    <span class=\"badge badge-warning mt-2\" title=\"{{warning}}\" *ngIf=\"warning !== undefined\">!</span>\n    <div class=\"p-1 w-75\">\n      <input class=\"form-control form-control-sm\" type=\"range\" [step]=\"step\" [min]=\"min\" [max]=\"max\"\n        [ngModelOptions]=\"{standalone: true}\" [(ngModel)]=\"symbolizer[attribute]\" (change)=\"emitChange()\" />\n    </div>\n  </div>\n</div>"
            }]
    }], null, { symbolizer: [{
            type: Input
        }], attribute: [{
            type: Input
        }], label: [{
            type: Input
        }], min: [{
            type: Input
        }], max: [{
            type: Input
        }], step: [{
            type: Input
        }] }); })();

class HsSymbolizerComponent extends HsStylerPartBaseComponent {
    constructor() {
        super(...arguments);
        this.kinds = Kinds;
    }
}
HsSymbolizerComponent.ɵfac = /*@__PURE__*/ function () { let ɵHsSymbolizerComponent_BaseFactory; return function HsSymbolizerComponent_Factory(t) { return (ɵHsSymbolizerComponent_BaseFactory || (ɵHsSymbolizerComponent_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(HsSymbolizerComponent)))(t || HsSymbolizerComponent); }; }();
HsSymbolizerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsSymbolizerComponent, selectors: [["hs-symbolizer"]], inputs: { symbolizer: "symbolizer" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 7, vars: 5, consts: [[1, "card", "m-0"], [1, "form"], [3, "symbolizer", "changes", 4, "ngIf"], [3, "symbolizer", "changes"]], template: function HsSymbolizerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "form", 1);
        ɵngcc0.ɵɵtemplate(2, HsSymbolizerComponent_hs_fill_symbolizer_2_Template, 1, 1, "hs-fill-symbolizer", 2);
        ɵngcc0.ɵɵtemplate(3, HsSymbolizerComponent_hs_line_symbolizer_3_Template, 1, 1, "hs-line-symbolizer", 2);
        ɵngcc0.ɵɵtemplate(4, HsSymbolizerComponent_hs_mark_symbolizer_4_Template, 1, 1, "hs-mark-symbolizer", 2);
        ɵngcc0.ɵɵtemplate(5, HsSymbolizerComponent_hs_icon_symbolizer_5_Template, 1, 1, "hs-icon-symbolizer", 2);
        ɵngcc0.ɵɵtemplate(6, HsSymbolizerComponent_hs_text_symbolizer_6_Template, 1, 1, "hs-text-symbolizer", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.symbolizer.kind === ctx.kinds.fill);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.symbolizer.kind === ctx.kinds.line);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.symbolizer.kind === ctx.kinds.mark);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.symbolizer.kind === ctx.kinds.icon);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.symbolizer.kind === ctx.kinds.text);
    } }, directives: function () { return [ɵngcc5.ɵNgNoValidate, ɵngcc5.NgControlStatusGroup, ɵngcc5.NgForm, ɵngcc3.NgIf, HsFillSymbolizerComponent, HsLineSymbolizerComponent, HsMarkSymbolizerComponent, HsIconSymbolizerComponent, HsTextSymbolizerComponent]; }, encapsulation: 2 });
HsSymbolizerComponent.propDecorators = {
    symbolizer: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsSymbolizerComponent, [{
        type: Component,
        args: [{
                selector: 'hs-symbolizer',
                template: "<div class=\"card m-0\">\n  <form class=\"form\">\n    <hs-fill-symbolizer [symbolizer]=\"symbolizer\" (changes)=\"emitChange()\" *ngIf=\"symbolizer.kind === kinds.fill\">\n    </hs-fill-symbolizer>\n    <hs-line-symbolizer [symbolizer]=\"symbolizer\" (changes)=\"emitChange()\" *ngIf=\"symbolizer.kind === kinds.line\">\n    </hs-line-symbolizer>\n    <hs-mark-symbolizer [symbolizer]=\"symbolizer\" (changes)=\"emitChange()\" *ngIf=\"symbolizer.kind === kinds.mark\">\n    </hs-mark-symbolizer>\n    <hs-icon-symbolizer [symbolizer]=\"symbolizer\" (changes)=\"emitChange()\" *ngIf=\"symbolizer.kind === kinds.icon\">\n    </hs-icon-symbolizer>\n    <hs-text-symbolizer [symbolizer]=\"symbolizer\" (changes)=\"emitChange()\" *ngIf=\"symbolizer.kind === kinds.text\">\n    </hs-text-symbolizer>\n  </form>\n</div>"
            }]
    }], null, { symbolizer: [{
            type: Input
        }] }); })();

class HsSymbolizerListItemComponent extends HsStylerPartBaseComponent {
    constructor() {
        super(...arguments);
        this.symbolizerVisible = false;
    }
    getSymbolizerName(symbolizer) {
        switch (symbolizer.kind) {
            case Kinds.fill:
                return 'STYLER.fillSymbolizer';
            case Kinds.icon:
                return 'STYLER.iconSymbolizer';
            case Kinds.line:
                return 'STYLER.lineSymbolizer';
            case Kinds.text:
                return 'STYLER.textSymbolizer';
            case Kinds.mark:
                return 'STYLER.markSymbolizer';
            default:
                return 'STYLER.unknownSymbolizer';
        }
    }
    removeSymbolizer(symbolizer) {
        this.rule.symbolizers.splice(this.rule.symbolizers.indexOf(symbolizer), 1);
        this.emitChange();
    }
}
HsSymbolizerListItemComponent.ɵfac = /*@__PURE__*/ function () { let ɵHsSymbolizerListItemComponent_BaseFactory; return function HsSymbolizerListItemComponent_Factory(t) { return (ɵHsSymbolizerListItemComponent_BaseFactory || (ɵHsSymbolizerListItemComponent_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(HsSymbolizerListItemComponent)))(t || HsSymbolizerListItemComponent); }; }();
HsSymbolizerListItemComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsSymbolizerListItemComponent, selectors: [["hs-symbolizer-list-item"]], inputs: { symbolizer: "symbolizer", rule: "rule" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 13, vars: 8, consts: [[1, "list-group-item", "hs-list-item-header", "list-group-item-primary", "d-flex", "justify-content-between", "align-items-center", "mb-1", "mr-3", "ml-3", 3, "click"], ["type", "button", 2, "border", "none", "background-color", "transparent", "cursor", "move"], [1, "icon-move", "text-secondary"], [1, "glyphicon", "mr-2", 3, "ngClass"], ["data-toggle", "tooltip", 1, "btn", "btn-danger", "btn-sm", 3, "title", "click"], [1, "icon-trash"], [4, "ngIf"], [3, "symbolizer", "changes", "mousedown"]], template: function HsSymbolizerListItemComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "li", 0);
        ɵngcc0.ɵɵlistener("click", function HsSymbolizerListItemComponent_Template_li_click_0_listener() { return ctx.symbolizerVisible = !ctx.symbolizerVisible; });
        ɵngcc0.ɵɵelementStart(1, "div");
        ɵngcc0.ɵɵelementStart(2, "button", 1);
        ɵngcc0.ɵɵelement(3, "i", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "span");
        ɵngcc0.ɵɵtext(5);
        ɵngcc0.ɵɵpipe(6, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div");
        ɵngcc0.ɵɵelement(8, "span", 3);
        ɵngcc0.ɵɵelementStart(9, "button", 4);
        ɵngcc0.ɵɵlistener("click", function HsSymbolizerListItemComponent_Template_button_click_9_listener() { return ctx.removeSymbolizer(ctx.symbolizer); });
        ɵngcc0.ɵɵpipe(10, "translate");
        ɵngcc0.ɵɵelement(11, "i", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(12, HsSymbolizerListItemComponent_ng_container_12_Template, 2, 1, "ng-container", 6);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(6, 4, ctx.getSymbolizerName(ctx.symbolizer)), "\u00A0");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngClass", ctx.symbolizerVisible ? "icon-chevron-right" : "icon-chevron-down");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(10, 6, "STYLER.removeSymbolizer"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.symbolizerVisible);
    } }, directives: [ɵngcc3.NgClass, ɵngcc3.NgIf, HsSymbolizerComponent], pipes: [ɵngcc1.TranslatePipe], styles: [_c57] });
HsSymbolizerListItemComponent.propDecorators = {
    symbolizer: [{ type: Input }],
    rule: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsSymbolizerListItemComponent, [{
        type: Component,
        args: [{
                selector: 'hs-symbolizer-list-item',
                template: "<li\n  class=\"list-group-item hs-list-item-header list-group-item-primary d-flex justify-content-between align-items-center mb-1 mr-3 ml-3\"\n  (click)=\"symbolizerVisible = !symbolizerVisible;\">\n  <div>\n    <button type=\"button\" style=\"border: none; background-color: transparent; cursor: move\">\n      <i class=\"icon-move text-secondary\"></i>\n    </button>\n    <span>{{getSymbolizerName(symbolizer) | translate}}&nbsp;</span>\n  </div>\n  <div>\n    <span class=\"glyphicon mr-2\" [ngClass]=\"symbolizerVisible ? 'icon-chevron-right' : 'icon-chevron-down'\"></span>\n    <button class=\"btn btn-danger btn-sm\" (click)=\"removeSymbolizer(symbolizer)\" data-toggle=\"tooltip\"\n      [title]=\"'STYLER.removeSymbolizer' | translate\">\n      <i class=\"icon-trash\"></i>\n    </button>\n  </div>\n</li>\n\n<ng-container *ngIf=\"symbolizerVisible\">\n  <hs-symbolizer [symbolizer]=\"symbolizer\" (changes)=\"emitChange()\" (mousedown)=\"$event.stopPropagation()\">\n  </hs-symbolizer>\n</ng-container>",
                styles: [".cdk-drag-preview{box-sizing:content-box;border-radius:0;background-color:#b9b9b9bf;border:1px solid #b9b9b9;overflow:hidden;display:flex;align-items:center;color:#000;box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f}.cdk-drag-placeholder{opacity:0}.cdk-drag-animating{transition:transform 125ms cubic-bezier(0,0,.2,1)}.list-group.hs-styler-content-list.cdk-drop-list-dragging hs-rule-list-item:not(.cdk-drag-placeholder){transition:transform .25s cubic-bezier(0,0,.2,1)}.list-group.hs-styler-content-list.cdk-drop-list-dragging hs-symbolizer-list-item:not(.cdk-drag-placeholder){transition:transform .25s cubic-bezier(0,0,.2,1)}ul.hs-styler-content-list{margin-top:0;margin-bottom:0;border-bottom:1px solid var(--panel-wrapper-bg-color)}li.list-group-item.hs-list-item-header{padding:.3em;width:100%;cursor:pointer;display:flex;justify-content:space-between;align-items:center;border-radius:0}li.list-group-item.hs-list-item-header .btn-danger{margin-right:1rem}li.list-group-item.hs-list-item-header span.glyphicon{font-size:x-small}li.list-group-item.hs-list-item-header:hover{background-color:#b9b9b9bf}\n"]
            }]
    }], null, { symbolizer: [{
            type: Input
        }], rule: [{
            type: Input
        }] }); })();

class HsTextSymbolizerComponent extends HsStylerPartBaseComponent {
    constructor() {
        super(...arguments);
        this.anchors = [
            'center',
            'left',
            'right',
            'top',
            'bottom',
            'top-left',
            'top-right',
            'bottom-left',
            'bottom-right',
        ];
        this.fonts = [
            'Arial',
            'Verdana',
            'Sans-serif',
            'Courier New',
            'Lucida Console',
            'Monospace',
            'Times New Roman',
            'Georgia',
            'Serif',
        ];
        this.fontStyles = ['normal', 'italic', 'oblique'];
        this.transforms = ['none', 'uppercase', 'lowercase'];
        this.justifications = ['left', 'center', 'right'];
        this.fontWeights = ['normal', 'bold'];
    }
}
HsTextSymbolizerComponent.ɵfac = /*@__PURE__*/ function () { let ɵHsTextSymbolizerComponent_BaseFactory; return function HsTextSymbolizerComponent_Factory(t) { return (ɵHsTextSymbolizerComponent_BaseFactory || (ɵHsTextSymbolizerComponent_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(HsTextSymbolizerComponent)))(t || HsTextSymbolizerComponent); }; }();
HsTextSymbolizerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsTextSymbolizerComponent, selectors: [["hs-text-symbolizer"]], inputs: { symbolizer: "symbolizer" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 93, vars: 100, consts: [[1, "form"], [1, "d-flex", "flex-row"], [1, "p-1", "w-25"], [1, "p-1", "w-75"], [1, "form-control", "form-control-sm", 3, "ngModelOptions", "ngModel", "ngModelChange", "change"], ["attribute", "color", "opacityAttribute", "opacity", 3, "symbolizer", "label", "changes"], ["multiple", "", 1, "form-control", "form-control-sm", 3, "ngModelOptions", "ngModel", "ngModelChange"], [3, "ngValue", 4, "ngFor", "ngForOf"], [1, "p-1", "w-25", "mt-2"], [1, "badge", "badge-warning", "mt-2", 3, "title"], [1, "form-control", "form-control-sm", 3, "ngModel", "ngModelOptions", "ngModelChange", "change"], [4, "ngFor", "ngForOf"], ["attribute", "opacity", "step", "0.05", "min", "0", "max", "1", 3, "symbolizer", "label", "warning", "changes"], ["attribute", "haloColor", 3, "symbolizer", "label", "changes"], ["attribute", "haloWidth", "step", "1", "min", "0", "max", "20", 3, "symbolizer", "label", "changes"], ["class", "form-control form-control-sm", "type", "range", "step", "1", "min", "-40", "max", "40", 3, "ngModelOptions", "ngModel", "ngModelChange", "change", 4, "ngIf"], ["attribute", "rotate", "step", "1", "min", "0", "max", "360", 3, "symbolizer", "label", "changes"], [3, "ngValue"], ["type", "range", "step", "1", "min", "-40", "max", "40", 1, "form-control", "form-control-sm", 3, "ngModelOptions", "ngModel", "ngModelChange", "change"]], template: function HsTextSymbolizerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "form", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵpipe(4, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 3);
        ɵngcc0.ɵɵelementStart(6, "input", 4);
        ɵngcc0.ɵɵlistener("ngModelChange", function HsTextSymbolizerComponent_Template_input_ngModelChange_6_listener($event) { return ctx.symbolizer.label = $event; })("change", function HsTextSymbolizerComponent_Template_input_change_6_listener() { return ctx.emitChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "hs-symbolizer-color-picker", 5);
        ɵngcc0.ɵɵlistener("changes", function HsTextSymbolizerComponent_Template_hs_symbolizer_color_picker_changes_7_listener() { return ctx.emitChange(); });
        ɵngcc0.ɵɵpipe(8, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "div", 1);
        ɵngcc0.ɵɵelementStart(10, "div", 2);
        ɵngcc0.ɵɵtext(11);
        ɵngcc0.ɵɵpipe(12, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(13, "div", 3);
        ɵngcc0.ɵɵelementStart(14, "select", 6);
        ɵngcc0.ɵɵlistener("ngModelChange", function HsTextSymbolizerComponent_Template_select_ngModelChange_14_listener($event) { return ctx.symbolizer.font = $event; });
        ɵngcc0.ɵɵtemplate(15, HsTextSymbolizerComponent_option_15_Template, 2, 2, "option", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(16, "div", 1);
        ɵngcc0.ɵɵelementStart(17, "div", 2);
        ɵngcc0.ɵɵtext(18);
        ɵngcc0.ɵɵpipe(19, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(20, "div", 3);
        ɵngcc0.ɵɵelementStart(21, "input", 4);
        ɵngcc0.ɵɵlistener("ngModelChange", function HsTextSymbolizerComponent_Template_input_ngModelChange_21_listener($event) { return ctx.symbolizer.size = $event; })("change", function HsTextSymbolizerComponent_Template_input_change_21_listener() { return ctx.emitChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(22, "div", 1);
        ɵngcc0.ɵɵelementStart(23, "div", 8);
        ɵngcc0.ɵɵtext(24);
        ɵngcc0.ɵɵpipe(25, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(26, "span", 9);
        ɵngcc0.ɵɵpipe(27, "translate");
        ɵngcc0.ɵɵtext(28, "!");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(29, "div", 3);
        ɵngcc0.ɵɵelementStart(30, "select", 10);
        ɵngcc0.ɵɵlistener("ngModelChange", function HsTextSymbolizerComponent_Template_select_ngModelChange_30_listener($event) { return ctx.symbolizer.justify = $event; })("change", function HsTextSymbolizerComponent_Template_select_change_30_listener() { return ctx.emitChange(); });
        ɵngcc0.ɵɵtemplate(31, HsTextSymbolizerComponent_option_31_Template, 2, 1, "option", 11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(32, "div", 1);
        ɵngcc0.ɵɵelementStart(33, "div", 8);
        ɵngcc0.ɵɵtext(34);
        ɵngcc0.ɵɵpipe(35, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(36, "span", 9);
        ɵngcc0.ɵɵpipe(37, "translate");
        ɵngcc0.ɵɵtext(38, "!");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(39, "div", 3);
        ɵngcc0.ɵɵelementStart(40, "select", 10);
        ɵngcc0.ɵɵlistener("ngModelChange", function HsTextSymbolizerComponent_Template_select_ngModelChange_40_listener($event) { return ctx.symbolizer.transform = $event; })("change", function HsTextSymbolizerComponent_Template_select_change_40_listener() { return ctx.emitChange(); });
        ɵngcc0.ɵɵtemplate(41, HsTextSymbolizerComponent_option_41_Template, 2, 1, "option", 11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(42, "div", 1);
        ɵngcc0.ɵɵelementStart(43, "div", 8);
        ɵngcc0.ɵɵtext(44);
        ɵngcc0.ɵɵpipe(45, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(46, "span", 9);
        ɵngcc0.ɵɵpipe(47, "translate");
        ɵngcc0.ɵɵtext(48, "!");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(49, "div", 3);
        ɵngcc0.ɵɵelementStart(50, "select", 10);
        ɵngcc0.ɵɵlistener("ngModelChange", function HsTextSymbolizerComponent_Template_select_ngModelChange_50_listener($event) { return ctx.symbolizer.fontStyle = $event; })("change", function HsTextSymbolizerComponent_Template_select_change_50_listener() { return ctx.emitChange(); });
        ɵngcc0.ɵɵtemplate(51, HsTextSymbolizerComponent_option_51_Template, 2, 1, "option", 11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(52, "div", 1);
        ɵngcc0.ɵɵelementStart(53, "div", 8);
        ɵngcc0.ɵɵtext(54);
        ɵngcc0.ɵɵpipe(55, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(56, "span", 9);
        ɵngcc0.ɵɵpipe(57, "translate");
        ɵngcc0.ɵɵtext(58, "!");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(59, "div", 3);
        ɵngcc0.ɵɵelementStart(60, "select", 10);
        ɵngcc0.ɵɵlistener("ngModelChange", function HsTextSymbolizerComponent_Template_select_ngModelChange_60_listener($event) { return ctx.symbolizer.fontWeight = $event; })("change", function HsTextSymbolizerComponent_Template_select_change_60_listener() { return ctx.emitChange(); });
        ɵngcc0.ɵɵtemplate(61, HsTextSymbolizerComponent_option_61_Template, 2, 1, "option", 11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(62, "hs-symbolizer-slider", 12);
        ɵngcc0.ɵɵlistener("changes", function HsTextSymbolizerComponent_Template_hs_symbolizer_slider_changes_62_listener() { return ctx.emitChange(); });
        ɵngcc0.ɵɵpipe(63, "translate");
        ɵngcc0.ɵɵpipe(64, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(65, "hs-symbolizer-color-picker", 13);
        ɵngcc0.ɵɵlistener("changes", function HsTextSymbolizerComponent_Template_hs_symbolizer_color_picker_changes_65_listener() { return ctx.emitChange(); });
        ɵngcc0.ɵɵpipe(66, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(67, "hs-symbolizer-slider", 14);
        ɵngcc0.ɵɵlistener("changes", function HsTextSymbolizerComponent_Template_hs_symbolizer_slider_changes_67_listener() { return ctx.emitChange(); });
        ɵngcc0.ɵɵpipe(68, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(69, "div", 1);
        ɵngcc0.ɵɵelementStart(70, "div", 2);
        ɵngcc0.ɵɵtext(71);
        ɵngcc0.ɵɵpipe(72, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(73, "div", 3);
        ɵngcc0.ɵɵtemplate(74, HsTextSymbolizerComponent_input_74_Template, 1, 3, "input", 15);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(75, "div", 1);
        ɵngcc0.ɵɵelementStart(76, "div", 2);
        ɵngcc0.ɵɵtext(77);
        ɵngcc0.ɵɵpipe(78, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(79, "div", 3);
        ɵngcc0.ɵɵtemplate(80, HsTextSymbolizerComponent_input_80_Template, 1, 3, "input", 15);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(81, "hs-symbolizer-slider", 16);
        ɵngcc0.ɵɵlistener("changes", function HsTextSymbolizerComponent_Template_hs_symbolizer_slider_changes_81_listener() { return ctx.emitChange(); });
        ɵngcc0.ɵɵpipe(82, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(83, "div", 1);
        ɵngcc0.ɵɵelementStart(84, "div", 8);
        ɵngcc0.ɵɵtext(85);
        ɵngcc0.ɵɵpipe(86, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(87, "span", 9);
        ɵngcc0.ɵɵpipe(88, "translate");
        ɵngcc0.ɵɵtext(89, "!");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(90, "div", 3);
        ɵngcc0.ɵɵelementStart(91, "select", 10);
        ɵngcc0.ɵɵlistener("ngModelChange", function HsTextSymbolizerComponent_Template_select_ngModelChange_91_listener($event) { return ctx.symbolizer.anchor = $event; })("change", function HsTextSymbolizerComponent_Template_select_change_91_listener() { return ctx.emitChange(); });
        ɵngcc0.ɵɵtemplate(92, HsTextSymbolizerComponent_option_92_Template, 2, 1, "option", 11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(4, 50, "STYLER.template"), ":");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngModelOptions", ɵngcc0.ɵɵpureFunction0(92, _c2))("ngModel", ctx.symbolizer.label);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵpropertyInterpolate("label", ɵngcc0.ɵɵpipeBind1(8, 52, "STYLER.textColor"));
        ɵngcc0.ɵɵproperty("symbolizer", ctx.symbolizer);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(12, 54, "STYLER.font"), ":");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngModelOptions", ɵngcc0.ɵɵpureFunction0(93, _c2))("ngModel", ctx.symbolizer.font);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.fonts);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(19, 56, "STYLER.textSize"), ":");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngModelOptions", ɵngcc0.ɵɵpureFunction0(94, _c2))("ngModel", ctx.symbolizer.size);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(25, 58, "STYLER.justify"), ":");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵpropertyInterpolate("title", ɵngcc0.ɵɵpipeBind1(27, 60, "STYLER.warningAttribNotStoredNotVisualized"));
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngModel", ctx.symbolizer.justify)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(95, _c2));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.justifications);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(35, 62, "STYLER.transform"), ":");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵpropertyInterpolate("title", ɵngcc0.ɵɵpipeBind1(37, 64, "STYLER.warningAttribNotStoredNotVisualized"));
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngModel", ctx.symbolizer.transform)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(96, _c2));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.transforms);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(45, 66, "STYLER.fontStyle"), ":");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵpropertyInterpolate("title", ɵngcc0.ɵɵpipeBind1(47, 68, "STYLER.warningAttribStoredNotVisualized"));
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngModel", ctx.symbolizer.fontStyle)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(97, _c2));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.fontStyles);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(55, 70, "STYLER.fontWeight"), ":");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵpropertyInterpolate("title", ɵngcc0.ɵɵpipeBind1(57, 72, "STYLER.warningAttribStoredNotVisualized"));
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngModel", ctx.symbolizer.fontWeight)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(98, _c2));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.fontWeights);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵpropertyInterpolate("label", ɵngcc0.ɵɵpipeBind1(63, 74, "STYLER.opacity"));
        ɵngcc0.ɵɵpropertyInterpolate("warning", ɵngcc0.ɵɵpipeBind1(64, 76, "STYLER.warningAttribNotStoredVisualized"));
        ɵngcc0.ɵɵproperty("symbolizer", ctx.symbolizer);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵpropertyInterpolate("label", ɵngcc0.ɵɵpipeBind1(66, 78, "STYLER.haloColor"));
        ɵngcc0.ɵɵproperty("symbolizer", ctx.symbolizer);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵpropertyInterpolate("label", ɵngcc0.ɵɵpipeBind1(68, 80, "STYLER.haloWidth"));
        ɵngcc0.ɵɵproperty("symbolizer", ctx.symbolizer);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(72, 82, "STYLER.offsetX"), ":");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.symbolizer.offset !== undefined);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(78, 84, "STYLER.offsetY"), ":");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.symbolizer.offset !== undefined);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵpropertyInterpolate("label", ɵngcc0.ɵɵpipeBind1(82, 86, "STYLER.rotation"));
        ɵngcc0.ɵɵproperty("symbolizer", ctx.symbolizer);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(86, 88, "STYLER.anchor"), ":");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵpropertyInterpolate("title", ɵngcc0.ɵɵpipeBind1(88, 90, "STYLER.warningAttribStoredNotVisualized"));
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngModel", ctx.symbolizer.anchor)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(99, _c2));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.anchors);
    } }, directives: [ɵngcc5.ɵNgNoValidate, ɵngcc5.NgControlStatusGroup, ɵngcc5.NgForm, ɵngcc5.DefaultValueAccessor, ɵngcc5.NgControlStatus, ɵngcc5.NgModel, HsColorPickerComponent, ɵngcc5.SelectMultipleControlValueAccessor, ɵngcc3.NgForOf, ɵngcc5.SelectControlValueAccessor, HsSliderComponent, ɵngcc3.NgIf, ɵngcc5.NgSelectOption, ɵngcc5.ɵNgSelectMultipleOption, ɵngcc5.RangeValueAccessor], pipes: [ɵngcc1.TranslatePipe], encapsulation: 2 });
HsTextSymbolizerComponent.propDecorators = {
    symbolizer: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsTextSymbolizerComponent, [{
        type: Component,
        args: [{
                selector: 'hs-text-symbolizer',
                template: "<form class=\"form\">\n  <div class=\"d-flex flex-row\">\n    <div class=\"p-1 w-25\">{{'STYLER.template' | translate}}:</div>\n    <div class=\"p-1 w-75\">\n      <input class=\"form-control form-control-sm\" [ngModelOptions]=\"{standalone: true}\" [(ngModel)]=\"symbolizer.label\"\n        (change)=\"emitChange()\" />\n    </div>\n  </div>\n\n  <hs-symbolizer-color-picker [symbolizer]=\"symbolizer\" attribute=\"color\" opacityAttribute=\"opacity\"\n    (changes)=\"emitChange()\" label=\"{{'STYLER.textColor' | translate}}\"></hs-symbolizer-color-picker>\n\n  <div class=\"d-flex flex-row\">\n    <div class=\"p-1 w-25\">{{'STYLER.font' | translate}}:</div>\n    <div class=\"p-1 w-75\">\n      <select class=\"form-control form-control-sm\" [ngModelOptions]=\"{standalone: true}\" [(ngModel)]=\"symbolizer.font\"\n        multiple>\n        <option *ngFor=\"let font of fonts\" [ngValue]=\"font\">{{font}}</option>\n      </select>\n    </div>\n  </div>\n\n  <div class=\"d-flex flex-row\">\n    <div class=\"p-1 w-25\">{{'STYLER.textSize' | translate}}:</div>\n    <div class=\"p-1 w-75\">\n      <input class=\"form-control form-control-sm\" [ngModelOptions]=\"{standalone: true}\" [(ngModel)]=\"symbolizer.size\"\n        (change)=\"emitChange()\" />\n    </div>\n  </div>\n\n  <div class=\"d-flex flex-row\">\n    <div class=\"p-1 w-25 mt-2\">{{'STYLER.justify' | translate}}:</div>\n    <span class=\"badge badge-warning mt-2\" title=\"{{'STYLER.warningAttribNotStoredNotVisualized' | translate}}\">!</span>\n    <div class=\"p-1 w-75\">\n      <select class=\"form-control form-control-sm\" [(ngModel)]=\"symbolizer.justify\" (change)=\"emitChange()\"\n        [ngModelOptions]=\"{standalone: true}\">\n        <option *ngFor=\"let justify of justifications\">{{justify}}</option>\n      </select>\n    </div>\n  </div>\n\n  <div class=\"d-flex flex-row\">\n    <div class=\"p-1 w-25 mt-2\">{{'STYLER.transform' | translate}}:</div>\n    <span class=\"badge badge-warning mt-2\" title=\"{{'STYLER.warningAttribNotStoredNotVisualized' | translate}}\">!</span>\n    <div class=\"p-1 w-75\">\n      <select class=\"form-control form-control-sm\" [(ngModel)]=\"symbolizer.transform\" (change)=\"emitChange()\"\n        [ngModelOptions]=\"{standalone: true}\">\n        <option *ngFor=\"let transform of transforms\">{{transform}}</option>\n      </select>\n    </div>\n  </div>\n\n  <div class=\"d-flex flex-row\">\n    <div class=\"p-1 w-25 mt-2\">{{'STYLER.fontStyle' | translate}}:</div>\n    <span class=\"badge badge-warning mt-2\" title=\"{{'STYLER.warningAttribStoredNotVisualized' | translate}}\">!</span>\n    <div class=\"p-1 w-75\">\n      <select class=\"form-control form-control-sm\" [(ngModel)]=\"symbolizer.fontStyle\" (change)=\"emitChange()\"\n        [ngModelOptions]=\"{standalone: true}\">\n        <option *ngFor=\"let fontStyle of fontStyles\">{{fontStyle}}</option>\n      </select>\n    </div>\n  </div>\n\n  <div class=\"d-flex flex-row\">\n    <div class=\"p-1 w-25 mt-2\">{{'STYLER.fontWeight' | translate}}:</div>\n    <span class=\"badge badge-warning mt-2\" title=\"{{'STYLER.warningAttribStoredNotVisualized' | translate}}\">!</span>\n    <div class=\"p-1 w-75\">\n      <select class=\"form-control form-control-sm\" [(ngModel)]=\"symbolizer.fontWeight\" (change)=\"emitChange()\"\n        [ngModelOptions]=\"{standalone: true}\">\n        <option *ngFor=\"let fontWeight of fontWeights\">{{fontWeight}}</option>\n      </select>\n    </div>\n  </div>\n\n  <hs-symbolizer-slider [symbolizer]=\"symbolizer\" attribute=\"opacity\" (changes)=\"emitChange()\" step=\"0.05\" min=\"0\"\n    max=\"1\" label=\"{{'STYLER.opacity' | translate}}\"\n    warning=\"{{'STYLER.warningAttribNotStoredVisualized' | translate}}\"></hs-symbolizer-slider>\n\n  <hs-symbolizer-color-picker [symbolizer]=\"symbolizer\" attribute=\"haloColor\" (changes)=\"emitChange()\"\n    label=\"{{'STYLER.haloColor' | translate}}\"></hs-symbolizer-color-picker>\n\n  <hs-symbolizer-slider [symbolizer]=\"symbolizer\" attribute=\"haloWidth\" (changes)=\"emitChange()\" step=\"1\" min=\"0\"\n    max=\"20\" label=\"{{'STYLER.haloWidth' | translate}}\"></hs-symbolizer-slider>\n\n  <div class=\"d-flex flex-row\">\n    <div class=\"p-1 w-25\">{{'STYLER.offsetX' | translate}}:</div>\n    <div class=\"p-1 w-75\">\n      <input class=\"form-control form-control-sm\" type=\"range\" step=\"1\" min=\"-40\" max=\"40\"\n        [ngModelOptions]=\"{standalone: true}\" [(ngModel)]=\"symbolizer.offset[0]\" *ngIf=\"symbolizer.offset !== undefined\"\n        (change)=\"emitChange()\" />\n    </div>\n  </div>\n\n  <div class=\"d-flex flex-row\">\n    <div class=\"p-1 w-25\">{{'STYLER.offsetY' | translate}}:</div>\n    <div class=\"p-1 w-75\">\n      <input class=\"form-control form-control-sm\" type=\"range\" step=\"1\" min=\"-40\" max=\"40\"\n        [ngModelOptions]=\"{standalone: true}\" [(ngModel)]=\"symbolizer.offset[1]\" *ngIf=\"symbolizer.offset !== undefined\"\n        (change)=\"emitChange()\" />\n    </div>\n  </div>\n\n  <hs-symbolizer-slider [symbolizer]=\"symbolizer\" attribute=\"rotate\" (changes)=\"emitChange()\" step=\"1\" min=\"0\" max=\"360\"\n    label=\"{{'STYLER.rotation' | translate}}\"></hs-symbolizer-slider>\n\n  <div class=\"d-flex flex-row\">\n    <div class=\"p-1 w-25 mt-2\">{{'STYLER.anchor' | translate}}:</div>\n    <span class=\"badge badge-warning mt-2\" title=\"{{'STYLER.warningAttribStoredNotVisualized' | translate}}\">!</span>\n    <div class=\"p-1 w-75\">\n      <select class=\"form-control form-control-sm\" [(ngModel)]=\"symbolizer.anchor\" (change)=\"emitChange()\"\n        [ngModelOptions]=\"{standalone: true}\">\n        <option *ngFor=\"let anchor of anchors\">{{anchor}}</option>\n      </select>\n    </div>\n  </div>\n</form>"
            }]
    }], null, { symbolizer: [{
            type: Input
        }] }); })();

class HsStylerModule {
}
HsStylerModule.ɵfac = function HsStylerModule_Factory(t) { return new (t || HsStylerModule)(); };
HsStylerModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: HsStylerModule });
HsStylerModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            ColorSketchModule,
            HsPanelHelpersModule,
            FormsModule,
            NgbModule,
            TranslateModule,
            HsUploadModule,
            HsDownloadModule,
            DragDropModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsStylerModule, [{
        type: NgModule,
        args: [{
                schemas: [CUSTOM_ELEMENTS_SCHEMA],
                declarations: [
                    HsStylerComponent,
                    HsRuleComponent,
                    HsSymbolizerComponent,
                    HsFillSymbolizerComponent,
                    HsMarkSymbolizerComponent,
                    HsIconSymbolizerComponent,
                    HsTextSymbolizerComponent,
                    HsLineSymbolizerComponent,
                    HsColorPickerComponent,
                    HsSliderComponent,
                    HsFiltersComponent,
                    HsFilterComponent,
                    HsComparisonFilterComponent,
                    HsAddFilterButtonComponent,
                    HsScaleDenominatorComponent,
                    HsSelectIconDialogComponent,
                    HsStylerPartBaseComponent,
                    HsRuleListItemComponent,
                    HsSymbolizerListItemComponent,
                ],
                imports: [
                    CommonModule,
                    ColorSketchModule,
                    HsPanelHelpersModule,
                    FormsModule,
                    NgbModule,
                    TranslateModule,
                    HsUploadModule,
                    HsDownloadModule,
                    DragDropModule,
                ],
                exports: [
                    HsStylerComponent,
                    HsRuleComponent,
                    HsSymbolizerComponent,
                    HsFillSymbolizerComponent,
                    HsMarkSymbolizerComponent,
                    HsIconSymbolizerComponent,
                    HsTextSymbolizerComponent,
                    HsLineSymbolizerComponent,
                    HsSymbolizerListItemComponent,
                    HsColorPickerComponent,
                    HsSliderComponent,
                    HsFiltersComponent,
                    HsFilterComponent,
                    HsComparisonFilterComponent,
                    HsAddFilterButtonComponent,
                    HsScaleDenominatorComponent,
                    HsSelectIconDialogComponent,
                    HsRuleListItemComponent,
                ],
                entryComponents: [
                    HsStylerComponent,
                    HsRuleComponent,
                    HsSymbolizerComponent,
                    HsFillSymbolizerComponent,
                    HsMarkSymbolizerComponent,
                    HsIconSymbolizerComponent,
                    HsTextSymbolizerComponent,
                    HsLineSymbolizerComponent,
                    HsColorPickerComponent,
                    HsSliderComponent,
                    HsFiltersComponent,
                    HsFilterComponent,
                    HsComparisonFilterComponent,
                    HsAddFilterButtonComponent,
                    HsScaleDenominatorComponent,
                    HsSelectIconDialogComponent,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(HsStylerModule, { declarations: function () { return [HsStylerComponent, HsRuleComponent, HsSymbolizerComponent, HsFillSymbolizerComponent, HsMarkSymbolizerComponent, HsIconSymbolizerComponent, HsTextSymbolizerComponent, HsLineSymbolizerComponent, HsColorPickerComponent, HsSliderComponent, HsFiltersComponent, HsFilterComponent, HsComparisonFilterComponent, HsAddFilterButtonComponent, HsScaleDenominatorComponent, HsSelectIconDialogComponent, HsStylerPartBaseComponent, HsRuleListItemComponent, HsSymbolizerListItemComponent]; }, imports: function () { return [CommonModule,
        ColorSketchModule, HsPanelHelpersModule, FormsModule,
        NgbModule,
        TranslateModule, HsUploadModule, HsDownloadModule, DragDropModule]; }, exports: function () { return [HsStylerComponent, HsRuleComponent, HsSymbolizerComponent, HsFillSymbolizerComponent, HsMarkSymbolizerComponent, HsIconSymbolizerComponent, HsTextSymbolizerComponent, HsLineSymbolizerComponent, HsSymbolizerListItemComponent, HsColorPickerComponent, HsSliderComponent, HsFiltersComponent, HsFilterComponent, HsComparisonFilterComponent, HsAddFilterButtonComponent, HsScaleDenominatorComponent, HsSelectIconDialogComponent, HsRuleListItemComponent]; } }); })();

class HsQueryAttributeRowComponent {
    constructor() {
        this.isObject = false;
    }
    ngOnInit() {
        this.checkAttributeValue();
    }
    change() {
        var _a;
        if ((_a = this.feature) === null || _a === void 0 ? void 0 : _a.feature) {
            const feature = this.feature.feature;
            feature.set(this.attribute.name, this.attribute.value);
        }
    }
    checkAttributeValue() {
        if (typeof this.attribute.value == 'object' &&
            !Array.isArray(this.attribute.value)) {
            this.isObject = true;
            this.attribute.value = JSON.stringify(this.attribute.value);
        }
    }
}
HsQueryAttributeRowComponent.ɵfac = function HsQueryAttributeRowComponent_Factory(t) { return new (t || HsQueryAttributeRowComponent)(); };
HsQueryAttributeRowComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsQueryAttributeRowComponent, selectors: [["hs-query-attribute-row"]], inputs: { attribute: "attribute", feature: "feature", readonly: "readonly", template: "template" }, decls: 7, vars: 3, consts: [[1, "row"], [1, "input-group", "m-1"], [1, "input-group-prepend"], [1, "input-group-text"], ["class", "form-control", 3, "ngModel", "readonly", "ngModelOptions", "ngModelChange", "change", 4, "ngIf"], ["class", "form-control", "name", "attributeValue", 3, "ngModel", "readonly", "ngModelOptions", "ngModelChange", 4, "ngIf"], [1, "form-control", 3, "ngModel", "readonly", "ngModelOptions", "ngModelChange", "change"], ["name", "attributeValue", 1, "form-control", 3, "ngModel", "readonly", "ngModelOptions", "ngModelChange"]], template: function HsQueryAttributeRowComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "span", 3);
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(5, HsQueryAttributeRowComponent_input_5_Template, 1, 4, "input", 4);
        ɵngcc0.ɵɵtemplate(6, HsQueryAttributeRowComponent_textarea_6_Template, 2, 4, "textarea", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate(ctx.attribute.name);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.isObject);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isObject);
    } }, directives: [ɵngcc3.NgIf, ɵngcc5.DefaultValueAccessor, ɵngcc5.NgControlStatus, ɵngcc5.NgModel], encapsulation: 2 });
HsQueryAttributeRowComponent.propDecorators = {
    attribute: [{ type: Input }],
    feature: [{ type: Input }],
    readonly: [{ type: Input }],
    template: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsQueryAttributeRowComponent, [{
        type: Component,
        args: [{
                selector: 'hs-query-attribute-row',
                template: "<div class=\"row\">\n    <div class=\"input-group m-1\">\n        <div class=\"input-group-prepend\">\n            <span class=\"input-group-text\">{{attribute.name}}</span>\n        </div>\n        <input class=\"form-control\" *ngIf=\"!isObject\" [(ngModel)]=\"attribute.value\" (change)=\"change()\"\n            [readonly]=\"readonly\" [ngModelOptions]=\"{standalone: true}\">\n        <textarea class=\"form-control\" *ngIf=\"isObject\" name=\"attributeValue\" [(ngModel)]=\"attribute.value\"\n            [readonly]=\"readonly\" [ngModelOptions]=\"{standalone: true}\">\n            </textarea>\n    </div>\n</div>"
            }]
    }], function () { return []; }, { attribute: [{
            type: Input
        }], feature: [{
            type: Input
        }], readonly: [{
            type: Input
        }], template: [{
            type: Input
        }] }); })();

class HsQueryDefaultInfoPanelBodyComponent {
    constructor(HsQueryBaseService) {
        this.HsQueryBaseService = HsQueryBaseService;
    }
    ngOnInit() {
        this.featureInfoExpanded = true;
    }
}
HsQueryDefaultInfoPanelBodyComponent.ɵfac = function HsQueryDefaultInfoPanelBodyComponent_Factory(t) { return new (t || HsQueryDefaultInfoPanelBodyComponent)(ɵngcc0.ɵɵdirectiveInject(HsQueryBaseService)); };
HsQueryDefaultInfoPanelBodyComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsQueryDefaultInfoPanelBodyComponent, selectors: [["hs-query-default-info-panel-body"]], decls: 1, vars: 1, consts: [["class", "card hs-main-panel", 4, "ngIf"], [1, "card", "hs-main-panel"], [1, "card-body"], [1, "dropdown", 3, "hidden"], ["data-toggle", "dropdown", 1, "btn", "btn-light", "w-100", "dropdown-toggle", "rounded-0", 3, "click"], ["class", "dropdown-menu position-relative w-100", 3, "ngClass", "innerHtml", 4, "ngFor", "ngForOf"], [3, "features"], [1, "table", "table-striped", 2, "table-layout", "fixed", 3, "hidden"], [4, "ngFor", "ngForOf"], ["id", "invisible_popup", 2, "display", "block", "z-index", "12122", "left", "-10000px", "position", "absolute"], [1, "dropdown-menu", "position-relative", "w-100", 3, "ngClass", "innerHtml"], [1, "first-col"], [1, "second-col", 3, "innerHtml"]], template: function HsQueryDefaultInfoPanelBodyComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, HsQueryDefaultInfoPanelBodyComponent_div_0_Template, 12, 9, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.HsQueryBaseService.data.features.length > 0 || ctx.HsQueryBaseService.data.coordinates.length > 0);
    } }, directives: function () { return [ɵngcc3.NgIf, ɵngcc3.NgForOf, HsQueryFeatureListComponent, ɵngcc3.NgClass]; }, pipes: function () { return [ɵngcc1.TranslatePipe]; }, encapsulation: 2 });
HsQueryDefaultInfoPanelBodyComponent.ctorParameters = () => [
    { type: HsQueryBaseService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsQueryDefaultInfoPanelBodyComponent, [{
        type: Component,
        args: [{
                selector: 'hs-query-default-info-panel-body',
                template: "<div *ngIf=\"(HsQueryBaseService.data.features.length > 0) || (HsQueryBaseService.data.coordinates.length > 0)\" class=\"card hs-main-panel\">\n    <div class=\"card-body\">\n        <div class=\"dropdown\" [hidden]=\"!(HsQueryBaseService.data.featureInfoHtmls.length > 0)\">\n            <button class=\"btn btn-light w-100 dropdown-toggle rounded-0\" data-toggle=\"dropdown\" [attr.aria-expanded]=\"featureInfoExpanded\" (click)=\"featureInfoExpanded = !featureInfoExpanded\">\n                {{'QUERY.featureInfo' | translate}}\n            </button>\n            <div class=\"dropdown-menu position-relative w-100\" [ngClass]=\"{'show': featureInfoExpanded}\" *ngFor=\"let html of HsQueryBaseService.data.featureInfoHtmls\" [innerHtml]=\"html\"></div>\n        </div>\n        <hs-query-feature-list [features]=\"HsQueryBaseService.data.features\"></hs-query-feature-list>\n        <table class=\"table table-striped\" style=\"table-layout:fixed\" [hidden]=\"!(HsQueryBaseService.data.attributes.length > 0)\">\n            <tbody><tr *ngFor=\"let attribute of HsQueryBaseService.data.attributes\">\n                <td class=\"first-col\">{{attribute.name}}</td>\n                <td class=\"second-col\" [innerHtml]=\"attribute.value\"></td>\n            </tr>\n        </tbody></table>\n    </div>\n    <iframe id=\"invisible_popup\" style=\"display:block; z-index:12122;left:-10000px; position:absolute\"></iframe>\n</div>\n"
            }]
    }], function () { return [{ type: HsQueryBaseService }]; }, null); })();

[];
class HsFeatureCommonService {
    constructor(HsQueryVectorService, HsToastService, HsLanguageService, HsMapService, HsLayerUtilsService) {
        this.HsQueryVectorService = HsQueryVectorService;
        this.HsToastService = HsToastService;
        this.HsLanguageService = HsLanguageService;
        this.HsMapService = HsMapService;
        this.HsLayerUtilsService = HsLayerUtilsService;
        this.listSubject = new BehaviorSubject([]);
        this.availableLayer$ = this.listSubject.asObservable();
        this.HsMapService.loaded().then((map) => {
            map.getLayers().on('change:length', () => {
                this.updateLayerList();
            });
        });
    }
    translateString(module, text) {
        return this.HsLanguageService.getTranslationIgnoreNonExisting(module, text);
    }
    updateLayerList() {
        const layers = this.HsMapService.getLayersArray().filter((layer) => {
            return this.HsLayerUtilsService.isLayerDrawable(layer);
        });
        this.listSubject.next(layers);
    }
    toggleExportMenu(exportFormats, features) {
        for (const format of exportFormats) {
            format.serializedData = this.HsQueryVectorService.exportData(format.name, features);
        }
    }
    moveOrCopyFeature(type, features, toLayer) {
        features.forEach((feature) => {
            feature.setStyle(null); //To prevent feature from getting individual style
            toLayer.getSource().addFeature(feature.clone());
            if (type == 'move') {
                this.HsQueryVectorService.removeFeature(feature);
            }
        });
        this.HsToastService.createToastPopupMessage(this.HsLanguageService.getTranslation('QUERY.feature.featureEdited'), this.HsLanguageService.getTranslation(`QUERY.feature.feature${type}Succ`) + getTitle(toLayer), {
            toastStyleClasses: 'bg-success text-light',
            serviceCalledFrom: 'HsFeatureCommonService',
        });
    }
}
HsFeatureCommonService.ɵfac = function HsFeatureCommonService_Factory(t) { return new (t || HsFeatureCommonService)(ɵngcc0.ɵɵinject(HsQueryVectorService), ɵngcc0.ɵɵinject(HsToastService), ɵngcc0.ɵɵinject(HsLanguageService), ɵngcc0.ɵɵinject(HsMapService), ɵngcc0.ɵɵinject(HsLayerUtilsService)); };
HsFeatureCommonService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HsFeatureCommonService_Factory() { return new HsFeatureCommonService(i0.ɵɵinject(HsQueryVectorService), i0.ɵɵinject(HsToastService), i0.ɵɵinject(HsLanguageService), i0.ɵɵinject(HsMapService), i0.ɵɵinject(HsLayerUtilsService)); }, token: HsFeatureCommonService, providedIn: "root" });
HsFeatureCommonService.ctorParameters = () => [
    { type: HsQueryVectorService },
    { type: HsToastService },
    { type: HsLanguageService },
    { type: HsMapService },
    { type: HsLayerUtilsService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsFeatureCommonService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: HsQueryVectorService }, { type: HsToastService }, { type: HsLanguageService }, { type: HsMapService }, { type: HsLayerUtilsService }]; }, null); })();

class HsQueryFeatureComponent {
    constructor(HsMapService, HsQueryVectorService, HsFeatureCommonService, HsLayerUtilsService, cd) {
        this.HsMapService = HsMapService;
        this.HsQueryVectorService = HsQueryVectorService;
        this.HsFeatureCommonService = HsFeatureCommonService;
        this.HsLayerUtilsService = HsLayerUtilsService;
        this.cd = cd;
        this.attributeName = '';
        this.attributeValue = '';
        this.newAttribVisible = false;
        this.exportFormats = [
            { name: 'WKT', ext: 'wkt', mimeType: 'text/plain', downloadData: '' },
            {
                name: 'GeoJSON',
                ext: 'geojson',
                mimeType: 'application/json',
                downloadData: '',
            },
        ];
        this.exportMenuVisible = false;
        this.editMenuVisible = false;
        this.selectedLayer = null;
        this.getTitle = getTitle;
    }
    ngAfterViewInit() {
        const featureLayer = this.HsMapService.getLayerForFeature(this.olFeature());
        this.availableLayersSubscription =
            this.HsFeatureCommonService.availableLayer$.subscribe((layers) => {
                this.availableLayers = layers.filter((layer) => layer != featureLayer);
                this.cd.markForCheck();
            });
    }
    ngOnDestroy() {
        this.availableLayersSubscription.unsubscribe();
    }
    olFeature() {
        return this.feature.feature;
    }
    isFeatureRemovable() {
        return this.olFeature()
            ? this.HsQueryVectorService.isFeatureRemovable(this.olFeature())
            : false;
    }
    saveNewAttribute(attributeName, attributeValue) {
        var _a;
        if ((_a = this.feature) === null || _a === void 0 ? void 0 : _a.feature) {
            const feature = this.feature.feature;
            const getDuplicates = this.feature.attributes.filter((duplicate) => duplicate.name == attributeName);
            if (getDuplicates.length == 0) {
                const obj = { name: attributeName, value: attributeValue };
                this.feature.attributes.push(obj);
                feature.set(attributeName, attributeValue);
            }
        }
        this.newAttribVisible = !this.newAttribVisible;
        this.attributeName = '';
        this.attributeValue = '';
    }
    removeFeature() {
        this.HsQueryVectorService.removeFeature(this.olFeature());
    }
    zoomToFeature() {
        const extent = this.olFeature().getGeometry().getExtent();
        this.HsMapService.fitExtent(extent);
    }
    /**
     * Toggle dropdown menus
     * @param beingToggled Menu being toggled
     * @param other Other menu to be closed if opened
     */
    toggleMenus(beingToggled, other) {
        this[other] = this[other] ? !this[other] : this[other];
        this[beingToggled] = !this[beingToggled];
    }
    toggleExportMenu() {
        this.HsFeatureCommonService.toggleExportMenu(this.exportFormats, this.olFeature());
        this.toggleMenus('exportMenuVisible', 'editMenuVisible');
    }
    editTypeSelected(type) {
        this.editType = type;
        this.editMenuVisible = !this.editMenuVisible;
    }
    toggleEditMenu() {
        if (this.editType) {
            this.editType = null;
            return;
        }
        this.toggleMenus('editMenuVisible', 'exportMenuVisible');
    }
    moveOrCopyFeature() {
        this.HsFeatureCommonService.moveOrCopyFeature(this.editType, [this.olFeature()], this.selectedLayer);
    }
}
HsQueryFeatureComponent.ɵfac = function HsQueryFeatureComponent_Factory(t) { return new (t || HsQueryFeatureComponent)(ɵngcc0.ɵɵdirectiveInject(HsMapService), ɵngcc0.ɵɵdirectiveInject(HsQueryVectorService), ɵngcc0.ɵɵdirectiveInject(HsFeatureCommonService), ɵngcc0.ɵɵdirectiveInject(HsLayerUtilsService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
HsQueryFeatureComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsQueryFeatureComponent, selectors: [["hs-query-feature"]], inputs: { feature: "feature" }, decls: 61, vars: 53, consts: [[1, "container-fluid"], [1, "row"], [1, "col-12", "m-2"], [4, "ngIf"], [3, "template", "feature", "attribute", "readonly", 4, "ngFor", "ngForOf"], [3, "feature", "attribute", "readonly", 4, "ngFor", "ngForOf"], [1, "input-group", "m-1", 3, "hidden"], [1, "input-group", "m-1"], [1, "form-control", 3, "placeholder", "ngModel", "ngModelOptions", "ngModelChange"], [1, "row", 3, "hidden"], [1, "col-6", "mb-2", "text-left"], [1, "btn-group"], [1, "btn", "btn-primary", "btn-sm", 3, "click"], [1, "icon-save-floppy"], [1, "row", "p-2", 3, "hidden"], [1, "d-flex", "w-100", "input-group", "input-group-sm", "align-items-baseline"], [1, "input-group-prepend"], ["for", "selectedLayer", 1, "px-2"], ["name", "selectedLayer", 1, "form-control", "text-truncate", 3, "title", "ngModel", "ngModelChange"], ["selected", "", "hidden", "", 3, "ngValue", "disabled"], [3, "ngValue", 4, "ngFor", "ngForOf"], [1, "input-group-append"], [1, "btn", "btn-primary", "btn-sm", 3, "disabled", "click"], [1, "justify-content-end", 2, "padding-left", "10px"], [1, "mx-1", "mb-2", "text-right"], [1, "btn", "btn-secondary", "btn-sm", 3, "click"], [1, "icon-calcplus"], [1, "icon-search"], ["type", "button", "data-toggle", "dropdown", "aris-haspopup", "true", 1, "btn", "btn-secondary", "btn-sm", "dropdown-toggle", 3, "click"], [1, "icon-settingsthree-gears"], [1, "dropdown-menu", "dropdown-menu-right", 3, "ngClass"], [1, "dropdown-item", 3, "click"], ["type", "button", "data-toggle", "dropdown", "aris-haspopup", "true", 1, "btn", "btn-secondary", "btn-sm", "dropdown-toggle", "rounded-0", 3, "title", "click"], [1, "icon-download"], ["class", "dropdown-item", 3, "download", "hsDownload", "mimeType", "href", "downloadPrepared", 4, "ngFor", "ngForOf"], ["class", "btn btn-danger btn-sm", 3, "click", 4, "ngIf"], [3, "template", "feature", "attribute", "readonly"], [3, "feature", "attribute", "readonly"], [3, "ngValue"], [1, "dropdown-item", 3, "download", "hsDownload", "mimeType", "href", "downloadPrepared"], [1, "btn", "btn-danger", "btn-sm", 3, "click"], [1, "icon-trash"]], template: function HsQueryFeatureComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "strong");
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵtemplate(5, HsQueryFeatureComponent_span_5_Template, 2, 0, "span", 3);
        ɵngcc0.ɵɵtext(6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(7, HsQueryFeatureComponent_hs_query_attribute_row_7_Template, 1, 4, "hs-query-attribute-row", 4);
        ɵngcc0.ɵɵtemplate(8, HsQueryFeatureComponent_hs_query_attribute_row_8_Template, 1, 3, "hs-query-attribute-row", 5);
        ɵngcc0.ɵɵelementStart(9, "div", 1);
        ɵngcc0.ɵɵelementStart(10, "div", 6);
        ɵngcc0.ɵɵelementStart(11, "div", 7);
        ɵngcc0.ɵɵelementStart(12, "input", 8);
        ɵngcc0.ɵɵlistener("ngModelChange", function HsQueryFeatureComponent_Template_input_ngModelChange_12_listener($event) { return ctx.attributeName = $event; });
        ɵngcc0.ɵɵpipe(13, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(14, "div", 1);
        ɵngcc0.ɵɵelementStart(15, "div", 6);
        ɵngcc0.ɵɵelementStart(16, "div", 7);
        ɵngcc0.ɵɵelementStart(17, "input", 8);
        ɵngcc0.ɵɵlistener("ngModelChange", function HsQueryFeatureComponent_Template_input_ngModelChange_17_listener($event) { return ctx.attributeValue = $event; });
        ɵngcc0.ɵɵpipe(18, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(19, "div", 9);
        ɵngcc0.ɵɵelementStart(20, "div", 10);
        ɵngcc0.ɵɵelementStart(21, "div", 11);
        ɵngcc0.ɵɵelementStart(22, "button", 12);
        ɵngcc0.ɵɵlistener("click", function HsQueryFeatureComponent_Template_button_click_22_listener() { return ctx.saveNewAttribute(ctx.attributeName, ctx.attributeValue); });
        ɵngcc0.ɵɵelement(23, "i", 13);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(24, "div", 14);
        ɵngcc0.ɵɵelementStart(25, "div", 15);
        ɵngcc0.ɵɵelementStart(26, "div", 16);
        ɵngcc0.ɵɵelementStart(27, "label", 17);
        ɵngcc0.ɵɵtext(28);
        ɵngcc0.ɵɵpipe(29, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(30, "select", 18);
        ɵngcc0.ɵɵlistener("ngModelChange", function HsQueryFeatureComponent_Template_select_ngModelChange_30_listener($event) { return ctx.selectedLayer = $event; });
        ɵngcc0.ɵɵpipe(31, "translate");
        ɵngcc0.ɵɵelementStart(32, "option", 19);
        ɵngcc0.ɵɵtext(33);
        ɵngcc0.ɵɵpipe(34, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(35, HsQueryFeatureComponent_option_35_Template, 2, 2, "option", 20);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(36, "div", 21);
        ɵngcc0.ɵɵelementStart(37, "button", 22);
        ɵngcc0.ɵɵlistener("click", function HsQueryFeatureComponent_Template_button_click_37_listener() { return ctx.moveOrCopyFeature(); });
        ɵngcc0.ɵɵelement(38, "i", 13);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(39, "div", 23);
        ɵngcc0.ɵɵelementStart(40, "div", 24);
        ɵngcc0.ɵɵelementStart(41, "div", 11);
        ɵngcc0.ɵɵelementStart(42, "button", 25);
        ɵngcc0.ɵɵlistener("click", function HsQueryFeatureComponent_Template_button_click_42_listener() { return ctx.newAttribVisible = !ctx.newAttribVisible; });
        ɵngcc0.ɵɵelement(43, "i", 26);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(44, "button", 25);
        ɵngcc0.ɵɵlistener("click", function HsQueryFeatureComponent_Template_button_click_44_listener() { return ctx.zoomToFeature(); });
        ɵngcc0.ɵɵelement(45, "i", 27);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(46, "button", 28);
        ɵngcc0.ɵɵlistener("click", function HsQueryFeatureComponent_Template_button_click_46_listener() { return ctx.toggleEditMenu(); });
        ɵngcc0.ɵɵelement(47, "i", 29);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(48, "div", 30);
        ɵngcc0.ɵɵelementStart(49, "a", 31);
        ɵngcc0.ɵɵlistener("click", function HsQueryFeatureComponent_Template_a_click_49_listener() { return ctx.editTypeSelected("copy"); });
        ɵngcc0.ɵɵtext(50);
        ɵngcc0.ɵɵpipe(51, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(52, "a", 31);
        ɵngcc0.ɵɵlistener("click", function HsQueryFeatureComponent_Template_a_click_52_listener() { return ctx.editTypeSelected("move"); });
        ɵngcc0.ɵɵtext(53);
        ɵngcc0.ɵɵpipe(54, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(55, "button", 32);
        ɵngcc0.ɵɵlistener("click", function HsQueryFeatureComponent_Template_button_click_55_listener() { return ctx.toggleExportMenu(); });
        ɵngcc0.ɵɵpipe(56, "translate");
        ɵngcc0.ɵɵelement(57, "i", 33);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(58, "div", 30);
        ɵngcc0.ɵɵtemplate(59, HsQueryFeatureComponent_a_59_Template, 2, 6, "a", 34);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(60, HsQueryFeatureComponent_button_60_Template, 2, 0, "button", 35);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate1("", ctx.feature.name, " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.feature.layer);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.feature.layer, "");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.feature.attributes);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.feature.stats);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("hidden", !ctx.newAttribVisible);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("placeholder", ɵngcc0.ɵɵpipeBind1(13, 31, "QUERY.feature.attributeName"))("ngModel", ctx.attributeName)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(47, _c2));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("hidden", !(ctx.attributeName && ctx.newAttribVisible));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("placeholder", ɵngcc0.ɵɵpipeBind1(18, 33, "QUERY.feature.attributeValue"))("ngModel", ctx.attributeValue)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(48, _c2));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("hidden", !(ctx.attributeName && ctx.attributeValue && ctx.newAttribVisible));
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("hidden", !ctx.editType);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate2("", ctx.HsFeatureCommonService.translateString("QUERY.feature", ctx.editType + "Feature"), " ", ɵngcc0.ɵɵpipeBind1(29, 35, "COMMON.into"), ":");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(31, 37, "ADDLAYERS.Vector.chooseLayer"))("ngModel", ctx.selectedLayer);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngValue", null)("disabled", true);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(34, 39, "ADDLAYERS.Vector.chooseLayer"), "");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.availableLayers);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("disabled", !ctx.selectedLayer);
        ɵngcc0.ɵɵadvance(11);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(49, _c14, ctx.editMenuVisible));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(51, 41, "QUERY.feature.copyFeature"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(54, 43, "QUERY.feature.moveFeature"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(56, 45, "QUERY.downloadAs"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(51, _c14, ctx.exportMenuVisible));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.exportFormats);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isFeatureRemovable());
    } }, directives: [ɵngcc3.NgIf, ɵngcc3.NgForOf, ɵngcc5.DefaultValueAccessor, ɵngcc5.NgControlStatus, ɵngcc5.NgModel, ɵngcc5.SelectControlValueAccessor, ɵngcc5.NgSelectOption, ɵngcc5.ɵNgSelectMultipleOption, ɵngcc3.NgClass, HsQueryAttributeRowComponent, HsDownloadDirective], pipes: [ɵngcc1.TranslatePipe], encapsulation: 2, changeDetection: 0 });
HsQueryFeatureComponent.ctorParameters = () => [
    { type: HsMapService },
    { type: HsQueryVectorService },
    { type: HsFeatureCommonService },
    { type: HsLayerUtilsService },
    { type: ChangeDetectorRef }
];
HsQueryFeatureComponent.propDecorators = {
    feature: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsQueryFeatureComponent, [{
        type: Component,
        args: [{
                selector: 'hs-query-feature',
                template: "<div class=\"container-fluid\">\n    <div class=\"row\">\n        <div class=\"col-12 m-2\"><strong>{{feature.name}} <span *ngIf=\"feature.layer\">in layer</span>\n                {{feature.layer}}</strong></div>\n    </div>\n    <hs-query-attribute-row *ngFor=\"let attribute of feature.attributes\" [template]=\"feature.hstemplate\"\n        [feature]=\"feature\" [attribute]=\"attribute\" [readonly]=\"false\">\n    </hs-query-attribute-row>\n    <hs-query-attribute-row *ngFor=\"let stat of feature.stats\" [feature]=\"feature\" [attribute]=\"stat\" [readonly]=\"true\">\n    </hs-query-attribute-row>\n    <div class=\"row\">\n        <div class=\"input-group m-1\" [hidden]=\"!newAttribVisible\">\n            <div class=\"input-group m-1\">\n                <input class=\"form-control\" [placeholder]=\"'QUERY.feature.attributeName' | translate\" [(ngModel)]=\"attributeName\" [ngModelOptions]=\"{standalone: true}\">\n            </div>\n        </div>\n    </div>\n    <div class=\"row\">\n        <div class=\"input-group m-1\" [hidden]=\"!(attributeName && newAttribVisible)\">\n            <div class=\"input-group m-1\">\n                <input class=\"form-control\" [placeholder]=\"'QUERY.feature.attributeValue' | translate\" [(ngModel)]=\"attributeValue\" [ngModelOptions]=\"{standalone: true}\">\n            </div>\n        </div>\n    </div>\n    <div class=\"row\" [hidden]=\"!(attributeName && attributeValue && newAttribVisible)\">\n        <div class=\"col-6 mb-2 text-left\">\n            <div class=\"btn-group\">\n                <button class=\"btn btn-primary btn-sm\" (click)=\"saveNewAttribute(attributeName,attributeValue)\"><i\n                        class=\"icon-save-floppy\"></i></button>\n            </div>\n        </div>\n    </div>\n    \n    <div [hidden]=\"!editType\" class=\"row p-2 \">\n        <div class=\"d-flex w-100 input-group input-group-sm align-items-baseline\">\n            <div class=\"input-group-prepend\">\n                <label for=\"selectedLayer\" class=\"px-2\">{{HsFeatureCommonService.translateString('QUERY.feature',editType+'Feature')}} {{'COMMON.into' | translate}}:</label>\n            </div>\n            <select class=\"form-control text-truncate\"  [title]=\"'ADDLAYERS.Vector.chooseLayer' | translate\" [(ngModel)]=\"selectedLayer\" name=\"selectedLayer\">\n                <option  [ngValue]=\"null\" [disabled]=\"true\" selected hidden> {{'ADDLAYERS.Vector.chooseLayer' | translate}}</option>\n                <option *ngFor=\"let layer of availableLayers\" [ngValue]=\"layer\">\n                    {{HsLayerUtilsService.translateTitle(getTitle(layer))}}</option>\n            </select>\n            <div class=\"input-group-append\">\n                <button class=\"btn btn-primary btn-sm\" (click)=\"moveOrCopyFeature()\" [disabled]=\"!selectedLayer\"><i class=\"icon-save-floppy\"></i></button>\n              </div>\n        </div>\n    </div>\n</div>\n<div class=\"justify-content-end\" style=\"padding-left: 10px\">\n    <div class=\"mx-1 mb-2 text-right\">\n        <div class=\"btn-group\">\n            <button class=\"btn btn-secondary btn-sm\" (click)=\"newAttribVisible = !newAttribVisible\"><i\n                    class=\"icon-calcplus\"></i></button>\n            <button class=\"btn btn-secondary btn-sm\" (click)=\"zoomToFeature()\"><i class=\"icon-search\"></i></button>\n            <button class=\"btn btn-secondary btn-sm dropdown-toggle\" type=\"button\" data-toggle=\"dropdown\" aris-haspopup=\"true\" (click)=\"toggleEditMenu()\"><i\n                class=\"icon-settingsthree-gears\"></i></button>\n            <div class=\"dropdown-menu dropdown-menu-right\" [ngClass]=\"{'show': editMenuVisible}\">\n                <a class=\"dropdown-item\" (click)=\"editTypeSelected('copy')\">{{'QUERY.feature.copyFeature' | translate}}</a>\n                <a class=\"dropdown-item\" (click)=\"editTypeSelected('move')\">{{'QUERY.feature.moveFeature' | translate}}</a>\n            </div>\n            <button class=\"btn btn-secondary btn-sm dropdown-toggle rounded-0\" type=\"button\" data-toggle=\"dropdown\"\n                aris-haspopup=\"true\" (click)=\"toggleExportMenu()\" [title]=\"'QUERY.downloadAs' | translate\"\n                ><i\n                    class=\"icon-download\"></i></button>\n            <div class=\"dropdown-menu dropdown-menu-right\" [ngClass]=\"{'show': exportMenuVisible}\">\n                <a class=\"dropdown-item\" download=\"{{format.name}}_file.{{format.ext}}\" \n                [hsDownload]=\"format.serializedData\" \n                [mimeType]=\"format.mimeType\"\n                [href]=\"format.downloadData\"\n                (downloadPrepared)=\"format.downloadData = $event\"\n                *ngFor=\"let format of exportFormats\"\n                >{{format.name}}</a>\n            </div>\n            <button class=\"btn btn-danger btn-sm\" (click)=\"removeFeature()\" *ngIf=\"isFeatureRemovable()\"><i\n                    class=\"icon-trash\"></i></button>\n        </div>\n    </div>\n</div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: HsMapService }, { type: HsQueryVectorService }, { type: HsFeatureCommonService }, { type: HsLayerUtilsService }, { type: ɵngcc0.ChangeDetectorRef }]; }, { feature: [{
            type: Input
        }] }); })();

class HsQueryFeatureListComponent {
    constructor(HsQueryVectorService, hsLanguageService, HsDialogContainerService, HsLayoutService, HsFeatureCommonService, HsLayerUtilsService) {
        this.HsQueryVectorService = HsQueryVectorService;
        this.hsLanguageService = hsLanguageService;
        this.HsDialogContainerService = HsDialogContainerService;
        this.HsLayoutService = HsLayoutService;
        this.HsFeatureCommonService = HsFeatureCommonService;
        this.HsLayerUtilsService = HsLayerUtilsService;
        this.selectedFeaturesVisible = true;
        this.exportFormats = [
            { name: 'WKT', ext: 'wkt', mimeType: 'text/plain', downloadData: '' },
            {
                name: 'GeoJSON',
                ext: 'geojson',
                mimeType: 'application/json',
                downloadData: '',
            },
        ];
        this.editType = null;
        this.editMenuVisible = false;
        this.selectedLayer = null;
        this.getTitle = getTitle;
    }
    trackById(index, item) {
        return item.feature.ol_uid;
    }
    olFeatureArray() {
        return this.features.map((feature) => feature.feature);
    }
    /**
     * Toggle dropdown menus
     * @param beingToggled Menu being toggled
     * @param other Other menu to be closed if opened
     */
    toggleMenus(beingToggled, other) {
        this[other] = this[other] ? !this[other] : this[other];
        this[beingToggled] = !this[beingToggled];
    }
    toggleExportMenu() {
        this.HsFeatureCommonService.toggleExportMenu(this.exportFormats, this.olFeatureArray());
        this.toggleMenus('exportMenuVisible', 'editMenuVisible');
    }
    toggleEditMenu() {
        if (this.editType) {
            this.editType = null;
            return;
        }
        this.toggleMenus('editMenuVisible', 'exportMenuVisible');
    }
    editTypeSelected(type) {
        this.editType = type;
        this.editMenuVisible = !this.editMenuVisible;
    }
    moveOrCopyFeature() {
        this.HsFeatureCommonService.moveOrCopyFeature(this.editType, this.olFeatureArray(), this.selectedLayer);
    }
    removeAllSelectedFeatures() {
        return __awaiter(this, void 0, void 0, function* () {
            const dialog = this.HsDialogContainerService.create(HsConfirmDialogComponent, {
                message: this.hsLanguageService.getTranslation('QUERY.reallyDeleteAllSelectedLayers'),
                title: this.hsLanguageService.getTranslation('COMMON.confirmDelete'),
            });
            const confirmed = yield dialog.waitResult();
            if (confirmed == 'yes') {
                for (const feature of this.features) {
                    //Give HsQueryVectorService.featureRemovals time to splice QueryBase.data.features
                    setTimeout(() => {
                        this.HsQueryVectorService.removeFeature(feature.feature);
                    }, 250);
                }
            }
        });
    }
}
HsQueryFeatureListComponent.ɵfac = function HsQueryFeatureListComponent_Factory(t) { return new (t || HsQueryFeatureListComponent)(ɵngcc0.ɵɵdirectiveInject(HsQueryVectorService), ɵngcc0.ɵɵdirectiveInject(HsLanguageService), ɵngcc0.ɵɵdirectiveInject(HsDialogContainerService), ɵngcc0.ɵɵdirectiveInject(HsLayoutService), ɵngcc0.ɵɵdirectiveInject(HsFeatureCommonService), ɵngcc0.ɵɵdirectiveInject(HsLayerUtilsService)); };
HsQueryFeatureListComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsQueryFeatureListComponent, selectors: [["hs-query-feature-list"]], inputs: { features: "features" }, decls: 2, vars: 2, consts: [["class", "navbar navbar-light bg-light px-1", 4, "ngIf"], [4, "ngIf"], [1, "navbar", "navbar-light", "bg-light", "px-1"], [1, "d-flex", "align-items-baseline", "w-100"], [1, "d-flex", "align-items-baseline", 2, "flex", "1"], [1, "m-0", 3, "ngStyle"], ["type", "button", 1, "btn", "dropdown-toggle", "border-0", "ml-2", 3, "title", "click"], ["class", "btn-group", 4, "ngIf"], ["class", "d-flex p-2 w-100", 4, "ngIf"], [1, "btn-group"], ["type", "button", "data-toggle", "dropdown", "aris-haspopup", "true", 1, "btn", "btn-secondary", "btn-sm", "dropdown-toggle", 3, "click"], [1, "icon-settingsthree-gears"], [1, "dropdown-menu", "dropdown-menu-right", 3, "ngClass"], [1, "dropdown-item", 3, "click"], ["type", "button", "data-toggle", "dropdown", "aris-haspopup", "true", 1, "btn", "btn-secondary", "btn-sm", "dropdown-toggle", "rounded-0", 3, "title", "click"], [1, "icon-download"], ["class", "dropdown-item", 3, "download", "hsDownload", "mimeType", "href", "downloadPrepared", 4, "ngFor", "ngForOf"], ["type", "button", 1, "btn-danger", "btn", "btn-sm", "border-0", 3, "title", "click"], [1, "glyphicon", "icon-trash"], [1, "dropdown-item", 3, "download", "hsDownload", "mimeType", "href", "downloadPrepared"], [1, "d-flex", "p-2", "w-100"], [1, "d-flex", "w-100", "input-group", "input-group-sm", "align-items-baseline"], [1, "input-group-prepend"], ["for", "selectedLayer", 1, "px-2"], ["name", "selectedLayer", 1, "form-control", "text-truncate", 3, "ngModel", "title", "ngModelChange"], ["selected", "", "hidden", "", 3, "ngValue", "disabled"], [3, "ngValue", 4, "ngFor", "ngForOf"], [1, "input-group-append"], [1, "btn", "btn-primary", "btn-sm", 3, "disabled", "click"], [1, "icon-save-floppy"], [3, "ngValue"], [3, "feature", 4, "ngFor", "ngForOf", "ngForTrackBy"], [3, "feature"]], template: function HsQueryFeatureListComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, HsQueryFeatureListComponent_div_0_Template, 10, 12, "div", 0);
        ɵngcc0.ɵɵtemplate(1, HsQueryFeatureListComponent_div_1_Template, 3, 6, "div", 1);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.features.length > 0);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.selectedFeaturesVisible);
    } }, directives: [ɵngcc3.NgIf, ɵngcc3.NgStyle, ɵngcc3.NgClass, ɵngcc3.NgForOf, HsDownloadDirective, ɵngcc5.SelectControlValueAccessor, ɵngcc5.NgControlStatus, ɵngcc5.NgModel, ɵngcc5.NgSelectOption, ɵngcc5.ɵNgSelectMultipleOption, HsQueryFeatureComponent], pipes: [ɵngcc1.TranslatePipe, ɵngcc3.AsyncPipe, ɵngcc3.SlicePipe], encapsulation: 2, changeDetection: 0 });
HsQueryFeatureListComponent.ctorParameters = () => [
    { type: HsQueryVectorService },
    { type: HsLanguageService },
    { type: HsDialogContainerService },
    { type: HsLayoutService },
    { type: HsFeatureCommonService },
    { type: HsLayerUtilsService }
];
HsQueryFeatureListComponent.propDecorators = {
    features: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsQueryFeatureListComponent, [{
        type: Component,
        args: [{
                selector: 'hs-query-feature-list',
                template: "<div class=\"navbar navbar-light bg-light px-1\" *ngIf=\"features.length > 0\">\n    <div class=\"d-flex align-items-baseline w-100\">\n        <div class=\"d-flex align-items-baseline\" style=\"flex: 1;\">\n            <p class=\"m-0\" [ngStyle]=\"{'flex' : features.length > 1 ? '' : '1'}\">\n                {{'QUERY.featuresSelected' | translate}}{{features.length}}\n            </p>\n            <button type=\"button\" class=\"btn dropdown-toggle border-0 ml-2\" [title]=\"'HISTORY.toggleDropdown' | translate\"\n                (click)=\"selectedFeaturesVisible = !selectedFeaturesVisible\">\n            </button>\n        </div>\n        <div class=\"btn-group\" *ngIf=\"features.length > 1\">\n            <button class=\"btn btn-secondary btn-sm dropdown-toggle\" type=\"button\" data-toggle=\"dropdown\" aris-haspopup=\"true\"\n                (click)=\"toggleEditMenu()\"><i\n                    class=\"icon-settingsthree-gears\"></i></button>\n            <div class=\"dropdown-menu dropdown-menu-right\" [ngClass]=\"{'show': editMenuVisible}\">\n                <a class=\"dropdown-item\" (click)=\"editTypeSelected('copy')\">{{'QUERY.feature.copyFeatures' | translate}}</a>\n                <a class=\"dropdown-item\" (click)=\"editTypeSelected('move')\">{{'QUERY.feature.moveFeatures' | translate}}</a>\n            </div>\n            <button class=\"btn btn-secondary btn-sm dropdown-toggle rounded-0\" type=\"button\" data-toggle=\"dropdown\"\n                [title]=\"'QUERY.downloadAs' | translate\" (click)=\"toggleExportMenu()\" aris-haspopup=\"true\"><i\n                    class=\"icon-download\"></i></button>\n            <div class=\"dropdown-menu dropdown-menu-right\" [ngClass]=\"{'show': exportMenuVisible}\">\n                <a class=\"dropdown-item\" *ngFor=\"let format of exportFormats\" download=\"{{format.name}}_file.{{format.ext}}\"\n                    [hsDownload]=\"format.serializedData\" [mimeType]=\"format.mimeType\" [href]=\"format.downloadData\"\n                    (downloadPrepared)=\"format.downloadData = $event\">\n                    {{format.name}}</a>\n            </div>\n            <button type=\"button\" class=\"btn-danger btn btn-sm border-0\" [title]=\"'QUERY.deleteAllSelected' | translate\"\n                (click)=\"removeAllSelectedFeatures()\">\n                <i class=\"glyphicon icon-trash\"></i>\n            </button>\n        </div>\n    </div>\n    <div *ngIf=\"editType\" class=\"d-flex p-2 w-100\">\n        <div class=\"d-flex w-100 input-group input-group-sm align-items-baseline\">\n            <div class=\"input-group-prepend\">\n                <label for=\"selectedLayer\" class=\"px-2\">{{HsFeatureCommonService.translateString('QUERY.feature',editType+'Features')}} {{'COMMON.into' | translate}}:</label>\n            </div>\n            <select class=\"form-control text-truncate\" [(ngModel)]=\"selectedLayer\" name=\"selectedLayer\" [title]=\"'ADDLAYERS.Vector.chooseLayer' | translate\">\n                <option  [ngValue]=\"null\" [disabled]=\"true\" selected hidden > {{'ADDLAYERS.Vector.chooseLayer' | translate}}</option>\n                <option *ngFor=\"let layer of HsFeatureCommonService.availableLayer$ | async\" [ngValue]=\"layer\">\n                    {{HsLayerUtilsService.translateTitle(getTitle(layer))}}</option>\n            </select>\n            <div class=\"input-group-append\">\n                <button class=\"btn btn-primary btn-sm\" (click)=\"moveOrCopyFeature()\" [disabled]=\"!selectedLayer\"><i class=\"icon-save-floppy\"></i></button>\n              </div>\n        </div>\n    </div>\n</div>\n<div *ngIf=\"selectedFeaturesVisible\">\n    <hs-query-feature *ngFor=\"let item of features | slice:0:50; trackBy: trackById\" [feature]=\"item\">\n    </hs-query-feature>\n</div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: HsQueryVectorService }, { type: HsLanguageService }, { type: HsDialogContainerService }, { type: HsLayoutService }, { type: HsFeatureCommonService }, { type: HsLayerUtilsService }]; }, { features: [{
            type: Input
        }] }); })();

class HsQueryModule {
}
HsQueryModule.ɵfac = function HsQueryModule_Factory(t) { return new (t || HsQueryModule)(); };
HsQueryModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: HsQueryModule });
HsQueryModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            HsPanelHelpersModule,
            FormsModule,
            TranslateModule,
            HsDownloadModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsQueryModule, [{
        type: NgModule,
        args: [{
                schemas: [CUSTOM_ELEMENTS_SCHEMA],
                declarations: [
                    HsQueryComponent,
                    HsQueryFeaturePopupComponent,
                    HsQueryFeatureComponent,
                    HsQueryFeatureListComponent,
                    HsQueryDefaultInfoPanelBodyComponent,
                    HsQueryAttributeRowComponent,
                ],
                imports: [
                    CommonModule,
                    HsPanelHelpersModule,
                    FormsModule,
                    TranslateModule,
                    HsDownloadModule,
                ],
                exports: [
                    HsQueryComponent,
                    HsQueryFeaturePopupComponent,
                    HsQueryFeatureComponent,
                    HsQueryFeatureListComponent,
                ],
                entryComponents: [HsQueryComponent, HsQueryFeaturePopupComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(HsQueryModule, { declarations: function () { return [HsQueryComponent, HsQueryFeaturePopupComponent, HsQueryFeatureComponent, HsQueryFeatureListComponent, HsQueryDefaultInfoPanelBodyComponent, HsQueryAttributeRowComponent]; }, imports: function () { return [CommonModule, HsPanelHelpersModule, FormsModule,
        TranslateModule, HsDownloadModule]; }, exports: function () { return [HsQueryComponent, HsQueryFeaturePopupComponent, HsQueryFeatureComponent, HsQueryFeatureListComponent]; } }); })();

class HsDrawModule {
}
HsDrawModule.ɵfac = function HsDrawModule_Factory(t) { return new (t || HsDrawModule)(); };
HsDrawModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: HsDrawModule });
HsDrawModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            HsPanelHelpersModule,
            FormsModule,
            NgbModule,
            HsStylerModule,
            TranslateModule,
            HsQueryModule,
            HsLaymanModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsDrawModule, [{
        type: NgModule,
        args: [{
                schemas: [CUSTOM_ELEMENTS_SCHEMA],
                declarations: [
                    HsDrawComponent,
                    HsDrawLayerMetadataDialogComponent,
                    HsDrawToolbarComponent,
                ],
                imports: [
                    CommonModule,
                    HsPanelHelpersModule,
                    FormsModule,
                    NgbModule,
                    HsStylerModule,
                    TranslateModule,
                    HsQueryModule,
                    HsLaymanModule,
                ],
                exports: [
                    HsDrawComponent,
                    HsDrawLayerMetadataDialogComponent,
                    HsDrawToolbarComponent,
                ],
                entryComponents: [
                    HsDrawComponent,
                    HsDrawToolbarComponent,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(HsDrawModule, { declarations: function () { return [HsDrawComponent, HsDrawLayerMetadataDialogComponent, HsDrawToolbarComponent]; }, imports: function () { return [CommonModule, HsPanelHelpersModule, FormsModule,
        NgbModule, HsStylerModule, TranslateModule, HsQueryModule, HsLaymanModule]; }, exports: function () { return [HsDrawComponent, HsDrawLayerMetadataDialogComponent, HsDrawToolbarComponent]; } }); })();

const featureLimit = 20;
class HsFeatureFilterPipe {
    /**
     * Transform
     *
     * @param {any[]} features
     * @param {string} searchText
     * @returns {any[]}
     */
    transform(features, searchText) {
        if (!features) {
            return [];
        }
        if (!searchText) {
            return features;
        }
        searchText = searchText.toLocaleLowerCase();
        return features
            .filter((feature) => {
            return feature.name.toLocaleLowerCase().includes(searchText);
        })
            .slice(0, featureLimit);
    }
}
HsFeatureFilterPipe.ɵfac = function HsFeatureFilterPipe_Factory(t) { return new (t || HsFeatureFilterPipe)(); };
HsFeatureFilterPipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "featureFilter", type: HsFeatureFilterPipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsFeatureFilterPipe, [{
        type: Pipe,
        args: [{ name: 'featureFilter' }]
    }], null, null); })();

class HsLayerFeaturesComponent {
    constructor(HsFeatureTableService, HsUtilsService, HsMapService, HsLanguageService, HsLayerUtilsService //Used in template
    ) {
        this.HsFeatureTableService = HsFeatureTableService;
        this.HsUtilsService = HsUtilsService;
        this.HsMapService = HsMapService;
        this.HsLanguageService = HsLanguageService;
        this.HsLayerUtilsService = HsLayerUtilsService;
        this.showFeatureStats = false; //Toggle for showing feature statistics
        this.searchedFeatures = '';
    }
    /**
     * @public
     * @description Activate listeners for any layer source changes to update the html table
     */
    ngOnInit() {
        const olLayer = this.layer.lyr;
        const source = this.HsLayerUtilsService.isLayerClustered(olLayer)
            ? olLayer.getSource().getSource()
            : olLayer.getSource();
        if (source) {
            this.HsFeatureTableService.fillFeatureList(olLayer);
            source.on('changefeature', (e) => {
                this.HsFeatureTableService.updateFeatureDescription(e.feature);
            });
            source.on('addfeature', (e) => {
                this.HsFeatureTableService.addFeatureDescription(e.feature);
            });
            source.on('removefeature', (e) => {
                this.HsFeatureTableService.removeFeatureDescription(e.feature);
            });
        }
    }
    /**
     * @param operation Action for html table
     * @public
     * @description zoom to feature from html table after triggering zoom action
     */
    executeOperation(operation) {
        switch (operation.action) {
            case 'zoom to':
                const extent = operation.feature.getGeometry().getExtent();
                this.HsMapService.fitExtent(extent);
                break;
            case 'custom action':
                operation.customAction(operation.feature);
                break;
            default:
        }
    }
}
HsLayerFeaturesComponent.ɵfac = function HsLayerFeaturesComponent_Factory(t) { return new (t || HsLayerFeaturesComponent)(ɵngcc0.ɵɵdirectiveInject(HsFeatureTableService), ɵngcc0.ɵɵdirectiveInject(HsUtilsService), ɵngcc0.ɵɵdirectiveInject(HsMapService), ɵngcc0.ɵɵdirectiveInject(HsLanguageService), ɵngcc0.ɵɵdirectiveInject(HsLayerUtilsService)); };
HsLayerFeaturesComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsLayerFeaturesComponent, selectors: [["hs-layer-features"]], inputs: { layer: "layer" }, decls: 14, vars: 12, consts: [[1, "mt-1", 2, "text-align", "center"], [1, "form-group", "mt-1", "mb-1"], [1, "input-group", 2, "margin-bottom", "4px"], ["type", "text", "name", "FeatureName", 1, "form-control", "hs-filter", 3, "placeholder", "ngModel", "ngModelChange"], ["style", "width:100%;", 4, "ngFor", "ngForOf"], [1, "p-2"], [3, "click"], [2, "width", "100%"], [2, "text-align", "center", "background-color", "rgba(0,0,0,0.05)"], ["colspan", "2"], [2, "float", "center", 3, "title", "click"], ["rowspan", "3", 4, "ngFor", "ngForOf"], ["class", "tdbreak", 3, "hidden", 4, "ngFor", "ngForOf"], ["rowspan", "3"], [1, "tdbreak", 2, "background-color", "rgba(0,0,0,0.03)"], [2, "float", "right", 3, "title", "click"], [1, "tdbreak", 2, "min-width", "200px", "max-width", "200px"], [4, "ngIf"], [3, "innerHTML", 4, "ngIf"], [3, "innerHTML"], [3, "click", 4, "ngFor", "ngForOf"], [1, "tdbreak", 3, "hidden"]], template: function HsLayerFeaturesComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "h3", 0);
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵelementStart(3, "div", 2);
        ɵngcc0.ɵɵelementStart(4, "input", 3);
        ɵngcc0.ɵɵlistener("ngModelChange", function HsLayerFeaturesComponent_Template_input_ngModelChange_4_listener($event) { return ctx.searchedFeatures = $event; });
        ɵngcc0.ɵɵpipe(5, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(6, HsLayerFeaturesComponent_table_6_Template, 11, 6, "table", 4);
        ɵngcc0.ɵɵpipe(7, "featureFilter");
        ɵngcc0.ɵɵelementStart(8, "p", 5);
        ɵngcc0.ɵɵelementStart(9, "small");
        ɵngcc0.ɵɵelementStart(10, "a", 6);
        ɵngcc0.ɵɵlistener("click", function HsLayerFeaturesComponent_Template_a_click_10_listener() { return ctx.showFeatureStats = !ctx.showFeatureStats; });
        ɵngcc0.ɵɵtext(11);
        ɵngcc0.ɵɵpipe(12, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(13, "hr");
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.HsLayerUtilsService.translateTitle(ctx.layer.title));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("placeholder", ɵngcc0.ɵɵpipeBind1(5, 5, "COMMON.filter"))("ngModel", ctx.searchedFeatures);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind2(7, 7, ctx.HsFeatureTableService.features, ctx.searchedFeatures));
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(12, 10, "FEATURE_TABLE.showFeatureStats"));
    } }, directives: [ɵngcc5.DefaultValueAccessor, ɵngcc5.NgControlStatus, ɵngcc5.NgModel, ɵngcc3.NgForOf, ɵngcc3.NgIf], pipes: [ɵngcc1.TranslatePipe, HsFeatureFilterPipe], styles: ["td[_ngcontent-%COMP%], th[_ngcontent-%COMP%] {\n        border: 1px solid #dddddd;\n        text-align: left;\n        padding: 6px;\n        font-size: 14px;\n      }\n      .tdbreak[_ngcontent-%COMP%] {\n        overflow-wrap: break-word;\n        word-break: break-word;\n      }"] });
HsLayerFeaturesComponent.ctorParameters = () => [
    { type: HsFeatureTableService },
    { type: HsUtilsService },
    { type: HsMapService },
    { type: HsLanguageService },
    { type: HsLayerUtilsService }
];
HsLayerFeaturesComponent.propDecorators = {
    layer: [{ type: Input, args: ['layer',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsLayerFeaturesComponent, [{
        type: Component,
        args: [{
                selector: 'hs-layer-features',
                template: "<h3 class=\"mt-1\" style=\"text-align: center\">{{HsLayerUtilsService.translateTitle(layer.title)}}</h3>\n<div class=\"form-group mt-1 mb-1\">\n    <div class=\"input-group\" style=\"margin-bottom: 4px\">\n        <input type=\"text\" class=\"form-control hs-filter\" [placeholder]=\"'COMMON.filter' | translate\" [(ngModel)]=\"searchedFeatures\" name=\"FeatureName\">\n    </div>\n</div>\n<table style=\"width:100%;\" *ngFor=\"let feature of HsFeatureTableService.features | featureFilter: searchedFeatures\">\n    <thead>\n        <tr style=\"text-align: center; background-color: rgba(0,0,0,0.05);\">\n            <th colspan=\"2\">{{HsFeatureTableService.translate(feature.name)}}\n                <a  style=\"float: center;\" (click)=\"HsFeatureTableService.sortFeaturesBy(feature.name)\" [title]=\"'FEATURE_TABLE.sortFeaturesByValue' | translate\">^</a>\n            </th>\n        </tr>\n    </thead>\n    <tbody>\n        <tr *ngFor=\"let attr of feature.attributes\" rowspan=\"3\">\n            <th class=\"tdbreak\" style=\"background-color: rgba(0,0,0,0.03);\">{{HsFeatureTableService.translate(attr.name)}}<a  style=\"float: right;\" \n                (click)=\"HsFeatureTableService.sortFeaturesBy(attr.name)\" [title]=\"'FEATURE_TABLE.sortFeaturesByValue' | translate\">^</a>\n            </th>\n            <td class=\"tdbreak\" style=\"min-width: 200px; max-width: 200px;\">\n                <span *ngIf=\"!attr.sanitizedValue && !attr.value?.operations\">\n                    <i>{{attr.value}}</i>\n                </span>\n                <i><span *ngIf=\"!!attr.sanitizedValue\" [innerHTML]=\"attr.sanitizedValue\"></span></i>\n                <div *ngIf=\"attr.value?.operations\">\n                    <a  *ngFor=\"let operation of attr.value.operations\" (click)=\"executeOperation(operation)\"><span>\n                        <i> {{HsFeatureTableService.translate(operation.customActionName) || HsFeatureTableService.translate(operation.action)}};</i></span></a>\n                </div>\n            </td>\n        </tr>\n        <tr [hidden]=\"!showFeatureStats\" class=\"tdbreak\" *ngFor=\"let stat of feature.stats\">\n            <th class=\"tdbreak\" style=\"background-color: rgba(0,0,0,0.03);\">{{HsFeatureTableService.translate(stat.name)}}</th>\n            <td class=\"tdbreak\" style=\"min-width: 200px; max-width: 200px;\"><span><i>{{stat.value}}</i></span></td>\n        </tr>\n    </tbody>\n</table>\n<p class=\"p-2\">\n    <small><a \n            (click)=\"showFeatureStats = !showFeatureStats\">{{'FEATURE_TABLE.showFeatureStats' | translate}}</a></small>\n</p>\n<hr />",
                styles: [`
      td,
      th {
        border: 1px solid #dddddd;
        text-align: left;
        padding: 6px;
        font-size: 14px;
      }
      .tdbreak {
        overflow-wrap: break-word;
        word-break: break-word;
      }
    `]
            }]
    }], function () { return [{ type: HsFeatureTableService }, { type: HsUtilsService }, { type: HsMapService }, { type: HsLanguageService }, { type: HsLayerUtilsService }]; }, { layer: [{
            type: Input,
            args: ['layer']
        }] }); })();

class HsFeatureTableModule {
}
HsFeatureTableModule.ɵfac = function HsFeatureTableModule_Factory(t) { return new (t || HsFeatureTableModule)(); };
HsFeatureTableModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: HsFeatureTableModule });
HsFeatureTableModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule,
            HsPanelHelpersModule,
            TranslateModule,
            NgbModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsFeatureTableModule, [{
        type: NgModule,
        args: [{
                schemas: [CUSTOM_ELEMENTS_SCHEMA],
                declarations: [
                    HsFeatureTableComponent,
                    HsLayerFeaturesComponent,
                    HsFeatureFilterPipe,
                ],
                imports: [
                    CommonModule,
                    FormsModule,
                    HsPanelHelpersModule,
                    TranslateModule,
                    NgbModule,
                ],
                exports: [
                    HsFeatureTableComponent,
                    HsLayerFeaturesComponent,
                    HsFeatureFilterPipe,
                ],
                entryComponents: [HsFeatureTableComponent, HsLayerFeaturesComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(HsFeatureTableModule, { declarations: function () { return [HsFeatureTableComponent, HsLayerFeaturesComponent, HsFeatureFilterPipe]; }, imports: function () { return [CommonModule,
        FormsModule, HsPanelHelpersModule, TranslateModule,
        NgbModule]; }, exports: function () { return [HsFeatureTableComponent, HsLayerFeaturesComponent, HsFeatureFilterPipe]; } }); })();

class HsGeolocationModule {
}
HsGeolocationModule.ɵfac = function HsGeolocationModule_Factory(t) { return new (t || HsGeolocationModule)(); };
HsGeolocationModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: HsGeolocationModule });
HsGeolocationModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[FormsModule, CommonModule, HsPanelHelpersModule, TranslateModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsGeolocationModule, [{
        type: NgModule,
        args: [{
                schemas: [CUSTOM_ELEMENTS_SCHEMA],
                declarations: [HsGeolocationComponent],
                imports: [FormsModule, CommonModule, HsPanelHelpersModule, TranslateModule],
                exports: [HsGeolocationComponent],
                entryComponents: [HsGeolocationComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(HsGeolocationModule, { declarations: function () { return [HsGeolocationComponent]; }, imports: function () { return [FormsModule, CommonModule, HsPanelHelpersModule, TranslateModule]; }, exports: function () { return [HsGeolocationComponent]; } }); })();

class HsInfoModule {
}
HsInfoModule.ɵfac = function HsInfoModule_Factory(t) { return new (t || HsInfoModule)(); };
HsInfoModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: HsInfoModule });
HsInfoModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[FormsModule, CommonModule, HsPanelHelpersModule, TranslateModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsInfoModule, [{
        type: NgModule,
        args: [{
                schemas: [CUSTOM_ELEMENTS_SCHEMA],
                declarations: [HsInfoComponent],
                imports: [FormsModule, CommonModule, HsPanelHelpersModule, TranslateModule],
                exports: [HsInfoComponent],
                entryComponents: [HsInfoComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(HsInfoModule, { declarations: function () { return [HsInfoComponent]; }, imports: function () { return [FormsModule, CommonModule, HsPanelHelpersModule, TranslateModule]; }, exports: function () { return [HsInfoComponent]; } }); })();

class HsLanguageModule {
}
HsLanguageModule.ɵfac = function HsLanguageModule_Factory(t) { return new (t || HsLanguageModule)(); };
HsLanguageModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: HsLanguageModule });
HsLanguageModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [TranslateStore], imports: [[FormsModule, CommonModule, TranslateModule, HsPanelHelpersModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsLanguageModule, [{
        type: NgModule,
        args: [{
                schemas: [CUSTOM_ELEMENTS_SCHEMA],
                declarations: [HsLanguageComponent],
                imports: [FormsModule, CommonModule, TranslateModule, HsPanelHelpersModule],
                exports: [HsLanguageComponent],
                providers: [TranslateStore],
                entryComponents: [HsLanguageComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(HsLanguageModule, { declarations: function () { return [HsLanguageComponent]; }, imports: function () { return [FormsModule, CommonModule, TranslateModule, HsPanelHelpersModule]; }, exports: function () { return [HsLanguageComponent]; } }); })();

//TODO: Is this module declaration necessary at all?
class HsGetCapabilitiesModule {
}
HsGetCapabilitiesModule.ɵfac = function HsGetCapabilitiesModule_Factory(t) { return new (t || HsGetCapabilitiesModule)(); };
HsGetCapabilitiesModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: HsGetCapabilitiesModule });
HsGetCapabilitiesModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsGetCapabilitiesModule, [{
        type: NgModule,
        args: [{
                declarations: [],
                imports: [],
                entryComponents: [],
                exports: []
            }]
    }], null, null); })();

class HsLayerEditorService {
    constructor(HsMapService, HsWmsGetCapabilitiesService, HsLayerUtilsService, HsLayerEditorVectorLayerService, HsEventBusService, HsLayoutService, HsLegendService, HsLayerSelectorService, HsLayerManagerMetadataService) {
        this.HsMapService = HsMapService;
        this.HsWmsGetCapabilitiesService = HsWmsGetCapabilitiesService;
        this.HsLayerUtilsService = HsLayerUtilsService;
        this.HsLayerEditorVectorLayerService = HsLayerEditorVectorLayerService;
        this.HsEventBusService = HsEventBusService;
        this.HsLayoutService = HsLayoutService;
        this.HsLegendService = HsLegendService;
        this.HsLayerSelectorService = HsLayerSelectorService;
        this.HsLayerManagerMetadataService = HsLayerManagerMetadataService;
        this.layerTitleChange = new Subject();
        this.HsLayerSelectorService.layerSelected.subscribe((layer) => {
            this.legendDescriptor = this.HsLegendService.getLayerLegendDescriptor(layer.layer);
        });
    }
    /**
     * Zoom to selected layer (layer extent). Get extent
     * from bounding box property, getExtent() function or from
     * BoundingBox property of GetCapabilities request (for WMS layer)
     * @param layer - OpenLayers layer to zoom to
     */
    zoomToLayer(layer) {
        return __awaiter(this, void 0, void 0, function* () {
            let extent = null;
            if (layer.getExtent()) {
                extent = layer.getExtent();
            }
            else if (layer.getSource().getExtent != undefined) {
                extent = layer.getSource().getExtent();
            }
            if (extent) {
                this.fitIfExtentSet(extent, layer);
                return true;
            }
            if (extent === null && this.HsLayerUtilsService.isLayerWMS(layer)) {
                const url = this.HsLayerUtilsService.getURL(layer);
                const wrapper = yield this.HsWmsGetCapabilitiesService.request(url);
                const parser = new WMSCapabilities();
                const caps = parser.read(wrapper.response);
                if (Array.isArray(caps.Capability.Layer.Layer)) {
                    const foundDefs = caps.Capability.Layer.Layer.map((lyr) => {
                        var _a;
                        return this.HsLayerManagerMetadataService.identifyLayerObject((_a = this.HsLayerUtilsService.getLayerParams(layer)) === null || _a === void 0 ? void 0 : _a.LAYERS, lyr);
                    }).filter((item) => item);
                    const foundDef = foundDefs.length > 0 ? foundDefs[0] : null;
                    if (foundDef) {
                        extent = foundDef.EX_GeographicBoundingBox || foundDef.BoundingBox;
                        this.fitIfExtentSet(this.transformToCurrentProj(extent), layer);
                        return true;
                    }
                }
                else if (typeof caps.Capability.Layer == 'object') {
                    extent =
                        caps.Capability.Layer.EX_GeographicBoundingBox ||
                            caps.Capability.Layer.BoundingBox;
                    this.fitIfExtentSet(this.transformToCurrentProj(extent), layer);
                    return true;
                }
                else {
                    return false;
                }
            }
        });
    }
    /**
     * Set cluster for layer
     * @param layer - Layer
     * @param newValue - To cluster or not to cluster
     * @param distance - Distance in pixels
     * @returns Current cluster state
     */
    cluster(layer, newValue, distance) {
        if (layer == undefined) {
            return;
        }
        if (newValue != undefined) {
            setCluster(layer, newValue);
            this.HsLayerEditorVectorLayerService.cluster(newValue, layer, distance, !this.HsLayerEditorVectorLayerService.layersClusteredFromStart.includes(layer));
            this.HsEventBusService.compositionEdits.next();
        }
        else {
            return getCluster(layer);
        }
    }
    /**
     * @typedef {Array<number>} Extent
     * @param {Extent} extent - Extent in EPSG:4326
     * @param layer
     */
    fitIfExtentSet(extent, layer) {
        if (extent !== null) {
            layer.setExtent(extent);
            this.HsMapService.fitExtent(extent);
        }
    }
    /**
     * @param extent
     */
    transformToCurrentProj(extent) {
        return transformExtent(extent, 'EPSG:4326', this.HsMapService.getCurrentProj());
    }
    legendVisible() {
        return (this.HsLegendService.legendValid(this.legendDescriptor) &&
            (getInlineLegend(this.legendDescriptor.lyr) ||
                !this.HsLayoutService.panelEnabled('legend')));
    }
}
HsLayerEditorService.ɵfac = function HsLayerEditorService_Factory(t) { return new (t || HsLayerEditorService)(ɵngcc0.ɵɵinject(HsMapService), ɵngcc0.ɵɵinject(HsWmsGetCapabilitiesService), ɵngcc0.ɵɵinject(HsLayerUtilsService), ɵngcc0.ɵɵinject(HsLayerEditorVectorLayerService), ɵngcc0.ɵɵinject(HsEventBusService), ɵngcc0.ɵɵinject(HsLayoutService), ɵngcc0.ɵɵinject(HsLegendService), ɵngcc0.ɵɵinject(HsLayerSelectorService), ɵngcc0.ɵɵinject(HsLayerManagerMetadataService)); };
HsLayerEditorService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HsLayerEditorService_Factory() { return new HsLayerEditorService(i0.ɵɵinject(HsMapService), i0.ɵɵinject(HsWmsGetCapabilitiesService), i0.ɵɵinject(HsLayerUtilsService), i0.ɵɵinject(HsLayerEditorVectorLayerService), i0.ɵɵinject(HsEventBusService), i0.ɵɵinject(HsLayoutService), i0.ɵɵinject(HsLegendService), i0.ɵɵinject(HsLayerSelectorService), i0.ɵɵinject(HsLayerManagerMetadataService)); }, token: HsLayerEditorService, providedIn: "root" });
HsLayerEditorService.ctorParameters = () => [
    { type: HsMapService },
    { type: HsWmsGetCapabilitiesService },
    { type: HsLayerUtilsService },
    { type: HsLayerEditorVectorLayerService },
    { type: HsEventBusService },
    { type: HsLayoutService },
    { type: HsLegendService },
    { type: HsLayerSelectorService },
    { type: HsLayerManagerMetadataService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsLayerEditorService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: HsMapService }, { type: HsWmsGetCapabilitiesService }, { type: HsLayerUtilsService }, { type: HsLayerEditorVectorLayerService }, { type: HsEventBusService }, { type: HsLayoutService }, { type: HsLegendService }, { type: HsLayerSelectorService }, { type: HsLayerManagerMetadataService }]; }, null); })();

class HsLayerManagerRemoveLayerDialogComponent {
    constructor(HsDialogContainerService, HsEventBusService, HsDrawService, HsMapService) {
        this.HsDialogContainerService = HsDialogContainerService;
        this.HsEventBusService = HsEventBusService;
        this.HsDrawService = HsDrawService;
        this.HsMapService = HsMapService;
    }
    removeLayer() {
        if (this.HsDrawService.selectedLayer == this.data.olLayer) {
            this.HsDrawService.selectedLayer = null;
        }
        this.HsMapService.map.removeLayer(this.data.olLayer);
        this.HsDrawService.fillDrawableLayers();
        this.HsEventBusService.layerManagerUpdates.next();
        this.close();
    }
    close() {
        this.HsDialogContainerService.destroy(this);
    }
}
HsLayerManagerRemoveLayerDialogComponent.ɵfac = function HsLayerManagerRemoveLayerDialogComponent_Factory(t) { return new (t || HsLayerManagerRemoveLayerDialogComponent)(ɵngcc0.ɵɵdirectiveInject(HsDialogContainerService), ɵngcc0.ɵɵdirectiveInject(HsEventBusService), ɵngcc0.ɵɵdirectiveInject(HsDrawService), ɵngcc0.ɵɵdirectiveInject(HsMapService)); };
HsLayerManagerRemoveLayerDialogComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsLayerManagerRemoveLayerDialogComponent, selectors: [["hs-layermanager-remove-layer-dialog"]], inputs: { data: "data" }, decls: 22, vars: 15, consts: [["tabindex", "-1", "role", "dialog", "aria-hidden", "true", 1, "modal", "hs-remove-layer-dialog", "in"], [1, "modal-dialog"], [1, "modal-content"], [1, "modal-header"], [1, "modal-title"], ["data-dismiss", "modal", 1, "close", 3, "click"], ["aria-hidden", "true"], [1, "sr-only"], [1, "modal-body", 2, "max-height", "600px", "overflow-y", "auto"], [1, "modal-footer"], ["data-dismiss", "modal", 1, "btn", "btn-primary", 3, "click"], ["data-dismiss", "modal", 1, "btn", "btn-secondary", 3, "click"]], template: function HsLayerManagerRemoveLayerDialogComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelementStart(4, "h4", 4);
        ɵngcc0.ɵɵtext(5);
        ɵngcc0.ɵɵpipe(6, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "button", 5);
        ɵngcc0.ɵɵlistener("click", function HsLayerManagerRemoveLayerDialogComponent_Template_button_click_7_listener() { return ctx.close(); });
        ɵngcc0.ɵɵelement(8, "span", 6);
        ɵngcc0.ɵɵelementStart(9, "span", 7);
        ɵngcc0.ɵɵtext(10);
        ɵngcc0.ɵɵpipe(11, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "div", 8);
        ɵngcc0.ɵɵtext(13);
        ɵngcc0.ɵɵpipe(14, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(15, "div", 9);
        ɵngcc0.ɵɵelementStart(16, "button", 10);
        ɵngcc0.ɵɵlistener("click", function HsLayerManagerRemoveLayerDialogComponent_Template_button_click_16_listener() { return ctx.removeLayer(); });
        ɵngcc0.ɵɵtext(17);
        ɵngcc0.ɵɵpipe(18, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(19, "button", 11);
        ɵngcc0.ɵɵlistener("click", function HsLayerManagerRemoveLayerDialogComponent_Template_button_click_19_listener() { return ctx.close(); });
        ɵngcc0.ɵɵtext(20);
        ɵngcc0.ɵɵpipe(21, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(6, 5, "PANEL_HEADER.LM"), " ");
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(11, 7, "COMMON.close"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(14, 9, "LAYERMANAGER.dialogRemoveLayer.dialogMessage"), "");
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(18, 11, "COMMON.removeLayer"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(21, 13, "COMMON.no"));
    } }, pipes: [ɵngcc1.TranslatePipe], encapsulation: 2 });
HsLayerManagerRemoveLayerDialogComponent.ctorParameters = () => [
    { type: HsDialogContainerService },
    { type: HsEventBusService },
    { type: HsDrawService },
    { type: HsMapService }
];
HsLayerManagerRemoveLayerDialogComponent.propDecorators = {
    data: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsLayerManagerRemoveLayerDialogComponent, [{
        type: Component,
        args: [{
                selector: 'hs-layermanager-remove-layer-dialog',
                template: "<div class=\"modal hs-remove-layer-dialog in\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\">\n  <div class=\"modal-dialog\">\n    <div class=\"modal-content\">\n      <div class=\"modal-header\">\n        <h4 class=\"modal-title\">\n          {{'PANEL_HEADER.LM' | translate}}\n        </h4>\n        <button (click)=\"close()\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\"></span><span\n            class=\"sr-only\">{{'COMMON.close' | translate}}</span></button>\n      </div>\n      <div class=\"modal-body\" style=\"max-height:600px; overflow-y:auto\">\n        {{'LAYERMANAGER.dialogRemoveLayer.dialogMessage' | translate}}</div>\n      <div class=\"modal-footer\">\n        <button class=\"btn btn-primary\" (click)=\"removeLayer();\"\n          data-dismiss=\"modal\">{{'COMMON.removeLayer' | translate}}</button>\n        <button class=\"btn btn-secondary\" (click)=\"close()\" data-dismiss=\"modal\">{{'COMMON.no' | translate}}</button>\n      </div>\n    </div>\n  </div>\n</div>"
            }]
    }], function () { return [{ type: HsDialogContainerService }, { type: HsEventBusService }, { type: HsDrawService }, { type: HsMapService }]; }, { data: [{
            type: Input
        }] }); })();

class HsLayerEditorComponent {
    constructor(HsLayerUtilsService, HsDimensionTimeService, HsStylerService, HsMapService, HsLayerManagerService, HsLayoutService, HsLayerEditorSublayerService, HsLayerEditorService, HsDrawService, HsEventBusService, HsLayerManagerMetadataService, // Used in template
    HsDialogContainerService, HsLanguageService) {
        this.HsLayerUtilsService = HsLayerUtilsService;
        this.HsDimensionTimeService = HsDimensionTimeService;
        this.HsStylerService = HsStylerService;
        this.HsMapService = HsMapService;
        this.HsLayerManagerService = HsLayerManagerService;
        this.HsLayoutService = HsLayoutService;
        this.HsLayerEditorSublayerService = HsLayerEditorSublayerService;
        this.HsLayerEditorService = HsLayerEditorService;
        this.HsDrawService = HsDrawService;
        this.HsEventBusService = HsEventBusService;
        this.HsLayerManagerMetadataService = HsLayerManagerMetadataService;
        this.HsDialogContainerService = HsDialogContainerService;
        this.HsLanguageService = HsLanguageService;
        this.distance = {
            value: 40,
        };
        this.layer_renamer_visible = false;
        this.getAttribution = getAttribution;
        this.getBase = getBase;
        this.tmpTitle = undefined;
    }
    set currentLayer(value) {
        this._currentLayer = value;
        this.tmpTitle = undefined;
        this.layer_renamer_visible = false;
    }
    get currentLayer() {
        return this._currentLayer;
    }
    /**
     * Confirm saving a vector layer content as a geoJSON
     * @returns an empty promise
     */
    createSaveDialog() {
        return __awaiter(this, void 0, void 0, function* () {
            const dialog = this.HsDialogContainerService.create(HsConfirmDialogComponent, {
                message: this.HsLanguageService.getTranslation('LAYERMANAGER.layerEditor.savegeojson') + '?',
                title: this.HsLanguageService.getTranslation('COMMON.confirm'),
            });
            const confirmed = yield dialog.waitResult();
            if (confirmed == 'yes') {
                return this.HsLayerManagerService.saveGeoJson();
            }
        });
    }
    layerIsWmsT() {
        return this.HsDimensionTimeService.layerIsWmsT(this.currentLayer);
    }
    /**
     * Zoom to selected layer (layer extent). Get extent
     * from bounding box property, getExtent() function or from
     * BoundingBox property of GetCapabilities request (for WMS layer)
     * @returns a promise
     */
    zoomToLayer() {
        return this.HsLayerEditorService.zoomToLayer(this.olLayer());
    }
    /**
     * Display styler panel for selected layer, so user can change its style
     */
    styleLayer() {
        const layer = this.olLayer();
        this.HsStylerService.layer = layer;
        this.HsLayoutService.setMainPanel('styler');
    }
    /**
     * Test if layer is WMS layer
     * @param layer - Selected layer
     */
    isLayerVectorLayer(layer) {
        return this.HsLayerUtilsService.isLayerVectorLayer(layer);
    }
    /**
     * Test if layer is WMS layer
     */
    isVectorLayer() {
        if (!this.currentLayer) {
            return;
        }
        const layer = this.olLayer();
        if (!this.isLayerVectorLayer(layer)) {
            return;
        }
        else {
            return true;
        }
    }
    /**
     * Set cluster for layer
     * @param newValue - To cluster or not to cluster
     */
    set cluster(newValue) {
        if (!this.currentLayer) {
            return;
        }
        this.HsLayerEditorService.cluster(this.olLayer(), newValue, this.distance.value);
    }
    /**
     * @returns Current cluster state
     */
    get cluster() {
        if (!this.currentLayer) {
            return;
        }
        return this.HsLayerEditorService.cluster(this.olLayer(), undefined, this.distance.value);
    }
    /**
     * Set distance between cluster features;
     */
    changeDistance() {
        if (!this.currentLayer) {
            return;
        }
        const layer = this.olLayer();
        const src = layer.getSource();
        if (src.setDistance == undefined) {
            return;
        }
        src.setDistance(this.distance.value);
    }
    /**
     * Toogle layer rename control on panel (through layer rename variable)
     */
    toggleLayerRename() {
        this.tmpTitle = undefined;
        this.layer_renamer_visible = !this.layer_renamer_visible;
    }
    /**
     * Set selected layer's opacity and emits "compositionchanged"
     * @param newValue
     */
    set opacity(newValue) {
        if (!this.currentLayer) {
            return;
        }
        this.olLayer().setOpacity(newValue);
        this.HsEventBusService.compositionEdits.next();
    }
    get opacity() {
        return this.olLayer().getOpacity();
    }
    /**
     * Determines if selected layer has BoundingBox defined as
     * its metadata or is a Vector layer. Used for setting visibility
     * of 'Zoom to ' button
     */
    layerIsZoomable() {
        return this.HsLayerUtilsService.layerIsZoomable(this.olLayer());
    }
    /**
     * Determines if selected layer is a Vector layer and
     * styleable. Used for allowing styling
     */
    layerIsStyleable() {
        return this.HsLayerUtilsService.layerIsStyleable(this.olLayer());
    }
    /**
     * Determines if layer has copyright information available
     * @param layer - Selected layer (HsLayerManagerService.currentLayer)
     */
    hasCopyright(layer) {
        var _a;
        if (!this.currentLayer) {
            return;
        }
        else {
            return ((_a = getAttribution(layer.layer)) === null || _a === void 0 ? void 0 : _a.onlineResource) != undefined;
        }
    }
    /**
     * Set min resolution for selected layer
     * @param newValue
     */
    set minResolution(newValue) {
        if (!this.currentLayer) {
            return;
        }
        const layer = this.olLayer();
        layer.setMinResolution(newValue);
    }
    get minResolution() {
        if (!this.currentLayer) {
            return;
        }
        const layer = this.olLayer();
        return layer.getMinResolution();
    }
    /**
     * Set max resolution for selected layer
     * @param newValue
     */
    set maxResolution(newValue) {
        if (!this.currentLayer) {
            return;
        }
        const layer = this.olLayer();
        layer.setMaxResolution(newValue);
    }
    get maxResolution() {
        if (!this.currentLayer) {
            return;
        }
        const layer = this.olLayer();
        return layer.getMaxResolution();
    }
    /**
     * Check if layer can be removed based on 'removable'
     * layer attribute
     */
    isLayerRemovable() {
        const layer = this.olLayer();
        return (!layer || getRemovable(layer) == undefined || getRemovable(layer) == true);
    }
    removeLayer() {
        this.HsDialogContainerService.create(HsLayerManagerRemoveLayerDialogComponent, { olLayer: this.olLayer() });
    }
    /**
     * Test if selected layer has min and max resolution set
     */
    isScaleVisible() {
        const layer = this.olLayer();
        if (layer == undefined) {
            return false;
        }
        return this.minResolutionValid() || this.maxResolutionValid();
    }
    olLayer() {
        if (!this.currentLayer) {
            return undefined;
        }
        return this.currentLayer.layer;
    }
    minResolutionValid() {
        const layer = this.olLayer();
        if (layer == undefined) {
            return false;
        }
        return (layer.getMinResolution() != undefined && layer.getMinResolution() != 0);
    }
    maxResolutionValid() {
        const layer = this.olLayer();
        if (layer == undefined) {
            return false;
        }
        return (layer.getMaxResolution() != undefined &&
            layer.getMaxResolution() != Infinity);
    }
    /**
     * Change title of layer (Angular automatically change title in object wrapper but it is needed to manually change in Ol.layer object)
     * @param newTitle - New title to set
     */
    set title(newTitle) {
        this.tmpTitle = newTitle.trim();
    }
    get title() {
        const layer = this.olLayer();
        if (layer == undefined) {
            return;
        }
        if (this.tmpTitle == undefined) {
            this.tmpTitle = getTitle(layer);
        }
        return this.tmpTitle;
    }
    saveTitle() {
        const layer = this.olLayer();
        if (layer == undefined) {
            return;
        }
        this.HsLayerEditorService.layerTitleChange.next({
            newTitle: this.tmpTitle,
            oldTitle: getTitle(layer),
            layer,
        });
        setTitle(layer, this.tmpTitle);
        this.HsEventBusService.layerManagerUpdates.next();
        this.toggleLayerRename();
    }
    titleUnsaved() {
        return this.tmpTitle != getTitle(this.olLayer());
    }
    set abstract(newAbstract) {
        const layer = this.olLayer();
        if (layer == undefined) {
            return;
        }
        setAbstract(layer, newAbstract);
    }
    get abstract() {
        const layer = this.olLayer();
        if (layer == undefined) {
            return;
        }
        return getAbstract(layer);
    }
    hasSubLayers() {
        var _a;
        if (this.currentLayer === null) {
            return;
        }
        const subLayers = (_a = getCachedCapabilities(this.currentLayer.layer)) === null || _a === void 0 ? void 0 : _a.Layer;
        return subLayers != undefined && subLayers.length > 0;
    }
    getSubLayers() {
        return this.HsLayerEditorSublayerService.getSubLayers();
    }
}
HsLayerEditorComponent.ɵfac = function HsLayerEditorComponent_Factory(t) { return new (t || HsLayerEditorComponent)(ɵngcc0.ɵɵdirectiveInject(HsLayerUtilsService), ɵngcc0.ɵɵdirectiveInject(HsDimensionTimeService), ɵngcc0.ɵɵdirectiveInject(HsStylerService), ɵngcc0.ɵɵdirectiveInject(HsMapService), ɵngcc0.ɵɵdirectiveInject(HsLayerManagerService), ɵngcc0.ɵɵdirectiveInject(HsLayoutService), ɵngcc0.ɵɵdirectiveInject(HsLayerEditorSublayerService), ɵngcc0.ɵɵdirectiveInject(HsLayerEditorService), ɵngcc0.ɵɵdirectiveInject(HsDrawService), ɵngcc0.ɵɵdirectiveInject(HsEventBusService), ɵngcc0.ɵɵdirectiveInject(HsLayerManagerMetadataService), ɵngcc0.ɵɵdirectiveInject(HsDialogContainerService), ɵngcc0.ɵɵdirectiveInject(HsLanguageService)); };
HsLayerEditorComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsLayerEditorComponent, selectors: [["hs-layer-editor"]], inputs: { currentLayer: ["current-layer", "currentLayer"] }, decls: 3, vars: 2, consts: [[1, "card", "panel-default"], ["class", "card-body", 4, "ngIf"], ["class", "card-footer", 4, "ngIf"], [1, "card-body"], [1, "form-group", 3, "hidden"], [4, "ngFor", "ngForOf"], [4, "ngIf"], [3, "subLayer"], [1, "form-group"], [1, "text-secondary"], ["class", "form-group", 4, "ngIf"], [3, "innerHtml"], [1, "d-flex", "flex-row", 2, "border-bottom", "1px solid rgba(0, 0, 0, 0.125)"], ["class", "form-check flex-fill ", 4, "ngIf"], ["class", "form-group flex-fill", 4, "ngIf"], [3, "layer"], ["type", "range", "name", "layer-opacity", "step", "0.01", "min", "0", "max", "1", 1, "form-control", 2, "width", "100%", "height", "21px", 3, "ngModel", "ngModelChange"], ["class", "btn-group m-auto d-flex w-75", 4, "ngIf"], [1, "pt-2"], ["class", "card-href", "target", "_blank", 3, "href", "title", 4, "ngFor", "ngForOf"], ["target", "_blank", 1, "card-href", 3, "href", "title"], [3, "hidden"], [1, "ml-1"], [1, "form-check", "flex-fill"], ["name", "layer-cluster", "type", "checkbox", 1, "form-check-input", 3, "ngModel", "ngModelChange"], [1, "form-check-label"], [1, "form-group", "flex-fill"], ["name", "layer-cluster-distance", "type", "range", "min", "0", "max", "100", "step", "1", 1, "form-control", 2, "width", "100%", "height", "21px", 3, "ngModel", "ngModelChange", "change"], [2, "text-align", "center", "font-weight", "bold"], [1, "btn-group", "m-auto", "d-flex", "w-75"], ["data-toggle", "tooltip", 1, "btn", "btn-sm", "btn-outline-primary", "w-50", 3, "ngClass", "title", "click"], [1, "card-footer"], [1, "input-group"], ["type", "text", "name", "title", 1, "form-control", 3, "ngModel", "ngModelChange"], [1, "input-group-append", 3, "hidden", "click"], ["type", "button", 1, "btn", "btn-outline-secondary"], [1, "icon-save-floppy"], [1, "form"], ["role", "group", 1, "btn-group"], ["data-toggle", "tooltip", 1, "btn", "btn-primary", 3, "disabled", "title", "click"], [1, "icon-search"], [1, "icon-brush"], ["data-toggle", "tooltip", 1, "btn", "btn-primary", 3, "title", "click"], [1, "icon-textfield"], ["class", "btn btn-primary", "data-toggle", "tooltip", 3, "title", "click", 4, "ngIf"], ["class", "btn btn-danger", "data-toggle", "tooltip", 3, "title", "click", 4, "ngIf"], [1, "input-group-prepend"], [1, "input-group-text"], ["name", "minResolution", 1, "form-control", 2, "width", "65px", 3, "ngModel", "ngModelChange"], ["name", "maxResolution", 1, "form-control", 2, "width", "65px", 3, "ngModel", "ngModelChange"], ["data-toggle", "tooltip", 1, "btn", "btn-danger", 3, "title", "click"], [1, "icon-trash"]], template: function HsLayerEditorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, HsLayerEditorComponent_div_1_Template, 4, 3, "div", 1);
        ɵngcc0.ɵɵtemplate(2, HsLayerEditorComponent_div_2_Template, 30, 27, "div", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.currentLayer);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.currentLayer == null ? null : ctx.currentLayer.settings);
    } }, directives: function () { return [ɵngcc3.NgIf, ɵngcc3.NgForOf, HsLayerEditorSubLayerCheckboxesComponent, ɵngcc5.ɵNgNoValidate, ɵngcc5.NgControlStatusGroup, ɵngcc5.NgForm, HsLayerEditorDimensionsComponent, ɵngcc5.RangeValueAccessor, ɵngcc5.DefaultValueAccessor, ɵngcc5.NgControlStatus, ɵngcc5.NgModel, ɵngcc5.CheckboxControlValueAccessor, HsLegendLayerComponent, ɵngcc3.NgClass]; }, pipes: function () { return [ɵngcc1.TranslatePipe]; }, encapsulation: 2 });
HsLayerEditorComponent.ctorParameters = () => [
    { type: HsLayerUtilsService },
    { type: HsDimensionTimeService },
    { type: HsStylerService },
    { type: HsMapService },
    { type: HsLayerManagerService },
    { type: HsLayoutService },
    { type: HsLayerEditorSublayerService },
    { type: HsLayerEditorService },
    { type: HsDrawService },
    { type: HsEventBusService },
    { type: HsLayerManagerMetadataService },
    { type: HsDialogContainerService },
    { type: HsLanguageService }
];
HsLayerEditorComponent.propDecorators = {
    currentLayer: [{ type: Input, args: ['current-layer',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsLayerEditorComponent, [{
        type: Component,
        args: [{
                selector: 'hs-layer-editor',
                template: "<div class=\"card panel-default\">\n    <div class=\"card-body\" *ngIf=\"currentLayer\">\n        <!-- Sublayers-->\n        <div [hidden]=\"!currentLayer.sublayers\" class=\"form-group\">\n            <div *ngFor=\"let subLayer of getSubLayers()\">\n                <hs-layer-editor-sub-layer-checkbox [subLayer]=\"subLayer\"></hs-layer-editor-sub-layer-checkbox>\n            </div>\n        </div>\n        <div *ngIf=\"currentLayer.settings\">\n            <form>\n                <!-- Layer type info -->\n                <div class=\"form-group\">\n                    <small class=\"text-secondary \">\n                        {{HsLanguageService.getTranslationIgnoreNonExisting('LAYERMANAGER.layerEditor', currentLayer.type)}} {{'LAYERMANAGER.layerEditor.layerFrom' | translate}} {{HsLanguageService.getTranslationIgnoreNonExisting('LAYERMANAGER.layerEditor', currentLayer.source)}}\n                    </small>\n                </div>\n                <!-- Metadata/Copyright -->\n                <div class=\"form-group\" *ngIf=\"HsLayerManagerMetadataService.hasMetadata(currentLayer)\">\n                    <!-- Metadata -->\n                    <div class=\"pt-2\">\n                        <a class=\"card-href\"\n                            *ngFor=\"let metadataUrl of HsLayerManagerMetadataService.metadataArray(currentLayer)\"\n                            href=\"{{metadataUrl.onlineResource}}\" target=\"_blank\"\n                            [title]=\"'COMMON.metadata' | translate\">\n                            <span [hidden]=\"!metadataUrl.type\">\n                                {{'LAYERMANAGER.layerEditor.metadataOfLayer' | translate}} {{metadataUrl.type}}\n                            </span>\n                            <span [hidden]=\"metadataUrl.type\">\n                                {{'LAYERMANAGER.layerEditor.metadataOfService' | translate}}\n                            </span>\n                        </a>\n                    </div>\n                    <!-- Copyright -->\n                    <div *ngIf=\"hasCopyright(currentLayer)\">\n                        <a class=\"card-href\" href=\"{{getAttribution(currentLayer.layer).onlineResource}}\"\n                            target=\"_blank\" [title]=\"'LAYERMANAGER.layerEditor.copyright' | translate\">\n                            {{'LAYERMANAGER.layerEditor.copyright' | translate}}</a>\n                    </div>\n                </div>\n\n                <!-- Abstract -->\n                <div class=\"form-group\" [hidden]=\"!abstract\">\n                    <label>{{'COMMON.abstract' | translate}}</label>\n                    <p [innerHtml]=\"HsLayerManagerService.makeSafeAndTranslate('LAYERS', abstract)\">\n                    </p>\n                </div>\n\n                <!-- Scale -->\n                <div class=\"form-group\" [hidden]=\"!isScaleVisible()\">\n                    <label>{{'COMMON.scale' | translate}}</label>\n                    <span *ngIf=\"minResolutionValid()\"><span class=\"ml-1\">{{'COMMON.from' | translate}}</span>\n                        1:{{minResolution}}</span>\n                    <span *ngIf=\"maxResolutionValid()\"><span class=\"ml-1\">{{'COMMON.to' | translate}}</span>\n                        1:{{maxResolution}}</span>\n                </div>\n                <div class=\"d-flex flex-row\" style=\"border-bottom: 1px solid rgba(0, 0, 0, 0.125)\">\n                    <!-- Cluster features checkbox  -->\n                    <div *ngIf=\"isVectorLayer()\" class=\"form-check flex-fill \">\n                        <input name=\"layer-cluster\" class=\"form-check-input\" type=\"checkbox\" [(ngModel)]=\"cluster\">\n                        <label class=\"form-check-label\">{{'LAYERMANAGER.layerEditor.cluster' | translate}}</label>\n                    </div>\n                    <div class=\"form-group flex-fill\" *ngIf=\"cluster\">\n                        <label>{{'COMMON.distance' | translate}}</label>\n                        <input name=\"layer-cluster-distance\" type=\"range\" min=\"0\" max=\"100\" step=\"1\"\n                            [(ngModel)]=\"distance.value\" (change)=\"changeDistance()\" class=\"form-control\"\n                            style=\"width: 100%;height: 21px;\">\n                    </div>\n                </div>\n\n                <!-- Legends -->\n                <div *ngIf=\"olLayer()\">\n                    <div *ngIf=\"HsLayerEditorService.legendVisible()\">\n                        <p style=\"text-align: center;font-weight: bold;\">\n                            {{'COMMON.legend' | translate}}</p>\n                        <hs-legend-layer-directive [layer]=\"HsLayerEditorService.legendDescriptor\">\n                        </hs-legend-layer-directive>\n                        <hr />\n                    </div>\n                </div>\n                <!-- Dimensions -->\n                <hs-layer-editor-dimensions [layer]=\"olLayer()\"></hs-layer-editor-dimensions>\n\n                <!-- Opacity slider -->\n                <div class=\"form-group\">\n                    <label>{{'LAYERMANAGER.layerEditor.opacity' | translate}}</label>\n                    <input type=\"range\" name=\"layer-opacity\" step=\"0.01\" min=\"0\" max=\"1\" class=\"form-control\"\n                        style=\"width: 100%;height: 21px;\" [(ngModel)]=\"opacity\">\n                </div>\n\n                <!-- Footer -->\n            </form>\n            <div class=\"btn-group m-auto d-flex w-75\" *ngIf=\"currentLayer.visible && getBase(currentLayer.layer)\">\n                <button class=\"btn btn-sm btn-outline-primary  w-50\" (click)=\"HsLayerManagerService.setGreyscale(currentLayer)\" [ngClass]=\"{'active' : !currentLayer.grayscale}\"\n                data-toggle=\"tooltip\" [title]=\"'LAYERMANAGER.layerEditor.zoomToLayer' | translate\">{{'COMMON.color' | translate}}</button>\n                <button class=\"btn btn-sm btn-outline-primary  w-50\" (click)=\"HsLayerManagerService.setGreyscale(currentLayer)\" [ngClass]=\"{'active' : currentLayer.grayscale}\"\n                data-toggle=\"tooltip\" [title]=\"'LAYERMANAGER.layerEditor.styleLayer' | translate\">{{'LAYERMANAGER.baseMapGallery.grayscale' | translate}}</button>\n            </div>\n        </div>\n    </div>\n    <div class=\"card-footer\" *ngIf=\"currentLayer?.settings\">\n        <div class=\"form-group\" [hidden]=\"!layer_renamer_visible\">\n            <label>{{'COMMON.title' | translate}}</label>\n            <div class=\"input-group\">\n                <input type=\"text\" class=\"form-control\" [(ngModel)]=\"title\" name=\"title\">\n                <div class=\"input-group-append\" [hidden]=\"!titleUnsaved()\" (click)=\"saveTitle()\">\n                    <button class=\"btn btn-outline-secondary\" type=\"button\"><i class=\"icon-save-floppy\"></i></button>\n                </div>\n            </div>\n\n            \n            <div class=\"form\">\n                <br>\n                <label>{{'COMMON.scale' | translate}}</label>\n                <div *ngIf=\"minResolutionValid()\">\n                    <div class=\"input-group\">\n                        <div class=\"input-group-prepend\">\n                            <span class=\"input-group-text\"><span>{{'COMMON.from' | translate}}</span>&nbsp;1</span>\n                        </div>\n                        <input class=\"form-control\" style=\"width:65px\" [(ngModel)]=\"minResolution\" name=\"minResolution\">\n                    </div>\n                </div>\n                <div *ngIf=\"maxResolutionValid()\">\n                    <div class=\"input-group\">\n                        <div class=\"input-group-prepend\">\n                            <span class=\"input-group-text\"> <span>{{'COMMON.to' | translate}}</span>&nbsp;1</span>\n                        </div>\n                        <input class=\"form-control\" style=\"width:65px\" [(ngModel)]=\"maxResolution\" name=\"maxResolution\">\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"btn-group\" role=\"group\" [attr.aria-label]=\"'LAYERMANAGER.editorButtons' | translate\">\n            <button class=\"btn btn-primary\" (click)=\"zoomToLayer()\" [disabled]=\"!layerIsZoomable()\"\n                data-toggle=\"tooltip\" [title]=\"'LAYERMANAGER.layerEditor.zoomToLayer' | translate\"><i\n                    class=\"icon-search\"></i></button>\n            <button class=\"btn btn-primary\" (click)=\"styleLayer()\" [disabled]=\"!layerIsStyleable()\"\n                data-toggle=\"tooltip\" [title]=\"'LAYERMANAGER.layerEditor.styleLayer' | translate\"><i\n                    class=\"icon-brush\"></i></button>\n            <button class=\"btn btn-primary\" (click)=\"toggleLayerRename()\" data-toggle=\"tooltip\"\n                [title]=\"'COMMON.renameLayer' | translate\"><i class=\"icon-textfield\"></i></button>\n            <button class=\"btn btn-primary\" (click)=\"createSaveDialog()\" data-toggle=\"tooltip\" *ngIf=\"isLayerVectorLayer(currentLayer.layer)\"\n            [title]=\"'LAYERMANAGER.layerEditor.savegeojson' | translate\"><i class=\"icon-save-floppy\"></i></button>\n            <button class=\"btn btn-danger\" (click)=\"removeLayer()\" *ngIf=\"isLayerRemovable()\" data-toggle=\"tooltip\"\n                [title]=\"'COMMON.removeLayer' | translate\"><i class=\"icon-trash\"></i></button>\n        </div>\n    </div>\n\n</div>\n"
            }]
    }], function () { return [{ type: HsLayerUtilsService }, { type: HsDimensionTimeService }, { type: HsStylerService }, { type: HsMapService }, { type: HsLayerManagerService }, { type: HsLayoutService }, { type: HsLayerEditorSublayerService }, { type: HsLayerEditorService }, { type: HsDrawService }, { type: HsEventBusService }, { type: HsLayerManagerMetadataService }, { type: HsDialogContainerService }, { type: HsLanguageService }]; }, { currentLayer: [{
            type: Input,
            args: ['current-layer']
        }] }); })();

class HsLayerEditorDimensionsComponent {
    constructor(hsDimensionService, hsDimensionTimeService, hsMapService, hsEventBusService, hsUtilsService) {
        this.hsDimensionService = hsDimensionService;
        this.hsDimensionTimeService = hsDimensionTimeService;
        this.hsMapService = hsMapService;
        this.hsEventBusService = hsEventBusService;
        this.hsUtilsService = hsUtilsService;
        this.dimensions = [];
        this.ngUnsubscribe = new Subject();
        this.hsEventBusService.layerDimensionDefinitionChanges
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(({ layer }) => {
            if (layer == this.layer) {
                this.ngOnChanges();
            }
        });
    }
    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
    ngOnChanges() {
        const layer = this.layer;
        this.dimensions = [];
        const dimensions = getDimensions(layer);
        if (dimensions && Object.entries(dimensions)) {
            for (const [key, dimension] of Object.entries(dimensions)) {
                let available = true;
                if (this.hsUtilsService.isFunction(dimension.availability)) {
                    available = dimension.availability(layer);
                }
                if (available) {
                    if (typeof dimension.values === 'string') {
                        dimension.values = this.hsDimensionTimeService.parseTimePoints(dimension.values);
                    }
                    this.dimensions.push(new HsDimensionDescriptor(key, dimension));
                }
            }
        }
    }
    dimensionIsTime(dimension) {
        var _a;
        const dimensions = getDimensions(this.layer);
        const type = Object.keys(dimensions).find((key) => dimensions[key] === dimension);
        // value of time.onlyInEditor used inversely here intentionally
        // ( => replacement for inline time-editor)
        return type === 'time' && ((_a = dimensions.time) === null || _a === void 0 ? void 0 : _a.onlyInEditor);
    }
}
HsLayerEditorDimensionsComponent.ɵfac = function HsLayerEditorDimensionsComponent_Factory(t) { return new (t || HsLayerEditorDimensionsComponent)(ɵngcc0.ɵɵdirectiveInject(HsDimensionService), ɵngcc0.ɵɵdirectiveInject(HsDimensionTimeService), ɵngcc0.ɵɵdirectiveInject(HsMapService), ɵngcc0.ɵɵdirectiveInject(HsEventBusService), ɵngcc0.ɵɵdirectiveInject(HsUtilsService)); };
HsLayerEditorDimensionsComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsLayerEditorDimensionsComponent, selectors: [["hs-layer-editor-dimensions"]], inputs: { layer: "layer" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [[4, "ngIf"], [2, "text-align", "center", "font-weight", "bold"], ["class", "form-inline", 4, "ngFor", "ngForOf"], [1, "form-inline"], [1, "control-label", 2, "width", "100%", "justify-content", "left"], ["class", "form-control", "style", "width: 100%", 3, "ngModel", "ngModelOptions", "ngModelChange", "change", 4, "ngIf"], [1, "form-group", 3, "hidden"], ["class", "input-group flex-fill", 4, "ngIf"], ["size", "small", 3, "ngModel", "ngModelOptions", "ngModelChange", 4, "ngIf"], [1, "form-control", 2, "width", "100%", 3, "ngModel", "ngModelOptions", "ngModelChange", "change"], [3, "ngValue", 4, "ngFor", "ngForOf"], [3, "ngValue"], [1, "input-group", "flex-fill"], ["type", "text", "ngbDatepicker", "", "placeholder", "YYYY-MM-DD", 2, "width", "6.1em", 3, "ngModel", "ngModelOptions", "ngModelChange", "dateSelect"], ["d", "ngbDatepicker"], [1, "input-group-append"], ["type", "button", 1, "btn", "btn-outline-secondary", 3, "click"], [1, "icon-calendarthree"], ["size", "small", 3, "ngModel", "ngModelOptions", "ngModelChange"]], template: function HsLayerEditorDimensionsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, HsLayerEditorDimensionsComponent_div_0_Template, 5, 4, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.hsDimensionService.isLayerWithDimensions(ctx.layer));
    } }, directives: [ɵngcc3.NgIf, ɵngcc3.NgForOf, ɵngcc5.SelectControlValueAccessor, ɵngcc5.NgControlStatus, ɵngcc5.NgModel, ɵngcc5.NgSelectOption, ɵngcc5.ɵNgSelectMultipleOption, ɵngcc6.NgbInputDatepicker, ɵngcc5.DefaultValueAccessor, ɵngcc6.NgbTimepicker], pipes: [ɵngcc1.TranslatePipe], encapsulation: 2 });
HsLayerEditorDimensionsComponent.ctorParameters = () => [
    { type: HsDimensionService },
    { type: HsDimensionTimeService },
    { type: HsMapService },
    { type: HsEventBusService },
    { type: HsUtilsService }
];
HsLayerEditorDimensionsComponent.propDecorators = {
    layer: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsLayerEditorDimensionsComponent, [{
        type: Component,
        args: [{
                selector: 'hs-layer-editor-dimensions',
                template: "<div *ngIf=\"hsDimensionService.isLayerWithDimensions(layer)\">\n    <p style=\"text-align: center; font-weight: bold;\">{{'LAYERMANAGER.dimensions' | translate}}</p>\n    <div class=\"form-inline\" *ngFor=\"let dimension of dimensions\">\n        <label class=\"control-label\" style=\"width: 100%; justify-content: left;\">{{dimension.label || dimension.name}}:</label>\n\n        <select class=\"form-control\" style=\"width: 100%\" [(ngModel)]=\"dimension.modelValue\" [ngModelOptions]=\"{standalone: true}\" *ngIf=\"dimension.type == null\" (change)=\"hsDimensionService.dimensionChanged(dimension)\">\n            <option [ngValue]=\"dimension_value\" *ngFor=\"let dimension_value of dimension.values\">\n                {{dimension_value}}</option>\n        </select>\n        <!-- Time slider replaced by layermanger-time-editor component -->\n        <div class=\"form-group\" [hidden]=\"!dimensionIsTime(dimension)\">\n            <label>{{'COMMON.date' | translate}}</label>\n        </div>\n        <div class=\"input-group flex-fill\" *ngIf=\"dimension.type == 'datetime' || dimension.type == 'date'\">\n            <input type=\"text\" style=\"width: 6.1em\" ngbDatepicker placeholder=\"YYYY-MM-DD\" #d=\"ngbDatepicker\" [(ngModel)]=\"dimension.modelValue\" (dateSelect)=\"hsDimensionService.dimensionChanged(dimension)\" [ngModelOptions]=\"{standalone: true}\"/>\n            <div class=\"input-group-append\">\n                <button class=\"btn btn-outline-secondary\" (click)=\"d.toggle()\" type=\"button\"><i class=\"icon-calendarthree\"></i></button>\n            </div>\n        </div>\n        <ngb-timepicker *ngIf=\"dimension.type == 'datetime'\" size=\"small\" [(ngModel)]=\"dimension.modelTimeValue\" (ngModelChange)=\"hsDimensionService.dimensionChanged(dimension)\" [ngModelOptions]=\"{standalone: true}\"></ngb-timepicker>\n    </div>\n</div>\n"
            }]
    }], function () { return [{ type: HsDimensionService }, { type: HsDimensionTimeService }, { type: HsMapService }, { type: HsEventBusService }, { type: HsUtilsService }]; }, { layer: [{
            type: Input
        }] }); })();

class HsLayerEditorSubLayerCheckboxesComponent {
    constructor(HsLayerEditorSublayerService, HsLayerManagerService) {
        this.HsLayerEditorSublayerService = HsLayerEditorSublayerService;
        this.HsLayerManagerService = HsLayerManagerService;
        this.expanded = false;
        this.checkedSubLayers = this.HsLayerEditorSublayerService.checkedSubLayers;
        this.withChildren = this.HsLayerEditorSublayerService.withChildren;
    }
    getSubLayers() {
        return this.HsLayerEditorSublayerService.getSubLayers();
    }
    subLayerIsString(subLayer) {
        return typeof subLayer == 'string';
    }
    toggleExpanded() {
        this.expanded = !this.expanded;
    }
    /**
     * @description Controls state of layer´s sublayers manipulated by input checkboxes
     * @param {object} sublayer Selected sublayer
     * @param {object} state New state of sublayer
     */
    subLayerSelected(sublayer, state) {
        //TODO: Check if this works where subLayerSelected() is called from template. The second 'if' might fail
        if (sublayer != undefined && sublayer.Layer) {
            for (const children of sublayer.Layer) {
                Object.assign(this.checkedSubLayers, {
                    [children.Name]: state,
                });
                this.HsLayerEditorSublayerService.checkedSubLayersTmp[children.Name] =
                    state;
            }
        }
        if (this.checkedSubLayers[sublayer.Name] != undefined) {
            this.HsLayerEditorSublayerService.checkedSubLayersTmp[sublayer.Name] =
                state;
        }
        else {
            this.HsLayerEditorSublayerService.withChildrenTmp[sublayer.Name] = state;
        }
        return this.HsLayerEditorSublayerService.subLayerSelected();
    }
}
HsLayerEditorSubLayerCheckboxesComponent.ɵfac = function HsLayerEditorSubLayerCheckboxesComponent_Factory(t) { return new (t || HsLayerEditorSubLayerCheckboxesComponent)(ɵngcc0.ɵɵdirectiveInject(HsLayerEditorSublayerService), ɵngcc0.ɵɵdirectiveInject(HsLayerManagerService)); };
HsLayerEditorSubLayerCheckboxesComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsLayerEditorSubLayerCheckboxesComponent, selectors: [["hs-layer-editor-sub-layer-checkbox"]], inputs: { subLayer: "subLayer" }, decls: 3, vars: 2, consts: [[1, "d-flex", "m-auto", "sublayerContainer"], ["class", "p-0 form-check form-check-inline", 4, "ngIf"], ["class", "w-100", 4, "ngIf"], [1, "p-0", "form-check", "form-check-inline"], ["type", "checkbox", 1, "form-check-input", 3, "ngModel", "ngModelChange", "change"], [1, "form-check-label"], [1, "w-100"], [1, "d-flex"], ["class", "form-check-input", "type", "checkbox", 3, "ngModel", "ngModelOptions", "ngModelChange", "change", 4, "ngIf"], ["class", "p-0 d-inline-flex flex-grow", 4, "ngIf"], [4, "ngIf"], ["class", "collapse ml-4", 3, "hidden", 4, "ngIf"], ["type", "checkbox", 1, "form-check-input", 3, "ngModel", "ngModelOptions", "ngModelChange", "change"], [1, "p-0", "d-inline-flex", "flex-grow"], [1, "form-check-label", "m-0", 3, "ngClass"], [3, "ngStyle", "ngClass", "click"], ["type", "button", 1, "btn", "btn-sm", "p-0", 3, "ngStyle"], [3, "ngClass"], [1, "collapse", "ml-4", 3, "hidden"], [4, "ngFor", "ngForOf"], [3, "subLayer", 4, "ngIf"], [3, "subLayer"]], template: function HsLayerEditorSubLayerCheckboxesComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, HsLayerEditorSubLayerCheckboxesComponent_div_1_Template, 4, 2, "div", 1);
        ɵngcc0.ɵɵtemplate(2, HsLayerEditorSubLayerCheckboxesComponent_div_2_Template, 8, 5, "div", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.subLayerIsString(ctx.subLayer));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.subLayerIsString(ctx.subLayer));
    } }, directives: [ɵngcc3.NgIf, ɵngcc5.CheckboxControlValueAccessor, ɵngcc5.NgControlStatus, ɵngcc5.NgModel, ɵngcc3.NgClass, ɵngcc3.NgStyle, ɵngcc3.NgForOf, HsLayerEditorSubLayerCheckboxesComponent], encapsulation: 2 });
HsLayerEditorSubLayerCheckboxesComponent.ctorParameters = () => [
    { type: HsLayerEditorSublayerService },
    { type: HsLayerManagerService }
];
HsLayerEditorSubLayerCheckboxesComponent.propDecorators = {
    subLayer: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsLayerEditorSubLayerCheckboxesComponent, [{
        type: Component,
        args: [{
                selector: 'hs-layer-editor-sub-layer-checkbox',
                template: "<div class=\"d-flex m-auto sublayerContainer\">\n    <!-- string -->\n    <div class=\"p-0 form-check form-check-inline\" *ngIf=\"subLayerIsString(subLayer)\">\n        <input class=\"form-check-input\" type=\"checkbox\" [(ngModel)]=\"checkedSubLayers[subLayer]\"\n            (change)=\"subLayerSelected()\">\n        <label class=\"form-check-label\">{{subLayer}}</label>\n    </div>\n    <!-- object -->\n    <div *ngIf=\"!subLayerIsString(subLayer)\" class=\"w-100\">\n        <div class=\"d-flex\">\n            <div class=\"p-0 form-check form-check-inline\">\n                <input class=\"form-check-input\" type=\"checkbox\" [(ngModel)]=\"checkedSubLayers[subLayer.Name]\" [ngModelOptions]=\"{standalone: true}\"\n                    (change)=\"subLayerSelected(subLayer,checkedSubLayers[subLayer.Name])\"\n                    [attr.id]=\"'hs-sublayers-'+subLayer.Name\" *ngIf=\"!subLayer.Layer\">\n                <input class=\"form-check-input\" type=\"checkbox\" [(ngModel)]=\"withChildren[subLayer.Name]\" [ngModelOptions]=\"{standalone: true}\"\n                    (change)=\"subLayerSelected(subLayer, withChildren[subLayer.Name])\"\n                    [attr.id]=\"'hs-sublayers-'+subLayer.Name\" *ngIf=\"subLayer.Layer\">\n\n                <div class=\"p-0 d-inline-flex flex-grow\" *ngIf=\"subLayer.Layer\">\n                    <label class=\"form-check-label m-0\"\n                        [ngClass]=\"{'hs-checkmark':withChildren[subLayer.Name],'hs-uncheckmark':!withChildren[subLayer.Name]}\"\n                        [attr.for]=\"'hs-sublayers-'+subLayer.Name\"></label>\n                    <div (click)=\"toggleExpanded()\" [ngStyle]=\"{'cursor':'pointer'}\" [ngClass]=\"{'grayed': HsLayerManagerService.currentResolution >= subLayer.maxResolution}\">\n                        {{subLayer.Title || subLayer.Name}}\n                        <button type=\"button\" class=\"btn btn-sm p-0\" [ngStyle]=\"{'font-size':'x-small'}\">\n                            <i [ngClass]=\"{'icon-chevron-down': expanded, 'icon-chevron-right': !expanded}\"></i>\n                        </button>\n                    </div>\n                </div>\n                <div *ngIf=\"!subLayer.Layer\">\n                    <label class=\"form-check-label m-0\"\n                        [ngClass]=\"{'hs-checkmark':checkedSubLayers[subLayer.Name],'hs-uncheckmark':!checkedSubLayers[subLayer.Name], 'grayed': (HsLayerManagerService.currentResolution > subLayer.maxResolution) }\"\n                        [attr.for]=\"'hs-sublayers-'+subLayer.Name\">{{subLayer.Title || subLayer.Name}}</label>\n                </div>\n            </div>\n        </div>\n        <div *ngIf=\"subLayer.Layer\" class=\"collapse ml-4\" [hidden]=\"!expanded\">\n            <div *ngFor=\"let subLayer of subLayer.Layer\">\n                <div *ngIf=\"subLayerIsString(subLayer)\">\n                    <input class=\"form-check-input\" type=\"checkbox\" [(ngModel)]=\"checkedSubLayers[subLayer]\"\n                        (change)=\"subLayerSelected(subLayer,checkedSubLayers[subLayer.Name])\"\n                        [attr.id]=\"'hs-sublayers-'+subLayer\" [ngModelOptions]=\"{standalone: true}\">\n                    <label class=\"form-check-label\" [attr.for]=\"'hs-sublayers-'+subLayer\">{{subLayer}}</label>\n                </div>\n                <hs-layer-editor-sub-layer-checkbox [subLayer]=\"subLayer\" *ngIf=\"!subLayerIsString(subLayer)\">\n                </hs-layer-editor-sub-layer-checkbox>\n            </div>\n        </div>\n\n    </div>\n</div>\n"
            }]
    }], function () { return [{ type: HsLayerEditorSublayerService }, { type: HsLayerManagerService }]; }, { subLayer: [{
            type: Input
        }] }); })();

class HsLayerListComponent {
    constructor(HsConfig, HsLayerManagerService, hsDimensionTimeService, HsMapService, HsUtilsService, HsLayerEditorSublayerService, HsLayoutService, HsEventBusService, HsLayerUtilsService) {
        this.HsConfig = HsConfig;
        this.HsLayerManagerService = HsLayerManagerService;
        this.hsDimensionTimeService = hsDimensionTimeService;
        this.HsMapService = HsMapService;
        this.HsUtilsService = HsUtilsService;
        this.HsLayerEditorSublayerService = HsLayerEditorSublayerService;
        this.HsLayoutService = HsLayoutService;
        this.HsEventBusService = HsEventBusService;
        this.HsLayerUtilsService = HsLayerUtilsService;
        /**
         * List of layer titles for current folder structure level. List is always ordered in order which should be used in template.
         * @public
         */
        this.layer_titles = [];
        /**
         * List of layers which belong to folder hierarchy level of directive instance
         */
        this.filtered_layers = [];
        this.getHsLaymanSynchronizing = getHsLaymanSynchronizing;
        this.getExclusive = getExclusive;
        this.layerFilter = (item) => {
            const r = new RegExp(this.HsLayerManagerService.data.filter, 'i');
            return r.test(item.title);
        };
        this.layerManagerUpdatesSubscription =
            this.HsEventBusService.layerManagerUpdates.subscribe(() => {
                this.HsLayerManagerService.updateLayerListPositions();
                this.updateLayers();
            });
    }
    ngOnDestroy() {
        this.layerManagerUpdatesSubscription.unsubscribe();
    }
    /**
     * Test if selected layer is loaded in map
     * @param layer - Selected layer
     */
    layerLoaded(layer) {
        return this.HsLayerUtilsService.layerLoaded(layer);
    }
    changeSublayerVisibilityState(layer, state) {
        if (layer.checkedSubLayers) {
            Object.keys(layer.checkedSubLayers).forEach((key) => {
                layer.checkedSubLayers[key] = state;
            });
        }
        if (layer.withChildren) {
            Object.keys(layer.withChildren).forEach((key) => {
                layer.withChildren[key] = state;
            });
        }
    }
    /**
     * Test if selected layer is valid
     * @param layer - Selected layer
     * @returns true for invalid layer
     */
    layerValid(layer) {
        return this.HsLayerUtilsService.layerInvalid(layer);
    }
    /**
     * Controls state of layer's sublayers checkboxes with layer visibility changes
     * @param layer - Selected layer
     */
    toggleSublayersVisibility(layer) {
        if (!layer.visible) {
            if (this.HsLayerManagerService.currentLayer === layer) {
                if (this.HsLayerEditorSublayerService.hasSubLayers()) {
                    this.changeSublayerVisibilityState(layer, this.HsLayerManagerService.currentLayer.visible);
                }
            }
            else {
                this.changeSublayerVisibilityState(layer, layer.visible);
            }
        }
        else {
            if (layer.checkedSubLayers) {
                Object.keys(layer.checkedSubLayers).forEach((key) => {
                    layer.checkedSubLayers[key] = layer.checkedSubLayersTmp[key];
                });
            }
            if (layer.withChildren) {
                Object.keys(layer.withChildren).forEach((key) => {
                    layer.withChildren[key] = layer.withChildrenTmp[key];
                });
            }
        }
    }
    ngOnInit() {
        this.filtered_layers = this.filterLayers();
    }
    /**
     * Filters layers, and returns only the ones belonging to folder hierarchy level of directive
     * @private
     * @returns {Array<HsLayerDescriptor>} Filtered HsLayerManagerService layers
     */
    filterLayers() {
        const tmp = [];
        for (const layer of this.HsLayerManagerService.data.layers) {
            if (getPath(layer.layer) == this.folder.hsl_path ||
                ((getPath(layer.layer) == undefined || getPath(layer.layer) == '') &&
                    this.folder.hsl_path == '')) {
                tmp.push(layer);
            }
        }
        return tmp;
    }
    /**
     * Generate list of layer titles out of {@link hs.layermanager.layerlistDirective#filtered_layers filtered_layers}. Complex layer objects can't be used because DragDropList functionality can handle only simple structures.
     * @public
     */
    generateLayerTitlesArray() {
        this.layer_titles = [];
        for (let i = 0; i < this.filtered_layers.length; i++) {
            this.layer_titles.push(this.filtered_layers[i].title);
        }
    }
    /**
     * Test if layer is queryable (WMS layer with Info format)
     * @param layer_container - Selected layer - wrapped in layer object
     */
    isLayerQueryable(layer_container) {
        return this.HsLayerUtilsService.isLayerQueryable(layer_container.layer);
    }
    showLayerWmsT(layer) {
        var _a;
        return (this.hsDimensionTimeService.layerIsWmsT(layer) &&
            !((_a = getDimension(layer.layer, 'time')) === null || _a === void 0 ? void 0 : _a.onlyInEditor));
    }
    /**
     * Update layers list
     * @private
     */
    updateLayers() {
        this.filtered_layers = this.filterLayers();
        this.generateLayerTitlesArray();
    }
}
HsLayerListComponent.ɵfac = function HsLayerListComponent_Factory(t) { return new (t || HsLayerListComponent)(ɵngcc0.ɵɵdirectiveInject(HsConfig), ɵngcc0.ɵɵdirectiveInject(HsLayerManagerService), ɵngcc0.ɵɵdirectiveInject(HsDimensionTimeService), ɵngcc0.ɵɵdirectiveInject(HsMapService), ɵngcc0.ɵɵdirectiveInject(HsUtilsService), ɵngcc0.ɵɵdirectiveInject(HsLayerEditorSublayerService), ɵngcc0.ɵɵdirectiveInject(HsLayoutService), ɵngcc0.ɵɵdirectiveInject(HsEventBusService), ɵngcc0.ɵɵdirectiveInject(HsLayerUtilsService)); };
HsLayerListComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsLayerListComponent, selectors: [["hs-layermanager-layer-list"]], inputs: { folder: "folder" }, decls: 1, vars: 1, consts: [["class", "list-group-item hs-lm-list pb-1", 4, "ngIf"], [1, "list-group-item", "hs-lm-list", "pb-1"], [1, "list-group", "row"], ["class", "list-group-item hs-lm-item", 3, "id", "ngClass", 4, "ngFor", "ngForOf"], [1, "list-group-item", "hs-lm-item", 3, "id", "ngClass"], [1, "d-flex"], [1, "p-0", 3, "ngClass"], ["type", "button", 1, "btn", "btn-sm", "btn-light", "hs-lm-item-visibility", 3, "ngClass", "click"], ["abstractTooltip", ""], [1, "align-items-center", "p-0", "hs-lm-item-title", "flex-grow-1", 2, "word-break", "break-word", 3, "ngClass", "ngbTooltip", "closeDelay", "click"], ["class", "p-0 mr-1 ml-1 info_btn", "style", "font-size: x-small; flex-grow: 20;", 3, "click", 4, "ngIf"], [1, "p-0", 3, "hidden"], ["data-toggle", "tooltip", "data-container", "body", "data-placement", "auto", 1, "icon-warning-sign", "hs-lm-warning-scale", 3, "title", "hidden", "click"], ["data-toggle", "tooltip", "data-container", "body", "data-placement", "auto", 1, "icon-warning-sign", "alert-danger", "bg-white", "hs-lm-warning-error", 3, "title", "click"], ["data-toggle", "tooltip", "data-container", "body", "data-placement", "auto", 1, "icon-cloudaltsync", 3, "title", "click"], [1, "icon-info-sign", "hs-lm-queryable", 3, "title", "click"], [1, "pl-1", "info_btn"], ["data-toggle", "tooltip", "data-container", "body", "data-placement", "auto", 1, "icon-settingsthree-gears", "text-secondary", 3, "title", "click"], ["class", "d-flex", 3, "layer", 4, "ngIf"], [3, "innerHtml"], [1, "p-0", "mr-1", "ml-1", "info_btn", 2, "font-size", "x-small", "flex-grow", "20", 3, "click"], [1, "mr-1", "icon-refresh", "icon-spin", 3, "hidden"], [1, "mr-1", 3, "ngClass", "hidden"], [1, "d-flex", 3, "layer"]], template: function HsLayerListComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, HsLayerListComponent_div_0_Template, 4, 4, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.folder.layers.length > 0);
    } }, directives: function () { return [ɵngcc3.NgIf, ɵngcc3.NgForOf, ɵngcc3.NgClass, ɵngcc6.NgbTooltip, HsLayerManagerTimeEditorComponent]; }, pipes: function () { return [FilterPipe, ɵngcc1.TranslatePipe]; }, encapsulation: 2 });
HsLayerListComponent.ctorParameters = () => [
    { type: HsConfig },
    { type: HsLayerManagerService },
    { type: HsDimensionTimeService },
    { type: HsMapService },
    { type: HsUtilsService },
    { type: HsLayerEditorSublayerService },
    { type: HsLayoutService },
    { type: HsEventBusService },
    { type: HsLayerUtilsService }
];
HsLayerListComponent.propDecorators = {
    folder: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsLayerListComponent, [{
        type: Component,
        args: [{
                selector: 'hs-layermanager-layer-list',
                template: "<div class=\"list-group-item hs-lm-list pb-1\" *ngIf=\"folder.layers.length>0\">\n    <ul class=\"list-group row\">\n        <li *ngFor=\"let layer of filtered_layers | filter:layerFilter\" id=\"{{layer.idString()}}\" class=\"list-group-item hs-lm-item\"\n            [ngClass]=\"{'hs-lm-detail-activated':'currentLayer == layer', 'grayed': layer.grayed === true}\">\n            <div class=\"d-flex\">\n                <div class=\"p-0\" [ngClass]=\"getExclusive(layer.layer) ? 'exclusive' : ''\">\n                    <button type=\"button\" class=\"btn btn-sm btn-light hs-lm-item-visibility\"\n                        (click)=\"HsLayerManagerService.changeLayerVisibility(!layer.visible, layer);toggleSublayersVisibility(layer);$event.stopPropagation()\"\n                        [ngClass]=\"layer.visible ? 'hs-checkmark' : 'hs-uncheckmark'\"></button>\n                </div>\n                <ng-template #abstractTooltip>\n                    <span [innerHtml]=\"HsLayerManagerService.makeSafeAndTranslate('LAYERS', layer.abstract)\"></span>\n                </ng-template>\n                <div class=\"align-items-center p-0 hs-lm-item-title flex-grow-1\"\n                    (click)=\"HsLayerManagerService.toggleLayerEditor(layer,'sublayers', 'settings')\"\n                    style=\"word-break:break-word;\" [ngClass]=\"{'hover': layer.hasSublayers === true}\"\n                    [ngbTooltip]=\"layer.abstract ? abstractTooltip : ''\" [closeDelay]=\"HsConfig.layerTooltipDelay || 0\">\n                    {{HsLayerUtilsService.translateTitle(layer.title)}}\n                </div>\n                <div class=\"p-0 mr-1 ml-1 info_btn\" *ngIf=\"layer.hasSublayers\"\n                    style=\"font-size: x-small; flex-grow: 20;\"\n                    (click)=\"HsLayerManagerService.toggleLayerEditor(layer,'sublayers', 'settings')\">\n                    <span class=\"mr-1 icon-refresh icon-spin\" [hidden]=\"layerLoaded(layer)\"></span>\n                    <span class=\"mr-1\"\n                        [ngClass]=\"{'icon-chevron-right':HsLayerManagerService.currentLayer === layer, 'icon-chevron-down': HsLayerManagerService.currentLayer !== layer}\"\n                        [hidden]=\"!layerLoaded(layer)\"></span>\n                </div>\n\n                <div class=\"p-0 \" [hidden]=\"layerValid(layer)\">\n                    <i class=\"icon-warning-sign hs-lm-warning-scale\"\n                        [title]=\"'LAYERMANAGER.layerList.noAvailableInScale' | translate\" data-toggle=\"tooltip\"\n                        data-container=\"body\" data-placement=\"auto\" [hidden]=\"!layer.grayed\"\n                        (click)=\"$event.stopPropagation()\"></i>\n                </div>\n                <div class=\"p-0\" [hidden]=\"!layerValid(layer)\">\n                    <i class=\"icon-warning-sign alert-danger bg-white hs-lm-warning-error\"\n                        [title]=\"'LAYERMANAGER.layerList.layerNotAvailable' | translate\" data-toggle=\"tooltip\"\n                        data-container=\"body\" data-placement=\"auto\" (click)=\"$event.stopPropagation()\"></i>\n                </div>\n                <div class=\"p-0\" [hidden]=\"!getHsLaymanSynchronizing(layer.layer)\">\n                    <i class=\"icon-cloudaltsync\" [title]=\"'LAYERMANAGER.layerList.sendingToLayman' | translate\"\n                        data-toggle=\"tooltip\" data-container=\"body\" data-placement=\"auto\"\n                        (click)=\"$event.stopPropagation()\"></i>\n                </div>\n                <div class=\"p-0\" [hidden]=\"!isLayerQueryable(layer)\">\n                    <i class=\"icon-info-sign hs-lm-queryable\"\n                        [title]=\"'LAYERMANAGER.layerList.layerIsQueryable' | translate\"\n                        (click)=\"$event.stopPropagation()\"></i>\n                </div>\n                <div class=\"pl-1 info_btn\">\n                    <span class=\"icon-settingsthree-gears text-secondary\"\n                        (click)=\"HsLayerManagerService.toggleLayerEditor(layer,'settings','sublayers')\"\n                        [title]=\"'COMMON.info' | translate\" data-toggle=\"tooltip\" data-container=\"body\"\n                        data-placement=\"auto\"></span>\n                </div>\n            </div>\n            <hs-layermanager-time-editor [layer]=\"layer\" class=\"d-flex\" *ngIf=\"showLayerWmsT(layer)\"></hs-layermanager-time-editor>\n        </li>\n    </ul>\n</div>\n"
            }]
    }], function () { return [{ type: HsConfig }, { type: HsLayerManagerService }, { type: HsDimensionTimeService }, { type: HsMapService }, { type: HsUtilsService }, { type: HsLayerEditorSublayerService }, { type: HsLayoutService }, { type: HsEventBusService }, { type: HsLayerUtilsService }]; }, { folder: [{
            type: Input
        }] }); })();

class HsLayerManagerFolderComponent {
    constructor(HsLanguageService /* Used in template */) {
        this.HsLanguageService = HsLanguageService;
    }
    /**
     * @public
     * @param {object} obj Folder object of current hierarchy
     * @returns {boolean} True if subfolders exists
     * @description Find if current folder has any subfolder
     */
    folderVisible(obj) {
        return obj.sub_folders.length > 0;
    }
}
HsLayerManagerFolderComponent.ɵfac = function HsLayerManagerFolderComponent_Factory(t) { return new (t || HsLayerManagerFolderComponent)(ɵngcc0.ɵɵdirectiveInject(HsLanguageService)); };
HsLayerManagerFolderComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsLayerManagerFolderComponent, selectors: [["hs-layer-manager-folder"]], inputs: { folder: "folder" }, decls: 2, vars: 1, consts: [["class", "list-group", 4, "ngFor", "ngForOf"], [1, "list-group"], [1, "list-group-item", "list-group-item-warning"], [3, "ngStyle"], [3, "hidden"], [3, "folder"]], template: function HsLayerManagerFolderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵtemplate(1, HsLayerManagerFolderComponent_ul_1_Template, 8, 7, "ul", 0);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.folder.sub_folders);
    } }, directives: [ɵngcc3.NgForOf, ɵngcc3.NgStyle, HsLayerManagerFolderComponent, HsLayerListComponent], encapsulation: 2 });
HsLayerManagerFolderComponent.ctorParameters = () => [
    { type: HsLanguageService }
];
HsLayerManagerFolderComponent.propDecorators = {
    folder: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsLayerManagerFolderComponent, [{
        type: Component,
        args: [{
                selector: 'hs-layer-manager-folder',
                template: "<div>\n    <ul class=\"list-group\" *ngFor=\"let value of folder.sub_folders\">\n        <a  class=\"list-group-item list-group-item-warning\">\n            <span [ngStyle]=\"{'padding-left': value.indent*15}\">{{HsLanguageService.getTranslationIgnoreNonExisting('LAYERMANAGER', value.name)}}</span>\n        </a>\n        <li [hidden]=\"!folderVisible(value)\">\n            <hs-layer-manager-folder [folder]=\"value\"></hs-layer-manager-folder>\n        </li>\n        <li>\n            <hs-layermanager-layer-list [folder]=\"value\"></hs-layermanager-layer-list>\n        </li>\n    </ul>\n</div>\n"
            }]
    }], function () { return [{ type: HsLanguageService }]; }, { folder: [{
            type: Input
        }] }); })();

class HsLayerManagerTimeEditorComponent {
    constructor(hsEventBusService, hsDimensionTimeService, hsLayoutService, hsConfig) {
        this.hsEventBusService = hsEventBusService;
        this.hsDimensionTimeService = hsDimensionTimeService;
        this.hsLayoutService = hsLayoutService;
        this.hsConfig = hsConfig;
        this.timeDisplayFormat = 'yyyy-MM-dd HH:mm:ss z';
        /**
         * currently hard-coded and not changes
         * TODO: needs to load locale data via registerLocaleData() from '\@angular/common'
         * see https://stackoverflow.com/questions/34904683/how-to-set-locale-in-datepipe-in-angular-2
         */
        this.timeDisplayLocale = 'en-US';
        this.ngUnsubscribe = new Subject();
        this.hsDimensionTimeService.layerTimeChanges
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(({ layer: layerDescriptor, time }) => {
            if (this.layer.uid !== layerDescriptor.uid) {
                return;
            }
            if (!this.availableTimes) {
                this.fillAvailableTimes(layerDescriptor);
            }
            this.setCurrentTimeIfAvailable(time);
        });
        this.hsEventBusService.layerTimeSynchronizations
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(({ sync, time }) => {
            this.timesInSync = sync;
            if (sync) {
                this.hideTimeSelect();
                this.setCurrentTimeIfAvailable(time);
                if (this.currentTime) {
                    this.setLayerTime();
                }
            }
        });
    }
    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
    /**
     * This gets called from subscriber and also OnInit because
     * subscriber could have been set up after the event was broadcasted
     */
    fillAvailableTimes(layer) {
        this.availableTimes = layer.time.timePoints;
        this.setDateTimeFormatting();
        this.setCurrentTimeIfAvailable(this.layer.time.default);
        if (!this.currentTimeDefined()) {
            this.currentTime = this.availableTimes[0];
            this.currentTimeIdx = this.availableTimes.indexOf(this.currentTime);
        }
    }
    ngOnInit() {
        this.selectVisible = false;
        this.timesInSync = false;
        if (this.layer.time) {
            this.fillAvailableTimes(this.layer);
        }
    }
    currentTimeDefined() {
        return this.currentTime !== undefined && this.currentTime !== null;
    }
    hasPreviousTime() {
        return this.availableTimes && this.currentTimeIdx > 0;
    }
    hasFollowingTime() {
        return (this.availableTimes &&
            this.currentTimeIdx < this.availableTimes.length - 2);
    }
    previousTime() {
        if (this.hasPreviousTime()) {
            this.currentTime = this.availableTimes[--this.currentTimeIdx];
            if (this.timesInSync) {
                this.hsEventBusService.layerTimeSynchronizations.next({
                    sync: this.timesInSync,
                    time: this.currentTime,
                });
            }
            this.setLayerTime();
        }
    }
    followingTime() {
        if (this.hasFollowingTime()) {
            this.currentTime = this.availableTimes[++this.currentTimeIdx];
            if (this.timesInSync) {
                this.hsEventBusService.layerTimeSynchronizations.next({
                    sync: this.timesInSync,
                    time: this.currentTime,
                });
            }
            this.setLayerTime();
        }
    }
    selectTime() {
        this.currentTimeIdx = this.availableTimes.indexOf(this.currentTime);
        if (this.timesInSync) {
            this.hsEventBusService.layerTimeSynchronizations.next({
                sync: this.timesInSync,
                time: this.currentTime,
            });
        }
        this.setLayerTime();
    }
    setCurrentTimeIfAvailable(time) {
        if (this.availableTimes.includes(time)) {
            this.currentTime = time;
            this.currentTimeIdx = this.availableTimes.indexOf(time);
        }
        else {
            this.currentTime = null;
            this.currentTimeIdx = -1;
        }
    }
    setLayerTime() {
        setTimeout(() => {
            this.hsDimensionTimeService.setLayerTime(this.layer, this.currentTime);
        }, 100);
    }
    showTimeSelect() {
        this.selectVisible = true;
        this.selectElement.nativeElement.focus(); //FIXME: this just refuse to work...
    }
    hideTimeSelect() {
        this.selectVisible = false;
    }
    synchronizeTimes() {
        this.timesInSync = !this.timesInSync;
        this.hsEventBusService.layerTimeSynchronizations.next({
            sync: this.timesInSync,
            time: this.currentTime,
        });
    }
    setDateTimeFormatting() {
        if (this.hsConfig.timeDisplayFormat) {
            this.timeDisplayFormat = this.hsConfig.timeDisplayFormat;
        }
        else if (this.availableTimes.every((time) => time.endsWith('00-00T00:00:00.000Z'))) {
            this.timeDisplayFormat = 'yyyy';
        }
        else if (this.availableTimes.every((time) => time.endsWith('00T00:00:00.000Z'))) {
            this.timeDisplayFormat = 'yyyy-MM';
        }
        else if (this.availableTimes.every((time) => time.endsWith('00:00:00.000Z'))) {
            this.timeDisplayFormat = 'yyyy-MM-dd';
        }
        else if (this.availableTimes.every((time) => time.endsWith('00.000Z'))) {
            this.timeDisplayFormat = 'y-MM-dd HH:mm';
        }
        else if (this.availableTimes.every((time) => time.endsWith('000Z'))) {
            this.timeDisplayFormat = 'y-MM-dd HH:mm:ss';
        }
    }
}
HsLayerManagerTimeEditorComponent.ɵfac = function HsLayerManagerTimeEditorComponent_Factory(t) { return new (t || HsLayerManagerTimeEditorComponent)(ɵngcc0.ɵɵdirectiveInject(HsEventBusService), ɵngcc0.ɵɵdirectiveInject(HsDimensionTimeService), ɵngcc0.ɵɵdirectiveInject(HsLayoutService), ɵngcc0.ɵɵdirectiveInject(HsConfig)); };
HsLayerManagerTimeEditorComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsLayerManagerTimeEditorComponent, selectors: [["hs-layermanager-time-editor"]], viewQuery: function HsLayerManagerTimeEditorComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c68, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.selectElement = _t.first);
    } }, inputs: { layer: "layer" }, decls: 23, vars: 30, consts: [[1, "p-0", "flex-grow-1"], ["type", "button", 1, "btn", "btn-sm", "text-info", 3, "disabled", "click"], [1, "glyphicon", "icon-chevron-left"], [1, "btn", "btn-sm", "text-info", "px-0", 3, "hidden", "click"], [3, "hidden"], ["data-toggle", "tooltip", "data-container", "body", "data-placement", "auto", 1, "bg-warning", "text-dark", 3, "hidden", "ngbTooltip", "closeDelay"], [3, "hidden", "ngModel", "ngModelChange", "change", "blur"], ["hstimeselector", ""], [3, "ngValue", 4, "ngFor", "ngForOf"], [1, "glyphicon", "icon-chevron-right"], [1, "p-0"], ["type", "button", 1, "btn", "btn-sm", "px-0", 3, "ngClass", "title", "click"], [1, "glyphicon", "icon-timeline"], [1, "sr-only"], [3, "ngValue"]], template: function HsLayerManagerTimeEditorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "button", 1);
        ɵngcc0.ɵɵlistener("click", function HsLayerManagerTimeEditorComponent_Template_button_click_1_listener() { return ctx.previousTime(); });
        ɵngcc0.ɵɵelement(2, "i", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "button", 3);
        ɵngcc0.ɵɵlistener("click", function HsLayerManagerTimeEditorComponent_Template_button_click_3_listener($event) { $event.preventDefault(); return ctx.showTimeSelect(); });
        ɵngcc0.ɵɵelementStart(4, "span", 4);
        ɵngcc0.ɵɵtext(5);
        ɵngcc0.ɵɵpipe(6, "date");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "span", 5);
        ɵngcc0.ɵɵpipe(8, "translate");
        ɵngcc0.ɵɵtext(9);
        ɵngcc0.ɵɵpipe(10, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "select", 6, 7);
        ɵngcc0.ɵɵlistener("ngModelChange", function HsLayerManagerTimeEditorComponent_Template_select_ngModelChange_11_listener($event) { return ctx.currentTime = $event; })("change", function HsLayerManagerTimeEditorComponent_Template_select_change_11_listener() { ctx.selectTime(); return ctx.hideTimeSelect(); })("blur", function HsLayerManagerTimeEditorComponent_Template_select_blur_11_listener() { return ctx.hideTimeSelect(); });
        ɵngcc0.ɵɵtemplate(13, HsLayerManagerTimeEditorComponent_option_13_Template, 3, 6, "option", 8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(14, "button", 1);
        ɵngcc0.ɵɵlistener("click", function HsLayerManagerTimeEditorComponent_Template_button_click_14_listener() { return ctx.followingTime(); });
        ɵngcc0.ɵɵelement(15, "i", 9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(16, "div", 10);
        ɵngcc0.ɵɵelementStart(17, "button", 11);
        ɵngcc0.ɵɵlistener("click", function HsLayerManagerTimeEditorComponent_Template_button_click_17_listener() { return ctx.synchronizeTimes(); });
        ɵngcc0.ɵɵpipe(18, "translate");
        ɵngcc0.ɵɵelement(19, "i", 12);
        ɵngcc0.ɵɵelementStart(20, "span", 13);
        ɵngcc0.ɵɵtext(21);
        ɵngcc0.ɵɵpipe(22, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("disabled", !ctx.hasPreviousTime());
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("hidden", ctx.selectVisible);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", !ctx.currentTimeDefined());
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind3(6, 15, ctx.currentTime, ctx.timeDisplayFormat, "cs"), " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("hidden", ctx.currentTimeDefined())("ngbTooltip", ɵngcc0.ɵɵpipeBind1(8, 19, "LAYERMANAGER.time.outOfRangeDescription"))("closeDelay", ctx.hsConfig.layerTooltipDelay || 0);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(10, 21, "LAYERMANAGER.time.outOfRange"), " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("hidden", !ctx.selectVisible)("ngModel", ctx.currentTime);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.availableTimes);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("disabled", !ctx.hasFollowingTime());
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵpropertyInterpolate("title", ɵngcc0.ɵɵpipeBind1(18, 23, "LAYERMANAGER.time.syncTimesTooltip"));
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(27, _c69, ctx.timesInSync, !ctx.timesInSync));
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(22, 25, "LAYERMANAGER.time.syncTimes"));
    } }, directives: [ɵngcc6.NgbTooltip, ɵngcc5.SelectControlValueAccessor, ɵngcc5.NgControlStatus, ɵngcc5.NgModel, ɵngcc3.NgForOf, ɵngcc3.NgClass, ɵngcc5.NgSelectOption, ɵngcc5.ɵNgSelectMultipleOption], pipes: [ɵngcc3.DatePipe, ɵngcc1.TranslatePipe], encapsulation: 2 });
HsLayerManagerTimeEditorComponent.ctorParameters = () => [
    { type: HsEventBusService },
    { type: HsDimensionTimeService },
    { type: HsLayoutService },
    { type: HsConfig }
];
HsLayerManagerTimeEditorComponent.propDecorators = {
    layer: [{ type: Input }],
    selectElement: [{ type: ViewChild, args: ['hstimeselector',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsLayerManagerTimeEditorComponent, [{
        type: Component,
        args: [{
                selector: 'hs-layermanager-time-editor',
                template: "<div class=\"p-0 flex-grow-1\">\n  <button type=\"button\" class=\"btn btn-sm text-info\" (click)=\"previousTime()\" [disabled]=\"!hasPreviousTime()\">\n    <i class=\"glyphicon icon-chevron-left\"></i>\n  </button>\n  <button class=\"btn btn-sm text-info px-0\" (click)=\"$event.preventDefault();showTimeSelect()\"\n    [hidden]=\"selectVisible\">\n    <span [hidden]=\"!currentTimeDefined()\">\n      {{currentTime | date:timeDisplayFormat:'cs'}}\n    </span>\n    <span [hidden]=\"currentTimeDefined()\" class=\"bg-warning text-dark\" data-toggle=\"tooltip\" data-container=\"body\" data-placement=\"auto\"\n    [ngbTooltip]=\"'LAYERMANAGER.time.outOfRangeDescription' | translate\" [closeDelay]=\"hsConfig.layerTooltipDelay || 0\">\n      {{'LAYERMANAGER.time.outOfRange' | translate}}\n    </span>\n  </button>\n  <select #hstimeselector [hidden]=\"!selectVisible\" [(ngModel)]=\"currentTime\"\n    (change)=\"selectTime();hideTimeSelect();\" (blur)=\"hideTimeSelect()\">\n    <option *ngFor=\"let time of availableTimes\" [ngValue]=\"time\">\n      {{time | date:timeDisplayFormat:timeDisplayLocale}}\n    </option>\n  </select>\n  <button type=\"button\" class=\"btn btn-sm text-info\" (click)=\"followingTime()\" [disabled]=\"!hasFollowingTime()\">\n    <i class=\"glyphicon icon-chevron-right\"></i>\n  </button>\n</div>\n<div class=\"p-0\">\n  <button type=\"button\" class=\"btn btn-sm px-0\"\n    [ngClass]=\"{'btn-info': timesInSync, 'text-secondary': !timesInSync}\"\n    (click)=\"synchronizeTimes()\" title=\"{{'LAYERMANAGER.time.syncTimesTooltip' | translate}}\">\n    <i class=\"glyphicon icon-timeline\"></i>\n    <span class=\"sr-only\">{{'LAYERMANAGER.time.syncTimes' | translate}}</span>\n  </button>\n</div>\n"
            }]
    }], function () { return [{ type: HsEventBusService }, { type: HsDimensionTimeService }, { type: HsLayoutService }, { type: HsConfig }]; }, { layer: [{
            type: Input
        }], selectElement: [{
            type: ViewChild,
            args: ['hstimeselector']
        }] }); })();

class PhysicalListItem {
}
class HsLayermanagerPhysicalListService {
    constructor(HsEventBusService, HsLayerManagerService, HsConfig, HsMapService, HsUtilsService) {
        this.HsEventBusService = HsEventBusService;
        this.HsLayerManagerService = HsLayerManagerService;
        this.HsConfig = HsConfig;
        this.HsMapService = HsMapService;
        this.HsUtilsService = HsUtilsService;
    }
    get logicalListLayers() {
        return this.HsLayerManagerService.data.layers;
    }
    get mapLayers() {
        return this.HsMapService.getLayersArray().filter((layer) => getBase(layer) != true);
    }
    /**
     * Copies layers from Layermanager layer list for the physical layer list
     */
    fillLayers() {
        if (this.logicalListLayers == undefined) {
            return;
        }
        this.layersCopy = this.HsLayerManagerService.sortLayersByZ(this.logicalListLayers.map((l) => {
            return { title: l.title, layer: l.layer };
        }));
    }
    /**
     * Changes selected layers ZIndex value - layer with the largest ZIndex will be rendered on top of all other layers
     * @param baseLayer Selected layer from physical layer list
     * @param direction Direction in which to move the selected layer - up/down
     */
    swapSibling(baseLayer, direction) {
        const currentLayerIndex = this.layersCopy.indexOf(baseLayer);
        switch (direction.toLocaleLowerCase()) {
            case 'up':
                if (currentLayerIndex != 0) {
                    this.setLayerZIndex(currentLayerIndex - 1, baseLayer.layer);
                }
                break;
            case 'down':
                if (currentLayerIndex < this.layersCopy.length - 1) {
                    this.setLayerZIndex(currentLayerIndex + 1, baseLayer.layer);
                }
                break;
            default:
        }
    }
    /**
     * Applies a new ZIndex value to the selected layer that is responsible for layer rendering on the map
     * @param indexTo new ZIndex value for the selected layer
     * @param layer Selected layer from physical layer list
     */
    setLayerZIndex(indexTo, layer) {
        const layerSwitchedWith = this.layersCopy[indexTo].layer;
        const interactedLayerZIndex = layer.getZIndex();
        layer.setZIndex(layerSwitchedWith.getZIndex());
        layerSwitchedWith.setZIndex(interactedLayerZIndex);
        this.HsEventBusService.layerManagerUpdates.next(layer);
    }
    /**
     * Move the provided layer under all other rendered layers on the map
     * @param layer provided layer
     */
    moveToBottom(layer) {
        this.moveAndShift(this.getOlLayer(layer), this.getMinZ());
    }
    /**
     * Move the provided layer over all other rendered layers on the map
     * @param layer provided layer
     */
    moveToTop(layer) {
        this.moveAndShift(this.getOlLayer(layer), this.getMaxZ());
    }
    /**
     * Move the provided layer in the middle between all other rendered layers on the map
     * @param layer provided layer
     */
    moveTo(layer, target) {
        if (this.HsUtilsService.instOf(target, PhysicalListItem)) {
            //Wrapped layer provided
            target = target.layer.getZIndex();
        }
        else if (this.HsUtilsService.instOf(target, Layer)) {
            //OL layer provided
            target = target.getZIndex();
        }
        this.moveAndShift(this.getOlLayer(layer), target);
    }
    /**
     * Move and shift layer order to make changes on the map
     * @param providedLayer provided layer
     * @param preferredZIndex ZIndex value to switch to
     */
    moveAndShift(providedLayer, preferredZIndex) {
        if (providedLayer === undefined) {
            return;
        }
        if (providedLayer.getZIndex() != preferredZIndex) {
            const indexFrom = providedLayer.getZIndex();
            const indexTo = preferredZIndex;
            const incrementValue = indexTo > indexFrom ? -1 : 1;
            for (const lyr of this.mapLayers.filter((lyr) => lyr != providedLayer)) {
                const currentZIndex = lyr.getZIndex();
                if ((currentZIndex >= indexFrom && currentZIndex <= indexTo) ||
                    (currentZIndex <= indexFrom && currentZIndex >= indexTo)) {
                    lyr.setZIndex(lyr.getZIndex() + incrementValue);
                }
            }
            providedLayer.setZIndex(preferredZIndex);
            this.HsEventBusService.layerManagerUpdates.next(providedLayer);
        }
    }
    /**
     * Gets layer property of container object or the actual provided ol layer
     * @param layer Provided layer
     * @returns Returns ol layer
     */
    getOlLayer(providedLayer) {
        if (this.HsUtilsService.instOf(providedLayer, Layer)) {
            return providedLayer;
        }
        else {
            return providedLayer.layer;
        }
    }
    /**
     * Gets all layer ZIndex values from the layer list
     * @returns Returns array of ZIndex values
     */
    zIndexList() {
        return this.mapLayers.map((lyr) => lyr.getZIndex() || 0);
    }
    /**
     * Gets maximum value from ZIndex value array
     * @returns Returns max ZIndex value
     */
    getMaxZ() {
        return Math.max(...this.zIndexList());
    }
    /**
     * Gets minimum value from ZIndex value array
     * @returns Returns min ZIndex value
     */
    getMinZ() {
        return Math.min(...this.zIndexList());
    }
}
HsLayermanagerPhysicalListService.ɵfac = function HsLayermanagerPhysicalListService_Factory(t) { return new (t || HsLayermanagerPhysicalListService)(ɵngcc0.ɵɵinject(HsEventBusService), ɵngcc0.ɵɵinject(HsLayerManagerService), ɵngcc0.ɵɵinject(HsConfig), ɵngcc0.ɵɵinject(HsMapService), ɵngcc0.ɵɵinject(HsUtilsService)); };
HsLayermanagerPhysicalListService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HsLayermanagerPhysicalListService_Factory() { return new HsLayermanagerPhysicalListService(i0.ɵɵinject(HsEventBusService), i0.ɵɵinject(HsLayerManagerService), i0.ɵɵinject(HsConfig), i0.ɵɵinject(HsMapService), i0.ɵɵinject(HsUtilsService)); }, token: HsLayermanagerPhysicalListService, providedIn: "root" });
HsLayermanagerPhysicalListService.ctorParameters = () => [
    { type: HsEventBusService },
    { type: HsLayerManagerService },
    { type: HsConfig },
    { type: HsMapService },
    { type: HsUtilsService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsLayermanagerPhysicalListService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: HsEventBusService }, { type: HsLayerManagerService }, { type: HsConfig }, { type: HsMapService }, { type: HsUtilsService }]; }, null); })();

class HsLayerPhysicalListComponent {
    constructor(HsLayerManagerService, HsLayerUtilsService, HsEventBusService, HsLayermanagerPhysicalListService, HsConfig) {
        this.HsLayerManagerService = HsLayerManagerService;
        this.HsLayerUtilsService = HsLayerUtilsService;
        this.HsEventBusService = HsEventBusService;
        this.HsLayermanagerPhysicalListService = HsLayermanagerPhysicalListService;
        this.HsConfig = HsConfig;
        this.HsLayermanagerPhysicalListService.fillLayers();
        this.layerManagerUpdatesSubscription =
            this.HsEventBusService.layerManagerUpdates.subscribe((layer) => {
                this.HsLayermanagerPhysicalListService.fillLayers();
                if (layer !== undefined) {
                    const layerFound = this.HsLayermanagerPhysicalListService.layersCopy.find((wrapper) => wrapper.layer == layer || wrapper.layer == layer.layer);
                    if (layerFound !== undefined) {
                        layerFound.active = true;
                    }
                }
            });
    }
    ngOnDestroy() {
        this.layerManagerUpdatesSubscription.unsubscribe();
    }
    drop(event) {
        const draggedLayer = event.container.data[event.previousIndex];
        const replacedLayer = event.container.data[event.currentIndex];
        moveItemInArray(this.HsLayermanagerPhysicalListService.layersCopy, event.previousIndex, event.currentIndex);
        this.HsLayermanagerPhysicalListService.moveTo(draggedLayer, replacedLayer.layer);
    }
}
HsLayerPhysicalListComponent.ɵfac = function HsLayerPhysicalListComponent_Factory(t) { return new (t || HsLayerPhysicalListComponent)(ɵngcc0.ɵɵdirectiveInject(HsLayerManagerService), ɵngcc0.ɵɵdirectiveInject(HsLayerUtilsService), ɵngcc0.ɵɵdirectiveInject(HsEventBusService), ɵngcc0.ɵɵdirectiveInject(HsLayermanagerPhysicalListService), ɵngcc0.ɵɵdirectiveInject(HsConfig)); };
HsLayerPhysicalListComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsLayerPhysicalListComponent, selectors: [["hs-layermanager-physical-layer-list"]], decls: 1, vars: 1, consts: [["class", "list-group-item hs-lm-list pb-1", 4, "ngIf"], [1, "list-group-item", "hs-lm-list", "pb-1"], ["cdkDropList", "", 1, "list-group", "row", "pl-1", 3, "cdkDropListData", "cdkDropListDropped"], ["class", "list-group-item hs-lm-item p-2", "cdkDrag", "", 3, "ngClass", 4, "ngFor", "ngForOf"], ["cdkDrag", "", 1, "list-group-item", "hs-lm-item", "p-2", 3, "ngClass"], [1, "d-flex", "align-items-center", "justify-content-between", "p-0", "hs-lm-item-title", "flex-grow-1", 2, "word-break", "break-all", "cursor", "move"], [1, "m-0"], [1, "icon-move", "text-secondary"]], template: function HsLayerPhysicalListComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, HsLayerPhysicalListComponent_div_0_Template, 3, 2, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.HsLayermanagerPhysicalListService.layersCopy.length != 0);
    } }, directives: [ɵngcc3.NgIf, ɵngcc7.CdkDropList, ɵngcc3.NgForOf, ɵngcc7.CdkDrag, ɵngcc3.NgClass], styles: [".activeLayer[_ngcontent-%COMP%]{background-color:#0003}.cdk-drag-placeholder[_ngcontent-%COMP%]{background-color:#0000003d;color:#fff}.cdk-drag-preview[_ngcontent-%COMP%]{box-sizing:border-box;background-color:#b9b9b9bf;border:1px solid #b9b9b9;overflow:hidden;color:transparent;box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f}.cdk-drag-animating[_ngcontent-%COMP%]{transition:transform .25s cubic-bezier(0,0,.2,1)}.list-group.cdk-drop-list-dragging[_ngcontent-%COMP%]   .list-group-item[_ngcontent-%COMP%]:not(.cdk-drag-placeholder){transition:transform .25s cubic-bezier(0,0,.2,1)}"] });
HsLayerPhysicalListComponent.ctorParameters = () => [
    { type: HsLayerManagerService },
    { type: HsLayerUtilsService },
    { type: HsEventBusService },
    { type: HsLayermanagerPhysicalListService },
    { type: HsConfig }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsLayerPhysicalListComponent, [{
        type: Component,
        args: [{
                selector: 'hs-layermanager-physical-layer-list',
                template: "<div class=\"list-group-item hs-lm-list pb-1\" *ngIf=\"HsLayermanagerPhysicalListService.layersCopy.length != 0\">\n    <div cdkDropList class=\"list-group row pl-1\" (cdkDropListDropped)=\"drop($event)\" [cdkDropListData]=\"HsLayermanagerPhysicalListService.layersCopy\">\n        <div class=\"list-group-item hs-lm-item p-2\" [ngClass]=\"{'activeLayer': layer.active}\"\n            *ngFor=\"let layer of HsLayermanagerPhysicalListService.layersCopy;\" cdkDrag>\n                <div class=\"d-flex align-items-center justify-content-between p-0 hs-lm-item-title flex-grow-1\"\n                    style=\"word-break:break-all; cursor:move\">\n                    <p class=\"m-0\">{{HsLayerUtilsService.translateTitle(layer.title)}}</p>\n                    <i class=\"icon-move text-secondary\"></i>\n                </div>\n                <!-- <div *cdkDragPreview class=\"mw-100 physical-layerlist-preview\">\n                    <p class=\"m-0\">{{HsLayerUtilsService.translateTitle(layer.title)}}</p>\n                    <i class=\"icon-move text-secondary\"></i>\n                </div> -->\n        </div>\n    </div>\n</div>\n",
                styles: [".activeLayer{background-color:#0003}.cdk-drag-placeholder{background-color:#0000003d;color:#fff}.cdk-drag-preview{box-sizing:border-box;background-color:#b9b9b9bf;border:1px solid #b9b9b9;overflow:hidden;color:transparent;box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f}.cdk-drag-animating{transition:transform .25s cubic-bezier(0,0,.2,1)}.list-group.cdk-drop-list-dragging .list-group-item:not(.cdk-drag-placeholder){transition:transform .25s cubic-bezier(0,0,.2,1)}\n"]
            }]
    }], function () { return [{ type: HsLayerManagerService }, { type: HsLayerUtilsService }, { type: HsEventBusService }, { type: HsLayermanagerPhysicalListService }, { type: HsConfig }]; }, null); })();

class HsLegendLayerComponent {
    constructor(hsUtilsService, hsLegendService, hsStylerService) {
        this.hsUtilsService = hsUtilsService;
        this.hsLegendService = hsLegendService;
        this.hsStylerService = hsStylerService;
        this.styles = [];
        this.geometryTypes = [];
        this.ngUnsubscribe = new Subject();
        this.hsStylerService.onSet
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((_) => {
            this.styles = this.hsLegendService.getStyleVectorLayer(this.layer.lyr);
            this.geometryTypes = this.hsLegendService.getVectorFeatureGeometry(this.layer.lyr);
        });
    }
    ngOnInit() {
        const olLayer = this.layer.lyr;
        if (this.hsUtilsService.instOf(olLayer, VectorLayer)) {
            this.styles = this.hsLegendService.getStyleVectorLayer(olLayer);
            this.geometryTypes =
                this.hsLegendService.getVectorFeatureGeometry(olLayer);
        }
        if (olLayer.getSource()) {
            const source = olLayer.getSource();
            const changeHandler = this.hsUtilsService.debounce((e) => {
                this.styles = this.hsLegendService.getStyleVectorLayer(olLayer);
                this.geometryTypes =
                    this.hsLegendService.getVectorFeatureGeometry(olLayer);
            }, 200, false, this);
            source.on('changefeature', changeHandler);
            source.on('addfeature', changeHandler);
            source.on('removefeature', changeHandler);
        }
    }
    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
}
HsLegendLayerComponent.ɵfac = function HsLegendLayerComponent_Factory(t) { return new (t || HsLegendLayerComponent)(ɵngcc0.ɵɵdirectiveInject(HsUtilsService), ɵngcc0.ɵɵdirectiveInject(HsLegendService), ɵngcc0.ɵɵdirectiveInject(HsStylerService)); };
HsLegendLayerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsLegendLayerComponent, selectors: [["hs-legend-layer-directive"]], inputs: { layer: "layer" }, decls: 5, vars: 4, consts: [[3, "layer-style", "geometry-type", 4, "ngIf"], [4, "ngIf"], [3, "layer", 4, "ngIf"], [3, "layer-style", "geometry-type"], ["onerror", " this.parentNode.removeChild(this); ", "onload", "if(this.height<6) { this.parentNode.removeChild(this); }", 3, "src", 4, "ngFor", "ngForOf"], ["onerror", " this.parentNode.removeChild(this); ", "onload", "if(this.height<6) { this.parentNode.removeChild(this); }", 3, "src"], [4, "ngFor", "ngForOf"], [3, "ngStyle"], [3, "layer"]], template: function HsLegendLayerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵtemplate(1, HsLegendLayerComponent_hs_legend_vector_layer_1_Template, 1, 2, "hs-legend-vector-layer", 0);
        ɵngcc0.ɵɵtemplate(2, HsLegendLayerComponent_div_2_Template, 2, 1, "div", 1);
        ɵngcc0.ɵɵtemplate(3, HsLegendLayerComponent_div_3_Template, 2, 1, "div", 1);
        ɵngcc0.ɵɵtemplate(4, HsLegendLayerComponent_hs_legend_layer_static_4_Template, 1, 1, "hs-legend-layer-static", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.layer.type === "vector" && ctx.layer.autoLegend);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.layer.type === "wms");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.layer.type === "vector");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.layer.type === "static");
    } }, directives: function () { return [ɵngcc3.NgIf, HsLegendLayerVectorComponent, ɵngcc3.NgForOf, ɵngcc3.NgStyle, HsLegendLayerStaticComponent]; }, encapsulation: 2 });
HsLegendLayerComponent.ctorParameters = () => [
    { type: HsUtilsService },
    { type: HsLegendService },
    { type: HsStylerService }
];
HsLegendLayerComponent.propDecorators = {
    layer: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsLegendLayerComponent, [{
        type: Component,
        args: [{
                selector: 'hs-legend-layer-directive',
                template: "<div>\n    <hs-legend-vector-layer *ngIf=\"layer.type === 'vector' && layer.autoLegend\" [layer-style]=\"styles\"\n        [geometry-type]=\"geometryTypes\">\n    </hs-legend-vector-layer>\n    <div *ngIf=\"layer.type === 'wms'\">\n        <img *ngFor=\"let sublayer of layer.subLayerLegends\" [src]=\"sublayer\"\n            onerror=\" this.parentNode.removeChild(this); \"\n            onload=\"if(this.height<6) { this.parentNode.removeChild(this); }\">\n    </div>\n    <div *ngIf=\"layer.type === 'vector'\">\n        <p *ngFor=\"let category of layer.lyr.getSource().legend_categories\"><span\n                [ngStyle]=\"{'background-color': category.color}\">&nbsp;&nbsp;&nbsp;</span>&nbsp;{{category.name}}\n        </p>\n    </div>\n    <hs-legend-layer-static *ngIf=\"layer.type === 'static'\" [layer]=\"layer\"></hs-legend-layer-static>\n</div>"
            }]
    }], function () { return [{ type: HsUtilsService }, { type: HsLegendService }, { type: HsStylerService }]; }, { layer: [{
            type: Input
        }] }); })();

class HsLegendLayerStaticComponent {
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
    }
    fillContent() {
        let legendImage = getLegends(this.layer.lyr);
        if (Array.isArray(legendImage)) {
            legendImage = legendImage[0];
        }
        if (legendImage) {
            this.lastLegendImage = legendImage;
            if (legendImage.indexOf('<svg') > -1) {
                this.legendType = 'svg';
                this.svgContent = this.sanitizer.bypassSecurityTrustHtml(legendImage);
            }
            else {
                this.legendType = 'image';
                this.legendImage =
                    this.sanitizer.bypassSecurityTrustResourceUrl(legendImage);
            }
        }
    }
    ngOnInit() {
        if (getLegends(this.layer.lyr)) {
            this.fillContent();
        }
        this.layer.lyr.on('change', (e) => {
            //TODO: Maybe rewrite this to something more fancy like Observable
            if (getLegends(this.layer.lyr) != this.lastLegendImage) {
                this.fillContent();
            }
        });
    }
}
HsLegendLayerStaticComponent.ɵfac = function HsLegendLayerStaticComponent_Factory(t) { return new (t || HsLegendLayerStaticComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc4.DomSanitizer)); };
HsLegendLayerStaticComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsLegendLayerStaticComponent, selectors: [["hs-legend-layer-static"]], inputs: { layer: "layer" }, decls: 2, vars: 2, consts: [[3, "src", 4, "ngIf"], [3, "innerHtml", 4, "ngIf"], [3, "src"], [3, "innerHtml"]], template: function HsLegendLayerStaticComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, HsLegendLayerStaticComponent_img_0_Template, 1, 1, "img", 0);
        ɵngcc0.ɵɵtemplate(1, HsLegendLayerStaticComponent_div_1_Template, 1, 1, "div", 1);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.legendType === "image");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.legendType === "svg");
    } }, directives: [ɵngcc3.NgIf], encapsulation: 2 });
HsLegendLayerStaticComponent.ctorParameters = () => [
    { type: DomSanitizer }
];
HsLegendLayerStaticComponent.propDecorators = {
    layer: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsLegendLayerStaticComponent, [{
        type: Component,
        args: [{
                selector: 'hs-legend-layer-static',
                template: "<img *ngIf=\"legendType === 'image'\" [src]=\"legendImage\">\n<div *ngIf=\"legendType === 'svg'\" [innerHtml]=\"svgContent\">\n</div>"
            }]
    }], function () { return [{ type: ɵngcc4.DomSanitizer }]; }, { layer: [{
            type: Input
        }] }); })();

class HsLegendLayerVectorComponent {
    constructor() { }
}
HsLegendLayerVectorComponent.ɵfac = function HsLegendLayerVectorComponent_Factory(t) { return new (t || HsLegendLayerVectorComponent)(); };
HsLegendLayerVectorComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsLegendLayerVectorComponent, selectors: [["hs-legend-vector-layer"]], inputs: { layerStyle: ["layer-style", "layerStyle"], geometryType: ["geometry-type", "geometryType"] }, decls: 1, vars: 1, consts: [["class", "row", 4, "ngFor", "ngForOf"], [1, "row"], [1, "col-sm-2"], [4, "ngFor", "ngForOf"], [1, "col-sm-10"], [4, "ngIf"], [3, "ngStyle", "src"], [3, "ngStyle"], ["points", "5,30 8,5 25,5 30,30", 3, "ngStyle"], ["x1", "0", "y1", "20", "x2", "35", "y2", "20", 3, "ngStyle"]], template: function HsLegendLayerVectorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, HsLegendLayerVectorComponent_div_0_Template, 5, 2, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngForOf", ctx.geometryType);
    } }, directives: [ɵngcc3.NgForOf, ɵngcc3.NgIf, ɵngcc3.NgStyle], encapsulation: 2 });
HsLegendLayerVectorComponent.ctorParameters = () => [];
HsLegendLayerVectorComponent.propDecorators = {
    layerStyle: [{ type: Input, args: ['layer-style',] }],
    geometryType: [{ type: Input, args: ['geometry-type',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsLegendLayerVectorComponent, [{
        type: Component,
        args: [{
                selector: 'hs-legend-vector-layer',
                template: "<div class=\"row\" *ngFor=\"let geometry of geometryType\">\n    <div class=\"col-sm-2\">\n        <div *ngFor=\"let style of layerStyle\">\n            <div *ngIf=\"style.icon && geometry === 'point'\">\n                <img [ngStyle]=\"style.style\" [src]=\"style.icon.src\" />\n            </div>\n            <div *ngIf=\"style.defaultCircle && geometry === 'point'\">\n                <svg [ngStyle]=\"style.style\">\n                    <circle [ngStyle]=\"style.defaultCircle\"></circle>\n                </svg>\n            </div>\n            <div *ngIf=\"style.customCircle && geometry === 'point'\">\n                <svg [ngStyle]=\"style.style\">\n                    <circle [ngStyle]=\"style.customCircle\"></circle>\n                </svg>\n            </div>\n            <div *ngIf=\"style.defaultPolygon && geometry === 'polygon'\">\n                <svg [ngStyle]=\"style.style\">\n                    <polygon points=\"5,30 8,5 25,5 30,30\" [ngStyle]=\"style.defaultPolygon\"></polygon>\n                </svg>\n            </div>\n            <div *ngIf=\"style.fullPolygon && geometry === 'polygon'\">\n                <svg [ngStyle]=\"style.style\">\n                    <polygon points=\"5,30 8,5 25,5 30,30\" [ngStyle]=\"style.fullPolygon\"></polygon>\n                </svg>\n            </div>\n            <div *ngIf=\"style.polygon && geometry === 'polygon'\">\n                <svg [ngStyle]=\"style.style\">\n                    <polygon points=\"5,30 8,5 25,5 30,30\" [ngStyle]=\"style.polygon\"></polygon>\n                </svg>\n            </div>\n            <div *ngIf=\"style.defaultLine && geometry === 'line'\">\n                <svg [ngStyle]=\"style.style\">\n                    <line x1=\"0\" y1=\"20\" x2=\"35\" y2=\"20\" [ngStyle]=\"style.defaultLine\"></line>\n                </svg>\n            </div>\n            <div *ngIf=\"style.line && geometry === 'line'\">\n                <svg [ngStyle]=\"style.style\">\n                    <line x1=\"0\" y1=\"20\" x2=\"35\" y2=\"20\" [ngStyle]=\"style.line\"></line>\n                </svg>\n            </div>\n        </div>\n    </div>\n    <div class=\"col-sm-10\">\n        {{geometry}}\n    </div>\n</div>"
            }]
    }], function () { return []; }, { layerStyle: [{
            type: Input,
            args: ['layer-style']
        }], geometryType: [{
            type: Input,
            args: ['geometry-type']
        }] }); })();

//TODO: Is this module declaration needed at all?
class HsQueuesModule {
}
HsQueuesModule.ɵfac = function HsQueuesModule_Factory(t) { return new (t || HsQueuesModule)(); };
HsQueuesModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: HsQueuesModule });
HsQueuesModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsQueuesModule, [{
        type: NgModule,
        args: [{
                declarations: [],
                imports: [],
                bootstrap: []
            }]
    }], null, null); })();

class HsLegendModule {
}
HsLegendModule.ɵfac = function HsLegendModule_Factory(t) { return new (t || HsLegendModule)(); };
HsLegendModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: HsLegendModule });
HsLegendModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule,
            HsPanelHelpersModule,
            HsUiExtensionsModule,
            TranslateModule,
            HsQueuesModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsLegendModule, [{
        type: NgModule,
        args: [{
                schemas: [CUSTOM_ELEMENTS_SCHEMA],
                declarations: [
                    HsLegendComponent,
                    HsLegendLayerComponent,
                    HsLegendLayerVectorComponent,
                    HsLegendLayerStaticComponent,
                ],
                imports: [
                    CommonModule,
                    FormsModule,
                    HsPanelHelpersModule,
                    HsUiExtensionsModule,
                    TranslateModule,
                    HsQueuesModule,
                ],
                exports: [HsLegendComponent, HsLegendLayerComponent],
                entryComponents: [HsLegendComponent, HsLegendLayerComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(HsLegendModule, { declarations: function () { return [HsLegendComponent, HsLegendLayerComponent, HsLegendLayerVectorComponent, HsLegendLayerStaticComponent]; }, imports: function () { return [CommonModule,
        FormsModule, HsPanelHelpersModule, HsUiExtensionsModule, TranslateModule, HsQueuesModule]; }, exports: function () { return [HsLegendComponent, HsLegendLayerComponent]; } }); })();

class HsLayerManagerModule {
}
HsLayerManagerModule.ɵfac = function HsLayerManagerModule_Factory(t) { return new (t || HsLayerManagerModule)(); };
HsLayerManagerModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: HsLayerManagerModule });
HsLayerManagerModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            TranslateModule,
            CommonModule,
            FormsModule,
            HsGetCapabilitiesModule,
            HsPanelHelpersModule,
            HsLegendModule,
            HsUiExtensionsModule,
            NgbModule,
            DragDropModule,
            HsQueuesModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsLayerManagerModule, [{
        type: NgModule,
        args: [{
                schemas: [CUSTOM_ELEMENTS_SCHEMA],
                declarations: [
                    HsLayerManagerComponent,
                    HsLayerEditorDimensionsComponent,
                    HsLayerEditorSubLayerCheckboxesComponent,
                    HsLayerManagerGalleryComponent,
                    HsLayerEditorComponent,
                    HsLayerManagerFolderComponent,
                    HsLayerListComponent,
                    HsLayerManagerRemoveAllDialogComponent,
                    HsLayerManagerRemoveLayerDialogComponent,
                    HsLayerManagerTimeEditorComponent,
                    HsLayerPhysicalListComponent,
                ],
                imports: [
                    TranslateModule,
                    CommonModule,
                    FormsModule,
                    HsGetCapabilitiesModule,
                    HsPanelHelpersModule,
                    HsLegendModule,
                    HsUiExtensionsModule,
                    NgbModule,
                    DragDropModule,
                    HsQueuesModule,
                ],
                exports: [
                    HsLayerManagerComponent,
                    HsLayerEditorDimensionsComponent,
                    HsLayerEditorSubLayerCheckboxesComponent,
                    HsLayerManagerGalleryComponent,
                    HsLayerEditorComponent,
                    HsLayerManagerFolderComponent,
                    HsLayerListComponent,
                    HsLayerManagerRemoveAllDialogComponent,
                    HsLayerManagerRemoveLayerDialogComponent,
                    HsLayerManagerTimeEditorComponent,
                    HsLayerPhysicalListComponent,
                ],
                entryComponents: [
                    HsLayerManagerComponent,
                    HsLayerEditorDimensionsComponent,
                    HsLayerEditorSubLayerCheckboxesComponent,
                    HsLayerManagerGalleryComponent,
                    HsLayerManagerFolderComponent,
                    HsLayerListComponent,
                    HsLayerManagerRemoveAllDialogComponent,
                    HsLayerManagerRemoveLayerDialogComponent,
                    HsLayerManagerTimeEditorComponent,
                    HsLayerPhysicalListComponent,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(HsLayerManagerModule, { declarations: function () { return [HsLayerManagerComponent, HsLayerEditorDimensionsComponent, HsLayerEditorSubLayerCheckboxesComponent, HsLayerManagerGalleryComponent, HsLayerEditorComponent, HsLayerManagerFolderComponent, HsLayerListComponent, HsLayerManagerRemoveAllDialogComponent, HsLayerManagerRemoveLayerDialogComponent, HsLayerManagerTimeEditorComponent, HsLayerPhysicalListComponent]; }, imports: function () { return [TranslateModule,
        CommonModule,
        FormsModule, HsGetCapabilitiesModule, HsPanelHelpersModule, HsLegendModule, HsUiExtensionsModule, NgbModule,
        DragDropModule, HsQueuesModule]; }, exports: function () { return [HsLayerManagerComponent, HsLayerEditorDimensionsComponent, HsLayerEditorSubLayerCheckboxesComponent, HsLayerManagerGalleryComponent, HsLayerEditorComponent, HsLayerManagerFolderComponent, HsLayerListComponent, HsLayerManagerRemoveAllDialogComponent, HsLayerManagerRemoveLayerDialogComponent, HsLayerManagerTimeEditorComponent, HsLayerPhysicalListComponent]; } }); })();

class HsMeasureModule {
}
HsMeasureModule.ɵfac = function HsMeasureModule_Factory(t) { return new (t || HsMeasureModule)(); };
HsMeasureModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: HsMeasureModule });
HsMeasureModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule,
            HsPanelHelpersModule,
            NgbModule,
            TranslateModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsMeasureModule, [{
        type: NgModule,
        args: [{
                schemas: [CUSTOM_ELEMENTS_SCHEMA],
                declarations: [HsMeasureComponent, HsMeasureToolbarComponent],
                imports: [
                    CommonModule,
                    FormsModule,
                    HsPanelHelpersModule,
                    NgbModule,
                    TranslateModule,
                ],
                exports: [HsMeasureComponent, HsMeasureToolbarComponent],
                entryComponents: [HsMeasureComponent, HsMeasureToolbarComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(HsMeasureModule, { declarations: function () { return [HsMeasureComponent, HsMeasureToolbarComponent]; }, imports: function () { return [CommonModule,
        FormsModule, HsPanelHelpersModule, NgbModule,
        TranslateModule]; }, exports: function () { return [HsMeasureComponent, HsMeasureToolbarComponent]; } }); })();

/**
 * Add print dialog template to the app
 */
class HsPrintModule {
}
HsPrintModule.ɵfac = function HsPrintModule_Factory(t) { return new (t || HsPrintModule)(); };
HsPrintModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: HsPrintModule });
HsPrintModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, FormsModule, HsPanelHelpersModule, TranslateModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsPrintModule, [{
        type: NgModule,
        args: [{
                schemas: [CUSTOM_ELEMENTS_SCHEMA],
                declarations: [HsPrintComponent],
                imports: [CommonModule, FormsModule, HsPanelHelpersModule, TranslateModule],
                exports: [HsPrintComponent],
                entryComponents: [HsPrintComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(HsPrintModule, { declarations: function () { return [HsPrintComponent]; }, imports: function () { return [CommonModule, FormsModule, HsPanelHelpersModule, TranslateModule]; }, exports: function () { return [HsPrintComponent]; } }); })();

class HsSaveMapAdvancedFormComponent {
    constructor(HsSaveMapManagerService, HsEventBusService, HsCoreService, HsUtilsService, HsLayerUtilsService //Used in template
    ) {
        this.HsSaveMapManagerService = HsSaveMapManagerService;
        this.HsEventBusService = HsEventBusService;
        this.HsCoreService = HsCoreService;
        this.HsUtilsService = HsUtilsService;
        this.HsLayerUtilsService = HsLayerUtilsService;
        this.btnSelectDeselectClicked = true;
        this.step = 'context';
        this.steps = ['context', 'access', 'author'];
        this.overwrite = false;
        this.ngUnsubscribe = new Subject();
        this.HsEventBusService.mapResets
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(() => {
            this.step = 'context';
        });
        this.HsEventBusService.mainPanelChanges
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((which) => {
            if (which == 'saveMap') {
                this.step = 'context';
            }
        });
        this.HsSaveMapManagerService.endpointSelected
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((endpoint) => {
            this.endpoint = endpoint;
            switch (endpoint === null || endpoint === void 0 ? void 0 : endpoint.type) {
                case 'layman':
                    this.steps = ['context', 'author'];
                    break;
                default:
                    this.steps = ['context', 'access', 'author'];
            }
        });
        this.HsSaveMapManagerService.saveMapResulted
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((statusData) => {
            if (statusData.status || statusData == 'rename') {
                this.step = 'context';
            }
            if (statusData.overWriteNeeded) {
                this.overwrite = true;
            }
        });
    }
    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
    saveCompoJson() {
        const compositionJSON = this.HsSaveMapManagerService.generateCompositionJson();
        const file = new Blob([JSON.stringify(compositionJSON)], {
            type: 'application/json',
        });
        const a = document.getElementById('stc-download'), url = URL.createObjectURL(file);
        a.href = url;
        a.download = 'composition';
        setTimeout(() => {
            window.URL.revokeObjectURL(url);
        }, 0);
    }
    selectDeselectAllLayers() {
        this.btnSelectDeselectClicked = !this.btnSelectDeselectClicked;
        this.HsSaveMapManagerService.compoData.layers.forEach((layer) => (layer.checked = this.btnSelectDeselectClicked));
    }
    /**
     * Callback function for clicking Next button, create download link for map context and show save, saveas buttons
     */
    next() {
        const ixCurrent = this.steps.indexOf(this.step);
        if (this.steps.length > ixCurrent + 1) {
            this.step = this.steps[ixCurrent + 1];
        }
        else {
            this.step = 'end';
        }
    }
    setStep(step) {
        this.step = step;
    }
    capitalizeFirstLetter(string) {
        return this.HsUtilsService.capitalizeFirstLetter(string);
    }
    titleChanged() {
        this.overwrite = false;
    }
    isAllowed() {
        if (this.endpoint === null) {
            return false;
        }
        if (this.endpoint.type == 'statusmanager') {
            return !this.HsCoreService.isAuthorized();
        }
        else if (this.endpoint.type == 'layman') {
            return true;
        }
    }
}
HsSaveMapAdvancedFormComponent.ɵfac = function HsSaveMapAdvancedFormComponent_Factory(t) { return new (t || HsSaveMapAdvancedFormComponent)(ɵngcc0.ɵɵdirectiveInject(HsSaveMapManagerService), ɵngcc0.ɵɵdirectiveInject(HsEventBusService), ɵngcc0.ɵɵdirectiveInject(HsCoreService), ɵngcc0.ɵɵdirectiveInject(HsUtilsService), ɵngcc0.ɵɵdirectiveInject(HsLayerUtilsService)); };
HsSaveMapAdvancedFormComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsSaveMapAdvancedFormComponent, selectors: [["hs-save-map-advanced-form"]], decls: 114, vars: 130, consts: [["role", "tablist", 1, "nav", "flex-column", "flex-sm-row", "stc-tabs"], ["role", "presentation", "class", "nav-item", 4, "ngFor", "ngForOf"], [1, "tab-content"], ["role", "tabpanel", "id", "hs-context", 1, "tab-pane", 3, "ngClass"], [1, "form-group"], ["type", "text", "name", "hs-save-map-title", 1, "form-control", 3, "ngModel", "ngModelChange", "change"], ["type", "text", "name", "hs-save-map-name", 1, "form-control", 3, "ngModel", "ngModelChange", "change"], ["name", "hs-save-map-abstract", 1, "form-control", 3, "ngModel", "ngModelChange"], ["type", "text", "name", "hs-save-map-keywords", 1, "form-control", 3, "ngModel", "ngModelChange"], [3, "access_rights", "access_rightsChange"], ["for", "stc-extent1", 1, "form-group"], ["class", "form-row stc-extent-row", 4, "ngIf"], ["type", "button", 1, "mt-1", "btn", "btn-secondary", "btn-block", 3, "click"], ["id", "stc-layerlist", 1, "list-group"], ["style", "padding: 3px", "class", "list-group-item", 4, "ngFor", "ngForOf"], [1, "list-group-item", 2, "padding", "3px"], [1, "d-flex", "w-100", "justify-content-center"], ["type", "button", 1, "mt-1", "btn", "btn-primary", 3, "click"], ["role", "tabpanel", "id", "hs-access", 1, "tab-pane", 3, "ngClass"], [1, "table", "table-condensed"], [4, "ngFor", "ngForOf"], ["role", "tabpanel", "id", "hs-author", 1, "tab-pane", 3, "ngClass"], ["type", "text", 1, "form-control", 3, "ngModel", "ngModelOptions", "ngModelChange"], [1, "modal-footer", "w-100"], [3, "hidden"], [1, "alert", "alert-info", "text-gray"], ["type", "button", "id", "stc-save", 1, "btn", "btn-block", "btn-primary", 3, "click"], [1, "m-1", 2, "text-align", "center"], ["type", "button", "id", "stc-saveas", 1, "btn", "btn-block", "btn-primary", 3, "hidden", "click"], ["type", "button", "id", "stc-next", 1, "btn", "btn-block", "btn-primary", "btn-block", 3, "hidden", "click"], ["id", "stc-download", 1, "btn", "btn-block", "btn-secondary", 3, "hidden", "click"], ["role", "presentation", 1, "nav-item"], ["role", "tab", "data-toggle", "tab", 1, "nav-link", 3, "ngClass", "click"], [1, "form-row", "stc-extent-row"], [1, "col-sm-3", "px-0"], ["type", "text", 1, "form-control", 3, "ngModelOptions", "ngModel", "title", "ngModelChange"], [1, "form-check"], ["type", "checkbox", 1, "form-check-input", 3, "ngModelOptions", "ngModel", "ngModelChange"], [1, "form-check-label"], ["type", "checkbox", 1, "form-control", 3, "ngModel", "ngModelOptions", "ngModelChange"]], template: function HsSaveMapAdvancedFormComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "ul", 0);
        ɵngcc0.ɵɵtemplate(1, HsSaveMapAdvancedFormComponent_li_1_Template, 3, 5, "li", 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelementStart(4, "form");
        ɵngcc0.ɵɵelementStart(5, "label", 4);
        ɵngcc0.ɵɵtext(6);
        ɵngcc0.ɵɵpipe(7, "translate");
        ɵngcc0.ɵɵelementStart(8, "input", 5);
        ɵngcc0.ɵɵlistener("ngModelChange", function HsSaveMapAdvancedFormComponent_Template_input_ngModelChange_8_listener($event) { return ctx.HsSaveMapManagerService.compoData.title = $event; })("change", function HsSaveMapAdvancedFormComponent_Template_input_change_8_listener() { return ctx.titleChanged(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "label", 4);
        ɵngcc0.ɵɵtext(10);
        ɵngcc0.ɵɵpipe(11, "translate");
        ɵngcc0.ɵɵelementStart(12, "input", 6);
        ɵngcc0.ɵɵlistener("ngModelChange", function HsSaveMapAdvancedFormComponent_Template_input_ngModelChange_12_listener($event) { return ctx.HsSaveMapManagerService.compoData.name = $event; })("change", function HsSaveMapAdvancedFormComponent_Template_input_change_12_listener() { return ctx.titleChanged(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(13, "label", 4);
        ɵngcc0.ɵɵtext(14);
        ɵngcc0.ɵɵpipe(15, "translate");
        ɵngcc0.ɵɵelementStart(16, "textarea", 7);
        ɵngcc0.ɵɵlistener("ngModelChange", function HsSaveMapAdvancedFormComponent_Template_textarea_ngModelChange_16_listener($event) { return ctx.HsSaveMapManagerService.compoData.abstract = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(17, "label", 4);
        ɵngcc0.ɵɵtext(18);
        ɵngcc0.ɵɵpipe(19, "translate");
        ɵngcc0.ɵɵelementStart(20, "input", 8);
        ɵngcc0.ɵɵlistener("ngModelChange", function HsSaveMapAdvancedFormComponent_Template_input_ngModelChange_20_listener($event) { return ctx.HsSaveMapManagerService.compoData.keywords = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(21, "hs-layman-access-rights", 9);
        ɵngcc0.ɵɵlistener("access_rightsChange", function HsSaveMapAdvancedFormComponent_Template_hs_layman_access_rights_access_rightsChange_21_listener($event) { return ctx.HsSaveMapManagerService.compoData.access_rights = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(22, "div", 4);
        ɵngcc0.ɵɵelementStart(23, "label", 10);
        ɵngcc0.ɵɵtext(24);
        ɵngcc0.ɵɵpipe(25, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(26, HsSaveMapAdvancedFormComponent_div_26_Template, 13, 24, "div", 11);
        ɵngcc0.ɵɵelementStart(27, "button", 12);
        ɵngcc0.ɵɵlistener("click", function HsSaveMapAdvancedFormComponent_Template_button_click_27_listener() { return ctx.HsSaveMapManagerService.setCurrentBoundingBox(); });
        ɵngcc0.ɵɵtext(28);
        ɵngcc0.ɵɵpipe(29, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(30, "div", 4);
        ɵngcc0.ɵɵelementStart(31, "ul", 13);
        ɵngcc0.ɵɵtemplate(32, HsSaveMapAdvancedFormComponent_li_32_Template, 5, 4, "li", 14);
        ɵngcc0.ɵɵelementStart(33, "li", 15);
        ɵngcc0.ɵɵelementStart(34, "div", 16);
        ɵngcc0.ɵɵelementStart(35, "button", 17);
        ɵngcc0.ɵɵlistener("click", function HsSaveMapAdvancedFormComponent_Template_button_click_35_listener() { return ctx.selectDeselectAllLayers(); });
        ɵngcc0.ɵɵtext(36);
        ɵngcc0.ɵɵpipe(37, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(38, "div", 18);
        ɵngcc0.ɵɵelementStart(39, "table", 19);
        ɵngcc0.ɵɵelementStart(40, "tbody");
        ɵngcc0.ɵɵelementStart(41, "tr");
        ɵngcc0.ɵɵelement(42, "th");
        ɵngcc0.ɵɵelementStart(43, "th");
        ɵngcc0.ɵɵtext(44);
        ɵngcc0.ɵɵpipe(45, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(46, "th");
        ɵngcc0.ɵɵtext(47);
        ɵngcc0.ɵɵpipe(48, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(49, HsSaveMapAdvancedFormComponent_tr_49_Template, 7, 7, "tr", 20);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(50, "div", 21);
        ɵngcc0.ɵɵelementStart(51, "label", 4);
        ɵngcc0.ɵɵtext(52);
        ɵngcc0.ɵɵpipe(53, "translate");
        ɵngcc0.ɵɵelementStart(54, "input", 22);
        ɵngcc0.ɵɵlistener("ngModelChange", function HsSaveMapAdvancedFormComponent_Template_input_ngModelChange_54_listener($event) { return ctx.HsSaveMapManagerService.userData.name = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(55, "label", 4);
        ɵngcc0.ɵɵtext(56);
        ɵngcc0.ɵɵpipe(57, "translate");
        ɵngcc0.ɵɵelementStart(58, "input", 22);
        ɵngcc0.ɵɵlistener("ngModelChange", function HsSaveMapAdvancedFormComponent_Template_input_ngModelChange_58_listener($event) { return ctx.HsSaveMapManagerService.userData.organization = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(59, "label", 4);
        ɵngcc0.ɵɵtext(60);
        ɵngcc0.ɵɵpipe(61, "translate");
        ɵngcc0.ɵɵelementStart(62, "input", 22);
        ɵngcc0.ɵɵlistener("ngModelChange", function HsSaveMapAdvancedFormComponent_Template_input_ngModelChange_62_listener($event) { return ctx.HsSaveMapManagerService.userData.position = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(63, "label", 4);
        ɵngcc0.ɵɵtext(64);
        ɵngcc0.ɵɵpipe(65, "translate");
        ɵngcc0.ɵɵelementStart(66, "input", 22);
        ɵngcc0.ɵɵlistener("ngModelChange", function HsSaveMapAdvancedFormComponent_Template_input_ngModelChange_66_listener($event) { return ctx.HsSaveMapManagerService.userData.address = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(67, "label", 4);
        ɵngcc0.ɵɵtext(68);
        ɵngcc0.ɵɵpipe(69, "translate");
        ɵngcc0.ɵɵelementStart(70, "input", 22);
        ɵngcc0.ɵɵlistener("ngModelChange", function HsSaveMapAdvancedFormComponent_Template_input_ngModelChange_70_listener($event) { return ctx.HsSaveMapManagerService.userData.city = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(71, "label", 4);
        ɵngcc0.ɵɵtext(72);
        ɵngcc0.ɵɵpipe(73, "translate");
        ɵngcc0.ɵɵelementStart(74, "input", 22);
        ɵngcc0.ɵɵlistener("ngModelChange", function HsSaveMapAdvancedFormComponent_Template_input_ngModelChange_74_listener($event) { return ctx.HsSaveMapManagerService.userData.state = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(75, "label", 4);
        ɵngcc0.ɵɵtext(76);
        ɵngcc0.ɵɵpipe(77, "translate");
        ɵngcc0.ɵɵelementStart(78, "input", 22);
        ɵngcc0.ɵɵlistener("ngModelChange", function HsSaveMapAdvancedFormComponent_Template_input_ngModelChange_78_listener($event) { return ctx.HsSaveMapManagerService.userData.postalcode = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(79, "label", 4);
        ɵngcc0.ɵɵtext(80);
        ɵngcc0.ɵɵpipe(81, "translate");
        ɵngcc0.ɵɵelementStart(82, "input", 22);
        ɵngcc0.ɵɵlistener("ngModelChange", function HsSaveMapAdvancedFormComponent_Template_input_ngModelChange_82_listener($event) { return ctx.HsSaveMapManagerService.userData.country = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(83, "label", 4);
        ɵngcc0.ɵɵtext(84);
        ɵngcc0.ɵɵpipe(85, "translate");
        ɵngcc0.ɵɵelementStart(86, "input", 22);
        ɵngcc0.ɵɵlistener("ngModelChange", function HsSaveMapAdvancedFormComponent_Template_input_ngModelChange_86_listener($event) { return ctx.HsSaveMapManagerService.userData.phone = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(87, "label", 4);
        ɵngcc0.ɵɵtext(88);
        ɵngcc0.ɵɵpipe(89, "translate");
        ɵngcc0.ɵɵelementStart(90, "input", 22);
        ɵngcc0.ɵɵlistener("ngModelChange", function HsSaveMapAdvancedFormComponent_Template_input_ngModelChange_90_listener($event) { return ctx.HsSaveMapManagerService.userData.email = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(91, "label", 4);
        ɵngcc0.ɵɵtext(92, "WWW ");
        ɵngcc0.ɵɵelementStart(93, "input", 22);
        ɵngcc0.ɵɵlistener("ngModelChange", function HsSaveMapAdvancedFormComponent_Template_input_ngModelChange_93_listener($event) { return ctx.HsSaveMapManagerService.userData.url = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(94, "div", 23);
        ɵngcc0.ɵɵelementStart(95, "div", 24);
        ɵngcc0.ɵɵelementStart(96, "div", 25);
        ɵngcc0.ɵɵtext(97);
        ɵngcc0.ɵɵpipe(98, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(99, "button", 26);
        ɵngcc0.ɵɵlistener("click", function HsSaveMapAdvancedFormComponent_Template_button_click_99_listener() { return ctx.HsSaveMapManagerService.initiateSave(false); });
        ɵngcc0.ɵɵtext(100);
        ɵngcc0.ɵɵpipe(101, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(102, "p", 27);
        ɵngcc0.ɵɵtext(103);
        ɵngcc0.ɵɵpipe(104, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(105, "button", 28);
        ɵngcc0.ɵɵlistener("click", function HsSaveMapAdvancedFormComponent_Template_button_click_105_listener() { return ctx.HsSaveMapManagerService.initiateSave(true); });
        ɵngcc0.ɵɵtext(106);
        ɵngcc0.ɵɵpipe(107, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(108, "button", 29);
        ɵngcc0.ɵɵlistener("click", function HsSaveMapAdvancedFormComponent_Template_button_click_108_listener() { return ctx.next(); });
        ɵngcc0.ɵɵtext(109);
        ɵngcc0.ɵɵpipe(110, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(111, "a", 30);
        ɵngcc0.ɵɵlistener("click", function HsSaveMapAdvancedFormComponent_Template_a_click_111_listener() { return ctx.saveCompoJson(); });
        ɵngcc0.ɵɵtext(112);
        ɵngcc0.ɵɵpipe(113, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.steps);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(113, _c12, ctx.step === "context"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(7, 63, "COMMON.title"), " * ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngModel", ctx.HsSaveMapManagerService.compoData.title);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(11, 65, "COMMON.name"), " * ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngModel", ctx.HsSaveMapManagerService.compoData.name);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(15, 67, "COMMON.abstract"), " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngModel", ctx.HsSaveMapManagerService.compoData.abstract);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(19, 69, "COMMON.keywords"), " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngModel", ctx.HsSaveMapManagerService.compoData.keywords);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("access_rights", ctx.HsSaveMapManagerService.compoData.access_rights);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(25, 71, "COMMON.extent"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.HsSaveMapManagerService.compoData.bbox);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(29, 73, "SAVECOMPOSITION.form.userCurrentMapExtent"));
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.HsSaveMapManagerService.compoData.layers);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(37, 75, "SAVECOMPOSITION.form.toggleAll"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(115, _c12, ctx.step === "access"));
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(45, 77, "SAVECOMPOSITION.form.read"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(48, 79, "SAVECOMPOSITION.form.write"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.HsSaveMapManagerService.statusData.groups);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(117, _c12, ctx.step === "author"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(53, 81, "SAVECOMPOSITION.form.person"), " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngModel", ctx.HsSaveMapManagerService.userData.name)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(119, _c2));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(57, 83, "SAVECOMPOSITION.form.organization"), " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngModel", ctx.HsSaveMapManagerService.userData.organization)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(120, _c2));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(61, 85, "SAVECOMPOSITION.form.position"), " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngModel", ctx.HsSaveMapManagerService.userData.position)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(121, _c2));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(65, 87, "SAVECOMPOSITION.form.address"), " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngModel", ctx.HsSaveMapManagerService.userData.address)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(122, _c2));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(69, 89, "SAVECOMPOSITION.form.city"), " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngModel", ctx.HsSaveMapManagerService.userData.city)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(123, _c2));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(73, 91, "SAVECOMPOSITION.form.state"), " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngModel", ctx.HsSaveMapManagerService.userData.state)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(124, _c2));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(77, 93, "SAVECOMPOSITION.form.postalCode"), " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngModel", ctx.HsSaveMapManagerService.userData.postalcode)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(125, _c2));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(81, 95, "SAVECOMPOSITION.form.country"), " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngModel", ctx.HsSaveMapManagerService.userData.country)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(126, _c2));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(85, 97, "SAVECOMPOSITION.form.phone"), " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngModel", ctx.HsSaveMapManagerService.userData.phone)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(127, _c2));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(89, 99, "SAVECOMPOSITION.form.email"), " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngModel", ctx.HsSaveMapManagerService.userData.email)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(128, _c2));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngModel", ctx.HsSaveMapManagerService.userData.url)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(129, _c2));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("hidden", !(ctx.step === "end" && ctx.HsSaveMapManagerService.currentUser !== ctx.HsSaveMapManagerService.compoData.workspace && ctx.HsSaveMapManagerService.compoData.workspace));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(98, 101, "SAVECOMPOSITION.saveOrOverwrite"), " ");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(101, 103, "SAVECOMPOSITION.form.overwrite"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(104, 105, "COMMON.or"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("hidden", !(ctx.step === "end" && ctx.isAllowed()));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(107, 107, "COMMON.save"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("hidden", !(ctx.step !== "end"));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(110, 109, "COMMON.next"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("hidden", !(ctx.step === "end"));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(113, 111, "COMMON.download"));
    } }, directives: [ɵngcc3.NgForOf, ɵngcc3.NgClass, ɵngcc5.ɵNgNoValidate, ɵngcc5.NgControlStatusGroup, ɵngcc5.NgForm, ɵngcc5.DefaultValueAccessor, ɵngcc5.NgControlStatus, ɵngcc5.NgModel, HsCommonLaymanAccessRightsComponent, ɵngcc3.NgIf, ɵngcc5.CheckboxControlValueAccessor], pipes: [ɵngcc1.TranslatePipe], encapsulation: 2 });
HsSaveMapAdvancedFormComponent.ctorParameters = () => [
    { type: HsSaveMapManagerService },
    { type: HsEventBusService },
    { type: HsCoreService },
    { type: HsUtilsService },
    { type: HsLayerUtilsService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsSaveMapAdvancedFormComponent, [{
        type: Component,
        args: [{
                selector: 'hs-save-map-advanced-form',
                template: "<!-- Nav tabs -->\n<ul class=\"nav flex-column flex-sm-row stc-tabs\" role=\"tablist\">\n    <li role=\"presentation\" class=\"nav-item\" *ngFor=\"let s of steps\">\n        <a class=\"nav-link\" [ngClass]=\"{'btn-primary': step === s}\" attr.aria-controls=\"hs-{{s}}\" role=\"tab\"\n            data-toggle=\"tab\" (click)=\"setStep(s)\">{{capitalizeFirstLetter(s)}}</a>\n    </li>\n</ul><!-- Tab panes -->\n<div class=\"tab-content\">\n    <div role=\"tabpanel\" class=\"tab-pane\" [ngClass]=\"{'active': step ==='context'}\" id=\"hs-context\">\n        <form>\n            <label class=\"form-group\">\n                {{'COMMON.title' | translate}} *\n                <input type=\"text\" class=\"form-control\" name=\"hs-save-map-title\"\n                    [(ngModel)]=\"HsSaveMapManagerService.compoData.title\" (change)=\"titleChanged()\">\n            </label>\n            <label class=\"form-group\">\n                {{'COMMON.name' | translate}} *\n                <input type=\"text\" class=\"form-control\" name=\"hs-save-map-name\"\n                    [(ngModel)]=\"HsSaveMapManagerService.compoData.name\" (change)=\"titleChanged()\">\n            </label>\n\n            <label class=\"form-group\">\n                {{'COMMON.abstract' | translate}}\n                <textarea class=\"form-control\" name=\"hs-save-map-abstract\"\n                    [(ngModel)]=\"HsSaveMapManagerService.compoData.abstract\"></textarea>\n            </label>\n\n            <label class=\"form-group\">\n                {{'COMMON.keywords' | translate}}\n                <input type=\"text\" class=\"form-control\" name=\"hs-save-map-keywords\"\n                    [(ngModel)]=\"HsSaveMapManagerService.compoData.keywords\">\n            </label>\n            <hs-layman-access-rights [(access_rights)]=\"HsSaveMapManagerService.compoData.access_rights\"></hs-layman-access-rights>\n            <div class=\"form-group\">\n                <label for=\"stc-extent1\" class=\"form-group\">{{'COMMON.extent' | translate}}</label>\n                <div class=\"form-row stc-extent-row\" *ngIf=\"HsSaveMapManagerService.compoData.bbox\">\n                    <div class=\"col-sm-3 px-0\">\n                        <input type=\"text\" class=\"form-control\" [ngModelOptions]=\"{standalone: true}\"\n                            [(ngModel)]=\"HsSaveMapManagerService.compoData.bbox.east\"\n                            [title]=\"'COMMON.east' | translate\">\n                    </div>\n                    <div class=\"col-sm-3 px-0\">\n                        <input type=\"text\" class=\"form-control\" [ngModelOptions]=\"{standalone: true}\"\n                            [(ngModel)]=\"HsSaveMapManagerService.compoData.bbox.south\"\n                            [title]=\"'COMMON.south' | translate\">\n                    </div>\n                    <div class=\"col-sm-3 px-0\">\n                        <input type=\"text\" class=\"form-control\" [ngModelOptions]=\"{standalone: true}\"\n                            [(ngModel)]=\"HsSaveMapManagerService.compoData.bbox.west\"\n                            [title]=\"'COMMON.west' | translate\">\n                    </div>\n                    <div class=\"col-sm-3 px-0\">\n                        <input type=\"text\" class=\"form-control\" [ngModelOptions]=\"{standalone: true}\"\n                            [(ngModel)]=\"HsSaveMapManagerService.compoData.bbox.north\"\n                            [title]=\"'COMMON.north' | translate\">\n                    </div>\n                </div>\n                <button type=\"button\" class=\"mt-1 btn btn-secondary btn-block\"\n                    (click)=\"HsSaveMapManagerService.setCurrentBoundingBox()\">{{'SAVECOMPOSITION.form.userCurrentMapExtent'\n                    | translate}}</button>\n            </div>\n            <div class=\"form-group\">\n                <ul class=\"list-group\" id=\"stc-layerlist\">\n                    <li *ngFor=\"let layer of HsSaveMapManagerService.compoData.layers\" style=\"padding: 3px\"\n                        class=\"list-group-item\">\n                        <div class=\"form-check\">\n                            <input type=\"checkbox\" class=\"form-check-input\" [ngModelOptions]=\"{standalone: true}\"\n                                [(ngModel)]=\"layer.checked\">\n                            <label class=\"form-check-label\">{{HsLayerUtilsService.translateTitle(layer.title)}}</label>\n                        </div>\n                    </li>\n                    <li class=\"list-group-item\" style=\"padding: 3px\">\n                        <div class=\"d-flex w-100 justify-content-center\">\n                            <button type=\"button\" class=\"mt-1 btn btn-primary\"\n                                (click)=\"selectDeselectAllLayers()\">{{'SAVECOMPOSITION.form.toggleAll' | translate}}</button>\n                        </div>\n                    </li>\n                </ul>\n            </div>\n        </form>\n    </div>\n    <div role=\"tabpanel\" class=\"tab-pane\" [ngClass]=\"{'active': step ==='access'}\" id=\"hs-access\">\n        <table class=\"table table-condensed\">\n            <tbody>\n                <tr>\n                    <th></th>\n                    <th>{{'SAVECOMPOSITION.form.read' | translate}}</th>\n                    <th>{{'SAVECOMPOSITION.form.write' | translate}}</th>\n                </tr>\n                <tr *ngFor=\"let g of HsSaveMapManagerService.statusData.groups\">\n                    <td>{{g.roleTitle || g.roleName}}:</td>\n                    <td><input type=\"checkbox\" class=\"form-control\" [(ngModel)]=\"g.r\"\n                            [ngModelOptions]=\"{standalone: true}\"></td>\n                    <td><input type=\"checkbox\" class=\"form-control\" [(ngModel)]=\"g.w\"\n                            [ngModelOptions]=\"{standalone: true}\"></td>\n                </tr>\n            </tbody>\n        </table>\n    </div>\n    <div role=\"tabpanel\" class=\"tab-pane\" [ngClass]=\"{'active': step ==='author'}\" id=\"hs-author\">\n\n        <label class=\"form-group\">\n            {{'SAVECOMPOSITION.form.person' | translate}}\n            <input type=\"text\" class=\"form-control\" [(ngModel)]=\"HsSaveMapManagerService.userData.name\"\n                [ngModelOptions]=\"{standalone: true}\">\n        </label>\n\n        <label class=\"form-group\">\n            {{'SAVECOMPOSITION.form.organization' | translate}}\n            <input type=\"text\" class=\"form-control\" [(ngModel)]=\"HsSaveMapManagerService.userData.organization\"\n                [ngModelOptions]=\"{standalone: true}\">\n        </label>\n\n        <label class=\"form-group\">\n            {{'SAVECOMPOSITION.form.position' | translate}}\n            <input type=\"text\" class=\"form-control\" [(ngModel)]=\"HsSaveMapManagerService.userData.position\"\n                [ngModelOptions]=\"{standalone: true}\">\n        </label>\n\n        <label class=\"form-group\">\n            {{'SAVECOMPOSITION.form.address' | translate}}\n            <input type=\"text\" class=\"form-control\" [(ngModel)]=\"HsSaveMapManagerService.userData.address\"\n                [ngModelOptions]=\"{standalone: true}\">\n        </label>\n\n        <label class=\"form-group\">\n            {{'SAVECOMPOSITION.form.city' | translate}}\n            <input type=\"text\" class=\"form-control\" [(ngModel)]=\"HsSaveMapManagerService.userData.city\"\n                [ngModelOptions]=\"{standalone: true}\">\n        </label>\n\n        <label class=\"form-group\">\n            {{'SAVECOMPOSITION.form.state' | translate}}\n            <input type=\"text\" class=\"form-control\" [(ngModel)]=\"HsSaveMapManagerService.userData.state\"\n                [ngModelOptions]=\"{standalone: true}\">\n        </label>\n\n        <label class=\"form-group\">\n            {{'SAVECOMPOSITION.form.postalCode' | translate}}\n            <input type=\"text\" class=\"form-control\" [(ngModel)]=\"HsSaveMapManagerService.userData.postalcode\"\n                [ngModelOptions]=\"{standalone: true}\">\n        </label>\n\n        <label class=\"form-group\">\n            {{'SAVECOMPOSITION.form.country' | translate}}\n            <input type=\"text\" class=\"form-control\" [(ngModel)]=\"HsSaveMapManagerService.userData.country\"\n                [ngModelOptions]=\"{standalone: true}\">\n        </label>\n\n        <label class=\"form-group\">\n            {{'SAVECOMPOSITION.form.phone' | translate}}\n            <input type=\"text\" class=\"form-control\" [(ngModel)]=\"HsSaveMapManagerService.userData.phone\"\n                [ngModelOptions]=\"{standalone: true}\">\n        </label>\n\n        <label class=\"form-group\">\n            {{'SAVECOMPOSITION.form.email' | translate}}\n            <input type=\"text\" class=\"form-control\" [(ngModel)]=\"HsSaveMapManagerService.userData.email\"\n                [ngModelOptions]=\"{standalone: true}\">\n        </label>\n\n        <label class=\"form-group\">WWW\n            <input type=\"text\" class=\"form-control\" [(ngModel)]=\"HsSaveMapManagerService.userData.url\"\n                [ngModelOptions]=\"{standalone: true}\">\n        </label>\n\n    </div>\n</div>\n<div class=\"modal-footer w-100\">\n    <div\n        [hidden]=\"!(step === 'end' \n        && HsSaveMapManagerService.currentUser !== HsSaveMapManagerService.compoData.workspace \n        && HsSaveMapManagerService.compoData.workspace)\">\n        <div class=\"alert alert-info text-gray\" >\n            {{'SAVECOMPOSITION.saveOrOverwrite' | translate}}\n        </div>\n        <button type=\"button\" class=\"btn btn-block btn-primary\" id=\"stc-save\"\n            (click)=\"HsSaveMapManagerService.initiateSave(false)\">{{'SAVECOMPOSITION.form.overwrite' |\n            translate}}</button>\n        <p style=\"text-align: center;\" class=\"m-1\">{{'COMMON.or' | translate}}</p>\n    </div>\n\n    <button type=\"button\" class=\"btn btn-block btn-primary\" id=\"stc-saveas\" [hidden]=\"!(step === 'end' && isAllowed())\"\n        (click)=\"HsSaveMapManagerService.initiateSave(true)\">{{'COMMON.save' | translate}}</button>\n    <button type=\"button\" class=\"btn btn-block btn-primary btn-block\" id=\"stc-next\" [hidden]=\"!(step !== 'end')\"\n        (click)=\"next()\">{{'COMMON.next' | translate}}</button>\n    <a class=\"btn btn-block btn-secondary\" (click)=\"saveCompoJson()\" id=\"stc-download\"\n        [hidden]=\"!(step === 'end')\">{{'COMMON.download' | translate}}</a>\n</div>\n"
            }]
    }], function () { return [{ type: HsSaveMapManagerService }, { type: HsEventBusService }, { type: HsCoreService }, { type: HsUtilsService }, { type: HsLayerUtilsService }]; }, null); })();

class HsSaveMapSimpleFormComponent {
    constructor(HsLayerUtilsService, HsSaveMapManagerService) {
        this.HsLayerUtilsService = HsLayerUtilsService;
        this.HsSaveMapManagerService = HsSaveMapManagerService;
    }
    isAllowed() {
        //TODO: Needs implementation
        return true;
    }
}
HsSaveMapSimpleFormComponent.ɵfac = function HsSaveMapSimpleFormComponent_Factory(t) { return new (t || HsSaveMapSimpleFormComponent)(ɵngcc0.ɵɵdirectiveInject(HsLayerUtilsService), ɵngcc0.ɵɵdirectiveInject(HsSaveMapManagerService)); };
HsSaveMapSimpleFormComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsSaveMapSimpleFormComponent, selectors: [["hs-save-map-simple-form"]], decls: 2, vars: 2, consts: [[4, "ngIf"], [1, "form"], [1, "form-group"], ["type", "text", 1, "form-control", 3, "placeholder", "ngModel", "ngModelChange"], [1, "form-control", 3, "placeholder", "ngModel", "ngModelOptions", "ngModelChange"], ["alt", "Composition thumbnail", "width", "256", "height", "256", 1, "hs-stc-thumbnail", "img-thumbnail"], ["class", "checkbox", 4, "ngFor", "ngForOf"], ["type", "button", "data-toggle", "collapse", "data-target", "hs-save-comp-advanced-panel", 1, "btn", "btn-secondary"], [1, "collapse", "hs-save-comp-advanced-panel"], ["type", "text", 1, "form-control", 3, "ngModel", "ngModelOptions", "ngModelChange"], [1, "row", "hs-comp-ext-row"], [1, "form-group", "hs-comp-ext", "col-sm-3"], ["type", "text", 1, "form-control", "input-group-lg", 3, "ngModel", "ngModelOptions", "ngModelChange"], ["type", "text", 1, "form-control", "hs-comp-ext", "input-group-lg", 3, "ngModel", "ngModelOptions", "ngModelChange"], ["type", "button", 1, "btn", "btn-secondary", 3, "click"], [1, "list-group"], ["class", "list-group-item", 3, "id", 4, "ngFor", "ngForOf"], [1, "card-footer", "row", "hs-stc-footer"], ["role", "group", 1, "btn-group"], ["type", "button", 1, "btn", "btn-primary", 3, "disabled", "click"], [1, "checkbox"], ["type", "checkbox", 3, "ngModel", "ngModelOptions", "ngModelChange"], [1, "list-group-item", 3, "id"], [1, "pull-right"], [1, "alert", "alert-info"]], template: function HsSaveMapSimpleFormComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, HsSaveMapSimpleFormComponent_div_0_Template, 54, 58, "div", 0);
        ɵngcc0.ɵɵtemplate(1, HsSaveMapSimpleFormComponent_div_1_Template, 4, 3, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.isAllowed());
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isAllowed());
    } }, directives: [ɵngcc3.NgIf, ɵngcc5.ɵNgNoValidate, ɵngcc5.NgControlStatusGroup, ɵngcc5.NgForm, ɵngcc5.DefaultValueAccessor, ɵngcc5.NgControlStatus, ɵngcc5.NgModel, ɵngcc3.NgForOf, ɵngcc5.CheckboxControlValueAccessor], pipes: [ɵngcc1.TranslatePipe], encapsulation: 2 });
HsSaveMapSimpleFormComponent.ctorParameters = () => [
    { type: HsLayerUtilsService },
    { type: HsSaveMapManagerService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsSaveMapSimpleFormComponent, [{
        type: Component,
        args: [{
                selector: 'hs-save-map-simple-form',
                template: "<div *ngIf=\"isAllowed()\">\n    <form class=\"form\">\n        <label class=\"form-group\">{{'COMMON.name' | translate}}\n            <input type=\"text\" class=\"form-control\" [placeholder]=\"'COMMON.fillInName' | translate\"\n                [(ngModel)]=\"HsSaveMapManagerService.compoData.title\">\n        </label>\n\n        <label class=\"form-group\">{{'COMMON.abstract' | translate}}\n            <textarea class=\"form-control\" [placeholder]=\"'COMMON.fillInDescriptive' | translate\"\n                [(ngModel)]=\"HsSaveMapManagerService.compoData.abstract\" [ngModelOptions]=\"{standalone: true}\">            </textarea>\n        </label>\n\n        <label class=\"form-group\">{{'COMMON.thumbnail' | translate}}\n            <img class=\"hs-stc-thumbnail img-thumbnail\" alt=\"Composition thumbnail\" width=\"256\" height=\"256\">\n        </label>\n\n        <div class=\"form-group\">\n            <div class=\"checkbox\" *ngFor=\"let g of HsSaveMapManagerService.statusData.groups\">\n                <label>\n                    <input type=\"checkbox\" [(ngModel)]=\"g.r\" [ngModelOptions]=\"{standalone: true}\">\n                    <span>{{'SAVECOMPOSITION.panelMd.makePublic' | translate}}</span>\n                </label>\n            </div>\n        </div>\n\n    </form>\n\n    <button type=\"button\" class=\"btn btn-secondary\" data-toggle=\"collapse\"\n        data-target=\"hs-save-comp-advanced-panel\">{{'COMMON.advancedOptions' | translate}}</button>\n    <div class=\"collapse hs-save-comp-advanced-panel\">\n        <form class=\"form\">\n            <label class=\"form-group\">{{'COMMON.keywords' | translate}}\n                <input type=\"text\" class=\"form-control\" [(ngModel)]=\"HsSaveMapManagerService.compoData.keywords\" [ngModelOptions]=\"{standalone: true}\">\n            </label>\n\n            <label class=\"form-group\">{{'COMMON.extent' | translate}}\n                <div class=\"row hs-comp-ext-row\">\n                    <div class=\"form-group hs-comp-ext col-sm-3\">\n                        <input type=\"text\" class=\"form-control input-group-lg\"\n                            [(ngModel)]=\"HsSaveMapManagerService.compoData.bbox[0]\" [ngModelOptions]=\"{standalone: true}\">\n                    </div>\n                    <div class=\"form-group hs-comp-ext col-sm-3\">\n                        <input type=\"text\" class=\"form-control hs-comp-ext input-group-lg\"\n                            [(ngModel)]=\"HsSaveMapManagerService.compoData.bbox[1]\" [ngModelOptions]=\"{standalone: true}\">\n                    </div>\n                    <div class=\"form-group hs-comp-ext col-sm-3\">\n                        <input type=\"text\" class=\"form-control hs-comp-ext input-group-lg\"\n                            [(ngModel)]=\"HsSaveMapManagerService.compoData.bbox[2]\" [ngModelOptions]=\"{standalone: true}\">\n                    </div>\n                    <div class=\"form-group hs-comp-ext col-sm-3\">\n                        <input type=\"text\" class=\"form-control hs-comp-ext input-group-lg\"\n                            [(ngModel)]=\"HsSaveMapManagerService.compoData.bbox[3]\" [ngModelOptions]=\"{standalone: true}\">\n                    </div>\n                </div>\n            </label>\n\n            <button type=\"button\" class=\"btn btn-secondary\"\n                (click)=\"HsSaveMapManagerService.setCurrentBoundingBox()\">{{'SAVECOMPOSITION.form.userCurrentMapExtent' | translate}}</button>\n\n\n            <label class=\"form-group\">{{'COMMON.layers' | translate}}\n                <ul class=\"list-group\">\n                    <li *ngFor=\"let layer of HsSaveMapManagerService.compoData.layers; let index = index\" id=\"layer-{{index}}\"\n                        class=\"list-group-item\">\n                        <span>{{HsLayerUtilsService.translateTitle(layer.title)}}</span>\n                        <span class=\"pull-right\">\n                            <input type=\"checkbox\" [(ngModel)]=\"layer.checked\" [ngModelOptions]=\"{standalone: true}\">\n                        </span>\n                    </li>\n                </ul>\n            </label>\n\n        </form>\n    </div>\n\n    <div class=\"card-footer row hs-stc-footer\">\n        <div class=\"btn-group\" role=\"group\" [attr.aria-label]=\"'SAVECOMPOSITION.dialogSave.saveComposition' | translate\">\n                <button type=\"button\" class=\"btn btn-primary\"\n                [disabled]=\"!HsSaveMapManagerService.compoData.title\"\n                (click)=\"HsSaveMapManagerService.confirmSave()\">{{'COMMON.save' | translate}}</button>\n        </div>\n    </div>\n</div>\n<div *ngIf=\"isAllowed()\">\n    <div class=\"alert alert-info\">\n        {{'SAVECOMPOSITION.panelMd.youAreNotAuthorized' | translate}}</div>\n</div>\n"
            }]
    }], function () { return [{ type: HsLayerUtilsService }, { type: HsSaveMapManagerService }]; }, null); })();

class HsSaveMapModule {
}
HsSaveMapModule.ɵfac = function HsSaveMapModule_Factory(t) { return new (t || HsSaveMapModule)(); };
HsSaveMapModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: HsSaveMapModule });
HsSaveMapModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            HsPanelHelpersModule,
            FormsModule,
            HsLogModule,
            HsUiExtensionsModule,
            TranslateModule,
            HsLaymanModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsSaveMapModule, [{
        type: NgModule,
        args: [{
                schemas: [CUSTOM_ELEMENTS_SCHEMA],
                declarations: [
                    HsSaveMapComponent,
                    HsSaveMapResultDialogComponent,
                    HsSaveMapSimpleFormComponent,
                    HsSaveMapDialogComponent,
                    HsSaveMapAdvancedFormComponent,
                ],
                imports: [
                    CommonModule,
                    HsPanelHelpersModule,
                    FormsModule,
                    HsLogModule,
                    HsUiExtensionsModule,
                    TranslateModule,
                    HsLaymanModule,
                ],
                exports: [HsSaveMapComponent],
                entryComponents: [
                    HsSaveMapComponent,
                    HsSaveMapAdvancedFormComponent,
                    HsSaveMapResultDialogComponent,
                    HsSaveMapDialogComponent,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(HsSaveMapModule, { declarations: function () { return [HsSaveMapComponent, HsSaveMapResultDialogComponent, HsSaveMapSimpleFormComponent, HsSaveMapDialogComponent, HsSaveMapAdvancedFormComponent]; }, imports: function () { return [CommonModule, HsPanelHelpersModule, FormsModule, HsLogModule, HsUiExtensionsModule, TranslateModule, HsLaymanModule]; }, exports: function () { return [HsSaveMapComponent]; } }); })();

/**
 * Add search input template to page
 */
class HsSearchInputComponent {
    constructor(HsSearchService, HsEventBusService, HsShareUrlService) {
        this.HsSearchService = HsSearchService;
        this.HsEventBusService = HsEventBusService;
        this.HsShareUrlService = HsShareUrlService;
        this.query = '';
        this.clearVisible = false;
        this.searchResultsReceivedSubscription =
            this.HsEventBusService.searchResultsReceived.subscribe((_) => {
                this.clearVisible = true;
            });
    }
    ngOnDestroy() {
        this.searchResultsReceivedSubscription.unsubscribe();
    }
    ngOnInit() {
        const query = this.HsShareUrlService.getParamValue(HS_PRMS.search);
        if (query) {
            this.query = query;
            this.queryChanged();
        }
        window.innerWidth < 767
            ? (this.searchInputVisible = false)
            : (this.searchInputVisible = true);
    }
    /**
     * Handler of search input, request search service and display results div
     */
    queryChanged() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.HsSearchService.HsMapService.loaded();
            if (this.query.length == 0) {
                this.clear();
                return;
            }
            this.HsSearchService.request(this.query);
        });
    }
    /**
     * Remove previous search and search results
     */
    clear() {
        this.query = '';
        this.clearVisible = false;
        this.HsSearchService.cleanResults();
        this.HsEventBusService.clearSearchResults.next();
    }
    toggleSearchInput() {
        this.searchInputVisible = !this.searchInputVisible;
        if (this.query != '') {
            this.clear();
        }
    }
}
HsSearchInputComponent.ɵfac = function HsSearchInputComponent_Factory(t) { return new (t || HsSearchInputComponent)(ɵngcc0.ɵɵdirectiveInject(HsSearchService), ɵngcc0.ɵɵdirectiveInject(HsEventBusService), ɵngcc0.ɵɵdirectiveInject(HsShareUrlService)); };
HsSearchInputComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsSearchInputComponent, selectors: [["hs-search-input"]], decls: 8, vars: 9, consts: [[1, "input-group"], [1, "input-group-prepend"], [1, "btn", "btn-light", "btn-outline-secondary", "rounded-0", "hs-toolbar-button", 3, "click"], [1, "glyphicon", "icon-search", 3, "title"], ["name", "query", 1, "form-control", "hs-search-address-input", "rounded-0", "hs-toolbar-button", 3, "ngModel", "hidden", "placeholder", "ngModelChange"], ["class", "clearSearch", 3, "click", 4, "ngIf"], [1, "clearSearch", 3, "click"], [1, "icon-remove-circle", "align-middle"]], template: function HsSearchInputComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "button", 2);
        ɵngcc0.ɵɵlistener("click", function HsSearchInputComponent_Template_button_click_2_listener() { return ctx.toggleSearchInput(); });
        ɵngcc0.ɵɵelement(3, "i", 3);
        ɵngcc0.ɵɵpipe(4, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "input", 4);
        ɵngcc0.ɵɵlistener("ngModelChange", function HsSearchInputComponent_Template_input_ngModelChange_5_listener($event) { return ctx.query = $event; })("ngModelChange", function HsSearchInputComponent_Template_input_ngModelChange_5_listener() { return ctx.queryChanged(); });
        ɵngcc0.ɵɵpipe(6, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(7, HsSearchInputComponent_button_7_Template, 2, 0, "button", 5);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(4, 5, "COMMON.search"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngModel", ctx.query)("hidden", !ctx.searchInputVisible)("placeholder", ɵngcc0.ɵɵpipeBind1(6, 7, "COMMON.search"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.clearVisible);
    } }, directives: [ɵngcc5.DefaultValueAccessor, ɵngcc5.NgControlStatus, ɵngcc5.NgModel, ɵngcc3.NgIf], pipes: [ɵngcc1.TranslatePipe], encapsulation: 2 });
HsSearchInputComponent.ctorParameters = () => [
    { type: HsSearchService },
    { type: HsEventBusService },
    { type: HsShareUrlService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsSearchInputComponent, [{
        type: Component,
        args: [{
                selector: 'hs-search-input',
                template: "<div class=\"input-group\">\n    <div class=\"input-group-prepend\">\n        <button (click)=\"toggleSearchInput()\"\n            class=\"btn btn-light btn-outline-secondary rounded-0 hs-toolbar-button\"><i class=\"glyphicon icon-search\"\n                [title]=\"'COMMON.search' | translate\"></i></button>\n    </div>\n    <input [(ngModel)]=\"query\" [hidden]=\"!searchInputVisible\" name=\"query\" \n        class=\"form-control hs-search-address-input rounded-0 hs-toolbar-button\" [placeholder]=\"'COMMON.search' | translate\"\n        (ngModelChange)=\"queryChanged()\">\n    <button class=\"clearSearch\" (click)=\"clear()\" *ngIf=\"clearVisible\"><i class=\"icon-remove-circle align-middle\"></i></button>\n</div>\n"
            }]
    }], function () { return [{ type: HsSearchService }, { type: HsEventBusService }, { type: HsShareUrlService }]; }, null); })();

/**
 * Add search results template to page
 */
class HsSearchResultsComponent {
    constructor(HsEventBusService, HsSearchService) {
        this.HsEventBusService = HsEventBusService;
        this.HsSearchService = HsSearchService;
        this.data = {};
        this.ngUnsubscribe = new Subject();
        this.HsEventBusService.searchResultsReceived
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((_) => {
            this.searchResultsReceived();
        });
        this.HsEventBusService.clearSearchResults
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((_) => {
            this.clear();
        });
    }
    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
    /**
     * Handler for receiving results of search request, sends results to correct parser
     */
    searchResultsReceived() {
        this.data = this.HsSearchService.data;
        this.searchResultsVisible = true;
        this.HsSearchService.showResultsLayer();
    }
    clear() {
        this.searchResultsVisible = false;
    }
    /**
     * Zoom map to selected result from results list
     *
     * @param result Selected result
     */
    zoomTo(result) {
        this.fcode_zoom_map = {
            'PPLA': 12,
            'PPL': 15,
            'PPLC': 10,
            'ADM1': 9,
            'FRM': 15,
            'PPLF': 13,
            'LCTY': 13,
            'RSTN': 15,
            'PPLA3': 9,
            'AIRP': 13,
            'AIRF': 13,
            'HTL': 17,
            'STM': 14,
            'LK': 13,
        };
        let zoom_level = 10;
        if (result.fcode !== undefined &&
            this.fcode_zoom_map[result.fcode] !== undefined) {
            zoom_level = this.fcode_zoom_map[result.fcode];
        }
        this.HsSearchService.selectResult(result, zoom_level);
    }
}
HsSearchResultsComponent.ɵfac = function HsSearchResultsComponent_Factory(t) { return new (t || HsSearchResultsComponent)(ɵngcc0.ɵɵdirectiveInject(HsEventBusService), ɵngcc0.ɵɵdirectiveInject(HsSearchService)); };
HsSearchResultsComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsSearchResultsComponent, selectors: [["hs-search-results"]], decls: 3, vars: 4, consts: [[1, "list-group", 2, "display", "block", "margin-bottom", "0px", 3, "hidden"], [4, "ngFor", "ngForOf"], [1, "list-group-item", "active", 3, "hidden"], ["class", "list-group-item hsl-search-result", 3, "click", 4, "ngFor", "ngForOf"], [1, "list-group-item", "hsl-search-result", 3, "click"], [2, "color", "rgb(148, 143, 143)"]], template: function HsSearchResultsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, HsSearchResultsComponent_div_1_Template, 3, 3, "div", 1);
        ɵngcc0.ɵɵpipe(2, "keyvalue");
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("hidden", !ctx.searchResultsVisible);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind1(2, 2, ctx.data));
    } }, directives: function () { return [ɵngcc3.NgForOf]; }, pipes: function () { return [ɵngcc3.KeyValuePipe, limitToPipe]; }, encapsulation: 2 });
HsSearchResultsComponent.ctorParameters = () => [
    { type: HsEventBusService },
    { type: HsSearchService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsSearchResultsComponent, [{
        type: Component,
        args: [{
                selector: 'hs-search-results',
                template: "<div class=\"list-group\" [hidden]=\"!searchResultsVisible\" style=\"display: block; margin-bottom: 0px\">\n    <div *ngFor=\"let provider of data | keyvalue \">\n        <div *ngFor=\"let item of provider.value | keyvalue \">\n        <a class=\"list-group-item active\" [hidden]=\"!(item.value.results.length > 0)\">Provider: {{item.value.name}}</a>\n        <a  *ngFor=\"let result of item.value.results | limitTo: 10\" class=\"list-group-item hsl-search-result\"\n            (click)=\"zoomTo(result)\"\n            [attr.title]=\"result.DisplayDescription\">{{result.name || result.DisplayTitle}}<small\n                style=\"color: rgb(148, 143, 143)\"><br>{{result.fcodeName}}</small></a>\n            </div>\n    </div>\n</div>\n"
            }]
    }], function () { return [{ type: HsEventBusService }, { type: HsSearchService }]; }, null); })();

class limitToPipe {
    transform(value, limit) {
        return value.slice(0, limit);
    }
}
limitToPipe.ɵfac = function limitToPipe_Factory(t) { return new (t || limitToPipe)(); };
limitToPipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "limitTo", type: limitToPipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(limitToPipe, [{
        type: Pipe,
        args: [{ name: 'limitTo' }]
    }], null, null); })();

class HsSearchModule {
}
HsSearchModule.ɵfac = function HsSearchModule_Factory(t) { return new (t || HsSearchModule)(); };
HsSearchModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: HsSearchModule });
HsSearchModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[FormsModule, CommonModule, HsPanelHelpersModule, TranslateModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsSearchModule, [{
        type: NgModule,
        args: [{
                schemas: [CUSTOM_ELEMENTS_SCHEMA],
                declarations: [
                    HsSearchComponent,
                    HsSearchResultsComponent,
                    HsSearchInputComponent,
                    limitToPipe,
                    HsSearchToolbarComponent,
                ],
                imports: [FormsModule, CommonModule, HsPanelHelpersModule, TranslateModule],
                exports: [
                    HsSearchComponent,
                    HsSearchResultsComponent,
                    HsSearchInputComponent,
                    HsSearchToolbarComponent,
                ],
                entryComponents: [
                    HsSearchComponent,
                    HsSearchResultsComponent,
                    HsSearchInputComponent,
                    HsSearchToolbarComponent,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(HsSearchModule, { declarations: function () { return [HsSearchComponent, HsSearchResultsComponent, HsSearchInputComponent, limitToPipe, HsSearchToolbarComponent]; }, imports: function () { return [FormsModule, CommonModule, HsPanelHelpersModule, TranslateModule]; }, exports: function () { return [HsSearchComponent, HsSearchResultsComponent, HsSearchInputComponent, HsSearchToolbarComponent]; } }); })();

class HsShareModule {
}
HsShareModule.ɵfac = function HsShareModule_Factory(t) { return new (t || HsShareModule)(); };
HsShareModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: HsShareModule });
HsShareModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        { provide: LocationStrategy, useClass: PathLocationStrategy },
        { provide: APP_BASE_HREF, useValue: '/' },
    ], imports: [[CommonModule, FormsModule, HsPanelHelpersModule, TranslateModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsShareModule, [{
        type: NgModule,
        args: [{
                schemas: [CUSTOM_ELEMENTS_SCHEMA],
                declarations: [HsShareComponent],
                imports: [CommonModule, FormsModule, HsPanelHelpersModule, TranslateModule],
                exports: [HsShareComponent],
                providers: [
                    { provide: LocationStrategy, useClass: PathLocationStrategy },
                    { provide: APP_BASE_HREF, useValue: '/' },
                ],
                entryComponents: [HsShareComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(HsShareModule, { declarations: function () { return [HsShareComponent]; }, imports: function () { return [CommonModule, FormsModule, HsPanelHelpersModule, TranslateModule]; }, exports: function () { return [HsShareComponent]; } }); })();

class HsThemesModule {
}
HsThemesModule.ɵfac = function HsThemesModule_Factory(t) { return new (t || HsThemesModule)(); };
HsThemesModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: HsThemesModule });
HsThemesModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, NgbModule, TranslateModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsThemesModule, [{
        type: NgModule,
        args: [{
                schemas: [CUSTOM_ELEMENTS_SCHEMA],
                declarations: [HsThemeToolbarComponent],
                imports: [CommonModule, NgbModule, TranslateModule],
                exports: [HsThemeToolbarComponent],
                entryComponents: [HsThemeToolbarComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(HsThemesModule, { declarations: function () { return [HsThemeToolbarComponent]; }, imports: function () { return [CommonModule, NgbModule, TranslateModule]; }, exports: function () { return [HsThemeToolbarComponent]; } }); })();

class HsToolbarModule {
}
HsToolbarModule.ɵfac = function HsToolbarModule_Factory(t) { return new (t || HsToolbarModule)(); };
HsToolbarModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: HsToolbarModule });
HsToolbarModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule,
            NgbModule,
            TranslateModule,
            HsPanelHelpersModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsToolbarModule, [{
        type: NgModule,
        args: [{
                schemas: [CUSTOM_ELEMENTS_SCHEMA],
                declarations: [HsToolbarComponent, HsToolbarPanelBaseComponent],
                imports: [
                    CommonModule,
                    FormsModule,
                    NgbModule,
                    TranslateModule,
                    HsPanelHelpersModule,
                ],
                exports: [HsToolbarComponent, HsToolbarPanelBaseComponent],
                entryComponents: [HsToolbarComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(HsToolbarModule, { declarations: function () { return [HsToolbarComponent, HsToolbarPanelBaseComponent]; }, imports: function () { return [CommonModule,
        FormsModule,
        NgbModule,
        TranslateModule, HsPanelHelpersModule]; }, exports: function () { return [HsToolbarComponent, HsToolbarPanelBaseComponent]; } }); })();

class HsTripPlannerLayerSelectorComponent {
    constructor(HsTripPlannerService, HsLayerUtilsService) {
        this.HsTripPlannerService = HsTripPlannerService;
        this.HsLayerUtilsService = HsLayerUtilsService;
    }
}
HsTripPlannerLayerSelectorComponent.ɵfac = function HsTripPlannerLayerSelectorComponent_Factory(t) { return new (t || HsTripPlannerLayerSelectorComponent)(ɵngcc0.ɵɵdirectiveInject(HsTripPlannerService), ɵngcc0.ɵɵdirectiveInject(HsLayerUtilsService)); };
HsTripPlannerLayerSelectorComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HsTripPlannerLayerSelectorComponent, selectors: [["hs-trip-planner-layer-selector"]], inputs: { label: "label", usage: "usage", selectedwrapper: "selectedwrapper" }, decls: 9, vars: 7, consts: [[1, "flex-row", "w-100", "m-auto", "justify-content-center", "align-items-center", 2, "display", "flex"], [1, "m-0", "p-0", "flex-fill", 2, "color", "var(--primary)"], [1, "dropdown", 2, "max-width", "50%"], ["type", "button", "data-toggle", "dropdown", "aria-haspopup", "true", 1, "btn", "btn-sm", "rounded-0", "hs-toolbar-button", "dropdown-toggle", "d-flex", "align-items-center", "mw-100", 3, "click"], ["class", "text-truncate", 4, "ngIf"], [1, "dropdown-menu", "dropdown-menu-right", 2, "transform", "translateX(25%)", "width", "15em", 3, "ngClass"], [1, "d-flex", "align-items-center", "w-100", "flex-column"], ["class", "dropdown-item text-truncate", "data-toggle", "tooltip", 3, "title", "click", 4, "ngFor", "ngForOf"], [1, "text-truncate"], ["data-toggle", "tooltip", 1, "dropdown-item", "text-truncate", 3, "title", "click"]], template: function HsTripPlannerLayerSelectorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "p", 1);
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 2);
        ɵngcc0.ɵɵelementStart(4, "button", 3);
        ɵngcc0.ɵɵlistener("click", function HsTripPlannerLayerSelectorComponent_Template_button_click_4_listener() { ctx.layersExpanded = !ctx.layersExpanded; return ctx.HsTripPlannerService.fillVectorLayers(); });
        ɵngcc0.ɵɵtemplate(5, HsTripPlannerLayerSelectorComponent_div_5_Template, 2, 1, "div", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "div", 5);
        ɵngcc0.ɵɵelementStart(7, "div", 6);
        ɵngcc0.ɵɵtemplate(8, HsTripPlannerLayerSelectorComponent_a_8_Template, 2, 2, "a", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1("", ctx.label, ":");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵattribute("aria-expanded", ctx.layersExpanded);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.selectedwrapper !== undefined);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(5, _c14, ctx.layersExpanded));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.HsTripPlannerService.vectorLayers);
    } }, directives: [ɵngcc3.NgIf, ɵngcc3.NgClass, ɵngcc3.NgForOf], encapsulation: 2 });
HsTripPlannerLayerSelectorComponent.ctorParameters = () => [
    { type: HsTripPlannerService },
    { type: HsLayerUtilsService }
];
HsTripPlannerLayerSelectorComponent.propDecorators = {
    label: [{ type: Input }],
    usage: [{ type: Input }],
    selectedwrapper: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsTripPlannerLayerSelectorComponent, [{
        type: Component,
        args: [{
                selector: 'hs-trip-planner-layer-selector',
                template: "<div\n  class=\"flex-row w-100 m-auto justify-content-center align-items-center\"\n  style=\"display: flex\"\n>\n  <p class=\"m-0 p-0 flex-fill\" style=\"color: var(--primary)\">{{label}}:</p>\n  <div class=\"dropdown\" style=\"max-width: 50%\">\n    <button\n      type=\"button\"\n      class=\"\n        btn btn-sm\n        rounded-0\n        hs-toolbar-button\n        dropdown-toggle\n        d-flex\n        align-items-center\n        mw-100\n      \"\n      data-toggle=\"dropdown\"\n      aria-haspopup=\"true\"\n      (click)=\"layersExpanded = !layersExpanded; HsTripPlannerService.fillVectorLayers() \"\n      [attr.aria-expanded]=\"layersExpanded\"\n    >\n      <div class=\"text-truncate\" *ngIf=\"selectedwrapper !== undefined\">\n        {{HsLayerUtilsService.translateTitle(selectedwrapper.title)}}\n      </div>\n    </button>\n    <div\n      class=\"dropdown-menu dropdown-menu-right\"\n      [ngClass]=\"{'show': layersExpanded}\"\n      style=\"transform: translateX(25%); width: 15em\"\n    >\n      <div class=\"d-flex align-items-center w-100 flex-column\">\n        <a\n          class=\"dropdown-item text-truncate\"\n          *ngFor=\"let layer of HsTripPlannerService.vectorLayers\"\n          data-toggle=\"tooltip\"\n          title=\"{{HsLayerUtilsService.translateTitle(layer.title)}}\"\n          (click)=\"HsTripPlannerService.selectLayer(layer, usage); layersExpanded = false\"\n          >{{HsLayerUtilsService.translateTitle(layer.title)}}</a\n        >\n      </div>\n    </div>\n  </div>\n</div>\n"
            }]
    }], function () { return [{ type: HsTripPlannerService }, { type: HsLayerUtilsService }]; }, { label: [{
            type: Input
        }], usage: [{
            type: Input
        }], selectedwrapper: [{
            type: Input
        }] }); })();

class HsTripPlannerModule {
}
HsTripPlannerModule.ɵfac = function HsTripPlannerModule_Factory(t) { return new (t || HsTripPlannerModule)(); };
HsTripPlannerModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: HsTripPlannerModule });
HsTripPlannerModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[FormsModule, CommonModule, TranslateModule, HsPanelHelpersModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsTripPlannerModule, [{
        type: NgModule,
        args: [{
                schemas: [CUSTOM_ELEMENTS_SCHEMA],
                declarations: [HsTripPlannerComponent, HsTripPlannerLayerSelectorComponent],
                imports: [FormsModule, CommonModule, TranslateModule, HsPanelHelpersModule],
                exports: [HsTripPlannerComponent, HsTripPlannerLayerSelectorComponent],
                entryComponents: [
                    HsTripPlannerComponent,
                    HsTripPlannerLayerSelectorComponent,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(HsTripPlannerModule, { declarations: function () { return [HsTripPlannerComponent, HsTripPlannerLayerSelectorComponent]; }, imports: function () { return [FormsModule, CommonModule, TranslateModule, HsPanelHelpersModule]; }, exports: function () { return [HsTripPlannerComponent, HsTripPlannerLayerSelectorComponent]; } }); })();

class HslayersModule {
}
HslayersModule.ɵfac = function HslayersModule_Factory(t) { return new (t || HslayersModule)(); };
HslayersModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: HslayersModule });
HslayersModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            HsCoreModule,
            HsLayoutModule,
            HsLayerManagerModule,
            HsMeasureModule,
            HsAddDataModule,
            HsDrawModule,
            HsGeolocationModule,
            HsInfoModule,
            HsLanguageModule,
            HsLegendModule,
            HsTripPlannerModule,
            HsSaveMapModule,
            HsFeatureTableModule,
            HsPrintModule,
            HsShareModule,
            HsQueryModule,
            HsSearchModule,
            HsCompositionsModule,
            HsStylerModule,
            HsToolbarModule,
            HsThemesModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HslayersModule, [{
        type: NgModule,
        args: [{
                declarations: [HslayersComponent],
                imports: [
                    HsCoreModule,
                    HsLayoutModule,
                    HsLayerManagerModule,
                    HsMeasureModule,
                    HsAddDataModule,
                    HsDrawModule,
                    HsGeolocationModule,
                    HsInfoModule,
                    HsLanguageModule,
                    HsLegendModule,
                    HsTripPlannerModule,
                    HsSaveMapModule,
                    HsFeatureTableModule,
                    HsPrintModule,
                    HsShareModule,
                    HsQueryModule,
                    HsSearchModule,
                    HsCompositionsModule,
                    HsStylerModule,
                    HsToolbarModule,
                    HsThemesModule,
                ],
                exports: [HslayersComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(HslayersModule, { declarations: [HslayersComponent], imports: [HsCoreModule, HsLayoutModule, HsLayerManagerModule, HsMeasureModule, HsAddDataModule, HsDrawModule, HsGeolocationModule, HsInfoModule, HsLanguageModule, HsLegendModule, HsTripPlannerModule, HsSaveMapModule, HsFeatureTableModule, HsPrintModule, HsShareModule, HsQueryModule, HsSearchModule, HsCompositionsModule, HsStylerModule, HsToolbarModule, HsThemesModule], exports: [HslayersComponent] }); })();

/**
 * Handy shorthand for SparqlJson source with some params pre-filled for SPOI dataset
 */
class SPOI extends SparqlJson {
    constructor({ category, projection }) {
        const options = {
            endpointUrl: 'https://www.foodie-cloud.org/sparql',
            endpointOptions: {},
            geom_attribute: '?geom',
            optimizeForVirtuoso: true,
            projection: projection,
            query: `
        PREFIX poi: <http://www.openvoc.eu/poi#>
        PREFIX spoi: <http://gis.zcu.cz/SPOI/Ontology#>
        SELECT ?o ?p ?s
        FROM <http://www.sdi4apps.eu/poi.rdf>
        WHERE {
          ?o <http://www.w3.org/1999/02/22-rdf-syntax-ns#type> spoi:${category} .
          ?o <http://www.opengis.net/ont/geosparql#asWKT> ?geom.
          FILTER(isBlank(?geom) = false).
          <extent>
          ?o ?p ?s .
        } ORDER BY ?o`,
        };
        super(options);
    }
}

class HsCompositionsEndpointsModule {
}
HsCompositionsEndpointsModule.ɵfac = function HsCompositionsEndpointsModule_Factory(t) { return new (t || HsCompositionsEndpointsModule)(); };
HsCompositionsEndpointsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: HsCompositionsEndpointsModule });
HsCompositionsEndpointsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, FormsModule, TranslateModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HsCompositionsEndpointsModule, [{
        type: NgModule,
        args: [{
                schemas: [CUSTOM_ELEMENTS_SCHEMA],
                declarations: [],
                imports: [CommonModule, FormsModule, TranslateModule],
                exports: [],
                entryComponents: []
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(HsCompositionsEndpointsModule, { imports: function () { return [CommonModule, FormsModule, TranslateModule]; } }); })();

/*
 * Public API Surface of hslayers
 */

/**
 * Generated bundle index. Do not edit.
 */

export { DuplicateHandling, EndpointErrorHandling, EndpointsWithDatasourcesPipe, FilterPipe, HS_PRMS, HS_PRMS_BACKWARDS, HS_PRMS_REGENERATED, HsAddDataArcGisComponent, HsAddDataArcGisModule, HsAddDataArcGisService, HsAddDataCatalogueComponent, HsAddDataCatalogueMapService, HsAddDataCatalogueModule, HsAddDataCatalogueService, HsAddDataCommonModule, HsAddDataCommonUrlService, HsAddDataComponent, HsAddDataFileComponent, HsAddDataFileModule, HsAddDataFileShpComponent, HsAddDataFileShpModule, HsAddDataFileShpService, HsAddDataModule, HsAddDataService, HsAddDataTargetPositionComponent, HsAddDataUrlComponent, HsAddDataUrlModule, HsAddDataUrlService, HsAddDataUrlWmsModule, HsAddDataUrlWmsService, HsAddDataUrlWmtsService, HsAddDataVectorComponent, HsAddDataVectorModule, HsAddDataVectorService, HsAddDataWfsComponent, HsAddDataWfsModule, HsAddDataWfsService, HsAddDataWmsComponent, HsAddDataWmtsComponent, HsAddDataWmtsModule, HsAddFilterButtonComponent, HsArcgisGetCapabilitiesService, HsCapabilityCacheService, HsCatalogueListItemComponent, HsCatalogueMetadataComponent, HsCatalogueMetadataService, HsColorPickerComponent, HsCommonEndpointsModule, HsCommonEndpointsService, HsCommonLaymanAccessRightsComponent, HsCommonLaymanService, HsCommonUrlAddComponent, HsCommonUrlComponent, HsCommonUrlDetailsComponent, HsCommonUrlProgressComponent, HsComparisonFilterComponent, HsCompositionsCatalogueService, HsCompositionsComponent, HsCompositionsDeleteDialogComponent, HsCompositionsEndpointsModule, HsCompositionsInfoDialogComponent, HsCompositionsLayerParserModule, HsCompositionsLayerParserService, HsCompositionsLaymanService, HsCompositionsListItemComponent, HsCompositionsMapService, HsCompositionsMickaService, HsCompositionsModule, HsCompositionsOverwriteDialogComponent, HsCompositionsParserService, HsCompositionsService, HsCompositionsShareDialogComponent, HsCompositionsStatusManagerMickaJointService, HsCompositionsStatusManagerService, HsCompositionsWarningDialogComponent, HsConfig, HsConfirmDialogComponent, HsConfirmModule, HsCoreModule, HsCoreService, HsDialogContainerComponent, HsDialogContainerService, HsDialogHostDirective, HsDialogItem, HsDimensionDescriptor, HsDimensionService, HsDimensionTimeService, HsDownloadDirective, HsDownloadModule, HsDrawComponent, HsDrawLayerMetadataDialogComponent, HsDrawModule, HsDrawService, HsDrawToolbarComponent, HsEventBusService, HsFeatureCommonService, HsFeatureExt, HsFeatureFilterPipe, HsFeatureTableComponent, HsFeatureTableModule, HsFeatureTableService, HsFileDropDirective, HsFillSymbolizerComponent, HsFilterComponent, HsFiltersComponent, HsFiltersService, HsGeolocationComponent, HsGeolocationModule, HsGeolocationService, HsGetCapabilitiesErrorComponent, HsGetCapabilitiesModule, HsHistoryListComponent, HsHistoryListModule, HsHistoryListService, HsIconSymbolizerComponent, HsImpressumComponent, HsInfoComponent, HsInfoModule, HsLanguageComponent, HsLanguageModule, HsLanguageService, HsLayerEditorComponent, HsLayerEditorDimensionsComponent, HsLayerEditorService, HsLayerEditorSubLayerCheckboxesComponent, HsLayerEditorSublayerService, HsLayerEditorVectorLayerService, HsLayerExt, HsLayerFeaturesComponent, HsLayerListComponent, HsLayerManagerComponent, HsLayerManagerFolderComponent, HsLayerManagerGalleryComponent, HsLayerManagerMetadataService, HsLayerManagerModule, HsLayerManagerRemoveAllDialogComponent, HsLayerManagerRemoveLayerDialogComponent, HsLayerManagerService, HsLayerManagerTimeEditorComponent, HsLayerPhysicalListComponent, HsLayerSelectorService, HsLayerSynchronizerService, HsLayerUtilsService, HsLayermanagerPhysicalListService, HsLaymanBrowserService, HsLaymanCurrentUserComponent, HsLaymanLoginComponent, HsLaymanModule, HsLaymanService, HsLayoutComponent, HsLayoutHostDirective, HsLayoutModule, HsLayoutService, HsLegendComponent, HsLegendLayerComponent, HsLegendLayerStaticComponent, HsLegendLayerVectorComponent, HsLegendModule, HsLegendService, HsLineSymbolizerComponent, HsLogModule, HsLogService, HsMapComponent, HsMapDirective, HsMapHostDirective, HsMapModule, HsMapService, HsMarkSymbolizerComponent, HsMeasureComponent, HsMeasureModule, HsMeasureService, HsMeasureToolbarComponent, HsMickaBrowserService, HsMiniSidebarComponent, HsNestedLayersTableComponent, HsOverlayPanelContainerService, HsPagerComponent, HsPagerModule, HsPanelBaseComponent, HsPanelContainerComponent, HsPanelContainerService, HsPanelHeaderComponent, HsPanelHelpersModule, HsPanelHostDirective, HsPanelItem, HsPrintComponent, HsPrintModule, HsPrintService, HsQueryAttributeRowComponent, HsQueryBaseService, HsQueryComponent, HsQueryDefaultInfoPanelBodyComponent, HsQueryFeatureComponent, HsQueryFeatureListComponent, HsQueryFeaturePopupComponent, HsQueryModule, HsQueryVectorService, HsQueryWmsService, HsQueryWmtsService, HsQueuesModule, HsQueuesService, HsRuleComponent, HsRuleListItemComponent, HsSaveMapAdvancedFormComponent, HsSaveMapComponent, HsSaveMapDialogComponent, HsSaveMapDialogSpawnerService, HsSaveMapManagerService, HsSaveMapModule, HsSaveMapResultDialogComponent, HsSaveMapService, HsSaveMapSimpleFormComponent, HsScaleDenominatorComponent, HsSearchComponent, HsSearchInputComponent, HsSearchModule, HsSearchResultsComponent, HsSearchService, HsSearchToolbarComponent, HsSelectIconDialogComponent, HsShareComponent, HsShareModule, HsShareService, HsShareUrlService, HsSidebarComponent, HsSidebarModule, HsSidebarService, HsSliderComponent, HsStatusManagerService, HsStylerComponent, HsStylerModule, HsStylerPartBaseComponent, HsStylerService, HsSymbolizerComponent, HsSymbolizerListItemComponent, HsTextSymbolizerComponent, HsThemeService, HsToastComponent, HsToastModule, HsToastService, HsToolbarComponent, HsToolbarModule, HsToolbarPanelBaseComponent, HsTripPlannerComponent, HsTripPlannerLayerSelectorComponent, HsTripPlannerModule, HsTripPlannerService, HsUiExtensionsModule, HsUiExtensionsRecursiveDdComponent, HsUploadComponent, HsUploadModule, HsUtilsModule, HsUtilsService, HsVectorUrlParserService, HsWfsGetCapabilitiesService, HsWmsGetCapabilitiesService, HsWmtsGetCapabilitiesService, HslayersComponent, HslayersModule, HslayersService, INSPIRETHEMES, KEYWORDS, PREFER_RESUMABLE_SIZE_LIMIT, PhysicalListItem, SORTBYVALUES, SPOI, SortByPipe, SparqlJson, TYPES, Themes, TrackByPropertyPipe, VectorLayerDescriptor, VectorSourceDescriptor, VectorSourceFromUrl, WebpackTranslateLoader, WfsSource, WmsLayerHighlightDirective, dark, defaultStyle, getAbstract, getAccessRights, getActive, getAttribution, getAutoLegend, getBase, getCachedCapabilities, getCluster, getCustomInfoTemplate, getDefinition, getDimension, getDimensions, getEditor, getEnableProxy, getEventsSuspended, getExclusive, getFeatureInfoLang, getFeatureInfoTarget, getFeatureLabel, getFeatureName, getFeatureTitle, getFeatures, getFromComposition, getHighlighted, getHsLaymanSynchronizing, getInfoFormat, getInlineLegend, getLayerName, getLaymanFriendlyLayerName, getLaymanLayerDescriptor, getLegends, getMaxResolutionDenominator, getMetadata, getMinimumTerrainLevel, getName, getOnFeatureSelected, getPath, getPopUp, getPopupClass, getQueryCapabilities, getQueryFilter, getQueryable, getRecord, getRemovable, getShowInLayerManager, getSld, getSubLayers, getThumbnail, getTitle, getUnitId, getVirtualAttributes, getWaypoint, getWebpackTranslateLoader, getWfsUrl, getWorkspace, isErrorHandlerFunction, light, limitToPipe, servicesSupportedByUrl, setAbstract, setAccessRights, setActive, setAttribution, setAutoLegend, setBase, setCacheCapabilities, setCluster, setCustomInfoTemplate, setDefinition, setDimension, setDimensions, setEditor, setEnableProxy, setEventsSuspended, setExclusive, setFeatureInfoLang, setFeatureInfoTarget, setFeatureLabel, setFeatureName, setFeatureTitle, setFeatures, setFromComposition, setHighlighted, setHsLaymanSynchronizing, setInfoFormat, setInlineLegend, setLaymanLayerDescriptor, setLegends, setMaxResolutionDenominator, setMetadata, setMinimumTerrainLevel, setName, setOnFeatureSelected, setPath, setPopUp, setPopupClass, setQueryCapabilities, setQueryFilter, setQueryable, setRecord, setRemovable, setShowInLayerManager, setSld, setSubLayers, setThumbnail, setTitle, setUnitId, setVirtualAttributes, setWaypoint, setWfsUrl, setWorkspace, simple_style, wfsFailed, wfsNotAvailable, wfsPendingOrStarting, HsToolbarPanelContainerService as ɵa, HsCatalogueMetadataModule as ɵb, HsThemesModule as ɵc, HsThemeToolbarComponent as ɵd };

